
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire39a4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire39a4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7fPBF", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fSPLm"));

});
parcelRegister("fSPLm", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $b9040d2deeb360f4$export$dca3b0875bd9a954; }, function (v) { return $b9040d2deeb360f4$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b9040d2deeb360f4$export$16fa2f45be04daa8; }, function (v) { return $b9040d2deeb360f4$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b9040d2deeb360f4$export$ffb0004e005737fa; }, function (v) { return $b9040d2deeb360f4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $b9040d2deeb360f4$export$e2c29f18771995cb; }, function (v) { return $b9040d2deeb360f4$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b9040d2deeb360f4$export$221d75b3f55bb0bd; }, function (v) { return $b9040d2deeb360f4$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b9040d2deeb360f4$export$5f8d39834fd61797; }, function (v) { return $b9040d2deeb360f4$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b9040d2deeb360f4$export$74bf444e3cd11ea5; }, function (v) { return $b9040d2deeb360f4$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b9040d2deeb360f4$export$ae55be85d98224ed; }, function (v) { return $b9040d2deeb360f4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b9040d2deeb360f4$export$e530037191fcd5d7; }, function (v) { return $b9040d2deeb360f4$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b9040d2deeb360f4$export$fd42f52fd3ae1109; }, function (v) { return $b9040d2deeb360f4$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b9040d2deeb360f4$export$c8a8987d4410bf2d; }, function (v) { return $b9040d2deeb360f4$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $b9040d2deeb360f4$export$d38cd72104c1f0e9; }, function (v) { return $b9040d2deeb360f4$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43; }, function (v) { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b9040d2deeb360f4$export$257a8862b851cb5b; }, function (v) { return $b9040d2deeb360f4$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b9040d2deeb360f4$export$a8257692ac88316c; }, function (v) { return $b9040d2deeb360f4$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b9040d2deeb360f4$export$488013bae63b21da; }, function (v) { return $b9040d2deeb360f4$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b9040d2deeb360f4$export$7c73462e0d25e514; }, function (v) { return $b9040d2deeb360f4$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $b9040d2deeb360f4$export$7568632d0d33d16d; }, function (v) { return $b9040d2deeb360f4$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $b9040d2deeb360f4$export$88948ce120ea2619; }, function (v) { return $b9040d2deeb360f4$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b9040d2deeb360f4$export$35808ee640e87ca7; }, function (v) { return $b9040d2deeb360f4$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b9040d2deeb360f4$export$fae74005e78b1a27; }, function (v) { return $b9040d2deeb360f4$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e; }, function (v) { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf; }, function (v) { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $b9040d2deeb360f4$export$6d9c69b0de29b591; }, function (v) { return $b9040d2deeb360f4$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $b9040d2deeb360f4$export$f680877a34711e37; }, function (v) { return $b9040d2deeb360f4$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b9040d2deeb360f4$export$d5a552a76deda3c2; }, function (v) { return $b9040d2deeb360f4$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $b9040d2deeb360f4$export$aaabe4eda9ed9969; }, function (v) { return $b9040d2deeb360f4$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b9040d2deeb360f4$export$e5c5a5f917a5871c; }, function (v) { return $b9040d2deeb360f4$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b9040d2deeb360f4$export$1538c33de8887b59; }, function (v) { return $b9040d2deeb360f4$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $b9040d2deeb360f4$export$13e3392192263954; }, function (v) { return $b9040d2deeb360f4$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b9040d2deeb360f4$export$b8f5890fc79d6aca; }, function (v) { return $b9040d2deeb360f4$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b9040d2deeb360f4$export$60241385465d0a34; }, function (v) { return $b9040d2deeb360f4$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $b9040d2deeb360f4$export$306c0aa65ff9ec16; }, function (v) { return $b9040d2deeb360f4$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $b9040d2deeb360f4$export$7b286972b8d8ccbf; }, function (v) { return $b9040d2deeb360f4$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $b9040d2deeb360f4$export$83d89fbfd8236492; }, function (v) { return $b9040d2deeb360f4$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b9040d2deeb360f4$export$dca3b0875bd9a954;
var $b9040d2deeb360f4$export$16fa2f45be04daa8;
var $b9040d2deeb360f4$export$ffb0004e005737fa;
var $b9040d2deeb360f4$export$e2c29f18771995cb;
var $b9040d2deeb360f4$export$221d75b3f55bb0bd;
var $b9040d2deeb360f4$export$5f8d39834fd61797;
var $b9040d2deeb360f4$export$74bf444e3cd11ea5;
var $b9040d2deeb360f4$export$ae55be85d98224ed;
var $b9040d2deeb360f4$export$e530037191fcd5d7;
var $b9040d2deeb360f4$export$fd42f52fd3ae1109;
var $b9040d2deeb360f4$export$c8a8987d4410bf2d;
var $b9040d2deeb360f4$export$d38cd72104c1f0e9;
var $b9040d2deeb360f4$export$7d1e3a5e95ceca43;
var $b9040d2deeb360f4$export$257a8862b851cb5b;
var $b9040d2deeb360f4$export$a8257692ac88316c;
var $b9040d2deeb360f4$export$488013bae63b21da;
var $b9040d2deeb360f4$export$7c73462e0d25e514;
var $b9040d2deeb360f4$export$7568632d0d33d16d;
var $b9040d2deeb360f4$export$88948ce120ea2619;
var $b9040d2deeb360f4$export$35808ee640e87ca7;
var $b9040d2deeb360f4$export$fae74005e78b1a27;
var $b9040d2deeb360f4$export$dc8fbce3eb94dc1e;
var $b9040d2deeb360f4$export$6a7bc4e911dc01cf;
var $b9040d2deeb360f4$export$6d9c69b0de29b591;
var $b9040d2deeb360f4$export$f680877a34711e37;
var $b9040d2deeb360f4$export$d5a552a76deda3c2;
var $b9040d2deeb360f4$export$aaabe4eda9ed9969;
var $b9040d2deeb360f4$export$e5c5a5f917a5871c;
var $b9040d2deeb360f4$export$1538c33de8887b59;
var $b9040d2deeb360f4$export$13e3392192263954;
var $b9040d2deeb360f4$export$b8f5890fc79d6aca;
var $b9040d2deeb360f4$export$60241385465d0a34;
var $b9040d2deeb360f4$export$306c0aa65ff9ec16;
var $b9040d2deeb360f4$export$7b286972b8d8ccbf;
var $b9040d2deeb360f4$export$83d89fbfd8236492;
"use strict";
var $b9040d2deeb360f4$var$l = Symbol.for("react.element"), $b9040d2deeb360f4$var$n = Symbol.for("react.portal"), $b9040d2deeb360f4$var$p = Symbol.for("react.fragment"), $b9040d2deeb360f4$var$q = Symbol.for("react.strict_mode"), $b9040d2deeb360f4$var$r = Symbol.for("react.profiler"), $b9040d2deeb360f4$var$t = Symbol.for("react.provider"), $b9040d2deeb360f4$var$u = Symbol.for("react.context"), $b9040d2deeb360f4$var$v = Symbol.for("react.forward_ref"), $b9040d2deeb360f4$var$w = Symbol.for("react.suspense"), $b9040d2deeb360f4$var$x = Symbol.for("react.memo"), $b9040d2deeb360f4$var$y = Symbol.for("react.lazy"), $b9040d2deeb360f4$var$z = Symbol.iterator;
function $b9040d2deeb360f4$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b9040d2deeb360f4$var$z && a[$b9040d2deeb360f4$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b9040d2deeb360f4$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b9040d2deeb360f4$var$C = Object.assign, $b9040d2deeb360f4$var$D = {};
function $b9040d2deeb360f4$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
$b9040d2deeb360f4$var$E.prototype.isReactComponent = {};
$b9040d2deeb360f4$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b9040d2deeb360f4$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b9040d2deeb360f4$var$F() {}
$b9040d2deeb360f4$var$F.prototype = $b9040d2deeb360f4$var$E.prototype;
function $b9040d2deeb360f4$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
var $b9040d2deeb360f4$var$H = $b9040d2deeb360f4$var$G.prototype = new $b9040d2deeb360f4$var$F;
$b9040d2deeb360f4$var$H.constructor = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$var$C($b9040d2deeb360f4$var$H, $b9040d2deeb360f4$var$E.prototype);
$b9040d2deeb360f4$var$H.isPureReactComponent = !0;
var $b9040d2deeb360f4$var$I = Array.isArray, $b9040d2deeb360f4$var$J = Object.prototype.hasOwnProperty, $b9040d2deeb360f4$var$K = {
    current: null
}, $b9040d2deeb360f4$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b9040d2deeb360f4$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b9040d2deeb360f4$var$J.call(b, d) && !$b9040d2deeb360f4$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $b9040d2deeb360f4$var$K.current
    };
}
function $b9040d2deeb360f4$var$N(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b9040d2deeb360f4$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b9040d2deeb360f4$var$l;
}
function $b9040d2deeb360f4$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b9040d2deeb360f4$var$P = /\/+/g;
function $b9040d2deeb360f4$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b9040d2deeb360f4$var$escape("" + a.key) : b.toString(36);
}
function $b9040d2deeb360f4$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b9040d2deeb360f4$var$l:
                case $b9040d2deeb360f4$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $b9040d2deeb360f4$var$Q(h, 0) : d, $b9040d2deeb360f4$var$I(c) ? (e = "", null != a && (e = a.replace($b9040d2deeb360f4$var$P, "$&/") + "/"), $b9040d2deeb360f4$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($b9040d2deeb360f4$var$O(c) && (c = $b9040d2deeb360f4$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($b9040d2deeb360f4$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($b9040d2deeb360f4$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $b9040d2deeb360f4$var$Q(k, g);
        h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    }
    else if (f = $b9040d2deeb360f4$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $b9040d2deeb360f4$var$Q(k, g++), h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $b9040d2deeb360f4$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $b9040d2deeb360f4$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $b9040d2deeb360f4$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $b9040d2deeb360f4$var$U = {
    current: null
}, $b9040d2deeb360f4$var$V = {
    transition: null
}, $b9040d2deeb360f4$var$W = {
    ReactCurrentDispatcher: $b9040d2deeb360f4$var$U,
    ReactCurrentBatchConfig: $b9040d2deeb360f4$var$V,
    ReactCurrentOwner: $b9040d2deeb360f4$var$K
};
$b9040d2deeb360f4$export$dca3b0875bd9a954 = {
    map: $b9040d2deeb360f4$var$S,
    forEach: function(a, b, e) {
        $b9040d2deeb360f4$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $b9040d2deeb360f4$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b9040d2deeb360f4$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b9040d2deeb360f4$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$b9040d2deeb360f4$export$16fa2f45be04daa8 = $b9040d2deeb360f4$var$E;
$b9040d2deeb360f4$export$ffb0004e005737fa = $b9040d2deeb360f4$var$p;
$b9040d2deeb360f4$export$e2c29f18771995cb = $b9040d2deeb360f4$var$r;
$b9040d2deeb360f4$export$221d75b3f55bb0bd = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$export$5f8d39834fd61797 = $b9040d2deeb360f4$var$q;
$b9040d2deeb360f4$export$74bf444e3cd11ea5 = $b9040d2deeb360f4$var$w;
$b9040d2deeb360f4$export$ae55be85d98224ed = $b9040d2deeb360f4$var$W;
$b9040d2deeb360f4$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $b9040d2deeb360f4$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b9040d2deeb360f4$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b9040d2deeb360f4$var$J.call(b, f) && !$b9040d2deeb360f4$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$b9040d2deeb360f4$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $b9040d2deeb360f4$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $b9040d2deeb360f4$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$b9040d2deeb360f4$export$c8a8987d4410bf2d = $b9040d2deeb360f4$var$M;
$b9040d2deeb360f4$export$d38cd72104c1f0e9 = function(a) {
    var b = $b9040d2deeb360f4$var$M.bind(null, a);
    b.type = a;
    return b;
};
$b9040d2deeb360f4$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b9040d2deeb360f4$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$v,
        render: a
    };
};
$b9040d2deeb360f4$export$a8257692ac88316c = $b9040d2deeb360f4$var$O;
$b9040d2deeb360f4$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b9040d2deeb360f4$var$T
    };
};
$b9040d2deeb360f4$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b9040d2deeb360f4$export$7568632d0d33d16d = function(a) {
    var b = $b9040d2deeb360f4$var$V.transition;
    $b9040d2deeb360f4$var$V.transition = {};
    try {
        a();
    } finally{
        $b9040d2deeb360f4$var$V.transition = b;
    }
};
$b9040d2deeb360f4$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$b9040d2deeb360f4$export$35808ee640e87ca7 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useCallback(a, b);
};
$b9040d2deeb360f4$export$fae74005e78b1a27 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useContext(a);
};
$b9040d2deeb360f4$export$dc8fbce3eb94dc1e = function() {};
$b9040d2deeb360f4$export$6a7bc4e911dc01cf = function(a) {
    return $b9040d2deeb360f4$var$U.current.useDeferredValue(a);
};
$b9040d2deeb360f4$export$6d9c69b0de29b591 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useEffect(a, b);
};
$b9040d2deeb360f4$export$f680877a34711e37 = function() {
    return $b9040d2deeb360f4$var$U.current.useId();
};
$b9040d2deeb360f4$export$d5a552a76deda3c2 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useImperativeHandle(a, b, e);
};
$b9040d2deeb360f4$export$aaabe4eda9ed9969 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useInsertionEffect(a, b);
};
$b9040d2deeb360f4$export$e5c5a5f917a5871c = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useLayoutEffect(a, b);
};
$b9040d2deeb360f4$export$1538c33de8887b59 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useMemo(a, b);
};
$b9040d2deeb360f4$export$13e3392192263954 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useReducer(a, b, e);
};
$b9040d2deeb360f4$export$b8f5890fc79d6aca = function(a) {
    return $b9040d2deeb360f4$var$U.current.useRef(a);
};
$b9040d2deeb360f4$export$60241385465d0a34 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useState(a);
};
$b9040d2deeb360f4$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useSyncExternalStore(a, b, e);
};
$b9040d2deeb360f4$export$7b286972b8d8ccbf = function() {
    return $b9040d2deeb360f4$var$U.current.useTransition();
};
$b9040d2deeb360f4$export$83d89fbfd8236492 = "18.2.0";

});


parcelRegister("fw0lo", function(module, exports) {
"use strict";
function $b4ba1c853f6e1116$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4ba1c853f6e1116$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4ba1c853f6e1116$var$checkDCE();

module.exports = (parcelRequire("6EA3T"));

});
parcelRegister("6EA3T", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4d82739dd229d539$export$ae55be85d98224ed; }, function (v) { return $4d82739dd229d539$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $4d82739dd229d539$export$d39a5bbd09211389; }, function (v) { return $4d82739dd229d539$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $4d82739dd229d539$export$882461b6382ed46c; }, function (v) { return $4d82739dd229d539$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $4d82739dd229d539$export$466bfc07425424d5; }, function (v) { return $4d82739dd229d539$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $4d82739dd229d539$export$cd75ccfd720a3cd4; }, function (v) { return $4d82739dd229d539$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $4d82739dd229d539$export$fa8d919ba61d84db; }, function (v) { return $4d82739dd229d539$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $4d82739dd229d539$export$757ceba2d55c277e; }, function (v) { return $4d82739dd229d539$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $4d82739dd229d539$export$b3890eb0ae9dca99; }, function (v) { return $4d82739dd229d539$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $4d82739dd229d539$export$502457920280e6be; }, function (v) { return $4d82739dd229d539$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $4d82739dd229d539$export$c78a37762a8d58e1; }, function (v) { return $4d82739dd229d539$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $4d82739dd229d539$export$dc54d992c10e8a18; }, function (v) { return $4d82739dd229d539$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $4d82739dd229d539$export$83d89fbfd8236492; }, function (v) { return $4d82739dd229d539$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $4d82739dd229d539$export$ae55be85d98224ed;
var $4d82739dd229d539$export$d39a5bbd09211389;
var $4d82739dd229d539$export$882461b6382ed46c;
var $4d82739dd229d539$export$466bfc07425424d5;
var $4d82739dd229d539$export$cd75ccfd720a3cd4;
var $4d82739dd229d539$export$fa8d919ba61d84db;
var $4d82739dd229d539$export$757ceba2d55c277e;
var $4d82739dd229d539$export$b3890eb0ae9dca99;
var $4d82739dd229d539$export$502457920280e6be;
var $4d82739dd229d539$export$c78a37762a8d58e1;
var $4d82739dd229d539$export$dc54d992c10e8a18;
var $4d82739dd229d539$export$83d89fbfd8236492;
"use strict";

var $7fPBF = parcelRequire("7fPBF");

var $4SikT = parcelRequire("4SikT");
function $4d82739dd229d539$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $4d82739dd229d539$var$da = new Set, $4d82739dd229d539$var$ea = {};
function $4d82739dd229d539$var$fa(a, b) {
    $4d82739dd229d539$var$ha(a, b);
    $4d82739dd229d539$var$ha(a + "Capture", b);
}
function $4d82739dd229d539$var$ha(a, b) {
    $4d82739dd229d539$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$4d82739dd229d539$var$da.add(b[a]);
}
var $4d82739dd229d539$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $4d82739dd229d539$var$ja = Object.prototype.hasOwnProperty, $4d82739dd229d539$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $4d82739dd229d539$var$la = {}, $4d82739dd229d539$var$ma = {};
function $4d82739dd229d539$var$oa(a) {
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$ma, a)) return !0;
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$la, a)) return !1;
    if ($4d82739dd229d539$var$ka.test(a)) return $4d82739dd229d539$var$ma[a] = !0;
    $4d82739dd229d539$var$la[a] = !0;
    return !1;
}
function $4d82739dd229d539$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $4d82739dd229d539$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $4d82739dd229d539$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $4d82739dd229d539$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $4d82739dd229d539$var$ra = /[\-:]([a-z])/g;
function $4d82739dd229d539$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$4d82739dd229d539$var$z.xlinkHref = new $4d82739dd229d539$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $4d82739dd229d539$var$ta(a, b, c, d) {
    var e = $4d82739dd229d539$var$z.hasOwnProperty(b) ? $4d82739dd229d539$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $4d82739dd229d539$var$qa(b, c, e, d) && (c = null), d || null === e ? $4d82739dd229d539$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $4d82739dd229d539$var$ua = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $4d82739dd229d539$var$va = Symbol.for("react.element"), $4d82739dd229d539$var$wa = Symbol.for("react.portal"), $4d82739dd229d539$var$ya = Symbol.for("react.fragment"), $4d82739dd229d539$var$za = Symbol.for("react.strict_mode"), $4d82739dd229d539$var$Aa = Symbol.for("react.profiler"), $4d82739dd229d539$var$Ba = Symbol.for("react.provider"), $4d82739dd229d539$var$Ca = Symbol.for("react.context"), $4d82739dd229d539$var$Da = Symbol.for("react.forward_ref"), $4d82739dd229d539$var$Ea = Symbol.for("react.suspense"), $4d82739dd229d539$var$Fa = Symbol.for("react.suspense_list"), $4d82739dd229d539$var$Ga = Symbol.for("react.memo"), $4d82739dd229d539$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $4d82739dd229d539$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $4d82739dd229d539$var$Ja = Symbol.iterator;
function $4d82739dd229d539$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4d82739dd229d539$var$Ja && a[$4d82739dd229d539$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4d82739dd229d539$var$A = Object.assign, $4d82739dd229d539$var$La;
function $4d82739dd229d539$var$Ma(a) {
    if (void 0 === $4d82739dd229d539$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $4d82739dd229d539$var$La = b && b[1] || "";
    }
    return "\n" + $4d82739dd229d539$var$La + a;
}
var $4d82739dd229d539$var$Na = !1;
function $4d82739dd229d539$var$Oa(a, b) {
    if (!a || $4d82739dd229d539$var$Na) return "";
    $4d82739dd229d539$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $4d82739dd229d539$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $4d82739dd229d539$var$Ma(a) : "";
}
function $4d82739dd229d539$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $4d82739dd229d539$var$Ma(a.type);
        case 16:
            return $4d82739dd229d539$var$Ma("Lazy");
        case 13:
            return $4d82739dd229d539$var$Ma("Suspense");
        case 19:
            return $4d82739dd229d539$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $4d82739dd229d539$var$Oa(a.type, !1), a;
        case 11:
            return a = $4d82739dd229d539$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $4d82739dd229d539$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $4d82739dd229d539$var$ya:
            return "Fragment";
        case $4d82739dd229d539$var$wa:
            return "Portal";
        case $4d82739dd229d539$var$Aa:
            return "Profiler";
        case $4d82739dd229d539$var$za:
            return "StrictMode";
        case $4d82739dd229d539$var$Ea:
            return "Suspense";
        case $4d82739dd229d539$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $4d82739dd229d539$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $4d82739dd229d539$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $4d82739dd229d539$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $4d82739dd229d539$var$Ga:
            return b = a.displayName || null, null !== b ? b : $4d82739dd229d539$var$Qa(a.type) || "Memo";
        case $4d82739dd229d539$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $4d82739dd229d539$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $4d82739dd229d539$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $4d82739dd229d539$var$Qa(b);
        case 8:
            return b === $4d82739dd229d539$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $4d82739dd229d539$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $4d82739dd229d539$var$Ua(a) {
    var b = $4d82739dd229d539$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $4d82739dd229d539$var$Va(a) {
    a._valueTracker || (a._valueTracker = $4d82739dd229d539$var$Ua(a));
}
function $4d82739dd229d539$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $4d82739dd229d539$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $4d82739dd229d539$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $4d82739dd229d539$var$Ya(a, b) {
    var c = b.checked;
    return $4d82739dd229d539$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $4d82739dd229d539$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $4d82739dd229d539$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $4d82739dd229d539$var$ab(a, b) {
    b = b.checked;
    null != b && $4d82739dd229d539$var$ta(a, "checked", b, !1);
}
function $4d82739dd229d539$var$bb(a, b) {
    $4d82739dd229d539$var$ab(a, b);
    var c = $4d82739dd229d539$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $4d82739dd229d539$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $4d82739dd229d539$var$cb(a, b.type, $4d82739dd229d539$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $4d82739dd229d539$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $4d82739dd229d539$var$cb(a, b, c) {
    if ("number" !== b || $4d82739dd229d539$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $4d82739dd229d539$var$eb = Array.isArray;
function $4d82739dd229d539$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $4d82739dd229d539$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $4d82739dd229d539$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($4d82739dd229d539$var$p(91));
    return $4d82739dd229d539$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $4d82739dd229d539$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($4d82739dd229d539$var$p(92));
            if ($4d82739dd229d539$var$eb(c)) {
                if (1 < c.length) throw Error($4d82739dd229d539$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $4d82739dd229d539$var$Sa(c)
    };
}
function $4d82739dd229d539$var$ib(a, b) {
    var c = $4d82739dd229d539$var$Sa(b.value), d = $4d82739dd229d539$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $4d82739dd229d539$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $4d82739dd229d539$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $4d82739dd229d539$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $4d82739dd229d539$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $4d82739dd229d539$var$mb, $4d82739dd229d539$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $4d82739dd229d539$var$mb = $4d82739dd229d539$var$mb || document.createElement("div");
        $4d82739dd229d539$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $4d82739dd229d539$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $4d82739dd229d539$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $4d82739dd229d539$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $4d82739dd229d539$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($4d82739dd229d539$var$pb).forEach(function(a) {
    $4d82739dd229d539$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $4d82739dd229d539$var$pb[b] = $4d82739dd229d539$var$pb[a];
    });
});
function $4d82739dd229d539$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $4d82739dd229d539$var$pb.hasOwnProperty(a) && $4d82739dd229d539$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $4d82739dd229d539$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $4d82739dd229d539$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $4d82739dd229d539$var$tb = $4d82739dd229d539$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $4d82739dd229d539$var$ub(a, b) {
    if (b) {
        if ($4d82739dd229d539$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($4d82739dd229d539$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($4d82739dd229d539$var$p(62));
    }
}
function $4d82739dd229d539$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $4d82739dd229d539$var$wb = null;
function $4d82739dd229d539$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $4d82739dd229d539$var$yb = null, $4d82739dd229d539$var$zb = null, $4d82739dd229d539$var$Ab = null;
function $4d82739dd229d539$var$Bb(a) {
    if (a = $4d82739dd229d539$var$Cb(a)) {
        if ("function" !== typeof $4d82739dd229d539$var$yb) throw Error($4d82739dd229d539$var$p(280));
        var b = a.stateNode;
        b && (b = $4d82739dd229d539$var$Db(b), $4d82739dd229d539$var$yb(a.stateNode, a.type, b));
    }
}
function $4d82739dd229d539$var$Eb(a) {
    $4d82739dd229d539$var$zb ? $4d82739dd229d539$var$Ab ? $4d82739dd229d539$var$Ab.push(a) : $4d82739dd229d539$var$Ab = [
        a
    ] : $4d82739dd229d539$var$zb = a;
}
function $4d82739dd229d539$var$Fb() {
    if ($4d82739dd229d539$var$zb) {
        var a = $4d82739dd229d539$var$zb, b = $4d82739dd229d539$var$Ab;
        $4d82739dd229d539$var$Ab = $4d82739dd229d539$var$zb = null;
        $4d82739dd229d539$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$4d82739dd229d539$var$Bb(b[a]);
    }
}
function $4d82739dd229d539$var$Gb(a, b) {
    return a(b);
}
function $4d82739dd229d539$var$Hb() {}
var $4d82739dd229d539$var$Ib = !1;
function $4d82739dd229d539$var$Jb(a, b, c) {
    if ($4d82739dd229d539$var$Ib) return a(b, c);
    $4d82739dd229d539$var$Ib = !0;
    try {
        return $4d82739dd229d539$var$Gb(a, b, c);
    } finally{
        if ($4d82739dd229d539$var$Ib = !1, null !== $4d82739dd229d539$var$zb || null !== $4d82739dd229d539$var$Ab) $4d82739dd229d539$var$Hb(), $4d82739dd229d539$var$Fb();
    }
}
function $4d82739dd229d539$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $4d82739dd229d539$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($4d82739dd229d539$var$p(231, b, typeof c));
    return c;
}
var $4d82739dd229d539$var$Lb = !1;
if ($4d82739dd229d539$var$ia) try {
    var $4d82739dd229d539$var$Mb = {};
    Object.defineProperty($4d82739dd229d539$var$Mb, "passive", {
        get: function() {
            $4d82739dd229d539$var$Lb = !0;
        }
    });
    window.addEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
    window.removeEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
} catch (a) {
    $4d82739dd229d539$var$Lb = !1;
}
function $4d82739dd229d539$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $4d82739dd229d539$var$Ob = !1, $4d82739dd229d539$var$Pb = null, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, $4d82739dd229d539$var$Sb = {
    onError: function(a) {
        $4d82739dd229d539$var$Ob = !0;
        $4d82739dd229d539$var$Pb = a;
    }
};
function $4d82739dd229d539$var$Tb(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Ob = !1;
    $4d82739dd229d539$var$Pb = null;
    $4d82739dd229d539$var$Nb.apply($4d82739dd229d539$var$Sb, arguments);
}
function $4d82739dd229d539$var$Ub(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Tb.apply(this, arguments);
    if ($4d82739dd229d539$var$Ob) {
        if ($4d82739dd229d539$var$Ob) {
            var l = $4d82739dd229d539$var$Pb;
            $4d82739dd229d539$var$Ob = !1;
            $4d82739dd229d539$var$Pb = null;
        } else throw Error($4d82739dd229d539$var$p(198));
        $4d82739dd229d539$var$Qb || ($4d82739dd229d539$var$Qb = !0, $4d82739dd229d539$var$Rb = l);
    }
}
function $4d82739dd229d539$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $4d82739dd229d539$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $4d82739dd229d539$var$Xb(a) {
    if ($4d82739dd229d539$var$Vb(a) !== a) throw Error($4d82739dd229d539$var$p(188));
}
function $4d82739dd229d539$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $4d82739dd229d539$var$Vb(a);
        if (null === b) throw Error($4d82739dd229d539$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $4d82739dd229d539$var$Xb(e), a;
                if (f === d) return $4d82739dd229d539$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($4d82739dd229d539$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($4d82739dd229d539$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($4d82739dd229d539$var$p(190));
    }
    if (3 !== c.tag) throw Error($4d82739dd229d539$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $4d82739dd229d539$var$Zb(a) {
    a = $4d82739dd229d539$var$Yb(a);
    return null !== a ? $4d82739dd229d539$var$$b(a) : null;
}
function $4d82739dd229d539$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $4d82739dd229d539$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$ac = $4SikT.unstable_scheduleCallback, $4d82739dd229d539$var$bc = $4SikT.unstable_cancelCallback, $4d82739dd229d539$var$cc = $4SikT.unstable_shouldYield, $4d82739dd229d539$var$dc = $4SikT.unstable_requestPaint, $4d82739dd229d539$var$B = $4SikT.unstable_now, $4d82739dd229d539$var$ec = $4SikT.unstable_getCurrentPriorityLevel, $4d82739dd229d539$var$fc = $4SikT.unstable_ImmediatePriority, $4d82739dd229d539$var$gc = $4SikT.unstable_UserBlockingPriority, $4d82739dd229d539$var$hc = $4SikT.unstable_NormalPriority, $4d82739dd229d539$var$ic = $4SikT.unstable_LowPriority, $4d82739dd229d539$var$jc = $4SikT.unstable_IdlePriority, $4d82739dd229d539$var$kc = null, $4d82739dd229d539$var$lc = null;
function $4d82739dd229d539$var$mc(a) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberRoot) try {
        $4d82739dd229d539$var$lc.onCommitFiberRoot($4d82739dd229d539$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $4d82739dd229d539$var$oc = Math.clz32 ? Math.clz32 : $4d82739dd229d539$var$nc, $4d82739dd229d539$var$pc = Math.log, $4d82739dd229d539$var$qc = Math.LN2;
function $4d82739dd229d539$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($4d82739dd229d539$var$pc(a) / $4d82739dd229d539$var$qc | 0) | 0;
}
var $4d82739dd229d539$var$rc = 64, $4d82739dd229d539$var$sc = 4194304;
function $4d82739dd229d539$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $4d82739dd229d539$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $4d82739dd229d539$var$tc(h) : (f &= g, 0 !== f && (d = $4d82739dd229d539$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $4d82739dd229d539$var$tc(g) : 0 !== f && (d = $4d82739dd229d539$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $4d82739dd229d539$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $4d82739dd229d539$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $4d82739dd229d539$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $4d82739dd229d539$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $4d82739dd229d539$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $4d82739dd229d539$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $4d82739dd229d539$var$yc() {
    var a = $4d82739dd229d539$var$rc;
    $4d82739dd229d539$var$rc <<= 1;
    0 === ($4d82739dd229d539$var$rc & 4194240) && ($4d82739dd229d539$var$rc = 64);
    return a;
}
function $4d82739dd229d539$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $4d82739dd229d539$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $4d82739dd229d539$var$oc(b);
    a[b] = c;
}
function $4d82739dd229d539$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $4d82739dd229d539$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $4d82739dd229d539$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $4d82739dd229d539$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $4d82739dd229d539$var$C = 0;
function $4d82739dd229d539$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $4d82739dd229d539$var$Ec, $4d82739dd229d539$var$Fc, $4d82739dd229d539$var$Gc, $4d82739dd229d539$var$Hc, $4d82739dd229d539$var$Ic, $4d82739dd229d539$var$Jc = !1, $4d82739dd229d539$var$Kc = [], $4d82739dd229d539$var$Lc = null, $4d82739dd229d539$var$Mc = null, $4d82739dd229d539$var$Nc = null, $4d82739dd229d539$var$Oc = new Map, $4d82739dd229d539$var$Pc = new Map, $4d82739dd229d539$var$Qc = [], $4d82739dd229d539$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $4d82739dd229d539$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $4d82739dd229d539$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $4d82739dd229d539$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $4d82739dd229d539$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $4d82739dd229d539$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $4d82739dd229d539$var$Pc.delete(b.pointerId);
    }
}
function $4d82739dd229d539$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $4d82739dd229d539$var$Cb(b), null !== b && $4d82739dd229d539$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $4d82739dd229d539$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $4d82739dd229d539$var$Lc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $4d82739dd229d539$var$Mc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $4d82739dd229d539$var$Nc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $4d82739dd229d539$var$Oc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $4d82739dd229d539$var$Pc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $4d82739dd229d539$var$Vc(a) {
    var b = $4d82739dd229d539$var$Wc(a.target);
    if (null !== b) {
        var c = $4d82739dd229d539$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $4d82739dd229d539$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $4d82739dd229d539$var$Ic(a.priority, function() {
                        $4d82739dd229d539$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $4d82739dd229d539$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $4d82739dd229d539$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $4d82739dd229d539$var$wb = d;
            c.target.dispatchEvent(d);
            $4d82739dd229d539$var$wb = null;
        } else return b = $4d82739dd229d539$var$Cb(c), null !== b && $4d82739dd229d539$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $4d82739dd229d539$var$Zc(a, b, c) {
    $4d82739dd229d539$var$Xc(a) && c.delete(b);
}
function $4d82739dd229d539$var$$c() {
    $4d82739dd229d539$var$Jc = !1;
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Lc) && ($4d82739dd229d539$var$Lc = null);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Mc) && ($4d82739dd229d539$var$Mc = null);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Nc) && ($4d82739dd229d539$var$Nc = null);
    $4d82739dd229d539$var$Oc.forEach($4d82739dd229d539$var$Zc);
    $4d82739dd229d539$var$Pc.forEach($4d82739dd229d539$var$Zc);
}
function $4d82739dd229d539$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $4d82739dd229d539$var$Jc || ($4d82739dd229d539$var$Jc = !0, $4SikT.unstable_scheduleCallback($4SikT.unstable_NormalPriority, $4d82739dd229d539$var$$c)));
}
function $4d82739dd229d539$var$bd(a) {
    function b(b) {
        return $4d82739dd229d539$var$ad(b, a);
    }
    if (0 < $4d82739dd229d539$var$Kc.length) {
        $4d82739dd229d539$var$ad($4d82739dd229d539$var$Kc[0], a);
        for(var c = 1; c < $4d82739dd229d539$var$Kc.length; c++){
            var d = $4d82739dd229d539$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Lc, a);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Mc, a);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Nc, a);
    $4d82739dd229d539$var$Oc.forEach(b);
    $4d82739dd229d539$var$Pc.forEach(b);
    for(c = 0; c < $4d82739dd229d539$var$Qc.length; c++)d = $4d82739dd229d539$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $4d82739dd229d539$var$Qc.length && (c = $4d82739dd229d539$var$Qc[0], null === c.blockedOn);)$4d82739dd229d539$var$Vc(c), null === c.blockedOn && $4d82739dd229d539$var$Qc.shift();
}
var $4d82739dd229d539$var$cd = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$dd = !0;
function $4d82739dd229d539$var$ed(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$gd(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 4, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$fd(a, b, c, d) {
    if ($4d82739dd229d539$var$dd) {
        var e = $4d82739dd229d539$var$Yc(a, b, c, d);
        if (null === e) $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c), $4d82739dd229d539$var$Sc(a, d);
        else if ($4d82739dd229d539$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($4d82739dd229d539$var$Sc(a, d), b & 4 && -1 < $4d82739dd229d539$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $4d82739dd229d539$var$Cb(e);
                null !== f && $4d82739dd229d539$var$Ec(f);
                f = $4d82739dd229d539$var$Yc(a, b, c, d);
                null === f && $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $4d82739dd229d539$var$hd(a, b, d, null, c);
    }
}
var $4d82739dd229d539$var$id = null;
function $4d82739dd229d539$var$Yc(a, b, c, d) {
    $4d82739dd229d539$var$id = null;
    a = $4d82739dd229d539$var$xb(d);
    a = $4d82739dd229d539$var$Wc(a);
    if (null !== a) {
        if (b = $4d82739dd229d539$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $4d82739dd229d539$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $4d82739dd229d539$var$id = a;
    return null;
}
function $4d82739dd229d539$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($4d82739dd229d539$var$ec()){
                case $4d82739dd229d539$var$fc:
                    return 1;
                case $4d82739dd229d539$var$gc:
                    return 4;
                case $4d82739dd229d539$var$hc:
                case $4d82739dd229d539$var$ic:
                    return 16;
                case $4d82739dd229d539$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ld = null, $4d82739dd229d539$var$md = null;
function $4d82739dd229d539$var$nd() {
    if ($4d82739dd229d539$var$md) return $4d82739dd229d539$var$md;
    var a, b = $4d82739dd229d539$var$ld, c = b.length, d, e = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $4d82739dd229d539$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $4d82739dd229d539$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $4d82739dd229d539$var$pd() {
    return !0;
}
function $4d82739dd229d539$var$qd() {
    return !1;
}
function $4d82739dd229d539$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $4d82739dd229d539$var$pd : $4d82739dd229d539$var$qd;
        this.isPropagationStopped = $4d82739dd229d539$var$qd;
        return this;
    }
    $4d82739dd229d539$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $4d82739dd229d539$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $4d82739dd229d539$var$pd);
        },
        persist: function() {},
        isPersistent: $4d82739dd229d539$var$pd
    });
    return b;
}
var $4d82739dd229d539$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $4d82739dd229d539$var$td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$sd), $4d82739dd229d539$var$ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    view: 0,
    detail: 0
}), $4d82739dd229d539$var$vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$ud), $4d82739dd229d539$var$wd, $4d82739dd229d539$var$xd, $4d82739dd229d539$var$yd, $4d82739dd229d539$var$Ad = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $4d82739dd229d539$var$yd && ($4d82739dd229d539$var$yd && "mousemove" === a.type ? ($4d82739dd229d539$var$wd = a.screenX - $4d82739dd229d539$var$yd.screenX, $4d82739dd229d539$var$xd = a.screenY - $4d82739dd229d539$var$yd.screenY) : $4d82739dd229d539$var$xd = $4d82739dd229d539$var$wd = 0, $4d82739dd229d539$var$yd = a);
        return $4d82739dd229d539$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $4d82739dd229d539$var$xd;
    }
}), $4d82739dd229d539$var$Bd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ad), $4d82739dd229d539$var$Cd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    dataTransfer: 0
}), $4d82739dd229d539$var$Dd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Cd), $4d82739dd229d539$var$Ed = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    relatedTarget: 0
}), $4d82739dd229d539$var$Fd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ed), $4d82739dd229d539$var$Gd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Hd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Gd), $4d82739dd229d539$var$Id = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $4d82739dd229d539$var$Jd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Id), $4d82739dd229d539$var$Kd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    data: 0
}), $4d82739dd229d539$var$Ld = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Kd), $4d82739dd229d539$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $4d82739dd229d539$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $4d82739dd229d539$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $4d82739dd229d539$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $4d82739dd229d539$var$Od[a]) ? !!b[a] : !1;
}
function $4d82739dd229d539$var$zd() {
    return $4d82739dd229d539$var$Pd;
}
var $4d82739dd229d539$var$Qd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $4d82739dd229d539$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $4d82739dd229d539$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $4d82739dd229d539$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $4d82739dd229d539$var$Rd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Qd), $4d82739dd229d539$var$Sd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $4d82739dd229d539$var$Td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Sd), $4d82739dd229d539$var$Ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $4d82739dd229d539$var$zd
}), $4d82739dd229d539$var$Vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ud), $4d82739dd229d539$var$Wd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Xd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Wd), $4d82739dd229d539$var$Yd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $4d82739dd229d539$var$Zd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Yd), $4d82739dd229d539$var$$d = [
    9,
    13,
    27,
    32
], $4d82739dd229d539$var$ae = $4d82739dd229d539$var$ia && "CompositionEvent" in window, $4d82739dd229d539$var$be = null;
$4d82739dd229d539$var$ia && "documentMode" in document && ($4d82739dd229d539$var$be = document.documentMode);
var $4d82739dd229d539$var$ce = $4d82739dd229d539$var$ia && "TextEvent" in window && !$4d82739dd229d539$var$be, $4d82739dd229d539$var$de = $4d82739dd229d539$var$ia && (!$4d82739dd229d539$var$ae || $4d82739dd229d539$var$be && 8 < $4d82739dd229d539$var$be && 11 >= $4d82739dd229d539$var$be), $4d82739dd229d539$var$ee = String.fromCharCode(32), $4d82739dd229d539$var$fe = !1;
function $4d82739dd229d539$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $4d82739dd229d539$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $4d82739dd229d539$var$ie = !1;
function $4d82739dd229d539$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $4d82739dd229d539$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $4d82739dd229d539$var$fe = !0;
            return $4d82739dd229d539$var$ee;
        case "textInput":
            return a = b.data, a === $4d82739dd229d539$var$ee && $4d82739dd229d539$var$fe ? null : a;
        default:
            return null;
    }
}
function $4d82739dd229d539$var$ke(a, b) {
    if ($4d82739dd229d539$var$ie) return "compositionend" === a || !$4d82739dd229d539$var$ae && $4d82739dd229d539$var$ge(a, b) ? (a = $4d82739dd229d539$var$nd(), $4d82739dd229d539$var$md = $4d82739dd229d539$var$ld = $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $4d82739dd229d539$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $4d82739dd229d539$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$4d82739dd229d539$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $4d82739dd229d539$var$ne(a, b, c, d) {
    $4d82739dd229d539$var$Eb(d);
    b = $4d82739dd229d539$var$oe(b, "onChange");
    0 < b.length && (c = new $4d82739dd229d539$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $4d82739dd229d539$var$pe = null, $4d82739dd229d539$var$qe = null;
function $4d82739dd229d539$var$re(a) {
    $4d82739dd229d539$var$se(a, 0);
}
function $4d82739dd229d539$var$te(a) {
    var b = $4d82739dd229d539$var$ue(a);
    if ($4d82739dd229d539$var$Wa(b)) return a;
}
function $4d82739dd229d539$var$ve(a, b) {
    if ("change" === a) return b;
}
var $4d82739dd229d539$var$we = !1;
if ($4d82739dd229d539$var$ia) {
    var $4d82739dd229d539$var$xe;
    if ($4d82739dd229d539$var$ia) {
        var $4d82739dd229d539$var$ye = "oninput" in document;
        if (!$4d82739dd229d539$var$ye) {
            var $4d82739dd229d539$var$ze = document.createElement("div");
            $4d82739dd229d539$var$ze.setAttribute("oninput", "return;");
            $4d82739dd229d539$var$ye = "function" === typeof $4d82739dd229d539$var$ze.oninput;
        }
        $4d82739dd229d539$var$xe = $4d82739dd229d539$var$ye;
    } else $4d82739dd229d539$var$xe = !1;
    $4d82739dd229d539$var$we = $4d82739dd229d539$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $4d82739dd229d539$var$Ae() {
    $4d82739dd229d539$var$pe && ($4d82739dd229d539$var$pe.detachEvent("onpropertychange", $4d82739dd229d539$var$Be), $4d82739dd229d539$var$qe = $4d82739dd229d539$var$pe = null);
}
function $4d82739dd229d539$var$Be(a) {
    if ("value" === a.propertyName && $4d82739dd229d539$var$te($4d82739dd229d539$var$qe)) {
        var b = [];
        $4d82739dd229d539$var$ne(b, $4d82739dd229d539$var$qe, a, $4d82739dd229d539$var$xb(a));
        $4d82739dd229d539$var$Jb($4d82739dd229d539$var$re, b);
    }
}
function $4d82739dd229d539$var$Ce(a, b, c) {
    "focusin" === a ? ($4d82739dd229d539$var$Ae(), $4d82739dd229d539$var$pe = b, $4d82739dd229d539$var$qe = c, $4d82739dd229d539$var$pe.attachEvent("onpropertychange", $4d82739dd229d539$var$Be)) : "focusout" === a && $4d82739dd229d539$var$Ae();
}
function $4d82739dd229d539$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $4d82739dd229d539$var$te($4d82739dd229d539$var$qe);
}
function $4d82739dd229d539$var$Ee(a, b) {
    if ("click" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $4d82739dd229d539$var$He = "function" === typeof Object.is ? Object.is : $4d82739dd229d539$var$Ge;
function $4d82739dd229d539$var$Ie(a, b) {
    if ($4d82739dd229d539$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$4d82739dd229d539$var$ja.call(b, e) || !$4d82739dd229d539$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $4d82739dd229d539$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $4d82739dd229d539$var$Ke(a, b) {
    var c = $4d82739dd229d539$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $4d82739dd229d539$var$Je(c);
    }
}
function $4d82739dd229d539$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $4d82739dd229d539$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $4d82739dd229d539$var$Me() {
    for(var a = window, b = $4d82739dd229d539$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $4d82739dd229d539$var$Xa(a.document);
    }
    return b;
}
function $4d82739dd229d539$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $4d82739dd229d539$var$Oe(a) {
    var b = $4d82739dd229d539$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $4d82739dd229d539$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $4d82739dd229d539$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $4d82739dd229d539$var$Ke(c, f);
                var g = $4d82739dd229d539$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $4d82739dd229d539$var$Pe = $4d82739dd229d539$var$ia && "documentMode" in document && 11 >= document.documentMode, $4d82739dd229d539$var$Qe = null, $4d82739dd229d539$var$Re = null, $4d82739dd229d539$var$Se = null, $4d82739dd229d539$var$Te = !1;
function $4d82739dd229d539$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $4d82739dd229d539$var$Te || null == $4d82739dd229d539$var$Qe || $4d82739dd229d539$var$Qe !== $4d82739dd229d539$var$Xa(d) || (d = $4d82739dd229d539$var$Qe, "selectionStart" in d && $4d82739dd229d539$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $4d82739dd229d539$var$Se && $4d82739dd229d539$var$Ie($4d82739dd229d539$var$Se, d) || ($4d82739dd229d539$var$Se = d, d = $4d82739dd229d539$var$oe($4d82739dd229d539$var$Re, "onSelect"), 0 < d.length && (b = new $4d82739dd229d539$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $4d82739dd229d539$var$Qe)));
}
function $4d82739dd229d539$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $4d82739dd229d539$var$We = {
    animationend: $4d82739dd229d539$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $4d82739dd229d539$var$Ve("Animation", "AnimationIteration"),
    animationstart: $4d82739dd229d539$var$Ve("Animation", "AnimationStart"),
    transitionend: $4d82739dd229d539$var$Ve("Transition", "TransitionEnd")
}, $4d82739dd229d539$var$Xe = {}, $4d82739dd229d539$var$Ye = {};
$4d82739dd229d539$var$ia && ($4d82739dd229d539$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $4d82739dd229d539$var$We.animationend.animation, delete $4d82739dd229d539$var$We.animationiteration.animation, delete $4d82739dd229d539$var$We.animationstart.animation), "TransitionEvent" in window || delete $4d82739dd229d539$var$We.transitionend.transition);
function $4d82739dd229d539$var$Ze(a) {
    if ($4d82739dd229d539$var$Xe[a]) return $4d82739dd229d539$var$Xe[a];
    if (!$4d82739dd229d539$var$We[a]) return a;
    var b = $4d82739dd229d539$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $4d82739dd229d539$var$Ye) return $4d82739dd229d539$var$Xe[a] = b[c];
    return a;
}
var $4d82739dd229d539$var$$e = $4d82739dd229d539$var$Ze("animationend"), $4d82739dd229d539$var$af = $4d82739dd229d539$var$Ze("animationiteration"), $4d82739dd229d539$var$bf = $4d82739dd229d539$var$Ze("animationstart"), $4d82739dd229d539$var$cf = $4d82739dd229d539$var$Ze("transitionend"), $4d82739dd229d539$var$df = new Map, $4d82739dd229d539$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $4d82739dd229d539$var$ff(a, b) {
    $4d82739dd229d539$var$df.set(a, b);
    $4d82739dd229d539$var$fa(b, [
        a
    ]);
}
for(var $4d82739dd229d539$var$gf = 0; $4d82739dd229d539$var$gf < $4d82739dd229d539$var$ef.length; $4d82739dd229d539$var$gf++){
    var $4d82739dd229d539$var$hf = $4d82739dd229d539$var$ef[$4d82739dd229d539$var$gf], $4d82739dd229d539$var$jf = $4d82739dd229d539$var$hf.toLowerCase(), $4d82739dd229d539$var$kf = $4d82739dd229d539$var$hf[0].toUpperCase() + $4d82739dd229d539$var$hf.slice(1);
    $4d82739dd229d539$var$ff($4d82739dd229d539$var$jf, "on" + $4d82739dd229d539$var$kf);
}
$4d82739dd229d539$var$ff($4d82739dd229d539$var$$e, "onAnimationEnd");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$af, "onAnimationIteration");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$bf, "onAnimationStart");
$4d82739dd229d539$var$ff("dblclick", "onDoubleClick");
$4d82739dd229d539$var$ff("focusin", "onFocus");
$4d82739dd229d539$var$ff("focusout", "onBlur");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$cf, "onTransitionEnd");
$4d82739dd229d539$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$4d82739dd229d539$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $4d82739dd229d539$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $4d82739dd229d539$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($4d82739dd229d539$var$lf));
function $4d82739dd229d539$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $4d82739dd229d539$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $4d82739dd229d539$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($4d82739dd229d539$var$Qb) throw a = $4d82739dd229d539$var$Rb, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, a;
}
function $4d82739dd229d539$var$D(a, b) {
    var c = b[$4d82739dd229d539$var$of];
    void 0 === c && (c = b[$4d82739dd229d539$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($4d82739dd229d539$var$pf(b, a, 2, !1), c.add(d));
}
function $4d82739dd229d539$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $4d82739dd229d539$var$pf(c, a, d, b);
}
var $4d82739dd229d539$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $4d82739dd229d539$var$sf(a) {
    if (!a[$4d82739dd229d539$var$rf]) {
        a[$4d82739dd229d539$var$rf] = !0;
        $4d82739dd229d539$var$da.forEach(function(b) {
            "selectionchange" !== b && ($4d82739dd229d539$var$mf.has(b) || $4d82739dd229d539$var$qf(b, !1, a), $4d82739dd229d539$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$4d82739dd229d539$var$rf] || (b[$4d82739dd229d539$var$rf] = !0, $4d82739dd229d539$var$qf("selectionchange", !1, b));
    }
}
function $4d82739dd229d539$var$pf(a, b, c, d) {
    switch($4d82739dd229d539$var$jd(b)){
        case 1:
            var e = $4d82739dd229d539$var$ed;
            break;
        case 4:
            e = $4d82739dd229d539$var$gd;
            break;
        default:
            e = $4d82739dd229d539$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$4d82739dd229d539$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $4d82739dd229d539$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $4d82739dd229d539$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $4d82739dd229d539$var$Jb(function() {
        var d = f, e = $4d82739dd229d539$var$xb(c), g = [];
        a: {
            var h = $4d82739dd229d539$var$df.get(a);
            if (void 0 !== h) {
                var k = $4d82739dd229d539$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $4d82739dd229d539$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $4d82739dd229d539$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $4d82739dd229d539$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $4d82739dd229d539$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $4d82739dd229d539$var$Vd;
                        break;
                    case $4d82739dd229d539$var$$e:
                    case $4d82739dd229d539$var$af:
                    case $4d82739dd229d539$var$bf:
                        k = $4d82739dd229d539$var$Hd;
                        break;
                    case $4d82739dd229d539$var$cf:
                        k = $4d82739dd229d539$var$Xd;
                        break;
                    case "scroll":
                        k = $4d82739dd229d539$var$vd;
                        break;
                    case "wheel":
                        k = $4d82739dd229d539$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $4d82739dd229d539$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $4d82739dd229d539$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $4d82739dd229d539$var$Kb(w, x), null != F && t.push($4d82739dd229d539$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $4d82739dd229d539$var$wb && (n = c.relatedTarget || c.fromElement) && ($4d82739dd229d539$var$Wc(n) || n[$4d82739dd229d539$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $4d82739dd229d539$var$Wc(n) : null, null !== n && (J = $4d82739dd229d539$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $4d82739dd229d539$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $4d82739dd229d539$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $4d82739dd229d539$var$ue(k);
                        u = null == n ? h : $4d82739dd229d539$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $4d82739dd229d539$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $4d82739dd229d539$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $4d82739dd229d539$var$vf(F))u++;
                            for(; 0 < w - u;)t = $4d82739dd229d539$var$vf(t), w--;
                            for(; 0 < u - w;)x = $4d82739dd229d539$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $4d82739dd229d539$var$vf(t);
                                x = $4d82739dd229d539$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $4d82739dd229d539$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $4d82739dd229d539$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $4d82739dd229d539$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $4d82739dd229d539$var$ve;
                else if ($4d82739dd229d539$var$me(h)) {
                    if ($4d82739dd229d539$var$we) na = $4d82739dd229d539$var$Fe;
                    else {
                        na = $4d82739dd229d539$var$De;
                        var xa = $4d82739dd229d539$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $4d82739dd229d539$var$Ee);
                if (na && (na = na(a, d))) {
                    $4d82739dd229d539$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $4d82739dd229d539$var$cb(h, "number", h.value);
            }
            xa = d ? $4d82739dd229d539$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($4d82739dd229d539$var$me(xa) || "true" === xa.contentEditable) $4d82739dd229d539$var$Qe = xa, $4d82739dd229d539$var$Re = d, $4d82739dd229d539$var$Se = null;
                    break;
                case "focusout":
                    $4d82739dd229d539$var$Se = $4d82739dd229d539$var$Re = $4d82739dd229d539$var$Qe = null;
                    break;
                case "mousedown":
                    $4d82739dd229d539$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $4d82739dd229d539$var$Te = !1;
                    $4d82739dd229d539$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($4d82739dd229d539$var$Pe) break;
                case "keydown":
                case "keyup":
                    $4d82739dd229d539$var$Ue(g, c, e);
            }
            var $a;
            if ($4d82739dd229d539$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $4d82739dd229d539$var$ie ? $4d82739dd229d539$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($4d82739dd229d539$var$de && "ko" !== c.locale && ($4d82739dd229d539$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $4d82739dd229d539$var$ie && ($a = $4d82739dd229d539$var$nd()) : ($4d82739dd229d539$var$kd = e, $4d82739dd229d539$var$ld = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, $4d82739dd229d539$var$ie = !0)), xa = $4d82739dd229d539$var$oe(d, ba), 0 < xa.length && (ba = new $4d82739dd229d539$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $4d82739dd229d539$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $4d82739dd229d539$var$ce ? $4d82739dd229d539$var$je(a, c) : $4d82739dd229d539$var$ke(a, c)) d = $4d82739dd229d539$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $4d82739dd229d539$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $4d82739dd229d539$var$se(g, b);
    });
}
function $4d82739dd229d539$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $4d82739dd229d539$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $4d82739dd229d539$var$Kb(a, c), null != f && d.unshift($4d82739dd229d539$var$tf(a, f, e)), f = $4d82739dd229d539$var$Kb(a, b), null != f && d.push($4d82739dd229d539$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $4d82739dd229d539$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $4d82739dd229d539$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.unshift($4d82739dd229d539$var$tf(c, k, h))) : e || (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.push($4d82739dd229d539$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $4d82739dd229d539$var$xf = /\r\n?/g, $4d82739dd229d539$var$yf = /\u0000|\uFFFD/g;
function $4d82739dd229d539$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($4d82739dd229d539$var$xf, "\n").replace($4d82739dd229d539$var$yf, "");
}
function $4d82739dd229d539$var$Af(a, b, c) {
    b = $4d82739dd229d539$var$zf(b);
    if ($4d82739dd229d539$var$zf(a) !== b && c) throw Error($4d82739dd229d539$var$p(425));
}
function $4d82739dd229d539$var$Bf() {}
var $4d82739dd229d539$var$Cf = null, $4d82739dd229d539$var$Df = null;
function $4d82739dd229d539$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $4d82739dd229d539$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $4d82739dd229d539$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $4d82739dd229d539$var$Hf = "function" === typeof Promise ? Promise : void 0, $4d82739dd229d539$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $4d82739dd229d539$var$Hf ? function(a) {
    return $4d82739dd229d539$var$Hf.resolve(null).then(a).catch($4d82739dd229d539$var$If);
} : $4d82739dd229d539$var$Ff;
function $4d82739dd229d539$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $4d82739dd229d539$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $4d82739dd229d539$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $4d82739dd229d539$var$bd(b);
}
function $4d82739dd229d539$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $4d82739dd229d539$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $4d82739dd229d539$var$Nf = Math.random().toString(36).slice(2), $4d82739dd229d539$var$Of = "__reactFiber$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Pf = "__reactProps$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$uf = "__reactContainer$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$of = "__reactEvents$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Qf = "__reactListeners$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Rf = "__reactHandles$" + $4d82739dd229d539$var$Nf;
function $4d82739dd229d539$var$Wc(a) {
    var b = a[$4d82739dd229d539$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$4d82739dd229d539$var$uf] || c[$4d82739dd229d539$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $4d82739dd229d539$var$Mf(a); null !== a;){
                if (c = a[$4d82739dd229d539$var$Of]) return c;
                a = $4d82739dd229d539$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $4d82739dd229d539$var$Cb(a) {
    a = a[$4d82739dd229d539$var$Of] || a[$4d82739dd229d539$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $4d82739dd229d539$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($4d82739dd229d539$var$p(33));
}
function $4d82739dd229d539$var$Db(a) {
    return a[$4d82739dd229d539$var$Pf] || null;
}
var $4d82739dd229d539$var$Sf = [], $4d82739dd229d539$var$Tf = -1;
function $4d82739dd229d539$var$Uf(a) {
    return {
        current: a
    };
}
function $4d82739dd229d539$var$E(a) {
    0 > $4d82739dd229d539$var$Tf || (a.current = $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf], $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = null, $4d82739dd229d539$var$Tf--);
}
function $4d82739dd229d539$var$G(a, b) {
    $4d82739dd229d539$var$Tf++;
    $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = a.current;
    a.current = b;
}
var $4d82739dd229d539$var$Vf = {}, $4d82739dd229d539$var$H = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Vf), $4d82739dd229d539$var$Wf = $4d82739dd229d539$var$Uf(!1), $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$Vf;
function $4d82739dd229d539$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $4d82739dd229d539$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $4d82739dd229d539$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $4d82739dd229d539$var$$f() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
}
function $4d82739dd229d539$var$ag(a, b, c) {
    if ($4d82739dd229d539$var$H.current !== $4d82739dd229d539$var$Vf) throw Error($4d82739dd229d539$var$p(168));
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
function $4d82739dd229d539$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($4d82739dd229d539$var$p(108, $4d82739dd229d539$var$Ra(a) || "Unknown", e));
    return $4d82739dd229d539$var$A({}, c, d);
}
function $4d82739dd229d539$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $4d82739dd229d539$var$Vf;
    $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$H.current;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, $4d82739dd229d539$var$Wf.current);
    return !0;
}
function $4d82739dd229d539$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($4d82739dd229d539$var$p(169));
    c ? (a = $4d82739dd229d539$var$bg(a, b, $4d82739dd229d539$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a)) : $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
var $4d82739dd229d539$var$eg = null, $4d82739dd229d539$var$fg = !1, $4d82739dd229d539$var$gg = !1;
function $4d82739dd229d539$var$hg(a) {
    null === $4d82739dd229d539$var$eg ? $4d82739dd229d539$var$eg = [
        a
    ] : $4d82739dd229d539$var$eg.push(a);
}
function $4d82739dd229d539$var$ig(a) {
    $4d82739dd229d539$var$fg = !0;
    $4d82739dd229d539$var$hg(a);
}
function $4d82739dd229d539$var$jg() {
    if (!$4d82739dd229d539$var$gg && null !== $4d82739dd229d539$var$eg) {
        $4d82739dd229d539$var$gg = !0;
        var a = 0, b = $4d82739dd229d539$var$C;
        try {
            var c = $4d82739dd229d539$var$eg;
            for($4d82739dd229d539$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $4d82739dd229d539$var$eg = null;
            $4d82739dd229d539$var$fg = !1;
        } catch (e) {
            throw null !== $4d82739dd229d539$var$eg && ($4d82739dd229d539$var$eg = $4d82739dd229d539$var$eg.slice(a + 1)), $4d82739dd229d539$var$ac($4d82739dd229d539$var$fc, $4d82739dd229d539$var$jg), e;
        } finally{
            $4d82739dd229d539$var$C = b, $4d82739dd229d539$var$gg = !1;
        }
    }
    return null;
}
var $4d82739dd229d539$var$kg = [], $4d82739dd229d539$var$lg = 0, $4d82739dd229d539$var$mg = null, $4d82739dd229d539$var$ng = 0, $4d82739dd229d539$var$og = [], $4d82739dd229d539$var$pg = 0, $4d82739dd229d539$var$qg = null, $4d82739dd229d539$var$rg = 1, $4d82739dd229d539$var$sg = "";
function $4d82739dd229d539$var$tg(a, b) {
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$ng;
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$mg;
    $4d82739dd229d539$var$mg = a;
    $4d82739dd229d539$var$ng = b;
}
function $4d82739dd229d539$var$ug(a, b, c) {
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg;
    $4d82739dd229d539$var$qg = a;
    var d = $4d82739dd229d539$var$rg;
    a = $4d82739dd229d539$var$sg;
    var e = 32 - $4d82739dd229d539$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $4d82739dd229d539$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $4d82739dd229d539$var$rg = 1 << 32 - $4d82739dd229d539$var$oc(b) + e | c << e | d;
        $4d82739dd229d539$var$sg = f + a;
    } else $4d82739dd229d539$var$rg = 1 << f | c << e | d, $4d82739dd229d539$var$sg = a;
}
function $4d82739dd229d539$var$vg(a) {
    null !== a.return && ($4d82739dd229d539$var$tg(a, 1), $4d82739dd229d539$var$ug(a, 1, 0));
}
function $4d82739dd229d539$var$wg(a) {
    for(; a === $4d82739dd229d539$var$mg;)$4d82739dd229d539$var$mg = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null, $4d82739dd229d539$var$ng = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null;
    for(; a === $4d82739dd229d539$var$qg;)$4d82739dd229d539$var$qg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$sg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$rg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null;
}
var $4d82739dd229d539$var$xg = null, $4d82739dd229d539$var$yg = null, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$zg = null;
function $4d82739dd229d539$var$Ag(a, b) {
    var c = $4d82739dd229d539$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $4d82739dd229d539$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $4d82739dd229d539$var$qg ? {
                id: $4d82739dd229d539$var$rg,
                overflow: $4d82739dd229d539$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $4d82739dd229d539$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $4d82739dd229d539$var$Eg(a) {
    if ($4d82739dd229d539$var$I) {
        var b = $4d82739dd229d539$var$yg;
        if (b) {
            var c = b;
            if (!$4d82739dd229d539$var$Cg(a, b)) {
                if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
                b = $4d82739dd229d539$var$Lf(c.nextSibling);
                var d = $4d82739dd229d539$var$xg;
                b && $4d82739dd229d539$var$Cg(a, b) ? $4d82739dd229d539$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$xg = a);
            }
        } else {
            if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $4d82739dd229d539$var$I = !1;
            $4d82739dd229d539$var$xg = a;
        }
    }
}
function $4d82739dd229d539$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $4d82739dd229d539$var$xg = a;
}
function $4d82739dd229d539$var$Gg(a) {
    if (a !== $4d82739dd229d539$var$xg) return !1;
    if (!$4d82739dd229d539$var$I) return $4d82739dd229d539$var$Fg(a), $4d82739dd229d539$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$4d82739dd229d539$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $4d82739dd229d539$var$yg)) {
        if ($4d82739dd229d539$var$Dg(a)) throw $4d82739dd229d539$var$Hg(), Error($4d82739dd229d539$var$p(418));
        for(; b;)$4d82739dd229d539$var$Ag(a, b), b = $4d82739dd229d539$var$Lf(b.nextSibling);
    }
    $4d82739dd229d539$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($4d82739dd229d539$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $4d82739dd229d539$var$yg = null;
        }
    } else $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg ? $4d82739dd229d539$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $4d82739dd229d539$var$Hg() {
    for(var a = $4d82739dd229d539$var$yg; a;)a = $4d82739dd229d539$var$Lf(a.nextSibling);
}
function $4d82739dd229d539$var$Ig() {
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg = null;
    $4d82739dd229d539$var$I = !1;
}
function $4d82739dd229d539$var$Jg(a) {
    null === $4d82739dd229d539$var$zg ? $4d82739dd229d539$var$zg = [
        a
    ] : $4d82739dd229d539$var$zg.push(a);
}
var $4d82739dd229d539$var$Kg = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig;
function $4d82739dd229d539$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $4d82739dd229d539$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $4d82739dd229d539$var$Mg = $4d82739dd229d539$var$Uf(null), $4d82739dd229d539$var$Ng = null, $4d82739dd229d539$var$Og = null, $4d82739dd229d539$var$Pg = null;
function $4d82739dd229d539$var$Qg() {
    $4d82739dd229d539$var$Pg = $4d82739dd229d539$var$Og = $4d82739dd229d539$var$Ng = null;
}
function $4d82739dd229d539$var$Rg(a) {
    var b = $4d82739dd229d539$var$Mg.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Mg);
    a._currentValue = b;
}
function $4d82739dd229d539$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $4d82739dd229d539$var$Tg(a, b) {
    $4d82739dd229d539$var$Ng = a;
    $4d82739dd229d539$var$Pg = $4d82739dd229d539$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($4d82739dd229d539$var$Ug = !0), a.firstContext = null);
}
function $4d82739dd229d539$var$Vg(a) {
    var b = a._currentValue;
    if ($4d82739dd229d539$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $4d82739dd229d539$var$Og) {
            if (null === $4d82739dd229d539$var$Ng) throw Error($4d82739dd229d539$var$p(308));
            $4d82739dd229d539$var$Og = a;
            $4d82739dd229d539$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $4d82739dd229d539$var$Og = $4d82739dd229d539$var$Og.next = a;
    }
    return b;
}
var $4d82739dd229d539$var$Wg = null;
function $4d82739dd229d539$var$Xg(a) {
    null === $4d82739dd229d539$var$Wg ? $4d82739dd229d539$var$Wg = [
        a
    ] : $4d82739dd229d539$var$Wg.push(a);
}
function $4d82739dd229d539$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $4d82739dd229d539$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $4d82739dd229d539$var$Zg(a, d);
}
function $4d82739dd229d539$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $4d82739dd229d539$var$$g = !1;
function $4d82739dd229d539$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $4d82739dd229d539$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $4d82739dd229d539$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $4d82739dd229d539$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($4d82739dd229d539$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $4d82739dd229d539$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $4d82739dd229d539$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $4d82739dd229d539$var$Zg(a, c);
}
function $4d82739dd229d539$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
function $4d82739dd229d539$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $4d82739dd229d539$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $4d82739dd229d539$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $4d82739dd229d539$var$A({}, q, r);
                            break a;
                        case 2:
                            $4d82739dd229d539$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $4d82739dd229d539$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $4d82739dd229d539$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($4d82739dd229d539$var$p(191, e));
            e.call(d);
        }
    }
}
var $4d82739dd229d539$var$jh = (new $7fPBF.Component).refs;
function $4d82739dd229d539$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $4d82739dd229d539$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $4d82739dd229d539$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $4d82739dd229d539$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$L(), e = $4d82739dd229d539$var$lh(a), f = $4d82739dd229d539$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$dh(a, f, e);
        null !== b && ($4d82739dd229d539$var$mh(b, a, e, d), $4d82739dd229d539$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$L(), e = $4d82739dd229d539$var$lh(a), f = $4d82739dd229d539$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$dh(a, f, e);
        null !== b && ($4d82739dd229d539$var$mh(b, a, e, d), $4d82739dd229d539$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $4d82739dd229d539$var$L(), d = $4d82739dd229d539$var$lh(a), e = $4d82739dd229d539$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $4d82739dd229d539$var$dh(a, e, d);
        null !== b && ($4d82739dd229d539$var$mh(b, a, d, c), $4d82739dd229d539$var$eh(b, a, d));
    }
};
function $4d82739dd229d539$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$4d82739dd229d539$var$Ie(c, d) || !$4d82739dd229d539$var$Ie(e, f) : !0;
}
function $4d82739dd229d539$var$ph(a, b, c) {
    var d = !1, e = $4d82739dd229d539$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $4d82739dd229d539$var$Vg(f) : (e = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $4d82739dd229d539$var$Yf(a, e) : $4d82739dd229d539$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $4d82739dd229d539$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $4d82739dd229d539$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $4d82739dd229d539$var$nh.enqueueReplaceState(b, b.state, null);
}
function $4d82739dd229d539$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $4d82739dd229d539$var$jh;
    $4d82739dd229d539$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $4d82739dd229d539$var$Vg(f) : (f = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, e.context = $4d82739dd229d539$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($4d82739dd229d539$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $4d82739dd229d539$var$nh.enqueueReplaceState(e, e.state, null), $4d82739dd229d539$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $4d82739dd229d539$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($4d82739dd229d539$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($4d82739dd229d539$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $4d82739dd229d539$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($4d82739dd229d539$var$p(284));
        if (!c._owner) throw Error($4d82739dd229d539$var$p(290, a));
    }
    return a;
}
function $4d82739dd229d539$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($4d82739dd229d539$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $4d82739dd229d539$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $4d82739dd229d539$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $4d82739dd229d539$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $4d82739dd229d539$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $4d82739dd229d539$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $4d82739dd229d539$var$sh(a, b, c), d.return = a, d;
        d = $4d82739dd229d539$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $4d82739dd229d539$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $4d82739dd229d539$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $4d82739dd229d539$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $4d82739dd229d539$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c = $4d82739dd229d539$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $4d82739dd229d539$var$sh(a, null, b), c.return = a, c;
                case $4d82739dd229d539$var$wa:
                    return b = $4d82739dd229d539$var$zh(b, a.mode, c), b.return = a, b;
                case $4d82739dd229d539$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($4d82739dd229d539$var$eb(b) || $4d82739dd229d539$var$Ka(b)) return b = $4d82739dd229d539$var$Ah(b, a.mode, c, null), b.return = a, b;
            $4d82739dd229d539$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $4d82739dd229d539$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $4d82739dd229d539$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($4d82739dd229d539$var$eb(c) || $4d82739dd229d539$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $4d82739dd229d539$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $4d82739dd229d539$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $4d82739dd229d539$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $4d82739dd229d539$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($4d82739dd229d539$var$eb(d) || $4d82739dd229d539$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $4d82739dd229d539$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $4d82739dd229d539$var$Ka(h);
        if ("function" !== typeof l) throw Error($4d82739dd229d539$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($4d82739dd229d539$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $4d82739dd229d539$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $4d82739dd229d539$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $4d82739dd229d539$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $4d82739dd229d539$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $4d82739dd229d539$var$ya ? (d = $4d82739dd229d539$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $4d82739dd229d539$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $4d82739dd229d539$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $4d82739dd229d539$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $4d82739dd229d539$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $4d82739dd229d539$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($4d82739dd229d539$var$eb(f)) return n(a, d, f, h);
            if ($4d82739dd229d539$var$Ka(f)) return t(a, d, f, h);
            $4d82739dd229d539$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $4d82739dd229d539$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $4d82739dd229d539$var$Bh = $4d82739dd229d539$var$vh(!0), $4d82739dd229d539$var$Ch = $4d82739dd229d539$var$vh(!1), $4d82739dd229d539$var$Dh = {}, $4d82739dd229d539$var$Eh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Dh), $4d82739dd229d539$var$Fh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Dh), $4d82739dd229d539$var$Gh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Dh);
function $4d82739dd229d539$var$Hh(a) {
    if (a === $4d82739dd229d539$var$Dh) throw Error($4d82739dd229d539$var$p(174));
    return a;
}
function $4d82739dd229d539$var$Ih(a, b) {
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Gh, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Fh, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Eh, $4d82739dd229d539$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $4d82739dd229d539$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $4d82739dd229d539$var$lb(b, a);
    }
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Eh);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Eh, b);
}
function $4d82739dd229d539$var$Jh() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Eh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Fh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Gh);
}
function $4d82739dd229d539$var$Kh(a) {
    $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Gh.current);
    var b = $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Eh.current);
    var c = $4d82739dd229d539$var$lb(b, a.type);
    b !== c && ($4d82739dd229d539$var$G($4d82739dd229d539$var$Fh, a), $4d82739dd229d539$var$G($4d82739dd229d539$var$Eh, c));
}
function $4d82739dd229d539$var$Lh(a) {
    $4d82739dd229d539$var$Fh.current === a && ($4d82739dd229d539$var$E($4d82739dd229d539$var$Eh), $4d82739dd229d539$var$E($4d82739dd229d539$var$Fh));
}
var $4d82739dd229d539$var$M = $4d82739dd229d539$var$Uf(0);
function $4d82739dd229d539$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$Nh = [];
function $4d82739dd229d539$var$Oh() {
    for(var a = 0; a < $4d82739dd229d539$var$Nh.length; a++)$4d82739dd229d539$var$Nh[a]._workInProgressVersionPrimary = null;
    $4d82739dd229d539$var$Nh.length = 0;
}
var $4d82739dd229d539$var$Ph = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$Qh = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$Rh = 0, $4d82739dd229d539$var$N = null, $4d82739dd229d539$var$O = null, $4d82739dd229d539$var$P = null, $4d82739dd229d539$var$Sh = !1, $4d82739dd229d539$var$Th = !1, $4d82739dd229d539$var$Uh = 0, $4d82739dd229d539$var$Vh = 0;
function $4d82739dd229d539$var$Q() {
    throw Error($4d82739dd229d539$var$p(321));
}
function $4d82739dd229d539$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$4d82739dd229d539$var$He(a[c], b[c])) return !1;
    return !0;
}
function $4d82739dd229d539$var$Xh(a, b, c, d, e, f) {
    $4d82739dd229d539$var$Rh = f;
    $4d82739dd229d539$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $4d82739dd229d539$var$Ph.current = null === a || null === a.memoizedState ? $4d82739dd229d539$var$Yh : $4d82739dd229d539$var$Zh;
    a = c(d, e);
    if ($4d82739dd229d539$var$Th) {
        f = 0;
        do {
            $4d82739dd229d539$var$Th = !1;
            $4d82739dd229d539$var$Uh = 0;
            if (25 <= f) throw Error($4d82739dd229d539$var$p(301));
            f += 1;
            $4d82739dd229d539$var$P = $4d82739dd229d539$var$O = null;
            b.updateQueue = null;
            $4d82739dd229d539$var$Ph.current = $4d82739dd229d539$var$$h;
            a = c(d, e);
        }while ($4d82739dd229d539$var$Th);
    }
    $4d82739dd229d539$var$Ph.current = $4d82739dd229d539$var$ai;
    b = null !== $4d82739dd229d539$var$O && null !== $4d82739dd229d539$var$O.next;
    $4d82739dd229d539$var$Rh = 0;
    $4d82739dd229d539$var$P = $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = null;
    $4d82739dd229d539$var$Sh = !1;
    if (b) throw Error($4d82739dd229d539$var$p(300));
    return a;
}
function $4d82739dd229d539$var$bi() {
    var a = 0 !== $4d82739dd229d539$var$Uh;
    $4d82739dd229d539$var$Uh = 0;
    return a;
}
function $4d82739dd229d539$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $4d82739dd229d539$var$P ? $4d82739dd229d539$var$N.memoizedState = $4d82739dd229d539$var$P = a : $4d82739dd229d539$var$P = $4d82739dd229d539$var$P.next = a;
    return $4d82739dd229d539$var$P;
}
function $4d82739dd229d539$var$di() {
    if (null === $4d82739dd229d539$var$O) {
        var a = $4d82739dd229d539$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $4d82739dd229d539$var$O.next;
    var b = null === $4d82739dd229d539$var$P ? $4d82739dd229d539$var$N.memoizedState : $4d82739dd229d539$var$P.next;
    if (null !== b) $4d82739dd229d539$var$P = b, $4d82739dd229d539$var$O = a;
    else {
        if (null === a) throw Error($4d82739dd229d539$var$p(310));
        $4d82739dd229d539$var$O = a;
        a = {
            memoizedState: $4d82739dd229d539$var$O.memoizedState,
            baseState: $4d82739dd229d539$var$O.baseState,
            baseQueue: $4d82739dd229d539$var$O.baseQueue,
            queue: $4d82739dd229d539$var$O.queue,
            next: null
        };
        null === $4d82739dd229d539$var$P ? $4d82739dd229d539$var$N.memoizedState = $4d82739dd229d539$var$P = a : $4d82739dd229d539$var$P = $4d82739dd229d539$var$P.next = a;
    }
    return $4d82739dd229d539$var$P;
}
function $4d82739dd229d539$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $4d82739dd229d539$var$fi(a) {
    var b = $4d82739dd229d539$var$di(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = $4d82739dd229d539$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($4d82739dd229d539$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $4d82739dd229d539$var$N.lanes |= m;
                $4d82739dd229d539$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $4d82739dd229d539$var$He(d, b.memoizedState) || ($4d82739dd229d539$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $4d82739dd229d539$var$N.lanes |= f, $4d82739dd229d539$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $4d82739dd229d539$var$gi(a) {
    var b = $4d82739dd229d539$var$di(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $4d82739dd229d539$var$He(f, b.memoizedState) || ($4d82739dd229d539$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $4d82739dd229d539$var$hi() {}
function $4d82739dd229d539$var$ii(a, b) {
    var c = $4d82739dd229d539$var$N, d = $4d82739dd229d539$var$di(), e = b(), f = !$4d82739dd229d539$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $4d82739dd229d539$var$Ug = !0);
    d = d.queue;
    $4d82739dd229d539$var$ji($4d82739dd229d539$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $4d82739dd229d539$var$P && $4d82739dd229d539$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $4d82739dd229d539$var$li(9, $4d82739dd229d539$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $4d82739dd229d539$var$R) throw Error($4d82739dd229d539$var$p(349));
        0 !== ($4d82739dd229d539$var$Rh & 30) || $4d82739dd229d539$var$ni(c, b, e);
    }
    return e;
}
function $4d82739dd229d539$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $4d82739dd229d539$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $4d82739dd229d539$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $4d82739dd229d539$var$oi(b) && $4d82739dd229d539$var$pi(a);
}
function $4d82739dd229d539$var$ki(a, b, c) {
    return c(function() {
        $4d82739dd229d539$var$oi(b) && $4d82739dd229d539$var$pi(a);
    });
}
function $4d82739dd229d539$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$4d82739dd229d539$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $4d82739dd229d539$var$pi(a) {
    var b = $4d82739dd229d539$var$Zg(a, 1);
    null !== b && $4d82739dd229d539$var$mh(b, a, 1, -1);
}
function $4d82739dd229d539$var$qi(a) {
    var b = $4d82739dd229d539$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $4d82739dd229d539$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $4d82739dd229d539$var$ri.bind(null, $4d82739dd229d539$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $4d82739dd229d539$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $4d82739dd229d539$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $4d82739dd229d539$var$si() {
    return $4d82739dd229d539$var$di().memoizedState;
}
function $4d82739dd229d539$var$ti(a, b, c, d) {
    var e = $4d82739dd229d539$var$ci();
    $4d82739dd229d539$var$N.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $4d82739dd229d539$var$ui(a, b, c, d) {
    var e = $4d82739dd229d539$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $4d82739dd229d539$var$O) {
        var g = $4d82739dd229d539$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $4d82739dd229d539$var$Wh(d, g.deps)) {
            e.memoizedState = $4d82739dd229d539$var$li(b, c, f, d);
            return;
        }
    }
    $4d82739dd229d539$var$N.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$li(1 | b, c, f, d);
}
function $4d82739dd229d539$var$vi(a, b) {
    return $4d82739dd229d539$var$ti(8390656, 8, a, b);
}
function $4d82739dd229d539$var$ji(a, b) {
    return $4d82739dd229d539$var$ui(2048, 8, a, b);
}
function $4d82739dd229d539$var$wi(a, b) {
    return $4d82739dd229d539$var$ui(4, 2, a, b);
}
function $4d82739dd229d539$var$xi(a, b) {
    return $4d82739dd229d539$var$ui(4, 4, a, b);
}
function $4d82739dd229d539$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $4d82739dd229d539$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $4d82739dd229d539$var$ui(4, 4, $4d82739dd229d539$var$yi.bind(null, b, a), c);
}
function $4d82739dd229d539$var$Ai() {}
function $4d82739dd229d539$var$Bi(a, b) {
    var c = $4d82739dd229d539$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$Ci(a, b) {
    var c = $4d82739dd229d539$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$Di(a, b, c) {
    if (0 === ($4d82739dd229d539$var$Rh & 21)) return a.baseState && (a.baseState = !1, $4d82739dd229d539$var$Ug = !0), a.memoizedState = c;
    $4d82739dd229d539$var$He(c, b) || (c = $4d82739dd229d539$var$yc(), $4d82739dd229d539$var$N.lanes |= c, $4d82739dd229d539$var$hh |= c, a.baseState = !0);
    return b;
}
function $4d82739dd229d539$var$Ei(a, b) {
    var c = $4d82739dd229d539$var$C;
    $4d82739dd229d539$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $4d82739dd229d539$var$Qh.transition;
    $4d82739dd229d539$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$Qh.transition = d;
    }
}
function $4d82739dd229d539$var$Fi() {
    return $4d82739dd229d539$var$di().memoizedState;
}
function $4d82739dd229d539$var$Gi(a, b, c) {
    var d = $4d82739dd229d539$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$Hi(a)) $4d82739dd229d539$var$Ii(b, c);
    else if (c = $4d82739dd229d539$var$Yg(a, b, c, d), null !== c) {
        var e = $4d82739dd229d539$var$L();
        $4d82739dd229d539$var$mh(c, a, d, e);
        $4d82739dd229d539$var$Ji(c, b, d);
    }
}
function $4d82739dd229d539$var$ri(a, b, c) {
    var d = $4d82739dd229d539$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$Hi(a)) $4d82739dd229d539$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($4d82739dd229d539$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $4d82739dd229d539$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $4d82739dd229d539$var$Yg(a, b, e, d);
        null !== c && (e = $4d82739dd229d539$var$L(), $4d82739dd229d539$var$mh(c, a, d, e), $4d82739dd229d539$var$Ji(c, b, d));
    }
}
function $4d82739dd229d539$var$Hi(a) {
    var b = a.alternate;
    return a === $4d82739dd229d539$var$N || null !== b && b === $4d82739dd229d539$var$N;
}
function $4d82739dd229d539$var$Ii(a, b) {
    $4d82739dd229d539$var$Th = $4d82739dd229d539$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $4d82739dd229d539$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
var $4d82739dd229d539$var$ai = {
    readContext: $4d82739dd229d539$var$Vg,
    useCallback: $4d82739dd229d539$var$Q,
    useContext: $4d82739dd229d539$var$Q,
    useEffect: $4d82739dd229d539$var$Q,
    useImperativeHandle: $4d82739dd229d539$var$Q,
    useInsertionEffect: $4d82739dd229d539$var$Q,
    useLayoutEffect: $4d82739dd229d539$var$Q,
    useMemo: $4d82739dd229d539$var$Q,
    useReducer: $4d82739dd229d539$var$Q,
    useRef: $4d82739dd229d539$var$Q,
    useState: $4d82739dd229d539$var$Q,
    useDebugValue: $4d82739dd229d539$var$Q,
    useDeferredValue: $4d82739dd229d539$var$Q,
    useTransition: $4d82739dd229d539$var$Q,
    useMutableSource: $4d82739dd229d539$var$Q,
    useSyncExternalStore: $4d82739dd229d539$var$Q,
    useId: $4d82739dd229d539$var$Q,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Yh = {
    readContext: $4d82739dd229d539$var$Vg,
    useCallback: function(a, b) {
        $4d82739dd229d539$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $4d82739dd229d539$var$Vg,
    useEffect: $4d82739dd229d539$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $4d82739dd229d539$var$ti(4194308, 4, $4d82739dd229d539$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $4d82739dd229d539$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $4d82739dd229d539$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $4d82739dd229d539$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $4d82739dd229d539$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $4d82739dd229d539$var$Gi.bind(null, $4d82739dd229d539$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $4d82739dd229d539$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $4d82739dd229d539$var$qi,
    useDebugValue: $4d82739dd229d539$var$Ai,
    useDeferredValue: function(a) {
        return $4d82739dd229d539$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$qi(!1), b = a[0];
        a = $4d82739dd229d539$var$Ei.bind(null, a[1]);
        $4d82739dd229d539$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $4d82739dd229d539$var$N, e = $4d82739dd229d539$var$ci();
        if ($4d82739dd229d539$var$I) {
            if (void 0 === c) throw Error($4d82739dd229d539$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $4d82739dd229d539$var$R) throw Error($4d82739dd229d539$var$p(349));
            0 !== ($4d82739dd229d539$var$Rh & 30) || $4d82739dd229d539$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $4d82739dd229d539$var$vi($4d82739dd229d539$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $4d82739dd229d539$var$li(9, $4d82739dd229d539$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $4d82739dd229d539$var$ci(), b = $4d82739dd229d539$var$R.identifierPrefix;
        if ($4d82739dd229d539$var$I) {
            var c = $4d82739dd229d539$var$sg;
            var d = $4d82739dd229d539$var$rg;
            c = (d & ~(1 << 32 - $4d82739dd229d539$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $4d82739dd229d539$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $4d82739dd229d539$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Zh = {
    readContext: $4d82739dd229d539$var$Vg,
    useCallback: $4d82739dd229d539$var$Bi,
    useContext: $4d82739dd229d539$var$Vg,
    useEffect: $4d82739dd229d539$var$ji,
    useImperativeHandle: $4d82739dd229d539$var$zi,
    useInsertionEffect: $4d82739dd229d539$var$wi,
    useLayoutEffect: $4d82739dd229d539$var$xi,
    useMemo: $4d82739dd229d539$var$Ci,
    useReducer: $4d82739dd229d539$var$fi,
    useRef: $4d82739dd229d539$var$si,
    useState: function() {
        return $4d82739dd229d539$var$fi($4d82739dd229d539$var$ei);
    },
    useDebugValue: $4d82739dd229d539$var$Ai,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$di();
        return $4d82739dd229d539$var$Di(b, $4d82739dd229d539$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$fi($4d82739dd229d539$var$ei)[0], b = $4d82739dd229d539$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$hi,
    useSyncExternalStore: $4d82739dd229d539$var$ii,
    useId: $4d82739dd229d539$var$Fi,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$$h = {
    readContext: $4d82739dd229d539$var$Vg,
    useCallback: $4d82739dd229d539$var$Bi,
    useContext: $4d82739dd229d539$var$Vg,
    useEffect: $4d82739dd229d539$var$ji,
    useImperativeHandle: $4d82739dd229d539$var$zi,
    useInsertionEffect: $4d82739dd229d539$var$wi,
    useLayoutEffect: $4d82739dd229d539$var$xi,
    useMemo: $4d82739dd229d539$var$Ci,
    useReducer: $4d82739dd229d539$var$gi,
    useRef: $4d82739dd229d539$var$si,
    useState: function() {
        return $4d82739dd229d539$var$gi($4d82739dd229d539$var$ei);
    },
    useDebugValue: $4d82739dd229d539$var$Ai,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$di();
        return null === $4d82739dd229d539$var$O ? b.memoizedState = a : $4d82739dd229d539$var$Di(b, $4d82739dd229d539$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$gi($4d82739dd229d539$var$ei)[0], b = $4d82739dd229d539$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$hi,
    useSyncExternalStore: $4d82739dd229d539$var$ii,
    useId: $4d82739dd229d539$var$Fi,
    unstable_isNewReconciler: !1
};
function $4d82739dd229d539$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $4d82739dd229d539$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $4d82739dd229d539$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $4d82739dd229d539$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $4d82739dd229d539$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $4d82739dd229d539$var$Oi(a, b, c) {
    c = $4d82739dd229d539$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $4d82739dd229d539$var$Pi || ($4d82739dd229d539$var$Pi = !0, $4d82739dd229d539$var$Qi = d);
        $4d82739dd229d539$var$Mi(a, b);
    };
    return c;
}
function $4d82739dd229d539$var$Ri(a, b, c) {
    c = $4d82739dd229d539$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $4d82739dd229d539$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $4d82739dd229d539$var$Mi(a, b);
        "function" !== typeof d && (null === $4d82739dd229d539$var$Si ? $4d82739dd229d539$var$Si = new Set([
            this
        ]) : $4d82739dd229d539$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $4d82739dd229d539$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $4d82739dd229d539$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $4d82739dd229d539$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $4d82739dd229d539$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $4d82739dd229d539$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $4d82739dd229d539$var$ch(-1, 1), b.tag = 2, $4d82739dd229d539$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $4d82739dd229d539$var$Xi = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$Ug = !1;
function $4d82739dd229d539$var$Yi(a, b, c, d) {
    b.child = null === a ? $4d82739dd229d539$var$Ch(b, null, c, d) : $4d82739dd229d539$var$Bh(b, a.child, c, d);
}
function $4d82739dd229d539$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $4d82739dd229d539$var$Tg(b, e);
    d = $4d82739dd229d539$var$Xh(a, b, c, d, f, e);
    c = $4d82739dd229d539$var$bi();
    if (null !== a && !$4d82739dd229d539$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$$i(a, b, e);
    $4d82739dd229d539$var$I && c && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Yi(a, b, d, e);
    return b.child;
}
function $4d82739dd229d539$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$4d82739dd229d539$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $4d82739dd229d539$var$cj(a, b, f, d, e);
        a = $4d82739dd229d539$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $4d82739dd229d539$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $4d82739dd229d539$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $4d82739dd229d539$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $4d82739dd229d539$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($4d82739dd229d539$var$Ie(f, d) && a.ref === b.ref) {
            if ($4d82739dd229d539$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($4d82739dd229d539$var$Ug = !0);
            else return b.lanes = a.lanes, $4d82739dd229d539$var$$i(a, b, e);
        }
    }
    return $4d82739dd229d539$var$dj(a, b, c, d, e);
}
function $4d82739dd229d539$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $4d82739dd229d539$var$G($4d82739dd229d539$var$fj, $4d82739dd229d539$var$gj), $4d82739dd229d539$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $4d82739dd229d539$var$G($4d82739dd229d539$var$fj, $4d82739dd229d539$var$gj), $4d82739dd229d539$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$fj, $4d82739dd229d539$var$gj);
            $4d82739dd229d539$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $4d82739dd229d539$var$G($4d82739dd229d539$var$fj, $4d82739dd229d539$var$gj), $4d82739dd229d539$var$gj |= d;
    $4d82739dd229d539$var$Yi(a, b, e, c);
    return b.child;
}
function $4d82739dd229d539$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $4d82739dd229d539$var$dj(a, b, c, d, e) {
    var f = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current;
    f = $4d82739dd229d539$var$Yf(b, f);
    $4d82739dd229d539$var$Tg(b, e);
    c = $4d82739dd229d539$var$Xh(a, b, c, d, f, e);
    d = $4d82739dd229d539$var$bi();
    if (null !== a && !$4d82739dd229d539$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$$i(a, b, e);
    $4d82739dd229d539$var$I && d && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Yi(a, b, c, e);
    return b.child;
}
function $4d82739dd229d539$var$ij(a, b, c, d, e) {
    if ($4d82739dd229d539$var$Zf(c)) {
        var f = !0;
        $4d82739dd229d539$var$cg(b);
    } else f = !1;
    $4d82739dd229d539$var$Tg(b, e);
    if (null === b.stateNode) $4d82739dd229d539$var$jj(a, b), $4d82739dd229d539$var$ph(b, c, d), $4d82739dd229d539$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $4d82739dd229d539$var$Vg(l) : (l = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, l = $4d82739dd229d539$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $4d82739dd229d539$var$qh(b, g, d, l);
        $4d82739dd229d539$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$$g ? ("function" === typeof m && ($4d82739dd229d539$var$kh(b, c, m, d), k = b.memoizedState), (h = $4d82739dd229d539$var$$g || $4d82739dd229d539$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $4d82739dd229d539$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $4d82739dd229d539$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $4d82739dd229d539$var$Vg(k) : (k = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, k = $4d82739dd229d539$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $4d82739dd229d539$var$qh(b, g, d, k);
        $4d82739dd229d539$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$$g ? ("function" === typeof y && ($4d82739dd229d539$var$kh(b, c, y, d), n = b.memoizedState), (l = $4d82739dd229d539$var$$g || $4d82739dd229d539$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $4d82739dd229d539$var$kj(a, b, c, d, f, e);
}
function $4d82739dd229d539$var$kj(a, b, c, d, e, f) {
    $4d82739dd229d539$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $4d82739dd229d539$var$dg(b, c, !1), $4d82739dd229d539$var$$i(a, b, f);
    d = b.stateNode;
    $4d82739dd229d539$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $4d82739dd229d539$var$Bh(b, a.child, null, f), b.child = $4d82739dd229d539$var$Bh(b, null, h, f)) : $4d82739dd229d539$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $4d82739dd229d539$var$dg(b, c, !0);
    return b.child;
}
function $4d82739dd229d539$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $4d82739dd229d539$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $4d82739dd229d539$var$ag(a, b.context, !1);
    $4d82739dd229d539$var$Ih(a, b.containerInfo);
}
function $4d82739dd229d539$var$mj(a, b, c, d, e) {
    $4d82739dd229d539$var$Ig();
    $4d82739dd229d539$var$Jg(e);
    b.flags |= 256;
    $4d82739dd229d539$var$Yi(a, b, c, d);
    return b.child;
}
var $4d82739dd229d539$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $4d82739dd229d539$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $4d82739dd229d539$var$pj(a, b, c) {
    var d = b.pendingProps, e = $4d82739dd229d539$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$M, e & 1);
    if (null === a) {
        $4d82739dd229d539$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $4d82739dd229d539$var$qj(g, d, 0, null), a = $4d82739dd229d539$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $4d82739dd229d539$var$oj(c), b.memoizedState = $4d82739dd229d539$var$nj, a) : $4d82739dd229d539$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $4d82739dd229d539$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $4d82739dd229d539$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $4d82739dd229d539$var$wh(h, f) : (f = $4d82739dd229d539$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $4d82739dd229d539$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $4d82739dd229d539$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $4d82739dd229d539$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $4d82739dd229d539$var$rj(a, b) {
    b = $4d82739dd229d539$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $4d82739dd229d539$var$tj(a, b, c, d) {
    null !== d && $4d82739dd229d539$var$Jg(d);
    $4d82739dd229d539$var$Bh(b, a.child, null, c);
    a = $4d82739dd229d539$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $4d82739dd229d539$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $4d82739dd229d539$var$Li(Error($4d82739dd229d539$var$p(422))), $4d82739dd229d539$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $4d82739dd229d539$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $4d82739dd229d539$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $4d82739dd229d539$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $4d82739dd229d539$var$oj(g);
        b.memoizedState = $4d82739dd229d539$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $4d82739dd229d539$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($4d82739dd229d539$var$p(419));
        d = $4d82739dd229d539$var$Li(f, d, void 0);
        return $4d82739dd229d539$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($4d82739dd229d539$var$Ug || h) {
        d = $4d82739dd229d539$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $4d82739dd229d539$var$Zg(a, e), $4d82739dd229d539$var$mh(d, a, e, -1));
        }
        $4d82739dd229d539$var$uj();
        d = $4d82739dd229d539$var$Li(Error($4d82739dd229d539$var$p(421)));
        return $4d82739dd229d539$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $4d82739dd229d539$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(e.nextSibling);
    $4d82739dd229d539$var$xg = b;
    $4d82739dd229d539$var$I = !0;
    $4d82739dd229d539$var$zg = null;
    null !== a && ($4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg, $4d82739dd229d539$var$rg = a.id, $4d82739dd229d539$var$sg = a.overflow, $4d82739dd229d539$var$qg = b);
    b = $4d82739dd229d539$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $4d82739dd229d539$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $4d82739dd229d539$var$Sg(a.return, b, c);
}
function $4d82739dd229d539$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $4d82739dd229d539$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $4d82739dd229d539$var$Yi(a, b, d.children, c);
    d = $4d82739dd229d539$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $4d82739dd229d539$var$wj(a, c, b);
            else if (19 === a.tag) $4d82739dd229d539$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $4d82739dd229d539$var$G($4d82739dd229d539$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $4d82739dd229d539$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $4d82739dd229d539$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $4d82739dd229d539$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $4d82739dd229d539$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $4d82739dd229d539$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $4d82739dd229d539$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $4d82739dd229d539$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($4d82739dd229d539$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $4d82739dd229d539$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $4d82739dd229d539$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $4d82739dd229d539$var$lj(b);
            $4d82739dd229d539$var$Ig();
            break;
        case 5:
            $4d82739dd229d539$var$Kh(b);
            break;
        case 1:
            $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$cg(b);
            break;
        case 4:
            $4d82739dd229d539$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $4d82739dd229d539$var$pj(a, b, c);
                $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current & 1);
                a = $4d82739dd229d539$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $4d82739dd229d539$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $4d82739dd229d539$var$ej(a, b, c);
    }
    return $4d82739dd229d539$var$$i(a, b, c);
}
var $4d82739dd229d539$var$Aj, $4d82739dd229d539$var$Bj, $4d82739dd229d539$var$Cj, $4d82739dd229d539$var$Dj;
$4d82739dd229d539$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$4d82739dd229d539$var$Bj = function() {};
$4d82739dd229d539$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $4d82739dd229d539$var$Ya(a, e);
                d = $4d82739dd229d539$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $4d82739dd229d539$var$A({}, e, {
                    value: void 0
                });
                d = $4d82739dd229d539$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $4d82739dd229d539$var$gb(a, e);
                d = $4d82739dd229d539$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
        }
        $4d82739dd229d539$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $4d82739dd229d539$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$4d82739dd229d539$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $4d82739dd229d539$var$Ej(a, b) {
    if (!$4d82739dd229d539$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $4d82739dd229d539$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $4d82739dd229d539$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $4d82739dd229d539$var$S(b), null;
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 3:
            d = b.stateNode;
            $4d82739dd229d539$var$Jh();
            $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
            $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
            $4d82739dd229d539$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $4d82739dd229d539$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Gj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null));
            $4d82739dd229d539$var$Bj(a, b);
            $4d82739dd229d539$var$S(b);
            return null;
        case 5:
            $4d82739dd229d539$var$Lh(b);
            var e = $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $4d82739dd229d539$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                    $4d82739dd229d539$var$S(b);
                    return null;
                }
                a = $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Eh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    d[$4d82739dd229d539$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $4d82739dd229d539$var$D("cancel", d);
                            $4d82739dd229d539$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], d);
                            break;
                        case "source":
                            $4d82739dd229d539$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $4d82739dd229d539$var$D("error", d);
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "details":
                            $4d82739dd229d539$var$D("toggle", d);
                            break;
                        case "input":
                            $4d82739dd229d539$var$Za(d, f);
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$hb(d, f), $4d82739dd229d539$var$D("invalid", d);
                    }
                    $4d82739dd229d539$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $4d82739dd229d539$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $4d82739dd229d539$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $4d82739dd229d539$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $4d82739dd229d539$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$4d82739dd229d539$var$Of] = b;
                    a[$4d82739dd229d539$var$Pf] = d;
                    $4d82739dd229d539$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $4d82739dd229d539$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $4d82739dd229d539$var$D("cancel", a);
                                $4d82739dd229d539$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $4d82739dd229d539$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $4d82739dd229d539$var$D("error", a);
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $4d82739dd229d539$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $4d82739dd229d539$var$Za(a, d);
                                e = $4d82739dd229d539$var$Ya(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $4d82739dd229d539$var$A({}, d, {
                                    value: void 0
                                });
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$hb(a, d);
                                e = $4d82739dd229d539$var$gb(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $4d82739dd229d539$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $4d82739dd229d539$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $4d82739dd229d539$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $4d82739dd229d539$var$ob(a, k) : "number" === typeof k && $4d82739dd229d539$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($4d82739dd229d539$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $4d82739dd229d539$var$D("scroll", a) : null != k && $4d82739dd229d539$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $4d82739dd229d539$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $4d82739dd229d539$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $4d82739dd229d539$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $4d82739dd229d539$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                c = $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Gh.current);
                $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Eh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $4d82739dd229d539$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$4d82739dd229d539$var$Of] = b, b.stateNode = d;
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($4d82739dd229d539$var$I && null !== $4d82739dd229d539$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $4d82739dd229d539$var$Hg(), $4d82739dd229d539$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $4d82739dd229d539$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($4d82739dd229d539$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($4d82739dd229d539$var$p(317));
                        f[$4d82739dd229d539$var$Of] = b;
                    } else $4d82739dd229d539$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $4d82739dd229d539$var$S(b);
                    f = !1;
                } else null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Gj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($4d82739dd229d539$var$M.current & 1) ? 0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 3) : $4d82739dd229d539$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $4d82739dd229d539$var$S(b);
            return null;
        case 4:
            return $4d82739dd229d539$var$Jh(), $4d82739dd229d539$var$Bj(a, b), null === a && $4d82739dd229d539$var$sf(b.stateNode.containerInfo), $4d82739dd229d539$var$S(b), null;
        case 10:
            return $4d82739dd229d539$var$Rg(b.type._context), $4d82739dd229d539$var$S(b), null;
        case 17:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 19:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
            f = b.memoizedState;
            if (null === f) return $4d82739dd229d539$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $4d82739dd229d539$var$Ej(f, !1);
                else {
                    if (0 !== $4d82739dd229d539$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $4d82739dd229d539$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $4d82739dd229d539$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $4d82739dd229d539$var$B() > $4d82739dd229d539$var$Hj && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $4d82739dd229d539$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $4d82739dd229d539$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$4d82739dd229d539$var$I) return $4d82739dd229d539$var$S(b), null;
                    } else 2 * $4d82739dd229d539$var$B() - f.renderingStartTime > $4d82739dd229d539$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $4d82739dd229d539$var$B(), b.sibling = null, c = $4d82739dd229d539$var$M.current, $4d82739dd229d539$var$G($4d82739dd229d539$var$M, d ? c & 1 | 2 : c & 1), b;
            $4d82739dd229d539$var$S(b);
            return null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($4d82739dd229d539$var$gj & 1073741824) && ($4d82739dd229d539$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $4d82739dd229d539$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
}
function $4d82739dd229d539$var$Jj(a, b) {
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $4d82739dd229d539$var$Jh(), $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $4d82739dd229d539$var$Lh(b), null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($4d82739dd229d539$var$p(340));
                $4d82739dd229d539$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $4d82739dd229d539$var$E($4d82739dd229d539$var$M), null;
        case 4:
            return $4d82739dd229d539$var$Jh(), null;
        case 10:
            return $4d82739dd229d539$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$Kj = !1, $4d82739dd229d539$var$U = !1, $4d82739dd229d539$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $4d82739dd229d539$var$V = null;
function $4d82739dd229d539$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $4d82739dd229d539$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $4d82739dd229d539$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $4d82739dd229d539$var$W(a, b, d);
    }
}
var $4d82739dd229d539$var$Oj = !1;
function $4d82739dd229d539$var$Pj(a, b) {
    $4d82739dd229d539$var$Cf = $4d82739dd229d539$var$dd;
    a = $4d82739dd229d539$var$Me();
    if ($4d82739dd229d539$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $4d82739dd229d539$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $4d82739dd229d539$var$dd = !1;
    for($4d82739dd229d539$var$V = b; null !== $4d82739dd229d539$var$V;)if (b = $4d82739dd229d539$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $4d82739dd229d539$var$V = a;
    else for(; null !== $4d82739dd229d539$var$V;){
        b = $4d82739dd229d539$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $4d82739dd229d539$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(163));
            }
        } catch (F) {
            $4d82739dd229d539$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $4d82739dd229d539$var$V = a;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
    n = $4d82739dd229d539$var$Oj;
    $4d82739dd229d539$var$Oj = !1;
    return n;
}
function $4d82739dd229d539$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $4d82739dd229d539$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $4d82739dd229d539$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $4d82739dd229d539$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $4d82739dd229d539$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $4d82739dd229d539$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$4d82739dd229d539$var$Of], delete b[$4d82739dd229d539$var$Pf], delete b[$4d82739dd229d539$var$of], delete b[$4d82739dd229d539$var$Qf], delete b[$4d82739dd229d539$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $4d82739dd229d539$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $4d82739dd229d539$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $4d82739dd229d539$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $4d82739dd229d539$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $4d82739dd229d539$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Wj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Wj(a, b, c), a = a.sibling;
}
function $4d82739dd229d539$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Xj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Xj(a, b, c), a = a.sibling;
}
var $4d82739dd229d539$var$X = null, $4d82739dd229d539$var$Yj = !1;
function $4d82739dd229d539$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$4d82739dd229d539$var$ak(a, b, c), c = c.sibling;
}
function $4d82739dd229d539$var$ak(a, b, c) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberUnmount) try {
        $4d82739dd229d539$var$lc.onCommitFiberUnmount($4d82739dd229d539$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $4d82739dd229d539$var$U || $4d82739dd229d539$var$Mj(c, b);
        case 6:
            var d = $4d82739dd229d539$var$X, e = $4d82739dd229d539$var$Yj;
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Zj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Yj = e;
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Yj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $4d82739dd229d539$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Yj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? $4d82739dd229d539$var$Kf(a.parentNode, c) : 1 === a.nodeType && $4d82739dd229d539$var$Kf(a, c), $4d82739dd229d539$var$bd(a)) : $4d82739dd229d539$var$Kf($4d82739dd229d539$var$X, c.stateNode));
            break;
        case 4:
            d = $4d82739dd229d539$var$X;
            e = $4d82739dd229d539$var$Yj;
            $4d82739dd229d539$var$X = c.stateNode.containerInfo;
            $4d82739dd229d539$var$Yj = !0;
            $4d82739dd229d539$var$Zj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$4d82739dd229d539$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $4d82739dd229d539$var$Nj(c, b, g) : 0 !== (f & 4) && $4d82739dd229d539$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $4d82739dd229d539$var$Zj(a, b, c);
            break;
        case 1:
            if (!$4d82739dd229d539$var$U && ($4d82739dd229d539$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $4d82739dd229d539$var$W(c, b, h);
            }
            $4d82739dd229d539$var$Zj(a, b, c);
            break;
        case 21:
            $4d82739dd229d539$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($4d82739dd229d539$var$U = (d = $4d82739dd229d539$var$U) || null !== c.memoizedState, $4d82739dd229d539$var$Zj(a, b, c), $4d82739dd229d539$var$U = d) : $4d82739dd229d539$var$Zj(a, b, c);
            break;
        default:
            $4d82739dd229d539$var$Zj(a, b, c);
    }
}
function $4d82739dd229d539$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $4d82739dd229d539$var$Lj);
        b.forEach(function(b) {
            var d = $4d82739dd229d539$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $4d82739dd229d539$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $4d82739dd229d539$var$X = h.stateNode;
                        $4d82739dd229d539$var$Yj = !1;
                        break a;
                    case 3:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Yj = !0;
                        break a;
                    case 4:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $4d82739dd229d539$var$X) throw Error($4d82739dd229d539$var$p(160));
            $4d82739dd229d539$var$ak(f, g, e);
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $4d82739dd229d539$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$4d82739dd229d539$var$ek(b, a), b = b.sibling;
}
function $4d82739dd229d539$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            if (d & 4) {
                try {
                    $4d82739dd229d539$var$Qj(3, a, a.return), $4d82739dd229d539$var$Rj(3, a);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
                try {
                    $4d82739dd229d539$var$Qj(5, a, a.return);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Mj(c, c.return);
            break;
        case 5:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $4d82739dd229d539$var$ob(e, "");
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $4d82739dd229d539$var$ab(e, f);
                    $4d82739dd229d539$var$vb(h, g);
                    var l = $4d82739dd229d539$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $4d82739dd229d539$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $4d82739dd229d539$var$nb(e, q) : "children" === m ? $4d82739dd229d539$var$ob(e, q) : $4d82739dd229d539$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $4d82739dd229d539$var$bb(e, f);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $4d82739dd229d539$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $4d82739dd229d539$var$fb(e, !!f.multiple, f.defaultValue, !0) : $4d82739dd229d539$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$4d82739dd229d539$var$Pf] = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($4d82739dd229d539$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $4d82739dd229d539$var$bd(b.containerInfo);
            } catch (t) {
                $4d82739dd229d539$var$W(a, a.return, t);
            }
            break;
        case 4:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            break;
        case 13:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($4d82739dd229d539$var$gk = $4d82739dd229d539$var$B()));
            d & 4 && $4d82739dd229d539$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($4d82739dd229d539$var$U = (l = $4d82739dd229d539$var$U) || m, $4d82739dd229d539$var$dk(b, a), $4d82739dd229d539$var$U = l) : $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($4d82739dd229d539$var$V = a, m = a.child; null !== m;){
                    for(q = $4d82739dd229d539$var$V = m; null !== $4d82739dd229d539$var$V;){
                        r = $4d82739dd229d539$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $4d82739dd229d539$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $4d82739dd229d539$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $4d82739dd229d539$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $4d82739dd229d539$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $4d82739dd229d539$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $4d82739dd229d539$var$V = y) : $4d82739dd229d539$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $4d82739dd229d539$var$rb("display", g));
                            } catch (t) {
                                $4d82739dd229d539$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $4d82739dd229d539$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            d & 4 && $4d82739dd229d539$var$bk(a);
            break;
        case 21:
            break;
        default:
            $4d82739dd229d539$var$dk(b, a), $4d82739dd229d539$var$fk(a);
    }
}
function $4d82739dd229d539$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($4d82739dd229d539$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($4d82739dd229d539$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($4d82739dd229d539$var$ob(e, ""), d.flags &= -33);
                    var f = $4d82739dd229d539$var$Vj(a);
                    $4d82739dd229d539$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $4d82739dd229d539$var$Vj(a);
                    $4d82739dd229d539$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(161));
            }
        } catch (k) {
            $4d82739dd229d539$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $4d82739dd229d539$var$ik(a, b, c) {
    $4d82739dd229d539$var$V = a;
    $4d82739dd229d539$var$jk(a, b, c);
}
function $4d82739dd229d539$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $4d82739dd229d539$var$V;){
        var e = $4d82739dd229d539$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $4d82739dd229d539$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $4d82739dd229d539$var$U;
                h = $4d82739dd229d539$var$Kj;
                var l = $4d82739dd229d539$var$U;
                $4d82739dd229d539$var$Kj = g;
                if (($4d82739dd229d539$var$U = k) && !l) for($4d82739dd229d539$var$V = e; null !== $4d82739dd229d539$var$V;)g = $4d82739dd229d539$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $4d82739dd229d539$var$kk(e) : null !== k ? (k.return = g, $4d82739dd229d539$var$V = k) : $4d82739dd229d539$var$kk(e);
                for(; null !== f;)$4d82739dd229d539$var$V = f, $4d82739dd229d539$var$jk(f, b, c), f = f.sibling;
                $4d82739dd229d539$var$V = e;
                $4d82739dd229d539$var$Kj = h;
                $4d82739dd229d539$var$U = l;
            }
            $4d82739dd229d539$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $4d82739dd229d539$var$V = f) : $4d82739dd229d539$var$lk(a, b, c);
    }
}
function $4d82739dd229d539$var$lk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $4d82739dd229d539$var$U || $4d82739dd229d539$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$4d82739dd229d539$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $4d82739dd229d539$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $4d82739dd229d539$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $4d82739dd229d539$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $4d82739dd229d539$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($4d82739dd229d539$var$p(163));
                }
                $4d82739dd229d539$var$U || b.flags & 512 && $4d82739dd229d539$var$Sj(b);
            } catch (r) {
                $4d82739dd229d539$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$hk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$kk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $4d82739dd229d539$var$Rj(4, b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $4d82739dd229d539$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $4d82739dd229d539$var$Sj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $4d82739dd229d539$var$Sj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $4d82739dd229d539$var$W(b, b.return, k);
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $4d82739dd229d539$var$V = h;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
var $4d82739dd229d539$var$mk = Math.ceil, $4d82739dd229d539$var$nk = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$ok = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$pk = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$K = 0, $4d82739dd229d539$var$R = null, $4d82739dd229d539$var$Y = null, $4d82739dd229d539$var$Z = 0, $4d82739dd229d539$var$gj = 0, $4d82739dd229d539$var$fj = $4d82739dd229d539$var$Uf(0), $4d82739dd229d539$var$T = 0, $4d82739dd229d539$var$qk = null, $4d82739dd229d539$var$hh = 0, $4d82739dd229d539$var$rk = 0, $4d82739dd229d539$var$sk = 0, $4d82739dd229d539$var$tk = null, $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$gk = 0, $4d82739dd229d539$var$Hj = Infinity, $4d82739dd229d539$var$vk = null, $4d82739dd229d539$var$Pi = !1, $4d82739dd229d539$var$Qi = null, $4d82739dd229d539$var$Si = null, $4d82739dd229d539$var$wk = !1, $4d82739dd229d539$var$xk = null, $4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = 0, $4d82739dd229d539$var$Ak = null, $4d82739dd229d539$var$Bk = -1, $4d82739dd229d539$var$Ck = 0;
function $4d82739dd229d539$var$L() {
    return 0 !== ($4d82739dd229d539$var$K & 6) ? $4d82739dd229d539$var$B() : -1 !== $4d82739dd229d539$var$Bk ? $4d82739dd229d539$var$Bk : $4d82739dd229d539$var$Bk = $4d82739dd229d539$var$B();
}
function $4d82739dd229d539$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($4d82739dd229d539$var$K & 2) && 0 !== $4d82739dd229d539$var$Z) return $4d82739dd229d539$var$Z & -$4d82739dd229d539$var$Z;
    if (null !== $4d82739dd229d539$var$Kg.transition) return 0 === $4d82739dd229d539$var$Ck && ($4d82739dd229d539$var$Ck = $4d82739dd229d539$var$yc()), $4d82739dd229d539$var$Ck;
    a = $4d82739dd229d539$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $4d82739dd229d539$var$jd(a.type);
    return a;
}
function $4d82739dd229d539$var$mh(a, b, c, d) {
    if (50 < $4d82739dd229d539$var$zk) throw $4d82739dd229d539$var$zk = 0, $4d82739dd229d539$var$Ak = null, Error($4d82739dd229d539$var$p(185));
    $4d82739dd229d539$var$Ac(a, c, d);
    if (0 === ($4d82739dd229d539$var$K & 2) || a !== $4d82739dd229d539$var$R) a === $4d82739dd229d539$var$R && (0 === ($4d82739dd229d539$var$K & 2) && ($4d82739dd229d539$var$rk |= c), 4 === $4d82739dd229d539$var$T && $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$Z)), $4d82739dd229d539$var$Ek(a, d), 1 === c && 0 === $4d82739dd229d539$var$K && 0 === (b.mode & 1) && ($4d82739dd229d539$var$Hj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
}
function $4d82739dd229d539$var$Ek(a, b) {
    var c = a.callbackNode;
    $4d82739dd229d539$var$wc(a, b);
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$R ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) null !== c && $4d82739dd229d539$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $4d82739dd229d539$var$bc(c);
        if (1 === b) 0 === a.tag ? $4d82739dd229d539$var$ig($4d82739dd229d539$var$Fk.bind(null, a)) : $4d82739dd229d539$var$hg($4d82739dd229d539$var$Fk.bind(null, a)), $4d82739dd229d539$var$Jf(function() {
            0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
        }), c = null;
        else {
            switch($4d82739dd229d539$var$Dc(d)){
                case 1:
                    c = $4d82739dd229d539$var$fc;
                    break;
                case 4:
                    c = $4d82739dd229d539$var$gc;
                    break;
                case 16:
                    c = $4d82739dd229d539$var$hc;
                    break;
                case 536870912:
                    c = $4d82739dd229d539$var$jc;
                    break;
                default:
                    c = $4d82739dd229d539$var$hc;
            }
            c = $4d82739dd229d539$var$Gk(c, $4d82739dd229d539$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $4d82739dd229d539$var$Hk(a, b) {
    $4d82739dd229d539$var$Bk = -1;
    $4d82739dd229d539$var$Ck = 0;
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    var c = a.callbackNode;
    if ($4d82739dd229d539$var$Ik() && a.callbackNode !== c) return null;
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$R ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $4d82739dd229d539$var$Jk(a, d);
    else {
        b = d;
        var e = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 2;
        var f = $4d82739dd229d539$var$Kk();
        if ($4d82739dd229d539$var$R !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$vk = null, $4d82739dd229d539$var$Hj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$Lk(a, b);
        for(;;)try {
            $4d82739dd229d539$var$Mk();
            break;
        } catch (h) {
            $4d82739dd229d539$var$Nk(a, h);
        }
        $4d82739dd229d539$var$Qg();
        $4d82739dd229d539$var$nk.current = f;
        $4d82739dd229d539$var$K = e;
        null !== $4d82739dd229d539$var$Y ? b = 0 : ($4d82739dd229d539$var$R = null, $4d82739dd229d539$var$Z = 0, b = $4d82739dd229d539$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $4d82739dd229d539$var$xc(a), 0 !== e && (d = e, b = $4d82739dd229d539$var$Ok(a, e)));
        if (1 === b) throw c = $4d82739dd229d539$var$qk, $4d82739dd229d539$var$Lk(a, 0), $4d82739dd229d539$var$Dk(a, d), $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B()), c;
        if (6 === b) $4d82739dd229d539$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$4d82739dd229d539$var$Pk(e) && (b = $4d82739dd229d539$var$Jk(a, d), 2 === b && (f = $4d82739dd229d539$var$xc(a), 0 !== f && (d = f, b = $4d82739dd229d539$var$Ok(a, f))), 1 === b)) throw c = $4d82739dd229d539$var$qk, $4d82739dd229d539$var$Lk(a, 0), $4d82739dd229d539$var$Dk(a, d), $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($4d82739dd229d539$var$p(345));
                case 2:
                    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
                    break;
                case 3:
                    $4d82739dd229d539$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $4d82739dd229d539$var$gk + 500 - $4d82739dd229d539$var$B(), 10 < b)) {
                        if (0 !== $4d82739dd229d539$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $4d82739dd229d539$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Qk.bind(null, a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk), b);
                        break;
                    }
                    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
                    break;
                case 4:
                    $4d82739dd229d539$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $4d82739dd229d539$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $4d82739dd229d539$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $4d82739dd229d539$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Qk.bind(null, a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk), d);
                        break;
                    }
                    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
                    break;
                case 5:
                    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(329));
            }
        }
    }
    $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B());
    return a.callbackNode === c ? $4d82739dd229d539$var$Hk.bind(null, a) : null;
}
function $4d82739dd229d539$var$Ok(a, b) {
    var c = $4d82739dd229d539$var$tk;
    a.current.memoizedState.isDehydrated && ($4d82739dd229d539$var$Lk(a, b).flags |= 256);
    a = $4d82739dd229d539$var$Jk(a, b);
    2 !== a && (b = $4d82739dd229d539$var$uk, $4d82739dd229d539$var$uk = c, null !== b && $4d82739dd229d539$var$Gj(b));
    return a;
}
function $4d82739dd229d539$var$Gj(a) {
    null === $4d82739dd229d539$var$uk ? $4d82739dd229d539$var$uk = a : $4d82739dd229d539$var$uk.push.apply($4d82739dd229d539$var$uk, a);
}
function $4d82739dd229d539$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$4d82739dd229d539$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $4d82739dd229d539$var$Dk(a, b) {
    b &= ~$4d82739dd229d539$var$sk;
    b &= ~$4d82739dd229d539$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $4d82739dd229d539$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $4d82739dd229d539$var$Fk(a) {
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    $4d82739dd229d539$var$Ik();
    var b = $4d82739dd229d539$var$uc(a, 0);
    if (0 === (b & 1)) return $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B()), null;
    var c = $4d82739dd229d539$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $4d82739dd229d539$var$xc(a);
        0 !== d && (b = d, c = $4d82739dd229d539$var$Ok(a, d));
    }
    if (1 === c) throw c = $4d82739dd229d539$var$qk, $4d82739dd229d539$var$Lk(a, 0), $4d82739dd229d539$var$Dk(a, b), $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B()), c;
    if (6 === c) throw Error($4d82739dd229d539$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
    $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B());
    return null;
}
function $4d82739dd229d539$var$Rk(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    try {
        return a(b);
    } finally{
        $4d82739dd229d539$var$K = c, 0 === $4d82739dd229d539$var$K && ($4d82739dd229d539$var$Hj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
    }
}
function $4d82739dd229d539$var$Sk(a) {
    null !== $4d82739dd229d539$var$xk && 0 === $4d82739dd229d539$var$xk.tag && 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$Ik();
    var b = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    var c = $4d82739dd229d539$var$pk.transition, d = $4d82739dd229d539$var$C;
    try {
        if ($4d82739dd229d539$var$pk.transition = null, $4d82739dd229d539$var$C = 1, a) return a();
    } finally{
        $4d82739dd229d539$var$C = d, $4d82739dd229d539$var$pk.transition = c, $4d82739dd229d539$var$K = b, 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
    }
}
function $4d82739dd229d539$var$Ij() {
    $4d82739dd229d539$var$gj = $4d82739dd229d539$var$fj.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$fj);
}
function $4d82739dd229d539$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $4d82739dd229d539$var$Gf(c));
    if (null !== $4d82739dd229d539$var$Y) for(c = $4d82739dd229d539$var$Y.return; null !== c;){
        var d = c;
        $4d82739dd229d539$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $4d82739dd229d539$var$$f();
                break;
            case 3:
                $4d82739dd229d539$var$Jh();
                $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
                $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
                $4d82739dd229d539$var$Oh();
                break;
            case 5:
                $4d82739dd229d539$var$Lh(d);
                break;
            case 4:
                $4d82739dd229d539$var$Jh();
                break;
            case 13:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
                break;
            case 19:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
                break;
            case 10:
                $4d82739dd229d539$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $4d82739dd229d539$var$Ij();
        }
        c = c.return;
    }
    $4d82739dd229d539$var$R = a;
    $4d82739dd229d539$var$Y = a = $4d82739dd229d539$var$wh(a.current, null);
    $4d82739dd229d539$var$Z = $4d82739dd229d539$var$gj = b;
    $4d82739dd229d539$var$T = 0;
    $4d82739dd229d539$var$qk = null;
    $4d82739dd229d539$var$sk = $4d82739dd229d539$var$rk = $4d82739dd229d539$var$hh = 0;
    $4d82739dd229d539$var$uk = $4d82739dd229d539$var$tk = null;
    if (null !== $4d82739dd229d539$var$Wg) {
        for(b = 0; b < $4d82739dd229d539$var$Wg.length; b++)if (c = $4d82739dd229d539$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $4d82739dd229d539$var$Wg = null;
    }
    return a;
}
function $4d82739dd229d539$var$Nk(a, b) {
    do {
        var c = $4d82739dd229d539$var$Y;
        try {
            $4d82739dd229d539$var$Qg();
            $4d82739dd229d539$var$Ph.current = $4d82739dd229d539$var$ai;
            if ($4d82739dd229d539$var$Sh) {
                for(var d = $4d82739dd229d539$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $4d82739dd229d539$var$Sh = !1;
            }
            $4d82739dd229d539$var$Rh = 0;
            $4d82739dd229d539$var$P = $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = null;
            $4d82739dd229d539$var$Th = !1;
            $4d82739dd229d539$var$Uh = 0;
            $4d82739dd229d539$var$ok.current = null;
            if (null === c || null === c.return) {
                $4d82739dd229d539$var$T = 1;
                $4d82739dd229d539$var$qk = b;
                $4d82739dd229d539$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $4d82739dd229d539$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $4d82739dd229d539$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $4d82739dd229d539$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $4d82739dd229d539$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $4d82739dd229d539$var$Ti(f, l, b);
                            $4d82739dd229d539$var$uj();
                            break a;
                        }
                        k = Error($4d82739dd229d539$var$p(426));
                    }
                } else if ($4d82739dd229d539$var$I && h.mode & 1) {
                    var J = $4d82739dd229d539$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $4d82739dd229d539$var$Wi(J, g, h, f, b);
                        $4d82739dd229d539$var$Jg($4d82739dd229d539$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $4d82739dd229d539$var$Ki(k, h);
                4 !== $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 2);
                null === $4d82739dd229d539$var$tk ? $4d82739dd229d539$var$tk = [
                    f
                ] : $4d82739dd229d539$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $4d82739dd229d539$var$Oi(f, k, b);
                            $4d82739dd229d539$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $4d82739dd229d539$var$Si || !$4d82739dd229d539$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $4d82739dd229d539$var$Ri(f, h, b);
                                $4d82739dd229d539$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $4d82739dd229d539$var$Tk(c);
        } catch (na) {
            b = na;
            $4d82739dd229d539$var$Y === c && null !== c && ($4d82739dd229d539$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $4d82739dd229d539$var$Kk() {
    var a = $4d82739dd229d539$var$nk.current;
    $4d82739dd229d539$var$nk.current = $4d82739dd229d539$var$ai;
    return null === a ? $4d82739dd229d539$var$ai : a;
}
function $4d82739dd229d539$var$uj() {
    if (0 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T || 2 === $4d82739dd229d539$var$T) $4d82739dd229d539$var$T = 4;
    null === $4d82739dd229d539$var$R || 0 === ($4d82739dd229d539$var$hh & 268435455) && 0 === ($4d82739dd229d539$var$rk & 268435455) || $4d82739dd229d539$var$Dk($4d82739dd229d539$var$R, $4d82739dd229d539$var$Z);
}
function $4d82739dd229d539$var$Jk(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 2;
    var d = $4d82739dd229d539$var$Kk();
    if ($4d82739dd229d539$var$R !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$vk = null, $4d82739dd229d539$var$Lk(a, b);
    for(;;)try {
        $4d82739dd229d539$var$Uk();
        break;
    } catch (e) {
        $4d82739dd229d539$var$Nk(a, e);
    }
    $4d82739dd229d539$var$Qg();
    $4d82739dd229d539$var$K = c;
    $4d82739dd229d539$var$nk.current = d;
    if (null !== $4d82739dd229d539$var$Y) throw Error($4d82739dd229d539$var$p(261));
    $4d82739dd229d539$var$R = null;
    $4d82739dd229d539$var$Z = 0;
    return $4d82739dd229d539$var$T;
}
function $4d82739dd229d539$var$Uk() {
    for(; null !== $4d82739dd229d539$var$Y;)$4d82739dd229d539$var$Vk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Mk() {
    for(; null !== $4d82739dd229d539$var$Y && !$4d82739dd229d539$var$cc();)$4d82739dd229d539$var$Vk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Vk(a) {
    var b = $4d82739dd229d539$var$Wk(a.alternate, a, $4d82739dd229d539$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $4d82739dd229d539$var$Tk(a) : $4d82739dd229d539$var$Y = b;
    $4d82739dd229d539$var$ok.current = null;
}
function $4d82739dd229d539$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $4d82739dd229d539$var$Fj(c, b, $4d82739dd229d539$var$gj), null !== c) {
                $4d82739dd229d539$var$Y = c;
                return;
            }
        } else {
            c = $4d82739dd229d539$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $4d82739dd229d539$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $4d82739dd229d539$var$T = 6;
                $4d82739dd229d539$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $4d82739dd229d539$var$Y = b;
            return;
        }
        $4d82739dd229d539$var$Y = b = a;
    }while (null !== b);
    0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 5);
}
function $4d82739dd229d539$var$Qk(a, b, c) {
    var d = $4d82739dd229d539$var$C, e = $4d82739dd229d539$var$pk.transition;
    try {
        $4d82739dd229d539$var$pk.transition = null, $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$Xk(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$pk.transition = e, $4d82739dd229d539$var$C = d;
    }
    return null;
}
function $4d82739dd229d539$var$Xk(a, b, c, d) {
    do $4d82739dd229d539$var$Ik();
    while (null !== $4d82739dd229d539$var$xk);
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($4d82739dd229d539$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $4d82739dd229d539$var$Bc(a, f);
    a === $4d82739dd229d539$var$R && ($4d82739dd229d539$var$Y = $4d82739dd229d539$var$R = null, $4d82739dd229d539$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $4d82739dd229d539$var$wk || ($4d82739dd229d539$var$wk = !0, $4d82739dd229d539$var$Gk($4d82739dd229d539$var$hc, function() {
        $4d82739dd229d539$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $4d82739dd229d539$var$pk.transition;
        $4d82739dd229d539$var$pk.transition = null;
        var g = $4d82739dd229d539$var$C;
        $4d82739dd229d539$var$C = 1;
        var h = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 4;
        $4d82739dd229d539$var$ok.current = null;
        $4d82739dd229d539$var$Pj(a, c);
        $4d82739dd229d539$var$ek(c, a);
        $4d82739dd229d539$var$Oe($4d82739dd229d539$var$Df);
        $4d82739dd229d539$var$dd = !!$4d82739dd229d539$var$Cf;
        $4d82739dd229d539$var$Df = $4d82739dd229d539$var$Cf = null;
        a.current = c;
        $4d82739dd229d539$var$ik(c, a, e);
        $4d82739dd229d539$var$dc();
        $4d82739dd229d539$var$K = h;
        $4d82739dd229d539$var$C = g;
        $4d82739dd229d539$var$pk.transition = f;
    } else a.current = c;
    $4d82739dd229d539$var$wk && ($4d82739dd229d539$var$wk = !1, $4d82739dd229d539$var$xk = a, $4d82739dd229d539$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($4d82739dd229d539$var$Si = null);
    $4d82739dd229d539$var$mc(c.stateNode, d);
    $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($4d82739dd229d539$var$Pi) throw $4d82739dd229d539$var$Pi = !1, a = $4d82739dd229d539$var$Qi, $4d82739dd229d539$var$Qi = null, a;
    0 !== ($4d82739dd229d539$var$yk & 1) && 0 !== a.tag && $4d82739dd229d539$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $4d82739dd229d539$var$Ak ? $4d82739dd229d539$var$zk++ : ($4d82739dd229d539$var$zk = 0, $4d82739dd229d539$var$Ak = a) : $4d82739dd229d539$var$zk = 0;
    $4d82739dd229d539$var$jg();
    return null;
}
function $4d82739dd229d539$var$Ik() {
    if (null !== $4d82739dd229d539$var$xk) {
        var a = $4d82739dd229d539$var$Dc($4d82739dd229d539$var$yk), b = $4d82739dd229d539$var$pk.transition, c = $4d82739dd229d539$var$C;
        try {
            $4d82739dd229d539$var$pk.transition = null;
            $4d82739dd229d539$var$C = 16 > a ? 16 : a;
            if (null === $4d82739dd229d539$var$xk) var d = !1;
            else {
                a = $4d82739dd229d539$var$xk;
                $4d82739dd229d539$var$xk = null;
                $4d82739dd229d539$var$yk = 0;
                if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(331));
                var e = $4d82739dd229d539$var$K;
                $4d82739dd229d539$var$K |= 4;
                for($4d82739dd229d539$var$V = a.current; null !== $4d82739dd229d539$var$V;){
                    var f = $4d82739dd229d539$var$V, g = f.child;
                    if (0 !== ($4d82739dd229d539$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($4d82739dd229d539$var$V = l; null !== $4d82739dd229d539$var$V;){
                                    var m = $4d82739dd229d539$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $4d82739dd229d539$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $4d82739dd229d539$var$V = q;
                                    else for(; null !== $4d82739dd229d539$var$V;){
                                        m = $4d82739dd229d539$var$V;
                                        var r = m.sibling, y = m.return;
                                        $4d82739dd229d539$var$Tj(m);
                                        if (m === l) {
                                            $4d82739dd229d539$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $4d82739dd229d539$var$V = r;
                                            break;
                                        }
                                        $4d82739dd229d539$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $4d82739dd229d539$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $4d82739dd229d539$var$V = g;
                    else b: for(; null !== $4d82739dd229d539$var$V;){
                        f = $4d82739dd229d539$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $4d82739dd229d539$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $4d82739dd229d539$var$V = x;
                            break b;
                        }
                        $4d82739dd229d539$var$V = f.return;
                    }
                }
                var w = a.current;
                for($4d82739dd229d539$var$V = w; null !== $4d82739dd229d539$var$V;){
                    g = $4d82739dd229d539$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $4d82739dd229d539$var$V = u;
                    else b: for(g = w; null !== $4d82739dd229d539$var$V;){
                        h = $4d82739dd229d539$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $4d82739dd229d539$var$Rj(9, h);
                            }
                        } catch (na) {
                            $4d82739dd229d539$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $4d82739dd229d539$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $4d82739dd229d539$var$V = F;
                            break b;
                        }
                        $4d82739dd229d539$var$V = h.return;
                    }
                }
                $4d82739dd229d539$var$K = e;
                $4d82739dd229d539$var$jg();
                if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onPostCommitFiberRoot) try {
                    $4d82739dd229d539$var$lc.onPostCommitFiberRoot($4d82739dd229d539$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$pk.transition = b;
        }
    }
    return !1;
}
function $4d82739dd229d539$var$Yk(a, b, c) {
    b = $4d82739dd229d539$var$Ki(c, b);
    b = $4d82739dd229d539$var$Oi(a, b, 1);
    a = $4d82739dd229d539$var$dh(a, b, 1);
    b = $4d82739dd229d539$var$L();
    null !== a && ($4d82739dd229d539$var$Ac(a, 1, b), $4d82739dd229d539$var$Ek(a, b));
}
function $4d82739dd229d539$var$W(a, b, c) {
    if (3 === a.tag) $4d82739dd229d539$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $4d82739dd229d539$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $4d82739dd229d539$var$Si || !$4d82739dd229d539$var$Si.has(d))) {
                a = $4d82739dd229d539$var$Ki(c, a);
                a = $4d82739dd229d539$var$Ri(b, a, 1);
                b = $4d82739dd229d539$var$dh(b, a, 1);
                a = $4d82739dd229d539$var$L();
                null !== b && ($4d82739dd229d539$var$Ac(b, 1, a), $4d82739dd229d539$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $4d82739dd229d539$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $4d82739dd229d539$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $4d82739dd229d539$var$R === a && ($4d82739dd229d539$var$Z & c) === c && (4 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$Z & 130023424) === $4d82739dd229d539$var$Z && 500 > $4d82739dd229d539$var$B() - $4d82739dd229d539$var$gk ? $4d82739dd229d539$var$Lk(a, 0) : $4d82739dd229d539$var$sk |= c);
    $4d82739dd229d539$var$Ek(a, b);
}
function $4d82739dd229d539$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $4d82739dd229d539$var$sc, $4d82739dd229d539$var$sc <<= 1, 0 === ($4d82739dd229d539$var$sc & 130023424) && ($4d82739dd229d539$var$sc = 4194304)));
    var c = $4d82739dd229d539$var$L();
    a = $4d82739dd229d539$var$Zg(a, b);
    null !== a && ($4d82739dd229d539$var$Ac(a, b, c), $4d82739dd229d539$var$Ek(a, c));
}
function $4d82739dd229d539$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $4d82739dd229d539$var$Zk(a, c);
}
function $4d82739dd229d539$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($4d82739dd229d539$var$p(314));
    }
    null !== d && d.delete(b);
    $4d82739dd229d539$var$Zk(a, c);
}
var $4d82739dd229d539$var$Wk;
$4d82739dd229d539$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $4d82739dd229d539$var$Wf.current) $4d82739dd229d539$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $4d82739dd229d539$var$Ug = !1, $4d82739dd229d539$var$zj(a, b, c);
            $4d82739dd229d539$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $4d82739dd229d539$var$Ug = !1, $4d82739dd229d539$var$I && 0 !== (b.flags & 1048576) && $4d82739dd229d539$var$ug(b, $4d82739dd229d539$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $4d82739dd229d539$var$jj(a, b);
            a = b.pendingProps;
            var e = $4d82739dd229d539$var$Yf(b, $4d82739dd229d539$var$H.current);
            $4d82739dd229d539$var$Tg(b, c);
            e = $4d82739dd229d539$var$Xh(null, b, d, a, e, c);
            var f = $4d82739dd229d539$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $4d82739dd229d539$var$Zf(d) ? (f = !0, $4d82739dd229d539$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $4d82739dd229d539$var$ah(b), e.updater = $4d82739dd229d539$var$nh, b.stateNode = e, e._reactInternals = b, $4d82739dd229d539$var$rh(b, d, a, c), b = $4d82739dd229d539$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $4d82739dd229d539$var$I && f && $4d82739dd229d539$var$vg(b), $4d82739dd229d539$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $4d82739dd229d539$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $4d82739dd229d539$var$$k(d);
                a = $4d82739dd229d539$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $4d82739dd229d539$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $4d82739dd229d539$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $4d82739dd229d539$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $4d82739dd229d539$var$aj(null, b, d, $4d82739dd229d539$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($4d82739dd229d539$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Lg(d, e), $4d82739dd229d539$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Lg(d, e), $4d82739dd229d539$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $4d82739dd229d539$var$lj(b);
                if (null === a) throw Error($4d82739dd229d539$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $4d82739dd229d539$var$bh(a, b);
                $4d82739dd229d539$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(423)), b);
                        b = $4d82739dd229d539$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(424)), b);
                        b = $4d82739dd229d539$var$mj(a, b, d, c, e);
                        break a;
                    } else for($4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.stateNode.containerInfo.firstChild), $4d82739dd229d539$var$xg = b, $4d82739dd229d539$var$I = !0, $4d82739dd229d539$var$zg = null, c = $4d82739dd229d539$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $4d82739dd229d539$var$Ig();
                    if (d === e) {
                        b = $4d82739dd229d539$var$$i(a, b, c);
                        break a;
                    }
                    $4d82739dd229d539$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $4d82739dd229d539$var$Kh(b), null === a && $4d82739dd229d539$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $4d82739dd229d539$var$Ef(d, e) ? g = null : null !== f && $4d82739dd229d539$var$Ef(d, f) && (b.flags |= 32), $4d82739dd229d539$var$hj(a, b), $4d82739dd229d539$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $4d82739dd229d539$var$Eg(b), null;
        case 13:
            return $4d82739dd229d539$var$pj(a, b, c);
        case 4:
            return $4d82739dd229d539$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $4d82739dd229d539$var$Bh(b, null, d, c) : $4d82739dd229d539$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Lg(d, e), $4d82739dd229d539$var$Zi(a, b, d, e, c);
        case 7:
            return $4d82739dd229d539$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $4d82739dd229d539$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $4d82739dd229d539$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $4d82739dd229d539$var$G($4d82739dd229d539$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($4d82739dd229d539$var$He(f.value, g)) {
                        if (f.children === e.children && !$4d82739dd229d539$var$Wf.current) {
                            b = $4d82739dd229d539$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $4d82739dd229d539$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $4d82739dd229d539$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($4d82739dd229d539$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $4d82739dd229d539$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $4d82739dd229d539$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $4d82739dd229d539$var$Tg(b, c), e = $4d82739dd229d539$var$Vg(e), d = d(e), b.flags |= 1, $4d82739dd229d539$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $4d82739dd229d539$var$Lg(d, b.pendingProps), e = $4d82739dd229d539$var$Lg(d.type, e), $4d82739dd229d539$var$aj(a, b, d, e, c);
        case 15:
            return $4d82739dd229d539$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Lg(d, e), $4d82739dd229d539$var$jj(a, b), b.tag = 1, $4d82739dd229d539$var$Zf(d) ? (a = !0, $4d82739dd229d539$var$cg(b)) : a = !1, $4d82739dd229d539$var$Tg(b, c), $4d82739dd229d539$var$ph(b, d, e), $4d82739dd229d539$var$rh(b, d, e, c), $4d82739dd229d539$var$kj(null, b, d, !0, a, c);
        case 19:
            return $4d82739dd229d539$var$yj(a, b, c);
        case 22:
            return $4d82739dd229d539$var$ej(a, b, c);
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
};
function $4d82739dd229d539$var$Gk(a, b) {
    return $4d82739dd229d539$var$ac(a, b);
}
function $4d82739dd229d539$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $4d82739dd229d539$var$Bg(a, b, c, d) {
    return new $4d82739dd229d539$var$al(a, b, c, d);
}
function $4d82739dd229d539$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $4d82739dd229d539$var$$k(a) {
    if ("function" === typeof a) return $4d82739dd229d539$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $4d82739dd229d539$var$Da) return 11;
        if (a === $4d82739dd229d539$var$Ga) return 14;
    }
    return 2;
}
function $4d82739dd229d539$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $4d82739dd229d539$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $4d82739dd229d539$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $4d82739dd229d539$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $4d82739dd229d539$var$ya:
            return $4d82739dd229d539$var$Ah(c.children, e, f, b);
        case $4d82739dd229d539$var$za:
            g = 8;
            e |= 8;
            break;
        case $4d82739dd229d539$var$Aa:
            return a = $4d82739dd229d539$var$Bg(12, c, b, e | 2), a.elementType = $4d82739dd229d539$var$Aa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ea:
            return a = $4d82739dd229d539$var$Bg(13, c, b, e), a.elementType = $4d82739dd229d539$var$Ea, a.lanes = f, a;
        case $4d82739dd229d539$var$Fa:
            return a = $4d82739dd229d539$var$Bg(19, c, b, e), a.elementType = $4d82739dd229d539$var$Fa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ia:
            return $4d82739dd229d539$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $4d82739dd229d539$var$Ba:
                    g = 10;
                    break a;
                case $4d82739dd229d539$var$Ca:
                    g = 9;
                    break a;
                case $4d82739dd229d539$var$Da:
                    g = 11;
                    break a;
                case $4d82739dd229d539$var$Ga:
                    g = 14;
                    break a;
                case $4d82739dd229d539$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($4d82739dd229d539$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $4d82739dd229d539$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $4d82739dd229d539$var$Ah(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$qj(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(22, a, d, b);
    a.elementType = $4d82739dd229d539$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $4d82739dd229d539$var$xh(a, b, c) {
    a = $4d82739dd229d539$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$zh(a, b, c) {
    b = $4d82739dd229d539$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $4d82739dd229d539$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $4d82739dd229d539$var$zc(0);
    this.expirationTimes = $4d82739dd229d539$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $4d82739dd229d539$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $4d82739dd229d539$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $4d82739dd229d539$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $4d82739dd229d539$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $4d82739dd229d539$var$ah(f);
    return a;
}
function $4d82739dd229d539$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4d82739dd229d539$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $4d82739dd229d539$var$el(a) {
    if (!a) return $4d82739dd229d539$var$Vf;
    a = a._reactInternals;
    a: {
        if ($4d82739dd229d539$var$Vb(a) !== a || 1 !== a.tag) throw Error($4d82739dd229d539$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($4d82739dd229d539$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($4d82739dd229d539$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($4d82739dd229d539$var$Zf(c)) return $4d82739dd229d539$var$bg(a, c, b);
    }
    return b;
}
function $4d82739dd229d539$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $4d82739dd229d539$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $4d82739dd229d539$var$el(null);
    c = a.current;
    d = $4d82739dd229d539$var$L();
    e = $4d82739dd229d539$var$lh(c);
    f = $4d82739dd229d539$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $4d82739dd229d539$var$dh(c, f, e);
    a.current.lanes = e;
    $4d82739dd229d539$var$Ac(a, e, d);
    $4d82739dd229d539$var$Ek(a, d);
    return a;
}
function $4d82739dd229d539$var$gl(a, b, c, d) {
    var e = b.current, f = $4d82739dd229d539$var$L(), g = $4d82739dd229d539$var$lh(e);
    c = $4d82739dd229d539$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $4d82739dd229d539$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $4d82739dd229d539$var$dh(e, b, g);
    null !== a && ($4d82739dd229d539$var$mh(a, e, g, f), $4d82739dd229d539$var$eh(a, e, g));
    return g;
}
function $4d82739dd229d539$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $4d82739dd229d539$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $4d82739dd229d539$var$jl(a, b) {
    $4d82739dd229d539$var$il(a, b);
    (a = a.alternate) && $4d82739dd229d539$var$il(a, b);
}
function $4d82739dd229d539$var$kl() {
    return null;
}
var $4d82739dd229d539$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $4d82739dd229d539$var$ml(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$nl.prototype.render = $4d82739dd229d539$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($4d82739dd229d539$var$p(409));
    $4d82739dd229d539$var$gl(a, b, null, null);
};
$4d82739dd229d539$var$nl.prototype.unmount = $4d82739dd229d539$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $4d82739dd229d539$var$Sk(function() {
            $4d82739dd229d539$var$gl(null, a, null, null);
        });
        b[$4d82739dd229d539$var$uf] = null;
    }
};
function $4d82739dd229d539$var$nl(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $4d82739dd229d539$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $4d82739dd229d539$var$Qc.length && 0 !== b && b < $4d82739dd229d539$var$Qc[c].priority; c++);
        $4d82739dd229d539$var$Qc.splice(c, 0, a);
        0 === c && $4d82739dd229d539$var$Vc(a);
    }
};
function $4d82739dd229d539$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $4d82739dd229d539$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $4d82739dd229d539$var$ql() {}
function $4d82739dd229d539$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $4d82739dd229d539$var$hl(g);
                f.call(a);
            };
        }
        var g = $4d82739dd229d539$var$fl(b, d, a, 0, null, !1, !1, "", $4d82739dd229d539$var$ql);
        a._reactRootContainer = g;
        a[$4d82739dd229d539$var$uf] = g.current;
        $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
        $4d82739dd229d539$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $4d82739dd229d539$var$hl(k);
            h.call(a);
        };
    }
    var k = $4d82739dd229d539$var$cl(a, 0, !1, null, null, !1, !1, "", $4d82739dd229d539$var$ql);
    a._reactRootContainer = k;
    a[$4d82739dd229d539$var$uf] = k.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    $4d82739dd229d539$var$Sk(function() {
        $4d82739dd229d539$var$gl(b, k, c, d);
    });
    return k;
}
function $4d82739dd229d539$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $4d82739dd229d539$var$hl(g);
                h.call(a);
            };
        }
        $4d82739dd229d539$var$gl(b, g, a, e);
    } else g = $4d82739dd229d539$var$rl(c, b, a, e, d);
    return $4d82739dd229d539$var$hl(g);
}
$4d82739dd229d539$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $4d82739dd229d539$var$tc(b.pendingLanes);
                0 !== c && ($4d82739dd229d539$var$Cc(b, c | 1), $4d82739dd229d539$var$Ek(b, $4d82739dd229d539$var$B()), 0 === ($4d82739dd229d539$var$K & 6) && ($4d82739dd229d539$var$Hj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$jg()));
            }
            break;
        case 13:
            $4d82739dd229d539$var$Sk(function() {
                var b = $4d82739dd229d539$var$Zg(a, 1);
                if (null !== b) {
                    var c = $4d82739dd229d539$var$L();
                    $4d82739dd229d539$var$mh(b, a, 1, c);
                }
            }), $4d82739dd229d539$var$jl(a, 1);
    }
};
$4d82739dd229d539$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $4d82739dd229d539$var$L();
            $4d82739dd229d539$var$mh(b, a, 134217728, c);
        }
        $4d82739dd229d539$var$jl(a, 134217728);
    }
};
$4d82739dd229d539$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$lh(a), c = $4d82739dd229d539$var$Zg(a, b);
        if (null !== c) {
            var d = $4d82739dd229d539$var$L();
            $4d82739dd229d539$var$mh(c, a, b, d);
        }
        $4d82739dd229d539$var$jl(a, b);
    }
};
$4d82739dd229d539$var$Hc = function() {
    return $4d82739dd229d539$var$C;
};
$4d82739dd229d539$var$Ic = function(a, b) {
    var c = $4d82739dd229d539$var$C;
    try {
        return $4d82739dd229d539$var$C = a, b();
    } finally{
        $4d82739dd229d539$var$C = c;
    }
};
$4d82739dd229d539$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $4d82739dd229d539$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $4d82739dd229d539$var$Db(d);
                        if (!e) throw Error($4d82739dd229d539$var$p(90));
                        $4d82739dd229d539$var$Wa(d);
                        $4d82739dd229d539$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $4d82739dd229d539$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $4d82739dd229d539$var$fb(a, !!c.multiple, b, !1);
    }
};
$4d82739dd229d539$var$Gb = $4d82739dd229d539$var$Rk;
$4d82739dd229d539$var$Hb = $4d82739dd229d539$var$Sk;
var $4d82739dd229d539$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $4d82739dd229d539$var$Cb,
        $4d82739dd229d539$var$ue,
        $4d82739dd229d539$var$Db,
        $4d82739dd229d539$var$Eb,
        $4d82739dd229d539$var$Fb,
        $4d82739dd229d539$var$Rk
    ]
}, $4d82739dd229d539$var$ul = {
    findFiberByHostInstance: $4d82739dd229d539$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $4d82739dd229d539$var$vl = {
    bundleType: $4d82739dd229d539$var$ul.bundleType,
    version: $4d82739dd229d539$var$ul.version,
    rendererPackageName: $4d82739dd229d539$var$ul.rendererPackageName,
    rendererConfig: $4d82739dd229d539$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $4d82739dd229d539$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $4d82739dd229d539$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $4d82739dd229d539$var$ul.findFiberByHostInstance || $4d82739dd229d539$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $4d82739dd229d539$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$4d82739dd229d539$var$wl.isDisabled && $4d82739dd229d539$var$wl.supportsFiber) try {
        $4d82739dd229d539$var$kc = $4d82739dd229d539$var$wl.inject($4d82739dd229d539$var$vl), $4d82739dd229d539$var$lc = $4d82739dd229d539$var$wl;
    } catch (a) {}
}
$4d82739dd229d539$export$ae55be85d98224ed = $4d82739dd229d539$var$tl;
$4d82739dd229d539$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$4d82739dd229d539$var$ol(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$dl(a, b, null, c);
};
$4d82739dd229d539$export$882461b6382ed46c = function(a, b) {
    if (!$4d82739dd229d539$var$ol(a)) throw Error($4d82739dd229d539$var$p(299));
    var c = !1, d = "", e = $4d82739dd229d539$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $4d82739dd229d539$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $4d82739dd229d539$var$ml(b);
};
$4d82739dd229d539$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($4d82739dd229d539$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($4d82739dd229d539$var$p(268, a));
    }
    a = $4d82739dd229d539$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$4d82739dd229d539$export$cd75ccfd720a3cd4 = function(a) {
    return $4d82739dd229d539$var$Sk(a);
};
$4d82739dd229d539$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$4d82739dd229d539$var$pl(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$sl(null, a, b, !0, c);
};
$4d82739dd229d539$export$757ceba2d55c277e = function(a, b, c) {
    if (!$4d82739dd229d539$var$ol(a)) throw Error($4d82739dd229d539$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $4d82739dd229d539$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $4d82739dd229d539$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $4d82739dd229d539$var$nl(b);
};
$4d82739dd229d539$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$4d82739dd229d539$var$pl(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$sl(null, a, b, !1, c);
};
$4d82739dd229d539$export$502457920280e6be = function(a) {
    if (!$4d82739dd229d539$var$pl(a)) throw Error($4d82739dd229d539$var$p(40));
    return a._reactRootContainer ? ($4d82739dd229d539$var$Sk(function() {
        $4d82739dd229d539$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$4d82739dd229d539$var$uf] = null;
        });
    }), !0) : !1;
};
$4d82739dd229d539$export$c78a37762a8d58e1 = $4d82739dd229d539$var$Rk;
$4d82739dd229d539$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$4d82739dd229d539$var$pl(c)) throw Error($4d82739dd229d539$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($4d82739dd229d539$var$p(38));
    return $4d82739dd229d539$var$sl(a, b, c, !1, d);
};
$4d82739dd229d539$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("4SikT", function(module, exports) {
"use strict";

module.exports = (parcelRequire("QUkeG"));

});
parcelRegister("QUkeG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $09f08c7ddbbce24d$export$c4744153514ff05d; }, function (v) { return $09f08c7ddbbce24d$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $09f08c7ddbbce24d$export$3e506c1ccc9cc1a7; }, function (v) { return $09f08c7ddbbce24d$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $09f08c7ddbbce24d$export$e26fe2ed2fa76875; }, function (v) { return $09f08c7ddbbce24d$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $09f08c7ddbbce24d$export$502329bbf4b505b1; }, function (v) { return $09f08c7ddbbce24d$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $09f08c7ddbbce24d$export$6e3807111c4874c4; }, function (v) { return $09f08c7ddbbce24d$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $09f08c7ddbbce24d$export$c27134553091fb3a; }, function (v) { return $09f08c7ddbbce24d$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $09f08c7ddbbce24d$export$33ee1acdc04fd2a2; }, function (v) { return $09f08c7ddbbce24d$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $09f08c7ddbbce24d$export$b00a404bbd5edef2; }, function (v) { return $09f08c7ddbbce24d$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $09f08c7ddbbce24d$export$8352ce38b91d0c62; }, function (v) { return $09f08c7ddbbce24d$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $09f08c7ddbbce24d$export$d66a1c1c77bd778b; }, function (v) { return $09f08c7ddbbce24d$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $09f08c7ddbbce24d$export$d3dfb8e4810cb555; }, function (v) { return $09f08c7ddbbce24d$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $09f08c7ddbbce24d$export$839f9183b0465a69; }, function (v) { return $09f08c7ddbbce24d$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $09f08c7ddbbce24d$export$72fdf0e06517287b; }, function (v) { return $09f08c7ddbbce24d$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $09f08c7ddbbce24d$export$4b844e58a3e414b4; }, function (v) { return $09f08c7ddbbce24d$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $09f08c7ddbbce24d$export$816d2913ae6b83b1; }, function (v) { return $09f08c7ddbbce24d$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $09f08c7ddbbce24d$export$61bcfe829111a1d0; }, function (v) { return $09f08c7ddbbce24d$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $09f08c7ddbbce24d$export$7ee8c9beb337bc3f; }, function (v) { return $09f08c7ddbbce24d$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $09f08c7ddbbce24d$export$b5836b71941fa3ed; }, function (v) { return $09f08c7ddbbce24d$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $09f08c7ddbbce24d$export$cf845f2c119da08a; }, function (v) { return $09f08c7ddbbce24d$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $09f08c7ddbbce24d$export$c4744153514ff05d;
var $09f08c7ddbbce24d$export$3e506c1ccc9cc1a7;
var $09f08c7ddbbce24d$export$e26fe2ed2fa76875;
var $09f08c7ddbbce24d$export$502329bbf4b505b1;
var $09f08c7ddbbce24d$export$6e3807111c4874c4;
var $09f08c7ddbbce24d$export$c27134553091fb3a;
var $09f08c7ddbbce24d$export$33ee1acdc04fd2a2;
var $09f08c7ddbbce24d$export$b00a404bbd5edef2;
var $09f08c7ddbbce24d$export$8352ce38b91d0c62;
var $09f08c7ddbbce24d$export$d66a1c1c77bd778b;
var $09f08c7ddbbce24d$export$d3dfb8e4810cb555;
var $09f08c7ddbbce24d$export$839f9183b0465a69;
var $09f08c7ddbbce24d$export$72fdf0e06517287b;
var $09f08c7ddbbce24d$export$4b844e58a3e414b4;
var $09f08c7ddbbce24d$export$816d2913ae6b83b1;
var $09f08c7ddbbce24d$export$61bcfe829111a1d0;
var $09f08c7ddbbce24d$export$7ee8c9beb337bc3f;
var $09f08c7ddbbce24d$export$b5836b71941fa3ed;
var $09f08c7ddbbce24d$export$cf845f2c119da08a;
"use strict";
function $09f08c7ddbbce24d$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $09f08c7ddbbce24d$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $09f08c7ddbbce24d$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $09f08c7ddbbce24d$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $09f08c7ddbbce24d$var$g(C, c)) n < e && 0 > $09f08c7ddbbce24d$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $09f08c7ddbbce24d$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $09f08c7ddbbce24d$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $09f08c7ddbbce24d$var$l = performance;
    $09f08c7ddbbce24d$export$c4744153514ff05d = function() {
        return $09f08c7ddbbce24d$var$l.now();
    };
} else {
    var $09f08c7ddbbce24d$var$p = Date, $09f08c7ddbbce24d$var$q = $09f08c7ddbbce24d$var$p.now();
    $09f08c7ddbbce24d$export$c4744153514ff05d = function() {
        return $09f08c7ddbbce24d$var$p.now() - $09f08c7ddbbce24d$var$q;
    };
}
var $09f08c7ddbbce24d$var$r = [], $09f08c7ddbbce24d$var$t = [], $09f08c7ddbbce24d$var$u = 1, $09f08c7ddbbce24d$var$v = null, $09f08c7ddbbce24d$var$y = 3, $09f08c7ddbbce24d$var$z = !1, $09f08c7ddbbce24d$var$A = !1, $09f08c7ddbbce24d$var$B = !1, $09f08c7ddbbce24d$var$D = "function" === typeof setTimeout ? setTimeout : null, $09f08c7ddbbce24d$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $09f08c7ddbbce24d$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $09f08c7ddbbce24d$var$G(a) {
    for(var b = $09f08c7ddbbce24d$var$h($09f08c7ddbbce24d$var$t); null !== b;){
        if (null === b.callback) $09f08c7ddbbce24d$var$k($09f08c7ddbbce24d$var$t);
        else if (b.startTime <= a) $09f08c7ddbbce24d$var$k($09f08c7ddbbce24d$var$t), b.sortIndex = b.expirationTime, $09f08c7ddbbce24d$var$f($09f08c7ddbbce24d$var$r, b);
        else break;
        b = $09f08c7ddbbce24d$var$h($09f08c7ddbbce24d$var$t);
    }
}
function $09f08c7ddbbce24d$var$H(a) {
    $09f08c7ddbbce24d$var$B = !1;
    $09f08c7ddbbce24d$var$G(a);
    if (!$09f08c7ddbbce24d$var$A) {
        if (null !== $09f08c7ddbbce24d$var$h($09f08c7ddbbce24d$var$r)) $09f08c7ddbbce24d$var$A = !0, $09f08c7ddbbce24d$var$I($09f08c7ddbbce24d$var$J);
        else {
            var b = $09f08c7ddbbce24d$var$h($09f08c7ddbbce24d$var$t);
            null !== b && $09f08c7ddbbce24d$var$K($09f08c7ddbbce24d$var$H, b.startTime - a);
        }
    }
}
function $09f08c7ddbbce24d$var$J(a, b) {
    $09f08c7ddbbce24d$var$A = !1;
    $09f08c7ddbbce24d$var$B && ($09f08c7ddbbce24d$var$B = !1, $09f08c7ddbbce24d$var$E($09f08c7ddbbce24d$var$L), $09f08c7ddbbce24d$var$L = -1);
    $09f08c7ddbbce24d$var$z = !0;
    var c = $09f08c7ddbbce24d$var$y;
    try {
        $09f08c7ddbbce24d$var$G(b);
        for($09f08c7ddbbce24d$var$v = $09f08c7ddbbce24d$var$h($09f08c7ddbbce24d$var$r); null !== $09f08c7ddbbce24d$var$v && (!($09f08c7ddbbce24d$var$v.expirationTime > b) || a && !$09f08c7ddbbce24d$var$M());){
            var d = $09f08c7ddbbce24d$var$v.callback;
            if ("function" === typeof d) {
                $09f08c7ddbbce24d$var$v.callback = null;
                $09f08c7ddbbce24d$var$y = $09f08c7ddbbce24d$var$v.priorityLevel;
                var e = d($09f08c7ddbbce24d$var$v.expirationTime <= b);
                b = $09f08c7ddbbce24d$export$c4744153514ff05d();
                "function" === typeof e ? $09f08c7ddbbce24d$var$v.callback = e : $09f08c7ddbbce24d$var$v === $09f08c7ddbbce24d$var$h($09f08c7ddbbce24d$var$r) && $09f08c7ddbbce24d$var$k($09f08c7ddbbce24d$var$r);
                $09f08c7ddbbce24d$var$G(b);
            } else $09f08c7ddbbce24d$var$k($09f08c7ddbbce24d$var$r);
            $09f08c7ddbbce24d$var$v = $09f08c7ddbbce24d$var$h($09f08c7ddbbce24d$var$r);
        }
        if (null !== $09f08c7ddbbce24d$var$v) var w = !0;
        else {
            var m = $09f08c7ddbbce24d$var$h($09f08c7ddbbce24d$var$t);
            null !== m && $09f08c7ddbbce24d$var$K($09f08c7ddbbce24d$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $09f08c7ddbbce24d$var$v = null, $09f08c7ddbbce24d$var$y = c, $09f08c7ddbbce24d$var$z = !1;
    }
}
var $09f08c7ddbbce24d$var$N = !1, $09f08c7ddbbce24d$var$O = null, $09f08c7ddbbce24d$var$L = -1, $09f08c7ddbbce24d$var$P = 5, $09f08c7ddbbce24d$var$Q = -1;
function $09f08c7ddbbce24d$var$M() {
    return $09f08c7ddbbce24d$export$c4744153514ff05d() - $09f08c7ddbbce24d$var$Q < $09f08c7ddbbce24d$var$P ? !1 : !0;
}
function $09f08c7ddbbce24d$var$R() {
    if (null !== $09f08c7ddbbce24d$var$O) {
        var a = $09f08c7ddbbce24d$export$c4744153514ff05d();
        $09f08c7ddbbce24d$var$Q = a;
        var b = !0;
        try {
            b = $09f08c7ddbbce24d$var$O(!0, a);
        } finally{
            b ? $09f08c7ddbbce24d$var$S() : ($09f08c7ddbbce24d$var$N = !1, $09f08c7ddbbce24d$var$O = null);
        }
    } else $09f08c7ddbbce24d$var$N = !1;
}
var $09f08c7ddbbce24d$var$S;
if ("function" === typeof $09f08c7ddbbce24d$var$F) $09f08c7ddbbce24d$var$S = function() {
    $09f08c7ddbbce24d$var$F($09f08c7ddbbce24d$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $09f08c7ddbbce24d$var$T = new MessageChannel, $09f08c7ddbbce24d$var$U = $09f08c7ddbbce24d$var$T.port2;
    $09f08c7ddbbce24d$var$T.port1.onmessage = $09f08c7ddbbce24d$var$R;
    $09f08c7ddbbce24d$var$S = function() {
        $09f08c7ddbbce24d$var$U.postMessage(null);
    };
} else $09f08c7ddbbce24d$var$S = function() {
    $09f08c7ddbbce24d$var$D($09f08c7ddbbce24d$var$R, 0);
};
function $09f08c7ddbbce24d$var$I(a) {
    $09f08c7ddbbce24d$var$O = a;
    $09f08c7ddbbce24d$var$N || ($09f08c7ddbbce24d$var$N = !0, $09f08c7ddbbce24d$var$S());
}
function $09f08c7ddbbce24d$var$K(a, b) {
    $09f08c7ddbbce24d$var$L = $09f08c7ddbbce24d$var$D(function() {
        a($09f08c7ddbbce24d$export$c4744153514ff05d());
    }, b);
}
$09f08c7ddbbce24d$export$3e506c1ccc9cc1a7 = 5;
$09f08c7ddbbce24d$export$e26fe2ed2fa76875 = 1;
$09f08c7ddbbce24d$export$502329bbf4b505b1 = 4;
$09f08c7ddbbce24d$export$6e3807111c4874c4 = 3;
$09f08c7ddbbce24d$export$c27134553091fb3a = null;
$09f08c7ddbbce24d$export$33ee1acdc04fd2a2 = 2;
$09f08c7ddbbce24d$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$09f08c7ddbbce24d$export$8352ce38b91d0c62 = function() {
    $09f08c7ddbbce24d$var$A || $09f08c7ddbbce24d$var$z || ($09f08c7ddbbce24d$var$A = !0, $09f08c7ddbbce24d$var$I($09f08c7ddbbce24d$var$J));
};
$09f08c7ddbbce24d$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $09f08c7ddbbce24d$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$09f08c7ddbbce24d$export$d3dfb8e4810cb555 = function() {
    return $09f08c7ddbbce24d$var$y;
};
$09f08c7ddbbce24d$export$839f9183b0465a69 = function() {
    return $09f08c7ddbbce24d$var$h($09f08c7ddbbce24d$var$r);
};
$09f08c7ddbbce24d$export$72fdf0e06517287b = function(a) {
    switch($09f08c7ddbbce24d$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $09f08c7ddbbce24d$var$y;
    }
    var c = $09f08c7ddbbce24d$var$y;
    $09f08c7ddbbce24d$var$y = b;
    try {
        return a();
    } finally{
        $09f08c7ddbbce24d$var$y = c;
    }
};
$09f08c7ddbbce24d$export$4b844e58a3e414b4 = function() {};
$09f08c7ddbbce24d$export$816d2913ae6b83b1 = function() {};
$09f08c7ddbbce24d$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $09f08c7ddbbce24d$var$y;
    $09f08c7ddbbce24d$var$y = a;
    try {
        return b();
    } finally{
        $09f08c7ddbbce24d$var$y = c;
    }
};
$09f08c7ddbbce24d$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $09f08c7ddbbce24d$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $09f08c7ddbbce24d$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $09f08c7ddbbce24d$var$f($09f08c7ddbbce24d$var$t, a), null === $09f08c7ddbbce24d$var$h($09f08c7ddbbce24d$var$r) && a === $09f08c7ddbbce24d$var$h($09f08c7ddbbce24d$var$t) && ($09f08c7ddbbce24d$var$B ? ($09f08c7ddbbce24d$var$E($09f08c7ddbbce24d$var$L), $09f08c7ddbbce24d$var$L = -1) : $09f08c7ddbbce24d$var$B = !0, $09f08c7ddbbce24d$var$K($09f08c7ddbbce24d$var$H, c - d))) : (a.sortIndex = e, $09f08c7ddbbce24d$var$f($09f08c7ddbbce24d$var$r, a), $09f08c7ddbbce24d$var$A || $09f08c7ddbbce24d$var$z || ($09f08c7ddbbce24d$var$A = !0, $09f08c7ddbbce24d$var$I($09f08c7ddbbce24d$var$J)));
    return a;
};
$09f08c7ddbbce24d$export$b5836b71941fa3ed = $09f08c7ddbbce24d$var$M;
$09f08c7ddbbce24d$export$cf845f2c119da08a = function(a) {
    var b = $09f08c7ddbbce24d$var$y;
    return function() {
        var c = $09f08c7ddbbce24d$var$y;
        $09f08c7ddbbce24d$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $09f08c7ddbbce24d$var$y = c;
        }
    };
};

});




parcelRegister("eyN91", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $89IRS = parcelRequire("89IRS");

var $3buYL = parcelRequire("3buYL");

var $5zYCF = parcelRequire("5zYCF");

var $l2rYF = parcelRequire("l2rYF");
var $a99a5cbe9557244c$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new $5zYCF.RawSha256();
        if (secret) {
            this.outer = new $5zYCF.RawSha256();
            var inner = $a99a5cbe9557244c$var$bufferFromSecret(secret);
            var outer = new Uint8Array($3buYL.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $3buYL.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $l2rYF.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, $l2rYF.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $89IRS.__awaiter)(this, void 0, void 0, function() {
            return (0, $89IRS.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $a99a5cbe9557244c$var$Sha256;
function $a99a5cbe9557244c$var$bufferFromSecret(secret) {
    var input = (0, $l2rYF.convertToBuffer)(secret);
    if (input.byteLength > $3buYL.BLOCK_SIZE) {
        var bufferHash = new $5zYCF.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($3buYL.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

});
parcelRegister("89IRS", function(module, exports) {

$parcel$export(module.exports, "__awaiter", function () { return $5f01f7d5d046a198$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $5f01f7d5d046a198$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__exportStar", function () { return $5f01f7d5d046a198$export$f33643c0debef087; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5f01f7d5d046a198$var$extendStatics = function(d, b) {
    $5f01f7d5d046a198$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $5f01f7d5d046a198$var$extendStatics(d, b);
};
function $5f01f7d5d046a198$export$a8ba968b8961cb8a(d, b) {
    $5f01f7d5d046a198$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5f01f7d5d046a198$export$18ce0697a983be9b = function() {
    $5f01f7d5d046a198$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5f01f7d5d046a198$export$18ce0697a983be9b.apply(this, arguments);
};
function $5f01f7d5d046a198$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5f01f7d5d046a198$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5f01f7d5d046a198$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5f01f7d5d046a198$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5f01f7d5d046a198$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5f01f7d5d046a198$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $5f01f7d5d046a198$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $5f01f7d5d046a198$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $5f01f7d5d046a198$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5f01f7d5d046a198$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5f01f7d5d046a198$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5f01f7d5d046a198$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5f01f7d5d046a198$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5f01f7d5d046a198$export$10c90e4f7922046c(v) {
    return this instanceof $5f01f7d5d046a198$export$10c90e4f7922046c ? (this.v = v, this) : new $5f01f7d5d046a198$export$10c90e4f7922046c(v);
}
function $5f01f7d5d046a198$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5f01f7d5d046a198$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5f01f7d5d046a198$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5f01f7d5d046a198$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $5f01f7d5d046a198$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5f01f7d5d046a198$export$19a8beecd37a4c45 === "function" ? $5f01f7d5d046a198$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5f01f7d5d046a198$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $5f01f7d5d046a198$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $5f01f7d5d046a198$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5f01f7d5d046a198$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $5f01f7d5d046a198$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("3buYL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_HASHABLE_LENGTH = module.exports.INIT = module.exports.KEY = module.exports.DIGEST_LENGTH = module.exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRegister("5zYCF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawSha256 = void 0;

var $3buYL = parcelRequire("3buYL");
/**
 * @internal
 */ var $40ff3f0add742396$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($3buYL.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $3buYL.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $3buYL.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $3buYL.BLOCK_SIZE >= $3buYL.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $3buYL.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $3buYL.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($3buYL.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($3buYL.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($3buYL.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $3buYL.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($3buYL.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $40ff3f0add742396$var$RawSha256;

});

parcelRegister("l2rYF", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = module.exports.numToUint8 = module.exports.isEmptyData = module.exports.convertToBuffer = void 0;

var $7UcU9 = parcelRequire("7UcU9");
Object.defineProperty(module.exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return $7UcU9.convertToBuffer;
    }
});

var $gW0Hw = parcelRequire("gW0Hw");
Object.defineProperty(module.exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return $gW0Hw.isEmptyData;
    }
});

var $bnMPG = parcelRequire("bnMPG");
Object.defineProperty(module.exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return $bnMPG.numToUint8;
    }
});

var $fAKRQ = parcelRequire("fAKRQ");
Object.defineProperty(module.exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return $fAKRQ.uint32ArrayFrom;
    }
});

});
parcelRegister("7UcU9", function(module, exports) {

var $bdjQ6 = parcelRequire("bdjQ6");
var $5c17c5f46f99c1cd$require$Buffer = $bdjQ6.Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertToBuffer = void 0;

var $hvKlG = parcelRequire("hvKlG");
// Quick polyfill
var $5c17c5f46f99c1cd$var$fromUtf8 = typeof $5c17c5f46f99c1cd$require$Buffer !== "undefined" && $5c17c5f46f99c1cd$require$Buffer.from ? function(input) {
    return $5c17c5f46f99c1cd$require$Buffer.from(input, "utf8");
} : $hvKlG.fromUtf8;
function $5c17c5f46f99c1cd$var$convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $5c17c5f46f99c1cd$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
module.exports.convertToBuffer = $5c17c5f46f99c1cd$var$convertToBuffer;

});
parcelRegister("bdjQ6", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $82a04c4ec6982288$export$a143d493d941bafc; }, function (v) { return $82a04c4ec6982288$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $82a04c4ec6982288$export$f99ded8fe4b79145; }, function (v) { return $82a04c4ec6982288$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $82a04c4ec6982288$export$a143d493d941bafc;
var $82a04c4ec6982288$export$e4cf37d7f6fb9e0a;
var $82a04c4ec6982288$export$f99ded8fe4b79145;
var $82a04c4ec6982288$export$599f31c3813fae4d;
"use strict";

var $3nocJ = parcelRequire("3nocJ");

var $gU9iR = parcelRequire("gU9iR");
const $82a04c4ec6982288$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$82a04c4ec6982288$export$a143d493d941bafc = $82a04c4ec6982288$var$Buffer;
$82a04c4ec6982288$export$e4cf37d7f6fb9e0a = $82a04c4ec6982288$var$SlowBuffer;
$82a04c4ec6982288$export$f99ded8fe4b79145 = 50;
const $82a04c4ec6982288$var$K_MAX_LENGTH = 0x7fffffff;
$82a04c4ec6982288$export$599f31c3813fae4d = $82a04c4ec6982288$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT = $82a04c4ec6982288$var$typedArraySupport();
if (!$82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $82a04c4ec6982288$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $82a04c4ec6982288$var$createBuffer(length) {
    if (length > $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $82a04c4ec6982288$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $82a04c4ec6982288$var$allocUnsafe(arg);
    }
    return $82a04c4ec6982288$var$from(arg, encodingOrOffset, length);
}
$82a04c4ec6982288$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $82a04c4ec6982288$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $82a04c4ec6982288$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $82a04c4ec6982288$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($82a04c4ec6982288$var$isInstance(value, ArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, ArrayBuffer)) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($82a04c4ec6982288$var$isInstance(value, SharedArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, SharedArrayBuffer))) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $82a04c4ec6982288$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $82a04c4ec6982288$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $82a04c4ec6982288$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $82a04c4ec6982288$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $82a04c4ec6982288$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer, Uint8Array);
function $82a04c4ec6982288$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $82a04c4ec6982288$var$alloc(size, fill, encoding) {
    $82a04c4ec6982288$var$assertSize(size);
    if (size <= 0) return $82a04c4ec6982288$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $82a04c4ec6982288$var$createBuffer(size).fill(fill, encoding) : $82a04c4ec6982288$var$createBuffer(size).fill(fill);
    return $82a04c4ec6982288$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $82a04c4ec6982288$var$Buffer.alloc = function(size, fill, encoding) {
    return $82a04c4ec6982288$var$alloc(size, fill, encoding);
};
function $82a04c4ec6982288$var$allocUnsafe(size) {
    $82a04c4ec6982288$var$assertSize(size);
    return $82a04c4ec6982288$var$createBuffer(size < 0 ? 0 : $82a04c4ec6982288$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $82a04c4ec6982288$var$Buffer.allocUnsafe = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $82a04c4ec6982288$var$Buffer.allocUnsafeSlow = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
function $82a04c4ec6982288$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $82a04c4ec6982288$var$byteLength(string, encoding) | 0;
    let buf = $82a04c4ec6982288$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $82a04c4ec6982288$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $82a04c4ec6982288$var$checked(array.length) | 0;
    const buf = $82a04c4ec6982288$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $82a04c4ec6982288$var$fromArrayView(arrayView) {
    if ($82a04c4ec6982288$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $82a04c4ec6982288$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $82a04c4ec6982288$var$fromArrayLike(arrayView);
}
function $82a04c4ec6982288$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
function $82a04c4ec6982288$var$fromObject(obj) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(obj)) {
        const len = $82a04c4ec6982288$var$checked(obj.length) | 0;
        const buf = $82a04c4ec6982288$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $82a04c4ec6982288$var$numberIsNaN(obj.length)) return $82a04c4ec6982288$var$createBuffer(0);
        return $82a04c4ec6982288$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $82a04c4ec6982288$var$fromArrayLike(obj.data);
}
function $82a04c4ec6982288$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $82a04c4ec6982288$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $82a04c4ec6982288$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $82a04c4ec6982288$var$Buffer.alloc(+length);
}
$82a04c4ec6982288$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $82a04c4ec6982288$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$82a04c4ec6982288$var$Buffer.compare = function compare(a, b) {
    if ($82a04c4ec6982288$var$isInstance(a, Uint8Array)) a = $82a04c4ec6982288$var$Buffer.from(a, a.offset, a.byteLength);
    if ($82a04c4ec6982288$var$isInstance(b, Uint8Array)) b = $82a04c4ec6982288$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(a) || !$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$82a04c4ec6982288$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$82a04c4ec6982288$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $82a04c4ec6982288$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $82a04c4ec6982288$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($82a04c4ec6982288$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) buf = $82a04c4ec6982288$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $82a04c4ec6982288$var$byteLength(string, encoding) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $82a04c4ec6982288$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $82a04c4ec6982288$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $82a04c4ec6982288$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $82a04c4ec6982288$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$82a04c4ec6982288$var$Buffer.byteLength = $82a04c4ec6982288$var$byteLength;
function $82a04c4ec6982288$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $82a04c4ec6982288$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $82a04c4ec6982288$var$utf8Slice(this, start, end);
        case "ascii":
            return $82a04c4ec6982288$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $82a04c4ec6982288$var$latin1Slice(this, start, end);
        case "base64":
            return $82a04c4ec6982288$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $82a04c4ec6982288$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$82a04c4ec6982288$var$Buffer.prototype._isBuffer = true;
function $82a04c4ec6982288$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$82a04c4ec6982288$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$82a04c4ec6982288$var$swap(this, i, i + 1);
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $82a04c4ec6982288$var$swap(this, i, i + 3);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $82a04c4ec6982288$var$swap(this, i, i + 7);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 6);
        $82a04c4ec6982288$var$swap(this, i + 2, i + 5);
        $82a04c4ec6982288$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $82a04c4ec6982288$var$utf8Slice(this, 0, length);
    return $82a04c4ec6982288$var$slowToString.apply(this, arguments);
};
$82a04c4ec6982288$var$Buffer.prototype.toLocaleString = $82a04c4ec6982288$var$Buffer.prototype.toString;
$82a04c4ec6982288$var$Buffer.prototype.equals = function equals(b) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $82a04c4ec6982288$var$Buffer.compare(this, b) === 0;
};
$82a04c4ec6982288$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $82a04c4ec6982288$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($82a04c4ec6982288$var$customInspectSymbol) $82a04c4ec6982288$var$Buffer.prototype[$82a04c4ec6982288$var$customInspectSymbol] = $82a04c4ec6982288$var$Buffer.prototype.inspect;
$82a04c4ec6982288$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($82a04c4ec6982288$var$isInstance(target, Uint8Array)) target = $82a04c4ec6982288$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $82a04c4ec6982288$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($82a04c4ec6982288$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $82a04c4ec6982288$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($82a04c4ec6982288$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $82a04c4ec6982288$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$82a04c4ec6982288$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$82a04c4ec6982288$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$82a04c4ec6982288$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $82a04c4ec6982288$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($82a04c4ec6982288$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $82a04c4ec6982288$var$utf8Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $82a04c4ec6982288$var$asciiWrite(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$asciiToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$base64Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$base64ToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$ucs2Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$82a04c4ec6982288$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $82a04c4ec6982288$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $82a04c4ec6982288$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $82a04c4ec6982288$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $82a04c4ec6982288$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $82a04c4ec6982288$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$82a04c4ec6982288$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $82a04c4ec6982288$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3nocJ.fromByteArray(buf);
    else return $3nocJ.fromByteArray(buf.slice(start, end));
}
function $82a04c4ec6982288$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $82a04c4ec6982288$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $82a04c4ec6982288$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $82a04c4ec6982288$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $82a04c4ec6982288$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $82a04c4ec6982288$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $82a04c4ec6982288$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $82a04c4ec6982288$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$82a04c4ec6982288$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $82a04c4ec6982288$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $82a04c4ec6982288$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$82a04c4ec6982288$var$Buffer.prototype.readUintLE = $82a04c4ec6982288$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUintBE = $82a04c4ec6982288$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint8 = $82a04c4ec6982288$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$82a04c4ec6982288$var$Buffer.prototype.readBigUInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$82a04c4ec6982288$var$Buffer.prototype.readBigUInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$82a04c4ec6982288$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$82a04c4ec6982288$var$Buffer.prototype.readBigInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$82a04c4ec6982288$var$Buffer.prototype.readBigInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$82a04c4ec6982288$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, true, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, false, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, true, 52, 8);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, false, 52, 8);
};
function $82a04c4ec6982288$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$82a04c4ec6982288$var$Buffer.prototype.writeUintLE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUintBE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint8 = $82a04c4ec6982288$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $82a04c4ec6982288$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $82a04c4ec6982288$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$82a04c4ec6982288$var$Buffer.prototype.writeBigUInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$82a04c4ec6982288$var$Buffer.prototype.writeBigUInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$82a04c4ec6982288$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeBigInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$82a04c4ec6982288$var$Buffer.prototype.writeBigInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $82a04c4ec6982288$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$82a04c4ec6982288$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, false, noAssert);
};
function $82a04c4ec6982288$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$82a04c4ec6982288$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$82a04c4ec6982288$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $82a04c4ec6982288$var$Buffer.isBuffer(val) ? val : $82a04c4ec6982288$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $82a04c4ec6982288$var$errors = {};
function $82a04c4ec6982288$var$E(sym, getMessage, Base) {
    $82a04c4ec6982288$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$82a04c4ec6982288$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$82a04c4ec6982288$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$82a04c4ec6982288$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $82a04c4ec6982288$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $82a04c4ec6982288$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $82a04c4ec6982288$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $82a04c4ec6982288$var$checkBounds(buf, offset, byteLength) {
    $82a04c4ec6982288$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $82a04c4ec6982288$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $82a04c4ec6982288$var$checkBounds(buf, offset, byteLength);
}
function $82a04c4ec6982288$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $82a04c4ec6982288$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $82a04c4ec6982288$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $82a04c4ec6982288$var$validateNumber(value, type);
        throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $82a04c4ec6982288$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $82a04c4ec6982288$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $82a04c4ec6982288$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($82a04c4ec6982288$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $82a04c4ec6982288$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $82a04c4ec6982288$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $82a04c4ec6982288$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $82a04c4ec6982288$var$base64ToBytes(str) {
    return $3nocJ.toByteArray($82a04c4ec6982288$var$base64clean(str));
}
function $82a04c4ec6982288$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $82a04c4ec6982288$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $82a04c4ec6982288$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $82a04c4ec6982288$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $82a04c4ec6982288$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $82a04c4ec6982288$var$BufferBigIntNotDefined : fn;
}
function $82a04c4ec6982288$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("3nocJ", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $27564b8a0078aa3d$export$d622b2ad8d90c771; }, function (v) { return $27564b8a0078aa3d$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $27564b8a0078aa3d$export$6100ba28696e12de; }, function (v) { return $27564b8a0078aa3d$export$6100ba28696e12de = v; });
var $27564b8a0078aa3d$export$a48f0734ac7c2329;
var $27564b8a0078aa3d$export$d622b2ad8d90c771;
var $27564b8a0078aa3d$export$6100ba28696e12de;
"use strict";
$27564b8a0078aa3d$export$a48f0734ac7c2329 = $27564b8a0078aa3d$var$byteLength;
$27564b8a0078aa3d$export$d622b2ad8d90c771 = $27564b8a0078aa3d$var$toByteArray;
$27564b8a0078aa3d$export$6100ba28696e12de = $27564b8a0078aa3d$var$fromByteArray;
var $27564b8a0078aa3d$var$lookup = [];
var $27564b8a0078aa3d$var$revLookup = [];
var $27564b8a0078aa3d$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $27564b8a0078aa3d$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $27564b8a0078aa3d$var$i = 0, $27564b8a0078aa3d$var$len = $27564b8a0078aa3d$var$code.length; $27564b8a0078aa3d$var$i < $27564b8a0078aa3d$var$len; ++$27564b8a0078aa3d$var$i){
    $27564b8a0078aa3d$var$lookup[$27564b8a0078aa3d$var$i] = $27564b8a0078aa3d$var$code[$27564b8a0078aa3d$var$i];
    $27564b8a0078aa3d$var$revLookup[$27564b8a0078aa3d$var$code.charCodeAt($27564b8a0078aa3d$var$i)] = $27564b8a0078aa3d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$27564b8a0078aa3d$var$revLookup["-".charCodeAt(0)] = 62;
$27564b8a0078aa3d$var$revLookup["_".charCodeAt(0)] = 63;
function $27564b8a0078aa3d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $27564b8a0078aa3d$var$byteLength(b64) {
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$toByteArray(b64) {
    var tmp;
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $27564b8a0078aa3d$var$Arr($27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 18 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 2 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 10 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $27564b8a0078aa3d$var$tripletToBase64(num) {
    return $27564b8a0078aa3d$var$lookup[num >> 18 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 12 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 6 & 0x3F] + $27564b8a0078aa3d$var$lookup[num & 0x3F];
}
function $27564b8a0078aa3d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($27564b8a0078aa3d$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $27564b8a0078aa3d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($27564b8a0078aa3d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 2] + $27564b8a0078aa3d$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 10] + $27564b8a0078aa3d$var$lookup[tmp >> 4 & 0x3F] + $27564b8a0078aa3d$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("gU9iR", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $c4e917b4c37bfab7$export$aafa59e2e03f2942; }, function (v) { return $c4e917b4c37bfab7$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $c4e917b4c37bfab7$export$68d8715fc104d294; }, function (v) { return $c4e917b4c37bfab7$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $c4e917b4c37bfab7$export$aafa59e2e03f2942;
var $c4e917b4c37bfab7$export$68d8715fc104d294;
$c4e917b4c37bfab7$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$c4e917b4c37bfab7$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("hvKlG", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $cbf948ca762bd5db$export$c7c5cef950a4d2fc; });

var $bBhOX = parcelRequire("bBhOX");

var $cMzsV = parcelRequire("cMzsV");
const $cbf948ca762bd5db$export$c7c5cef950a4d2fc = (input)=>typeof TextEncoder === "function" ? (0, $cMzsV.fromUtf8)(input) : (0, $bBhOX.fromUtf8)(input);
const $cbf948ca762bd5db$export$b4b216764bb846eb = (input)=>typeof TextDecoder === "function" ? (0, $cMzsV.toUtf8)(input) : (0, $bBhOX.toUtf8)(input);

});
parcelRegister("bBhOX", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $8720f94718fab5b6$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $8720f94718fab5b6$export$b4b216764bb846eb; });
const $8720f94718fab5b6$export$c7c5cef950a4d2fc = (input)=>{
    const bytes = [];
    for(let i = 0, len = input.length; i < len; i++){
        const value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            const surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
const $8720f94718fab5b6$export$b4b216764bb846eb = (input)=>{
    let decoded = "";
    for(let i = 0, len = input.length; i < len; i++){
        const byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            const nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            const surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            const encoded = "%" + surrogatePair.map((byteValue)=>byteValue.toString(16)).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRegister("cMzsV", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $94e57a6e206f0e63$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $94e57a6e206f0e63$export$b4b216764bb846eb; });
function $94e57a6e206f0e63$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $94e57a6e206f0e63$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});



parcelRegister("gW0Hw", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $c5429b5812080e93$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $c5429b5812080e93$var$isEmptyData;

});

parcelRegister("bnMPG", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numToUint8 = void 0;
function $8497b8d46ba6694e$var$numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
module.exports.numToUint8 = $8497b8d46ba6694e$var$numToUint8;

});

parcelRegister("fAKRQ", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function $b59e92b916401fd2$var$uint32ArrayFrom(a_lookUpTable) {
    if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length)return_array[a_index] = a_lookUpTable[a_index];
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
module.exports.uint32ArrayFrom = $b59e92b916401fd2$var$uint32ArrayFrom;

});



parcelRegister("adsYI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $770198bedaf11a30$export$2e2bcd8739ae039; });
function $770198bedaf11a30$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});

parcelRegister("7ccsP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $53d35279befda580$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $53d35279befda580$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $53d35279befda580$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $53d35279befda580$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $53d35279befda580$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $53d35279befda580$var$hasSymbols = function() {
    return typeof Symbol === "function";
};
var $53d35279befda580$var$hasSymbol = function(name) {
    return $53d35279befda580$var$hasSymbols() && Boolean(Symbol[name]);
};
var $53d35279befda580$var$getSymbol = function(name) {
    return $53d35279befda580$var$hasSymbol(name) ? Symbol[name] : "@@" + name;
};
if ($53d35279befda580$var$hasSymbols() && !$53d35279befda580$var$hasSymbol("observable")) Symbol.observable = Symbol("observable");
var $53d35279befda580$var$SymbolIterator = $53d35279befda580$var$getSymbol("iterator");
var $53d35279befda580$var$SymbolObservable = $53d35279befda580$var$getSymbol("observable");
var $53d35279befda580$var$SymbolSpecies = $53d35279befda580$var$getSymbol("species"); // === Abstract Operations ===
function $53d35279befda580$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== "function") throw new TypeError(value + " is not a function");
    return value;
}
function $53d35279befda580$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$53d35279befda580$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $53d35279befda580$var$Observable;
}
function $53d35279befda580$var$isObservable(x) {
    return x instanceof $53d35279befda580$var$Observable; // SPEC: Brand check
}
function $53d35279befda580$var$hostReportError(e) {
    if ($53d35279befda580$var$hostReportError.log) $53d35279befda580$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $53d35279befda580$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $53d35279befda580$var$hostReportError(e);
        }
    });
}
function $53d35279befda580$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === "function") cleanup();
        else {
            var unsubscribe = $53d35279befda580$var$getMethod(cleanup, "unsubscribe");
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $53d35279befda580$var$hostReportError(e);
    }
}
function $53d35279befda580$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = "closed";
}
function $53d35279befda580$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = "ready";
    for(var i = 0; i < queue.length; ++i){
        $53d35279befda580$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === "closed") break;
    }
}
function $53d35279befda580$var$notifySubscription(subscription, type, value) {
    subscription._state = "running";
    var observer = subscription._observer;
    try {
        var m = $53d35279befda580$var$getMethod(observer, type);
        switch(type){
            case "next":
                if (m) m.call(observer, value);
                break;
            case "error":
                $53d35279befda580$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case "complete":
                $53d35279befda580$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $53d35279befda580$var$hostReportError(e);
    }
    if (subscription._state === "closed") $53d35279befda580$var$cleanupSubscription(subscription);
    else if (subscription._state === "running") subscription._state = "ready";
}
function $53d35279befda580$var$onNotify(subscription, type, value) {
    if (subscription._state === "closed") return;
    if (subscription._state === "buffering") {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== "ready") {
        subscription._state = "buffering";
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $53d35279befda580$var$enqueue(function() {
            return $53d35279befda580$var$flushSubscription(subscription);
        });
        return;
    }
    $53d35279befda580$var$notifySubscription(subscription, type, value);
}
var $53d35279befda580$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $53d35279befda580$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = "initializing";
        var subscriptionObserver = new $53d35279befda580$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === "initializing") this._state = "ready";
    }
    $53d35279befda580$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== "closed") {
                    $53d35279befda580$var$closeSubscription(this);
                    $53d35279befda580$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === "closed";
            }
        }
    ]);
    return Subscription;
}();
var $53d35279befda580$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $53d35279befda580$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $53d35279befda580$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $53d35279befda580$var$onNotify(this._subscription, "next", value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $53d35279befda580$var$onNotify(this._subscription, "error", value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $53d35279befda580$var$onNotify(this._subscription, "complete");
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === "closed";
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $53d35279befda580$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $53d35279befda580$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError("Observable cannot be called as a function");
        if (typeof subscriber !== "function") throw new TypeError("Observable initializer must be a function");
        this._subscriber = subscriber;
    }
    $53d35279befda580$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $53d35279befda580$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== "function") {
                        reject(new TypeError(fn + " is not a function"));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = $53d35279befda580$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = $53d35279befda580$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = $53d35279befda580$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError("Cannot reduce an empty sequence"));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $53d35279befda580$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = $53d35279befda580$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $53d35279befda580$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === "function" ? this : Observable;
                if (x == null) throw new TypeError(x + " is not an object");
                var method = $53d35279befda580$var$getMethod(x, $53d35279befda580$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + " is not an object");
                    if ($53d35279befda580$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($53d35279befda580$var$hasSymbol("iterator")) {
                    method = $53d35279befda580$var$getMethod(x, $53d35279befda580$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $53d35279befda580$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $53d35279befda580$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + " is not observable");
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === "function" ? this : Observable;
                return new C(function(observer) {
                    $53d35279befda580$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $53d35279befda580$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $53d35279befda580$var$Observable;
if ($53d35279befda580$var$hasSymbols()) Object.defineProperty($53d35279befda580$var$Observable, Symbol("extensions"), {
    value: {
        symbol: $53d35279befda580$var$SymbolObservable,
        hostReportError: $53d35279befda580$var$hostReportError
    },
    configurable: true
});

});

parcelRegister("3oWWu", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $27a155bcdd967657$export$2b8d127b894957b9; }, function (v) { return $27a155bcdd967657$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $27a155bcdd967657$export$cea3a54a6425200c; }, function (v) { return $27a155bcdd967657$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $27a155bcdd967657$export$a7c73072b1a182ae; }, function (v) { return $27a155bcdd967657$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $27a155bcdd967657$export$9f27bc3417b4524d; }, function (v) { return $27a155bcdd967657$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $27a155bcdd967657$export$db77ccec0bb4ccac; }, function (v) { return $27a155bcdd967657$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $27a155bcdd967657$export$8392c0c9d3dcbd35; }, function (v) { return $27a155bcdd967657$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $27a155bcdd967657$export$ffb0004e005737fa; }, function (v) { return $27a155bcdd967657$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $27a155bcdd967657$export$b624eff549462981; }, function (v) { return $27a155bcdd967657$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $27a155bcdd967657$export$7897aa7841a5380c; }, function (v) { return $27a155bcdd967657$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $27a155bcdd967657$export$602eac185826482c; }, function (v) { return $27a155bcdd967657$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $27a155bcdd967657$export$e2c29f18771995cb; }, function (v) { return $27a155bcdd967657$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $27a155bcdd967657$export$5f8d39834fd61797; }, function (v) { return $27a155bcdd967657$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $27a155bcdd967657$export$74bf444e3cd11ea5; }, function (v) { return $27a155bcdd967657$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $27a155bcdd967657$export$92387174baf9b227; }, function (v) { return $27a155bcdd967657$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $27a155bcdd967657$export$ec112efeb987d9c6; }, function (v) { return $27a155bcdd967657$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $27a155bcdd967657$export$b706b080d889d2c9; }, function (v) { return $27a155bcdd967657$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $27a155bcdd967657$export$5be5a87408f70ddc; }, function (v) { return $27a155bcdd967657$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $27a155bcdd967657$export$45a5e7f76e0caa8d; }, function (v) { return $27a155bcdd967657$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $27a155bcdd967657$export$455c2e768291efa6; }, function (v) { return $27a155bcdd967657$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $27a155bcdd967657$export$9522e17588c12572; }, function (v) { return $27a155bcdd967657$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $27a155bcdd967657$export$2110ac352bb060b9; }, function (v) { return $27a155bcdd967657$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $27a155bcdd967657$export$56885ab8b9c456ab; }, function (v) { return $27a155bcdd967657$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $27a155bcdd967657$export$d927fcb6adf8f9de; }, function (v) { return $27a155bcdd967657$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $27a155bcdd967657$export$b82d16f27459e05a; }, function (v) { return $27a155bcdd967657$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $27a155bcdd967657$export$522c17b4f5e123e8; }, function (v) { return $27a155bcdd967657$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $27a155bcdd967657$export$1aabd8a0274ecfd6; }, function (v) { return $27a155bcdd967657$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $27a155bcdd967657$export$9b621391a187a31a; }, function (v) { return $27a155bcdd967657$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $27a155bcdd967657$export$f5bbd400c2f4426f; }, function (v) { return $27a155bcdd967657$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $27a155bcdd967657$export$2b8d127b894957b9;
var $27a155bcdd967657$export$cea3a54a6425200c;
var $27a155bcdd967657$export$a7c73072b1a182ae;
var $27a155bcdd967657$export$9f27bc3417b4524d;
var $27a155bcdd967657$export$db77ccec0bb4ccac;
var $27a155bcdd967657$export$8392c0c9d3dcbd35;
var $27a155bcdd967657$export$ffb0004e005737fa;
var $27a155bcdd967657$export$b624eff549462981;
var $27a155bcdd967657$export$7897aa7841a5380c;
var $27a155bcdd967657$export$602eac185826482c;
var $27a155bcdd967657$export$e2c29f18771995cb;
var $27a155bcdd967657$export$5f8d39834fd61797;
var $27a155bcdd967657$export$74bf444e3cd11ea5;
var $27a155bcdd967657$export$92387174baf9b227;
var $27a155bcdd967657$export$ec112efeb987d9c6;
var $27a155bcdd967657$export$b706b080d889d2c9;
var $27a155bcdd967657$export$5be5a87408f70ddc;
var $27a155bcdd967657$export$45a5e7f76e0caa8d;
var $27a155bcdd967657$export$455c2e768291efa6;
var $27a155bcdd967657$export$9522e17588c12572;
var $27a155bcdd967657$export$2110ac352bb060b9;
var $27a155bcdd967657$export$56885ab8b9c456ab;
var $27a155bcdd967657$export$d927fcb6adf8f9de;
var $27a155bcdd967657$export$b82d16f27459e05a;
var $27a155bcdd967657$export$522c17b4f5e123e8;
var $27a155bcdd967657$export$1aabd8a0274ecfd6;
var $27a155bcdd967657$export$9b621391a187a31a;
var $27a155bcdd967657$export$f5bbd400c2f4426f;
"use strict";
var $27a155bcdd967657$var$b = "function" === typeof Symbol && Symbol.for, $27a155bcdd967657$var$c = $27a155bcdd967657$var$b ? Symbol.for("react.element") : 60103, $27a155bcdd967657$var$d = $27a155bcdd967657$var$b ? Symbol.for("react.portal") : 60106, $27a155bcdd967657$var$e = $27a155bcdd967657$var$b ? Symbol.for("react.fragment") : 60107, $27a155bcdd967657$var$f = $27a155bcdd967657$var$b ? Symbol.for("react.strict_mode") : 60108, $27a155bcdd967657$var$g = $27a155bcdd967657$var$b ? Symbol.for("react.profiler") : 60114, $27a155bcdd967657$var$h = $27a155bcdd967657$var$b ? Symbol.for("react.provider") : 60109, $27a155bcdd967657$var$k = $27a155bcdd967657$var$b ? Symbol.for("react.context") : 60110, $27a155bcdd967657$var$l = $27a155bcdd967657$var$b ? Symbol.for("react.async_mode") : 60111, $27a155bcdd967657$var$m = $27a155bcdd967657$var$b ? Symbol.for("react.concurrent_mode") : 60111, $27a155bcdd967657$var$n = $27a155bcdd967657$var$b ? Symbol.for("react.forward_ref") : 60112, $27a155bcdd967657$var$p = $27a155bcdd967657$var$b ? Symbol.for("react.suspense") : 60113, $27a155bcdd967657$var$q = $27a155bcdd967657$var$b ? Symbol.for("react.suspense_list") : 60120, $27a155bcdd967657$var$r = $27a155bcdd967657$var$b ? Symbol.for("react.memo") : 60115, $27a155bcdd967657$var$t = $27a155bcdd967657$var$b ? Symbol.for("react.lazy") : 60116, $27a155bcdd967657$var$v = $27a155bcdd967657$var$b ? Symbol.for("react.block") : 60121, $27a155bcdd967657$var$w = $27a155bcdd967657$var$b ? Symbol.for("react.fundamental") : 60117, $27a155bcdd967657$var$x = $27a155bcdd967657$var$b ? Symbol.for("react.responder") : 60118, $27a155bcdd967657$var$y = $27a155bcdd967657$var$b ? Symbol.for("react.scope") : 60119;
function $27a155bcdd967657$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $27a155bcdd967657$var$c:
                switch(a = a.type, a){
                    case $27a155bcdd967657$var$l:
                    case $27a155bcdd967657$var$m:
                    case $27a155bcdd967657$var$e:
                    case $27a155bcdd967657$var$g:
                    case $27a155bcdd967657$var$f:
                    case $27a155bcdd967657$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $27a155bcdd967657$var$k:
                            case $27a155bcdd967657$var$n:
                            case $27a155bcdd967657$var$t:
                            case $27a155bcdd967657$var$r:
                            case $27a155bcdd967657$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $27a155bcdd967657$var$d:
                return u;
        }
    }
}
function $27a155bcdd967657$var$A(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$m;
}
$27a155bcdd967657$export$2b8d127b894957b9 = $27a155bcdd967657$var$l;
$27a155bcdd967657$export$cea3a54a6425200c = $27a155bcdd967657$var$m;
$27a155bcdd967657$export$a7c73072b1a182ae = $27a155bcdd967657$var$k;
$27a155bcdd967657$export$9f27bc3417b4524d = $27a155bcdd967657$var$h;
$27a155bcdd967657$export$db77ccec0bb4ccac = $27a155bcdd967657$var$c;
$27a155bcdd967657$export$8392c0c9d3dcbd35 = $27a155bcdd967657$var$n;
$27a155bcdd967657$export$ffb0004e005737fa = $27a155bcdd967657$var$e;
$27a155bcdd967657$export$b624eff549462981 = $27a155bcdd967657$var$t;
$27a155bcdd967657$export$7897aa7841a5380c = $27a155bcdd967657$var$r;
$27a155bcdd967657$export$602eac185826482c = $27a155bcdd967657$var$d;
$27a155bcdd967657$export$e2c29f18771995cb = $27a155bcdd967657$var$g;
$27a155bcdd967657$export$5f8d39834fd61797 = $27a155bcdd967657$var$f;
$27a155bcdd967657$export$74bf444e3cd11ea5 = $27a155bcdd967657$var$p;
$27a155bcdd967657$export$92387174baf9b227 = function(a) {
    return $27a155bcdd967657$var$A(a) || $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$l;
};
$27a155bcdd967657$export$ec112efeb987d9c6 = $27a155bcdd967657$var$A;
$27a155bcdd967657$export$b706b080d889d2c9 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$k;
};
$27a155bcdd967657$export$5be5a87408f70ddc = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$h;
};
$27a155bcdd967657$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $27a155bcdd967657$var$c;
};
$27a155bcdd967657$export$455c2e768291efa6 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$n;
};
$27a155bcdd967657$export$9522e17588c12572 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$e;
};
$27a155bcdd967657$export$2110ac352bb060b9 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$t;
};
$27a155bcdd967657$export$56885ab8b9c456ab = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$r;
};
$27a155bcdd967657$export$d927fcb6adf8f9de = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$d;
};
$27a155bcdd967657$export$b82d16f27459e05a = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$g;
};
$27a155bcdd967657$export$522c17b4f5e123e8 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$f;
};
$27a155bcdd967657$export$1aabd8a0274ecfd6 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$p;
};
$27a155bcdd967657$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $27a155bcdd967657$var$e || a === $27a155bcdd967657$var$m || a === $27a155bcdd967657$var$g || a === $27a155bcdd967657$var$f || a === $27a155bcdd967657$var$p || a === $27a155bcdd967657$var$q || "object" === typeof a && null !== a && (a.$$typeof === $27a155bcdd967657$var$t || a.$$typeof === $27a155bcdd967657$var$r || a.$$typeof === $27a155bcdd967657$var$h || a.$$typeof === $27a155bcdd967657$var$k || a.$$typeof === $27a155bcdd967657$var$n || a.$$typeof === $27a155bcdd967657$var$w || a.$$typeof === $27a155bcdd967657$var$x || a.$$typeof === $27a155bcdd967657$var$y || a.$$typeof === $27a155bcdd967657$var$v);
};
$27a155bcdd967657$export$f5bbd400c2f4426f = $27a155bcdd967657$var$z;

});

parcelRegister("iDep4", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $7KQqJ = parcelRequire("7KQqJ");
function $d9070abd96403449$var$emptyFunction() {}
function $d9070abd96403449$var$emptyFunctionWithReset() {}
$d9070abd96403449$var$emptyFunctionWithReset.resetWarningCache = $d9070abd96403449$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7KQqJ) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d9070abd96403449$var$emptyFunctionWithReset,
        resetWarningCache: $d9070abd96403449$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("7KQqJ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $5a557fcd99e4c0a9$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $5a557fcd99e4c0a9$var$ReactPropTypesSecret;

});


parcelRegister("2nzLi", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1bb9784afa87e369$export$ffb0004e005737fa; }, function (v) { return $1bb9784afa87e369$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1bb9784afa87e369$export$34b9dba7ce09269b; }, function (v) { return $1bb9784afa87e369$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1bb9784afa87e369$export$25062201e9e25d76; }, function (v) { return $1bb9784afa87e369$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bb9784afa87e369$export$ffb0004e005737fa;
var $1bb9784afa87e369$export$34b9dba7ce09269b;
var $1bb9784afa87e369$export$25062201e9e25d76;
"use strict";

var $7fPBF = parcelRequire("7fPBF");
var $1bb9784afa87e369$var$k = Symbol.for("react.element"), $1bb9784afa87e369$var$l = Symbol.for("react.fragment"), $1bb9784afa87e369$var$m = Object.prototype.hasOwnProperty, $1bb9784afa87e369$var$n = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1bb9784afa87e369$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1bb9784afa87e369$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$1bb9784afa87e369$var$m.call(a, b) && !$1bb9784afa87e369$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1bb9784afa87e369$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $1bb9784afa87e369$var$n.current
    };
}
$1bb9784afa87e369$export$ffb0004e005737fa = $1bb9784afa87e369$var$l;
$1bb9784afa87e369$export$34b9dba7ce09269b = $1bb9784afa87e369$var$q;
$1bb9784afa87e369$export$25062201e9e25d76 = $1bb9784afa87e369$var$q;

});

parcelRegister("45MkT", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $2fad1f91101d4119$export$a7c73072b1a182ae; }, function (v) { return $2fad1f91101d4119$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $2fad1f91101d4119$export$9f27bc3417b4524d; }, function (v) { return $2fad1f91101d4119$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $2fad1f91101d4119$export$db77ccec0bb4ccac; }, function (v) { return $2fad1f91101d4119$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $2fad1f91101d4119$export$8392c0c9d3dcbd35; }, function (v) { return $2fad1f91101d4119$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $2fad1f91101d4119$export$ffb0004e005737fa; }, function (v) { return $2fad1f91101d4119$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $2fad1f91101d4119$export$b624eff549462981; }, function (v) { return $2fad1f91101d4119$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $2fad1f91101d4119$export$7897aa7841a5380c; }, function (v) { return $2fad1f91101d4119$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $2fad1f91101d4119$export$602eac185826482c; }, function (v) { return $2fad1f91101d4119$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $2fad1f91101d4119$export$e2c29f18771995cb; }, function (v) { return $2fad1f91101d4119$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $2fad1f91101d4119$export$5f8d39834fd61797; }, function (v) { return $2fad1f91101d4119$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $2fad1f91101d4119$export$74bf444e3cd11ea5; }, function (v) { return $2fad1f91101d4119$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $2fad1f91101d4119$export$998bcd577473dd93; }, function (v) { return $2fad1f91101d4119$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $2fad1f91101d4119$export$92387174baf9b227; }, function (v) { return $2fad1f91101d4119$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $2fad1f91101d4119$export$ec112efeb987d9c6; }, function (v) { return $2fad1f91101d4119$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $2fad1f91101d4119$export$b706b080d889d2c9; }, function (v) { return $2fad1f91101d4119$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $2fad1f91101d4119$export$5be5a87408f70ddc; }, function (v) { return $2fad1f91101d4119$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $2fad1f91101d4119$export$45a5e7f76e0caa8d; }, function (v) { return $2fad1f91101d4119$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $2fad1f91101d4119$export$455c2e768291efa6; }, function (v) { return $2fad1f91101d4119$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $2fad1f91101d4119$export$9522e17588c12572; }, function (v) { return $2fad1f91101d4119$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $2fad1f91101d4119$export$2110ac352bb060b9; }, function (v) { return $2fad1f91101d4119$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $2fad1f91101d4119$export$56885ab8b9c456ab; }, function (v) { return $2fad1f91101d4119$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $2fad1f91101d4119$export$d927fcb6adf8f9de; }, function (v) { return $2fad1f91101d4119$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $2fad1f91101d4119$export$b82d16f27459e05a; }, function (v) { return $2fad1f91101d4119$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $2fad1f91101d4119$export$522c17b4f5e123e8; }, function (v) { return $2fad1f91101d4119$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $2fad1f91101d4119$export$1aabd8a0274ecfd6; }, function (v) { return $2fad1f91101d4119$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $2fad1f91101d4119$export$3d6c20d97e46b957; }, function (v) { return $2fad1f91101d4119$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $2fad1f91101d4119$export$9b621391a187a31a; }, function (v) { return $2fad1f91101d4119$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $2fad1f91101d4119$export$f5bbd400c2f4426f; }, function (v) { return $2fad1f91101d4119$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2fad1f91101d4119$export$a7c73072b1a182ae;
var $2fad1f91101d4119$export$9f27bc3417b4524d;
var $2fad1f91101d4119$export$db77ccec0bb4ccac;
var $2fad1f91101d4119$export$8392c0c9d3dcbd35;
var $2fad1f91101d4119$export$ffb0004e005737fa;
var $2fad1f91101d4119$export$b624eff549462981;
var $2fad1f91101d4119$export$7897aa7841a5380c;
var $2fad1f91101d4119$export$602eac185826482c;
var $2fad1f91101d4119$export$e2c29f18771995cb;
var $2fad1f91101d4119$export$5f8d39834fd61797;
var $2fad1f91101d4119$export$74bf444e3cd11ea5;
var $2fad1f91101d4119$export$998bcd577473dd93;
var $2fad1f91101d4119$export$92387174baf9b227;
var $2fad1f91101d4119$export$ec112efeb987d9c6;
var $2fad1f91101d4119$export$b706b080d889d2c9;
var $2fad1f91101d4119$export$5be5a87408f70ddc;
var $2fad1f91101d4119$export$45a5e7f76e0caa8d;
var $2fad1f91101d4119$export$455c2e768291efa6;
var $2fad1f91101d4119$export$9522e17588c12572;
var $2fad1f91101d4119$export$2110ac352bb060b9;
var $2fad1f91101d4119$export$56885ab8b9c456ab;
var $2fad1f91101d4119$export$d927fcb6adf8f9de;
var $2fad1f91101d4119$export$b82d16f27459e05a;
var $2fad1f91101d4119$export$522c17b4f5e123e8;
var $2fad1f91101d4119$export$1aabd8a0274ecfd6;
var $2fad1f91101d4119$export$3d6c20d97e46b957;
var $2fad1f91101d4119$export$9b621391a187a31a;
var $2fad1f91101d4119$export$f5bbd400c2f4426f;
"use strict";
var $2fad1f91101d4119$var$b = Symbol.for("react.element"), $2fad1f91101d4119$var$c = Symbol.for("react.portal"), $2fad1f91101d4119$var$d = Symbol.for("react.fragment"), $2fad1f91101d4119$var$e = Symbol.for("react.strict_mode"), $2fad1f91101d4119$var$f = Symbol.for("react.profiler"), $2fad1f91101d4119$var$g = Symbol.for("react.provider"), $2fad1f91101d4119$var$h = Symbol.for("react.context"), $2fad1f91101d4119$var$k = Symbol.for("react.server_context"), $2fad1f91101d4119$var$l = Symbol.for("react.forward_ref"), $2fad1f91101d4119$var$m = Symbol.for("react.suspense"), $2fad1f91101d4119$var$n = Symbol.for("react.suspense_list"), $2fad1f91101d4119$var$p = Symbol.for("react.memo"), $2fad1f91101d4119$var$q = Symbol.for("react.lazy"), $2fad1f91101d4119$var$t = Symbol.for("react.offscreen"), $2fad1f91101d4119$var$u;
$2fad1f91101d4119$var$u = Symbol.for("react.module.reference");
function $2fad1f91101d4119$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $2fad1f91101d4119$var$b:
                switch(a = a.type, a){
                    case $2fad1f91101d4119$var$d:
                    case $2fad1f91101d4119$var$f:
                    case $2fad1f91101d4119$var$e:
                    case $2fad1f91101d4119$var$m:
                    case $2fad1f91101d4119$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2fad1f91101d4119$var$k:
                            case $2fad1f91101d4119$var$h:
                            case $2fad1f91101d4119$var$l:
                            case $2fad1f91101d4119$var$q:
                            case $2fad1f91101d4119$var$p:
                            case $2fad1f91101d4119$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $2fad1f91101d4119$var$c:
                return r;
        }
    }
}
$2fad1f91101d4119$export$a7c73072b1a182ae = $2fad1f91101d4119$var$h;
$2fad1f91101d4119$export$9f27bc3417b4524d = $2fad1f91101d4119$var$g;
$2fad1f91101d4119$export$db77ccec0bb4ccac = $2fad1f91101d4119$var$b;
$2fad1f91101d4119$export$8392c0c9d3dcbd35 = $2fad1f91101d4119$var$l;
$2fad1f91101d4119$export$ffb0004e005737fa = $2fad1f91101d4119$var$d;
$2fad1f91101d4119$export$b624eff549462981 = $2fad1f91101d4119$var$q;
$2fad1f91101d4119$export$7897aa7841a5380c = $2fad1f91101d4119$var$p;
$2fad1f91101d4119$export$602eac185826482c = $2fad1f91101d4119$var$c;
$2fad1f91101d4119$export$e2c29f18771995cb = $2fad1f91101d4119$var$f;
$2fad1f91101d4119$export$5f8d39834fd61797 = $2fad1f91101d4119$var$e;
$2fad1f91101d4119$export$74bf444e3cd11ea5 = $2fad1f91101d4119$var$m;
$2fad1f91101d4119$export$998bcd577473dd93 = $2fad1f91101d4119$var$n;
$2fad1f91101d4119$export$92387174baf9b227 = function() {
    return !1;
};
$2fad1f91101d4119$export$ec112efeb987d9c6 = function() {
    return !1;
};
$2fad1f91101d4119$export$b706b080d889d2c9 = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$h;
};
$2fad1f91101d4119$export$5be5a87408f70ddc = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$g;
};
$2fad1f91101d4119$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2fad1f91101d4119$var$b;
};
$2fad1f91101d4119$export$455c2e768291efa6 = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$l;
};
$2fad1f91101d4119$export$9522e17588c12572 = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$d;
};
$2fad1f91101d4119$export$2110ac352bb060b9 = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$q;
};
$2fad1f91101d4119$export$56885ab8b9c456ab = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$p;
};
$2fad1f91101d4119$export$d927fcb6adf8f9de = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$c;
};
$2fad1f91101d4119$export$b82d16f27459e05a = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$f;
};
$2fad1f91101d4119$export$522c17b4f5e123e8 = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$e;
};
$2fad1f91101d4119$export$1aabd8a0274ecfd6 = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$m;
};
$2fad1f91101d4119$export$3d6c20d97e46b957 = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$n;
};
$2fad1f91101d4119$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2fad1f91101d4119$var$d || a === $2fad1f91101d4119$var$f || a === $2fad1f91101d4119$var$e || a === $2fad1f91101d4119$var$m || a === $2fad1f91101d4119$var$n || a === $2fad1f91101d4119$var$t || "object" === typeof a && null !== a && (a.$$typeof === $2fad1f91101d4119$var$q || a.$$typeof === $2fad1f91101d4119$var$p || a.$$typeof === $2fad1f91101d4119$var$g || a.$$typeof === $2fad1f91101d4119$var$h || a.$$typeof === $2fad1f91101d4119$var$l || a.$$typeof === $2fad1f91101d4119$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$2fad1f91101d4119$export$f5bbd400c2f4426f = $2fad1f91101d4119$var$v;

});

parcelRegister("3xowt", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6PKLM.default;
    }
});

var $6PKLM = parcelRequire("6PKLM");

});
parcelRegister("6PKLM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f9bc8f83648f682$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $freJ2 = parcelRequire("freJ2");

var $bbzbN = parcelRequire("bbzbN");
"use client";
function $4f9bc8f83648f682$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $freJ2.default), (0, $kY3Ke.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $freJ2.default).muiName;
    return /*#__PURE__*/ $7fPBF.memo(/*#__PURE__*/ $7fPBF.forwardRef(Component));
}

});
parcelRegister("kY3Ke", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f43c50d92a19d876$export$2e2bcd8739ae039; });
function $f43c50d92a19d876$export$2e2bcd8739ae039() {
    $f43c50d92a19d876$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f43c50d92a19d876$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("freJ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3d4ccc5f426d62a$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $b6UUh = parcelRequire("b6UUh");

var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $6VWZo = parcelRequire("6VWZo");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $b3d4ccc5f426d62a$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $b3d4ccc5f426d62a$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $b6UUh.default)(color)}`,
            `fontSize${(0, $b6UUh.default)(fontSize)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $6VWZo.getSvgIconUtilityClass), classes);
};
const $b3d4ccc5f426d62a$var$SvgIconRoot = (0, $kDBhE.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $b6UUh.default)(ownerState.color)}`],
            styles[`fontSize${(0, $b6UUh.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // e.g. heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $b3d4ccc5f426d62a$var$SvgIcon = /*#__PURE__*/ $7fPBF.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $cFLic.default)(props, $b3d4ccc5f426d62a$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $7fPBF.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $b3d4ccc5f426d62a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($b3d4ccc5f426d62a$var$SvgIconRoot, (0, $kY3Ke.default)({
        as: component,
        className: (0, $hngXp.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $bbzbN.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$b3d4ccc5f426d62a$var$SvgIcon.muiName = "SvgIcon";
var $b3d4ccc5f426d62a$export$2e2bcd8739ae039 = $b3d4ccc5f426d62a$var$SvgIcon;

});
parcelRegister("cFLic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $939dffaddf93a85b$export$2e2bcd8739ae039; });
function $939dffaddf93a85b$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("hngXp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07a883fe7c352c85$export$2e2bcd8739ae039; });
function $07a883fe7c352c85$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $07a883fe7c352c85$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $07a883fe7c352c85$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $07a883fe7c352c85$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $07a883fe7c352c85$export$2e2bcd8739ae039 = $07a883fe7c352c85$export$4f5d2d50c9deca37;

});

parcelRegister("cFCqu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93971f0806345477$export$2e2bcd8739ae039; });
function $93971f0806345477$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRegister("b6UUh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $816c65c0e1f7082c$export$2e2bcd8739ae039; });

var $iCiVn = parcelRequire("iCiVn");
var $816c65c0e1f7082c$export$2e2bcd8739ae039 = (0, $iCiVn.default);

});
parcelRegister("iCiVn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8da749d88f71122$export$2e2bcd8739ae039; });

var $e5zLi = parcelRequire("e5zLi");
function $d8da749d88f71122$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $e5zLi.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("e5zLi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a41d45db477219b9$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $a41d45db477219b9$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRegister("5j2OD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3dd0e9417d40119e$export$2e2bcd8739ae039; });

var $9HPC7 = parcelRequire("9HPC7");

var $9P91Y = parcelRequire("9P91Y");

var $jwhZE = parcelRequire("jwhZE");
"use client";
function $3dd0e9417d40119e$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $9HPC7.default)({
        props: props,
        name: name,
        defaultTheme: $9P91Y.default,
        themeId: (0, $jwhZE.default)
    });
}

});
parcelRegister("9HPC7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71102aa90e2b2620$export$2e2bcd8739ae039; });

var $38WAi = parcelRequire("38WAi");

var $4kWyf = parcelRequire("4kWyf");
"use client";
function $71102aa90e2b2620$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $4kWyf.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $38WAi.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRegister("38WAi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $249f9015c4a2303b$export$2e2bcd8739ae039; });

var $aNaIu = parcelRequire("aNaIu");
function $249f9015c4a2303b$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $aNaIu.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("aNaIu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7db6cb11f5bc6e76$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
function $7db6cb11f5bc6e76$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $kY3Ke.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $kY3Ke.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $kY3Ke.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $7db6cb11f5bc6e76$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRegister("4kWyf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $328672c8d07e1c59$export$2e2bcd8739ae039; });

var $2G6xE = parcelRequire("2G6xE");

var $84PRT = parcelRequire("84PRT");
"use client";
const $328672c8d07e1c59$export$35e57303dbd8a66 = (0, $2G6xE.default)();
function $328672c8d07e1c59$var$useTheme(defaultTheme = $328672c8d07e1c59$export$35e57303dbd8a66) {
    return (0, $84PRT.default)(defaultTheme);
}
var $328672c8d07e1c59$export$2e2bcd8739ae039 = $328672c8d07e1c59$var$useTheme;

});
parcelRegister("2G6xE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f34940f58017e5f$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $dYkRa = parcelRequire("dYkRa");

var $iZrRs = parcelRequire("iZrRs");

var $l8Cag = parcelRequire("l8Cag");

var $GLqnW = parcelRequire("GLqnW");

var $8M6a3 = parcelRequire("8M6a3");

var $hXGiu = parcelRequire("hXGiu");
const $1f34940f58017e5f$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $1f34940f58017e5f$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $cFLic.default)(options, $1f34940f58017e5f$var$_excluded);
    const breakpoints = (0, $iZrRs.default)(breakpointsInput);
    const spacing = (0, $GLqnW.default)(spacingInput);
    let muiTheme = (0, $dYkRa.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $kY3Ke.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $kY3Ke.default)({}, (0, $l8Cag.default), shapeInput)
    }, other);
    muiTheme = args.reduce((acc, argument)=>(0, $dYkRa.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $kY3Ke.default)({}, (0, $hXGiu.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $8M6a3.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $1f34940f58017e5f$export$2e2bcd8739ae039 = $1f34940f58017e5f$var$createTheme;

});
parcelRegister("dYkRa", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $a2c10ea133da1790$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $a2c10ea133da1790$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
function $a2c10ea133da1790$export$53b83ca8eaab0383(item) {
    return item !== null && typeof item === "object" && item.constructor === Object;
}
function $a2c10ea133da1790$var$deepClone(source) {
    if (!$a2c10ea133da1790$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $a2c10ea133da1790$var$deepClone(source[key]);
    });
    return output;
}
function $a2c10ea133da1790$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $kY3Ke.default)({}, target) : target;
    if ($a2c10ea133da1790$export$53b83ca8eaab0383(target) && $a2c10ea133da1790$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($a2c10ea133da1790$export$53b83ca8eaab0383(source[key]) && key in target && $a2c10ea133da1790$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $a2c10ea133da1790$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $a2c10ea133da1790$export$53b83ca8eaab0383(source[key]) ? $a2c10ea133da1790$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("iZrRs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd33892704fa9f8b$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
const $dd33892704fa9f8b$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $dd33892704fa9f8b$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $dd33892704fa9f8b$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $kY3Ke.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $dd33892704fa9f8b$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $cFLic.default)(breakpoints, $dd33892704fa9f8b$var$_excluded);
    const sortedValues = $dd33892704fa9f8b$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $kY3Ke.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("l8Cag", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f637f3037d6dee04$export$2e2bcd8739ae039; });
const $f637f3037d6dee04$var$shape = {
    borderRadius: 4
};
var $f637f3037d6dee04$export$2e2bcd8739ae039 = $f637f3037d6dee04$var$shape;

});

parcelRegister("GLqnW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0808b5e3ab0ab6d4$export$2e2bcd8739ae039; });

var $5z69T = parcelRequire("5z69T");
function $0808b5e3ab0ab6d4$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $5z69T.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("5z69T", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $40d4ff9e66a5531b$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $40d4ff9e66a5531b$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $40d4ff9e66a5531b$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $40d4ff9e66a5531b$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $40d4ff9e66a5531b$export$6f98e8eaf0be1996; });


var $cvrkU = parcelRequire("cvrkU");

var $190Wm = parcelRequire("190Wm");

var $4So0q = parcelRequire("4So0q");

var $dMDTp = parcelRequire("dMDTp");
const $40d4ff9e66a5531b$var$properties = {
    m: "margin",
    p: "padding"
};
const $40d4ff9e66a5531b$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $40d4ff9e66a5531b$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $40d4ff9e66a5531b$var$getCssProperties = (0, $dMDTp.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($40d4ff9e66a5531b$var$aliases[prop]) prop = $40d4ff9e66a5531b$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $40d4ff9e66a5531b$var$properties[a];
    const direction = $40d4ff9e66a5531b$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $40d4ff9e66a5531b$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $40d4ff9e66a5531b$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $40d4ff9e66a5531b$var$spacingKeys = [
    ...$40d4ff9e66a5531b$export$aab52a0dde05ad8a,
    ...$40d4ff9e66a5531b$export$f8397d44f03ab6ad
];
function $40d4ff9e66a5531b$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $190Wm.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $40d4ff9e66a5531b$export$1def6f833384e3d1(theme) {
    return $40d4ff9e66a5531b$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $40d4ff9e66a5531b$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $40d4ff9e66a5531b$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $40d4ff9e66a5531b$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $40d4ff9e66a5531b$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $40d4ff9e66a5531b$var$getCssProperties(prop);
    const styleFromPropValue = $40d4ff9e66a5531b$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $cvrkU.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $40d4ff9e66a5531b$var$style(props, keys) {
    const transformer = $40d4ff9e66a5531b$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$40d4ff9e66a5531b$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $4So0q.default), {});
}
function $40d4ff9e66a5531b$export$7ede87f9b603dd3c(props) {
    return $40d4ff9e66a5531b$var$style(props, $40d4ff9e66a5531b$export$aab52a0dde05ad8a);
}
$40d4ff9e66a5531b$export$7ede87f9b603dd3c.propTypes = {};
$40d4ff9e66a5531b$export$7ede87f9b603dd3c.filterProps = $40d4ff9e66a5531b$export$aab52a0dde05ad8a;
function $40d4ff9e66a5531b$export$6f98e8eaf0be1996(props) {
    return $40d4ff9e66a5531b$var$style(props, $40d4ff9e66a5531b$export$f8397d44f03ab6ad);
}
$40d4ff9e66a5531b$export$6f98e8eaf0be1996.propTypes = {};
$40d4ff9e66a5531b$export$6f98e8eaf0be1996.filterProps = $40d4ff9e66a5531b$export$f8397d44f03ab6ad;
function $40d4ff9e66a5531b$var$spacing(props) {
    return $40d4ff9e66a5531b$var$style(props, $40d4ff9e66a5531b$var$spacingKeys);
}
$40d4ff9e66a5531b$var$spacing.propTypes = {};
$40d4ff9e66a5531b$var$spacing.filterProps = $40d4ff9e66a5531b$var$spacingKeys;
var $40d4ff9e66a5531b$export$2e2bcd8739ae039 = $40d4ff9e66a5531b$var$spacing;

});
parcelRegister("cvrkU", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $91ad95ac62846a03$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $91ad95ac62846a03$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $91ad95ac62846a03$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $91ad95ac62846a03$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $91ad95ac62846a03$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $91ad95ac62846a03$export$980e6a259d807490; });

var $kY3Ke = parcelRequire("kY3Ke");


var $dYkRa = parcelRequire("dYkRa");

var $4So0q = parcelRequire("4So0q");
const $91ad95ac62846a03$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $91ad95ac62846a03$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$91ad95ac62846a03$export$68c286be0e7e55b7[key]}px)`
};
function $91ad95ac62846a03$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $91ad95ac62846a03$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $91ad95ac62846a03$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $91ad95ac62846a03$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $91ad95ac62846a03$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $91ad95ac62846a03$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $kY3Ke.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $4So0q.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $91ad95ac62846a03$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $91ad95ac62846a03$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $91ad95ac62846a03$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $91ad95ac62846a03$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $dYkRa.default)(prev, next), {});
    return $91ad95ac62846a03$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $91ad95ac62846a03$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $91ad95ac62846a03$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $91ad95ac62846a03$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $91ad95ac62846a03$export$2e2bcd8739ae039 = $91ad95ac62846a03$var$breakpoints;

});
parcelRegister("4So0q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38ced3a04f47cab4$export$2e2bcd8739ae039; });

var $dYkRa = parcelRequire("dYkRa");
function $38ced3a04f47cab4$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $dYkRa.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $38ced3a04f47cab4$export$2e2bcd8739ae039 = $38ced3a04f47cab4$var$merge;

});


parcelRegister("190Wm", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $0d575c74131361b5$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $0d575c74131361b5$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $0d575c74131361b5$export$2e2bcd8739ae039; });

var $iCiVn = parcelRequire("iCiVn");


var $cvrkU = parcelRequire("cvrkU");
function $0d575c74131361b5$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $0d575c74131361b5$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $0d575c74131361b5$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $0d575c74131361b5$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $0d575c74131361b5$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $0d575c74131361b5$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $0d575c74131361b5$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $iCiVn.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $cvrkU.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $0d575c74131361b5$export$2e2bcd8739ae039 = $0d575c74131361b5$var$style;

});

parcelRegister("dMDTp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a08eb3ea758ca121$export$2e2bcd8739ae039; });
function $a08eb3ea758ca121$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("8M6a3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $663795ec7cbfcd06$export$2e2bcd8739ae039; });

var $iCiVn = parcelRequire("iCiVn");

var $4So0q = parcelRequire("4So0q");

var $190Wm = parcelRequire("190Wm");

var $cvrkU = parcelRequire("cvrkU");

var $hXGiu = parcelRequire("hXGiu");
function $663795ec7cbfcd06$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $663795ec7cbfcd06$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $663795ec7cbfcd06$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $190Wm.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $190Wm.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $190Wm.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $iCiVn.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $cvrkU.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $hXGiu.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $cvrkU.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $663795ec7cbfcd06$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $4So0q.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $cvrkU.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($663795ec7cbfcd06$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $4So0q.default)(css, breakpointsValues);
                        }
                    } else css = (0, $4So0q.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $cvrkU.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $663795ec7cbfcd06$var$styleFunctionSx = $663795ec7cbfcd06$export$7d53d8bf2911e013();
$663795ec7cbfcd06$var$styleFunctionSx.filterProps = [
    "sx"
];
var $663795ec7cbfcd06$export$2e2bcd8739ae039 = $663795ec7cbfcd06$var$styleFunctionSx;

});
parcelRegister("hXGiu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d138c1b003d294d5$export$2e2bcd8739ae039; });

var $5z69T = parcelRequire("5z69T");

var $brmMH = parcelRequire("brmMH");

var $aoYMG = parcelRequire("aoYMG");

var $lzsJx = parcelRequire("lzsJx");

var $8LvXe = parcelRequire("8LvXe");
const $d138c1b003d294d5$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $brmMH.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $brmMH.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $brmMH.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $brmMH.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $brmMH.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $brmMH.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $lzsJx.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $lzsJx.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $lzsJx.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $5z69T.padding)
    },
    pt: {
        style: (0, $5z69T.padding)
    },
    pr: {
        style: (0, $5z69T.padding)
    },
    pb: {
        style: (0, $5z69T.padding)
    },
    pl: {
        style: (0, $5z69T.padding)
    },
    px: {
        style: (0, $5z69T.padding)
    },
    py: {
        style: (0, $5z69T.padding)
    },
    padding: {
        style: (0, $5z69T.padding)
    },
    paddingTop: {
        style: (0, $5z69T.padding)
    },
    paddingRight: {
        style: (0, $5z69T.padding)
    },
    paddingBottom: {
        style: (0, $5z69T.padding)
    },
    paddingLeft: {
        style: (0, $5z69T.padding)
    },
    paddingX: {
        style: (0, $5z69T.padding)
    },
    paddingY: {
        style: (0, $5z69T.padding)
    },
    paddingInline: {
        style: (0, $5z69T.padding)
    },
    paddingInlineStart: {
        style: (0, $5z69T.padding)
    },
    paddingInlineEnd: {
        style: (0, $5z69T.padding)
    },
    paddingBlock: {
        style: (0, $5z69T.padding)
    },
    paddingBlockStart: {
        style: (0, $5z69T.padding)
    },
    paddingBlockEnd: {
        style: (0, $5z69T.padding)
    },
    m: {
        style: (0, $5z69T.margin)
    },
    mt: {
        style: (0, $5z69T.margin)
    },
    mr: {
        style: (0, $5z69T.margin)
    },
    mb: {
        style: (0, $5z69T.margin)
    },
    ml: {
        style: (0, $5z69T.margin)
    },
    mx: {
        style: (0, $5z69T.margin)
    },
    my: {
        style: (0, $5z69T.margin)
    },
    margin: {
        style: (0, $5z69T.margin)
    },
    marginTop: {
        style: (0, $5z69T.margin)
    },
    marginRight: {
        style: (0, $5z69T.margin)
    },
    marginBottom: {
        style: (0, $5z69T.margin)
    },
    marginLeft: {
        style: (0, $5z69T.margin)
    },
    marginX: {
        style: (0, $5z69T.margin)
    },
    marginY: {
        style: (0, $5z69T.margin)
    },
    marginInline: {
        style: (0, $5z69T.margin)
    },
    marginInlineStart: {
        style: (0, $5z69T.margin)
    },
    marginInlineEnd: {
        style: (0, $5z69T.margin)
    },
    marginBlock: {
        style: (0, $5z69T.margin)
    },
    marginBlockStart: {
        style: (0, $5z69T.margin)
    },
    marginBlockEnd: {
        style: (0, $5z69T.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $aoYMG.gap)
    },
    rowGap: {
        style: (0, $aoYMG.rowGap)
    },
    columnGap: {
        style: (0, $aoYMG.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $8LvXe.sizingTransform)
    },
    maxWidth: {
        style: (0, $8LvXe.maxWidth)
    },
    minWidth: {
        transform: (0, $8LvXe.sizingTransform)
    },
    height: {
        transform: (0, $8LvXe.sizingTransform)
    },
    maxHeight: {
        transform: (0, $8LvXe.sizingTransform)
    },
    minHeight: {
        transform: (0, $8LvXe.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $d138c1b003d294d5$export$2e2bcd8739ae039 = $d138c1b003d294d5$var$defaultSxConfig;

});
parcelRegister("brmMH", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $8543e3d4e0a2f626$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $8543e3d4e0a2f626$export$7a57f79000377ca2; });


var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");

var $5z69T = parcelRequire("5z69T");

var $cvrkU = parcelRequire("cvrkU");
function $8543e3d4e0a2f626$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
const $8543e3d4e0a2f626$export$1edee58a52776cd9 = (0, $190Wm.default)({
    prop: "border",
    themeKey: "borders",
    transform: $8543e3d4e0a2f626$export$34e2febe53ae29cc
});
const $8543e3d4e0a2f626$export$f9a7b6bd24892946 = (0, $190Wm.default)({
    prop: "borderTop",
    themeKey: "borders",
    transform: $8543e3d4e0a2f626$export$34e2febe53ae29cc
});
const $8543e3d4e0a2f626$export$5abca33e6be905d2 = (0, $190Wm.default)({
    prop: "borderRight",
    themeKey: "borders",
    transform: $8543e3d4e0a2f626$export$34e2febe53ae29cc
});
const $8543e3d4e0a2f626$export$e2ce9f12a980a822 = (0, $190Wm.default)({
    prop: "borderBottom",
    themeKey: "borders",
    transform: $8543e3d4e0a2f626$export$34e2febe53ae29cc
});
const $8543e3d4e0a2f626$export$47658cca1a909427 = (0, $190Wm.default)({
    prop: "borderLeft",
    themeKey: "borders",
    transform: $8543e3d4e0a2f626$export$34e2febe53ae29cc
});
const $8543e3d4e0a2f626$export$e7fb0694ba2404fc = (0, $190Wm.default)({
    prop: "borderColor",
    themeKey: "palette"
});
const $8543e3d4e0a2f626$export$126a92c968acdb85 = (0, $190Wm.default)({
    prop: "borderTopColor",
    themeKey: "palette"
});
const $8543e3d4e0a2f626$export$85cc51cb8fbb8c0e = (0, $190Wm.default)({
    prop: "borderRightColor",
    themeKey: "palette"
});
const $8543e3d4e0a2f626$export$340b0327727f6d1a = (0, $190Wm.default)({
    prop: "borderBottomColor",
    themeKey: "palette"
});
const $8543e3d4e0a2f626$export$60beef91a985b4bf = (0, $190Wm.default)({
    prop: "borderLeftColor",
    themeKey: "palette"
});
const $8543e3d4e0a2f626$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$8543e3d4e0a2f626$export$7a57f79000377ca2.propTypes = {};
$8543e3d4e0a2f626$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $8543e3d4e0a2f626$var$borders = (0, $eB9d8.default)($8543e3d4e0a2f626$export$1edee58a52776cd9, $8543e3d4e0a2f626$export$f9a7b6bd24892946, $8543e3d4e0a2f626$export$5abca33e6be905d2, $8543e3d4e0a2f626$export$e2ce9f12a980a822, $8543e3d4e0a2f626$export$47658cca1a909427, $8543e3d4e0a2f626$export$e7fb0694ba2404fc, $8543e3d4e0a2f626$export$126a92c968acdb85, $8543e3d4e0a2f626$export$85cc51cb8fbb8c0e, $8543e3d4e0a2f626$export$340b0327727f6d1a, $8543e3d4e0a2f626$export$60beef91a985b4bf, $8543e3d4e0a2f626$export$7a57f79000377ca2);
var $8543e3d4e0a2f626$export$2e2bcd8739ae039 = $8543e3d4e0a2f626$var$borders;

});
parcelRegister("eB9d8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa0baa79cee865b3$export$2e2bcd8739ae039; });

var $4So0q = parcelRequire("4So0q");
function $aa0baa79cee865b3$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $4So0q.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $aa0baa79cee865b3$export$2e2bcd8739ae039 = $aa0baa79cee865b3$var$compose;

});


parcelRegister("aoYMG", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $792b4bc41110be3c$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $792b4bc41110be3c$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $792b4bc41110be3c$export$8a833ffa5f5dbeda; });

var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");

var $5z69T = parcelRequire("5z69T");

var $cvrkU = parcelRequire("cvrkU");

const $792b4bc41110be3c$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$792b4bc41110be3c$export$5df9adcb0db95e1e.propTypes = {};
$792b4bc41110be3c$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $792b4bc41110be3c$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$792b4bc41110be3c$export$ec60d70ff941a580.propTypes = {};
$792b4bc41110be3c$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $792b4bc41110be3c$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$792b4bc41110be3c$export$8a833ffa5f5dbeda.propTypes = {};
$792b4bc41110be3c$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $792b4bc41110be3c$export$baf44164ca3a34e8 = (0, $190Wm.default)({
    prop: "gridColumn"
});
const $792b4bc41110be3c$export$8f7213a1cd01e832 = (0, $190Wm.default)({
    prop: "gridRow"
});
const $792b4bc41110be3c$export$b0e0abbc49ba668 = (0, $190Wm.default)({
    prop: "gridAutoFlow"
});
const $792b4bc41110be3c$export$bcd8b929d4b4142 = (0, $190Wm.default)({
    prop: "gridAutoColumns"
});
const $792b4bc41110be3c$export$e5039a674e14c828 = (0, $190Wm.default)({
    prop: "gridAutoRows"
});
const $792b4bc41110be3c$export$42bd9088661ffb03 = (0, $190Wm.default)({
    prop: "gridTemplateColumns"
});
const $792b4bc41110be3c$export$920682ae05b999bc = (0, $190Wm.default)({
    prop: "gridTemplateRows"
});
const $792b4bc41110be3c$export$1b88fbdd482fd33a = (0, $190Wm.default)({
    prop: "gridTemplateAreas"
});
const $792b4bc41110be3c$export$bdb486e40d52d26f = (0, $190Wm.default)({
    prop: "gridArea"
});
const $792b4bc41110be3c$var$grid = (0, $eB9d8.default)($792b4bc41110be3c$export$5df9adcb0db95e1e, $792b4bc41110be3c$export$ec60d70ff941a580, $792b4bc41110be3c$export$8a833ffa5f5dbeda, $792b4bc41110be3c$export$baf44164ca3a34e8, $792b4bc41110be3c$export$8f7213a1cd01e832, $792b4bc41110be3c$export$b0e0abbc49ba668, $792b4bc41110be3c$export$bcd8b929d4b4142, $792b4bc41110be3c$export$e5039a674e14c828, $792b4bc41110be3c$export$42bd9088661ffb03, $792b4bc41110be3c$export$920682ae05b999bc, $792b4bc41110be3c$export$1b88fbdd482fd33a, $792b4bc41110be3c$export$bdb486e40d52d26f);
var $792b4bc41110be3c$export$2e2bcd8739ae039 = $792b4bc41110be3c$var$grid;

});

parcelRegister("lzsJx", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $fb4327c08e40e84e$export$dbaffd4420ea0ac6; });

var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");
function $fb4327c08e40e84e$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $fb4327c08e40e84e$export$35e9368ef982300f = (0, $190Wm.default)({
    prop: "color",
    themeKey: "palette",
    transform: $fb4327c08e40e84e$export$dbaffd4420ea0ac6
});
const $fb4327c08e40e84e$export$2506f56c10355b33 = (0, $190Wm.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $fb4327c08e40e84e$export$dbaffd4420ea0ac6
});
const $fb4327c08e40e84e$export$8c5a050822fd698c = (0, $190Wm.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $fb4327c08e40e84e$export$dbaffd4420ea0ac6
});
const $fb4327c08e40e84e$var$palette = (0, $eB9d8.default)($fb4327c08e40e84e$export$35e9368ef982300f, $fb4327c08e40e84e$export$2506f56c10355b33, $fb4327c08e40e84e$export$8c5a050822fd698c);
var $fb4327c08e40e84e$export$2e2bcd8739ae039 = $fb4327c08e40e84e$var$palette;

});

parcelRegister("8LvXe", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $661b7ffebb8ef134$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $661b7ffebb8ef134$export$488fda99655ff65a; });

var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");

var $cvrkU = parcelRequire("cvrkU");
function $661b7ffebb8ef134$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $661b7ffebb8ef134$export$7e3df82ee760448c = (0, $190Wm.default)({
    prop: "width",
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $cvrkU.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $661b7ffebb8ef134$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $cvrkU.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$661b7ffebb8ef134$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $661b7ffebb8ef134$export$ee148fbbe8357dd2 = (0, $190Wm.default)({
    prop: "minWidth",
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$ac607276a8fe9f0a = (0, $190Wm.default)({
    prop: "height",
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$dc0d8bd0b94f8570 = (0, $190Wm.default)({
    prop: "maxHeight",
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$a43cf604e12f3b17 = (0, $190Wm.default)({
    prop: "minHeight",
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$ffed9f14fb65e276 = (0, $190Wm.default)({
    prop: "size",
    cssProperty: "width",
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$905076ed6620e671 = (0, $190Wm.default)({
    prop: "size",
    cssProperty: "height",
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$6ccc93f785106a58 = (0, $190Wm.default)({
    prop: "boxSizing"
});
const $661b7ffebb8ef134$var$sizing = (0, $eB9d8.default)($661b7ffebb8ef134$export$7e3df82ee760448c, $661b7ffebb8ef134$export$488fda99655ff65a, $661b7ffebb8ef134$export$ee148fbbe8357dd2, $661b7ffebb8ef134$export$ac607276a8fe9f0a, $661b7ffebb8ef134$export$dc0d8bd0b94f8570, $661b7ffebb8ef134$export$a43cf604e12f3b17, $661b7ffebb8ef134$export$6ccc93f785106a58);
var $661b7ffebb8ef134$export$2e2bcd8739ae039 = $661b7ffebb8ef134$var$sizing;

});




parcelRegister("84PRT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e16ee62ac64bb0b$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("bpHMA");
var $6H441 = parcelRequire("6H441");
"use client";
function $5e16ee62ac64bb0b$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $5e16ee62ac64bb0b$var$useTheme(defaultTheme = null) {
    const contextTheme = $7fPBF.useContext((0, $6H441.T));
    return !contextTheme || $5e16ee62ac64bb0b$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $5e16ee62ac64bb0b$export$2e2bcd8739ae039 = $5e16ee62ac64bb0b$var$useTheme;

});
parcelRegister("bpHMA", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $84f3fdd51733d70b$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $84f3fdd51733d70b$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $84f3fdd51733d70b$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("6H441")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("6H441")).w; });

var $6H441 = parcelRequire("6H441");

var $7fPBF = parcelRequire("7fPBF");

var $6g0AG = parcelRequire("6g0AG");

var $fjS7T = parcelRequire("fjS7T");

var $3kqr7 = parcelRequire("3kqr7");
parcelRequire("10euI");
parcelRequire("cvBp9");
parcelRequire("lT6zG");

parcelRequire("8Ae2G");
var $84f3fdd51733d70b$var$pkg = {
    name: "@emotion/react",
    version: "11.11.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $84f3fdd51733d70b$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $6H441.h).call(props, "css")) // $FlowFixMe
    return $7fPBF.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $6H441.E);
    createElementArgArray[1] = (0, $6H441.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $7fPBF.createElement.apply(null, createElementArgArray);
};
var $84f3fdd51733d70b$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $84f3fdd51733d70b$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $6H441.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $3kqr7.serializeStyles)([
        styles
    ], undefined, $7fPBF.useContext((0, $6H441.T)));
    if (!(0, $6H441.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $7fPBF.useRef();
    (0, $fjS7T.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $fjS7T.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $6g0AG.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $84f3fdd51733d70b$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $3kqr7.serializeStyles)(args);
}
var $84f3fdd51733d70b$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $84f3fdd51733d70b$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $84f3fdd51733d70b$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $84f3fdd51733d70b$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $6g0AG.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $84f3fdd51733d70b$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $fjS7T.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $6g0AG.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $84f3fdd51733d70b$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $6H441.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $3kqr7.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $6g0AG.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $84f3fdd51733d70b$var$merge(cache.registered, css, $84f3fdd51733d70b$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $7fPBF.useContext((0, $6H441.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($84f3fdd51733d70b$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $84f3fdd51733d70b$var$isBrowser, $84f3fdd51733d70b$var$isTestEnv, $84f3fdd51733d70b$var$globalContext, $84f3fdd51733d70b$var$globalKey;

});
parcelRegister("6H441", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $4df9e939738a7402$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $4df9e939738a7402$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "w", function () { return $4df9e939738a7402$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $4df9e939738a7402$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $4df9e939738a7402$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $4df9e939738a7402$export$a9c23c6ac3fc3eca; });

var $7fPBF = parcelRequire("7fPBF");

var $10euI = parcelRequire("10euI");

var $kY3Ke = parcelRequire("kY3Ke");

var $lT6zG = parcelRequire("lT6zG");

var $haRds = parcelRequire("haRds");

var $6g0AG = parcelRequire("6g0AG");

var $3kqr7 = parcelRequire("3kqr7");

var $fjS7T = parcelRequire("fjS7T");
var $4df9e939738a7402$export$23f2a1d2818174ef = true;
var $4df9e939738a7402$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $4df9e939738a7402$var$EmotionCacheContext = /* #__PURE__ */ $7fPBF.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $10euI.default)({
    key: "css"
}) : null);
var $4df9e939738a7402$export$e7094788287c5e9b = $4df9e939738a7402$var$EmotionCacheContext.Provider;
var $4df9e939738a7402$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $7fPBF.useContext)($4df9e939738a7402$var$EmotionCacheContext);
};
var $4df9e939738a7402$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $7fPBF.useContext)($4df9e939738a7402$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$4df9e939738a7402$export$23f2a1d2818174ef) $4df9e939738a7402$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $7fPBF.useContext)($4df9e939738a7402$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $10euI.default)({
                key: "css"
            });
            return /*#__PURE__*/ $7fPBF.createElement($4df9e939738a7402$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $4df9e939738a7402$export$971d5caa766a69d7 = /* #__PURE__ */ $7fPBF.createContext({});
var $4df9e939738a7402$export$3b14a55fb2447963 = function useTheme() {
    return $7fPBF.useContext($4df9e939738a7402$export$971d5caa766a69d7);
};
var $4df9e939738a7402$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $kY3Ke.default)({}, outerTheme, theme);
};
var $4df9e939738a7402$var$createCacheWithTheme = /* #__PURE__ */ (0, $lT6zG.default)(function(outerTheme) {
    return (0, $lT6zG.default)(function(theme) {
        return $4df9e939738a7402$var$getTheme(outerTheme, theme);
    });
});
var $4df9e939738a7402$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $7fPBF.useContext($4df9e939738a7402$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $4df9e939738a7402$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $7fPBF.createElement($4df9e939738a7402$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $4df9e939738a7402$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $7fPBF.useContext($4df9e939738a7402$export$971d5caa766a69d7);
        return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $7fPBF.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $haRds.default)(WithTheme, Component);
}
var $4df9e939738a7402$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $4df9e939738a7402$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $4df9e939738a7402$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $4df9e939738a7402$var$getLastPart(match[1]);
    return undefined;
};
var $4df9e939738a7402$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $4df9e939738a7402$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $4df9e939738a7402$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $4df9e939738a7402$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($4df9e939738a7402$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $4df9e939738a7402$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $4df9e939738a7402$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $4df9e939738a7402$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $4df9e939738a7402$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($4df9e939738a7402$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$4df9e939738a7402$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $4df9e939738a7402$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $6g0AG.registerStyles)(cache, serialized, isStringTag);
    (0, $fjS7T.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $6g0AG.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $4df9e939738a7402$var$Emotion = /* #__PURE__ */ $4df9e939738a7402$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$4df9e939738a7402$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $6g0AG.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $3kqr7.serializeStyles)(registeredStyles, undefined, $7fPBF.useContext($4df9e939738a7402$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($4df9e939738a7402$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $4df9e939738a7402$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($4df9e939738a7402$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $7fPBF.createElement(WrappedComponent, newProps));
});
var $4df9e939738a7402$export$a9c23c6ac3fc3eca = $4df9e939738a7402$var$Emotion;

});
parcelRegister("10euI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bb108cf9f15301b$export$2e2bcd8739ae039; });

var $67tST = parcelRequire("67tST");

var $cByrN = parcelRequire("cByrN");
parcelRequire("lT6zG");
parcelRequire("4AWAi");
var $0bb108cf9f15301b$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $cByrN.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $cByrN.token)(character)) break;
        (0, $cByrN.next)();
    }
    return (0, $cByrN.slice)(begin, (0, $cByrN.position));
};
var $0bb108cf9f15301b$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $cByrN.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $cByrN.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $0bb108cf9f15301b$var$identifierWithPointTracking((0, $cByrN.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $cByrN.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $cByrN.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $cByrN.from)(character);
    }
    while (character = (0, $cByrN.next)());
    return parsed;
};
var $0bb108cf9f15301b$var$getRules = function getRules(value, points) {
    return (0, $cByrN.dealloc)($0bb108cf9f15301b$var$toRules((0, $cByrN.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $0bb108cf9f15301b$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $0bb108cf9f15301b$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$0bb108cf9f15301b$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $0bb108cf9f15301b$var$fixedElements.set(element, true);
    var points = [];
    var rules = $0bb108cf9f15301b$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $0bb108cf9f15301b$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $0bb108cf9f15301b$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $0bb108cf9f15301b$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($0bb108cf9f15301b$var$ignoreFlag) > -1;
};
var $0bb108cf9f15301b$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($0bb108cf9f15301b$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $0bb108cf9f15301b$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $0bb108cf9f15301b$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$0bb108cf9f15301b$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $0bb108cf9f15301b$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $0bb108cf9f15301b$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$0bb108cf9f15301b$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $0bb108cf9f15301b$var$nullifyElement(element);
    } else if ($0bb108cf9f15301b$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $0bb108cf9f15301b$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $0bb108cf9f15301b$var$prefix(value, length) {
    switch((0, $cByrN.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $cByrN.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $cByrN.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MOZ) + value + (0, $cByrN.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + value + value;
        // order
        case 6165:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.replace)(value, /(\w+).+(:[^]+)/, (0, $cByrN.WEBKIT) + "box-$1$2" + (0, $cByrN.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + "flex-item-" + (0, $cByrN.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + "flex-line-pack" + (0, $cByrN.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $cByrN.WEBKIT) + "box-" + (0, $cByrN.replace)(value, "-grow", "") + (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $cByrN.WEBKIT) + (0, $cByrN.replace)(value, /([^-])(transform)/g, "$1" + (0, $cByrN.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $cByrN.replace)((0, $cByrN.replace)((0, $cByrN.replace)(value, /(zoom-|grab)/, (0, $cByrN.WEBKIT) + "$1"), /(image-set)/, (0, $cByrN.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $cByrN.replace)(value, /(image-set\([^]*)/, (0, $cByrN.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $cByrN.replace)((0, $cByrN.replace)(value, /(.+:)(flex-)?(.*)/, (0, $cByrN.WEBKIT) + "box-pack:$3" + (0, $cByrN.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $cByrN.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $cByrN.replace)(value, /(.+)-inline(.+)/, (0, $cByrN.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $cByrN.strlen)(value) - 1 - length > 6) switch((0, $cByrN.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $cByrN.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $cByrN.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $cByrN.WEBKIT) + "$2-$3" + "$1" + (0, $cByrN.MOZ) + ((0, $cByrN.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $cByrN.indexof)(value, "stretch") ? $0bb108cf9f15301b$var$prefix((0, $cByrN.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $cByrN.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $cByrN.charat)(value, (0, $cByrN.strlen)(value) - 3 - (~(0, $cByrN.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $cByrN.replace)(value, ":", ":" + (0, $cByrN.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $cByrN.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $cByrN.WEBKIT) + ((0, $cByrN.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $cByrN.WEBKIT) + "$2$3" + "$1" + (0, $cByrN.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $cByrN.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + value + value;
    }
    return value;
}
var $0bb108cf9f15301b$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $cByrN.DECLARATION:
                element["return"] = $0bb108cf9f15301b$var$prefix(element.value, element.length);
                break;
            case 0, $cByrN.KEYFRAMES:
                return (0, $cByrN.serialize)([
                    (0, $cByrN.copy)(element, {
                        value: (0, $cByrN.replace)(element.value, "@", "@" + (0, $cByrN.WEBKIT))
                    })
                ], callback);
            case 0, $cByrN.RULESET:
                if (element.length) return (0, $cByrN.combine)(element.props, function(value) {
                    switch((0, $cByrN.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $cByrN.serialize)([
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(read-\w+)/, ":" + (0, $cByrN.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $cByrN.serialize)([
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(plac\w+)/, ":" + (0, $cByrN.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(plac\w+)/, ":" + (0, $cByrN.MOZ) + "$1")
                                    ]
                                }),
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(plac\w+)/, (0, $cByrN.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $0bb108cf9f15301b$var$defaultStylisPlugins = [
    $0bb108cf9f15301b$var$prefixer
];
var $0bb108cf9f15301b$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $0bb108cf9f15301b$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $0bb108cf9f15301b$var$compat,
        $0bb108cf9f15301b$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $cByrN.stringify),
        (0, $cByrN.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $cByrN.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $cByrN.serialize)((0, $cByrN.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $67tST.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("67tST", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $474a93eda108ec7a$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $474a93eda108ec7a$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $474a93eda108ec7a$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $474a93eda108ec7a$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($474a93eda108ec7a$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $474a93eda108ec7a$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("cByrN", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $83f8df0fc4bef2f6$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $83f8df0fc4bef2f6$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $83f8df0fc4bef2f6$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $83f8df0fc4bef2f6$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $83f8df0fc4bef2f6$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $83f8df0fc4bef2f6$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $83f8df0fc4bef2f6$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $83f8df0fc4bef2f6$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $83f8df0fc4bef2f6$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $83f8df0fc4bef2f6$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $83f8df0fc4bef2f6$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $83f8df0fc4bef2f6$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $83f8df0fc4bef2f6$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $83f8df0fc4bef2f6$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $83f8df0fc4bef2f6$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $83f8df0fc4bef2f6$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $83f8df0fc4bef2f6$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $83f8df0fc4bef2f6$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $83f8df0fc4bef2f6$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $83f8df0fc4bef2f6$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $83f8df0fc4bef2f6$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $83f8df0fc4bef2f6$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $83f8df0fc4bef2f6$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $83f8df0fc4bef2f6$export$38bcb760f1d4871c; });
var $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 = "-ms-";
var $83f8df0fc4bef2f6$export$2c0f367103c8d01c = "-moz-";
var $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 = "-webkit-";
var $83f8df0fc4bef2f6$export$a29989082612d0d9 = "comm";
var $83f8df0fc4bef2f6$export$aa3a2e812ca8570d = "rule";
var $83f8df0fc4bef2f6$export$527d108ccf083c2b = "decl";
var $83f8df0fc4bef2f6$export$d3d35020fa5b54f0 = "@page";
var $83f8df0fc4bef2f6$export$500415a86c544f73 = "@media";
var $83f8df0fc4bef2f6$export$a763edbf796b780a = "@import";
var $83f8df0fc4bef2f6$export$2790aeb8b4e5c826 = "@charset";
var $83f8df0fc4bef2f6$export$1cc683e23b84b133 = "@viewport";
var $83f8df0fc4bef2f6$export$9447a5efea57e862 = "@supports";
var $83f8df0fc4bef2f6$export$ef011b4e114b1fba = "@document";
var $83f8df0fc4bef2f6$export$6aad947bda0f3f46 = "@namespace";
var $83f8df0fc4bef2f6$export$b44a8529a35fcb60 = "@keyframes";
var $83f8df0fc4bef2f6$export$2c16de31893252e6 = "@font-face";
var $83f8df0fc4bef2f6$export$3d846dd52e150c6f = "@counter-style";
var $83f8df0fc4bef2f6$export$22314bfbb57653fe = "@font-feature-values";
var $83f8df0fc4bef2f6$export$d773506282b3cfe6 = "@layer";
var $83f8df0fc4bef2f6$export$2335f513bbd82c6d = Math.abs;
var $83f8df0fc4bef2f6$export$6788812c4e6611e6 = String.fromCharCode;
var $83f8df0fc4bef2f6$export$e6e34fd1f2686227 = Object.assign;
function $83f8df0fc4bef2f6$export$d6af199866bfb566(e, r) {
    return $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 0)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 1)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 2)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 3) : 0;
}
function $83f8df0fc4bef2f6$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $83f8df0fc4bef2f6$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $83f8df0fc4bef2f6$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $83f8df0fc4bef2f6$export$36776f635604f274(e) {
    return e.length;
}
function $83f8df0fc4bef2f6$export$f9084667e487ed46(e) {
    return e.length;
}
function $83f8df0fc4bef2f6$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $83f8df0fc4bef2f6$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c = 1;
var $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1;
var $83f8df0fc4bef2f6$export$f24224f1c91d8156 = 0;
var $83f8df0fc4bef2f6$export$5880b8b5730aff45 = 0;
var $83f8df0fc4bef2f6$export$c0306caf338ac095 = 0;
var $83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = "";
function $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c,
        column: $83f8df0fc4bef2f6$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $83f8df0fc4bef2f6$export$784d13d8ee351f07(e, r) {
    return $83f8df0fc4bef2f6$export$e6e34fd1f2686227($83f8df0fc4bef2f6$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $83f8df0fc4bef2f6$export$eba6f6f03b0a92e7() {
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$232faf9add678146() {
    $83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$5880b8b5730aff45 > 0 ? $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, --$83f8df0fc4bef2f6$export$5880b8b5730aff45) : 0;
    if ($83f8df0fc4bef2f6$export$4e0c71f277ca26b3--, $83f8df0fc4bef2f6$export$c0306caf338ac095 === 10) $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c--;
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$48cfd1e771a65c4f() {
    $83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$5880b8b5730aff45 < $83f8df0fc4bef2f6$export$f24224f1c91d8156 ? $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, $83f8df0fc4bef2f6$export$5880b8b5730aff45++) : 0;
    if ($83f8df0fc4bef2f6$export$4e0c71f277ca26b3++, $83f8df0fc4bef2f6$export$c0306caf338ac095 === 10) $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c++;
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() {
    return $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, $83f8df0fc4bef2f6$export$5880b8b5730aff45);
}
function $83f8df0fc4bef2f6$export$e88cb2efb12ae807() {
    return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
}
function $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, r) {
    return $83f8df0fc4bef2f6$export$2f35ab04d2335697($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, e, r);
}
function $83f8df0fc4bef2f6$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $83f8df0fc4bef2f6$export$2de70f21292aac9e(e) {
    return $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c = $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$f24224f1c91d8156 = $83f8df0fc4bef2f6$export$36776f635604f274($83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = e), $83f8df0fc4bef2f6$export$5880b8b5730aff45 = 0, [];
}
function $83f8df0fc4bef2f6$export$45918ac1574455b1(e) {
    return $83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = "", e;
}
function $83f8df0fc4bef2f6$export$410ac95b9ec204b8(e) {
    return $83f8df0fc4bef2f6$export$87c2784dc9fc4ab($83f8df0fc4bef2f6$export$58adb3bec8346d0f($83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1, $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $83f8df0fc4bef2f6$export$660b2ee2d4fb4eff(e) {
    return $83f8df0fc4bef2f6$export$45918ac1574455b1($83f8df0fc4bef2f6$export$5f8c09e3ae6f64e1($83f8df0fc4bef2f6$export$2de70f21292aac9e(e)));
}
function $83f8df0fc4bef2f6$export$7af1228ff777d175(e) {
    while($83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$4d3fb11e950abb9e())if ($83f8df0fc4bef2f6$export$c0306caf338ac095 < 33) $83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
    else break;
    return $83f8df0fc4bef2f6$export$9e1725a4cfeada27(e) > 2 || $83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $83f8df0fc4bef2f6$export$5f8c09e3ae6f64e1(e) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())switch($83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$c0306caf338ac095)){
        case 0:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$c2ab62c7bf24634($83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$410ac95b9ec204b8($83f8df0fc4bef2f6$export$c0306caf338ac095), e);
            break;
        default:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$6788812c4e6611e6($83f8df0fc4bef2f6$export$c0306caf338ac095), e);
    }
    return e;
}
function $83f8df0fc4bef2f6$export$955ba06d119e085e(e, r) {
    while(--r && $83f8df0fc4bef2f6$export$48cfd1e771a65c4f())if ($83f8df0fc4bef2f6$export$c0306caf338ac095 < 48 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 102 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 57 && $83f8df0fc4bef2f6$export$c0306caf338ac095 < 65 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 70 && $83f8df0fc4bef2f6$export$c0306caf338ac095 < 97) break;
    return $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, $83f8df0fc4bef2f6$export$e88cb2efb12ae807() + (r < 6 && $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() == 32 && $83f8df0fc4bef2f6$export$48cfd1e771a65c4f() == 32));
}
function $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())switch($83f8df0fc4bef2f6$export$c0306caf338ac095){
        case e:
            return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $83f8df0fc4bef2f6$export$c889f2fcc19dbf12($83f8df0fc4bef2f6$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
            break;
    }
    return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
}
function $83f8df0fc4bef2f6$export$4254d4e2b3745c4c(e, r) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())if (e + $83f8df0fc4bef2f6$export$c0306caf338ac095 === 57) break;
    else if (e + $83f8df0fc4bef2f6$export$c0306caf338ac095 === 84 && $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $83f8df0fc4bef2f6$export$58adb3bec8346d0f(r, $83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1) + "*" + $83f8df0fc4bef2f6$export$6788812c4e6611e6(e === 47 ? e : $83f8df0fc4bef2f6$export$48cfd1e771a65c4f());
}
function $83f8df0fc4bef2f6$export$c2ab62c7bf24634(e) {
    while(!$83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$4d3fb11e950abb9e()))$83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
    return $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, $83f8df0fc4bef2f6$export$5880b8b5730aff45);
}
function $83f8df0fc4bef2f6$export$ef7acd7185315e22(e) {
    return $83f8df0fc4bef2f6$export$45918ac1574455b1($83f8df0fc4bef2f6$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $83f8df0fc4bef2f6$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $83f8df0fc4bef2f6$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $83f8df0fc4bef2f6$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $83f8df0fc4bef2f6$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($83f8df0fc4bef2f6$export$f8e21b1e77979a08(j += $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $83f8df0fc4bef2f6$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $83f8df0fc4bef2f6$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $83f8df0fc4bef2f6$export$955ba06d119e085e($83f8df0fc4bef2f6$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($83f8df0fc4bef2f6$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$4a34f930e789283c($83f8df0fc4bef2f6$export$4254d4e2b3745c4c($83f8df0fc4bef2f6$export$48cfd1e771a65c4f(), $83f8df0fc4bef2f6$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $83f8df0fc4bef2f6$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $83f8df0fc4bef2f6$export$36776f635604f274(j) - l) $83f8df0fc4bef2f6$export$10d8903dec122b9d(p > 32 ? $83f8df0fc4bef2f6$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $83f8df0fc4bef2f6$export$f8483753829ec8f3($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $83f8df0fc4bef2f6$export$10d8903dec122b9d(y = $83f8df0fc4bef2f6$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $83f8df0fc4bef2f6$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $83f8df0fc4bef2f6$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $83f8df0fc4bef2f6$export$98e6a39c04603d36(e, y, y, n && $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $83f8df0fc4bef2f6$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $83f8df0fc4bef2f6$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $83f8df0fc4bef2f6$export$232faf9add678146() == 125) continue;
            }
            switch(j += $83f8df0fc4bef2f6$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($83f8df0fc4bef2f6$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($83f8df0fc4bef2f6$export$4d3fb11e950abb9e() === 45) j += $83f8df0fc4bef2f6$export$410ac95b9ec204b8($83f8df0fc4bef2f6$export$48cfd1e771a65c4f());
                    v = $83f8df0fc4bef2f6$export$4d3fb11e950abb9e(), o = l = $83f8df0fc4bef2f6$export$36776f635604f274(g = j += $83f8df0fc4bef2f6$export$c2ab62c7bf24634($83f8df0fc4bef2f6$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $83f8df0fc4bef2f6$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $83f8df0fc4bef2f6$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $83f8df0fc4bef2f6$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, v + 1, v = $83f8df0fc4bef2f6$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $83f8df0fc4bef2f6$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, s === 0 ? $83f8df0fc4bef2f6$export$aa3a2e812ca8570d : i, f, o, l);
}
function $83f8df0fc4bef2f6$export$4a34f930e789283c(e, r, a) {
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, $83f8df0fc4bef2f6$export$a29989082612d0d9, $83f8df0fc4bef2f6$export$6788812c4e6611e6($83f8df0fc4bef2f6$export$eba6f6f03b0a92e7()), $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $83f8df0fc4bef2f6$export$f8483753829ec8f3(e, r, a, n) {
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, $83f8df0fc4bef2f6$export$527d108ccf083c2b, $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, 0, n), $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $83f8df0fc4bef2f6$export$82e9f45cca5ba907(n, c, s) {
    switch($83f8df0fc4bef2f6$export$d6af199866bfb566(n, c)){
        case 5103:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $83f8df0fc4bef2f6$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-$1$2" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-item-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-row-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-line-pack" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-grow", "") + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-pack:$3" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-column-align" + $83f8df0fc4bef2f6$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(s, "span") ? $83f8df0fc4bef2f6$export$4659b591c19bdf3d(s, /\d+/) : +$83f8df0fc4bef2f6$export$4659b591c19bdf3d(s, /\d+/) - +$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($83f8df0fc4bef2f6$export$36776f635604f274(n) - 1 - c > 6) switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(n, "stretch") ? $83f8df0fc4bef2f6$export$82e9f45cca5ba907($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 6) === 121) return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, ":", ":" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, $83f8df0fc4bef2f6$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, ":", ":" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $83f8df0fc4bef2f6$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $83f8df0fc4bef2f6$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $83f8df0fc4bef2f6$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $83f8df0fc4bef2f6$export$a763edbf796b780a:
        case $83f8df0fc4bef2f6$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $83f8df0fc4bef2f6$export$a29989082612d0d9:
            return "";
        case $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $83f8df0fc4bef2f6$export$36776f635604f274(a = $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $83f8df0fc4bef2f6$export$5a7767152ae0305f(e) {
    var r = $83f8df0fc4bef2f6$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $83f8df0fc4bef2f6$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $83f8df0fc4bef2f6$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $83f8df0fc4bef2f6$export$527d108ccf083c2b:
                n.return = $83f8df0fc4bef2f6$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
                return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                    $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                        value: $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
                if (n.length) return $83f8df0fc4bef2f6$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($83f8df0fc4bef2f6$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $83f8df0fc4bef2f6$export$76a88f7de6507443(e) {
    switch(e.type){
        case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $83f8df0fc4bef2f6$export$1be1fc439b849fdf($83f8df0fc4bef2f6$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($83f8df0fc4bef2f6$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $83f8df0fc4bef2f6$export$2f35ab04d2335697(r, 1, $83f8df0fc4bef2f6$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $83f8df0fc4bef2f6$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $83f8df0fc4bef2f6$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $83f8df0fc4bef2f6$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("lT6zG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fef3d59b736200bc$export$2e2bcd8739ae039; });
var $fef3d59b736200bc$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("4AWAi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3587f7e2ed7416b3$export$2e2bcd8739ae039; });
function $3587f7e2ed7416b3$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("haRds", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c80ca66c64e3fad5$export$2e2bcd8739ae039; });

var $8Ae2G = parcelRequire("8Ae2G");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $c80ca66c64e3fad5$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8Ae2G)))(targetComponent, sourceComponent);
};

});
parcelRegister("8Ae2G", function(module, exports) {
"use strict";

var $dOv1V = parcelRequire("dOv1V");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $63fc9407ef8fcdfe$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $63fc9407ef8fcdfe$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$TYPE_STATICS = {};
$63fc9407ef8fcdfe$var$TYPE_STATICS[$dOv1V.ForwardRef] = $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS;
$63fc9407ef8fcdfe$var$TYPE_STATICS[$dOv1V.Memo] = $63fc9407ef8fcdfe$var$MEMO_STATICS;
function $63fc9407ef8fcdfe$var$getStatics(component) {
    // React v16.11 and below
    if ($dOv1V.isMemo(component)) return $63fc9407ef8fcdfe$var$MEMO_STATICS;
     // React v16.12 and above
    return $63fc9407ef8fcdfe$var$TYPE_STATICS[component["$$typeof"]] || $63fc9407ef8fcdfe$var$REACT_STATICS;
}
var $63fc9407ef8fcdfe$var$defineProperty = Object.defineProperty;
var $63fc9407ef8fcdfe$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $63fc9407ef8fcdfe$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $63fc9407ef8fcdfe$var$getPrototypeOf = Object.getPrototypeOf;
var $63fc9407ef8fcdfe$var$objectPrototype = Object.prototype;
function $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($63fc9407ef8fcdfe$var$objectPrototype) {
            var inheritedComponent = $63fc9407ef8fcdfe$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $63fc9407ef8fcdfe$var$objectPrototype) $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $63fc9407ef8fcdfe$var$getOwnPropertyNames(sourceComponent);
        if ($63fc9407ef8fcdfe$var$getOwnPropertySymbols) keys = keys.concat($63fc9407ef8fcdfe$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $63fc9407ef8fcdfe$var$getStatics(targetComponent);
        var sourceStatics = $63fc9407ef8fcdfe$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$63fc9407ef8fcdfe$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $63fc9407ef8fcdfe$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $63fc9407ef8fcdfe$var$hoistNonReactStatics;

});
parcelRegister("dOv1V", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3oWWu"));

});



parcelRegister("6g0AG", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $48e4b1fcfcd646c1$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $48e4b1fcfcd646c1$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $48e4b1fcfcd646c1$export$6f077d94b33a01aa; });
var $48e4b1fcfcd646c1$var$isBrowser = true;
function $48e4b1fcfcd646c1$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $48e4b1fcfcd646c1$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $48e4b1fcfcd646c1$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $48e4b1fcfcd646c1$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $48e4b1fcfcd646c1$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("3kqr7", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $26c7bf120a29b208$export$6321afa313b251b5; });

var $1OEsj = parcelRequire("1OEsj");

var $cfR4M = parcelRequire("cfR4M");

var $4AWAi = parcelRequire("4AWAi");
var $26c7bf120a29b208$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $26c7bf120a29b208$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $26c7bf120a29b208$var$hyphenateRegex = /[A-Z]|^ms/g;
var $26c7bf120a29b208$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $26c7bf120a29b208$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $26c7bf120a29b208$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $26c7bf120a29b208$var$processStyleName = /* #__PURE__ */ (0, $4AWAi.default)(function(styleName) {
    return $26c7bf120a29b208$var$isCustomProperty(styleName) ? styleName : styleName.replace($26c7bf120a29b208$var$hyphenateRegex, "-$&").toLowerCase();
});
var $26c7bf120a29b208$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($26c7bf120a29b208$var$animationRegex, function(match, p1, p2) {
                $26c7bf120a29b208$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $26c7bf120a29b208$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cfR4M.default)[key] !== 1 && !$26c7bf120a29b208$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $26c7bf120a29b208$var$contentValuePattern, $26c7bf120a29b208$var$contentValues, $26c7bf120a29b208$var$oldProcessStyleValue, $26c7bf120a29b208$var$msPattern, $26c7bf120a29b208$var$hyphenPattern, $26c7bf120a29b208$var$hyphenatedCache;
var $26c7bf120a29b208$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $26c7bf120a29b208$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $26c7bf120a29b208$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $26c7bf120a29b208$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $26c7bf120a29b208$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $26c7bf120a29b208$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $26c7bf120a29b208$var$cursor;
                var result = interpolation(mergedProps);
                $26c7bf120a29b208$var$cursor = previousCursor;
                return $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $26c7bf120a29b208$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($26c7bf120a29b208$var$isProcessableValue(value)) string += $26c7bf120a29b208$var$processStyleName(_key) + ":" + $26c7bf120a29b208$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($26c7bf120a29b208$var$isProcessableValue(value[_i])) string += $26c7bf120a29b208$var$processStyleName(_key) + ":" + $26c7bf120a29b208$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $26c7bf120a29b208$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $26c7bf120a29b208$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $26c7bf120a29b208$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $26c7bf120a29b208$var$cursor;
var $26c7bf120a29b208$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $26c7bf120a29b208$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $26c7bf120a29b208$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $26c7bf120a29b208$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $1OEsj.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $26c7bf120a29b208$var$cursor
    };
};

});
parcelRegister("1OEsj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1529d79d9aa6f066$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $1529d79d9aa6f066$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cfR4M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039; });
var $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("fjS7T", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $b2729db54ba7ee9b$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $b2729db54ba7ee9b$export$811a713a7276cb9d; });

var $7fPBF = parcelRequire("7fPBF");
var $b2729db54ba7ee9b$var$syncFallback = function syncFallback(create) {
    return create();
};
var $b2729db54ba7ee9b$var$useInsertionEffect = $7fPBF.useInsertionEffect ? $7fPBF.useInsertionEffect : false;
var $b2729db54ba7ee9b$export$db21c7ffa21794e7 = $b2729db54ba7ee9b$var$useInsertionEffect || $b2729db54ba7ee9b$var$syncFallback;
var $b2729db54ba7ee9b$export$811a713a7276cb9d = $b2729db54ba7ee9b$var$useInsertionEffect || $7fPBF.useLayoutEffect;

});


parcelRegister("cvBp9", function(module, exports) {
function $91b5651481cc9d5c$var$_extends() {
    module.exports = $91b5651481cc9d5c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $91b5651481cc9d5c$var$_extends.apply(this, arguments);
}
module.exports = $91b5651481cc9d5c$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("9P91Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $726fe1d2377a5002$export$2e2bcd8739ae039; });

var $hmhHQ = parcelRequire("hmhHQ");
"use client";
const $726fe1d2377a5002$var$defaultTheme = (0, $hmhHQ.default)();
var $726fe1d2377a5002$export$2e2bcd8739ae039 = $726fe1d2377a5002$var$defaultTheme;

});
parcelRegister("hmhHQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca3239ce6bf6e490$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $dYkRa = parcelRequire("dYkRa");
var $e5zLi = parcelRequire("e5zLi");

var $2G6xE = parcelRequire("2G6xE");
var $hXGiu = parcelRequire("hXGiu");
var $8M6a3 = parcelRequire("8M6a3");


var $oPCQw = parcelRequire("oPCQw");

var $G7KID = parcelRequire("G7KID");

var $5vuSA = parcelRequire("5vuSA");

var $3jGgo = parcelRequire("3jGgo");

var $kjiCM = parcelRequire("kjiCM");

var $eGmqa = parcelRequire("eGmqa");
const $ca3239ce6bf6e490$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $ca3239ce6bf6e490$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $cFLic.default)(options, $ca3239ce6bf6e490$var$_excluded);
    if (options.vars) throw new Error((0, $e5zLi.default)(18));
    const palette = (0, $G7KID.default)(paletteInput);
    const systemTheme = (0, $2G6xE.default)(options);
    let muiTheme = (0, $dYkRa.default)(systemTheme, {
        mixins: (0, $oPCQw.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $3jGgo.default).slice(),
        typography: (0, $5vuSA.default)(palette, typographyInput),
        transitions: (0, $kjiCM.default)(transitionsInput),
        zIndex: (0, $kY3Ke.default)({}, (0, $eGmqa.default))
    });
    muiTheme = (0, $dYkRa.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $dYkRa.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $kY3Ke.default)({}, (0, $hXGiu.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $8M6a3.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $ca3239ce6bf6e490$var$warnedOnce = false;
function $ca3239ce6bf6e490$export$c469355549431d9b(...args) {
    return $ca3239ce6bf6e490$var$createTheme(...args);
}
var $ca3239ce6bf6e490$export$2e2bcd8739ae039 = $ca3239ce6bf6e490$var$createTheme;

});
parcelRegister("oPCQw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04aa49c3b5b31b02$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
function $04aa49c3b5b31b02$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $kY3Ke.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("G7KID", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07e9efd96a5c6f8a$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $dYkRa = parcelRequire("dYkRa");
var $e5zLi = parcelRequire("e5zLi");

var $cxeT8 = parcelRequire("cxeT8");

var $6akYf = parcelRequire("6akYf");

var $2nhXL = parcelRequire("2nhXL");

var $3Ctzq = parcelRequire("3Ctzq");

var $9PTBs = parcelRequire("9PTBs");

var $5WQac = parcelRequire("5WQac");

var $gal31 = parcelRequire("gal31");

var $1Btry = parcelRequire("1Btry");

var $hnm6Q = parcelRequire("hnm6Q");
const $07e9efd96a5c6f8a$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $07e9efd96a5c6f8a$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $6akYf.default).white,
        default: (0, $6akYf.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $07e9efd96a5c6f8a$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $6akYf.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $6akYf.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $07e9efd96a5c6f8a$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $cxeT8.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $cxeT8.darken)(intent.main, tonalOffsetDark);
    }
}
function $07e9efd96a5c6f8a$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $gal31.default)[200],
        light: (0, $gal31.default)[50],
        dark: (0, $gal31.default)[400]
    };
    return {
        main: (0, $gal31.default)[700],
        light: (0, $gal31.default)[400],
        dark: (0, $gal31.default)[800]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $3Ctzq.default)[200],
        light: (0, $3Ctzq.default)[50],
        dark: (0, $3Ctzq.default)[400]
    };
    return {
        main: (0, $3Ctzq.default)[500],
        light: (0, $3Ctzq.default)[300],
        dark: (0, $3Ctzq.default)[700]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $9PTBs.default)[500],
        light: (0, $9PTBs.default)[300],
        dark: (0, $9PTBs.default)[700]
    };
    return {
        main: (0, $9PTBs.default)[700],
        light: (0, $9PTBs.default)[400],
        dark: (0, $9PTBs.default)[800]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $1Btry.default)[400],
        light: (0, $1Btry.default)[300],
        dark: (0, $1Btry.default)[700]
    };
    return {
        main: (0, $1Btry.default)[700],
        light: (0, $1Btry.default)[500],
        dark: (0, $1Btry.default)[900]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $hnm6Q.default)[400],
        light: (0, $hnm6Q.default)[300],
        dark: (0, $hnm6Q.default)[700]
    };
    return {
        main: (0, $hnm6Q.default)[800],
        light: (0, $hnm6Q.default)[500],
        dark: (0, $hnm6Q.default)[900]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $5WQac.default)[400],
        light: (0, $5WQac.default)[300],
        dark: (0, $5WQac.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $5WQac.default)[500],
        dark: (0, $5WQac.default)[900]
    };
}
function $07e9efd96a5c6f8a$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $cFLic.default)(palette, $07e9efd96a5c6f8a$var$_excluded);
    const primary = palette.primary || $07e9efd96a5c6f8a$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $07e9efd96a5c6f8a$var$getDefaultSecondary(mode);
    const error = palette.error || $07e9efd96a5c6f8a$var$getDefaultError(mode);
    const info = palette.info || $07e9efd96a5c6f8a$var$getDefaultInfo(mode);
    const success = palette.success || $07e9efd96a5c6f8a$var$getDefaultSuccess(mode);
    const warning = palette.warning || $07e9efd96a5c6f8a$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $cxeT8.getContrastRatio)(background, $07e9efd96a5c6f8a$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $07e9efd96a5c6f8a$export$55ce6f3a06c59543.text.primary : $07e9efd96a5c6f8a$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $kY3Ke.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $e5zLi.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $e5zLi.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $07e9efd96a5c6f8a$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $07e9efd96a5c6f8a$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $07e9efd96a5c6f8a$export$55ce6f3a06c59543,
        light: $07e9efd96a5c6f8a$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $dYkRa.default)((0, $kY3Ke.default)({
        // A collection of common colors.
        common: (0, $kY3Ke.default)({}, (0, $6akYf.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $2nhXL.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("cxeT8", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", function () { return $92041da11764723e$export$d061e26956a60b0a; });
$parcel$export(module.exports, "alpha", function () { return $92041da11764723e$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "darken", function () { return $92041da11764723e$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $92041da11764723e$export$c0816ed86df316af; });
$parcel$export(module.exports, "emphasize", function () { return $92041da11764723e$export$e665714f76e581fd; });

var $e5zLi = parcelRequire("e5zLi");
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $92041da11764723e$var$clamp(value, min = 0, max = 1) {
    return Math.min(Math.max(min, value), max);
}
function $92041da11764723e$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $92041da11764723e$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $92041da11764723e$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $92041da11764723e$export$677b39864803984e($92041da11764723e$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $e5zLi.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $e5zLi.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $92041da11764723e$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $92041da11764723e$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $92041da11764723e$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $92041da11764723e$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $92041da11764723e$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $92041da11764723e$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $92041da11764723e$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$92041da11764723e$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $92041da11764723e$export$29fb7152bd3f781a(color) {
    color = $92041da11764723e$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $92041da11764723e$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $92041da11764723e$export$c852d90bf7403b62(color) {
    color = $92041da11764723e$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $92041da11764723e$export$677b39864803984e($92041da11764723e$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $92041da11764723e$export$d061e26956a60b0a(foreground, background) {
    const lumA = $92041da11764723e$export$c852d90bf7403b62(foreground);
    const lumB = $92041da11764723e$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $92041da11764723e$export$58f0f39f63f3cf42(color, value) {
    color = $92041da11764723e$export$677b39864803984e(color);
    value = $92041da11764723e$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $92041da11764723e$export$211a73f2b8c10ce4(color);
}
function $92041da11764723e$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $92041da11764723e$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $92041da11764723e$export$4b073707ff63303(color, coefficient) {
    color = $92041da11764723e$export$677b39864803984e(color);
    coefficient = $92041da11764723e$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $92041da11764723e$export$211a73f2b8c10ce4(color);
}
function $92041da11764723e$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $92041da11764723e$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $92041da11764723e$export$c0816ed86df316af(color, coefficient) {
    color = $92041da11764723e$export$677b39864803984e(color);
    coefficient = $92041da11764723e$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $92041da11764723e$export$211a73f2b8c10ce4(color);
}
function $92041da11764723e$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $92041da11764723e$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $92041da11764723e$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $92041da11764723e$export$c852d90bf7403b62(color) > 0.5 ? $92041da11764723e$export$4b073707ff63303(color, coefficient) : $92041da11764723e$export$c0816ed86df316af(color, coefficient);
}
function $92041da11764723e$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $92041da11764723e$export$11bb74ba10c85505(color, coefficient);
    } catch (error) {
        return color;
    }
}

});

parcelRegister("6akYf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47d3f19e39b3b144$export$2e2bcd8739ae039; });
const $47d3f19e39b3b144$var$common = {
    black: "#000",
    white: "#fff"
};
var $47d3f19e39b3b144$export$2e2bcd8739ae039 = $47d3f19e39b3b144$var$common;

});

parcelRegister("2nhXL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1baba9d0f229a247$export$2e2bcd8739ae039; });
const $1baba9d0f229a247$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $1baba9d0f229a247$export$2e2bcd8739ae039 = $1baba9d0f229a247$var$grey;

});

parcelRegister("3Ctzq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a2bdbc6cce4aa96$export$2e2bcd8739ae039; });
const $2a2bdbc6cce4aa96$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $2a2bdbc6cce4aa96$export$2e2bcd8739ae039 = $2a2bdbc6cce4aa96$var$purple;

});

parcelRegister("9PTBs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72940215fdf862f4$export$2e2bcd8739ae039; });
const $72940215fdf862f4$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $72940215fdf862f4$export$2e2bcd8739ae039 = $72940215fdf862f4$var$red;

});

parcelRegister("5WQac", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $454ad523c90fa85d$export$2e2bcd8739ae039; });
const $454ad523c90fa85d$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $454ad523c90fa85d$export$2e2bcd8739ae039 = $454ad523c90fa85d$var$orange;

});

parcelRegister("gal31", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc4de82bafd68977$export$2e2bcd8739ae039; });
const $bc4de82bafd68977$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $bc4de82bafd68977$export$2e2bcd8739ae039 = $bc4de82bafd68977$var$blue;

});

parcelRegister("1Btry", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12b015f9ee6c8f9f$export$2e2bcd8739ae039; });
const $12b015f9ee6c8f9f$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $12b015f9ee6c8f9f$export$2e2bcd8739ae039 = $12b015f9ee6c8f9f$var$lightBlue;

});

parcelRegister("hnm6Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca65bc19996a7eac$export$2e2bcd8739ae039; });
const $ca65bc19996a7eac$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $ca65bc19996a7eac$export$2e2bcd8739ae039 = $ca65bc19996a7eac$var$green;

});


parcelRegister("5vuSA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4027cd084802bc60$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $dYkRa = parcelRequire("dYkRa");
const $4027cd084802bc60$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $4027cd084802bc60$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $4027cd084802bc60$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $4027cd084802bc60$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $4027cd084802bc60$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $4027cd084802bc60$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $cFLic.default)(_ref, $4027cd084802bc60$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $kY3Ke.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $4027cd084802bc60$var$defaultFontFamily ? {
            letterSpacing: `${$4027cd084802bc60$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $4027cd084802bc60$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $4027cd084802bc60$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $dYkRa.default)((0, $kY3Ke.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("3jGgo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26a3ee12a0d43232$export$2e2bcd8739ae039; });
const $26a3ee12a0d43232$var$shadowKeyUmbraOpacity = 0.2;
const $26a3ee12a0d43232$var$shadowKeyPenumbraOpacity = 0.14;
const $26a3ee12a0d43232$var$shadowAmbientShadowOpacity = 0.12;
function $26a3ee12a0d43232$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $26a3ee12a0d43232$var$shadows = [
    "none",
    $26a3ee12a0d43232$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $26a3ee12a0d43232$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $26a3ee12a0d43232$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $26a3ee12a0d43232$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $26a3ee12a0d43232$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $26a3ee12a0d43232$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $26a3ee12a0d43232$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $26a3ee12a0d43232$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $26a3ee12a0d43232$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $26a3ee12a0d43232$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $26a3ee12a0d43232$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $26a3ee12a0d43232$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $26a3ee12a0d43232$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $26a3ee12a0d43232$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $26a3ee12a0d43232$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $26a3ee12a0d43232$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $26a3ee12a0d43232$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $26a3ee12a0d43232$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $26a3ee12a0d43232$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $26a3ee12a0d43232$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $26a3ee12a0d43232$export$2e2bcd8739ae039 = $26a3ee12a0d43232$var$shadows;

});

parcelRegister("kjiCM", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $ec94076b9ecccee1$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $ec94076b9ecccee1$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
const $ec94076b9ecccee1$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $ec94076b9ecccee1$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $ec94076b9ecccee1$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $ec94076b9ecccee1$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $ec94076b9ecccee1$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $ec94076b9ecccee1$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $kY3Ke.default)({}, $ec94076b9ecccee1$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $kY3Ke.default)({}, $ec94076b9ecccee1$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $cFLic.default)(options, $ec94076b9ecccee1$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $ec94076b9ecccee1$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $ec94076b9ecccee1$var$formatMs(delay)}`).join(",");
    };
    return (0, $kY3Ke.default)({
        getAutoHeightDuration: $ec94076b9ecccee1$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("eGmqa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab06614e124e32b2$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $ab06614e124e32b2$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $ab06614e124e32b2$export$2e2bcd8739ae039 = $ab06614e124e32b2$var$zIndex;

});



parcelRegister("jwhZE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e35ef6915a224202$export$2e2bcd8739ae039; });
var $e35ef6915a224202$export$2e2bcd8739ae039 = "$$material";

});


parcelRegister("kDBhE", function(module, exports) {

$parcel$export(module.exports, "rootShouldForwardProp", function () { return $f0645ef192f222f7$export$effb20ecdbf4d6aa; });
$parcel$export(module.exports, "slotShouldForwardProp", function () { return $f0645ef192f222f7$export$f10c5a10d27438e5; });
$parcel$export(module.exports, "default", function () { return $f0645ef192f222f7$export$2e2bcd8739ae039; });

var $UAzpO = parcelRequire("UAzpO");

var $9P91Y = parcelRequire("9P91Y");

var $jwhZE = parcelRequire("jwhZE");
"use client";
const $f0645ef192f222f7$export$effb20ecdbf4d6aa = (prop)=>(0, $UAzpO.shouldForwardProp)(prop) && prop !== "classes";
const $f0645ef192f222f7$export$f10c5a10d27438e5 = (0, $UAzpO.shouldForwardProp);
const $f0645ef192f222f7$var$styled = (0, $UAzpO.default)({
    themeId: (0, $jwhZE.default),
    defaultTheme: $9P91Y.default,
    rootShouldForwardProp: $f0645ef192f222f7$export$effb20ecdbf4d6aa
});
var $f0645ef192f222f7$export$2e2bcd8739ae039 = $f0645ef192f222f7$var$styled;

});
parcelRegister("UAzpO", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", function () { return $0aa19929000e58fe$export$3ba67b570e26eea0; });
$parcel$export(module.exports, "default", function () { return $0aa19929000e58fe$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $5VCcJ = parcelRequire("5VCcJ");

var $dYkRa = parcelRequire("dYkRa");

var $2G6xE = parcelRequire("2G6xE");

var $kQ3gK = parcelRequire("kQ3gK");

var $8M6a3 = parcelRequire("8M6a3");
const $0aa19929000e58fe$var$_excluded = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $0aa19929000e58fe$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $0aa19929000e58fe$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
const $0aa19929000e58fe$var$getStyleOverrides = (name, theme)=>{
    if (theme.components && theme.components[name] && theme.components[name].styleOverrides) return theme.components[name].styleOverrides;
    return null;
};
const $0aa19929000e58fe$var$transformVariants = (variants)=>{
    const variantsStyles = {};
    if (variants) variants.forEach((definition)=>{
        const key = (0, $kQ3gK.default)(definition.props);
        variantsStyles[key] = definition.style;
    });
    return variantsStyles;
};
const $0aa19929000e58fe$var$getVariantStyles = (name, theme)=>{
    let variants = [];
    if (theme && theme.components && theme.components[name] && theme.components[name].variants) variants = theme.components[name].variants;
    return $0aa19929000e58fe$var$transformVariants(variants);
};
const $0aa19929000e58fe$var$variantsResolver = (props, styles, variants)=>{
    const { ownerState: ownerState = {} } = props;
    const variantsStyles = [];
    if (variants) variants.forEach((variant)=>{
        let isMatch = true;
        Object.keys(variant.props).forEach((key)=>{
            if (ownerState[key] !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
        });
        if (isMatch) variantsStyles.push(styles[(0, $kQ3gK.default)(variant.props)]);
    });
    return variantsStyles;
};
const $0aa19929000e58fe$var$themeVariantsResolver = (props, styles, theme, name)=>{
    var _theme$components;
    const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[name]) == null ? void 0 : _theme$components.variants;
    return $0aa19929000e58fe$var$variantsResolver(props, styles, themeVariants);
};
function $0aa19929000e58fe$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $0aa19929000e58fe$export$35e57303dbd8a66 = (0, $2G6xE.default)();
const $0aa19929000e58fe$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $0aa19929000e58fe$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $0aa19929000e58fe$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $0aa19929000e58fe$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
const $0aa19929000e58fe$var$muiStyledFunctionResolver = ({ styledArg: styledArg, props: props, defaultTheme: defaultTheme, themeId: themeId })=>{
    const resolvedStyles = styledArg((0, $kY3Ke.default)({}, props, {
        theme: $0aa19929000e58fe$var$resolveTheme((0, $kY3Ke.default)({}, props, {
            defaultTheme: defaultTheme,
            themeId: themeId
        }))
    }));
    let optionalVariants;
    if (resolvedStyles && resolvedStyles.variants) {
        optionalVariants = resolvedStyles.variants;
        delete resolvedStyles.variants;
    }
    if (optionalVariants) {
        const variantsStyles = $0aa19929000e58fe$var$variantsResolver(props, $0aa19929000e58fe$var$transformVariants(optionalVariants), optionalVariants);
        return [
            resolvedStyles,
            ...variantsStyles
        ];
    }
    return resolvedStyles;
};
function $0aa19929000e58fe$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $0aa19929000e58fe$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $0aa19929000e58fe$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $0aa19929000e58fe$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $8M6a3.default)((0, $kY3Ke.default)({}, props, {
            theme: $0aa19929000e58fe$var$resolveTheme((0, $kY3Ke.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $5VCcJ.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $0aa19929000e58fe$var$defaultOverridesResolver($0aa19929000e58fe$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $cFLic.default)(inputOptions, $0aa19929000e58fe$var$_excluded);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $0aa19929000e58fe$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($0aa19929000e58fe$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $5VCcJ.default)(tag, (0, $kY3Ke.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const muiStyledResolver = (styleArg, ...expressions)=>{
            const expressionsWithDefaultTheme = expressions ? expressions.map((stylesArg)=>{
                // On the server Emotion doesn't use React.forwardRef for creating components, so the created
                // component stays as a function. This condition makes sure that we do not interpolate functions
                // which are basically components used as a selectors.
                if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg) return (props)=>$0aa19929000e58fe$var$muiStyledFunctionResolver({
                        styledArg: stylesArg,
                        props: props,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    });
                if ((0, $dYkRa.isPlainObject)(stylesArg)) {
                    let transformedStylesArg = stylesArg;
                    let styledArgVariants;
                    if (stylesArg && stylesArg.variants) {
                        styledArgVariants = stylesArg.variants;
                        delete transformedStylesArg.variants;
                        transformedStylesArg = (props)=>{
                            let result = stylesArg;
                            const variantStyles = $0aa19929000e58fe$var$variantsResolver(props, $0aa19929000e58fe$var$transformVariants(styledArgVariants), styledArgVariants);
                            variantStyles.forEach((variantStyle)=>{
                                result = (0, $dYkRa.default)(result, variantStyle);
                            });
                            return result;
                        };
                    }
                    return transformedStylesArg;
                }
                return stylesArg;
            }) : [];
            let transformedStyleArg = styleArg;
            if ((0, $dYkRa.isPlainObject)(styleArg)) {
                let styledArgVariants;
                if (styleArg && styleArg.variants) {
                    styledArgVariants = styleArg.variants;
                    delete transformedStyleArg.variants;
                    transformedStyleArg = (props)=>{
                        let result = styleArg;
                        const variantStyles = $0aa19929000e58fe$var$variantsResolver(props, $0aa19929000e58fe$var$transformVariants(styledArgVariants), styledArgVariants);
                        variantStyles.forEach((variantStyle)=>{
                            result = (0, $dYkRa.default)(result, variantStyle);
                        });
                        return result;
                    };
                }
            } else if (typeof styleArg === "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            styleArg.__emotion_real !== styleArg) // If the type is function, we need to define the default theme.
            transformedStyleArg = (props)=>$0aa19929000e58fe$var$muiStyledFunctionResolver({
                    styledArg: styleArg,
                    props: props,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $0aa19929000e58fe$var$resolveTheme((0, $kY3Ke.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const styleOverrides = $0aa19929000e58fe$var$getStyleOverrides(componentName, theme);
                if (styleOverrides) {
                    const resolvedStyleOverrides = {};
                    Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                        resolvedStyleOverrides[slotKey] = typeof slotStyle === "function" ? slotStyle((0, $kY3Ke.default)({}, props, {
                            theme: theme
                        })) : slotStyle;
                    });
                    return overridesResolver(props, resolvedStyleOverrides);
                }
                return null;
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $0aa19929000e58fe$var$resolveTheme((0, $kY3Ke.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                return $0aa19929000e58fe$var$themeVariantsResolver(props, $0aa19929000e58fe$var$getVariantStyles(componentName, theme), theme, componentName);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("5VCcJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $450fe936b88a7a32$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $450fe936b88a7a32$export$e00380445f2b9e0c; });
/**
 * @mui/styled-engine v5.14.16
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $cbgs6 = parcelRequire("cbgs6");
parcelRequire("bpHMA");
var $6H441 = parcelRequire("6H441");
var $bpHMA = parcelRequire("bpHMA");


var $5tMhb = parcelRequire("5tMhb");
"use client";
function $450fe936b88a7a32$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $cbgs6.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $450fe936b88a7a32$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("cbgs6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8de346382d86c747$export$2e2bcd8739ae039; });

var $2MQws = parcelRequire("2MQws");
parcelRequire("cvBp9");
parcelRequire("7fPBF");
parcelRequire("9YmaI");

parcelRequire("6g0AG");
parcelRequire("3kqr7");
parcelRequire("fjS7T");
var $8de346382d86c747$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $8de346382d86c747$export$2e2bcd8739ae039 = (0, $2MQws.default).bind();
$8de346382d86c747$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $8de346382d86c747$export$2e2bcd8739ae039[tagName] = $8de346382d86c747$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("2MQws", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2078ce513e00dfd7$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $9YmaI = parcelRequire("9YmaI");
parcelRequire("bpHMA");
var $6H441 = parcelRequire("6H441");

var $6g0AG = parcelRequire("6g0AG");

var $3kqr7 = parcelRequire("3kqr7");

var $fjS7T = parcelRequire("fjS7T");
var $2078ce513e00dfd7$var$testOmitPropsOnStringTag = (0, $9YmaI.default);
var $2078ce513e00dfd7$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $2078ce513e00dfd7$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $2078ce513e00dfd7$var$testOmitPropsOnStringTag : $2078ce513e00dfd7$var$testOmitPropsOnComponent;
};
var $2078ce513e00dfd7$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $2078ce513e00dfd7$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $2078ce513e00dfd7$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $6g0AG.registerStyles)(cache, serialized, isStringTag);
    (0, $fjS7T.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $6g0AG.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $2078ce513e00dfd7$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $2078ce513e00dfd7$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $2078ce513e00dfd7$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $6H441.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $7fPBF.useContext((0, $6H441.T));
            }
            if (typeof props.className === "string") className = (0, $6g0AG.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $3kqr7.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $2078ce513e00dfd7$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($2078ce513e00dfd7$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $7fPBF.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $kY3Ke.default)({}, options, nextOptions, {
                shouldForwardProp: $2078ce513e00dfd7$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("9YmaI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $742aea85e4e67b26$export$2e2bcd8739ae039; });

var $4AWAi = parcelRequire("4AWAi");
var $742aea85e4e67b26$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $742aea85e4e67b26$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $4AWAi.default)(function(prop) {
    return $742aea85e4e67b26$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("5tMhb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fd51bd676aa60b7$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");


var $bpHMA = parcelRequire("bpHMA");

var $bbzbN = parcelRequire("bbzbN");
"use client";
function $3fd51bd676aa60b7$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $3fd51bd676aa60b7$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($3fd51bd676aa60b7$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bpHMA.Global), {
        styles: globalStyles
    });
}

});
parcelRegister("bbzbN", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2nzLi"));

});



parcelRegister("kQ3gK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2bb3328370663ea$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $iCiVn = parcelRequire("iCiVn");
const $f2bb3328370663ea$var$_excluded = [
    "variant"
];
function $f2bb3328370663ea$var$isEmpty(string) {
    return string.length === 0;
}
function $f2bb3328370663ea$export$2e2bcd8739ae039(props) {
    const { variant: variant } = props, other = (0, $cFLic.default)(props, $f2bb3328370663ea$var$_excluded);
    let classKey = variant || "";
    Object.keys(other).sort().forEach((key)=>{
        if (key === "color") classKey += $f2bb3328370663ea$var$isEmpty(classKey) ? props[key] : (0, $iCiVn.default)(props[key]);
        else classKey += `${$f2bb3328370663ea$var$isEmpty(classKey) ? key : (0, $iCiVn.default)(key)}${(0, $iCiVn.default)(props[key].toString())}`;
    });
    return classKey;
}

});



parcelRegister("6VWZo", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $50c5d2f6ad13a504$export$c7c50641356bdfa5; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $50c5d2f6ad13a504$export$c7c50641356bdfa5(slot) {
    return (0, $k6RDS.default)("MuiSvgIcon", slot);
}
const $50c5d2f6ad13a504$var$svgIconClasses = (0, $4jzsB.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $50c5d2f6ad13a504$export$2e2bcd8739ae039 = $50c5d2f6ad13a504$var$svgIconClasses;

});
parcelRegister("4jzsB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32447174989d1976$export$2e2bcd8739ae039; });

var $k6RDS = parcelRequire("k6RDS");
function $32447174989d1976$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $k6RDS.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("k6RDS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea3dfa6b173640a4$export$2e2bcd8739ae039; });

var $kU6nt = parcelRequire("kU6nt");
// If GlobalStateSlot is changed, GLOBAL_STATE_CLASSES in
// \packages\api-docs-builder\utils\parseSlotsAndClasses.ts must be updated accordingly.
const $ea3dfa6b173640a4$var$globalStateClassesMapping = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $ea3dfa6b173640a4$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $ea3dfa6b173640a4$var$globalStateClassesMapping[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $kU6nt.default).generate(componentName)}-${slot}`;
}

});
parcelRegister("kU6nt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f37dfc12e5d89c96$export$2e2bcd8739ae039; });
const $f37dfc12e5d89c96$var$defaultGenerator = (componentName)=>componentName;
const $f37dfc12e5d89c96$var$createClassNameGenerator = ()=>{
    let generate = $f37dfc12e5d89c96$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $f37dfc12e5d89c96$var$defaultGenerator;
        }
    };
};
const $f37dfc12e5d89c96$var$ClassNameGenerator = $f37dfc12e5d89c96$var$createClassNameGenerator();
var $f37dfc12e5d89c96$export$2e2bcd8739ae039 = $f37dfc12e5d89c96$var$ClassNameGenerator;

});







parcelRegister("hzZfF", function(module, exports) {

var $aH9iS = parcelRequire("aH9iS");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $034d80e6a88ef527$var$isEqual(value, other) {
    return $aH9iS(value, other);
}
module.exports = $034d80e6a88ef527$var$isEqual;

});
parcelRegister("aH9iS", function(module, exports) {

var $h11tW = parcelRequire("h11tW");

var $d2kYI = parcelRequire("d2kYI");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $7c952302caee51c1$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$d2kYI(value) && !$d2kYI(other)) return value !== value && other !== other;
    return $h11tW(value, other, bitmask, customizer, $7c952302caee51c1$var$baseIsEqual, stack);
}
module.exports = $7c952302caee51c1$var$baseIsEqual;

});
parcelRegister("h11tW", function(module, exports) {

var $a6ECp = parcelRequire("a6ECp");

var $1JRPZ = parcelRequire("1JRPZ");

var $4eUTQ = parcelRequire("4eUTQ");

var $lgEYI = parcelRequire("lgEYI");

var $3tPzb = parcelRequire("3tPzb");

var $7wkJN = parcelRequire("7wkJN");

var $9gBlp = parcelRequire("9gBlp");

var $cuTxs = parcelRequire("cuTxs");
/** Used to compose bitmasks for value comparisons. */ var $c633adf42a0b7174$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $c633adf42a0b7174$var$argsTag = "[object Arguments]", $c633adf42a0b7174$var$arrayTag = "[object Array]", $c633adf42a0b7174$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $c633adf42a0b7174$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c633adf42a0b7174$var$hasOwnProperty = $c633adf42a0b7174$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $c633adf42a0b7174$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $7wkJN(object), othIsArr = $7wkJN(other), objTag = objIsArr ? $c633adf42a0b7174$var$arrayTag : $3tPzb(object), othTag = othIsArr ? $c633adf42a0b7174$var$arrayTag : $3tPzb(other);
    objTag = objTag == $c633adf42a0b7174$var$argsTag ? $c633adf42a0b7174$var$objectTag : objTag;
    othTag = othTag == $c633adf42a0b7174$var$argsTag ? $c633adf42a0b7174$var$objectTag : othTag;
    var objIsObj = objTag == $c633adf42a0b7174$var$objectTag, othIsObj = othTag == $c633adf42a0b7174$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $9gBlp(object)) {
        if (!$9gBlp(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $a6ECp);
        return objIsArr || $cuTxs(object) ? $1JRPZ(object, other, bitmask, customizer, equalFunc, stack) : $4eUTQ(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $c633adf42a0b7174$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $c633adf42a0b7174$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $c633adf42a0b7174$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $a6ECp);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $a6ECp);
    return $lgEYI(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $c633adf42a0b7174$var$baseIsEqualDeep;

});
parcelRegister("a6ECp", function(module, exports) {

var $ibr17 = parcelRequire("ibr17");

var $eoTVC = parcelRequire("eoTVC");

var $DoMSX = parcelRequire("DoMSX");

var $k4t2v = parcelRequire("k4t2v");

var $4NwfS = parcelRequire("4NwfS");

var $lcWk9 = parcelRequire("lcWk9");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $75b9f8e835026959$var$Stack(entries) {
    var data = this.__data__ = new $ibr17(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$75b9f8e835026959$var$Stack.prototype.clear = $eoTVC;
$75b9f8e835026959$var$Stack.prototype["delete"] = $DoMSX;
$75b9f8e835026959$var$Stack.prototype.get = $k4t2v;
$75b9f8e835026959$var$Stack.prototype.has = $4NwfS;
$75b9f8e835026959$var$Stack.prototype.set = $lcWk9;
module.exports = $75b9f8e835026959$var$Stack;

});
parcelRegister("ibr17", function(module, exports) {

var $foxyq = parcelRequire("foxyq");

var $13lJV = parcelRequire("13lJV");

var $jjKHO = parcelRequire("jjKHO");

var $9CRkh = parcelRequire("9CRkh");

var $gz97O = parcelRequire("gz97O");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d3ce36181053a891$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$d3ce36181053a891$var$ListCache.prototype.clear = $foxyq;
$d3ce36181053a891$var$ListCache.prototype["delete"] = $13lJV;
$d3ce36181053a891$var$ListCache.prototype.get = $jjKHO;
$d3ce36181053a891$var$ListCache.prototype.has = $9CRkh;
$d3ce36181053a891$var$ListCache.prototype.set = $gz97O;
module.exports = $d3ce36181053a891$var$ListCache;

});
parcelRegister("foxyq", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $b3532018e1ff9eab$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $b3532018e1ff9eab$var$listCacheClear;

});

parcelRegister("13lJV", function(module, exports) {

var $4Ptfn = parcelRequire("4Ptfn");
/** Used for built-in method references. */ var $0c46ef5003b13e31$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $0c46ef5003b13e31$var$splice = $0c46ef5003b13e31$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0c46ef5003b13e31$var$listCacheDelete(key) {
    var data = this.__data__, index = $4Ptfn(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $0c46ef5003b13e31$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $0c46ef5003b13e31$var$listCacheDelete;

});
parcelRegister("4Ptfn", function(module, exports) {

var $bGvkD = parcelRequire("bGvkD");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $38429cb5a86e691c$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($bGvkD(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $38429cb5a86e691c$var$assocIndexOf;

});
parcelRegister("bGvkD", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $881bebc960934ade$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $881bebc960934ade$var$eq;

});



parcelRegister("jjKHO", function(module, exports) {

var $4Ptfn = parcelRequire("4Ptfn");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e1040571ebb469f5$var$listCacheGet(key) {
    var data = this.__data__, index = $4Ptfn(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $e1040571ebb469f5$var$listCacheGet;

});

parcelRegister("9CRkh", function(module, exports) {

var $4Ptfn = parcelRequire("4Ptfn");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7021072296e166d7$var$listCacheHas(key) {
    return $4Ptfn(this.__data__, key) > -1;
}
module.exports = $7021072296e166d7$var$listCacheHas;

});

parcelRegister("gz97O", function(module, exports) {

var $4Ptfn = parcelRequire("4Ptfn");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $c0f6fe3ec712f3b3$var$listCacheSet(key, value) {
    var data = this.__data__, index = $4Ptfn(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $c0f6fe3ec712f3b3$var$listCacheSet;

});


parcelRegister("eoTVC", function(module, exports) {

var $ibr17 = parcelRequire("ibr17");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $a7beb0ce4fa4126e$var$stackClear() {
    this.__data__ = new $ibr17;
    this.size = 0;
}
module.exports = $a7beb0ce4fa4126e$var$stackClear;

});

parcelRegister("DoMSX", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0766dee8ae28686e$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $0766dee8ae28686e$var$stackDelete;

});

parcelRegister("k4t2v", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e9cab4f83b8cf2e9$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $e9cab4f83b8cf2e9$var$stackGet;

});

parcelRegister("4NwfS", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $37e4c239050b91e3$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $37e4c239050b91e3$var$stackHas;

});

parcelRegister("lcWk9", function(module, exports) {

var $ibr17 = parcelRequire("ibr17");

var $55ur3 = parcelRequire("55ur3");

var $ejRls = parcelRequire("ejRls");
/** Used as the size to enable large array optimizations. */ var $f707f5e6173bece0$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $f707f5e6173bece0$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $ibr17) {
        var pairs = data.__data__;
        if (!$55ur3 || pairs.length < $f707f5e6173bece0$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $ejRls(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $f707f5e6173bece0$var$stackSet;

});
parcelRegister("55ur3", function(module, exports) {

var $cS0Ds = parcelRequire("cS0Ds");

var $1DySm = parcelRequire("1DySm");
/* Built-in method references that are verified to be native. */ var $3b45073a9f2f1273$var$Map = $cS0Ds($1DySm, "Map");
module.exports = $3b45073a9f2f1273$var$Map;

});
parcelRegister("cS0Ds", function(module, exports) {

var $fRlj1 = parcelRequire("fRlj1");

var $1kkOJ = parcelRequire("1kkOJ");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $95eb055fdd27d869$var$getNative(object, key) {
    var value = $1kkOJ(object, key);
    return $fRlj1(value) ? value : undefined;
}
module.exports = $95eb055fdd27d869$var$getNative;

});
parcelRegister("fRlj1", function(module, exports) {

var $Fb9OL = parcelRequire("Fb9OL");

var $k5w0M = parcelRequire("k5w0M");

var $kSkOG = parcelRequire("kSkOG");

var $kZRNU = parcelRequire("kZRNU");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $b8bc552383eab615$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $b8bc552383eab615$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $b8bc552383eab615$var$funcProto = Function.prototype, $b8bc552383eab615$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $b8bc552383eab615$var$funcToString = $b8bc552383eab615$var$funcProto.toString;
/** Used to check objects for own properties. */ var $b8bc552383eab615$var$hasOwnProperty = $b8bc552383eab615$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $b8bc552383eab615$var$reIsNative = RegExp("^" + $b8bc552383eab615$var$funcToString.call($b8bc552383eab615$var$hasOwnProperty).replace($b8bc552383eab615$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $b8bc552383eab615$var$baseIsNative(value) {
    if (!$kSkOG(value) || $k5w0M(value)) return false;
    var pattern = $Fb9OL(value) ? $b8bc552383eab615$var$reIsNative : $b8bc552383eab615$var$reIsHostCtor;
    return pattern.test($kZRNU(value));
}
module.exports = $b8bc552383eab615$var$baseIsNative;

});
parcelRegister("Fb9OL", function(module, exports) {

var $eXwEi = parcelRequire("eXwEi");

var $kSkOG = parcelRequire("kSkOG");
/** `Object#toString` result references. */ var $07bc7c115e963817$var$asyncTag = "[object AsyncFunction]", $07bc7c115e963817$var$funcTag = "[object Function]", $07bc7c115e963817$var$genTag = "[object GeneratorFunction]", $07bc7c115e963817$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $07bc7c115e963817$var$isFunction(value) {
    if (!$kSkOG(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $eXwEi(value);
    return tag == $07bc7c115e963817$var$funcTag || tag == $07bc7c115e963817$var$genTag || tag == $07bc7c115e963817$var$asyncTag || tag == $07bc7c115e963817$var$proxyTag;
}
module.exports = $07bc7c115e963817$var$isFunction;

});
parcelRegister("eXwEi", function(module, exports) {

var $hjYSj = parcelRequire("hjYSj");

var $adgZm = parcelRequire("adgZm");

var $ahXW6 = parcelRequire("ahXW6");
/** `Object#toString` result references. */ var $ae3fe6c5950c122e$var$nullTag = "[object Null]", $ae3fe6c5950c122e$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $ae3fe6c5950c122e$var$symToStringTag = $hjYSj ? $hjYSj.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $ae3fe6c5950c122e$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $ae3fe6c5950c122e$var$undefinedTag : $ae3fe6c5950c122e$var$nullTag;
    return $ae3fe6c5950c122e$var$symToStringTag && $ae3fe6c5950c122e$var$symToStringTag in Object(value) ? $adgZm(value) : $ahXW6(value);
}
module.exports = $ae3fe6c5950c122e$var$baseGetTag;

});
parcelRegister("hjYSj", function(module, exports) {

var $1DySm = parcelRequire("1DySm");
/** Built-in value references. */ var $c9c36e86f7d6f497$var$Symbol = $1DySm.Symbol;
module.exports = $c9c36e86f7d6f497$var$Symbol;

});
parcelRegister("1DySm", function(module, exports) {

var $8X2yT = parcelRequire("8X2yT");
/** Detect free variable `self`. */ var $13147c93e8511c05$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $13147c93e8511c05$var$root = $8X2yT || $13147c93e8511c05$var$freeSelf || Function("return this")();
module.exports = $13147c93e8511c05$var$root;

});
parcelRegister("8X2yT", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $6845d21fa7e75b3b$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $6845d21fa7e75b3b$var$freeGlobal;

});



parcelRegister("adgZm", function(module, exports) {

var $hjYSj = parcelRequire("hjYSj");
/** Used for built-in method references. */ var $76f84bdae49ee13c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $76f84bdae49ee13c$var$hasOwnProperty = $76f84bdae49ee13c$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $76f84bdae49ee13c$var$nativeObjectToString = $76f84bdae49ee13c$var$objectProto.toString;
/** Built-in value references. */ var $76f84bdae49ee13c$var$symToStringTag = $hjYSj ? $hjYSj.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $76f84bdae49ee13c$var$getRawTag(value) {
    var isOwn = $76f84bdae49ee13c$var$hasOwnProperty.call(value, $76f84bdae49ee13c$var$symToStringTag), tag = value[$76f84bdae49ee13c$var$symToStringTag];
    try {
        value[$76f84bdae49ee13c$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $76f84bdae49ee13c$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$76f84bdae49ee13c$var$symToStringTag] = tag;
        else delete value[$76f84bdae49ee13c$var$symToStringTag];
    }
    return result;
}
module.exports = $76f84bdae49ee13c$var$getRawTag;

});

parcelRegister("ahXW6", function(module, exports) {
/** Used for built-in method references. */ var $77d9fbfccc3fe2a6$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $77d9fbfccc3fe2a6$var$nativeObjectToString = $77d9fbfccc3fe2a6$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $77d9fbfccc3fe2a6$var$objectToString(value) {
    return $77d9fbfccc3fe2a6$var$nativeObjectToString.call(value);
}
module.exports = $77d9fbfccc3fe2a6$var$objectToString;

});


parcelRegister("kSkOG", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f328ff7ee4fde81a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $f328ff7ee4fde81a$var$isObject;

});


parcelRegister("k5w0M", function(module, exports) {

var $24tqU = parcelRequire("24tqU");
/** Used to detect methods masquerading as native. */ var $e9fd1b1d57dc1cf8$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($24tqU && $24tqU.keys && $24tqU.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $e9fd1b1d57dc1cf8$var$isMasked(func) {
    return !!$e9fd1b1d57dc1cf8$var$maskSrcKey && $e9fd1b1d57dc1cf8$var$maskSrcKey in func;
}
module.exports = $e9fd1b1d57dc1cf8$var$isMasked;

});
parcelRegister("24tqU", function(module, exports) {

var $1DySm = parcelRequire("1DySm");
/** Used to detect overreaching core-js shims. */ var $1822c948e6f3062a$var$coreJsData = $1DySm["__core-js_shared__"];
module.exports = $1822c948e6f3062a$var$coreJsData;

});


parcelRegister("kZRNU", function(module, exports) {
/** Used for built-in method references. */ var $f4933d7f0a06eb7d$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $f4933d7f0a06eb7d$var$funcToString = $f4933d7f0a06eb7d$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $f4933d7f0a06eb7d$var$toSource(func) {
    if (func != null) {
        try {
            return $f4933d7f0a06eb7d$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $f4933d7f0a06eb7d$var$toSource;

});


parcelRegister("1kkOJ", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $0f77ce8dc1867245$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $0f77ce8dc1867245$var$getValue;

});



parcelRegister("ejRls", function(module, exports) {

var $8Amwq = parcelRequire("8Amwq");

var $7v4cX = parcelRequire("7v4cX");

var $46YH9 = parcelRequire("46YH9");

var $2YNeK = parcelRequire("2YNeK");

var $fq6pV = parcelRequire("fq6pV");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a6cc38418910b2e0$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$a6cc38418910b2e0$var$MapCache.prototype.clear = $8Amwq;
$a6cc38418910b2e0$var$MapCache.prototype["delete"] = $7v4cX;
$a6cc38418910b2e0$var$MapCache.prototype.get = $46YH9;
$a6cc38418910b2e0$var$MapCache.prototype.has = $2YNeK;
$a6cc38418910b2e0$var$MapCache.prototype.set = $fq6pV;
module.exports = $a6cc38418910b2e0$var$MapCache;

});
parcelRegister("8Amwq", function(module, exports) {

var $5kvl6 = parcelRequire("5kvl6");

var $ibr17 = parcelRequire("ibr17");

var $55ur3 = parcelRequire("55ur3");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $640327eb3d1069cf$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $5kvl6,
        "map": new ($55ur3 || $ibr17),
        "string": new $5kvl6
    };
}
module.exports = $640327eb3d1069cf$var$mapCacheClear;

});
parcelRegister("5kvl6", function(module, exports) {

var $gGs3m = parcelRequire("gGs3m");

var $dj7NW = parcelRequire("dj7NW");

var $g496M = parcelRequire("g496M");

var $th0Zm = parcelRequire("th0Zm");

var $biNn6 = parcelRequire("biNn6");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3e17215e62373b7a$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$3e17215e62373b7a$var$Hash.prototype.clear = $gGs3m;
$3e17215e62373b7a$var$Hash.prototype["delete"] = $dj7NW;
$3e17215e62373b7a$var$Hash.prototype.get = $g496M;
$3e17215e62373b7a$var$Hash.prototype.has = $th0Zm;
$3e17215e62373b7a$var$Hash.prototype.set = $biNn6;
module.exports = $3e17215e62373b7a$var$Hash;

});
parcelRegister("gGs3m", function(module, exports) {

var $boWgw = parcelRequire("boWgw");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $c25654624248087e$var$hashClear() {
    this.__data__ = $boWgw ? $boWgw(null) : {};
    this.size = 0;
}
module.exports = $c25654624248087e$var$hashClear;

});
parcelRegister("boWgw", function(module, exports) {

var $cS0Ds = parcelRequire("cS0Ds");
/* Built-in method references that are verified to be native. */ var $84cf21ec84c19391$var$nativeCreate = $cS0Ds(Object, "create");
module.exports = $84cf21ec84c19391$var$nativeCreate;

});


parcelRegister("dj7NW", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9b031a80da354f86$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $9b031a80da354f86$var$hashDelete;

});

parcelRegister("g496M", function(module, exports) {

var $boWgw = parcelRequire("boWgw");
/** Used to stand-in for `undefined` hash values. */ var $bb2415c9bb53848d$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $bb2415c9bb53848d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bb2415c9bb53848d$var$hasOwnProperty = $bb2415c9bb53848d$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $bb2415c9bb53848d$var$hashGet(key) {
    var data = this.__data__;
    if ($boWgw) {
        var result = data[key];
        return result === $bb2415c9bb53848d$var$HASH_UNDEFINED ? undefined : result;
    }
    return $bb2415c9bb53848d$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $bb2415c9bb53848d$var$hashGet;

});

parcelRegister("th0Zm", function(module, exports) {

var $boWgw = parcelRequire("boWgw");
/** Used for built-in method references. */ var $057fe85caf4b041d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $057fe85caf4b041d$var$hasOwnProperty = $057fe85caf4b041d$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $057fe85caf4b041d$var$hashHas(key) {
    var data = this.__data__;
    return $boWgw ? data[key] !== undefined : $057fe85caf4b041d$var$hasOwnProperty.call(data, key);
}
module.exports = $057fe85caf4b041d$var$hashHas;

});

parcelRegister("biNn6", function(module, exports) {

var $boWgw = parcelRequire("boWgw");
/** Used to stand-in for `undefined` hash values. */ var $83a7ac52366bc66e$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $83a7ac52366bc66e$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $boWgw && value === undefined ? $83a7ac52366bc66e$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $83a7ac52366bc66e$var$hashSet;

});



parcelRegister("7v4cX", function(module, exports) {

var $jUk43 = parcelRequire("jUk43");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $575eb14ab2b31b03$var$mapCacheDelete(key) {
    var result = $jUk43(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $575eb14ab2b31b03$var$mapCacheDelete;

});
parcelRegister("jUk43", function(module, exports) {

var $8P708 = parcelRequire("8P708");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $e7e2cfab823d50ee$var$getMapData(map, key) {
    var data = map.__data__;
    return $8P708(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $e7e2cfab823d50ee$var$getMapData;

});
parcelRegister("8P708", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $66c884747b0ddd4d$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $66c884747b0ddd4d$var$isKeyable;

});



parcelRegister("46YH9", function(module, exports) {

var $jUk43 = parcelRequire("jUk43");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $2fe6cdb7e5c793dc$var$mapCacheGet(key) {
    return $jUk43(this, key).get(key);
}
module.exports = $2fe6cdb7e5c793dc$var$mapCacheGet;

});

parcelRegister("2YNeK", function(module, exports) {

var $jUk43 = parcelRequire("jUk43");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $22b760cf30a31377$var$mapCacheHas(key) {
    return $jUk43(this, key).has(key);
}
module.exports = $22b760cf30a31377$var$mapCacheHas;

});

parcelRegister("fq6pV", function(module, exports) {

var $jUk43 = parcelRequire("jUk43");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $b39e430f93ec17f8$var$mapCacheSet(key, value) {
    var data = $jUk43(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $b39e430f93ec17f8$var$mapCacheSet;

});




parcelRegister("1JRPZ", function(module, exports) {

var $aKlWX = parcelRequire("aKlWX");

var $gGKJn = parcelRequire("gGKJn");

var $8fDqx = parcelRequire("8fDqx");
/** Used to compose bitmasks for value comparisons. */ var $1443c170489acf32$var$COMPARE_PARTIAL_FLAG = 1, $1443c170489acf32$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1443c170489acf32$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1443c170489acf32$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1443c170489acf32$var$COMPARE_UNORDERED_FLAG ? new $aKlWX : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$gGKJn(other, function(othValue, othIndex) {
                if (!$8fDqx(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = $1443c170489acf32$var$equalArrays;

});
parcelRegister("aKlWX", function(module, exports) {

var $ejRls = parcelRequire("ejRls");

var $lcsEj = parcelRequire("lcsEj");

var $kDzQ4 = parcelRequire("kDzQ4");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $7d2f3a0d9ce14f26$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $ejRls;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$7d2f3a0d9ce14f26$var$SetCache.prototype.add = $7d2f3a0d9ce14f26$var$SetCache.prototype.push = $lcsEj;
$7d2f3a0d9ce14f26$var$SetCache.prototype.has = $kDzQ4;
module.exports = $7d2f3a0d9ce14f26$var$SetCache;

});
parcelRegister("lcsEj", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $f6f0f11ce35948e9$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $f6f0f11ce35948e9$var$setCacheAdd(value) {
    this.__data__.set(value, $f6f0f11ce35948e9$var$HASH_UNDEFINED);
    return this;
}
module.exports = $f6f0f11ce35948e9$var$setCacheAdd;

});

parcelRegister("kDzQ4", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $f0633ffdd75034a5$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $f0633ffdd75034a5$var$setCacheHas;

});


parcelRegister("gGKJn", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $c264d15e7c8deb78$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $c264d15e7c8deb78$var$arraySome;

});

parcelRegister("8fDqx", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $601e4ed5362647b9$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $601e4ed5362647b9$var$cacheHas;

});


parcelRegister("4eUTQ", function(module, exports) {

var $hjYSj = parcelRequire("hjYSj");

var $bdBvw = parcelRequire("bdBvw");

var $bGvkD = parcelRequire("bGvkD");

var $1JRPZ = parcelRequire("1JRPZ");

var $3zqiw = parcelRequire("3zqiw");

var $kqPJB = parcelRequire("kqPJB");
/** Used to compose bitmasks for value comparisons. */ var $31649b4ecd936387$var$COMPARE_PARTIAL_FLAG = 1, $31649b4ecd936387$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $31649b4ecd936387$var$boolTag = "[object Boolean]", $31649b4ecd936387$var$dateTag = "[object Date]", $31649b4ecd936387$var$errorTag = "[object Error]", $31649b4ecd936387$var$mapTag = "[object Map]", $31649b4ecd936387$var$numberTag = "[object Number]", $31649b4ecd936387$var$regexpTag = "[object RegExp]", $31649b4ecd936387$var$setTag = "[object Set]", $31649b4ecd936387$var$stringTag = "[object String]", $31649b4ecd936387$var$symbolTag = "[object Symbol]";
var $31649b4ecd936387$var$arrayBufferTag = "[object ArrayBuffer]", $31649b4ecd936387$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $31649b4ecd936387$var$symbolProto = $hjYSj ? $hjYSj.prototype : undefined, $31649b4ecd936387$var$symbolValueOf = $31649b4ecd936387$var$symbolProto ? $31649b4ecd936387$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $31649b4ecd936387$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $31649b4ecd936387$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $31649b4ecd936387$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $bdBvw(object), new $bdBvw(other))) return false;
            return true;
        case $31649b4ecd936387$var$boolTag:
        case $31649b4ecd936387$var$dateTag:
        case $31649b4ecd936387$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $bGvkD(+object, +other);
        case $31649b4ecd936387$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $31649b4ecd936387$var$regexpTag:
        case $31649b4ecd936387$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $31649b4ecd936387$var$mapTag:
            var convert = $3zqiw;
        case $31649b4ecd936387$var$setTag:
            var isPartial = bitmask & $31649b4ecd936387$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $kqPJB);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $31649b4ecd936387$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1JRPZ(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $31649b4ecd936387$var$symbolTag:
            if ($31649b4ecd936387$var$symbolValueOf) return $31649b4ecd936387$var$symbolValueOf.call(object) == $31649b4ecd936387$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $31649b4ecd936387$var$equalByTag;

});
parcelRegister("bdBvw", function(module, exports) {

var $1DySm = parcelRequire("1DySm");
/** Built-in value references. */ var $82ae00c827cb4de5$var$Uint8Array = $1DySm.Uint8Array;
module.exports = $82ae00c827cb4de5$var$Uint8Array;

});

parcelRegister("3zqiw", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $29990a2aa372abaa$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $29990a2aa372abaa$var$mapToArray;

});

parcelRegister("kqPJB", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $edfe5dc5ee94a646$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $edfe5dc5ee94a646$var$setToArray;

});


parcelRegister("lgEYI", function(module, exports) {

var $ftbiQ = parcelRequire("ftbiQ");
/** Used to compose bitmasks for value comparisons. */ var $f7bae1035bea0715$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $f7bae1035bea0715$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f7bae1035bea0715$var$hasOwnProperty = $f7bae1035bea0715$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $f7bae1035bea0715$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $f7bae1035bea0715$var$COMPARE_PARTIAL_FLAG, objProps = $ftbiQ(object), objLength = objProps.length, othProps = $ftbiQ(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $f7bae1035bea0715$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = $f7bae1035bea0715$var$equalObjects;

});
parcelRegister("ftbiQ", function(module, exports) {

var $7Pscw = parcelRequire("7Pscw");

var $lgL09 = parcelRequire("lgL09");

var $1m8gD = parcelRequire("1m8gD");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $b43254fda44c104a$var$getAllKeys(object) {
    return $7Pscw(object, $1m8gD, $lgL09);
}
module.exports = $b43254fda44c104a$var$getAllKeys;

});
parcelRegister("7Pscw", function(module, exports) {

var $kAZ2U = parcelRequire("kAZ2U");

var $7wkJN = parcelRequire("7wkJN");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $5b332bf09b0c6ec2$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $7wkJN(object) ? result : $kAZ2U(result, symbolsFunc(object));
}
module.exports = $5b332bf09b0c6ec2$var$baseGetAllKeys;

});
parcelRegister("kAZ2U", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $efe685e6768936ef$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $efe685e6768936ef$var$arrayPush;

});

parcelRegister("7wkJN", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $579b9ba2588bb9de$var$isArray = Array.isArray;
module.exports = $579b9ba2588bb9de$var$isArray;

});


parcelRegister("lgL09", function(module, exports) {

var $iiRuw = parcelRequire("iiRuw");

var $lJTi6 = parcelRequire("lJTi6");
/** Used for built-in method references. */ var $f7bf8d1519698205$var$objectProto = Object.prototype;
/** Built-in value references. */ var $f7bf8d1519698205$var$propertyIsEnumerable = $f7bf8d1519698205$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f7bf8d1519698205$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $f7bf8d1519698205$var$getSymbols = !$f7bf8d1519698205$var$nativeGetSymbols ? $lJTi6 : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $iiRuw($f7bf8d1519698205$var$nativeGetSymbols(object), function(symbol) {
        return $f7bf8d1519698205$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $f7bf8d1519698205$var$getSymbols;

});
parcelRegister("iiRuw", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $d53366b2ff590363$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $d53366b2ff590363$var$arrayFilter;

});

parcelRegister("lJTi6", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $fd38b0983d4c349d$var$stubArray() {
    return [];
}
module.exports = $fd38b0983d4c349d$var$stubArray;

});


parcelRegister("1m8gD", function(module, exports) {

var $1NsVH = parcelRequire("1NsVH");

var $gjkox = parcelRequire("gjkox");

var $5VpCg = parcelRequire("5VpCg");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $0fce4239ee480ef0$var$keys(object) {
    return $5VpCg(object) ? $1NsVH(object) : $gjkox(object);
}
module.exports = $0fce4239ee480ef0$var$keys;

});
parcelRegister("1NsVH", function(module, exports) {

var $3GJcb = parcelRequire("3GJcb");

var $6O5ny = parcelRequire("6O5ny");

var $7wkJN = parcelRequire("7wkJN");

var $9gBlp = parcelRequire("9gBlp");

var $e8xSQ = parcelRequire("e8xSQ");

var $cuTxs = parcelRequire("cuTxs");
/** Used for built-in method references. */ var $14f0cee26f6289b7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $14f0cee26f6289b7$var$hasOwnProperty = $14f0cee26f6289b7$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $14f0cee26f6289b7$var$arrayLikeKeys(value, inherited) {
    var isArr = $7wkJN(value), isArg = !isArr && $6O5ny(value), isBuff = !isArr && !isArg && $9gBlp(value), isType = !isArr && !isArg && !isBuff && $cuTxs(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $3GJcb(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $14f0cee26f6289b7$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $e8xSQ(key, length)))) result.push(key);
    return result;
}
module.exports = $14f0cee26f6289b7$var$arrayLikeKeys;

});
parcelRegister("3GJcb", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $2af85a3e5a570ba7$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $2af85a3e5a570ba7$var$baseTimes;

});

parcelRegister("6O5ny", function(module, exports) {

var $1VgPC = parcelRequire("1VgPC");

var $d2kYI = parcelRequire("d2kYI");
/** Used for built-in method references. */ var $4f4b95b8aefe4d77$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4f4b95b8aefe4d77$var$hasOwnProperty = $4f4b95b8aefe4d77$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $4f4b95b8aefe4d77$var$propertyIsEnumerable = $4f4b95b8aefe4d77$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $4f4b95b8aefe4d77$var$isArguments = $1VgPC(function() {
    return arguments;
}()) ? $1VgPC : function(value) {
    return $d2kYI(value) && $4f4b95b8aefe4d77$var$hasOwnProperty.call(value, "callee") && !$4f4b95b8aefe4d77$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $4f4b95b8aefe4d77$var$isArguments;

});
parcelRegister("1VgPC", function(module, exports) {

var $eXwEi = parcelRequire("eXwEi");

var $d2kYI = parcelRequire("d2kYI");
/** `Object#toString` result references. */ var $16682bb217664efe$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $16682bb217664efe$var$baseIsArguments(value) {
    return $d2kYI(value) && $eXwEi(value) == $16682bb217664efe$var$argsTag;
}
module.exports = $16682bb217664efe$var$baseIsArguments;

});
parcelRegister("d2kYI", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $97dbbc1a069ce16a$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $97dbbc1a069ce16a$var$isObjectLike;

});



parcelRegister("9gBlp", function(module, exports) {

var $1DySm = parcelRequire("1DySm");

var $1Wbuo = parcelRequire("1Wbuo");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $1DySm.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $1Wbuo;
module.exports = isBuffer;

});
parcelRegister("1Wbuo", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $16941ebaddae1967$var$stubFalse() {
    return false;
}
module.exports = $16941ebaddae1967$var$stubFalse;

});


parcelRegister("e8xSQ", function(module, exports) {
/** Used as references for various `Number` constants. */ var $a4ac18a3b008eabc$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $a4ac18a3b008eabc$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $a4ac18a3b008eabc$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $a4ac18a3b008eabc$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $a4ac18a3b008eabc$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $a4ac18a3b008eabc$var$isIndex;

});

parcelRegister("cuTxs", function(module, exports) {

var $5xVTl = parcelRequire("5xVTl");

var $gSVZ6 = parcelRequire("gSVZ6");

var $iU8uW = parcelRequire("iU8uW");
/* Node.js helper references. */ var $91935e2ee1691ad1$var$nodeIsTypedArray = $iU8uW && $iU8uW.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $91935e2ee1691ad1$var$isTypedArray = $91935e2ee1691ad1$var$nodeIsTypedArray ? $gSVZ6($91935e2ee1691ad1$var$nodeIsTypedArray) : $5xVTl;
module.exports = $91935e2ee1691ad1$var$isTypedArray;

});
parcelRegister("5xVTl", function(module, exports) {

var $eXwEi = parcelRequire("eXwEi");

var $1FA1m = parcelRequire("1FA1m");

var $d2kYI = parcelRequire("d2kYI");
/** `Object#toString` result references. */ var $409cf0e4c937c990$var$argsTag = "[object Arguments]", $409cf0e4c937c990$var$arrayTag = "[object Array]", $409cf0e4c937c990$var$boolTag = "[object Boolean]", $409cf0e4c937c990$var$dateTag = "[object Date]", $409cf0e4c937c990$var$errorTag = "[object Error]", $409cf0e4c937c990$var$funcTag = "[object Function]", $409cf0e4c937c990$var$mapTag = "[object Map]", $409cf0e4c937c990$var$numberTag = "[object Number]", $409cf0e4c937c990$var$objectTag = "[object Object]", $409cf0e4c937c990$var$regexpTag = "[object RegExp]", $409cf0e4c937c990$var$setTag = "[object Set]", $409cf0e4c937c990$var$stringTag = "[object String]", $409cf0e4c937c990$var$weakMapTag = "[object WeakMap]";
var $409cf0e4c937c990$var$arrayBufferTag = "[object ArrayBuffer]", $409cf0e4c937c990$var$dataViewTag = "[object DataView]", $409cf0e4c937c990$var$float32Tag = "[object Float32Array]", $409cf0e4c937c990$var$float64Tag = "[object Float64Array]", $409cf0e4c937c990$var$int8Tag = "[object Int8Array]", $409cf0e4c937c990$var$int16Tag = "[object Int16Array]", $409cf0e4c937c990$var$int32Tag = "[object Int32Array]", $409cf0e4c937c990$var$uint8Tag = "[object Uint8Array]", $409cf0e4c937c990$var$uint8ClampedTag = "[object Uint8ClampedArray]", $409cf0e4c937c990$var$uint16Tag = "[object Uint16Array]", $409cf0e4c937c990$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $409cf0e4c937c990$var$typedArrayTags = {};
$409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$float32Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$float64Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$int8Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$int16Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$int32Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$uint8Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$uint8ClampedTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$uint16Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$uint32Tag] = true;
$409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$argsTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$arrayTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$arrayBufferTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$boolTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$dataViewTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$dateTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$errorTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$funcTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$mapTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$numberTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$objectTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$regexpTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$setTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$stringTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $409cf0e4c937c990$var$baseIsTypedArray(value) {
    return $d2kYI(value) && $1FA1m(value.length) && !!$409cf0e4c937c990$var$typedArrayTags[$eXwEi(value)];
}
module.exports = $409cf0e4c937c990$var$baseIsTypedArray;

});
parcelRegister("1FA1m", function(module, exports) {
/** Used as references for various `Number` constants. */ var $13758fcec31fd7af$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $13758fcec31fd7af$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $13758fcec31fd7af$var$MAX_SAFE_INTEGER;
}
module.exports = $13758fcec31fd7af$var$isLength;

});


parcelRegister("gSVZ6", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $c4aeaafb4421a79e$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $c4aeaafb4421a79e$var$baseUnary;

});

parcelRegister("iU8uW", function(module, exports) {

var $8X2yT = parcelRequire("8X2yT");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $8X2yT.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("gjkox", function(module, exports) {

var $fzGpL = parcelRequire("fzGpL");

var $2V88E = parcelRequire("2V88E");
/** Used for built-in method references. */ var $bdfe3da66489f7d9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bdfe3da66489f7d9$var$hasOwnProperty = $bdfe3da66489f7d9$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $bdfe3da66489f7d9$var$baseKeys(object) {
    if (!$fzGpL(object)) return $2V88E(object);
    var result = [];
    for(var key in Object(object))if ($bdfe3da66489f7d9$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $bdfe3da66489f7d9$var$baseKeys;

});
parcelRegister("fzGpL", function(module, exports) {
/** Used for built-in method references. */ var $b56b06902d83e6f4$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $b56b06902d83e6f4$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $b56b06902d83e6f4$var$objectProto;
    return value === proto;
}
module.exports = $b56b06902d83e6f4$var$isPrototype;

});

parcelRegister("2V88E", function(module, exports) {

var $lMYRi = parcelRequire("lMYRi");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $220737c9fb125768$var$nativeKeys = $lMYRi(Object.keys, Object);
module.exports = $220737c9fb125768$var$nativeKeys;

});
parcelRegister("lMYRi", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $fdcd49ef52ce3234$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $fdcd49ef52ce3234$var$overArg;

});



parcelRegister("5VpCg", function(module, exports) {

var $Fb9OL = parcelRequire("Fb9OL");

var $1FA1m = parcelRequire("1FA1m");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $4506257970d5c979$var$isArrayLike(value) {
    return value != null && $1FA1m(value.length) && !$Fb9OL(value);
}
module.exports = $4506257970d5c979$var$isArrayLike;

});




parcelRegister("3tPzb", function(module, exports) {

var $6JzGB = parcelRequire("6JzGB");

var $55ur3 = parcelRequire("55ur3");

var $h9bAs = parcelRequire("h9bAs");

var $3D3eV = parcelRequire("3D3eV");

var $jr2IZ = parcelRequire("jr2IZ");

var $eXwEi = parcelRequire("eXwEi");

var $kZRNU = parcelRequire("kZRNU");
/** `Object#toString` result references. */ var $288c148fae7027f4$var$mapTag = "[object Map]", $288c148fae7027f4$var$objectTag = "[object Object]", $288c148fae7027f4$var$promiseTag = "[object Promise]", $288c148fae7027f4$var$setTag = "[object Set]", $288c148fae7027f4$var$weakMapTag = "[object WeakMap]";
var $288c148fae7027f4$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $288c148fae7027f4$var$dataViewCtorString = $kZRNU($6JzGB), $288c148fae7027f4$var$mapCtorString = $kZRNU($55ur3), $288c148fae7027f4$var$promiseCtorString = $kZRNU($h9bAs), $288c148fae7027f4$var$setCtorString = $kZRNU($3D3eV), $288c148fae7027f4$var$weakMapCtorString = $kZRNU($jr2IZ);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $288c148fae7027f4$var$getTag = $eXwEi;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($6JzGB && $288c148fae7027f4$var$getTag(new $6JzGB(new ArrayBuffer(1))) != $288c148fae7027f4$var$dataViewTag || $55ur3 && $288c148fae7027f4$var$getTag(new $55ur3) != $288c148fae7027f4$var$mapTag || $h9bAs && $288c148fae7027f4$var$getTag($h9bAs.resolve()) != $288c148fae7027f4$var$promiseTag || $3D3eV && $288c148fae7027f4$var$getTag(new $3D3eV) != $288c148fae7027f4$var$setTag || $jr2IZ && $288c148fae7027f4$var$getTag(new $jr2IZ) != $288c148fae7027f4$var$weakMapTag) $288c148fae7027f4$var$getTag = function(value) {
    var result = $eXwEi(value), Ctor = result == $288c148fae7027f4$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $kZRNU(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $288c148fae7027f4$var$dataViewCtorString:
            return $288c148fae7027f4$var$dataViewTag;
        case $288c148fae7027f4$var$mapCtorString:
            return $288c148fae7027f4$var$mapTag;
        case $288c148fae7027f4$var$promiseCtorString:
            return $288c148fae7027f4$var$promiseTag;
        case $288c148fae7027f4$var$setCtorString:
            return $288c148fae7027f4$var$setTag;
        case $288c148fae7027f4$var$weakMapCtorString:
            return $288c148fae7027f4$var$weakMapTag;
    }
    return result;
};
module.exports = $288c148fae7027f4$var$getTag;

});
parcelRegister("6JzGB", function(module, exports) {

var $cS0Ds = parcelRequire("cS0Ds");

var $1DySm = parcelRequire("1DySm");
/* Built-in method references that are verified to be native. */ var $4e72a091824b54c2$var$DataView = $cS0Ds($1DySm, "DataView");
module.exports = $4e72a091824b54c2$var$DataView;

});

parcelRegister("h9bAs", function(module, exports) {

var $cS0Ds = parcelRequire("cS0Ds");

var $1DySm = parcelRequire("1DySm");
/* Built-in method references that are verified to be native. */ var $c7bc43de39f545d4$var$Promise = $cS0Ds($1DySm, "Promise");
module.exports = $c7bc43de39f545d4$var$Promise;

});

parcelRegister("3D3eV", function(module, exports) {

var $cS0Ds = parcelRequire("cS0Ds");

var $1DySm = parcelRequire("1DySm");
/* Built-in method references that are verified to be native. */ var $2a4786f2dfc898c9$var$Set = $cS0Ds($1DySm, "Set");
module.exports = $2a4786f2dfc898c9$var$Set;

});

parcelRegister("jr2IZ", function(module, exports) {

var $cS0Ds = parcelRequire("cS0Ds");

var $1DySm = parcelRequire("1DySm");
/* Built-in method references that are verified to be native. */ var $e262a6fad30144cf$var$WeakMap = $cS0Ds($1DySm, "WeakMap");
module.exports = $e262a6fad30144cf$var$WeakMap;

});





parcelRegister("gpR4L", function(module, exports) {

var $bdjQ6 = parcelRequire("bdjQ6");
var $bf3826e8a03fdeb3$require$Buffer = $bdjQ6.Buffer;
/*!
 * Quill Editor v1.3.7
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(typeof self !== "undefined" ? self : module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 109);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var container_1 = __webpack_require__(17);
            var format_1 = __webpack_require__(18);
            var leaf_1 = __webpack_require__(19);
            var scroll_1 = __webpack_require__(45);
            var inline_1 = __webpack_require__(46);
            var block_1 = __webpack_require__(47);
            var embed_1 = __webpack_require__(48);
            var text_1 = __webpack_require__(49);
            var attributor_1 = __webpack_require__(12);
            var class_1 = __webpack_require__(32);
            var style_1 = __webpack_require__(33);
            var store_1 = __webpack_require__(31);
            var Registry = __webpack_require__(1);
            var Parchment = {
                Scope: Registry.Scope,
                create: Registry.create,
                find: Registry.find,
                query: Registry.query,
                register: Registry.register,
                Container: container_1.default,
                Format: format_1.default,
                Leaf: leaf_1.default,
                Embed: embed_1.default,
                Scroll: scroll_1.default,
                Block: block_1.default,
                Inline: inline_1.default,
                Text: text_1.default,
                Attributor: {
                    Attribute: attributor_1.default,
                    Class: class_1.default,
                    Style: style_1.default,
                    Store: store_1.default
                }
            };
            exports.default = Parchment;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var ParchmentError = /** @class */ function(_super) {
                __extends(ParchmentError, _super);
                function ParchmentError(message) {
                    var _this = this;
                    message = "[Parchment] " + message;
                    _this = _super.call(this, message) || this;
                    _this.message = message;
                    _this.name = _this.constructor.name;
                    return _this;
                }
                return ParchmentError;
            }(Error);
            exports.ParchmentError = ParchmentError;
            var attributes = {};
            var classes = {};
            var tags = {};
            var types = {};
            exports.DATA_KEY = "__blot";
            var Scope;
            (function(Scope) {
                Scope[Scope["TYPE"] = 3] = "TYPE";
                Scope[Scope["LEVEL"] = 12] = "LEVEL";
                Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
                Scope[Scope["BLOT"] = 14] = "BLOT";
                Scope[Scope["INLINE"] = 7] = "INLINE";
                Scope[Scope["BLOCK"] = 11] = "BLOCK";
                Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
                Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
                Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
                Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
                Scope[Scope["ANY"] = 15] = "ANY";
            })(Scope = exports.Scope || (exports.Scope = {}));
            function create(input, value) {
                var match = query(input);
                if (match == null) throw new ParchmentError("Unable to create " + input + " blot");
                var BlotClass = match;
                var node = // @ts-ignore
                input instanceof Node || input["nodeType"] === Node.TEXT_NODE ? input : BlotClass.create(value);
                return new BlotClass(node, value);
            }
            exports.create = create;
            function find(node, bubble) {
                if (bubble === void 0) bubble = false;
                if (node == null) return null;
                // @ts-ignore
                if (node[exports.DATA_KEY] != null) return node[exports.DATA_KEY].blot;
                if (bubble) return find(node.parentNode, bubble);
                return null;
            }
            exports.find = find;
            function query(query, scope) {
                if (scope === void 0) scope = Scope.ANY;
                var match;
                if (typeof query === "string") match = types[query] || attributes[query];
                else if (query instanceof Text || query["nodeType"] === Node.TEXT_NODE) match = types["text"];
                else if (typeof query === "number") {
                    if (query & Scope.LEVEL & Scope.BLOCK) match = types["block"];
                    else if (query & Scope.LEVEL & Scope.INLINE) match = types["inline"];
                } else if (query instanceof HTMLElement) {
                    var names = (query.getAttribute("class") || "").split(/\s+/);
                    for(var i in names){
                        match = classes[names[i]];
                        if (match) break;
                    }
                    match = match || tags[query.tagName];
                }
                if (match == null) return null;
                // @ts-ignore
                if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope) return match;
                return null;
            }
            exports.query = query;
            function register() {
                var Definitions = [];
                for(var _i = 0; _i < arguments.length; _i++)Definitions[_i] = arguments[_i];
                if (Definitions.length > 1) return Definitions.map(function(d) {
                    return register(d);
                });
                var Definition = Definitions[0];
                if (typeof Definition.blotName !== "string" && typeof Definition.attrName !== "string") throw new ParchmentError("Invalid definition");
                else if (Definition.blotName === "abstract") throw new ParchmentError("Cannot register abstract class");
                types[Definition.blotName || Definition.attrName] = Definition;
                if (typeof Definition.keyName === "string") attributes[Definition.keyName] = Definition;
                else {
                    if (Definition.className != null) classes[Definition.className] = Definition;
                    if (Definition.tagName != null) {
                        if (Array.isArray(Definition.tagName)) Definition.tagName = Definition.tagName.map(function(tagName) {
                            return tagName.toUpperCase();
                        });
                        else Definition.tagName = Definition.tagName.toUpperCase();
                        var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [
                            Definition.tagName
                        ];
                        tagNames.forEach(function(tag) {
                            if (tags[tag] == null || Definition.className == null) tags[tag] = Definition;
                        });
                    }
                }
                return Definition;
            }
            exports.register = register;
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            var diff = __webpack_require__(51);
            var equal = __webpack_require__(11);
            var extend = __webpack_require__(3);
            var op = __webpack_require__(20);
            var NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()
            var Delta = function(ops) {
                // Assume we are given a well formed ops
                if (Array.isArray(ops)) this.ops = ops;
                else if (ops != null && Array.isArray(ops.ops)) this.ops = ops.ops;
                else this.ops = [];
            };
            Delta.prototype.insert = function(text, attributes) {
                var newOp = {};
                if (text.length === 0) return this;
                newOp.insert = text;
                if (attributes != null && typeof attributes === "object" && Object.keys(attributes).length > 0) newOp.attributes = attributes;
                return this.push(newOp);
            };
            Delta.prototype["delete"] = function(length) {
                if (length <= 0) return this;
                return this.push({
                    "delete": length
                });
            };
            Delta.prototype.retain = function(length, attributes) {
                if (length <= 0) return this;
                var newOp = {
                    retain: length
                };
                if (attributes != null && typeof attributes === "object" && Object.keys(attributes).length > 0) newOp.attributes = attributes;
                return this.push(newOp);
            };
            Delta.prototype.push = function(newOp) {
                var index = this.ops.length;
                var lastOp = this.ops[index - 1];
                newOp = extend(true, {}, newOp);
                if (typeof lastOp === "object") {
                    if (typeof newOp["delete"] === "number" && typeof lastOp["delete"] === "number") {
                        this.ops[index - 1] = {
                            "delete": lastOp["delete"] + newOp["delete"]
                        };
                        return this;
                    }
                    // Since it does not matter if we insert before or after deleting at the same index,
                    // always prefer to insert first
                    if (typeof lastOp["delete"] === "number" && newOp.insert != null) {
                        index -= 1;
                        lastOp = this.ops[index - 1];
                        if (typeof lastOp !== "object") {
                            this.ops.unshift(newOp);
                            return this;
                        }
                    }
                    if (equal(newOp.attributes, lastOp.attributes)) {
                        if (typeof newOp.insert === "string" && typeof lastOp.insert === "string") {
                            this.ops[index - 1] = {
                                insert: lastOp.insert + newOp.insert
                            };
                            if (typeof newOp.attributes === "object") this.ops[index - 1].attributes = newOp.attributes;
                            return this;
                        } else if (typeof newOp.retain === "number" && typeof lastOp.retain === "number") {
                            this.ops[index - 1] = {
                                retain: lastOp.retain + newOp.retain
                            };
                            if (typeof newOp.attributes === "object") this.ops[index - 1].attributes = newOp.attributes;
                            return this;
                        }
                    }
                }
                if (index === this.ops.length) this.ops.push(newOp);
                else this.ops.splice(index, 0, newOp);
                return this;
            };
            Delta.prototype.chop = function() {
                var lastOp = this.ops[this.ops.length - 1];
                if (lastOp && lastOp.retain && !lastOp.attributes) this.ops.pop();
                return this;
            };
            Delta.prototype.filter = function(predicate) {
                return this.ops.filter(predicate);
            };
            Delta.prototype.forEach = function(predicate) {
                this.ops.forEach(predicate);
            };
            Delta.prototype.map = function(predicate) {
                return this.ops.map(predicate);
            };
            Delta.prototype.partition = function(predicate) {
                var passed = [], failed = [];
                this.forEach(function(op) {
                    var target = predicate(op) ? passed : failed;
                    target.push(op);
                });
                return [
                    passed,
                    failed
                ];
            };
            Delta.prototype.reduce = function(predicate, initial) {
                return this.ops.reduce(predicate, initial);
            };
            Delta.prototype.changeLength = function() {
                return this.reduce(function(length, elem) {
                    if (elem.insert) return length + op.length(elem);
                    else if (elem.delete) return length - elem.delete;
                    return length;
                }, 0);
            };
            Delta.prototype.length = function() {
                return this.reduce(function(length, elem) {
                    return length + op.length(elem);
                }, 0);
            };
            Delta.prototype.slice = function(start, end) {
                start = start || 0;
                if (typeof end !== "number") end = Infinity;
                var ops = [];
                var iter = op.iterator(this.ops);
                var index = 0;
                while(index < end && iter.hasNext()){
                    var nextOp;
                    if (index < start) nextOp = iter.next(start - index);
                    else {
                        nextOp = iter.next(end - index);
                        ops.push(nextOp);
                    }
                    index += op.length(nextOp);
                }
                return new Delta(ops);
            };
            Delta.prototype.compose = function(other) {
                var thisIter = op.iterator(this.ops);
                var otherIter = op.iterator(other.ops);
                var ops = [];
                var firstOther = otherIter.peek();
                if (firstOther != null && typeof firstOther.retain === "number" && firstOther.attributes == null) {
                    var firstLeft = firstOther.retain;
                    while(thisIter.peekType() === "insert" && thisIter.peekLength() <= firstLeft){
                        firstLeft -= thisIter.peekLength();
                        ops.push(thisIter.next());
                    }
                    if (firstOther.retain - firstLeft > 0) otherIter.next(firstOther.retain - firstLeft);
                }
                var delta = new Delta(ops);
                while(thisIter.hasNext() || otherIter.hasNext()){
                    if (otherIter.peekType() === "insert") delta.push(otherIter.next());
                    else if (thisIter.peekType() === "delete") delta.push(thisIter.next());
                    else {
                        var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                        var thisOp = thisIter.next(length);
                        var otherOp = otherIter.next(length);
                        if (typeof otherOp.retain === "number") {
                            var newOp = {};
                            if (typeof thisOp.retain === "number") newOp.retain = length;
                            else newOp.insert = thisOp.insert;
                            // Preserve null when composing with a retain, otherwise remove it for inserts
                            var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === "number");
                            if (attributes) newOp.attributes = attributes;
                            delta.push(newOp);
                            // Optimization if rest of other is just retain
                            if (!otherIter.hasNext() && equal(delta.ops[delta.ops.length - 1], newOp)) {
                                var rest = new Delta(thisIter.rest());
                                return delta.concat(rest).chop();
                            }
                        // Other op should be delete, we could be an insert or retain
                        // Insert + delete cancels out
                        } else if (typeof otherOp["delete"] === "number" && typeof thisOp.retain === "number") delta.push(otherOp);
                    }
                }
                return delta.chop();
            };
            Delta.prototype.concat = function(other) {
                var delta = new Delta(this.ops.slice());
                if (other.ops.length > 0) {
                    delta.push(other.ops[0]);
                    delta.ops = delta.ops.concat(other.ops.slice(1));
                }
                return delta;
            };
            Delta.prototype.diff = function(other, index) {
                if (this.ops === other.ops) return new Delta();
                var strings = [
                    this,
                    other
                ].map(function(delta) {
                    return delta.map(function(op) {
                        if (op.insert != null) return typeof op.insert === "string" ? op.insert : NULL_CHARACTER;
                        var prep = delta === other ? "on" : "with";
                        throw new Error("diff() called " + prep + " non-document");
                    }).join("");
                });
                var delta = new Delta();
                var diffResult = diff(strings[0], strings[1], index);
                var thisIter = op.iterator(this.ops);
                var otherIter = op.iterator(other.ops);
                diffResult.forEach(function(component) {
                    var length = component[1].length;
                    while(length > 0){
                        var opLength = 0;
                        switch(component[0]){
                            case diff.INSERT:
                                opLength = Math.min(otherIter.peekLength(), length);
                                delta.push(otherIter.next(opLength));
                                break;
                            case diff.DELETE:
                                opLength = Math.min(length, thisIter.peekLength());
                                thisIter.next(opLength);
                                delta["delete"](opLength);
                                break;
                            case diff.EQUAL:
                                opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
                                var thisOp = thisIter.next(opLength);
                                var otherOp = otherIter.next(opLength);
                                if (equal(thisOp.insert, otherOp.insert)) delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
                                else delta.push(otherOp)["delete"](opLength);
                                break;
                        }
                        length -= opLength;
                    }
                });
                return delta.chop();
            };
            Delta.prototype.eachLine = function(predicate, newline) {
                newline = newline || "\n";
                var iter = op.iterator(this.ops);
                var line = new Delta();
                var i = 0;
                while(iter.hasNext()){
                    if (iter.peekType() !== "insert") return;
                    var thisOp = iter.peek();
                    var start = op.length(thisOp) - iter.peekLength();
                    var index = typeof thisOp.insert === "string" ? thisOp.insert.indexOf(newline, start) - start : -1;
                    if (index < 0) line.push(iter.next());
                    else if (index > 0) line.push(iter.next(index));
                    else {
                        if (predicate(line, iter.next(1).attributes || {}, i) === false) return;
                        i += 1;
                        line = new Delta();
                    }
                }
                if (line.length() > 0) predicate(line, {}, i);
            };
            Delta.prototype.transform = function(other, priority) {
                priority = !!priority;
                if (typeof other === "number") return this.transformPosition(other, priority);
                var thisIter = op.iterator(this.ops);
                var otherIter = op.iterator(other.ops);
                var delta = new Delta();
                while(thisIter.hasNext() || otherIter.hasNext()){
                    if (thisIter.peekType() === "insert" && (priority || otherIter.peekType() !== "insert")) delta.retain(op.length(thisIter.next()));
                    else if (otherIter.peekType() === "insert") delta.push(otherIter.next());
                    else {
                        var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                        var thisOp = thisIter.next(length);
                        var otherOp = otherIter.next(length);
                        if (thisOp["delete"]) continue;
                        else if (otherOp["delete"]) delta.push(otherOp);
                        else // We retain either their retain or insert
                        delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
                    }
                }
                return delta.chop();
            };
            Delta.prototype.transformPosition = function(index, priority) {
                priority = !!priority;
                var thisIter = op.iterator(this.ops);
                var offset = 0;
                while(thisIter.hasNext() && offset <= index){
                    var length = thisIter.peekLength();
                    var nextType = thisIter.peekType();
                    thisIter.next();
                    if (nextType === "delete") {
                        index -= Math.min(length, index - offset);
                        continue;
                    } else if (nextType === "insert" && (offset < index || !priority)) index += length;
                    offset += length;
                }
                return index;
            };
            module1.exports = Delta;
        /***/ },
        /* 3 */ /***/ function(module1, exports) {
            "use strict";
            var hasOwn = Object.prototype.hasOwnProperty;
            var toStr = Object.prototype.toString;
            var defineProperty = Object.defineProperty;
            var gOPD = Object.getOwnPropertyDescriptor;
            var isArray = function isArray(arr) {
                if (typeof Array.isArray === "function") return Array.isArray(arr);
                return toStr.call(arr) === "[object Array]";
            };
            var isPlainObject = function isPlainObject(obj) {
                if (!obj || toStr.call(obj) !== "[object Object]") return false;
                var hasOwnConstructor = hasOwn.call(obj, "constructor");
                var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
                // Not own constructor property must be Object
                if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
                // Own properties are enumerated firstly, so to speed up,
                // if last one is own, then all properties are own.
                var key;
                for(key in obj);
                return typeof key === "undefined" || hasOwn.call(obj, key);
            };
            // If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
            var setProperty = function setProperty(target, options) {
                if (defineProperty && options.name === "__proto__") defineProperty(target, options.name, {
                    enumerable: true,
                    configurable: true,
                    value: options.newValue,
                    writable: true
                });
                else target[options.name] = options.newValue;
            };
            // Return undefined instead of __proto__ if '__proto__' is not an own property
            var getProperty = function getProperty(obj, name) {
                if (name === "__proto__") {
                    if (!hasOwn.call(obj, name)) return void 0;
                    else if (gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
                    // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
                    return gOPD(obj, name).value;
                }
                return obj[name];
            };
            module1.exports = function extend() {
                var options, name, src, copy, copyIsArray, clone;
                var target = arguments[0];
                var i = 1;
                var length = arguments.length;
                var deep = false;
                // Handle a deep copy situation
                if (typeof target === "boolean") {
                    deep = target;
                    target = arguments[1] || {};
                    // skip the boolean and the target
                    i = 2;
                }
                if (target == null || typeof target !== "object" && typeof target !== "function") target = {};
                for(; i < length; ++i){
                    options = arguments[i];
                    // Only deal with non-null/undefined values
                    if (options != null) // Extend the base object
                    for(name in options){
                        src = getProperty(target, name);
                        copy = getProperty(options, name);
                        // Prevent never-ending loop
                        if (target !== copy) {
                            // Recurse if we're merging plain objects or arrays
                            if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
                                if (copyIsArray) {
                                    copyIsArray = false;
                                    clone = src && isArray(src) ? src : [];
                                } else clone = src && isPlainObject(src) ? src : {};
                                // Never move original objects, clone them
                                setProperty(target, {
                                    name: name,
                                    newValue: extend(deep, clone, copy)
                                });
                            // Don't bring in undefined values
                            } else if (typeof copy !== "undefined") setProperty(target, {
                                name: name,
                                newValue: copy
                            });
                        }
                    }
                }
                // Return the modified object
                return target;
            };
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var NEWLINE_LENGTH = 1;
            var BlockEmbed = function(_Parchment$Embed) {
                _inherits(BlockEmbed, _Parchment$Embed);
                function BlockEmbed() {
                    _classCallCheck(this, BlockEmbed);
                    return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
                }
                _createClass(BlockEmbed, [
                    {
                        key: "attach",
                        value: function attach() {
                            _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), "attach", this).call(this);
                            this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
                        }
                    },
                    {
                        key: "delta",
                        value: function delta() {
                            return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
                        }
                    },
                    {
                        key: "format",
                        value: function format(name, value) {
                            var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
                            if (attribute != null) this.attributes.attribute(attribute, value);
                        }
                    },
                    {
                        key: "formatAt",
                        value: function formatAt(index, length, name, value) {
                            this.format(name, value);
                        }
                    },
                    {
                        key: "insertAt",
                        value: function insertAt(index, value, def) {
                            if (typeof value === "string" && value.endsWith("\n")) {
                                var block = _parchment2.default.create(Block.blotName);
                                this.parent.insertBefore(block, index === 0 ? this : this.next);
                                block.insertAt(0, value.slice(0, -1));
                            } else _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), "insertAt", this).call(this, index, value, def);
                        }
                    }
                ]);
                return BlockEmbed;
            }(_parchment2.default.Embed);
            BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
            // It is important for cursor behavior BlockEmbeds use tags that are block level elements
            var Block = function(_Parchment$Block) {
                _inherits(Block, _Parchment$Block);
                function Block(domNode) {
                    _classCallCheck(this, Block);
                    var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));
                    _this2.cache = {};
                    return _this2;
                }
                _createClass(Block, [
                    {
                        key: "delta",
                        value: function delta() {
                            if (this.cache.delta == null) this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function(delta, leaf) {
                                if (leaf.length() === 0) return delta;
                                else return delta.insert(leaf.value(), bubbleFormats(leaf));
                            }, new _quillDelta2.default()).insert("\n", bubbleFormats(this));
                            return this.cache.delta;
                        }
                    },
                    {
                        key: "deleteAt",
                        value: function deleteAt(index, length) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), "deleteAt", this).call(this, index, length);
                            this.cache = {};
                        }
                    },
                    {
                        key: "formatAt",
                        value: function formatAt(index, length, name, value) {
                            if (length <= 0) return;
                            if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
                                if (index + length === this.length()) this.format(name, value);
                            } else _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), "formatAt", this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
                            this.cache = {};
                        }
                    },
                    {
                        key: "insertAt",
                        value: function insertAt(index, value, def) {
                            if (def != null) return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), "insertAt", this).call(this, index, value, def);
                            if (value.length === 0) return;
                            var lines = value.split("\n");
                            var text = lines.shift();
                            if (text.length > 0) {
                                if (index < this.length() - 1 || this.children.tail == null) _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), "insertAt", this).call(this, Math.min(index, this.length() - 1), text);
                                else this.children.tail.insertAt(this.children.tail.length(), text);
                                this.cache = {};
                            }
                            var block = this;
                            lines.reduce(function(index, line) {
                                block = block.split(index, true);
                                block.insertAt(0, line);
                                return line.length;
                            }, index + text.length);
                        }
                    },
                    {
                        key: "insertBefore",
                        value: function insertBefore(blot, ref) {
                            var head = this.children.head;
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), "insertBefore", this).call(this, blot, ref);
                            if (head instanceof _break2.default) head.remove();
                            this.cache = {};
                        }
                    },
                    {
                        key: "length",
                        value: function length() {
                            if (this.cache.length == null) this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), "length", this).call(this) + NEWLINE_LENGTH;
                            return this.cache.length;
                        }
                    },
                    {
                        key: "moveChildren",
                        value: function moveChildren(target, ref) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), "moveChildren", this).call(this, target, ref);
                            this.cache = {};
                        }
                    },
                    {
                        key: "optimize",
                        value: function optimize(context) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), "optimize", this).call(this, context);
                            this.cache = {};
                        }
                    },
                    {
                        key: "path",
                        value: function path(index) {
                            return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), "path", this).call(this, index, true);
                        }
                    },
                    {
                        key: "removeChild",
                        value: function removeChild(child) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), "removeChild", this).call(this, child);
                            this.cache = {};
                        }
                    },
                    {
                        key: "split",
                        value: function split(index) {
                            var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
                                var clone = this.clone();
                                if (index === 0) {
                                    this.parent.insertBefore(clone, this);
                                    return this;
                                } else {
                                    this.parent.insertBefore(clone, this.next);
                                    return clone;
                                }
                            } else {
                                var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), "split", this).call(this, index, force);
                                this.cache = {};
                                return next;
                            }
                        }
                    }
                ]);
                return Block;
            }(_parchment2.default.Block);
            Block.blotName = "block";
            Block.tagName = "P";
            Block.defaultChild = "break";
            Block.allowedChildren = [
                _inline2.default,
                _parchment2.default.Embed,
                _text2.default
            ];
            function bubbleFormats(blot) {
                var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (blot == null) return formats;
                if (typeof blot.formats === "function") formats = (0, _extend2.default)(formats, blot.formats());
                if (blot.parent == null || blot.parent.blotName == "scroll" || blot.parent.statics.scope !== blot.statics.scope) return formats;
                return bubbleFormats(blot.parent, formats);
            }
            exports.bubbleFormats = bubbleFormats;
            exports.BlockEmbed = BlockEmbed;
            exports.default = Block;
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.overload = exports.expandConfig = undefined;
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            __webpack_require__(50);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _editor = __webpack_require__(14);
            var _editor2 = _interopRequireDefault(_editor);
            var _emitter3 = __webpack_require__(8);
            var _emitter4 = _interopRequireDefault(_emitter3);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _selection = __webpack_require__(15);
            var _selection2 = _interopRequireDefault(_selection);
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _theme = __webpack_require__(34);
            var _theme2 = _interopRequireDefault(_theme);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var debug = (0, _logger2.default)("quill");
            var Quill = function() {
                _createClass(Quill, null, [
                    {
                        key: "debug",
                        value: function debug(limit) {
                            if (limit === true) limit = "log";
                            _logger2.default.level(limit);
                        }
                    },
                    {
                        key: "find",
                        value: function find(node) {
                            return node.__quill || _parchment2.default.find(node);
                        }
                    },
                    {
                        key: "import",
                        value: function _import(name) {
                            if (this.imports[name] == null) debug.error("Cannot import " + name + ". Are you sure it was registered?");
                            return this.imports[name];
                        }
                    },
                    {
                        key: "register",
                        value: function register(path, target) {
                            var _this = this;
                            var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                            if (typeof path !== "string") {
                                var name = path.attrName || path.blotName;
                                if (typeof name === "string") // register(Blot | Attributor, overwrite)
                                this.register("formats/" + name, path, target);
                                else Object.keys(path).forEach(function(key) {
                                    _this.register(key, path[key], target);
                                });
                            } else {
                                if (this.imports[path] != null && !overwrite) debug.warn("Overwriting " + path + " with", target);
                                this.imports[path] = target;
                                if ((path.startsWith("blots/") || path.startsWith("formats/")) && target.blotName !== "abstract") _parchment2.default.register(target);
                                else if (path.startsWith("modules") && typeof target.register === "function") target.register();
                            }
                        }
                    }
                ]);
                function Quill(container) {
                    var _this2 = this;
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    _classCallCheck(this, Quill);
                    this.options = expandConfig(container, options);
                    this.container = this.options.container;
                    if (this.container == null) return debug.error("Invalid Quill container", container);
                    if (this.options.debug) Quill.debug(this.options.debug);
                    var html = this.container.innerHTML.trim();
                    this.container.classList.add("ql-container");
                    this.container.innerHTML = "";
                    this.container.__quill = this;
                    this.root = this.addContainer("ql-editor");
                    this.root.classList.add("ql-blank");
                    this.root.setAttribute("data-gramm", false);
                    this.scrollingContainer = this.options.scrollingContainer || this.root;
                    this.emitter = new _emitter4.default();
                    this.scroll = _parchment2.default.create(this.root, {
                        emitter: this.emitter,
                        whitelist: this.options.formats
                    });
                    this.editor = new _editor2.default(this.scroll);
                    this.selection = new _selection2.default(this.scroll, this.emitter);
                    this.theme = new this.options.theme(this, this.options);
                    this.keyboard = this.theme.addModule("keyboard");
                    this.clipboard = this.theme.addModule("clipboard");
                    this.history = this.theme.addModule("history");
                    this.theme.init();
                    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function(type) {
                        if (type === _emitter4.default.events.TEXT_CHANGE) _this2.root.classList.toggle("ql-blank", _this2.editor.isBlank());
                    });
                    this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function(source, mutations) {
                        var range = _this2.selection.lastRange;
                        var index = range && range.length === 0 ? range.index : undefined;
                        modify.call(_this2, function() {
                            return _this2.editor.update(null, mutations, index);
                        }, source);
                    });
                    var contents = this.clipboard.convert("<div class='ql-editor' style=\"white-space: normal;\">" + html + "<p><br></p></div>");
                    this.setContents(contents);
                    this.history.clear();
                    if (this.options.placeholder) this.root.setAttribute("data-placeholder", this.options.placeholder);
                    if (this.options.readOnly) this.disable();
                }
                _createClass(Quill, [
                    {
                        key: "addContainer",
                        value: function addContainer(container) {
                            var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                            if (typeof container === "string") {
                                var className = container;
                                container = document.createElement("div");
                                container.classList.add(className);
                            }
                            this.container.insertBefore(container, refNode);
                            return container;
                        }
                    },
                    {
                        key: "blur",
                        value: function blur() {
                            this.selection.setRange(null);
                        }
                    },
                    {
                        key: "deleteText",
                        value: function deleteText(index, length, source) {
                            var _this3 = this;
                            var _overload = overload(index, length, source);
                            var _overload2 = _slicedToArray(_overload, 4);
                            index = _overload2[0];
                            length = _overload2[1];
                            source = _overload2[3];
                            return modify.call(this, function() {
                                return _this3.editor.deleteText(index, length);
                            }, source, index, -1 * length);
                        }
                    },
                    {
                        key: "disable",
                        value: function disable() {
                            this.enable(false);
                        }
                    },
                    {
                        key: "enable",
                        value: function enable() {
                            var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                            this.scroll.enable(enabled);
                            this.container.classList.toggle("ql-disabled", !enabled);
                        }
                    },
                    {
                        key: "focus",
                        value: function focus() {
                            var scrollTop = this.scrollingContainer.scrollTop;
                            this.selection.focus();
                            this.scrollingContainer.scrollTop = scrollTop;
                            this.scrollIntoView();
                        }
                    },
                    {
                        key: "format",
                        value: function format(name, value) {
                            var _this4 = this;
                            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
                            return modify.call(this, function() {
                                var range = _this4.getSelection(true);
                                var change = new _quillDelta2.default();
                                if (range == null) return change;
                                else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
                                else if (range.length === 0) {
                                    _this4.selection.format(name, value);
                                    return change;
                                } else change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
                                _this4.setSelection(range, _emitter4.default.sources.SILENT);
                                return change;
                            }, source);
                        }
                    },
                    {
                        key: "formatLine",
                        value: function formatLine(index, length, name, value, source) {
                            var _this5 = this;
                            var formats = void 0;
                            var _overload3 = overload(index, length, name, value, source);
                            var _overload4 = _slicedToArray(_overload3, 4);
                            index = _overload4[0];
                            length = _overload4[1];
                            formats = _overload4[2];
                            source = _overload4[3];
                            return modify.call(this, function() {
                                return _this5.editor.formatLine(index, length, formats);
                            }, source, index, 0);
                        }
                    },
                    {
                        key: "formatText",
                        value: function formatText(index, length, name, value, source) {
                            var _this6 = this;
                            var formats = void 0;
                            var _overload5 = overload(index, length, name, value, source);
                            var _overload6 = _slicedToArray(_overload5, 4);
                            index = _overload6[0];
                            length = _overload6[1];
                            formats = _overload6[2];
                            source = _overload6[3];
                            return modify.call(this, function() {
                                return _this6.editor.formatText(index, length, formats);
                            }, source, index, 0);
                        }
                    },
                    {
                        key: "getBounds",
                        value: function getBounds(index) {
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            var bounds = void 0;
                            if (typeof index === "number") bounds = this.selection.getBounds(index, length);
                            else bounds = this.selection.getBounds(index.index, index.length);
                            var containerBounds = this.container.getBoundingClientRect();
                            return {
                                bottom: bounds.bottom - containerBounds.top,
                                height: bounds.height,
                                left: bounds.left - containerBounds.left,
                                right: bounds.right - containerBounds.left,
                                top: bounds.top - containerBounds.top,
                                width: bounds.width
                            };
                        }
                    },
                    {
                        key: "getContents",
                        value: function getContents() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
                            var _overload7 = overload(index, length);
                            var _overload8 = _slicedToArray(_overload7, 2);
                            index = _overload8[0];
                            length = _overload8[1];
                            return this.editor.getContents(index, length);
                        }
                    },
                    {
                        key: "getFormat",
                        value: function getFormat() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            if (typeof index === "number") return this.editor.getFormat(index, length);
                            else return this.editor.getFormat(index.index, index.length);
                        }
                    },
                    {
                        key: "getIndex",
                        value: function getIndex(blot) {
                            return blot.offset(this.scroll);
                        }
                    },
                    {
                        key: "getLength",
                        value: function getLength() {
                            return this.scroll.length();
                        }
                    },
                    {
                        key: "getLeaf",
                        value: function getLeaf(index) {
                            return this.scroll.leaf(index);
                        }
                    },
                    {
                        key: "getLine",
                        value: function getLine(index) {
                            return this.scroll.line(index);
                        }
                    },
                    {
                        key: "getLines",
                        value: function getLines() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
                            if (typeof index !== "number") return this.scroll.lines(index.index, index.length);
                            else return this.scroll.lines(index, length);
                        }
                    },
                    {
                        key: "getModule",
                        value: function getModule(name) {
                            return this.theme.modules[name];
                        }
                    },
                    {
                        key: "getSelection",
                        value: function getSelection() {
                            var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                            if (focus) this.focus();
                            this.update(); // Make sure we access getRange with editor in consistent state
                            return this.selection.getRange()[0];
                        }
                    },
                    {
                        key: "getText",
                        value: function getText() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
                            var _overload9 = overload(index, length);
                            var _overload10 = _slicedToArray(_overload9, 2);
                            index = _overload10[0];
                            length = _overload10[1];
                            return this.editor.getText(index, length);
                        }
                    },
                    {
                        key: "hasFocus",
                        value: function hasFocus() {
                            return this.selection.hasFocus();
                        }
                    },
                    {
                        key: "insertEmbed",
                        value: function insertEmbed(index, embed, value) {
                            var _this7 = this;
                            var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;
                            return modify.call(this, function() {
                                return _this7.editor.insertEmbed(index, embed, value);
                            }, source, index);
                        }
                    },
                    {
                        key: "insertText",
                        value: function insertText(index, text, name, value, source) {
                            var _this8 = this;
                            var formats = void 0;
                            var _overload11 = overload(index, 0, name, value, source);
                            var _overload12 = _slicedToArray(_overload11, 4);
                            index = _overload12[0];
                            formats = _overload12[2];
                            source = _overload12[3];
                            return modify.call(this, function() {
                                return _this8.editor.insertText(index, text, formats);
                            }, source, index, text.length);
                        }
                    },
                    {
                        key: "isEnabled",
                        value: function isEnabled() {
                            return !this.container.classList.contains("ql-disabled");
                        }
                    },
                    {
                        key: "off",
                        value: function off() {
                            return this.emitter.off.apply(this.emitter, arguments);
                        }
                    },
                    {
                        key: "on",
                        value: function on() {
                            return this.emitter.on.apply(this.emitter, arguments);
                        }
                    },
                    {
                        key: "once",
                        value: function once() {
                            return this.emitter.once.apply(this.emitter, arguments);
                        }
                    },
                    {
                        key: "pasteHTML",
                        value: function pasteHTML(index, html, source) {
                            this.clipboard.dangerouslyPasteHTML(index, html, source);
                        }
                    },
                    {
                        key: "removeFormat",
                        value: function removeFormat(index, length, source) {
                            var _this9 = this;
                            var _overload13 = overload(index, length, source);
                            var _overload14 = _slicedToArray(_overload13, 4);
                            index = _overload14[0];
                            length = _overload14[1];
                            source = _overload14[3];
                            return modify.call(this, function() {
                                return _this9.editor.removeFormat(index, length);
                            }, source, index);
                        }
                    },
                    {
                        key: "scrollIntoView",
                        value: function scrollIntoView() {
                            this.selection.scrollIntoView(this.scrollingContainer);
                        }
                    },
                    {
                        key: "setContents",
                        value: function setContents(delta) {
                            var _this10 = this;
                            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
                            return modify.call(this, function() {
                                delta = new _quillDelta2.default(delta);
                                var length = _this10.getLength();
                                var deleted = _this10.editor.deleteText(0, length);
                                var applied = _this10.editor.applyDelta(delta);
                                var lastOp = applied.ops[applied.ops.length - 1];
                                if (lastOp != null && typeof lastOp.insert === "string" && lastOp.insert[lastOp.insert.length - 1] === "\n") {
                                    _this10.editor.deleteText(_this10.getLength() - 1, 1);
                                    applied.delete(1);
                                }
                                var ret = deleted.compose(applied);
                                return ret;
                            }, source);
                        }
                    },
                    {
                        key: "setSelection",
                        value: function setSelection(index, length, source) {
                            if (index == null) this.selection.setRange(null, length || Quill.sources.API);
                            else {
                                var _overload15 = overload(index, length, source);
                                var _overload16 = _slicedToArray(_overload15, 4);
                                index = _overload16[0];
                                length = _overload16[1];
                                source = _overload16[3];
                                this.selection.setRange(new _selection.Range(index, length), source);
                                if (source !== _emitter4.default.sources.SILENT) this.selection.scrollIntoView(this.scrollingContainer);
                            }
                        }
                    },
                    {
                        key: "setText",
                        value: function setText(text) {
                            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
                            var delta = new _quillDelta2.default().insert(text);
                            return this.setContents(delta, source);
                        }
                    },
                    {
                        key: "update",
                        value: function update() {
                            var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
                            var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
                            this.selection.update(source);
                            return change;
                        }
                    },
                    {
                        key: "updateContents",
                        value: function updateContents(delta) {
                            var _this11 = this;
                            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
                            return modify.call(this, function() {
                                delta = new _quillDelta2.default(delta);
                                return _this11.editor.applyDelta(delta, source);
                            }, source, true);
                        }
                    }
                ]);
                return Quill;
            }();
            Quill.DEFAULTS = {
                bounds: null,
                formats: null,
                modules: {},
                placeholder: "",
                readOnly: false,
                scrollingContainer: null,
                strict: true,
                theme: "default"
            };
            Quill.events = _emitter4.default.events;
            Quill.sources = _emitter4.default.sources;
            // eslint-disable-next-line no-undef
            Quill.version = "1.3.7";
            Quill.imports = {
                "delta": _quillDelta2.default,
                "parchment": _parchment2.default,
                "core/module": _module2.default,
                "core/theme": _theme2.default
            };
            function expandConfig(container, userConfig) {
                userConfig = (0, _extend2.default)(true, {
                    container: container,
                    modules: {
                        clipboard: true,
                        keyboard: true,
                        history: true
                    }
                }, userConfig);
                if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) userConfig.theme = _theme2.default;
                else {
                    userConfig.theme = Quill.import("themes/" + userConfig.theme);
                    if (userConfig.theme == null) throw new Error("Invalid theme " + userConfig.theme + ". Did you register it?");
                }
                var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
                [
                    themeConfig,
                    userConfig
                ].forEach(function(config) {
                    config.modules = config.modules || {};
                    Object.keys(config.modules).forEach(function(module1) {
                        if (config.modules[module1] === true) config.modules[module1] = {};
                    });
                });
                var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
                var moduleConfig = moduleNames.reduce(function(config, name) {
                    var moduleClass = Quill.import("modules/" + name);
                    if (moduleClass == null) debug.error("Cannot load " + name + " module. Are you sure you registered it?");
                    else config[name] = moduleClass.DEFAULTS || {};
                    return config;
                }, {});
                // Special case toolbar shorthand
                if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) userConfig.modules.toolbar = {
                    container: userConfig.modules.toolbar
                };
                userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, {
                    modules: moduleConfig
                }, themeConfig, userConfig);
                [
                    "bounds",
                    "container",
                    "scrollingContainer"
                ].forEach(function(key) {
                    if (typeof userConfig[key] === "string") userConfig[key] = document.querySelector(userConfig[key]);
                });
                userConfig.modules = Object.keys(userConfig.modules).reduce(function(config, name) {
                    if (userConfig.modules[name]) config[name] = userConfig.modules[name];
                    return config;
                }, {});
                return userConfig;
            }
            // Handle selection preservation and TEXT_CHANGE emission
            // common to modification APIs
            function modify(modifier, source, index, shift) {
                if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) return new _quillDelta2.default();
                var range = index == null ? null : this.getSelection();
                var oldDelta = this.editor.delta;
                var change = modifier();
                if (range != null) {
                    if (index === true) index = range.index;
                    if (shift == null) range = shiftRange(range, change, source);
                    else if (shift !== 0) range = shiftRange(range, index, shift, source);
                    this.setSelection(range, _emitter4.default.sources.SILENT);
                }
                if (change.length() > 0) {
                    var _emitter;
                    var args = [
                        _emitter4.default.events.TEXT_CHANGE,
                        change,
                        oldDelta,
                        source
                    ];
                    (_emitter = this.emitter).emit.apply(_emitter, [
                        _emitter4.default.events.EDITOR_CHANGE
                    ].concat(args));
                    if (source !== _emitter4.default.sources.SILENT) {
                        var _emitter2;
                        (_emitter2 = this.emitter).emit.apply(_emitter2, args);
                    }
                }
                return change;
            }
            function overload(index, length, name, value, source) {
                var formats = {};
                if (typeof index.index === "number" && typeof index.length === "number") {
                    // Allow for throwaway end (used by insertText/insertEmbed)
                    if (typeof length !== "number") source = value, value = name, name = length, length = index.length, index = index.index;
                    else length = index.length, index = index.index;
                } else if (typeof length !== "number") source = value, value = name, name = length, length = 0;
                // Handle format being object, two format name/value strings or excluded
                if ((typeof name === "undefined" ? "undefined" : _typeof(name)) === "object") {
                    formats = name;
                    source = value;
                } else if (typeof name === "string") {
                    if (value != null) formats[name] = value;
                    else source = name;
                }
                // Handle optional source
                source = source || _emitter4.default.sources.API;
                return [
                    index,
                    length,
                    formats,
                    source
                ];
            }
            function shiftRange(range, index, length, source) {
                if (range == null) return null;
                var start = void 0, end = void 0;
                if (index instanceof _quillDelta2.default) {
                    var _map = [
                        range.index,
                        range.index + range.length
                    ].map(function(pos) {
                        return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
                    });
                    var _map2 = _slicedToArray(_map, 2);
                    start = _map2[0];
                    end = _map2[1];
                } else {
                    var _map3 = [
                        range.index,
                        range.index + range.length
                    ].map(function(pos) {
                        if (pos < index || pos === index && source === _emitter4.default.sources.USER) return pos;
                        if (length >= 0) return pos + length;
                        else return Math.max(index, pos + length);
                    });
                    var _map4 = _slicedToArray(_map3, 2);
                    start = _map4[0];
                    end = _map4[1];
                }
                return new _selection.Range(start, end - start);
            }
            exports.expandConfig = expandConfig;
            exports.overload = overload;
            exports.default = Quill;
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Inline = function(_Parchment$Inline) {
                _inherits(Inline, _Parchment$Inline);
                function Inline() {
                    _classCallCheck(this, Inline);
                    return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
                }
                _createClass(Inline, [
                    {
                        key: "formatAt",
                        value: function formatAt(index, length, name, value) {
                            if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
                                var blot = this.isolate(index, length);
                                if (value) blot.wrap(name, value);
                            } else _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), "formatAt", this).call(this, index, length, name, value);
                        }
                    },
                    {
                        key: "optimize",
                        value: function optimize(context) {
                            _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), "optimize", this).call(this, context);
                            if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
                                var parent = this.parent.isolate(this.offset(), this.length());
                                this.moveChildren(parent);
                                parent.wrap(this);
                            }
                        }
                    }
                ], [
                    {
                        key: "compare",
                        value: function compare(self1, other) {
                            var selfIndex = Inline.order.indexOf(self1);
                            var otherIndex = Inline.order.indexOf(other);
                            if (selfIndex >= 0 || otherIndex >= 0) return selfIndex - otherIndex;
                            else if (self1 === other) return 0;
                            else if (self1 < other) return -1;
                            else return 1;
                        }
                    }
                ]);
                return Inline;
            }(_parchment2.default.Inline);
            Inline.allowedChildren = [
                Inline,
                _parchment2.default.Embed,
                _text2.default
            ];
            // Lower index means deeper in the DOM tree, since not found (-1) is for embeds
            Inline.order = [
                "cursor",
                "inline",
                "underline",
                "strike",
                "italic",
                "bold",
                "script",
                "link",
                "code" // Must be higher
            ];
            exports.default = Inline;
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var TextBlot = function(_Parchment$Text) {
                _inherits(TextBlot, _Parchment$Text);
                function TextBlot() {
                    _classCallCheck(this, TextBlot);
                    return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
                }
                return TextBlot;
            }(_parchment2.default.Text);
            exports.default = TextBlot;
        /***/ },
        /* 8 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _eventemitter = __webpack_require__(54);
            var _eventemitter2 = _interopRequireDefault(_eventemitter);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var debug = (0, _logger2.default)("quill:events");
            var EVENTS = [
                "selectionchange",
                "mousedown",
                "mouseup",
                "click"
            ];
            EVENTS.forEach(function(eventName) {
                document.addEventListener(eventName, function() {
                    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    [].slice.call(document.querySelectorAll(".ql-container")).forEach(function(node) {
                        // TODO use WeakMap
                        if (node.__quill && node.__quill.emitter) {
                            var _node$__quill$emitter;
                            (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
                        }
                    });
                });
            });
            var Emitter = function(_EventEmitter) {
                _inherits(Emitter, _EventEmitter);
                function Emitter() {
                    _classCallCheck(this, Emitter);
                    var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));
                    _this.listeners = {};
                    _this.on("error", debug.error);
                    return _this;
                }
                _createClass(Emitter, [
                    {
                        key: "emit",
                        value: function emit() {
                            debug.log.apply(debug, arguments);
                            _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), "emit", this).apply(this, arguments);
                        }
                    },
                    {
                        key: "handleDOM",
                        value: function handleDOM(event) {
                            for(var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                            (this.listeners[event.type] || []).forEach(function(_ref) {
                                var node = _ref.node, handler = _ref.handler;
                                if (event.target === node || node.contains(event.target)) handler.apply(undefined, [
                                    event
                                ].concat(args));
                            });
                        }
                    },
                    {
                        key: "listenDOM",
                        value: function listenDOM(eventName, node, handler) {
                            if (!this.listeners[eventName]) this.listeners[eventName] = [];
                            this.listeners[eventName].push({
                                node: node,
                                handler: handler
                            });
                        }
                    }
                ]);
                return Emitter;
            }(_eventemitter2.default);
            Emitter.events = {
                EDITOR_CHANGE: "editor-change",
                SCROLL_BEFORE_UPDATE: "scroll-before-update",
                SCROLL_OPTIMIZE: "scroll-optimize",
                SCROLL_UPDATE: "scroll-update",
                SELECTION_CHANGE: "selection-change",
                TEXT_CHANGE: "text-change"
            };
            Emitter.sources = {
                API: "api",
                SILENT: "silent",
                USER: "user"
            };
            exports.default = Emitter;
        /***/ },
        /* 9 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var Module = function Module(quill) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                _classCallCheck(this, Module);
                this.quill = quill;
                this.options = options;
            };
            Module.DEFAULTS = {};
            exports.default = Module;
        /***/ },
        /* 10 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var levels = [
                "error",
                "warn",
                "log",
                "info"
            ];
            var level = "warn";
            function debug(method) {
                if (levels.indexOf(method) <= levels.indexOf(level)) {
                    var _console;
                    for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
                }
            }
            function namespace(ns) {
                return levels.reduce(function(logger, method) {
                    logger[method] = debug.bind(console, method, ns);
                    return logger;
                }, {});
            }
            debug.level = namespace.level = function(newLevel) {
                level = newLevel;
            };
            exports.default = namespace;
        /***/ },
        /* 11 */ /***/ function(module1, exports, __webpack_require__) {
            var pSlice = Array.prototype.slice;
            var objectKeys = __webpack_require__(52);
            var isArguments = __webpack_require__(53);
            var deepEqual = module1.exports = function(actual, expected, opts) {
                if (!opts) opts = {};
                // 7.1. All identical values are equivalent, as determined by ===.
                if (actual === expected) return true;
                else if (actual instanceof Date && expected instanceof Date) return actual.getTime() === expected.getTime();
                else if (!actual || !expected || typeof actual != "object" && typeof expected != "object") return opts.strict ? actual === expected : actual == expected;
                else return objEquiv(actual, expected, opts);
            };
            function isUndefinedOrNull(value) {
                return value === null || value === undefined;
            }
            function isBuffer(x) {
                if (!x || typeof x !== "object" || typeof x.length !== "number") return false;
                if (typeof x.copy !== "function" || typeof x.slice !== "function") return false;
                if (x.length > 0 && typeof x[0] !== "number") return false;
                return true;
            }
            function objEquiv(a, b, opts) {
                var i, key;
                if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) return false;
                // an identical 'prototype' property.
                if (a.prototype !== b.prototype) return false;
                //~~~I've managed to break Object.keys through screwy arguments passing.
                //   Converting to array solves the problem.
                if (isArguments(a)) {
                    if (!isArguments(b)) return false;
                    a = pSlice.call(a);
                    b = pSlice.call(b);
                    return deepEqual(a, b, opts);
                }
                if (isBuffer(a)) {
                    if (!isBuffer(b)) return false;
                    if (a.length !== b.length) return false;
                    for(i = 0; i < a.length; i++){
                        if (a[i] !== b[i]) return false;
                    }
                    return true;
                }
                try {
                    var ka = objectKeys(a), kb = objectKeys(b);
                } catch (e) {
                    return false;
                }
                // having the same number of owned properties (keys incorporates
                // hasOwnProperty)
                if (ka.length != kb.length) return false;
                //the same set of keys (although not necessarily the same order),
                ka.sort();
                kb.sort();
                //~~~cheap key test
                for(i = ka.length - 1; i >= 0; i--){
                    if (ka[i] != kb[i]) return false;
                }
                //equivalent values for every corresponding key, and
                //~~~possibly expensive deep test
                for(i = ka.length - 1; i >= 0; i--){
                    key = ka[i];
                    if (!deepEqual(a[key], b[key], opts)) return false;
                }
                return typeof a === typeof b;
            }
        /***/ },
        /* 12 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var Registry = __webpack_require__(1);
            var Attributor = /** @class */ function() {
                function Attributor(attrName, keyName, options) {
                    if (options === void 0) options = {};
                    this.attrName = attrName;
                    this.keyName = keyName;
                    var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
                    if (options.scope != null) // Ignore type bits, force attribute bit
                    this.scope = options.scope & Registry.Scope.LEVEL | attributeBit;
                    else this.scope = Registry.Scope.ATTRIBUTE;
                    if (options.whitelist != null) this.whitelist = options.whitelist;
                }
                Attributor.keys = function(node) {
                    return [].map.call(node.attributes, function(item) {
                        return item.name;
                    });
                };
                Attributor.prototype.add = function(node, value) {
                    if (!this.canAdd(node, value)) return false;
                    node.setAttribute(this.keyName, value);
                    return true;
                };
                Attributor.prototype.canAdd = function(node, value) {
                    var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
                    if (match == null) return false;
                    if (this.whitelist == null) return true;
                    if (typeof value === "string") return this.whitelist.indexOf(value.replace(/["']/g, "")) > -1;
                    else return this.whitelist.indexOf(value) > -1;
                };
                Attributor.prototype.remove = function(node) {
                    node.removeAttribute(this.keyName);
                };
                Attributor.prototype.value = function(node) {
                    var value = node.getAttribute(this.keyName);
                    if (this.canAdd(node, value) && value) return value;
                    return "";
                };
                return Attributor;
            }();
            exports.default = Attributor;
        /***/ },
        /* 13 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.Code = undefined;
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Code = function(_Inline) {
                _inherits(Code, _Inline);
                function Code() {
                    _classCallCheck(this, Code);
                    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
                }
                return Code;
            }(_inline2.default);
            Code.blotName = "code";
            Code.tagName = "CODE";
            var CodeBlock = function(_Block) {
                _inherits(CodeBlock, _Block);
                function CodeBlock() {
                    _classCallCheck(this, CodeBlock);
                    return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
                }
                _createClass(CodeBlock, [
                    {
                        key: "delta",
                        value: function delta() {
                            var _this3 = this;
                            var text = this.domNode.textContent;
                            if (text.endsWith("\n")) // Should always be true
                            text = text.slice(0, -1);
                            return text.split("\n").reduce(function(delta, frag) {
                                return delta.insert(frag).insert("\n", _this3.formats());
                            }, new _quillDelta2.default());
                        }
                    },
                    {
                        key: "format",
                        value: function format(name, value) {
                            if (name === this.statics.blotName && value) return;
                            var _descendant = this.descendant(_text2.default, this.length() - 1), _descendant2 = _slicedToArray(_descendant, 1), text = _descendant2[0];
                            if (text != null) text.deleteAt(text.length() - 1, 1);
                            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), "format", this).call(this, name, value);
                        }
                    },
                    {
                        key: "formatAt",
                        value: function formatAt(index, length, name, value) {
                            if (length === 0) return;
                            if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) return;
                            var nextNewline = this.newlineIndex(index);
                            if (nextNewline < 0 || nextNewline >= index + length) return;
                            var prevNewline = this.newlineIndex(index, true) + 1;
                            var isolateLength = nextNewline - prevNewline + 1;
                            var blot = this.isolate(prevNewline, isolateLength);
                            var next = blot.next;
                            blot.format(name, value);
                            if (next instanceof CodeBlock) next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
                        }
                    },
                    {
                        key: "insertAt",
                        value: function insertAt(index, value, def) {
                            if (def != null) return;
                            var _descendant3 = this.descendant(_text2.default, index), _descendant4 = _slicedToArray(_descendant3, 2), text = _descendant4[0], offset = _descendant4[1];
                            text.insertAt(offset, value);
                        }
                    },
                    {
                        key: "length",
                        value: function length() {
                            var length = this.domNode.textContent.length;
                            if (!this.domNode.textContent.endsWith("\n")) return length + 1;
                            return length;
                        }
                    },
                    {
                        key: "newlineIndex",
                        value: function newlineIndex(searchIndex) {
                            var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            if (!reverse) {
                                var offset = this.domNode.textContent.slice(searchIndex).indexOf("\n");
                                return offset > -1 ? searchIndex + offset : -1;
                            } else return this.domNode.textContent.slice(0, searchIndex).lastIndexOf("\n");
                        }
                    },
                    {
                        key: "optimize",
                        value: function optimize(context) {
                            if (!this.domNode.textContent.endsWith("\n")) this.appendChild(_parchment2.default.create("text", "\n"));
                            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), "optimize", this).call(this, context);
                            var next = this.next;
                            if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
                                next.optimize(context);
                                next.moveChildren(this);
                                next.remove();
                            }
                        }
                    },
                    {
                        key: "replace",
                        value: function replace(target) {
                            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), "replace", this).call(this, target);
                            [].slice.call(this.domNode.querySelectorAll("*")).forEach(function(node) {
                                var blot = _parchment2.default.find(node);
                                if (blot == null) node.parentNode.removeChild(node);
                                else if (blot instanceof _parchment2.default.Embed) blot.remove();
                                else blot.unwrap();
                            });
                        }
                    }
                ], [
                    {
                        key: "create",
                        value: function create(value) {
                            var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), "create", this).call(this, value);
                            domNode.setAttribute("spellcheck", false);
                            return domNode;
                        }
                    },
                    {
                        key: "formats",
                        value: function formats() {
                            return true;
                        }
                    }
                ]);
                return CodeBlock;
            }(_block2.default);
            CodeBlock.blotName = "code-block";
            CodeBlock.tagName = "PRE";
            CodeBlock.TAB = "  ";
            exports.Code = Code;
            exports.default = CodeBlock;
        /***/ },
        /* 14 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _op = __webpack_require__(20);
            var _op2 = _interopRequireDefault(_op);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _cursor = __webpack_require__(24);
            var _cursor2 = _interopRequireDefault(_cursor);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _clone = __webpack_require__(21);
            var _clone2 = _interopRequireDefault(_clone);
            var _deepEqual = __webpack_require__(11);
            var _deepEqual2 = _interopRequireDefault(_deepEqual);
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var ASCII = /^[ -~]*$/;
            var Editor = function() {
                function Editor(scroll) {
                    _classCallCheck(this, Editor);
                    this.scroll = scroll;
                    this.delta = this.getDelta();
                }
                _createClass(Editor, [
                    {
                        key: "applyDelta",
                        value: function applyDelta(delta) {
                            var _this = this;
                            var consumeNextNewline = false;
                            this.scroll.update();
                            var scrollLength = this.scroll.length();
                            this.scroll.batchStart();
                            delta = normalizeDelta(delta);
                            delta.reduce(function(index, op) {
                                var length = op.retain || op.delete || op.insert.length || 1;
                                var attributes = op.attributes || {};
                                if (op.insert != null) {
                                    if (typeof op.insert === "string") {
                                        var text = op.insert;
                                        if (text.endsWith("\n") && consumeNextNewline) {
                                            consumeNextNewline = false;
                                            text = text.slice(0, -1);
                                        }
                                        if (index >= scrollLength && !text.endsWith("\n")) consumeNextNewline = true;
                                        _this.scroll.insertAt(index, text);
                                        var _scroll$line = _this.scroll.line(index), _scroll$line2 = _slicedToArray(_scroll$line, 2), line = _scroll$line2[0], offset = _scroll$line2[1];
                                        var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
                                        if (line instanceof _block2.default) {
                                            var _line$descendant = line.descendant(_parchment2.default.Leaf, offset), _line$descendant2 = _slicedToArray(_line$descendant, 1), leaf = _line$descendant2[0];
                                            formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
                                        }
                                        attributes = _op2.default.attributes.diff(formats, attributes) || {};
                                    } else if (_typeof(op.insert) === "object") {
                                        var key = Object.keys(op.insert)[0]; // There should only be one key
                                        if (key == null) return index;
                                        _this.scroll.insertAt(index, key, op.insert[key]);
                                    }
                                    scrollLength += length;
                                }
                                Object.keys(attributes).forEach(function(name) {
                                    _this.scroll.formatAt(index, length, name, attributes[name]);
                                });
                                return index + length;
                            }, 0);
                            delta.reduce(function(index, op) {
                                if (typeof op.delete === "number") {
                                    _this.scroll.deleteAt(index, op.delete);
                                    return index;
                                }
                                return index + (op.retain || op.insert.length || 1);
                            }, 0);
                            this.scroll.batchEnd();
                            return this.update(delta);
                        }
                    },
                    {
                        key: "deleteText",
                        value: function deleteText(index, length) {
                            this.scroll.deleteAt(index, length);
                            return this.update(new _quillDelta2.default().retain(index).delete(length));
                        }
                    },
                    {
                        key: "formatLine",
                        value: function formatLine(index, length) {
                            var _this2 = this;
                            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            this.scroll.update();
                            Object.keys(formats).forEach(function(format) {
                                if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format]) return;
                                var lines = _this2.scroll.lines(index, Math.max(length, 1));
                                var lengthRemaining = length;
                                lines.forEach(function(line) {
                                    var lineLength = line.length();
                                    if (!(line instanceof _code2.default)) line.format(format, formats[format]);
                                    else {
                                        var codeIndex = index - line.offset(_this2.scroll);
                                        var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
                                        line.formatAt(codeIndex, codeLength, format, formats[format]);
                                    }
                                    lengthRemaining -= lineLength;
                                });
                            });
                            this.scroll.optimize();
                            return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
                        }
                    },
                    {
                        key: "formatText",
                        value: function formatText(index, length) {
                            var _this3 = this;
                            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            Object.keys(formats).forEach(function(format) {
                                _this3.scroll.formatAt(index, length, format, formats[format]);
                            });
                            return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
                        }
                    },
                    {
                        key: "getContents",
                        value: function getContents(index, length) {
                            return this.delta.slice(index, index + length);
                        }
                    },
                    {
                        key: "getDelta",
                        value: function getDelta() {
                            return this.scroll.lines().reduce(function(delta, line) {
                                return delta.concat(line.delta());
                            }, new _quillDelta2.default());
                        }
                    },
                    {
                        key: "getFormat",
                        value: function getFormat(index) {
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            var lines = [], leaves = [];
                            if (length === 0) this.scroll.path(index).forEach(function(path) {
                                var _path = _slicedToArray(path, 1), blot = _path[0];
                                if (blot instanceof _block2.default) lines.push(blot);
                                else if (blot instanceof _parchment2.default.Leaf) leaves.push(blot);
                            });
                            else {
                                lines = this.scroll.lines(index, length);
                                leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
                            }
                            var formatsArr = [
                                lines,
                                leaves
                            ].map(function(blots) {
                                if (blots.length === 0) return {};
                                var formats = (0, _block.bubbleFormats)(blots.shift());
                                while(Object.keys(formats).length > 0){
                                    var blot = blots.shift();
                                    if (blot == null) return formats;
                                    formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
                                }
                                return formats;
                            });
                            return _extend2.default.apply(_extend2.default, formatsArr);
                        }
                    },
                    {
                        key: "getText",
                        value: function getText(index, length) {
                            return this.getContents(index, length).filter(function(op) {
                                return typeof op.insert === "string";
                            }).map(function(op) {
                                return op.insert;
                            }).join("");
                        }
                    },
                    {
                        key: "insertEmbed",
                        value: function insertEmbed(index, embed, value) {
                            this.scroll.insertAt(index, embed, value);
                            return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
                        }
                    },
                    {
                        key: "insertText",
                        value: function insertText(index, text) {
                            var _this4 = this;
                            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            text = text.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                            this.scroll.insertAt(index, text);
                            Object.keys(formats).forEach(function(format) {
                                _this4.scroll.formatAt(index, text.length, format, formats[format]);
                            });
                            return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
                        }
                    },
                    {
                        key: "isBlank",
                        value: function isBlank() {
                            if (this.scroll.children.length == 0) return true;
                            if (this.scroll.children.length > 1) return false;
                            var block = this.scroll.children.head;
                            if (block.statics.blotName !== _block2.default.blotName) return false;
                            if (block.children.length > 1) return false;
                            return block.children.head instanceof _break2.default;
                        }
                    },
                    {
                        key: "removeFormat",
                        value: function removeFormat(index, length) {
                            var text = this.getText(index, length);
                            var _scroll$line3 = this.scroll.line(index + length), _scroll$line4 = _slicedToArray(_scroll$line3, 2), line = _scroll$line4[0], offset = _scroll$line4[1];
                            var suffixLength = 0, suffix = new _quillDelta2.default();
                            if (line != null) {
                                if (!(line instanceof _code2.default)) suffixLength = line.length() - offset;
                                else suffixLength = line.newlineIndex(offset) - offset + 1;
                                suffix = line.delta().slice(offset, offset + suffixLength - 1).insert("\n");
                            }
                            var contents = this.getContents(index, length + suffixLength);
                            var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
                            var delta = new _quillDelta2.default().retain(index).concat(diff);
                            return this.applyDelta(delta);
                        }
                    },
                    {
                        key: "update",
                        value: function update(change) {
                            var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                            var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                            var oldDelta = this.delta;
                            if (mutations.length === 1 && mutations[0].type === "characterData" && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
                                // Optimization for character changes
                                var textBlot = _parchment2.default.find(mutations[0].target);
                                var formats = (0, _block.bubbleFormats)(textBlot);
                                var index = textBlot.offset(this.scroll);
                                var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, "");
                                var oldText = new _quillDelta2.default().insert(oldValue);
                                var newText = new _quillDelta2.default().insert(textBlot.value());
                                var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
                                change = diffDelta.reduce(function(delta, op) {
                                    if (op.insert) return delta.insert(op.insert, formats);
                                    else return delta.push(op);
                                }, new _quillDelta2.default());
                                this.delta = oldDelta.compose(change);
                            } else {
                                this.delta = this.getDelta();
                                if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) change = oldDelta.diff(this.delta, cursorIndex);
                            }
                            return change;
                        }
                    }
                ]);
                return Editor;
            }();
            function combineFormats(formats, combined) {
                return Object.keys(combined).reduce(function(merged, name) {
                    if (formats[name] == null) return merged;
                    if (combined[name] === formats[name]) merged[name] = combined[name];
                    else if (Array.isArray(combined[name])) {
                        if (combined[name].indexOf(formats[name]) < 0) merged[name] = combined[name].concat([
                            formats[name]
                        ]);
                    } else merged[name] = [
                        combined[name],
                        formats[name]
                    ];
                    return merged;
                }, {});
            }
            function normalizeDelta(delta) {
                return delta.reduce(function(delta, op) {
                    if (op.insert === 1) {
                        var attributes = (0, _clone2.default)(op.attributes);
                        delete attributes["image"];
                        return delta.insert({
                            image: op.attributes.image
                        }, attributes);
                    }
                    if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
                        op = (0, _clone2.default)(op);
                        if (op.attributes.list) op.attributes.list = "ordered";
                        else {
                            op.attributes.list = "bullet";
                            delete op.attributes.bullet;
                        }
                    }
                    if (typeof op.insert === "string") {
                        var text = op.insert.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                        return delta.insert(text, op.attributes);
                    }
                    return delta.push(op);
                }, new _quillDelta2.default());
            }
            exports.default = Editor;
        /***/ },
        /* 15 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.Range = undefined;
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _clone = __webpack_require__(21);
            var _clone2 = _interopRequireDefault(_clone);
            var _deepEqual = __webpack_require__(11);
            var _deepEqual2 = _interopRequireDefault(_deepEqual);
            var _emitter3 = __webpack_require__(8);
            var _emitter4 = _interopRequireDefault(_emitter3);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _toConsumableArray(arr) {
                if (Array.isArray(arr)) {
                    for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
                    return arr2;
                } else return Array.from(arr);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var debug = (0, _logger2.default)("quill:selection");
            var Range = function Range(index) {
                var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                _classCallCheck(this, Range);
                this.index = index;
                this.length = length;
            };
            var Selection = function() {
                function Selection(scroll, emitter) {
                    var _this = this;
                    _classCallCheck(this, Selection);
                    this.emitter = emitter;
                    this.scroll = scroll;
                    this.composing = false;
                    this.mouseDown = false;
                    this.root = this.scroll.domNode;
                    this.cursor = _parchment2.default.create("cursor", this);
                    // savedRange is last non-null range
                    this.lastRange = this.savedRange = new Range(0, 0);
                    this.handleComposition();
                    this.handleDragging();
                    this.emitter.listenDOM("selectionchange", document, function() {
                        if (!_this.mouseDown) setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
                    });
                    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function(type, delta) {
                        if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) _this.update(_emitter4.default.sources.SILENT);
                    });
                    this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function() {
                        if (!_this.hasFocus()) return;
                        var native = _this.getNativeRange();
                        if (native == null) return;
                        if (native.start.node === _this.cursor.textNode) return; // cursor.restore() will handle
                        // TODO unclear if this has negative side effects
                        _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function() {
                            try {
                                _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
                            } catch (ignored) {}
                        });
                    });
                    this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function(mutations, context) {
                        if (context.range) {
                            var _context$range = context.range, startNode = _context$range.startNode, startOffset = _context$range.startOffset, endNode = _context$range.endNode, endOffset = _context$range.endOffset;
                            _this.setNativeRange(startNode, startOffset, endNode, endOffset);
                        }
                    });
                    this.update(_emitter4.default.sources.SILENT);
                }
                _createClass(Selection, [
                    {
                        key: "handleComposition",
                        value: function handleComposition() {
                            var _this2 = this;
                            this.root.addEventListener("compositionstart", function() {
                                _this2.composing = true;
                            });
                            this.root.addEventListener("compositionend", function() {
                                _this2.composing = false;
                                if (_this2.cursor.parent) {
                                    var range = _this2.cursor.restore();
                                    if (!range) return;
                                    setTimeout(function() {
                                        _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
                                    }, 1);
                                }
                            });
                        }
                    },
                    {
                        key: "handleDragging",
                        value: function handleDragging() {
                            var _this3 = this;
                            this.emitter.listenDOM("mousedown", document.body, function() {
                                _this3.mouseDown = true;
                            });
                            this.emitter.listenDOM("mouseup", document.body, function() {
                                _this3.mouseDown = false;
                                _this3.update(_emitter4.default.sources.USER);
                            });
                        }
                    },
                    {
                        key: "focus",
                        value: function focus() {
                            if (this.hasFocus()) return;
                            this.root.focus();
                            this.setRange(this.savedRange);
                        }
                    },
                    {
                        key: "format",
                        value: function format(_format, value) {
                            if (this.scroll.whitelist != null && !this.scroll.whitelist[_format]) return;
                            this.scroll.update();
                            var nativeRange = this.getNativeRange();
                            if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;
                            if (nativeRange.start.node !== this.cursor.textNode) {
                                var blot = _parchment2.default.find(nativeRange.start.node, false);
                                if (blot == null) return;
                                // TODO Give blot ability to not split
                                if (blot instanceof _parchment2.default.Leaf) {
                                    var after = blot.split(nativeRange.start.offset);
                                    blot.parent.insertBefore(this.cursor, after);
                                } else blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
                                this.cursor.attach();
                            }
                            this.cursor.format(_format, value);
                            this.scroll.optimize();
                            this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
                            this.update();
                        }
                    },
                    {
                        key: "getBounds",
                        value: function getBounds(index) {
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            var scrollLength = this.scroll.length();
                            index = Math.min(index, scrollLength - 1);
                            length = Math.min(index + length, scrollLength - 1) - index;
                            var node = void 0, _scroll$leaf = this.scroll.leaf(index), _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2), leaf = _scroll$leaf2[0], offset = _scroll$leaf2[1];
                            if (leaf == null) return null;
                            var _leaf$position = leaf.position(offset, true);
                            var _leaf$position2 = _slicedToArray(_leaf$position, 2);
                            node = _leaf$position2[0];
                            offset = _leaf$position2[1];
                            var range = document.createRange();
                            if (length > 0) {
                                range.setStart(node, offset);
                                var _scroll$leaf3 = this.scroll.leaf(index + length);
                                var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);
                                leaf = _scroll$leaf4[0];
                                offset = _scroll$leaf4[1];
                                if (leaf == null) return null;
                                var _leaf$position3 = leaf.position(offset, true);
                                var _leaf$position4 = _slicedToArray(_leaf$position3, 2);
                                node = _leaf$position4[0];
                                offset = _leaf$position4[1];
                                range.setEnd(node, offset);
                                return range.getBoundingClientRect();
                            } else {
                                var side = "left";
                                var rect = void 0;
                                if (node instanceof Text) {
                                    if (offset < node.data.length) {
                                        range.setStart(node, offset);
                                        range.setEnd(node, offset + 1);
                                    } else {
                                        range.setStart(node, offset - 1);
                                        range.setEnd(node, offset);
                                        side = "right";
                                    }
                                    rect = range.getBoundingClientRect();
                                } else {
                                    rect = leaf.domNode.getBoundingClientRect();
                                    if (offset > 0) side = "right";
                                }
                                return {
                                    bottom: rect.top + rect.height,
                                    height: rect.height,
                                    left: rect[side],
                                    right: rect[side],
                                    top: rect.top,
                                    width: 0
                                };
                            }
                        }
                    },
                    {
                        key: "getNativeRange",
                        value: function getNativeRange() {
                            var selection = document.getSelection();
                            if (selection == null || selection.rangeCount <= 0) return null;
                            var nativeRange = selection.getRangeAt(0);
                            if (nativeRange == null) return null;
                            var range = this.normalizeNative(nativeRange);
                            debug.info("getNativeRange", range);
                            return range;
                        }
                    },
                    {
                        key: "getRange",
                        value: function getRange() {
                            var normalized = this.getNativeRange();
                            if (normalized == null) return [
                                null,
                                null
                            ];
                            var range = this.normalizedToRange(normalized);
                            return [
                                range,
                                normalized
                            ];
                        }
                    },
                    {
                        key: "hasFocus",
                        value: function hasFocus() {
                            return document.activeElement === this.root;
                        }
                    },
                    {
                        key: "normalizedToRange",
                        value: function normalizedToRange(range) {
                            var _this4 = this;
                            var positions = [
                                [
                                    range.start.node,
                                    range.start.offset
                                ]
                            ];
                            if (!range.native.collapsed) positions.push([
                                range.end.node,
                                range.end.offset
                            ]);
                            var indexes = positions.map(function(position) {
                                var _position = _slicedToArray(position, 2), node = _position[0], offset = _position[1];
                                var blot = _parchment2.default.find(node, true);
                                var index = blot.offset(_this4.scroll);
                                if (offset === 0) return index;
                                else if (blot instanceof _parchment2.default.Container) return index + blot.length();
                                else return index + blot.index(node, offset);
                            });
                            var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
                            var start = Math.min.apply(Math, [
                                end
                            ].concat(_toConsumableArray(indexes)));
                            return new Range(start, end - start);
                        }
                    },
                    {
                        key: "normalizeNative",
                        value: function normalizeNative(nativeRange) {
                            if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) return null;
                            var range = {
                                start: {
                                    node: nativeRange.startContainer,
                                    offset: nativeRange.startOffset
                                },
                                end: {
                                    node: nativeRange.endContainer,
                                    offset: nativeRange.endOffset
                                },
                                native: nativeRange
                            };
                            [
                                range.start,
                                range.end
                            ].forEach(function(position) {
                                var node = position.node, offset = position.offset;
                                while(!(node instanceof Text) && node.childNodes.length > 0){
                                    if (node.childNodes.length > offset) {
                                        node = node.childNodes[offset];
                                        offset = 0;
                                    } else if (node.childNodes.length === offset) {
                                        node = node.lastChild;
                                        offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
                                    } else break;
                                }
                                position.node = node, position.offset = offset;
                            });
                            return range;
                        }
                    },
                    {
                        key: "rangeToNative",
                        value: function rangeToNative(range) {
                            var _this5 = this;
                            var indexes = range.collapsed ? [
                                range.index
                            ] : [
                                range.index,
                                range.index + range.length
                            ];
                            var args = [];
                            var scrollLength = this.scroll.length();
                            indexes.forEach(function(index, i) {
                                index = Math.min(scrollLength - 1, index);
                                var node = void 0, _scroll$leaf5 = _this5.scroll.leaf(index), _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2), leaf = _scroll$leaf6[0], offset = _scroll$leaf6[1];
                                var _leaf$position5 = leaf.position(offset, i !== 0);
                                var _leaf$position6 = _slicedToArray(_leaf$position5, 2);
                                node = _leaf$position6[0];
                                offset = _leaf$position6[1];
                                args.push(node, offset);
                            });
                            if (args.length < 2) args = args.concat(args);
                            return args;
                        }
                    },
                    {
                        key: "scrollIntoView",
                        value: function scrollIntoView(scrollingContainer) {
                            var range = this.lastRange;
                            if (range == null) return;
                            var bounds = this.getBounds(range.index, range.length);
                            if (bounds == null) return;
                            var limit = this.scroll.length() - 1;
                            var _scroll$line = this.scroll.line(Math.min(range.index, limit)), _scroll$line2 = _slicedToArray(_scroll$line, 1), first = _scroll$line2[0];
                            var last = first;
                            if (range.length > 0) {
                                var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));
                                var _scroll$line4 = _slicedToArray(_scroll$line3, 1);
                                last = _scroll$line4[0];
                            }
                            if (first == null || last == null) return;
                            var scrollBounds = scrollingContainer.getBoundingClientRect();
                            if (bounds.top < scrollBounds.top) scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
                            else if (bounds.bottom > scrollBounds.bottom) scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
                        }
                    },
                    {
                        key: "setNativeRange",
                        value: function setNativeRange(startNode, startOffset) {
                            var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
                            var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
                            var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
                            debug.info("setNativeRange", startNode, startOffset, endNode, endOffset);
                            if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) return;
                            var selection = document.getSelection();
                            if (selection == null) return;
                            if (startNode != null) {
                                if (!this.hasFocus()) this.root.focus();
                                var native = (this.getNativeRange() || {}).native;
                                if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
                                    if (startNode.tagName == "BR") {
                                        startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
                                        startNode = startNode.parentNode;
                                    }
                                    if (endNode.tagName == "BR") {
                                        endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
                                        endNode = endNode.parentNode;
                                    }
                                    var range = document.createRange();
                                    range.setStart(startNode, startOffset);
                                    range.setEnd(endNode, endOffset);
                                    selection.removeAllRanges();
                                    selection.addRange(range);
                                }
                            } else {
                                selection.removeAllRanges();
                                this.root.blur();
                                document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
                            }
                        }
                    },
                    {
                        key: "setRange",
                        value: function setRange(range) {
                            var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
                            if (typeof force === "string") {
                                source = force;
                                force = false;
                            }
                            debug.info("setRange", range);
                            if (range != null) {
                                var args = this.rangeToNative(range);
                                this.setNativeRange.apply(this, _toConsumableArray(args).concat([
                                    force
                                ]));
                            } else this.setNativeRange(null);
                            this.update(source);
                        }
                    },
                    {
                        key: "update",
                        value: function update() {
                            var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
                            var oldRange = this.lastRange;
                            var _getRange = this.getRange(), _getRange2 = _slicedToArray(_getRange, 2), lastRange = _getRange2[0], nativeRange = _getRange2[1];
                            this.lastRange = lastRange;
                            if (this.lastRange != null) this.savedRange = this.lastRange;
                            if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
                                var _emitter;
                                if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) this.cursor.restore();
                                var args = [
                                    _emitter4.default.events.SELECTION_CHANGE,
                                    (0, _clone2.default)(this.lastRange),
                                    (0, _clone2.default)(oldRange),
                                    source
                                ];
                                (_emitter = this.emitter).emit.apply(_emitter, [
                                    _emitter4.default.events.EDITOR_CHANGE
                                ].concat(args));
                                if (source !== _emitter4.default.sources.SILENT) {
                                    var _emitter2;
                                    (_emitter2 = this.emitter).emit.apply(_emitter2, args);
                                }
                            }
                        }
                    }
                ]);
                return Selection;
            }();
            function contains(parent, descendant) {
                try {
                    // Firefox inserts inaccessible nodes around video elements
                    descendant.parentNode;
                } catch (e) {
                    return false;
                }
                // IE11 has bug with Text nodes
                // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
                if (descendant instanceof Text) descendant = descendant.parentNode;
                return parent.contains(descendant);
            }
            exports.Range = Range;
            exports.default = Selection;
        /***/ },
        /* 16 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Break = function(_Parchment$Embed) {
                _inherits(Break, _Parchment$Embed);
                function Break() {
                    _classCallCheck(this, Break);
                    return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
                }
                _createClass(Break, [
                    {
                        key: "insertInto",
                        value: function insertInto(parent, ref) {
                            if (parent.children.length === 0) _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), "insertInto", this).call(this, parent, ref);
                            else this.remove();
                        }
                    },
                    {
                        key: "length",
                        value: function length() {
                            return 0;
                        }
                    },
                    {
                        key: "value",
                        value: function value() {
                            return "";
                        }
                    }
                ], [
                    {
                        key: "value",
                        value: function value() {
                            return undefined;
                        }
                    }
                ]);
                return Break;
            }(_parchment2.default.Embed);
            Break.blotName = "break";
            Break.tagName = "BR";
            exports.default = Break;
        /***/ },
        /* 17 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var linked_list_1 = __webpack_require__(44);
            var shadow_1 = __webpack_require__(30);
            var Registry = __webpack_require__(1);
            var ContainerBlot = /** @class */ function(_super) {
                __extends(ContainerBlot, _super);
                function ContainerBlot(domNode) {
                    var _this = _super.call(this, domNode) || this;
                    _this.build();
                    return _this;
                }
                ContainerBlot.prototype.appendChild = function(other) {
                    this.insertBefore(other);
                };
                ContainerBlot.prototype.attach = function() {
                    _super.prototype.attach.call(this);
                    this.children.forEach(function(child) {
                        child.attach();
                    });
                };
                ContainerBlot.prototype.build = function() {
                    var _this = this;
                    this.children = new linked_list_1.default();
                    // Need to be reversed for if DOM nodes already in order
                    [].slice.call(this.domNode.childNodes).reverse().forEach(function(node) {
                        try {
                            var child = makeBlot(node);
                            _this.insertBefore(child, _this.children.head || undefined);
                        } catch (err) {
                            if (err instanceof Registry.ParchmentError) return;
                            else throw err;
                        }
                    });
                };
                ContainerBlot.prototype.deleteAt = function(index, length) {
                    if (index === 0 && length === this.length()) return this.remove();
                    this.children.forEachAt(index, length, function(child, offset, length) {
                        child.deleteAt(offset, length);
                    });
                };
                ContainerBlot.prototype.descendant = function(criteria, index) {
                    var _a = this.children.find(index), child = _a[0], offset = _a[1];
                    if (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) return [
                        child,
                        offset
                    ];
                    else if (child instanceof ContainerBlot) return child.descendant(criteria, offset);
                    else return [
                        null,
                        -1
                    ];
                };
                ContainerBlot.prototype.descendants = function(criteria, index, length) {
                    if (index === void 0) index = 0;
                    if (length === void 0) length = Number.MAX_VALUE;
                    var descendants = [];
                    var lengthLeft = length;
                    this.children.forEachAt(index, length, function(child, index, length) {
                        if (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) descendants.push(child);
                        if (child instanceof ContainerBlot) descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
                        lengthLeft -= length;
                    });
                    return descendants;
                };
                ContainerBlot.prototype.detach = function() {
                    this.children.forEach(function(child) {
                        child.detach();
                    });
                    _super.prototype.detach.call(this);
                };
                ContainerBlot.prototype.formatAt = function(index, length, name, value) {
                    this.children.forEachAt(index, length, function(child, offset, length) {
                        child.formatAt(offset, length, name, value);
                    });
                };
                ContainerBlot.prototype.insertAt = function(index, value, def) {
                    var _a = this.children.find(index), child = _a[0], offset = _a[1];
                    if (child) child.insertAt(offset, value, def);
                    else {
                        var blot = def == null ? Registry.create("text", value) : Registry.create(value, def);
                        this.appendChild(blot);
                    }
                };
                ContainerBlot.prototype.insertBefore = function(childBlot, refBlot) {
                    if (this.statics.allowedChildren != null && !this.statics.allowedChildren.some(function(child) {
                        return childBlot instanceof child;
                    })) throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
                    childBlot.insertInto(this, refBlot);
                };
                ContainerBlot.prototype.length = function() {
                    return this.children.reduce(function(memo, child) {
                        return memo + child.length();
                    }, 0);
                };
                ContainerBlot.prototype.moveChildren = function(targetParent, refNode) {
                    this.children.forEach(function(child) {
                        targetParent.insertBefore(child, refNode);
                    });
                };
                ContainerBlot.prototype.optimize = function(context) {
                    _super.prototype.optimize.call(this, context);
                    if (this.children.length === 0) {
                        if (this.statics.defaultChild != null) {
                            var child = Registry.create(this.statics.defaultChild);
                            this.appendChild(child);
                            child.optimize(context);
                        } else this.remove();
                    }
                };
                ContainerBlot.prototype.path = function(index, inclusive) {
                    if (inclusive === void 0) inclusive = false;
                    var _a = this.children.find(index, inclusive), child = _a[0], offset = _a[1];
                    var position = [
                        [
                            this,
                            index
                        ]
                    ];
                    if (child instanceof ContainerBlot) return position.concat(child.path(offset, inclusive));
                    else if (child != null) position.push([
                        child,
                        offset
                    ]);
                    return position;
                };
                ContainerBlot.prototype.removeChild = function(child) {
                    this.children.remove(child);
                };
                ContainerBlot.prototype.replace = function(target) {
                    if (target instanceof ContainerBlot) target.moveChildren(this);
                    _super.prototype.replace.call(this, target);
                };
                ContainerBlot.prototype.split = function(index, force) {
                    if (force === void 0) force = false;
                    if (!force) {
                        if (index === 0) return this;
                        if (index === this.length()) return this.next;
                    }
                    var after = this.clone();
                    this.parent.insertBefore(after, this.next);
                    this.children.forEachAt(index, this.length(), function(child, offset, length) {
                        child = child.split(offset, force);
                        after.appendChild(child);
                    });
                    return after;
                };
                ContainerBlot.prototype.unwrap = function() {
                    this.moveChildren(this.parent, this.next);
                    this.remove();
                };
                ContainerBlot.prototype.update = function(mutations, context) {
                    var _this = this;
                    var addedNodes = [];
                    var removedNodes = [];
                    mutations.forEach(function(mutation) {
                        if (mutation.target === _this.domNode && mutation.type === "childList") {
                            addedNodes.push.apply(addedNodes, mutation.addedNodes);
                            removedNodes.push.apply(removedNodes, mutation.removedNodes);
                        }
                    });
                    removedNodes.forEach(function(node) {
                        // Check node has actually been removed
                        // One exception is Chrome does not immediately remove IFRAMEs
                        // from DOM but MutationRecord is correct in its reported removal
                        if (node.parentNode != null && // @ts-ignore
                        node.tagName !== "IFRAME" && document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) return;
                        var blot = Registry.find(node);
                        if (blot == null) return;
                        if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) blot.detach();
                    });
                    addedNodes.filter(function(node) {
                        return node.parentNode == _this.domNode;
                    }).sort(function(a, b) {
                        if (a === b) return 0;
                        if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) return 1;
                        return -1;
                    }).forEach(function(node) {
                        var refBlot = null;
                        if (node.nextSibling != null) refBlot = Registry.find(node.nextSibling);
                        var blot = makeBlot(node);
                        if (blot.next != refBlot || blot.next == null) {
                            if (blot.parent != null) blot.parent.removeChild(_this);
                            _this.insertBefore(blot, refBlot || undefined);
                        }
                    });
                };
                return ContainerBlot;
            }(shadow_1.default);
            function makeBlot(node) {
                var blot = Registry.find(node);
                if (blot == null) try {
                    blot = Registry.create(node);
                } catch (e) {
                    blot = Registry.create(Registry.Scope.INLINE);
                    [].slice.call(node.childNodes).forEach(function(child) {
                        // @ts-ignore
                        blot.domNode.appendChild(child);
                    });
                    if (node.parentNode) node.parentNode.replaceChild(blot.domNode, node);
                    blot.attach();
                }
                return blot;
            }
            exports.default = ContainerBlot;
        /***/ },
        /* 18 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var attributor_1 = __webpack_require__(12);
            var store_1 = __webpack_require__(31);
            var container_1 = __webpack_require__(17);
            var Registry = __webpack_require__(1);
            var FormatBlot = /** @class */ function(_super) {
                __extends(FormatBlot, _super);
                function FormatBlot(domNode) {
                    var _this = _super.call(this, domNode) || this;
                    _this.attributes = new store_1.default(_this.domNode);
                    return _this;
                }
                FormatBlot.formats = function(domNode) {
                    if (typeof this.tagName === "string") return true;
                    else if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
                    return undefined;
                };
                FormatBlot.prototype.format = function(name, value) {
                    var format = Registry.query(name);
                    if (format instanceof attributor_1.default) this.attributes.attribute(format, value);
                    else if (value) {
                        if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) this.replaceWith(name, value);
                    }
                };
                FormatBlot.prototype.formats = function() {
                    var formats = this.attributes.values();
                    var format = this.statics.formats(this.domNode);
                    if (format != null) formats[this.statics.blotName] = format;
                    return formats;
                };
                FormatBlot.prototype.replaceWith = function(name, value) {
                    var replacement = _super.prototype.replaceWith.call(this, name, value);
                    this.attributes.copy(replacement);
                    return replacement;
                };
                FormatBlot.prototype.update = function(mutations, context) {
                    var _this = this;
                    _super.prototype.update.call(this, mutations, context);
                    if (mutations.some(function(mutation) {
                        return mutation.target === _this.domNode && mutation.type === "attributes";
                    })) this.attributes.build();
                };
                FormatBlot.prototype.wrap = function(name, value) {
                    var wrapper = _super.prototype.wrap.call(this, name, value);
                    if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) this.attributes.move(wrapper);
                    return wrapper;
                };
                return FormatBlot;
            }(container_1.default);
            exports.default = FormatBlot;
        /***/ },
        /* 19 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var shadow_1 = __webpack_require__(30);
            var Registry = __webpack_require__(1);
            var LeafBlot = /** @class */ function(_super) {
                __extends(LeafBlot, _super);
                function LeafBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                LeafBlot.value = function(domNode) {
                    return true;
                };
                LeafBlot.prototype.index = function(node, offset) {
                    if (this.domNode === node || this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) return Math.min(offset, 1);
                    return -1;
                };
                LeafBlot.prototype.position = function(index, inclusive) {
                    var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
                    if (index > 0) offset += 1;
                    return [
                        this.parent.domNode,
                        offset
                    ];
                };
                LeafBlot.prototype.value = function() {
                    var _a;
                    return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
                };
                LeafBlot.scope = Registry.Scope.INLINE_BLOT;
                return LeafBlot;
            }(shadow_1.default);
            exports.default = LeafBlot;
        /***/ },
        /* 20 */ /***/ function(module1, exports, __webpack_require__) {
            var equal = __webpack_require__(11);
            var extend = __webpack_require__(3);
            var lib = {
                attributes: {
                    compose: function(a, b, keepNull) {
                        if (typeof a !== "object") a = {};
                        if (typeof b !== "object") b = {};
                        var attributes = extend(true, {}, b);
                        if (!keepNull) attributes = Object.keys(attributes).reduce(function(copy, key) {
                            if (attributes[key] != null) copy[key] = attributes[key];
                            return copy;
                        }, {});
                        for(var key in a)if (a[key] !== undefined && b[key] === undefined) attributes[key] = a[key];
                        return Object.keys(attributes).length > 0 ? attributes : undefined;
                    },
                    diff: function(a, b) {
                        if (typeof a !== "object") a = {};
                        if (typeof b !== "object") b = {};
                        var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function(attributes, key) {
                            if (!equal(a[key], b[key])) attributes[key] = b[key] === undefined ? null : b[key];
                            return attributes;
                        }, {});
                        return Object.keys(attributes).length > 0 ? attributes : undefined;
                    },
                    transform: function(a, b, priority) {
                        if (typeof a !== "object") return b;
                        if (typeof b !== "object") return undefined;
                        if (!priority) return b; // b simply overwrites us without priority
                        var attributes = Object.keys(b).reduce(function(attributes, key) {
                            if (a[key] === undefined) attributes[key] = b[key]; // null is a valid value
                            return attributes;
                        }, {});
                        return Object.keys(attributes).length > 0 ? attributes : undefined;
                    }
                },
                iterator: function(ops) {
                    return new Iterator(ops);
                },
                length: function(op) {
                    if (typeof op["delete"] === "number") return op["delete"];
                    else if (typeof op.retain === "number") return op.retain;
                    else return typeof op.insert === "string" ? op.insert.length : 1;
                }
            };
            function Iterator(ops) {
                this.ops = ops;
                this.index = 0;
                this.offset = 0;
            }
            Iterator.prototype.hasNext = function() {
                return this.peekLength() < Infinity;
            };
            Iterator.prototype.next = function(length) {
                if (!length) length = Infinity;
                var nextOp = this.ops[this.index];
                if (nextOp) {
                    var offset = this.offset;
                    var opLength = lib.length(nextOp);
                    if (length >= opLength - offset) {
                        length = opLength - offset;
                        this.index += 1;
                        this.offset = 0;
                    } else this.offset += length;
                    if (typeof nextOp["delete"] === "number") return {
                        "delete": length
                    };
                    else {
                        var retOp = {};
                        if (nextOp.attributes) retOp.attributes = nextOp.attributes;
                        if (typeof nextOp.retain === "number") retOp.retain = length;
                        else if (typeof nextOp.insert === "string") retOp.insert = nextOp.insert.substr(offset, length);
                        else // offset should === 0, length should === 1
                        retOp.insert = nextOp.insert;
                        return retOp;
                    }
                } else return {
                    retain: Infinity
                };
            };
            Iterator.prototype.peek = function() {
                return this.ops[this.index];
            };
            Iterator.prototype.peekLength = function() {
                if (this.ops[this.index]) // Should never return 0 if our index is being managed correctly
                return lib.length(this.ops[this.index]) - this.offset;
                else return Infinity;
            };
            Iterator.prototype.peekType = function() {
                if (this.ops[this.index]) {
                    if (typeof this.ops[this.index]["delete"] === "number") return "delete";
                    else if (typeof this.ops[this.index].retain === "number") return "retain";
                    else return "insert";
                }
                return "retain";
            };
            Iterator.prototype.rest = function() {
                if (!this.hasNext()) return [];
                else if (this.offset === 0) return this.ops.slice(this.index);
                else {
                    var offset = this.offset;
                    var index = this.index;
                    var next = this.next();
                    var rest = this.ops.slice(this.index);
                    this.offset = offset;
                    this.index = index;
                    return [
                        next
                    ].concat(rest);
                }
            };
            module1.exports = lib;
        /***/ },
        /* 21 */ /***/ function(module1, exports) {
            var clone = function() {
                "use strict";
                function _instanceof(obj, type) {
                    return type != null && obj instanceof type;
                }
                var nativeMap;
                try {
                    nativeMap = Map;
                } catch (_) {
                    // maybe a reference error because no `Map`. Give it a dummy value that no
                    // value will ever be an instanceof.
                    nativeMap = function() {};
                }
                var nativeSet;
                try {
                    nativeSet = Set;
                } catch (_) {
                    nativeSet = function() {};
                }
                var nativePromise;
                try {
                    nativePromise = Promise;
                } catch (_) {
                    nativePromise = function() {};
                }
                /**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/ function clone(parent, circular, depth, prototype, includeNonEnumerable) {
                    if (typeof circular === "object") {
                        depth = circular.depth;
                        prototype = circular.prototype;
                        includeNonEnumerable = circular.includeNonEnumerable;
                        circular = circular.circular;
                    }
                    // maintain two arrays for circular references, where corresponding parents
                    // and children have the same index
                    var allParents = [];
                    var allChildren = [];
                    var useBuffer = typeof $bf3826e8a03fdeb3$require$Buffer != "undefined";
                    if (typeof circular == "undefined") circular = true;
                    if (typeof depth == "undefined") depth = Infinity;
                    // recurse this function so we don't reset allParents and allChildren
                    function _clone(parent, depth) {
                        // cloning null always returns null
                        if (parent === null) return null;
                        if (depth === 0) return parent;
                        var child;
                        var proto;
                        if (typeof parent != "object") return parent;
                        if (_instanceof(parent, nativeMap)) child = new nativeMap();
                        else if (_instanceof(parent, nativeSet)) child = new nativeSet();
                        else if (_instanceof(parent, nativePromise)) child = new nativePromise(function(resolve, reject) {
                            parent.then(function(value) {
                                resolve(_clone(value, depth - 1));
                            }, function(err) {
                                reject(_clone(err, depth - 1));
                            });
                        });
                        else if (clone.__isArray(parent)) child = [];
                        else if (clone.__isRegExp(parent)) {
                            child = new RegExp(parent.source, __getRegExpFlags(parent));
                            if (parent.lastIndex) child.lastIndex = parent.lastIndex;
                        } else if (clone.__isDate(parent)) child = new Date(parent.getTime());
                        else if (useBuffer && $bf3826e8a03fdeb3$require$Buffer.isBuffer(parent)) {
                            if ($bf3826e8a03fdeb3$require$Buffer.allocUnsafe) // Node.js >= 4.5.0
                            child = $bf3826e8a03fdeb3$require$Buffer.allocUnsafe(parent.length);
                            else // Older Node.js versions
                            child = new $bf3826e8a03fdeb3$require$Buffer(parent.length);
                            parent.copy(child);
                            return child;
                        } else if (_instanceof(parent, Error)) child = Object.create(parent);
                        else if (typeof prototype == "undefined") {
                            proto = Object.getPrototypeOf(parent);
                            child = Object.create(proto);
                        } else {
                            child = Object.create(prototype);
                            proto = prototype;
                        }
                        if (circular) {
                            var index = allParents.indexOf(parent);
                            if (index != -1) return allChildren[index];
                            allParents.push(parent);
                            allChildren.push(child);
                        }
                        if (_instanceof(parent, nativeMap)) parent.forEach(function(value, key) {
                            var keyChild = _clone(key, depth - 1);
                            var valueChild = _clone(value, depth - 1);
                            child.set(keyChild, valueChild);
                        });
                        if (_instanceof(parent, nativeSet)) parent.forEach(function(value) {
                            var entryChild = _clone(value, depth - 1);
                            child.add(entryChild);
                        });
                        for(var i in parent){
                            var attrs;
                            if (proto) attrs = Object.getOwnPropertyDescriptor(proto, i);
                            if (attrs && attrs.set == null) continue;
                            child[i] = _clone(parent[i], depth - 1);
                        }
                        if (Object.getOwnPropertySymbols) {
                            var symbols = Object.getOwnPropertySymbols(parent);
                            for(var i = 0; i < symbols.length; i++){
                                // Don't need to worry about cloning a symbol because it is a primitive,
                                // like a number or string.
                                var symbol = symbols[i];
                                var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
                                if (descriptor && !descriptor.enumerable && !includeNonEnumerable) continue;
                                child[symbol] = _clone(parent[symbol], depth - 1);
                                if (!descriptor.enumerable) Object.defineProperty(child, symbol, {
                                    enumerable: false
                                });
                            }
                        }
                        if (includeNonEnumerable) {
                            var allPropertyNames = Object.getOwnPropertyNames(parent);
                            for(var i = 0; i < allPropertyNames.length; i++){
                                var propertyName = allPropertyNames[i];
                                var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
                                if (descriptor && descriptor.enumerable) continue;
                                child[propertyName] = _clone(parent[propertyName], depth - 1);
                                Object.defineProperty(child, propertyName, {
                                    enumerable: false
                                });
                            }
                        }
                        return child;
                    }
                    return _clone(parent, depth);
                }
                /**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */ clone.clonePrototype = function clonePrototype(parent) {
                    if (parent === null) return null;
                    var c = function() {};
                    c.prototype = parent;
                    return new c();
                };
                // private utility functions
                function __objToStr(o) {
                    return Object.prototype.toString.call(o);
                }
                clone.__objToStr = __objToStr;
                function __isDate(o) {
                    return typeof o === "object" && __objToStr(o) === "[object Date]";
                }
                clone.__isDate = __isDate;
                function __isArray(o) {
                    return typeof o === "object" && __objToStr(o) === "[object Array]";
                }
                clone.__isArray = __isArray;
                function __isRegExp(o) {
                    return typeof o === "object" && __objToStr(o) === "[object RegExp]";
                }
                clone.__isRegExp = __isRegExp;
                function __getRegExpFlags(re) {
                    var flags = "";
                    if (re.global) flags += "g";
                    if (re.ignoreCase) flags += "i";
                    if (re.multiline) flags += "m";
                    return flags;
                }
                clone.__getRegExpFlags = __getRegExpFlags;
                return clone;
            }();
            if (typeof module1 === "object" && module1.exports) module1.exports = clone;
        /***/ },
        /* 22 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _container = __webpack_require__(25);
            var _container2 = _interopRequireDefault(_container);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            function isLine(blot) {
                return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
            }
            var Scroll = function(_Parchment$Scroll) {
                _inherits(Scroll, _Parchment$Scroll);
                function Scroll(domNode, config) {
                    _classCallCheck(this, Scroll);
                    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));
                    _this.emitter = config.emitter;
                    if (Array.isArray(config.whitelist)) _this.whitelist = config.whitelist.reduce(function(whitelist, format) {
                        whitelist[format] = true;
                        return whitelist;
                    }, {});
                    // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
                    _this.domNode.addEventListener("DOMNodeInserted", function() {});
                    _this.optimize();
                    _this.enable();
                    return _this;
                }
                _createClass(Scroll, [
                    {
                        key: "batchStart",
                        value: function batchStart() {
                            this.batch = true;
                        }
                    },
                    {
                        key: "batchEnd",
                        value: function batchEnd() {
                            this.batch = false;
                            this.optimize();
                        }
                    },
                    {
                        key: "deleteAt",
                        value: function deleteAt(index, length) {
                            var _line = this.line(index), _line2 = _slicedToArray(_line, 2), first = _line2[0], offset = _line2[1];
                            var _line3 = this.line(index + length), _line4 = _slicedToArray(_line3, 1), last = _line4[0];
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), "deleteAt", this).call(this, index, length);
                            if (last != null && first !== last && offset > 0) {
                                if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
                                    this.optimize();
                                    return;
                                }
                                if (first instanceof _code2.default) {
                                    var newlineIndex = first.newlineIndex(first.length(), true);
                                    if (newlineIndex > -1) {
                                        first = first.split(newlineIndex + 1);
                                        if (first === last) {
                                            this.optimize();
                                            return;
                                        }
                                    }
                                } else if (last instanceof _code2.default) {
                                    var _newlineIndex = last.newlineIndex(0);
                                    if (_newlineIndex > -1) last.split(_newlineIndex + 1);
                                }
                                var ref = last.children.head instanceof _break2.default ? null : last.children.head;
                                first.moveChildren(last, ref);
                                first.remove();
                            }
                            this.optimize();
                        }
                    },
                    {
                        key: "enable",
                        value: function enable() {
                            var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                            this.domNode.setAttribute("contenteditable", enabled);
                        }
                    },
                    {
                        key: "formatAt",
                        value: function formatAt(index, length, format, value) {
                            if (this.whitelist != null && !this.whitelist[format]) return;
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), "formatAt", this).call(this, index, length, format, value);
                            this.optimize();
                        }
                    },
                    {
                        key: "insertAt",
                        value: function insertAt(index, value, def) {
                            if (def != null && this.whitelist != null && !this.whitelist[value]) return;
                            if (index >= this.length()) {
                                if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
                                    var blot = _parchment2.default.create(this.statics.defaultChild);
                                    this.appendChild(blot);
                                    if (def == null && value.endsWith("\n")) value = value.slice(0, -1);
                                    blot.insertAt(0, value, def);
                                } else {
                                    var embed = _parchment2.default.create(value, def);
                                    this.appendChild(embed);
                                }
                            } else _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), "insertAt", this).call(this, index, value, def);
                            this.optimize();
                        }
                    },
                    {
                        key: "insertBefore",
                        value: function insertBefore(blot, ref) {
                            if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
                                var wrapper = _parchment2.default.create(this.statics.defaultChild);
                                wrapper.appendChild(blot);
                                blot = wrapper;
                            }
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), "insertBefore", this).call(this, blot, ref);
                        }
                    },
                    {
                        key: "leaf",
                        value: function leaf(index) {
                            return this.path(index).pop() || [
                                null,
                                -1
                            ];
                        }
                    },
                    {
                        key: "line",
                        value: function line(index) {
                            if (index === this.length()) return this.line(index - 1);
                            return this.descendant(isLine, index);
                        }
                    },
                    {
                        key: "lines",
                        value: function lines() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
                            var getLines = function getLines(blot, index, length) {
                                var lines = [], lengthLeft = length;
                                blot.children.forEachAt(index, length, function(child, index, length) {
                                    if (isLine(child)) lines.push(child);
                                    else if (child instanceof _parchment2.default.Container) lines = lines.concat(getLines(child, index, lengthLeft));
                                    lengthLeft -= length;
                                });
                                return lines;
                            };
                            return getLines(this, index, length);
                        }
                    },
                    {
                        key: "optimize",
                        value: function optimize() {
                            var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            if (this.batch === true) return;
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), "optimize", this).call(this, mutations, context);
                            if (mutations.length > 0) this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
                        }
                    },
                    {
                        key: "path",
                        value: function path(index) {
                            return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), "path", this).call(this, index).slice(1); // Exclude self
                        }
                    },
                    {
                        key: "update",
                        value: function update(mutations) {
                            if (this.batch === true) return;
                            var source = _emitter2.default.sources.USER;
                            if (typeof mutations === "string") source = mutations;
                            if (!Array.isArray(mutations)) mutations = this.observer.takeRecords();
                            if (mutations.length > 0) this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), "update", this).call(this, mutations.concat([])); // pass copy
                            if (mutations.length > 0) this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
                        }
                    }
                ]);
                return Scroll;
            }(_parchment2.default.Scroll);
            Scroll.blotName = "scroll";
            Scroll.className = "ql-editor";
            Scroll.tagName = "DIV";
            Scroll.defaultChild = "block";
            Scroll.allowedChildren = [
                _block2.default,
                _block.BlockEmbed,
                _container2.default
            ];
            exports.default = Scroll;
        /***/ },
        /* 23 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.SHORTKEY = exports.default = undefined;
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _clone = __webpack_require__(21);
            var _clone2 = _interopRequireDefault(_clone);
            var _deepEqual = __webpack_require__(11);
            var _deepEqual2 = _interopRequireDefault(_deepEqual);
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _op = __webpack_require__(20);
            var _op2 = _interopRequireDefault(_op);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var debug = (0, _logger2.default)("quill:keyboard");
            var SHORTKEY = /Mac/i.test(navigator.platform) ? "metaKey" : "ctrlKey";
            var Keyboard = function(_Module) {
                _inherits(Keyboard, _Module);
                _createClass(Keyboard, null, [
                    {
                        key: "match",
                        value: function match(evt, binding) {
                            binding = normalize(binding);
                            if ([
                                "altKey",
                                "ctrlKey",
                                "metaKey",
                                "shiftKey"
                            ].some(function(key) {
                                return !!binding[key] !== evt[key] && binding[key] !== null;
                            })) return false;
                            return binding.key === (evt.which || evt.keyCode);
                        }
                    }
                ]);
                function Keyboard(quill, options) {
                    _classCallCheck(this, Keyboard);
                    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));
                    _this.bindings = {};
                    Object.keys(_this.options.bindings).forEach(function(name) {
                        if (name === "list autofill" && quill.scroll.whitelist != null && !quill.scroll.whitelist["list"]) return;
                        if (_this.options.bindings[name]) _this.addBinding(_this.options.bindings[name]);
                    });
                    _this.addBinding({
                        key: Keyboard.keys.ENTER,
                        shiftKey: null
                    }, handleEnter);
                    _this.addBinding({
                        key: Keyboard.keys.ENTER,
                        metaKey: null,
                        ctrlKey: null,
                        altKey: null
                    }, function() {});
                    if (/Firefox/i.test(navigator.userAgent)) {
                        // Need to handle delete and backspace for Firefox in the general case #1171
                        _this.addBinding({
                            key: Keyboard.keys.BACKSPACE
                        }, {
                            collapsed: true
                        }, handleBackspace);
                        _this.addBinding({
                            key: Keyboard.keys.DELETE
                        }, {
                            collapsed: true
                        }, handleDelete);
                    } else {
                        _this.addBinding({
                            key: Keyboard.keys.BACKSPACE
                        }, {
                            collapsed: true,
                            prefix: /^.?$/
                        }, handleBackspace);
                        _this.addBinding({
                            key: Keyboard.keys.DELETE
                        }, {
                            collapsed: true,
                            suffix: /^.?$/
                        }, handleDelete);
                    }
                    _this.addBinding({
                        key: Keyboard.keys.BACKSPACE
                    }, {
                        collapsed: false
                    }, handleDeleteRange);
                    _this.addBinding({
                        key: Keyboard.keys.DELETE
                    }, {
                        collapsed: false
                    }, handleDeleteRange);
                    _this.addBinding({
                        key: Keyboard.keys.BACKSPACE,
                        altKey: null,
                        ctrlKey: null,
                        metaKey: null,
                        shiftKey: null
                    }, {
                        collapsed: true,
                        offset: 0
                    }, handleBackspace);
                    _this.listen();
                    return _this;
                }
                _createClass(Keyboard, [
                    {
                        key: "addBinding",
                        value: function addBinding(key) {
                            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            var binding = normalize(key);
                            if (binding == null || binding.key == null) return debug.warn("Attempted to add invalid keyboard binding", binding);
                            if (typeof context === "function") context = {
                                handler: context
                            };
                            if (typeof handler === "function") handler = {
                                handler: handler
                            };
                            binding = (0, _extend2.default)(binding, context, handler);
                            this.bindings[binding.key] = this.bindings[binding.key] || [];
                            this.bindings[binding.key].push(binding);
                        }
                    },
                    {
                        key: "listen",
                        value: function listen() {
                            var _this2 = this;
                            this.quill.root.addEventListener("keydown", function(evt) {
                                if (evt.defaultPrevented) return;
                                var which = evt.which || evt.keyCode;
                                var bindings = (_this2.bindings[which] || []).filter(function(binding) {
                                    return Keyboard.match(evt, binding);
                                });
                                if (bindings.length === 0) return;
                                var range = _this2.quill.getSelection();
                                if (range == null || !_this2.quill.hasFocus()) return;
                                var _quill$getLine = _this2.quill.getLine(range.index), _quill$getLine2 = _slicedToArray(_quill$getLine, 2), line = _quill$getLine2[0], offset = _quill$getLine2[1];
                                var _quill$getLeaf = _this2.quill.getLeaf(range.index), _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2), leafStart = _quill$getLeaf2[0], offsetStart = _quill$getLeaf2[1];
                                var _ref = range.length === 0 ? [
                                    leafStart,
                                    offsetStart
                                ] : _this2.quill.getLeaf(range.index + range.length), _ref2 = _slicedToArray(_ref, 2), leafEnd = _ref2[0], offsetEnd = _ref2[1];
                                var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : "";
                                var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : "";
                                var curContext = {
                                    collapsed: range.length === 0,
                                    empty: range.length === 0 && line.length() <= 1,
                                    format: _this2.quill.getFormat(range),
                                    offset: offset,
                                    prefix: prefixText,
                                    suffix: suffixText
                                };
                                var prevented = bindings.some(function(binding) {
                                    if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
                                    if (binding.empty != null && binding.empty !== curContext.empty) return false;
                                    if (binding.offset != null && binding.offset !== curContext.offset) return false;
                                    if (Array.isArray(binding.format)) {
                                        // any format is present
                                        if (binding.format.every(function(name) {
                                            return curContext.format[name] == null;
                                        })) return false;
                                    } else if (_typeof(binding.format) === "object") {
                                        // all formats must match
                                        if (!Object.keys(binding.format).every(function(name) {
                                            if (binding.format[name] === true) return curContext.format[name] != null;
                                            if (binding.format[name] === false) return curContext.format[name] == null;
                                            return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
                                        })) return false;
                                    }
                                    if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
                                    if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
                                    return binding.handler.call(_this2, range, curContext) !== true;
                                });
                                if (prevented) evt.preventDefault();
                            });
                        }
                    }
                ]);
                return Keyboard;
            }(_module2.default);
            Keyboard.keys = {
                BACKSPACE: 8,
                TAB: 9,
                ENTER: 13,
                ESCAPE: 27,
                LEFT: 37,
                UP: 38,
                RIGHT: 39,
                DOWN: 40,
                DELETE: 46
            };
            Keyboard.DEFAULTS = {
                bindings: {
                    "bold": makeFormatHandler("bold"),
                    "italic": makeFormatHandler("italic"),
                    "underline": makeFormatHandler("underline"),
                    "indent": {
                        // highlight tab or tab at beginning of list, indent or blockquote
                        key: Keyboard.keys.TAB,
                        format: [
                            "blockquote",
                            "indent",
                            "list"
                        ],
                        handler: function handler(range, context) {
                            if (context.collapsed && context.offset !== 0) return true;
                            this.quill.format("indent", "+1", _quill2.default.sources.USER);
                        }
                    },
                    "outdent": {
                        key: Keyboard.keys.TAB,
                        shiftKey: true,
                        format: [
                            "blockquote",
                            "indent",
                            "list"
                        ],
                        // highlight tab or tab at beginning of list, indent or blockquote
                        handler: function handler(range, context) {
                            if (context.collapsed && context.offset !== 0) return true;
                            this.quill.format("indent", "-1", _quill2.default.sources.USER);
                        }
                    },
                    "outdent backspace": {
                        key: Keyboard.keys.BACKSPACE,
                        collapsed: true,
                        shiftKey: null,
                        metaKey: null,
                        ctrlKey: null,
                        altKey: null,
                        format: [
                            "indent",
                            "list"
                        ],
                        offset: 0,
                        handler: function handler(range, context) {
                            if (context.format.indent != null) this.quill.format("indent", "-1", _quill2.default.sources.USER);
                            else if (context.format.list != null) this.quill.format("list", false, _quill2.default.sources.USER);
                        }
                    },
                    "indent code-block": makeCodeBlockHandler(true),
                    "outdent code-block": makeCodeBlockHandler(false),
                    "remove tab": {
                        key: Keyboard.keys.TAB,
                        shiftKey: true,
                        collapsed: true,
                        prefix: /\t$/,
                        handler: function handler(range) {
                            this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
                        }
                    },
                    "tab": {
                        key: Keyboard.keys.TAB,
                        handler: function handler(range) {
                            this.quill.history.cutoff();
                            var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert("	");
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.history.cutoff();
                            this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                        }
                    },
                    "list empty enter": {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: [
                            "list"
                        ],
                        empty: true,
                        handler: function handler(range, context) {
                            this.quill.format("list", false, _quill2.default.sources.USER);
                            if (context.format.indent) this.quill.format("indent", false, _quill2.default.sources.USER);
                        }
                    },
                    "checklist enter": {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: {
                            list: "checked"
                        },
                        handler: function handler(range) {
                            var _quill$getLine3 = this.quill.getLine(range.index), _quill$getLine4 = _slicedToArray(_quill$getLine3, 2), line = _quill$getLine4[0], offset = _quill$getLine4[1];
                            var formats = (0, _extend2.default)({}, line.formats(), {
                                list: "checked"
                            });
                            var delta = new _quillDelta2.default().retain(range.index).insert("\n", formats).retain(line.length() - offset - 1).retain(1, {
                                list: "unchecked"
                            });
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                            this.quill.scrollIntoView();
                        }
                    },
                    "header enter": {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: [
                            "header"
                        ],
                        suffix: /^$/,
                        handler: function handler(range, context) {
                            var _quill$getLine5 = this.quill.getLine(range.index), _quill$getLine6 = _slicedToArray(_quill$getLine5, 2), line = _quill$getLine6[0], offset = _quill$getLine6[1];
                            var delta = new _quillDelta2.default().retain(range.index).insert("\n", context.format).retain(line.length() - offset - 1).retain(1, {
                                header: null
                            });
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                            this.quill.scrollIntoView();
                        }
                    },
                    "list autofill": {
                        key: " ",
                        collapsed: true,
                        format: {
                            list: false
                        },
                        prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
                        handler: function handler(range, context) {
                            var length = context.prefix.length;
                            var _quill$getLine7 = this.quill.getLine(range.index), _quill$getLine8 = _slicedToArray(_quill$getLine7, 2), line = _quill$getLine8[0], offset = _quill$getLine8[1];
                            if (offset > length) return true;
                            var value = void 0;
                            switch(context.prefix.trim()){
                                case "[]":
                                case "[ ]":
                                    value = "unchecked";
                                    break;
                                case "[x]":
                                    value = "checked";
                                    break;
                                case "-":
                                case "*":
                                    value = "bullet";
                                    break;
                                default:
                                    value = "ordered";
                            }
                            this.quill.insertText(range.index, " ", _quill2.default.sources.USER);
                            this.quill.history.cutoff();
                            var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, {
                                list: value
                            });
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.history.cutoff();
                            this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
                        }
                    },
                    "code exit": {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: [
                            "code-block"
                        ],
                        prefix: /\n\n$/,
                        suffix: /^\s+$/,
                        handler: function handler(range) {
                            var _quill$getLine9 = this.quill.getLine(range.index), _quill$getLine10 = _slicedToArray(_quill$getLine9, 2), line = _quill$getLine10[0], offset = _quill$getLine10[1];
                            var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, {
                                "code-block": null
                            }).delete(1);
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                        }
                    },
                    "embed left": makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
                    "embed left shift": makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
                    "embed right": makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
                    "embed right shift": makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
                }
            };
            function makeEmbedArrowHandler(key, shiftKey) {
                var _ref3;
                var where = key === Keyboard.keys.LEFT ? "prefix" : "suffix";
                return _ref3 = {
                    key: key,
                    shiftKey: shiftKey,
                    altKey: null
                }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, "handler", function handler(range) {
                    var index = range.index;
                    if (key === Keyboard.keys.RIGHT) index += range.length + 1;
                    var _quill$getLeaf3 = this.quill.getLeaf(index), _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1), leaf = _quill$getLeaf4[0];
                    if (!(leaf instanceof _parchment2.default.Embed)) return true;
                    if (key === Keyboard.keys.LEFT) {
                        if (shiftKey) this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
                        else this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
                    } else if (shiftKey) this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
                    else this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
                    return false;
                }), _ref3;
            }
            function handleBackspace(range, context) {
                if (range.index === 0 || this.quill.getLength() <= 1) return;
                var _quill$getLine11 = this.quill.getLine(range.index), _quill$getLine12 = _slicedToArray(_quill$getLine11, 1), line = _quill$getLine12[0];
                var formats = {};
                if (context.offset === 0) {
                    var _quill$getLine13 = this.quill.getLine(range.index - 1), _quill$getLine14 = _slicedToArray(_quill$getLine13, 1), prev = _quill$getLine14[0];
                    if (prev != null && prev.length() > 1) {
                        var curFormats = line.formats();
                        var prevFormats = this.quill.getFormat(range.index - 1, 1);
                        formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
                    }
                }
                // Check for astral symbols
                var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
                this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
                if (Object.keys(formats).length > 0) this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
                this.quill.focus();
            }
            function handleDelete(range, context) {
                // Check for astral symbols
                var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
                if (range.index >= this.quill.getLength() - length) return;
                var formats = {}, nextLength = 0;
                var _quill$getLine15 = this.quill.getLine(range.index), _quill$getLine16 = _slicedToArray(_quill$getLine15, 1), line = _quill$getLine16[0];
                if (context.offset >= line.length() - 1) {
                    var _quill$getLine17 = this.quill.getLine(range.index + 1), _quill$getLine18 = _slicedToArray(_quill$getLine17, 1), next = _quill$getLine18[0];
                    if (next) {
                        var curFormats = line.formats();
                        var nextFormats = this.quill.getFormat(range.index, 1);
                        formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
                        nextLength = next.length();
                    }
                }
                this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
                if (Object.keys(formats).length > 0) this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
            }
            function handleDeleteRange(range) {
                var lines = this.quill.getLines(range);
                var formats = {};
                if (lines.length > 1) {
                    var firstFormats = lines[0].formats();
                    var lastFormats = lines[lines.length - 1].formats();
                    formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
                }
                this.quill.deleteText(range, _quill2.default.sources.USER);
                if (Object.keys(formats).length > 0) this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
                this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
                this.quill.focus();
            }
            function handleEnter(range, context) {
                var _this3 = this;
                if (range.length > 0) this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
                var lineFormats = Object.keys(context.format).reduce(function(lineFormats, format) {
                    if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) lineFormats[format] = context.format[format];
                    return lineFormats;
                }, {});
                this.quill.insertText(range.index, "\n", lineFormats, _quill2.default.sources.USER);
                // Earlier scroll.deleteAt might have messed up our selection,
                // so insertText's built in selection preservation is not reliable
                this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                this.quill.focus();
                Object.keys(context.format).forEach(function(name) {
                    if (lineFormats[name] != null) return;
                    if (Array.isArray(context.format[name])) return;
                    if (name === "link") return;
                    _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
                });
            }
            function makeCodeBlockHandler(indent) {
                return {
                    key: Keyboard.keys.TAB,
                    shiftKey: !indent,
                    format: {
                        "code-block": true
                    },
                    handler: function handler(range) {
                        var CodeBlock = _parchment2.default.query("code-block");
                        var index = range.index, length = range.length;
                        var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index), _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2), block = _quill$scroll$descend2[0], offset = _quill$scroll$descend2[1];
                        if (block == null) return;
                        var scrollIndex = this.quill.getIndex(block);
                        var start = block.newlineIndex(offset, true) + 1;
                        var end = block.newlineIndex(scrollIndex + offset + length);
                        var lines = block.domNode.textContent.slice(start, end).split("\n");
                        offset = 0;
                        lines.forEach(function(line, i) {
                            if (indent) {
                                block.insertAt(start + offset, CodeBlock.TAB);
                                offset += CodeBlock.TAB.length;
                                if (i === 0) index += CodeBlock.TAB.length;
                                else length += CodeBlock.TAB.length;
                            } else if (line.startsWith(CodeBlock.TAB)) {
                                block.deleteAt(start + offset, CodeBlock.TAB.length);
                                offset -= CodeBlock.TAB.length;
                                if (i === 0) index -= CodeBlock.TAB.length;
                                else length -= CodeBlock.TAB.length;
                            }
                            offset += line.length + 1;
                        });
                        this.quill.update(_quill2.default.sources.USER);
                        this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
                    }
                };
            }
            function makeFormatHandler(format) {
                return {
                    key: format[0].toUpperCase(),
                    shortKey: true,
                    handler: function handler(range, context) {
                        this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
                    }
                };
            }
            function normalize(binding) {
                if (typeof binding === "string" || typeof binding === "number") return normalize({
                    key: binding
                });
                if ((typeof binding === "undefined" ? "undefined" : _typeof(binding)) === "object") binding = (0, _clone2.default)(binding, false);
                if (typeof binding.key === "string") {
                    if (Keyboard.keys[binding.key.toUpperCase()] != null) binding.key = Keyboard.keys[binding.key.toUpperCase()];
                    else if (binding.key.length === 1) binding.key = binding.key.toUpperCase().charCodeAt(0);
                    else return null;
                }
                if (binding.shortKey) {
                    binding[SHORTKEY] = binding.shortKey;
                    delete binding.shortKey;
                }
                return binding;
            }
            exports.default = Keyboard;
            exports.SHORTKEY = SHORTKEY;
        /***/ },
        /* 24 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Cursor = function(_Parchment$Embed) {
                _inherits(Cursor, _Parchment$Embed);
                _createClass(Cursor, null, [
                    {
                        key: "value",
                        value: function value() {
                            return undefined;
                        }
                    }
                ]);
                function Cursor(domNode, selection) {
                    _classCallCheck(this, Cursor);
                    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));
                    _this.selection = selection;
                    _this.textNode = document.createTextNode(Cursor.CONTENTS);
                    _this.domNode.appendChild(_this.textNode);
                    _this._length = 0;
                    return _this;
                }
                _createClass(Cursor, [
                    {
                        key: "detach",
                        value: function detach() {
                            // super.detach() will also clear domNode.__blot
                            if (this.parent != null) this.parent.removeChild(this);
                        }
                    },
                    {
                        key: "format",
                        value: function format(name, value) {
                            if (this._length !== 0) return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), "format", this).call(this, name, value);
                            var target = this, index = 0;
                            while(target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT){
                                index += target.offset(target.parent);
                                target = target.parent;
                            }
                            if (target != null) {
                                this._length = Cursor.CONTENTS.length;
                                target.optimize();
                                target.formatAt(index, Cursor.CONTENTS.length, name, value);
                                this._length = 0;
                            }
                        }
                    },
                    {
                        key: "index",
                        value: function index(node, offset) {
                            if (node === this.textNode) return 0;
                            return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), "index", this).call(this, node, offset);
                        }
                    },
                    {
                        key: "length",
                        value: function length() {
                            return this._length;
                        }
                    },
                    {
                        key: "position",
                        value: function position() {
                            return [
                                this.textNode,
                                this.textNode.data.length
                            ];
                        }
                    },
                    {
                        key: "remove",
                        value: function remove() {
                            _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), "remove", this).call(this);
                            this.parent = null;
                        }
                    },
                    {
                        key: "restore",
                        value: function restore() {
                            if (this.selection.composing || this.parent == null) return;
                            var textNode = this.textNode;
                            var range = this.selection.getNativeRange();
                            var restoreText = void 0, start = void 0, end = void 0;
                            if (range != null && range.start.node === textNode && range.end.node === textNode) {
                                var _ref = [
                                    textNode,
                                    range.start.offset,
                                    range.end.offset
                                ];
                                restoreText = _ref[0];
                                start = _ref[1];
                                end = _ref[2];
                            }
                            // Link format will insert text outside of anchor tag
                            while(this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode)this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
                            if (this.textNode.data !== Cursor.CONTENTS) {
                                var text = this.textNode.data.split(Cursor.CONTENTS).join("");
                                if (this.next instanceof _text2.default) {
                                    restoreText = this.next.domNode;
                                    this.next.insertAt(0, text);
                                    this.textNode.data = Cursor.CONTENTS;
                                } else {
                                    this.textNode.data = text;
                                    this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
                                    this.textNode = document.createTextNode(Cursor.CONTENTS);
                                    this.domNode.appendChild(this.textNode);
                                }
                            }
                            this.remove();
                            if (start != null) {
                                var _map = [
                                    start,
                                    end
                                ].map(function(offset) {
                                    return Math.max(0, Math.min(restoreText.data.length, offset - 1));
                                });
                                var _map2 = _slicedToArray(_map, 2);
                                start = _map2[0];
                                end = _map2[1];
                                return {
                                    startNode: restoreText,
                                    startOffset: start,
                                    endNode: restoreText,
                                    endOffset: end
                                };
                            }
                        }
                    },
                    {
                        key: "update",
                        value: function update(mutations, context) {
                            var _this2 = this;
                            if (mutations.some(function(mutation) {
                                return mutation.type === "characterData" && mutation.target === _this2.textNode;
                            })) {
                                var range = this.restore();
                                if (range) context.range = range;
                            }
                        }
                    },
                    {
                        key: "value",
                        value: function value() {
                            return "";
                        }
                    }
                ]);
                return Cursor;
            }(_parchment2.default.Embed);
            Cursor.blotName = "cursor";
            Cursor.className = "ql-cursor";
            Cursor.tagName = "span";
            Cursor.CONTENTS = "\uFEFF"; // Zero width no break space
            exports.default = Cursor;
        /***/ },
        /* 25 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Container = function(_Parchment$Container) {
                _inherits(Container, _Parchment$Container);
                function Container() {
                    _classCallCheck(this, Container);
                    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
                }
                return Container;
            }(_parchment2.default.Container);
            Container.allowedChildren = [
                _block2.default,
                _block.BlockEmbed,
                Container
            ];
            exports.default = Container;
        /***/ },
        /* 26 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ColorAttributor = function(_Parchment$Attributor) {
                _inherits(ColorAttributor, _Parchment$Attributor);
                function ColorAttributor() {
                    _classCallCheck(this, ColorAttributor);
                    return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
                }
                _createClass(ColorAttributor, [
                    {
                        key: "value",
                        value: function value(domNode) {
                            var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), "value", this).call(this, domNode);
                            if (!value.startsWith("rgb(")) return value;
                            value = value.replace(/^[^\d]+/, "").replace(/[^\d]+$/, "");
                            return "#" + value.split(",").map(function(component) {
                                return ("00" + parseInt(component).toString(16)).slice(-2);
                            }).join("");
                        }
                    }
                ]);
                return ColorAttributor;
            }(_parchment2.default.Attributor.Style);
            var ColorClass = new _parchment2.default.Attributor.Class("color", "ql-color", {
                scope: _parchment2.default.Scope.INLINE
            });
            var ColorStyle = new ColorAttributor("color", "color", {
                scope: _parchment2.default.Scope.INLINE
            });
            exports.ColorAttributor = ColorAttributor;
            exports.ColorClass = ColorClass;
            exports.ColorStyle = ColorStyle;
        /***/ },
        /* 27 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.sanitize = exports.default = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Link = function(_Inline) {
                _inherits(Link, _Inline);
                function Link() {
                    _classCallCheck(this, Link);
                    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
                }
                _createClass(Link, [
                    {
                        key: "format",
                        value: function format(name, value) {
                            if (name !== this.statics.blotName || !value) return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), "format", this).call(this, name, value);
                            value = this.constructor.sanitize(value);
                            this.domNode.setAttribute("href", value);
                        }
                    }
                ], [
                    {
                        key: "create",
                        value: function create(value) {
                            var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), "create", this).call(this, value);
                            value = this.sanitize(value);
                            node.setAttribute("href", value);
                            node.setAttribute("rel", "noopener noreferrer");
                            node.setAttribute("target", "_blank");
                            return node;
                        }
                    },
                    {
                        key: "formats",
                        value: function formats(domNode) {
                            return domNode.getAttribute("href");
                        }
                    },
                    {
                        key: "sanitize",
                        value: function sanitize(url) {
                            return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
                        }
                    }
                ]);
                return Link;
            }(_inline2.default);
            Link.blotName = "link";
            Link.tagName = "A";
            Link.SANITIZED_URL = "about:blank";
            Link.PROTOCOL_WHITELIST = [
                "http",
                "https",
                "mailto",
                "tel"
            ];
            function _sanitize(url, protocols) {
                var anchor = document.createElement("a");
                anchor.href = url;
                var protocol = anchor.href.slice(0, anchor.href.indexOf(":"));
                return protocols.indexOf(protocol) > -1;
            }
            exports.default = Link;
            exports.sanitize = _sanitize;
        /***/ },
        /* 28 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _keyboard = __webpack_require__(23);
            var _keyboard2 = _interopRequireDefault(_keyboard);
            var _dropdown = __webpack_require__(107);
            var _dropdown2 = _interopRequireDefault(_dropdown);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var optionsCounter = 0;
            function toggleAriaAttribute(element, attribute) {
                element.setAttribute(attribute, !(element.getAttribute(attribute) === "true"));
            }
            var Picker = function() {
                function Picker(select) {
                    var _this = this;
                    _classCallCheck(this, Picker);
                    this.select = select;
                    this.container = document.createElement("span");
                    this.buildPicker();
                    this.select.style.display = "none";
                    this.select.parentNode.insertBefore(this.container, this.select);
                    this.label.addEventListener("mousedown", function() {
                        _this.togglePicker();
                    });
                    this.label.addEventListener("keydown", function(event) {
                        switch(event.keyCode){
                            // Allows the "Enter" key to open the picker
                            case _keyboard2.default.keys.ENTER:
                                _this.togglePicker();
                                break;
                            // Allows the "Escape" key to close the picker
                            case _keyboard2.default.keys.ESCAPE:
                                _this.escape();
                                event.preventDefault();
                                break;
                            default:
                        }
                    });
                    this.select.addEventListener("change", this.update.bind(this));
                }
                _createClass(Picker, [
                    {
                        key: "togglePicker",
                        value: function togglePicker() {
                            this.container.classList.toggle("ql-expanded");
                            // Toggle aria-expanded and aria-hidden to make the picker accessible
                            toggleAriaAttribute(this.label, "aria-expanded");
                            toggleAriaAttribute(this.options, "aria-hidden");
                        }
                    },
                    {
                        key: "buildItem",
                        value: function buildItem(option) {
                            var _this2 = this;
                            var item = document.createElement("span");
                            item.tabIndex = "0";
                            item.setAttribute("role", "button");
                            item.classList.add("ql-picker-item");
                            if (option.hasAttribute("value")) item.setAttribute("data-value", option.getAttribute("value"));
                            if (option.textContent) item.setAttribute("data-label", option.textContent);
                            item.addEventListener("click", function() {
                                _this2.selectItem(item, true);
                            });
                            item.addEventListener("keydown", function(event) {
                                switch(event.keyCode){
                                    // Allows the "Enter" key to select an item
                                    case _keyboard2.default.keys.ENTER:
                                        _this2.selectItem(item, true);
                                        event.preventDefault();
                                        break;
                                    // Allows the "Escape" key to close the picker
                                    case _keyboard2.default.keys.ESCAPE:
                                        _this2.escape();
                                        event.preventDefault();
                                        break;
                                    default:
                                }
                            });
                            return item;
                        }
                    },
                    {
                        key: "buildLabel",
                        value: function buildLabel() {
                            var label = document.createElement("span");
                            label.classList.add("ql-picker-label");
                            label.innerHTML = _dropdown2.default;
                            label.tabIndex = "0";
                            label.setAttribute("role", "button");
                            label.setAttribute("aria-expanded", "false");
                            this.container.appendChild(label);
                            return label;
                        }
                    },
                    {
                        key: "buildOptions",
                        value: function buildOptions() {
                            var _this3 = this;
                            var options = document.createElement("span");
                            options.classList.add("ql-picker-options");
                            // Don't want screen readers to read this until options are visible
                            options.setAttribute("aria-hidden", "true");
                            options.tabIndex = "-1";
                            // Need a unique id for aria-controls
                            options.id = "ql-picker-options-" + optionsCounter;
                            optionsCounter += 1;
                            this.label.setAttribute("aria-controls", options.id);
                            this.options = options;
                            [].slice.call(this.select.options).forEach(function(option) {
                                var item = _this3.buildItem(option);
                                options.appendChild(item);
                                if (option.selected === true) _this3.selectItem(item);
                            });
                            this.container.appendChild(options);
                        }
                    },
                    {
                        key: "buildPicker",
                        value: function buildPicker() {
                            var _this4 = this;
                            [].slice.call(this.select.attributes).forEach(function(item) {
                                _this4.container.setAttribute(item.name, item.value);
                            });
                            this.container.classList.add("ql-picker");
                            this.label = this.buildLabel();
                            this.buildOptions();
                        }
                    },
                    {
                        key: "escape",
                        value: function escape() {
                            var _this5 = this;
                            // Close menu and return focus to trigger label
                            this.close();
                            // Need setTimeout for accessibility to ensure that the browser executes
                            // focus on the next process thread and after any DOM content changes
                            setTimeout(function() {
                                return _this5.label.focus();
                            }, 1);
                        }
                    },
                    {
                        key: "close",
                        value: function close() {
                            this.container.classList.remove("ql-expanded");
                            this.label.setAttribute("aria-expanded", "false");
                            this.options.setAttribute("aria-hidden", "true");
                        }
                    },
                    {
                        key: "selectItem",
                        value: function selectItem(item) {
                            var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            var selected = this.container.querySelector(".ql-selected");
                            if (item === selected) return;
                            if (selected != null) selected.classList.remove("ql-selected");
                            if (item == null) return;
                            item.classList.add("ql-selected");
                            this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
                            if (item.hasAttribute("data-value")) this.label.setAttribute("data-value", item.getAttribute("data-value"));
                            else this.label.removeAttribute("data-value");
                            if (item.hasAttribute("data-label")) this.label.setAttribute("data-label", item.getAttribute("data-label"));
                            else this.label.removeAttribute("data-label");
                            if (trigger) {
                                if (typeof Event === "function") this.select.dispatchEvent(new Event("change"));
                                else if ((typeof Event === "undefined" ? "undefined" : _typeof(Event)) === "object") {
                                    // IE11
                                    var event = document.createEvent("Event");
                                    event.initEvent("change", true, true);
                                    this.select.dispatchEvent(event);
                                }
                                this.close();
                            }
                        }
                    },
                    {
                        key: "update",
                        value: function update() {
                            var option = void 0;
                            if (this.select.selectedIndex > -1) {
                                var item = this.container.querySelector(".ql-picker-options").children[this.select.selectedIndex];
                                option = this.select.options[this.select.selectedIndex];
                                this.selectItem(item);
                            } else this.selectItem(null);
                            var isActive = option != null && option !== this.select.querySelector("option[selected]");
                            this.label.classList.toggle("ql-active", isActive);
                        }
                    }
                ]);
                return Picker;
            }();
            exports.default = Picker;
        /***/ },
        /* 29 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _container = __webpack_require__(25);
            var _container2 = _interopRequireDefault(_container);
            var _cursor = __webpack_require__(24);
            var _cursor2 = _interopRequireDefault(_cursor);
            var _embed = __webpack_require__(35);
            var _embed2 = _interopRequireDefault(_embed);
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            var _scroll = __webpack_require__(22);
            var _scroll2 = _interopRequireDefault(_scroll);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            var _clipboard = __webpack_require__(55);
            var _clipboard2 = _interopRequireDefault(_clipboard);
            var _history = __webpack_require__(42);
            var _history2 = _interopRequireDefault(_history);
            var _keyboard = __webpack_require__(23);
            var _keyboard2 = _interopRequireDefault(_keyboard);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            _quill2.default.register({
                "blots/block": _block2.default,
                "blots/block/embed": _block.BlockEmbed,
                "blots/break": _break2.default,
                "blots/container": _container2.default,
                "blots/cursor": _cursor2.default,
                "blots/embed": _embed2.default,
                "blots/inline": _inline2.default,
                "blots/scroll": _scroll2.default,
                "blots/text": _text2.default,
                "modules/clipboard": _clipboard2.default,
                "modules/history": _history2.default,
                "modules/keyboard": _keyboard2.default
            });
            _parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);
            exports.default = _quill2.default;
        /***/ },
        /* 30 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var Registry = __webpack_require__(1);
            var ShadowBlot = /** @class */ function() {
                function ShadowBlot(domNode) {
                    this.domNode = domNode;
                    // @ts-ignore
                    this.domNode[Registry.DATA_KEY] = {
                        blot: this
                    };
                }
                Object.defineProperty(ShadowBlot.prototype, "statics", {
                    // Hack for accessing inherited static methods
                    get: function() {
                        return this.constructor;
                    },
                    enumerable: true,
                    configurable: true
                });
                ShadowBlot.create = function(value) {
                    if (this.tagName == null) throw new Registry.ParchmentError("Blot definition missing tagName");
                    var node;
                    if (Array.isArray(this.tagName)) {
                        if (typeof value === "string") {
                            value = value.toUpperCase();
                            if (parseInt(value).toString() === value) value = parseInt(value);
                        }
                        if (typeof value === "number") node = document.createElement(this.tagName[value - 1]);
                        else if (this.tagName.indexOf(value) > -1) node = document.createElement(value);
                        else node = document.createElement(this.tagName[0]);
                    } else node = document.createElement(this.tagName);
                    if (this.className) node.classList.add(this.className);
                    return node;
                };
                ShadowBlot.prototype.attach = function() {
                    if (this.parent != null) this.scroll = this.parent.scroll;
                };
                ShadowBlot.prototype.clone = function() {
                    var domNode = this.domNode.cloneNode(false);
                    return Registry.create(domNode);
                };
                ShadowBlot.prototype.detach = function() {
                    if (this.parent != null) this.parent.removeChild(this);
                    // @ts-ignore
                    delete this.domNode[Registry.DATA_KEY];
                };
                ShadowBlot.prototype.deleteAt = function(index, length) {
                    var blot = this.isolate(index, length);
                    blot.remove();
                };
                ShadowBlot.prototype.formatAt = function(index, length, name, value) {
                    var blot = this.isolate(index, length);
                    if (Registry.query(name, Registry.Scope.BLOT) != null && value) blot.wrap(name, value);
                    else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
                        var parent = Registry.create(this.statics.scope);
                        blot.wrap(parent);
                        parent.format(name, value);
                    }
                };
                ShadowBlot.prototype.insertAt = function(index, value, def) {
                    var blot = def == null ? Registry.create("text", value) : Registry.create(value, def);
                    var ref = this.split(index);
                    this.parent.insertBefore(blot, ref);
                };
                ShadowBlot.prototype.insertInto = function(parentBlot, refBlot) {
                    if (refBlot === void 0) refBlot = null;
                    if (this.parent != null) this.parent.children.remove(this);
                    var refDomNode = null;
                    parentBlot.children.insertBefore(this, refBlot);
                    if (refBlot != null) refDomNode = refBlot.domNode;
                    if (this.domNode.parentNode != parentBlot.domNode || this.domNode.nextSibling != refDomNode) parentBlot.domNode.insertBefore(this.domNode, refDomNode);
                    this.parent = parentBlot;
                    this.attach();
                };
                ShadowBlot.prototype.isolate = function(index, length) {
                    var target = this.split(index);
                    target.split(length);
                    return target;
                };
                ShadowBlot.prototype.length = function() {
                    return 1;
                };
                ShadowBlot.prototype.offset = function(root) {
                    if (root === void 0) root = this.parent;
                    if (this.parent == null || this == root) return 0;
                    return this.parent.children.offset(this) + this.parent.offset(root);
                };
                ShadowBlot.prototype.optimize = function(context) {
                    // TODO clean up once we use WeakMap
                    // @ts-ignore
                    if (this.domNode[Registry.DATA_KEY] != null) // @ts-ignore
                    delete this.domNode[Registry.DATA_KEY].mutations;
                };
                ShadowBlot.prototype.remove = function() {
                    if (this.domNode.parentNode != null) this.domNode.parentNode.removeChild(this.domNode);
                    this.detach();
                };
                ShadowBlot.prototype.replace = function(target) {
                    if (target.parent == null) return;
                    target.parent.insertBefore(this, target.next);
                    target.remove();
                };
                ShadowBlot.prototype.replaceWith = function(name, value) {
                    var replacement = typeof name === "string" ? Registry.create(name, value) : name;
                    replacement.replace(this);
                    return replacement;
                };
                ShadowBlot.prototype.split = function(index, force) {
                    return index === 0 ? this : this.next;
                };
                ShadowBlot.prototype.update = function(mutations, context) {
                // Nothing to do by default
                };
                ShadowBlot.prototype.wrap = function(name, value) {
                    var wrapper = typeof name === "string" ? Registry.create(name, value) : name;
                    if (this.parent != null) this.parent.insertBefore(wrapper, this.next);
                    wrapper.appendChild(this);
                    return wrapper;
                };
                ShadowBlot.blotName = "abstract";
                return ShadowBlot;
            }();
            exports.default = ShadowBlot;
        /***/ },
        /* 31 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var attributor_1 = __webpack_require__(12);
            var class_1 = __webpack_require__(32);
            var style_1 = __webpack_require__(33);
            var Registry = __webpack_require__(1);
            var AttributorStore = /** @class */ function() {
                function AttributorStore(domNode) {
                    this.attributes = {};
                    this.domNode = domNode;
                    this.build();
                }
                AttributorStore.prototype.attribute = function(attribute, value) {
                    // verb
                    if (value) {
                        if (attribute.add(this.domNode, value)) {
                            if (attribute.value(this.domNode) != null) this.attributes[attribute.attrName] = attribute;
                            else delete this.attributes[attribute.attrName];
                        }
                    } else {
                        attribute.remove(this.domNode);
                        delete this.attributes[attribute.attrName];
                    }
                };
                AttributorStore.prototype.build = function() {
                    var _this = this;
                    this.attributes = {};
                    var attributes = attributor_1.default.keys(this.domNode);
                    var classes = class_1.default.keys(this.domNode);
                    var styles = style_1.default.keys(this.domNode);
                    attributes.concat(classes).concat(styles).forEach(function(name) {
                        var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
                        if (attr instanceof attributor_1.default) _this.attributes[attr.attrName] = attr;
                    });
                };
                AttributorStore.prototype.copy = function(target) {
                    var _this = this;
                    Object.keys(this.attributes).forEach(function(key) {
                        var value = _this.attributes[key].value(_this.domNode);
                        target.format(key, value);
                    });
                };
                AttributorStore.prototype.move = function(target) {
                    var _this = this;
                    this.copy(target);
                    Object.keys(this.attributes).forEach(function(key) {
                        _this.attributes[key].remove(_this.domNode);
                    });
                    this.attributes = {};
                };
                AttributorStore.prototype.values = function() {
                    var _this = this;
                    return Object.keys(this.attributes).reduce(function(attributes, name) {
                        attributes[name] = _this.attributes[name].value(_this.domNode);
                        return attributes;
                    }, {});
                };
                return AttributorStore;
            }();
            exports.default = AttributorStore;
        /***/ },
        /* 32 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var attributor_1 = __webpack_require__(12);
            function match(node, prefix) {
                var className = node.getAttribute("class") || "";
                return className.split(/\s+/).filter(function(name) {
                    return name.indexOf(prefix + "-") === 0;
                });
            }
            var ClassAttributor = /** @class */ function(_super) {
                __extends(ClassAttributor, _super);
                function ClassAttributor() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                ClassAttributor.keys = function(node) {
                    return (node.getAttribute("class") || "").split(/\s+/).map(function(name) {
                        return name.split("-").slice(0, -1).join("-");
                    });
                };
                ClassAttributor.prototype.add = function(node, value) {
                    if (!this.canAdd(node, value)) return false;
                    this.remove(node);
                    node.classList.add(this.keyName + "-" + value);
                    return true;
                };
                ClassAttributor.prototype.remove = function(node) {
                    var matches = match(node, this.keyName);
                    matches.forEach(function(name) {
                        node.classList.remove(name);
                    });
                    if (node.classList.length === 0) node.removeAttribute("class");
                };
                ClassAttributor.prototype.value = function(node) {
                    var result = match(node, this.keyName)[0] || "";
                    var value = result.slice(this.keyName.length + 1); // +1 for hyphen
                    return this.canAdd(node, value) ? value : "";
                };
                return ClassAttributor;
            }(attributor_1.default);
            exports.default = ClassAttributor;
        /***/ },
        /* 33 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var attributor_1 = __webpack_require__(12);
            function camelize(name) {
                var parts = name.split("-");
                var rest = parts.slice(1).map(function(part) {
                    return part[0].toUpperCase() + part.slice(1);
                }).join("");
                return parts[0] + rest;
            }
            var StyleAttributor = /** @class */ function(_super) {
                __extends(StyleAttributor, _super);
                function StyleAttributor() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                StyleAttributor.keys = function(node) {
                    return (node.getAttribute("style") || "").split(";").map(function(value) {
                        var arr = value.split(":");
                        return arr[0].trim();
                    });
                };
                StyleAttributor.prototype.add = function(node, value) {
                    if (!this.canAdd(node, value)) return false;
                    // @ts-ignore
                    node.style[camelize(this.keyName)] = value;
                    return true;
                };
                StyleAttributor.prototype.remove = function(node) {
                    // @ts-ignore
                    node.style[camelize(this.keyName)] = "";
                    if (!node.getAttribute("style")) node.removeAttribute("style");
                };
                StyleAttributor.prototype.value = function(node) {
                    // @ts-ignore
                    var value = node.style[camelize(this.keyName)];
                    return this.canAdd(node, value) ? value : "";
                };
                return StyleAttributor;
            }(attributor_1.default);
            exports.default = StyleAttributor;
        /***/ },
        /* 34 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var Theme = function() {
                function Theme(quill, options) {
                    _classCallCheck(this, Theme);
                    this.quill = quill;
                    this.options = options;
                    this.modules = {};
                }
                _createClass(Theme, [
                    {
                        key: "init",
                        value: function init() {
                            var _this = this;
                            Object.keys(this.options.modules).forEach(function(name) {
                                if (_this.modules[name] == null) _this.addModule(name);
                            });
                        }
                    },
                    {
                        key: "addModule",
                        value: function addModule(name) {
                            var moduleClass = this.quill.constructor.import("modules/" + name);
                            this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
                            return this.modules[name];
                        }
                    }
                ]);
                return Theme;
            }();
            Theme.DEFAULTS = {
                modules: {}
            };
            Theme.themes = {
                "default": Theme
            };
            exports.default = Theme;
        /***/ },
        /* 35 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var GUARD_TEXT = "\uFEFF";
            var Embed = function(_Parchment$Embed) {
                _inherits(Embed, _Parchment$Embed);
                function Embed(node) {
                    _classCallCheck(this, Embed);
                    var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, node));
                    _this.contentNode = document.createElement("span");
                    _this.contentNode.setAttribute("contenteditable", false);
                    [].slice.call(_this.domNode.childNodes).forEach(function(childNode) {
                        _this.contentNode.appendChild(childNode);
                    });
                    _this.leftGuard = document.createTextNode(GUARD_TEXT);
                    _this.rightGuard = document.createTextNode(GUARD_TEXT);
                    _this.domNode.appendChild(_this.leftGuard);
                    _this.domNode.appendChild(_this.contentNode);
                    _this.domNode.appendChild(_this.rightGuard);
                    return _this;
                }
                _createClass(Embed, [
                    {
                        key: "index",
                        value: function index(node, offset) {
                            if (node === this.leftGuard) return 0;
                            if (node === this.rightGuard) return 1;
                            return _get(Embed.prototype.__proto__ || Object.getPrototypeOf(Embed.prototype), "index", this).call(this, node, offset);
                        }
                    },
                    {
                        key: "restore",
                        value: function restore(node) {
                            var range = void 0, textNode = void 0;
                            var text = node.data.split(GUARD_TEXT).join("");
                            if (node === this.leftGuard) {
                                if (this.prev instanceof _text2.default) {
                                    var prevLength = this.prev.length();
                                    this.prev.insertAt(prevLength, text);
                                    range = {
                                        startNode: this.prev.domNode,
                                        startOffset: prevLength + text.length
                                    };
                                } else {
                                    textNode = document.createTextNode(text);
                                    this.parent.insertBefore(_parchment2.default.create(textNode), this);
                                    range = {
                                        startNode: textNode,
                                        startOffset: text.length
                                    };
                                }
                            } else if (node === this.rightGuard) {
                                if (this.next instanceof _text2.default) {
                                    this.next.insertAt(0, text);
                                    range = {
                                        startNode: this.next.domNode,
                                        startOffset: text.length
                                    };
                                } else {
                                    textNode = document.createTextNode(text);
                                    this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
                                    range = {
                                        startNode: textNode,
                                        startOffset: text.length
                                    };
                                }
                            }
                            node.data = GUARD_TEXT;
                            return range;
                        }
                    },
                    {
                        key: "update",
                        value: function update(mutations, context) {
                            var _this2 = this;
                            mutations.forEach(function(mutation) {
                                if (mutation.type === "characterData" && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
                                    var range = _this2.restore(mutation.target);
                                    if (range) context.range = range;
                                }
                            });
                        }
                    }
                ]);
                return Embed;
            }(_parchment2.default.Embed);
            exports.default = Embed;
        /***/ },
        /* 36 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var config = {
                scope: _parchment2.default.Scope.BLOCK,
                whitelist: [
                    "right",
                    "center",
                    "justify"
                ]
            };
            var AlignAttribute = new _parchment2.default.Attributor.Attribute("align", "align", config);
            var AlignClass = new _parchment2.default.Attributor.Class("align", "ql-align", config);
            var AlignStyle = new _parchment2.default.Attributor.Style("align", "text-align", config);
            exports.AlignAttribute = AlignAttribute;
            exports.AlignClass = AlignClass;
            exports.AlignStyle = AlignStyle;
        /***/ },
        /* 37 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.BackgroundStyle = exports.BackgroundClass = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _color = __webpack_require__(26);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var BackgroundClass = new _parchment2.default.Attributor.Class("background", "ql-bg", {
                scope: _parchment2.default.Scope.INLINE
            });
            var BackgroundStyle = new _color.ColorAttributor("background", "background-color", {
                scope: _parchment2.default.Scope.INLINE
            });
            exports.BackgroundClass = BackgroundClass;
            exports.BackgroundStyle = BackgroundStyle;
        /***/ },
        /* 38 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var config = {
                scope: _parchment2.default.Scope.BLOCK,
                whitelist: [
                    "rtl"
                ]
            };
            var DirectionAttribute = new _parchment2.default.Attributor.Attribute("direction", "dir", config);
            var DirectionClass = new _parchment2.default.Attributor.Class("direction", "ql-direction", config);
            var DirectionStyle = new _parchment2.default.Attributor.Style("direction", "direction", config);
            exports.DirectionAttribute = DirectionAttribute;
            exports.DirectionClass = DirectionClass;
            exports.DirectionStyle = DirectionStyle;
        /***/ },
        /* 39 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.FontClass = exports.FontStyle = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var config = {
                scope: _parchment2.default.Scope.INLINE,
                whitelist: [
                    "serif",
                    "monospace"
                ]
            };
            var FontClass = new _parchment2.default.Attributor.Class("font", "ql-font", config);
            var FontStyleAttributor = function(_Parchment$Attributor) {
                _inherits(FontStyleAttributor, _Parchment$Attributor);
                function FontStyleAttributor() {
                    _classCallCheck(this, FontStyleAttributor);
                    return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
                }
                _createClass(FontStyleAttributor, [
                    {
                        key: "value",
                        value: function value(node) {
                            return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), "value", this).call(this, node).replace(/["']/g, "");
                        }
                    }
                ]);
                return FontStyleAttributor;
            }(_parchment2.default.Attributor.Style);
            var FontStyle = new FontStyleAttributor("font", "font-family", config);
            exports.FontStyle = FontStyle;
            exports.FontClass = FontClass;
        /***/ },
        /* 40 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.SizeStyle = exports.SizeClass = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var SizeClass = new _parchment2.default.Attributor.Class("size", "ql-size", {
                scope: _parchment2.default.Scope.INLINE,
                whitelist: [
                    "small",
                    "large",
                    "huge"
                ]
            });
            var SizeStyle = new _parchment2.default.Attributor.Style("size", "font-size", {
                scope: _parchment2.default.Scope.INLINE,
                whitelist: [
                    "10px",
                    "18px",
                    "32px"
                ]
            });
            exports.SizeClass = SizeClass;
            exports.SizeStyle = SizeStyle;
        /***/ },
        /* 41 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = {
                "align": {
                    "": __webpack_require__(76),
                    "center": __webpack_require__(77),
                    "right": __webpack_require__(78),
                    "justify": __webpack_require__(79)
                },
                "background": __webpack_require__(80),
                "blockquote": __webpack_require__(81),
                "bold": __webpack_require__(82),
                "clean": __webpack_require__(83),
                "code": __webpack_require__(58),
                "code-block": __webpack_require__(58),
                "color": __webpack_require__(84),
                "direction": {
                    "": __webpack_require__(85),
                    "rtl": __webpack_require__(86)
                },
                "float": {
                    "center": __webpack_require__(87),
                    "full": __webpack_require__(88),
                    "left": __webpack_require__(89),
                    "right": __webpack_require__(90)
                },
                "formula": __webpack_require__(91),
                "header": {
                    "1": __webpack_require__(92),
                    "2": __webpack_require__(93)
                },
                "italic": __webpack_require__(94),
                "image": __webpack_require__(95),
                "indent": {
                    "+1": __webpack_require__(96),
                    "-1": __webpack_require__(97)
                },
                "link": __webpack_require__(98),
                "list": {
                    "ordered": __webpack_require__(99),
                    "bullet": __webpack_require__(100),
                    "check": __webpack_require__(101)
                },
                "script": {
                    "sub": __webpack_require__(102),
                    "super": __webpack_require__(103)
                },
                "strike": __webpack_require__(104),
                "underline": __webpack_require__(105),
                "video": __webpack_require__(106)
            };
        /***/ },
        /* 42 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.getLastChangeIndex = exports.default = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var History = function(_Module) {
                _inherits(History, _Module);
                function History(quill, options) {
                    _classCallCheck(this, History);
                    var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));
                    _this.lastRecorded = 0;
                    _this.ignoreChange = false;
                    _this.clear();
                    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function(eventName, delta, oldDelta, source) {
                        if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;
                        if (!_this.options.userOnly || source === _quill2.default.sources.USER) _this.record(delta, oldDelta);
                        else _this.transform(delta);
                    });
                    _this.quill.keyboard.addBinding({
                        key: "Z",
                        shortKey: true
                    }, _this.undo.bind(_this));
                    _this.quill.keyboard.addBinding({
                        key: "Z",
                        shortKey: true,
                        shiftKey: true
                    }, _this.redo.bind(_this));
                    if (/Win/i.test(navigator.platform)) _this.quill.keyboard.addBinding({
                        key: "Y",
                        shortKey: true
                    }, _this.redo.bind(_this));
                    return _this;
                }
                _createClass(History, [
                    {
                        key: "change",
                        value: function change(source, dest) {
                            if (this.stack[source].length === 0) return;
                            var delta = this.stack[source].pop();
                            this.stack[dest].push(delta);
                            this.lastRecorded = 0;
                            this.ignoreChange = true;
                            this.quill.updateContents(delta[source], _quill2.default.sources.USER);
                            this.ignoreChange = false;
                            var index = getLastChangeIndex(delta[source]);
                            this.quill.setSelection(index);
                        }
                    },
                    {
                        key: "clear",
                        value: function clear() {
                            this.stack = {
                                undo: [],
                                redo: []
                            };
                        }
                    },
                    {
                        key: "cutoff",
                        value: function cutoff() {
                            this.lastRecorded = 0;
                        }
                    },
                    {
                        key: "record",
                        value: function record(changeDelta, oldDelta) {
                            if (changeDelta.ops.length === 0) return;
                            this.stack.redo = [];
                            var undoDelta = this.quill.getContents().diff(oldDelta);
                            var timestamp = Date.now();
                            if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
                                var delta = this.stack.undo.pop();
                                undoDelta = undoDelta.compose(delta.undo);
                                changeDelta = delta.redo.compose(changeDelta);
                            } else this.lastRecorded = timestamp;
                            this.stack.undo.push({
                                redo: changeDelta,
                                undo: undoDelta
                            });
                            if (this.stack.undo.length > this.options.maxStack) this.stack.undo.shift();
                        }
                    },
                    {
                        key: "redo",
                        value: function redo() {
                            this.change("redo", "undo");
                        }
                    },
                    {
                        key: "transform",
                        value: function transform(delta) {
                            this.stack.undo.forEach(function(change) {
                                change.undo = delta.transform(change.undo, true);
                                change.redo = delta.transform(change.redo, true);
                            });
                            this.stack.redo.forEach(function(change) {
                                change.undo = delta.transform(change.undo, true);
                                change.redo = delta.transform(change.redo, true);
                            });
                        }
                    },
                    {
                        key: "undo",
                        value: function undo() {
                            this.change("undo", "redo");
                        }
                    }
                ]);
                return History;
            }(_module2.default);
            History.DEFAULTS = {
                delay: 1000,
                maxStack: 100,
                userOnly: false
            };
            function endsWithNewlineChange(delta) {
                var lastOp = delta.ops[delta.ops.length - 1];
                if (lastOp == null) return false;
                if (lastOp.insert != null) return typeof lastOp.insert === "string" && lastOp.insert.endsWith("\n");
                if (lastOp.attributes != null) return Object.keys(lastOp.attributes).some(function(attr) {
                    return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
                });
                return false;
            }
            function getLastChangeIndex(delta) {
                var deleteLength = delta.reduce(function(length, op) {
                    length += op.delete || 0;
                    return length;
                }, 0);
                var changeIndex = delta.length() - deleteLength;
                if (endsWithNewlineChange(delta)) changeIndex -= 1;
                return changeIndex;
            }
            exports.default = History;
            exports.getLastChangeIndex = getLastChangeIndex;
        /***/ },
        /* 43 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.BaseTooltip = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _keyboard = __webpack_require__(23);
            var _keyboard2 = _interopRequireDefault(_keyboard);
            var _theme = __webpack_require__(34);
            var _theme2 = _interopRequireDefault(_theme);
            var _colorPicker = __webpack_require__(59);
            var _colorPicker2 = _interopRequireDefault(_colorPicker);
            var _iconPicker = __webpack_require__(60);
            var _iconPicker2 = _interopRequireDefault(_iconPicker);
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            var _tooltip = __webpack_require__(61);
            var _tooltip2 = _interopRequireDefault(_tooltip);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ALIGNS = [
                false,
                "center",
                "right",
                "justify"
            ];
            var COLORS = [
                "#000000",
                "#e60000",
                "#ff9900",
                "#ffff00",
                "#008a00",
                "#0066cc",
                "#9933ff",
                "#ffffff",
                "#facccc",
                "#ffebcc",
                "#ffffcc",
                "#cce8cc",
                "#cce0f5",
                "#ebd6ff",
                "#bbbbbb",
                "#f06666",
                "#ffc266",
                "#ffff66",
                "#66b966",
                "#66a3e0",
                "#c285ff",
                "#888888",
                "#a10000",
                "#b26b00",
                "#b2b200",
                "#006100",
                "#0047b2",
                "#6b24b2",
                "#444444",
                "#5c0000",
                "#663d00",
                "#666600",
                "#003700",
                "#002966",
                "#3d1466"
            ];
            var FONTS = [
                false,
                "serif",
                "monospace"
            ];
            var HEADERS = [
                "1",
                "2",
                "3",
                false
            ];
            var SIZES = [
                "small",
                false,
                "large",
                "huge"
            ];
            var BaseTheme = function(_Theme) {
                _inherits(BaseTheme, _Theme);
                function BaseTheme(quill, options) {
                    _classCallCheck(this, BaseTheme);
                    var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));
                    var listener = function listener(e) {
                        if (!document.body.contains(quill.root)) return document.body.removeEventListener("click", listener);
                        if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) _this.tooltip.hide();
                        if (_this.pickers != null) _this.pickers.forEach(function(picker) {
                            if (!picker.container.contains(e.target)) picker.close();
                        });
                    };
                    quill.emitter.listenDOM("click", document.body, listener);
                    return _this;
                }
                _createClass(BaseTheme, [
                    {
                        key: "addModule",
                        value: function addModule(name) {
                            var module1 = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), "addModule", this).call(this, name);
                            if (name === "toolbar") this.extendToolbar(module1);
                            return module1;
                        }
                    },
                    {
                        key: "buildButtons",
                        value: function buildButtons(buttons, icons) {
                            buttons.forEach(function(button) {
                                var className = button.getAttribute("class") || "";
                                className.split(/\s+/).forEach(function(name) {
                                    if (!name.startsWith("ql-")) return;
                                    name = name.slice(3);
                                    if (icons[name] == null) return;
                                    if (name === "direction") button.innerHTML = icons[name][""] + icons[name]["rtl"];
                                    else if (typeof icons[name] === "string") button.innerHTML = icons[name];
                                    else {
                                        var value = button.value || "";
                                        if (value != null && icons[name][value]) button.innerHTML = icons[name][value];
                                    }
                                });
                            });
                        }
                    },
                    {
                        key: "buildPickers",
                        value: function buildPickers(selects, icons) {
                            var _this2 = this;
                            this.pickers = selects.map(function(select) {
                                if (select.classList.contains("ql-align")) {
                                    if (select.querySelector("option") == null) fillSelect(select, ALIGNS);
                                    return new _iconPicker2.default(select, icons.align);
                                } else if (select.classList.contains("ql-background") || select.classList.contains("ql-color")) {
                                    var format = select.classList.contains("ql-background") ? "background" : "color";
                                    if (select.querySelector("option") == null) fillSelect(select, COLORS, format === "background" ? "#ffffff" : "#000000");
                                    return new _colorPicker2.default(select, icons[format]);
                                } else {
                                    if (select.querySelector("option") == null) {
                                        if (select.classList.contains("ql-font")) fillSelect(select, FONTS);
                                        else if (select.classList.contains("ql-header")) fillSelect(select, HEADERS);
                                        else if (select.classList.contains("ql-size")) fillSelect(select, SIZES);
                                    }
                                    return new _picker2.default(select);
                                }
                            });
                            var update = function update() {
                                _this2.pickers.forEach(function(picker) {
                                    picker.update();
                                });
                            };
                            this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
                        }
                    }
                ]);
                return BaseTheme;
            }(_theme2.default);
            BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
                modules: {
                    toolbar: {
                        handlers: {
                            formula: function formula() {
                                this.quill.theme.tooltip.edit("formula");
                            },
                            image: function image() {
                                var _this3 = this;
                                var fileInput = this.container.querySelector("input.ql-image[type=file]");
                                if (fileInput == null) {
                                    fileInput = document.createElement("input");
                                    fileInput.setAttribute("type", "file");
                                    fileInput.setAttribute("accept", "image/png, image/gif, image/jpeg, image/bmp, image/x-icon");
                                    fileInput.classList.add("ql-image");
                                    fileInput.addEventListener("change", function() {
                                        if (fileInput.files != null && fileInput.files[0] != null) {
                                            var reader = new FileReader();
                                            reader.onload = function(e) {
                                                var range = _this3.quill.getSelection(true);
                                                _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({
                                                    image: e.target.result
                                                }), _emitter2.default.sources.USER);
                                                _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
                                                fileInput.value = "";
                                            };
                                            reader.readAsDataURL(fileInput.files[0]);
                                        }
                                    });
                                    this.container.appendChild(fileInput);
                                }
                                fileInput.click();
                            },
                            video: function video() {
                                this.quill.theme.tooltip.edit("video");
                            }
                        }
                    }
                }
            });
            var BaseTooltip = function(_Tooltip) {
                _inherits(BaseTooltip, _Tooltip);
                function BaseTooltip(quill, boundsContainer) {
                    _classCallCheck(this, BaseTooltip);
                    var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));
                    _this4.textbox = _this4.root.querySelector('input[type="text"]');
                    _this4.listen();
                    return _this4;
                }
                _createClass(BaseTooltip, [
                    {
                        key: "listen",
                        value: function listen() {
                            var _this5 = this;
                            this.textbox.addEventListener("keydown", function(event) {
                                if (_keyboard2.default.match(event, "enter")) {
                                    _this5.save();
                                    event.preventDefault();
                                } else if (_keyboard2.default.match(event, "escape")) {
                                    _this5.cancel();
                                    event.preventDefault();
                                }
                            });
                        }
                    },
                    {
                        key: "cancel",
                        value: function cancel() {
                            this.hide();
                        }
                    },
                    {
                        key: "edit",
                        value: function edit() {
                            var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "link";
                            var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                            this.root.classList.remove("ql-hidden");
                            this.root.classList.add("ql-editing");
                            if (preview != null) this.textbox.value = preview;
                            else if (mode !== this.root.getAttribute("data-mode")) this.textbox.value = "";
                            this.position(this.quill.getBounds(this.quill.selection.savedRange));
                            this.textbox.select();
                            this.textbox.setAttribute("placeholder", this.textbox.getAttribute("data-" + mode) || "");
                            this.root.setAttribute("data-mode", mode);
                        }
                    },
                    {
                        key: "restoreFocus",
                        value: function restoreFocus() {
                            var scrollTop = this.quill.scrollingContainer.scrollTop;
                            this.quill.focus();
                            this.quill.scrollingContainer.scrollTop = scrollTop;
                        }
                    },
                    {
                        key: "save",
                        value: function save() {
                            var value = this.textbox.value;
                            switch(this.root.getAttribute("data-mode")){
                                case "link":
                                    var scrollTop = this.quill.root.scrollTop;
                                    if (this.linkRange) {
                                        this.quill.formatText(this.linkRange, "link", value, _emitter2.default.sources.USER);
                                        delete this.linkRange;
                                    } else {
                                        this.restoreFocus();
                                        this.quill.format("link", value, _emitter2.default.sources.USER);
                                    }
                                    this.quill.root.scrollTop = scrollTop;
                                    break;
                                case "video":
                                    value = extractVideoUrl(value);
                                case "formula":
                                    if (!value) break;
                                    var range = this.quill.getSelection(true);
                                    if (range != null) {
                                        var index = range.index + range.length;
                                        this.quill.insertEmbed(index, this.root.getAttribute("data-mode"), value, _emitter2.default.sources.USER);
                                        if (this.root.getAttribute("data-mode") === "formula") this.quill.insertText(index + 1, " ", _emitter2.default.sources.USER);
                                        this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
                                    }
                                    break;
                                default:
                            }
                            this.textbox.value = "";
                            this.hide();
                        }
                    }
                ]);
                return BaseTooltip;
            }(_tooltip2.default);
            function extractVideoUrl(url) {
                var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
                if (match) return (match[1] || "https") + "://www.youtube.com/embed/" + match[2] + "?showinfo=0";
                if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) // eslint-disable-line no-cond-assign
                return (match[1] || "https") + "://player.vimeo.com/video/" + match[2] + "/";
                return url;
            }
            function fillSelect(select, values) {
                var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                values.forEach(function(value) {
                    var option = document.createElement("option");
                    if (value === defaultValue) option.setAttribute("selected", "selected");
                    else option.setAttribute("value", value);
                    select.appendChild(option);
                });
            }
            exports.BaseTooltip = BaseTooltip;
            exports.default = BaseTheme;
        /***/ },
        /* 44 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var LinkedList = /** @class */ function() {
                function LinkedList() {
                    this.head = this.tail = null;
                    this.length = 0;
                }
                LinkedList.prototype.append = function() {
                    var nodes = [];
                    for(var _i = 0; _i < arguments.length; _i++)nodes[_i] = arguments[_i];
                    this.insertBefore(nodes[0], null);
                    if (nodes.length > 1) this.append.apply(this, nodes.slice(1));
                };
                LinkedList.prototype.contains = function(node) {
                    var cur, next = this.iterator();
                    while(cur = next()){
                        if (cur === node) return true;
                    }
                    return false;
                };
                LinkedList.prototype.insertBefore = function(node, refNode) {
                    if (!node) return;
                    node.next = refNode;
                    if (refNode != null) {
                        node.prev = refNode.prev;
                        if (refNode.prev != null) refNode.prev.next = node;
                        refNode.prev = node;
                        if (refNode === this.head) this.head = node;
                    } else if (this.tail != null) {
                        this.tail.next = node;
                        node.prev = this.tail;
                        this.tail = node;
                    } else {
                        node.prev = null;
                        this.head = this.tail = node;
                    }
                    this.length += 1;
                };
                LinkedList.prototype.offset = function(target) {
                    var index = 0, cur = this.head;
                    while(cur != null){
                        if (cur === target) return index;
                        index += cur.length();
                        cur = cur.next;
                    }
                    return -1;
                };
                LinkedList.prototype.remove = function(node) {
                    if (!this.contains(node)) return;
                    if (node.prev != null) node.prev.next = node.next;
                    if (node.next != null) node.next.prev = node.prev;
                    if (node === this.head) this.head = node.next;
                    if (node === this.tail) this.tail = node.prev;
                    this.length -= 1;
                };
                LinkedList.prototype.iterator = function(curNode) {
                    if (curNode === void 0) curNode = this.head;
                    // TODO use yield when we can
                    return function() {
                        var ret = curNode;
                        if (curNode != null) curNode = curNode.next;
                        return ret;
                    };
                };
                LinkedList.prototype.find = function(index, inclusive) {
                    if (inclusive === void 0) inclusive = false;
                    var cur, next = this.iterator();
                    while(cur = next()){
                        var length = cur.length();
                        if (index < length || inclusive && index === length && (cur.next == null || cur.next.length() !== 0)) return [
                            cur,
                            index
                        ];
                        index -= length;
                    }
                    return [
                        null,
                        0
                    ];
                };
                LinkedList.prototype.forEach = function(callback) {
                    var cur, next = this.iterator();
                    while(cur = next())callback(cur);
                };
                LinkedList.prototype.forEachAt = function(index, length, callback) {
                    if (length <= 0) return;
                    var _a = this.find(index), startNode = _a[0], offset = _a[1];
                    var cur, curIndex = index - offset, next = this.iterator(startNode);
                    while((cur = next()) && curIndex < index + length){
                        var curLength = cur.length();
                        if (index > curIndex) callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
                        else callback(cur, 0, Math.min(curLength, index + length - curIndex));
                        curIndex += curLength;
                    }
                };
                LinkedList.prototype.map = function(callback) {
                    return this.reduce(function(memo, cur) {
                        memo.push(callback(cur));
                        return memo;
                    }, []);
                };
                LinkedList.prototype.reduce = function(callback, memo) {
                    var cur, next = this.iterator();
                    while(cur = next())memo = callback(memo, cur);
                    return memo;
                };
                return LinkedList;
            }();
            exports.default = LinkedList;
        /***/ },
        /* 45 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var container_1 = __webpack_require__(17);
            var Registry = __webpack_require__(1);
            var OBSERVER_CONFIG = {
                attributes: true,
                characterData: true,
                characterDataOldValue: true,
                childList: true,
                subtree: true
            };
            var MAX_OPTIMIZE_ITERATIONS = 100;
            var ScrollBlot = /** @class */ function(_super) {
                __extends(ScrollBlot, _super);
                function ScrollBlot(node) {
                    var _this = _super.call(this, node) || this;
                    _this.scroll = _this;
                    _this.observer = new MutationObserver(function(mutations) {
                        _this.update(mutations);
                    });
                    _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
                    _this.attach();
                    return _this;
                }
                ScrollBlot.prototype.detach = function() {
                    _super.prototype.detach.call(this);
                    this.observer.disconnect();
                };
                ScrollBlot.prototype.deleteAt = function(index, length) {
                    this.update();
                    if (index === 0 && length === this.length()) this.children.forEach(function(child) {
                        child.remove();
                    });
                    else _super.prototype.deleteAt.call(this, index, length);
                };
                ScrollBlot.prototype.formatAt = function(index, length, name, value) {
                    this.update();
                    _super.prototype.formatAt.call(this, index, length, name, value);
                };
                ScrollBlot.prototype.insertAt = function(index, value, def) {
                    this.update();
                    _super.prototype.insertAt.call(this, index, value, def);
                };
                ScrollBlot.prototype.optimize = function(mutations, context) {
                    var _this = this;
                    if (mutations === void 0) mutations = [];
                    if (context === void 0) context = {};
                    _super.prototype.optimize.call(this, context);
                    // We must modify mutations directly, cannot make copy and then modify
                    var records = [].slice.call(this.observer.takeRecords());
                    // Array.push currently seems to be implemented by a non-tail recursive function
                    // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
                    while(records.length > 0)mutations.push(records.pop());
                    // TODO use WeakMap
                    var mark = function(blot, markParent) {
                        if (markParent === void 0) markParent = true;
                        if (blot == null || blot === _this) return;
                        if (blot.domNode.parentNode == null) return;
                        // @ts-ignore
                        if (blot.domNode[Registry.DATA_KEY].mutations == null) // @ts-ignore
                        blot.domNode[Registry.DATA_KEY].mutations = [];
                        if (markParent) mark(blot.parent);
                    };
                    var optimize = function(blot) {
                        // Post-order traversal
                        if (// @ts-ignore
                        blot.domNode[Registry.DATA_KEY] == null || // @ts-ignore
                        blot.domNode[Registry.DATA_KEY].mutations == null) return;
                        if (blot instanceof container_1.default) blot.children.forEach(optimize);
                        blot.optimize(context);
                    };
                    var remaining = mutations;
                    for(var i = 0; remaining.length > 0; i += 1){
                        if (i >= MAX_OPTIMIZE_ITERATIONS) throw new Error("[Parchment] Maximum optimize iterations reached");
                        remaining.forEach(function(mutation) {
                            var blot = Registry.find(mutation.target, true);
                            if (blot == null) return;
                            if (blot.domNode === mutation.target) {
                                if (mutation.type === "childList") {
                                    mark(Registry.find(mutation.previousSibling, false));
                                    [].forEach.call(mutation.addedNodes, function(node) {
                                        var child = Registry.find(node, false);
                                        mark(child, false);
                                        if (child instanceof container_1.default) child.children.forEach(function(grandChild) {
                                            mark(grandChild, false);
                                        });
                                    });
                                } else if (mutation.type === "attributes") mark(blot.prev);
                            }
                            mark(blot);
                        });
                        this.children.forEach(optimize);
                        remaining = [].slice.call(this.observer.takeRecords());
                        records = remaining.slice();
                        while(records.length > 0)mutations.push(records.pop());
                    }
                };
                ScrollBlot.prototype.update = function(mutations, context) {
                    var _this = this;
                    if (context === void 0) context = {};
                    mutations = mutations || this.observer.takeRecords();
                    // TODO use WeakMap
                    mutations.map(function(mutation) {
                        var blot = Registry.find(mutation.target, true);
                        if (blot == null) return null;
                        // @ts-ignore
                        if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                            // @ts-ignore
                            blot.domNode[Registry.DATA_KEY].mutations = [
                                mutation
                            ];
                            return blot;
                        } else {
                            // @ts-ignore
                            blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
                            return null;
                        }
                    }).forEach(function(blot) {
                        if (blot == null || blot === _this || //@ts-ignore
                        blot.domNode[Registry.DATA_KEY] == null) return;
                        // @ts-ignore
                        blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
                    });
                    // @ts-ignore
                    if (this.domNode[Registry.DATA_KEY].mutations != null) // @ts-ignore
                    _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
                    this.optimize(mutations, context);
                };
                ScrollBlot.blotName = "scroll";
                ScrollBlot.defaultChild = "block";
                ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
                ScrollBlot.tagName = "DIV";
                return ScrollBlot;
            }(container_1.default);
            exports.default = ScrollBlot;
        /***/ },
        /* 46 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var format_1 = __webpack_require__(18);
            var Registry = __webpack_require__(1);
            // Shallow object comparison
            function isEqual(obj1, obj2) {
                if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
                // @ts-ignore
                for(var prop in obj1){
                    // @ts-ignore
                    if (obj1[prop] !== obj2[prop]) return false;
                }
                return true;
            }
            var InlineBlot = /** @class */ function(_super) {
                __extends(InlineBlot, _super);
                function InlineBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                InlineBlot.formats = function(domNode) {
                    if (domNode.tagName === InlineBlot.tagName) return undefined;
                    return _super.formats.call(this, domNode);
                };
                InlineBlot.prototype.format = function(name, value) {
                    var _this = this;
                    if (name === this.statics.blotName && !value) {
                        this.children.forEach(function(child) {
                            if (!(child instanceof format_1.default)) child = child.wrap(InlineBlot.blotName, true);
                            _this.attributes.copy(child);
                        });
                        this.unwrap();
                    } else _super.prototype.format.call(this, name, value);
                };
                InlineBlot.prototype.formatAt = function(index, length, name, value) {
                    if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
                        var blot = this.isolate(index, length);
                        blot.format(name, value);
                    } else _super.prototype.formatAt.call(this, index, length, name, value);
                };
                InlineBlot.prototype.optimize = function(context) {
                    _super.prototype.optimize.call(this, context);
                    var formats = this.formats();
                    if (Object.keys(formats).length === 0) return this.unwrap(); // unformatted span
                    var next = this.next;
                    if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
                        next.moveChildren(this);
                        next.remove();
                    }
                };
                InlineBlot.blotName = "inline";
                InlineBlot.scope = Registry.Scope.INLINE_BLOT;
                InlineBlot.tagName = "SPAN";
                return InlineBlot;
            }(format_1.default);
            exports.default = InlineBlot;
        /***/ },
        /* 47 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var format_1 = __webpack_require__(18);
            var Registry = __webpack_require__(1);
            var BlockBlot = /** @class */ function(_super) {
                __extends(BlockBlot, _super);
                function BlockBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                BlockBlot.formats = function(domNode) {
                    var tagName = Registry.query(BlockBlot.blotName).tagName;
                    if (domNode.tagName === tagName) return undefined;
                    return _super.formats.call(this, domNode);
                };
                BlockBlot.prototype.format = function(name, value) {
                    if (Registry.query(name, Registry.Scope.BLOCK) == null) return;
                    else if (name === this.statics.blotName && !value) this.replaceWith(BlockBlot.blotName);
                    else _super.prototype.format.call(this, name, value);
                };
                BlockBlot.prototype.formatAt = function(index, length, name, value) {
                    if (Registry.query(name, Registry.Scope.BLOCK) != null) this.format(name, value);
                    else _super.prototype.formatAt.call(this, index, length, name, value);
                };
                BlockBlot.prototype.insertAt = function(index, value, def) {
                    if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) // Insert text or inline
                    _super.prototype.insertAt.call(this, index, value, def);
                    else {
                        var after = this.split(index);
                        var blot = Registry.create(value, def);
                        after.parent.insertBefore(blot, after);
                    }
                };
                BlockBlot.prototype.update = function(mutations, context) {
                    if (navigator.userAgent.match(/Trident/)) this.build();
                    else _super.prototype.update.call(this, mutations, context);
                };
                BlockBlot.blotName = "block";
                BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
                BlockBlot.tagName = "P";
                return BlockBlot;
            }(format_1.default);
            exports.default = BlockBlot;
        /***/ },
        /* 48 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var leaf_1 = __webpack_require__(19);
            var EmbedBlot = /** @class */ function(_super) {
                __extends(EmbedBlot, _super);
                function EmbedBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                EmbedBlot.formats = function(domNode) {
                    return undefined;
                };
                EmbedBlot.prototype.format = function(name, value) {
                    // super.formatAt wraps, which is what we want in general,
                    // but this allows subclasses to overwrite for formats
                    // that just apply to particular embeds
                    _super.prototype.formatAt.call(this, 0, this.length(), name, value);
                };
                EmbedBlot.prototype.formatAt = function(index, length, name, value) {
                    if (index === 0 && length === this.length()) this.format(name, value);
                    else _super.prototype.formatAt.call(this, index, length, name, value);
                };
                EmbedBlot.prototype.formats = function() {
                    return this.statics.formats(this.domNode);
                };
                return EmbedBlot;
            }(leaf_1.default);
            exports.default = EmbedBlot;
        /***/ },
        /* 49 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var leaf_1 = __webpack_require__(19);
            var Registry = __webpack_require__(1);
            var TextBlot = /** @class */ function(_super) {
                __extends(TextBlot, _super);
                function TextBlot(node) {
                    var _this = _super.call(this, node) || this;
                    _this.text = _this.statics.value(_this.domNode);
                    return _this;
                }
                TextBlot.create = function(value) {
                    return document.createTextNode(value);
                };
                TextBlot.value = function(domNode) {
                    var text = domNode.data;
                    // @ts-ignore
                    if (text["normalize"]) text = text["normalize"]();
                    return text;
                };
                TextBlot.prototype.deleteAt = function(index, length) {
                    this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
                };
                TextBlot.prototype.index = function(node, offset) {
                    if (this.domNode === node) return offset;
                    return -1;
                };
                TextBlot.prototype.insertAt = function(index, value, def) {
                    if (def == null) {
                        this.text = this.text.slice(0, index) + value + this.text.slice(index);
                        this.domNode.data = this.text;
                    } else _super.prototype.insertAt.call(this, index, value, def);
                };
                TextBlot.prototype.length = function() {
                    return this.text.length;
                };
                TextBlot.prototype.optimize = function(context) {
                    _super.prototype.optimize.call(this, context);
                    this.text = this.statics.value(this.domNode);
                    if (this.text.length === 0) this.remove();
                    else if (this.next instanceof TextBlot && this.next.prev === this) {
                        this.insertAt(this.length(), this.next.value());
                        this.next.remove();
                    }
                };
                TextBlot.prototype.position = function(index, inclusive) {
                    if (inclusive === void 0) inclusive = false;
                    return [
                        this.domNode,
                        index
                    ];
                };
                TextBlot.prototype.split = function(index, force) {
                    if (force === void 0) force = false;
                    if (!force) {
                        if (index === 0) return this;
                        if (index === this.length()) return this.next;
                    }
                    var after = Registry.create(this.domNode.splitText(index));
                    this.parent.insertBefore(after, this.next);
                    this.text = this.statics.value(this.domNode);
                    return after;
                };
                TextBlot.prototype.update = function(mutations, context) {
                    var _this = this;
                    if (mutations.some(function(mutation) {
                        return mutation.type === "characterData" && mutation.target === _this.domNode;
                    })) this.text = this.statics.value(this.domNode);
                };
                TextBlot.prototype.value = function() {
                    return this.text;
                };
                TextBlot.blotName = "text";
                TextBlot.scope = Registry.Scope.INLINE_BLOT;
                return TextBlot;
            }(leaf_1.default);
            exports.default = TextBlot;
        /***/ },
        /* 50 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var elem = document.createElement("div");
            elem.classList.toggle("test-class", false);
            if (elem.classList.contains("test-class")) {
                var _toggle = DOMTokenList.prototype.toggle;
                DOMTokenList.prototype.toggle = function(token, force) {
                    if (arguments.length > 1 && !this.contains(token) === !force) return force;
                    else return _toggle.call(this, token);
                };
            }
            if (!String.prototype.startsWith) String.prototype.startsWith = function(searchString, position) {
                position = position || 0;
                return this.substr(position, searchString.length) === searchString;
            };
            if (!String.prototype.endsWith) String.prototype.endsWith = function(searchString, position) {
                var subjectString = this.toString();
                if (typeof position !== "number" || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) position = subjectString.length;
                position -= searchString.length;
                var lastIndex = subjectString.indexOf(searchString, position);
                return lastIndex !== -1 && lastIndex === position;
            };
            if (!Array.prototype.find) Object.defineProperty(Array.prototype, "find", {
                value: function value(predicate) {
                    if (this === null) throw new TypeError("Array.prototype.find called on null or undefined");
                    if (typeof predicate !== "function") throw new TypeError("predicate must be a function");
                    var list = Object(this);
                    var length = list.length >>> 0;
                    var thisArg = arguments[1];
                    var value;
                    for(var i = 0; i < length; i++){
                        value = list[i];
                        if (predicate.call(thisArg, value, i, list)) return value;
                    }
                    return undefined;
                }
            });
            document.addEventListener("DOMContentLoaded", function() {
                // Disable resizing in Firefox
                document.execCommand("enableObjectResizing", false, false);
                // Disable automatic linkifying in IE11
                document.execCommand("autoUrlDetect", false, false);
            });
        /***/ },
        /* 51 */ /***/ function(module1, exports) {
            /**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */ var DIFF_DELETE = -1;
            var DIFF_INSERT = 1;
            var DIFF_EQUAL = 0;
            /**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int} cursor_pos Expected edit position in text1 (optional)
 * @return {Array} Array of diff tuples.
 */ function diff_main(text1, text2, cursor_pos) {
                // Check for equality (speedup).
                if (text1 == text2) {
                    if (text1) return [
                        [
                            DIFF_EQUAL,
                            text1
                        ]
                    ];
                    return [];
                }
                // Check cursor_pos within bounds
                if (cursor_pos < 0 || text1.length < cursor_pos) cursor_pos = null;
                // Trim off common prefix (speedup).
                var commonlength = diff_commonPrefix(text1, text2);
                var commonprefix = text1.substring(0, commonlength);
                text1 = text1.substring(commonlength);
                text2 = text2.substring(commonlength);
                // Trim off common suffix (speedup).
                commonlength = diff_commonSuffix(text1, text2);
                var commonsuffix = text1.substring(text1.length - commonlength);
                text1 = text1.substring(0, text1.length - commonlength);
                text2 = text2.substring(0, text2.length - commonlength);
                // Compute the diff on the middle block.
                var diffs = diff_compute_(text1, text2);
                // Restore the prefix and suffix.
                if (commonprefix) diffs.unshift([
                    DIFF_EQUAL,
                    commonprefix
                ]);
                if (commonsuffix) diffs.push([
                    DIFF_EQUAL,
                    commonsuffix
                ]);
                diff_cleanupMerge(diffs);
                if (cursor_pos != null) diffs = fix_cursor(diffs, cursor_pos);
                diffs = fix_emoji(diffs);
                return diffs;
            }
            /**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */ function diff_compute_(text1, text2) {
                var diffs;
                if (!text1) // Just add some text (speedup).
                return [
                    [
                        DIFF_INSERT,
                        text2
                    ]
                ];
                if (!text2) // Just delete some text (speedup).
                return [
                    [
                        DIFF_DELETE,
                        text1
                    ]
                ];
                var longtext = text1.length > text2.length ? text1 : text2;
                var shorttext = text1.length > text2.length ? text2 : text1;
                var i = longtext.indexOf(shorttext);
                if (i != -1) {
                    // Shorter text is inside the longer text (speedup).
                    diffs = [
                        [
                            DIFF_INSERT,
                            longtext.substring(0, i)
                        ],
                        [
                            DIFF_EQUAL,
                            shorttext
                        ],
                        [
                            DIFF_INSERT,
                            longtext.substring(i + shorttext.length)
                        ]
                    ];
                    // Swap insertions for deletions if diff is reversed.
                    if (text1.length > text2.length) diffs[0][0] = diffs[2][0] = DIFF_DELETE;
                    return diffs;
                }
                if (shorttext.length == 1) // Single character string.
                // After the previous speedup, the character can't be an equality.
                return [
                    [
                        DIFF_DELETE,
                        text1
                    ],
                    [
                        DIFF_INSERT,
                        text2
                    ]
                ];
                // Check to see if the problem can be split in two.
                var hm = diff_halfMatch_(text1, text2);
                if (hm) {
                    // A half-match was found, sort out the return data.
                    var text1_a = hm[0];
                    var text1_b = hm[1];
                    var text2_a = hm[2];
                    var text2_b = hm[3];
                    var mid_common = hm[4];
                    // Send both pairs off for separate processing.
                    var diffs_a = diff_main(text1_a, text2_a);
                    var diffs_b = diff_main(text1_b, text2_b);
                    // Merge the results.
                    return diffs_a.concat([
                        [
                            DIFF_EQUAL,
                            mid_common
                        ]
                    ], diffs_b);
                }
                return diff_bisect_(text1, text2);
            }
            /**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */ function diff_bisect_(text1, text2) {
                // Cache the text lengths to prevent multiple calls.
                var text1_length = text1.length;
                var text2_length = text2.length;
                var max_d = Math.ceil((text1_length + text2_length) / 2);
                var v_offset = max_d;
                var v_length = 2 * max_d;
                var v1 = new Array(v_length);
                var v2 = new Array(v_length);
                // Setting all elements to -1 is faster in Chrome & Firefox than mixing
                // integers and undefined.
                for(var x = 0; x < v_length; x++){
                    v1[x] = -1;
                    v2[x] = -1;
                }
                v1[v_offset + 1] = 0;
                v2[v_offset + 1] = 0;
                var delta = text1_length - text2_length;
                // If the total number of characters is odd, then the front path will collide
                // with the reverse path.
                var front = delta % 2 != 0;
                // Offsets for start and end of k loop.
                // Prevents mapping of space beyond the grid.
                var k1start = 0;
                var k1end = 0;
                var k2start = 0;
                var k2end = 0;
                for(var d = 0; d < max_d; d++){
                    // Walk the front path one step.
                    for(var k1 = -d + k1start; k1 <= d - k1end; k1 += 2){
                        var k1_offset = v_offset + k1;
                        var x1;
                        if (k1 == -d || k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1]) x1 = v1[k1_offset + 1];
                        else x1 = v1[k1_offset - 1] + 1;
                        var y1 = x1 - k1;
                        while(x1 < text1_length && y1 < text2_length && text1.charAt(x1) == text2.charAt(y1)){
                            x1++;
                            y1++;
                        }
                        v1[k1_offset] = x1;
                        if (x1 > text1_length) // Ran off the right of the graph.
                        k1end += 2;
                        else if (y1 > text2_length) // Ran off the bottom of the graph.
                        k1start += 2;
                        else if (front) {
                            var k2_offset = v_offset + delta - k1;
                            if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
                                // Mirror x2 onto top-left coordinate system.
                                var x2 = text1_length - v2[k2_offset];
                                if (x1 >= x2) // Overlap detected.
                                return diff_bisectSplit_(text1, text2, x1, y1);
                            }
                        }
                    }
                    // Walk the reverse path one step.
                    for(var k2 = -d + k2start; k2 <= d - k2end; k2 += 2){
                        var k2_offset = v_offset + k2;
                        var x2;
                        if (k2 == -d || k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1]) x2 = v2[k2_offset + 1];
                        else x2 = v2[k2_offset - 1] + 1;
                        var y2 = x2 - k2;
                        while(x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) == text2.charAt(text2_length - y2 - 1)){
                            x2++;
                            y2++;
                        }
                        v2[k2_offset] = x2;
                        if (x2 > text1_length) // Ran off the left of the graph.
                        k2end += 2;
                        else if (y2 > text2_length) // Ran off the top of the graph.
                        k2start += 2;
                        else if (!front) {
                            var k1_offset = v_offset + delta - k2;
                            if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
                                var x1 = v1[k1_offset];
                                var y1 = v_offset + x1 - k1_offset;
                                // Mirror x2 onto top-left coordinate system.
                                x2 = text1_length - x2;
                                if (x1 >= x2) // Overlap detected.
                                return diff_bisectSplit_(text1, text2, x1, y1);
                            }
                        }
                    }
                }
                // Diff took too long and hit the deadline or
                // number of diffs equals number of characters, no commonality at all.
                return [
                    [
                        DIFF_DELETE,
                        text1
                    ],
                    [
                        DIFF_INSERT,
                        text2
                    ]
                ];
            }
            /**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */ function diff_bisectSplit_(text1, text2, x, y) {
                var text1a = text1.substring(0, x);
                var text2a = text2.substring(0, y);
                var text1b = text1.substring(x);
                var text2b = text2.substring(y);
                // Compute both diffs serially.
                var diffs = diff_main(text1a, text2a);
                var diffsb = diff_main(text1b, text2b);
                return diffs.concat(diffsb);
            }
            /**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */ function diff_commonPrefix(text1, text2) {
                // Quick check for common null cases.
                if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) return 0;
                // Binary search.
                // Performance analysis: http://neil.fraser.name/news/2007/10/09/
                var pointermin = 0;
                var pointermax = Math.min(text1.length, text2.length);
                var pointermid = pointermax;
                var pointerstart = 0;
                while(pointermin < pointermid){
                    if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
                        pointermin = pointermid;
                        pointerstart = pointermin;
                    } else pointermax = pointermid;
                    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
                }
                return pointermid;
            }
            /**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */ function diff_commonSuffix(text1, text2) {
                // Quick check for common null cases.
                if (!text1 || !text2 || text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) return 0;
                // Binary search.
                // Performance analysis: http://neil.fraser.name/news/2007/10/09/
                var pointermin = 0;
                var pointermax = Math.min(text1.length, text2.length);
                var pointermid = pointermax;
                var pointerend = 0;
                while(pointermin < pointermid){
                    if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
                        pointermin = pointermid;
                        pointerend = pointermin;
                    } else pointermax = pointermid;
                    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
                }
                return pointermid;
            }
            /**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */ function diff_halfMatch_(text1, text2) {
                var longtext = text1.length > text2.length ? text1 : text2;
                var shorttext = text1.length > text2.length ? text2 : text1;
                if (longtext.length < 4 || shorttext.length * 2 < longtext.length) return null; // Pointless.
                /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */ function diff_halfMatchI_(longtext, shorttext, i) {
                    // Start with a 1/4 length substring at position i as a seed.
                    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
                    var j = -1;
                    var best_common = "";
                    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
                    while((j = shorttext.indexOf(seed, j + 1)) != -1){
                        var prefixLength = diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
                        var suffixLength = diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
                        if (best_common.length < suffixLength + prefixLength) {
                            best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
                            best_longtext_a = longtext.substring(0, i - suffixLength);
                            best_longtext_b = longtext.substring(i + prefixLength);
                            best_shorttext_a = shorttext.substring(0, j - suffixLength);
                            best_shorttext_b = shorttext.substring(j + prefixLength);
                        }
                    }
                    if (best_common.length * 2 >= longtext.length) return [
                        best_longtext_a,
                        best_longtext_b,
                        best_shorttext_a,
                        best_shorttext_b,
                        best_common
                    ];
                    else return null;
                }
                // First check if the second quarter is the seed for a half-match.
                var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
                // Check again based on the third quarter.
                var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
                var hm;
                if (!hm1 && !hm2) return null;
                else if (!hm2) hm = hm1;
                else if (!hm1) hm = hm2;
                else // Both matched.  Select the longest.
                hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
                // A half-match was found, sort out the return data.
                var text1_a, text1_b, text2_a, text2_b;
                if (text1.length > text2.length) {
                    text1_a = hm[0];
                    text1_b = hm[1];
                    text2_a = hm[2];
                    text2_b = hm[3];
                } else {
                    text2_a = hm[0];
                    text2_b = hm[1];
                    text1_a = hm[2];
                    text1_b = hm[3];
                }
                var mid_common = hm[4];
                return [
                    text1_a,
                    text1_b,
                    text2_a,
                    text2_b,
                    mid_common
                ];
            }
            /**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 */ function diff_cleanupMerge(diffs) {
                diffs.push([
                    DIFF_EQUAL,
                    ""
                ]); // Add a dummy entry at the end.
                var pointer = 0;
                var count_delete = 0;
                var count_insert = 0;
                var text_delete = "";
                var text_insert = "";
                var commonlength;
                while(pointer < diffs.length)switch(diffs[pointer][0]){
                    case DIFF_INSERT:
                        count_insert++;
                        text_insert += diffs[pointer][1];
                        pointer++;
                        break;
                    case DIFF_DELETE:
                        count_delete++;
                        text_delete += diffs[pointer][1];
                        pointer++;
                        break;
                    case DIFF_EQUAL:
                        // Upon reaching an equality, check for prior redundancies.
                        if (count_delete + count_insert > 1) {
                            if (count_delete !== 0 && count_insert !== 0) {
                                // Factor out any common prefixies.
                                commonlength = diff_commonPrefix(text_insert, text_delete);
                                if (commonlength !== 0) {
                                    if (pointer - count_delete - count_insert > 0 && diffs[pointer - count_delete - count_insert - 1][0] == DIFF_EQUAL) diffs[pointer - count_delete - count_insert - 1][1] += text_insert.substring(0, commonlength);
                                    else {
                                        diffs.splice(0, 0, [
                                            DIFF_EQUAL,
                                            text_insert.substring(0, commonlength)
                                        ]);
                                        pointer++;
                                    }
                                    text_insert = text_insert.substring(commonlength);
                                    text_delete = text_delete.substring(commonlength);
                                }
                                // Factor out any common suffixies.
                                commonlength = diff_commonSuffix(text_insert, text_delete);
                                if (commonlength !== 0) {
                                    diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                                    text_insert = text_insert.substring(0, text_insert.length - commonlength);
                                    text_delete = text_delete.substring(0, text_delete.length - commonlength);
                                }
                            }
                            // Delete the offending records and add the merged ones.
                            if (count_delete === 0) diffs.splice(pointer - count_insert, count_delete + count_insert, [
                                DIFF_INSERT,
                                text_insert
                            ]);
                            else if (count_insert === 0) diffs.splice(pointer - count_delete, count_delete + count_insert, [
                                DIFF_DELETE,
                                text_delete
                            ]);
                            else diffs.splice(pointer - count_delete - count_insert, count_delete + count_insert, [
                                DIFF_DELETE,
                                text_delete
                            ], [
                                DIFF_INSERT,
                                text_insert
                            ]);
                            pointer = pointer - count_delete - count_insert + (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
                        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
                            // Merge this equality with the previous one.
                            diffs[pointer - 1][1] += diffs[pointer][1];
                            diffs.splice(pointer, 1);
                        } else pointer++;
                        count_insert = 0;
                        count_delete = 0;
                        text_delete = "";
                        text_insert = "";
                        break;
                }
                if (diffs[diffs.length - 1][1] === "") diffs.pop(); // Remove the dummy entry at the end.
                // Second pass: look for single edits surrounded on both sides by equalities
                // which can be shifted sideways to eliminate an equality.
                // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
                var changes = false;
                pointer = 1;
                // Intentionally ignore the first and last element (don't need checking).
                while(pointer < diffs.length - 1){
                    if (diffs[pointer - 1][0] == DIFF_EQUAL && diffs[pointer + 1][0] == DIFF_EQUAL) {
                        // This is a single edit surrounded by equalities.
                        if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
                            // Shift the edit over the previous equality.
                            diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                            diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                            diffs.splice(pointer - 1, 1);
                            changes = true;
                        } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                            // Shift the edit over the next equality.
                            diffs[pointer - 1][1] += diffs[pointer + 1][1];
                            diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                            diffs.splice(pointer + 1, 1);
                            changes = true;
                        }
                    }
                    pointer++;
                }
                // If shifts were made, the diff needs reordering and another shift sweep.
                if (changes) diff_cleanupMerge(diffs);
            }
            var diff = diff_main;
            diff.INSERT = DIFF_INSERT;
            diff.DELETE = DIFF_DELETE;
            diff.EQUAL = DIFF_EQUAL;
            module1.exports = diff;
            /*
 * Modify a diff such that the cursor position points to the start of a change:
 * E.g.
 *   cursor_normalize_diff([[DIFF_EQUAL, 'abc']], 1)
 *     => [1, [[DIFF_EQUAL, 'a'], [DIFF_EQUAL, 'bc']]]
 *   cursor_normalize_diff([[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xyz']], 2)
 *     => [2, [[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xy'], [DIFF_DELETE, 'z']]]
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} A tuple [cursor location in the modified diff, modified diff]
 */ function cursor_normalize_diff(diffs, cursor_pos) {
                if (cursor_pos === 0) return [
                    DIFF_EQUAL,
                    diffs
                ];
                for(var current_pos = 0, i = 0; i < diffs.length; i++){
                    var d = diffs[i];
                    if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
                        var next_pos = current_pos + d[1].length;
                        if (cursor_pos === next_pos) return [
                            i + 1,
                            diffs
                        ];
                        else if (cursor_pos < next_pos) {
                            // copy to prevent side effects
                            diffs = diffs.slice();
                            // split d into two diff changes
                            var split_pos = cursor_pos - current_pos;
                            var d_left = [
                                d[0],
                                d[1].slice(0, split_pos)
                            ];
                            var d_right = [
                                d[0],
                                d[1].slice(split_pos)
                            ];
                            diffs.splice(i, 1, d_left, d_right);
                            return [
                                i + 1,
                                diffs
                            ];
                        } else current_pos = next_pos;
                    }
                }
                throw new Error("cursor_pos is out of bounds!");
            }
            /*
 * Modify a diff such that the edit position is "shifted" to the proposed edit location (cursor_position).
 *
 * Case 1)
 *   Check if a naive shift is possible:
 *     [0, X], [ 1, Y] -> [ 1, Y], [0, X]    (if X + Y === Y + X)
 *     [0, X], [-1, Y] -> [-1, Y], [0, X]    (if X + Y === Y + X) - holds same result
 * Case 2)
 *   Check if the following shifts are possible:
 *     [0, 'pre'], [ 1, 'prefix'] -> [ 1, 'pre'], [0, 'pre'], [ 1, 'fix']
 *     [0, 'pre'], [-1, 'prefix'] -> [-1, 'pre'], [0, 'pre'], [-1, 'fix']
 *         ^            ^
 *         d          d_next
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} Array of diff tuples
 */ function fix_cursor(diffs, cursor_pos) {
                var norm = cursor_normalize_diff(diffs, cursor_pos);
                var ndiffs = norm[1];
                var cursor_pointer = norm[0];
                var d = ndiffs[cursor_pointer];
                var d_next = ndiffs[cursor_pointer + 1];
                if (d == null) // Text was deleted from end of original string,
                // cursor is now out of bounds in new string
                return diffs;
                else if (d[0] !== DIFF_EQUAL) // A modification happened at the cursor location.
                // This is the expected outcome, so we can return the original diff.
                return diffs;
                else {
                    if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
                        // Case 1)
                        // It is possible to perform a naive shift
                        ndiffs.splice(cursor_pointer, 2, d_next, d);
                        return merge_tuples(ndiffs, cursor_pointer, 2);
                    } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
                        // Case 2)
                        // d[1] is a prefix of d_next[1]
                        // We can assume that d_next[0] !== 0, since d[0] === 0
                        // Shift edit locations..
                        ndiffs.splice(cursor_pointer, 2, [
                            d_next[0],
                            d[1]
                        ], [
                            0,
                            d[1]
                        ]);
                        var suffix = d_next[1].slice(d[1].length);
                        if (suffix.length > 0) ndiffs.splice(cursor_pointer + 2, 0, [
                            d_next[0],
                            suffix
                        ]);
                        return merge_tuples(ndiffs, cursor_pointer, 3);
                    } else // Not possible to perform any modification
                    return diffs;
                }
            }
            /*
 * Check diff did not split surrogate pairs.
 * Ex. [0, '\uD83D'], [-1, '\uDC36'], [1, '\uDC2F'] -> [-1, '\uD83D\uDC36'], [1, '\uD83D\uDC2F']
 *     '\uD83D\uDC36' === '🐶', '\uD83D\uDC2F' === '🐯'
 *
 * @param {Array} diffs Array of diff tuples
 * @return {Array} Array of diff tuples
 */ function fix_emoji(diffs) {
                var compact = false;
                var starts_with_pair_end = function(str) {
                    return str.charCodeAt(0) >= 0xDC00 && str.charCodeAt(0) <= 0xDFFF;
                };
                var ends_with_pair_start = function(str) {
                    return str.charCodeAt(str.length - 1) >= 0xD800 && str.charCodeAt(str.length - 1) <= 0xDBFF;
                };
                for(var i = 2; i < diffs.length; i += 1)if (diffs[i - 2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i - 2][1]) && diffs[i - 1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i - 1][1]) && diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
                    compact = true;
                    diffs[i - 1][1] = diffs[i - 2][1].slice(-1) + diffs[i - 1][1];
                    diffs[i][1] = diffs[i - 2][1].slice(-1) + diffs[i][1];
                    diffs[i - 2][1] = diffs[i - 2][1].slice(0, -1);
                }
                if (!compact) return diffs;
                var fixed_diffs = [];
                for(var i = 0; i < diffs.length; i += 1)if (diffs[i][1].length > 0) fixed_diffs.push(diffs[i]);
                return fixed_diffs;
            }
            /*
 * Try to merge tuples with their neigbors in a given range.
 * E.g. [0, 'a'], [0, 'b'] -> [0, 'ab']
 *
 * @param {Array} diffs Array of diff tuples.
 * @param {Int} start Position of the first element to merge (diffs[start] is also merged with diffs[start - 1]).
 * @param {Int} length Number of consecutive elements to check.
 * @return {Array} Array of merged diff tuples.
 */ function merge_tuples(diffs, start, length) {
                // Check from (start-1) to (start+length).
                for(var i = start + length - 1; i >= 0 && i >= start - 1; i--)if (i + 1 < diffs.length) {
                    var left_d = diffs[i];
                    var right_d = diffs[i + 1];
                    if (left_d[0] === right_d[1]) diffs.splice(i, 2, [
                        left_d[0],
                        left_d[1] + right_d[1]
                    ]);
                }
                return diffs;
            }
        /***/ },
        /* 52 */ /***/ function(module1, exports) {
            exports = module1.exports = typeof Object.keys === "function" ? Object.keys : shim;
            exports.shim = shim;
            function shim(obj) {
                var keys = [];
                for(var key in obj)keys.push(key);
                return keys;
            }
        /***/ },
        /* 53 */ /***/ function(module1, exports) {
            var supportsArgumentsClass = function() {
                return Object.prototype.toString.call(arguments);
            }() == "[object Arguments]";
            exports = module1.exports = supportsArgumentsClass ? supported : unsupported;
            exports.supported = supported;
            function supported(object) {
                return Object.prototype.toString.call(object) == "[object Arguments]";
            }
            exports.unsupported = unsupported;
            function unsupported(object) {
                return object && typeof object == "object" && typeof object.length == "number" && Object.prototype.hasOwnProperty.call(object, "callee") && !Object.prototype.propertyIsEnumerable.call(object, "callee") || false;
            }
        /***/ },
        /* 54 */ /***/ function(module1, exports) {
            "use strict";
            var has = Object.prototype.hasOwnProperty, prefix = "~";
            /**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */ function Events() {}
            //
            // We try to not inherit from `Object.prototype`. In some engines creating an
            // instance in this way is faster than calling `Object.create(null)` directly.
            // If `Object.create(null)` is not supported we prefix the event names with a
            // character to make sure that the built-in object properties are not
            // overridden or used as an attack vector.
            //
            if (Object.create) {
                Events.prototype = Object.create(null);
                //
                // This hack is needed because the `__proto__` property is still inherited in
                // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
                //
                if (!new Events().__proto__) prefix = false;
            }
            /**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */ function EE(fn, context, once) {
                this.fn = fn;
                this.context = context;
                this.once = once || false;
            }
            /**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */ function EventEmitter() {
                this._events = new Events();
                this._eventsCount = 0;
            }
            /**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */ EventEmitter.prototype.eventNames = function eventNames() {
                var names = [], events, name;
                if (this._eventsCount === 0) return names;
                for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
                if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
                return names;
            };
            /**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */ EventEmitter.prototype.listeners = function listeners(event, exists) {
                var evt = prefix ? prefix + event : event, available = this._events[evt];
                if (exists) return !!available;
                if (!available) return [];
                if (available.fn) return [
                    available.fn
                ];
                for(var i = 0, l = available.length, ee = new Array(l); i < l; i++)ee[i] = available[i].fn;
                return ee;
            };
            /**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
                var evt = prefix ? prefix + event : event;
                if (!this._events[evt]) return false;
                var listeners = this._events[evt], len = arguments.length, args, i;
                if (listeners.fn) {
                    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
                    switch(len){
                        case 1:
                            return listeners.fn.call(listeners.context), true;
                        case 2:
                            return listeners.fn.call(listeners.context, a1), true;
                        case 3:
                            return listeners.fn.call(listeners.context, a1, a2), true;
                        case 4:
                            return listeners.fn.call(listeners.context, a1, a2, a3), true;
                        case 5:
                            return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
                        case 6:
                            return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
                    }
                    for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
                    listeners.fn.apply(listeners.context, args);
                } else {
                    var length = listeners.length, j;
                    for(i = 0; i < length; i++){
                        if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
                        switch(len){
                            case 1:
                                listeners[i].fn.call(listeners[i].context);
                                break;
                            case 2:
                                listeners[i].fn.call(listeners[i].context, a1);
                                break;
                            case 3:
                                listeners[i].fn.call(listeners[i].context, a1, a2);
                                break;
                            case 4:
                                listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                                break;
                            default:
                                if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                                listeners[i].fn.apply(listeners[i].context, args);
                        }
                    }
                }
                return true;
            };
            /**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
                var listener = new EE(fn, context || this), evt = prefix ? prefix + event : event;
                if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
                else if (!this._events[evt].fn) this._events[evt].push(listener);
                else this._events[evt] = [
                    this._events[evt],
                    listener
                ];
                return this;
            };
            /**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
                var listener = new EE(fn, context || this, true), evt = prefix ? prefix + event : event;
                if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
                else if (!this._events[evt].fn) this._events[evt].push(listener);
                else this._events[evt] = [
                    this._events[evt],
                    listener
                ];
                return this;
            };
            /**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
                var evt = prefix ? prefix + event : event;
                if (!this._events[evt]) return this;
                if (!fn) {
                    if (--this._eventsCount === 0) this._events = new Events();
                    else delete this._events[evt];
                    return this;
                }
                var listeners = this._events[evt];
                if (listeners.fn) {
                    if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
                        if (--this._eventsCount === 0) this._events = new Events();
                        else delete this._events[evt];
                    }
                } else {
                    for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
                    //
                    // Reset the array, or remove it completely if we have no more listeners.
                    //
                    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
                    else if (--this._eventsCount === 0) this._events = new Events();
                    else delete this._events[evt];
                }
                return this;
            };
            /**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
                var evt;
                if (event) {
                    evt = prefix ? prefix + event : event;
                    if (this._events[evt]) {
                        if (--this._eventsCount === 0) this._events = new Events();
                        else delete this._events[evt];
                    }
                } else {
                    this._events = new Events();
                    this._eventsCount = 0;
                }
                return this;
            };
            //
            // Alias methods names because people roll like that.
            //
            EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
            EventEmitter.prototype.addListener = EventEmitter.prototype.on;
            //
            // This function doesn't apply anymore.
            //
            EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
                return this;
            };
            //
            // Expose the prefix.
            //
            EventEmitter.prefixed = prefix;
            //
            // Allow `EventEmitter` to be imported as module namespace.
            //
            EventEmitter.EventEmitter = EventEmitter;
            //
            // Expose the module.
            //
            if ("undefined" !== typeof module1) module1.exports = EventEmitter;
        /***/ },
        /* 55 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _extend2 = __webpack_require__(3);
            var _extend3 = _interopRequireDefault(_extend2);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            var _align = __webpack_require__(36);
            var _background = __webpack_require__(37);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _color = __webpack_require__(26);
            var _direction = __webpack_require__(38);
            var _font = __webpack_require__(39);
            var _size = __webpack_require__(40);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var debug = (0, _logger2.default)("quill:clipboard");
            var DOM_KEY = "__ql-matcher";
            var CLIPBOARD_CONFIG = [
                [
                    Node.TEXT_NODE,
                    matchText
                ],
                [
                    Node.TEXT_NODE,
                    matchNewline
                ],
                [
                    "br",
                    matchBreak
                ],
                [
                    Node.ELEMENT_NODE,
                    matchNewline
                ],
                [
                    Node.ELEMENT_NODE,
                    matchBlot
                ],
                [
                    Node.ELEMENT_NODE,
                    matchSpacing
                ],
                [
                    Node.ELEMENT_NODE,
                    matchAttributor
                ],
                [
                    Node.ELEMENT_NODE,
                    matchStyles
                ],
                [
                    "li",
                    matchIndent
                ],
                [
                    "b",
                    matchAlias.bind(matchAlias, "bold")
                ],
                [
                    "i",
                    matchAlias.bind(matchAlias, "italic")
                ],
                [
                    "style",
                    matchIgnore
                ]
            ];
            var ATTRIBUTE_ATTRIBUTORS = [
                _align.AlignAttribute,
                _direction.DirectionAttribute
            ].reduce(function(memo, attr) {
                memo[attr.keyName] = attr;
                return memo;
            }, {});
            var STYLE_ATTRIBUTORS = [
                _align.AlignStyle,
                _background.BackgroundStyle,
                _color.ColorStyle,
                _direction.DirectionStyle,
                _font.FontStyle,
                _size.SizeStyle
            ].reduce(function(memo, attr) {
                memo[attr.keyName] = attr;
                return memo;
            }, {});
            var Clipboard = function(_Module) {
                _inherits(Clipboard, _Module);
                function Clipboard(quill, options) {
                    _classCallCheck(this, Clipboard);
                    var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));
                    _this.quill.root.addEventListener("paste", _this.onPaste.bind(_this));
                    _this.container = _this.quill.addContainer("ql-clipboard");
                    _this.container.setAttribute("contenteditable", true);
                    _this.container.setAttribute("tabindex", -1);
                    _this.matchers = [];
                    CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function(_ref) {
                        var _ref2 = _slicedToArray(_ref, 2), selector = _ref2[0], matcher = _ref2[1];
                        if (!options.matchVisual && matcher === matchSpacing) return;
                        _this.addMatcher(selector, matcher);
                    });
                    return _this;
                }
                _createClass(Clipboard, [
                    {
                        key: "addMatcher",
                        value: function addMatcher(selector, matcher) {
                            this.matchers.push([
                                selector,
                                matcher
                            ]);
                        }
                    },
                    {
                        key: "convert",
                        value: function convert(html) {
                            if (typeof html === "string") {
                                this.container.innerHTML = html.replace(/\>\r?\n +\</g, "><"); // Remove spaces between tags
                                return this.convert();
                            }
                            var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
                            if (formats[_code2.default.blotName]) {
                                var text = this.container.innerText;
                                this.container.innerHTML = "";
                                return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
                            }
                            var _prepareMatching = this.prepareMatching(), _prepareMatching2 = _slicedToArray(_prepareMatching, 2), elementMatchers = _prepareMatching2[0], textMatchers = _prepareMatching2[1];
                            var delta = traverse(this.container, elementMatchers, textMatchers);
                            // Remove trailing newline
                            if (deltaEndsWith(delta, "\n") && delta.ops[delta.ops.length - 1].attributes == null) delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
                            debug.log("convert", this.container.innerHTML, delta);
                            this.container.innerHTML = "";
                            return delta;
                        }
                    },
                    {
                        key: "dangerouslyPasteHTML",
                        value: function dangerouslyPasteHTML(index, html) {
                            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;
                            if (typeof index === "string") {
                                this.quill.setContents(this.convert(index), html);
                                this.quill.setSelection(0, _quill2.default.sources.SILENT);
                            } else {
                                var paste = this.convert(html);
                                this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
                                this.quill.setSelection(index + paste.length(), _quill2.default.sources.SILENT);
                            }
                        }
                    },
                    {
                        key: "onPaste",
                        value: function onPaste(e) {
                            var _this2 = this;
                            if (e.defaultPrevented || !this.quill.isEnabled()) return;
                            var range = this.quill.getSelection();
                            var delta = new _quillDelta2.default().retain(range.index);
                            var scrollTop = this.quill.scrollingContainer.scrollTop;
                            this.container.focus();
                            this.quill.selection.update(_quill2.default.sources.SILENT);
                            setTimeout(function() {
                                delta = delta.concat(_this2.convert()).delete(range.length);
                                _this2.quill.updateContents(delta, _quill2.default.sources.USER);
                                // range.length contributes to delta.length()
                                _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
                                _this2.quill.scrollingContainer.scrollTop = scrollTop;
                                _this2.quill.focus();
                            }, 1);
                        }
                    },
                    {
                        key: "prepareMatching",
                        value: function prepareMatching() {
                            var _this3 = this;
                            var elementMatchers = [], textMatchers = [];
                            this.matchers.forEach(function(pair) {
                                var _pair = _slicedToArray(pair, 2), selector = _pair[0], matcher = _pair[1];
                                switch(selector){
                                    case Node.TEXT_NODE:
                                        textMatchers.push(matcher);
                                        break;
                                    case Node.ELEMENT_NODE:
                                        elementMatchers.push(matcher);
                                        break;
                                    default:
                                        [].forEach.call(_this3.container.querySelectorAll(selector), function(node) {
                                            // TODO use weakmap
                                            node[DOM_KEY] = node[DOM_KEY] || [];
                                            node[DOM_KEY].push(matcher);
                                        });
                                        break;
                                }
                            });
                            return [
                                elementMatchers,
                                textMatchers
                            ];
                        }
                    }
                ]);
                return Clipboard;
            }(_module2.default);
            Clipboard.DEFAULTS = {
                matchers: [],
                matchVisual: true
            };
            function applyFormat(delta, format, value) {
                if ((typeof format === "undefined" ? "undefined" : _typeof(format)) === "object") return Object.keys(format).reduce(function(delta, key) {
                    return applyFormat(delta, key, format[key]);
                }, delta);
                else return delta.reduce(function(delta, op) {
                    if (op.attributes && op.attributes[format]) return delta.push(op);
                    else return delta.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
                }, new _quillDelta2.default());
            }
            function computeStyle(node) {
                if (node.nodeType !== Node.ELEMENT_NODE) return {};
                var DOM_KEY = "__ql-computed-style";
                return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
            }
            function deltaEndsWith(delta, text) {
                var endText = "";
                for(var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i){
                    var op = delta.ops[i];
                    if (typeof op.insert !== "string") break;
                    endText = op.insert + endText;
                }
                return endText.slice(-1 * text.length) === text;
            }
            function isLine(node) {
                if (node.childNodes.length === 0) return false; // Exclude embed blocks
                var style = computeStyle(node);
                return [
                    "block",
                    "list-item"
                ].indexOf(style.display) > -1;
            }
            function traverse(node, elementMatchers, textMatchers) {
                // Post-order
                if (node.nodeType === node.TEXT_NODE) return textMatchers.reduce(function(delta, matcher) {
                    return matcher(node, delta);
                }, new _quillDelta2.default());
                else if (node.nodeType === node.ELEMENT_NODE) return [].reduce.call(node.childNodes || [], function(delta, childNode) {
                    var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
                    if (childNode.nodeType === node.ELEMENT_NODE) {
                        childrenDelta = elementMatchers.reduce(function(childrenDelta, matcher) {
                            return matcher(childNode, childrenDelta);
                        }, childrenDelta);
                        childrenDelta = (childNode[DOM_KEY] || []).reduce(function(childrenDelta, matcher) {
                            return matcher(childNode, childrenDelta);
                        }, childrenDelta);
                    }
                    return delta.concat(childrenDelta);
                }, new _quillDelta2.default());
                else return new _quillDelta2.default();
            }
            function matchAlias(format, node, delta) {
                return applyFormat(delta, format, true);
            }
            function matchAttributor(node, delta) {
                var attributes = _parchment2.default.Attributor.Attribute.keys(node);
                var classes = _parchment2.default.Attributor.Class.keys(node);
                var styles = _parchment2.default.Attributor.Style.keys(node);
                var formats = {};
                attributes.concat(classes).concat(styles).forEach(function(name) {
                    var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
                    if (attr != null) {
                        formats[attr.attrName] = attr.value(node);
                        if (formats[attr.attrName]) return;
                    }
                    attr = ATTRIBUTE_ATTRIBUTORS[name];
                    if (attr != null && (attr.attrName === name || attr.keyName === name)) formats[attr.attrName] = attr.value(node) || undefined;
                    attr = STYLE_ATTRIBUTORS[name];
                    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
                        attr = STYLE_ATTRIBUTORS[name];
                        formats[attr.attrName] = attr.value(node) || undefined;
                    }
                });
                if (Object.keys(formats).length > 0) delta = applyFormat(delta, formats);
                return delta;
            }
            function matchBlot(node, delta) {
                var match = _parchment2.default.query(node);
                if (match == null) return delta;
                if (match.prototype instanceof _parchment2.default.Embed) {
                    var embed = {};
                    var value = match.value(node);
                    if (value != null) {
                        embed[match.blotName] = value;
                        delta = new _quillDelta2.default().insert(embed, match.formats(node));
                    }
                } else if (typeof match.formats === "function") delta = applyFormat(delta, match.blotName, match.formats(node));
                return delta;
            }
            function matchBreak(node, delta) {
                if (!deltaEndsWith(delta, "\n")) delta.insert("\n");
                return delta;
            }
            function matchIgnore() {
                return new _quillDelta2.default();
            }
            function matchIndent(node, delta) {
                var match = _parchment2.default.query(node);
                if (match == null || match.blotName !== "list-item" || !deltaEndsWith(delta, "\n")) return delta;
                var indent = -1, parent = node.parentNode;
                while(!parent.classList.contains("ql-clipboard")){
                    if ((_parchment2.default.query(parent) || {}).blotName === "list") indent += 1;
                    parent = parent.parentNode;
                }
                if (indent <= 0) return delta;
                return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, {
                    indent: indent
                }));
            }
            function matchNewline(node, delta) {
                if (!deltaEndsWith(delta, "\n")) {
                    if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) delta.insert("\n");
                }
                return delta;
            }
            function matchSpacing(node, delta) {
                if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, "\n\n")) {
                    var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
                    if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) delta.insert("\n");
                }
                return delta;
            }
            function matchStyles(node, delta) {
                var formats = {};
                var style = node.style || {};
                if (style.fontStyle && computeStyle(node).fontStyle === "italic") formats.italic = true;
                if (style.fontWeight && (computeStyle(node).fontWeight.startsWith("bold") || parseInt(computeStyle(node).fontWeight) >= 700)) formats.bold = true;
                if (Object.keys(formats).length > 0) delta = applyFormat(delta, formats);
                if (parseFloat(style.textIndent || 0) > 0) // Could be 0.5in
                delta = new _quillDelta2.default().insert("	").concat(delta);
                return delta;
            }
            function matchText(node, delta) {
                var text = node.data;
                // Word represents empty line with <o:p>&nbsp;</o:p>
                if (node.parentNode.tagName === "O:P") return delta.insert(text.trim());
                if (text.trim().length === 0 && node.parentNode.classList.contains("ql-clipboard")) return delta;
                if (!computeStyle(node.parentNode).whiteSpace.startsWith("pre")) {
                    // eslint-disable-next-line func-style
                    var replacer = function replacer(collapse, match) {
                        match = match.replace(/[^\u00a0]/g, ""); // \u00a0 is nbsp;
                        return match.length < 1 && collapse ? " " : match;
                    };
                    text = text.replace(/\r\n/g, " ").replace(/\n/g, " ");
                    text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
                    if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) text = text.replace(/^\s+/, replacer.bind(replacer, false));
                    if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) text = text.replace(/\s+$/, replacer.bind(replacer, false));
                }
                return delta.insert(text);
            }
            exports.default = Clipboard;
            exports.matchAttributor = matchAttributor;
            exports.matchBlot = matchBlot;
            exports.matchNewline = matchNewline;
            exports.matchSpacing = matchSpacing;
            exports.matchText = matchText;
        /***/ },
        /* 56 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Bold = function(_Inline) {
                _inherits(Bold, _Inline);
                function Bold() {
                    _classCallCheck(this, Bold);
                    return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
                }
                _createClass(Bold, [
                    {
                        key: "optimize",
                        value: function optimize(context) {
                            _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), "optimize", this).call(this, context);
                            if (this.domNode.tagName !== this.statics.tagName[0]) this.replaceWith(this.statics.blotName);
                        }
                    }
                ], [
                    {
                        key: "create",
                        value: function create() {
                            return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), "create", this).call(this);
                        }
                    },
                    {
                        key: "formats",
                        value: function formats() {
                            return true;
                        }
                    }
                ]);
                return Bold;
            }(_inline2.default);
            Bold.blotName = "bold";
            Bold.tagName = [
                "STRONG",
                "B"
            ];
            exports.default = Bold;
        /***/ },
        /* 57 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.addControls = exports.default = undefined;
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var debug = (0, _logger2.default)("quill:toolbar");
            var Toolbar = function(_Module) {
                _inherits(Toolbar, _Module);
                function Toolbar(quill, options) {
                    _classCallCheck(this, Toolbar);
                    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));
                    if (Array.isArray(_this.options.container)) {
                        var container = document.createElement("div");
                        addControls(container, _this.options.container);
                        quill.container.parentNode.insertBefore(container, quill.container);
                        _this.container = container;
                    } else if (typeof _this.options.container === "string") _this.container = document.querySelector(_this.options.container);
                    else _this.container = _this.options.container;
                    if (!(_this.container instanceof HTMLElement)) {
                        var _ret;
                        return _ret = debug.error("Container required for toolbar", _this.options), _possibleConstructorReturn(_this, _ret);
                    }
                    _this.container.classList.add("ql-toolbar");
                    _this.controls = [];
                    _this.handlers = {};
                    Object.keys(_this.options.handlers).forEach(function(format) {
                        _this.addHandler(format, _this.options.handlers[format]);
                    });
                    [].forEach.call(_this.container.querySelectorAll("button, select"), function(input) {
                        _this.attach(input);
                    });
                    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function(type, range) {
                        if (type === _quill2.default.events.SELECTION_CHANGE) _this.update(range);
                    });
                    _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function() {
                        var _this$quill$selection = _this.quill.selection.getRange(), _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1), range = _this$quill$selection2[0]; // quill.getSelection triggers update
                        _this.update(range);
                    });
                    return _this;
                }
                _createClass(Toolbar, [
                    {
                        key: "addHandler",
                        value: function addHandler(format, handler) {
                            this.handlers[format] = handler;
                        }
                    },
                    {
                        key: "attach",
                        value: function attach(input) {
                            var _this2 = this;
                            var format = [].find.call(input.classList, function(className) {
                                return className.indexOf("ql-") === 0;
                            });
                            if (!format) return;
                            format = format.slice(3);
                            if (input.tagName === "BUTTON") input.setAttribute("type", "button");
                            if (this.handlers[format] == null) {
                                if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
                                    debug.warn("ignoring attaching to disabled format", format, input);
                                    return;
                                }
                                if (_parchment2.default.query(format) == null) {
                                    debug.warn("ignoring attaching to nonexistent format", format, input);
                                    return;
                                }
                            }
                            var eventName = input.tagName === "SELECT" ? "change" : "click";
                            input.addEventListener(eventName, function(e) {
                                var value = void 0;
                                if (input.tagName === "SELECT") {
                                    if (input.selectedIndex < 0) return;
                                    var selected = input.options[input.selectedIndex];
                                    if (selected.hasAttribute("selected")) value = false;
                                    else value = selected.value || false;
                                } else {
                                    if (input.classList.contains("ql-active")) value = false;
                                    else value = input.value || !input.hasAttribute("value");
                                    e.preventDefault();
                                }
                                _this2.quill.focus();
                                var _quill$selection$getR = _this2.quill.selection.getRange(), _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1), range = _quill$selection$getR2[0];
                                if (_this2.handlers[format] != null) _this2.handlers[format].call(_this2, value);
                                else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
                                    value = prompt("Enter " + format);
                                    if (!value) return;
                                    _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
                                } else _this2.quill.format(format, value, _quill2.default.sources.USER);
                                _this2.update(range);
                            });
                            // TODO use weakmap
                            this.controls.push([
                                format,
                                input
                            ]);
                        }
                    },
                    {
                        key: "update",
                        value: function update(range) {
                            var formats = range == null ? {} : this.quill.getFormat(range);
                            this.controls.forEach(function(pair) {
                                var _pair = _slicedToArray(pair, 2), format = _pair[0], input = _pair[1];
                                if (input.tagName === "SELECT") {
                                    var option = void 0;
                                    if (range == null) option = null;
                                    else if (formats[format] == null) option = input.querySelector("option[selected]");
                                    else if (!Array.isArray(formats[format])) {
                                        var value = formats[format];
                                        if (typeof value === "string") value = value.replace(/\"/g, '\\"');
                                        option = input.querySelector('option[value="' + value + '"]');
                                    }
                                    if (option == null) {
                                        input.value = ""; // TODO make configurable?
                                        input.selectedIndex = -1;
                                    } else option.selected = true;
                                } else {
                                    if (range == null) input.classList.remove("ql-active");
                                    else if (input.hasAttribute("value")) {
                                        // both being null should match (default values)
                                        // '1' should match with 1 (headers)
                                        var isActive = formats[format] === input.getAttribute("value") || formats[format] != null && formats[format].toString() === input.getAttribute("value") || formats[format] == null && !input.getAttribute("value");
                                        input.classList.toggle("ql-active", isActive);
                                    } else input.classList.toggle("ql-active", formats[format] != null);
                                }
                            });
                        }
                    }
                ]);
                return Toolbar;
            }(_module2.default);
            Toolbar.DEFAULTS = {};
            function addButton(container, format, value) {
                var input = document.createElement("button");
                input.setAttribute("type", "button");
                input.classList.add("ql-" + format);
                if (value != null) input.value = value;
                container.appendChild(input);
            }
            function addControls(container, groups) {
                if (!Array.isArray(groups[0])) groups = [
                    groups
                ];
                groups.forEach(function(controls) {
                    var group = document.createElement("span");
                    group.classList.add("ql-formats");
                    controls.forEach(function(control) {
                        if (typeof control === "string") addButton(group, control);
                        else {
                            var format = Object.keys(control)[0];
                            var value = control[format];
                            if (Array.isArray(value)) addSelect(group, format, value);
                            else addButton(group, format, value);
                        }
                    });
                    container.appendChild(group);
                });
            }
            function addSelect(container, format, values) {
                var input = document.createElement("select");
                input.classList.add("ql-" + format);
                values.forEach(function(value) {
                    var option = document.createElement("option");
                    if (value !== false) option.setAttribute("value", value);
                    else option.setAttribute("selected", "selected");
                    input.appendChild(option);
                });
                container.appendChild(input);
            }
            Toolbar.DEFAULTS = {
                container: null,
                handlers: {
                    clean: function clean() {
                        var _this3 = this;
                        var range = this.quill.getSelection();
                        if (range == null) return;
                        if (range.length == 0) {
                            var formats = this.quill.getFormat();
                            Object.keys(formats).forEach(function(name) {
                                // Clean functionality in existing apps only clean inline formats
                                if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) _this3.quill.format(name, false);
                            });
                        } else this.quill.removeFormat(range, _quill2.default.sources.USER);
                    },
                    direction: function direction(value) {
                        var align = this.quill.getFormat()["align"];
                        if (value === "rtl" && align == null) this.quill.format("align", "right", _quill2.default.sources.USER);
                        else if (!value && align === "right") this.quill.format("align", false, _quill2.default.sources.USER);
                        this.quill.format("direction", value, _quill2.default.sources.USER);
                    },
                    indent: function indent(value) {
                        var range = this.quill.getSelection();
                        var formats = this.quill.getFormat(range);
                        var indent = parseInt(formats.indent || 0);
                        if (value === "+1" || value === "-1") {
                            var modifier = value === "+1" ? 1 : -1;
                            if (formats.direction === "rtl") modifier *= -1;
                            this.quill.format("indent", indent + modifier, _quill2.default.sources.USER);
                        }
                    },
                    link: function link(value) {
                        if (value === true) value = prompt("Enter link URL:");
                        this.quill.format("link", value, _quill2.default.sources.USER);
                    },
                    list: function list(value) {
                        var range = this.quill.getSelection();
                        var formats = this.quill.getFormat(range);
                        if (value === "check") {
                            if (formats["list"] === "checked" || formats["list"] === "unchecked") this.quill.format("list", false, _quill2.default.sources.USER);
                            else this.quill.format("list", "unchecked", _quill2.default.sources.USER);
                        } else this.quill.format("list", value, _quill2.default.sources.USER);
                    }
                }
            };
            exports.default = Toolbar;
            exports.addControls = addControls;
        /***/ },
        /* 58 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <polyline class="ql-even ql-stroke" points="5 7 3 9 5 11"></polyline> <polyline class="ql-even ql-stroke" points="13 7 15 9 13 11"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>';
        /***/ },
        /* 59 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ColorPicker = function(_Picker) {
                _inherits(ColorPicker, _Picker);
                function ColorPicker(select, label) {
                    _classCallCheck(this, ColorPicker);
                    var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));
                    _this.label.innerHTML = label;
                    _this.container.classList.add("ql-color-picker");
                    [].slice.call(_this.container.querySelectorAll(".ql-picker-item"), 0, 7).forEach(function(item) {
                        item.classList.add("ql-primary");
                    });
                    return _this;
                }
                _createClass(ColorPicker, [
                    {
                        key: "buildItem",
                        value: function buildItem(option) {
                            var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), "buildItem", this).call(this, option);
                            item.style.backgroundColor = option.getAttribute("value") || "";
                            return item;
                        }
                    },
                    {
                        key: "selectItem",
                        value: function selectItem(item, trigger) {
                            _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), "selectItem", this).call(this, item, trigger);
                            var colorLabel = this.label.querySelector(".ql-color-label");
                            var value = item ? item.getAttribute("data-value") || "" : "";
                            if (colorLabel) {
                                if (colorLabel.tagName === "line") colorLabel.style.stroke = value;
                                else colorLabel.style.fill = value;
                            }
                        }
                    }
                ]);
                return ColorPicker;
            }(_picker2.default);
            exports.default = ColorPicker;
        /***/ },
        /* 60 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var IconPicker = function(_Picker) {
                _inherits(IconPicker, _Picker);
                function IconPicker(select, icons) {
                    _classCallCheck(this, IconPicker);
                    var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));
                    _this.container.classList.add("ql-icon-picker");
                    [].forEach.call(_this.container.querySelectorAll(".ql-picker-item"), function(item) {
                        item.innerHTML = icons[item.getAttribute("data-value") || ""];
                    });
                    _this.defaultItem = _this.container.querySelector(".ql-selected");
                    _this.selectItem(_this.defaultItem);
                    return _this;
                }
                _createClass(IconPicker, [
                    {
                        key: "selectItem",
                        value: function selectItem(item, trigger) {
                            _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), "selectItem", this).call(this, item, trigger);
                            item = item || this.defaultItem;
                            this.label.innerHTML = item.innerHTML;
                        }
                    }
                ]);
                return IconPicker;
            }(_picker2.default);
            exports.default = IconPicker;
        /***/ },
        /* 61 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var Tooltip = function() {
                function Tooltip(quill, boundsContainer) {
                    var _this = this;
                    _classCallCheck(this, Tooltip);
                    this.quill = quill;
                    this.boundsContainer = boundsContainer || document.body;
                    this.root = quill.addContainer("ql-tooltip");
                    this.root.innerHTML = this.constructor.TEMPLATE;
                    if (this.quill.root === this.quill.scrollingContainer) this.quill.root.addEventListener("scroll", function() {
                        _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + "px";
                    });
                    this.hide();
                }
                _createClass(Tooltip, [
                    {
                        key: "hide",
                        value: function hide() {
                            this.root.classList.add("ql-hidden");
                        }
                    },
                    {
                        key: "position",
                        value: function position(reference) {
                            var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
                            // root.scrollTop should be 0 if scrollContainer !== root
                            var top = reference.bottom + this.quill.root.scrollTop;
                            this.root.style.left = left + "px";
                            this.root.style.top = top + "px";
                            this.root.classList.remove("ql-flip");
                            var containerBounds = this.boundsContainer.getBoundingClientRect();
                            var rootBounds = this.root.getBoundingClientRect();
                            var shift = 0;
                            if (rootBounds.right > containerBounds.right) {
                                shift = containerBounds.right - rootBounds.right;
                                this.root.style.left = left + shift + "px";
                            }
                            if (rootBounds.left < containerBounds.left) {
                                shift = containerBounds.left - rootBounds.left;
                                this.root.style.left = left + shift + "px";
                            }
                            if (rootBounds.bottom > containerBounds.bottom) {
                                var height = rootBounds.bottom - rootBounds.top;
                                var verticalShift = reference.bottom - reference.top + height;
                                this.root.style.top = top - verticalShift + "px";
                                this.root.classList.add("ql-flip");
                            }
                            return shift;
                        }
                    },
                    {
                        key: "show",
                        value: function show() {
                            this.root.classList.remove("ql-editing");
                            this.root.classList.remove("ql-hidden");
                        }
                    }
                ]);
                return Tooltip;
            }();
            exports.default = Tooltip;
        /***/ },
        /* 62 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _base = __webpack_require__(43);
            var _base2 = _interopRequireDefault(_base);
            var _link = __webpack_require__(27);
            var _link2 = _interopRequireDefault(_link);
            var _selection = __webpack_require__(15);
            var _icons = __webpack_require__(41);
            var _icons2 = _interopRequireDefault(_icons);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var TOOLBAR_CONFIG = [
                [
                    {
                        header: [
                            "1",
                            "2",
                            "3",
                            false
                        ]
                    }
                ],
                [
                    "bold",
                    "italic",
                    "underline",
                    "link"
                ],
                [
                    {
                        list: "ordered"
                    },
                    {
                        list: "bullet"
                    }
                ],
                [
                    "clean"
                ]
            ];
            var SnowTheme = function(_BaseTheme) {
                _inherits(SnowTheme, _BaseTheme);
                function SnowTheme(quill, options) {
                    _classCallCheck(this, SnowTheme);
                    if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = TOOLBAR_CONFIG;
                    var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));
                    _this.quill.container.classList.add("ql-snow");
                    return _this;
                }
                _createClass(SnowTheme, [
                    {
                        key: "extendToolbar",
                        value: function extendToolbar(toolbar) {
                            toolbar.container.classList.add("ql-snow");
                            this.buildButtons([].slice.call(toolbar.container.querySelectorAll("button")), _icons2.default);
                            this.buildPickers([].slice.call(toolbar.container.querySelectorAll("select")), _icons2.default);
                            this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
                            if (toolbar.container.querySelector(".ql-link")) this.quill.keyboard.addBinding({
                                key: "K",
                                shortKey: true
                            }, function(range, context) {
                                toolbar.handlers["link"].call(toolbar, !context.format.link);
                            });
                        }
                    }
                ]);
                return SnowTheme;
            }(_base2.default);
            SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
                modules: {
                    toolbar: {
                        handlers: {
                            link: function link(value) {
                                if (value) {
                                    var range = this.quill.getSelection();
                                    if (range == null || range.length == 0) return;
                                    var preview = this.quill.getText(range);
                                    if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf("mailto:") !== 0) preview = "mailto:" + preview;
                                    var tooltip = this.quill.theme.tooltip;
                                    tooltip.edit("link", preview);
                                } else this.quill.format("link", false);
                            }
                        }
                    }
                }
            });
            var SnowTooltip = function(_BaseTooltip) {
                _inherits(SnowTooltip, _BaseTooltip);
                function SnowTooltip(quill, bounds) {
                    _classCallCheck(this, SnowTooltip);
                    var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));
                    _this2.preview = _this2.root.querySelector("a.ql-preview");
                    return _this2;
                }
                _createClass(SnowTooltip, [
                    {
                        key: "listen",
                        value: function listen() {
                            var _this3 = this;
                            _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), "listen", this).call(this);
                            this.root.querySelector("a.ql-action").addEventListener("click", function(event) {
                                if (_this3.root.classList.contains("ql-editing")) _this3.save();
                                else _this3.edit("link", _this3.preview.textContent);
                                event.preventDefault();
                            });
                            this.root.querySelector("a.ql-remove").addEventListener("click", function(event) {
                                if (_this3.linkRange != null) {
                                    var range = _this3.linkRange;
                                    _this3.restoreFocus();
                                    _this3.quill.formatText(range, "link", false, _emitter2.default.sources.USER);
                                    delete _this3.linkRange;
                                }
                                event.preventDefault();
                                _this3.hide();
                            });
                            this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function(range, oldRange, source) {
                                if (range == null) return;
                                if (range.length === 0 && source === _emitter2.default.sources.USER) {
                                    var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index), _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2), link = _quill$scroll$descend2[0], offset = _quill$scroll$descend2[1];
                                    if (link != null) {
                                        _this3.linkRange = new _selection.Range(range.index - offset, link.length());
                                        var preview = _link2.default.formats(link.domNode);
                                        _this3.preview.textContent = preview;
                                        _this3.preview.setAttribute("href", preview);
                                        _this3.show();
                                        _this3.position(_this3.quill.getBounds(_this3.linkRange));
                                        return;
                                    }
                                } else delete _this3.linkRange;
                                _this3.hide();
                            });
                        }
                    },
                    {
                        key: "show",
                        value: function show() {
                            _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), "show", this).call(this);
                            this.root.removeAttribute("data-mode");
                        }
                    }
                ]);
                return SnowTooltip;
            }(_base.BaseTooltip);
            SnowTooltip.TEMPLATE = [
                '<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>',
                '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
                '<a class="ql-action"></a>',
                '<a class="ql-remove"></a>'
            ].join("");
            exports.default = SnowTheme;
        /***/ },
        /* 63 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _core = __webpack_require__(29);
            var _core2 = _interopRequireDefault(_core);
            var _align = __webpack_require__(36);
            var _direction = __webpack_require__(38);
            var _indent = __webpack_require__(64);
            var _blockquote = __webpack_require__(65);
            var _blockquote2 = _interopRequireDefault(_blockquote);
            var _header = __webpack_require__(66);
            var _header2 = _interopRequireDefault(_header);
            var _list = __webpack_require__(67);
            var _list2 = _interopRequireDefault(_list);
            var _background = __webpack_require__(37);
            var _color = __webpack_require__(26);
            var _font = __webpack_require__(39);
            var _size = __webpack_require__(40);
            var _bold = __webpack_require__(56);
            var _bold2 = _interopRequireDefault(_bold);
            var _italic = __webpack_require__(68);
            var _italic2 = _interopRequireDefault(_italic);
            var _link = __webpack_require__(27);
            var _link2 = _interopRequireDefault(_link);
            var _script = __webpack_require__(69);
            var _script2 = _interopRequireDefault(_script);
            var _strike = __webpack_require__(70);
            var _strike2 = _interopRequireDefault(_strike);
            var _underline = __webpack_require__(71);
            var _underline2 = _interopRequireDefault(_underline);
            var _image = __webpack_require__(72);
            var _image2 = _interopRequireDefault(_image);
            var _video = __webpack_require__(73);
            var _video2 = _interopRequireDefault(_video);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _formula = __webpack_require__(74);
            var _formula2 = _interopRequireDefault(_formula);
            var _syntax = __webpack_require__(75);
            var _syntax2 = _interopRequireDefault(_syntax);
            var _toolbar = __webpack_require__(57);
            var _toolbar2 = _interopRequireDefault(_toolbar);
            var _icons = __webpack_require__(41);
            var _icons2 = _interopRequireDefault(_icons);
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            var _colorPicker = __webpack_require__(59);
            var _colorPicker2 = _interopRequireDefault(_colorPicker);
            var _iconPicker = __webpack_require__(60);
            var _iconPicker2 = _interopRequireDefault(_iconPicker);
            var _tooltip = __webpack_require__(61);
            var _tooltip2 = _interopRequireDefault(_tooltip);
            var _bubble = __webpack_require__(108);
            var _bubble2 = _interopRequireDefault(_bubble);
            var _snow = __webpack_require__(62);
            var _snow2 = _interopRequireDefault(_snow);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            _core2.default.register({
                "attributors/attribute/direction": _direction.DirectionAttribute,
                "attributors/class/align": _align.AlignClass,
                "attributors/class/background": _background.BackgroundClass,
                "attributors/class/color": _color.ColorClass,
                "attributors/class/direction": _direction.DirectionClass,
                "attributors/class/font": _font.FontClass,
                "attributors/class/size": _size.SizeClass,
                "attributors/style/align": _align.AlignStyle,
                "attributors/style/background": _background.BackgroundStyle,
                "attributors/style/color": _color.ColorStyle,
                "attributors/style/direction": _direction.DirectionStyle,
                "attributors/style/font": _font.FontStyle,
                "attributors/style/size": _size.SizeStyle
            }, true);
            _core2.default.register({
                "formats/align": _align.AlignClass,
                "formats/direction": _direction.DirectionClass,
                "formats/indent": _indent.IndentClass,
                "formats/background": _background.BackgroundStyle,
                "formats/color": _color.ColorStyle,
                "formats/font": _font.FontClass,
                "formats/size": _size.SizeClass,
                "formats/blockquote": _blockquote2.default,
                "formats/code-block": _code2.default,
                "formats/header": _header2.default,
                "formats/list": _list2.default,
                "formats/bold": _bold2.default,
                "formats/code": _code.Code,
                "formats/italic": _italic2.default,
                "formats/link": _link2.default,
                "formats/script": _script2.default,
                "formats/strike": _strike2.default,
                "formats/underline": _underline2.default,
                "formats/image": _image2.default,
                "formats/video": _video2.default,
                "formats/list/item": _list.ListItem,
                "modules/formula": _formula2.default,
                "modules/syntax": _syntax2.default,
                "modules/toolbar": _toolbar2.default,
                "themes/bubble": _bubble2.default,
                "themes/snow": _snow2.default,
                "ui/icons": _icons2.default,
                "ui/picker": _picker2.default,
                "ui/icon-picker": _iconPicker2.default,
                "ui/color-picker": _colorPicker2.default,
                "ui/tooltip": _tooltip2.default
            }, true);
            exports.default = _core2.default;
        /***/ },
        /* 64 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.IndentClass = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var IdentAttributor = function(_Parchment$Attributor) {
                _inherits(IdentAttributor, _Parchment$Attributor);
                function IdentAttributor() {
                    _classCallCheck(this, IdentAttributor);
                    return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
                }
                _createClass(IdentAttributor, [
                    {
                        key: "add",
                        value: function add(node, value) {
                            if (value === "+1" || value === "-1") {
                                var indent = this.value(node) || 0;
                                value = value === "+1" ? indent + 1 : indent - 1;
                            }
                            if (value === 0) {
                                this.remove(node);
                                return true;
                            } else return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), "add", this).call(this, node, value);
                        }
                    },
                    {
                        key: "canAdd",
                        value: function canAdd(node, value) {
                            return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), "canAdd", this).call(this, node, value) || _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), "canAdd", this).call(this, node, parseInt(value));
                        }
                    },
                    {
                        key: "value",
                        value: function value(node) {
                            return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), "value", this).call(this, node)) || undefined; // Don't return NaN
                        }
                    }
                ]);
                return IdentAttributor;
            }(_parchment2.default.Attributor.Class);
            var IndentClass = new IdentAttributor("indent", "ql-indent", {
                scope: _parchment2.default.Scope.BLOCK,
                whitelist: [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8
                ]
            });
            exports.IndentClass = IndentClass;
        /***/ },
        /* 65 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Blockquote = function(_Block) {
                _inherits(Blockquote, _Block);
                function Blockquote() {
                    _classCallCheck(this, Blockquote);
                    return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
                }
                return Blockquote;
            }(_block2.default);
            Blockquote.blotName = "blockquote";
            Blockquote.tagName = "blockquote";
            exports.default = Blockquote;
        /***/ },
        /* 66 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Header = function(_Block) {
                _inherits(Header, _Block);
                function Header() {
                    _classCallCheck(this, Header);
                    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
                }
                _createClass(Header, null, [
                    {
                        key: "formats",
                        value: function formats(domNode) {
                            return this.tagName.indexOf(domNode.tagName) + 1;
                        }
                    }
                ]);
                return Header;
            }(_block2.default);
            Header.blotName = "header";
            Header.tagName = [
                "H1",
                "H2",
                "H3",
                "H4",
                "H5",
                "H6"
            ];
            exports.default = Header;
        /***/ },
        /* 67 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.ListItem = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _container = __webpack_require__(25);
            var _container2 = _interopRequireDefault(_container);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ListItem = function(_Block) {
                _inherits(ListItem, _Block);
                function ListItem() {
                    _classCallCheck(this, ListItem);
                    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
                }
                _createClass(ListItem, [
                    {
                        key: "format",
                        value: function format(name, value) {
                            if (name === List.blotName && !value) this.replaceWith(_parchment2.default.create(this.statics.scope));
                            else _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), "format", this).call(this, name, value);
                        }
                    },
                    {
                        key: "remove",
                        value: function remove() {
                            if (this.prev == null && this.next == null) this.parent.remove();
                            else _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), "remove", this).call(this);
                        }
                    },
                    {
                        key: "replaceWith",
                        value: function replaceWith(name, value) {
                            this.parent.isolate(this.offset(this.parent), this.length());
                            if (name === this.parent.statics.blotName) {
                                this.parent.replaceWith(name, value);
                                return this;
                            } else {
                                this.parent.unwrap();
                                return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), "replaceWith", this).call(this, name, value);
                            }
                        }
                    }
                ], [
                    {
                        key: "formats",
                        value: function formats(domNode) {
                            return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), "formats", this).call(this, domNode);
                        }
                    }
                ]);
                return ListItem;
            }(_block2.default);
            ListItem.blotName = "list-item";
            ListItem.tagName = "LI";
            var List = function(_Container) {
                _inherits(List, _Container);
                _createClass(List, null, [
                    {
                        key: "create",
                        value: function create(value) {
                            var tagName = value === "ordered" ? "OL" : "UL";
                            var node = _get(List.__proto__ || Object.getPrototypeOf(List), "create", this).call(this, tagName);
                            if (value === "checked" || value === "unchecked") node.setAttribute("data-checked", value === "checked");
                            return node;
                        }
                    },
                    {
                        key: "formats",
                        value: function formats(domNode) {
                            if (domNode.tagName === "OL") return "ordered";
                            if (domNode.tagName === "UL") {
                                if (domNode.hasAttribute("data-checked")) return domNode.getAttribute("data-checked") === "true" ? "checked" : "unchecked";
                                else return "bullet";
                            }
                            return undefined;
                        }
                    }
                ]);
                function List(domNode) {
                    _classCallCheck(this, List);
                    var _this2 = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, domNode));
                    var listEventHandler = function listEventHandler(e) {
                        if (e.target.parentNode !== domNode) return;
                        var format = _this2.statics.formats(domNode);
                        var blot = _parchment2.default.find(e.target);
                        if (format === "checked") blot.format("list", "unchecked");
                        else if (format === "unchecked") blot.format("list", "checked");
                    };
                    domNode.addEventListener("touchstart", listEventHandler);
                    domNode.addEventListener("mousedown", listEventHandler);
                    return _this2;
                }
                _createClass(List, [
                    {
                        key: "format",
                        value: function format(name, value) {
                            if (this.children.length > 0) this.children.tail.format(name, value);
                        }
                    },
                    {
                        key: "formats",
                        value: function formats() {
                            // We don't inherit from FormatBlot
                            return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
                        }
                    },
                    {
                        key: "insertBefore",
                        value: function insertBefore(blot, ref) {
                            if (blot instanceof ListItem) _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), "insertBefore", this).call(this, blot, ref);
                            else {
                                var index = ref == null ? this.length() : ref.offset(this);
                                var after = this.split(index);
                                after.parent.insertBefore(blot, after);
                            }
                        }
                    },
                    {
                        key: "optimize",
                        value: function optimize(context) {
                            _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), "optimize", this).call(this, context);
                            var next = this.next;
                            if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute("data-checked") === this.domNode.getAttribute("data-checked")) {
                                next.moveChildren(this);
                                next.remove();
                            }
                        }
                    },
                    {
                        key: "replace",
                        value: function replace(target) {
                            if (target.statics.blotName !== this.statics.blotName) {
                                var item = _parchment2.default.create(this.statics.defaultChild);
                                target.moveChildren(item);
                                this.appendChild(item);
                            }
                            _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), "replace", this).call(this, target);
                        }
                    }
                ]);
                return List;
            }(_container2.default);
            List.blotName = "list";
            List.scope = _parchment2.default.Scope.BLOCK_BLOT;
            List.tagName = [
                "OL",
                "UL"
            ];
            List.defaultChild = "list-item";
            List.allowedChildren = [
                ListItem
            ];
            exports.ListItem = ListItem;
            exports.default = List;
        /***/ },
        /* 68 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _bold = __webpack_require__(56);
            var _bold2 = _interopRequireDefault(_bold);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Italic = function(_Bold) {
                _inherits(Italic, _Bold);
                function Italic() {
                    _classCallCheck(this, Italic);
                    return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
                }
                return Italic;
            }(_bold2.default);
            Italic.blotName = "italic";
            Italic.tagName = [
                "EM",
                "I"
            ];
            exports.default = Italic;
        /***/ },
        /* 69 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Script = function(_Inline) {
                _inherits(Script, _Inline);
                function Script() {
                    _classCallCheck(this, Script);
                    return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
                }
                _createClass(Script, null, [
                    {
                        key: "create",
                        value: function create(value) {
                            if (value === "super") return document.createElement("sup");
                            else if (value === "sub") return document.createElement("sub");
                            else return _get(Script.__proto__ || Object.getPrototypeOf(Script), "create", this).call(this, value);
                        }
                    },
                    {
                        key: "formats",
                        value: function formats(domNode) {
                            if (domNode.tagName === "SUB") return "sub";
                            if (domNode.tagName === "SUP") return "super";
                            return undefined;
                        }
                    }
                ]);
                return Script;
            }(_inline2.default);
            Script.blotName = "script";
            Script.tagName = [
                "SUB",
                "SUP"
            ];
            exports.default = Script;
        /***/ },
        /* 70 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Strike = function(_Inline) {
                _inherits(Strike, _Inline);
                function Strike() {
                    _classCallCheck(this, Strike);
                    return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
                }
                return Strike;
            }(_inline2.default);
            Strike.blotName = "strike";
            Strike.tagName = "S";
            exports.default = Strike;
        /***/ },
        /* 71 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Underline = function(_Inline) {
                _inherits(Underline, _Inline);
                function Underline() {
                    _classCallCheck(this, Underline);
                    return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
                }
                return Underline;
            }(_inline2.default);
            Underline.blotName = "underline";
            Underline.tagName = "U";
            exports.default = Underline;
        /***/ },
        /* 72 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _link = __webpack_require__(27);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ATTRIBUTES = [
                "alt",
                "height",
                "width"
            ];
            var Image = function(_Parchment$Embed) {
                _inherits(Image, _Parchment$Embed);
                function Image() {
                    _classCallCheck(this, Image);
                    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
                }
                _createClass(Image, [
                    {
                        key: "format",
                        value: function format(name, value) {
                            if (ATTRIBUTES.indexOf(name) > -1) {
                                if (value) this.domNode.setAttribute(name, value);
                                else this.domNode.removeAttribute(name);
                            } else _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), "format", this).call(this, name, value);
                        }
                    }
                ], [
                    {
                        key: "create",
                        value: function create(value) {
                            var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), "create", this).call(this, value);
                            if (typeof value === "string") node.setAttribute("src", this.sanitize(value));
                            return node;
                        }
                    },
                    {
                        key: "formats",
                        value: function formats(domNode) {
                            return ATTRIBUTES.reduce(function(formats, attribute) {
                                if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
                                return formats;
                            }, {});
                        }
                    },
                    {
                        key: "match",
                        value: function match(url) {
                            return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
                        }
                    },
                    {
                        key: "sanitize",
                        value: function sanitize(url) {
                            return (0, _link.sanitize)(url, [
                                "http",
                                "https",
                                "data"
                            ]) ? url : "//:0";
                        }
                    },
                    {
                        key: "value",
                        value: function value(domNode) {
                            return domNode.getAttribute("src");
                        }
                    }
                ]);
                return Image;
            }(_parchment2.default.Embed);
            Image.blotName = "image";
            Image.tagName = "IMG";
            exports.default = Image;
        /***/ },
        /* 73 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _block = __webpack_require__(4);
            var _link = __webpack_require__(27);
            var _link2 = _interopRequireDefault(_link);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ATTRIBUTES = [
                "height",
                "width"
            ];
            var Video = function(_BlockEmbed) {
                _inherits(Video, _BlockEmbed);
                function Video() {
                    _classCallCheck(this, Video);
                    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
                }
                _createClass(Video, [
                    {
                        key: "format",
                        value: function format(name, value) {
                            if (ATTRIBUTES.indexOf(name) > -1) {
                                if (value) this.domNode.setAttribute(name, value);
                                else this.domNode.removeAttribute(name);
                            } else _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), "format", this).call(this, name, value);
                        }
                    }
                ], [
                    {
                        key: "create",
                        value: function create(value) {
                            var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), "create", this).call(this, value);
                            node.setAttribute("frameborder", "0");
                            node.setAttribute("allowfullscreen", true);
                            node.setAttribute("src", this.sanitize(value));
                            return node;
                        }
                    },
                    {
                        key: "formats",
                        value: function formats(domNode) {
                            return ATTRIBUTES.reduce(function(formats, attribute) {
                                if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
                                return formats;
                            }, {});
                        }
                    },
                    {
                        key: "sanitize",
                        value: function sanitize(url) {
                            return _link2.default.sanitize(url);
                        }
                    },
                    {
                        key: "value",
                        value: function value(domNode) {
                            return domNode.getAttribute("src");
                        }
                    }
                ]);
                return Video;
            }(_block.BlockEmbed);
            Video.blotName = "video";
            Video.className = "ql-video";
            Video.tagName = "IFRAME";
            exports.default = Video;
        /***/ },
        /* 74 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.FormulaBlot = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _embed = __webpack_require__(35);
            var _embed2 = _interopRequireDefault(_embed);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var FormulaBlot = function(_Embed) {
                _inherits(FormulaBlot, _Embed);
                function FormulaBlot() {
                    _classCallCheck(this, FormulaBlot);
                    return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
                }
                _createClass(FormulaBlot, null, [
                    {
                        key: "create",
                        value: function create(value) {
                            var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), "create", this).call(this, value);
                            if (typeof value === "string") {
                                window.katex.render(value, node, {
                                    throwOnError: false,
                                    errorColor: "#f00"
                                });
                                node.setAttribute("data-value", value);
                            }
                            return node;
                        }
                    },
                    {
                        key: "value",
                        value: function value(domNode) {
                            return domNode.getAttribute("data-value");
                        }
                    }
                ]);
                return FormulaBlot;
            }(_embed2.default);
            FormulaBlot.blotName = "formula";
            FormulaBlot.className = "ql-formula";
            FormulaBlot.tagName = "SPAN";
            var Formula = function(_Module) {
                _inherits(Formula, _Module);
                _createClass(Formula, null, [
                    {
                        key: "register",
                        value: function register() {
                            _quill2.default.register(FormulaBlot, true);
                        }
                    }
                ]);
                function Formula() {
                    _classCallCheck(this, Formula);
                    var _this2 = _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).call(this));
                    if (window.katex == null) throw new Error("Formula module requires KaTeX.");
                    return _this2;
                }
                return Formula;
            }(_module2.default);
            exports.FormulaBlot = FormulaBlot;
            exports.default = Formula;
        /***/ },
        /* 75 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.CodeToken = exports.CodeBlock = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var SyntaxCodeBlock = function(_CodeBlock) {
                _inherits(SyntaxCodeBlock, _CodeBlock);
                function SyntaxCodeBlock() {
                    _classCallCheck(this, SyntaxCodeBlock);
                    return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
                }
                _createClass(SyntaxCodeBlock, [
                    {
                        key: "replaceWith",
                        value: function replaceWith(block) {
                            this.domNode.textContent = this.domNode.textContent;
                            this.attach();
                            _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), "replaceWith", this).call(this, block);
                        }
                    },
                    {
                        key: "highlight",
                        value: function highlight(_highlight) {
                            var text = this.domNode.textContent;
                            if (this.cachedText !== text) {
                                if (text.trim().length > 0 || this.cachedText == null) {
                                    this.domNode.innerHTML = _highlight(text);
                                    this.domNode.normalize();
                                    this.attach();
                                }
                                this.cachedText = text;
                            }
                        }
                    }
                ]);
                return SyntaxCodeBlock;
            }(_code2.default);
            SyntaxCodeBlock.className = "ql-syntax";
            var CodeToken = new _parchment2.default.Attributor.Class("token", "hljs", {
                scope: _parchment2.default.Scope.INLINE
            });
            var Syntax = function(_Module) {
                _inherits(Syntax, _Module);
                _createClass(Syntax, null, [
                    {
                        key: "register",
                        value: function register() {
                            _quill2.default.register(CodeToken, true);
                            _quill2.default.register(SyntaxCodeBlock, true);
                        }
                    }
                ]);
                function Syntax(quill, options) {
                    _classCallCheck(this, Syntax);
                    var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));
                    if (typeof _this2.options.highlight !== "function") throw new Error("Syntax module requires highlight.js. Please include the library on the page before Quill.");
                    var timer = null;
                    _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function() {
                        clearTimeout(timer);
                        timer = setTimeout(function() {
                            _this2.highlight();
                            timer = null;
                        }, _this2.options.interval);
                    });
                    _this2.highlight();
                    return _this2;
                }
                _createClass(Syntax, [
                    {
                        key: "highlight",
                        value: function highlight() {
                            var _this3 = this;
                            if (this.quill.selection.composing) return;
                            this.quill.update(_quill2.default.sources.USER);
                            var range = this.quill.getSelection();
                            this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function(code) {
                                code.highlight(_this3.options.highlight);
                            });
                            this.quill.update(_quill2.default.sources.SILENT);
                            if (range != null) this.quill.setSelection(range, _quill2.default.sources.SILENT);
                        }
                    }
                ]);
                return Syntax;
            }(_module2.default);
            Syntax.DEFAULTS = {
                highlight: function() {
                    if (window.hljs == null) return null;
                    return function(text) {
                        var result = window.hljs.highlightAuto(text);
                        return result.value;
                    };
                }(),
                interval: 1000
            };
            exports.CodeBlock = SyntaxCodeBlock;
            exports.CodeToken = CodeToken;
            exports.default = Syntax;
        /***/ },
        /* 76 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>';
        /***/ },
        /* 77 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>';
        /***/ },
        /* 78 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>';
        /***/ },
        /* 79 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>';
        /***/ },
        /* 80 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <g class="ql-fill ql-color-label"> <polygon points="6 6.868 6 6 5 6 5 7 5.942 7 6 6.868"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points="6.817 5 6 5 6 6 6.38 6 6.817 5"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points="4 11.439 4 11 3 11 3 12 3.755 12 4 11.439"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points="4.63 10 4 10 4 11 4.192 11 4.63 10"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points="13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points="12 6.868 12 6 11.62 6 12 6.868"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points="12.933 9 13 9 13 8 12.495 8 12.933 9"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points="5.5 13 9 5 12.5 13"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>';
        /***/ },
        /* 81 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <rect class="ql-fill ql-stroke" height=3 width=3 x=4 y=5></rect> <rect class="ql-fill ql-stroke" height=3 width=3 x=11 y=5></rect> <path class="ql-even ql-fill ql-stroke" d=M7,8c0,4.031-3,5-3,5></path> <path class="ql-even ql-fill ql-stroke" d=M14,8c0,4.031-3,5-3,5></path> </svg>';
        /***/ },
        /* 82 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>';
        /***/ },
        /* 83 */ /***/ function(module1, exports) {
            module1.exports = '<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>';
        /***/ },
        /* 84 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class="ql-color-label ql-stroke ql-transparent" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points="5.5 11 9 3 12.5 11"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>';
        /***/ },
        /* 85 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="3 11 5 9 3 7 3 11"></polygon> <line class="ql-stroke ql-fill" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>';
        /***/ },
        /* 86 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="15 12 13 10 15 8 15 12"></polygon> <line class="ql-stroke ql-fill" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>';
        /***/ },
        /* 87 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>';
        /***/ },
        /* 88 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>';
        /***/ },
        /* 89 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>';
        /***/ },
        /* 90 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform="translate(24 18) rotate(-180)"/> </svg>';
        /***/ },
        /* 91 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>';
        /***/ },
        /* 92 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 18 18"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>';
        /***/ },
        /* 93 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 18 18"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>';
        /***/ },
        /* 94 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>';
        /***/ },
        /* 95 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"></polyline> </svg>';
        /***/ },
        /* 96 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class="ql-fill ql-stroke" points="3 7 3 11 5 9 3 7"></polyline> </svg>';
        /***/ },
        /* 97 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="5 7 5 11 3 9 5 7"></polyline> </svg>';
        /***/ },
        /* 98 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class="ql-even ql-stroke" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class="ql-even ql-stroke" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>';
        /***/ },
        /* 99 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class="ql-stroke ql-thin" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class="ql-stroke ql-thin" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class="ql-stroke ql-thin" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>';
        /***/ },
        /* 100 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>';
        /***/ },
        /* 101 */ /***/ function(module1, exports) {
            module1.exports = '<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points="3 4 4 5 6 3"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points="3 14 4 15 6 13"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="3 9 4 10 6 8"></polyline> </svg>';
        /***/ },
        /* 102 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>';
        /***/ },
        /* 103 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>';
        /***/ },
        /* 104 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <line class="ql-stroke ql-thin" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>';
        /***/ },
        /* 105 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>';
        /***/ },
        /* 106 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>';
        /***/ },
        /* 107 */ /***/ function(module1, exports) {
            module1.exports = '<svg viewbox="0 0 18 18"> <polygon class=ql-stroke points="7 11 9 13 11 11 7 11"></polygon> <polygon class=ql-stroke points="7 7 9 5 11 7 7 7"></polygon> </svg>';
        /***/ },
        /* 108 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.BubbleTooltip = undefined;
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _base = __webpack_require__(43);
            var _base2 = _interopRequireDefault(_base);
            var _selection = __webpack_require__(15);
            var _icons = __webpack_require__(41);
            var _icons2 = _interopRequireDefault(_icons);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var TOOLBAR_CONFIG = [
                [
                    "bold",
                    "italic",
                    "link"
                ],
                [
                    {
                        header: 1
                    },
                    {
                        header: 2
                    },
                    "blockquote"
                ]
            ];
            var BubbleTheme = function(_BaseTheme) {
                _inherits(BubbleTheme, _BaseTheme);
                function BubbleTheme(quill, options) {
                    _classCallCheck(this, BubbleTheme);
                    if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = TOOLBAR_CONFIG;
                    var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));
                    _this.quill.container.classList.add("ql-bubble");
                    return _this;
                }
                _createClass(BubbleTheme, [
                    {
                        key: "extendToolbar",
                        value: function extendToolbar(toolbar) {
                            this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
                            this.tooltip.root.appendChild(toolbar.container);
                            this.buildButtons([].slice.call(toolbar.container.querySelectorAll("button")), _icons2.default);
                            this.buildPickers([].slice.call(toolbar.container.querySelectorAll("select")), _icons2.default);
                        }
                    }
                ]);
                return BubbleTheme;
            }(_base2.default);
            BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
                modules: {
                    toolbar: {
                        handlers: {
                            link: function link(value) {
                                if (!value) this.quill.format("link", false);
                                else this.quill.theme.tooltip.edit();
                            }
                        }
                    }
                }
            });
            var BubbleTooltip = function(_BaseTooltip) {
                _inherits(BubbleTooltip, _BaseTooltip);
                function BubbleTooltip(quill, bounds) {
                    _classCallCheck(this, BubbleTooltip);
                    var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));
                    _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function(type, range, oldRange, source) {
                        if (type !== _emitter2.default.events.SELECTION_CHANGE) return;
                        if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
                            _this2.show();
                            // Lock our width so we will expand beyond our offsetParent boundaries
                            _this2.root.style.left = "0px";
                            _this2.root.style.width = "";
                            _this2.root.style.width = _this2.root.offsetWidth + "px";
                            var lines = _this2.quill.getLines(range.index, range.length);
                            if (lines.length === 1) _this2.position(_this2.quill.getBounds(range));
                            else {
                                var lastLine = lines[lines.length - 1];
                                var index = _this2.quill.getIndex(lastLine);
                                var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
                                var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
                                _this2.position(_bounds);
                            }
                        } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) _this2.hide();
                    });
                    return _this2;
                }
                _createClass(BubbleTooltip, [
                    {
                        key: "listen",
                        value: function listen() {
                            var _this3 = this;
                            _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), "listen", this).call(this);
                            this.root.querySelector(".ql-close").addEventListener("click", function() {
                                _this3.root.classList.remove("ql-editing");
                            });
                            this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function() {
                                // Let selection be restored by toolbar handlers before repositioning
                                setTimeout(function() {
                                    if (_this3.root.classList.contains("ql-hidden")) return;
                                    var range = _this3.quill.getSelection();
                                    if (range != null) _this3.position(_this3.quill.getBounds(range));
                                }, 1);
                            });
                        }
                    },
                    {
                        key: "cancel",
                        value: function cancel() {
                            this.show();
                        }
                    },
                    {
                        key: "position",
                        value: function position(reference) {
                            var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), "position", this).call(this, reference);
                            var arrow = this.root.querySelector(".ql-tooltip-arrow");
                            arrow.style.marginLeft = "";
                            if (shift === 0) return shift;
                            arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + "px";
                        }
                    }
                ]);
                return BubbleTooltip;
            }(_base.BaseTooltip);
            BubbleTooltip.TEMPLATE = [
                '<span class="ql-tooltip-arrow"></span>',
                '<div class="ql-tooltip-editor">',
                '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
                '<a class="ql-close"></a>',
                "</div>"
            ].join("");
            exports.BubbleTooltip = BubbleTooltip;
            exports.default = BubbleTheme;
        /***/ },
        /* 109 */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = __webpack_require__(63);
        /***/ }
    ])["default"];
});

});

parcelRegister("ifbub", function(module, exports) {
"use strict";

});

parcelRegister("eAyj5", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";

var $k9qD0 = parcelRequire("k9qD0");

var $c0YT0 = parcelRequire("c0YT0");
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    "'"
].concat(unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat(autoEscape), hostEndingChars = [
    "/",
    "?",
    "#"
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that never have a hostname.
hostlessProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that always contain a // bit.
slashedProtocol = {
    "http": true,
    "https": true,
    "ftp": true,
    "gopher": true,
    "file": true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};

var $iyaFA = parcelRequire("iyaFA");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && $c0YT0.isObject(url) && url instanceof Url) return url;
    var u = new Url;
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (!$c0YT0.isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $iyaFA.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf("@", hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || "";
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) // IDNA Support: Returns a punycoded representation of "domain".
        // It only converts parts of the domain name that
        // have non-ASCII characters, i.e. it doesn't matter if
        // you call it with a domain that already is ASCII-only.
        this.hostname = $k9qD0.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    // now rest is set to the post-host stuff.
    // chop off any delim chars.
    if (!unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $iyaFA.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    //to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    // ensure it's an object, and not a string url.
    // If it's an obj, this is a no-op.
    // this way, you can call url_format() on strings
    // to clean up potentially wonky urls.
    if ($c0YT0.isString(obj)) obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && $c0YT0.isObject(this.query) && Object.keys(this.query).length) query = $iyaFA.stringify(this.query);
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
    // unless they had them to begin with.
    if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if ($c0YT0.isString(relative)) {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    // hash is always overridden, no matter what.
    // even href="" will remove it.
    result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        //urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = "/";
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        // if it's a known url protocol, then changing
        // the protocol does weird things
        // first, if it's not file:, then we MUST have a host,
        // and if there was a path
        // to begin with, then we MUST have a path.
        // if it is file:, then the host is dropped,
        // because that's known to be hostless.
        // anything else is assumed to be absolute.
        if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    // if the url is a non-slashed url, then relative
    // links like ../.. should be able
    // to crawl up to the hostname, as well.  This is strange.
    // result.protocol has already been set by now.
    // Later on, put the first path part into the host field.
    if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        // it's relative
        // throw away the existing file, and take the new path instead.
        if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (!$c0YT0.isNullOrUndefined(relative.search)) {
        // just pull out the search.
        // like href='?foo'.
        // Put this after the other two cases because it simplifies the booleans
        if (psychotic) {
            result.hostname = result.host = srcPath.shift();
            //occationaly the auth can get stuck only in host
            //this especially happens in cases like
            //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
            var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.host = result.hostname = authInHost.shift();
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        //to support http.request
        if (!$c0YT0.isNull(result.pathname) || !$c0YT0.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        // no path at all.  easy.
        // we've already handled the other stuff above.
        result.pathname = null;
        //to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    // if a url ENDs in . or .., then it must get a trailing slash.
    // however, if it ends in anything else non-slashy,
    // then it must NOT get a trailing slash.
    var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    // strip single dots, resolve double dots to parent dir
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = result.host = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        //occationaly the auth can get stuck only in host
        //this especially happens in cases like
        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
        var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.host = result.hostname = authInHost.shift();
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (!srcPath.length) {
        result.pathname = null;
        result.path = null;
    } else result.pathname = srcPath.join("/");
    //to support request.http
    if (!$c0YT0.isNull(result.pathname) || !$c0YT0.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};

});
parcelRegister("k9qD0", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.3.2",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) freeModule.exports = punycode;
        else for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else root.punycode = punycode;
})(this);

});

parcelRegister("c0YT0", function(module, exports) {
"use strict";
module.exports = {
    isString: function(arg) {
        return typeof arg === "string";
    },
    isObject: function(arg) {
        return typeof arg === "object" && arg !== null;
    },
    isNull: function(arg) {
        return arg === null;
    },
    isNullOrUndefined: function(arg) {
        return arg == null;
    }
};

});

parcelRegister("iyaFA", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $d813adbc456acb47$export$98e6a39c04603d36; }, function (v) { return $d813adbc456acb47$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $d813adbc456acb47$export$fac44ee5b035f737; }, function (v) { return $d813adbc456acb47$export$fac44ee5b035f737 = v; });
var $d813adbc456acb47$export$2f872c0f2117be69;
var $d813adbc456acb47$export$98e6a39c04603d36;
var $d813adbc456acb47$export$c564cdbbe6da493;
var $d813adbc456acb47$export$fac44ee5b035f737;
"use strict";

$d813adbc456acb47$export$2f872c0f2117be69 = $d813adbc456acb47$export$98e6a39c04603d36 = (parcelRequire("2APiE"));

$d813adbc456acb47$export$c564cdbbe6da493 = $d813adbc456acb47$export$fac44ee5b035f737 = (parcelRequire("lPZ4b"));

});
parcelRegister("2APiE", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $1e36bca46bb754c7$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || "&";
    eq = eq || "=";
    var obj = {};
    if (typeof qs !== "string" || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === "number") maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, "%20"), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = "";
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$1e36bca46bb754c7$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($1e36bca46bb754c7$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $1e36bca46bb754c7$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};

});

parcelRegister("lPZ4b", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $fe5dbae852f328cf$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case "string":
            return v;
        case "boolean":
            return v ? "true" : "false";
        case "number":
            return isFinite(v) ? v : "";
        default:
            return "";
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || "&";
    eq = eq || "=";
    if (obj === null) obj = undefined;
    if (typeof obj === "object") return $fe5dbae852f328cf$var$map($fe5dbae852f328cf$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($fe5dbae852f328cf$var$stringifyPrimitive(k)) + eq;
        if ($fe5dbae852f328cf$var$isArray(obj[k])) return $fe5dbae852f328cf$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($fe5dbae852f328cf$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($fe5dbae852f328cf$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return "";
    return encodeURIComponent($fe5dbae852f328cf$var$stringifyPrimitive(name)) + eq + encodeURIComponent($fe5dbae852f328cf$var$stringifyPrimitive(obj));
};
var $fe5dbae852f328cf$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};
function $fe5dbae852f328cf$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $fe5dbae852f328cf$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});



parcelRegister("a2ZiP", function(module, exports) {
"use strict";

var $2jspb = parcelRequire("2jspb");

var $2gQiD = parcelRequire("2gQiD");

var $kSNaY = parcelRequire("kSNaY");

var $jLKfw = parcelRequire("jLKfw");

var $gk4S3 = parcelRequire("gk4S3");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $7509a4babff59c83$var$createInstance(defaultConfig) {
    var context = new $kSNaY(defaultConfig);
    var instance = $2gQiD($kSNaY.prototype.request, context);
    // Copy axios.prototype to instance
    $2jspb.extend(instance, $kSNaY.prototype, context);
    // Copy context to instance
    $2jspb.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $7509a4babff59c83$var$createInstance($jLKfw(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $7509a4babff59c83$var$axios = $7509a4babff59c83$var$createInstance($gk4S3);
// Expose Axios class to allow class inheritance
$7509a4babff59c83$var$axios.Axios = $kSNaY;

// Expose Cancel & CancelToken
$7509a4babff59c83$var$axios.Cancel = (parcelRequire("8tFqz"));

$7509a4babff59c83$var$axios.CancelToken = (parcelRequire("k1WYj"));

$7509a4babff59c83$var$axios.isCancel = (parcelRequire("dByrq"));

$7509a4babff59c83$var$axios.VERSION = (parcelRequire("bUKfL")).version;
// Expose all/spread
$7509a4babff59c83$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$7509a4babff59c83$var$axios.spread = (parcelRequire("hnisX"));

// Expose isAxiosError
$7509a4babff59c83$var$axios.isAxiosError = (parcelRequire("kIHL2"));
module.exports = $7509a4babff59c83$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $7509a4babff59c83$var$axios;

});
parcelRegister("2jspb", function(module, exports) {
"use strict";

var $2gQiD = parcelRequire("2gQiD");
// utils is a library of generic helper functions non-specific to axios
var $1af363cd1875cfda$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $1af363cd1875cfda$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $1af363cd1875cfda$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $1af363cd1875cfda$var$isBuffer(val) {
    return val !== null && !$1af363cd1875cfda$var$isUndefined(val) && val.constructor !== null && !$1af363cd1875cfda$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $1af363cd1875cfda$var$isArrayBuffer(val) {
    return $1af363cd1875cfda$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $1af363cd1875cfda$var$isFormData(val) {
    return $1af363cd1875cfda$var$toString.call(val) === "[object FormData]";
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $1af363cd1875cfda$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $1af363cd1875cfda$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $1af363cd1875cfda$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $1af363cd1875cfda$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $1af363cd1875cfda$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $1af363cd1875cfda$var$isPlainObject(val) {
    if ($1af363cd1875cfda$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $1af363cd1875cfda$var$isDate(val) {
    return $1af363cd1875cfda$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $1af363cd1875cfda$var$isFile(val) {
    return $1af363cd1875cfda$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $1af363cd1875cfda$var$isBlob(val) {
    return $1af363cd1875cfda$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $1af363cd1875cfda$var$isFunction(val) {
    return $1af363cd1875cfda$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $1af363cd1875cfda$var$isStream(val) {
    return $1af363cd1875cfda$var$isObject(val) && $1af363cd1875cfda$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $1af363cd1875cfda$var$isURLSearchParams(val) {
    return $1af363cd1875cfda$var$toString.call(val) === "[object URLSearchParams]";
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $1af363cd1875cfda$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $1af363cd1875cfda$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $1af363cd1875cfda$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($1af363cd1875cfda$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $1af363cd1875cfda$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($1af363cd1875cfda$var$isPlainObject(result[key]) && $1af363cd1875cfda$var$isPlainObject(val)) result[key] = $1af363cd1875cfda$var$merge(result[key], val);
        else if ($1af363cd1875cfda$var$isPlainObject(val)) result[key] = $1af363cd1875cfda$var$merge({}, val);
        else if ($1af363cd1875cfda$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$1af363cd1875cfda$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $1af363cd1875cfda$var$extend(a, b, thisArg) {
    $1af363cd1875cfda$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $2gQiD(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $1af363cd1875cfda$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $1af363cd1875cfda$var$isArray,
    isArrayBuffer: $1af363cd1875cfda$var$isArrayBuffer,
    isBuffer: $1af363cd1875cfda$var$isBuffer,
    isFormData: $1af363cd1875cfda$var$isFormData,
    isArrayBufferView: $1af363cd1875cfda$var$isArrayBufferView,
    isString: $1af363cd1875cfda$var$isString,
    isNumber: $1af363cd1875cfda$var$isNumber,
    isObject: $1af363cd1875cfda$var$isObject,
    isPlainObject: $1af363cd1875cfda$var$isPlainObject,
    isUndefined: $1af363cd1875cfda$var$isUndefined,
    isDate: $1af363cd1875cfda$var$isDate,
    isFile: $1af363cd1875cfda$var$isFile,
    isBlob: $1af363cd1875cfda$var$isBlob,
    isFunction: $1af363cd1875cfda$var$isFunction,
    isStream: $1af363cd1875cfda$var$isStream,
    isURLSearchParams: $1af363cd1875cfda$var$isURLSearchParams,
    isStandardBrowserEnv: $1af363cd1875cfda$var$isStandardBrowserEnv,
    forEach: $1af363cd1875cfda$var$forEach,
    merge: $1af363cd1875cfda$var$merge,
    extend: $1af363cd1875cfda$var$extend,
    trim: $1af363cd1875cfda$var$trim,
    stripBOM: $1af363cd1875cfda$var$stripBOM
};

});
parcelRegister("2gQiD", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("kSNaY", function(module, exports) {
"use strict";

var $2jspb = parcelRequire("2jspb");

var $4XLC5 = parcelRequire("4XLC5");

var $31RnK = parcelRequire("31RnK");

var $1KbJg = parcelRequire("1KbJg");

var $jLKfw = parcelRequire("jLKfw");

var $aqfPt = parcelRequire("aqfPt");
var $f33eff22a8a6749a$var$validators = $aqfPt.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $f33eff22a8a6749a$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $31RnK(),
        response: new $31RnK()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $f33eff22a8a6749a$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $jLKfw(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $aqfPt.assertOptions(transitional, {
        silentJSONParsing: $f33eff22a8a6749a$var$validators.transitional($f33eff22a8a6749a$var$validators.boolean),
        forcedJSONParsing: $f33eff22a8a6749a$var$validators.transitional($f33eff22a8a6749a$var$validators.boolean),
        clarifyTimeoutError: $f33eff22a8a6749a$var$validators.transitional($f33eff22a8a6749a$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $1KbJg,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $1KbJg(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$f33eff22a8a6749a$var$Axios.prototype.getUri = function getUri(config) {
    config = $jLKfw(this.defaults, config);
    return $4XLC5(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$2jspb.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $f33eff22a8a6749a$var$Axios.prototype[method] = function(url, config) {
        return this.request($jLKfw(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$2jspb.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $f33eff22a8a6749a$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($jLKfw(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $f33eff22a8a6749a$var$Axios;

});
parcelRegister("4XLC5", function(module, exports) {
"use strict";

var $2jspb = parcelRequire("2jspb");
function $39d19b24009e9a2a$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($2jspb.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $2jspb.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($2jspb.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $2jspb.forEach(val, function parseValue(v) {
                if ($2jspb.isDate(v)) v = v.toISOString();
                else if ($2jspb.isObject(v)) v = JSON.stringify(v);
                parts.push($39d19b24009e9a2a$var$encode(key) + "=" + $39d19b24009e9a2a$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("31RnK", function(module, exports) {
"use strict";

var $2jspb = parcelRequire("2jspb");
function $234adfa3907a72d5$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $234adfa3907a72d5$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $234adfa3907a72d5$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $234adfa3907a72d5$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $2jspb.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $234adfa3907a72d5$var$InterceptorManager;

});

parcelRegister("1KbJg", function(module, exports) {
"use strict";

var $2jspb = parcelRequire("2jspb");

var $5uDwf = parcelRequire("5uDwf");

var $dByrq = parcelRequire("dByrq");

var $gk4S3 = parcelRequire("gk4S3");

var $8tFqz = parcelRequire("8tFqz");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $14532f71e3307534$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $8tFqz("canceled");
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $14532f71e3307534$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $5uDwf.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $2jspb.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $2jspb.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $gk4S3.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $14532f71e3307534$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $5uDwf.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$dByrq(reason)) {
            $14532f71e3307534$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $5uDwf.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("5uDwf", function(module, exports) {
"use strict";

var $2jspb = parcelRequire("2jspb");

var $gk4S3 = parcelRequire("gk4S3");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $gk4S3;
    /*eslint no-param-reassign:0*/ $2jspb.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("gk4S3", function(module, exports) {

var $4ZL0H = parcelRequire("4ZL0H");
"use strict";

var $2jspb = parcelRequire("2jspb");

var $kRp4s = parcelRequire("kRp4s");

var $bHXz4 = parcelRequire("bHXz4");
var $be224ad8c729ef64$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $be224ad8c729ef64$var$setContentTypeIfUnset(headers, value) {
    if (!$2jspb.isUndefined(headers) && $2jspb.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $be224ad8c729ef64$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("8SgMg"));
    else if (typeof $4ZL0H !== "undefined" && Object.prototype.toString.call($4ZL0H) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("8SgMg"));
    return adapter;
}
function $be224ad8c729ef64$var$stringifySafely(rawValue, parser, encoder) {
    if ($2jspb.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $2jspb.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $be224ad8c729ef64$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $be224ad8c729ef64$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $kRp4s(headers, "Accept");
            $kRp4s(headers, "Content-Type");
            if ($2jspb.isFormData(data) || $2jspb.isArrayBuffer(data) || $2jspb.isBuffer(data) || $2jspb.isStream(data) || $2jspb.isFile(data) || $2jspb.isBlob(data)) return data;
            if ($2jspb.isArrayBufferView(data)) return data.buffer;
            if ($2jspb.isURLSearchParams(data)) {
                $be224ad8c729ef64$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($2jspb.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $be224ad8c729ef64$var$setContentTypeIfUnset(headers, "application/json");
                return $be224ad8c729ef64$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $be224ad8c729ef64$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $2jspb.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $bHXz4(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
$2jspb.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $be224ad8c729ef64$var$defaults.headers[method] = {};
});
$2jspb.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $be224ad8c729ef64$var$defaults.headers[method] = $2jspb.merge($be224ad8c729ef64$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $be224ad8c729ef64$var$defaults;

});
parcelRegister("4ZL0H", function(module, exports) {
// shim for using process in browser
var $3a3153321729209f$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $3a3153321729209f$var$cachedSetTimeout;
var $3a3153321729209f$var$cachedClearTimeout;
function $3a3153321729209f$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $3a3153321729209f$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $3a3153321729209f$var$cachedSetTimeout = setTimeout;
        else $3a3153321729209f$var$cachedSetTimeout = $3a3153321729209f$var$defaultSetTimout;
    } catch (e) {
        $3a3153321729209f$var$cachedSetTimeout = $3a3153321729209f$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $3a3153321729209f$var$cachedClearTimeout = clearTimeout;
        else $3a3153321729209f$var$cachedClearTimeout = $3a3153321729209f$var$defaultClearTimeout;
    } catch (e) {
        $3a3153321729209f$var$cachedClearTimeout = $3a3153321729209f$var$defaultClearTimeout;
    }
})();
function $3a3153321729209f$var$runTimeout(fun) {
    if ($3a3153321729209f$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($3a3153321729209f$var$cachedSetTimeout === $3a3153321729209f$var$defaultSetTimout || !$3a3153321729209f$var$cachedSetTimeout) && setTimeout) {
        $3a3153321729209f$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3a3153321729209f$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3a3153321729209f$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3a3153321729209f$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3a3153321729209f$var$runClearTimeout(marker) {
    if ($3a3153321729209f$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($3a3153321729209f$var$cachedClearTimeout === $3a3153321729209f$var$defaultClearTimeout || !$3a3153321729209f$var$cachedClearTimeout) && clearTimeout) {
        $3a3153321729209f$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3a3153321729209f$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3a3153321729209f$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3a3153321729209f$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3a3153321729209f$var$queue = [];
var $3a3153321729209f$var$draining = false;
var $3a3153321729209f$var$currentQueue;
var $3a3153321729209f$var$queueIndex = -1;
function $3a3153321729209f$var$cleanUpNextTick() {
    if (!$3a3153321729209f$var$draining || !$3a3153321729209f$var$currentQueue) return;
    $3a3153321729209f$var$draining = false;
    if ($3a3153321729209f$var$currentQueue.length) $3a3153321729209f$var$queue = $3a3153321729209f$var$currentQueue.concat($3a3153321729209f$var$queue);
    else $3a3153321729209f$var$queueIndex = -1;
    if ($3a3153321729209f$var$queue.length) $3a3153321729209f$var$drainQueue();
}
function $3a3153321729209f$var$drainQueue() {
    if ($3a3153321729209f$var$draining) return;
    var timeout = $3a3153321729209f$var$runTimeout($3a3153321729209f$var$cleanUpNextTick);
    $3a3153321729209f$var$draining = true;
    var len = $3a3153321729209f$var$queue.length;
    while(len){
        $3a3153321729209f$var$currentQueue = $3a3153321729209f$var$queue;
        $3a3153321729209f$var$queue = [];
        while(++$3a3153321729209f$var$queueIndex < len)if ($3a3153321729209f$var$currentQueue) $3a3153321729209f$var$currentQueue[$3a3153321729209f$var$queueIndex].run();
        $3a3153321729209f$var$queueIndex = -1;
        len = $3a3153321729209f$var$queue.length;
    }
    $3a3153321729209f$var$currentQueue = null;
    $3a3153321729209f$var$draining = false;
    $3a3153321729209f$var$runClearTimeout(timeout);
}
$3a3153321729209f$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3a3153321729209f$var$queue.push(new $3a3153321729209f$var$Item(fun, args));
    if ($3a3153321729209f$var$queue.length === 1 && !$3a3153321729209f$var$draining) $3a3153321729209f$var$runTimeout($3a3153321729209f$var$drainQueue);
};
// v8 likes predictible objects
function $3a3153321729209f$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3a3153321729209f$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$3a3153321729209f$var$process.title = "browser";
$3a3153321729209f$var$process.browser = true;
$3a3153321729209f$var$process.env = {};
$3a3153321729209f$var$process.argv = [];
$3a3153321729209f$var$process.version = ""; // empty string to avoid regexp issues
$3a3153321729209f$var$process.versions = {};
function $3a3153321729209f$var$noop() {}
$3a3153321729209f$var$process.on = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.addListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.once = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.off = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.removeListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.removeAllListeners = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.emit = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.prependListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.prependOnceListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.listeners = function(name) {
    return [];
};
$3a3153321729209f$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$3a3153321729209f$var$process.cwd = function() {
    return "/";
};
$3a3153321729209f$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$3a3153321729209f$var$process.umask = function() {
    return 0;
};

});

parcelRegister("kRp4s", function(module, exports) {
"use strict";

var $2jspb = parcelRequire("2jspb");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $2jspb.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("bHXz4", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    };
    return error;
};

});

parcelRegister("8SgMg", function(module, exports) {
"use strict";

var $2jspb = parcelRequire("2jspb");

var $a7wmI = parcelRequire("a7wmI");

var $6GbSB = parcelRequire("6GbSB");

var $4XLC5 = parcelRequire("4XLC5");

var $5vcvc = parcelRequire("5vcvc");

var $U51bT = parcelRequire("U51bT");

var $eYJ32 = parcelRequire("eYJ32");

var $hmzXG = parcelRequire("hmzXG");

var $gk4S3 = parcelRequire("gk4S3");

var $8tFqz = parcelRequire("8tFqz");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ($2jspb.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $5vcvc(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $4XLC5(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $U51bT(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $a7wmI(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($hmzXG("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($hmzXG("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || $gk4S3.transitional;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($hmzXG(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($2jspb.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $eYJ32(fullPath)) && config.xsrfCookieName ? $6GbSB.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $2jspb.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$2jspb.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $8tFqz("canceled") : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("a7wmI", function(module, exports) {
"use strict";

var $hmzXG = parcelRequire("hmzXG");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($hmzXG("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("hmzXG", function(module, exports) {
"use strict";

var $bHXz4 = parcelRequire("bHXz4");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $bHXz4(error, config, code, request, response);
};

});


parcelRegister("6GbSB", function(module, exports) {
"use strict";

var $2jspb = parcelRequire("2jspb");
module.exports = $2jspb.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($2jspb.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($2jspb.isString(path)) cookie.push("path=" + path);
            if ($2jspb.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("5vcvc", function(module, exports) {
"use strict";

var $8JWyd = parcelRequire("8JWyd");

var $3DFe4 = parcelRequire("3DFe4");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$8JWyd(requestedURL)) return $3DFe4(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("8JWyd", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("3DFe4", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("U51bT", function(module, exports) {
"use strict";

var $2jspb = parcelRequire("2jspb");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $0a891f96b8e2d27f$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $2jspb.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $2jspb.trim(line.substr(0, i)).toLowerCase();
        val = $2jspb.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $0a891f96b8e2d27f$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("eYJ32", function(module, exports) {
"use strict";

var $2jspb = parcelRequire("2jspb");
module.exports = $2jspb.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $2jspb.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("8tFqz", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $62c12ad4bb2a08ad$var$Cancel(message) {
    this.message = message;
}
$62c12ad4bb2a08ad$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$62c12ad4bb2a08ad$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $62c12ad4bb2a08ad$var$Cancel;

});




parcelRegister("dByrq", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("jLKfw", function(module, exports) {
"use strict";

var $2jspb = parcelRequire("2jspb");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($2jspb.isPlainObject(target) && $2jspb.isPlainObject(source)) return $2jspb.merge(target, source);
        else if ($2jspb.isPlainObject(source)) return $2jspb.merge({}, source);
        else if ($2jspb.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$2jspb.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$2jspb.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$2jspb.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$2jspb.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$2jspb.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
    };
    $2jspb.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $2jspb.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("aqfPt", function(module, exports) {
"use strict";

var $bUKfL = parcelRequire("bUKfL");
var $79689c7473d4935e$require$VERSION = $bUKfL.version;
var $79689c7473d4935e$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $79689c7473d4935e$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $79689c7473d4935e$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $79689c7473d4935e$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + $79689c7473d4935e$require$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed" + (version ? " in " + version : "")));
        if (version && !$79689c7473d4935e$var$deprecatedWarnings[opt]) {
            $79689c7473d4935e$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $79689c7473d4935e$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    assertOptions: $79689c7473d4935e$var$assertOptions,
    validators: $79689c7473d4935e$var$validators
};

});
parcelRegister("bUKfL", function(module, exports) {
module.exports = {
    "version": "0.26.0"
};

});



parcelRegister("k1WYj", function(module, exports) {
"use strict";

var $8tFqz = parcelRequire("8tFqz");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $e951a53018d6ead4$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $8tFqz(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $e951a53018d6ead4$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $e951a53018d6ead4$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $e951a53018d6ead4$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $e951a53018d6ead4$var$CancelToken.source = function source() {
    var cancel;
    var token = new $e951a53018d6ead4$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $e951a53018d6ead4$var$CancelToken;

});

parcelRegister("hnisX", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("kIHL2", function(module, exports) {
"use strict";

var $2jspb = parcelRequire("2jspb");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $2jspb.isObject(payload) && payload.isAxiosError === true;
};

});


parcelRegister("2oXYc", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bfc5778dcd4841a$var$ReactIs, $1bfc5778dcd4841a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("iDep4"))();

});


var $7fPBF = parcelRequire("7fPBF");
var $f11ec298ebcca059$exports = {};

$parcel$export($f11ec298ebcca059$exports, "createRoot", function () { return $f11ec298ebcca059$export$882461b6382ed46c; }, function (v) { return $f11ec298ebcca059$export$882461b6382ed46c = v; });
$parcel$export($f11ec298ebcca059$exports, "hydrateRoot", function () { return $f11ec298ebcca059$export$757ceba2d55c277e; }, function (v) { return $f11ec298ebcca059$export$757ceba2d55c277e = v; });
var $f11ec298ebcca059$export$882461b6382ed46c;
var $f11ec298ebcca059$export$757ceba2d55c277e;
"use strict";

var $fw0lo = parcelRequire("fw0lo");
var $f11ec298ebcca059$var$i;
$f11ec298ebcca059$export$882461b6382ed46c = $fw0lo.createRoot;
$f11ec298ebcca059$export$757ceba2d55c277e = $fw0lo.hydrateRoot;




var $7fPBF = parcelRequire("7fPBF");
/**
 * React Router v6.18.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");
/**
 * @remix-run/router v1.11.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $55100129ab36ed65$var$_extends() {
    $55100129ab36ed65$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $55100129ab36ed65$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $55100129ab36ed65$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($55100129ab36ed65$export$e19cd5f9376f8cee || ($55100129ab36ed65$export$e19cd5f9376f8cee = {}));
const $55100129ab36ed65$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $55100129ab36ed65$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $55100129ab36ed65$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $55100129ab36ed65$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $55100129ab36ed65$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $55100129ab36ed65$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
    }
    return $55100129ab36ed65$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $55100129ab36ed65$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $55100129ab36ed65$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $55100129ab36ed65$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $55100129ab36ed65$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $55100129ab36ed65$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $55100129ab36ed65$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $55100129ab36ed65$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $55100129ab36ed65$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $55100129ab36ed65$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $55100129ab36ed65$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $55100129ab36ed65$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $55100129ab36ed65$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $55100129ab36ed65$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $55100129ab36ed65$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $55100129ab36ed65$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($55100129ab36ed65$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        let location = $55100129ab36ed65$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $55100129ab36ed65$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        let location = $55100129ab36ed65$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $55100129ab36ed65$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
        $55100129ab36ed65$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($55100129ab36ed65$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($55100129ab36ed65$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $55100129ab36ed65$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($55100129ab36ed65$var$ResultType || ($55100129ab36ed65$var$ResultType = {}));
const $55100129ab36ed65$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $55100129ab36ed65$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $55100129ab36ed65$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $55100129ab36ed65$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $55100129ab36ed65$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($55100129ab36ed65$var$isIndexRoute(route)) {
            let indexRoute = $55100129ab36ed65$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $55100129ab36ed65$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $55100129ab36ed65$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $55100129ab36ed65$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $55100129ab36ed65$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $55100129ab36ed65$var$flattenRoutes(routes);
    $55100129ab36ed65$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $55100129ab36ed65$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $55100129ab36ed65$var$safelyDecodeURI(pathname));
    return matches;
}
function $55100129ab36ed65$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $55100129ab36ed65$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $55100129ab36ed65$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $55100129ab36ed65$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $55100129ab36ed65$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $55100129ab36ed65$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $55100129ab36ed65$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $55100129ab36ed65$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $55100129ab36ed65$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $55100129ab36ed65$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $55100129ab36ed65$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $55100129ab36ed65$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $55100129ab36ed65$var$paramRe = /^:\w+$/;
const $55100129ab36ed65$var$dynamicSegmentValue = 3;
const $55100129ab36ed65$var$indexRouteValue = 2;
const $55100129ab36ed65$var$emptySegmentValue = 1;
const $55100129ab36ed65$var$staticSegmentValue = 10;
const $55100129ab36ed65$var$splatPenalty = -2;
const $55100129ab36ed65$var$isSplat = (s)=>s === "*";
function $55100129ab36ed65$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($55100129ab36ed65$var$isSplat)) initialScore += $55100129ab36ed65$var$splatPenalty;
    if (index) initialScore += $55100129ab36ed65$var$indexRouteValue;
    return segments.filter((s)=>!$55100129ab36ed65$var$isSplat(s)).reduce((score, segment)=>score + ($55100129ab36ed65$var$paramRe.test(segment) ? $55100129ab36ed65$var$dynamicSegmentValue : segment === "" ? $55100129ab36ed65$var$emptySegmentValue : $55100129ab36ed65$var$staticSegmentValue), initialScore);
}
function $55100129ab36ed65$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $55100129ab36ed65$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $55100129ab36ed65$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $55100129ab36ed65$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $55100129ab36ed65$export$a5c6d149b50c1d86($55100129ab36ed65$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $55100129ab36ed65$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $55100129ab36ed65$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $55100129ab36ed65$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $55100129ab36ed65$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $55100129ab36ed65$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $55100129ab36ed65$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = $55100129ab36ed65$var$safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $55100129ab36ed65$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $55100129ab36ed65$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $55100129ab36ed65$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $55100129ab36ed65$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $55100129ab36ed65$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $55100129ab36ed65$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $55100129ab36ed65$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $55100129ab36ed65$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $55100129ab36ed65$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $55100129ab36ed65$var$normalizeSearch(search),
        hash: $55100129ab36ed65$var$normalizeHash(hash)
    };
}
function $55100129ab36ed65$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $55100129ab36ed65$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $55100129ab36ed65$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $55100129ab36ed65$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $55100129ab36ed65$export$8ccf933b0513f8d0(toArg);
    else {
        to = $55100129ab36ed65$var$_extends({}, toArg);
        $55100129ab36ed65$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $55100129ab36ed65$var$getInvalidPathError("?", "pathname", "search", to));
        $55100129ab36ed65$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $55100129ab36ed65$var$getInvalidPathError("#", "pathname", "hash", to));
        $55100129ab36ed65$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $55100129ab36ed65$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $55100129ab36ed65$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $55100129ab36ed65$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $55100129ab36ed65$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $55100129ab36ed65$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $55100129ab36ed65$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $55100129ab36ed65$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $55100129ab36ed65$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $55100129ab36ed65$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $55100129ab36ed65$export$42a99a7a4bc0e76a extends Error {
}
class $55100129ab36ed65$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $55100129ab36ed65$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $55100129ab36ed65$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $55100129ab36ed65$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $55100129ab36ed65$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $55100129ab36ed65$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $55100129ab36ed65$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $55100129ab36ed65$var$unwrapTrackedPromise(value) {
    if (!$55100129ab36ed65$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $55100129ab36ed65$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $55100129ab36ed65$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $55100129ab36ed65$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $55100129ab36ed65$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $55100129ab36ed65$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $55100129ab36ed65$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $55100129ab36ed65$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $55100129ab36ed65$var$validMutationMethods = new Set($55100129ab36ed65$var$validMutationMethodsArr);
const $55100129ab36ed65$var$validRequestMethodsArr = [
    "get",
    ...$55100129ab36ed65$var$validMutationMethodsArr
];
const $55100129ab36ed65$var$validRequestMethods = new Set($55100129ab36ed65$var$validRequestMethodsArr);
const $55100129ab36ed65$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $55100129ab36ed65$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $55100129ab36ed65$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $55100129ab36ed65$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $55100129ab36ed65$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $55100129ab36ed65$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $55100129ab36ed65$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $55100129ab36ed65$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $55100129ab36ed65$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $55100129ab36ed65$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $55100129ab36ed65$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $55100129ab36ed65$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $55100129ab36ed65$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $55100129ab36ed65$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $55100129ab36ed65$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$55100129ab36ed65$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($55100129ab36ed65$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, viewTransitionOpts) {
        state = $55100129ab36ed65$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        subscribers.forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: viewTransitionOpts
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $55100129ab36ed65$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $55100129ab36ed65$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $55100129ab36ed65$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $55100129ab36ed65$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($55100129ab36ed65$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $55100129ab36ed65$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), viewTransitionOpts);
        // Reset stateful navigation vars
        pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $55100129ab36ed65$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $55100129ab36ed65$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $55100129ab36ed65$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $55100129ab36ed65$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $55100129ab36ed65$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $55100129ab36ed65$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $55100129ab36ed65$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $55100129ab36ed65$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $55100129ab36ed65$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$55100129ab36ed65$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $55100129ab36ed65$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $55100129ab36ed65$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $55100129ab36ed65$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $55100129ab36ed65$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $55100129ab36ed65$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $55100129ab36ed65$var$ResultType.error,
            error: $55100129ab36ed65$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $55100129ab36ed65$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($55100129ab36ed65$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($55100129ab36ed65$var$isDeferredResult(result)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $55100129ab36ed65$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $55100129ab36ed65$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $55100129ab36ed65$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $55100129ab36ed65$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $55100129ab36ed65$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($55100129ab36ed65$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $55100129ab36ed65$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $55100129ab36ed65$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $55100129ab36ed65$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $55100129ab36ed65$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $55100129ab36ed65$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $55100129ab36ed65$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $55100129ab36ed65$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $55100129ab36ed65$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $55100129ab36ed65$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (deletedFetchers.has(key)) {
            state.fetchers.set(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return;
        }
        if ($55100129ab36ed65$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                let loadingFetcher = $55100129ab36ed65$var$getLoadingFetcher(submission);
                state.fetchers.set(key, loadingFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return startRedirectNavigation(state, actionResult, {
                    fetcherSubmission: submission
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($55100129ab36ed65$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($55100129ab36ed65$var$isDeferredResult(actionResult)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $55100129ab36ed65$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $55100129ab36ed65$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $55100129ab36ed65$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $55100129ab36ed65$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $55100129ab36ed65$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $55100129ab36ed65$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $55100129ab36ed65$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $55100129ab36ed65$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $55100129ab36ed65$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $55100129ab36ed65$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($55100129ab36ed65$var$isDeferredResult(result)) result = await $55100129ab36ed65$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (deletedFetchers.has(key)) {
            state.fetchers.set(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($55100129ab36ed65$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $55100129ab36ed65$export$3e9cee6b33872309(!$55100129ab36ed65$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $55100129ab36ed65$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $55100129ab36ed65$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $55100129ab36ed65$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $55100129ab36ed65$export$e19cd5f9376f8cee.Replace : $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $55100129ab36ed65$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($55100129ab36ed65$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $55100129ab36ed65$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $55100129ab36ed65$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $55100129ab36ed65$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$55100129ab36ed65$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $55100129ab36ed65$var$callLoaderOrAction("loader", $55100129ab36ed65$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $55100129ab36ed65$var$ResultType.error,
                        error: $55100129ab36ed65$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $55100129ab36ed65$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $55100129ab36ed65$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $55100129ab36ed65$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $55100129ab36ed65$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $55100129ab36ed65$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $55100129ab36ed65$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $55100129ab36ed65$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $55100129ab36ed65$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $55100129ab36ed65$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $55100129ab36ed65$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$55100129ab36ed65$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $55100129ab36ed65$export$4d0306f8f6a4585b = Symbol("deferred");
function $55100129ab36ed65$export$3336b097a6fbc59a(routes, opts) {
    $55100129ab36ed65$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $55100129ab36ed65$var$defaultMapRouteProperties;
    let dataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $55100129ab36ed65$var$createLocation("", $55100129ab36ed65$export$fe53371bee54353d(url), null, "default");
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$55100129ab36ed65$var$isValidMethod(method) && method !== "HEAD") {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($55100129ab36ed65$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $55100129ab36ed65$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $55100129ab36ed65$var$createLocation("", $55100129ab36ed65$export$fe53371bee54353d(url), null, "default");
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$55100129ab36ed65$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $55100129ab36ed65$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $55100129ab36ed65$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $55100129ab36ed65$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($55100129ab36ed65$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$55100129ab36ed65$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $55100129ab36ed65$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($55100129ab36ed65$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $55100129ab36ed65$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $55100129ab36ed65$var$isResponse(result) ? result : $55100129ab36ed65$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($55100129ab36ed65$var$isQueryRouteResponse(e)) {
                if (e.type === $55100129ab36ed65$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($55100129ab36ed65$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $55100129ab36ed65$var$ResultType.error,
                error: error
            };
        } else {
            result = await $55100129ab36ed65$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($55100129ab36ed65$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($55100129ab36ed65$var$isDeferredResult(result)) {
            let error = $55100129ab36ed65$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $55100129ab36ed65$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($55100129ab36ed65$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $55100129ab36ed65$var$_extends({}, context, {
                statusCode: $55100129ab36ed65$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $55100129ab36ed65$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $55100129ab36ed65$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $55100129ab36ed65$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$55100129ab36ed65$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $55100129ab36ed65$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $55100129ab36ed65$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $55100129ab36ed65$export$fec11da027c70692(routes, context, error) {
    let newContext = $55100129ab36ed65$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $55100129ab36ed65$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $55100129ab36ed65$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $55100129ab36ed65$export$cae722b0cc860f13(to ? to : ".", $55100129ab36ed65$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $55100129ab36ed65$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$55100129ab36ed65$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $55100129ab36ed65$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $55100129ab36ed65$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $55100129ab36ed65$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$55100129ab36ed65$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$55100129ab36ed65$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $55100129ab36ed65$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $55100129ab36ed65$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $55100129ab36ed65$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$55100129ab36ed65$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$55100129ab36ed65$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $55100129ab36ed65$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $55100129ab36ed65$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $55100129ab36ed65$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($55100129ab36ed65$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $55100129ab36ed65$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $55100129ab36ed65$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $55100129ab36ed65$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $55100129ab36ed65$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($55100129ab36ed65$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $55100129ab36ed65$var$shouldRevalidateLoader(match, $55100129ab36ed65$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $55100129ab36ed65$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $55100129ab36ed65$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $55100129ab36ed65$var$shouldRevalidateLoader(fetcherMatch, $55100129ab36ed65$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $55100129ab36ed65$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $55100129ab36ed65$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $55100129ab36ed65$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $55100129ab36ed65$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $55100129ab36ed65$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $55100129ab36ed65$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$55100129ab36ed65$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $55100129ab36ed65$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $55100129ab36ed65$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $55100129ab36ed65$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $55100129ab36ed65$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $55100129ab36ed65$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $55100129ab36ed65$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $55100129ab36ed65$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $55100129ab36ed65$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($55100129ab36ed65$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($55100129ab36ed65$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $55100129ab36ed65$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) location = $55100129ab36ed65$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $55100129ab36ed65$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $55100129ab36ed65$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $55100129ab36ed65$var$ResultType.error ? $55100129ab36ed65$var$ResultType.error : $55100129ab36ed65$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $55100129ab36ed65$var$ResultType.error) return {
            type: resultType,
            error: new $55100129ab36ed65$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $55100129ab36ed65$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($55100129ab36ed65$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $55100129ab36ed65$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $55100129ab36ed65$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $55100129ab36ed65$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($55100129ab36ed65$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $55100129ab36ed65$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $55100129ab36ed65$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $55100129ab36ed65$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $55100129ab36ed65$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $55100129ab36ed65$export$3e9cee6b33872309(!$55100129ab36ed65$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $55100129ab36ed65$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($55100129ab36ed65$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $55100129ab36ed65$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $55100129ab36ed65$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($55100129ab36ed65$var$isErrorResult(result)) {
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $55100129ab36ed65$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($55100129ab36ed65$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $55100129ab36ed65$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($55100129ab36ed65$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $55100129ab36ed65$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $55100129ab36ed65$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $55100129ab36ed65$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $55100129ab36ed65$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $55100129ab36ed65$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $55100129ab36ed65$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $55100129ab36ed65$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $55100129ab36ed65$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($55100129ab36ed65$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $55100129ab36ed65$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(path) : path;
    return $55100129ab36ed65$export$fe53371bee54353d($55100129ab36ed65$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $55100129ab36ed65$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $55100129ab36ed65$var$isDeferredResult(result) {
    return result.type === $55100129ab36ed65$var$ResultType.deferred;
}
function $55100129ab36ed65$var$isErrorResult(result) {
    return result.type === $55100129ab36ed65$var$ResultType.error;
}
function $55100129ab36ed65$var$isRedirectResult(result) {
    return (result && result.type) === $55100129ab36ed65$var$ResultType.redirect;
}
function $55100129ab36ed65$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $55100129ab36ed65$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $55100129ab36ed65$var$isRedirectResponse(result) {
    if (!$55100129ab36ed65$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $55100129ab36ed65$var$isQueryRouteResponse(obj) {
    return obj && $55100129ab36ed65$var$isResponse(obj.response) && (obj.type === $55100129ab36ed65$var$ResultType.data || obj.type === $55100129ab36ed65$var$ResultType.error);
}
function $55100129ab36ed65$var$isValidMethod(method) {
    return $55100129ab36ed65$var$validRequestMethods.has(method.toLowerCase());
}
function $55100129ab36ed65$var$isMutationMethod(method) {
    return $55100129ab36ed65$var$validMutationMethods.has(method.toLowerCase());
}
async function $55100129ab36ed65$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$55100129ab36ed65$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($55100129ab36ed65$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $55100129ab36ed65$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $55100129ab36ed65$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $55100129ab36ed65$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $55100129ab36ed65$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $55100129ab36ed65$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $55100129ab36ed65$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $55100129ab36ed65$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $55100129ab36ed65$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $55100129ab36ed65$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $55100129ab36ed65$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $55100129ab36ed65$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $55100129ab36ed65$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $55100129ab36ed65$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $55100129ab36ed65$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $55100129ab36ed65$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $55100129ab36ed65$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $55100129ab36ed65$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}


function $d9fd026bfea79ab9$var$_extends() {
    $d9fd026bfea79ab9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d9fd026bfea79ab9$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $d9fd026bfea79ab9$export$3add0d5dce533e2e = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$145dfa71566a64dc = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$var$AwaitContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $d9fd026bfea79ab9$export$26749e8557646306 = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$c7914228fb69b0f5 = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$9072aa6dd1f93057 = /*#__PURE__*/ $7fPBF.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $d9fd026bfea79ab9$var$RouteErrorContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $d9fd026bfea79ab9$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $d9fd026bfea79ab9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $d9fd026bfea79ab9$export$9c954a9d03d32f4a() {
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $d9fd026bfea79ab9$export$45d76561a5302f2b() {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $d9fd026bfea79ab9$export$1b3f31771c5d07c() {
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $d9fd026bfea79ab9$export$6c330e8992e8a295(pattern) {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    return $7fPBF.useMemo(()=>(0, $55100129ab36ed65$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $d9fd026bfea79ab9$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $7fPBF.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $d9fd026bfea79ab9$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $d9fd026bfea79ab9$var$useNavigateStable() : $d9fd026bfea79ab9$var$useNavigateUnstable();
}
function $d9fd026bfea79ab9$var$useNavigateUnstable() {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let dataRouterContext = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $55100129ab36ed65$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $7fPBF.useRef(false);
    $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $55100129ab36ed65$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $d9fd026bfea79ab9$var$OutletContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $d9fd026bfea79ab9$export$4138103a3ae699cc() {
    return $7fPBF.useContext($d9fd026bfea79ab9$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $d9fd026bfea79ab9$export$a3be3530d8e40d0b(context) {
    let outlet = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $d9fd026bfea79ab9$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $d9fd026bfea79ab9$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $55100129ab36ed65$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $7fPBF.useMemo(()=>(0, $55100129ab36ed65$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $d9fd026bfea79ab9$export$5d3fca4a98652595(routes, locationArg) {
    return $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: parentMatches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $55100129ab36ed65$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $55100129ab36ed65$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $d9fd026bfea79ab9$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $55100129ab36ed65$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $d9fd026bfea79ab9$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $55100129ab36ed65$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $d9fd026bfea79ab9$var$DefaultErrorComponent() {
    let error = $d9fd026bfea79ab9$export$ed527bf60f6e05f2();
    let message = (0, $55100129ab36ed65$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $7fPBF.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $7fPBF.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $d9fd026bfea79ab9$var$defaultErrorElement = /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$DefaultErrorComponent, null);
class $d9fd026bfea79ab9$var$RenderErrorBoundary extends $7fPBF.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $d9fd026bfea79ab9$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $d9fd026bfea79ab9$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $d9fd026bfea79ab9$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $7fPBF.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $d9fd026bfea79ab9$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($d9fd026bfea79ab9$var$DataRouterHook || {});
var $d9fd026bfea79ab9$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($d9fd026bfea79ab9$var$DataRouterStateHook || {});
function $d9fd026bfea79ab9$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $d9fd026bfea79ab9$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    !ctx && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return ctx;
}
function $d9fd026bfea79ab9$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext($d9fd026bfea79ab9$export$145dfa71566a64dc);
    !state && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return state;
}
function $d9fd026bfea79ab9$var$useRouteContext(hookName) {
    let route = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    !route && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $d9fd026bfea79ab9$var$useCurrentRouteId(hookName) {
    let route = $d9fd026bfea79ab9$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $d9fd026bfea79ab9$export$5fc8298006ad9e58() {
    return $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $d9fd026bfea79ab9$export$d0fd4b7106de2769() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $d9fd026bfea79ab9$export$600dc272ed516c15() {
    let dataRouterContext = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseRevalidator);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRevalidator);
    return $7fPBF.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $d9fd026bfea79ab9$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseMatches);
    return $7fPBF.useMemo(()=>matches.map((m)=>(0, $55100129ab36ed65$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $d9fd026bfea79ab9$export$1448a5050d252c4d() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $d9fd026bfea79ab9$export$fd5d37484eab868d(routeId) {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $d9fd026bfea79ab9$export$fdc00f3f26066d5e() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseActionData);
    let route = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    !route && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $d9fd026bfea79ab9$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $7fPBF.useContext($d9fd026bfea79ab9$var$RouteErrorContext);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteError);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $d9fd026bfea79ab9$export$78a72ddb39bdd145() {
    let value = $7fPBF.useContext($d9fd026bfea79ab9$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $d9fd026bfea79ab9$export$17f53340677d5831() {
    let value = $7fPBF.useContext($d9fd026bfea79ab9$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $d9fd026bfea79ab9$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $d9fd026bfea79ab9$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseBlocker);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $7fPBF.useState("");
    let blockerFunction = $7fPBF.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $d9fd026bfea79ab9$var$_extends({}, currentLocation, {
                pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $d9fd026bfea79ab9$var$_extends({}, nextLocation, {
                pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $7fPBF.useEffect(()=>{
        let key = String(++$d9fd026bfea79ab9$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $7fPBF.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $55100129ab36ed65$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $d9fd026bfea79ab9$var$useNavigateStable() {
    let { router: router } = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseNavigateStable);
    let id = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $7fPBF.useRef(false);
    $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $d9fd026bfea79ab9$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $d9fd026bfea79ab9$var$alreadyWarned = {};
function $d9fd026bfea79ab9$var$warningOnce(key, cond, message) {
    if (!cond && !$d9fd026bfea79ab9$var$alreadyWarned[key]) $d9fd026bfea79ab9$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $d9fd026bfea79ab9$var$START_TRANSITION = "startTransition";
const $d9fd026bfea79ab9$var$startTransitionImpl = $7fPBF[$d9fd026bfea79ab9$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $d9fd026bfea79ab9$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7fPBF.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        if (v7_startTransition && $d9fd026bfea79ab9$var$startTransitionImpl) $d9fd026bfea79ab9$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $d9fd026bfea79ab9$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $d9fd026bfea79ab9$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $d9fd026bfea79ab9$var$startTransitionImpl ? $d9fd026bfea79ab9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $d9fd026bfea79ab9$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let navigate = $d9fd026bfea79ab9$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $55100129ab36ed65$export$cae722b0cc860f13)(to, (0, $55100129ab36ed65$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $7fPBF.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $d9fd026bfea79ab9$export$910ae8079b2c2852(props) {
    return $d9fd026bfea79ab9$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $d9fd026bfea79ab9$export$e7b0ac011bb776c6(_props) {
    (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $d9fd026bfea79ab9$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $55100129ab36ed65$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7fPBF.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $55100129ab36ed65$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $7fPBF.useMemo(()=>{
        let trailingPathname = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $d9fd026bfea79ab9$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $d9fd026bfea79ab9$export$5d3fca4a98652595($d9fd026bfea79ab9$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $d9fd026bfea79ab9$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$ResolveAwait, null, children));
}
var $d9fd026bfea79ab9$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($d9fd026bfea79ab9$var$AwaitRenderStatus || {});
const $d9fd026bfea79ab9$var$neverSettledPromise = new Promise(()=>{});
class $d9fd026bfea79ab9$var$AwaitErrorBoundary extends $7fPBF.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $d9fd026bfea79ab9$var$AwaitRenderStatus.error : promise._data !== undefined ? $d9fd026bfea79ab9$var$AwaitRenderStatus.success : $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error && promise._error instanceof (0, $55100129ab36ed65$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $d9fd026bfea79ab9$var$neverSettledPromise;
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $d9fd026bfea79ab9$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $d9fd026bfea79ab9$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $d9fd026bfea79ab9$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $7fPBF.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $7fPBF.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $d9fd026bfea79ab9$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $d9fd026bfea79ab9$export$e7b0ac011bb776c6) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $d9fd026bfea79ab9$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $d9fd026bfea79ab9$export$daf73786167a7f72(matches) {
    return $d9fd026bfea79ab9$var$_renderMatches(matches);
}
function $d9fd026bfea79ab9$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $7fPBF.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $7fPBF.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $d9fd026bfea79ab9$export$f30f7e456d254e83(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d9fd026bfea79ab9$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $d9fd026bfea79ab9$export$52b333d321859367
    }).initialize();
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Logging constants
var $d6ea3da750ca9f15$export$480ff6141d16ea0 = 26;
var $d6ea3da750ca9f15$export$b28184bf79b04783 = 1048576;
var $d6ea3da750ca9f15$export$a21f820c9933d674 = 256000;
var $d6ea3da750ca9f15$export$13470c6f1642bbce = "Logging";
var $d6ea3da750ca9f15$export$d781556e70493844 = "AWSCloudWatch";
var $d6ea3da750ca9f15$export$9a85ff898770a423 = "No credentials";
var $d6ea3da750ca9f15$export$569d67cd7966b708 = [
    "ResourceNotFoundException",
    "InvalidSequenceTokenException"
];


var $67f97941d33988c4$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $67f97941d33988c4$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $67f97941d33988c4$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $67f97941d33988c4$var$LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5
};
var $67f97941d33988c4$export$ee432113040024a6;
(function(LOG_TYPE) {
    LOG_TYPE["DEBUG"] = "DEBUG";
    LOG_TYPE["ERROR"] = "ERROR";
    LOG_TYPE["INFO"] = "INFO";
    LOG_TYPE["WARN"] = "WARN";
    LOG_TYPE["VERBOSE"] = "VERBOSE";
})($67f97941d33988c4$export$ee432113040024a6 || ($67f97941d33988c4$export$ee432113040024a6 = {}));
var $67f97941d33988c4$export$ba6a9c7ac8291f7f = /** @class */ function() {
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */ function ConsoleLogger(name, level) {
        if (level === void 0) level = $67f97941d33988c4$export$ee432113040024a6.WARN;
        this.name = name;
        this.level = level;
        this._pluggables = [];
    }
    ConsoleLogger.prototype._padding = function(n) {
        return n < 10 ? "0" + n : "" + n;
    };
    ConsoleLogger.prototype._ts = function() {
        var dt = new Date();
        return [
            this._padding(dt.getMinutes()),
            this._padding(dt.getSeconds())
        ].join(":") + "." + dt.getMilliseconds();
    };
    ConsoleLogger.prototype.configure = function(config) {
        if (!config) return this._config;
        this._config = config;
        return this._config;
    };
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {LOG_TYPE|string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype._log = function(type) {
        var e_1, _a;
        var msg = [];
        for(var _i = 1; _i < arguments.length; _i++)msg[_i - 1] = arguments[_i];
        var logger_level_name = this.level;
        if (ConsoleLogger.LOG_LEVEL) logger_level_name = ConsoleLogger.LOG_LEVEL;
        if (typeof window !== "undefined" && window.LOG_LEVEL) logger_level_name = window.LOG_LEVEL;
        var logger_level = $67f97941d33988c4$var$LOG_LEVELS[logger_level_name];
        var type_level = $67f97941d33988c4$var$LOG_LEVELS[type];
        if (!(type_level >= logger_level)) // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
        var log = console.log.bind(console);
        if (type === $67f97941d33988c4$export$ee432113040024a6.ERROR && console.error) log = console.error.bind(console);
        if (type === $67f97941d33988c4$export$ee432113040024a6.WARN && console.warn) log = console.warn.bind(console);
        var prefix = "[".concat(type, "] ").concat(this._ts(), " ").concat(this.name);
        var message = "";
        if (msg.length === 1 && typeof msg[0] === "string") {
            message = "".concat(prefix, " - ").concat(msg[0]);
            log(message);
        } else if (msg.length === 1) {
            message = "".concat(prefix, " ").concat(msg[0]);
            log(prefix, msg[0]);
        } else if (typeof msg[0] === "string") {
            var obj = msg.slice(1);
            if (obj.length === 1) obj = obj[0];
            message = "".concat(prefix, " - ").concat(msg[0], " ").concat(obj);
            log("".concat(prefix, " - ").concat(msg[0]), obj);
        } else {
            message = "".concat(prefix, " ").concat(msg);
            log(prefix, msg);
        }
        try {
            for(var _b = $67f97941d33988c4$var$__values(this._pluggables), _c = _b.next(); !_c.done; _c = _b.next()){
                var plugin = _c.value;
                var logEvent = {
                    message: message,
                    timestamp: Date.now()
                };
                plugin.pushLogs([
                    logEvent
                ]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.log = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $67f97941d33988c4$var$__spreadArray([
            $67f97941d33988c4$export$ee432113040024a6.INFO
        ], $67f97941d33988c4$var$__read(msg), false));
    };
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.info = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $67f97941d33988c4$var$__spreadArray([
            $67f97941d33988c4$export$ee432113040024a6.INFO
        ], $67f97941d33988c4$var$__read(msg), false));
    };
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.warn = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $67f97941d33988c4$var$__spreadArray([
            $67f97941d33988c4$export$ee432113040024a6.WARN
        ], $67f97941d33988c4$var$__read(msg), false));
    };
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.error = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $67f97941d33988c4$var$__spreadArray([
            $67f97941d33988c4$export$ee432113040024a6.ERROR
        ], $67f97941d33988c4$var$__read(msg), false));
    };
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.debug = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $67f97941d33988c4$var$__spreadArray([
            $67f97941d33988c4$export$ee432113040024a6.DEBUG
        ], $67f97941d33988c4$var$__read(msg), false));
    };
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.verbose = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $67f97941d33988c4$var$__spreadArray([
            $67f97941d33988c4$export$ee432113040024a6.VERBOSE
        ], $67f97941d33988c4$var$__read(msg), false));
    };
    ConsoleLogger.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategoryName() === (0, $d6ea3da750ca9f15$export$13470c6f1642bbce)) {
            this._pluggables.push(pluggable);
            pluggable.configure(this._config);
        }
    };
    ConsoleLogger.prototype.listPluggables = function() {
        return this._pluggables;
    };
    ConsoleLogger.LOG_LEVEL = null;
    return ConsoleLogger;
}();


var $6ff5c7c169206e21$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $6ff5c7c169206e21$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("Amplify");
var $6ff5c7c169206e21$export$b412d755cfa0136 = /** @class */ function() {
    function AmplifyClass() {
        // Everything that is `register`ed is tracked here
        this._components = [];
        this._config = {};
        // All modules (with `getModuleName()`) are stored here for dependency injection
        this._modules = {};
        // for backward compatibility to avoid breaking change
        // if someone is using like Amplify.Auth
        this.Auth = null;
        this.Analytics = null;
        this.API = null;
        this.Credentials = null;
        this.Storage = null;
        this.I18n = null;
        this.Cache = null;
        this.PubSub = null;
        this.Interactions = null;
        this.Pushnotification = null;
        this.UI = null;
        this.XR = null;
        this.Predictions = null;
        this.DataStore = null;
        this.Geo = null;
        this.Notifications = null;
        this.Logger = (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f);
        this.ServiceWorker = null;
    }
    AmplifyClass.prototype.register = function(comp) {
        $6ff5c7c169206e21$var$logger.debug("component registered in amplify", comp);
        this._components.push(comp);
        if (typeof comp.getModuleName === "function") {
            this._modules[comp.getModuleName()] = comp;
            this[comp.getModuleName()] = comp;
        } else $6ff5c7c169206e21$var$logger.debug("no getModuleName method for component", comp);
        // Finally configure this new component(category) loaded
        // With the new modularization changes in Amplify V3, all the Amplify
        // component are not loaded/registered right away but when they are
        // imported (and hence instantiated) in the client's app. This ensures
        // that all new components imported get correctly configured with the
        // configuration that Amplify.configure() was called with.
        comp.configure(this._config);
    };
    AmplifyClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config;
        this._config = Object.assign(this._config, config);
        $6ff5c7c169206e21$var$logger.debug("amplify config", this._config);
        // Dependency Injection via property-setting.
        // This avoids introducing a public method/interface/setter that's difficult to remove later.
        // Plus, it reduces `if` statements within the `constructor` and `configure` of each module
        Object.entries(this._modules).forEach(function(_a) {
            var _b = $6ff5c7c169206e21$var$__read(_a, 2), Name = _b[0], comp = _b[1];
            // e.g. Auth.*
            Object.keys(comp).forEach(function(property) {
                // e.g. Auth["Credentials"] = this._modules["Credentials"] when set
                if (_this._modules[property]) comp[property] = _this._modules[property];
            });
        });
        this._components.map(function(comp) {
            comp.configure(_this._config);
        });
        return this._config;
    };
    AmplifyClass.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable["getCategory"] && typeof pluggable["getCategory"] === "function") this._components.map(function(comp) {
            if (comp["addPluggable"] && typeof comp["addPluggable"] === "function") comp.addPluggable(pluggable);
        });
    };
    return AmplifyClass;
}();
var $6ff5c7c169206e21$export$a3858a9a153cffc7 = new $6ff5c7c169206e21$export$b412d755cfa0136();


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $58c96d580693cdce$export$638889172ebce0c4;
(function(Framework) {
    // < 100 - Web frameworks
    Framework["WebUnknown"] = "0";
    Framework["React"] = "1";
    Framework["NextJs"] = "2";
    Framework["Angular"] = "3";
    Framework["VueJs"] = "4";
    Framework["Nuxt"] = "5";
    Framework["Svelte"] = "6";
    // 100s - Server side frameworks
    Framework["ServerSideUnknown"] = "100";
    Framework["ReactSSR"] = "101";
    Framework["NextJsSSR"] = "102";
    Framework["AngularSSR"] = "103";
    Framework["VueJsSSR"] = "104";
    Framework["NuxtSSR"] = "105";
    Framework["SvelteSSR"] = "106";
    // 200s - Mobile framework
    Framework["ReactNative"] = "201";
    Framework["Expo"] = "202";
})($58c96d580693cdce$export$638889172ebce0c4 || ($58c96d580693cdce$export$638889172ebce0c4 = {}));
var $58c96d580693cdce$export$3a8840c5b2ecf003;
(function(Category) {
    Category["API"] = "api";
    Category["Auth"] = "auth";
    Category["Analytics"] = "analytics";
    Category["DataStore"] = "datastore";
    Category["Geo"] = "geo";
    Category["InAppMessaging"] = "inappmessaging";
    Category["Interactions"] = "interactions";
    Category["Predictions"] = "predictions";
    Category["PubSub"] = "pubsub";
    Category["PushNotification"] = "pushnotification";
    Category["Storage"] = "storage";
})($58c96d580693cdce$export$3a8840c5b2ecf003 || ($58c96d580693cdce$export$3a8840c5b2ecf003 = {}));
var $58c96d580693cdce$export$30c16f5c43437fd7;
(function(AnalyticsAction) {
    AnalyticsAction["Record"] = "1";
    AnalyticsAction["UpdateEndpoint"] = "2";
})($58c96d580693cdce$export$30c16f5c43437fd7 || ($58c96d580693cdce$export$30c16f5c43437fd7 = {}));
var $58c96d580693cdce$export$126e20fdc0f0d34b;
(function(ApiAction) {
    ApiAction["GraphQl"] = "1";
    ApiAction["Get"] = "2";
    ApiAction["Post"] = "3";
    ApiAction["Put"] = "4";
    ApiAction["Patch"] = "5";
    ApiAction["Del"] = "6";
    ApiAction["Head"] = "7";
})($58c96d580693cdce$export$126e20fdc0f0d34b || ($58c96d580693cdce$export$126e20fdc0f0d34b = {}));
var $58c96d580693cdce$export$900b1436d7e65f4;
(function(AuthAction) {
    // SignUp = '1',
    // ConfirmSignUp = '2',
    // ResendSignUp = '3',
    // SignIn = '4',
    // GetMFAOptions = '5',
    // GetPreferredMFA = '6',
    // SetPreferredMFA = '7',
    // DisableSMS = '8',
    // EnableSMS = '9',
    // SetupTOTP = '10',
    // VerifyTotpToken = '11',
    // ConfirmSignIn = '12',
    // CompleteNewPassword = '13',
    // SendCustomChallengeAnswer = '14',
    // DeleteUserAttributes = '15',
    // DeleteUser = '16',
    // UpdateUserAttributes = '17',
    // UserAttributes = '18',
    // CurrentUserPoolUser = '19',
    // CurrentAuthenticatedUser = '20',
    // CurrentSession = '21',
    // VerifyUserAttribute = '22',
    // VerifyUserAttributeSubmit = '23',
    // VerifyCurrentUserAttribute = '24',
    // VerifyCurrentUserAttributeSubmit = '25',
    // SignOut = '26',
    // ChangePassword = '27',
    // ForgotPassword = '28',
    // ForgotPasswordSubmit = '29',
    AuthAction["FederatedSignIn"] = "30";
// CurrentUserInfo = '31',
// RememberDevice = '32',
// ForgetDevice = '33',
// FetchDevices = '34',
})($58c96d580693cdce$export$900b1436d7e65f4 || ($58c96d580693cdce$export$900b1436d7e65f4 = {}));
var $58c96d580693cdce$export$2f5a715aba4cde93;
(function(DataStoreAction) {
    DataStoreAction["Subscribe"] = "1";
    DataStoreAction["GraphQl"] = "2";
})($58c96d580693cdce$export$2f5a715aba4cde93 || ($58c96d580693cdce$export$2f5a715aba4cde93 = {}));
var $58c96d580693cdce$export$afafab3eb8fc6fef;
(function(GeoAction) {
    GeoAction["None"] = "0";
})($58c96d580693cdce$export$afafab3eb8fc6fef || ($58c96d580693cdce$export$afafab3eb8fc6fef = {}));
var $58c96d580693cdce$export$c01a8c16ffda791e;
(function(InAppMessagingAction) {
    InAppMessagingAction["None"] = "0";
})($58c96d580693cdce$export$c01a8c16ffda791e || ($58c96d580693cdce$export$c01a8c16ffda791e = {}));
var $58c96d580693cdce$export$68e0695a774ab7fa;
(function(InteractionsAction) {
    InteractionsAction["None"] = "0";
})($58c96d580693cdce$export$68e0695a774ab7fa || ($58c96d580693cdce$export$68e0695a774ab7fa = {}));
var $58c96d580693cdce$export$aa89b4c447a07cee;
(function(PredictionsAction) {
    PredictionsAction["Convert"] = "1";
    PredictionsAction["Identify"] = "2";
    PredictionsAction["Interpret"] = "3";
})($58c96d580693cdce$export$aa89b4c447a07cee || ($58c96d580693cdce$export$aa89b4c447a07cee = {}));
var $58c96d580693cdce$export$ade48b30f1e78672;
(function(PubSubAction) {
    PubSubAction["Subscribe"] = "1";
})($58c96d580693cdce$export$ade48b30f1e78672 || ($58c96d580693cdce$export$ade48b30f1e78672 = {}));
var $58c96d580693cdce$export$2c5ee06ab9fa5040;
(function(PushNotificationAction) {
    PushNotificationAction["None"] = "0";
})($58c96d580693cdce$export$2c5ee06ab9fa5040 || ($58c96d580693cdce$export$2c5ee06ab9fa5040 = {}));
var $58c96d580693cdce$export$d4f3c54b808b00ce;
(function(StorageAction) {
    StorageAction["Put"] = "1";
    StorageAction["Get"] = "2";
    StorageAction["List"] = "3";
    StorageAction["Copy"] = "4";
    StorageAction["Remove"] = "5";
    StorageAction["GetProperties"] = "6";
})($58c96d580693cdce$export$d4f3c54b808b00ce || ($58c96d580693cdce$export$d4f3c54b808b00ce = {}));


// generated by genversion
var $5fb670f7cfe5ce44$export$83d89fbfd8236492 = "5.3.11";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $4ZL0H = parcelRequire("4ZL0H");
var $1db37af8e35e2a81$export$a15eed0e463030a9 = function() {
    return typeof $parcel$global !== "undefined";
};
var $1db37af8e35e2a81$export$a5e7eb32e5221222 = function() {
    return typeof globalThis !== "undefined";
};
var $1db37af8e35e2a81$export$daba2802a1a41c1f = function() {
    return typeof window !== "undefined";
};
var $1db37af8e35e2a81$export$b949ebcb877faa59 = function() {
    return typeof document !== "undefined";
};
var $1db37af8e35e2a81$export$ba10401363d0f7f6 = function() {
    return typeof $4ZL0H !== "undefined";
};
var $1db37af8e35e2a81$export$252f88727cff70c7 = function(object, prefix) {
    return !!Object.keys(object).find(function(key) {
        return key.startsWith(prefix);
    });
};



var $4ZL0H = parcelRequire("4ZL0H");
function $e2f2ada3d44c3589$export$ba3f37c54f0f7805() {
    var elementKeyPrefixedWithReact = function(key) {
        return key.startsWith("_react") || key.startsWith("__react");
    };
    var elementIsReactEnabled = function(element) {
        return Object.keys(element).find(elementKeyPrefixedWithReact);
    };
    var allElementsWithId = function() {
        return Array.from(document.querySelectorAll("[id]"));
    };
    return (0, $1db37af8e35e2a81$export$b949ebcb877faa59)() && allElementsWithId().some(elementIsReactEnabled);
}
function $e2f2ada3d44c3589$export$86269c582305790() {
    return (0, $1db37af8e35e2a81$export$ba10401363d0f7f6)() && typeof $4ZL0H.env !== "undefined" && !!Object.keys($4ZL0H.env).find(function(key) {
        return key.includes("react");
    });
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $1f7686f88f92e6b2$export$d91d90d62b78936d() {
    return (0, $1db37af8e35e2a81$export$daba2802a1a41c1f)() && (0, $1db37af8e35e2a81$export$252f88727cff70c7)(window, "__VUE");
}
function $1f7686f88f92e6b2$export$257a4c0f8294a101() {
    return (0, $1db37af8e35e2a81$export$a15eed0e463030a9)() && (0, $1db37af8e35e2a81$export$252f88727cff70c7)($parcel$global, "__VUE");
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $4ZL0H = parcelRequire("4ZL0H");
function $08c1ee461c51bc9c$export$6dafc32a94edaed3() {
    return (0, $1db37af8e35e2a81$export$daba2802a1a41c1f)() && (0, $1db37af8e35e2a81$export$252f88727cff70c7)(window, "__SVELTE");
}
function $08c1ee461c51bc9c$export$819dcb7fe144d8b0() {
    return (0, $1db37af8e35e2a81$export$ba10401363d0f7f6)() && typeof $4ZL0H.env !== "undefined" && !!Object.keys($4ZL0H.env).find(function(key) {
        return key.includes("svelte");
    });
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $50cf570577672103$export$f8462bcf03110eff() {
    // @ts-ignore
    return (0, $1db37af8e35e2a81$export$daba2802a1a41c1f)() && window["next"] && typeof window["next"] === "object";
}
function $50cf570577672103$export$61c08ed144a5d4ca() {
    return (0, $1db37af8e35e2a81$export$a15eed0e463030a9)() && ((0, $1db37af8e35e2a81$export$252f88727cff70c7)($parcel$global, "__next") || (0, $1db37af8e35e2a81$export$252f88727cff70c7)($parcel$global, "__NEXT"));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $f97f47802d0e39ff$export$bed54a4e6d9d25fb() {
    return (0, $1db37af8e35e2a81$export$daba2802a1a41c1f)() && // @ts-ignore
    (window["__NUXT__"] !== undefined || window["$nuxt"] !== undefined);
}
function $f97f47802d0e39ff$export$fb3ce982948d27e8() {
    // @ts-ignore
    return (0, $1db37af8e35e2a81$export$a15eed0e463030a9)() && typeof $parcel$global["__NUXT_PATHS__"] !== "undefined";
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $4ZL0H = parcelRequire("4ZL0H");
function $dfe0bb3daaae0033$export$b5a20bd39eb02ba0() {
    var angularVersionSetInDocument = Boolean((0, $1db37af8e35e2a81$export$b949ebcb877faa59)() && document.querySelector("[ng-version]"));
    var angularContentSetInWindow = Boolean(// @ts-ignore
    (0, $1db37af8e35e2a81$export$daba2802a1a41c1f)() && typeof window["ng"] !== "undefined");
    return angularVersionSetInDocument || angularContentSetInWindow;
}
function $dfe0bb3daaae0033$export$8ab518c8987c870f() {
    var _a;
    return (0, $1db37af8e35e2a81$export$ba10401363d0f7f6)() && typeof $4ZL0H.env === "object" && ((_a = undefined, _a === void 0) ? void 0 : _a.startsWith("ng ")) || false;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react-native 0.17.7
function $bd02bf0993a8d7b5$export$1c8414c1859e3748() {
    return typeof navigator !== "undefined" && typeof navigator.product !== "undefined" && navigator.product === "ReactNative";
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $5585635492c0ce73$export$85fd46d5e29a4f7e() {
    // @ts-ignore
    return (0, $1db37af8e35e2a81$export$a15eed0e463030a9)() && typeof $parcel$global["expo"] !== "undefined";
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $48d4ef85a3e93658$export$41b1270b988065fb() {
    return (0, $1db37af8e35e2a81$export$daba2802a1a41c1f)();
}


// These are in the order of detection where when both are detectable, the early Framework will be reported
var $f2e510f83a6ae1b5$var$detectionMap = [
    // First, detect mobile
    {
        platform: (0, $58c96d580693cdce$export$638889172ebce0c4).Expo,
        detectionMethod: (0, $5585635492c0ce73$export$85fd46d5e29a4f7e)
    },
    {
        platform: (0, $58c96d580693cdce$export$638889172ebce0c4).ReactNative,
        detectionMethod: (0, $bd02bf0993a8d7b5$export$1c8414c1859e3748)
    },
    // Next, detect web frameworks
    {
        platform: (0, $58c96d580693cdce$export$638889172ebce0c4).NextJs,
        detectionMethod: (0, $50cf570577672103$export$f8462bcf03110eff)
    },
    {
        platform: (0, $58c96d580693cdce$export$638889172ebce0c4).Nuxt,
        detectionMethod: (0, $f97f47802d0e39ff$export$bed54a4e6d9d25fb)
    },
    {
        platform: (0, $58c96d580693cdce$export$638889172ebce0c4).Angular,
        detectionMethod: (0, $dfe0bb3daaae0033$export$b5a20bd39eb02ba0)
    },
    {
        platform: (0, $58c96d580693cdce$export$638889172ebce0c4).React,
        detectionMethod: (0, $e2f2ada3d44c3589$export$ba3f37c54f0f7805)
    },
    {
        platform: (0, $58c96d580693cdce$export$638889172ebce0c4).VueJs,
        detectionMethod: (0, $1f7686f88f92e6b2$export$d91d90d62b78936d)
    },
    {
        platform: (0, $58c96d580693cdce$export$638889172ebce0c4).Svelte,
        detectionMethod: (0, $08c1ee461c51bc9c$export$6dafc32a94edaed3)
    },
    {
        platform: (0, $58c96d580693cdce$export$638889172ebce0c4).WebUnknown,
        detectionMethod: (0, $48d4ef85a3e93658$export$41b1270b988065fb)
    },
    // Last, detect ssr frameworks
    {
        platform: (0, $58c96d580693cdce$export$638889172ebce0c4).NextJsSSR,
        detectionMethod: (0, $50cf570577672103$export$61c08ed144a5d4ca)
    },
    {
        platform: (0, $58c96d580693cdce$export$638889172ebce0c4).NuxtSSR,
        detectionMethod: (0, $f97f47802d0e39ff$export$fb3ce982948d27e8)
    },
    {
        platform: (0, $58c96d580693cdce$export$638889172ebce0c4).ReactSSR,
        detectionMethod: (0, $e2f2ada3d44c3589$export$86269c582305790)
    },
    {
        platform: (0, $58c96d580693cdce$export$638889172ebce0c4).VueJsSSR,
        detectionMethod: (0, $1f7686f88f92e6b2$export$257a4c0f8294a101)
    },
    {
        platform: (0, $58c96d580693cdce$export$638889172ebce0c4).AngularSSR,
        detectionMethod: (0, $dfe0bb3daaae0033$export$8ab518c8987c870f)
    },
    {
        platform: (0, $58c96d580693cdce$export$638889172ebce0c4).SvelteSSR,
        detectionMethod: (0, $08c1ee461c51bc9c$export$819dcb7fe144d8b0)
    }
];
function $f2e510f83a6ae1b5$export$17b446b869dad473() {
    var _a;
    return ((_a = $f2e510f83a6ae1b5$var$detectionMap.find(function(detectionEntry) {
        return detectionEntry.detectionMethod();
    })) === null || _a === void 0 ? void 0 : _a.platform) || (0, $58c96d580693cdce$export$638889172ebce0c4).ServerSideUnknown;
}


// We want to cache detection since the framework won't change
var $cd82d9b57ae46de9$var$frameworkCache;
var $cd82d9b57ae46de9$export$d56891f33aa26edc = [];
// Setup the detection reset tracking / timeout delays
var $cd82d9b57ae46de9$var$resetTriggered = false;
var $cd82d9b57ae46de9$var$SSR_RESET_TIMEOUT = 10; // ms
var $cd82d9b57ae46de9$var$WEB_RESET_TIMEOUT = 10; // ms
var $cd82d9b57ae46de9$var$PRIME_FRAMEWORK_DELAY = 1000; // ms
var $cd82d9b57ae46de9$export$9ce73e459ec93b6a = function() {
    if (!$cd82d9b57ae46de9$var$frameworkCache) {
        $cd82d9b57ae46de9$var$frameworkCache = (0, $f2e510f83a6ae1b5$export$17b446b869dad473)();
        if ($cd82d9b57ae46de9$var$resetTriggered) // The final run of detectFramework:
        // Starting from this point, the `frameworkCache` becomes "final".
        // So we don't need to notify the observers again so the observer
        // can be removed after the final notice.
        while($cd82d9b57ae46de9$export$d56891f33aa26edc.length)$cd82d9b57ae46de9$export$d56891f33aa26edc.pop()();
        else // The first run of detectFramework:
        // Every time we update the cache, call each observer function
        $cd82d9b57ae46de9$export$d56891f33aa26edc.forEach(function(fcn) {
            return fcn();
        });
        // Retry once for either Unknown type after a delay (explained below)
        $cd82d9b57ae46de9$var$resetTimeout((0, $58c96d580693cdce$export$638889172ebce0c4).ServerSideUnknown, $cd82d9b57ae46de9$var$SSR_RESET_TIMEOUT);
        $cd82d9b57ae46de9$var$resetTimeout((0, $58c96d580693cdce$export$638889172ebce0c4).WebUnknown, $cd82d9b57ae46de9$var$WEB_RESET_TIMEOUT);
    }
    return $cd82d9b57ae46de9$var$frameworkCache;
};
var $cd82d9b57ae46de9$export$5d5c467ce0b213f = function(fcn) {
    // When the `frameworkCache` won't be updated again, we ignore all incoming
    // observers.
    if ($cd82d9b57ae46de9$var$resetTriggered) return;
    $cd82d9b57ae46de9$export$d56891f33aa26edc.push(fcn);
};
function $cd82d9b57ae46de9$export$d2adf65b87e47523() {
    $cd82d9b57ae46de9$var$frameworkCache = undefined;
}
// For a framework type and a delay amount, setup the event to re-detect
//   During the runtime boot, it is possible that framework detection will
//   be triggered before the framework has made modifications to the
//   global/window/etc needed for detection. When no framework is detected
//   we will reset and try again to ensure we don't use a cached
//   non-framework detection result for all requests.
function $cd82d9b57ae46de9$var$resetTimeout(framework, delay) {
    if ($cd82d9b57ae46de9$var$frameworkCache === framework && !$cd82d9b57ae46de9$var$resetTriggered) setTimeout(function() {
        $cd82d9b57ae46de9$export$d2adf65b87e47523();
        $cd82d9b57ae46de9$var$resetTriggered = true;
        setTimeout($cd82d9b57ae46de9$export$9ce73e459ec93b6a, $cd82d9b57ae46de9$var$PRIME_FRAMEWORK_DELAY);
    }, delay);
}


var $0d25e50bf44b1a9b$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $0d25e50bf44b1a9b$var$BASE_USER_AGENT = "aws-amplify";
var $0d25e50bf44b1a9b$var$PlatformBuilder = /** @class */ function() {
    function PlatformBuilder() {
        this.userAgent = "".concat($0d25e50bf44b1a9b$var$BASE_USER_AGENT, "/").concat((0, $5fb670f7cfe5ce44$export$83d89fbfd8236492));
    }
    Object.defineProperty(PlatformBuilder.prototype, "framework", {
        get: function() {
            return (0, $cd82d9b57ae46de9$export$9ce73e459ec93b6a)();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlatformBuilder.prototype, "isReactNative", {
        get: function() {
            return this.framework === (0, $58c96d580693cdce$export$638889172ebce0c4).ReactNative || this.framework === (0, $58c96d580693cdce$export$638889172ebce0c4).Expo;
        },
        enumerable: false,
        configurable: true
    });
    PlatformBuilder.prototype.observeFrameworkChanges = function(fcn) {
        (0, $cd82d9b57ae46de9$export$5d5c467ce0b213f)(fcn);
    };
    return PlatformBuilder;
}();
var $0d25e50bf44b1a9b$export$2dffd0b5373a4389 = new $0d25e50bf44b1a9b$var$PlatformBuilder();
var $0d25e50bf44b1a9b$export$7d201307d8979e21 = function(_a) {
    var _b = _a === void 0 ? {} : _a, category = _b.category, action = _b.action, framework = _b.framework;
    var userAgent = [
        [
            $0d25e50bf44b1a9b$var$BASE_USER_AGENT,
            (0, $5fb670f7cfe5ce44$export$83d89fbfd8236492)
        ]
    ];
    if (category) userAgent.push([
        category,
        action
    ]);
    userAgent.push([
        "framework",
        (0, $cd82d9b57ae46de9$export$9ce73e459ec93b6a)()
    ]);
    return userAgent;
};
var $0d25e50bf44b1a9b$export$ede38edb26c0bfdf = function(customUserAgentDetails) {
    var userAgent = $0d25e50bf44b1a9b$export$7d201307d8979e21(customUserAgentDetails);
    var userAgentString = userAgent.map(function(_a) {
        var _b = $0d25e50bf44b1a9b$var$__read(_a, 2), agentKey = _b[0], agentValue = _b[1];
        return "".concat(agentKey, "/").concat(agentValue);
    }).join(" ");
    return userAgentString;
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $3b4d9bb645fe011c$var$__assign = undefined && undefined.__assign || function() {
    $3b4d9bb645fe011c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3b4d9bb645fe011c$var$__assign.apply(this, arguments);
};
var $3b4d9bb645fe011c$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $3b4d9bb645fe011c$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $3b4d9bb645fe011c$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("Hub");
var $3b4d9bb645fe011c$var$AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
function $3b4d9bb645fe011c$var$isLegacyCallback(callback) {
    return callback.onHubCapsule !== undefined;
}
var $3b4d9bb645fe011c$export$6b38ef2be9abbbb9 = /** @class */ function() {
    function HubClass(name) {
        this.listeners = [];
        this.patterns = [];
        this.protectedChannels = [
            "core",
            "auth",
            "api",
            "analytics",
            "interactions",
            "pubsub",
            "storage",
            "ui",
            "xr"
        ];
        this.name = name;
    }
    /**
     * Used internally to remove a Hub listener.
     *
     * @remarks
     * This private method is for internal use only. Instead of calling Hub.remove, call the result of Hub.listen.
     */ HubClass.prototype._remove = function(channel, listener) {
        if (channel instanceof RegExp) {
            var pattern_1 = this.patterns.find(function(_a) {
                var pattern = _a.pattern;
                return pattern.source === channel.source;
            });
            if (!pattern_1) {
                $3b4d9bb645fe011c$var$logger.warn("No listeners for ".concat(channel));
                return;
            }
            this.patterns = $3b4d9bb645fe011c$var$__spreadArray([], $3b4d9bb645fe011c$var$__read(this.patterns.filter(function(x) {
                return x !== pattern_1;
            })), false);
        } else {
            var holder = this.listeners[channel];
            if (!holder) {
                $3b4d9bb645fe011c$var$logger.warn("No listeners for ".concat(channel));
                return;
            }
            this.listeners[channel] = $3b4d9bb645fe011c$var$__spreadArray([], $3b4d9bb645fe011c$var$__read(holder.filter(function(_a) {
                var callback = _a.callback;
                return callback !== listener;
            })), false);
        }
    };
    /**
     * @deprecated Instead of calling Hub.remove, call the result of Hub.listen.
     */ HubClass.prototype.remove = function(channel, listener) {
        this._remove(channel, listener);
    };
    /**
     * Used to send a Hub event.
     *
     * @param channel - The channel on which the event will be broadcast
     * @param payload - The HubPayload
     * @param source  - The source of the event; defaults to ''
     * @param ampSymbol - Symbol used to determine if the event is dispatched internally on a protected channel
     *
     */ HubClass.prototype.dispatch = function(channel, payload, source, ampSymbol) {
        if (source === void 0) source = "";
        if (this.protectedChannels.indexOf(channel) > -1) {
            var hasAccess = ampSymbol === $3b4d9bb645fe011c$var$AMPLIFY_SYMBOL;
            if (!hasAccess) $3b4d9bb645fe011c$var$logger.warn("WARNING: ".concat(channel, " is protected and dispatching on it can have unintended consequences"));
        }
        var capsule = {
            channel: channel,
            payload: $3b4d9bb645fe011c$var$__assign({}, payload),
            source: source,
            patternInfo: []
        };
        try {
            this._toListeners(capsule);
        } catch (e) {
            $3b4d9bb645fe011c$var$logger.error(e);
        }
    };
    /**
     * Used to listen for Hub events.
     *
     * @param channel - The channel on which to listen
     * @param callback - The callback to execute when an event is received on the specified channel
     * @param listenerName - The name of the listener; defaults to 'noname'
     * @returns A function which can be called to cancel the listener.
     *
     */ HubClass.prototype.listen = function(channel, callback, listenerName) {
        var _this = this;
        if (listenerName === void 0) listenerName = "noname";
        var cb;
        // Check for legacy onHubCapsule callback for backwards compatability
        if ($3b4d9bb645fe011c$var$isLegacyCallback(callback)) {
            $3b4d9bb645fe011c$var$logger.warn("WARNING onHubCapsule is Deprecated. Please pass in a callback.");
            cb = callback.onHubCapsule.bind(callback);
        } else if (typeof callback !== "function") throw new Error("No callback supplied to Hub");
        else cb = callback;
        if (channel instanceof RegExp) this.patterns.push({
            pattern: channel,
            callback: cb
        });
        else {
            var holder = this.listeners[channel];
            if (!holder) {
                holder = [];
                this.listeners[channel] = holder;
            }
            holder.push({
                name: listenerName,
                callback: cb
            });
        }
        return function() {
            _this._remove(channel, cb);
        };
    };
    HubClass.prototype._toListeners = function(capsule) {
        var channel = capsule.channel, payload = capsule.payload;
        var holder = this.listeners[channel];
        if (holder) holder.forEach(function(listener) {
            $3b4d9bb645fe011c$var$logger.debug("Dispatching to ".concat(channel, " with "), payload);
            try {
                listener.callback(capsule);
            } catch (e) {
                $3b4d9bb645fe011c$var$logger.error(e);
            }
        });
        if (this.patterns.length > 0) {
            if (!payload.message) {
                $3b4d9bb645fe011c$var$logger.warn("Cannot perform pattern matching without a message key");
                return;
            }
            var payloadStr_1 = payload.message;
            this.patterns.forEach(function(pattern) {
                var match = payloadStr_1.match(pattern.pattern);
                if (match) {
                    var _a = $3b4d9bb645fe011c$var$__read(match), groups = _a.slice(1);
                    var dispatchingCapsule = $3b4d9bb645fe011c$var$__assign($3b4d9bb645fe011c$var$__assign({}, capsule), {
                        patternInfo: groups
                    });
                    try {
                        pattern.callback(dispatchingCapsule);
                    } catch (e) {
                        $3b4d9bb645fe011c$var$logger.error(e);
                    }
                }
            });
        }
    };
    return HubClass;
}();
var $3b4d9bb645fe011c$export$8c41bb232f1008b1 = new $3b4d9bb645fe011c$export$6b38ef2be9abbbb9("__default__");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $0d43ad65926e19b2$var$__assign = undefined && undefined.__assign || function() {
    $0d43ad65926e19b2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0d43ad65926e19b2$var$__assign.apply(this, arguments);
};
var $0d43ad65926e19b2$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("I18n");
/**
 * Language transition class
 */ var $0d43ad65926e19b2$export$dbe3113d60765c1a = /** @class */ function() {
    /**
     * @constructor
     * Initialize with configurations
     * @param {Object} options
     */ function I18n(options) {
        /**
         * @private
         */ this._options = null;
        /**
         * @private
         */ this._lang = null;
        /**
         * @private
         */ this._dict = {};
        this._options = Object.assign({}, options);
        this._lang = this._options.language;
        if (!this._lang && typeof window !== "undefined" && window && window.navigator) this._lang = window.navigator.language;
        $0d43ad65926e19b2$var$logger.debug(this._lang);
    }
    /**
     * @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.prototype.setLanguage = function(lang) {
        this._lang = lang;
    };
    /**
     * @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.prototype.get = function(key, defVal) {
        if (defVal === void 0) defVal = undefined;
        if (!this._lang) return typeof defVal !== "undefined" ? defVal : key;
        var lang = this._lang;
        var val = this.getByLanguage(key, lang);
        if (val) return val;
        if (lang.indexOf("-") > 0) val = this.getByLanguage(key, lang.split("-")[0]);
        if (val) return val;
        return typeof defVal !== "undefined" ? defVal : key;
    };
    /**
     * @method
     * Get value according to specified language
     * @param {String} key
     * @param {String} language - Specified langurage to be used
     * @param {String} defVal - Default value
     */ I18n.prototype.getByLanguage = function(key, language, defVal) {
        if (defVal === void 0) defVal = null;
        if (!language) return defVal;
        var lang_dict = this._dict[language];
        if (!lang_dict) return defVal;
        return lang_dict[key];
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {String} language - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.prototype.putVocabulariesForLanguage = function(language, vocabularies) {
        var lang_dict = this._dict[language];
        if (!lang_dict) lang_dict = this._dict[language] = {};
        this._dict[language] = $0d43ad65926e19b2$var$__assign($0d43ad65926e19b2$var$__assign({}, lang_dict), vocabularies);
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.prototype.putVocabularies = function(vocabularies) {
        var _this = this;
        Object.keys(vocabularies).map(function(key) {
            _this.putVocabulariesForLanguage(key, vocabularies[key]);
        });
    };
    return I18n;
}();




var $459a018ad4c4e88a$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("I18n");
var $459a018ad4c4e88a$var$_config = null;
var $459a018ad4c4e88a$var$_i18n = null;
/**
 * Export I18n APIs
 */ var $459a018ad4c4e88a$export$dbe3113d60765c1a = /** @class */ function() {
    function I18n() {}
    /**
     * @static
     * @method
     * Configure I18n part
     * @param {Object} config - Configuration of the I18n
     */ I18n.configure = function(config) {
        $459a018ad4c4e88a$var$logger.debug("configure I18n");
        if (!config) return $459a018ad4c4e88a$var$_config;
        $459a018ad4c4e88a$var$_config = Object.assign({}, $459a018ad4c4e88a$var$_config, config.I18n || config);
        I18n.createInstance();
        return $459a018ad4c4e88a$var$_config;
    };
    I18n.getModuleName = function() {
        return "I18n";
    };
    /**
     * @static
     * @method
     * Create an instance of I18n for the library
     */ I18n.createInstance = function() {
        $459a018ad4c4e88a$var$logger.debug("create I18n instance");
        if ($459a018ad4c4e88a$var$_i18n) return;
        $459a018ad4c4e88a$var$_i18n = new (0, $0d43ad65926e19b2$export$dbe3113d60765c1a)($459a018ad4c4e88a$var$_config);
    };
    /**
     * @static @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.setLanguage = function(lang) {
        I18n.checkConfig();
        return $459a018ad4c4e88a$var$_i18n.setLanguage(lang);
    };
    /**
     * @static @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.get = function(key, defVal) {
        if (!I18n.checkConfig()) return typeof defVal === "undefined" ? key : defVal;
        return $459a018ad4c4e88a$var$_i18n.get(key, defVal);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {String} langurage - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.putVocabulariesForLanguage = function(language, vocabularies) {
        I18n.checkConfig();
        return $459a018ad4c4e88a$var$_i18n.putVocabulariesForLanguage(language, vocabularies);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.putVocabularies = function(vocabularies) {
        I18n.checkConfig();
        return $459a018ad4c4e88a$var$_i18n.putVocabularies(vocabularies);
    };
    I18n.checkConfig = function() {
        if (!$459a018ad4c4e88a$var$_i18n) $459a018ad4c4e88a$var$_i18n = new (0, $0d43ad65926e19b2$export$dbe3113d60765c1a)($459a018ad4c4e88a$var$_config);
        return true;
    };
    return I18n;
}();
(0, $6ff5c7c169206e21$export$a3858a9a153cffc7).register($459a018ad4c4e88a$export$dbe3113d60765c1a);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $4ZL0H = parcelRequire("4ZL0H");
var $4fe24881fb69f2d5$var$MIME_MAP = [
    {
        type: "text/plain",
        ext: "txt"
    },
    {
        type: "text/html",
        ext: "html"
    },
    {
        type: "text/javascript",
        ext: "js"
    },
    {
        type: "text/css",
        ext: "css"
    },
    {
        type: "text/csv",
        ext: "csv"
    },
    {
        type: "text/yaml",
        ext: "yml"
    },
    {
        type: "text/yaml",
        ext: "yaml"
    },
    {
        type: "text/calendar",
        ext: "ics"
    },
    {
        type: "text/calendar",
        ext: "ical"
    },
    {
        type: "image/apng",
        ext: "apng"
    },
    {
        type: "image/bmp",
        ext: "bmp"
    },
    {
        type: "image/gif",
        ext: "gif"
    },
    {
        type: "image/x-icon",
        ext: "ico"
    },
    {
        type: "image/x-icon",
        ext: "cur"
    },
    {
        type: "image/jpeg",
        ext: "jpg"
    },
    {
        type: "image/jpeg",
        ext: "jpeg"
    },
    {
        type: "image/jpeg",
        ext: "jfif"
    },
    {
        type: "image/jpeg",
        ext: "pjp"
    },
    {
        type: "image/jpeg",
        ext: "pjpeg"
    },
    {
        type: "image/png",
        ext: "png"
    },
    {
        type: "image/svg+xml",
        ext: "svg"
    },
    {
        type: "image/tiff",
        ext: "tif"
    },
    {
        type: "image/tiff",
        ext: "tiff"
    },
    {
        type: "image/webp",
        ext: "webp"
    },
    {
        type: "application/json",
        ext: "json"
    },
    {
        type: "application/xml",
        ext: "xml"
    },
    {
        type: "application/x-sh",
        ext: "sh"
    },
    {
        type: "application/zip",
        ext: "zip"
    },
    {
        type: "application/x-rar-compressed",
        ext: "rar"
    },
    {
        type: "application/x-tar",
        ext: "tar"
    },
    {
        type: "application/x-bzip",
        ext: "bz"
    },
    {
        type: "application/x-bzip2",
        ext: "bz2"
    },
    {
        type: "application/pdf",
        ext: "pdf"
    },
    {
        type: "application/java-archive",
        ext: "jar"
    },
    {
        type: "application/msword",
        ext: "doc"
    },
    {
        type: "application/vnd.ms-excel",
        ext: "xls"
    },
    {
        type: "application/vnd.ms-excel",
        ext: "xlsx"
    },
    {
        type: "message/rfc822",
        ext: "eml"
    }
];
var $4fe24881fb69f2d5$export$dd1bc94b04021eeb = function(obj) {
    if (obj === void 0) obj = {};
    return Object.keys(obj).length === 0;
};
var $4fe24881fb69f2d5$export$756e1e7707954007 = function(list, field, dir) {
    if (!list || !list.sort) return false;
    var dirX = dir && dir === "desc" ? -1 : 1;
    list.sort(function(a, b) {
        var a_val = a[field];
        var b_val = b[field];
        if (typeof b_val === "undefined") return typeof a_val === "undefined" ? 0 : 1 * dirX;
        if (typeof a_val === "undefined") return -1 * dirX;
        if (a_val < b_val) return -1 * dirX;
        if (a_val > b_val) return 1 * dirX;
        return 0;
    });
    return true;
};
var $4fe24881fb69f2d5$export$5e10ed067f63a9ea = function(obj, less) {
    var ret = Object.assign({}, obj);
    if (less) {
        if (typeof less === "string") delete ret[less];
        else less.forEach(function(attr) {
            delete ret[attr];
        });
    }
    return ret;
};
var $4fe24881fb69f2d5$export$49cecb876bed446d = function(filename, defVal) {
    if (defVal === void 0) defVal = "application/octet-stream";
    var name = filename.toLowerCase();
    var filtered = $4fe24881fb69f2d5$var$MIME_MAP.filter(function(mime) {
        return name.endsWith("." + mime.ext);
    });
    return filtered.length > 0 ? filtered[0].type : defVal;
};
var $4fe24881fb69f2d5$export$689bea3eece53c0e = function(contentType) {
    var type = contentType.toLowerCase();
    if (type.startsWith("text/")) return true;
    return "application/json" === type || "application/xml" === type || "application/sh" === type;
};
var $4fe24881fb69f2d5$export$9e15fb06e64c4810 = function() {
    var result = "";
    var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(var i = 32; i > 0; i -= 1)result += chars[Math.floor(Math.random() * chars.length)];
    return result;
};
var $4fe24881fb69f2d5$export$8f33cb495ca11832 = function(promise) {
    if (promise.isResolved) return promise;
    var isPending = true;
    var isRejected = false;
    var isFullfilled = false;
    var result = promise.then(function(data) {
        isFullfilled = true;
        isPending = false;
        return data;
    }, function(e) {
        isRejected = true;
        isPending = false;
        throw e;
    });
    result.isFullfilled = function() {
        return isFullfilled;
    };
    result.isPending = function() {
        return isPending;
    };
    result.isRejected = function() {
        return isRejected;
    };
    return result;
};
var $4fe24881fb69f2d5$export$97b87b8868ff7a3c = function() {
    if (typeof self === "undefined") return false;
    var selfContext = self;
    return typeof selfContext.WorkerGlobalScope !== "undefined" && self instanceof selfContext.WorkerGlobalScope;
};
var $4fe24881fb69f2d5$export$a2708fdb45cd35f = function() {
    var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined";
    var isNode = typeof $4ZL0H !== "undefined" && $4ZL0H.versions != null && $4ZL0H.versions.node != null;
    return {
        isBrowser: isBrowser,
        isNode: isNode
    };
};
var $4fe24881fb69f2d5$export$6281ea8cfc59a49c = function(obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) whiteListForItself = [];
    if (whiteListForChildren === void 0) whiteListForChildren = [];
    if (!$4fe24881fb69f2d5$export$250974ab4f95003c(obj)) return obj;
    var ret = {};
    for(var key in obj)if (obj.hasOwnProperty(key)) {
        var transferedKey = whiteListForItself.includes(key) ? key : key[0].toLowerCase() + key.slice(1);
        ret[transferedKey] = whiteListForChildren.includes(key) ? obj[key] : $4fe24881fb69f2d5$export$6281ea8cfc59a49c(obj[key], whiteListForItself, whiteListForChildren);
    }
    return ret;
};
var $4fe24881fb69f2d5$export$f8790a3d3d35829c = function(obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) whiteListForItself = [];
    if (whiteListForChildren === void 0) whiteListForChildren = [];
    if (!$4fe24881fb69f2d5$export$250974ab4f95003c(obj)) return obj;
    var ret = {};
    for(var key in obj)if (obj.hasOwnProperty(key)) {
        var transferredKey = whiteListForItself.includes(key) ? key : key[0].toUpperCase() + key.slice(1);
        ret[transferredKey] = whiteListForChildren.includes(key) ? obj[key] : $4fe24881fb69f2d5$export$f8790a3d3d35829c(obj[key], whiteListForItself, whiteListForChildren);
    }
    return ret;
};
var $4fe24881fb69f2d5$export$250974ab4f95003c = function(obj) {
    return obj instanceof Object && !(obj instanceof Array) && !(obj instanceof Function) && !(obj instanceof Number) && !(obj instanceof String) && !(obj instanceof Boolean);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Date & time utility functions to abstract the `aws-sdk` away from users.
 * (v2 => v3 modularization is a breaking change)
 *
 * @see https://github.com/aws/aws-sdk-js/blob/6edf586dcc1de7fe8fbfbbd9a0d2b1847921e6e1/lib/util.js#L262
 */ var $51eccc75455b5d7a$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
// Comment - TODO: remove
var $51eccc75455b5d7a$var$FIVE_MINUTES_IN_MS = 300000;
var $51eccc75455b5d7a$export$3e048df13f4eb60b = {
    /**
     * Milliseconds to offset the date to compensate for clock skew between device & services
     */ clockOffset: 0,
    getDateWithClockOffset: function() {
        if ($51eccc75455b5d7a$export$3e048df13f4eb60b.clockOffset) return new Date(new Date().getTime() + $51eccc75455b5d7a$export$3e048df13f4eb60b.clockOffset);
        else return new Date();
    },
    /**
     * @returns {number} Clock offset in milliseconds
     */ getClockOffset: function() {
        return $51eccc75455b5d7a$export$3e048df13f4eb60b.clockOffset;
    },
    getHeaderStringFromDate: function(date) {
        if (date === void 0) date = $51eccc75455b5d7a$export$3e048df13f4eb60b.getDateWithClockOffset();
        return date.toISOString().replace(/[:\-]|\.\d{3}/g, "");
    },
    getDateFromHeaderString: function(header) {
        var _a = $51eccc75455b5d7a$var$__read(header.match(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2}).+/), 7), year = _a[1], month = _a[2], day = _a[3], hour = _a[4], minute = _a[5], second = _a[6];
        return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second)));
    },
    isClockSkewed: function(serverDate) {
        // API gateway permits client calls that are off by no more than ±5 minutes
        return Math.abs(serverDate.getTime() - $51eccc75455b5d7a$export$3e048df13f4eb60b.getDateWithClockOffset().getTime()) >= $51eccc75455b5d7a$var$FIVE_MINUTES_IN_MS;
    },
    isClockSkewError: function(error) {
        if (!error.response || !error.response.headers) return false;
        var headers = error.response.headers;
        return Boolean([
            "BadRequestException",
            "InvalidSignatureException"
        ].includes(headers["x-amzn-errortype"]) && (headers.date || headers.Date));
    },
    /**
     * @param {number} offset Clock offset in milliseconds
     */ setClockOffset: function(offset) {
        $51eccc75455b5d7a$export$3e048df13f4eb60b.clockOffset = offset;
    }
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// query params
var $247c6c6e885234db$export$186cd8495ba0377d = "X-Amz-Algorithm";
var $247c6c6e885234db$export$6e114beec37430d7 = "X-Amz-Date";
var $247c6c6e885234db$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
var $247c6c6e885234db$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
var $247c6c6e885234db$export$296a4bada3fe6343 = "X-Amz-Region-Set";
var $247c6c6e885234db$export$41ae838dc1e0f082 = "X-Amz-Signature";
var $247c6c6e885234db$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
var $247c6c6e885234db$export$8e1383b7eea7bee = "X-Amz-Security-Token";
var $247c6c6e885234db$export$9924a64a4b8b0d58 = "authorization";
var $247c6c6e885234db$export$96307741595055fc = "host";
var $247c6c6e885234db$export$acf4b8bdf24aab34 = $247c6c6e885234db$export$6e114beec37430d7.toLowerCase();
var $247c6c6e885234db$export$fdc81b663012a8d2 = $247c6c6e885234db$export$8e1383b7eea7bee.toLowerCase();
var $247c6c6e885234db$export$c4bf0942098f6bb = "aws4_request";
var $247c6c6e885234db$export$aba583fcf2c2a4e9 = "AWS4-HMAC-SHA256";
var $247c6c6e885234db$export$c295e35583a9d67a = "AWS4";
var $247c6c6e885234db$export$b445dbfd1d7f2d42 = "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
var $247c6c6e885234db$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $949a57c5b8dc3bb6$export$a720a7c8dd7ab696 = function(date, region, service) {
    return "".concat(date, "/").concat(region, "/").concat(service, "/").concat((0, $247c6c6e885234db$export$c4bf0942098f6bb));
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns expected date strings to be used in signing.
 *
 * @param date JavaScript `Date` object.
 * @returns `FormattedDates` object containing the following:
 * - longDate: A date string in 'YYYYMMDDThhmmssZ' format
 * - shortDate: A date string in 'YYYYMMDD' format
 *
 * @internal
 */ var $0bfb8053366c50bd$export$79cc774850e3b1b = function(date) {
    var longDate = date.toISOString().replace(/[:\-]|\.\d{3}/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.slice(0, 8)
    };
};


var $d8cdec767a85f5f4$export$188c70d4d3596d39 = function(_a) {
    var credentials = _a.credentials, _b = _a.signingDate, signingDate = _b === void 0 ? new Date() : _b, signingRegion = _a.signingRegion, signingService = _a.signingService, _c = _a.uriEscapePath, uriEscapePath = _c === void 0 ? true : _c;
    // get properties from credentials
    var accessKeyId = credentials.accessKeyId, secretAccessKey = credentials.secretAccessKey, sessionToken = credentials.sessionToken;
    // get formatted dates for signing
    var _d = (0, $0bfb8053366c50bd$export$79cc774850e3b1b)(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
    // copy header and set signing properties
    var credentialScope = (0, $949a57c5b8dc3bb6$export$a720a7c8dd7ab696)(shortDate, signingRegion, signingService);
    return {
        accessKeyId: accessKeyId,
        credentialScope: credentialScope,
        longDate: longDate,
        secretAccessKey: secretAccessKey,
        sessionToken: sessionToken,
        shortDate: shortDate,
        signingRegion: signingRegion,
        signingService: signingService,
        uriEscapePath: uriEscapePath
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: V6 update to different crypto dependency?
var $f0fc6b161cb35602$exports = {};
"use strict";
Object.defineProperty($f0fc6b161cb35602$exports, "__esModule", {
    value: true
});

var $89IRS = parcelRequire("89IRS");

(0, $89IRS.__exportStar)((parcelRequire("eyN91")), $f0fc6b161cb35602$exports);


var $46424f3a8fe54247$var$SHORT_TO_HEX = {};
var $46424f3a8fe54247$var$HEX_TO_SHORT = {};
for(var $46424f3a8fe54247$var$i = 0; $46424f3a8fe54247$var$i < 256; $46424f3a8fe54247$var$i++){
    var $46424f3a8fe54247$var$encodedByte = $46424f3a8fe54247$var$i.toString(16).toLowerCase();
    if ($46424f3a8fe54247$var$encodedByte.length === 1) $46424f3a8fe54247$var$encodedByte = "0" + $46424f3a8fe54247$var$encodedByte;
    $46424f3a8fe54247$var$SHORT_TO_HEX[$46424f3a8fe54247$var$i] = $46424f3a8fe54247$var$encodedByte;
    $46424f3a8fe54247$var$HEX_TO_SHORT[$46424f3a8fe54247$var$encodedByte] = $46424f3a8fe54247$var$i;
}
function $46424f3a8fe54247$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    var out = new Uint8Array(encoded.length / 2);
    for(var i = 0; i < encoded.length; i += 2){
        var encodedByte = encoded.substr(i, 2).toLowerCase();
        if (encodedByte in $46424f3a8fe54247$var$HEX_TO_SHORT) out[i / 2] = $46424f3a8fe54247$var$HEX_TO_SHORT[encodedByte];
        else throw new Error("Cannot decode unrecognized sequence " + encodedByte + " as hexadecimal");
    }
    return out;
}
function $46424f3a8fe54247$export$7ea66e3774a60b67(bytes) {
    var out = "";
    for(var i = 0; i < bytes.byteLength; i++)out += $46424f3a8fe54247$var$SHORT_TO_HEX[bytes[i]];
    return out;
}


var $f3d247362f2a3e8d$export$1a568184069ac3c8 = function(key, data) {
    var sha256 = new (0, $f0fc6b161cb35602$exports.Sha256)(key);
    sha256.update(data);
    // TODO: V6 flip to async digest
    var hashedData = sha256.digestSync();
    return hashedData;
};
var $f3d247362f2a3e8d$export$45d3ccefb0f0c6da = function(key, data) {
    var hashedData = $f3d247362f2a3e8d$export$1a568184069ac3c8(key, data);
    return (0, $46424f3a8fe54247$export$7ea66e3774a60b67)(hashedData);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $fe8421beb750e89c$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $fe8421beb750e89c$export$859d7f1bb55e2914 = function(headers) {
    return Object.entries(headers).map(function(_a) {
        var _b;
        var _c = $fe8421beb750e89c$var$__read(_a, 2), key = _c[0], value = _c[1];
        return {
            key: key.toLowerCase(),
            value: (_b = value === null || value === void 0 ? void 0 : value.trim().replace(/\s+/g, " ")) !== null && _b !== void 0 ? _b : ""
        };
    }).sort(function(a, b) {
        return a.key < b.key ? -1 : 1;
    }).map(function(entry) {
        return "".concat(entry.key, ":").concat(entry.value, "\n");
    }).join("");
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $f33b7ac7364d2674$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $f33b7ac7364d2674$export$87a9cc45e3be0a17 = function(searchParams) {
    return Array.from(searchParams).sort(function(_a, _b) {
        var _c = $f33b7ac7364d2674$var$__read(_a, 2), keyA = _c[0], valA = _c[1];
        var _d = $f33b7ac7364d2674$var$__read(_b, 2), keyB = _d[0], valB = _d[1];
        if (keyA === keyB) return valA < valB ? -1 : 1;
        return keyA < keyB ? -1 : 1;
    }).map(function(_a) {
        var _b = $f33b7ac7364d2674$var$__read(_a, 2), key = _b[0], val = _b[1];
        return "".concat($f33b7ac7364d2674$var$escapeUri(key), "=").concat($f33b7ac7364d2674$var$escapeUri(val));
    }).join("&");
};
var $f33b7ac7364d2674$var$escapeUri = function(uri) {
    return encodeURIComponent(uri).replace(/[!'()*]/g, $f33b7ac7364d2674$var$hexEncode);
};
var $f33b7ac7364d2674$var$hexEncode = function(c) {
    return "%".concat(c.charCodeAt(0).toString(16).toUpperCase());
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a canonical uri.
 *
 * @param pathname `pathname` from request url.
 * @param uriEscapePath Whether to uri encode the path as part of canonical uri. It's used for S3 only where the
 *   pathname is already uri encoded, and the signing process is not expected to uri encode it again. Defaults to true.
 * @returns URI-encoded version of the absolute path component URL (everything between the host and the question mark
 * character (?) that starts the query string parameters). If the absolute path is empty, a forward slash character (/).
 *
 * @internal
 */ var $fe4a753c9a5ccbe7$export$4bbb144438cceb59 = function(pathname, uriEscapePath) {
    if (uriEscapePath === void 0) uriEscapePath = true;
    return pathname ? uriEscapePath ? encodeURIComponent(pathname).replace(/%2F/g, "/") : pathname : "/";
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $566f2e9642a13796$export$b671a27d01dfc160 = function(body) {
    // return precalculated empty hash if body is undefined or null
    if (body == null) return 0, $247c6c6e885234db$export$b445dbfd1d7f2d42;
    if ($566f2e9642a13796$var$isSourceData(body)) {
        var hashedData = (0, $f3d247362f2a3e8d$export$45d3ccefb0f0c6da)(null, body);
        return hashedData;
    }
    // Defined body is not signable. Return unsigned payload which may or may not be accepted by the service.
    return 0, $247c6c6e885234db$export$91f7321b40d9fd07;
};
var $566f2e9642a13796$var$isSourceData = function(body) {
    return typeof body === "string" || ArrayBuffer.isView(body) || $566f2e9642a13796$var$isArrayBuffer(body);
};
var $566f2e9642a13796$var$isArrayBuffer = function(arg) {
    return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns signed headers.
 *
 * @param headers `headers` from the request.
 * @returns List of headers included in canonical headers, separated by semicolons (;). This indicates which headers
 * are part of the signing process. Header names must use lowercase characters and must appear in alphabetical order.
 *
 * @internal
 */ var $8b35bda6daef0838$export$812d6f56efda9cfa = function(headers) {
    return Object.keys(headers).map(function(key) {
        return key.toLowerCase();
    }).sort().join(";");
};


var $c1e4b20d797592a9$export$78136353678f36ec = function(_a, uriEscapePath) {
    var body = _a.body, headers = _a.headers, method = _a.method, url = _a.url;
    if (uriEscapePath === void 0) uriEscapePath = true;
    return [
        method,
        (0, $fe4a753c9a5ccbe7$export$4bbb144438cceb59)(url.pathname, uriEscapePath),
        (0, $f33b7ac7364d2674$export$87a9cc45e3be0a17)(url.searchParams),
        (0, $fe8421beb750e89c$export$859d7f1bb55e2914)(headers),
        (0, $8b35bda6daef0838$export$812d6f56efda9cfa)(headers),
        (0, $566f2e9642a13796$export$b671a27d01dfc160)(body)
    ].join("\n");
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $cc2f700cdd6053a6$export$8b95a069d16dd783 = function(secretAccessKey, date, region, service) {
    var key = "".concat((0, $247c6c6e885234db$export$c295e35583a9d67a)).concat(secretAccessKey);
    var dateKey = (0, $f3d247362f2a3e8d$export$1a568184069ac3c8)(key, date);
    var regionKey = (0, $f3d247362f2a3e8d$export$1a568184069ac3c8)(dateKey, region);
    var serviceKey = (0, $f3d247362f2a3e8d$export$1a568184069ac3c8)(regionKey, service);
    var signingKey = (0, $f3d247362f2a3e8d$export$1a568184069ac3c8)(serviceKey, (0, $247c6c6e885234db$export$c4bf0942098f6bb));
    return signingKey;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $cec14932cfbe9fca$export$ff872c70ad45fed1 = function(date, credentialScope, hashedRequest) {
    return [
        (0, $247c6c6e885234db$export$aba583fcf2c2a4e9),
        date,
        credentialScope,
        hashedRequest
    ].join("\n");
};


var $67a0902c443a070e$export$2f768fec5d73d91a = function(request, _a) {
    var credentialScope = _a.credentialScope, longDate = _a.longDate, secretAccessKey = _a.secretAccessKey, shortDate = _a.shortDate, signingRegion = _a.signingRegion, signingService = _a.signingService, uriEscapePath = _a.uriEscapePath;
    // step 1: create a canonical request
    var canonicalRequest = (0, $c1e4b20d797592a9$export$78136353678f36ec)(request, uriEscapePath);
    // step 2: create a hash of the canonical request
    var hashedRequest = (0, $f3d247362f2a3e8d$export$45d3ccefb0f0c6da)(null, canonicalRequest);
    // step 3: create a string to sign
    var stringToSign = (0, $cec14932cfbe9fca$export$ff872c70ad45fed1)(longDate, credentialScope, hashedRequest);
    // step 4: calculate the signature
    var signature = (0, $f3d247362f2a3e8d$export$45d3ccefb0f0c6da)((0, $cc2f700cdd6053a6$export$8b95a069d16dd783)(secretAccessKey, shortDate, signingRegion, signingService), stringToSign);
    return signature;
};


var $b4fbe6c7907f8450$var$__assign = undefined && undefined.__assign || function() {
    $b4fbe6c7907f8450$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b4fbe6c7907f8450$var$__assign.apply(this, arguments);
};
var $b4fbe6c7907f8450$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b4fbe6c7907f8450$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $b4fbe6c7907f8450$export$b30eabd005f8b990 = function(_a, _b) {
    var _c, _d, _e, _f;
    var body = _a.body, _g = _a.method, method = _g === void 0 ? "GET" : _g, url = _a.url;
    var expiration = _b.expiration, options = $b4fbe6c7907f8450$var$__rest(_b, [
        "expiration"
    ]);
    var signingValues = (0, $d8cdec767a85f5f4$export$188c70d4d3596d39)(options);
    var accessKeyId = signingValues.accessKeyId, credentialScope = signingValues.credentialScope, longDate = signingValues.longDate, sessionToken = signingValues.sessionToken;
    // create the request to sign
    // @ts-ignore URL constructor accepts a URL object
    var presignedUrl = new URL(url);
    Object.entries($b4fbe6c7907f8450$var$__assign($b4fbe6c7907f8450$var$__assign((_c = {}, _c[0, $247c6c6e885234db$export$186cd8495ba0377d] = (0, $247c6c6e885234db$export$aba583fcf2c2a4e9), _c[0, $247c6c6e885234db$export$5c8e6dd7758f59d6] = "".concat(accessKeyId, "/").concat(credentialScope), _c[0, $247c6c6e885234db$export$6e114beec37430d7] = longDate, _c[0, $247c6c6e885234db$export$2dcbb254f883c238] = (0, $247c6c6e885234db$export$96307741595055fc), _c), expiration && (_d = {}, _d[0, $247c6c6e885234db$export$a0afe6f3bbfaf76e] = expiration.toString(), _d)), sessionToken && (_e = {}, _e[0, $247c6c6e885234db$export$8e1383b7eea7bee] = sessionToken, _e))).forEach(function(_a) {
        var _b = $b4fbe6c7907f8450$var$__read(_a, 2), key = _b[0], value = _b[1];
        presignedUrl.searchParams.append(key, value);
    });
    var requestToSign = {
        body: body,
        headers: (_f = {}, _f[0, $247c6c6e885234db$export$96307741595055fc] = url.host, _f),
        method: method,
        url: presignedUrl
    };
    // calculate and add the signature to the url
    var signature = (0, $67a0902c443a070e$export$2f768fec5d73d91a)(requestToSign, signingValues);
    presignedUrl.searchParams.append((0, $247c6c6e885234db$export$41ae838dc1e0f082), signature);
    return presignedUrl;
};

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




var $59bef32240e822f5$var$__assign = undefined && undefined.__assign || function() {
    $59bef32240e822f5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $59bef32240e822f5$var$__assign.apply(this, arguments);
};
var $59bef32240e822f5$export$aa7d25cddbad24ed = function(request, options) {
    var signingValues = (0, $d8cdec767a85f5f4$export$188c70d4d3596d39)(options);
    var accessKeyId = signingValues.accessKeyId, credentialScope = signingValues.credentialScope, longDate = signingValues.longDate, sessionToken = signingValues.sessionToken;
    // create the request to sign
    var headers = $59bef32240e822f5$var$__assign({}, request.headers);
    headers[0, $247c6c6e885234db$export$96307741595055fc] = request.url.host;
    headers[0, $247c6c6e885234db$export$acf4b8bdf24aab34] = longDate;
    if (sessionToken) headers[0, $247c6c6e885234db$export$fdc81b663012a8d2] = sessionToken;
    var requestToSign = $59bef32240e822f5$var$__assign($59bef32240e822f5$var$__assign({}, request), {
        headers: headers
    });
    // calculate and add the signature to the request
    var signature = (0, $67a0902c443a070e$export$2f768fec5d73d91a)(requestToSign, signingValues);
    var credentialEntry = "Credential=".concat(accessKeyId, "/").concat(credentialScope);
    var signedHeadersEntry = "SignedHeaders=".concat((0, $8b35bda6daef0838$export$812d6f56efda9cfa)(headers));
    var signatureEntry = "Signature=".concat(signature);
    headers[0, $247c6c6e885234db$export$9924a64a4b8b0d58] = "".concat((0, $247c6c6e885234db$export$aba583fcf2c2a4e9), " ").concat(credentialEntry, ", ").concat(signedHeadersEntry, ", ").concat(signatureEntry);
    return requestToSign;
};


var $14d9a0650c98b5f6$var$__assign = undefined && undefined.__assign || function() {
    $14d9a0650c98b5f6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $14d9a0650c98b5f6$var$__assign.apply(this, arguments);
};
var $14d9a0650c98b5f6$var$IOT_SERVICE_NAME = "iotdevicegateway";
// Best practice regex to parse the service and region from an AWS endpoint
var $14d9a0650c98b5f6$var$AWS_ENDPOINT_REGEX = /([^\.]+)\.(?:([^\.]*)\.)?amazonaws\.com(.cn)?$/;
var $14d9a0650c98b5f6$export$fdf54fdde81cc9f0 = /** @class */ function() {
    function Signer() {}
    /**
    * Sign a HTTP request, add 'Authorization' header to request param
    * @method sign
    * @memberof Signer
    * @static
    *
    * @param {object} request - HTTP request object
    <pre>
    request: {
        method: GET | POST | PUT ...
        url: ...,
        headers: {
            header1: ...
        },
        data: data
    }
    </pre>
    * @param {object} access_info - AWS access credential info
    <pre>
    access_info: {
        access_key: ...,
        secret_key: ...,
        session_token: ...
    }
    </pre>
    * @param {object} [service_info] - AWS service type and region, optional,
    *                                  if not provided then parse out from url
    <pre>
    service_info: {
        service: ...,
        region: ...
    }
    </pre>
    *
    * @returns {object} Signed HTTP request
    */ Signer.sign = function(request, accessInfo, serviceInfo) {
        request.headers = request.headers || {};
        if (request.body && !request.data) throw new Error('The attribute "body" was found on the request object. Please use the attribute "data" instead.');
        var requestToSign = $14d9a0650c98b5f6$var$__assign($14d9a0650c98b5f6$var$__assign({}, request), {
            body: request.data,
            url: new URL(request.url)
        });
        var options = $14d9a0650c98b5f6$var$getOptions(requestToSign, accessInfo, serviceInfo);
        var signedRequest = (0, $59bef32240e822f5$export$aa7d25cddbad24ed)(requestToSign, options);
        // Prior to using `signRequest`, Signer accepted urls as strings and outputted urls as string. Coerce the property
        // back to a string so as not to disrupt consumers of Signer.
        signedRequest.url = signedRequest.url.toString();
        // HTTP headers should be case insensitive but, to maintain parity with the previous Signer implementation and
        // limit the impact of this implementation swap, replace lowercased headers with title cased ones.
        signedRequest.headers.Authorization = signedRequest.headers.authorization;
        signedRequest.headers["X-Amz-Security-Token"] = signedRequest.headers["x-amz-security-token"];
        delete signedRequest.headers.authorization;
        delete signedRequest.headers["x-amz-security-token"];
        return signedRequest;
    };
    Signer.signUrl = function(urlOrRequest, accessInfo, serviceInfo, expiration) {
        var urlToSign = typeof urlOrRequest === "object" ? urlOrRequest.url : urlOrRequest;
        var method = typeof urlOrRequest === "object" ? urlOrRequest.method : "GET";
        var body = typeof urlOrRequest === "object" ? urlOrRequest.body : undefined;
        var presignable = {
            body: body,
            method: method,
            url: new URL(urlToSign)
        };
        var options = $14d9a0650c98b5f6$var$getOptions(presignable, accessInfo, serviceInfo, expiration);
        var signedUrl = (0, $b4fbe6c7907f8450$export$b30eabd005f8b990)(presignable, options);
        if (accessInfo.session_token && !$14d9a0650c98b5f6$var$sessionTokenRequiredInSigning(options.signingService)) signedUrl.searchParams.append((0, $247c6c6e885234db$export$8e1383b7eea7bee), accessInfo.session_token);
        return signedUrl.toString();
    };
    return Signer;
}();
var $14d9a0650c98b5f6$var$getOptions = function(request, accessInfo, serviceInfo, expiration) {
    var _a = accessInfo !== null && accessInfo !== void 0 ? accessInfo : {}, access_key = _a.access_key, secret_key = _a.secret_key, session_token = _a.session_token;
    var _b = $14d9a0650c98b5f6$var$parseServiceInfo(request.url), urlRegion = _b.region, urlService = _b.service;
    var _c = serviceInfo !== null && serviceInfo !== void 0 ? serviceInfo : {}, _d = _c.region, region = _d === void 0 ? urlRegion : _d, _e = _c.service, service = _e === void 0 ? urlService : _e;
    var credentials = $14d9a0650c98b5f6$var$__assign({
        accessKeyId: access_key,
        secretAccessKey: secret_key
    }, $14d9a0650c98b5f6$var$sessionTokenRequiredInSigning(service) ? {
        sessionToken: session_token
    } : {});
    return $14d9a0650c98b5f6$var$__assign({
        credentials: credentials,
        signingDate: (0, $51eccc75455b5d7a$export$3e048df13f4eb60b).getDateWithClockOffset(),
        signingRegion: region,
        signingService: service
    }, expiration && {
        expiration: expiration
    });
};
// TODO: V6 investigate whether add to custom clients' general signer implementation.
var $14d9a0650c98b5f6$var$parseServiceInfo = function(url) {
    var _a;
    var host = url.host;
    var matched = (_a = host.match($14d9a0650c98b5f6$var$AWS_ENDPOINT_REGEX)) !== null && _a !== void 0 ? _a : [];
    var parsed = matched.slice(1, 3);
    if (parsed[1] === "es") // Elastic Search
    parsed = parsed.reverse();
    return {
        service: parsed[0],
        region: parsed[1]
    };
};
// IoT service does not allow the session token in the canonical request
// https://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html
// TODO: V6 investigate whether add to custom clients' general signer implementation.
var $14d9a0650c98b5f6$var$sessionTokenRequiredInSigning = function(service) {
    return service !== $14d9a0650c98b5f6$var$IOT_SERVICE_NAME;
};



var $d0434983171bcfb8$var$__assign = undefined && undefined.__assign || function() {
    $d0434983171bcfb8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d0434983171bcfb8$var$__assign.apply(this, arguments);
};
var $d0434983171bcfb8$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("Parser");
var $d0434983171bcfb8$export$1ef2e9c2da492d = function(config) {
    var amplifyConfig = {};
    // Analytics
    if (config["aws_mobile_analytics_app_id"]) {
        var Analytics = {
            AWSPinpoint: {
                appId: config["aws_mobile_analytics_app_id"],
                region: config["aws_mobile_analytics_app_region"]
            }
        };
        amplifyConfig.Analytics = Analytics;
    }
    // Auth
    if (config["aws_cognito_identity_pool_id"] || config["aws_user_pools_id"]) amplifyConfig.Auth = {
        userPoolId: config["aws_user_pools_id"],
        userPoolWebClientId: config["aws_user_pools_web_client_id"],
        region: config["aws_cognito_region"],
        identityPoolId: config["aws_cognito_identity_pool_id"],
        identityPoolRegion: config["aws_cognito_region"],
        mandatorySignIn: config["aws_mandatory_sign_in"] === "enable",
        signUpVerificationMethod: config["aws_cognito_sign_up_verification_method"] || "code"
    };
    // Storage
    var storageConfig;
    if (config["aws_user_files_s3_bucket"]) storageConfig = {
        AWSS3: {
            bucket: config["aws_user_files_s3_bucket"],
            region: config["aws_user_files_s3_bucket_region"],
            dangerouslyConnectToHttpEndpointForTesting: config["aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing"]
        }
    };
    else storageConfig = config ? config.Storage || config : {};
    // Logging
    if (config["Logging"]) amplifyConfig.Logging = $d0434983171bcfb8$var$__assign($d0434983171bcfb8$var$__assign({}, config["Logging"]), {
        region: config["aws_project_region"]
    });
    // Geo
    if (config["geo"]) {
        amplifyConfig.Geo = Object.assign({}, config.geo);
        if (config.geo["amazon_location_service"]) amplifyConfig.Geo = {
            AmazonLocationService: config.geo["amazon_location_service"]
        };
    }
    amplifyConfig.Analytics = Object.assign({}, amplifyConfig.Analytics, config.Analytics);
    amplifyConfig.Auth = Object.assign({}, amplifyConfig.Auth, config.Auth);
    amplifyConfig.Storage = Object.assign({}, storageConfig);
    amplifyConfig.Logging = Object.assign({}, amplifyConfig.Logging, config.Logging);
    $d0434983171bcfb8$var$logger.debug("parse config", config, "to amplifyconfig", amplifyConfig);
    return amplifyConfig;
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $7a09b30b2e4e0fe6$var$dataMemory = {};
/** @class */ var $7a09b30b2e4e0fe6$export$d7392285c701ecf5 = /** @class */ function() {
    function MemoryStorage() {}
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ MemoryStorage.setItem = function(key, value) {
        $7a09b30b2e4e0fe6$var$dataMemory[key] = value;
        return $7a09b30b2e4e0fe6$var$dataMemory[key];
    };
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ MemoryStorage.getItem = function(key) {
        return Object.prototype.hasOwnProperty.call($7a09b30b2e4e0fe6$var$dataMemory, key) ? $7a09b30b2e4e0fe6$var$dataMemory[key] : undefined;
    };
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ MemoryStorage.removeItem = function(key) {
        return delete $7a09b30b2e4e0fe6$var$dataMemory[key];
    };
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ MemoryStorage.clear = function() {
        $7a09b30b2e4e0fe6$var$dataMemory = {};
        return $7a09b30b2e4e0fe6$var$dataMemory;
    };
    return MemoryStorage;
}();
var $7a09b30b2e4e0fe6$export$a2bd19c49e4760e8 = /** @class */ function() {
    /**
     * This is used to get a storage object
     * @returns {object} the storage
     */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem("aws.amplify.test-ls", 1);
            this.storageWindow.removeItem("aws.amplify.test-ls");
        } catch (exception) {
            this.storageWindow = $7a09b30b2e4e0fe6$export$d7392285c701ecf5;
        }
    }
    /**
     * This is used to return the storage
     * @returns {object} the storage
     */ StorageHelper.prototype.getStorage = function() {
        return this.storageWindow;
    };
    return StorageHelper;
}();



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



var $e630ff0a3924a99b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $e630ff0a3924a99b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e630ff0a3924a99b$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $e630ff0a3924a99b$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $e630ff0a3924a99b$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $e630ff0a3924a99b$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("Util");
var $e630ff0a3924a99b$export$1e38badc838ad384 = /** @class */ function(_super) {
    $e630ff0a3924a99b$var$__extends(NonRetryableError, _super);
    function NonRetryableError(message) {
        var _this = _super.call(this, message) || this;
        _this.nonRetryable = true;
        return _this;
    }
    return NonRetryableError;
}(Error);
var $e630ff0a3924a99b$export$490cab1f6f83794d = function(obj) {
    var key = "nonRetryable";
    return obj && obj[key];
};
function $e630ff0a3924a99b$export$9369b12211e1fce4(functionToRetry, args, delayFn, onTerminate) {
    return $e630ff0a3924a99b$var$__awaiter(this, void 0, void 0, function() {
        var _this = this;
        return $e630ff0a3924a99b$var$__generator(this, function(_a) {
            if (typeof functionToRetry !== "function") throw Error("functionToRetry must be a function");
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    return $e630ff0a3924a99b$var$__awaiter(_this, void 0, void 0, function() {
                        var attempt, terminated, timeout, wakeUp, lastError, _loop_1, state_1;
                        return $e630ff0a3924a99b$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    attempt = 0;
                                    terminated = false;
                                    wakeUp = function() {};
                                    onTerminate && onTerminate.then(function() {
                                        // signal not to try anymore.
                                        terminated = true;
                                        // stop sleeping if we're sleeping.
                                        clearTimeout(timeout);
                                        wakeUp();
                                    });
                                    _loop_1 = function() {
                                        var _b, _c, err_1, retryIn_1;
                                        return $e630ff0a3924a99b$var$__generator(this, function(_d) {
                                            switch(_d.label){
                                                case 0:
                                                    attempt++;
                                                    $e630ff0a3924a99b$var$logger.debug("".concat(functionToRetry.name, " attempt #").concat(attempt, " with this vars: ").concat(JSON.stringify(args)));
                                                    _d.label = 1;
                                                case 1:
                                                    _d.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        7
                                                    ]);
                                                    _b = {};
                                                    _c = resolve;
                                                    return [
                                                        4 /*yield*/ ,
                                                        functionToRetry.apply(void 0, $e630ff0a3924a99b$var$__spreadArray([], $e630ff0a3924a99b$var$__read(args), false))
                                                    ];
                                                case 2:
                                                    return [
                                                        2 /*return*/ ,
                                                        (_b.value = _c.apply(void 0, [
                                                            _d.sent()
                                                        ]), _b)
                                                    ];
                                                case 3:
                                                    err_1 = _d.sent();
                                                    lastError = err_1;
                                                    $e630ff0a3924a99b$var$logger.debug("error on ".concat(functionToRetry.name), err_1);
                                                    if ($e630ff0a3924a99b$export$490cab1f6f83794d(err_1)) {
                                                        $e630ff0a3924a99b$var$logger.debug("".concat(functionToRetry.name, " non retryable error"), err_1);
                                                        return [
                                                            2 /*return*/ ,
                                                            {
                                                                value: reject(err_1)
                                                            }
                                                        ];
                                                    }
                                                    retryIn_1 = delayFn(attempt, args, err_1);
                                                    $e630ff0a3924a99b$var$logger.debug("".concat(functionToRetry.name, " retrying in ").concat(retryIn_1, " ms"));
                                                    if (!(retryIn_1 === false || terminated)) return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                    return [
                                                        2 /*return*/ ,
                                                        {
                                                            value: reject(err_1)
                                                        }
                                                    ];
                                                case 4:
                                                    return [
                                                        4 /*yield*/ ,
                                                        new Promise(function(r) {
                                                            wakeUp = r; // export wakeUp for onTerminate handling
                                                            timeout = setTimeout(wakeUp, retryIn_1);
                                                        })
                                                    ];
                                                case 5:
                                                    _d.sent();
                                                    _d.label = 6;
                                                case 6:
                                                    return [
                                                        3 /*break*/ ,
                                                        7
                                                    ];
                                                case 7:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    };
                                    _a.label = 1;
                                case 1:
                                    if (!!terminated) return [
                                        3 /*break*/ ,
                                        3
                                    ];
                                    return [
                                        5 /*yield**/ ,
                                        _loop_1()
                                    ];
                                case 2:
                                    state_1 = _a.sent();
                                    if (typeof state_1 === "object") return [
                                        2 /*return*/ ,
                                        state_1.value
                                    ];
                                    return [
                                        3 /*break*/ ,
                                        1
                                    ];
                                case 3:
                                    // reached if terminated while waiting for a timer.
                                    reject(lastError);
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                })
            ];
        });
    });
}
var $e630ff0a3924a99b$var$MAX_DELAY_MS = 300000;
function $e630ff0a3924a99b$export$caea50bde345f648(maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = $e630ff0a3924a99b$var$MAX_DELAY_MS;
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var $e630ff0a3924a99b$export$a24aa7705df9cf44 = function(functionToRetry, args, maxDelayMs, onTerminate) {
    if (maxDelayMs === void 0) maxDelayMs = $e630ff0a3924a99b$var$MAX_DELAY_MS;
    return $e630ff0a3924a99b$export$9369b12211e1fce4(functionToRetry, args, $e630ff0a3924a99b$export$caea50bde345f648(maxDelayMs), onTerminate);
};


var $232f740ec9075291$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $232f740ec9075291$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $232f740ec9075291$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("CognitoCredentials");
var $232f740ec9075291$var$waitForInit = new Promise(function(res, rej) {
    if (!(0, $4fe24881fb69f2d5$export$a2708fdb45cd35f)().isBrowser) {
        $232f740ec9075291$var$logger.debug("not in the browser, directly resolved");
        return res();
    }
    var ga = window["gapi"] && window["gapi"].auth2 ? window["gapi"].auth2 : null;
    if (ga) {
        $232f740ec9075291$var$logger.debug("google api already loaded");
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var $232f740ec9075291$export$75ace714083c1340 = /** @class */ function() {
    function GoogleOAuth() {
        this.initialized = false;
        this.refreshGoogleToken = this.refreshGoogleToken.bind(this);
        this._refreshGoogleTokenImpl = this._refreshGoogleTokenImpl.bind(this);
    }
    GoogleOAuth.prototype.refreshGoogleToken = function() {
        return $232f740ec9075291$var$__awaiter(this, void 0, void 0, function() {
            return $232f740ec9075291$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        $232f740ec9075291$var$logger.debug("need to wait for the Google SDK loaded");
                        return [
                            4 /*yield*/ ,
                            $232f740ec9075291$var$waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        $232f740ec9075291$var$logger.debug("finish waiting");
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshGoogleTokenImpl()
                        ];
                }
            });
        });
    };
    GoogleOAuth.prototype._refreshGoogleTokenImpl = function() {
        var ga = null;
        if ((0, $4fe24881fb69f2d5$export$a2708fdb45cd35f)().isBrowser) ga = window["gapi"] && window["gapi"].auth2 ? window["gapi"].auth2 : null;
        if (!ga) {
            $232f740ec9075291$var$logger.debug("no gapi auth2 available");
            return Promise.reject("no gapi auth2 available");
        }
        return new Promise(function(res, rej) {
            ga.getAuthInstance().then(function(googleAuth) {
                if (!googleAuth) {
                    $232f740ec9075291$var$logger.debug("google Auth undefined");
                    rej(new (0, $e630ff0a3924a99b$export$1e38badc838ad384)("google Auth undefined"));
                }
                var googleUser = googleAuth.currentUser.get();
                // refresh the token
                if (googleUser.isSignedIn()) {
                    $232f740ec9075291$var$logger.debug("refreshing the google access token");
                    googleUser.reloadAuthResponse().then(function(authResponse) {
                        var id_token = authResponse.id_token, expires_at = authResponse.expires_at;
                        res({
                            token: id_token,
                            expires_at: expires_at
                        });
                    }).catch(function(err) {
                        if (err && err.error === "network_error") // Not using NonRetryableError so handler will be retried
                        rej("Network error reloading google auth response");
                        else rej(new (0, $e630ff0a3924a99b$export$1e38badc838ad384)("Failed to reload google auth response"));
                    });
                } else rej(new (0, $e630ff0a3924a99b$export$1e38badc838ad384)("User is not signed in with Google"));
            }).catch(function(err) {
                $232f740ec9075291$var$logger.debug("Failed to refresh google token", err);
                rej(new (0, $e630ff0a3924a99b$export$1e38badc838ad384)("Failed to refresh google token"));
            });
        });
    };
    return GoogleOAuth;
}();





var $6f14d89ae82643cd$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6f14d89ae82643cd$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $6f14d89ae82643cd$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("CognitoCredentials");
var $6f14d89ae82643cd$var$waitForInit = new Promise(function(res, rej) {
    if (!(0, $4fe24881fb69f2d5$export$a2708fdb45cd35f)().isBrowser) {
        $6f14d89ae82643cd$var$logger.debug("not in the browser, directly resolved");
        return res();
    }
    var fb = window["FB"];
    if (fb) {
        $6f14d89ae82643cd$var$logger.debug("FB SDK already loaded");
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var $6f14d89ae82643cd$export$1b6b8b5328e38349 = /** @class */ function() {
    function FacebookOAuth() {
        this.initialized = false;
        this.refreshFacebookToken = this.refreshFacebookToken.bind(this);
        this._refreshFacebookTokenImpl = this._refreshFacebookTokenImpl.bind(this);
    }
    FacebookOAuth.prototype.refreshFacebookToken = function() {
        return $6f14d89ae82643cd$var$__awaiter(this, void 0, void 0, function() {
            return $6f14d89ae82643cd$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        $6f14d89ae82643cd$var$logger.debug("need to wait for the Facebook SDK loaded");
                        return [
                            4 /*yield*/ ,
                            $6f14d89ae82643cd$var$waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        $6f14d89ae82643cd$var$logger.debug("finish waiting");
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshFacebookTokenImpl()
                        ];
                }
            });
        });
    };
    FacebookOAuth.prototype._refreshFacebookTokenImpl = function() {
        var fb = null;
        if ((0, $4fe24881fb69f2d5$export$a2708fdb45cd35f)().isBrowser) fb = window["FB"];
        if (!fb) {
            var errorMessage = "no fb sdk available";
            $6f14d89ae82643cd$var$logger.debug(errorMessage);
            return Promise.reject(new (0, $e630ff0a3924a99b$export$1e38badc838ad384)(errorMessage));
        }
        return new Promise(function(res, rej) {
            fb.getLoginStatus(function(fbResponse) {
                if (!fbResponse || !fbResponse.authResponse) {
                    var errorMessage = "no response from facebook when refreshing the jwt token";
                    $6f14d89ae82643cd$var$logger.debug(errorMessage);
                    // There is no definitive indication for a network error in
                    // fbResponse, so we are treating it as an invalid token.
                    rej(new (0, $e630ff0a3924a99b$export$1e38badc838ad384)(errorMessage));
                } else {
                    var response = fbResponse.authResponse;
                    var accessToken = response.accessToken, expiresIn = response.expiresIn;
                    var date = new Date();
                    var expires_at = expiresIn * 1000 + date.getTime();
                    if (!accessToken) {
                        var errorMessage = "the jwtToken is undefined";
                        $6f14d89ae82643cd$var$logger.debug(errorMessage);
                        rej(new (0, $e630ff0a3924a99b$export$1e38badc838ad384)(errorMessage));
                    }
                    res({
                        token: accessToken,
                        expires_at: expires_at
                    });
                }
            }, {
                scope: "public_profile,email"
            });
        });
    };
    return FacebookOAuth;
}();


var $9851706019ceefa3$export$75ace714083c1340 = new (0, $232f740ec9075291$export$75ace714083c1340)();
var $9851706019ceefa3$export$1b6b8b5328e38349 = new (0, $6f14d89ae82643cd$export$1b6b8b5328e38349)();




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Default partition for AWS services. This is used when the region is not provided or the region is not recognized.
 *
 * @internal
 */ var $aaa2efb0fddeada9$export$72f3cee421ee8a74 = {
    id: "aws",
    outputs: {
        dnsSuffix: "amazonaws.com"
    },
    regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
    regions: [
        "aws-global"
    ]
};
var $aaa2efb0fddeada9$export$d7c12af0c0f12206 = {
    partitions: [
        $aaa2efb0fddeada9$export$72f3cee421ee8a74,
        {
            id: "aws-cn",
            outputs: {
                dnsSuffix: "amazonaws.com.cn"
            },
            regionRegex: "^cn\\-\\w+\\-\\d+$",
            regions: [
                "aws-cn-global"
            ]
        }
    ]
};


var $045984a6263bd645$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $045984a6263bd645$export$1c28e37cdcc37f6d = function(region) {
    var e_1, _a;
    var partitions = (0, $aaa2efb0fddeada9$export$d7c12af0c0f12206).partitions;
    try {
        for(var partitions_1 = $045984a6263bd645$var$__values(partitions), partitions_1_1 = partitions_1.next(); !partitions_1_1.done; partitions_1_1 = partitions_1.next()){
            var _b = partitions_1_1.value, regions = _b.regions, outputs = _b.outputs, regionRegex = _b.regionRegex;
            var regex = new RegExp(regionRegex);
            if (regions.includes(region) || regex.test(region)) return outputs.dnsSuffix;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (partitions_1_1 && !partitions_1_1.done && (_a = partitions_1.return)) _a.call(partitions_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, $aaa2efb0fddeada9$export$72f3cee421ee8a74).outputs.dnsSuffix;
};

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $fe0ec52dee712a0c$var$__assign = undefined && undefined.__assign || function() {
    $fe0ec52dee712a0c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fe0ec52dee712a0c$var$__assign.apply(this, arguments);
};
var $fe0ec52dee712a0c$export$978f9418fe0cb26c = function(response) {
    var _a, _b;
    var headers = response.headers, statusCode = response.statusCode;
    return $fe0ec52dee712a0c$var$__assign($fe0ec52dee712a0c$var$__assign({}, $fe0ec52dee712a0c$var$isMetadataBearer(response) ? response.$metadata : {}), {
        httpStatusCode: statusCode,
        requestId: (_b = (_a = headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : headers["x-amzn-request-id"]) !== null && _b !== void 0 ? _b : headers["x-amz-request-id"],
        extendedRequestId: headers["x-amz-id-2"],
        cfId: headers["x-amz-cf-id"]
    });
};
var $fe0ec52dee712a0c$var$isMetadataBearer = function(response) {
    return typeof (response === null || response === void 0 ? void 0 : response["$metadata"]) === "object";
};


var $8bf6542fe3057a62$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8bf6542fe3057a62$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $8bf6542fe3057a62$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $8bf6542fe3057a62$export$be467dfcc0538e25 = function(response) {
    return $8bf6542fe3057a62$var$__awaiter(void 0, void 0, void 0, function() {
        var body, sanitizeErrorCode, code, message, error;
        var _a, _b, _c, _d, _e;
        return $8bf6542fe3057a62$var$__generator(this, function(_f) {
            switch(_f.label){
                case 0:
                    if (!response || response.statusCode < 300) return [
                        2 /*return*/ 
                    ];
                    return [
                        4 /*yield*/ ,
                        $8bf6542fe3057a62$export$759bcb35b0d1bf81(response)
                    ];
                case 1:
                    body = _f.sent();
                    sanitizeErrorCode = function(rawValue) {
                        var _a = $8bf6542fe3057a62$var$__read(rawValue.toString().split(/[\,\:]+/), 1), cleanValue = _a[0];
                        if (cleanValue.includes("#")) return cleanValue.split("#")[1];
                        return cleanValue;
                    };
                    code = sanitizeErrorCode((_c = (_b = (_a = response.headers["x-amzn-errortype"]) !== null && _a !== void 0 ? _a : body.code) !== null && _b !== void 0 ? _b : body.__type) !== null && _c !== void 0 ? _c : "UnknownError");
                    message = (_e = (_d = body.message) !== null && _d !== void 0 ? _d : body.Message) !== null && _e !== void 0 ? _e : "Unknown error";
                    error = new Error(message);
                    return [
                        2 /*return*/ ,
                        Object.assign(error, {
                            name: code,
                            $metadata: (0, $fe0ec52dee712a0c$export$978f9418fe0cb26c)(response)
                        })
                    ];
            }
        });
    });
};
var $8bf6542fe3057a62$export$759bcb35b0d1bf81 = function(response) {
    return $8bf6542fe3057a62$var$__awaiter(void 0, void 0, void 0, function() {
        var output;
        return $8bf6542fe3057a62$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!response.body) throw new Error("Missing response payload");
                    return [
                        4 /*yield*/ ,
                        response.body.json()
                    ];
                case 1:
                    output = _a.sent();
                    return [
                        2 /*return*/ ,
                        Object.assign(output, {
                            $metadata: (0, $fe0ec52dee712a0c$export$978f9418fe0cb26c)(response)
                        })
                    ];
            }
        });
    });
};

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $ac90ade79318ec57$var$__assign = undefined && undefined.__assign || function() {
    $ac90ade79318ec57$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ac90ade79318ec57$var$__assign.apply(this, arguments);
};
var $ac90ade79318ec57$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ac90ade79318ec57$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $ac90ade79318ec57$var$DEFAULT_RETRY_ATTEMPTS = 3;
var $ac90ade79318ec57$export$a3922aa5f87bae85 = function(_a) {
    var _b = _a.maxAttempts, maxAttempts = _b === void 0 ? $ac90ade79318ec57$var$DEFAULT_RETRY_ATTEMPTS : _b, retryDecider = _a.retryDecider, computeDelay = _a.computeDelay, abortSignal = _a.abortSignal;
    if (maxAttempts < 1) throw new Error("maxAttempts must be greater than 0");
    return function(next, context) {
        return function retryMiddleware(request) {
            var _a;
            return $ac90ade79318ec57$var$__awaiter(this, void 0, void 0, function() {
                var error, attemptsCount, response, handleTerminalErrorOrResponse, e_1, delay;
                return $ac90ade79318ec57$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            attemptsCount = (_a = context.attemptsCount) !== null && _a !== void 0 ? _a : 0;
                            handleTerminalErrorOrResponse = function() {
                                if (response) {
                                    $ac90ade79318ec57$var$addOrIncrementMetadataAttempts(response, attemptsCount);
                                    return response;
                                } else {
                                    $ac90ade79318ec57$var$addOrIncrementMetadataAttempts(error, attemptsCount);
                                    throw error;
                                }
                            };
                            _b.label = 1;
                        case 1:
                            if (!(!(abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) && attemptsCount < maxAttempts)) return [
                                3 /*break*/ ,
                                11
                            ];
                            _b.label = 2;
                        case 2:
                            _b.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4 /*yield*/ ,
                                next(request)
                            ];
                        case 3:
                            response = _b.sent();
                            error = undefined;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            e_1 = _b.sent();
                            error = e_1;
                            response = undefined;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            // context.attemptsCount may be updated after calling next handler which may retry the request by itself.
                            attemptsCount = context.attemptsCount > attemptsCount ? context.attemptsCount : attemptsCount + 1;
                            context.attemptsCount = attemptsCount;
                            return [
                                4 /*yield*/ ,
                                retryDecider(response, error)
                            ];
                        case 6:
                            if (!_b.sent()) return [
                                3 /*break*/ ,
                                9
                            ];
                            if (!(!(abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) && attemptsCount < maxAttempts)) return [
                                3 /*break*/ ,
                                8
                            ];
                            delay = computeDelay(attemptsCount);
                            return [
                                4 /*yield*/ ,
                                $ac90ade79318ec57$var$cancellableSleep(delay, abortSignal)
                            ];
                        case 7:
                            _b.sent();
                            _b.label = 8;
                        case 8:
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 9:
                            return [
                                2 /*return*/ ,
                                handleTerminalErrorOrResponse()
                            ];
                        case 10:
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 11:
                            if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) throw new Error("Request aborted.");
                            else return [
                                2 /*return*/ ,
                                handleTerminalErrorOrResponse()
                            ];
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
    };
};
var $ac90ade79318ec57$var$cancellableSleep = function(timeoutMs, abortSignal) {
    if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) return Promise.resolve();
    var timeoutId;
    var sleepPromiseResolveFn;
    var sleepPromise = new Promise(function(resolve) {
        sleepPromiseResolveFn = resolve;
        timeoutId = setTimeout(resolve, timeoutMs);
    });
    abortSignal === null || abortSignal === void 0 || abortSignal.addEventListener("abort", function cancelSleep(event) {
        clearTimeout(timeoutId);
        abortSignal === null || abortSignal === void 0 || abortSignal.removeEventListener("abort", cancelSleep);
        sleepPromiseResolveFn();
    });
    return sleepPromise;
};
var $ac90ade79318ec57$var$addOrIncrementMetadataAttempts = function(nextHandlerOutput, attempts) {
    var _a;
    if (Object.prototype.toString.call(nextHandlerOutput) !== "[object Object]") return;
    nextHandlerOutput["$metadata"] = $ac90ade79318ec57$var$__assign($ac90ade79318ec57$var$__assign({}, (_a = nextHandlerOutput["$metadata"]) !== null && _a !== void 0 ? _a : {}), {
        attempts: attempts
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $e0f2f8f6c8baf5f5$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e0f2f8f6c8baf5f5$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $e0f2f8f6c8baf5f5$export$62c460923941c0b0 = function(_a) {
    var _b = _a.userAgentHeader, userAgentHeader = _b === void 0 ? "x-amz-user-agent" : _b, _c = _a.userAgentValue, userAgentValue = _c === void 0 ? "" : _c;
    return function(next) {
        return function userAgentMiddleware(request) {
            return $e0f2f8f6c8baf5f5$var$__awaiter(this, void 0, void 0, function() {
                var result, headerName, response;
                return $e0f2f8f6c8baf5f5$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(userAgentValue.trim().length === 0)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                next(request)
                            ];
                        case 1:
                            result = _a.sent();
                            return [
                                2 /*return*/ ,
                                result
                            ];
                        case 2:
                            headerName = userAgentHeader.toLowerCase();
                            request.headers[headerName] = request.headers[headerName] ? "".concat(request.headers[headerName], " ").concat(userAgentValue) : userAgentValue;
                            return [
                                4 /*yield*/ ,
                                next(request)
                            ];
                        case 3:
                            response = _a.sent();
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Compose a transfer handler with a core transfer handler and a list of middleware.
 * @param coreHandler Core transfer handler
 * @param middleware	List of middleware
 * @returns A transfer handler whose option type is the union of the core
 * 	transfer handler's option type and the middleware's option type.
 * @internal
 */ var $7c6efce776c036f5$export$f074d76e52925468 = function(coreHandler, middleware) {
    return function(request, options) {
        var context = {};
        var composedHandler = function(request) {
            return coreHandler(request, options);
        };
        for(var i = middleware.length - 1; i >= 0; i--){
            var m = middleware[i];
            var resolvedMiddleware = m(options);
            composedHandler = resolvedMiddleware(composedHandler, context);
        }
        return composedHandler(request);
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $0ecd5c8b07acacb9$exports = {};


$0ecd5c8b07acacb9$exports = self.fetch || (self.fetch = (parcelRequire("adsYI")).default || (parcelRequire("adsYI")));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cache the payload of a response body. It allows multiple calls to the body,
 * for example, when reading the body in both retry decider and error deserializer.
 * Caching body is allowed here because we call the body accessor(blob(), json(),
 * etc.) when body is small or streaming implementation is not available(RN).
 *
 * @internal
 */ var $6b29aa0d39f75dc5$export$580ad1ce15092b15 = function(payloadAccessor) {
    var cached;
    return function() {
        if (!cached) // Explicitly not awaiting. Intermediate await would add overhead and
        // introduce a possible race in the event that this wrapper is called
        // again before the first `payloadAccessor` call resolves.
        cached = payloadAccessor();
        return cached;
    };
};


var $fe3a4fef129e35cd$var$__assign = undefined && undefined.__assign || function() {
    $fe3a4fef129e35cd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fe3a4fef129e35cd$var$__assign.apply(this, arguments);
};
var $fe3a4fef129e35cd$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $fe3a4fef129e35cd$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $fe3a4fef129e35cd$var$shouldSendBody = function(method) {
    return ![
        "HEAD",
        "GET",
        "DELETE"
    ].includes(method.toUpperCase());
};
var $fe3a4fef129e35cd$export$d2573baf35521e4c = function(_a, _b) {
    var url = _a.url, method = _a.method, headers = _a.headers, body = _a.body;
    var abortSignal = _b.abortSignal;
    return $fe3a4fef129e35cd$var$__awaiter(void 0, void 0, void 0, function() {
        var resp, e_1, responseHeaders, httpResponse, bodyWithMixin;
        var _c, _d;
        return $fe3a4fef129e35cd$var$__generator(this, function(_e) {
            switch(_e.label){
                case 0:
                    _e.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4 /*yield*/ ,
                        fetch(url, {
                            method: method,
                            headers: headers,
                            body: $fe3a4fef129e35cd$var$shouldSendBody(method) ? body : undefined,
                            signal: abortSignal
                        })
                    ];
                case 1:
                    resp = _e.sent();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 2:
                    e_1 = _e.sent();
                    // TODO: needs to revise error handling in v6
                    // For now this is a thin wrapper over original fetch error similar to cognito-identity-js package.
                    // Ref: https://github.com/aws-amplify/amplify-js/blob/4fbc8c0a2be7526aab723579b4c95b552195a80b/packages/amazon-cognito-identity-js/src/Client.js#L103-L108
                    if (e_1 instanceof TypeError) throw new Error("Network error");
                    throw e_1;
                case 3:
                    responseHeaders = {};
                    (_c = resp.headers) === null || _c === void 0 || _c.forEach(function(value, key) {
                        responseHeaders[key.toLowerCase()] = value;
                    });
                    httpResponse = {
                        statusCode: resp.status,
                        headers: responseHeaders,
                        body: null
                    };
                    bodyWithMixin = Object.assign((_d = resp.body) !== null && _d !== void 0 ? _d : {}, {
                        text: (0, $6b29aa0d39f75dc5$export$580ad1ce15092b15)(function() {
                            return resp.text();
                        }),
                        blob: (0, $6b29aa0d39f75dc5$export$580ad1ce15092b15)(function() {
                            return resp.blob();
                        }),
                        json: (0, $6b29aa0d39f75dc5$export$580ad1ce15092b15)(function() {
                            return resp.json();
                        })
                    });
                    return [
                        2 /*return*/ ,
                        $fe3a4fef129e35cd$var$__assign($fe3a4fef129e35cd$var$__assign({}, httpResponse), {
                            body: bodyWithMixin
                        })
                    ];
            }
        });
    });
};


var $57812d3f7f02ece1$export$ed7e1ccf00f39c4a = (0, $7c6efce776c036f5$export$f074d76e52925468)((0, $fe3a4fef129e35cd$export$d2573baf35521e4c), [
    (0, $e0f2f8f6c8baf5f5$export$62c460923941c0b0),
    (0, $ac90ade79318ec57$export$a3922aa5f87bae85)
]);



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// via https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L8
var $fe431aae0fb3d196$var$CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch",
    "BadRequestException"
];
var $fe431aae0fb3d196$export$7b87435661177a94 = function(errorCode) {
    return $fe431aae0fb3d196$var$CLOCK_SKEW_ERROR_CODES.includes(errorCode);
};


var $87853ac980d212ed$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $87853ac980d212ed$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $87853ac980d212ed$export$b919d98317a7685f = function(errorParser) {
    return function(response, error) {
        return $87853ac980d212ed$var$__awaiter(void 0, void 0, void 0, function() {
            var errorCode, _a, statusCode;
            var _b;
            return $87853ac980d212ed$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (!(error !== null && error !== void 0)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _a = error;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            errorParser(response)
                        ];
                    case 2:
                        _a = _c.sent();
                        _c.label = 3;
                    case 3:
                        errorCode = ((_b = _a) !== null && _b !== void 0 ? _b : {}).name;
                        statusCode = response === null || response === void 0 ? void 0 : response.statusCode;
                        return [
                            2 /*return*/ ,
                            $87853ac980d212ed$var$isConnectionError(error) || $87853ac980d212ed$var$isThrottlingError(statusCode, errorCode) || (0, $fe431aae0fb3d196$export$7b87435661177a94)(errorCode) || $87853ac980d212ed$var$isServerSideError(statusCode, errorCode)
                        ];
                }
            });
        });
    };
};
// reference: https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L22-L37
var $87853ac980d212ed$var$THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException"
];
var $87853ac980d212ed$var$TIMEOUT_ERROR_CODES = [
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
var $87853ac980d212ed$var$isThrottlingError = function(statusCode, errorCode) {
    return statusCode === 429 || $87853ac980d212ed$var$THROTTLING_ERROR_CODES.includes(errorCode);
};
var $87853ac980d212ed$var$isConnectionError = function(error) {
    return (error === null || error === void 0 ? void 0 : error.name) === "Network error";
};
var $87853ac980d212ed$var$isServerSideError = function(statusCode, errorCode) {
    return [
        500,
        502,
        503,
        504
    ].includes(statusCode) || $87853ac980d212ed$var$TIMEOUT_ERROR_CODES.includes(errorCode);
};

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: [v6] The separate retry utility is used by Data packages now and will replaced by retry middleware.

var $6e5ff8686fd7c540$var$DEFAULT_MAX_DELAY_MS = 300000;
var $6e5ff8686fd7c540$export$caea50bde345f648 = function(attempt) {
    var delayFunction = (0, $e630ff0a3924a99b$export$caea50bde345f648)($6e5ff8686fd7c540$var$DEFAULT_MAX_DELAY_MS);
    var delay = delayFunction(attempt);
    // The delayFunction returns false when the delay is greater than the max delay(5 mins).
    // In this case, the retry middleware will delay 5 mins instead, as a ceiling of the delay.
    return delay === false ? $6e5ff8686fd7c540$var$DEFAULT_MAX_DELAY_MS : delay;
};




var $65483638d70e2781$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $65483638d70e2781$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
/**
 * The service name used to sign requests if the API requires authentication.
 */ var $65483638d70e2781$var$SERVICE_NAME = "cognito-identity";
/**
 * The endpoint resolver function that returns the endpoint URL for a given region.
 */ var $65483638d70e2781$var$endpointResolver = function(_a) {
    var region = _a.region;
    return {
        url: new URL("https://cognito-identity.".concat(region, ".").concat((0, $045984a6263bd645$export$1c28e37cdcc37f6d)(region)))
    };
};
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ var $65483638d70e2781$var$disableCacheMiddleware = function() {
    return function(next, context) {
        return function disableCacheMiddleware(request) {
            return $65483638d70e2781$var$__awaiter(this, void 0, void 0, function() {
                return $65483638d70e2781$var$__generator(this, function(_a) {
                    request.headers["cache-control"] = "no-store";
                    return [
                        2 /*return*/ ,
                        next(request)
                    ];
                });
            });
        };
    };
};
var $65483638d70e2781$export$8029646671d2c482 = (0, $7c6efce776c036f5$export$f074d76e52925468)((0, $57812d3f7f02ece1$export$ed7e1ccf00f39c4a), [
    $65483638d70e2781$var$disableCacheMiddleware
]);
var $65483638d70e2781$export$f84bd70098573c5c = {
    service: $65483638d70e2781$var$SERVICE_NAME,
    endpointResolver: $65483638d70e2781$var$endpointResolver,
    retryDecider: (0, $87853ac980d212ed$export$b919d98317a7685f)((0, $8bf6542fe3057a62$export$be467dfcc0538e25)),
    computeDelay: (0, $6e5ff8686fd7c540$export$caea50bde345f648),
    userAgentValue: (0, $0d25e50bf44b1a9b$export$ede38edb26c0bfdf)()
};
(0, $cd82d9b57ae46de9$export$5d5c467ce0b213f)(function() {
    $65483638d70e2781$export$f84bd70098573c5c.userAgentValue = (0, $0d25e50bf44b1a9b$export$ede38edb26c0bfdf)();
});
var $65483638d70e2781$export$a46bbeaba09f7285 = function(operation) {
    return {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "AWSCognitoIdentityService.".concat(operation)
    };
};
var $65483638d70e2781$export$a692bdb7eb624f96 = function(_a, headers, body) {
    var url = _a.url;
    return {
        headers: headers,
        url: url,
        body: body,
        method: "POST"
    };
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $ed795cf51f5bd210$var$__assign = undefined && undefined.__assign || function() {
    $ed795cf51f5bd210$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ed795cf51f5bd210$var$__assign.apply(this, arguments);
};
var $ed795cf51f5bd210$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ed795cf51f5bd210$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $ed795cf51f5bd210$export$880429a8ae983d4d = function(transferHandler, serializer, deserializer, defaultConfig) {
    return function(config, input) {
        return $ed795cf51f5bd210$var$__awaiter(void 0, void 0, void 0, function() {
            var resolvedConfig, endpoint, request, response;
            return $ed795cf51f5bd210$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        resolvedConfig = $ed795cf51f5bd210$var$__assign($ed795cf51f5bd210$var$__assign({}, defaultConfig), config);
                        return [
                            4 /*yield*/ ,
                            resolvedConfig.endpointResolver(resolvedConfig, input)
                        ];
                    case 1:
                        endpoint = _a.sent();
                        return [
                            4 /*yield*/ ,
                            serializer(input, endpoint)
                        ];
                    case 2:
                        request = _a.sent();
                        return [
                            4 /*yield*/ ,
                            transferHandler(request, $ed795cf51f5bd210$var$__assign({}, resolvedConfig))
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            deserializer(response)
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
};


var $f223afe81790eec3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f223afe81790eec3$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $f223afe81790eec3$var$getCredentialsForIdentitySerializer = function(input, endpoint) {
    var headers = (0, $65483638d70e2781$export$a46bbeaba09f7285)("GetCredentialsForIdentity");
    var body = JSON.stringify(input);
    return (0, $65483638d70e2781$export$a692bdb7eb624f96)(endpoint, headers, body);
};
var $f223afe81790eec3$var$getCredentialsForIdentityDeserializer = function(response) {
    return $f223afe81790eec3$var$__awaiter(void 0, void 0, void 0, function() {
        var error, body;
        return $f223afe81790eec3$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $8bf6542fe3057a62$export$be467dfcc0538e25)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, $8bf6542fe3057a62$export$759bcb35b0d1bf81)(response)
                    ];
                case 3:
                    body = _a.sent();
                    return [
                        2 /*return*/ ,
                        {
                            IdentityId: body.IdentityId,
                            Credentials: $f223afe81790eec3$var$deserializeCredentials(body.Credentials),
                            $metadata: (0, $fe0ec52dee712a0c$export$978f9418fe0cb26c)(response)
                        }
                    ];
            }
        });
    });
};
var $f223afe81790eec3$var$deserializeCredentials = function(output) {
    if (output === void 0) output = {};
    return {
        AccessKeyId: output["AccessKeyId"],
        SecretKey: output["SecretKey"],
        SessionToken: output["SessionToken"],
        Expiration: new Date(output["Expiration"] * 1000)
    };
};
var $f223afe81790eec3$export$a49c1c173ab96b58 = (0, $ed795cf51f5bd210$export$880429a8ae983d4d)((0, $65483638d70e2781$export$8029646671d2c482), $f223afe81790eec3$var$getCredentialsForIdentitySerializer, $f223afe81790eec3$var$getCredentialsForIdentityDeserializer, (0, $65483638d70e2781$export$f84bd70098573c5c));

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



var $7fc1b42be59d47d7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7fc1b42be59d47d7$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $7fc1b42be59d47d7$var$getIdSerializer = function(input, endpoint) {
    var headers = (0, $65483638d70e2781$export$a46bbeaba09f7285)("GetId");
    var body = JSON.stringify(input);
    return (0, $65483638d70e2781$export$a692bdb7eb624f96)(endpoint, headers, body);
};
var $7fc1b42be59d47d7$var$getIdDeserializer = function(response) {
    return $7fc1b42be59d47d7$var$__awaiter(void 0, void 0, void 0, function() {
        var error, body;
        return $7fc1b42be59d47d7$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $8bf6542fe3057a62$export$be467dfcc0538e25)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, $8bf6542fe3057a62$export$759bcb35b0d1bf81)(response)
                    ];
                case 3:
                    body = _a.sent();
                    return [
                        2 /*return*/ ,
                        {
                            IdentityId: body.IdentityId,
                            $metadata: (0, $fe0ec52dee712a0c$export$978f9418fe0cb26c)(response)
                        }
                    ];
            }
        });
    });
};
var $7fc1b42be59d47d7$export$218c8c3169c024d2 = (0, $ed795cf51f5bd210$export$880429a8ae983d4d)((0, $65483638d70e2781$export$8029646671d2c482), $7fc1b42be59d47d7$var$getIdSerializer, $7fc1b42be59d47d7$var$getIdDeserializer, (0, $65483638d70e2781$export$f84bd70098573c5c));




var $44b8a981f31e24b5$var$__assign = undefined && undefined.__assign || function() {
    $44b8a981f31e24b5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $44b8a981f31e24b5$var$__assign.apply(this, arguments);
};
var $44b8a981f31e24b5$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $44b8a981f31e24b5$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $44b8a981f31e24b5$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("Credentials");
var $44b8a981f31e24b5$var$CREDENTIALS_TTL = 3000000; // 50 min, can be modified on config if required in the future
var $44b8a981f31e24b5$var$COGNITO_IDENTITY_KEY_PREFIX = "CognitoIdentityId-";
var $44b8a981f31e24b5$var$AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var $44b8a981f31e24b5$var$dispatchCredentialsEvent = function(event, data, message) {
    (0, $3b4d9bb645fe011c$export$8c41bb232f1008b1).dispatch("core", {
        event: event,
        data: data,
        message: message
    }, "Credentials", $44b8a981f31e24b5$var$AMPLIFY_SYMBOL);
};
var $44b8a981f31e24b5$export$9be509043bd0c09a = /** @class */ function() {
    function CredentialsClass(config) {
        this._gettingCredPromise = null;
        this._refreshHandlers = {};
        // Allow `Auth` to be injected for SSR, but Auth isn't a required dependency for Credentials
        this.Auth = undefined;
        this.configure(config);
        this._refreshHandlers["google"] = (0, $9851706019ceefa3$export$75ace714083c1340).refreshGoogleToken;
        this._refreshHandlers["facebook"] = (0, $9851706019ceefa3$export$1b6b8b5328e38349).refreshFacebookToken;
    }
    CredentialsClass.prototype.getModuleName = function() {
        return "Credentials";
    };
    CredentialsClass.prototype.getCredSource = function() {
        return this._credentials_source;
    };
    CredentialsClass.prototype.configure = function(config) {
        if (!config) return this._config || {};
        this._config = Object.assign({}, this._config, config);
        var refreshHandlers = this._config.refreshHandlers;
        // If the developer has provided an object of refresh handlers,
        // then we can merge the provided handlers with the current handlers.
        if (refreshHandlers) this._refreshHandlers = $44b8a981f31e24b5$var$__assign($44b8a981f31e24b5$var$__assign({}, this._refreshHandlers), refreshHandlers);
        this._storage = this._config.storage;
        if (!this._storage) this._storage = new (0, $7a09b30b2e4e0fe6$export$a2bd19c49e4760e8)().getStorage();
        this._storageSync = Promise.resolve();
        if (typeof this._storage["sync"] === "function") this._storageSync = this._storage["sync"]();
        $44b8a981f31e24b5$var$dispatchCredentialsEvent("credentials_configured", null, "Credentials has been configured successfully");
        return this._config;
    };
    CredentialsClass.prototype.get = function() {
        $44b8a981f31e24b5$var$logger.debug("getting credentials");
        return this._pickupCredentials();
    };
    // currently we only store the guest identity in local storage
    CredentialsClass.prototype._getCognitoIdentityIdStorageKey = function(identityPoolId) {
        return "".concat($44b8a981f31e24b5$var$COGNITO_IDENTITY_KEY_PREFIX).concat(identityPoolId);
    };
    CredentialsClass.prototype._pickupCredentials = function() {
        $44b8a981f31e24b5$var$logger.debug("picking up credentials");
        if (!this._gettingCredPromise || !this._gettingCredPromise.isPending()) {
            $44b8a981f31e24b5$var$logger.debug("getting new cred promise");
            this._gettingCredPromise = (0, $4fe24881fb69f2d5$export$8f33cb495ca11832)(this._keepAlive());
        } else $44b8a981f31e24b5$var$logger.debug("getting old cred promise");
        return this._gettingCredPromise;
    };
    CredentialsClass.prototype._keepAlive = function() {
        return $44b8a981f31e24b5$var$__awaiter(this, void 0, void 0, function() {
            var cred, _a, Auth, user_1, session, refreshToken_1, refreshRequest, err_1;
            return $44b8a981f31e24b5$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $44b8a981f31e24b5$var$logger.debug("checking if credentials exists and not expired");
                        cred = this._credentials;
                        if (cred && !this._isExpired(cred) && !this._isPastTTL()) {
                            $44b8a981f31e24b5$var$logger.debug("credentials not changed and not expired, directly return");
                            return [
                                2 /*return*/ ,
                                Promise.resolve(cred)
                            ];
                        }
                        $44b8a981f31e24b5$var$logger.debug("need to get a new credential or refresh the existing one");
                        _a = this.Auth, Auth = _a === void 0 ? (0, $6ff5c7c169206e21$export$a3858a9a153cffc7).Auth : _a;
                        if (!Auth || typeof Auth.currentUserCredentials !== "function") // If Auth module is not imported, do a best effort to get guest credentials
                        return [
                            2 /*return*/ ,
                            this._setCredentialsForGuest()
                        ];
                        if (!(!this._isExpired(cred) && this._isPastTTL())) return [
                            3 /*break*/ ,
                            6
                        ];
                        $44b8a981f31e24b5$var$logger.debug("ttl has passed but token is not yet expired");
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            Auth.currentUserPoolUser()
                        ];
                    case 2:
                        user_1 = _b.sent();
                        return [
                            4 /*yield*/ ,
                            Auth.currentSession()
                        ];
                    case 3:
                        session = _b.sent();
                        refreshToken_1 = session.refreshToken;
                        refreshRequest = new Promise(function(res, rej) {
                            user_1.refreshSession(refreshToken_1, function(err, data) {
                                return err ? rej(err) : res(data);
                            });
                        });
                        return [
                            4 /*yield*/ ,
                            refreshRequest
                        ];
                    case 4:
                        _b.sent(); // note that rejections will be caught and handled in the catch block.
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        err_1 = _b.sent();
                        // should not throw because user might just be on guest access or is authenticated through federation
                        $44b8a981f31e24b5$var$logger.debug("Error attempting to refreshing the session", err_1);
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            2 /*return*/ ,
                            Auth.currentUserCredentials()
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype.refreshFederatedToken = function(federatedInfo) {
        $44b8a981f31e24b5$var$logger.debug("Getting federated credentials");
        var provider = federatedInfo.provider, user = federatedInfo.user, token = federatedInfo.token, identity_id = federatedInfo.identity_id;
        var expires_at = federatedInfo.expires_at;
        // Make sure expires_at is in millis
        expires_at = new Date(expires_at).getFullYear() === 1970 ? expires_at * 1000 : expires_at;
        var that = this;
        $44b8a981f31e24b5$var$logger.debug("checking if federated jwt token expired");
        if (expires_at > new Date().getTime()) {
            // if not expired
            $44b8a981f31e24b5$var$logger.debug("token not expired");
            return this._setCredentialsFromFederation({
                provider: provider,
                token: token,
                user: user,
                identity_id: identity_id,
                expires_at: expires_at
            });
        } else // if refresh handler exists
        if (that._refreshHandlers[provider] && typeof that._refreshHandlers[provider] === "function") {
            $44b8a981f31e24b5$var$logger.debug("getting refreshed jwt token from federation provider");
            return this._providerRefreshWithRetry({
                refreshHandler: that._refreshHandlers[provider],
                provider: provider,
                user: user
            });
        } else {
            $44b8a981f31e24b5$var$logger.debug("no refresh handler for provider:", provider);
            this.clear();
            return Promise.reject("no refresh handler for provider");
        }
    };
    CredentialsClass.prototype._providerRefreshWithRetry = function(_a) {
        var _this = this;
        var refreshHandler = _a.refreshHandler, provider = _a.provider, user = _a.user;
        var MAX_DELAY_MS = 10000;
        // refreshHandler will retry network errors, otherwise it will
        // return NonRetryableError to break out of jitteredExponentialRetry
        return (0, $e630ff0a3924a99b$export$a24aa7705df9cf44)(refreshHandler, [], MAX_DELAY_MS).then(function(data) {
            $44b8a981f31e24b5$var$logger.debug("refresh federated token sucessfully", data);
            return _this._setCredentialsFromFederation({
                provider: provider,
                token: data.token,
                user: user,
                identity_id: data.identity_id,
                expires_at: data.expires_at
            });
        }).catch(function(e) {
            var isNetworkError = typeof e === "string" && e.toLowerCase().lastIndexOf("network error", e.length) === 0;
            if (!isNetworkError) _this.clear();
            $44b8a981f31e24b5$var$logger.debug("refresh federated token failed", e);
            return Promise.reject("refreshing federation token failed: " + e);
        });
    };
    CredentialsClass.prototype._isExpired = function(credentials) {
        if (!credentials) {
            $44b8a981f31e24b5$var$logger.debug("no credentials for expiration check");
            return true;
        }
        $44b8a981f31e24b5$var$logger.debug("are these credentials expired?", credentials);
        var ts = Date.now();
        /* returns date object.
            https://github.com/aws/aws-sdk-js-v3/blob/v1.0.0-beta.1/packages/types/src/credentials.ts#L26
        */ var expiration = credentials.expiration;
        return expiration.getTime() <= ts;
    };
    CredentialsClass.prototype._isPastTTL = function() {
        return this._nextCredentialsRefresh <= Date.now();
    };
    CredentialsClass.prototype._setCredentialsForGuest = function() {
        var _a;
        return $44b8a981f31e24b5$var$__awaiter(this, void 0, void 0, function() {
            var _b, identityPoolId, region, mandatorySignIn, identityPoolRegion, identityId, _c, cognitoConfig, guestCredentialsProvider, credentials;
            var _this = this;
            return $44b8a981f31e24b5$var$__generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        $44b8a981f31e24b5$var$logger.debug("setting credentials for guest");
                        if (!((_a = this._config) === null || _a === void 0 ? void 0 : _a.identityPoolId)) // If Credentials are not configured thru Auth module,
                        // doing best effort to check if the library was configured
                        this._config = Object.assign({}, this._config, (0, $d0434983171bcfb8$export$1ef2e9c2da492d)(this._config || {}).Auth);
                        _b = this._config, identityPoolId = _b.identityPoolId, region = _b.region, mandatorySignIn = _b.mandatorySignIn, identityPoolRegion = _b.identityPoolRegion;
                        if (mandatorySignIn) return [
                            2 /*return*/ ,
                            Promise.reject("cannot get guest credentials when mandatory signin enabled")
                        ];
                        if (!identityPoolId) {
                            $44b8a981f31e24b5$var$logger.debug("No Cognito Identity pool provided for unauthenticated access");
                            return [
                                2 /*return*/ ,
                                Promise.reject("No Cognito Identity pool provided for unauthenticated access")
                            ];
                        }
                        if (!identityPoolRegion && !region) {
                            $44b8a981f31e24b5$var$logger.debug("region is not configured for getting the credentials");
                            return [
                                2 /*return*/ ,
                                Promise.reject("region is not configured for getting the credentials")
                            ];
                        }
                        _c = this;
                        return [
                            4 /*yield*/ ,
                            this._getGuestIdentityId()
                        ];
                    case 1:
                        identityId = _c._identityId = _d.sent();
                        cognitoConfig = {
                            region: identityPoolRegion !== null && identityPoolRegion !== void 0 ? identityPoolRegion : region
                        };
                        guestCredentialsProvider = function() {
                            return $44b8a981f31e24b5$var$__awaiter(_this, void 0, void 0, function() {
                                var IdentityId, Credentials;
                                return $44b8a981f31e24b5$var$__generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            if (!!identityId) return [
                                                3 /*break*/ ,
                                                2
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                (0, $7fc1b42be59d47d7$export$218c8c3169c024d2)(cognitoConfig, {
                                                    IdentityPoolId: identityPoolId
                                                })
                                            ];
                                        case 1:
                                            IdentityId = _a.sent().IdentityId;
                                            this._identityId = IdentityId;
                                            _a.label = 2;
                                        case 2:
                                            return [
                                                4 /*yield*/ ,
                                                (0, $f223afe81790eec3$export$a49c1c173ab96b58)(cognitoConfig, {
                                                    IdentityId: this._identityId
                                                })
                                            ];
                                        case 3:
                                            Credentials = _a.sent().Credentials;
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    identityId: this._identityId,
                                                    accessKeyId: Credentials.AccessKeyId,
                                                    secretAccessKey: Credentials.SecretKey,
                                                    sessionToken: Credentials.SessionToken,
                                                    expiration: Credentials.Expiration
                                                }
                                            ];
                                    }
                                });
                            });
                        };
                        credentials = guestCredentialsProvider().catch(function(err) {
                            return $44b8a981f31e24b5$var$__awaiter(_this, void 0, void 0, function() {
                                return $44b8a981f31e24b5$var$__generator(this, function(_a) {
                                    throw err;
                                });
                            });
                        });
                        return [
                            2 /*return*/ ,
                            this._loadCredentials(credentials, "guest", false, null).then(function(res) {
                                return res;
                            }).catch(function(e) {
                                return $44b8a981f31e24b5$var$__awaiter(_this, void 0, void 0, function() {
                                    var guestCredentialsProvider_1;
                                    var _this = this;
                                    return $44b8a981f31e24b5$var$__generator(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                if (!(e.name === "ResourceNotFoundException" && e.message === "Identity '".concat(identityId, "' not found."))) return [
                                                    3 /*break*/ ,
                                                    2
                                                ];
                                                $44b8a981f31e24b5$var$logger.debug("Failed to load guest credentials");
                                                return [
                                                    4 /*yield*/ ,
                                                    this._removeGuestIdentityId()
                                                ];
                                            case 1:
                                                _a.sent();
                                                guestCredentialsProvider_1 = function() {
                                                    return $44b8a981f31e24b5$var$__awaiter(_this, void 0, void 0, function() {
                                                        var IdentityId, Credentials;
                                                        return $44b8a981f31e24b5$var$__generator(this, function(_a) {
                                                            switch(_a.label){
                                                                case 0:
                                                                    return [
                                                                        4 /*yield*/ ,
                                                                        (0, $7fc1b42be59d47d7$export$218c8c3169c024d2)(cognitoConfig, {
                                                                            IdentityPoolId: identityPoolId
                                                                        })
                                                                    ];
                                                                case 1:
                                                                    IdentityId = _a.sent().IdentityId;
                                                                    this._identityId = IdentityId;
                                                                    return [
                                                                        4 /*yield*/ ,
                                                                        (0, $f223afe81790eec3$export$a49c1c173ab96b58)(cognitoConfig, {
                                                                            IdentityId: IdentityId
                                                                        })
                                                                    ];
                                                                case 2:
                                                                    Credentials = _a.sent().Credentials;
                                                                    return [
                                                                        2 /*return*/ ,
                                                                        {
                                                                            identityId: IdentityId,
                                                                            accessKeyId: Credentials.AccessKeyId,
                                                                            secretAccessKey: Credentials.SecretKey,
                                                                            sessionToken: Credentials.SessionToken,
                                                                            expiration: Credentials.Expiration
                                                                        }
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                };
                                                credentials = guestCredentialsProvider_1().catch(function(err) {
                                                    return $44b8a981f31e24b5$var$__awaiter(_this, void 0, void 0, function() {
                                                        return $44b8a981f31e24b5$var$__generator(this, function(_a) {
                                                            throw err;
                                                        });
                                                    });
                                                });
                                                return [
                                                    2 /*return*/ ,
                                                    this._loadCredentials(credentials, "guest", false, null)
                                                ];
                                            case 2:
                                                return [
                                                    2 /*return*/ ,
                                                    e
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._setCredentialsFromFederation = function(params) {
        var _this = this;
        var provider = params.provider, token = params.token;
        var identity_id = params.identity_id;
        var domains = {
            google: "accounts.google.com",
            facebook: "graph.facebook.com",
            amazon: "www.amazon.com",
            developer: "cognito-identity.amazonaws.com"
        };
        // Use custom provider url instead of the predefined ones
        var domain = domains[provider] || provider;
        if (!domain) return Promise.reject("You must specify a federated provider");
        var logins = {};
        logins[domain] = token;
        var _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region, identityPoolRegion = _a.identityPoolRegion;
        if (!identityPoolId) {
            $44b8a981f31e24b5$var$logger.debug("No Cognito Federated Identity pool provided");
            return Promise.reject("No Cognito Federated Identity pool provided");
        }
        if (!identityPoolRegion && !region) {
            $44b8a981f31e24b5$var$logger.debug("region is not configured for getting the credentials");
            return Promise.reject("region is not configured for getting the credentials");
        }
        var cognitoConfig = {
            region: identityPoolRegion !== null && identityPoolRegion !== void 0 ? identityPoolRegion : region
        };
        var authenticatedCredentialsProvider = function() {
            return $44b8a981f31e24b5$var$__awaiter(_this, void 0, void 0, function() {
                var IdentityId, Credentials;
                return $44b8a981f31e24b5$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!!identity_id) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, $7fc1b42be59d47d7$export$218c8c3169c024d2)(cognitoConfig, {
                                    IdentityPoolId: identityPoolId,
                                    Logins: logins
                                })
                            ];
                        case 1:
                            IdentityId = _a.sent().IdentityId;
                            identity_id = IdentityId;
                            _a.label = 2;
                        case 2:
                            return [
                                4 /*yield*/ ,
                                (0, $f223afe81790eec3$export$a49c1c173ab96b58)(cognitoConfig, {
                                    IdentityId: identity_id,
                                    Logins: logins
                                })
                            ];
                        case 3:
                            Credentials = _a.sent().Credentials;
                            return [
                                2 /*return*/ ,
                                {
                                    identityId: identity_id,
                                    accessKeyId: Credentials.AccessKeyId,
                                    secretAccessKey: Credentials.SecretKey,
                                    sessionToken: Credentials.SessionToken,
                                    expiration: Credentials.Expiration
                                }
                            ];
                    }
                });
            });
        };
        var credentials = authenticatedCredentialsProvider().catch(function(err) {
            return $44b8a981f31e24b5$var$__awaiter(_this, void 0, void 0, function() {
                return $44b8a981f31e24b5$var$__generator(this, function(_a) {
                    throw err;
                });
            });
        });
        return this._loadCredentials(credentials, "federated", true, params);
    };
    CredentialsClass.prototype._setCredentialsFromSession = function(session) {
        var _this = this;
        $44b8a981f31e24b5$var$logger.debug("set credentials from session");
        var idToken = session.getIdToken().getJwtToken();
        var _a = this._config, region = _a.region, userPoolId = _a.userPoolId, identityPoolId = _a.identityPoolId, identityPoolRegion = _a.identityPoolRegion;
        if (!identityPoolId) {
            $44b8a981f31e24b5$var$logger.debug("No Cognito Federated Identity pool provided");
            return Promise.reject("No Cognito Federated Identity pool provided");
        }
        if (!identityPoolRegion && !region) {
            $44b8a981f31e24b5$var$logger.debug("region is not configured for getting the credentials");
            return Promise.reject("region is not configured for getting the credentials");
        }
        var key = "cognito-idp." + region + ".amazonaws.com/" + userPoolId;
        var logins = {};
        logins[key] = idToken;
        var cognitoConfig = {
            region: identityPoolRegion !== null && identityPoolRegion !== void 0 ? identityPoolRegion : region
        };
        /*
            Retreiving identityId with GetIdCommand to mimic the behavior in the following code in aws-sdk-v3:
            https://git.io/JeDxU

            Note: Retreive identityId from CredentialsProvider once aws-sdk-js v3 supports this.
        */ var credentialsProvider = function() {
            return $44b8a981f31e24b5$var$__awaiter(_this, void 0, void 0, function() {
                var guestIdentityId, generatedOrRetrievedIdentityId, IdentityId, _a, _b, AccessKeyId, Expiration, SecretKey, SessionToken, primaryIdentityId;
                return $44b8a981f31e24b5$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this._getGuestIdentityId()
                            ];
                        case 1:
                            guestIdentityId = _c.sent();
                            if (!!guestIdentityId) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, $7fc1b42be59d47d7$export$218c8c3169c024d2)(cognitoConfig, {
                                    IdentityPoolId: identityPoolId,
                                    Logins: logins
                                })
                            ];
                        case 2:
                            IdentityId = _c.sent().IdentityId;
                            generatedOrRetrievedIdentityId = IdentityId;
                            _c.label = 3;
                        case 3:
                            return [
                                4 /*yield*/ ,
                                (0, $f223afe81790eec3$export$a49c1c173ab96b58)(cognitoConfig, {
                                    IdentityId: guestIdentityId || generatedOrRetrievedIdentityId,
                                    Logins: logins
                                })
                            ];
                        case 4:
                            _a = _c.sent(), _b = _a.Credentials, AccessKeyId = _b.AccessKeyId, Expiration = _b.Expiration, SecretKey = _b.SecretKey, SessionToken = _b.SessionToken, primaryIdentityId = _a.IdentityId;
                            this._identityId = primaryIdentityId;
                            if (!guestIdentityId) return [
                                3 /*break*/ ,
                                6
                            ];
                            // if guestIdentity is found and used by GetCredentialsForIdentity
                            // it will be linked to the logins provided, and disqualified as an unauth identity
                            $44b8a981f31e24b5$var$logger.debug("The guest identity ".concat(guestIdentityId, " has been successfully linked to the logins"));
                            if (guestIdentityId === primaryIdentityId) $44b8a981f31e24b5$var$logger.debug("The guest identity ".concat(guestIdentityId, " has become the primary identity"));
                            // remove it from local storage to avoid being used as a guest Identity by _setCredentialsForGuest
                            return [
                                4 /*yield*/ ,
                                this._removeGuestIdentityId()
                            ];
                        case 5:
                            // remove it from local storage to avoid being used as a guest Identity by _setCredentialsForGuest
                            _c.sent();
                            _c.label = 6;
                        case 6:
                            // https://github.com/aws/aws-sdk-js-v3/blob/main/packages/credential-provider-cognito-identity/src/fromCognitoIdentity.ts#L40
                            return [
                                2 /*return*/ ,
                                {
                                    accessKeyId: AccessKeyId,
                                    secretAccessKey: SecretKey,
                                    sessionToken: SessionToken,
                                    expiration: Expiration,
                                    identityId: primaryIdentityId
                                }
                            ];
                    }
                });
            });
        };
        var credentials = credentialsProvider().catch(function(err) {
            return $44b8a981f31e24b5$var$__awaiter(_this, void 0, void 0, function() {
                return $44b8a981f31e24b5$var$__generator(this, function(_a) {
                    throw err;
                });
            });
        });
        return this._loadCredentials(credentials, "userPool", true, null);
    };
    CredentialsClass.prototype._loadCredentials = function(credentials, source, authenticated, info) {
        var _this = this;
        var that = this;
        return new Promise(function(res, rej) {
            credentials.then(function(credentials) {
                return $44b8a981f31e24b5$var$__awaiter(_this, void 0, void 0, function() {
                    var user, provider, token, expires_at, identity_id;
                    return $44b8a981f31e24b5$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                $44b8a981f31e24b5$var$logger.debug("Load credentials successfully", credentials);
                                if (this._identityId && !credentials.identityId) credentials["identityId"] = this._identityId;
                                that._credentials = credentials;
                                that._credentials.authenticated = authenticated;
                                that._credentials_source = source;
                                that._nextCredentialsRefresh = new Date().getTime() + $44b8a981f31e24b5$var$CREDENTIALS_TTL;
                                if (source === "federated") {
                                    user = Object.assign({
                                        id: this._credentials.identityId
                                    }, info.user);
                                    provider = info.provider, token = info.token, expires_at = info.expires_at, identity_id = info.identity_id;
                                    try {
                                        this._storage.setItem("aws-amplify-federatedInfo", JSON.stringify({
                                            provider: provider,
                                            token: token,
                                            user: user,
                                            expires_at: expires_at,
                                            identity_id: identity_id
                                        }));
                                    } catch (e) {
                                        $44b8a981f31e24b5$var$logger.debug("Failed to put federated info into auth storage", e);
                                    }
                                }
                                if (!(source === "guest")) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    this._setGuestIdentityId(credentials.identityId)
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                res(that._credentials);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }).catch(function(err) {
                if (err) {
                    $44b8a981f31e24b5$var$logger.debug("Failed to load credentials", credentials);
                    $44b8a981f31e24b5$var$logger.debug("Error loading credentials", err);
                    rej(err);
                    return;
                }
            });
        });
    };
    CredentialsClass.prototype.set = function(params, source) {
        if (source === "session") return this._setCredentialsFromSession(params);
        else if (source === "federation") return this._setCredentialsFromFederation(params);
        else if (source === "guest") return this._setCredentialsForGuest();
        else {
            $44b8a981f31e24b5$var$logger.debug("no source specified for setting credentials");
            return Promise.reject("invalid source");
        }
    };
    CredentialsClass.prototype.clear = function() {
        return $44b8a981f31e24b5$var$__awaiter(this, void 0, void 0, function() {
            return $44b8a981f31e24b5$var$__generator(this, function(_a) {
                this._credentials = null;
                this._credentials_source = null;
                $44b8a981f31e24b5$var$logger.debug("removing aws-amplify-federatedInfo from storage");
                this._storage.removeItem("aws-amplify-federatedInfo");
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /* operations on local stored guest identity */ CredentialsClass.prototype._getGuestIdentityId = function() {
        return $44b8a981f31e24b5$var$__awaiter(this, void 0, void 0, function() {
            var identityPoolId, e_1;
            return $44b8a981f31e24b5$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        identityPoolId = this._config.identityPoolId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            this._storage.getItem(this._getCognitoIdentityIdStorageKey(identityPoolId))
                        ];
                    case 3:
                        e_1 = _a.sent();
                        $44b8a981f31e24b5$var$logger.debug("Failed to get the cached guest identityId", e_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._setGuestIdentityId = function(identityId) {
        return $44b8a981f31e24b5$var$__awaiter(this, void 0, void 0, function() {
            var identityPoolId, e_2;
            return $44b8a981f31e24b5$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        identityPoolId = this._config.identityPoolId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        this._storage.setItem(this._getCognitoIdentityIdStorageKey(identityPoolId), identityId);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_2 = _a.sent();
                        $44b8a981f31e24b5$var$logger.debug("Failed to cache guest identityId", e_2);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._removeGuestIdentityId = function() {
        return $44b8a981f31e24b5$var$__awaiter(this, void 0, void 0, function() {
            var identityPoolId;
            return $44b8a981f31e24b5$var$__generator(this, function(_a) {
                identityPoolId = this._config.identityPoolId;
                $44b8a981f31e24b5$var$logger.debug("removing ".concat(this._getCognitoIdentityIdStorageKey(identityPoolId), " from storage"));
                this._storage.removeItem(this._getCognitoIdentityIdStorageKey(identityPoolId));
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ CredentialsClass.prototype.shear = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    return CredentialsClass;
}();
var $44b8a981f31e24b5$export$a9627919734faa48 = new $44b8a981f31e24b5$export$9be509043bd0c09a(null);
(0, $6ff5c7c169206e21$export$a3858a9a153cffc7).register($44b8a981f31e24b5$export$a9627919734faa48);




/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $16539d2dc16d64b1$export$98e6a39c04603d36;
var $16539d2dc16d64b1$export$dfdc1655ccc5b9cb;
"use strict";
$16539d2dc16d64b1$export$98e6a39c04603d36 = $16539d2dc16d64b1$var$parse;
$16539d2dc16d64b1$export$dfdc1655ccc5b9cb = $16539d2dc16d64b1$var$serialize;
/**
 * Module variables.
 * @private
 */ var $16539d2dc16d64b1$var$decode = decodeURIComponent;
var $16539d2dc16d64b1$var$encode = encodeURIComponent;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */ var $16539d2dc16d64b1$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */ function $16539d2dc16d64b1$var$parse(str, options) {
    if (typeof str !== "string") throw new TypeError("argument str must be a string");
    var obj = {};
    var opt = options || {};
    var pairs = str.split(";");
    var dec = opt.decode || $16539d2dc16d64b1$var$decode;
    for(var i = 0; i < pairs.length; i++){
        var pair = pairs[i];
        var index = pair.indexOf("=");
        // skip things that don't look like key=value
        if (index < 0) continue;
        var key = pair.substring(0, index).trim();
        // only assign once
        if (undefined == obj[key]) {
            var val = pair.substring(index + 1, pair.length).trim();
            // quoted values
            if (val[0] === '"') val = val.slice(1, -1);
            obj[key] = $16539d2dc16d64b1$var$tryDecode(val, dec);
        }
    }
    return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */ function $16539d2dc16d64b1$var$serialize(name, val, options) {
    var opt = options || {};
    var enc = opt.encode || $16539d2dc16d64b1$var$encode;
    if (typeof enc !== "function") throw new TypeError("option encode is invalid");
    if (!$16539d2dc16d64b1$var$fieldContentRegExp.test(name)) throw new TypeError("argument name is invalid");
    var value = enc(val);
    if (value && !$16539d2dc16d64b1$var$fieldContentRegExp.test(value)) throw new TypeError("argument val is invalid");
    var str = name + "=" + value;
    if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) throw new TypeError("option maxAge is invalid");
        str += "; Max-Age=" + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!$16539d2dc16d64b1$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=" + opt.domain;
    }
    if (opt.path) {
        if (!$16539d2dc16d64b1$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=" + opt.path;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=" + opt.expires.toUTCString();
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */ function $16539d2dc16d64b1$var$tryDecode(str, decode) {
    try {
        return decode(str);
    } catch (e) {
        return str;
    }
}



function $66269edbe5b3d3ad$export$56232575010ba89() {
    // Can we get/set cookies on document.cookie?
    return typeof document === "object" && typeof document.cookie === "string";
}
function $66269edbe5b3d3ad$export$bfce569af136abdc() {
    document.cookie.split(";").forEach(function(c) {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
}
function $66269edbe5b3d3ad$export$d2e637738f5e6ae8(cookies, options) {
    if (typeof cookies === "string") return $16539d2dc16d64b1$export$98e6a39c04603d36(cookies, options);
    else if (typeof cookies === "object" && cookies !== null) return cookies;
    else return {};
}
function $66269edbe5b3d3ad$export$9f55e081dbb22cd9(value, doNotParse) {
    if (typeof doNotParse === "undefined") // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== "{" && value[0] !== "[" && value[0] !== '"';
    return !doNotParse;
}
function $66269edbe5b3d3ad$export$bead674655ff515d(value, options) {
    if (options === void 0) options = {};
    var cleanValue = $66269edbe5b3d3ad$var$cleanupCookieValue(value);
    if ($66269edbe5b3d3ad$export$9f55e081dbb22cd9(cleanValue, options.doNotParse)) try {
        return JSON.parse(cleanValue);
    } catch (e) {
    // At least we tried
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function $66269edbe5b3d3ad$var$cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === "j" && value[1] === ":") return value.substr(2);
    return value;
}


var $255eada7dbdf2b17$var$__assign = undefined && undefined.__assign || function() {
    $255eada7dbdf2b17$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $255eada7dbdf2b17$var$__assign.apply(this, arguments);
};
var $255eada7dbdf2b17$var$Cookies = /** @class */ function() {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = (0, $66269edbe5b3d3ad$export$d2e637738f5e6ae8)(cookies, options);
        new Promise(function() {
            _this.HAS_DOCUMENT_COOKIE = (0, $66269edbe5b3d3ad$export$56232575010ba89)();
        }).catch(function() {});
    }
    Cookies.prototype._updateBrowserValues = function(parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) return;
        this.cookies = $16539d2dc16d64b1$export$98e6a39c04603d36(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function(params) {
        for(var i = 0; i < this.changeListeners.length; ++i)this.changeListeners[i](params);
    };
    Cookies.prototype.get = function(name, options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        return (0, $66269edbe5b3d3ad$export$bead674655ff515d)(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function(options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        var result = {};
        for(var name_1 in this.cookies)result[name_1] = (0, $66269edbe5b3d3ad$export$bead674655ff515d)(this.cookies[name_1], options);
        return result;
    };
    Cookies.prototype.set = function(name, value, options) {
        var _a;
        if (typeof value === "object") value = JSON.stringify(value);
        this.cookies = $255eada7dbdf2b17$var$__assign($255eada7dbdf2b17$var$__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $16539d2dc16d64b1$export$dfdc1655ccc5b9cb(name, value, options);
        this._emitChange({
            name: name,
            value: value,
            options: options
        });
    };
    Cookies.prototype.remove = function(name, options) {
        var finalOptions = options = $255eada7dbdf2b17$var$__assign($255eada7dbdf2b17$var$__assign({}, options), {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        });
        this.cookies = $255eada7dbdf2b17$var$__assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $16539d2dc16d64b1$export$dfdc1655ccc5b9cb(name, "", finalOptions);
        this._emitChange({
            name: name,
            value: undefined,
            options: options
        });
    };
    Cookies.prototype.addChangeListener = function(callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function(callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) this.changeListeners.splice(idx, 1);
    };
    return Cookies;
}();
var $255eada7dbdf2b17$export$2e2bcd8739ae039 = $255eada7dbdf2b17$var$Cookies;


var $805ac1b74e6fa7f9$export$2e2bcd8739ae039 = (0, $255eada7dbdf2b17$export$2e2bcd8739ae039);



var $ff4879a542aaba90$var$__assign = undefined && undefined.__assign || function() {
    $ff4879a542aaba90$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ff4879a542aaba90$var$__assign.apply(this, arguments);
};
var $ff4879a542aaba90$var$isBrowser = (0, $4fe24881fb69f2d5$export$a2708fdb45cd35f)().isBrowser;
var $ff4879a542aaba90$var$ONE_YEAR_IN_MS = 31536000000;
var $ff4879a542aaba90$export$ded9c57084144144 = /** @class */ function() {
    function UniversalStorage(context) {
        if (context === void 0) context = {};
        this.cookies = new (0, $805ac1b74e6fa7f9$export$2e2bcd8739ae039)();
        this.store = $ff4879a542aaba90$var$isBrowser ? window.localStorage : Object.create(null);
        this.cookies = context.req ? new (0, $805ac1b74e6fa7f9$export$2e2bcd8739ae039)(decodeURIComponent(context.req.headers.cookie)) : new (0, $805ac1b74e6fa7f9$export$2e2bcd8739ae039)();
        Object.assign(this.store, this.cookies.getAll());
    }
    Object.defineProperty(UniversalStorage.prototype, "length", {
        get: function() {
            return Object.entries(this.store).length;
        },
        enumerable: false,
        configurable: true
    });
    UniversalStorage.prototype.clear = function() {
        var _this = this;
        Array.from(new Array(this.length)).map(function(_, i) {
            return _this.key(i);
        }).forEach(function(key) {
            return _this.removeItem(key);
        });
    };
    UniversalStorage.prototype.getItem = function(key) {
        return this.getLocalItem(key);
    };
    UniversalStorage.prototype.getLocalItem = function(key) {
        return Object.prototype.hasOwnProperty.call(this.store, key) ? this.store[key] : null;
    };
    UniversalStorage.prototype.getUniversalItem = function(key) {
        return this.cookies.get(key);
    };
    UniversalStorage.prototype.key = function(index) {
        return Object.keys(this.store)[index];
    };
    UniversalStorage.prototype.removeItem = function(key) {
        this.removeLocalItem(key);
        this.removeUniversalItem(key);
    };
    UniversalStorage.prototype.removeLocalItem = function(key) {
        delete this.store[key];
    };
    UniversalStorage.prototype.removeUniversalItem = function(key) {
        this.cookies.remove(key, {
            path: "/"
        });
    };
    UniversalStorage.prototype.setItem = function(key, value) {
        this.setLocalItem(key, value);
        // keys take the shape:
        //  1. `${ProviderPrefix}.${userPoolClientId}.${username}.${tokenType}
        //  2. `${ProviderPrefix}.${userPoolClientId}.LastAuthUser
        var tokenType = key.split(".").pop();
        var sessionTokenTypes = [
            "LastAuthUser",
            "accessToken",
            // refreshToken originates on the client, but SSR pages won't fail when this expires
            // Note: the new `accessToken` will also be refreshed on the client (since Amplify doesn't set server-side cookies)
            "refreshToken",
            // Required for CognitoUserSession
            "idToken"
        ];
        if (sessionTokenTypes.includes(tokenType !== null && tokenType !== void 0 ? tokenType : "")) this.setUniversalItem(key, value, {
            expires: new Date(Date.now() + $ff4879a542aaba90$var$ONE_YEAR_IN_MS)
        });
    };
    UniversalStorage.prototype.setLocalItem = function(key, value) {
        this.store[key] = value;
    };
    UniversalStorage.prototype.setUniversalItem = function(key, value, options) {
        if (options === void 0) options = {};
        this.cookies.set(key, value, $ff4879a542aaba90$var$__assign($ff4879a542aaba90$var$__assign({}, options), {
            path: "/",
            // `httpOnly` cannot be set via JavaScript: https://developer.mozilla.org/en-US/docs/Web/HTTP/Cookies#JavaScript_access_using_Document.cookie
            sameSite: true,
            // Allow unsecure requests to http://localhost:3000/ when in development.
            secure: $ff4879a542aaba90$var$isBrowser && window.location.hostname === "localhost" ? false : true
        }));
    };
    return UniversalStorage;
}();



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * This Symbol is used to reference an internal-only PubSub provider that
 * is used for AppSync/GraphQL subscriptions in the API category.
 */ var $ed8a415515f52c9d$var$hasSymbol = typeof Symbol !== "undefined" && typeof Symbol.for === "function";
var $ed8a415515f52c9d$export$ea26e09ecef8d08d = $ed8a415515f52c9d$var$hasSymbol ? Symbol.for("INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER") : "@@INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER";
var $ed8a415515f52c9d$export$16032fc466434892 = "x-amz-user-agent";



var $a118de4c999a2382$exports = {};

$a118de4c999a2382$exports = (parcelRequire("7ccsP")).Observable;


var $297ced72d65979d1$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($a118de4c999a2382$exports)));
var $297ced72d65979d1$export$2e2bcd8739ae039 = $297ced72d65979d1$export$77cea355fa80b5f4;


var $510cca51d2937e6d$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $510cca51d2937e6d$var$ReachabilityNavigator = /** @class */ function() {
    function ReachabilityNavigator() {}
    ReachabilityNavigator.prototype.networkMonitor = function(netInfo) {
        if ((0, $4fe24881fb69f2d5$export$a2708fdb45cd35f)().isNode) return (0, $297ced72d65979d1$export$2e2bcd8739ae039).from([
            {
                online: true
            }
        ]);
        var globalObj = (0, $4fe24881fb69f2d5$export$97b87b8868ff7a3c)() ? self : window;
        return new (0, $297ced72d65979d1$export$2e2bcd8739ae039)(function(observer) {
            observer.next({
                online: globalObj.navigator.onLine
            });
            var notifyOnline = function() {
                return observer.next({
                    online: true
                });
            };
            var notifyOffline = function() {
                return observer.next({
                    online: false
                });
            };
            globalObj.addEventListener("online", notifyOnline);
            globalObj.addEventListener("offline", notifyOffline);
            ReachabilityNavigator._observers.push(observer);
            return function() {
                globalObj.removeEventListener("online", notifyOnline);
                globalObj.removeEventListener("offline", notifyOffline);
                ReachabilityNavigator._observers = ReachabilityNavigator._observers.filter(function(_observer) {
                    return _observer !== observer;
                });
            };
        });
    };
    // expose observers to simulate offline mode for integration testing
    ReachabilityNavigator._observerOverride = function(status) {
        var e_1, _a;
        var _loop_1 = function(observer) {
            if (observer.closed) {
                ReachabilityNavigator._observers = ReachabilityNavigator._observers.filter(function(_observer) {
                    return _observer !== observer;
                });
                return "continue";
            }
            observer.next(status);
        };
        try {
            for(var _b = $510cca51d2937e6d$var$__values(ReachabilityNavigator._observers), _c = _b.next(); !_c.done; _c = _b.next()){
                var observer = _c.value;
                _loop_1(observer);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    ReachabilityNavigator._observers = [];
    return ReachabilityNavigator;
}();
var $510cca51d2937e6d$export$2e2bcd8739ae039 = $510cca51d2937e6d$var$ReachabilityNavigator;

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $019354a06509f3ba$export$b855308a44508212(str) {
    return str.split("").map(function(char) {
        return char.charCodeAt(0).toString(16).padStart(2, "0");
    }).join("");
}
function $019354a06509f3ba$export$a7ea17e93539f9a5(hex) {
    return hex.match(/.{2}/g).map(function(char) {
        return String.fromCharCode(parseInt(char, 16));
    }).join("");
}


var $b77a6c022ec92b76$export$a002182e51710d39 = {
    userAgent: (0, $0d25e50bf44b1a9b$export$2dffd0b5373a4389).userAgent
};
var /**
 * @deprecated use named import
 */ $b77a6c022ec92b76$export$2e2bcd8739ae039 = (0, $6ff5c7c169206e21$export$a3858a9a153cffc7);


/* eslint-disable */ // WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
const $e49d2414ba339a79$var$awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://7grvwl2ok2.execute-api.ap-southeast-2.amazonaws.com/prod",
            "region": "ap-southeast-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://sijxt3go55haja662udd6rwhya.appsync-api.ap-southeast-2.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-p3ppzho5zrd5vlvqlshifgcos4",
    "aws_cognito_identity_pool_id": "ap-southeast-2:c895d18a-2f08-482e-9ffa-b03ff5d8c387",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": "ap-southeast-2_RYRIRiIyj",
    "aws_user_pools_web_client_id": "4bfq91o8ntji1d087ah91tbak4",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_user_files_s3_bucket": "surveymusterappbucket221236-prod",
    "aws_user_files_s3_bucket_region": "ap-southeast-2"
};
var $e49d2414ba339a79$export$2e2bcd8739ae039 = $e49d2414ba339a79$var$awsmobile;



var $aed4709c841a33e1$var$__assign = undefined && undefined.__assign || function() {
    $aed4709c841a33e1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $aed4709c841a33e1$var$__assign.apply(this, arguments);
};
(0, $b77a6c022ec92b76$export$2e2bcd8739ae039).configure((0, $e49d2414ba339a79$export$2e2bcd8739ae039));
var $aed4709c841a33e1$var$App = function(_a) {
    var InternalRoutes = _a.InternalRoutes, pageRoutes = _a.pageRoutes, system = _a.system;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d9fd026bfea79ab9$export$3565eb3d00ca5a74), null, Object.values(pageRoutes).map(function(routeInfo) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
            key: routeInfo.route,
            path: routeInfo.route,
            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(InternalRoutes, $aed4709c841a33e1$var$__assign({}, routeInfo, {
                system: system
            }))
        });
    })));
};
var $aed4709c841a33e1$export$2e2bcd8739ae039 = $aed4709c841a33e1$var$App;



var $7fPBF = parcelRequire("7fPBF");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $1e2082910c54650f$var$extendStatics = function(d, b) {
    $1e2082910c54650f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $1e2082910c54650f$var$extendStatics(d, b);
};
function $1e2082910c54650f$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $1e2082910c54650f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1e2082910c54650f$export$18ce0697a983be9b = function() {
    $1e2082910c54650f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1e2082910c54650f$export$18ce0697a983be9b.apply(this, arguments);
};
function $1e2082910c54650f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1e2082910c54650f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $1e2082910c54650f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $1e2082910c54650f$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $1e2082910c54650f$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $1e2082910c54650f$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $1e2082910c54650f$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $1e2082910c54650f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $1e2082910c54650f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $1e2082910c54650f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $1e2082910c54650f$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $1e2082910c54650f$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $1e2082910c54650f$export$45d3717a4c69092e(o, m, p);
}
function $1e2082910c54650f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $1e2082910c54650f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $1e2082910c54650f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($1e2082910c54650f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $1e2082910c54650f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $1e2082910c54650f$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $1e2082910c54650f$export$10c90e4f7922046c(v) {
    return this instanceof $1e2082910c54650f$export$10c90e4f7922046c ? (this.v = v, this) : new $1e2082910c54650f$export$10c90e4f7922046c(v);
}
function $1e2082910c54650f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $1e2082910c54650f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $1e2082910c54650f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $1e2082910c54650f$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $1e2082910c54650f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $1e2082910c54650f$export$19a8beecd37a4c45 === "function" ? $1e2082910c54650f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $1e2082910c54650f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $1e2082910c54650f$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $1e2082910c54650f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1e2082910c54650f$export$45d3717a4c69092e(result, mod, k);
    }
    $1e2082910c54650f$var$__setModuleDefault(result, mod);
    return result;
}
function $1e2082910c54650f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $1e2082910c54650f$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $1e2082910c54650f$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $1e2082910c54650f$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $1e2082910c54650f$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $1e2082910c54650f$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $1e2082910c54650f$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $1e2082910c54650f$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $1e2082910c54650f$export$2e2bcd8739ae039 = {
    __extends: $1e2082910c54650f$export$a8ba968b8961cb8a,
    __assign: $1e2082910c54650f$export$18ce0697a983be9b,
    __rest: $1e2082910c54650f$export$3c9a16f847548506,
    __decorate: $1e2082910c54650f$export$29e00dfd3077644b,
    __param: $1e2082910c54650f$export$d5ad3fd78186038f,
    __metadata: $1e2082910c54650f$export$f1db080c865becb9,
    __awaiter: $1e2082910c54650f$export$1050f835b63b671e,
    __generator: $1e2082910c54650f$export$67ebef60e6f28a6,
    __createBinding: $1e2082910c54650f$export$45d3717a4c69092e,
    __exportStar: $1e2082910c54650f$export$f33643c0debef087,
    __values: $1e2082910c54650f$export$19a8beecd37a4c45,
    __read: $1e2082910c54650f$export$8d051b38c9118094,
    __spread: $1e2082910c54650f$export$afc72e2116322959,
    __spreadArrays: $1e2082910c54650f$export$6388937ca91ccae8,
    __spreadArray: $1e2082910c54650f$export$1216008129fb82ed,
    __await: $1e2082910c54650f$export$10c90e4f7922046c,
    __asyncGenerator: $1e2082910c54650f$export$e427f37a30a4de9b,
    __asyncDelegator: $1e2082910c54650f$export$bbd80228419bb833,
    __asyncValues: $1e2082910c54650f$export$e3b29a3d6162315f,
    __makeTemplateObject: $1e2082910c54650f$export$4fb47efe1390b86f,
    __importStar: $1e2082910c54650f$export$c21735bcef00d192,
    __importDefault: $1e2082910c54650f$export$da59b14a69baef04,
    __classPrivateFieldGet: $1e2082910c54650f$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $1e2082910c54650f$export$d40a35129aaff81f,
    __classPrivateFieldIn: $1e2082910c54650f$export$81fdc39f203e4e04,
    __addDisposableResource: $1e2082910c54650f$export$88ac25d8e944e405,
    __disposeResources: $1e2082910c54650f$export$8f076105dc360e92
};


parcelRequire("9YmaI");

var $7fPBF = parcelRequire("7fPBF");
var $4a0bf7bd570986e8$exports = {};
//
$4a0bf7bd570986e8$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 = "-ms-";
var $224fb5bfd01f6fb6$export$2c0f367103c8d01c = "-moz-";
var $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 = "-webkit-";
var $224fb5bfd01f6fb6$export$a29989082612d0d9 = "comm";
var $224fb5bfd01f6fb6$export$aa3a2e812ca8570d = "rule";
var $224fb5bfd01f6fb6$export$527d108ccf083c2b = "decl";
var $224fb5bfd01f6fb6$export$d3d35020fa5b54f0 = "@page";
var $224fb5bfd01f6fb6$export$500415a86c544f73 = "@media";
var $224fb5bfd01f6fb6$export$a763edbf796b780a = "@import";
var $224fb5bfd01f6fb6$export$2790aeb8b4e5c826 = "@charset";
var $224fb5bfd01f6fb6$export$1cc683e23b84b133 = "@viewport";
var $224fb5bfd01f6fb6$export$9447a5efea57e862 = "@supports";
var $224fb5bfd01f6fb6$export$ef011b4e114b1fba = "@document";
var $224fb5bfd01f6fb6$export$6aad947bda0f3f46 = "@namespace";
var $224fb5bfd01f6fb6$export$b44a8529a35fcb60 = "@keyframes";
var $224fb5bfd01f6fb6$export$2c16de31893252e6 = "@font-face";
var $224fb5bfd01f6fb6$export$3d846dd52e150c6f = "@counter-style";
var $224fb5bfd01f6fb6$export$22314bfbb57653fe = "@font-feature-values";
var $224fb5bfd01f6fb6$export$d773506282b3cfe6 = "@layer";
var $224fb5bfd01f6fb6$export$2335f513bbd82c6d = Math.abs;
var $224fb5bfd01f6fb6$export$6788812c4e6611e6 = String.fromCharCode;
var $224fb5bfd01f6fb6$export$e6e34fd1f2686227 = Object.assign;
function $224fb5bfd01f6fb6$export$d6af199866bfb566(e, r) {
    return $224fb5bfd01f6fb6$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $224fb5bfd01f6fb6$export$a9db5e087081082d(e, 0)) << 2 ^ $224fb5bfd01f6fb6$export$a9db5e087081082d(e, 1)) << 2 ^ $224fb5bfd01f6fb6$export$a9db5e087081082d(e, 2)) << 2 ^ $224fb5bfd01f6fb6$export$a9db5e087081082d(e, 3) : 0;
}
function $224fb5bfd01f6fb6$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $224fb5bfd01f6fb6$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $224fb5bfd01f6fb6$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $224fb5bfd01f6fb6$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $224fb5bfd01f6fb6$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $224fb5bfd01f6fb6$export$36776f635604f274(e) {
    return e.length;
}
function $224fb5bfd01f6fb6$export$f9084667e487ed46(e) {
    return e.length;
}
function $224fb5bfd01f6fb6$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $224fb5bfd01f6fb6$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $224fb5bfd01f6fb6$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$224fb5bfd01f6fb6$export$4659b591c19bdf3d(e, r);
    });
}
var $224fb5bfd01f6fb6$export$53f1d5ea8de3d7c = 1;
var $224fb5bfd01f6fb6$export$4e0c71f277ca26b3 = 1;
var $224fb5bfd01f6fb6$export$f24224f1c91d8156 = 0;
var $224fb5bfd01f6fb6$export$5880b8b5730aff45 = 0;
var $224fb5bfd01f6fb6$export$c0306caf338ac095 = 0;
var $224fb5bfd01f6fb6$export$30a86d91af8ff6e6 = "";
function $224fb5bfd01f6fb6$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $224fb5bfd01f6fb6$export$53f1d5ea8de3d7c,
        column: $224fb5bfd01f6fb6$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $224fb5bfd01f6fb6$export$784d13d8ee351f07(e, r) {
    return $224fb5bfd01f6fb6$export$e6e34fd1f2686227($224fb5bfd01f6fb6$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $224fb5bfd01f6fb6$export$590e8b2c435046d9(e) {
    while(e.root)e = $224fb5bfd01f6fb6$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $224fb5bfd01f6fb6$export$10d8903dec122b9d(e, e.siblings);
}
function $224fb5bfd01f6fb6$export$eba6f6f03b0a92e7() {
    return $224fb5bfd01f6fb6$export$c0306caf338ac095;
}
function $224fb5bfd01f6fb6$export$232faf9add678146() {
    $224fb5bfd01f6fb6$export$c0306caf338ac095 = $224fb5bfd01f6fb6$export$5880b8b5730aff45 > 0 ? $224fb5bfd01f6fb6$export$a9db5e087081082d($224fb5bfd01f6fb6$export$30a86d91af8ff6e6, --$224fb5bfd01f6fb6$export$5880b8b5730aff45) : 0;
    if ($224fb5bfd01f6fb6$export$4e0c71f277ca26b3--, $224fb5bfd01f6fb6$export$c0306caf338ac095 === 10) $224fb5bfd01f6fb6$export$4e0c71f277ca26b3 = 1, $224fb5bfd01f6fb6$export$53f1d5ea8de3d7c--;
    return $224fb5bfd01f6fb6$export$c0306caf338ac095;
}
function $224fb5bfd01f6fb6$export$48cfd1e771a65c4f() {
    $224fb5bfd01f6fb6$export$c0306caf338ac095 = $224fb5bfd01f6fb6$export$5880b8b5730aff45 < $224fb5bfd01f6fb6$export$f24224f1c91d8156 ? $224fb5bfd01f6fb6$export$a9db5e087081082d($224fb5bfd01f6fb6$export$30a86d91af8ff6e6, $224fb5bfd01f6fb6$export$5880b8b5730aff45++) : 0;
    if ($224fb5bfd01f6fb6$export$4e0c71f277ca26b3++, $224fb5bfd01f6fb6$export$c0306caf338ac095 === 10) $224fb5bfd01f6fb6$export$4e0c71f277ca26b3 = 1, $224fb5bfd01f6fb6$export$53f1d5ea8de3d7c++;
    return $224fb5bfd01f6fb6$export$c0306caf338ac095;
}
function $224fb5bfd01f6fb6$export$4d3fb11e950abb9e() {
    return $224fb5bfd01f6fb6$export$a9db5e087081082d($224fb5bfd01f6fb6$export$30a86d91af8ff6e6, $224fb5bfd01f6fb6$export$5880b8b5730aff45);
}
function $224fb5bfd01f6fb6$export$e88cb2efb12ae807() {
    return $224fb5bfd01f6fb6$export$5880b8b5730aff45;
}
function $224fb5bfd01f6fb6$export$58adb3bec8346d0f(e, r) {
    return $224fb5bfd01f6fb6$export$2f35ab04d2335697($224fb5bfd01f6fb6$export$30a86d91af8ff6e6, e, r);
}
function $224fb5bfd01f6fb6$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $224fb5bfd01f6fb6$export$2de70f21292aac9e(e) {
    return $224fb5bfd01f6fb6$export$53f1d5ea8de3d7c = $224fb5bfd01f6fb6$export$4e0c71f277ca26b3 = 1, $224fb5bfd01f6fb6$export$f24224f1c91d8156 = $224fb5bfd01f6fb6$export$36776f635604f274($224fb5bfd01f6fb6$export$30a86d91af8ff6e6 = e), $224fb5bfd01f6fb6$export$5880b8b5730aff45 = 0, [];
}
function $224fb5bfd01f6fb6$export$45918ac1574455b1(e) {
    return $224fb5bfd01f6fb6$export$30a86d91af8ff6e6 = "", e;
}
function $224fb5bfd01f6fb6$export$410ac95b9ec204b8(e) {
    return $224fb5bfd01f6fb6$export$87c2784dc9fc4ab($224fb5bfd01f6fb6$export$58adb3bec8346d0f($224fb5bfd01f6fb6$export$5880b8b5730aff45 - 1, $224fb5bfd01f6fb6$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $224fb5bfd01f6fb6$export$660b2ee2d4fb4eff(e) {
    return $224fb5bfd01f6fb6$export$45918ac1574455b1($224fb5bfd01f6fb6$export$5f8c09e3ae6f64e1($224fb5bfd01f6fb6$export$2de70f21292aac9e(e)));
}
function $224fb5bfd01f6fb6$export$7af1228ff777d175(e) {
    while($224fb5bfd01f6fb6$export$c0306caf338ac095 = $224fb5bfd01f6fb6$export$4d3fb11e950abb9e())if ($224fb5bfd01f6fb6$export$c0306caf338ac095 < 33) $224fb5bfd01f6fb6$export$48cfd1e771a65c4f();
    else break;
    return $224fb5bfd01f6fb6$export$9e1725a4cfeada27(e) > 2 || $224fb5bfd01f6fb6$export$9e1725a4cfeada27($224fb5bfd01f6fb6$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $224fb5bfd01f6fb6$export$5f8c09e3ae6f64e1(e) {
    while($224fb5bfd01f6fb6$export$48cfd1e771a65c4f())switch($224fb5bfd01f6fb6$export$9e1725a4cfeada27($224fb5bfd01f6fb6$export$c0306caf338ac095)){
        case 0:
            $224fb5bfd01f6fb6$export$10d8903dec122b9d($224fb5bfd01f6fb6$export$c2ab62c7bf24634($224fb5bfd01f6fb6$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $224fb5bfd01f6fb6$export$10d8903dec122b9d($224fb5bfd01f6fb6$export$410ac95b9ec204b8($224fb5bfd01f6fb6$export$c0306caf338ac095), e);
            break;
        default:
            $224fb5bfd01f6fb6$export$10d8903dec122b9d($224fb5bfd01f6fb6$export$6788812c4e6611e6($224fb5bfd01f6fb6$export$c0306caf338ac095), e);
    }
    return e;
}
function $224fb5bfd01f6fb6$export$955ba06d119e085e(e, r) {
    while(--r && $224fb5bfd01f6fb6$export$48cfd1e771a65c4f())if ($224fb5bfd01f6fb6$export$c0306caf338ac095 < 48 || $224fb5bfd01f6fb6$export$c0306caf338ac095 > 102 || $224fb5bfd01f6fb6$export$c0306caf338ac095 > 57 && $224fb5bfd01f6fb6$export$c0306caf338ac095 < 65 || $224fb5bfd01f6fb6$export$c0306caf338ac095 > 70 && $224fb5bfd01f6fb6$export$c0306caf338ac095 < 97) break;
    return $224fb5bfd01f6fb6$export$58adb3bec8346d0f(e, $224fb5bfd01f6fb6$export$e88cb2efb12ae807() + (r < 6 && $224fb5bfd01f6fb6$export$4d3fb11e950abb9e() == 32 && $224fb5bfd01f6fb6$export$48cfd1e771a65c4f() == 32));
}
function $224fb5bfd01f6fb6$export$c889f2fcc19dbf12(e) {
    while($224fb5bfd01f6fb6$export$48cfd1e771a65c4f())switch($224fb5bfd01f6fb6$export$c0306caf338ac095){
        case e:
            return $224fb5bfd01f6fb6$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $224fb5bfd01f6fb6$export$c889f2fcc19dbf12($224fb5bfd01f6fb6$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $224fb5bfd01f6fb6$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $224fb5bfd01f6fb6$export$48cfd1e771a65c4f();
            break;
    }
    return $224fb5bfd01f6fb6$export$5880b8b5730aff45;
}
function $224fb5bfd01f6fb6$export$4254d4e2b3745c4c(e, r) {
    while($224fb5bfd01f6fb6$export$48cfd1e771a65c4f())if (e + $224fb5bfd01f6fb6$export$c0306caf338ac095 === 57) break;
    else if (e + $224fb5bfd01f6fb6$export$c0306caf338ac095 === 84 && $224fb5bfd01f6fb6$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $224fb5bfd01f6fb6$export$58adb3bec8346d0f(r, $224fb5bfd01f6fb6$export$5880b8b5730aff45 - 1) + "*" + $224fb5bfd01f6fb6$export$6788812c4e6611e6(e === 47 ? e : $224fb5bfd01f6fb6$export$48cfd1e771a65c4f());
}
function $224fb5bfd01f6fb6$export$c2ab62c7bf24634(e) {
    while(!$224fb5bfd01f6fb6$export$9e1725a4cfeada27($224fb5bfd01f6fb6$export$4d3fb11e950abb9e()))$224fb5bfd01f6fb6$export$48cfd1e771a65c4f();
    return $224fb5bfd01f6fb6$export$58adb3bec8346d0f(e, $224fb5bfd01f6fb6$export$5880b8b5730aff45);
}
function $224fb5bfd01f6fb6$export$ef7acd7185315e22(e) {
    return $224fb5bfd01f6fb6$export$45918ac1574455b1($224fb5bfd01f6fb6$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $224fb5bfd01f6fb6$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $224fb5bfd01f6fb6$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var m = c;
    var x = s;
    var y = n;
    var j = k;
    while(w)switch(h = g, g = $224fb5bfd01f6fb6$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $224fb5bfd01f6fb6$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($224fb5bfd01f6fb6$export$f8e21b1e77979a08(j += $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed($224fb5bfd01f6fb6$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $224fb5bfd01f6fb6$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $224fb5bfd01f6fb6$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $224fb5bfd01f6fb6$export$955ba06d119e085e($224fb5bfd01f6fb6$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($224fb5bfd01f6fb6$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $224fb5bfd01f6fb6$export$10d8903dec122b9d($224fb5bfd01f6fb6$export$4a34f930e789283c($224fb5bfd01f6fb6$export$4254d4e2b3745c4c($224fb5bfd01f6fb6$export$48cfd1e771a65c4f(), $224fb5bfd01f6fb6$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $224fb5bfd01f6fb6$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $224fb5bfd01f6fb6$export$36776f635604f274(j) - l) $224fb5bfd01f6fb6$export$10d8903dec122b9d(p > 32 ? $224fb5bfd01f6fb6$export$f8483753829ec8f3(j + ";", n, a, l - 1, i) : $224fb5bfd01f6fb6$export$f8483753829ec8f3($224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $224fb5bfd01f6fb6$export$10d8903dec122b9d(y = $224fb5bfd01f6fb6$export$3307ffa7023ede1e(j, r, a, f, o, c, u, k, m = [], x = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $224fb5bfd01f6fb6$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $224fb5bfd01f6fb6$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $224fb5bfd01f6fb6$export$98e6a39c04603d36(e, y, y, n && $224fb5bfd01f6fb6$export$10d8903dec122b9d($224fb5bfd01f6fb6$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, k, c, m = [], l, x), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $224fb5bfd01f6fb6$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = j = "", l = t;
            break;
        case 58:
            l = 1 + $224fb5bfd01f6fb6$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $224fb5bfd01f6fb6$export$232faf9add678146() == 125) continue;
            }
            switch(j += $224fb5bfd01f6fb6$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($224fb5bfd01f6fb6$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($224fb5bfd01f6fb6$export$4d3fb11e950abb9e() === 45) j += $224fb5bfd01f6fb6$export$410ac95b9ec204b8($224fb5bfd01f6fb6$export$48cfd1e771a65c4f());
                    v = $224fb5bfd01f6fb6$export$4d3fb11e950abb9e(), o = l = $224fb5bfd01f6fb6$export$36776f635604f274(k = j += $224fb5bfd01f6fb6$export$c2ab62c7bf24634($224fb5bfd01f6fb6$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $224fb5bfd01f6fb6$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $224fb5bfd01f6fb6$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $224fb5bfd01f6fb6$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var $ = 0, m = $224fb5bfd01f6fb6$export$2f35ab04d2335697(e, p + 1, p = $224fb5bfd01f6fb6$export$2335f513bbd82c6d(d = u[w])), x = e; $ < b; ++$)if (x = $224fb5bfd01f6fb6$export$87c2784dc9fc4ab(d > 0 ? h[$] + " " + m : $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(m, /&\f/g, h[$]))) f[g++] = x;
    return $224fb5bfd01f6fb6$export$35059013cd4a06db(e, r, a, s === 0 ? $224fb5bfd01f6fb6$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $224fb5bfd01f6fb6$export$4a34f930e789283c(e, r, a, c) {
    return $224fb5bfd01f6fb6$export$35059013cd4a06db(e, r, a, $224fb5bfd01f6fb6$export$a29989082612d0d9, $224fb5bfd01f6fb6$export$6788812c4e6611e6($224fb5bfd01f6fb6$export$eba6f6f03b0a92e7()), $224fb5bfd01f6fb6$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $224fb5bfd01f6fb6$export$f8483753829ec8f3(e, r, a, n, c) {
    return $224fb5bfd01f6fb6$export$35059013cd4a06db(e, r, a, $224fb5bfd01f6fb6$export$527d108ccf083c2b, $224fb5bfd01f6fb6$export$2f35ab04d2335697(e, 0, n), $224fb5bfd01f6fb6$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $224fb5bfd01f6fb6$export$82e9f45cca5ba907(n, c, s) {
    switch($224fb5bfd01f6fb6$export$d6af199866bfb566(n, c)){
        case 5103:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $224fb5bfd01f6fb6$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$2c0f367103c8d01c + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($224fb5bfd01f6fb6$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "box-$1$2" + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + "flex-item-" + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$224fb5bfd01f6fb6$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + "grid-row-" + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + "flex-line-pack" + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "box-" + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, "-grow", "") + $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed($224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed($224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed($224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "box-pack:$3" + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$224fb5bfd01f6fb6$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + "grid-column-align" + $224fb5bfd01f6fb6$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $224fb5bfd01f6fb6$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$224fb5bfd01f6fb6$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$224fb5bfd01f6fb6$export$f8e21b1e77979a08(s, "span") ? $224fb5bfd01f6fb6$export$4659b591c19bdf3d(s, /\d+/) : +$224fb5bfd01f6fb6$export$4659b591c19bdf3d(s, /\d+/) - +$224fb5bfd01f6fb6$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $224fb5bfd01f6fb6$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed($224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($224fb5bfd01f6fb6$export$36776f635604f274(n) - 1 - c > 6) switch($224fb5bfd01f6fb6$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($224fb5bfd01f6fb6$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $224fb5bfd01f6fb6$export$2c0f367103c8d01c + ($224fb5bfd01f6fb6$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$224fb5bfd01f6fb6$export$f8e21b1e77979a08(n, "stretch") ? $224fb5bfd01f6fb6$export$82e9f45cca5ba907($224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($224fb5bfd01f6fb6$export$a9db5e087081082d(n, c + 6) === 121) return $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, ":", ":" + $224fb5bfd01f6fb6$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($224fb5bfd01f6fb6$export$a9db5e087081082d(n, $224fb5bfd01f6fb6$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + ($224fb5bfd01f6fb6$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, ":", ":" + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $224fb5bfd01f6fb6$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $224fb5bfd01f6fb6$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $224fb5bfd01f6fb6$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $224fb5bfd01f6fb6$export$a763edbf796b780a:
        case $224fb5bfd01f6fb6$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $224fb5bfd01f6fb6$export$a29989082612d0d9:
            return "";
        case $224fb5bfd01f6fb6$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $224fb5bfd01f6fb6$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $224fb5bfd01f6fb6$export$aa3a2e812ca8570d:
            if (!$224fb5bfd01f6fb6$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $224fb5bfd01f6fb6$export$36776f635604f274(a = $224fb5bfd01f6fb6$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $224fb5bfd01f6fb6$export$5a7767152ae0305f(e) {
    var r = $224fb5bfd01f6fb6$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $224fb5bfd01f6fb6$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $224fb5bfd01f6fb6$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $224fb5bfd01f6fb6$export$527d108ccf083c2b:
                n.return = $224fb5bfd01f6fb6$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $224fb5bfd01f6fb6$export$b44a8529a35fcb60:
                return $224fb5bfd01f6fb6$export$dfdc1655ccc5b9cb([
                    $224fb5bfd01f6fb6$export$784d13d8ee351f07(n, {
                        value: $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $224fb5bfd01f6fb6$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $224fb5bfd01f6fb6$export$aa3a2e812ca8570d:
                if (n.length) return $224fb5bfd01f6fb6$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($224fb5bfd01f6fb6$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $224fb5bfd01f6fb6$export$590e8b2c435046d9($224fb5bfd01f6fb6$export$784d13d8ee351f07(n, {
                                props: [
                                    $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $224fb5bfd01f6fb6$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $224fb5bfd01f6fb6$export$590e8b2c435046d9($224fb5bfd01f6fb6$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $224fb5bfd01f6fb6$export$e6e34fd1f2686227(n, {
                                props: $224fb5bfd01f6fb6$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $224fb5bfd01f6fb6$export$590e8b2c435046d9($224fb5bfd01f6fb6$export$784d13d8ee351f07(n, {
                                props: [
                                    $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $224fb5bfd01f6fb6$export$590e8b2c435046d9($224fb5bfd01f6fb6$export$784d13d8ee351f07(n, {
                                props: [
                                    $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $224fb5bfd01f6fb6$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $224fb5bfd01f6fb6$export$590e8b2c435046d9($224fb5bfd01f6fb6$export$784d13d8ee351f07(n, {
                                props: [
                                    $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $224fb5bfd01f6fb6$export$590e8b2c435046d9($224fb5bfd01f6fb6$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $224fb5bfd01f6fb6$export$e6e34fd1f2686227(n, {
                                props: $224fb5bfd01f6fb6$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $224fb5bfd01f6fb6$export$76a88f7de6507443(e) {
    switch(e.type){
        case $224fb5bfd01f6fb6$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $224fb5bfd01f6fb6$export$1be1fc439b849fdf($224fb5bfd01f6fb6$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($224fb5bfd01f6fb6$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $224fb5bfd01f6fb6$export$2f35ab04d2335697(r, 1, $224fb5bfd01f6fb6$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $224fb5bfd01f6fb6$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $224fb5bfd01f6fb6$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $224fb5bfd01f6fb6$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}



var $cfR4M = parcelRequire("cfR4M");

var $4ZL0H = parcelRequire("4ZL0H");
var $4920bb85ed07bfd6$var$f = ("undefined" != typeof $4ZL0H && void 0 !== $4ZL0H.env && undefined, "data-styled"), $4920bb85ed07bfd6$export$83d89fbfd8236492 = "6.1.0", $4920bb85ed07bfd6$var$y = "undefined" != typeof window && "HTMLElement" in window, $4920bb85ed07bfd6$var$v = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $4ZL0H && $4ZL0H.env, "undefined" != typeof $4ZL0H && $4ZL0H.env, false)), $4920bb85ed07bfd6$var$g = {}, $4920bb85ed07bfd6$var$S = /invalid hook call/i, $4920bb85ed07bfd6$var$w = new Set, $4920bb85ed07bfd6$var$b = function(t, n) {
    var o, s, i, a, e;
}, $4920bb85ed07bfd6$var$E = Object.freeze([]), $4920bb85ed07bfd6$var$N = Object.freeze({});
function $4920bb85ed07bfd6$var$P(e, t, n) {
    return void 0 === n && (n = $4920bb85ed07bfd6$var$N), e.theme !== n.theme && e.theme || t || n.theme;
}
var $4920bb85ed07bfd6$var$_ = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $4920bb85ed07bfd6$var$C = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $4920bb85ed07bfd6$var$I = /(^-|-$)/g;
function $4920bb85ed07bfd6$var$A(e) {
    return e.replace($4920bb85ed07bfd6$var$C, "-").replace($4920bb85ed07bfd6$var$I, "");
}
var $4920bb85ed07bfd6$var$O = /(a)(d)/gi, $4920bb85ed07bfd6$var$D = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $4920bb85ed07bfd6$var$R(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $4920bb85ed07bfd6$var$D(t % 52) + n;
    return ($4920bb85ed07bfd6$var$D(t % 52) + n).replace($4920bb85ed07bfd6$var$O, "$1-$2");
}
var $4920bb85ed07bfd6$var$T, $4920bb85ed07bfd6$var$k = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $4920bb85ed07bfd6$var$j = function(e) {
    return $4920bb85ed07bfd6$var$k(5381, e);
};
function $4920bb85ed07bfd6$var$x(e) {
    return $4920bb85ed07bfd6$var$R($4920bb85ed07bfd6$var$j(e) >>> 0);
}
function $4920bb85ed07bfd6$var$V(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $4920bb85ed07bfd6$var$F(e) {
    return "string" == typeof e && true;
}
var $4920bb85ed07bfd6$var$M = "function" == typeof Symbol && Symbol.for, $4920bb85ed07bfd6$var$$ = $4920bb85ed07bfd6$var$M ? Symbol.for("react.memo") : 60115, $4920bb85ed07bfd6$var$z = $4920bb85ed07bfd6$var$M ? Symbol.for("react.forward_ref") : 60112, $4920bb85ed07bfd6$var$B = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $4920bb85ed07bfd6$var$L = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $4920bb85ed07bfd6$var$G = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $4920bb85ed07bfd6$var$Y = (($4920bb85ed07bfd6$var$T = {})[$4920bb85ed07bfd6$var$z] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $4920bb85ed07bfd6$var$T[$4920bb85ed07bfd6$var$$] = $4920bb85ed07bfd6$var$G, $4920bb85ed07bfd6$var$T);
function $4920bb85ed07bfd6$var$W(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $4920bb85ed07bfd6$var$$ ? $4920bb85ed07bfd6$var$G : "$$typeof" in e ? $4920bb85ed07bfd6$var$Y[e.$$typeof] : $4920bb85ed07bfd6$var$B;
}
var $4920bb85ed07bfd6$var$q = Object.defineProperty, $4920bb85ed07bfd6$var$H = Object.getOwnPropertyNames, $4920bb85ed07bfd6$var$U = Object.getOwnPropertySymbols, $4920bb85ed07bfd6$var$J = Object.getOwnPropertyDescriptor, $4920bb85ed07bfd6$var$X = Object.getPrototypeOf, $4920bb85ed07bfd6$var$Z = Object.prototype;
function $4920bb85ed07bfd6$var$K(e, t, n) {
    if ("string" != typeof t) {
        if ($4920bb85ed07bfd6$var$Z) {
            var o = $4920bb85ed07bfd6$var$X(t);
            o && o !== $4920bb85ed07bfd6$var$Z && $4920bb85ed07bfd6$var$K(e, o, n);
        }
        var r = $4920bb85ed07bfd6$var$H(t);
        $4920bb85ed07bfd6$var$U && (r = r.concat($4920bb85ed07bfd6$var$U(t)));
        for(var s = $4920bb85ed07bfd6$var$W(e), i = $4920bb85ed07bfd6$var$W(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $4920bb85ed07bfd6$var$L || n && n[c] || i && c in i || s && c in s)) {
                var l = $4920bb85ed07bfd6$var$J(t, c);
                try {
                    $4920bb85ed07bfd6$var$q(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $4920bb85ed07bfd6$var$Q(e) {
    return "function" == typeof e;
}
function $4920bb85ed07bfd6$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $4920bb85ed07bfd6$var$te(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $4920bb85ed07bfd6$var$ne(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $4920bb85ed07bfd6$var$oe(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $4920bb85ed07bfd6$var$re(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$4920bb85ed07bfd6$var$oe(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $4920bb85ed07bfd6$var$re(e[o], t[o]);
    else if ($4920bb85ed07bfd6$var$oe(t)) for(var o in t)e[o] = $4920bb85ed07bfd6$var$re(e[o], t[o]);
    return e;
}
function $4920bb85ed07bfd6$var$se(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $4920bb85ed07bfd6$var$ie = {};
function $4920bb85ed07bfd6$var$ae() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $4920bb85ed07bfd6$var$ce(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $4920bb85ed07bfd6$var$le = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $4920bb85ed07bfd6$var$ce(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat("/*!sc*/\n");
        return t;
    }, e;
}(), $4920bb85ed07bfd6$var$ue = new Map, $4920bb85ed07bfd6$var$pe = new Map, $4920bb85ed07bfd6$var$de = 1, $4920bb85ed07bfd6$var$he = function(e) {
    if ($4920bb85ed07bfd6$var$ue.has(e)) return $4920bb85ed07bfd6$var$ue.get(e);
    for(; $4920bb85ed07bfd6$var$pe.has($4920bb85ed07bfd6$var$de);)$4920bb85ed07bfd6$var$de++;
    var t = $4920bb85ed07bfd6$var$de++;
    return $4920bb85ed07bfd6$var$ue.set(e, t), $4920bb85ed07bfd6$var$pe.set(t, e), t;
}, $4920bb85ed07bfd6$var$fe = function(e, t) {
    $4920bb85ed07bfd6$var$ue.set(e, t), $4920bb85ed07bfd6$var$pe.set(t, e);
}, $4920bb85ed07bfd6$var$me = "style[".concat($4920bb85ed07bfd6$var$f, "][").concat("data-styled-version", '="').concat("6.1.0", '"]'), $4920bb85ed07bfd6$var$ye = new RegExp("^".concat($4920bb85ed07bfd6$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $4920bb85ed07bfd6$var$ve = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $4920bb85ed07bfd6$var$ge = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split("/*!sc*/\n"), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($4920bb85ed07bfd6$var$ye);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($4920bb85ed07bfd6$var$fe(u, l), $4920bb85ed07bfd6$var$ve(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
};
function $4920bb85ed07bfd6$var$Se() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $4920bb85ed07bfd6$var$we = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($4920bb85ed07bfd6$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($4920bb85ed07bfd6$var$f, "active"), o.setAttribute("data-styled-version", "6.1.0");
    var i = $4920bb85ed07bfd6$var$Se();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $4920bb85ed07bfd6$var$be = function() {
    function e(e) {
        this.element = $4920bb85ed07bfd6$var$we(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $4920bb85ed07bfd6$var$ce(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $4920bb85ed07bfd6$var$Ee = function() {
    function e(e) {
        this.element = $4920bb85ed07bfd6$var$we(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $4920bb85ed07bfd6$var$Ne = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $4920bb85ed07bfd6$var$Pe = $4920bb85ed07bfd6$var$y, $4920bb85ed07bfd6$var$_e = {
    isServer: !$4920bb85ed07bfd6$var$y,
    useCSSOMInjection: !$4920bb85ed07bfd6$var$v
}, $4920bb85ed07bfd6$var$Ce = function() {
    function e(e, n, o) {
        void 0 === e && (e = $4920bb85ed07bfd6$var$N), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $1e2082910c54650f$export$18ce0697a983be9b)((0, $1e2082910c54650f$export$18ce0697a983be9b)({}, $4920bb85ed07bfd6$var$_e), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $4920bb85ed07bfd6$var$y && $4920bb85ed07bfd6$var$Pe && ($4920bb85ed07bfd6$var$Pe = !1, function(e) {
            for(var t = document.querySelectorAll($4920bb85ed07bfd6$var$me), n = 0, o = t.length; n < o; n++){
                var r = t[n];
                r && "active" !== r.getAttribute($4920bb85ed07bfd6$var$f) && ($4920bb85ed07bfd6$var$ge(e, r), r.parentNode && r.parentNode.removeChild(r));
            }
        }(this)), $4920bb85ed07bfd6$var$se(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $4920bb85ed07bfd6$var$pe.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || 0 === i.length) return "continue";
                    var a = "".concat($4920bb85ed07bfd6$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat("/*!sc*/\n");
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $4920bb85ed07bfd6$var$he(e);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $1e2082910c54650f$export$18ce0697a983be9b)((0, $1e2082910c54650f$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $4920bb85ed07bfd6$var$Ne(n) : t ? new $4920bb85ed07bfd6$var$be(n) : new $4920bb85ed07bfd6$var$Ee(n);
        }(this.options), new $4920bb85ed07bfd6$var$le(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($4920bb85ed07bfd6$var$he(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($4920bb85ed07bfd6$var$he(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($4920bb85ed07bfd6$var$he(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $4920bb85ed07bfd6$var$Ie = /&/g, $4920bb85ed07bfd6$var$Ae = /^\s*\/\/.*$/gm;
function $4920bb85ed07bfd6$var$Oe(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $4920bb85ed07bfd6$var$Oe(e.children, t)), e;
    });
}
function $4920bb85ed07bfd6$var$De(e) {
    var t, n, o, r = void 0 === e ? $4920bb85ed07bfd6$var$N : e, s = r.options, i = void 0 === s ? $4920bb85ed07bfd6$var$N : s, a = r.plugins, c = void 0 === a ? $4920bb85ed07bfd6$var$E : a, l = function(e, o, r) {
        return r === n || r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $224fb5bfd01f6fb6$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($4920bb85ed07bfd6$var$Ie, n).replace(o, l));
    }), i.prefix && u.push($224fb5bfd01f6fb6$export$e08c7d021b829b7a), u.push($224fb5bfd01f6fb6$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($4920bb85ed07bfd6$var$Ae, ""), l = $224fb5bfd01f6fb6$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $4920bb85ed07bfd6$var$Oe(l, i.namespace));
        var p = [];
        return $224fb5bfd01f6fb6$export$dfdc1655ccc5b9cb(l, $224fb5bfd01f6fb6$export$5a7767152ae0305f(u.concat($224fb5bfd01f6fb6$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $4920bb85ed07bfd6$var$ce(15), $4920bb85ed07bfd6$var$k(e, t.name);
    }, 5381).toString() : "", p;
}
var $4920bb85ed07bfd6$var$Re = new $4920bb85ed07bfd6$var$Ce, $4920bb85ed07bfd6$var$Te = $4920bb85ed07bfd6$var$De(), $4920bb85ed07bfd6$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $4920bb85ed07bfd6$var$Re,
    stylis: $4920bb85ed07bfd6$var$Te
}), $4920bb85ed07bfd6$export$91317688fc694efa = $4920bb85ed07bfd6$export$8c190ef828af4c86.Consumer, $4920bb85ed07bfd6$var$xe = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(void 0);
function $4920bb85ed07bfd6$var$Ve() {
    return (0, $7fPBF.useContext)($4920bb85ed07bfd6$export$8c190ef828af4c86);
}
function $4920bb85ed07bfd6$export$a473771da2f0ff7c(e) {
    var t = (0, $7fPBF.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $4920bb85ed07bfd6$var$Ve().styleSheet, l = (0, $7fPBF.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $7fPBF.useMemo)(function() {
        return $4920bb85ed07bfd6$var$De({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $7fPBF.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($4a0bf7bd570986e8$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $7fPBF.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4920bb85ed07bfd6$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4920bb85ed07bfd6$var$xe.Provider, {
        value: u
    }, e.children));
}
var $4920bb85ed07bfd6$var$Me = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $4920bb85ed07bfd6$var$Te);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $4920bb85ed07bfd6$var$se(this, function() {
            throw $4920bb85ed07bfd6$var$ce(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $4920bb85ed07bfd6$var$Te), this.name + e.hash;
    }, e;
}(), $4920bb85ed07bfd6$var$$e = function(e) {
    return e >= "A" && e <= "Z";
};
function $4920bb85ed07bfd6$var$ze(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $4920bb85ed07bfd6$var$$e(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $4920bb85ed07bfd6$var$Be = function(e) {
    return null == e || !1 === e || "" === e;
}, $4920bb85ed07bfd6$var$Le = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$4920bb85ed07bfd6$var$Be(i) && (Array.isArray(i) && i.isCss || $4920bb85ed07bfd6$var$Q(i) ? r.push("".concat($4920bb85ed07bfd6$var$ze(s), ":"), i, ";") : $4920bb85ed07bfd6$var$oe(i) ? r.push.apply(r, (0, $1e2082910c54650f$export$1216008129fb82ed)((0, $1e2082910c54650f$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $4920bb85ed07bfd6$var$Le(i), !1), [
            "}"
        ], !1)) : r.push("".concat($4920bb85ed07bfd6$var$ze(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $cfR4M.default) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $4920bb85ed07bfd6$var$Ge(e, t, n, o) {
    if ($4920bb85ed07bfd6$var$Be(e)) return [];
    if ($4920bb85ed07bfd6$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($4920bb85ed07bfd6$var$Q(e)) {
        if (!$4920bb85ed07bfd6$var$Q(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $4920bb85ed07bfd6$var$Ge(r, t, n, o);
    }
    var s;
    return e instanceof $4920bb85ed07bfd6$var$Me ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $4920bb85ed07bfd6$var$oe(e) ? $4920bb85ed07bfd6$var$Le(e) : Array.isArray(e) ? Array.prototype.concat.apply($4920bb85ed07bfd6$var$E, e.map(function(e) {
        return $4920bb85ed07bfd6$var$Ge(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $4920bb85ed07bfd6$var$Ye(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($4920bb85ed07bfd6$var$Q(n) && !$4920bb85ed07bfd6$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $4920bb85ed07bfd6$var$We = $4920bb85ed07bfd6$var$j("6.1.0"), $4920bb85ed07bfd6$var$qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $4920bb85ed07bfd6$var$Ye(e), this.componentId = t, this.baseHash = $4920bb85ed07bfd6$var$k($4920bb85ed07bfd6$var$We, t), this.baseStyle = n, $4920bb85ed07bfd6$var$Ce.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $4920bb85ed07bfd6$var$te(o, this.staticRulesId);
            else {
                var r = $4920bb85ed07bfd6$var$ne($4920bb85ed07bfd6$var$Ge(this.rules, e, t, n)), s = $4920bb85ed07bfd6$var$R($4920bb85ed07bfd6$var$k(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $4920bb85ed07bfd6$var$te(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $4920bb85ed07bfd6$var$k(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $4920bb85ed07bfd6$var$ne($4920bb85ed07bfd6$var$Ge(u, e, t, n));
                    a = $4920bb85ed07bfd6$var$k(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $4920bb85ed07bfd6$var$R(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $4920bb85ed07bfd6$var$te(o, d);
            }
        }
        return o;
    }, e;
}(), $4920bb85ed07bfd6$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(void 0), $4920bb85ed07bfd6$export$b631efc24e9d5e2f = $4920bb85ed07bfd6$export$2c657da244d00bd6.Consumer;
function $4920bb85ed07bfd6$export$93d4e7f90805808f() {
    var e = (0, $7fPBF.useContext)($4920bb85ed07bfd6$export$2c657da244d00bd6);
    if (!e) throw $4920bb85ed07bfd6$var$ce(18);
    return e;
}
function $4920bb85ed07bfd6$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($4920bb85ed07bfd6$export$2c657da244d00bd6), r = (0, $7fPBF.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $4920bb85ed07bfd6$var$ce(14);
            if ($4920bb85ed07bfd6$var$Q(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $4920bb85ed07bfd6$var$ce(8);
            return n ? (0, $1e2082910c54650f$export$18ce0697a983be9b)((0, $1e2082910c54650f$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4920bb85ed07bfd6$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $4920bb85ed07bfd6$var$Ze = {}, $4920bb85ed07bfd6$var$Ke = new Set;
function $4920bb85ed07bfd6$var$Qe(e, r, s) {
    var i = $4920bb85ed07bfd6$export$7ba318d8d2f06c76(e), a = e, c = !$4920bb85ed07bfd6$var$F(e), p = r.attrs, d = void 0 === p ? $4920bb85ed07bfd6$var$E : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $4920bb85ed07bfd6$var$A(e);
        $4920bb85ed07bfd6$var$Ze[n] = ($4920bb85ed07bfd6$var$Ze[n] || 0) + 1;
        var o = "".concat(n, "-").concat($4920bb85ed07bfd6$var$x("6.1.0" + n + $4920bb85ed07bfd6$var$Ze[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $4920bb85ed07bfd6$var$F(e) ? "styled.".concat(e) : "Styled(".concat($4920bb85ed07bfd6$var$V(e), ")");
    }(e) : m, v = r.displayName && r.componentId ? "".concat($4920bb85ed07bfd6$var$A(r.displayName), "-").concat(r.componentId) : r.componentId || f, g = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, S = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var w = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var C = r.shouldForwardProp;
            S = function(e, t) {
                return w(e, t) && C(e, t);
            };
        } else S = w;
    }
    var I = new $4920bb85ed07bfd6$var$qe(s, v, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($4920bb85ed07bfd6$export$2c657da244d00bd6), m = $4920bb85ed07bfd6$var$Ve(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = function(e, n, o) {
                for(var r, s = (0, $1e2082910c54650f$export$18ce0697a983be9b)((0, $1e2082910c54650f$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $4920bb85ed07bfd6$var$Q(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $4920bb85ed07bfd6$var$te(s[c], a[c]) : "style" === c ? (0, $1e2082910c54650f$export$18ce0697a983be9b)((0, $1e2082910c54650f$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $4920bb85ed07bfd6$var$te(s.className, n.className)), s;
            }(i, r, $4920bb85ed07bfd6$var$P(r, f, c) || $4920bb85ed07bfd6$var$N), g = v.as || h, S = {};
            for(var w in v)void 0 === v[w] || "$" === w[0] || "as" === w || "theme" === w || ("forwardedAs" === w ? S.as = v.forwardedAs : y && !y(w, g) || (S[w] = v[w], y));
            var b = function(e, t) {
                var n = $4920bb85ed07bfd6$var$Ve(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, v);
            var E = $4920bb85ed07bfd6$var$te(p, d);
            return b && (E += " " + b), v.className && (E += " " + v.className), S[$4920bb85ed07bfd6$var$F(g) && !$4920bb85ed07bfd6$var$_.has(g) ? "class" : "className"] = E, S.ref = s, (0, $7fPBF.createElement)(g, S);
        }(D, e, r);
    }
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(O);
    return D.attrs = g, D.componentStyle = I, D.shouldForwardProp = S, D.foldedComponentIds = i ? $4920bb85ed07bfd6$var$te(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = v, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$4920bb85ed07bfd6$var$re(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $4920bb85ed07bfd6$var$se(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $4920bb85ed07bfd6$var$K(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $4920bb85ed07bfd6$var$et(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $4920bb85ed07bfd6$var$tt = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $4920bb85ed07bfd6$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($4920bb85ed07bfd6$var$Q(t) || $4920bb85ed07bfd6$var$oe(t)) {
        var r = t;
        return $4920bb85ed07bfd6$var$tt($4920bb85ed07bfd6$var$Ge($4920bb85ed07bfd6$var$et($4920bb85ed07bfd6$var$E, (0, $1e2082910c54650f$export$1216008129fb82ed)([
            r
        ], n, !0))));
    }
    var s = t;
    return 0 === n.length && 1 === s.length && "string" == typeof s[0] ? $4920bb85ed07bfd6$var$Ge(s) : $4920bb85ed07bfd6$var$tt($4920bb85ed07bfd6$var$Ge($4920bb85ed07bfd6$var$et(s, n)));
}
function $4920bb85ed07bfd6$var$ot(n, o, r) {
    if (void 0 === r && (r = $4920bb85ed07bfd6$var$N), !o) throw $4920bb85ed07bfd6$var$ce(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $4920bb85ed07bfd6$export$dbf350e5966cf602.apply(void 0, (0, $1e2082910c54650f$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $4920bb85ed07bfd6$var$ot(n, o, (0, $1e2082910c54650f$export$18ce0697a983be9b)((0, $1e2082910c54650f$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $4920bb85ed07bfd6$var$ot(n, o, (0, $1e2082910c54650f$export$18ce0697a983be9b)((0, $1e2082910c54650f$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $4920bb85ed07bfd6$var$rt = function(e) {
    return $4920bb85ed07bfd6$var$ot($4920bb85ed07bfd6$var$Qe, e);
}, $4920bb85ed07bfd6$export$2e2bcd8739ae039 = $4920bb85ed07bfd6$var$rt;
$4920bb85ed07bfd6$var$_.forEach(function(e) {
    $4920bb85ed07bfd6$export$2e2bcd8739ae039[e] = $4920bb85ed07bfd6$var$rt(e);
});
var $4920bb85ed07bfd6$var$it = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $4920bb85ed07bfd6$var$Ye(e), $4920bb85ed07bfd6$var$Ce.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($4920bb85ed07bfd6$var$ne($4920bb85ed07bfd6$var$Ge(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $4920bb85ed07bfd6$var$Ce.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $4920bb85ed07bfd6$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $4920bb85ed07bfd6$export$dbf350e5966cf602.apply(void 0, (0, $1e2082910c54650f$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($4920bb85ed07bfd6$var$x(JSON.stringify(i))), c = new $4920bb85ed07bfd6$var$it(i, a);
    var l = function(e) {
        var t = $4920bb85ed07bfd6$var$Ve(), n = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($4920bb85ed07bfd6$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $4920bb85ed07bfd6$var$g, o, s);
        else {
            var i = (0, $1e2082910c54650f$export$18ce0697a983be9b)((0, $1e2082910c54650f$export$18ce0697a983be9b)({}, n), {
                theme: $4920bb85ed07bfd6$var$P(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(l);
}
function $4920bb85ed07bfd6$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $4920bb85ed07bfd6$var$ne($4920bb85ed07bfd6$export$dbf350e5966cf602.apply(void 0, (0, $1e2082910c54650f$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $4920bb85ed07bfd6$var$x(r);
    return new $4920bb85ed07bfd6$var$Me(s, r);
}
function $4920bb85ed07bfd6$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function(n, r) {
        var s = $4920bb85ed07bfd6$var$P(n, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($4920bb85ed07bfd6$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(e, (0, $1e2082910c54650f$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return $4920bb85ed07bfd6$var$K(n, e);
}
var $4920bb85ed07bfd6$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString(), n = $4920bb85ed07bfd6$var$Se(), o = $4920bb85ed07bfd6$var$ne([
                n && 'nonce="'.concat(n, '"'),
                "".concat($4920bb85ed07bfd6$var$f, '="true"'),
                "".concat("data-styled-version", '="').concat("6.1.0", '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $4920bb85ed07bfd6$var$ce(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $4920bb85ed07bfd6$var$ce(2);
            var r = ((n = {})[$4920bb85ed07bfd6$var$f] = "", n["data-styled-version"] = "6.1.0", n.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, n), s = $4920bb85ed07bfd6$var$Se();
            return s && (r.nonce = s), [
                (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("style", (0, $1e2082910c54650f$export$18ce0697a983be9b)({}, r, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $4920bb85ed07bfd6$var$Ce({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $4920bb85ed07bfd6$var$ce(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4920bb85ed07bfd6$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $4920bb85ed07bfd6$var$ce(3);
    }, e;
}(), $4920bb85ed07bfd6$export$5c87cfe6c475f500 = {
    StyleSheet: $4920bb85ed07bfd6$var$Ce,
    mainSheet: $4920bb85ed07bfd6$var$Re
};
var $4920bb85ed07bfd6$var$dt = "__sc-".concat($4920bb85ed07bfd6$var$f, "__");



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");

var $hngXp = parcelRequire("hngXp");

var $5VCcJ = parcelRequire("5VCcJ");

var $8M6a3 = parcelRequire("8M6a3");
var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $dYkRa = parcelRequire("dYkRa");

var $hXGiu = parcelRequire("hXGiu");
const $043690c2de8ba6fa$var$_excluded = [
    "sx"
];
const $043690c2de8ba6fa$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $hXGiu.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $043690c2de8ba6fa$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $cFLic.default)(props, $043690c2de8ba6fa$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $043690c2de8ba6fa$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $dYkRa.isPlainObject)(result)) return systemProps;
        return (0, $kY3Ke.default)({}, systemProps, result);
    };
    else finalSx = (0, $kY3Ke.default)({}, systemProps, inSx);
    return (0, $kY3Ke.default)({}, otherProps, {
        sx: finalSx
    });
}



var $4kWyf = parcelRequire("4kWyf");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $bd7b6b8695507478$var$_excluded = [
    "className",
    "component"
];
function $bd7b6b8695507478$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName } = options;
    const BoxRoot = (0, $5VCcJ.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $8M6a3.default));
    const Box = /*#__PURE__*/ $7fPBF.forwardRef(function Box(inProps, ref) {
        const theme = (0, $4kWyf.default)(defaultTheme);
        const _extendSxProp = (0, $043690c2de8ba6fa$export$2e2bcd8739ae039)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $cFLic.default)(_extendSxProp, $bd7b6b8695507478$var$_excluded);
        return /*#__PURE__*/ (0, $bbzbN.jsx)(BoxRoot, (0, $kY3Ke.default)({
            as: component,
            ref: ref,
            className: (0, $hngXp.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $kU6nt = parcelRequire("kU6nt");

var $hmhHQ = parcelRequire("hmhHQ");

var $jwhZE = parcelRequire("jwhZE");
"use client";
const $77ec199cefd4182a$var$defaultTheme = (0, $hmhHQ.default)();
const $77ec199cefd4182a$var$Box = (0, $bd7b6b8695507478$export$2e2bcd8739ae039)({
    themeId: (0, $jwhZE.default),
    defaultTheme: $77ec199cefd4182a$var$defaultTheme,
    defaultClassName: "MuiBox-root",
    generateClassName: (0, $kU6nt.default).generate
});
var $77ec199cefd4182a$export$2e2bcd8739ae039 = $77ec199cefd4182a$var$Box;


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $b6UUh = parcelRequire("b6UUh");

var $kDBhE = parcelRequire("kDBhE");

var $7fPBF = parcelRequire("7fPBF");
"use client";
function $bc6c881cebb96954$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $7fPBF.useRef(controlled !== undefined);
    const [valueState, setValue] = $7fPBF.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $7fPBF.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


"use client";
var $3b64539a8a5729fa$export$2e2bcd8739ae039 = (0, $bc6c881cebb96954$export$2e2bcd8739ae039);



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ const $f29d66cab44a33c0$var$FormControlContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
var $f29d66cab44a33c0$export$2e2bcd8739ae039 = $f29d66cab44a33c0$var$FormControlContext;


"use client";
function $1af6f86e160474f0$export$2e2bcd8739ae039() {
    return $7fPBF.useContext((0, $f29d66cab44a33c0$export$2e2bcd8739ae039));
}



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $7fPBF = parcelRequire("7fPBF");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $b4ea50f2d27bbd24$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


"use client";
function $e7adb12ba33c17bd$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $7fPBF.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $b4ea50f2d27bbd24$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


"use client";
var $4f30d4c1188a58e6$export$2e2bcd8739ae039 = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039);



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $fd3794ae41ea97a8$var$useEnhancedEffect = typeof window !== "undefined" ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $fd3794ae41ea97a8$export$2e2bcd8739ae039 = $fd3794ae41ea97a8$var$useEnhancedEffect;


"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $bddccca9f6cee29b$var$useEventCallback(fn) {
    const ref = $7fPBF.useRef(fn);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $7fPBF.useRef((...args)=>// @ts-expect-error hide `this`
        // tslint:disable-next-line:ban-comma-operator
        (0, ref.current)(...args)).current;
}
var $bddccca9f6cee29b$export$2e2bcd8739ae039 = $bddccca9f6cee29b$var$useEventCallback;


"use client";
var $16db65b1f19e65f7$export$2e2bcd8739ae039 = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039);



var $7fPBF = parcelRequire("7fPBF");
"use client";
let $e015d3df8b2e1fd4$var$hadKeyboardEvent = true;
let $e015d3df8b2e1fd4$var$hadFocusVisibleRecently = false;
let $e015d3df8b2e1fd4$var$hadFocusVisibleRecentlyTimeout;
const $e015d3df8b2e1fd4$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $e015d3df8b2e1fd4$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $e015d3df8b2e1fd4$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $e015d3df8b2e1fd4$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $e015d3df8b2e1fd4$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $e015d3df8b2e1fd4$var$handlePointerDown() {
    $e015d3df8b2e1fd4$var$hadKeyboardEvent = false;
}
function $e015d3df8b2e1fd4$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($e015d3df8b2e1fd4$var$hadFocusVisibleRecently) $e015d3df8b2e1fd4$var$hadKeyboardEvent = true;
    }
}
function $e015d3df8b2e1fd4$var$prepare(doc) {
    doc.addEventListener("keydown", $e015d3df8b2e1fd4$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $e015d3df8b2e1fd4$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $e015d3df8b2e1fd4$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $e015d3df8b2e1fd4$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $e015d3df8b2e1fd4$var$handleVisibilityChange, true);
}
function $e015d3df8b2e1fd4$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $e015d3df8b2e1fd4$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $e015d3df8b2e1fd4$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $e015d3df8b2e1fd4$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $e015d3df8b2e1fd4$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $e015d3df8b2e1fd4$var$handleVisibilityChange, true);
}
function $e015d3df8b2e1fd4$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $e015d3df8b2e1fd4$var$hadKeyboardEvent || $e015d3df8b2e1fd4$var$focusTriggersKeyboardModality(target);
}
function $e015d3df8b2e1fd4$export$2e2bcd8739ae039() {
    const ref = $7fPBF.useCallback((node)=>{
        if (node != null) $e015d3df8b2e1fd4$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $7fPBF.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $e015d3df8b2e1fd4$var$hadFocusVisibleRecently = true;
            window.clearTimeout($e015d3df8b2e1fd4$var$hadFocusVisibleRecentlyTimeout);
            $e015d3df8b2e1fd4$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(()=>{
                $e015d3df8b2e1fd4$var$hadFocusVisibleRecently = false;
            }, 100);
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($e015d3df8b2e1fd4$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


"use client";
var $77c51d9bab7ec5dd$export$2e2bcd8739ae039 = (0, $e015d3df8b2e1fd4$export$2e2bcd8739ae039);



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
function $298ff58efa174465$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $da27c96857818bcc$export$2e2bcd8739ae039(o, p) {
    $da27c96857818bcc$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $da27c96857818bcc$export$2e2bcd8739ae039(o, p);
}


function $146ee816144a450d$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $da27c96857818bcc$export$2e2bcd8739ae039)(subClass, superClass);
}




var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $61c94efb1735eff6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);



var $7fPBF = parcelRequire("7fPBF");
function $2a31251aa5f7eb4f$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $7fPBF.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $7fPBF.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $2a31251aa5f7eb4f$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $2a31251aa5f7eb4f$export$fa71e2345c31d7a2(props, onExited) {
    return $2a31251aa5f7eb4f$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $2a31251aa5f7eb4f$var$getProp(child, "appear", props),
            enter: $2a31251aa5f7eb4f$var$getProp(child, "enter", props),
            exit: $2a31251aa5f7eb4f$var$getProp(child, "exit", props)
        });
    });
}
function $2a31251aa5f7eb4f$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $2a31251aa5f7eb4f$export$bbc8a025727ea824(nextProps.children);
    var children = $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $7fPBF.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $7fPBF.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $2a31251aa5f7eb4f$var$getProp(child, "exit", nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $7fPBF.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $2a31251aa5f7eb4f$var$getProp(child, "exit", nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $30921f11ad4ef55c$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $30921f11ad4ef55c$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $30921f11ad4ef55c$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $146ee816144a450d$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $2a31251aa5f7eb4f$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $2a31251aa5f7eb4f$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $2a31251aa5f7eb4f$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $kY3Ke.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $cFLic.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $30921f11ad4ef55c$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$30921f11ad4ef55c$var$TransitionGroup.propTypes = {};
$30921f11ad4ef55c$var$TransitionGroup.defaultProps = $30921f11ad4ef55c$var$defaultProps;
var $30921f11ad4ef55c$export$2e2bcd8739ae039 = $30921f11ad4ef55c$var$TransitionGroup;



var $hngXp = parcelRequire("hngXp");

var $bpHMA = parcelRequire("bpHMA");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $bbzbN = parcelRequire("bbzbN");
"use client";
function $3d4a0ced9cf2c3c7$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $7fPBF.useState(false);
    const rippleClassName = (0, $hngXp.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $hngXp.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $7fPBF.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            className: childClassName
        })
    });
}
var $3d4a0ced9cf2c3c7$export$2e2bcd8739ae039 = $3d4a0ced9cf2c3c7$var$Ripple;



var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $fbda7a0931c56f58$export$b464606f735ab902(slot) {
    return (0, $k6RDS.default)("MuiTouchRipple", slot);
}
const $fbda7a0931c56f58$var$touchRippleClasses = (0, $4jzsB.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $fbda7a0931c56f58$export$2e2bcd8739ae039 = $fbda7a0931c56f58$var$touchRippleClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
let $3f5ffa895ad4456e$var$_ = (t)=>t, $3f5ffa895ad4456e$var$t, $3f5ffa895ad4456e$var$t1, $3f5ffa895ad4456e$var$t2, $3f5ffa895ad4456e$var$t3;
const $3f5ffa895ad4456e$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $3f5ffa895ad4456e$var$_1 = (t)=>t, $3f5ffa895ad4456e$var$_t, $3f5ffa895ad4456e$var$_t2, $3f5ffa895ad4456e$var$_t3, $3f5ffa895ad4456e$var$_t4;
const $3f5ffa895ad4456e$var$DURATION = 550;
const $3f5ffa895ad4456e$export$95d0c9356b2231a3 = 80;
const $3f5ffa895ad4456e$var$enterKeyframe = (0, $bpHMA.keyframes)($3f5ffa895ad4456e$var$_t || ($3f5ffa895ad4456e$var$_t = $3f5ffa895ad4456e$var$_1($3f5ffa895ad4456e$var$t || ($3f5ffa895ad4456e$var$t = $3f5ffa895ad4456e$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`))));
const $3f5ffa895ad4456e$var$exitKeyframe = (0, $bpHMA.keyframes)($3f5ffa895ad4456e$var$_t2 || ($3f5ffa895ad4456e$var$_t2 = $3f5ffa895ad4456e$var$_1($3f5ffa895ad4456e$var$t1 || ($3f5ffa895ad4456e$var$t1 = $3f5ffa895ad4456e$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`))));
const $3f5ffa895ad4456e$var$pulsateKeyframe = (0, $bpHMA.keyframes)($3f5ffa895ad4456e$var$_t3 || ($3f5ffa895ad4456e$var$_t3 = $3f5ffa895ad4456e$var$_1($3f5ffa895ad4456e$var$t2 || ($3f5ffa895ad4456e$var$t2 = $3f5ffa895ad4456e$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`))));
const $3f5ffa895ad4456e$export$f6b7418508c72c25 = (0, $kDBhE.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $3f5ffa895ad4456e$export$676cfe7b12693c4b = (0, $kDBhE.default)((0, $3d4a0ced9cf2c3c7$export$2e2bcd8739ae039), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($3f5ffa895ad4456e$var$_t4 || ($3f5ffa895ad4456e$var$_t4 = $3f5ffa895ad4456e$var$_1($3f5ffa895ad4456e$var$t3 || ($3f5ffa895ad4456e$var$t3 = $3f5ffa895ad4456e$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)), (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).rippleVisible, $3f5ffa895ad4456e$var$enterKeyframe, $3f5ffa895ad4456e$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).child, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childLeaving, $3f5ffa895ad4456e$var$exitKeyframe, $3f5ffa895ad4456e$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childPulsate, $3f5ffa895ad4456e$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $3f5ffa895ad4456e$var$TouchRipple = /*#__PURE__*/ $7fPBF.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $cFLic.default)(props, $3f5ffa895ad4456e$var$_excluded);
    const [ripples, setRipples] = $7fPBF.useState([]);
    const nextKey = $7fPBF.useRef(0);
    const rippleCallback = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $7fPBF.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = $7fPBF.useRef(0);
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $7fPBF.useRef(null);
    const container = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        return ()=>{
            if (startTimer.current) clearTimeout(startTimer.current);
        };
    }, []);
    const startCommit = $7fPBF.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $bbzbN.jsx)($3f5ffa895ad4456e$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $hngXp.default)(classes.ripple, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $hngXp.default)(classes.rippleVisible, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $hngXp.default)(classes.ripplePulsate, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $hngXp.default)(classes.child, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $hngXp.default)(classes.childLeaving, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $hngXp.default)(classes.childPulsate, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $3f5ffa895ad4456e$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $7fPBF.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $3f5ffa895ad4456e$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    const pulsate = $7fPBF.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $7fPBF.useCallback((event, cb)=>{
        clearTimeout(startTimer.current);
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $7fPBF.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($3f5ffa895ad4456e$export$f6b7418508c72c25, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)((0, $fbda7a0931c56f58$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $30921f11ad4ef55c$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $3f5ffa895ad4456e$export$2e2bcd8739ae039 = $3f5ffa895ad4456e$var$TouchRipple;



var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $d365e8bde1350eb0$export$fccb0498dcd99783(slot) {
    return (0, $k6RDS.default)("MuiButtonBase", slot);
}
const $d365e8bde1350eb0$var$buttonBaseClasses = (0, $4jzsB.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $d365e8bde1350eb0$export$2e2bcd8739ae039 = $d365e8bde1350eb0$var$buttonBaseClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $2d0c76ae9ca5c817$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $2d0c76ae9ca5c817$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $d365e8bde1350eb0$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $2d0c76ae9ca5c817$export$7ec0dcc5e3cdcd36 = (0, $kDBhE.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $d365e8bde1350eb0$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $2d0c76ae9ca5c817$var$ButtonBase = /*#__PURE__*/ $7fPBF.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $cFLic.default)(props, $2d0c76ae9ca5c817$var$_excluded);
    const buttonRef = $7fPBF.useRef(null);
    const rippleRef = $7fPBF.useRef(null);
    const handleRippleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $77c51d9bab7ec5dd$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $7fPBF.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $7fPBF.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $7fPBF.useState(false);
    $7fPBF.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $7fPBF.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $7fPBF.useRef(false);
    const handleKeyDown = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $2d0c76ae9ca5c817$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($2d0c76ae9ca5c817$export$7ec0dcc5e3cdcd36, (0, $kY3Ke.default)({
        as: ComponentProp,
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $bbzbN.jsx)((0, $3f5ffa895ad4456e$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $2d0c76ae9ca5c817$export$2e2bcd8739ae039 = $2d0c76ae9ca5c817$var$ButtonBase;



var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $5928be47f00793d2$export$baa0faa0c7ad8085(slot) {
    return (0, $k6RDS.default)("PrivateSwitchBase", slot);
}
const $5928be47f00793d2$var$switchBaseClasses = (0, $4jzsB.default)("PrivateSwitchBase", [
    "root",
    "checked",
    "disabled",
    "input",
    "edgeStart",
    "edgeEnd"
]);
var $5928be47f00793d2$export$2e2bcd8739ae039 = $5928be47f00793d2$var$switchBaseClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $69935e2350f58c79$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $69935e2350f58c79$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            "root",
            checked && "checked",
            disabled && "disabled",
            edge && `edge${(0, $b6UUh.default)(edge)}`
        ],
        input: [
            "input"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $5928be47f00793d2$export$baa0faa0c7ad8085), classes);
};
const $69935e2350f58c79$var$SwitchBaseRoot = (0, $kDBhE.default)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039))(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        padding: 9,
        borderRadius: "50%"
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }));
const $69935e2350f58c79$var$SwitchBaseInput = (0, $kDBhE.default)("input", {
    shouldForwardProp: (0, $kDBhE.rootShouldForwardProp)
})({
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $69935e2350f58c79$var$SwitchBase = /*#__PURE__*/ $7fPBF.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $cFLic.default)(props, $69935e2350f58c79$var$_excluded);
    const [checked, setCheckedState] = (0, $3b64539a8a5729fa$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    });
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === "checkbox" || type === "radio";
    const ownerState = (0, $kY3Ke.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $69935e2350f58c79$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($69935e2350f58c79$var$SwitchBaseRoot, (0, $kY3Ke.default)({
        component: "span",
        className: (0, $hngXp.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($69935e2350f58c79$var$SwitchBaseInput, (0, $kY3Ke.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === "checkbox" && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $69935e2350f58c79$export$2e2bcd8739ae039 = $69935e2350f58c79$var$SwitchBase;


parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $4f4e3692f5c75417$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank");


parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $dc941e595b205c8e$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox");


parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $d54af422e767409d$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");



var $b6UUh = parcelRequire("b6UUh");

var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $5350254b5a4e1ee2$export$6c57c6e16b4063b(slot) {
    return (0, $k6RDS.default)("MuiCheckbox", slot);
}
const $5350254b5a4e1ee2$var$checkboxClasses = (0, $4jzsB.default)("MuiCheckbox", [
    "root",
    "checked",
    "disabled",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium"
]);
var $5350254b5a4e1ee2$export$2e2bcd8739ae039 = $5350254b5a4e1ee2$var$checkboxClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $4d99e6d55ec7d57a$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $4d99e6d55ec7d57a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            indeterminate && "indeterminate",
            `color${(0, $b6UUh.default)(color)}`,
            `size${(0, $b6UUh.default)(size)}`
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $5350254b5a4e1ee2$export$6c57c6e16b4063b), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $4d99e6d55ec7d57a$var$CheckboxRoot = (0, $kDBhE.default)((0, $69935e2350f58c79$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $kDBhE.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiCheckbox",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $b6UUh.default)(ownerState.size)}`],
            ownerState.color !== "default" && styles[`color${(0, $b6UUh.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === "default" ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cxeT8.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $5350254b5a4e1ee2$export$2e2bcd8739ae039).checked}, &.${(0, $5350254b5a4e1ee2$export$2e2bcd8739ae039).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $5350254b5a4e1ee2$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $4d99e6d55ec7d57a$var$defaultCheckedIcon = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dc941e595b205c8e$export$2e2bcd8739ae039), {});
const $4d99e6d55ec7d57a$var$defaultIcon = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4f4e3692f5c75417$export$2e2bcd8739ae039), {});
const $4d99e6d55ec7d57a$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d54af422e767409d$export$2e2bcd8739ae039), {});
const $4d99e6d55ec7d57a$var$Checkbox = /*#__PURE__*/ $7fPBF.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiCheckbox"
    });
    const { checkedIcon: checkedIcon = $4d99e6d55ec7d57a$var$defaultCheckedIcon, color: color = "primary", icon: iconProp = $4d99e6d55ec7d57a$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $4d99e6d55ec7d57a$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = "medium", className: className } = props, other = (0, $cFLic.default)(props, $4d99e6d55ec7d57a$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $4d99e6d55ec7d57a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($4d99e6d55ec7d57a$var$CheckboxRoot, (0, $kY3Ke.default)({
        type: "checkbox",
        inputProps: (0, $kY3Ke.default)({
            "data-indeterminate": indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $7fPBF.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $7fPBF.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $hngXp.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $4d99e6d55ec7d57a$export$2e2bcd8739ae039 = $4d99e6d55ec7d57a$var$Checkbox;


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $dYkRa = parcelRequire("dYkRa");
var $cFCqu = parcelRequire("cFCqu");
var $k6RDS = parcelRequire("k6RDS");

var $UAzpO = parcelRequire("UAzpO");
const $81df530a7daa801f$var$styled = (0, $UAzpO.default)();
var $81df530a7daa801f$export$2e2bcd8739ae039 = $81df530a7daa801f$var$styled;



var $9HPC7 = parcelRequire("9HPC7");


var $2G6xE = parcelRequire("2G6xE");

var $cvrkU = parcelRequire("cvrkU");

var $5z69T = parcelRequire("5z69T");

var $bbzbN = parcelRequire("bbzbN");
const $dbad31c7655ddfe7$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $dbad31c7655ddfe7$var$defaultTheme = (0, $2G6xE.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $dbad31c7655ddfe7$var$defaultCreateStyledComponent = (0, $81df530a7daa801f$export$2e2bcd8739ae039)("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function $dbad31c7655ddfe7$var$useThemePropsDefault(props) {
    return (0, $9HPC7.default)({
        props: props,
        name: "MuiStack",
        defaultTheme: $dbad31c7655ddfe7$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $dbad31c7655ddfe7$var$joinChildren(children, separator) {
    const childrenArray = $7fPBF.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $7fPBF.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $dbad31c7655ddfe7$var$getSideFromDirection = (direction)=>{
    return ({
        row: "Left",
        "row-reverse": "Right",
        column: "Top",
        "column-reverse": "Bottom"
    })[direction];
};
const $dbad31c7655ddfe7$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $kY3Ke.default)({
        display: "flex",
        flexDirection: "column"
    }, (0, $cvrkU.handleBreakpoints)({
        theme: theme
    }, (0, $cvrkU.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $5z69T.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === "object" && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === "object" && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $cvrkU.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $cvrkU.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === "object") Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : "column";
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $5z69T.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                "& > :not(style):not(style)": {
                    margin: 0
                },
                "& > :not(style) ~ :not(style)": {
                    [`margin${$dbad31c7655ddfe7$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $5z69T.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $dYkRa.default)(styles, (0, $cvrkU.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $cvrkU.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $dbad31c7655ddfe7$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $dbad31c7655ddfe7$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $dbad31c7655ddfe7$var$useThemePropsDefault, componentName: componentName = "MuiStack" } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                "root"
            ]
        };
        return (0, $cFCqu.default)(slots, (slot)=>(0, $k6RDS.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($dbad31c7655ddfe7$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $7fPBF.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $043690c2de8ba6fa$export$2e2bcd8739ae039)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = "div", direction: direction = "column", spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $cFLic.default)(props, $dbad31c7655ddfe7$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $bbzbN.jsx)(StackRoot, (0, $kY3Ke.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $hngXp.default)(classes.root, className)
        }, other, {
            children: divider ? $dbad31c7655ddfe7$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}



var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");
"use client";
const $cde6d60726777b50$var$Stack = (0, $dbad31c7655ddfe7$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $kDBhE.default)("div", {
        name: "MuiStack",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $5j2OD.default)({
            props: inProps,
            name: "MuiStack"
        })
});
var $cde6d60726777b50$export$2e2bcd8739ae039 = $cde6d60726777b50$var$Stack;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $b6UUh = parcelRequire("b6UUh");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $d9914d0380157c73$export$24c1f8f60cbac79e(slot) {
    return (0, $k6RDS.default)("MuiTypography", slot);
}
const $d9914d0380157c73$var$typographyClasses = (0, $4jzsB.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $d9914d0380157c73$export$2e2bcd8739ae039 = $d9914d0380157c73$var$typographyClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $26f68e516ee75fc4$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $26f68e516ee75fc4$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $b6UUh.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $d9914d0380157c73$export$24c1f8f60cbac79e), classes);
};
const $26f68e516ee75fc4$export$140e2f5526d3cad8 = (0, $kDBhE.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $b6UUh.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        margin: 0
    }, ownerState.variant === "inherit" && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit"
    }, ownerState.variant !== "inherit" && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $26f68e516ee75fc4$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $26f68e516ee75fc4$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $26f68e516ee75fc4$var$transformDeprecatedColors = (color)=>{
    return $26f68e516ee75fc4$var$colorTransformations[color] || color;
};
const $26f68e516ee75fc4$var$Typography = /*#__PURE__*/ $7fPBF.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $26f68e516ee75fc4$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $043690c2de8ba6fa$export$2e2bcd8739ae039)((0, $kY3Ke.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $26f68e516ee75fc4$var$defaultVariantMapping } = props, other = (0, $cFLic.default)(props, $26f68e516ee75fc4$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $26f68e516ee75fc4$var$defaultVariantMapping[variant]) || "span";
    const classes = $26f68e516ee75fc4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($26f68e516ee75fc4$export$140e2f5526d3cad8, (0, $kY3Ke.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className)
    }, other));
});
var $26f68e516ee75fc4$export$2e2bcd8739ae039 = $26f68e516ee75fc4$var$Typography;



var $b6UUh = parcelRequire("b6UUh");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $7d55f5085d222c99$export$717666c39ec07e12(slot) {
    return (0, $k6RDS.default)("MuiFormControlLabel", slot);
}
const $7d55f5085d222c99$var$formControlLabelClasses = (0, $4jzsB.default)("MuiFormControlLabel", [
    "root",
    "labelPlacementStart",
    "labelPlacementTop",
    "labelPlacementBottom",
    "disabled",
    "label",
    "error",
    "required",
    "asterisk"
]);
var $7d55f5085d222c99$export$2e2bcd8739ae039 = $7d55f5085d222c99$var$formControlLabelClasses;


function $e570c333aacea667$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $206020d7e70b2617$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $206020d7e70b2617$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            `labelPlacement${(0, $b6UUh.default)(labelPlacement)}`,
            error && "error",
            required && "required"
        ],
        label: [
            "label",
            disabled && "disabled"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $7d55f5085d222c99$export$717666c39ec07e12), classes);
};
const $206020d7e70b2617$export$1b479270917a5676 = (0, $kDBhE.default)("label", {
    name: "MuiFormControlLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $7d55f5085d222c99$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $b6UUh.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        // For correct alignment with the text.
        verticalAlign: "middle",
        WebkitTapHighlightColor: "transparent",
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $7d55f5085d222c99$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        }
    }, ownerState.labelPlacement === "start" && {
        flexDirection: "row-reverse",
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === "top" && {
        flexDirection: "column-reverse",
        marginLeft: 16
    }, ownerState.labelPlacement === "bottom" && {
        flexDirection: "column",
        marginLeft: 16
    }, {
        [`& .${(0, $7d55f5085d222c99$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $7d55f5085d222c99$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $206020d7e70b2617$var$AsteriskComponent = (0, $kDBhE.default)("span", {
    name: "MuiFormControlLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $7d55f5085d222c99$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $206020d7e70b2617$var$FormControlLabel = /*#__PURE__*/ $7fPBF.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiFormControlLabel"
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = "end", required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $cFLic.default)(props, $206020d7e70b2617$var$_excluded);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        "checked",
        "name",
        "onChange",
        "value",
        "inputRef"
    ].forEach((key)=>{
        if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") controlProps[key] = props[key];
    });
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $206020d7e70b2617$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $26f68e516ee75fc4$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $hngXp.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($206020d7e70b2617$export$1b479270917a5676, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $7fPBF.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $cde6d60726777b50$export$2e2bcd8739ae039), {
                direction: "row",
                alignItems: "center",
                children: [
                    label,
                    /*#__PURE__*/ (0, $bbzbN.jsxs)($206020d7e70b2617$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            "*"
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $206020d7e70b2617$export$2e2bcd8739ae039 = $206020d7e70b2617$var$FormControlLabel;



var $cb41040a78bf22dc$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $cb41040a78bf22dc$var$Container = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).div($cb41040a78bf22dc$var$templateObject_1 || ($cb41040a78bf22dc$var$templateObject_1 = $cb41040a78bf22dc$var$__makeTemplateObject([
    "\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n"
], [
    "\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n"
])));
var $cb41040a78bf22dc$export$2e2bcd8739ae039 = $cb41040a78bf22dc$var$Container;
var $cb41040a78bf22dc$var$templateObject_1;



var $583409c85622bda5$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $583409c85622bda5$export$69b6e38dc7d8a757 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).div($583409c85622bda5$var$templateObject_1 || ($583409c85622bda5$var$templateObject_1 = $583409c85622bda5$var$__makeTemplateObject([
    "\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: white;\n  border-right: 1px solid black;\n  min-height: 511px;\n\n  @media (max-width: 768px) {\n    display: none;\n  }\n"
], [
    "\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: white;\n  border-right: 1px solid black;\n  min-height: 511px;\n\n  @media (max-width: 768px) {\n    display: none;\n  }\n"
])));
var $583409c85622bda5$export$5d77723460428c5b = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).div($583409c85622bda5$var$templateObject_2 || ($583409c85622bda5$var$templateObject_2 = $583409c85622bda5$var$__makeTemplateObject([
    "\n  flex: 1;\n  width: 100%;\n  max-width: 470px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: #f7f7f7;\n  padding: 2rem;\n  min-height: 511px;\n\n  @media (max-width: 768px) {\n    flex: 1;\n    max-width: 100%;\n  }\n"
], [
    "\n  flex: 1;\n  width: 100%;\n  max-width: 470px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: #f7f7f7;\n  padding: 2rem;\n  min-height: 511px;\n\n  @media (max-width: 768px) {\n    flex: 1;\n    max-width: 100%;\n  }\n"
])));
var $583409c85622bda5$export$3b3351848a5e0231 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).div($583409c85622bda5$var$templateObject_3 || ($583409c85622bda5$var$templateObject_3 = $583409c85622bda5$var$__makeTemplateObject([
    "\n  display: flex;\n  flex: 1;\n"
], [
    "\n  display: flex;\n  flex: 1;\n"
])));
var $583409c85622bda5$var$templateObject_1, $583409c85622bda5$var$templateObject_2, $583409c85622bda5$var$templateObject_3;




var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $aNaIu = parcelRequire("aNaIu");

var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");


var $b6UUh = parcelRequire("b6UUh");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $bf96407f1f5b4126$export$5a6f9035944c8119(slot) {
    return (0, $k6RDS.default)("MuiButton", slot);
}
const $bf96407f1f5b4126$var$buttonClasses = (0, $4jzsB.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $bf96407f1f5b4126$export$2e2bcd8739ae039 = $bf96407f1f5b4126$var$buttonClasses;



var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ const $40ed7573a59c2be9$var$ButtonGroupContext = /*#__PURE__*/ $7fPBF.createContext({});
var $40ed7573a59c2be9$export$2e2bcd8739ae039 = $40ed7573a59c2be9$var$ButtonGroupContext;



var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ const $e319f5c3a4402058$var$ButtonGroupButtonContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
var $e319f5c3a4402058$export$2e2bcd8739ae039 = $e319f5c3a4402058$var$ButtonGroupButtonContext;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $45be1777d6a28263$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $45be1777d6a28263$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $b6UUh.default)(color)}`,
            `size${(0, $b6UUh.default)(size)}`,
            `${variant}Size${(0, $b6UUh.default)(size)}`,
            color === "inherit" && "colorInherit",
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "startIcon",
            `iconSize${(0, $b6UUh.default)(size)}`
        ],
        endIcon: [
            "endIcon",
            `iconSize${(0, $b6UUh.default)(size)}`
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $bf96407f1f5b4126$export$5a6f9035944c8119), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $45be1777d6a28263$var$commonIconStyles = (ownerState)=>(0, $kY3Ke.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $45be1777d6a28263$var$ButtonRoot = (0, $kDBhE.default)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $kDBhE.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $b6UUh.default)(ownerState.color)}`],
            styles[`size${(0, $b6UUh.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $b6UUh.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $kY3Ke.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $kY3Ke.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cxeT8.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cxeT8.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cxeT8.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $kY3Ke.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).focusVisible}`]: (0, $kY3Ke.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).disabled}`]: (0, $kY3Ke.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $cxeT8.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: "none"
        }
    });
const $45be1777d6a28263$var$ButtonStartIcon = (0, $kDBhE.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $b6UUh.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $45be1777d6a28263$var$commonIconStyles(ownerState)));
const $45be1777d6a28263$var$ButtonEndIcon = (0, $kDBhE.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $b6UUh.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $45be1777d6a28263$var$commonIconStyles(ownerState)));
const $45be1777d6a28263$var$Button = /*#__PURE__*/ $7fPBF.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $7fPBF.useContext((0, $40ed7573a59c2be9$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $7fPBF.useContext((0, $e319f5c3a4402058$export$2e2bcd8739ae039));
    const resolvedProps = (0, $aNaIu.default)(contextProps, inProps);
    const props = (0, $5j2OD.default)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text" } = props, other = (0, $cFLic.default)(props, $45be1777d6a28263$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $45be1777d6a28263$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $bbzbN.jsx)($45be1777d6a28263$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $bbzbN.jsx)($45be1777d6a28263$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || "";
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($45be1777d6a28263$var$ButtonRoot, (0, $kY3Ke.default)({
        ownerState: ownerState,
        className: (0, $hngXp.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $hngXp.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $45be1777d6a28263$export$2e2bcd8739ae039 = $45be1777d6a28263$var$Button;


var $edb2ad7a7eb6ffb9$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $edb2ad7a7eb6ffb9$var$Button = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $45be1777d6a28263$export$2e2bcd8739ae039))($edb2ad7a7eb6ffb9$var$templateObject_1 || ($edb2ad7a7eb6ffb9$var$templateObject_1 = $edb2ad7a7eb6ffb9$var$__makeTemplateObject([
    "\n  margin-top: ",
    ";\n"
], [
    "\n  margin-top: ",
    ";\n"
])), function(props) {
    var _a;
    return (_a = props.marginTop) !== null && _a !== void 0 ? _a : "1rem";
});
var $edb2ad7a7eb6ffb9$export$2e2bcd8739ae039 = $edb2ad7a7eb6ffb9$var$Button;
var $edb2ad7a7eb6ffb9$var$templateObject_1;




var $caf112117fe1fc50$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $caf112117fe1fc50$var$Typography = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039))($caf112117fe1fc50$var$templateObject_1 || ($caf112117fe1fc50$var$templateObject_1 = $caf112117fe1fc50$var$__makeTemplateObject([
    "\n  margin-top: 1rem;\n"
], [
    "\n  margin-top: 1rem;\n"
])));
var $caf112117fe1fc50$export$2e2bcd8739ae039 = $caf112117fe1fc50$var$Typography;
var $caf112117fe1fc50$var$templateObject_1;



var $0ffd2a40b14139b1$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $0ffd2a40b14139b1$var$Link = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).a($0ffd2a40b14139b1$var$templateObject_1 || ($0ffd2a40b14139b1$var$templateObject_1 = $0ffd2a40b14139b1$var$__makeTemplateObject([
    "\n  text-decoration: none;\n  color: #3f51b5;\n"
], [
    "\n  text-decoration: none;\n  color: #3f51b5;\n"
])));
var $0ffd2a40b14139b1$export$2e2bcd8739ae039 = $0ffd2a40b14139b1$var$Link;
var $0ffd2a40b14139b1$var$templateObject_1;



var $8f033a6d446e1ef1$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $8f033a6d446e1ef1$var$FlexContainer = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).div($8f033a6d446e1ef1$var$templateObject_1 || ($8f033a6d446e1ef1$var$templateObject_1 = $8f033a6d446e1ef1$var$__makeTemplateObject([
    "\n  margin-top: ",
    ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n"
], [
    "\n  margin-top: ",
    ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n"
])), function(props) {
    var _a;
    return (_a = props.marginTop) !== null && _a !== void 0 ? _a : "1rem";
});
var $8f033a6d446e1ef1$export$2e2bcd8739ae039 = $8f033a6d446e1ef1$var$FlexContainer;
var $8f033a6d446e1ef1$var$templateObject_1;




var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");


var $5j2OD = parcelRequire("5j2OD");

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");

parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $ac707a057545a407$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked");


parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $37003fd2171922a7$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked");



var $kDBhE = parcelRequire("kDBhE");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $96b9a35dc7d8e11f$var$RadioButtonIconRoot = (0, $kDBhE.default)("span", {
    shouldForwardProp: (0, $kDBhE.rootShouldForwardProp)
})({
    position: "relative",
    display: "flex"
});
const $96b9a35dc7d8e11f$var$RadioButtonIconBackground = (0, $kDBhE.default)((0, $ac707a057545a407$export$2e2bcd8739ae039))({
    // Scale applied to prevent dot misalignment in Safari
    transform: "scale(1)"
});
const $96b9a35dc7d8e11f$var$RadioButtonIconDot = (0, $kDBhE.default)((0, $37003fd2171922a7$export$2e2bcd8739ae039))(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        left: 0,
        position: "absolute",
        transform: "scale(0)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        })
    }, ownerState.checked && {
        transform: "scale(1)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.shortest
        })
    }));
/**
 * @ignore - internal component.
 */ function $96b9a35dc7d8e11f$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = (0, $kY3Ke.default)({}, props, {
        checked: checked
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($96b9a35dc7d8e11f$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($96b9a35dc7d8e11f$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)($96b9a35dc7d8e11f$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $96b9a35dc7d8e11f$export$2e2bcd8739ae039 = $96b9a35dc7d8e11f$var$RadioButtonIcon;



var $b6UUh = parcelRequire("b6UUh");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $88500a39ccee70fd$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}


var $0e6a2af606f99b7f$export$2e2bcd8739ae039 = (0, $88500a39ccee70fd$export$2e2bcd8739ae039);



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ const $81ff23480207fa97$var$RadioGroupContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
var $81ff23480207fa97$export$2e2bcd8739ae039 = $81ff23480207fa97$var$RadioGroupContext;


"use client";
function $bd8bfb8e1742ab4f$export$2e2bcd8739ae039() {
    return $7fPBF.useContext((0, $81ff23480207fa97$export$2e2bcd8739ae039));
}



var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $e9a5de8192a35b89$export$192f7b2363c77155(slot) {
    return (0, $k6RDS.default)("MuiRadio", slot);
}
const $e9a5de8192a35b89$var$radioClasses = (0, $4jzsB.default)("MuiRadio", [
    "root",
    "checked",
    "disabled",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall"
]);
var $e9a5de8192a35b89$export$2e2bcd8739ae039 = $e9a5de8192a35b89$var$radioClasses;



var $kDBhE = parcelRequire("kDBhE");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $de28970229c88fa7$var$_excluded = [
    "checked",
    "checkedIcon",
    "color",
    "icon",
    "name",
    "onChange",
    "size",
    "className"
];
const $de28970229c88fa7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $b6UUh.default)(color)}`,
            size !== "medium" && `size${(0, $b6UUh.default)(size)}`
        ]
    };
    return (0, $kY3Ke.default)({}, classes, (0, $cFCqu.default)(slots, (0, $e9a5de8192a35b89$export$192f7b2363c77155), classes));
};
const $de28970229c88fa7$var$RadioRoot = (0, $kDBhE.default)((0, $69935e2350f58c79$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $kDBhE.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiRadio",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== "medium" && styles[`size${(0, $b6UUh.default)(ownerState.size)}`],
            styles[`color${(0, $b6UUh.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === "default" ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cxeT8.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $e9a5de8192a35b89$export$2e2bcd8739ae039).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        }
    }, {
        [`&.${(0, $e9a5de8192a35b89$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
function $de28970229c88fa7$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $de28970229c88fa7$var$defaultCheckedIcon = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $96b9a35dc7d8e11f$export$2e2bcd8739ae039), {
    checked: true
});
const $de28970229c88fa7$var$defaultIcon = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $96b9a35dc7d8e11f$export$2e2bcd8739ae039), {});
const $de28970229c88fa7$var$Radio = /*#__PURE__*/ $7fPBF.forwardRef(function Radio(inProps, ref) {
    var _defaultIcon$props$fo, _defaultCheckedIcon$p;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiRadio"
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $de28970229c88fa7$var$defaultCheckedIcon, color: color = "primary", icon: icon = $de28970229c88fa7$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = "medium", className: className } = props, other = (0, $cFLic.default)(props, $de28970229c88fa7$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        size: size
    });
    const classes = $de28970229c88fa7$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $bd8bfb8e1742ab4f$export$2e2bcd8739ae039)();
    let checked = checkedProp;
    const onChange = (0, $0e6a2af606f99b7f$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === "undefined") checked = $de28970229c88fa7$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === "undefined") name = radioGroup.name;
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)($de28970229c88fa7$var$RadioRoot, (0, $kY3Ke.default)({
        type: "radio",
        icon: /*#__PURE__*/ $7fPBF.cloneElement(icon, {
            fontSize: (_defaultIcon$props$fo = $de28970229c88fa7$var$defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
        }),
        checkedIcon: /*#__PURE__*/ $7fPBF.cloneElement(checkedIcon, {
            fontSize: (_defaultCheckedIcon$p = $de28970229c88fa7$var$defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
        }),
        ownerState: ownerState,
        classes: classes,
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref,
        className: (0, $hngXp.default)(classes.root, className)
    }, other));
});
var $de28970229c88fa7$export$2e2bcd8739ae039 = $de28970229c88fa7$var$Radio;


var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $dYkRa = parcelRequire("dYkRa");

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $e5zLi = parcelRequire("e5zLi");
var $7fPBF = parcelRequire("7fPBF");
"use client";
let $46f5b561912058f9$var$globalId = 0;
function $46f5b561912058f9$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $7fPBF.useState(idOverride);
    const id = idOverride || defaultId;
    $7fPBF.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $46f5b561912058f9$var$globalId += 1;
            setDefaultId(`mui-${$46f5b561912058f9$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $46f5b561912058f9$var$maybeReactUseId = $7fPBF["useId".toString()];
function $46f5b561912058f9$export$2e2bcd8739ae039(idOverride) {
    if ($46f5b561912058f9$var$maybeReactUseId !== undefined) {
        const reactId = $46f5b561912058f9$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $46f5b561912058f9$var$useGlobalId(idOverride);
}



var $7fPBF = parcelRequire("7fPBF");
var $dddaf6f84c717660$exports = {};
"use strict";

$dddaf6f84c717660$exports = (parcelRequire("45MkT"));




var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");
function $35e4b0c27d76b933$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


var $9502daaf177b272b$export$2e2bcd8739ae039 = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039);



var $b6UUh = parcelRequire("b6UUh");

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");



var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");


var $kY3Ke = parcelRequire("kY3Ke");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $59c589404b20ab2d$export$e28348cc2430497(element) {
    return typeof element === "string";
}


function $465892a610f5fa03$export$b089efb01a7bdf50(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $59c589404b20ab2d$export$e28348cc2430497)(elementType)) return otherProps;
    return (0, $kY3Ke.default)({}, otherProps, {
        ownerState: (0, $kY3Ke.default)({}, otherProps.ownerState, ownerState)
    });
}



var $kY3Ke = parcelRequire("kY3Ke");

var $hngXp = parcelRequire("hngXp");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $676085a836f199f4$export$24d5698b57eff81c(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $38b4de40642d32ce$export$2ac0fa4d3a39be45(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


function $27e8a811df72cf86$export$b01d1e419b049226(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $hngXp.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $kY3Ke.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $kY3Ke.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $676085a836f199f4$export$24d5698b57eff81c)((0, $kY3Ke.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $38b4de40642d32ce$export$2ac0fa4d3a39be45)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $38b4de40642d32ce$export$2ac0fa4d3a39be45)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $hngXp.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $kY3Ke.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $kY3Ke.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $029d34f88c9482cd$export$308c24034cde71de(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}


"use client";
const $699e2a22f1708389$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
function $699e2a22f1708389$export$1e5c9e6e4e15efe3(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $cFLic.default)(parameters, $699e2a22f1708389$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $029d34f88c9482cd$export$308c24034cde71de)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $27e8a811df72cf86$export$b01d1e419b049226)((0, $kY3Ke.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $465892a610f5fa03$export$b089efb01a7bdf50)(elementType, (0, $kY3Ke.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}




var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");




var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $7fPBF = parcelRequire("7fPBF");
"use client";
/**
 * @ignore - internal component.
 */ const $94e271e17fd22222$var$ListContext = /*#__PURE__*/ $7fPBF.createContext({});
var $94e271e17fd22222$export$2e2bcd8739ae039 = $94e271e17fd22222$var$ListContext;



var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $d56e26d1d10ff784$export$c6bd6795ed6e3203(slot) {
    return (0, $k6RDS.default)("MuiList", slot);
}
const $d56e26d1d10ff784$var$listClasses = (0, $4jzsB.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $d56e26d1d10ff784$export$2e2bcd8739ae039 = $d56e26d1d10ff784$var$listClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $fb70212a09473954$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $fb70212a09473954$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $d56e26d1d10ff784$export$c6bd6795ed6e3203), classes);
};
const $fb70212a09473954$var$ListRoot = (0, $kDBhE.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $fb70212a09473954$var$List = /*#__PURE__*/ $7fPBF.forwardRef(function List(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children, className: className, component: component = "ul", dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $cFLic.default)(props, $fb70212a09473954$var$_excluded);
    const context = $7fPBF.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $fb70212a09473954$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $94e271e17fd22222$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)($fb70212a09473954$var$ListRoot, (0, $kY3Ke.default)({
            as: component,
            className: (0, $hngXp.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $fb70212a09473954$export$2e2bcd8739ae039 = $fb70212a09473954$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $6b2c48b06f3074b8$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


var $15bf9ba27fbfc052$export$2e2bcd8739ae039 = (0, $6b2c48b06f3074b8$export$2e2bcd8739ae039);




"use client";
var $cfde3819487a0686$export$2e2bcd8739ae039 = (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039);



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $9cb95136bc90d127$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $9cb95136bc90d127$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $9cb95136bc90d127$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $9cb95136bc90d127$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$9cb95136bc90d127$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $9cb95136bc90d127$var$MenuList = /*#__PURE__*/ $7fPBF.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = "selectedMenu" } = props, other = (0, $cFLic.default)(props, $9cb95136bc90d127$var$_excluded);
    const listRef = $7fPBF.useRef(null);
    const textCriteriaRef = $7fPBF.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $7fPBF.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, theme)=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $15bf9ba27fbfc052$export$2e2bcd8739ae039)((0, $9502daaf177b272b$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $9502daaf177b272b$export$2e2bcd8739ae039)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $9cb95136bc90d127$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $9cb95136bc90d127$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $7fPBF.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $7fPBF.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $7fPBF.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fb70212a09473954$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $9cb95136bc90d127$export$2e2bcd8739ae039 = $9cb95136bc90d127$var$MenuList;



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");


var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $c285f587ed4585eb$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $3aadd01758bd49c1$export$2e2bcd8739ae039 = (0, $c285f587ed4585eb$export$2e2bcd8739ae039);




function $c1e4563498af7952$export$2e2bcd8739ae039(node) {
    const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $6cb2f4180c9526e0$export$2e2bcd8739ae039 = (0, $c1e4563498af7952$export$2e2bcd8739ae039);




var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");



var $cFLic = parcelRequire("cFLic");



var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");
var $8a9a7006a9b8efe4$export$2e2bcd8739ae039 = {
    disabled: false
};




var $f1bbb084f2fb10b7$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $623678cbb6daf054$export$bb38bb9a1161268 = "unmounted";
var $623678cbb6daf054$export$84cbff306f539230 = "exited";
var $623678cbb6daf054$export$df38205c966be359 = "entering";
var $623678cbb6daf054$export$78e9e6e3e014d60a = "entered";
var $623678cbb6daf054$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $623678cbb6daf054$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $146ee816144a450d$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $623678cbb6daf054$export$84cbff306f539230;
                _this.appearStatus = $623678cbb6daf054$export$df38205c966be359;
            } else initialStatus = $623678cbb6daf054$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $623678cbb6daf054$export$bb38bb9a1161268;
        else initialStatus = $623678cbb6daf054$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $623678cbb6daf054$export$bb38bb9a1161268) return {
            status: $623678cbb6daf054$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $623678cbb6daf054$export$df38205c966be359 && status !== $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$df38205c966be359;
            } else if (status === $623678cbb6daf054$export$df38205c966be359 || status === $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $623678cbb6daf054$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $f1bbb084f2fb10b7$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $623678cbb6daf054$export$84cbff306f539230) this.setState({
            status: $623678cbb6daf054$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $8a9a7006a9b8efe4$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $623678cbb6daf054$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $623678cbb6daf054$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $8a9a7006a9b8efe4$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $623678cbb6daf054$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $623678cbb6daf054$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $623678cbb6daf054$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $cFLic.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$623678cbb6daf054$var$Transition.contextType = (0, $61c94efb1735eff6$export$2e2bcd8739ae039);
$623678cbb6daf054$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $623678cbb6daf054$var$noop() {}
$623678cbb6daf054$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $623678cbb6daf054$var$noop,
    onEntering: $623678cbb6daf054$var$noop,
    onEntered: $623678cbb6daf054$var$noop,
    onExit: $623678cbb6daf054$var$noop,
    onExiting: $623678cbb6daf054$var$noop,
    onExited: $623678cbb6daf054$var$noop
};
$623678cbb6daf054$var$Transition.UNMOUNTED = $623678cbb6daf054$export$bb38bb9a1161268;
$623678cbb6daf054$var$Transition.EXITED = $623678cbb6daf054$export$84cbff306f539230;
$623678cbb6daf054$var$Transition.ENTERING = $623678cbb6daf054$export$df38205c966be359;
$623678cbb6daf054$var$Transition.ENTERED = $623678cbb6daf054$export$78e9e6e3e014d60a;
$623678cbb6daf054$var$Transition.EXITING = $623678cbb6daf054$export$4aacc83d4d59139f;
var $623678cbb6daf054$export$2e2bcd8739ae039 = $623678cbb6daf054$var$Transition;


parcelRequire("7fPBF");

var $4kWyf = parcelRequire("4kWyf");

var $9P91Y = parcelRequire("9P91Y");

var $jwhZE = parcelRequire("jwhZE");
"use client";
function $bc16b792e42cac5d$export$2e2bcd8739ae039() {
    const theme = (0, $4kWyf.default)((0, $9P91Y.default));
    return theme[0, $jwhZE.default] || theme;
}


const $1ae2edacd7be6319$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $1ae2edacd7be6319$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $bbzbN = parcelRequire("bbzbN");
"use client";
const $7ec2c0aa92d4d29c$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $7ec2c0aa92d4d29c$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $7ec2c0aa92d4d29c$var$styles = {
    entering: {
        opacity: 1,
        transform: $7ec2c0aa92d4d29c$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $7ec2c0aa92d4d29c$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $7ec2c0aa92d4d29c$var$Grow = /*#__PURE__*/ $7fPBF.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $623678cbb6daf054$export$2e2bcd8739ae039) } = props, other = (0, $cFLic.default)(props, $7ec2c0aa92d4d29c$var$_excluded);
    const timer = $7fPBF.useRef();
    const autoTimeout = $7fPBF.useRef();
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const nodeRef = $7fPBF.useRef(null);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $1ae2edacd7be6319$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $7ec2c0aa92d4d29c$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $7ec2c0aa92d4d29c$var$isWebKit154 ? duration : duration * 0.666,
                delay: $7ec2c0aa92d4d29c$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $7ec2c0aa92d4d29c$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.current = setTimeout(next, autoTimeout.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    $7fPBF.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $7fPBF.cloneElement(children, (0, $kY3Ke.default)({
                style: (0, $kY3Ke.default)({
                    opacity: 0,
                    transform: $7ec2c0aa92d4d29c$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $7ec2c0aa92d4d29c$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$7ec2c0aa92d4d29c$var$Grow.muiSupportAuto = true;
var $7ec2c0aa92d4d29c$export$2e2bcd8739ae039 = $7ec2c0aa92d4d29c$var$Grow;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");



var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");



// Is a vertical scrollbar displayed?
function $0cc83ef1bfdc25eb$var$isOverflowing(container) {
    const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $c1e4563498af7952$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $0cc83ef1bfdc25eb$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $0cc83ef1bfdc25eb$var$getPaddingRight(element) {
    return parseInt((0, $c1e4563498af7952$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $0cc83ef1bfdc25eb$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $0cc83ef1bfdc25eb$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$0cc83ef1bfdc25eb$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $0cc83ef1bfdc25eb$export$e1bd0c6150f13d96(element, show);
    });
}
function $0cc83ef1bfdc25eb$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $0cc83ef1bfdc25eb$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($0cc83ef1bfdc25eb$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $6b2c48b06f3074b8$export$2e2bcd8739ae039)((0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$0cc83ef1bfdc25eb$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$0cc83ef1bfdc25eb$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $c1e4563498af7952$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $0cc83ef1bfdc25eb$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $0cc83ef1bfdc25eb$export$ce11c4ecd08cea67 {
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $0cc83ef1bfdc25eb$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $0cc83ef1bfdc25eb$var$getHiddenSiblings(container);
        $0cc83ef1bfdc25eb$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $0cc83ef1bfdc25eb$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $0cc83ef1bfdc25eb$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $0cc83ef1bfdc25eb$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $0cc83ef1bfdc25eb$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $0cc83ef1bfdc25eb$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $0cc83ef1bfdc25eb$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $0cc83ef1bfdc25eb$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
}


"use client";
function $0aaff92e83b421f6$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $0aaff92e83b421f6$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $0aaff92e83b421f6$var$defaultManager = new (0, $0cc83ef1bfdc25eb$export$ce11c4ecd08cea67)();
function $0aaff92e83b421f6$export$33ffd74ebf07f060(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $0aaff92e83b421f6$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $7fPBF.useRef({});
    const mountNodeRef = $7fPBF.useRef(null);
    const modalRef = $7fPBF.useRef(null);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $7fPBF.useState(!open);
    const hasTransition = $0aaff92e83b421f6$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $0aaff92e83b421f6$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $7fPBF.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $0cc83ef1bfdc25eb$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $7fPBF.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $7fPBF.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $7fPBF.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== "Escape" || !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, "escapeKeyDown");
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, "backdropClick");
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $676085a836f199f4$export$24d5698b57eff81c)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $kY3Ke.default)({}, propsEventHandlers, otherHandlers);
        return (0, $kY3Ke.default)({
            role: "presentation"
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $kY3Ke.default)({
            "aria-hidden": true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $88500a39ccee70fd$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $88500a39ccee70fd$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}



var $cFCqu = parcelRequire("cFCqu");

var $7fPBF = parcelRequire("7fPBF");



var $bbzbN = parcelRequire("bbzbN");
"use client";
// Inspired by https://github.com/focus-trap/tabbable
const $820d2e8c6ed0c158$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $820d2e8c6ed0c158$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $820d2e8c6ed0c158$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $820d2e8c6ed0c158$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $820d2e8c6ed0c158$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $820d2e8c6ed0c158$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($820d2e8c6ed0c158$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $820d2e8c6ed0c158$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$820d2e8c6ed0c158$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $820d2e8c6ed0c158$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base-ui/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base-ui/react-focus-trap/components-api/#focus-trap)
 */ function $820d2e8c6ed0c158$export$34eba2437817a67b(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $820d2e8c6ed0c158$var$defaultGetTabbable, isEnabled: isEnabled = $820d2e8c6ed0c158$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $7fPBF.useRef(false);
    const sentinelStart = $7fPBF.useRef(null);
    const sentinelEnd = $7fPBF.useRef(null);
    const nodeToRestore = $7fPBF.useRef(null);
    const reactFocusEventTarget = $7fPBF.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $7fPBF.useRef(false);
    const rootRef = $7fPBF.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(children.ref, rootRef);
    const lastKeydown = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $7fPBF.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}



var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");



var $bbzbN = parcelRequire("bbzbN");
"use client";
function $af6f301d1bc38583$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */ const $af6f301d1bc38583$export$602eac185826482c = /*#__PURE__*/ $7fPBF.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $7fPBF.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(/*#__PURE__*/ $7fPBF.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($af6f301d1bc38583$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $b4ea50f2d27bbd24$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $b4ea50f2d27bbd24$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $7fPBF.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $7fPBF.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $bbzbN.jsx)($7fPBF.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)($7fPBF.Fragment, {
        children: mountNode ? /*#__PURE__*/ $fw0lo.createPortal(children, mountNode) : mountNode
    });
});



var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");







var $bbzbN = parcelRequire("bbzbN");
"use client";
const $68214be7242cbfc8$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $68214be7242cbfc8$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $68214be7242cbfc8$var$Fade = /*#__PURE__*/ $7fPBF.forwardRef(function Fade(props, ref) {
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $623678cbb6daf054$export$2e2bcd8739ae039) } = props, other = (0, $cFLic.default)(props, $68214be7242cbfc8$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $7fPBF.useRef(null);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $1ae2edacd7be6319$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $7fPBF.cloneElement(children, (0, $kY3Ke.default)({
                style: (0, $kY3Ke.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $68214be7242cbfc8$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $68214be7242cbfc8$export$2e2bcd8739ae039 = $68214be7242cbfc8$var$Fade;



var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $36421d1d94159248$export$9927a91fd93152bd(slot) {
    return (0, $k6RDS.default)("MuiBackdrop", slot);
}
const $36421d1d94159248$var$backdropClasses = (0, $4jzsB.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $36421d1d94159248$export$2e2bcd8739ae039 = $36421d1d94159248$var$backdropClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $e70e583d684cb5f4$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $e70e583d684cb5f4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $36421d1d94159248$export$9927a91fd93152bd), classes);
};
const $e70e583d684cb5f4$var$BackdropRoot = (0, $kDBhE.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $e70e583d684cb5f4$var$Backdrop = /*#__PURE__*/ $7fPBF.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, className: className, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $68214be7242cbfc8$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $cFLic.default)(props, $e70e583d684cb5f4$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $e70e583d684cb5f4$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($e70e583d684cb5f4$var$BackdropRoot, (0, $kY3Ke.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $hngXp.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $kY3Ke.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $e70e583d684cb5f4$export$2e2bcd8739ae039 = $e70e583d684cb5f4$var$Backdrop;



var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $1581382eb39c1df6$export$67960e22b12a638d(slot) {
    return (0, $k6RDS.default)("MuiModal", slot);
}
const $1581382eb39c1df6$var$modalClasses = (0, $4jzsB.default)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $1581382eb39c1df6$export$2e2bcd8739ae039 = $1581382eb39c1df6$var$modalClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $a65b89a1133e1fe4$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $a65b89a1133e1fe4$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $1581382eb39c1df6$export$67960e22b12a638d), classes);
};
const $a65b89a1133e1fe4$var$ModalRoot = (0, $kDBhE.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $a65b89a1133e1fe4$var$ModalBackdrop = (0, $kDBhE.default)((0, $e70e583d684cb5f4$export$2e2bcd8739ae039), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $a65b89a1133e1fe4$var$Modal = /*#__PURE__*/ $7fPBF.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $5j2OD.default)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $a65b89a1133e1fe4$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $cFLic.default)(props, $a65b89a1133e1fe4$var$_excluded);
    const propsWithDefaults = (0, $kY3Ke.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $0aaff92e83b421f6$export$33ffd74ebf07f060)((0, $kY3Ke.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $kY3Ke.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $a65b89a1133e1fe4$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $a65b89a1133e1fe4$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $hngXp.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $kY3Ke.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $hngXp.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $af6f301d1bc38583$export$602eac185826482c), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)(RootSlot, (0, $kY3Ke.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $bbzbN.jsx)(BackdropSlot, (0, $kY3Ke.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $820d2e8c6ed0c158$export$34eba2437817a67b), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $7fPBF.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $a65b89a1133e1fe4$export$2e2bcd8739ae039 = $a65b89a1133e1fe4$var$Modal;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");

var $kDBhE = parcelRequire("kDBhE");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $8fa7ddbbf42193a7$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $8fa7ddbbf42193a7$export$2e2bcd8739ae039 = $8fa7ddbbf42193a7$var$getOverlayAlpha;



var $5j2OD = parcelRequire("5j2OD");


var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $bde3e2fffcaea664$export$29cdb466b9b6f20b(slot) {
    return (0, $k6RDS.default)("MuiPaper", slot);
}
const $bde3e2fffcaea664$var$paperClasses = (0, $4jzsB.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $bde3e2fffcaea664$export$2e2bcd8739ae039 = $bde3e2fffcaea664$var$paperClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $74e245c78e363f11$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $74e245c78e363f11$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $bde3e2fffcaea664$export$29cdb466b9b6f20b), classes);
};
const $74e245c78e363f11$var$PaperRoot = (0, $kDBhE.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $kY3Ke.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $kY3Ke.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $cxeT8.alpha)("#fff", (0, $8fa7ddbbf42193a7$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $cxeT8.alpha)("#fff", (0, $8fa7ddbbf42193a7$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $74e245c78e363f11$var$Paper = /*#__PURE__*/ $7fPBF.forwardRef(function Paper(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation" } = props, other = (0, $cFLic.default)(props, $74e245c78e363f11$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $74e245c78e363f11$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($74e245c78e363f11$var$PaperRoot, (0, $kY3Ke.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref
    }, other));
});
var $74e245c78e363f11$export$2e2bcd8739ae039 = $74e245c78e363f11$var$Paper;



var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $a5a68170633995c3$export$88f455dd56c95edb(slot) {
    return (0, $k6RDS.default)("MuiPopover", slot);
}
const $a5a68170633995c3$var$popoverClasses = (0, $4jzsB.default)("MuiPopover", [
    "root",
    "paper"
]);
var $a5a68170633995c3$export$2e2bcd8739ae039 = $a5a68170633995c3$var$popoverClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $77b3b30833fb8c12$var$_excluded = [
    "onEntering"
], $77b3b30833fb8c12$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $77b3b30833fb8c12$var$_excluded3 = [
    "slotProps"
];
function $77b3b30833fb8c12$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $77b3b30833fb8c12$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $77b3b30833fb8c12$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $77b3b30833fb8c12$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $77b3b30833fb8c12$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $a5a68170633995c3$export$88f455dd56c95edb), classes);
};
const $77b3b30833fb8c12$export$bcce13685275fc99 = (0, $kDBhE.default)((0, $a65b89a1133e1fe4$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $77b3b30833fb8c12$export$821346c38a2d9390 = (0, $kDBhE.default)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $77b3b30833fb8c12$var$Popover = /*#__PURE__*/ $7fPBF.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = "anchorEl", children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent: TransitionComponent = (0, $7ec2c0aa92d4d29c$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $cFLic.default)(props.TransitionProps, $77b3b30833fb8c12$var$_excluded), other = (0, $cFLic.default)(props, $77b3b30833fb8c12$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $7fPBF.useRef();
    const handlePaperRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $77b3b30833fb8c12$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $7fPBF.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $77b3b30833fb8c12$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $9502daaf177b272b$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $77b3b30833fb8c12$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $77b3b30833fb8c12$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $7fPBF.useCallback((elemRect)=>{
        return {
            vertical: $77b3b30833fb8c12$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $77b3b30833fb8c12$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $7fPBF.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $77b3b30833fb8c12$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $6cb2f4180c9526e0$export$2e2bcd8739ae039)($77b3b30833fb8c12$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $77b3b30833fb8c12$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $7fPBF.useState(open);
    const setPositioningStyles = $7fPBF.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $7fPBF.useEffect(()=>{
        if (disableScrollLock) window.addEventListener("scroll", setPositioningStyles);
        return ()=>window.removeEventListener("scroll", setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $7fPBF.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $7fPBF.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $7fPBF.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $3aadd01758bd49c1$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $6cb2f4180c9526e0$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $9502daaf177b272b$export$2e2bcd8739ae039)($77b3b30833fb8c12$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $77b3b30833fb8c12$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $77b3b30833fb8c12$export$821346c38a2d9390;
    const paperProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: (0, $kY3Ke.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $kY3Ke.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $cFLic.default)(_useSlotProps, $77b3b30833fb8c12$var$_excluded3);
    return /*#__PURE__*/ (0, $bbzbN.jsx)(RootSlot, (0, $kY3Ke.default)({}, rootProps, !(0, $59c589404b20ab2d$export$e28348cc2430497)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $bbzbN.jsx)(PaperSlot, (0, $kY3Ke.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $77b3b30833fb8c12$export$2e2bcd8739ae039 = $77b3b30833fb8c12$var$Popover;



var $kDBhE = parcelRequire("kDBhE");


var $5j2OD = parcelRequire("5j2OD");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $a942fdfc6e6c5d42$export$2cf86a63a84fe23d(slot) {
    return (0, $k6RDS.default)("MuiMenu", slot);
}
const $a942fdfc6e6c5d42$var$menuClasses = (0, $4jzsB.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $a942fdfc6e6c5d42$export$2e2bcd8739ae039 = $a942fdfc6e6c5d42$var$menuClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $c415fb7f3f0f9d08$var$_excluded = [
    "onEntering"
], $c415fb7f3f0f9d08$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $c415fb7f3f0f9d08$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $c415fb7f3f0f9d08$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $c415fb7f3f0f9d08$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $a942fdfc6e6c5d42$export$2cf86a63a84fe23d), classes);
};
const $c415fb7f3f0f9d08$var$MenuRoot = (0, $kDBhE.default)((0, $77b3b30833fb8c12$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $kDBhE.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $c415fb7f3f0f9d08$export$4f7c51a5920c9f33 = (0, $kDBhE.default)((0, $77b3b30833fb8c12$export$821346c38a2d9390), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $c415fb7f3f0f9d08$var$MenuMenuList = (0, $kDBhE.default)((0, $9cb95136bc90d127$export$2e2bcd8739ae039), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $c415fb7f3f0f9d08$var$Menu = /*#__PURE__*/ $7fPBF.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = "auto", TransitionProps: { onEntering: onEntering } = {}, variant: variant = "selectedMenu", slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $cFLic.default)(props.TransitionProps, $c415fb7f3f0f9d08$var$_excluded), other = (0, $cFLic.default)(props, $c415fb7f3f0f9d08$var$_excluded2);
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $kY3Ke.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $c415fb7f3f0f9d08$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $7fPBF.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $7fPBF.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $c415fb7f3f0f9d08$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)($c415fb7f3f0f9d08$var$MenuRoot, (0, $kY3Ke.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $c415fb7f3f0f9d08$var$RTL_ORIGIN : $c415fb7f3f0f9d08$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $kY3Ke.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($c415fb7f3f0f9d08$var$MenuMenuList, (0, $kY3Ke.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $hngXp.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $c415fb7f3f0f9d08$export$2e2bcd8739ae039 = $c415fb7f3f0f9d08$var$Menu;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $b6UUh = parcelRequire("b6UUh");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $a5651256592f6f65$export$1ee13051fd9e2ab5(slot) {
    return (0, $k6RDS.default)("MuiNativeSelect", slot);
}
const $a5651256592f6f65$var$nativeSelectClasses = (0, $4jzsB.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $a5651256592f6f65$export$2e2bcd8739ae039 = $a5651256592f6f65$var$nativeSelectClasses;



var $kDBhE = parcelRequire("kDBhE");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $7a6261f84c63d345$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $7a6261f84c63d345$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $b6UUh.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $a5651256592f6f65$export$1ee13051fd9e2ab5), classes);
};
const $7a6261f84c63d345$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": (0, $kY3Ke.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, $a5651256592f6f65$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:focus": {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const $7a6261f84c63d345$var$NativeSelectSelect = (0, $kDBhE.default)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $kDBhE.rootShouldForwardProp),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $a5651256592f6f65$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($7a6261f84c63d345$export$c1eccd1617458c87);
const $7a6261f84c63d345$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $a5651256592f6f65$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const $7a6261f84c63d345$var$NativeSelectIcon = (0, $kDBhE.default)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $b6UUh.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($7a6261f84c63d345$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $7a6261f84c63d345$var$NativeSelectInput = /*#__PURE__*/ $7fPBF.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = "standard" } = props, other = (0, $cFLic.default)(props, $7a6261f84c63d345$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $7a6261f84c63d345$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($7a6261f84c63d345$var$NativeSelectSelect, (0, $kY3Ke.default)({
                ownerState: ownerState,
                className: (0, $hngXp.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $bbzbN.jsx)($7a6261f84c63d345$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $7a6261f84c63d345$export$2e2bcd8739ae039 = $7a6261f84c63d345$var$NativeSelectInput;


// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $5e9f5ca6e3e911fc$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $5e9f5ca6e3e911fc$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($5e9f5ca6e3e911fc$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $5e9f5ca6e3e911fc$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
}
function $5e9f5ca6e3e911fc$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $kDBhE = parcelRequire("kDBhE");



var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $5ea8b5d2968b699c$export$2c0c1ee5a3392e(slot) {
    return (0, $k6RDS.default)("MuiSelect", slot);
}
const $5ea8b5d2968b699c$var$selectClasses = (0, $4jzsB.default)("MuiSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $5ea8b5d2968b699c$export$2e2bcd8739ae039 = $5ea8b5d2968b699c$var$selectClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
var $59b8977b1194262f$var$_span;
const $59b8977b1194262f$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $59b8977b1194262f$var$SelectSelect = (0, $kDBhE.default)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $7a6261f84c63d345$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $59b8977b1194262f$var$SelectIcon = (0, $kDBhE.default)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $b6UUh.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $7a6261f84c63d345$export$e7a817afd12a40d0));
const $59b8977b1194262f$var$SelectNativeInput = (0, $kDBhE.default)("input", {
    shouldForwardProp: (prop)=>(0, $kDBhE.slotShouldForwardProp)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $59b8977b1194262f$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $59b8977b1194262f$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $59b8977b1194262f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $b6UUh.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $5ea8b5d2968b699c$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $59b8977b1194262f$var$SelectInput = /*#__PURE__*/ $7fPBF.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = "standard" } = props, other = (0, $cFLic.default)(props, $59b8977b1194262f$var$_excluded);
    const [value, setValueState] = (0, $3b64539a8a5729fa$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $3b64539a8a5729fa$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $7fPBF.useRef(null);
    const displayRef = $7fPBF.useRef(null);
    const [displayNode, setDisplayNode] = $7fPBF.useState(null);
    const { current: isOpenControlled } = $7fPBF.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $7fPBF.useState();
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $7fPBF.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $7fPBF.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $7fPBF.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $7fPBF.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $7fPBF.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $9502daaf177b272b$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $7fPBF.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $5e9f5ca6e3e911fc$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $e5zLi.default)(2));
            selected = value.some((v)=>$59b8977b1194262f$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $59b8977b1194262f$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $7fPBF.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $59b8977b1194262f$var$useUtilityClasses(ownerState);
    const paperProps = (0, $kY3Ke.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $46f5b561912058f9$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($59b8977b1194262f$var$SelectSelect, (0, $kY3Ke.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $hngXp.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $59b8977b1194262f$var$isEmpty(display) ? $59b8977b1194262f$var$_span || ($59b8977b1194262f$var$_span = /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $bbzbN.jsx)($59b8977b1194262f$var$SelectNativeInput, (0, $kY3Ke.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $bbzbN.jsx)($59b8977b1194262f$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
                id: `menu-${name || ""}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $kY3Ke.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    "aria-multiselectable": multiple ? "true" : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $kY3Ke.default)({}, MenuProps.slotProps, {
                    paper: (0, $kY3Ke.default)({}, paperProps, {
                        style: (0, $kY3Ke.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $59b8977b1194262f$export$2e2bcd8739ae039 = $59b8977b1194262f$var$SelectInput;




parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $7cc16c93aade5bc5$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $cFCqu = parcelRequire("cFCqu");

var $dYkRa = parcelRequire("dYkRa");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $e5zLi = parcelRequire("e5zLi");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $fw0lo = parcelRequire("fw0lo");


var $bbzbN = parcelRequire("bbzbN");
"use client";
const $9907d957cc1b52b6$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $9907d957cc1b52b6$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $9907d957cc1b52b6$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $9907d957cc1b52b6$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflow;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base-ui/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base-ui/react-textarea-autosize/components-api/#textarea-autosize)
 */ const $9907d957cc1b52b6$export$d1710922ecaf577a = /*#__PURE__*/ $7fPBF.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $cFLic.default)(props, $9907d957cc1b52b6$var$_excluded);
    const { current: isControlled } = $7fPBF.useRef(value != null);
    const inputRef = $7fPBF.useRef(null);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(forwardedRef, inputRef);
    const shadowRef = $7fPBF.useRef(null);
    const renders = $7fPBF.useRef(0);
    const [state, setState] = $7fPBF.useState({
        outerHeightStyle: 0
    });
    const getUpdatedState = $7fPBF.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $c1e4563498af7952$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = $9907d957cc1b52b6$var$getStyleValue(computedStyle.paddingBottom) + $9907d957cc1b52b6$var$getStyleValue(computedStyle.paddingTop);
        const border = $9907d957cc1b52b6$var$getStyleValue(computedStyle.borderBottomWidth) + $9907d957cc1b52b6$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflow = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflow: overflow
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const updateState = (prevState, newState)=>{
        const { outerHeightStyle: outerHeightStyle, overflow: overflow } = newState;
        // Need a large enough difference to update the height.
        // This prevents infinite rendering loop.
        if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
            renders.current += 1;
            return {
                overflow: overflow,
                outerHeightStyle: outerHeightStyle
            };
        }
        return prevState;
    };
    const syncHeight = $7fPBF.useCallback(()=>{
        const newState = getUpdatedState();
        if ($9907d957cc1b52b6$var$isEmpty(newState)) return;
        setState((prevState)=>updateState(prevState, newState));
    }, [
        getUpdatedState
    ]);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        const syncHeightWithFlushSync = ()=>{
            const newState = getUpdatedState();
            if ($9907d957cc1b52b6$var$isEmpty(newState)) return;
            // In React 18, state updates in a ResizeObserver's callback are happening after
            // the paint, this leads to an infinite rendering.
            //
            // Using flushSync ensures that the states is updated before the next pain.
            // Related issue - https://github.com/facebook/react/issues/24331
            $fw0lo.flushSync(()=>{
                setState((prevState)=>updateState(prevState, newState));
            });
        };
        const handleResize = ()=>{
            renders.current = 0;
            syncHeightWithFlushSync();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, $c285f587ed4585eb$export$2e2bcd8739ae039)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, $c1e4563498af7952$export$2e2bcd8739ae039)(input);
        containerWindow.addEventListener("resize", debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener("resize", debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        getUpdatedState
    ]);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    $7fPBF.useEffect(()=>{
        renders.current = 0;
    }, [
        value
    ]);
    const handleChange = (event)=>{
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("textarea", (0, $kY3Ke.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: (0, $kY3Ke.default)({
                    height: state.outerHeightStyle,
                    // Need a large enough difference to allow scrolling.
                    // This prevents infinite rendering loop.
                    overflow: state.overflow ? "hidden" : undefined
                }, style)
            }, other)),
            /*#__PURE__*/ (0, $bbzbN.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $kY3Ke.default)({}, $9907d957cc1b52b6$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});


var $cFCqu = parcelRequire("cFCqu");




var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $b6UUh = parcelRequire("b6UUh");



var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");

parcelRequire("7fPBF");


var $5tMhb = parcelRequire("5tMhb");

var $4kWyf = parcelRequire("4kWyf");

var $bbzbN = parcelRequire("bbzbN");
"use client";
function $ee13700d4d997375$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $4kWyf.default)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5tMhb.default), {
        styles: globalStyles
    });
}
var $ee13700d4d997375$export$2e2bcd8739ae039 = $ee13700d4d997375$var$GlobalStyles;



var $9P91Y = parcelRequire("9P91Y");

var $jwhZE = parcelRequire("jwhZE");

var $bbzbN = parcelRequire("bbzbN");
"use client";
function $a50e20ff7f02e09b$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ee13700d4d997375$export$2e2bcd8739ae039), (0, $kY3Ke.default)({}, props, {
        defaultTheme: (0, $9P91Y.default),
        themeId: (0, $jwhZE.default)
    }));
}
var $a50e20ff7f02e09b$export$2e2bcd8739ae039 = $a50e20ff7f02e09b$var$GlobalStyles;




var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $2b15682cef07fc0a$export$ef57d5c8ca2278f6(slot) {
    return (0, $k6RDS.default)("MuiInputBase", slot);
}
const $2b15682cef07fc0a$var$inputBaseClasses = (0, $4jzsB.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $2b15682cef07fc0a$export$2e2bcd8739ae039 = $2b15682cef07fc0a$var$inputBaseClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $ba9f7182d6802613$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $ba9f7182d6802613$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $b6UUh.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $ba9f7182d6802613$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $ba9f7182d6802613$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $b6UUh.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size && size !== "medium" && `size${(0, $b6UUh.default)(size)}`,
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $2b15682cef07fc0a$export$ef57d5c8ca2278f6), classes);
};
const $ba9f7182d6802613$export$298a043133d72a38 = (0, $kDBhE.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $ba9f7182d6802613$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $2b15682cef07fc0a$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, $kY3Ke.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const $ba9f7182d6802613$export$a1ad29c901026019 = (0, $kDBhE.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $ba9f7182d6802613$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    const placeholder = (0, $kY3Ke.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $kY3Ke.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $2b15682cef07fc0a$export$2e2bcd8739ae039).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $2b15682cef07fc0a$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const $ba9f7182d6802613$var$inputGlobalStyles = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a50e20ff7f02e09b$export$2e2bcd8739ae039), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $ba9f7182d6802613$var$InputBase = /*#__PURE__*/ $7fPBF.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = "text", value: valueProp } = props, other = (0, $cFLic.default)(props, $ba9f7182d6802613$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $7fPBF.useRef(value != null);
    const inputRef = $7fPBF.useRef();
    const handleInputRefWarning = $7fPBF.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $7fPBF.useState(false);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $7fPBF.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $7fPBF.useCallback((obj)=>{
        if ((0, $5e9f5ca6e3e911fc$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $e5zLi.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $7fPBF.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, $kY3Ke.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $kY3Ke.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $9907d957cc1b52b6$export$d1710922ecaf577a);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $7fPBF.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $ba9f7182d6802613$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $ba9f7182d6802613$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $ba9f7182d6802613$export$a1ad29c901026019;
    inputProps = (0, $kY3Ke.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $ba9f7182d6802613$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $bbzbN.jsxs)(Root, (0, $kY3Ke.default)({}, rootProps, !(0, $59c589404b20ab2d$export$e28348cc2430497)(Root) && {
                ownerState: (0, $kY3Ke.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $hngXp.default)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f29d66cab44a33c0$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)(Input, (0, $kY3Ke.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $59c589404b20ab2d$export$e28348cc2430497)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $kY3Ke.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $hngXp.default)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $kY3Ke.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $ba9f7182d6802613$export$2e2bcd8739ae039 = $ba9f7182d6802613$var$InputBase;



var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $kY3Ke = parcelRequire("kY3Ke");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");

function $aadd2b32ac43594b$export$cdb270390122322b(slot) {
    return (0, $k6RDS.default)("MuiInput", slot);
}
const $aadd2b32ac43594b$var$inputClasses = (0, $kY3Ke.default)({}, (0, $2b15682cef07fc0a$export$2e2bcd8739ae039), (0, $4jzsB.default)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $aadd2b32ac43594b$export$2e2bcd8739ae039 = $aadd2b32ac43594b$var$inputClasses;




var $bbzbN = parcelRequire("bbzbN");
"use client";
const $e0d49bb29c2f8b76$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $e0d49bb29c2f8b76$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $aadd2b32ac43594b$export$cdb270390122322b), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $e0d49bb29c2f8b76$var$InputRoot = (0, $kDBhE.default)((0, $ba9f7182d6802613$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $kDBhE.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $ba9f7182d6802613$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $kY3Ke.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).error}`]: {
            "&:before, &:after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&:before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).disabled}, .${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const $e0d49bb29c2f8b76$var$InputInput = (0, $kDBhE.default)((0, $ba9f7182d6802613$export$a1ad29c901026019), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $ba9f7182d6802613$export$cf507b112810e72d)
})({});
const $e0d49bb29c2f8b76$var$Input = /*#__PURE__*/ $7fPBF.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $cFLic.default)(props, $e0d49bb29c2f8b76$var$_excluded);
    const classes = $e0d49bb29c2f8b76$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $dYkRa.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $e0d49bb29c2f8b76$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $e0d49bb29c2f8b76$var$InputInput;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ba9f7182d6802613$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$e0d49bb29c2f8b76$var$Input.muiName = "Input";
var $e0d49bb29c2f8b76$export$2e2bcd8739ae039 = $e0d49bb29c2f8b76$var$Input;




var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $dYkRa = parcelRequire("dYkRa");


var $cFCqu = parcelRequire("cFCqu");


var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $kY3Ke = parcelRequire("kY3Ke");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");

function $c2b262889cde4af1$export$3331e419f1a48437(slot) {
    return (0, $k6RDS.default)("MuiFilledInput", slot);
}
const $c2b262889cde4af1$var$filledInputClasses = (0, $kY3Ke.default)({}, (0, $2b15682cef07fc0a$export$2e2bcd8739ae039), (0, $4jzsB.default)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $c2b262889cde4af1$export$2e2bcd8739ae039 = $c2b262889cde4af1$var$filledInputClasses;




var $bbzbN = parcelRequire("bbzbN");
"use client";
const $faf35b44bb61ebfd$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $faf35b44bb61ebfd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $c2b262889cde4af1$export$3331e419f1a48437), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $faf35b44bb61ebfd$var$FilledInputRoot = (0, $kDBhE.default)((0, $ba9f7182d6802613$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $kDBhE.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $ba9f7182d6802613$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return (0, $kY3Ke.default)({
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).error}`]: {
            "&:before, &:after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&:before": {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).disabled}, .${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $kY3Ke.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }));
});
const $faf35b44bb61ebfd$var$FilledInputInput = (0, $kDBhE.default)((0, $ba9f7182d6802613$export$a1ad29c901026019), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $ba9f7182d6802613$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
const $faf35b44bb61ebfd$var$FilledInput = /*#__PURE__*/ $7fPBF.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $cFLic.default)(props, $faf35b44bb61ebfd$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $faf35b44bb61ebfd$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $dYkRa.default)(slotProps != null ? slotProps : componentsPropsProp, filledInputComponentsProps) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $faf35b44bb61ebfd$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $faf35b44bb61ebfd$var$FilledInputInput;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ba9f7182d6802613$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$faf35b44bb61ebfd$var$FilledInput.muiName = "Input";
var $faf35b44bb61ebfd$export$2e2bcd8739ae039 = $faf35b44bb61ebfd$var$FilledInput;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");



var $cFCqu = parcelRequire("cFCqu");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");


var $kDBhE = parcelRequire("kDBhE");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $ae700d9709d2b786$var$_span;
const $ae700d9709d2b786$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $ae700d9709d2b786$var$NotchedOutlineRoot = (0, $kDBhE.default)("fieldset", {
    shouldForwardProp: (0, $kDBhE.rootShouldForwardProp)
})({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $ae700d9709d2b786$var$NotchedOutlineLegend = (0, $kDBhE.default)("legend", {
    shouldForwardProp: (0, $kDBhE.rootShouldForwardProp)
})(({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $kY3Ke.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $ae700d9709d2b786$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $cFLic.default)(props, $ae700d9709d2b786$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $kY3Ke.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)($ae700d9709d2b786$var$NotchedOutlineRoot, (0, $kY3Ke.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($ae700d9709d2b786$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                children: label
            }) : $ae700d9709d2b786$var$_span || ($ae700d9709d2b786$var$_span = /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}





var $kDBhE = parcelRequire("kDBhE");

var $kY3Ke = parcelRequire("kY3Ke");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");

function $fbe32ff46b8bf823$export$89922944c7227687(slot) {
    return (0, $k6RDS.default)("MuiOutlinedInput", slot);
}
const $fbe32ff46b8bf823$var$outlinedInputClasses = (0, $kY3Ke.default)({}, (0, $2b15682cef07fc0a$export$2e2bcd8739ae039), (0, $4jzsB.default)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $fbe32ff46b8bf823$export$2e2bcd8739ae039 = $fbe32ff46b8bf823$var$outlinedInputClasses;




var $5j2OD = parcelRequire("5j2OD");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $50e7e9efec2c0b8c$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $50e7e9efec2c0b8c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $fbe32ff46b8bf823$export$89922944c7227687), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $50e7e9efec2c0b8c$var$OutlinedInputRoot = (0, $kDBhE.default)((0, $ba9f7182d6802613$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $kDBhE.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $ba9f7182d6802613$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, $kY3Ke.default)({
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).focused} .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).error} .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).disabled} .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $kY3Ke.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const $50e7e9efec2c0b8c$var$NotchedOutlineRoot = (0, $kDBhE.default)((0, $ae700d9709d2b786$export$2e2bcd8739ae039), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $50e7e9efec2c0b8c$var$OutlinedInputInput = (0, $kDBhE.default)((0, $ba9f7182d6802613$export$a1ad29c901026019), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $ba9f7182d6802613$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $50e7e9efec2c0b8c$var$OutlinedInput = /*#__PURE__*/ $7fPBF.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = "text" } = props, other = (0, $cFLic.default)(props, $50e7e9efec2c0b8c$var$_excluded);
    const classes = $50e7e9efec2c0b8c$var$useUtilityClasses(props);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "focused",
            "hiddenLabel",
            "size",
            "required"
        ]
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $50e7e9efec2c0b8c$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $50e7e9efec2c0b8c$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ba9f7182d6802613$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $bbzbN.jsx)($50e7e9efec2c0b8c$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $kY3Ke.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$50e7e9efec2c0b8c$var$OutlinedInput.muiName = "Input";
var $50e7e9efec2c0b8c$export$2e2bcd8739ae039 = $50e7e9efec2c0b8c$var$OutlinedInput;



var $5j2OD = parcelRequire("5j2OD");


var $kDBhE = parcelRequire("kDBhE");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $e07ff65b28ac412d$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $e07ff65b28ac412d$var$_excluded2 = [
    "root"
];
const $e07ff65b28ac412d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $e07ff65b28ac412d$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $kDBhE.rootShouldForwardProp)(prop) && prop !== "variant",
    slot: "Root"
};
const $e07ff65b28ac412d$var$StyledInput = (0, $kDBhE.default)((0, $e0d49bb29c2f8b76$export$2e2bcd8739ae039), $e07ff65b28ac412d$var$styledRootConfig)("");
const $e07ff65b28ac412d$var$StyledOutlinedInput = (0, $kDBhE.default)((0, $50e7e9efec2c0b8c$export$2e2bcd8739ae039), $e07ff65b28ac412d$var$styledRootConfig)("");
const $e07ff65b28ac412d$var$StyledFilledInput = (0, $kDBhE.default)((0, $faf35b44bb61ebfd$export$2e2bcd8739ae039), $e07ff65b28ac412d$var$styledRootConfig)("");
const $e07ff65b28ac412d$var$Select = /*#__PURE__*/ $7fPBF.forwardRef(function Select(inProps, ref) {
    const props = (0, $5j2OD.default)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $7cc16c93aade5bc5$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = "outlined" } = props, other = (0, $cFLic.default)(props, $e07ff65b28ac412d$var$_excluded);
    const inputComponent = native ? (0, $7a6261f84c63d345$export$2e2bcd8739ae039) : (0, $59b8977b1194262f$export$2e2bcd8739ae039);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $kY3Ke.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $e07ff65b28ac412d$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $cFLic.default)(classes, $e07ff65b28ac412d$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $bbzbN.jsx)($e07ff65b28ac412d$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $bbzbN.jsx)($e07ff65b28ac412d$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $bbzbN.jsx)($e07ff65b28ac412d$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($7fPBF.Fragment, {
        children: /*#__PURE__*/ $7fPBF.cloneElement(InputComponent, (0, $kY3Ke.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $kY3Ke.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $kY3Ke.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $dYkRa.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, multiple && native && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $hngXp.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$e07ff65b28ac412d$var$Select.muiName = "Select";
var $e07ff65b28ac412d$export$2e2bcd8739ae039 = $e07ff65b28ac412d$var$Select;


var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");


var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");




var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $cFCqu = parcelRequire("cFCqu");

var $hngXp = parcelRequire("hngXp");



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");



var $b6UUh = parcelRequire("b6UUh");

var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $94ffd68a66aaae7e$export$f7d501e40371cd17(slot) {
    return (0, $k6RDS.default)("MuiFormLabel", slot);
}
const $94ffd68a66aaae7e$var$formLabelClasses = (0, $4jzsB.default)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $94ffd68a66aaae7e$export$2e2bcd8739ae039 = $94ffd68a66aaae7e$var$formLabelClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $90370d1df15229dd$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $90370d1df15229dd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $b6UUh.default)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $94ffd68a66aaae7e$export$f7d501e40371cd17), classes);
};
const $90370d1df15229dd$export$aa5bc7f8a4705b27 = (0, $kDBhE.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $kY3Ke.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        [`&.${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $90370d1df15229dd$var$AsteriskComponent = (0, $kDBhE.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $90370d1df15229dd$var$FormLabel = /*#__PURE__*/ $7fPBF.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children: children, className: className, component: component = "label" } = props, other = (0, $cFLic.default)(props, $90370d1df15229dd$var$_excluded);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $90370d1df15229dd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($90370d1df15229dd$export$aa5bc7f8a4705b27, (0, $kY3Ke.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $bbzbN.jsxs)($90370d1df15229dd$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    "*"
                ]
            })
        ]
    }));
});
var $90370d1df15229dd$export$2e2bcd8739ae039 = $90370d1df15229dd$var$FormLabel;



var $5j2OD = parcelRequire("5j2OD");

var $b6UUh = parcelRequire("b6UUh");

var $kDBhE = parcelRequire("kDBhE");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $2b0d2ae144238f59$export$c1c4b4545ad2ea5f(slot) {
    return (0, $k6RDS.default)("MuiInputLabel", slot);
}
const $2b0d2ae144238f59$var$inputLabelClasses = (0, $4jzsB.default)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
var $2b0d2ae144238f59$export$2e2bcd8739ae039 = $2b0d2ae144238f59$var$inputLabelClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $fcd80672e9993aad$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $fcd80672e9993aad$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size && size !== "normal" && `size${(0, $b6UUh.default)(size)}`,
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $2b0d2ae144238f59$export$c1c4b4545ad2ea5f), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $fcd80672e9993aad$var$InputLabelRoot = (0, $kDBhE.default)((0, $90370d1df15229dd$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $kDBhE.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%"
    }, ownerState.formControl && {
        position: "absolute",
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: "translate(0, 20px) scale(1)"
    }, ownerState.size === "small" && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: "translate(0, 17px) scale(1)"
    }, ownerState.shrink && {
        transform: "translate(0, -1.5px) scale(0.75)",
        transformOrigin: "top left",
        maxWidth: "133%"
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            "color",
            "transform",
            "max-width"
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === "filled" && (0, $kY3Ke.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(12px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 13px) scale(1)"
    }, ownerState.shrink && (0, $kY3Ke.default)({
        userSelect: "none",
        pointerEvents: "auto",
        transform: "translate(12px, 7px) scale(0.75)",
        maxWidth: "calc(133% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 4px) scale(0.75)"
    })), ownerState.variant === "outlined" && (0, $kY3Ke.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(14px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(14px, 9px) scale(1)"
    }, ownerState.shrink && {
        userSelect: "none",
        pointerEvents: "auto",
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: "calc(133% - 32px)",
        transform: "translate(14px, -9px) scale(0.75)"
    })));
const $fcd80672e9993aad$var$InputLabel = /*#__PURE__*/ $7fPBF.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $5j2OD.default)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $cFLic.default)(props, $fcd80672e9993aad$var$_excluded);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "size",
            "variant",
            "required",
            "focused"
        ]
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $fcd80672e9993aad$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($fcd80672e9993aad$var$InputLabelRoot, (0, $kY3Ke.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $hngXp.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $fcd80672e9993aad$export$2e2bcd8739ae039 = $fcd80672e9993aad$var$InputLabel;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");


var $b6UUh = parcelRequire("b6UUh");

var $7fPBF = parcelRequire("7fPBF");
function $68d5ebbaafb4376f$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $7fPBF.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $6926d37cb7ff7774$export$2e2bcd8739ae039 = (0, $68d5ebbaafb4376f$export$2e2bcd8739ae039);




var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $6fa629ce89e8ad57$export$149c8b8bab2289d1(slot) {
    return (0, $k6RDS.default)("MuiFormControl", slot);
}
const $6fa629ce89e8ad57$var$formControlClasses = (0, $4jzsB.default)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $6fa629ce89e8ad57$export$2e2bcd8739ae039 = $6fa629ce89e8ad57$var$formControlClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $26a8e925f0aa9998$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $26a8e925f0aa9998$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, $b6UUh.default)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $6fa629ce89e8ad57$export$149c8b8bab2289d1), classes);
};
const $26a8e925f0aa9998$var$FormControlRoot = (0, $kDBhE.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $kY3Ke.default)({}, styles.root, styles[`margin${(0, $b6UUh.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $26a8e925f0aa9998$var$FormControl = /*#__PURE__*/ $7fPBF.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = "none", required: required = false, size: size = "medium", variant: variant = "outlined" } = props, other = (0, $cFLic.default)(props, $26a8e925f0aa9998$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $26a8e925f0aa9998$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $7fPBF.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $7fPBF.Children.forEach(children, (child)=>{
            if (!(0, $6926d37cb7ff7774$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, $6926d37cb7ff7774$export$2e2bcd8739ae039)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $5e9f5ca6e3e911fc$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $7fPBF.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $7fPBF.Children.forEach(children, (child)=>{
            if (!(0, $6926d37cb7ff7774$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $5e9f5ca6e3e911fc$export$d652b828d7fdeff8)(child.props, true) || (0, $5e9f5ca6e3e911fc$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $7fPBF.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $7fPBF.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f29d66cab44a33c0$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($26a8e925f0aa9998$var$FormControlRoot, (0, $kY3Ke.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $hngXp.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $26a8e925f0aa9998$export$2e2bcd8739ae039 = $26a8e925f0aa9998$var$FormControl;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");



var $kDBhE = parcelRequire("kDBhE");

var $b6UUh = parcelRequire("b6UUh");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $10a7abfeb1405549$export$a394fa61b1d583a9(slot) {
    return (0, $k6RDS.default)("MuiFormHelperText", slot);
}
const $10a7abfeb1405549$var$formHelperTextClasses = (0, $4jzsB.default)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
var $10a7abfeb1405549$export$2e2bcd8739ae039 = $10a7abfeb1405549$var$formHelperTextClasses;



var $5j2OD = parcelRequire("5j2OD");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $0321a2cb63129955$var$_span;
const $0321a2cb63129955$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $0321a2cb63129955$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && `size${(0, $b6UUh.default)(size)}`,
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $10a7abfeb1405549$export$a394fa61b1d583a9), classes);
};
const $0321a2cb63129955$var$FormHelperTextRoot = (0, $kDBhE.default)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $b6UUh.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $10a7abfeb1405549$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $10a7abfeb1405549$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === "small" && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $0321a2cb63129955$var$FormHelperText = /*#__PURE__*/ $7fPBF.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    const { children: children, className: className, component: component = "p" } = props, other = (0, $cFLic.default)(props, $0321a2cb63129955$var$_excluded);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $0321a2cb63129955$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($0321a2cb63129955$var$FormHelperTextRoot, (0, $kY3Ke.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === " " ? $0321a2cb63129955$var$_span || ($0321a2cb63129955$var$_span = /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $0321a2cb63129955$export$2e2bcd8739ae039 = $0321a2cb63129955$var$FormHelperText;




var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $16716b95f6c79ff6$export$c1bdcbaf0596aeda(slot) {
    return (0, $k6RDS.default)("MuiTextField", slot);
}
const $16716b95f6c79ff6$var$textFieldClasses = (0, $4jzsB.default)("MuiTextField", [
    "root"
]);
var $16716b95f6c79ff6$export$2e2bcd8739ae039 = $16716b95f6c79ff6$var$textFieldClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $afe2b905acb8b9f6$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $afe2b905acb8b9f6$var$variantComponent = {
    standard: (0, $e0d49bb29c2f8b76$export$2e2bcd8739ae039),
    filled: (0, $faf35b44bb61ebfd$export$2e2bcd8739ae039),
    outlined: (0, $50e7e9efec2c0b8c$export$2e2bcd8739ae039)
};
const $afe2b905acb8b9f6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $16716b95f6c79ff6$export$c1bdcbaf0596aeda), classes);
};
const $afe2b905acb8b9f6$var$TextFieldRoot = (0, $kDBhE.default)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $afe2b905acb8b9f6$var$TextField = /*#__PURE__*/ $7fPBF.forwardRef(function TextField(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiTextField"
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = "primary", defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = "outlined" } = props, other = (0, $cFLic.default)(props, $afe2b905acb8b9f6$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $afe2b905acb8b9f6$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    const id = (0, $46f5b561912058f9$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $afe2b905acb8b9f6$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $bbzbN.jsx)(InputComponent, (0, $kY3Ke.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($afe2b905acb8b9f6$var$TextFieldRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== "" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fcd80672e9993aad$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $0321a2cb63129955$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $afe2b905acb8b9f6$export$2e2bcd8739ae039 = $afe2b905acb8b9f6$var$TextField;



var $59325e2784da411f$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $59325e2784da411f$export$148f1ea13562f62c = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039))($59325e2784da411f$var$templateObject_1 || ($59325e2784da411f$var$templateObject_1 = $59325e2784da411f$var$__makeTemplateObject([
    "\n  .MuiOutlinedInput-root {\n    border-radius: 25px;\n  }\n"
], [
    "\n  .MuiOutlinedInput-root {\n    border-radius: 25px;\n  }\n"
])));
var $59325e2784da411f$export$4d7ecc5335eb78f1 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039))($59325e2784da411f$var$templateObject_2 || ($59325e2784da411f$var$templateObject_2 = $59325e2784da411f$var$__makeTemplateObject([
    "\n  border-radius: 25px !important;\n"
], [
    "\n  border-radius: 25px !important;\n"
])));
var $59325e2784da411f$export$975ebf2eafe6c281 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039))($59325e2784da411f$var$templateObject_3 || ($59325e2784da411f$var$templateObject_3 = $59325e2784da411f$var$__makeTemplateObject([
    "\n  margin-top: 16px !important;\n  margin-bottom: 8px !important;\n"
], [
    "\n  margin-top: 16px !important;\n  margin-bottom: 8px !important;\n"
])));
var $59325e2784da411f$export$d431c670a4473428 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).textarea($59325e2784da411f$var$templateObject_4 || ($59325e2784da411f$var$templateObject_4 = $59325e2784da411f$var$__makeTemplateObject([
    "\n  border: 1px solid #ccc;\n  border-radius: 25px;\n  padding: 8px;\n  width: 100%;\n"
], [
    "\n  border: 1px solid #ccc;\n  border-radius: 25px;\n  padding: 8px;\n  width: 100%;\n"
]))); // You can further style Checkbox and Radio if required
var $59325e2784da411f$export$887faf5e94d3db05 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $4d99e6d55ec7d57a$export$2e2bcd8739ae039))($59325e2784da411f$var$templateObject_5 || ($59325e2784da411f$var$templateObject_5 = $59325e2784da411f$var$__makeTemplateObject([
    ""
], [
    ""
])));
var $59325e2784da411f$export$827500fb527b2648 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $de28970229c88fa7$export$2e2bcd8739ae039))($59325e2784da411f$var$templateObject_6 || ($59325e2784da411f$var$templateObject_6 = $59325e2784da411f$var$__makeTemplateObject([
    ""
], [
    ""
])));
var $59325e2784da411f$var$templateObject_1, $59325e2784da411f$var$templateObject_2, $59325e2784da411f$var$templateObject_3, $59325e2784da411f$var$templateObject_4, $59325e2784da411f$var$templateObject_5, $59325e2784da411f$var$templateObject_6;




var $7fPBF = parcelRequire("7fPBF");
var $2a1f02c275eba654$var$__assign = undefined && undefined.__assign || function() {
    $2a1f02c275eba654$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2a1f02c275eba654$var$__assign.apply(this, arguments);
};
var $2a1f02c275eba654$var$Logo = function() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $2a1f02c275eba654$var$__assign({}, {
        enableBackground: "new 0 0 334.5 122.5"
    }, {
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 334.5 122.5",
        xmlSpace: "preserve"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("style", {
        type: "text/css"
    }, "\n            .st0{fill:#FFFFFF;}\n            .st1{opacity:0.4;fill:#FFFFFF;}\n            .st2{opacity:0.5;fill:#FFFFFF;}\n            .st3{opacity:0.6;fill:#FFFFFF;}\n            .st4{opacity:0.7;fill:#FFFFFF;}\n            .st5{opacity:0.8;fill:#FFFFFF;}\n            .st6{opacity:0.9;fill:#FFFFFF;}\n            "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        className: "st0",
        d: "M62.9,74.9h-0.1c-0.1,1.5-0.9,4.1-2,6.7l-11.5,30.1H39.1L27.3,81.1c-1-2.6-2-5.3-2-6.7h-0.1v29.9h5.3v7.4H12.3\n		v-7.4h4.5V68.1h-5.3v-7.4h18.7l13.1,33.9c0.8,2,1.8,4,2,6.9h0.1c0.2-2.9,1-5,2.6-9.1l11.9-31.7h18.5v7.4h-5.3v36.2h5.1v7.4H58.6\n		v-7.4h4.3V74.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        className: "st0",
        d: "M113.6,60.7h19.8v7.4h-4.6v23.3c0,15.9-6.7,21.2-21.7,21.2c-16.8,0-20.4-7.4-20.4-18.7V68.1h-4.6v-7.4H102v7.4\n		h-4.6v24c0,7.4,2.2,12.2,10.4,12.2c6.8,0,11.5-2.4,11.5-12.2v-24h-5.6V60.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        className: "st0",
        d: "M166.3,68.5c-1.9-0.7-4.4-1.2-6.9-1.2c-7.1,0-9.3,3.6-9.3,6.5c0,3.7,2.7,4.8,6.1,5.6l6.1,1.5\n		c7.5,1.9,15.8,4.4,15.8,15c0,9.7-6.6,16.8-21.1,16.8c-5.6,0-11.5-0.6-18.3-2.8V96.3h10.7v6.7c2.7,1.1,5.6,1.3,8.6,1.3\n		c6.3,0,9-3,9-6.9c0-2.6-1.5-4.5-8.3-6.3l-5.6-1.5C142.6,87,139,82.9,139,75.1c0-8.1,5.7-15.2,20.1-15.2c6.2,0,12.4,1,16.8,2.7v12.2\n		h-9.6V68.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        className: "st0",
        d: "M220.9,68.1h-9.2v36.2h4.6v7.4h-19.8v-7.4h4.6V68.1h-9.2l-0.4,7h-8.8l0.4-14.4h46.5l0.4,14.4h-8.8L220.9,68.1z\n		"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        className: "st0",
        d: "M262.7,95.7h8.8l-0.6,16h-36.7v-7.4h4.6V68.1h-5.5v-7.4h37.4l0.4,15h-8.8l-0.4-7.6h-12.5v13.4h12.8v7.9h-12.8\n		v14.9h12.7L262.7,95.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        className: "st0",
        d: "M282.1,68.1h-5v-7.4h22.5c6,0,7.8,0.4,10.7,1.9c4.6,2.3,6.9,6.9,6.9,12.1c0,7.6-6.3,13-12,13.2V88\n		c2.6,0.2,4,1.2,6.6,5.4l4.6,7.7c1.5,2.6,2.8,3.2,4.2,3.2h1.9v7.4h-8.2c-2.7,0-4.6-0.9-8.5-7.7l-6.2-10.7c-1-1.7-2.3-2.6-4.2-2.6\n		h-2.5v13.4h4.6v7.4h-19.8v-7.4h4.6V68.1z M292.7,83h5.5c5.7,0,8.3-2.5,8.3-7.4c0-5-2.5-7.4-9-7.4h-4.8V83z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: "234.2",
        y: "50.4",
        className: "st1",
        width: "9.2",
        height: "3.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: "246.5",
        y: "48.2",
        className: "st2",
        width: "9.2",
        height: "5.9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: "258.7",
        y: "43.7",
        className: "st3",
        width: "9.2",
        height: "10.3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: "271",
        y: "36.8",
        className: "st4",
        width: "9.2",
        height: "17.3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: "283.2",
        y: "30.6",
        className: "st5",
        width: "9.2",
        height: "23.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: "295.5",
        y: "21.6",
        className: "st6",
        width: "9.2",
        height: "32.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: "307.7",
        y: "11.1",
        className: "st0",
        width: "9.2",
        height: "43"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        className: "st0",
        d: "M12.2,48.7l0.5-0.7c0.4-0.5,0.8-0.6,1.3-0.2c0.6,0.5,4.8,4.4,10.6,4.4c5.2,0,9.6-3.5,9.6-7.7\n		c0-5.1-4.2-7.4-11.1-9.7c-6.6-2.3-11-4.7-11-11.2c0-4.3,3.4-10.1,12.3-10.1c5.7,0,9.8,2.9,9.8,2.9c0.2,0.2,0.6,0.6,0.2,1.2\n		c-0.2,0.2-0.3,0.5-0.5,0.7c-0.3,0.5-0.7,0.6-1.3,0.3c-0.2-0.1-4-2.7-8.4-2.7c-7,0-9.6,4.3-9.6,7.6c0,4.9,3.7,7,9.5,8.9\n		c7.8,2.7,12.8,5.4,12.8,12c0,5.7-5.9,10.2-12.4,10.2c-6.8,0-11.4-4-12.1-4.7C12,49.6,11.7,49.3,12.2,48.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        className: "st0",
        d: "M51.6,16.5H40.7c-0.6,0-0.7-0.3-0.7-0.9v-0.9c0-0.5,0.3-0.7,0.7-0.7h24.6c0.5,0,0.7,0.3,0.7,0.7v1\n		c0,0.4-0.3,0.7-0.7,0.7h-11v36.8c0,0.4-0.3,0.7-0.9,0.7h-1c-0.4,0-0.7-0.3-0.7-0.7V16.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        className: "st0",
        d: "M64.6,53.3l17.6-39.7c0.1-0.2,0.4-0.4,0.7-0.4H83c0.3,0,0.6,0.1,0.7,0.4l17.4,39.7c0.1,0.3,0.1,0.7-0.5,0.7\n		h-1.5c-0.4,0-0.7-0.3-0.8-0.5L93.7,43H71.9l-4.6,10.5C67.3,53.7,67,54,66.6,54H65C64.6,54,64.4,53.8,64.6,53.3z M92.8,40.7l-9.8-23\n		h-0.1l-9.9,23H92.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        className: "st0",
        d: "M107.6,14.8c0-0.4,0.3-0.7,0.7-0.7h14.2c7,0,12.7,5.3,12.7,12.2c0,5.8-4,10.4-9.4,11.9l8.3,14.8\n		c0.3,0.5,0.2,1-0.4,1h-1.8c-0.4,0-0.6-0.2-0.8-0.5l-8.3-15c-0.7,0.1-1.4,0.1-2.1,0.1h-10.5v14.7c0,0.4-0.3,0.7-0.9,0.7h-1\n		c-0.4,0-0.7-0.3-0.7-0.7V14.8z M122.4,36.2c5.5,0,10.1-4.3,10.1-9.9c0-5.4-4.6-9.6-10.2-9.6h-12v19.5H122.4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        className: "st0",
        d: "M150.6,16.5h-10.9c-0.6,0-0.7-0.3-0.7-0.9v-0.9c0-0.5,0.3-0.7,0.7-0.7h24.6c0.5,0,0.7,0.3,0.7,0.7v1\n		c0,0.4-0.3,0.7-0.7,0.7h-11v36.8c0,0.4-0.3,0.7-0.9,0.7h-1c-0.4,0-0.7-0.3-0.7-0.7V16.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        className: "st0",
        d: "M171.1,14.8c0-0.4,0.3-0.7,0.7-0.7h1.2c0.4,0,0.7,0.3,0.7,0.7v24.4c0,7.4,4.6,12.8,12.2,12.8\n		c7.7,0,12.3-5.4,12.3-12.7V14.8c0-0.5,0.2-0.7,0.8-0.7h1.1c0.4,0,0.7,0.3,0.7,0.7v24.7c0,8.7-5.9,15.1-15,15.1\n		c-9,0-14.9-6.4-14.9-15.1V14.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        className: "st0",
        d: "M212.6,14.8c0-0.4,0.3-0.7,0.7-0.7h12.3c7.1,0,12.9,5.8,12.9,12.8c0,7.1-5.8,13-12.8,13h-10.4v13.5\n		c0,0.4-0.3,0.7-0.9,0.7h-1c-0.4,0-0.7-0.3-0.7-0.7V14.8z M225.5,37.1c5.6,0,10.3-4.6,10.3-10.4c0-5.6-4.7-10-10.4-10h-10.2v20.4\n		H225.5z"
    })));
};
var $2a1f02c275eba654$export$2e2bcd8739ae039 = $2a1f02c275eba654$var$Logo;



var $7fPBF = parcelRequire("7fPBF");

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $c2cdbecd165cb878$export$964336739a8c7119(slot) {
    return (0, $k6RDS.default)("MuiCardContent", slot);
}
const $c2cdbecd165cb878$var$cardContentClasses = (0, $4jzsB.default)("MuiCardContent", [
    "root"
]);
var $c2cdbecd165cb878$export$2e2bcd8739ae039 = $c2cdbecd165cb878$var$cardContentClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $8bffaacbbee0c705$var$_excluded = [
    "className",
    "component"
];
const $8bffaacbbee0c705$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $c2cdbecd165cb878$export$964336739a8c7119), classes);
};
const $8bffaacbbee0c705$var$CardContentRoot = (0, $kDBhE.default)("div", {
    name: "MuiCardContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        padding: 16,
        "&:last-child": {
            paddingBottom: 24
        }
    };
});
const $8bffaacbbee0c705$var$CardContent = /*#__PURE__*/ $7fPBF.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiCardContent"
    });
    const { className: className, component: component = "div" } = props, other = (0, $cFLic.default)(props, $8bffaacbbee0c705$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component
    });
    const classes = $8bffaacbbee0c705$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($8bffaacbbee0c705$var$CardContentRoot, (0, $kY3Ke.default)({
        as: component,
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $8bffaacbbee0c705$export$2e2bcd8739ae039 = $8bffaacbbee0c705$var$CardContent;


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");


var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $20a955dc212878b8$export$f54c8b0d04b67946(slot) {
    return (0, $k6RDS.default)("MuiCardHeader", slot);
}
const $20a955dc212878b8$var$cardHeaderClasses = (0, $4jzsB.default)("MuiCardHeader", [
    "root",
    "avatar",
    "action",
    "content",
    "title",
    "subheader"
]);
var $20a955dc212878b8$export$2e2bcd8739ae039 = $20a955dc212878b8$var$cardHeaderClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $2bfceb6bd3ad6f45$var$_excluded = [
    "action",
    "avatar",
    "className",
    "component",
    "disableTypography",
    "subheader",
    "subheaderTypographyProps",
    "title",
    "titleTypographyProps"
];
const $2bfceb6bd3ad6f45$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        avatar: [
            "avatar"
        ],
        action: [
            "action"
        ],
        content: [
            "content"
        ],
        title: [
            "title"
        ],
        subheader: [
            "subheader"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $20a955dc212878b8$export$f54c8b0d04b67946), classes);
};
const $2bfceb6bd3ad6f45$var$CardHeaderRoot = (0, $kDBhE.default)("div", {
    name: "MuiCardHeader",
    slot: "Root",
    overridesResolver: (props, styles)=>(0, $kY3Ke.default)({
            [`& .${(0, $20a955dc212878b8$export$2e2bcd8739ae039).title}`]: styles.title,
            [`& .${(0, $20a955dc212878b8$export$2e2bcd8739ae039).subheader}`]: styles.subheader
        }, styles.root)
})({
    display: "flex",
    alignItems: "center",
    padding: 16
});
const $2bfceb6bd3ad6f45$var$CardHeaderAvatar = (0, $kDBhE.default)("div", {
    name: "MuiCardHeader",
    slot: "Avatar",
    overridesResolver: (props, styles)=>styles.avatar
})({
    display: "flex",
    flex: "0 0 auto",
    marginRight: 16
});
const $2bfceb6bd3ad6f45$var$CardHeaderAction = (0, $kDBhE.default)("div", {
    name: "MuiCardHeader",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    flex: "0 0 auto",
    alignSelf: "flex-start",
    marginTop: -4,
    marginRight: -8,
    marginBottom: -4
});
const $2bfceb6bd3ad6f45$var$CardHeaderContent = (0, $kDBhE.default)("div", {
    name: "MuiCardHeader",
    slot: "Content",
    overridesResolver: (props, styles)=>styles.content
})({
    flex: "1 1 auto"
});
const $2bfceb6bd3ad6f45$var$CardHeader = /*#__PURE__*/ $7fPBF.forwardRef(function CardHeader(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiCardHeader"
    });
    const { action: action, avatar: avatar, className: className, component: component = "div", disableTypography: disableTypography = false, subheader: subheaderProp, subheaderTypographyProps: subheaderTypographyProps, title: titleProp, titleTypographyProps: titleTypographyProps } = props, other = (0, $cFLic.default)(props, $2bfceb6bd3ad6f45$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        disableTypography: disableTypography
    });
    const classes = $2bfceb6bd3ad6f45$var$useUtilityClasses(ownerState);
    let title = titleProp;
    if (title != null && title.type !== (0, $26f68e516ee75fc4$export$2e2bcd8739ae039) && !disableTypography) title = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
        variant: avatar ? "body2" : "h5",
        className: classes.title,
        component: "span",
        display: "block"
    }, titleTypographyProps, {
        children: title
    }));
    let subheader = subheaderProp;
    if (subheader != null && subheader.type !== (0, $26f68e516ee75fc4$export$2e2bcd8739ae039) && !disableTypography) subheader = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
        variant: avatar ? "body2" : "body1",
        className: classes.subheader,
        color: "text.secondary",
        component: "span",
        display: "block"
    }, subheaderTypographyProps, {
        children: subheader
    }));
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($2bfceb6bd3ad6f45$var$CardHeaderRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        as: component,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            avatar && /*#__PURE__*/ (0, $bbzbN.jsx)($2bfceb6bd3ad6f45$var$CardHeaderAvatar, {
                className: classes.avatar,
                ownerState: ownerState,
                children: avatar
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)($2bfceb6bd3ad6f45$var$CardHeaderContent, {
                className: classes.content,
                ownerState: ownerState,
                children: [
                    title,
                    subheader
                ]
            }),
            action && /*#__PURE__*/ (0, $bbzbN.jsx)($2bfceb6bd3ad6f45$var$CardHeaderAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            })
        ]
    }));
});
var $2bfceb6bd3ad6f45$export$2e2bcd8739ae039 = $2bfceb6bd3ad6f45$var$CardHeader;


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $be601d991ccbe49a$export$46f01d01378ec5a2(slot) {
    return (0, $k6RDS.default)("MuiDivider", slot);
}
const $be601d991ccbe49a$var$dividerClasses = (0, $4jzsB.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $be601d991ccbe49a$export$2e2bcd8739ae039 = $be601d991ccbe49a$var$dividerClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $04d237a94a6557e6$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $04d237a94a6557e6$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            absolute && "absolute",
            variant,
            light && "light",
            orientation === "vertical" && "vertical",
            flexItem && "flexItem",
            children && "withChildren",
            children && orientation === "vertical" && "withChildrenVertical",
            textAlign === "right" && orientation !== "vertical" && "textAlignRight",
            textAlign === "left" && orientation !== "vertical" && "textAlignLeft"
        ],
        wrapper: [
            "wrapper",
            orientation === "vertical" && "wrapperVertical"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $be601d991ccbe49a$export$46f01d01378ec5a2), classes);
};
const $04d237a94a6557e6$var$DividerRoot = (0, $kDBhE.default)("div", {
    name: "MuiDivider",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === "vertical" && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === "vertical" && styles.withChildrenVertical,
            ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && styles.textAlignRight,
            ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: "solid",
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: "thin"
    }, ownerState.absolute && {
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%"
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $cxeT8.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === "inset" && {
        marginLeft: 72
    }, ownerState.variant === "middle" && ownerState.orientation === "horizontal" && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === "middle" && ownerState.orientation === "vertical" && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === "vertical" && {
        height: "100%",
        borderBottomWidth: 0,
        borderRightWidth: "thin"
    }, ownerState.flexItem && {
        alignSelf: "stretch",
        height: "auto"
    }), ({ ownerState: ownerState })=>(0, $kY3Ke.default)({}, ownerState.children && {
        display: "flex",
        whiteSpace: "nowrap",
        textAlign: "center",
        border: 0,
        "&::before, &::after": {
            content: '""',
            alignSelf: "center"
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, ownerState.children && ownerState.orientation !== "vertical" && {
        "&::before, &::after": {
            width: "100%",
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, ownerState.children && ownerState.orientation === "vertical" && {
        flexDirection: "column",
        "&::before, &::after": {
            height: "100%",
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ ownerState: ownerState })=>(0, $kY3Ke.default)({}, ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "90%"
        },
        "&::after": {
            width: "10%"
        }
    }, ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "10%"
        },
        "&::after": {
            width: "90%"
        }
    }));
const $04d237a94a6557e6$var$DividerWrapper = (0, $kDBhE.default)("span", {
    name: "MuiDivider",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === "vertical" && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "inline-block",
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === "vertical" && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $04d237a94a6557e6$var$Divider = /*#__PURE__*/ $7fPBF.forwardRef(function Divider(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiDivider"
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? "div" : "hr", flexItem: flexItem = false, light: light = false, orientation: orientation = "horizontal", role: role = component !== "hr" ? "separator" : undefined, textAlign: textAlign = "center", variant: variant = "fullWidth" } = props, other = (0, $cFLic.default)(props, $04d237a94a6557e6$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $04d237a94a6557e6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($04d237a94a6557e6$var$DividerRoot, (0, $kY3Ke.default)({
        as: component,
        className: (0, $hngXp.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $bbzbN.jsx)($04d237a94a6557e6$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $04d237a94a6557e6$var$Divider.muiSkipListHighlight = true;
var $04d237a94a6557e6$export$2e2bcd8739ae039 = $04d237a94a6557e6$var$Divider;


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cvrkU = parcelRequire("cvrkU");

var $cFCqu = parcelRequire("cFCqu");


var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");


var $7fPBF = parcelRequire("7fPBF");
"use client";
/**
 * @ignore - internal component.
 */ const $3cb45b8a02634c3b$var$GridContext = /*#__PURE__*/ $7fPBF.createContext();
var $3cb45b8a02634c3b$export$2e2bcd8739ae039 = $3cb45b8a02634c3b$var$GridContext;



var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $e896bfd9730b7f7a$export$9973ac5fd0181f33(slot) {
    return (0, $k6RDS.default)("MuiGrid", slot);
}
const $e896bfd9730b7f7a$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $e896bfd9730b7f7a$var$DIRECTIONS = [
    "column-reverse",
    "column",
    "row-reverse",
    "row"
];
const $e896bfd9730b7f7a$var$WRAPS = [
    "nowrap",
    "wrap-reverse",
    "wrap"
];
const $e896bfd9730b7f7a$var$GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $e896bfd9730b7f7a$var$gridClasses = (0, $4jzsB.default)("MuiGrid", [
    "root",
    "container",
    "item",
    "zeroMinWidth",
    // spacings
    ...$e896bfd9730b7f7a$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$e896bfd9730b7f7a$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$e896bfd9730b7f7a$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$e896bfd9730b7f7a$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$e896bfd9730b7f7a$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$e896bfd9730b7f7a$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$e896bfd9730b7f7a$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$e896bfd9730b7f7a$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $e896bfd9730b7f7a$export$2e2bcd8739ae039 = $e896bfd9730b7f7a$var$gridClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $7fa4a4d669bc53fb$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $7fa4a4d669bc53fb$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), "") || "px"}`;
}
function $7fa4a4d669bc53fb$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: "100%"
        };
        else if (size === "auto") styles = {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: "none",
            width: "auto"
        };
        else {
            const columnsBreakpointValues = (0, $cvrkU.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === "object" ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== "0px") {
                    const fullWidth = `calc(${width} + ${$7fa4a4d669bc53fb$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $kY3Ke.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $7fa4a4d669bc53fb$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $cvrkU.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $cvrkU.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf("column") === 0) output[`& > .${(0, $e896bfd9730b7f7a$export$2e2bcd8739ae039).item}`] = {
            maxWidth: "none"
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $7fa4a4d669bc53fb$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = "";
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== "") return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $7fa4a4d669bc53fb$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $cvrkU.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === "object") zeroValueBreakpointKeys = $7fa4a4d669bc53fb$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $cvrkU.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                marginTop: `-${$7fa4a4d669bc53fb$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $e896bfd9730b7f7a$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $7fa4a4d669bc53fb$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $e896bfd9730b7f7a$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $7fa4a4d669bc53fb$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $cvrkU.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === "object") zeroValueBreakpointKeys = $7fa4a4d669bc53fb$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $cvrkU.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                width: `calc(100% + ${$7fa4a4d669bc53fb$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$7fa4a4d669bc53fb$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $e896bfd9730b7f7a$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $7fa4a4d669bc53fb$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: "100%",
                marginLeft: 0,
                [`& > .${(0, $e896bfd9730b7f7a$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $7fa4a4d669bc53fb$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $7fa4a4d669bc53fb$var$GridRoot = (0, $kDBhE.default)("div", {
    name: "MuiGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $7fa4a4d669bc53fb$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== "row" && styles[`direction-xs-${String(direction)}`],
            wrap !== "wrap" && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        boxSizing: "border-box"
    }, ownerState.container && {
        display: "flex",
        flexWrap: "wrap",
        width: "100%"
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== "wrap" && {
        flexWrap: ownerState.wrap
    }), $7fa4a4d669bc53fb$export$71d4225eeb1bc13e, $7fa4a4d669bc53fb$export$380604d7c79f9e8f, $7fa4a4d669bc53fb$export$4315fba5128fb4a1, $7fa4a4d669bc53fb$export$ca2a698f6020fda);
function $7fa4a4d669bc53fb$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $7fa4a4d669bc53fb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $7fa4a4d669bc53fb$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            "root",
            container && "container",
            item && "item",
            zeroMinWidth && "zeroMinWidth",
            ...spacingClasses,
            direction !== "row" && `direction-xs-${String(direction)}`,
            wrap !== "wrap" && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $e896bfd9730b7f7a$export$9973ac5fd0181f33), classes);
};
const $7fa4a4d669bc53fb$var$Grid = /*#__PURE__*/ $7fPBF.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiGrid"
    });
    const { breakpoints: breakpoints } = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const props = (0, $043690c2de8ba6fa$export$2e2bcd8739ae039)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = "div", container: container = false, direction: direction = "row", item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = "wrap", zeroMinWidth: zeroMinWidth = false } = props, other = (0, $cFLic.default)(props, $7fa4a4d669bc53fb$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $7fPBF.useContext((0, $3cb45b8a02634c3b$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $kY3Ke.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $7fa4a4d669bc53fb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3cb45b8a02634c3b$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($7fa4a4d669bc53fb$var$GridRoot, (0, $kY3Ke.default)({
            ownerState: ownerState,
            className: (0, $hngXp.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $7fa4a4d669bc53fb$export$2e2bcd8739ae039 = $7fa4a4d669bc53fb$var$Grid;


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");


var $b6UUh = parcelRequire("b6UUh");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $0bca18aab596affa$export$5e8702d71474f093(slot) {
    return (0, $k6RDS.default)("MuiIconButton", slot);
}
const $0bca18aab596affa$var$iconButtonClasses = (0, $4jzsB.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $0bca18aab596affa$export$2e2bcd8739ae039 = $0bca18aab596affa$var$iconButtonClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $67a243c492197f3b$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $67a243c492197f3b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $b6UUh.default)(color)}`,
            edge && `edge${(0, $b6UUh.default)(edge)}`,
            `size${(0, $b6UUh.default)(size)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $0bca18aab596affa$export$5e8702d71474f093), classes);
};
const $67a243c492197f3b$var$IconButtonRoot = (0, $kDBhE.default)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $b6UUh.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $b6UUh.default)(ownerState.edge)}`],
            styles[`size${(0, $b6UUh.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cxeT8.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $kY3Ke.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $kY3Ke.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, $kY3Ke.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cxeT8.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $0bca18aab596affa$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $67a243c492197f3b$var$IconButton = /*#__PURE__*/ $7fPBF.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = "medium" } = props, other = (0, $cFLic.default)(props, $67a243c492197f3b$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $67a243c492197f3b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($67a243c492197f3b$var$IconButtonRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children
    }));
});
var $67a243c492197f3b$export$2e2bcd8739ae039 = $67a243c492197f3b$var$IconButton;


var $bpHMA = parcelRequire("bpHMA");

var $41c34e1167891c88$exports = {};
"use strict";
"use client";
var $4657741705a128f0$exports = {};
function $4657741705a128f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$4657741705a128f0$exports = $4657741705a128f0$var$_interopRequireDefault, $4657741705a128f0$exports.__esModule = true, $4657741705a128f0$exports["default"] = $4657741705a128f0$exports;


Object.defineProperty($41c34e1167891c88$exports, "__esModule", {
    value: true
});
$41c34e1167891c88$exports.default = void 0;

var $41c34e1167891c88$var$_createSvgIcon = $4657741705a128f0$exports((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $41c34e1167891c88$var$_default = (0, $41c34e1167891c88$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), "Search");
$41c34e1167891c88$exports.default = $41c34e1167891c88$var$_default;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $hngXp = parcelRequire("hngXp");


var $bpHMA = parcelRequire("bpHMA");

var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");function $fa82c24039cb02ec$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $fa82c24039cb02ec$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function $fa82c24039cb02ec$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $fa82c24039cb02ec$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $fa82c24039cb02ec$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $fa82c24039cb02ec$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== "px") {
            if (fromUnit === "em") pxLength = $fa82c24039cb02ec$export$8af1d214c6c2f0f1(length) * $fa82c24039cb02ec$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === "rem") pxLength = $fa82c24039cb02ec$export$8af1d214c6c2f0f1(length) * $fa82c24039cb02ec$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== "px") {
            if (toUnit === "em") outputLength = pxLength / $fa82c24039cb02ec$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === "rem") outputLength = pxLength / $fa82c24039cb02ec$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $fa82c24039cb02ec$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $fa82c24039cb02ec$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $fa82c24039cb02ec$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = "rem", breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}



var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $9766df26003dc3cf$export$c987db9fc844f86(slot) {
    return (0, $k6RDS.default)("MuiSkeleton", slot);
}
const $9766df26003dc3cf$var$skeletonClasses = (0, $4jzsB.default)("MuiSkeleton", [
    "root",
    "text",
    "rectangular",
    "rounded",
    "circular",
    "pulse",
    "wave",
    "withChildren",
    "fitContent",
    "heightAuto"
]);
var $9766df26003dc3cf$export$2e2bcd8739ae039 = $9766df26003dc3cf$var$skeletonClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
let $76ada7aef489324c$var$_ = (t)=>t, $76ada7aef489324c$var$t, $76ada7aef489324c$var$t1, $76ada7aef489324c$var$t2, $76ada7aef489324c$var$t3;
const $76ada7aef489324c$var$_excluded = [
    "animation",
    "className",
    "component",
    "height",
    "style",
    "variant",
    "width"
];
let $76ada7aef489324c$var$_1 = (t)=>t, $76ada7aef489324c$var$_t, $76ada7aef489324c$var$_t2, $76ada7aef489324c$var$_t3, $76ada7aef489324c$var$_t4;
const $76ada7aef489324c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            animation,
            hasChildren && "withChildren",
            hasChildren && !width && "fitContent",
            hasChildren && !height && "heightAuto"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $9766df26003dc3cf$export$c987db9fc844f86), classes);
};
const $76ada7aef489324c$var$pulseKeyframe = (0, $bpHMA.keyframes)($76ada7aef489324c$var$_t || ($76ada7aef489324c$var$_t = $76ada7aef489324c$var$_1($76ada7aef489324c$var$t || ($76ada7aef489324c$var$t = $76ada7aef489324c$var$_`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`))));
const $76ada7aef489324c$var$waveKeyframe = (0, $bpHMA.keyframes)($76ada7aef489324c$var$_t2 || ($76ada7aef489324c$var$_t2 = $76ada7aef489324c$var$_1($76ada7aef489324c$var$t1 || ($76ada7aef489324c$var$t1 = $76ada7aef489324c$var$_`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`))));
const $76ada7aef489324c$var$SkeletonRoot = (0, $kDBhE.default)("span", {
    name: "MuiSkeleton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const radiusUnit = (0, $fa82c24039cb02ec$export$65f2564e9a9b9222)(theme.shape.borderRadius) || "px";
    const radiusValue = (0, $fa82c24039cb02ec$export$8af1d214c6c2f0f1)(theme.shape.borderRadius);
    return (0, $kY3Ke.default)({
        display: "block",
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, $cxeT8.alpha)(theme.palette.text.primary, theme.palette.mode === "light" ? 0.11 : 0.13),
        height: "1.2em"
    }, ownerState.variant === "text" && {
        marginTop: 0,
        marginBottom: 0,
        height: "auto",
        transformOrigin: "0 55%",
        transform: "scale(1, 0.60)",
        borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
        "&:empty:before": {
            content: '"\\00a0"'
        }
    }, ownerState.variant === "circular" && {
        borderRadius: "50%"
    }, ownerState.variant === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.hasChildren && {
        "& > *": {
            visibility: "hidden"
        }
    }, ownerState.hasChildren && !ownerState.width && {
        maxWidth: "fit-content"
    }, ownerState.hasChildren && !ownerState.height && {
        height: "auto"
    });
}, ({ ownerState: ownerState })=>ownerState.animation === "pulse" && (0, $bpHMA.css)($76ada7aef489324c$var$_t3 || ($76ada7aef489324c$var$_t3 = $76ada7aef489324c$var$_1($76ada7aef489324c$var$t2 || ($76ada7aef489324c$var$t2 = $76ada7aef489324c$var$_`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), 0)), $76ada7aef489324c$var$pulseKeyframe), ({ ownerState: ownerState, theme: theme })=>ownerState.animation === "wave" && (0, $bpHMA.css)($76ada7aef489324c$var$_t4 || ($76ada7aef489324c$var$_t4 = $76ada7aef489324c$var$_1($76ada7aef489324c$var$t3 || ($76ada7aef489324c$var$t3 = $76ada7aef489324c$var$_`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), 0, 0)), $76ada7aef489324c$var$waveKeyframe, (theme.vars || theme).palette.action.hover));
const $76ada7aef489324c$var$Skeleton = /*#__PURE__*/ $7fPBF.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiSkeleton"
    });
    const { animation: animation = "pulse", className: className, component: component = "span", height: height, style: style, variant: variant = "text", width: width } = props, other = (0, $cFLic.default)(props, $76ada7aef489324c$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    });
    const classes = $76ada7aef489324c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($76ada7aef489324c$var$SkeletonRoot, (0, $kY3Ke.default)({
        as: component,
        ref: ref,
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        style: (0, $kY3Ke.default)({
            width: width,
            height: height
        }, style)
    }));
});
var $76ada7aef489324c$export$2e2bcd8739ae039 = $76ada7aef489324c$var$Skeleton;




var $a94c4d3b84a30d2f$exports = {};
"use strict";
"use client";

Object.defineProperty($a94c4d3b84a30d2f$exports, "__esModule", {
    value: true
});
$a94c4d3b84a30d2f$exports.default = void 0;

var $a94c4d3b84a30d2f$var$_createSvgIcon = $4657741705a128f0$exports((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $a94c4d3b84a30d2f$var$_default = (0, $a94c4d3b84a30d2f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), "Add");
$a94c4d3b84a30d2f$exports.default = $a94c4d3b84a30d2f$var$_default;


var $76b5567aeb1dd705$exports = {};
"use strict";
"use client";

Object.defineProperty($76b5567aeb1dd705$exports, "__esModule", {
    value: true
});
$76b5567aeb1dd705$exports.default = void 0;

var $76b5567aeb1dd705$var$_createSvgIcon = $4657741705a128f0$exports((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $76b5567aeb1dd705$var$_default = (0, $76b5567aeb1dd705$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
}), "Refresh");
$76b5567aeb1dd705$exports.default = $76b5567aeb1dd705$var$_default;



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");


var $5j2OD = parcelRequire("5j2OD");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $400e891885365e5b$export$427f1c1e2e839f85(slot) {
    return (0, $k6RDS.default)("MuiPagination", slot);
}
const $400e891885365e5b$var$paginationClasses = (0, $4jzsB.default)("MuiPagination", [
    "root",
    "ul",
    "outlined",
    "text"
]);
var $400e891885365e5b$export$2e2bcd8739ae039 = $400e891885365e5b$var$paginationClasses;



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

"use client";
const $a39bd8c65bc5e811$var$_excluded = [
    "boundaryCount",
    "componentName",
    "count",
    "defaultPage",
    "disabled",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "showFirstButton",
    "showLastButton",
    "siblingCount"
];
function $a39bd8c65bc5e811$export$2e2bcd8739ae039(props = {}) {
    // keep default values in sync with @default tags in Pagination.propTypes
    const { boundaryCount: boundaryCount = 1, componentName: componentName = "usePagination", count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, onChange: handleChange, page: pageProp, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1 } = props, other = (0, $cFLic.default)(props, $a39bd8c65bc5e811$var$_excluded);
    const [page, setPageState] = (0, $bc6c881cebb96954$export$2e2bcd8739ae039)({
        controlled: pageProp,
        default: defaultPage,
        name: componentName,
        state: "page"
    });
    const handleClick = (event, value)=>{
        if (!pageProp) setPageState(value);
        if (handleChange) handleChange(event, value);
    };
    // https://dev.to/namirsab/comment/2050
    const range = (start, end)=>{
        const length = end - start + 1;
        return Array.from({
            length: length
        }, (_, i)=>start + i);
    };
    const startPages = range(1, Math.min(boundaryCount, count));
    const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    const siblingsStart = Math.max(Math.min(// Natural start
    page - siblingCount, // Lower boundary when page is high
    count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
    boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(// Natural end
    page + siblingCount, // Upper boundary when page is low
    boundaryCount + siblingCount * 2 + 2), // Less than endPages
    endPages.length > 0 ? endPages[0] - 2 : count - 1);
    // Basic list of items to render
    // e.g. itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
    const itemList = [
        ...showFirstButton ? [
            "first"
        ] : [],
        ...hidePrevButton ? [] : [
            "previous"
        ],
        ...startPages,
        // Start ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsStart > boundaryCount + 2 ? [
            "start-ellipsis"
        ] : boundaryCount + 1 < count - boundaryCount ? [
            boundaryCount + 1
        ] : [],
        // Sibling pages
        ...range(siblingsStart, siblingsEnd),
        // End ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsEnd < count - boundaryCount - 1 ? [
            "end-ellipsis"
        ] : count - boundaryCount > boundaryCount ? [
            count - boundaryCount
        ] : [],
        ...endPages,
        ...hideNextButton ? [] : [
            "next"
        ],
        ...showLastButton ? [
            "last"
        ] : []
    ];
    // Map the button type to its page number
    const buttonPage = (type)=>{
        switch(type){
            case "first":
                return 1;
            case "previous":
                return page - 1;
            case "next":
                return page + 1;
            case "last":
                return count;
            default:
                return null;
        }
    };
    // Convert the basic item list to PaginationItem props objects
    const items = itemList.map((item)=>{
        return typeof item === "number" ? {
            onClick: (event)=>{
                handleClick(event, item);
            },
            type: "page",
            page: item,
            selected: item === page,
            disabled: disabled,
            "aria-current": item === page ? "true" : undefined
        } : {
            onClick: (event)=>{
                handleClick(event, buttonPage(item));
            },
            type: item,
            page: buttonPage(item),
            selected: false,
            disabled: disabled || item.indexOf("ellipsis") === -1 && (item === "next" || item === "last" ? page >= count : page <= 1)
        };
    });
    return (0, $kY3Ke.default)({
        items: items
    }, other);
}



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");

var $5j2OD = parcelRequire("5j2OD");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $976279323964304f$export$e4ce0a775adf2f74(slot) {
    return (0, $k6RDS.default)("MuiPaginationItem", slot);
}
const $976279323964304f$var$paginationItemClasses = (0, $4jzsB.default)("MuiPaginationItem", [
    "root",
    "page",
    "sizeSmall",
    "sizeLarge",
    "text",
    "textPrimary",
    "textSecondary",
    "outlined",
    "outlinedPrimary",
    "outlinedSecondary",
    "rounded",
    "ellipsis",
    "firstLast",
    "previousNext",
    "focusVisible",
    "disabled",
    "selected",
    "icon"
]);
var $976279323964304f$export$2e2bcd8739ae039 = $976279323964304f$var$paginationItemClasses;





var $b6UUh = parcelRequire("b6UUh");
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $4d70eff12e629650$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage");


parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $75fe20f994ad894a$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage");


parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $00353f05adca70de$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore");


parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $f97a8664bf777b63$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext");



var $kDBhE = parcelRequire("kDBhE");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $1d186760d7a4d76b$var$_excluded = [
    "className",
    "color",
    "component",
    "components",
    "disabled",
    "page",
    "selected",
    "shape",
    "size",
    "slots",
    "type",
    "variant"
];
const $1d186760d7a4d76b$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[ownerState.variant],
        styles[`size${(0, $b6UUh.default)(ownerState.size)}`],
        ownerState.variant === "text" && styles[`text${(0, $b6UUh.default)(ownerState.color)}`],
        ownerState.variant === "outlined" && styles[`outlined${(0, $b6UUh.default)(ownerState.color)}`],
        ownerState.shape === "rounded" && styles.rounded,
        ownerState.type === "page" && styles.page,
        (ownerState.type === "start-ellipsis" || ownerState.type === "end-ellipsis") && styles.ellipsis,
        (ownerState.type === "previous" || ownerState.type === "next") && styles.previousNext,
        (ownerState.type === "first" || ownerState.type === "last") && styles.firstLast
    ];
};
const $1d186760d7a4d76b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, selected: selected, size: size, shape: shape, type: type, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            `size${(0, $b6UUh.default)(size)}`,
            variant,
            shape,
            color !== "standard" && `${variant}${(0, $b6UUh.default)(color)}`,
            disabled && "disabled",
            selected && "selected",
            {
                page: "page",
                first: "firstLast",
                last: "firstLast",
                "start-ellipsis": "ellipsis",
                "end-ellipsis": "ellipsis",
                previous: "previousNext",
                next: "previousNext"
            }[type]
        ],
        icon: [
            "icon"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $976279323964304f$export$e4ce0a775adf2f74), classes);
};
const $1d186760d7a4d76b$var$PaginationItemEllipsis = (0, $kDBhE.default)("div", {
    name: "MuiPaginationItem",
    slot: "Root",
    overridesResolver: $1d186760d7a4d76b$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: "center",
        boxSizing: "border-box",
        minWidth: 32,
        padding: "0 6px",
        margin: "0 3px",
        color: (theme.vars || theme).palette.text.primary,
        height: "auto",
        [`&.${(0, $976279323964304f$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.size === "small" && {
        minWidth: 26,
        borderRadius: 13,
        margin: "0 1px",
        padding: "0 4px"
    }, ownerState.size === "large" && {
        minWidth: 40,
        borderRadius: 20,
        padding: "0 10px",
        fontSize: theme.typography.pxToRem(15)
    }));
const $1d186760d7a4d76b$var$PaginationItemPage = (0, $kDBhE.default)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    name: "MuiPaginationItem",
    slot: "Root",
    overridesResolver: $1d186760d7a4d76b$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: "center",
        boxSizing: "border-box",
        minWidth: 32,
        height: 32,
        padding: "0 6px",
        margin: "0 3px",
        color: (theme.vars || theme).palette.text.primary,
        [`&.${(0, $976279323964304f$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $976279323964304f$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        transition: theme.transitions.create([
            "color",
            "background-color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": {
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $976279323964304f$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: (theme.vars || theme).palette.action.selected,
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $cxeT8.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: (theme.vars || theme).palette.action.selected
                }
            },
            [`&.${(0, $976279323964304f$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $cxeT8.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            },
            [`&.${(0, $976279323964304f$export$2e2bcd8739ae039).disabled}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.action.disabled,
                backgroundColor: (theme.vars || theme).palette.action.selected
            }
        }
    }, ownerState.size === "small" && {
        minWidth: 26,
        height: 26,
        borderRadius: 13,
        margin: "0 1px",
        padding: "0 4px"
    }, ownerState.size === "large" && {
        minWidth: 40,
        height: 40,
        borderRadius: 20,
        padding: "0 10px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.shape === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }), ({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, ownerState.variant === "text" && {
        [`&.${(0, $976279323964304f$export$2e2bcd8739ae039).selected}`]: (0, $kY3Ke.default)({}, ownerState.color !== "standard" && {
            color: (theme.vars || theme).palette[ownerState.color].contrastText,
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
            "&:hover": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: (theme.vars || theme).palette[ownerState.color].main
                }
            },
            [`&.${(0, $976279323964304f$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
            }
        }, {
            [`&.${(0, $976279323964304f$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }, ownerState.variant === "outlined" && {
        border: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
        [`&.${(0, $976279323964304f$export$2e2bcd8739ae039).selected}`]: (0, $kY3Ke.default)({}, ownerState.color !== "standard" && {
            color: (theme.vars || theme).palette[ownerState.color].main,
            border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, $cxeT8.alpha)(theme.palette[ownerState.color].main, 0.5)}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.activatedOpacity})` : (0, $cxeT8.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity),
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $cxeT8.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            [`&.${(0, $976279323964304f$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $cxeT8.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity)
            }
        }, {
            [`&.${(0, $976279323964304f$export$2e2bcd8739ae039).disabled}`]: {
                borderColor: (theme.vars || theme).palette.action.disabledBackground,
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }));
const $1d186760d7a4d76b$var$PaginationItemPageIcon = (0, $kDBhE.default)("div", {
    name: "MuiPaginationItem",
    slot: "Icon",
    overridesResolver: (props, styles)=>styles.icon
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        fontSize: theme.typography.pxToRem(20),
        margin: "0 -8px"
    }, ownerState.size === "small" && {
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        fontSize: theme.typography.pxToRem(22)
    }));
const $1d186760d7a4d76b$var$PaginationItem = /*#__PURE__*/ $7fPBF.forwardRef(function PaginationItem(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiPaginationItem"
    });
    const { className: className, color: color = "standard", component: component, components: components = {}, disabled: disabled = false, page: page, selected: selected = false, shape: shape = "circular", size: size = "medium", slots: slots = {}, type: type = "page", variant: variant = "text" } = props, other = (0, $cFLic.default)(props, $1d186760d7a4d76b$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        disabled: disabled,
        selected: selected,
        shape: shape,
        size: size,
        type: type,
        variant: variant
    });
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const classes = $1d186760d7a4d76b$var$useUtilityClasses(ownerState);
    const normalizedIcons = theme.direction === "rtl" ? {
        previous: slots.next || components.next || (0, $f97a8664bf777b63$export$2e2bcd8739ae039),
        next: slots.previous || components.previous || (0, $00353f05adca70de$export$2e2bcd8739ae039),
        last: slots.first || components.first || (0, $4d70eff12e629650$export$2e2bcd8739ae039),
        first: slots.last || components.last || (0, $75fe20f994ad894a$export$2e2bcd8739ae039)
    } : {
        previous: slots.previous || components.previous || (0, $00353f05adca70de$export$2e2bcd8739ae039),
        next: slots.next || components.next || (0, $f97a8664bf777b63$export$2e2bcd8739ae039),
        first: slots.first || components.first || (0, $4d70eff12e629650$export$2e2bcd8739ae039),
        last: slots.last || components.last || (0, $75fe20f994ad894a$export$2e2bcd8739ae039)
    };
    const Icon = normalizedIcons[type];
    return type === "start-ellipsis" || type === "end-ellipsis" ? /*#__PURE__*/ (0, $bbzbN.jsx)($1d186760d7a4d76b$var$PaginationItemEllipsis, {
        ref: ref,
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className),
        children: "\u2026"
    }) : /*#__PURE__*/ (0, $bbzbN.jsxs)($1d186760d7a4d76b$var$PaginationItemPage, (0, $kY3Ke.default)({
        ref: ref,
        ownerState: ownerState,
        component: component,
        disabled: disabled,
        className: (0, $hngXp.default)(classes.root, className)
    }, other, {
        children: [
            type === "page" && page,
            Icon ? /*#__PURE__*/ (0, $bbzbN.jsx)($1d186760d7a4d76b$var$PaginationItemPageIcon, {
                as: Icon,
                ownerState: ownerState,
                className: classes.icon
            }) : null
        ]
    }));
});
var $1d186760d7a4d76b$export$2e2bcd8739ae039 = $1d186760d7a4d76b$var$PaginationItem;



var $kDBhE = parcelRequire("kDBhE");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $8f3171dc8a1db2af$var$_excluded = [
    "boundaryCount",
    "className",
    "color",
    "count",
    "defaultPage",
    "disabled",
    "getItemAriaLabel",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "renderItem",
    "shape",
    "showFirstButton",
    "showLastButton",
    "siblingCount",
    "size",
    "variant"
];
const $8f3171dc8a1db2af$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant
        ],
        ul: [
            "ul"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $400e891885365e5b$export$427f1c1e2e839f85), classes);
};
const $8f3171dc8a1db2af$var$PaginationRoot = (0, $kDBhE.default)("nav", {
    name: "MuiPagination",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant]
        ];
    }
})({});
const $8f3171dc8a1db2af$var$PaginationUl = (0, $kDBhE.default)("ul", {
    name: "MuiPagination",
    slot: "Ul",
    overridesResolver: (props, styles)=>styles.ul
})({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: 0,
    margin: 0,
    listStyle: "none"
});
function $8f3171dc8a1db2af$var$defaultGetAriaLabel(type, page, selected) {
    if (type === "page") return `${selected ? "" : "Go to "}page ${page}`;
    return `Go to ${type} page`;
}
const $8f3171dc8a1db2af$var$Pagination = /*#__PURE__*/ $7fPBF.forwardRef(function Pagination(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiPagination"
    });
    const { boundaryCount: boundaryCount = 1, className: className, color: color = "standard", count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $8f3171dc8a1db2af$var$defaultGetAriaLabel, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, renderItem: renderItem = (item)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $1d186760d7a4d76b$export$2e2bcd8739ae039), (0, $kY3Ke.default)({}, item)), shape: shape = "circular", showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1, size: size = "medium", variant: variant = "text" } = props, other = (0, $cFLic.default)(props, $8f3171dc8a1db2af$var$_excluded);
    const { items: items } = (0, $a39bd8c65bc5e811$export$2e2bcd8739ae039)((0, $kY3Ke.default)({}, props, {
        componentName: "Pagination"
    }));
    const ownerState = (0, $kY3Ke.default)({}, props, {
        boundaryCount: boundaryCount,
        color: color,
        count: count,
        defaultPage: defaultPage,
        disabled: disabled,
        getItemAriaLabel: getItemAriaLabel,
        hideNextButton: hideNextButton,
        hidePrevButton: hidePrevButton,
        renderItem: renderItem,
        shape: shape,
        showFirstButton: showFirstButton,
        showLastButton: showLastButton,
        siblingCount: siblingCount,
        size: size,
        variant: variant
    });
    const classes = $8f3171dc8a1db2af$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($8f3171dc8a1db2af$var$PaginationRoot, (0, $kY3Ke.default)({
        "aria-label": "pagination navigation",
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($8f3171dc8a1db2af$var$PaginationUl, {
            className: classes.ul,
            ownerState: ownerState,
            children: items.map((item, index)=>/*#__PURE__*/ (0, $bbzbN.jsx)("li", {
                    children: renderItem((0, $kY3Ke.default)({}, item, {
                        color: color,
                        "aria-label": getItemAriaLabel(item.type, item.page, item.selected),
                        shape: shape,
                        size: size,
                        variant: variant
                    }))
                }, index))
        })
    }));
});
var $8f3171dc8a1db2af$export$2e2bcd8739ae039 = $8f3171dc8a1db2af$var$Pagination;


var $97914e663a317172$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $97914e663a317172$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $97914e663a317172$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $97914e663a317172$var$rotateAnimation = (0, $bpHMA.keyframes)($97914e663a317172$var$templateObject_1 || ($97914e663a317172$var$templateObject_1 = $97914e663a317172$var$__makeTemplateObject([
    "\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"
], [
    "\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"
])));
var $97914e663a317172$var$DataGrid = function(_a) {
    var actionID = _a.actionID, itemProps = _a.itemProps, items = _a.items, itemActions = _a.itemActions, doShowCardHeader = _a.doShowCardHeader, doShowTableHeader = _a.doShowTableHeader, sm = _a.sm, loadRecords = _a.loadRecords, addInfo = _a.addInfo;
    var _b = (0, $7fPBF.useState)(false), isSearchVisible = _b[0], setSearchVisibility = _b[1];
    var _c = (0, $7fPBF.useState)(false), isRotating = _c[0], setIsRotating = _c[1];
    var _d = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(1), page = _d[0], setPage = _d[1];
    var _e = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(1), pages = _e[0], setPages = _e[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        pagination(1, "", false).then();
    }, []);
    var HeaderSkeleton = function() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
            container: true,
            spacing: 2,
            style: {
                marginBottom: "16px"
            }
        }, itemProps.map(function(_, index) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                key: index,
                item: true,
                xs: 12,
                sm: sm
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                variant: "text",
                width: "80%",
                height: 25
            }));
        }), itemActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
            item: true,
            xs: 12,
            sm: sm
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
            variant: "text",
            width: "80%",
            height: 25
        })));
    };
    var ItemSkeleton = function() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
            container: true,
            spacing: 2,
            style: {
                marginBottom: "8px",
                marginTop: "4px"
            }
        }, itemProps.map(function(_, index) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                sm: sm,
                key: index,
                style: {
                    alignItems: "center"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                variant: "text",
                width: "80%",
                height: 25
            }));
        }), itemActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
            item: true,
            xs: 12,
            sm: sm,
            style: {
                alignItems: "right"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
            variant: "text",
            width: "80%",
            height: 25
        })));
    };
    var Header = function() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
            container: true,
            spacing: 2,
            style: {
                marginBottom: "16px",
                alignItems: "center"
            }
        }, itemProps.map(function(itemInfo, index) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                key: index,
                item: true,
                xs: 12,
                sm: sm
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                component: "div",
                fontWeight: "bold",
                style: {
                    textAlign: "left"
                }
            }, itemInfo.text ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, itemInfo.text) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null)));
        }), itemActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
            item: true,
            xs: 12,
            sm: sm,
            style: {
                textAlign: "right"
            }
        }, "\xa0"));
    };
    var ItemRender = function(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
            container: true,
            spacing: 2,
            style: {
                alignItems: "center"
            }
        }, itemProps.map(function(itemInfo, index) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                sm: sm,
                key: index
            }, itemInfo.text ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, props.item[itemInfo.key]) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null));
        }), itemActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
            item: true,
            xs: 12,
            sm: sm,
            style: {
                textAlign: "right"
            }
        }, itemActions.map(function(action, index) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                key: index,
                onClick: function() {
                    return $97914e663a317172$var$__awaiter(void 0, void 0, void 0, function() {
                        return $97914e663a317172$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    return [
                                        4 /*yield*/ ,
                                        action.handler(props.item[actionID])
                                    ];
                                case 1:
                                    _a.sent();
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                }
            }, action.icon);
        })));
    };
    var pagination = function(value, name, refreshRecord) {
        if (refreshRecord === void 0) refreshRecord = false;
        return $97914e663a317172$var$__awaiter(void 0, void 0, void 0, function() {
            var number;
            return $97914e663a317172$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        setIsRotating(true);
                        return [
                            4 /*yield*/ ,
                            loadRecords(refreshRecord, value)
                        ];
                    case 1:
                        number = _a.sent();
                        setPages(number);
                        setPage(value);
                        setIsRotating(false);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var MyCardHeader = function() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2bfceb6bd3ad6f45$export$2e2bcd8739ae039), {
            avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, addInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    alignItems: "start"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                onClick: addInfo === null || addInfo === void 0 ? void 0 : addInfo.handler,
                variant: "outlined",
                color: "primary",
                size: "small",
                sx: {
                    fontSize: "0.875rem" // Default font-size for Material-UI's small buttons
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a94c4d3b84a30d2f$exports))), null), addInfo === null || addInfo === void 0 ? void 0 : addInfo.text)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    alignItems: "start"
                }
            })),
            action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    alignItems: "center"
                }
            }, isSearchVisible && !isRotating ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
                variant: "outlined",
                size: "small",
                placeholder: "Search...",
                sx: {
                    fontSize: "0.875rem",
                    "& .MuiOutlinedInput-root": {
                        height: "2.1rem",
                        padding: "0px"
                    },
                    "& .MuiOutlinedInput-input": {
                        padding: "0.5rem 1rem"
                    }
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                onClick: function() {
                    setSearchVisibility(function(prev) {
                        return !prev;
                    });
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($41c34e1167891c88$exports))), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                onClick: function() {
                    return $97914e663a317172$var$__awaiter(void 0, void 0, void 0, function() {
                        return $97914e663a317172$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    return [
                                        4 /*yield*/ ,
                                        pagination(1, "", true)
                                    ];
                                case 1:
                                    _a.sent();
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                sx: {
                    animation: isRotating ? "".concat($97914e663a317172$var$rotateAnimation, " 1s linear infinite") : "none"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($76b5567aeb1dd705$exports))), null))))
        });
    };
    var ItemFragment = function() {
        if (items && items.length < 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null);
        return items.map(function(item, index) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, {
                key: item[actionID]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(ItemRender, {
                item: item,
                key: index
            }), index !== items.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $04d237a94a6557e6$export$2e2bcd8739ae039), {
                key: index + "divider"
            }));
        });
    };
    var PaginationHeader = function() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
            container: true,
            spacing: 2,
            style: {
                alignItems: "center"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
            item: true,
            xs: 12,
            sm: 6
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
            item: true,
            xs: 12,
            sm: 6,
            style: {
                textAlign: "right"
            }
        }, "Pages:", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8f3171dc8a1db2af$export$2e2bcd8739ae039), {
            count: Math.ceil(pages / 25),
            page: page,
            onChange: function(e, page) {
                return $97914e663a317172$var$__awaiter(void 0, void 0, void 0, function() {
                    return $97914e663a317172$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                return [
                                    4 /*yield*/ ,
                                    pagination(page, "")
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            },
            sx: {
                float: "right"
            },
            color: "primary"
        })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $075f1be02379b00f$export$2e2bcd8739ae039), {
        variant: "outlined"
    }, doShowCardHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(MyCardHeader, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8bffaacbbee0c705$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(PaginationHeader, null), doShowTableHeader && (isRotating ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(HeaderSkeleton, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Header, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $04d237a94a6557e6$export$2e2bcd8739ae039), null), isRotating && items.length === 0 ? // If loading and items is empty, render 10 skeletons
    Array.from({
        length: 5
    }).map(function(_, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, {
            key: "skeleton-".concat(index)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $04d237a94a6557e6$export$2e2bcd8739ae039), null));
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(ItemFragment, null)));
};
var $97914e663a317172$export$2e2bcd8739ae039 = $97914e663a317172$var$DataGrid;
var $97914e663a317172$var$templateObject_1;



var $7fPBF = parcelRequire("7fPBF");

var $bpHMA = parcelRequire("bpHMA");




var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $b6UUh = parcelRequire("b6UUh");




var $kDBhE = parcelRequire("kDBhE");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $3347e858a7e1bb40$export$4b135a4b3a6c4550(slot) {
    return (0, $k6RDS.default)("MuiInputAdornment", slot);
}
const $3347e858a7e1bb40$var$inputAdornmentClasses = (0, $4jzsB.default)("MuiInputAdornment", [
    "root",
    "filled",
    "standard",
    "outlined",
    "positionStart",
    "positionEnd",
    "disablePointerEvents",
    "hiddenLabel",
    "sizeSmall"
]);
var $3347e858a7e1bb40$export$2e2bcd8739ae039 = $3347e858a7e1bb40$var$inputAdornmentClasses;



var $5j2OD = parcelRequire("5j2OD");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $a1383c8904b71ac9$var$_span;
const $a1383c8904b71ac9$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $a1383c8904b71ac9$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $b6UUh.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $a1383c8904b71ac9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            disablePointerEvents && "disablePointerEvents",
            position && `position${(0, $b6UUh.default)(position)}`,
            variant,
            hiddenLabel && "hiddenLabel",
            size && `size${(0, $b6UUh.default)(size)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $3347e858a7e1bb40$export$4b135a4b3a6c4550), classes);
};
const $a1383c8904b71ac9$var$InputAdornmentRoot = (0, $kDBhE.default)("div", {
    name: "MuiInputAdornment",
    slot: "Root",
    overridesResolver: $a1383c8904b71ac9$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "flex",
        height: "0.01em",
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: "2em",
        alignItems: "center",
        whiteSpace: "nowrap",
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === "filled" && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $3347e858a7e1bb40$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $3347e858a7e1bb40$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === "start" && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === "end" && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: "none"
    }));
const $a1383c8904b71ac9$var$InputAdornment = /*#__PURE__*/ $7fPBF.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiInputAdornment"
    });
    const { children: children, className: className, component: component = "div", disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $cFLic.default)(props, $a1383c8904b71ac9$var$_excluded);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $kY3Ke.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $a1383c8904b71ac9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f29d66cab44a33c0$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($a1383c8904b71ac9$var$InputAdornmentRoot, (0, $kY3Ke.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $hngXp.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === "string" && !disableTypography ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
                children: [
                    position === "start" ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $a1383c8904b71ac9$var$_span || ($a1383c8904b71ac9$var$_span = /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $a1383c8904b71ac9$export$2e2bcd8739ae039 = $a1383c8904b71ac9$var$InputAdornment;




var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $a276a1d2103e5468$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"
}), "Email");


var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $bbde4b7a95ac46c2$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
}), "Lock");


var $89a1e316f0035a4d$var$IconsMap = {
    email: $a276a1d2103e5468$export$2e2bcd8739ae039,
    password: $bbde4b7a95ac46c2$export$2e2bcd8739ae039
};
var $89a1e316f0035a4d$export$2e2bcd8739ae039 = $89a1e316f0035a4d$var$IconsMap;


var $12a77f498332df79$exports = {};
"use strict";
"use client";

Object.defineProperty($12a77f498332df79$exports, "__esModule", {
    value: true
});
$12a77f498332df79$exports.default = void 0;

var $12a77f498332df79$var$_createSvgIcon = $4657741705a128f0$exports((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $12a77f498332df79$var$_default = (0, $12a77f498332df79$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
}), "Dashboard");
$12a77f498332df79$exports.default = $12a77f498332df79$var$_default;


var $eadb4fed4a84c890$exports = {};
"use strict";
"use client";

Object.defineProperty($eadb4fed4a84c890$exports, "__esModule", {
    value: true
});
$eadb4fed4a84c890$exports.default = void 0;

var $eadb4fed4a84c890$var$_createSvgIcon = $4657741705a128f0$exports((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $eadb4fed4a84c890$var$_default = (0, $eadb4fed4a84c890$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"
}), "Description");
$eadb4fed4a84c890$exports.default = $eadb4fed4a84c890$var$_default;


var $d70e19cd63896173$exports = {};
"use strict";
"use client";

Object.defineProperty($d70e19cd63896173$exports, "__esModule", {
    value: true
});
$d70e19cd63896173$exports.default = void 0;

var $d70e19cd63896173$var$_createSvgIcon = $4657741705a128f0$exports((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $d70e19cd63896173$var$_default = (0, $d70e19cd63896173$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M3 18h13v-2H3v2zm0-5h10v-2H3v2zm0-7v2h13V6H3zm18 9.59L17.42 12 21 8.41 19.59 7l-5 5 5 5L21 15.59z"
}), "MenuOpen");
$d70e19cd63896173$exports.default = $d70e19cd63896173$var$_default;


var $a99a4ad15df2d688$exports = {};
"use strict";
"use client";

Object.defineProperty($a99a4ad15df2d688$exports, "__esModule", {
    value: true
});
$a99a4ad15df2d688$exports.default = void 0;

var $a99a4ad15df2d688$var$_createSvgIcon = $4657741705a128f0$exports((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $a99a4ad15df2d688$var$_default = (0, $a99a4ad15df2d688$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"
}), "Settings");
$a99a4ad15df2d688$exports.default = $a99a4ad15df2d688$var$_default;


var $ef47e10a6a5726cc$exports = {};
"use strict";
"use client";

Object.defineProperty($ef47e10a6a5726cc$exports, "__esModule", {
    value: true
});
$ef47e10a6a5726cc$exports.default = void 0;

var $ef47e10a6a5726cc$var$_createSvgIcon = $4657741705a128f0$exports((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $ef47e10a6a5726cc$var$_default = (0, $ef47e10a6a5726cc$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M7.5 5.6 10 7 8.6 4.5 10 2 7.5 3.4 5 2l1.4 2.5L5 7zm12 9.8L17 14l1.4 2.5L17 19l2.5-1.4L22 19l-1.4-2.5L22 14zM22 2l-2.5 1.4L17 2l1.4 2.5L17 7l2.5-1.4L22 7l-1.4-2.5zm-7.63 5.29a.9959.9959 0 0 0-1.41 0L1.29 18.96c-.39.39-.39 1.02 0 1.41l2.34 2.34c.39.39 1.02.39 1.41 0L16.7 11.05c.39-.39.39-1.02 0-1.41l-2.33-2.35zm-1.03 5.49-2.12-2.12 2.44-2.44 2.12 2.12-2.44 2.44z"
}), "AutoFixHigh");
$ef47e10a6a5726cc$exports.default = $ef47e10a6a5726cc$var$_default;


var $d7cea6fe3b90be12$exports = {};
"use strict";
"use client";

Object.defineProperty($d7cea6fe3b90be12$exports, "__esModule", {
    value: true
});
$d7cea6fe3b90be12$exports.default = void 0;

var $d7cea6fe3b90be12$var$_createSvgIcon = $4657741705a128f0$exports((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $d7cea6fe3b90be12$var$_default = (0, $d7cea6fe3b90be12$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 14v-1h1.5v.5h2v-1H13c-.55 0-1-.45-1-1V10c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1h-1.5v-.5h-2v1H16c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1zM9 9v4.5H7.5v-1H6v1c0 .83.67 1.5 1.5 1.5H9c.83 0 1.5-.67 1.5-1.5V9H9z"
}), "Javascript");
$d7cea6fe3b90be12$exports.default = $d7cea6fe3b90be12$var$_default;


var $4aa8b5f3e1ec707f$exports = {};
"use strict";
"use client";

Object.defineProperty($4aa8b5f3e1ec707f$exports, "__esModule", {
    value: true
});
$4aa8b5f3e1ec707f$exports.default = void 0;

var $4aa8b5f3e1ec707f$var$_createSvgIcon = $4657741705a128f0$exports((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $4aa8b5f3e1ec707f$var$_default = (0, $4aa8b5f3e1ec707f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "m22.7 19-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"
}), "Build");
$4aa8b5f3e1ec707f$exports.default = $4aa8b5f3e1ec707f$var$_default;


var $3b79f3e49bf99068$exports = {};
"use strict";
"use client";

Object.defineProperty($3b79f3e49bf99068$exports, "__esModule", {
    value: true
});
$3b79f3e49bf99068$exports.default = void 0;

var $3b79f3e49bf99068$var$_createSvgIcon = $4657741705a128f0$exports((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $3b79f3e49bf99068$var$_default = (0, $3b79f3e49bf99068$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
}), "Assignment");
$3b79f3e49bf99068$exports.default = $3b79f3e49bf99068$var$_default;


var $52fcde7ba0e452b2$exports = {};
"use strict";
"use client";

Object.defineProperty($52fcde7ba0e452b2$exports, "__esModule", {
    value: true
});
$52fcde7ba0e452b2$exports.default = void 0;

var $52fcde7ba0e452b2$var$_createSvgIcon = $4657741705a128f0$exports((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $52fcde7ba0e452b2$var$_default = (0, $52fcde7ba0e452b2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M21 10h-8.35C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H13l2 2 2-2 2 2 4-4.04L21 10zM7 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
}), "Key");
$52fcde7ba0e452b2$exports.default = $52fcde7ba0e452b2$var$_default;


var $954b0c75b3959361$exports = {};
"use strict";
"use client";

Object.defineProperty($954b0c75b3959361$exports, "__esModule", {
    value: true
});
$954b0c75b3959361$exports.default = void 0;

var $954b0c75b3959361$var$_createSvgIcon = $4657741705a128f0$exports((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $954b0c75b3959361$var$_default = (0, $954b0c75b3959361$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M15.5 13.5c0 2-2.5 3.5-2.5 5h-2c0-1.5-2.5-3-2.5-5 0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5zm-2.5 6h-2V21h2v-1.5zm6-6.5c0 1.68-.59 3.21-1.58 4.42l1.42 1.42C20.18 17.27 21 15.23 21 13c0-2.74-1.23-5.19-3.16-6.84l-1.42 1.42C17.99 8.86 19 10.82 19 13zm-3-8-4-4v3c-4.97 0-9 4.03-9 9 0 2.23.82 4.27 2.16 5.84l1.42-1.42C5.59 16.21 5 14.68 5 13c0-3.86 3.14-7 7-7v3l4-4z"
}), "ModelTraining");
$954b0c75b3959361$exports.default = $954b0c75b3959361$var$_default;


var $10b93fee5915531b$exports = {};
"use strict";
"use client";

Object.defineProperty($10b93fee5915531b$exports, "__esModule", {
    value: true
});
$10b93fee5915531b$exports.default = void 0;

var $10b93fee5915531b$var$_createSvgIcon = $4657741705a128f0$exports((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $10b93fee5915531b$var$_default = (0, $10b93fee5915531b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm-1 8V6h2v4h3l-4 4-4-4h3zm6 7H7v-2h10v2z"
}), "DownloadForOffline");
$10b93fee5915531b$exports.default = $10b93fee5915531b$var$_default;


var $0f1536060938b5c4$var$DrawerMenu = [
    {
        type: "link",
        text: "Dashboard",
        route: "/",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($12a77f498332df79$exports)))
    },
    {
        type: "text",
        text: "Records"
    },
    {
        type: "link",
        text: "Reports Downloaders",
        route: "/members/records/reports-downloaders",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($10b93fee5915531b$exports)))
    },
    {
        type: "text",
        text: "Survey"
    },
    {
        type: "link",
        text: "Reports",
        route: "/members/survey/reports",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3b79f3e49bf99068$exports)))
    },
    {
        type: "link",
        text: "Settings",
        route: "/members/survey/settings",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a99a4ad15df2d688$exports)))
    },
    {
        type: "text",
        text: "CMS"
    },
    {
        type: "link",
        text: "Pages",
        route: "/members/cms/pages",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eadb4fed4a84c890$exports)))
    },
    {
        type: "link",
        text: "Menus",
        route: "/members/cms/menus",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d70e19cd63896173$exports)))
    },
    {
        type: "link",
        text: "Metas",
        route: "/members/cms/metas",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ef47e10a6a5726cc$exports)))
    },
    {
        type: "link",
        text: "Scripts",
        route: "/members/cms/scripts",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d7cea6fe3b90be12$exports)))
    },
    {
        type: "link",
        text: "Configuration",
        route: "/members/cms/configurations",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4aa8b5f3e1ec707f$exports)))
    },
    {
        type: "text",
        text: "System"
    },
    {
        type: "link",
        text: "Secrets",
        route: "/members/system/secrets",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($52fcde7ba0e452b2$exports)))
    },
    {
        type: "link",
        text: "Interval Versions",
        route: "/members/system/internal-versions",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($954b0c75b3959361$exports)))
    }
];
var $0f1536060938b5c4$export$2e2bcd8739ae039 = $0f1536060938b5c4$var$DrawerMenu;




var $8c2d2a0d8e788bfd$var$__assign = undefined && undefined.__assign || function() {
    $8c2d2a0d8e788bfd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8c2d2a0d8e788bfd$var$__assign.apply(this, arguments);
};
var $8c2d2a0d8e788bfd$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8c2d2a0d8e788bfd$var$CurvedTextElement = function(_a) {
    var label = _a.label, errorInfo = _a.errorInfo, inputType = _a.inputType, isRequired = _a.isRequired, icon = _a.icon, onChangeInput = _a.onChangeInput, onChange = _a.onChange, name = _a.name, props = $8c2d2a0d8e788bfd$var$__rest(_a, [
        "label",
        "errorInfo",
        "inputType",
        "isRequired",
        "icon",
        "onChangeInput",
        "onChange",
        "name"
    ]);
    var _b = (0, $7fPBF.useState)(""), value = _b[0], setValue = _b[1];
    var isError = errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.hasError;
    var inputProps = {};
    if (icon) {
        var IconComponent = (0, $89a1e316f0035a4d$export$2e2bcd8739ae039)[icon];
        inputProps = {
            startAdornment: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a1383c8904b71ac9$export$2e2bcd8739ae039), {
                position: "start"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(IconComponent, {
                color: isError ? "error" : "action"
            }))
        };
    }
    var handleInputChange = function(e) {
        setValue(e.target.value);
        onChangeInput(e.target.value, name);
    };
    var elementLabel = isRequired ? label + "*" : label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $59325e2784da411f$export$148f1ea13562f62c), $8c2d2a0d8e788bfd$var$__assign({
        label: isError ? elementLabel + " (" + (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.errorMsg) + ")" : elementLabel,
        error: isError,
        variant: "outlined",
        margin: "normal",
        fullWidth: true,
        type: inputType,
        value: value,
        onChange: handleInputChange,
        InputProps: inputProps
    }, props));
};
var $8c2d2a0d8e788bfd$export$2e2bcd8739ae039 = $8c2d2a0d8e788bfd$var$CurvedTextElement;



var $7fPBF = parcelRequire("7fPBF");

var $b5969bfdb795f658$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b5969bfdb795f658$var$CurvedCheckboxElement = function(_a) {
    // const isError = errorInfo?.hasError;
    var label = _a.label, errorInfo = _a.errorInfo, isRequired = _a.isRequired, onChange = _a.onChange, name = _a.name, isChecked = _a.isChecked, props = $b5969bfdb795f658$var$__rest(_a, [
        "label",
        "errorInfo",
        "isRequired",
        "onChange",
        "name",
        "isChecked"
    ]);
    var handleChange = (0, $7fPBF.useCallback)(function(e) {
        onChange(e.target.checked, name);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("label", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $59325e2784da411f$export$887faf5e94d3db05), {
        checked: isChecked,
        onChange: handleChange
    }), label, isRequired && "*");
};
var $b5969bfdb795f658$export$2e2bcd8739ae039 = $b5969bfdb795f658$var$CurvedCheckboxElement;



var $7fPBF = parcelRequire("7fPBF");


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");






var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $7a8a9052410fb062$export$81478e24460c57f2(slot) {
    return (0, $k6RDS.default)("MuiListItemIcon", slot);
}
const $7a8a9052410fb062$var$listItemIconClasses = (0, $4jzsB.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $7a8a9052410fb062$export$2e2bcd8739ae039 = $7a8a9052410fb062$var$listItemIconClasses;



var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $2a8a1c268392e331$export$1061006a0db3aeb5(slot) {
    return (0, $k6RDS.default)("MuiListItemText", slot);
}
const $2a8a1c268392e331$var$listItemTextClasses = (0, $4jzsB.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $2a8a1c268392e331$export$2e2bcd8739ae039 = $2a8a1c268392e331$var$listItemTextClasses;



var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $81e9a11bd449f186$export$515f8c67b5305377(slot) {
    return (0, $k6RDS.default)("MuiMenuItem", slot);
}
const $81e9a11bd449f186$var$menuItemClasses = (0, $4jzsB.default)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $81e9a11bd449f186$export$2e2bcd8739ae039 = $81e9a11bd449f186$var$menuItemClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $3bdbe9250415b022$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $3bdbe9250415b022$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $3bdbe9250415b022$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $81e9a11bd449f186$export$515f8c67b5305377), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $3bdbe9250415b022$var$MenuItemRoot = (0, $kDBhE.default)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $kDBhE.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $3bdbe9250415b022$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, theme.typography.body1, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, {
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $be601d991ccbe49a$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $be601d991ccbe49a$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $2a8a1c268392e331$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $2a8a1c268392e331$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $7a8a9052410fb062$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up("sm")]: {
            minHeight: "auto"
        }
    }, ownerState.dense && (0, $kY3Ke.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $7a8a9052410fb062$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: "1.25rem"
        }
    })));
const $3bdbe9250415b022$var$MenuItem = /*#__PURE__*/ $7fPBF.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false, component: component = "li", dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = "menuitem", tabIndex: tabIndexProp, className: className } = props, other = (0, $cFLic.default)(props, $3bdbe9250415b022$var$_excluded);
    const context = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    const childContext = $7fPBF.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $7fPBF.useRef(null);
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $3bdbe9250415b022$var$useUtilityClasses(props);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $94e271e17fd22222$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($3bdbe9250415b022$var$MenuItemRoot, (0, $kY3Ke.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $hngXp.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $hngXp.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $3bdbe9250415b022$export$2e2bcd8739ae039 = $3bdbe9250415b022$var$MenuItem;



var $b6c87fe90d146370$var$__assign = undefined && undefined.__assign || function() {
    $b6c87fe90d146370$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b6c87fe90d146370$var$__assign.apply(this, arguments);
};
var $b6c87fe90d146370$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b6c87fe90d146370$var$CurvedSelectElement = function(_a) {
    var label = _a.label, errorInfo = _a.errorInfo, isRequired = _a.isRequired, onChange = _a.onChange, onChangeSelect = _a.onChangeSelect, name = _a.name, options = _a.options, defaultValue = _a.defaultValue, props = $b6c87fe90d146370$var$__rest(_a, [
        "label",
        "errorInfo",
        "isRequired",
        "onChange",
        "onChangeSelect",
        "name",
        "options",
        "defaultValue"
    ]);
    var _b = (0, $7fPBF.useState)(defaultValue !== null && defaultValue !== void 0 ? defaultValue : ""), value = _b[0], setValue = _b[1];
    var isError = errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.hasError;
    var handleChange = function(e) {
        var selectedValue = e.target.value;
        setValue(selectedValue);
        onChangeSelect(selectedValue, name);
    };
    var elementLabel = isRequired ? label + "*" : label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $59325e2784da411f$export$975ebf2eafe6c281), {
        fullWidth: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $fcd80672e9993aad$export$2e2bcd8739ae039), null, isError ? elementLabel + " (" + (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.errorMsg) + ")" : elementLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $59325e2784da411f$export$4d7ecc5335eb78f1), $b6c87fe90d146370$var$__assign({
        label: isError ? elementLabel + " (" + (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.errorMsg) + ")" : elementLabel,
        error: isError,
        value: value,
        variant: "outlined",
        fullWidth: true,
        onChange: handleChange
    }, props), options === null || options === void 0 ? void 0 : options.data.map(function(option, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
            key: index,
            value: option[options.dictionary.id]
        }, option[options.dictionary.value]);
    })));
};
var $b6c87fe90d146370$export$2e2bcd8739ae039 = $b6c87fe90d146370$var$CurvedSelectElement;



var $7fPBF = parcelRequire("7fPBF");


var $153c95909507e101$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $153c95909507e101$var$CurvedTextAreaElement = function(_a) {
    var label = _a.label, errorInfo = _a.errorInfo, isRequired = _a.isRequired, icon = _a.icon, onChange = _a.onChange, onChangeInput = _a.onChangeInput, initialValue = _a.initialValue, name = _a.name, props = $153c95909507e101$var$__rest(_a, [
        "label",
        "errorInfo",
        "isRequired",
        "icon",
        "onChange",
        "onChangeInput",
        "initialValue",
        "name"
    ]);
    var _b = (0, $7fPBF.useState)(""), value = _b[0], setValue = _b[1];
    var _c = (0, $7fPBF.useState)(false), isFocused = _c[0], setIsFocused = _c[1];
    var isError = errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.hasError;
    var handleInputChange = function(e) {
        var val = e;
        if (e.target) val = e.target.value;
        setValue(val);
        onChangeInput(val, name);
    };
    var handleFocus = function() {
        setIsFocused(true);
    };
    var handleBlur = function() {
        setIsFocused(false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        setValue(initialValue);
    }, [
        initialValue
    ]);
    var elementLabel = isRequired ? label + "*" : label;
    var isActive = isFocused || !!value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $77ec199cefd4182a$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("br", null), label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("label", {
        htmlFor: name,
        style: {
            backgroundColor: "white",
            zIndex: 10,
            fontSize: "1.1em",
            transition: "transform 0.2s, fontSize 0.2s",
            color: isError ? "red" : isActive ? "#367fbb" : "#6E6E6E",
            fontWeight: 400
        }
    }, isError ? elementLabel + " (" + (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.errorMsg) + ")" : elementLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $84c4a14bed3ab14b$export$2e2bcd8739ae039), {
        isactive: isActive + "",
        value: value,
        onChange: handleInputChange,
        onFocus: handleFocus,
        onBlur: handleBlur
    }));
};
var $153c95909507e101$export$2e2bcd8739ae039 = $153c95909507e101$var$CurvedTextAreaElement;



var $7fPBF = parcelRequire("7fPBF");



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");

var $b6UUh = parcelRequire("b6UUh");


var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $b585c34ca23c4f44$export$39f6debbec19b3ba(slot) {
    return (0, $k6RDS.default)("MuiSwitch", slot);
}
const $b585c34ca23c4f44$var$switchClasses = (0, $4jzsB.default)("MuiSwitch", [
    "root",
    "edgeStart",
    "edgeEnd",
    "switchBase",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium",
    "checked",
    "disabled",
    "input",
    "thumb",
    "track"
]);
var $b585c34ca23c4f44$export$2e2bcd8739ae039 = $b585c34ca23c4f44$var$switchClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $01917f736960ab46$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $01917f736960ab46$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            edge && `edge${(0, $b6UUh.default)(edge)}`,
            `size${(0, $b6UUh.default)(size)}`
        ],
        switchBase: [
            "switchBase",
            `color${(0, $b6UUh.default)(color)}`,
            checked && "checked",
            disabled && "disabled"
        ],
        thumb: [
            "thumb"
        ],
        track: [
            "track"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $b585c34ca23c4f44$export$39f6debbec19b3ba), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $01917f736960ab46$var$SwitchRoot = (0, $kDBhE.default)("span", {
    name: "MuiSwitch",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $b6UUh.default)(ownerState.edge)}`],
            styles[`size${(0, $b6UUh.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "inline-flex",
        width: 58,
        height: 38,
        overflow: "hidden",
        padding: 12,
        boxSizing: "border-box",
        position: "relative",
        flexShrink: 0,
        zIndex: 0,
        // Reset the stacking context.
        verticalAlign: "middle",
        // For correct alignment with the text.
        "@media print": {
            colorAdjust: "exact"
        }
    }, ownerState.edge === "start" && {
        marginLeft: -8
    }, ownerState.edge === "end" && {
        marginRight: -8
    }, ownerState.size === "small" && {
        width: 40,
        height: 24,
        padding: 7,
        [`& .${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).thumb}`]: {
            width: 16,
            height: 16
        },
        [`& .${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).switchBase}`]: {
            padding: 4,
            [`&.${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).checked}`]: {
                transform: "translateX(16px)"
            }
        }
    }));
const $01917f736960ab46$var$SwitchSwitchBase = (0, $kDBhE.default)((0, $69935e2350f58c79$export$2e2bcd8739ae039), {
    name: "MuiSwitch",
    slot: "SwitchBase",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== "default" && styles[`color${(0, $b6UUh.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme })=>({
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === "light" ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            "left",
            "transform"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).checked}`]: {
            transform: "translateX(20px)"
        },
        [`&.${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).checked} + .${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).disabled} + .${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === "light" ? 0.12 : 0.2}`
        },
        [`& .${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).input}`]: {
            left: "-100%",
            width: "300%"
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cxeT8.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main,
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cxeT8.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            [`&.${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).disabled}`]: {
                color: theme.vars ? theme.vars.palette.Switch[`${ownerState.color}DisabledColor`] : `${theme.palette.mode === "light" ? (0, $cxeT8.lighten)(theme.palette[ownerState.color].main, 0.62) : (0, $cxeT8.darken)(theme.palette[ownerState.color].main, 0.55)}`
            }
        },
        [`&.${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).checked} + .${(0, $b585c34ca23c4f44$export$2e2bcd8739ae039).track}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main
        }
    }));
const $01917f736960ab46$var$SwitchTrack = (0, $kDBhE.default)("span", {
    name: "MuiSwitch",
    slot: "Track",
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>({
        height: "100%",
        width: "100%",
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            "opacity",
            "background-color"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === "light" ? 0.38 : 0.3}`
    }));
const $01917f736960ab46$var$SwitchThumb = (0, $kDBhE.default)("span", {
    name: "MuiSwitch",
    slot: "Thumb",
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: "currentColor",
        width: 20,
        height: 20,
        borderRadius: "50%"
    }));
const $01917f736960ab46$var$Switch = /*#__PURE__*/ $7fPBF.forwardRef(function Switch(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiSwitch"
    });
    const { className: className, color: color = "primary", edge: edge = false, size: size = "medium", sx: sx } = props, other = (0, $cFLic.default)(props, $01917f736960ab46$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $01917f736960ab46$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $bbzbN.jsx)($01917f736960ab46$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($01917f736960ab46$var$SwitchRoot, {
        className: (0, $hngXp.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($01917f736960ab46$var$SwitchSwitchBase, (0, $kY3Ke.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $kY3Ke.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $bbzbN.jsx)($01917f736960ab46$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
var $01917f736960ab46$export$2e2bcd8739ae039 = $01917f736960ab46$var$Switch;




var $5c9549b0a31c6d14$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5c9549b0a31c6d14$var$CurvedEditorElement = function(_a) {
    var label = _a.label, errorInfo = _a.errorInfo, isRequired = _a.isRequired, onChangeInput = _a.onChangeInput, onChange = _a.onChange, name = _a.name, initialValue = _a.initialValue, props = $5c9549b0a31c6d14$var$__rest(_a, [
        "label",
        "errorInfo",
        "isRequired",
        "onChangeInput",
        "onChange",
        "name",
        "initialValue"
    ]);
    var _b = (0, $7fPBF.useState)("editor"), mode = _b[0], setMode = _b[1];
    var _c = (0, $7fPBF.useState)(""), value = _c[0], setValue = _c[1];
    var _d = (0, $7fPBF.useState)(false), isFocused = _d[0], setIsFocused = _d[1];
    var isError = errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.hasError;
    var modules = {
        toolbar: [
            [
                "bold",
                "italic",
                "underline",
                "strike"
            ],
            [
                "blockquote",
                "code-block"
            ],
            [
                {
                    header: 1
                },
                {
                    header: 2
                }
            ],
            [
                {
                    list: "ordered"
                },
                {
                    list: "bullet"
                }
            ],
            [
                {
                    script: "sub"
                },
                {
                    script: "super"
                }
            ],
            [
                {
                    indent: "-1"
                },
                {
                    indent: "+1"
                }
            ],
            [
                {
                    direction: "rtl"
                }
            ],
            [
                {
                    size: [
                        "small",
                        false,
                        "large",
                        "huge"
                    ]
                }
            ],
            [
                {
                    header: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        false
                    ]
                }
            ],
            [
                {
                    color: []
                },
                {
                    background: []
                }
            ],
            [
                {
                    font: []
                }
            ],
            [
                {
                    align: []
                }
            ],
            [
                "clean"
            ],
            [
                "link",
                "image",
                "video"
            ]
        ]
    };
    var formats = [
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "code-block",
        "header",
        "list",
        "script",
        "indent",
        "direction",
        "size",
        "color",
        "background",
        "font",
        "align",
        "link",
        "image",
        "video"
    ];
    var handleInputChange = function(e) {
        var val = e;
        if (e.target) val = e.target.value;
        setValue(val);
        onChangeInput(val, name);
    };
    var handleFocus = function() {
        setIsFocused(true);
    };
    var handleBlur = function() {
        setIsFocused(false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        setValue(initialValue);
    }, [
        initialValue
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {}, []);
    var elementLabel = isRequired ? label + "*" : label;
    var isActive = isFocused || !!value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $77ec199cefd4182a$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            justifyContent: "flex-end"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
        control: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $01917f736960ab46$export$2e2bcd8739ae039), {
            checked: mode === "code",
            onChange: function() {
                setMode(function(prevMode) {
                    return prevMode === "editor" ? "code" : "editor";
                });
            },
            name: "modeSwitch",
            color: "primary"
        }),
        label: mode === "editor" ? "Switch to Code" : "Switch to Editor"
    })), label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("label", {
        htmlFor: name,
        style: {
            backgroundColor: "white",
            zIndex: 10,
            fontSize: "1.1em",
            transition: "transform 0.2s, fontSize 0.2s",
            color: isError ? "red" : isActive ? "#367fbb" : "#6E6E6E",
            fontWeight: 400
        }
    }, isError ? elementLabel + " (" + (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.errorMsg) + ")" : elementLabel), mode === "editor" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $05020149fe4d10cd$export$2e2bcd8739ae039), {
        isactive: isActive,
        value: value,
        onChange: handleInputChange,
        modules: modules,
        formats: formats,
        onFocus: handleFocus,
        onBlur: handleBlur,
        theme: "snow"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $84c4a14bed3ab14b$export$2e2bcd8739ae039), {
        isactive: isActive + "",
        value: value,
        onChange: handleInputChange,
        onFocus: handleFocus,
        onBlur: handleBlur
    }));
};
var $5c9549b0a31c6d14$export$2e2bcd8739ae039 = $5c9549b0a31c6d14$var$CurvedEditorElement;



var $7fPBF = parcelRequire("7fPBF");

var $4c078c7a959fc44d$exports = {};
"use strict";
"use client";

Object.defineProperty($4c078c7a959fc44d$exports, "__esModule", {
    value: true
});
$4c078c7a959fc44d$exports.default = void 0;

var $4c078c7a959fc44d$var$_createSvgIcon = $4657741705a128f0$exports((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $4c078c7a959fc44d$var$_default = (0, $4c078c7a959fc44d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
}), "CloudUpload");
$4c078c7a959fc44d$exports.default = $4c078c7a959fc44d$var$_default;



var $c1ff01b2074014ba$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c1ff01b2074014ba$var$VisuallyHiddenInput = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1
});
var $c1ff01b2074014ba$var$CurvedFileElement = function(_a) {
    var label = _a.label, onChangeInput = _a.onChangeInput, name = _a.name, icon = _a.icon, errorInfo = _a.errorInfo, isRequired = _a.isRequired, fileType = _a.fileType, value = _a.value, props = $c1ff01b2074014ba$var$__rest(_a, [
        "label",
        "onChangeInput",
        "name",
        "icon",
        "errorInfo",
        "isRequired",
        "fileType",
        "value"
    ]);
    var _b = (0, $7fPBF.useState)(null), imagePreview = _b[0], setImagePreview = _b[1];
    var _c = (0, $7fPBF.useState)(), filename = _c[0], setFilename = _c[1];
    var isError = errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.hasError;
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        if (value && !filename) {
            var fileValue = JSON.parse(value);
            if (fileValue.file.includes("image/")) setImagePreview(fileValue.file);
            setFilename(fileValue);
            onChangeInput(fileValue, name);
        }
    }, [
        value
    ]);
    var handleFileChange = function(e) {
        var _a;
        var file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (file) {
            setFilename(file);
            onChangeInput(file, name);
            if (file.type.startsWith("image/")) setImagePreview(URL.createObjectURL(file));
        }
    };
    var renderButtonContent = function() {
        var elementLabel = isRequired ? label + "*" : label;
        return isError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
            style: {
                color: "red"
            }
        }, elementLabel + " (" + (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.errorMsg) + ")") : filename ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
            style: {
                color: "green"
            }
        }, elementLabel + " (" + (filename === null || filename === void 0 ? void 0 : filename.name) + ")") : elementLabel;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
        style: {
            backgroundColor: "#FF9800",
            color: "#fff",
            marginTop: "16px",
            marginBottom: "8px"
        },
        component: "label",
        variant: "contained",
        startIcon: imagePreview ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("img", {
            src: imagePreview,
            alt: "preview",
            style: {
                width: "24px",
                height: "24px"
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4c078c7a959fc44d$exports))), null),
        fullWidth: true
    }, renderButtonContent(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($c1ff01b2074014ba$var$VisuallyHiddenInput, {
        type: "file",
        onChange: handleFileChange,
        accept: fileType
    })));
};
var $c1ff01b2074014ba$export$2e2bcd8739ae039 = $c1ff01b2074014ba$var$CurvedFileElement;




var $7cfec887c27b8c9d$var$FormField = function(_a) {
    var _b;
    var config = _a.config, value = _a.value, error = _a.error, setValue = _a.setValue;
    switch(config.fieldType){
        case "editor":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $5c9549b0a31c6d14$export$2e2bcd8739ae039), {
                label: config.label,
                name: config.name,
                initialValue: value,
                errorInfo: {
                    hasError: !!error,
                    errorMsg: error !== null && error !== void 0 ? error : ""
                },
                onChangeInput: function(value, name) {
                    setValue(value, name);
                },
                isRequired: config === null || config === void 0 ? void 0 : config.isRequired
            });
        case "input":
        case "password":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8c2d2a0d8e788bfd$export$2e2bcd8739ae039), {
                label: config.label,
                name: config.name,
                errorInfo: {
                    hasError: !!error,
                    errorMsg: error !== null && error !== void 0 ? error : ""
                },
                inputType: config.fieldType,
                value: value,
                onChangeInput: function(value, name) {
                    setValue(value, name);
                },
                icon: config === null || config === void 0 ? void 0 : config.icon,
                isRequired: config === null || config === void 0 ? void 0 : config.isRequired
            });
        case "file":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $c1ff01b2074014ba$export$2e2bcd8739ae039), {
                label: config.label,
                name: config.name,
                errorInfo: {
                    hasError: !!error,
                    errorMsg: error !== null && error !== void 0 ? error : ""
                },
                value: value,
                onChangeInput: function(value, name) {
                    setValue(value, name);
                },
                icon: config === null || config === void 0 ? void 0 : config.icon,
                isRequired: config === null || config === void 0 ? void 0 : config.isRequired,
                fileType: config === null || config === void 0 ? void 0 : config.fileType
            });
        case "select":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $b6c87fe90d146370$export$2e2bcd8739ae039), {
                label: config.label,
                name: config.name,
                value: value,
                errorInfo: {
                    hasError: !!error,
                    errorMsg: error !== null && error !== void 0 ? error : "" // Joining the errors to form a string
                },
                isRequired: config === null || config === void 0 ? void 0 : config.isRequired,
                onChangeSelect: function(value, name) {
                    setValue(value, name);
                },
                options: (_b = config.options) !== null && _b !== void 0 ? _b : []
            });
        case "textarea":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $153c95909507e101$export$2e2bcd8739ae039), {
                label: config.label,
                name: config.name,
                value: value,
                errorInfo: {
                    hasError: !!error,
                    errorMsg: error !== null && error !== void 0 ? error : "" // Joining the errors to form a string
                },
                isRequired: config === null || config === void 0 ? void 0 : config.isRequired,
                icon: config === null || config === void 0 ? void 0 : config.icon,
                initialValue: value,
                onChangeInput: function(value, name) {
                    setValue(value, name);
                }
            });
        /*
    case 'checkbox':
      return (
        <CurvedCheckboxElement.test.tsx
          label={config.label}
          checked={!!value}
          onChange={e => {
            setValue(String(e.target.checked));
          }}
        />
      );
    // Assuming CurvedRadioElement exists too, similar to the provided components
    case 'radio':
      return (
        <div>
          {config.options?.map(option => (
            <FormControlLabel
              key={option}
              value={option}
              control={<CurvedRadioElement />}
              label={option}
              checked={value === option}
              onChange={() => {
                setValue(option);
              }}
            />
          ))}
        </div>
      ); */ default:
            return null;
    }
};
var $7cfec887c27b8c9d$export$2e2bcd8739ae039 = $7cfec887c27b8c9d$var$FormField;



var $7fPBF = parcelRequire("7fPBF");
var $054b28f0018c3ad0$var$ValidateField = function(_a, value) {
    var _b, _c, _d, _e;
    var type = _a.type, required = _a.required, minLength = _a.minLength, customMessages = _a.customMessages;
    var errors = []; // Check for required fields
    if (required && !value) errors.push((_b = customMessages === null || customMessages === void 0 ? void 0 : customMessages.required) !== null && _b !== void 0 ? _b : "".concat(type.charAt(0).toUpperCase() + type.slice(1), " is required"));
    var emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    switch(type){
        case "email":
            if (value && !emailRegex.test(value)) errors.push((_c = customMessages === null || customMessages === void 0 ? void 0 : customMessages.email) !== null && _c !== void 0 ? _c : "Email is not valid");
            break;
        case "password":
            if (value && minLength && value.length < minLength) errors.push((_d = customMessages === null || customMessages === void 0 ? void 0 : customMessages.minLength) !== null && _d !== void 0 ? _d : "Password should be at least ".concat(minLength, " characters"));
            break;
        case "text":
            if (value && minLength && value.length < minLength) errors.push((_e = customMessages === null || customMessages === void 0 ? void 0 : customMessages.minLength) !== null && _e !== void 0 ? _e : "Field should be at least ".concat(minLength, " characters"));
            break;
    }
    return errors;
};
var $054b28f0018c3ad0$export$2e2bcd8739ae039 = $054b28f0018c3ad0$var$ValidateField;


var $b924d7e70fc8529e$export$bffbb9fe62ba8e71 = function(fieldValidators, initialValue) {
    var _a = (0, $7fPBF.useState)(""), value = _a[0], setValue = _a[1];
    var _b = (0, $7fPBF.useState)([]), errors = _b[0], setErrors = _b[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        setValue(initialValue !== null && initialValue !== void 0 ? initialValue : "");
    }, []);
    var validate = function() {
        var validationErrors = (0, $054b28f0018c3ad0$export$2e2bcd8739ae039)(fieldValidators, value);
        setErrors(validationErrors);
        return validationErrors.length > 0;
    };
    var validateByValue = function(argValue) {
        var validationErrors = (0, $054b28f0018c3ad0$export$2e2bcd8739ae039)(fieldValidators, argValue);
        setErrors(validationErrors);
    };
    return {
        value: value,
        errors: errors,
        validate: validate,
        setValue: setValue,
        validateByValue: validateByValue
    };
};




var $7fPBF = parcelRequire("7fPBF");
function $582255ee0585c19b$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $582255ee0585c19b$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $582255ee0585c19b$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $582255ee0585c19b$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $582255ee0585c19b$export$2e2bcd8739ae039 = $582255ee0585c19b$export$4f5d2d50c9deca37;


"use client";
const $de77e498e07914bf$var$u = (t)=>"number" == typeof t && !isNaN(t), $de77e498e07914bf$var$d = (t)=>"string" == typeof t, $de77e498e07914bf$var$p = (t)=>"function" == typeof t, $de77e498e07914bf$var$m = (t)=>$de77e498e07914bf$var$d(t) || $de77e498e07914bf$var$p(t) ? t : null, $de77e498e07914bf$var$f = (t)=>(0, $7fPBF.isValidElement)(t) || $de77e498e07914bf$var$d(t) || $de77e498e07914bf$var$p(t) || $de77e498e07914bf$var$u(t);
function $de77e498e07914bf$export$184cca501f1aed7f(t, e, n) {
    void 0 === n && (n = 300);
    const { scrollHeight: o, style: s } = t;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = o + "px", s.transition = `all ${n}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(e, n);
        });
    });
}
function $de77e498e07914bf$export$3ff7dc44d332d222(e) {
    let { enter: a, exit: r, appendPosition: i = !1, collapse: l = !0, collapseDuration: c = 300 } = e;
    return function(e) {
        let { children: u, position: d, preventExitTransition: p, done: m, nodeRef: f, isIn: h } = e;
        const y = i ? `${a}--${d}` : a, v = i ? `${r}--${d}` : r, T = (0, $7fPBF.useRef)(0);
        return (0, $7fPBF.useLayoutEffect)(()=>{
            const t = f.current, e = y.split(" "), n = (o)=>{
                o.target === f.current && (t.dispatchEvent(new Event("d")), t.removeEventListener("animationend", n), t.removeEventListener("animationcancel", n), 0 === T.current && "animationcancel" !== o.type && t.classList.remove(...e));
            };
            t.classList.add(...e), t.addEventListener("animationend", n), t.addEventListener("animationcancel", n);
        }, []), (0, $7fPBF.useEffect)(()=>{
            const t = f.current, e = ()=>{
                t.removeEventListener("animationend", e), l ? $de77e498e07914bf$export$184cca501f1aed7f(t, m, c) : m();
            };
            h || (p ? e() : (T.current = 1, t.className += ` ${v}`, t.addEventListener("animationend", e)));
        }, [
            h
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, u);
    };
}
function $de77e498e07914bf$var$y(t, e) {
    return null != t ? {
        content: t.content,
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        status: e
    } : {};
}
const $de77e498e07914bf$var$v = {
    list: new Map,
    emitQueue: new Map,
    on (t, e) {
        return this.list.has(t) || this.list.set(t, []), this.list.get(t).push(e), this;
    },
    off (t, e) {
        if (e) {
            const n = this.list.get(t).filter((t)=>t !== e);
            return this.list.set(t, n), this;
        }
        return this.list.delete(t), this;
    },
    cancelEmit (t) {
        const e = this.emitQueue.get(t);
        return e && (e.forEach(clearTimeout), this.emitQueue.delete(t)), this;
    },
    emit (t) {
        this.list.has(t) && this.list.get(t).forEach((e)=>{
            const n = setTimeout(()=>{
                e(...[].slice.call(arguments, 1));
            }, 0);
            this.emitQueue.has(t) || this.emitQueue.set(t, []), this.emitQueue.get(t).push(n);
        });
    }
}, $de77e498e07914bf$var$T = (e)=>{
    let { theme: n, type: o, ...s } = e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: "colored" === n ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...s
    });
}, $de77e498e07914bf$export$4f13f83fd8bb1dac = {
    info: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($de77e498e07914bf$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
        }));
    },
    warning: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($de77e498e07914bf$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
            d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
        }));
    },
    success: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($de77e498e07914bf$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
        }));
    },
    error: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($de77e498e07914bf$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
            d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
        }));
    },
    spinner: function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "Toastify__spinner"
        });
    }
};
function $de77e498e07914bf$export$b262e13ca2dd2381(t) {
    const [, o] = (0, $7fPBF.useReducer)((t)=>t + 1, 0), [l, c] = (0, $7fPBF.useState)([]), g = (0, $7fPBF.useRef)(null), h = (0, $7fPBF.useRef)(new Map).current, T = (t)=>-1 !== l.indexOf(t), C = (0, $7fPBF.useRef)({
        toastKey: 1,
        displayedToast: 0,
        count: 0,
        queue: [],
        props: t,
        containerId: null,
        isToastActive: T,
        getToast: (t)=>h.get(t)
    }).current;
    function b(t) {
        let { containerId: e } = t;
        const { limit: n } = C.props;
        !n || e && C.containerId !== e || (C.count -= C.queue.length, C.queue = []);
    }
    function I(t) {
        c((e)=>null == t ? [] : e.filter((e)=>e !== t));
    }
    function _() {
        const { toastContent: t, toastProps: e, staleId: n } = C.queue.shift();
        O(t, e, n);
    }
    function L(t, n) {
        let { delay: s, staleId: r, ...i } = n;
        if (!$de77e498e07914bf$var$f(t) || function(t) {
            return !g.current || C.props.enableMultiContainer && t.containerId !== C.props.containerId || h.has(t.toastId) && null == t.updateId;
        }(i)) return;
        const { toastId: l, updateId: c, data: T } = i, { props: b } = C, L = ()=>I(l), N = null == c;
        N && C.count++;
        const M = {
            ...b,
            style: b.toastStyle,
            key: C.toastKey++,
            ...Object.fromEntries(Object.entries(i).filter((t)=>{
                let [e, n] = t;
                return null != n;
            })),
            toastId: l,
            updateId: c,
            data: T,
            closeToast: L,
            isIn: !1,
            className: $de77e498e07914bf$var$m(i.className || b.toastClassName),
            bodyClassName: $de77e498e07914bf$var$m(i.bodyClassName || b.bodyClassName),
            progressClassName: $de77e498e07914bf$var$m(i.progressClassName || b.progressClassName),
            autoClose: !i.isLoading && (R = i.autoClose, w = b.autoClose, !1 === R || $de77e498e07914bf$var$u(R) && R > 0 ? R : w),
            deleteToast () {
                const t = $de77e498e07914bf$var$y(h.get(l), "removed");
                h.delete(l), $de77e498e07914bf$var$v.emit(4, t);
                const e = C.queue.length;
                if (C.count = null == l ? C.count - C.displayedToast : C.count - 1, C.count < 0 && (C.count = 0), e > 0) {
                    const t = null == l ? C.props.limit : 1;
                    if (1 === e || 1 === t) C.displayedToast++, _();
                    else {
                        const n = t > e ? e : t;
                        C.displayedToast = n;
                        for(let t = 0; t < n; t++)_();
                    }
                } else o();
            }
        };
        var R, w;
        M.iconOut = function(t) {
            let { theme: n, type: o, isLoading: s, icon: r } = t, i = null;
            const l = {
                theme: n,
                type: o
            };
            return !1 === r || ($de77e498e07914bf$var$p(r) ? i = r(l) : (0, $7fPBF.isValidElement)(r) ? i = (0, $7fPBF.cloneElement)(r, l) : $de77e498e07914bf$var$d(r) || $de77e498e07914bf$var$u(r) ? i = r : s ? i = $de77e498e07914bf$export$4f13f83fd8bb1dac.spinner() : ((t)=>t in $de77e498e07914bf$export$4f13f83fd8bb1dac)(o) && (i = $de77e498e07914bf$export$4f13f83fd8bb1dac[o](l))), i;
        }(M), $de77e498e07914bf$var$p(i.onOpen) && (M.onOpen = i.onOpen), $de77e498e07914bf$var$p(i.onClose) && (M.onClose = i.onClose), M.closeButton = b.closeButton, !1 === i.closeButton || $de77e498e07914bf$var$f(i.closeButton) ? M.closeButton = i.closeButton : !0 === i.closeButton && (M.closeButton = !$de77e498e07914bf$var$f(b.closeButton) || b.closeButton);
        let x = t;
        (0, $7fPBF.isValidElement)(t) && !$de77e498e07914bf$var$d(t.type) ? x = (0, $7fPBF.cloneElement)(t, {
            closeToast: L,
            toastProps: M,
            data: T
        }) : $de77e498e07914bf$var$p(t) && (x = t({
            closeToast: L,
            toastProps: M,
            data: T
        })), b.limit && b.limit > 0 && C.count > b.limit && N ? C.queue.push({
            toastContent: x,
            toastProps: M,
            staleId: r
        }) : $de77e498e07914bf$var$u(s) ? setTimeout(()=>{
            O(x, M, r);
        }, s) : O(x, M, r);
    }
    function O(t, e, n) {
        const { toastId: o } = e;
        n && h.delete(n);
        const s = {
            content: t,
            props: e
        };
        h.set(o, s), c((t)=>[
                ...t,
                o
            ].filter((t)=>t !== n)), $de77e498e07914bf$var$v.emit(4, $de77e498e07914bf$var$y(s, null == s.props.updateId ? "added" : "updated"));
    }
    return (0, $7fPBF.useEffect)(()=>(C.containerId = t.containerId, $de77e498e07914bf$var$v.cancelEmit(3).on(0, L).on(1, (t)=>g.current && I(t)).on(5, b).emit(2, C), ()=>{
            h.clear(), $de77e498e07914bf$var$v.emit(3, C);
        }), []), (0, $7fPBF.useEffect)(()=>{
        C.props = t, C.isToastActive = T, C.displayedToast = l.length;
    }), {
        getToastToRender: function(e) {
            const n = new Map, o = Array.from(h.values());
            return t.newestOnTop && o.reverse(), o.forEach((t)=>{
                const { position: e } = t.props;
                n.has(e) || n.set(e, []), n.get(e).push(t);
            }), Array.from(n, (t)=>e(t[0], t[1]));
        },
        containerRef: g,
        isToastActive: T
    };
}
function $de77e498e07914bf$var$b(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientX : t.clientX;
}
function $de77e498e07914bf$var$I(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientY : t.clientY;
}
function $de77e498e07914bf$export$a407b657d3044108(t) {
    const [o, a] = (0, $7fPBF.useState)(!1), [r, l] = (0, $7fPBF.useState)(!1), c = (0, $7fPBF.useRef)(null), u = (0, $7fPBF.useRef)({
        start: 0,
        x: 0,
        y: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        boundingRect: null,
        didMove: !1
    }).current, d = (0, $7fPBF.useRef)(t), { autoClose: m, pauseOnHover: f, closeToast: g, onClick: h, closeOnClick: y } = t;
    function v(e) {
        if (t.draggable) {
            "touchstart" === e.nativeEvent.type && e.nativeEvent.preventDefault(), u.didMove = !1, document.addEventListener("mousemove", _), document.addEventListener("mouseup", L), document.addEventListener("touchmove", _), document.addEventListener("touchend", L);
            const n = c.current;
            u.canCloseOnClick = !0, u.canDrag = !0, u.boundingRect = n.getBoundingClientRect(), n.style.transition = "", u.x = $de77e498e07914bf$var$b(e.nativeEvent), u.y = $de77e498e07914bf$var$I(e.nativeEvent), "x" === t.draggableDirection ? (u.start = u.x, u.removalDistance = n.offsetWidth * (t.draggablePercent / 100)) : (u.start = u.y, u.removalDistance = n.offsetHeight * (80 === t.draggablePercent ? 1.5 * t.draggablePercent : t.draggablePercent / 100));
        }
    }
    function T(e) {
        if (u.boundingRect) {
            const { top: n, bottom: o, left: s, right: a } = u.boundingRect;
            "touchend" !== e.nativeEvent.type && t.pauseOnHover && u.x >= s && u.x <= a && u.y >= n && u.y <= o ? C() : E();
        }
    }
    function E() {
        a(!0);
    }
    function C() {
        a(!1);
    }
    function _(e) {
        const n = c.current;
        u.canDrag && n && (u.didMove = !0, o && C(), u.x = $de77e498e07914bf$var$b(e), u.y = $de77e498e07914bf$var$I(e), u.delta = "x" === t.draggableDirection ? u.x - u.start : u.y - u.start, u.start !== u.x && (u.canCloseOnClick = !1), n.style.transform = `translate${t.draggableDirection}(${u.delta}px)`, n.style.opacity = "" + (1 - Math.abs(u.delta / u.removalDistance)));
    }
    function L() {
        document.removeEventListener("mousemove", _), document.removeEventListener("mouseup", L), document.removeEventListener("touchmove", _), document.removeEventListener("touchend", L);
        const e = c.current;
        if (u.canDrag && u.didMove && e) {
            if (u.canDrag = !1, Math.abs(u.delta) > u.removalDistance) return l(!0), void t.closeToast();
            e.style.transition = "transform 0.2s, opacity 0.2s", e.style.transform = `translate${t.draggableDirection}(0)`, e.style.opacity = "1";
        }
    }
    (0, $7fPBF.useEffect)(()=>{
        d.current = t;
    }), (0, $7fPBF.useEffect)(()=>(c.current && c.current.addEventListener("d", E, {
            once: !0
        }), $de77e498e07914bf$var$p(t.onOpen) && t.onOpen((0, $7fPBF.isValidElement)(t.children) && t.children.props), ()=>{
            const t = d.current;
            $de77e498e07914bf$var$p(t.onClose) && t.onClose((0, $7fPBF.isValidElement)(t.children) && t.children.props);
        }), []), (0, $7fPBF.useEffect)(()=>(t.pauseOnFocusLoss && (document.hasFocus() || C(), window.addEventListener("focus", E), window.addEventListener("blur", C)), ()=>{
            t.pauseOnFocusLoss && (window.removeEventListener("focus", E), window.removeEventListener("blur", C));
        }), [
        t.pauseOnFocusLoss
    ]);
    const O = {
        onMouseDown: v,
        onTouchStart: v,
        onMouseUp: T,
        onTouchEnd: T
    };
    return m && f && (O.onMouseEnter = C, O.onMouseLeave = E), y && (O.onClick = (t)=>{
        h && h(t), u.canCloseOnClick && g();
    }), {
        playToast: E,
        pauseToast: C,
        isRunning: o,
        preventExitTransition: r,
        toastRef: c,
        eventHandlers: O
    };
}
function $de77e498e07914bf$var$L(e) {
    let { closeToast: n, theme: o, ariaLabel: s = "close" } = e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (t)=>{
            t.stopPropagation(), n(t);
        },
        "aria-label": s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $de77e498e07914bf$var$O(e) {
    let { delay: n, isRunning: o, closeToast: s, type: a = "default", hide: r, className: i, style: l, controlledProgress: u, progress: d, rtl: m, isIn: f, theme: g } = e;
    const h = r || u && 0 === d, y = {
        ...l,
        animationDuration: `${n}ms`,
        animationPlayState: o ? "running" : "paused",
        opacity: h ? 0 : 1
    };
    u && (y.transform = `scaleX(${d})`);
    const v = (0, $582255ee0585c19b$export$2e2bcd8739ae039)("Toastify__progress-bar", u ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${a}`, {
        "Toastify__progress-bar--rtl": m
    }), T = $de77e498e07914bf$var$p(i) ? i({
        rtl: m,
        type: a,
        defaultClassName: v
    }) : (0, $582255ee0585c19b$export$2e2bcd8739ae039)(v, i);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        role: "progressbar",
        "aria-hidden": h ? "true" : "false",
        "aria-label": "notification timer",
        className: T,
        style: y,
        [u && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: u && d < 1 ? null : ()=>{
            f && s();
        }
    });
}
const $de77e498e07914bf$var$N = (n)=>{
    const { isRunning: o, preventExitTransition: s, toastRef: r, eventHandlers: i } = $de77e498e07914bf$export$a407b657d3044108(n), { closeButton: l, children: u, autoClose: d, onClick: m, type: f, hideProgressBar: g, closeToast: h, transition: y, position: v, className: T, style: E, bodyClassName: C, bodyStyle: b, progressClassName: I, progressStyle: N, updateId: M, role: R, progress: w, rtl: x, toastId: $, deleteToast: k, isIn: P, isLoading: B, iconOut: D, closeOnClick: A, theme: z } = n, F = (0, $582255ee0585c19b$export$2e2bcd8739ae039)("Toastify__toast", `Toastify__toast-theme--${z}`, `Toastify__toast--${f}`, {
        "Toastify__toast--rtl": x
    }, {
        "Toastify__toast--close-on-click": A
    }), H = $de77e498e07914bf$var$p(T) ? T({
        rtl: x,
        position: v,
        type: f,
        defaultClassName: F
    }) : (0, $582255ee0585c19b$export$2e2bcd8739ae039)(F, T), S = !!w || !d, q = {
        closeToast: h,
        type: f,
        theme: z
    };
    let Q = null;
    return !1 === l || (Q = $de77e498e07914bf$var$p(l) ? l(q) : (0, $7fPBF.isValidElement)(l) ? (0, $7fPBF.cloneElement)(l, q) : $de77e498e07914bf$var$L(q)), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(y, {
        isIn: P,
        done: k,
        position: v,
        preventExitTransition: s,
        nodeRef: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        id: $,
        onClick: m,
        className: H,
        ...i,
        style: E,
        ref: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        ...P && {
            role: R
        },
        className: $de77e498e07914bf$var$p(C) ? C({
            type: f
        }) : (0, $582255ee0585c19b$export$2e2bcd8739ae039)("Toastify__toast-body", C),
        style: b
    }, null != D && (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: (0, $582255ee0585c19b$export$2e2bcd8739ae039)("Toastify__toast-icon", {
            "Toastify--animate-icon Toastify__zoom-enter": !B
        })
    }, D), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null, u)), Q, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($de77e498e07914bf$var$O, {
        ...M && !S ? {
            key: `pb-${M}`
        } : {},
        rtl: x,
        theme: z,
        delay: d,
        isRunning: o,
        isIn: P,
        closeToast: h,
        hide: g,
        type: f,
        style: N,
        className: I,
        controlledProgress: S,
        progress: w || 0
    })));
}, $de77e498e07914bf$var$M = function(t, e) {
    return void 0 === e && (e = !1), {
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: e
    };
}, $de77e498e07914bf$export$d20e79fdc3899e95 = $de77e498e07914bf$export$3ff7dc44d332d222($de77e498e07914bf$var$M("bounce", !0)), $de77e498e07914bf$export$d8dc01b5c85a37b9 = $de77e498e07914bf$export$3ff7dc44d332d222($de77e498e07914bf$var$M("slide", !0)), $de77e498e07914bf$export$65cfd44a2050f99 = $de77e498e07914bf$export$3ff7dc44d332d222($de77e498e07914bf$var$M("zoom")), $de77e498e07914bf$export$4d2fae537bd90431 = $de77e498e07914bf$export$3ff7dc44d332d222($de77e498e07914bf$var$M("flip")), $de77e498e07914bf$export$f2815235e76a62b9 = (0, $7fPBF.forwardRef)((e, n)=>{
    const { getToastToRender: o, containerRef: a, isToastActive: r } = $de77e498e07914bf$export$b262e13ca2dd2381(e), { className: i, style: l, rtl: u, containerId: d } = e;
    function f(t) {
        const e = (0, $582255ee0585c19b$export$2e2bcd8739ae039)("Toastify__toast-container", `Toastify__toast-container--${t}`, {
            "Toastify__toast-container--rtl": u
        });
        return $de77e498e07914bf$var$p(i) ? i({
            position: t,
            rtl: u,
            defaultClassName: e
        }) : (0, $582255ee0585c19b$export$2e2bcd8739ae039)(e, $de77e498e07914bf$var$m(i));
    }
    return (0, $7fPBF.useEffect)(()=>{
        n && (n.current = a.current);
    }, []), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        ref: a,
        className: "Toastify",
        id: d
    }, o((e, n)=>{
        const o = n.length ? {
            ...l
        } : {
            ...l,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: f(e),
            style: o,
            key: `container-${e}`
        }, n.map((e, o)=>{
            let { content: s, props: a } = e;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($de77e498e07914bf$var$N, {
                ...a,
                isIn: r(a.toastId),
                style: {
                    ...a.style,
                    "--nth": o + 1,
                    "--len": n.length
                },
                key: `toast-${a.key}`
            }, s);
        }));
    }));
});
$de77e498e07914bf$export$f2815235e76a62b9.displayName = "ToastContainer", $de77e498e07914bf$export$f2815235e76a62b9.defaultProps = {
    position: "top-right",
    transition: $de77e498e07914bf$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: $de77e498e07914bf$var$L,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    closeOnClick: !0,
    draggable: !0,
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light"
};
let $de77e498e07914bf$var$P, $de77e498e07914bf$var$B = new Map, $de77e498e07914bf$var$D = [], $de77e498e07914bf$var$A = 1;
function $de77e498e07914bf$var$z() {
    return "" + $de77e498e07914bf$var$A++;
}
function $de77e498e07914bf$var$F(t) {
    return t && ($de77e498e07914bf$var$d(t.toastId) || $de77e498e07914bf$var$u(t.toastId)) ? t.toastId : $de77e498e07914bf$var$z();
}
function $de77e498e07914bf$var$H(t, e) {
    return $de77e498e07914bf$var$B.size > 0 ? $de77e498e07914bf$var$v.emit(0, t, e) : $de77e498e07914bf$var$D.push({
        content: t,
        options: e
    }), e.toastId;
}
function $de77e498e07914bf$var$S(t, e) {
    return {
        ...e,
        type: e && e.type || t,
        toastId: $de77e498e07914bf$var$F(e)
    };
}
function $de77e498e07914bf$var$q(t) {
    return (e, n)=>$de77e498e07914bf$var$H(e, $de77e498e07914bf$var$S(t, n));
}
function $de77e498e07914bf$export$b410431fab84fa58(t, e) {
    return $de77e498e07914bf$var$H(t, $de77e498e07914bf$var$S("default", e));
}
$de77e498e07914bf$export$b410431fab84fa58.loading = (t, e)=>$de77e498e07914bf$var$H(t, $de77e498e07914bf$var$S("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...e
    })), $de77e498e07914bf$export$b410431fab84fa58.promise = function(t, e, n) {
    let o, { pending: s, error: a, success: r } = e;
    s && (o = $de77e498e07914bf$var$d(s) ? $de77e498e07914bf$export$b410431fab84fa58.loading(s, n) : $de77e498e07914bf$export$b410431fab84fa58.loading(s.render, {
        ...n,
        ...s
    }));
    const i = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, l = (t, e, s)=>{
        if (null == e) return void $de77e498e07914bf$export$b410431fab84fa58.dismiss(o);
        const a = {
            type: t,
            ...i,
            ...n,
            data: s
        }, r = $de77e498e07914bf$var$d(e) ? {
            render: e
        } : e;
        return o ? $de77e498e07914bf$export$b410431fab84fa58.update(o, {
            ...a,
            ...r
        }) : $de77e498e07914bf$export$b410431fab84fa58(r.render, {
            ...a,
            ...r
        }), s;
    }, c = $de77e498e07914bf$var$p(t) ? t() : t;
    return c.then((t)=>l("success", r, t)).catch((t)=>l("error", a, t)), c;
}, $de77e498e07914bf$export$b410431fab84fa58.success = $de77e498e07914bf$var$q("success"), $de77e498e07914bf$export$b410431fab84fa58.info = $de77e498e07914bf$var$q("info"), $de77e498e07914bf$export$b410431fab84fa58.error = $de77e498e07914bf$var$q("error"), $de77e498e07914bf$export$b410431fab84fa58.warning = $de77e498e07914bf$var$q("warning"), $de77e498e07914bf$export$b410431fab84fa58.warn = $de77e498e07914bf$export$b410431fab84fa58.warning, $de77e498e07914bf$export$b410431fab84fa58.dark = (t, e)=>$de77e498e07914bf$var$H(t, $de77e498e07914bf$var$S("default", {
        theme: "dark",
        ...e
    })), $de77e498e07914bf$export$b410431fab84fa58.dismiss = (t)=>{
    $de77e498e07914bf$var$B.size > 0 ? $de77e498e07914bf$var$v.emit(1, t) : $de77e498e07914bf$var$D = $de77e498e07914bf$var$D.filter((e)=>null != t && e.options.toastId !== t);
}, $de77e498e07914bf$export$b410431fab84fa58.clearWaitingQueue = function(t) {
    return void 0 === t && (t = {}), $de77e498e07914bf$var$v.emit(5, t);
}, $de77e498e07914bf$export$b410431fab84fa58.isActive = (t)=>{
    let e = !1;
    return $de77e498e07914bf$var$B.forEach((n)=>{
        n.isToastActive && n.isToastActive(t) && (e = !0);
    }), e;
}, $de77e498e07914bf$export$b410431fab84fa58.update = function(t, e) {
    void 0 === e && (e = {}), setTimeout(()=>{
        const n = function(t, e) {
            let { containerId: n } = e;
            const o = $de77e498e07914bf$var$B.get(n || $de77e498e07914bf$var$P);
            return o && o.getToast(t);
        }(t, e);
        if (n) {
            const { props: o, content: s } = n, a = {
                delay: 100,
                ...o,
                ...e,
                toastId: e.toastId || t,
                updateId: $de77e498e07914bf$var$z()
            };
            a.toastId !== t && (a.staleId = t);
            const r = a.render || s;
            delete a.render, $de77e498e07914bf$var$H(r, a);
        }
    }, 0);
}, $de77e498e07914bf$export$b410431fab84fa58.done = (t)=>{
    $de77e498e07914bf$export$b410431fab84fa58.update(t, {
        progress: 1
    });
}, $de77e498e07914bf$export$b410431fab84fa58.onChange = (t)=>($de77e498e07914bf$var$v.on(4, t), ()=>{
        $de77e498e07914bf$var$v.off(4, t);
    }), $de77e498e07914bf$export$b410431fab84fa58.POSITION = {
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right",
    TOP_CENTER: "top-center",
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
    BOTTOM_CENTER: "bottom-center"
}, $de77e498e07914bf$export$b410431fab84fa58.TYPE = {
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error",
    DEFAULT: "default"
}, $de77e498e07914bf$var$v.on(2, (t)=>{
    $de77e498e07914bf$var$P = t.containerId || t, $de77e498e07914bf$var$B.set($de77e498e07914bf$var$P, t), $de77e498e07914bf$var$D.forEach((t)=>{
        $de77e498e07914bf$var$v.emit(0, t.content, t.options);
    }), $de77e498e07914bf$var$D = [];
}).on(3, (t)=>{
    $de77e498e07914bf$var$B.delete(t.containerId || t), 0 === $de77e498e07914bf$var$B.size && $de77e498e07914bf$var$v.off(0).off(1).off(5);
});


var $d3accb062935cef9$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d3accb062935cef9$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $d3accb062935cef9$var$Form = function(_a) {
    var fields = _a.fields, onSubmit = _a.onSubmit, _b = _a.submitButtonText, submitButtonText = _b === void 0 ? "Submit" : _b, // Defaulting to "Submit"
    _c = _a.showCancelButton, // Defaulting to "Submit"
    showCancelButton = _c === void 0 ? false : _c, // Defaulting to false
    onCancel = _a.onCancel, extraBeforeForm = _a.extraBeforeForm, extraBeforeButtons = _a.extraBeforeButtons, extraAfterButtons = _a.extraAfterButtons;
    var hasSubmitted = (0, $7fPBF.useRef)(false);
    var fieldStates = fields.map(function(field) {
        var _a, _b;
        return (0, $b924d7e70fc8529e$export$bffbb9fe62ba8e71)((_a = field.validations) !== null && _a !== void 0 ? _a : {}, (_b = field.value) !== null && _b !== void 0 ? _b : "");
    });
    var handleSubmit = function() {
        return $d3accb062935cef9$var$__awaiter(void 0, void 0, void 0, function() {
            var allValid, formValues, _i, fieldStates_1, fieldState, index;
            return $d3accb062935cef9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        hasSubmitted.current = true;
                        allValid = true;
                        formValues = {};
                        for(_i = 0, fieldStates_1 = fieldStates; _i < fieldStates_1.length; _i++){
                            fieldState = fieldStates_1[_i];
                            index = fieldStates.indexOf(fieldState);
                            if (fieldState.validate()) allValid = false;
                            formValues[fields[index].name] = fieldState.value;
                        }
                        if (!allValid) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            onSubmit(formValues)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        (0, $de77e498e07914bf$export$b410431fab84fa58).info("Error(s) in form");
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var Field = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(function() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, fieldStates.map(function(fieldState, index) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                key: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7cfec887c27b8c9d$export$2e2bcd8739ae039), {
                config: fields[index],
                value: fieldState.value,
                error: fieldState.errors.length > 0 ? fieldState.errors[0] : undefined,
                setValue: function(value, name) {
                    var index = fieldStates.findIndex(function(_, idx) {
                        return fields[idx].name === name;
                    });
                    if (fieldStates[index]) {
                        fieldStates[index].setValue(value);
                        if (hasSubmitted.current) fieldStates[index].validateByValue(value);
                    }
                }
            }));
        }));
    }, [
        fieldStates
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        style: {
            width: "100%"
        }
    }, extraBeforeForm, Field, extraBeforeButtons, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $edb2ad7a7eb6ffb9$export$2e2bcd8739ae039), {
        variant: "contained",
        color: "primary",
        fullWidth: true,
        style: {
            marginTop: "2rem"
        },
        onClick: handleSubmit
    }, submitButtonText), showCancelButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
        onClick: onCancel
    }, "Cancel")), extraAfterButtons);
};
var $d3accb062935cef9$export$2e2bcd8739ae039 = $d3accb062935cef9$var$Form;






var $7fPBF = parcelRequire("7fPBF");

var $02d7d65f84f180ce$var$FormSkeletons = function(_a) {
    var number = _a.number, fieldHeights = _a.fieldHeights;
    var Elements = function() {
        var _a;
        var skElements = [];
        for(var i = 0; i < number; i++){
            var height = (_a = fieldHeights === null || fieldHeights === void 0 ? void 0 : fieldHeights[i]) !== null && _a !== void 0 ? _a : 50;
            skElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                key: i,
                style: {
                    marginBottom: "8px"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
                variant: "text",
                width: "100%",
                height: height,
                style: {
                    borderRadius: "25px",
                    transform: "scale(1, 1)"
                },
                animation: "wave"
            })));
        }
        skElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            key: number,
            style: {
                marginTop: "2rem"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
            key: number,
            variant: "rectangular",
            width: "100%",
            height: 40,
            style: {
                borderRadius: "25px",
                transform: "scale(1, 1)"
            },
            animation: "wave"
        })));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            style: {
                width: "100%"
            }
        }, skElements);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Elements, null);
};
var $02d7d65f84f180ce$export$2e2bcd8739ae039 = $02d7d65f84f180ce$var$FormSkeletons;




var $391db0dc72f5c1c4$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $391db0dc72f5c1c4$var$__assign = undefined && undefined.__assign || function() {
    $391db0dc72f5c1c4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $391db0dc72f5c1c4$var$__assign.apply(this, arguments);
};
var $391db0dc72f5c1c4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $391db0dc72f5c1c4$var$rotateAnimation = (0, $bpHMA.keyframes)($391db0dc72f5c1c4$var$templateObject_1 || ($391db0dc72f5c1c4$var$templateObject_1 = $391db0dc72f5c1c4$var$__makeTemplateObject([
    "\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"
], [
    "\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"
])));
var $391db0dc72f5c1c4$var$FormGrid = function(_a) {
    var doShowCardHeader = _a.doShowCardHeader, title = _a.title, loading = _a.loading, reloadFunc = _a.reloadFunc, props = $391db0dc72f5c1c4$var$__rest(_a, [
        "doShowCardHeader",
        "title",
        "loading",
        "reloadFunc"
    ]);
    var _b = (0, $7fPBF.useState)(false), isRotating = _b[0], setIsRotating = _b[1];
    var _c = (0, $7fPBF.useState)(0), formKey = _c[0], setFormKey = _c[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        setIsRotating(loading);
        if (formKey === 0 && !loading) setFormKey(Math.random());
    }, [
        loading
    ]);
    var MyCardHeader = function() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2bfceb6bd3ad6f45$export$2e2bcd8739ae039), {
            avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    alignItems: "center"
                }
            }, title),
            action: !reloadFunc ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    alignItems: "center"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
                onClick: reloadFunc,
                sx: {
                    animation: isRotating ? "".concat($391db0dc72f5c1c4$var$rotateAnimation, " 1s linear infinite") : "none"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($76b5567aeb1dd705$exports))), null)))
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $075f1be02379b00f$export$2e2bcd8739ae039), {
        variant: "outlined"
    }, doShowCardHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(MyCardHeader, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8bffaacbbee0c705$export$2e2bcd8739ae039), null, isRotating && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $02d7d65f84f180ce$export$2e2bcd8739ae039), {
        number: props.fields.length,
        fieldHeights: [
            50,
            50,
            50,
            500
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        style: {
            display: isRotating ? "none" : "block",
            width: "100%"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d3accb062935cef9$export$2e2bcd8739ae039), $391db0dc72f5c1c4$var$__assign({
        key: formKey
    }, props)))));
};
var $391db0dc72f5c1c4$export$2e2bcd8739ae039 = $391db0dc72f5c1c4$var$FormGrid;
var $391db0dc72f5c1c4$var$templateObject_1;




var $a416711bf93b5db7$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $a416711bf93b5db7$var$LogoStyled = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $2a1f02c275eba654$export$2e2bcd8739ae039))($a416711bf93b5db7$var$templateObject_1 || ($a416711bf93b5db7$var$templateObject_1 = $a416711bf93b5db7$var$__makeTemplateObject([
    "\n  align-self: flex-start;\n  margin: 1rem;\n"
], [
    "\n  align-self: flex-start;\n  margin: 1rem;\n"
])));
var $a416711bf93b5db7$export$2e2bcd8739ae039 = $a416711bf93b5db7$var$LogoStyled;
var $a416711bf93b5db7$var$templateObject_1;




var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $bpHMA = parcelRequire("bpHMA");
var $cxeT8 = parcelRequire("cxeT8");

var $b6UUh = parcelRequire("b6UUh");


var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $f2578a24ef24aa6e$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $k6RDS.default)("MuiLinearProgress", slot);
}
const $f2578a24ef24aa6e$var$linearProgressClasses = (0, $4jzsB.default)("MuiLinearProgress", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "determinate",
    "indeterminate",
    "buffer",
    "query",
    "dashed",
    "dashedColorPrimary",
    "dashedColorSecondary",
    "bar",
    "barColorPrimary",
    "barColorSecondary",
    "bar1Indeterminate",
    "bar1Determinate",
    "bar1Buffer",
    "bar2Indeterminate",
    "bar2Buffer"
]);
var $f2578a24ef24aa6e$export$2e2bcd8739ae039 = $f2578a24ef24aa6e$var$linearProgressClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
let $f118c00f3c44eea4$var$_ = (t)=>t, $f118c00f3c44eea4$var$t, $f118c00f3c44eea4$var$t1, $f118c00f3c44eea4$var$t2, $f118c00f3c44eea4$var$t3, $f118c00f3c44eea4$var$t4, $f118c00f3c44eea4$var$t5;
const $f118c00f3c44eea4$var$_excluded = [
    "className",
    "color",
    "value",
    "valueBuffer",
    "variant"
];
let $f118c00f3c44eea4$var$_1 = (t)=>t, $f118c00f3c44eea4$var$_t, $f118c00f3c44eea4$var$_t2, $f118c00f3c44eea4$var$_t3, $f118c00f3c44eea4$var$_t4, $f118c00f3c44eea4$var$_t5, $f118c00f3c44eea4$var$_t6;
const $f118c00f3c44eea4$var$TRANSITION_DURATION = 4; // seconds
const $f118c00f3c44eea4$var$indeterminate1Keyframe = (0, $bpHMA.keyframes)($f118c00f3c44eea4$var$_t || ($f118c00f3c44eea4$var$_t = $f118c00f3c44eea4$var$_1($f118c00f3c44eea4$var$t || ($f118c00f3c44eea4$var$t = $f118c00f3c44eea4$var$_`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`))));
const $f118c00f3c44eea4$var$indeterminate2Keyframe = (0, $bpHMA.keyframes)($f118c00f3c44eea4$var$_t2 || ($f118c00f3c44eea4$var$_t2 = $f118c00f3c44eea4$var$_1($f118c00f3c44eea4$var$t1 || ($f118c00f3c44eea4$var$t1 = $f118c00f3c44eea4$var$_`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`))));
const $f118c00f3c44eea4$var$bufferKeyframe = (0, $bpHMA.keyframes)($f118c00f3c44eea4$var$_t3 || ($f118c00f3c44eea4$var$_t3 = $f118c00f3c44eea4$var$_1($f118c00f3c44eea4$var$t2 || ($f118c00f3c44eea4$var$t2 = $f118c00f3c44eea4$var$_`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`))));
const $f118c00f3c44eea4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $b6UUh.default)(color)}`,
            variant
        ],
        dashed: [
            "dashed",
            `dashedColor${(0, $b6UUh.default)(color)}`
        ],
        bar1: [
            "bar",
            `barColor${(0, $b6UUh.default)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar1Indeterminate",
            variant === "determinate" && "bar1Determinate",
            variant === "buffer" && "bar1Buffer"
        ],
        bar2: [
            "bar",
            variant !== "buffer" && `barColor${(0, $b6UUh.default)(color)}`,
            variant === "buffer" && `color${(0, $b6UUh.default)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar2Indeterminate",
            variant === "buffer" && "bar2Buffer"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $f2578a24ef24aa6e$export$bc8a6ea1eb17d7c6), classes);
};
const $f118c00f3c44eea4$var$getColorShade = (theme, color)=>{
    if (color === "inherit") return "currentColor";
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === "light" ? (0, $cxeT8.lighten)(theme.palette[color].main, 0.62) : (0, $cxeT8.darken)(theme.palette[color].main, 0.5);
};
const $f118c00f3c44eea4$var$LinearProgressRoot = (0, $kDBhE.default)("span", {
    name: "MuiLinearProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $b6UUh.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        position: "relative",
        overflow: "hidden",
        display: "block",
        height: 4,
        zIndex: 0,
        // Fix Safari's bug during composition of different paint.
        "@media print": {
            colorAdjust: "exact"
        },
        backgroundColor: $f118c00f3c44eea4$var$getColorShade(theme, ownerState.color)
    }, ownerState.color === "inherit" && ownerState.variant !== "buffer" && {
        backgroundColor: "none",
        "&::before": {
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "currentColor",
            opacity: 0.3
        }
    }, ownerState.variant === "buffer" && {
        backgroundColor: "transparent"
    }, ownerState.variant === "query" && {
        transform: "rotate(180deg)"
    }));
const $f118c00f3c44eea4$var$LinearProgressDashed = (0, $kDBhE.default)("span", {
    name: "MuiLinearProgress",
    slot: "Dashed",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $b6UUh.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>{
    const backgroundColor = $f118c00f3c44eea4$var$getColorShade(theme, ownerState.color);
    return (0, $kY3Ke.default)({
        position: "absolute",
        marginTop: 0,
        height: "100%",
        width: "100%"
    }, ownerState.color === "inherit" && {
        opacity: 0.3
    }, {
        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
        backgroundSize: "10px 10px",
        backgroundPosition: "0 -23px"
    });
}, (0, $bpHMA.css)($f118c00f3c44eea4$var$_t4 || ($f118c00f3c44eea4$var$_t4 = $f118c00f3c44eea4$var$_1($f118c00f3c44eea4$var$t3 || ($f118c00f3c44eea4$var$t3 = $f118c00f3c44eea4$var$_`
    animation: ${0} 3s infinite linear;
  `), 0)), $f118c00f3c44eea4$var$bufferKeyframe));
const $f118c00f3c44eea4$var$LinearProgressBar1 = (0, $kDBhE.default)("span", {
    name: "MuiLinearProgress",
    slot: "Bar1",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $b6UUh.default)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar1Indeterminate,
            ownerState.variant === "determinate" && styles.bar1Determinate,
            ownerState.variant === "buffer" && styles.bar1Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left",
        backgroundColor: ownerState.color === "inherit" ? "currentColor" : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "determinate" && {
        transition: `transform .${$f118c00f3c44eea4$var$TRANSITION_DURATION}s linear`
    }, ownerState.variant === "buffer" && {
        zIndex: 1,
        transition: `transform .${$f118c00f3c44eea4$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === "indeterminate" || ownerState.variant === "query") && (0, $bpHMA.css)($f118c00f3c44eea4$var$_t5 || ($f118c00f3c44eea4$var$_t5 = $f118c00f3c44eea4$var$_1($f118c00f3c44eea4$var$t4 || ($f118c00f3c44eea4$var$t4 = $f118c00f3c44eea4$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), 0)), $f118c00f3c44eea4$var$indeterminate1Keyframe));
const $f118c00f3c44eea4$var$LinearProgressBar2 = (0, $kDBhE.default)("span", {
    name: "MuiLinearProgress",
    slot: "Bar2",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $b6UUh.default)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar2Indeterminate,
            ownerState.variant === "buffer" && styles.bar2Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left"
    }, ownerState.variant !== "buffer" && {
        backgroundColor: ownerState.color === "inherit" ? "currentColor" : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        opacity: 0.3
    }, ownerState.variant === "buffer" && {
        backgroundColor: $f118c00f3c44eea4$var$getColorShade(theme, ownerState.color),
        transition: `transform .${$f118c00f3c44eea4$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === "indeterminate" || ownerState.variant === "query") && (0, $bpHMA.css)($f118c00f3c44eea4$var$_t6 || ($f118c00f3c44eea4$var$_t6 = $f118c00f3c44eea4$var$_1($f118c00f3c44eea4$var$t5 || ($f118c00f3c44eea4$var$t5 = $f118c00f3c44eea4$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), 0)), $f118c00f3c44eea4$var$indeterminate2Keyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $f118c00f3c44eea4$var$LinearProgress = /*#__PURE__*/ $7fPBF.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiLinearProgress"
    });
    const { className: className, color: color = "primary", value: value, valueBuffer: valueBuffer, variant: variant = "indeterminate" } = props, other = (0, $cFLic.default)(props, $f118c00f3c44eea4$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        variant: variant
    });
    const classes = $f118c00f3c44eea4$var$useUtilityClasses(ownerState);
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === "determinate" || variant === "buffer") {
        if (value !== undefined) {
            rootProps["aria-valuenow"] = Math.round(value);
            rootProps["aria-valuemin"] = 0;
            rootProps["aria-valuemax"] = 100;
            let transform = value - 100;
            if (theme.direction === "rtl") transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === "buffer") {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (theme.direction === "rtl") transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($f118c00f3c44eea4$var$LinearProgressRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar"
    }, rootProps, {
        ref: ref
    }, other, {
        children: [
            variant === "buffer" ? /*#__PURE__*/ (0, $bbzbN.jsx)($f118c00f3c44eea4$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $bbzbN.jsx)($f118c00f3c44eea4$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === "determinate" ? null : /*#__PURE__*/ (0, $bbzbN.jsx)($f118c00f3c44eea4$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    }));
});
var $f118c00f3c44eea4$export$2e2bcd8739ae039 = $f118c00f3c44eea4$var$LinearProgress;


var $429e1b9333d17135$export$a3333cf4ee0f7f9c = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).div({
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.1)" // optional, if you want a slight overlay effect
});
var $429e1b9333d17135$export$d0ec8c45e742fc5f = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $76ada7aef489324c$export$2e2bcd8739ae039))({
    position: "fixed",
    top: "50%",
    left: "50%",
    width: "99vw",
    height: "99vh !important",
    transform: "translate(-50%, -50%)",
    zIndex: 9999 // or any value to ensure it's on top of other content
});
var $429e1b9333d17135$export$7ab73119e7428f59 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $f118c00f3c44eea4$export$2e2bcd8739ae039))({
    width: "60%",
    zIndex: 1 // to keep it above the skeleton
});



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $b6UUh = parcelRequire("b6UUh");


var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $8f7c5161bc7a509f$export$47a2da616e55e8e9(slot) {
    return (0, $k6RDS.default)("MuiAppBar", slot);
}
const $8f7c5161bc7a509f$var$appBarClasses = (0, $4jzsB.default)("MuiAppBar", [
    "root",
    "positionFixed",
    "positionAbsolute",
    "positionSticky",
    "positionStatic",
    "positionRelative",
    "colorDefault",
    "colorPrimary",
    "colorSecondary",
    "colorInherit",
    "colorTransparent",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning"
]);
var $8f7c5161bc7a509f$export$2e2bcd8739ae039 = $8f7c5161bc7a509f$var$appBarClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $5c04bc14285128b0$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $5c04bc14285128b0$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $b6UUh.default)(color)}`,
            `position${(0, $b6UUh.default)(position)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $8f7c5161bc7a509f$export$47a2da616e55e8e9), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $5c04bc14285128b0$var$joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(")", "")}, ${var2})` : var2;
const $5c04bc14285128b0$var$AppBarRoot = (0, $kDBhE.default)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: "MuiAppBar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $b6UUh.default)(ownerState.position)}`],
            styles[`color${(0, $b6UUh.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $kY3Ke.default)({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        boxSizing: "border-box",
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === "fixed" && {
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0,
        "@media print": {
            // Prevent the app bar to be visible on each printed page.
            position: "absolute"
        }
    }, ownerState.position === "absolute" && {
        position: "absolute",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "sticky" && {
        // ⚠️ sticky is not supported by IE11.
        position: "sticky",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "static" && {
        position: "static"
    }, ownerState.position === "relative" && {
        position: "relative"
    }, !theme.vars && (0, $kY3Ke.default)({}, ownerState.color === "default" && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== "default" && ownerState.color !== "inherit" && ownerState.color !== "transparent" && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, theme.palette.mode === "dark" && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === "transparent" && (0, $kY3Ke.default)({
        backgroundColor: "transparent",
        color: "inherit"
    }, theme.palette.mode === "dark" && {
        backgroundImage: "none"
    })), theme.vars && (0, $kY3Ke.default)({}, ownerState.color === "default" && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $5c04bc14285128b0$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $5c04bc14285128b0$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $5c04bc14285128b0$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $5c04bc14285128b0$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, {
        backgroundColor: "var(--AppBar-background)",
        color: ownerState.color === "inherit" ? "inherit" : "var(--AppBar-color)"
    }, ownerState.color === "transparent" && {
        backgroundImage: "none",
        backgroundColor: "transparent",
        color: "inherit"
    }));
});
const $5c04bc14285128b0$var$AppBar = /*#__PURE__*/ $7fPBF.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiAppBar"
    });
    const { className: className, color: color = "primary", enableColorOnDark: enableColorOnDark = false, position: position = "fixed" } = props, other = (0, $cFLic.default)(props, $5c04bc14285128b0$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $5c04bc14285128b0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($5c04bc14285128b0$var$AppBarRoot, (0, $kY3Ke.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $hngXp.default)(classes.root, className, position === "fixed" && "mui-fixed"),
        ref: ref
    }, other));
});
var $5c04bc14285128b0$export$2e2bcd8739ae039 = $5c04bc14285128b0$var$AppBar;




var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");


var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");









var $bbzbN = parcelRequire("bbzbN");
"use client";
const $a3f6f5762623b961$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "container",
    "direction",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $a3f6f5762623b961$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $6cb2f4180c9526e0$export$2e2bcd8739ae039)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue("-webkit-transform") || computedStyle.getPropertyValue("transform");
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== "none" && typeof transform === "string") {
        const transformValues = transform.split("(")[1].split(")")[0].split(",");
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === "left") {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === "right") {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === "up") {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $a3f6f5762623b961$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === "function" ? containerPropProp() : containerPropProp;
}
function $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $a3f6f5762623b961$var$resolveContainer(containerProp);
    const transform = $a3f6f5762623b961$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $a3f6f5762623b961$var$Slide = /*#__PURE__*/ $7fPBF.forwardRef(function Slide(props, ref) {
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = "down", easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $623678cbb6daf054$export$2e2bcd8739ae039) } = props, other = (0, $cFLic.default)(props, $a3f6f5762623b961$var$_excluded);
    const childrenRef = $7fPBF.useRef(null);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(children.ref, childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $1ae2edacd7be6319$export$b7a864e1eaef9de5)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", (0, $kY3Ke.default)({}, transitionProps));
        node.style.transition = theme.transitions.create("transform", (0, $kY3Ke.default)({}, transitionProps));
        node.style.webkitTransform = "none";
        node.style.transform = "none";
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", transitionProps);
        node.style.transition = theme.transitions.create("transform", transitionProps);
        $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = "";
        node.style.transition = "";
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $7fPBF.useCallback(()=>{
        if (childrenRef.current) $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $7fPBF.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === "down" || direction === "right") return undefined;
        const handleResize = (0, $3aadd01758bd49c1$export$2e2bcd8739ae039)(()=>{
            if (childrenRef.current) $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $6cb2f4180c9526e0$export$2e2bcd8739ae039)(childrenRef.current);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $7fPBF.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $7fPBF.cloneElement(children, (0, $kY3Ke.default)({
                ref: handleRef,
                style: (0, $kY3Ke.default)({
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, style, children.props.style)
            }, childProps));
        }
    }));
});
var $a3f6f5762623b961$export$2e2bcd8739ae039 = $a3f6f5762623b961$var$Slide;




var $b6UUh = parcelRequire("b6UUh");


var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $fb88ab4f6dbff241$export$b801318a856c9cd2(slot) {
    return (0, $k6RDS.default)("MuiDrawer", slot);
}
const $fb88ab4f6dbff241$var$drawerClasses = (0, $4jzsB.default)("MuiDrawer", [
    "root",
    "docked",
    "paper",
    "paperAnchorLeft",
    "paperAnchorRight",
    "paperAnchorTop",
    "paperAnchorBottom",
    "paperAnchorDockedLeft",
    "paperAnchorDockedRight",
    "paperAnchorDockedTop",
    "paperAnchorDockedBottom",
    "modal"
]);
var $fb88ab4f6dbff241$export$2e2bcd8739ae039 = $fb88ab4f6dbff241$var$drawerClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $fc202f2249b2dd6f$var$_excluded = [
    "BackdropProps"
], $fc202f2249b2dd6f$var$_excluded2 = [
    "anchor",
    "BackdropProps",
    "children",
    "className",
    "elevation",
    "hideBackdrop",
    "ModalProps",
    "onClose",
    "open",
    "PaperProps",
    "SlideProps",
    "TransitionComponent",
    "transitionDuration",
    "variant"
];
const $fc202f2249b2dd6f$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === "permanent" || ownerState.variant === "persistent") && styles.docked,
        styles.modal
    ];
};
const $fc202f2249b2dd6f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchor: anchor, variant: variant } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        docked: [
            (variant === "permanent" || variant === "persistent") && "docked"
        ],
        modal: [
            "modal"
        ],
        paper: [
            "paper",
            `paperAnchor${(0, $b6UUh.default)(anchor)}`,
            variant !== "temporary" && `paperAnchorDocked${(0, $b6UUh.default)(anchor)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $fb88ab4f6dbff241$export$b801318a856c9cd2), classes);
};
const $fc202f2249b2dd6f$var$DrawerRoot = (0, $kDBhE.default)((0, $a65b89a1133e1fe4$export$2e2bcd8739ae039), {
    name: "MuiDrawer",
    slot: "Root",
    overridesResolver: $fc202f2249b2dd6f$var$overridesResolver
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    }));
const $fc202f2249b2dd6f$var$DrawerDockedRoot = (0, $kDBhE.default)("div", {
    shouldForwardProp: (0, $kDBhE.rootShouldForwardProp),
    name: "MuiDrawer",
    slot: "Docked",
    skipVariantsResolver: false,
    overridesResolver: $fc202f2249b2dd6f$var$overridesResolver
})({
    flex: "0 0 auto"
});
const $fc202f2249b2dd6f$var$DrawerPaper = (0, $kDBhE.default)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: "MuiDrawer",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, $b6UUh.default)(ownerState.anchor)}`],
            ownerState.variant !== "temporary" && styles[`paperAnchorDocked${(0, $b6UUh.default)(ownerState.anchor)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        flex: "1 0 auto",
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        // temporary style
        position: "fixed",
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0
    }, ownerState.anchor === "left" && {
        left: 0
    }, ownerState.anchor === "top" && {
        top: 0,
        left: 0,
        right: 0,
        height: "auto",
        maxHeight: "100%"
    }, ownerState.anchor === "right" && {
        right: 0
    }, ownerState.anchor === "bottom" && {
        top: "auto",
        left: 0,
        bottom: 0,
        right: 0,
        height: "auto",
        maxHeight: "100%"
    }, ownerState.anchor === "left" && ownerState.variant !== "temporary" && {
        borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "top" && ownerState.variant !== "temporary" && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "right" && ownerState.variant !== "temporary" && {
        borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "bottom" && ownerState.variant !== "temporary" && {
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const $fc202f2249b2dd6f$var$oppositeDirection = {
    left: "right",
    right: "left",
    top: "down",
    bottom: "up"
};
function $fc202f2249b2dd6f$export$2a62b49acb270576(anchor) {
    return [
        "left",
        "right"
    ].indexOf(anchor) !== -1;
}
function $fc202f2249b2dd6f$export$830f4f08342d299e(theme, anchor) {
    return theme.direction === "rtl" && $fc202f2249b2dd6f$export$2a62b49acb270576(anchor) ? $fc202f2249b2dd6f$var$oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const $fc202f2249b2dd6f$var$Drawer = /*#__PURE__*/ $7fPBF.forwardRef(function Drawer(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiDrawer"
    });
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = "left", BackdropProps: BackdropProps, children: children, className: className, elevation: elevation = 16, hideBackdrop: hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp } = {}, onClose: onClose, open: open = false, PaperProps: PaperProps = {}, SlideProps: SlideProps, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $a3f6f5762623b961$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, variant: variant = "temporary" } = props, ModalProps = (0, $cFLic.default)(props.ModalProps, $fc202f2249b2dd6f$var$_excluded), other = (0, $cFLic.default)(props, $fc202f2249b2dd6f$var$_excluded2);
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = $7fPBF.useRef(false);
    $7fPBF.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = $fc202f2249b2dd6f$export$830f4f08342d299e(theme, anchorProp);
    const anchor = anchorProp;
    const ownerState = (0, $kY3Ke.default)({}, props, {
        anchor: anchor,
        elevation: elevation,
        open: open,
        variant: variant
    }, other);
    const classes = $fc202f2249b2dd6f$var$useUtilityClasses(ownerState);
    const drawer = /*#__PURE__*/ (0, $bbzbN.jsx)($fc202f2249b2dd6f$var$DrawerPaper, (0, $kY3Ke.default)({
        elevation: variant === "temporary" ? elevation : 0,
        square: true
    }, PaperProps, {
        className: (0, $hngXp.default)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        children: children
    }));
    if (variant === "permanent") return /*#__PURE__*/ (0, $bbzbN.jsx)($fc202f2249b2dd6f$var$DrawerDockedRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: drawer
    }));
    const slidingDrawer = /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        in: open,
        direction: $fc202f2249b2dd6f$var$oppositeDirection[anchorInvariant],
        timeout: transitionDuration,
        appear: mounted.current
    }, SlideProps, {
        children: drawer
    }));
    if (variant === "persistent") return /*#__PURE__*/ (0, $bbzbN.jsx)($fc202f2249b2dd6f$var$DrawerDockedRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: slidingDrawer
    }));
    // variant === temporary
    return /*#__PURE__*/ (0, $bbzbN.jsx)($fc202f2249b2dd6f$var$DrawerRoot, (0, $kY3Ke.default)({
        BackdropProps: (0, $kY3Ke.default)({}, BackdropProps, BackdropPropsProp, {
            transitionDuration: transitionDuration
        }),
        className: (0, $hngXp.default)(classes.root, classes.modal, className),
        open: open,
        ownerState: ownerState,
        onClose: onClose,
        hideBackdrop: hideBackdrop,
        ref: ref
    }, other, ModalProps, {
        children: slidingDrawer
    }));
});
var $fc202f2249b2dd6f$export$2e2bcd8739ae039 = $fc202f2249b2dd6f$var$Drawer;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $dc304ab6922390a3$export$b12cb262231eef32(slot) {
    return (0, $k6RDS.default)("MuiToolbar", slot);
}
const $dc304ab6922390a3$var$toolbarClasses = (0, $4jzsB.default)("MuiToolbar", [
    "root",
    "gutters",
    "regular",
    "dense"
]);
var $dc304ab6922390a3$export$2e2bcd8739ae039 = $dc304ab6922390a3$var$toolbarClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $4356b5696745688a$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $4356b5696745688a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            !disableGutters && "gutters",
            variant
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $dc304ab6922390a3$export$b12cb262231eef32), classes);
};
const $4356b5696745688a$var$ToolbarRoot = (0, $kDBhE.default)("div", {
    name: "MuiToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        position: "relative",
        display: "flex",
        alignItems: "center"
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === "dense" && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === "regular" && theme.mixins.toolbar);
const $4356b5696745688a$var$Toolbar = /*#__PURE__*/ $7fPBF.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiToolbar"
    });
    const { className: className, component: component = "div", disableGutters: disableGutters = false, variant: variant = "regular" } = props, other = (0, $cFLic.default)(props, $4356b5696745688a$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $4356b5696745688a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($4356b5696745688a$var$ToolbarRoot, (0, $kY3Ke.default)({
        as: component,
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $4356b5696745688a$export$2e2bcd8739ae039 = $4356b5696745688a$var$Toolbar;


var $e049be44ef4f8ddc$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $e049be44ef4f8ddc$export$a26b7944a460bc19 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $77ec199cefd4182a$export$2e2bcd8739ae039))($e049be44ef4f8ddc$var$templateObject_1 || ($e049be44ef4f8ddc$var$templateObject_1 = $e049be44ef4f8ddc$var$__makeTemplateObject([
    "\n  position: absolute !important;\n  width: 100%;\n"
], [
    "\n  position: absolute !important;\n  width: 100%;\n"
])));
var $e049be44ef4f8ddc$export$e1f54711bfda4290 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $5c04bc14285128b0$export$2e2bcd8739ae039))($e049be44ef4f8ddc$var$templateObject_2 || ($e049be44ef4f8ddc$var$templateObject_2 = $e049be44ef4f8ddc$var$__makeTemplateObject([
    "\n  background-color: transparent !important;\n  box-shadow: none !important;\n  //border-radius: 2px; // Increased radius\n  //z-index: 999;\n"
], [
    "\n  background-color: transparent !important;\n  box-shadow: none !important;\n  //border-radius: 2px; // Increased radius\n  //z-index: 999;\n"
])));
var $e049be44ef4f8ddc$export$f3f426abf36f8c0 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $4356b5696745688a$export$2e2bcd8739ae039))($e049be44ef4f8ddc$var$templateObject_3 || ($e049be44ef4f8ddc$var$templateObject_3 = $e049be44ef4f8ddc$var$__makeTemplateObject([
    "\n  background-color: #367fbb !important;\n  border-radius: 2px; // Increased radius\n  position: absolute !important;\n  width: calc(100vw - 23.3rem);\n  z-index: 999;\n  @media (max-width: 1023px) {\n    width: calc(100vw - 7rem);\n  }\n"
], [
    "\n  background-color: #367fbb !important;\n  border-radius: 2px; // Increased radius\n  position: absolute !important;\n  width: calc(100vw - 23.3rem);\n  z-index: 999;\n  @media (max-width: 1023px) {\n    width: calc(100vw - 7rem);\n  }\n"
])));
var $e049be44ef4f8ddc$export$7a49bdedb3cef1c4 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $fc202f2249b2dd6f$export$2e2bcd8739ae039))($e049be44ef4f8ddc$var$templateObject_4 || ($e049be44ef4f8ddc$var$templateObject_4 = $e049be44ef4f8ddc$var$__makeTemplateObject([
    "\n  width: 260px;\n  background-color: rgb(255, 255, 255);\n  box-shadow: rgba(47, 43, 61, 0.14) 0px 2px 6px 0px;\n  border-right: 0px solid;\n  outline: 0px;\n\n  & .MuiDrawer-paper {\n    width: 260px;\n    background-color: rgb(255, 255, 255);\n    border-right: 0px solid;\n    outline: 0px;\n  }\n"
], [
    "\n  width: 260px;\n  background-color: rgb(255, 255, 255);\n  box-shadow: rgba(47, 43, 61, 0.14) 0px 2px 6px 0px;\n  border-right: 0px solid;\n  outline: 0px;\n\n  & .MuiDrawer-paper {\n    width: 260px;\n    background-color: rgb(255, 255, 255);\n    border-right: 0px solid;\n    outline: 0px;\n  }\n"
])));
var $e049be44ef4f8ddc$var$templateObject_1, $e049be44ef4f8ddc$var$templateObject_2, $e049be44ef4f8ddc$var$templateObject_3, $e049be44ef4f8ddc$var$templateObject_4;





var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $iCiVn = parcelRequire("iCiVn");
var $cFCqu = parcelRequire("cFCqu");
var $k6RDS = parcelRequire("k6RDS");

var $9HPC7 = parcelRequire("9HPC7");


var $2G6xE = parcelRequire("2G6xE");

var $bbzbN = parcelRequire("bbzbN");
const $7fa748e340d672b7$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "fixed",
    "maxWidth",
    "classes"
];
const $7fa748e340d672b7$var$defaultTheme = (0, $2G6xE.default)();
const $7fa748e340d672b7$var$defaultCreateStyledComponent = (0, $81df530a7daa801f$export$2e2bcd8739ae039)("div", {
    name: "MuiContainer",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $iCiVn.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $7fa748e340d672b7$var$useThemePropsDefault = (inProps)=>(0, $9HPC7.default)({
        props: inProps,
        name: "MuiContainer",
        defaultTheme: $7fa748e340d672b7$var$defaultTheme
    });
const $7fa748e340d672b7$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $k6RDS.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            "root",
            maxWidth && `maxWidth${(0, $iCiVn.default)(String(maxWidth))}`,
            fixed && "fixed",
            disableGutters && "disableGutters"
        ]
    };
    return (0, $cFCqu.default)(slots, getContainerUtilityClass, classes);
};
function $7fa748e340d672b7$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $7fa748e340d672b7$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $7fa748e340d672b7$var$useThemePropsDefault, componentName: componentName = "MuiContainer" } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
            width: "100%",
            marginLeft: "auto",
            boxSizing: "border-box",
            marginRight: "auto",
            display: "block"
        }, !ownerState.disableGutters && {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up("sm")]: {
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3)
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, ownerState.maxWidth === "xs" && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up("xs")]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: Math.max(theme.breakpoints.values.xs, 444)
            }
        }, ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
        ownerState.maxWidth !== "xs" && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up(ownerState.maxWidth)]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
            }
        }));
    const Container = /*#__PURE__*/ $7fPBF.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = "div", disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = "lg" } = props, other = (0, $cFLic.default)(props, $7fa748e340d672b7$var$_excluded);
        const ownerState = (0, $kY3Ke.default)({}, props, {
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        });
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $7fa748e340d672b7$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $bbzbN.jsx)(ContainerRoot, (0, $kY3Ke.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $hngXp.default)(classes.root, className),
            ref: ref
        }, other)));
    });
    return Container;
}



var $b6UUh = parcelRequire("b6UUh");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");
"use client";
const $a224e7f09a1cd55c$var$Container = (0, $7fa748e340d672b7$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $kDBhE.default)("div", {
        name: "MuiContainer",
        slot: "Root",
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $b6UUh.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $5j2OD.default)({
            props: inProps,
            name: "MuiContainer"
        })
});
var $a224e7f09a1cd55c$export$2e2bcd8739ae039 = $a224e7f09a1cd55c$var$Container;


var $4703c608b586990e$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $4703c608b586990e$var$StyledPrivateContainer = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $a224e7f09a1cd55c$export$2e2bcd8739ae039))($4703c608b586990e$var$templateObject_1 || ($4703c608b586990e$var$templateObject_1 = $4703c608b586990e$var$__makeTemplateObject([
    "\n  max-width: 100% !important;\n  width: 100% !important;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  margin: 0 !important;\n  padding-left: 1.5rem !important;\n  padding-right: 1.5rem !important;\n  flex-grow: 1;\n  height: 100vh !important;\n  overflow: auto !important;\n"
], [
    "\n  max-width: 100% !important;\n  width: 100% !important;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  margin: 0 !important;\n  padding-left: 1.5rem !important;\n  padding-right: 1.5rem !important;\n  flex-grow: 1;\n  height: 100vh !important;\n  overflow: auto !important;\n"
])));
var $4703c608b586990e$export$2e2bcd8739ae039 = $4703c608b586990e$var$StyledPrivateContainer;
var $4703c608b586990e$var$templateObject_1;



var $533baf7da870110d$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $533baf7da870110d$export$547f7e6e23e64097 = (0, $4920bb85ed07bfd6$export$f0f03736edb61697)($533baf7da870110d$var$templateObject_1 || ($533baf7da870110d$var$templateObject_1 = $533baf7da870110d$var$__makeTemplateObject([
    "\n  body {  background-color: #fdfdfd;\n    font-size: 18px;\n    letter-spacing: -.1px;\n    font-family: 'Source Sans Pro,system-ui,-apple-system,BlinkMacSystemFont,Avenir Next,Avenir,Segoe UI,Lucida Grande,Helvetica Neue,Helvetica,Fira Sans,Roboto,Noto,Droid Sans,Cantarell,Oxygen,Ubuntu,Franklin Gothic Medium,Century Gothic,Liberation Sans,sans-serif',serif;\n\n    overflow: hidden;\n  }\n  html {\n    color: #44546a;\n    line-height: 1.56;\n  }\n"
], [
    "\n  body {  background-color: #fdfdfd;\n    font-size: 18px;\n    letter-spacing: -.1px;\n    font-family: 'Source Sans Pro,system-ui,-apple-system,BlinkMacSystemFont,Avenir Next,Avenir,Segoe UI,Lucida Grande,Helvetica Neue,Helvetica,Fira Sans,Roboto,Noto,Droid Sans,Cantarell,Oxygen,Ubuntu,Franklin Gothic Medium,Century Gothic,Liberation Sans,sans-serif',serif;\n\n    overflow: hidden;\n  }\n  html {\n    color: #44546a;\n    line-height: 1.56;\n  }\n"
])));
var $533baf7da870110d$export$d73fb1e26fe3246a = (0, $4920bb85ed07bfd6$export$f0f03736edb61697)($533baf7da870110d$var$templateObject_2 || ($533baf7da870110d$var$templateObject_2 = $533baf7da870110d$var$__makeTemplateObject([
    "\n  body {\n    background-color: #fdfdfd;\n    font-size: 18px;\n    letter-spacing: -.1px;\n    font-family: 'Source Sans Pro,system-ui,-apple-system,BlinkMacSystemFont,Avenir Next,Avenir,Segoe UI,Lucida Grande,Helvetica Neue,Helvetica,Fira Sans,Roboto,Noto,Droid Sans,Cantarell,Oxygen,Ubuntu,Franklin Gothic Medium,Century Gothic,Liberation Sans,sans-serif',serif;\n  }\n\n  html {\n    color: #44546a;\n    line-height: 1.56;\n  }\n"
], [
    "\n  body {\n    background-color: #fdfdfd;\n    font-size: 18px;\n    letter-spacing: -.1px;\n    font-family: 'Source Sans Pro,system-ui,-apple-system,BlinkMacSystemFont,Avenir Next,Avenir,Segoe UI,Lucida Grande,Helvetica Neue,Helvetica,Fira Sans,Roboto,Noto,Droid Sans,Cantarell,Oxygen,Ubuntu,Franklin Gothic Medium,Century Gothic,Liberation Sans,sans-serif',serif;\n  }\n\n  html {\n    color: #44546a;\n    line-height: 1.56;\n  }\n"
])));
var $533baf7da870110d$var$templateObject_1, $533baf7da870110d$var$templateObject_2;



var $6a8f348853d6c3c2$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $6a8f348853d6c3c2$var$MainContainer = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).div($6a8f348853d6c3c2$var$templateObject_1 || ($6a8f348853d6c3c2$var$templateObject_1 = $6a8f348853d6c3c2$var$__makeTemplateObject([
    "\n  display: flex; // Use flex to have child elements side by side\n  width: 100%; // Take the full width of its parent (ideally the viewport)\n"
], [
    "\n  display: flex; // Use flex to have child elements side by side\n  width: 100%; // Take the full width of its parent (ideally the viewport)\n"
])));
var $6a8f348853d6c3c2$export$2e2bcd8739ae039 = $6a8f348853d6c3c2$var$MainContainer;
var $6a8f348853d6c3c2$var$templateObject_1;




var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");


var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $833ef9b800b82ea7$export$f3b76d2cce458caa(slot) {
    return (0, $k6RDS.default)("MuiCard", slot);
}
const $833ef9b800b82ea7$var$cardClasses = (0, $4jzsB.default)("MuiCard", [
    "root"
]);
var $833ef9b800b82ea7$export$2e2bcd8739ae039 = $833ef9b800b82ea7$var$cardClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $bfb223886c302418$var$_excluded = [
    "className",
    "raised"
];
const $bfb223886c302418$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $833ef9b800b82ea7$export$f3b76d2cce458caa), classes);
};
const $bfb223886c302418$var$CardRoot = (0, $kDBhE.default)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: "MuiCard",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: "hidden"
    };
});
const $bfb223886c302418$var$Card = /*#__PURE__*/ $7fPBF.forwardRef(function Card(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiCard"
    });
    const { className: className, raised: raised = false } = props, other = (0, $cFLic.default)(props, $bfb223886c302418$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        raised: raised
    });
    const classes = $bfb223886c302418$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($bfb223886c302418$var$CardRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $bfb223886c302418$export$2e2bcd8739ae039 = $bfb223886c302418$var$Card;


var $075f1be02379b00f$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $075f1be02379b00f$var$StyledGridCard = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $bfb223886c302418$export$2e2bcd8739ae039))($075f1be02379b00f$var$templateObject_1 || ($075f1be02379b00f$var$templateObject_1 = $075f1be02379b00f$var$__makeTemplateObject([
    "\n  background-color: rgb(255, 255, 255);\n  color: rgba(47, 43, 61, 0.78);\n  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n\n  border-radius: 12px; // Increased radius\n\n  // Deeper shadow for 3D effect\n  box-shadow:\n    0px 3px 10px rgba(0, 0, 0, 0.15),\n    0px 3px 20px rgba(0, 0, 0, 0.1);\n\n  background-image: none;\n  border: 1px solid rgba(47, 43, 61, 0.16);\n"
], [
    "\n  background-color: rgb(255, 255, 255);\n  color: rgba(47, 43, 61, 0.78);\n  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n\n  border-radius: 12px; // Increased radius\n\n  // Deeper shadow for 3D effect\n  box-shadow:\n    0px 3px 10px rgba(0, 0, 0, 0.15),\n    0px 3px 20px rgba(0, 0, 0, 0.1);\n\n  background-image: none;\n  border: 1px solid rgba(47, 43, 61, 0.16);\n"
])));
var $075f1be02379b00f$export$2e2bcd8739ae039 = $075f1be02379b00f$var$StyledGridCard;
var $075f1be02379b00f$var$templateObject_1;




var $0d11cdf3888dcbb4$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $0d11cdf3888dcbb4$var$StyledLinkButton = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $45be1777d6a28263$export$2e2bcd8739ae039))($0d11cdf3888dcbb4$var$templateObject_1 || ($0d11cdf3888dcbb4$var$templateObject_1 = $0d11cdf3888dcbb4$var$__makeTemplateObject([
    "\n  && {\n    // && increases specificity, ensuring these styles take precedence\n    text-transform: none; // Removes uppercase transformation of text\n    color: blue;\n    background-color: transparent;\n    border: none;\n    padding: 0;\n    font-size: 1rem;\n    box-shadow: none;\n    text-decoration: underline;\n    &:hover {\n      background-color: transparent;\n      text-decoration: underline;\n    }\n  }\n"
], [
    "\n  && {\n    // && increases specificity, ensuring these styles take precedence\n    text-transform: none; // Removes uppercase transformation of text\n    color: blue;\n    background-color: transparent;\n    border: none;\n    padding: 0;\n    font-size: 1rem;\n    box-shadow: none;\n    text-decoration: underline;\n    &:hover {\n      background-color: transparent;\n      text-decoration: underline;\n    }\n  }\n"
])));
var $0d11cdf3888dcbb4$export$2e2bcd8739ae039 = $0d11cdf3888dcbb4$var$StyledLinkButton;
var $0d11cdf3888dcbb4$var$templateObject_1;


var $c74edd2b299b51db$exports = {};
"use strict";
/*
React-Quill
https://github.com/zenoamaro/react-quill
*/ var $c74edd2b299b51db$var$__extends = $c74edd2b299b51db$exports && $c74edd2b299b51db$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c74edd2b299b51db$var$__assign = $c74edd2b299b51db$exports && $c74edd2b299b51db$exports.__assign || function() {
    $c74edd2b299b51db$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c74edd2b299b51db$var$__assign.apply(this, arguments);
};
var $c74edd2b299b51db$var$__spreadArrays = $c74edd2b299b51db$exports && $c74edd2b299b51db$exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $c74edd2b299b51db$var$__importDefault = $c74edd2b299b51db$exports && $c74edd2b299b51db$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};

var $c74edd2b299b51db$var$react_1 = $c74edd2b299b51db$var$__importDefault((parcelRequire("7fPBF")));

var $c74edd2b299b51db$var$react_dom_1 = $c74edd2b299b51db$var$__importDefault((parcelRequire("fw0lo")));

var $c74edd2b299b51db$var$isEqual_1 = $c74edd2b299b51db$var$__importDefault((parcelRequire("hzZfF")));

var $c74edd2b299b51db$var$quill_1 = $c74edd2b299b51db$var$__importDefault((parcelRequire("gpR4L")));
var $c74edd2b299b51db$var$ReactQuill = /** @class */ function(_super) {
    $c74edd2b299b51db$var$__extends(ReactQuill, _super);
    function ReactQuill(props) {
        var _this = _super.call(this, props) || this;
        /*
        Changing one of these props should cause a full re-render and a
        re-instantiation of the Quill editor.
        */ _this.dirtyProps = [
            "modules",
            "formats",
            "bounds",
            "theme",
            "children"
        ];
        /*
        Changing one of these props should cause a regular update. These are mostly
        props that act on the container, rather than the quillized editing area.
        */ _this.cleanProps = [
            "id",
            "className",
            "style",
            "placeholder",
            "tabIndex",
            "onChange",
            "onChangeSelection",
            "onFocus",
            "onBlur",
            "onKeyPress",
            "onKeyDown",
            "onKeyUp"
        ];
        _this.state = {
            generation: 0
        };
        /*
        Tracks the internal selection of the Quill editor
        */ _this.selection = null;
        _this.onEditorChange = function(eventName, rangeOrDelta, oldRangeOrDelta, source) {
            var _a, _b, _c, _d;
            if (eventName === "text-change") (_b = (_a = _this).onEditorChangeText) === null || _b === void 0 || _b.call(_a, _this.editor.root.innerHTML, rangeOrDelta, source, _this.unprivilegedEditor);
            else if (eventName === "selection-change") (_d = (_c = _this).onEditorChangeSelection) === null || _d === void 0 || _d.call(_c, rangeOrDelta, source, _this.unprivilegedEditor);
        };
        var value = _this.isControlled() ? props.value : props.defaultValue;
        _this.value = value !== null && value !== void 0 ? value : "";
        return _this;
    }
    ReactQuill.prototype.validateProps = function(props) {
        var _a;
        if ($c74edd2b299b51db$var$react_1.default.Children.count(props.children) > 1) throw new Error("The Quill editing area can only be composed of a single React element.");
        if ($c74edd2b299b51db$var$react_1.default.Children.count(props.children)) {
            var child = $c74edd2b299b51db$var$react_1.default.Children.only(props.children);
            if (((_a = child) === null || _a === void 0 ? void 0 : _a.type) === "textarea") throw new Error("Quill does not support editing on a <textarea>. Use a <div> instead.");
        }
        if (this.lastDeltaChangeSet && props.value === this.lastDeltaChangeSet) throw new Error("You are passing the `delta` object from the `onChange` event back as `value`. You most probably want `editor.getContents()` instead. See: https://github.com/zenoamaro/react-quill#using-deltas");
    };
    ReactQuill.prototype.shouldComponentUpdate = function(nextProps, nextState) {
        var _this = this;
        var _a;
        this.validateProps(nextProps);
        // If the editor hasn't been instantiated yet, or the component has been
        // regenerated, we already know we should update.
        if (!this.editor || this.state.generation !== nextState.generation) return true;
        // Handle value changes in-place
        if ("value" in nextProps) {
            var prevContents = this.getEditorContents();
            var nextContents = (_a = nextProps.value, _a !== null && _a !== void 0 ? _a : "");
            // NOTE: Seeing that Quill is missing a way to prevent edits, we have to
            //       settle for a hybrid between controlled and uncontrolled mode. We
            //       can't prevent the change, but we'll still override content
            //       whenever `value` differs from current state.
            // NOTE: Comparing an HTML string and a Quill Delta will always trigger a
            //       change, regardless of whether they represent the same document.
            if (!this.isEqualValue(nextContents, prevContents)) this.setEditorContents(this.editor, nextContents);
        }
        // Handle read-only changes in-place
        if (nextProps.readOnly !== this.props.readOnly) this.setEditorReadOnly(this.editor, nextProps.readOnly);
        // Clean and Dirty props require a render
        return $c74edd2b299b51db$var$__spreadArrays(this.cleanProps, this.dirtyProps).some(function(prop) {
            return !$c74edd2b299b51db$var$isEqual_1.default(nextProps[prop], _this.props[prop]);
        });
    };
    ReactQuill.prototype.shouldComponentRegenerate = function(nextProps) {
        var _this = this;
        // Whenever a `dirtyProp` changes, the editor needs reinstantiation.
        return this.dirtyProps.some(function(prop) {
            return !$c74edd2b299b51db$var$isEqual_1.default(nextProps[prop], _this.props[prop]);
        });
    };
    ReactQuill.prototype.componentDidMount = function() {
        this.instantiateEditor();
        this.setEditorContents(this.editor, this.getEditorContents());
    };
    ReactQuill.prototype.componentWillUnmount = function() {
        this.destroyEditor();
    };
    ReactQuill.prototype.componentDidUpdate = function(prevProps, prevState) {
        var _this = this;
        // If we're changing one of the `dirtyProps`, the entire Quill Editor needs
        // to be re-instantiated. Regenerating the editor will cause the whole tree,
        // including the container, to be cleaned up and re-rendered from scratch.
        // Store the contents so they can be restored later.
        if (this.editor && this.shouldComponentRegenerate(prevProps)) {
            var delta = this.editor.getContents();
            var selection = this.editor.getSelection();
            this.regenerationSnapshot = {
                delta: delta,
                selection: selection
            };
            this.setState({
                generation: this.state.generation + 1
            });
            this.destroyEditor();
        }
        // The component has been regenerated, so it must be re-instantiated, and
        // its content must be restored to the previous values from the snapshot.
        if (this.state.generation !== prevState.generation) {
            var _a = this.regenerationSnapshot, delta = _a.delta, selection_1 = _a.selection;
            delete this.regenerationSnapshot;
            this.instantiateEditor();
            var editor_1 = this.editor;
            editor_1.setContents(delta);
            $c74edd2b299b51db$var$postpone(function() {
                return _this.setEditorSelection(editor_1, selection_1);
            });
        }
    };
    ReactQuill.prototype.instantiateEditor = function() {
        if (this.editor) this.hookEditor(this.editor);
        else this.editor = this.createEditor(this.getEditingArea(), this.getEditorConfig());
    };
    ReactQuill.prototype.destroyEditor = function() {
        if (!this.editor) return;
        this.unhookEditor(this.editor);
    };
    /*
    We consider the component to be controlled if `value` is being sent in props.
    */ ReactQuill.prototype.isControlled = function() {
        return "value" in this.props;
    };
    ReactQuill.prototype.getEditorConfig = function() {
        return {
            bounds: this.props.bounds,
            formats: this.props.formats,
            modules: this.props.modules,
            placeholder: this.props.placeholder,
            readOnly: this.props.readOnly,
            scrollingContainer: this.props.scrollingContainer,
            tabIndex: this.props.tabIndex,
            theme: this.props.theme
        };
    };
    ReactQuill.prototype.getEditor = function() {
        if (!this.editor) throw new Error("Accessing non-instantiated editor");
        return this.editor;
    };
    /**
    Creates an editor on the given element. The editor will be passed the
    configuration, have its events bound,
    */ ReactQuill.prototype.createEditor = function(element, config) {
        var editor = new $c74edd2b299b51db$var$quill_1.default(element, config);
        if (config.tabIndex != null) this.setEditorTabIndex(editor, config.tabIndex);
        this.hookEditor(editor);
        return editor;
    };
    ReactQuill.prototype.hookEditor = function(editor) {
        // Expose the editor on change events via a weaker, unprivileged proxy
        // object that does not allow accidentally modifying editor state.
        this.unprivilegedEditor = this.makeUnprivilegedEditor(editor);
        // Using `editor-change` allows picking up silent updates, like selection
        // changes on typing.
        editor.on("editor-change", this.onEditorChange);
    };
    ReactQuill.prototype.unhookEditor = function(editor) {
        editor.off("editor-change", this.onEditorChange);
    };
    ReactQuill.prototype.getEditorContents = function() {
        return this.value;
    };
    ReactQuill.prototype.getEditorSelection = function() {
        return this.selection;
    };
    /*
    True if the value is a Delta instance or a Delta look-alike.
    */ ReactQuill.prototype.isDelta = function(value) {
        return value && value.ops;
    };
    /*
    Special comparison function that knows how to compare Deltas.
    */ ReactQuill.prototype.isEqualValue = function(value, nextValue) {
        if (this.isDelta(value) && this.isDelta(nextValue)) return $c74edd2b299b51db$var$isEqual_1.default(value.ops, nextValue.ops);
        else return $c74edd2b299b51db$var$isEqual_1.default(value, nextValue);
    };
    /*
    Replace the contents of the editor, but keep the previous selection hanging
    around so that the cursor won't move.
    */ ReactQuill.prototype.setEditorContents = function(editor, value) {
        var _this = this;
        this.value = value;
        var sel = this.getEditorSelection();
        if (typeof value === "string") editor.setContents(editor.clipboard.convert(value));
        else editor.setContents(value);
        $c74edd2b299b51db$var$postpone(function() {
            return _this.setEditorSelection(editor, sel);
        });
    };
    ReactQuill.prototype.setEditorSelection = function(editor, range) {
        this.selection = range;
        if (range) {
            // Validate bounds before applying.
            var length_1 = editor.getLength();
            range.index = Math.max(0, Math.min(range.index, length_1 - 1));
            range.length = Math.max(0, Math.min(range.length, length_1 - 1 - range.index));
            editor.setSelection(range);
        }
    };
    ReactQuill.prototype.setEditorTabIndex = function(editor, tabIndex) {
        var _a, _b;
        if ((_b = (_a = editor) === null || _a === void 0 ? void 0 : _a.scroll) === null || _b === void 0 ? void 0 : _b.domNode) editor.scroll.domNode.tabIndex = tabIndex;
    };
    ReactQuill.prototype.setEditorReadOnly = function(editor, value) {
        if (value) editor.disable();
        else editor.enable();
    };
    /*
    Returns a weaker, unprivileged proxy object that only exposes read-only
    accessors found on the editor instance, without any state-modifying methods.
    */ ReactQuill.prototype.makeUnprivilegedEditor = function(editor) {
        var e = editor;
        return {
            getHTML: function() {
                return e.root.innerHTML;
            },
            getLength: e.getLength.bind(e),
            getText: e.getText.bind(e),
            getContents: e.getContents.bind(e),
            getSelection: e.getSelection.bind(e),
            getBounds: e.getBounds.bind(e)
        };
    };
    ReactQuill.prototype.getEditingArea = function() {
        if (!this.editingArea) throw new Error("Instantiating on missing editing area");
        var element = $c74edd2b299b51db$var$react_dom_1.default.findDOMNode(this.editingArea);
        if (!element) throw new Error("Cannot find element for editing area");
        if (element.nodeType === 3) throw new Error("Editing area cannot be a text node");
        return element;
    };
    /*
    Renders an editor area, unless it has been provided one to clone.
    */ ReactQuill.prototype.renderEditingArea = function() {
        var _this = this;
        var _a = this.props, children = _a.children, preserveWhitespace = _a.preserveWhitespace;
        var generation = this.state.generation;
        var properties = {
            key: generation,
            ref: function(instance) {
                _this.editingArea = instance;
            }
        };
        if ($c74edd2b299b51db$var$react_1.default.Children.count(children)) return $c74edd2b299b51db$var$react_1.default.cloneElement($c74edd2b299b51db$var$react_1.default.Children.only(children), properties);
        return preserveWhitespace ? $c74edd2b299b51db$var$react_1.default.createElement("pre", $c74edd2b299b51db$var$__assign({}, properties)) : $c74edd2b299b51db$var$react_1.default.createElement("div", $c74edd2b299b51db$var$__assign({}, properties));
    };
    ReactQuill.prototype.render = function() {
        var _a;
        return $c74edd2b299b51db$var$react_1.default.createElement("div", {
            id: this.props.id,
            style: this.props.style,
            key: this.state.generation,
            className: "quill " + (_a = this.props.className, _a !== null && _a !== void 0 ? _a : ""),
            onKeyPress: this.props.onKeyPress,
            onKeyDown: this.props.onKeyDown,
            onKeyUp: this.props.onKeyUp
        }, this.renderEditingArea());
    };
    ReactQuill.prototype.onEditorChangeText = function(value, delta, source, editor) {
        var _a, _b;
        if (!this.editor) return;
        // We keep storing the same type of value as what the user gives us,
        // so that value comparisons will be more stable and predictable.
        var nextContents = this.isDelta(this.value) ? editor.getContents() : editor.getHTML();
        if (nextContents !== this.getEditorContents()) {
            // Taint this `delta` object, so we can recognize whether the user
            // is trying to send it back as `value`, preventing a likely loop.
            this.lastDeltaChangeSet = delta;
            this.value = nextContents;
            (_b = (_a = this.props).onChange) === null || _b === void 0 || _b.call(_a, value, delta, source, editor);
        }
    };
    ReactQuill.prototype.onEditorChangeSelection = function(nextSelection, source, editor) {
        var _a, _b, _c, _d, _e, _f;
        if (!this.editor) return;
        var currentSelection = this.getEditorSelection();
        var hasGainedFocus = !currentSelection && nextSelection;
        var hasLostFocus = currentSelection && !nextSelection;
        if ($c74edd2b299b51db$var$isEqual_1.default(nextSelection, currentSelection)) return;
        this.selection = nextSelection;
        (_b = (_a = this.props).onChangeSelection) === null || _b === void 0 || _b.call(_a, nextSelection, source, editor);
        if (hasGainedFocus) (_d = (_c = this.props).onFocus) === null || _d === void 0 || _d.call(_c, nextSelection, source, editor);
        else if (hasLostFocus) (_f = (_e = this.props).onBlur) === null || _f === void 0 || _f.call(_e, currentSelection, source, editor);
    };
    ReactQuill.prototype.focus = function() {
        if (!this.editor) return;
        this.editor.focus();
    };
    ReactQuill.prototype.blur = function() {
        if (!this.editor) return;
        this.selection = null;
        this.editor.blur();
    };
    ReactQuill.displayName = "React Quill";
    /*
    Export Quill to be able to call `register`
    */ ReactQuill.Quill = $c74edd2b299b51db$var$quill_1.default;
    ReactQuill.defaultProps = {
        theme: "snow",
        modules: {},
        readOnly: false
    };
    return ReactQuill;
}($c74edd2b299b51db$var$react_1.default.Component);
/*
Small helper to execute a function in the next micro-tick.
*/ function $c74edd2b299b51db$var$postpone(fn) {
    Promise.resolve().then(fn);
}
$c74edd2b299b51db$exports = $c74edd2b299b51db$var$ReactQuill;



var $05020149fe4d10cd$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $05020149fe4d10cd$var$StyledReactQuill = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($c74edd2b299b51db$exports))))($05020149fe4d10cd$var$templateObject_1 || ($05020149fe4d10cd$var$templateObject_1 = $05020149fe4d10cd$var$__makeTemplateObject([
    "\n  margin-top: 16px;\n  margin-bottom: 8px;\n  .ql-container.ql-snow {\n    ",
    ";\n    border-bottom-left-radius: 16px;\n    border-bottom-right-radius: 16px;\n    height: 500px;\n    border-color: ",
    ";\n  }\n  .ql-toolbar.ql-snow {\n    ",
    ";\n    border-top-left-radius: 16px;\n    border-top-right-radius: 16px;\n    border-color: ",
    ";\n  }\n  .ql-tooltip.ql-editing {\n    left: 5px !important;\n  }\n"
], [
    "\n  margin-top: 16px;\n  margin-bottom: 8px;\n  .ql-container.ql-snow {\n    ",
    ";\n    border-bottom-left-radius: 16px;\n    border-bottom-right-radius: 16px;\n    height: 500px;\n    border-color: ",
    ";\n  }\n  .ql-toolbar.ql-snow {\n    ",
    ";\n    border-top-left-radius: 16px;\n    border-top-right-radius: 16px;\n    border-color: ",
    ";\n  }\n  .ql-tooltip.ql-editing {\n    left: 5px !important;\n  }\n"
])), function(props) {
    return props.isactive ? "border: 2px solid;" : "";
}, function(props) {
    return props.isactive ? "#367fbb" : "rgba(0, 0, 0, 0.23)";
}, function(props) {
    return props.isactive ? "border: 2px solid;" : "";
}, function(props) {
    return props.isactive ? "#367fbb" : "rgba(0, 0, 0, 0.23)";
});
var $05020149fe4d10cd$export$2e2bcd8739ae039 = $05020149fe4d10cd$var$StyledReactQuill;
var $05020149fe4d10cd$var$templateObject_1;



var $hmhHQ = parcelRequire("hmhHQ");
var $96974d1ebe256b25$var$StyledTheme = (0, $hmhHQ.default)({});
var $96974d1ebe256b25$export$2e2bcd8739ae039 = $96974d1ebe256b25$var$StyledTheme;



var $84c4a14bed3ab14b$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $84c4a14bed3ab14b$var$StyledEditorTextArea = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).textarea($84c4a14bed3ab14b$var$templateObject_1 || ($84c4a14bed3ab14b$var$templateObject_1 = $84c4a14bed3ab14b$var$__makeTemplateObject([
    "\n  margin-top: 16px;\n\n  margin-bottom: 8px;\n  ",
    ";\n  border-radius: 16px;\n  height: 500px;\n  width: 97.5%; // To take full width\n  padding: 10px; // Optional: To give some spacing inside\n  font-family: inherit; // To use the same font as the rest of the app\n  resize: none; // To prevent the user from resizing the textarea\n  border-color: ",
    ";\n"
], [
    "\n  margin-top: 16px;\n\n  margin-bottom: 8px;\n  ",
    ";\n  border-radius: 16px;\n  height: 500px;\n  width: 97.5%; // To take full width\n  padding: 10px; // Optional: To give some spacing inside\n  font-family: inherit; // To use the same font as the rest of the app\n  resize: none; // To prevent the user from resizing the textarea\n  border-color: ",
    ";\n"
])), function(props) {
    return props.isactive === "true" ? "border: 2px solid;" : "";
}, function(props) {
    return props.isactive === "true" ? "#367fbb" : "rgba(0, 0, 0, 0.23)";
});
var $84c4a14bed3ab14b$export$2e2bcd8739ae039 = $84c4a14bed3ab14b$var$StyledEditorTextArea;
var $84c4a14bed3ab14b$var$templateObject_1;




var $767547096e8203cd$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $767547096e8203cd$var$HeaderBurger = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $77ec199cefd4182a$export$2e2bcd8739ae039))($767547096e8203cd$var$templateObject_1 || ($767547096e8203cd$var$templateObject_1 = $767547096e8203cd$var$__makeTemplateObject([
    "\n  z-index: 16;\n  margin-right: 1.25rem;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n\n  @media (max-width: 720px) {\n    width: 7rem;\n  }\n"
], [
    "\n  z-index: 16;\n  margin-right: 1.25rem;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n\n  @media (max-width: 720px) {\n    width: 7rem;\n  }\n"
])));
var $767547096e8203cd$export$2e2bcd8739ae039 = $767547096e8203cd$var$HeaderBurger;
var $767547096e8203cd$var$templateObject_1;



var $7fd1c1b5e264e679$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $7fd1c1b5e264e679$var$HeaderLink = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).a($7fd1c1b5e264e679$var$templateObject_1 || ($7fd1c1b5e264e679$var$templateObject_1 = $7fd1c1b5e264e679$var$__makeTemplateObject([
    "\n  color: #406ab5;\n  text-decoration: none;\n  transition: color 0.15s ease;\n  background-color: transparent;\n  :focus {\n    outline: 5px solid rgba(43, 100, 147, 0.2);\n    outline-offset: 0;\n  }\n  :hover {\n    color: #305088;\n    text-decoration: underline;\n    cursor: pointer;\n  }\n"
], [
    "\n  color: #406ab5;\n  text-decoration: none;\n  transition: color 0.15s ease;\n  background-color: transparent;\n  :focus {\n    outline: 5px solid rgba(43, 100, 147, 0.2);\n    outline-offset: 0;\n  }\n  :hover {\n    color: #305088;\n    text-decoration: underline;\n    cursor: pointer;\n  }\n"
])));
var $7fd1c1b5e264e679$export$2e2bcd8739ae039 = $7fd1c1b5e264e679$var$HeaderLink;
var $7fd1c1b5e264e679$var$templateObject_1;




var $71f798123fa792a7$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $71f798123fa792a7$var$AppBarStyle = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $5c04bc14285128b0$export$2e2bcd8739ae039))($71f798123fa792a7$var$templateObject_1 || ($71f798123fa792a7$var$templateObject_1 = $71f798123fa792a7$var$__makeTemplateObject([
    "\n  background: transparent !important;\n  box-shadow: none !important;\n  margin: 0 !important;\n  padding: 0 !important;\n"
], [
    "\n  background: transparent !important;\n  box-shadow: none !important;\n  margin: 0 !important;\n  padding: 0 !important;\n"
])));
var $71f798123fa792a7$export$2e2bcd8739ae039 = $71f798123fa792a7$var$AppBarStyle;
var $71f798123fa792a7$var$templateObject_1;




var $f9b036cf55e12ab7$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $f9b036cf55e12ab7$var$ToolbarStyle = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $4356b5696745688a$export$2e2bcd8739ae039))($f9b036cf55e12ab7$var$templateObject_1 || ($f9b036cf55e12ab7$var$templateObject_1 = $f9b036cf55e12ab7$var$__makeTemplateObject([
    "\n  margin: 0 !important;\n  padding: 0 !important;\n  min-height: inherit;\n"
], [
    "\n  margin: 0 !important;\n  padding: 0 !important;\n  min-height: inherit;\n"
])));
var $f9b036cf55e12ab7$export$2e2bcd8739ae039 = $f9b036cf55e12ab7$var$ToolbarStyle;
var $f9b036cf55e12ab7$var$templateObject_1;




var $2ffdcffbab0cb7f8$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $2ffdcffbab0cb7f8$var$MenuLink = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039))($2ffdcffbab0cb7f8$var$templateObject_1 || ($2ffdcffbab0cb7f8$var$templateObject_1 = $2ffdcffbab0cb7f8$var$__makeTemplateObject([
    "\n  color: #fff;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n  cursor: pointer;\n  &:hover {\n    color: #ffd770;\n    text-decoration: none;\n    border-bottom: 0.1875rem solid #ffd770;\n    padding-bottom: 0;\n  }\n"
], [
    "\n  color: #fff;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n  cursor: pointer;\n  &:hover {\n    color: #ffd770;\n    text-decoration: none;\n    border-bottom: 0.1875rem solid #ffd770;\n    padding-bottom: 0;\n  }\n"
])));
var $2ffdcffbab0cb7f8$export$2e2bcd8739ae039 = $2ffdcffbab0cb7f8$var$MenuLink;
var $2ffdcffbab0cb7f8$var$templateObject_1;



var $eb03033f13ccf7ae$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $eb03033f13ccf7ae$var$LogoImageStyled = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).img($eb03033f13ccf7ae$var$templateObject_1 || ($eb03033f13ccf7ae$var$templateObject_1 = $eb03033f13ccf7ae$var$__makeTemplateObject([
    "\n  width: 9.375rem;\n  margin: 0;\n  max-width: 100%;\n  overflow-clip-margin: content-box;\n  overflow: clip;\n  border-style: none;\n"
], [
    "\n  width: 9.375rem;\n  margin: 0;\n  max-width: 100%;\n  overflow-clip-margin: content-box;\n  overflow: clip;\n  border-style: none;\n"
])));
var $eb03033f13ccf7ae$export$2e2bcd8739ae039 = $eb03033f13ccf7ae$var$LogoImageStyled;
var $eb03033f13ccf7ae$var$templateObject_1;





var $0dd52264ef4ab763$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $0dd52264ef4ab763$export$a06f1c675e846f6f = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).footer($0dd52264ef4ab763$var$templateObject_1 || ($0dd52264ef4ab763$var$templateObject_1 = $0dd52264ef4ab763$var$__makeTemplateObject([
    "\n  color: #bbc5ca;\n  background-color: #3c475e;\n  padding: 2.5rem;\n  font-size: 18px;\n"
], [
    "\n  color: #bbc5ca;\n  background-color: #3c475e;\n  padding: 2.5rem;\n  font-size: 18px;\n"
])));
var $0dd52264ef4ab763$export$b77809c590a7b2a1 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $77ec199cefd4182a$export$2e2bcd8739ae039))($0dd52264ef4ab763$var$templateObject_2 || ($0dd52264ef4ab763$var$templateObject_2 = $0dd52264ef4ab763$var$__makeTemplateObject([
    "\n  margin-bottom: 1.25rem;\n  display: flex;\n"
], [
    "\n  margin-bottom: 1.25rem;\n  display: flex;\n"
])));
var $0dd52264ef4ab763$export$29661101d42f8ad7 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $77ec199cefd4182a$export$2e2bcd8739ae039))($0dd52264ef4ab763$var$templateObject_3 || ($0dd52264ef4ab763$var$templateObject_3 = $0dd52264ef4ab763$var$__makeTemplateObject([
    "\n  flex-grow: 1;\n  border-bottom: 1px solid #fff3;\n"
], [
    "\n  flex-grow: 1;\n  border-bottom: 1px solid #fff3;\n"
])));
var $0dd52264ef4ab763$export$fca61eb8d64108cc = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039))($0dd52264ef4ab763$var$templateObject_4 || ($0dd52264ef4ab763$var$templateObject_4 = $0dd52264ef4ab763$var$__makeTemplateObject([
    "\n  margin-right: 2.5rem !important;\n  color: #bbc5ca;\n  text-decoration: none;\n  transition: color 0.15s ease;\n  cursor: pointer;\n  &:hover {\n    text-decoration: underline;\n  }\n"
], [
    "\n  margin-right: 2.5rem !important;\n  color: #bbc5ca;\n  text-decoration: none;\n  transition: color 0.15s ease;\n  cursor: pointer;\n  &:hover {\n    text-decoration: underline;\n  }\n"
])));
var $0dd52264ef4ab763$export$65c64c42ce748db0 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $77ec199cefd4182a$export$2e2bcd8739ae039))($0dd52264ef4ab763$var$templateObject_5 || ($0dd52264ef4ab763$var$templateObject_5 = $0dd52264ef4ab763$var$__makeTemplateObject([
    "\n  font-size: 14px;\n  opacity: 0.5;\n  margin-bottom: 0;\n"
], [
    "\n  font-size: 14px;\n  opacity: 0.5;\n  margin-bottom: 0;\n"
])));
var $0dd52264ef4ab763$var$templateObject_1, $0dd52264ef4ab763$var$templateObject_2, $0dd52264ef4ab763$var$templateObject_3, $0dd52264ef4ab763$var$templateObject_4, $0dd52264ef4ab763$var$templateObject_5;




var $c858e0b31b487591$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $c858e0b31b487591$var$Header = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $77ec199cefd4182a$export$2e2bcd8739ae039))($c858e0b31b487591$var$templateObject_1 || ($c858e0b31b487591$var$templateObject_1 = $c858e0b31b487591$var$__makeTemplateObject([
    "\n  background-color: #367fbb;\n  padding: 2.5rem 2.5rem 0;\n  @media (max-width: 720px) {\n    padding: 1.25rem 1.25rem 0;\n  }\n"
], [
    "\n  background-color: #367fbb;\n  padding: 2.5rem 2.5rem 0;\n  @media (max-width: 720px) {\n    padding: 1.25rem 1.25rem 0;\n  }\n"
])));
var $c858e0b31b487591$export$2e2bcd8739ae039 = $c858e0b31b487591$var$Header;
var $c858e0b31b487591$var$templateObject_1;




var $330e0167222bbfb2$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $330e0167222bbfb2$export$7cbae8a56cf36d2a = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $77ec199cefd4182a$export$2e2bcd8739ae039))($330e0167222bbfb2$var$templateObject_1 || ($330e0167222bbfb2$var$templateObject_1 = $330e0167222bbfb2$var$__makeTemplateObject([
    "\n  cursor: pointer;\n  border: solid 1px rgba(0, 0, 0, 0);\n  border-radius: 3px;\n  flex-shrink: 1;\n  padding: 1.25rem;\n  margin: 0 0.625rem;\n  text-align: center;\n  max-width: 15.625rem;\n  font-weight: 600;\n"
], [
    "\n  cursor: pointer;\n  border: solid 1px rgba(0, 0, 0, 0);\n  border-radius: 3px;\n  flex-shrink: 1;\n  padding: 1.25rem;\n  margin: 0 0.625rem;\n  text-align: center;\n  max-width: 15.625rem;\n  font-weight: 600;\n"
])));
var $330e0167222bbfb2$export$ae8703768ec16e8a = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).img($330e0167222bbfb2$var$templateObject_2 || ($330e0167222bbfb2$var$templateObject_2 = $330e0167222bbfb2$var$__makeTemplateObject([
    "\n  display: block;\n  border: 1px solid #bbc5ca;\n  margin: 0;\n  max-width: 100%;\n"
], [
    "\n  display: block;\n  border: 1px solid #bbc5ca;\n  margin: 0;\n  max-width: 100%;\n"
])));
var $330e0167222bbfb2$export$643523328257f345 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).span($330e0167222bbfb2$var$templateObject_3 || ($330e0167222bbfb2$var$templateObject_3 = $330e0167222bbfb2$var$__makeTemplateObject([
    "\n  white-space: nowrap;\n"
], [
    "\n  white-space: nowrap;\n"
])));
var $330e0167222bbfb2$export$76930ccd091205a8 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $77ec199cefd4182a$export$2e2bcd8739ae039))($330e0167222bbfb2$var$templateObject_4 || ($330e0167222bbfb2$var$templateObject_4 = $330e0167222bbfb2$var$__makeTemplateObject([
    "\n  cursor: pointer;\n  border: solid 1px #bbc5ca;\n  max-width: 25rem;\n  border-radius: 3px;\n  flex-shrink: 1;\n  padding: 1.25rem;\n  margin: 0 0;\n  text-align: center;\n  font-weight: 600;\n"
], [
    "\n  cursor: pointer;\n  border: solid 1px #bbc5ca;\n  max-width: 25rem;\n  border-radius: 3px;\n  flex-shrink: 1;\n  padding: 1.25rem;\n  margin: 0 0;\n  text-align: center;\n  font-weight: 600;\n"
])));
var $330e0167222bbfb2$export$d048b6aa73a37379 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).img($330e0167222bbfb2$var$templateObject_5 || ($330e0167222bbfb2$var$templateObject_5 = $330e0167222bbfb2$var$__makeTemplateObject([
    "\n  display: block;\n  border: 1px solid #bbc5ca;\n  margin: 0;\n  max-width: 100%;\n"
], [
    "\n  display: block;\n  border: 1px solid #bbc5ca;\n  margin: 0;\n  max-width: 100%;\n"
])));
var $330e0167222bbfb2$export$38acf89cb4e932a0 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).p($330e0167222bbfb2$var$templateObject_6 || ($330e0167222bbfb2$var$templateObject_6 = $330e0167222bbfb2$var$__makeTemplateObject([
    "\n  max-width: none !important;\n  margin: 0 0 1.25rem;\n"
], [
    "\n  max-width: none !important;\n  margin: 0 0 1.25rem;\n"
])));
var $330e0167222bbfb2$var$templateObject_1, $330e0167222bbfb2$var$templateObject_2, $330e0167222bbfb2$var$templateObject_3, $330e0167222bbfb2$var$templateObject_4, $330e0167222bbfb2$var$templateObject_5, $330e0167222bbfb2$var$templateObject_6;




var $e9512dd5d5a180fa$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $e9512dd5d5a180fa$var$StyledTypography = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039))($e9512dd5d5a180fa$var$templateObject_1 || ($e9512dd5d5a180fa$var$templateObject_1 = $e9512dd5d5a180fa$var$__makeTemplateObject([
    "\n  &.MuiTypography-h3 {\n    clear: both;\n    font-size: 36px;\n    font-weight: 600;\n    color: #2e374b;\n    text-align: center;\n    line-height: 1.2;\n    margin: 0 0 2.5rem;\n  }\n"
], [
    "\n  &.MuiTypography-h3 {\n    clear: both;\n    font-size: 36px;\n    font-weight: 600;\n    color: #2e374b;\n    text-align: center;\n    line-height: 1.2;\n    margin: 0 0 2.5rem;\n  }\n"
])));
var $e9512dd5d5a180fa$export$2e2bcd8739ae039 = $e9512dd5d5a180fa$var$StyledTypography;
var $e9512dd5d5a180fa$var$templateObject_1;




var $38b5ec1caf9c5093$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $38b5ec1caf9c5093$var$PageTitleTypography = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039))($38b5ec1caf9c5093$var$templateObject_1 || ($38b5ec1caf9c5093$var$templateObject_1 = $38b5ec1caf9c5093$var$__makeTemplateObject([
    "\n  font-size: 42px !important;\n  color: #fff !important;\n  text-shadow: 0 1px 2px rgba(68, 84, 106, 0.6) !important;\n  font-weight: 700 !important;\n  text-align: center !important;\n  line-height: 1.2 !important;\n  margin: 0 0 2.5rem !important;\n"
], [
    "\n  font-size: 42px !important;\n  color: #fff !important;\n  text-shadow: 0 1px 2px rgba(68, 84, 106, 0.6) !important;\n  font-weight: 700 !important;\n  text-align: center !important;\n  line-height: 1.2 !important;\n  margin: 0 0 2.5rem !important;\n"
])));
var $38b5ec1caf9c5093$export$2e2bcd8739ae039 = $38b5ec1caf9c5093$var$PageTitleTypography;
var $38b5ec1caf9c5093$var$templateObject_1;




var $69c87d542bb99a74$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $69c87d542bb99a74$var$PageHeaderTitleBox = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $77ec199cefd4182a$export$2e2bcd8739ae039))($69c87d542bb99a74$var$templateObject_1 || ($69c87d542bb99a74$var$templateObject_1 = $69c87d542bb99a74$var$__makeTemplateObject([
    "\n  color: #fff;\n  height: 9.9375rem;\n  padding: 1.25rem 0 0;\n  background: ",
    ";\n  background-size: auto 131px;\n"
], [
    "\n  color: #fff;\n  height: 9.9375rem;\n  padding: 1.25rem 0 0;\n  background: ",
    ";\n  background-size: auto 131px;\n"
])), function(_a) {
    var bgimage = _a.bgimage;
    return "#367fbb url(".concat(bgimage, ") repeat-x bottom");
});
var $69c87d542bb99a74$export$2e2bcd8739ae039 = $69c87d542bb99a74$var$PageHeaderTitleBox;
var $69c87d542bb99a74$var$templateObject_1;




var $65cb075c7aae556e$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $65cb075c7aae556e$var$PageContents = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $77ec199cefd4182a$export$2e2bcd8739ae039))($65cb075c7aae556e$var$templateObject_1 || ($65cb075c7aae556e$var$templateObject_1 = $65cb075c7aae556e$var$__makeTemplateObject([
    "\n  margin: 5rem 2.5rem;\n  font-size: 18px;\n  min-height: 50vh;\n  @media (max-width: 720px) {\n    margin: 2.5rem 0.625rem;\n  }\n"
], [
    "\n  margin: 5rem 2.5rem;\n  font-size: 18px;\n  min-height: 50vh;\n  @media (max-width: 720px) {\n    margin: 2.5rem 0.625rem;\n  }\n"
])));
var $65cb075c7aae556e$export$2e2bcd8739ae039 = $65cb075c7aae556e$var$PageContents;
var $65cb075c7aae556e$var$templateObject_1;







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $b054e3c0d18c20fe$var$extendStatics = function(d, b) {
    $b054e3c0d18c20fe$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $b054e3c0d18c20fe$var$extendStatics(d, b);
};
function $b054e3c0d18c20fe$export$a8ba968b8961cb8a(d, b) {
    $b054e3c0d18c20fe$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b054e3c0d18c20fe$export$18ce0697a983be9b = function() {
    $b054e3c0d18c20fe$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b054e3c0d18c20fe$export$18ce0697a983be9b.apply(this, arguments);
};
function $b054e3c0d18c20fe$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b054e3c0d18c20fe$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b054e3c0d18c20fe$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b054e3c0d18c20fe$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b054e3c0d18c20fe$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b054e3c0d18c20fe$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $b054e3c0d18c20fe$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $b054e3c0d18c20fe$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $b054e3c0d18c20fe$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b054e3c0d18c20fe$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b054e3c0d18c20fe$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b054e3c0d18c20fe$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b054e3c0d18c20fe$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b054e3c0d18c20fe$export$10c90e4f7922046c(v) {
    return this instanceof $b054e3c0d18c20fe$export$10c90e4f7922046c ? (this.v = v, this) : new $b054e3c0d18c20fe$export$10c90e4f7922046c(v);
}
function $b054e3c0d18c20fe$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b054e3c0d18c20fe$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b054e3c0d18c20fe$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b054e3c0d18c20fe$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $b054e3c0d18c20fe$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b054e3c0d18c20fe$export$19a8beecd37a4c45 === "function" ? $b054e3c0d18c20fe$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b054e3c0d18c20fe$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $b054e3c0d18c20fe$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $b054e3c0d18c20fe$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b054e3c0d18c20fe$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $b054e3c0d18c20fe$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $f267bd63d0d39d9d$export$eeb013770cb92342;
(function(CognitoHostedUIIdentityProvider) {
    CognitoHostedUIIdentityProvider["Cognito"] = "COGNITO";
    CognitoHostedUIIdentityProvider["Google"] = "Google";
    CognitoHostedUIIdentityProvider["Facebook"] = "Facebook";
    CognitoHostedUIIdentityProvider["Amazon"] = "LoginWithAmazon";
    CognitoHostedUIIdentityProvider["Apple"] = "SignInWithApple";
})($f267bd63d0d39d9d$export$eeb013770cb92342 || ($f267bd63d0d39d9d$export$eeb013770cb92342 = {}));
function $f267bd63d0d39d9d$export$9b905d6895bdc426(obj) {
    var keys = [
        "provider"
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $f267bd63d0d39d9d$export$828f8efbdf71714b(obj) {
    var keys = [
        "customProvider"
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $f267bd63d0d39d9d$export$6bae5520ca265d22(obj) {
    var keys = [
        "customState"
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $f267bd63d0d39d9d$export$b380f8ec78ef17c8(oauth) {
    return oauth.redirectSignIn !== undefined;
}
var $f267bd63d0d39d9d$export$edb367c0a140d3db;
(function(AuthErrorTypes) {
    AuthErrorTypes["NoConfig"] = "noConfig";
    AuthErrorTypes["MissingAuthConfig"] = "missingAuthConfig";
    AuthErrorTypes["EmptyUsername"] = "emptyUsername";
    AuthErrorTypes["InvalidUsername"] = "invalidUsername";
    AuthErrorTypes["EmptyPassword"] = "emptyPassword";
    AuthErrorTypes["EmptyCode"] = "emptyCode";
    AuthErrorTypes["SignUpError"] = "signUpError";
    AuthErrorTypes["NoMFA"] = "noMFA";
    AuthErrorTypes["InvalidMFA"] = "invalidMFA";
    AuthErrorTypes["EmptyChallengeResponse"] = "emptyChallengeResponse";
    AuthErrorTypes["NoUserSession"] = "noUserSession";
    AuthErrorTypes["Default"] = "default";
    AuthErrorTypes["DeviceConfig"] = "deviceConfig";
    AuthErrorTypes["NetworkError"] = "networkError";
    AuthErrorTypes["AutoSignInError"] = "autoSignInError";
})($f267bd63d0d39d9d$export$edb367c0a140d3db || ($f267bd63d0d39d9d$export$edb367c0a140d3db = {}));
function $f267bd63d0d39d9d$export$ad34f09783c4cb16(obj) {
    return !!obj.username;
}
var $f267bd63d0d39d9d$export$cfce9c15015bef96;
(function(GRAPHQL_AUTH_MODE) {
    GRAPHQL_AUTH_MODE["API_KEY"] = "API_KEY";
    GRAPHQL_AUTH_MODE["AWS_IAM"] = "AWS_IAM";
    GRAPHQL_AUTH_MODE["OPENID_CONNECT"] = "OPENID_CONNECT";
    GRAPHQL_AUTH_MODE["AMAZON_COGNITO_USER_POOLS"] = "AMAZON_COGNITO_USER_POOLS";
    GRAPHQL_AUTH_MODE["AWS_LAMBDA"] = "AWS_LAMBDA";
})($f267bd63d0d39d9d$export$cfce9c15015bef96 || ($f267bd63d0d39d9d$export$cfce9c15015bef96 = {}));



/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $5578ec1dc18d671c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationDetails object
   * @param {object=} data Creation options.
   * @param {string} data.Username User being authenticated.
   * @param {string} data.Password Plain-text password to authenticate with.
   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
   * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
   */ function AuthenticationDetails(data) {
        var _ref = data || {}, ValidationData = _ref.ValidationData, Username = _ref.Username, Password = _ref.Password, AuthParameters = _ref.AuthParameters, ClientMetadata = _ref.ClientMetadata;
        this.validationData = ValidationData || {};
        this.authParameters = AuthParameters || {};
        this.clientMetadata = ClientMetadata || {};
        this.username = Username;
        this.password = Password;
    }
    /**
   * @returns {string} the record's username
   */ var _proto = AuthenticationDetails.prototype;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {string} the record's password
   */ ;
    _proto.getPassword = function getPassword() {
        return this.password;
    } /**
   * @returns {Array} the record's validationData
   */ ;
    _proto.getValidationData = function getValidationData() {
        return this.validationData;
    } /**
   * @returns {Array} the record's authParameters
   */ ;
    _proto.getAuthParameters = function getAuthParameters() {
        return this.authParameters;
    } /**
   * @returns {ClientMetadata} the clientMetadata for a Lambda trigger
   */ ;
    _proto.getClientMetadata = function getClientMetadata() {
        return this.clientMetadata;
    };
    return AuthenticationDetails;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $411d94524a9cdc1d$export$a143d493d941bafc;
var $411d94524a9cdc1d$export$e4cf37d7f6fb9e0a;
var $411d94524a9cdc1d$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $411d94524a9cdc1d$export$599f31c3813fae4d;
"use strict";

var $3nocJ = parcelRequire("3nocJ");

var $gU9iR = parcelRequire("gU9iR");
var $801d26aa62c45839$exports = {};
var $801d26aa62c45839$var$toString = {}.toString;
$801d26aa62c45839$exports = Array.isArray || function(arr) {
    return $801d26aa62c45839$var$toString.call(arr) == "[object Array]";
};


$411d94524a9cdc1d$export$a143d493d941bafc = $411d94524a9cdc1d$var$Buffer;
$411d94524a9cdc1d$export$e4cf37d7f6fb9e0a = $411d94524a9cdc1d$var$SlowBuffer;
$411d94524a9cdc1d$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $411d94524a9cdc1d$var$typedArraySupport();
$411d94524a9cdc1d$export$599f31c3813fae4d = $411d94524a9cdc1d$var$kMaxLength();
function $411d94524a9cdc1d$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $411d94524a9cdc1d$var$kMaxLength() {
    return $411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $411d94524a9cdc1d$var$createBuffer(that, length) {
    if ($411d94524a9cdc1d$var$kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $411d94524a9cdc1d$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $411d94524a9cdc1d$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $411d94524a9cdc1d$var$Buffer(arg, encodingOrOffset, length) {
    if (!$411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $411d94524a9cdc1d$var$Buffer)) return new $411d94524a9cdc1d$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return $411d94524a9cdc1d$var$allocUnsafe(this, arg);
    }
    return $411d94524a9cdc1d$var$from(this, arg, encodingOrOffset, length);
}
$411d94524a9cdc1d$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$411d94524a9cdc1d$var$Buffer._augment = function(arr) {
    arr.__proto__ = $411d94524a9cdc1d$var$Buffer.prototype;
    return arr;
};
function $411d94524a9cdc1d$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return $411d94524a9cdc1d$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return $411d94524a9cdc1d$var$fromString(that, value, encodingOrOffset);
    return $411d94524a9cdc1d$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $411d94524a9cdc1d$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $411d94524a9cdc1d$var$from(null, value, encodingOrOffset, length);
};
if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $411d94524a9cdc1d$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $411d94524a9cdc1d$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && $411d94524a9cdc1d$var$Buffer[Symbol.species] === $411d94524a9cdc1d$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($411d94524a9cdc1d$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $411d94524a9cdc1d$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $411d94524a9cdc1d$var$alloc(that, size, fill, encoding) {
    $411d94524a9cdc1d$var$assertSize(size);
    if (size <= 0) return $411d94524a9cdc1d$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? $411d94524a9cdc1d$var$createBuffer(that, size).fill(fill, encoding) : $411d94524a9cdc1d$var$createBuffer(that, size).fill(fill);
    return $411d94524a9cdc1d$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $411d94524a9cdc1d$var$Buffer.alloc = function(size, fill, encoding) {
    return $411d94524a9cdc1d$var$alloc(null, size, fill, encoding);
};
function $411d94524a9cdc1d$var$allocUnsafe(that, size) {
    $411d94524a9cdc1d$var$assertSize(size);
    that = $411d94524a9cdc1d$var$createBuffer(that, size < 0 ? 0 : $411d94524a9cdc1d$var$checked(size) | 0);
    if (!$411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $411d94524a9cdc1d$var$Buffer.allocUnsafe = function(size) {
    return $411d94524a9cdc1d$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $411d94524a9cdc1d$var$Buffer.allocUnsafeSlow = function(size) {
    return $411d94524a9cdc1d$var$allocUnsafe(null, size);
};
function $411d94524a9cdc1d$var$fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$411d94524a9cdc1d$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $411d94524a9cdc1d$var$byteLength(string, encoding) | 0;
    that = $411d94524a9cdc1d$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $411d94524a9cdc1d$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $411d94524a9cdc1d$var$checked(array.length) | 0;
    that = $411d94524a9cdc1d$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $411d94524a9cdc1d$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $411d94524a9cdc1d$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $411d94524a9cdc1d$var$fromArrayLike(that, array);
    return that;
}
function $411d94524a9cdc1d$var$fromObject(that, obj) {
    if ($411d94524a9cdc1d$var$Buffer.isBuffer(obj)) {
        var len = $411d94524a9cdc1d$var$checked(obj.length) | 0;
        that = $411d94524a9cdc1d$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || $411d94524a9cdc1d$var$isnan(obj.length)) return $411d94524a9cdc1d$var$createBuffer(that, 0);
            return $411d94524a9cdc1d$var$fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && $801d26aa62c45839$exports(obj.data)) return $411d94524a9cdc1d$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function $411d94524a9cdc1d$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $411d94524a9cdc1d$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $411d94524a9cdc1d$var$kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function $411d94524a9cdc1d$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $411d94524a9cdc1d$var$Buffer.alloc(+length);
}
$411d94524a9cdc1d$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$411d94524a9cdc1d$var$Buffer.compare = function compare(a, b) {
    if (!$411d94524a9cdc1d$var$Buffer.isBuffer(a) || !$411d94524a9cdc1d$var$Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$411d94524a9cdc1d$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$411d94524a9cdc1d$var$Buffer.concat = function concat(list, length) {
    if (!$801d26aa62c45839$exports(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $411d94524a9cdc1d$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $411d94524a9cdc1d$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$411d94524a9cdc1d$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $411d94524a9cdc1d$var$byteLength(string, encoding) {
    if ($411d94524a9cdc1d$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return $411d94524a9cdc1d$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $411d94524a9cdc1d$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $411d94524a9cdc1d$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$411d94524a9cdc1d$var$Buffer.byteLength = $411d94524a9cdc1d$var$byteLength;
function $411d94524a9cdc1d$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $411d94524a9cdc1d$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $411d94524a9cdc1d$var$utf8Slice(this, start, end);
        case "ascii":
            return $411d94524a9cdc1d$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $411d94524a9cdc1d$var$latin1Slice(this, start, end);
        case "base64":
            return $411d94524a9cdc1d$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $411d94524a9cdc1d$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$411d94524a9cdc1d$var$Buffer.prototype._isBuffer = true;
function $411d94524a9cdc1d$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$411d94524a9cdc1d$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$411d94524a9cdc1d$var$swap(this, i, i + 1);
    return this;
};
$411d94524a9cdc1d$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $411d94524a9cdc1d$var$swap(this, i, i + 3);
        $411d94524a9cdc1d$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$411d94524a9cdc1d$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $411d94524a9cdc1d$var$swap(this, i, i + 7);
        $411d94524a9cdc1d$var$swap(this, i + 1, i + 6);
        $411d94524a9cdc1d$var$swap(this, i + 2, i + 5);
        $411d94524a9cdc1d$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$411d94524a9cdc1d$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return $411d94524a9cdc1d$var$utf8Slice(this, 0, length);
    return $411d94524a9cdc1d$var$slowToString.apply(this, arguments);
};
$411d94524a9cdc1d$var$Buffer.prototype.equals = function equals(b) {
    if (!$411d94524a9cdc1d$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $411d94524a9cdc1d$var$Buffer.compare(this, b) === 0;
};
$411d94524a9cdc1d$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $411d94524a9cdc1d$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
$411d94524a9cdc1d$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$411d94524a9cdc1d$var$Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $411d94524a9cdc1d$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $411d94524a9cdc1d$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($411d94524a9cdc1d$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $411d94524a9cdc1d$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $411d94524a9cdc1d$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $411d94524a9cdc1d$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$411d94524a9cdc1d$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$411d94524a9cdc1d$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $411d94524a9cdc1d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$411d94524a9cdc1d$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $411d94524a9cdc1d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $411d94524a9cdc1d$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $411d94524a9cdc1d$var$utf8Write(buf, string, offset, length) {
    return $411d94524a9cdc1d$var$blitBuffer($411d94524a9cdc1d$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $411d94524a9cdc1d$var$asciiWrite(buf, string, offset, length) {
    return $411d94524a9cdc1d$var$blitBuffer($411d94524a9cdc1d$var$asciiToBytes(string), buf, offset, length);
}
function $411d94524a9cdc1d$var$latin1Write(buf, string, offset, length) {
    return $411d94524a9cdc1d$var$asciiWrite(buf, string, offset, length);
}
function $411d94524a9cdc1d$var$base64Write(buf, string, offset, length) {
    return $411d94524a9cdc1d$var$blitBuffer($411d94524a9cdc1d$var$base64ToBytes(string), buf, offset, length);
}
function $411d94524a9cdc1d$var$ucs2Write(buf, string, offset, length) {
    return $411d94524a9cdc1d$var$blitBuffer($411d94524a9cdc1d$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$411d94524a9cdc1d$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $411d94524a9cdc1d$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $411d94524a9cdc1d$var$utf8Write(this, string, offset, length);
        case "ascii":
            return $411d94524a9cdc1d$var$asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return $411d94524a9cdc1d$var$latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $411d94524a9cdc1d$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $411d94524a9cdc1d$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$411d94524a9cdc1d$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $411d94524a9cdc1d$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3nocJ.fromByteArray(buf);
    else return $3nocJ.fromByteArray(buf.slice(start, end));
}
function $411d94524a9cdc1d$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $411d94524a9cdc1d$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $411d94524a9cdc1d$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $411d94524a9cdc1d$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $411d94524a9cdc1d$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $411d94524a9cdc1d$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $411d94524a9cdc1d$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $411d94524a9cdc1d$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $411d94524a9cdc1d$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $411d94524a9cdc1d$var$toHex(buf[i]);
    return out;
}
function $411d94524a9cdc1d$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$411d94524a9cdc1d$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $411d94524a9cdc1d$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $411d94524a9cdc1d$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $411d94524a9cdc1d$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$411d94524a9cdc1d$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$411d94524a9cdc1d$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$411d94524a9cdc1d$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$411d94524a9cdc1d$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$411d94524a9cdc1d$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$411d94524a9cdc1d$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$411d94524a9cdc1d$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$411d94524a9cdc1d$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$411d94524a9cdc1d$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$411d94524a9cdc1d$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$411d94524a9cdc1d$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$411d94524a9cdc1d$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$411d94524a9cdc1d$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$411d94524a9cdc1d$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$411d94524a9cdc1d$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, true, 23, 4);
};
$411d94524a9cdc1d$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, false, 23, 4);
};
$411d94524a9cdc1d$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, true, 52, 8);
};
$411d94524a9cdc1d$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, false, 52, 8);
};
function $411d94524a9cdc1d$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$411d94524a9cdc1d$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$411d94524a9cdc1d$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $411d94524a9cdc1d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$411d94524a9cdc1d$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $411d94524a9cdc1d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$411d94524a9cdc1d$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $411d94524a9cdc1d$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$411d94524a9cdc1d$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $411d94524a9cdc1d$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$411d94524a9cdc1d$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $411d94524a9cdc1d$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $411d94524a9cdc1d$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$411d94524a9cdc1d$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $411d94524a9cdc1d$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$411d94524a9cdc1d$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $411d94524a9cdc1d$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$411d94524a9cdc1d$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $411d94524a9cdc1d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$411d94524a9cdc1d$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $411d94524a9cdc1d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$411d94524a9cdc1d$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$411d94524a9cdc1d$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $411d94524a9cdc1d$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$411d94524a9cdc1d$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $411d94524a9cdc1d$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$411d94524a9cdc1d$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $411d94524a9cdc1d$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$411d94524a9cdc1d$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $411d94524a9cdc1d$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $411d94524a9cdc1d$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $411d94524a9cdc1d$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$411d94524a9cdc1d$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $411d94524a9cdc1d$var$writeFloat(this, value, offset, true, noAssert);
};
$411d94524a9cdc1d$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $411d94524a9cdc1d$var$writeFloat(this, value, offset, false, noAssert);
};
function $411d94524a9cdc1d$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$411d94524a9cdc1d$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $411d94524a9cdc1d$var$writeDouble(this, value, offset, true, noAssert);
};
$411d94524a9cdc1d$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $411d94524a9cdc1d$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$411d94524a9cdc1d$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$411d94524a9cdc1d$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$411d94524a9cdc1d$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $411d94524a9cdc1d$var$Buffer.isBuffer(val) ? val : $411d94524a9cdc1d$var$utf8ToBytes(new $411d94524a9cdc1d$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $411d94524a9cdc1d$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $411d94524a9cdc1d$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $411d94524a9cdc1d$var$stringtrim(str).replace($411d94524a9cdc1d$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $411d94524a9cdc1d$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function $411d94524a9cdc1d$var$toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function $411d94524a9cdc1d$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $411d94524a9cdc1d$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $411d94524a9cdc1d$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $411d94524a9cdc1d$var$base64ToBytes(str) {
    return $3nocJ.toByteArray($411d94524a9cdc1d$var$base64clean(str));
}
function $411d94524a9cdc1d$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $411d94524a9cdc1d$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}


var $b1d4dbaa5514b99a$var$crypto;
// Native crypto from window (Browser)
if (typeof window !== "undefined" && window.crypto) $b1d4dbaa5514b99a$var$crypto = window.crypto;
// Native (experimental IE 11) crypto from window (Browser)
if (!$b1d4dbaa5514b99a$var$crypto && typeof window !== "undefined" && window.msCrypto) $b1d4dbaa5514b99a$var$crypto = window.msCrypto;
// Native crypto from global (NodeJS)
if (!$b1d4dbaa5514b99a$var$crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) $b1d4dbaa5514b99a$var$crypto = $parcel$global.crypto;

// Native crypto import via require (NodeJS)
if (!$b1d4dbaa5514b99a$var$crypto && true) try {
    $b1d4dbaa5514b99a$var$crypto = (parcelRequire("ifbub"));
} catch (err) {}
function $b1d4dbaa5514b99a$export$2e2bcd8739ae039() {
    if ($b1d4dbaa5514b99a$var$crypto) {
        // Use getRandomValues method (Browser)
        if (typeof $b1d4dbaa5514b99a$var$crypto.getRandomValues === "function") try {
            return $b1d4dbaa5514b99a$var$crypto.getRandomValues(new Uint32Array(1))[0];
        } catch (err) {}
        // Use randomBytes method (NodeJS)
        if (typeof $b1d4dbaa5514b99a$var$crypto.randomBytes === "function") try {
            return $b1d4dbaa5514b99a$var$crypto.randomBytes(4).readInt32LE();
        } catch (err) {}
    }
    throw new Error("Native crypto module could not be used to get secure random number.");
}


/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function $a9fb8c8e5b047730$var$hexStringify(wordArray) {
    // Shortcuts
    var words = wordArray.words;
    var sigBytes = wordArray.sigBytes;
    // Convert
    var hexChars = [];
    for(var i = 0; i < sigBytes; i++){
        var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join("");
}
var $a9fb8c8e5b047730$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WordArray(words, sigBytes) {
        words = this.words = words || [];
        if (sigBytes != undefined) this.sigBytes = sigBytes;
        else this.sigBytes = words.length * 4;
    }
    var _proto = WordArray.prototype;
    _proto.random = function random(nBytes) {
        var words = [];
        for(var i = 0; i < nBytes; i += 4)words.push((0, $b1d4dbaa5514b99a$export$2e2bcd8739ae039)());
        return new WordArray(words, nBytes);
    };
    _proto.toString = function toString() {
        return $a9fb8c8e5b047730$var$hexStringify(this);
    };
    return WordArray;
}();



// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
var $3e40ba1bd46c35ab$export$2e2bcd8739ae039 = $3e40ba1bd46c35ab$var$BigInteger;
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $3e40ba1bd46c35ab$var$BigInteger(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function $3e40ba1bd46c35ab$var$nbi() {
    return new $3e40ba1bd46c35ab$var$BigInteger(null);
}
// Bits per digit
var $3e40ba1bd46c35ab$var$dbits;
// JavaScript engine analysis
var $3e40ba1bd46c35ab$var$canary = 0xdeadbeefcafe;
var $3e40ba1bd46c35ab$var$j_lm = ($3e40ba1bd46c35ab$var$canary & 0xffffff) == 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $3e40ba1bd46c35ab$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $3e40ba1bd46c35ab$var$am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $3e40ba1bd46c35ab$var$am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
var $3e40ba1bd46c35ab$var$inBrowser = typeof navigator !== "undefined";
if ($3e40ba1bd46c35ab$var$inBrowser && $3e40ba1bd46c35ab$var$j_lm && navigator.appName == "Microsoft Internet Explorer") {
    $3e40ba1bd46c35ab$var$BigInteger.prototype.am = $3e40ba1bd46c35ab$var$am2;
    $3e40ba1bd46c35ab$var$dbits = 30;
} else if ($3e40ba1bd46c35ab$var$inBrowser && $3e40ba1bd46c35ab$var$j_lm && navigator.appName != "Netscape") {
    $3e40ba1bd46c35ab$var$BigInteger.prototype.am = $3e40ba1bd46c35ab$var$am1;
    $3e40ba1bd46c35ab$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $3e40ba1bd46c35ab$var$BigInteger.prototype.am = $3e40ba1bd46c35ab$var$am3;
    $3e40ba1bd46c35ab$var$dbits = 28;
}
$3e40ba1bd46c35ab$var$BigInteger.prototype.DB = $3e40ba1bd46c35ab$var$dbits;
$3e40ba1bd46c35ab$var$BigInteger.prototype.DM = (1 << $3e40ba1bd46c35ab$var$dbits) - 1;
$3e40ba1bd46c35ab$var$BigInteger.prototype.DV = 1 << $3e40ba1bd46c35ab$var$dbits;
var $3e40ba1bd46c35ab$var$BI_FP = 52;
$3e40ba1bd46c35ab$var$BigInteger.prototype.FV = Math.pow(2, $3e40ba1bd46c35ab$var$BI_FP);
$3e40ba1bd46c35ab$var$BigInteger.prototype.F1 = $3e40ba1bd46c35ab$var$BI_FP - $3e40ba1bd46c35ab$var$dbits;
$3e40ba1bd46c35ab$var$BigInteger.prototype.F2 = 2 * $3e40ba1bd46c35ab$var$dbits - $3e40ba1bd46c35ab$var$BI_FP;
// Digit conversions
var $3e40ba1bd46c35ab$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var $3e40ba1bd46c35ab$var$BI_RC = new Array();
var $3e40ba1bd46c35ab$var$rr, $3e40ba1bd46c35ab$var$vv;
$3e40ba1bd46c35ab$var$rr = "0".charCodeAt(0);
for($3e40ba1bd46c35ab$var$vv = 0; $3e40ba1bd46c35ab$var$vv <= 9; ++$3e40ba1bd46c35ab$var$vv)$3e40ba1bd46c35ab$var$BI_RC[$3e40ba1bd46c35ab$var$rr++] = $3e40ba1bd46c35ab$var$vv;
$3e40ba1bd46c35ab$var$rr = "a".charCodeAt(0);
for($3e40ba1bd46c35ab$var$vv = 10; $3e40ba1bd46c35ab$var$vv < 36; ++$3e40ba1bd46c35ab$var$vv)$3e40ba1bd46c35ab$var$BI_RC[$3e40ba1bd46c35ab$var$rr++] = $3e40ba1bd46c35ab$var$vv;
$3e40ba1bd46c35ab$var$rr = "A".charCodeAt(0);
for($3e40ba1bd46c35ab$var$vv = 10; $3e40ba1bd46c35ab$var$vv < 36; ++$3e40ba1bd46c35ab$var$vv)$3e40ba1bd46c35ab$var$BI_RC[$3e40ba1bd46c35ab$var$rr++] = $3e40ba1bd46c35ab$var$vv;
function $3e40ba1bd46c35ab$var$int2char(n) {
    return $3e40ba1bd46c35ab$var$BI_RM.charAt(n);
}
function $3e40ba1bd46c35ab$var$intAt(s, i) {
    var c = $3e40ba1bd46c35ab$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $3e40ba1bd46c35ab$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $3e40ba1bd46c35ab$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $3e40ba1bd46c35ab$var$nbv(i) {
    var r = $3e40ba1bd46c35ab$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $3e40ba1bd46c35ab$var$bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = $3e40ba1bd46c35ab$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-") mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $3e40ba1bd46c35ab$var$BigInteger.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $3e40ba1bd46c35ab$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $3e40ba1bd46c35ab$var$bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $3e40ba1bd46c35ab$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $3e40ba1bd46c35ab$var$int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function $3e40ba1bd46c35ab$var$bnNegate() {
    var r = $3e40ba1bd46c35ab$var$nbi();
    $3e40ba1bd46c35ab$var$BigInteger.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $3e40ba1bd46c35ab$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $3e40ba1bd46c35ab$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $3e40ba1bd46c35ab$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $3e40ba1bd46c35ab$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $3e40ba1bd46c35ab$var$nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $3e40ba1bd46c35ab$var$bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $3e40ba1bd46c35ab$var$bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $3e40ba1bd46c35ab$var$bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $3e40ba1bd46c35ab$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $3e40ba1bd46c35ab$var$bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $3e40ba1bd46c35ab$var$bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) $3e40ba1bd46c35ab$var$BigInteger.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $3e40ba1bd46c35ab$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $3e40ba1bd46c35ab$var$bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = $3e40ba1bd46c35ab$var$nbi();
    var y = $3e40ba1bd46c35ab$var$nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - $3e40ba1bd46c35ab$var$nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? $3e40ba1bd46c35ab$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $3e40ba1bd46c35ab$var$BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) $3e40ba1bd46c35ab$var$BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) $3e40ba1bd46c35ab$var$BigInteger.ZERO.subTo(r, r);
}
// (public) this mod a
function $3e40ba1bd46c35ab$var$bnMod(a) {
    var r = $3e40ba1bd46c35ab$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($3e40ba1bd46c35ab$var$BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $3e40ba1bd46c35ab$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $3e40ba1bd46c35ab$var$bnEquals(a) {
    return this.compareTo(a) == 0;
}
// (protected) r = this + a
function $3e40ba1bd46c35ab$var$bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function $3e40ba1bd46c35ab$var$bnAdd(a) {
    var r = $3e40ba1bd46c35ab$var$nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function $3e40ba1bd46c35ab$var$bnSubtract(a) {
    var r = $3e40ba1bd46c35ab$var$nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function $3e40ba1bd46c35ab$var$bnMultiply(a) {
    var r = $3e40ba1bd46c35ab$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function $3e40ba1bd46c35ab$var$bnDivide(a) {
    var r = $3e40ba1bd46c35ab$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function $3e40ba1bd46c35ab$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $3e40ba1bd46c35ab$var$montConvert(x) {
    var r = $3e40ba1bd46c35ab$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($3e40ba1bd46c35ab$var$BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $3e40ba1bd46c35ab$var$montRevert(x) {
    var r = $3e40ba1bd46c35ab$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $3e40ba1bd46c35ab$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $3e40ba1bd46c35ab$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $3e40ba1bd46c35ab$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$3e40ba1bd46c35ab$var$Montgomery.prototype.convert = $3e40ba1bd46c35ab$var$montConvert;
$3e40ba1bd46c35ab$var$Montgomery.prototype.revert = $3e40ba1bd46c35ab$var$montRevert;
$3e40ba1bd46c35ab$var$Montgomery.prototype.reduce = $3e40ba1bd46c35ab$var$montReduce;
$3e40ba1bd46c35ab$var$Montgomery.prototype.mulTo = $3e40ba1bd46c35ab$var$montMulTo;
$3e40ba1bd46c35ab$var$Montgomery.prototype.sqrTo = $3e40ba1bd46c35ab$var$montSqrTo;
// (public) this^e % m (HAC 14.85)
function $3e40ba1bd46c35ab$var$bnModPow(e, m, callback) {
    var i = e.bitLength(), k, r = $3e40ba1bd46c35ab$var$nbv(1), z = new $3e40ba1bd46c35ab$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = $3e40ba1bd46c35ab$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $3e40ba1bd46c35ab$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = $3e40ba1bd46c35ab$var$nbi(), t;
    i = $3e40ba1bd46c35ab$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    var result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
$3e40ba1bd46c35ab$var$BigInteger.prototype.copyTo = $3e40ba1bd46c35ab$var$bnpCopyTo;
$3e40ba1bd46c35ab$var$BigInteger.prototype.fromInt = $3e40ba1bd46c35ab$var$bnpFromInt;
$3e40ba1bd46c35ab$var$BigInteger.prototype.fromString = $3e40ba1bd46c35ab$var$bnpFromString;
$3e40ba1bd46c35ab$var$BigInteger.prototype.clamp = $3e40ba1bd46c35ab$var$bnpClamp;
$3e40ba1bd46c35ab$var$BigInteger.prototype.dlShiftTo = $3e40ba1bd46c35ab$var$bnpDLShiftTo;
$3e40ba1bd46c35ab$var$BigInteger.prototype.drShiftTo = $3e40ba1bd46c35ab$var$bnpDRShiftTo;
$3e40ba1bd46c35ab$var$BigInteger.prototype.lShiftTo = $3e40ba1bd46c35ab$var$bnpLShiftTo;
$3e40ba1bd46c35ab$var$BigInteger.prototype.rShiftTo = $3e40ba1bd46c35ab$var$bnpRShiftTo;
$3e40ba1bd46c35ab$var$BigInteger.prototype.subTo = $3e40ba1bd46c35ab$var$bnpSubTo;
$3e40ba1bd46c35ab$var$BigInteger.prototype.multiplyTo = $3e40ba1bd46c35ab$var$bnpMultiplyTo;
$3e40ba1bd46c35ab$var$BigInteger.prototype.squareTo = $3e40ba1bd46c35ab$var$bnpSquareTo;
$3e40ba1bd46c35ab$var$BigInteger.prototype.divRemTo = $3e40ba1bd46c35ab$var$bnpDivRemTo;
$3e40ba1bd46c35ab$var$BigInteger.prototype.invDigit = $3e40ba1bd46c35ab$var$bnpInvDigit;
$3e40ba1bd46c35ab$var$BigInteger.prototype.addTo = $3e40ba1bd46c35ab$var$bnpAddTo;
// public
$3e40ba1bd46c35ab$var$BigInteger.prototype.toString = $3e40ba1bd46c35ab$var$bnToString;
$3e40ba1bd46c35ab$var$BigInteger.prototype.negate = $3e40ba1bd46c35ab$var$bnNegate;
$3e40ba1bd46c35ab$var$BigInteger.prototype.abs = $3e40ba1bd46c35ab$var$bnAbs;
$3e40ba1bd46c35ab$var$BigInteger.prototype.compareTo = $3e40ba1bd46c35ab$var$bnCompareTo;
$3e40ba1bd46c35ab$var$BigInteger.prototype.bitLength = $3e40ba1bd46c35ab$var$bnBitLength;
$3e40ba1bd46c35ab$var$BigInteger.prototype.mod = $3e40ba1bd46c35ab$var$bnMod;
$3e40ba1bd46c35ab$var$BigInteger.prototype.equals = $3e40ba1bd46c35ab$var$bnEquals;
$3e40ba1bd46c35ab$var$BigInteger.prototype.add = $3e40ba1bd46c35ab$var$bnAdd;
$3e40ba1bd46c35ab$var$BigInteger.prototype.subtract = $3e40ba1bd46c35ab$var$bnSubtract;
$3e40ba1bd46c35ab$var$BigInteger.prototype.multiply = $3e40ba1bd46c35ab$var$bnMultiply;
$3e40ba1bd46c35ab$var$BigInteger.prototype.divide = $3e40ba1bd46c35ab$var$bnDivide;
$3e40ba1bd46c35ab$var$BigInteger.prototype.modPow = $3e40ba1bd46c35ab$var$bnModPow;
// "constants"
$3e40ba1bd46c35ab$var$BigInteger.ZERO = $3e40ba1bd46c35ab$var$nbv(0);
$3e40ba1bd46c35ab$var$BigInteger.ONE = $3e40ba1bd46c35ab$var$nbv(1);


/**
 * Returns a Buffer with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Buffer} fixed-length sequence of random bytes
 */ function $88865c6be67431f3$var$randomBytes(nBytes) {
    return (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(new (0, $a9fb8c8e5b047730$export$2e2bcd8739ae039)().random(nBytes).toString(), "hex");
}
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ var $88865c6be67431f3$var$HEX_MSB_REGEX = /^[89a-f]/i;
var $88865c6be67431f3$var$initN = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
var $88865c6be67431f3$var$newPasswordRequiredChallengeUserAttributePrefix = "userAttributes.";
/** @class */ var $88865c6be67431f3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationHelper object
   * @param {string} PoolName Cognito user pool name.
   */ function AuthenticationHelper(PoolName) {
        this.N = new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)($88865c6be67431f3$var$initN, 16);
        this.g = new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)("2", 16);
        this.k = new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)(this.hexHash("" + this.padHex(this.N) + this.padHex(this.g)), 16);
        this.smallAValue = this.generateRandomSmallA();
        this.getLargeAValue(function() {});
        this.infoBits = (0, $411d94524a9cdc1d$export$a143d493d941bafc).from("Caldera Derived Key", "utf8");
        this.poolName = PoolName;
    }
    /**
   * @returns {BigInteger} small A, a random number
   */ var _proto = AuthenticationHelper.prototype;
    _proto.getSmallAValue = function getSmallAValue() {
        return this.smallAValue;
    } /**
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   */ ;
    _proto.getLargeAValue = function getLargeAValue(callback) {
        var _this = this;
        if (this.largeAValue) callback(null, this.largeAValue);
        else this.calculateA(this.smallAValue, function(err, largeAValue) {
            if (err) callback(err, null);
            _this.largeAValue = largeAValue;
            callback(null, _this.largeAValue);
        });
    } /**
   * helper function to generate a random big integer
   * @returns {BigInteger} a random value.
   * @private
   */ ;
    _proto.generateRandomSmallA = function generateRandomSmallA() {
        // This will be interpreted as a postive 128-bit integer
        var hexRandom = $88865c6be67431f3$var$randomBytes(128).toString("hex");
        var randomBigInt = new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)(hexRandom, 16);
        // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
        return randomBigInt;
    } /**
   * helper function to generate a random string
   * @returns {string} a random value.
   * @private
   */ ;
    _proto.generateRandomString = function generateRandomString() {
        return $88865c6be67431f3$var$randomBytes(40).toString("base64");
    } /**
   * @returns {string} Generated random value included in password hash.
   */ ;
    _proto.getRandomPassword = function getRandomPassword() {
        return this.randomPassword;
    } /**
   * @returns {string} Generated random value included in devices hash.
   */ ;
    _proto.getSaltDevices = function getSaltDevices() {
        return this.SaltToHashDevices;
    } /**
   * @returns {string} Value used to verify devices.
   */ ;
    _proto.getVerifierDevices = function getVerifierDevices() {
        return this.verifierDevices;
    } /**
   * Generate salts and compute verifier.
   * @param {string} deviceGroupKey Devices to generate verifier for.
   * @param {string} username User to generate verifier for.
   * @param {nodeCallback<null>} callback Called with (err, null)
   * @returns {void}
   */ ;
    _proto.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
        var _this2 = this;
        this.randomPassword = this.generateRandomString();
        var combinedString = "" + deviceGroupKey + username + ":" + this.randomPassword;
        var hashedString = this.hash(combinedString);
        var hexRandom = $88865c6be67431f3$var$randomBytes(16).toString("hex");
        // The random hex will be unambiguously represented as a postive integer
        this.SaltToHashDevices = this.padHex(new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)(hexRandom, 16));
        this.g.modPow(new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function(err, verifierDevicesNotPadded) {
            if (err) callback(err, null);
            _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
            callback(null, null);
        });
    } /**
   * Calculate the client's public value A = g^a%N
   * with the generated random number a
   * @param {BigInteger} a Randomly generated small A.
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   * @private
   */ ;
    _proto.calculateA = function calculateA(a, callback) {
        var _this3 = this;
        this.g.modPow(a, this.N, function(err, A) {
            if (err) callback(err, null);
            if (A.mod(_this3.N).equals((0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039).ZERO)) callback(new Error("Illegal paramater. A mod N cannot be 0."), null);
            callback(null, A);
        });
    } /**
   * Calculate the client's value U which is the hash of A and B
   * @param {BigInteger} A Large A value.
   * @param {BigInteger} B Server B value.
   * @returns {BigInteger} Computed U value.
   * @private
   */ ;
    _proto.calculateU = function calculateU(A, B) {
        this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
        var finalU = new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)(this.UHexHash, 16);
        return finalU;
    } /**
   * Calculate a hash from a bitArray
   * @param {Buffer} buf Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hash = function hash(buf) {
        var awsCryptoHash = new (0, $f0fc6b161cb35602$exports.Sha256)();
        awsCryptoHash.update(buf);
        var resultFromAWSCrypto = awsCryptoHash.digestSync();
        var hashHex = (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(resultFromAWSCrypto).toString("hex");
        return new Array(64 - hashHex.length).join("0") + hashHex;
    } /**
   * Calculate a hash from a hex string
   * @param {String} hexStr Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hexHash = function hexHash(hexStr) {
        return this.hash((0, $411d94524a9cdc1d$export$a143d493d941bafc).from(hexStr, "hex"));
    } /**
   * Standard hkdf algorithm
   * @param {Buffer} ikm Input key material.
   * @param {Buffer} salt Salt value.
   * @returns {Buffer} Strong key material.
   * @private
   */ ;
    _proto.computehkdf = function computehkdf(ikm, salt) {
        var infoBitsBuffer = (0, $411d94524a9cdc1d$export$a143d493d941bafc).concat([
            this.infoBits,
            (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(String.fromCharCode(1), "utf8")
        ]);
        var awsCryptoHash = new (0, $f0fc6b161cb35602$exports.Sha256)(salt);
        awsCryptoHash.update(ikm);
        var resultFromAWSCryptoPrk = awsCryptoHash.digestSync();
        var awsCryptoHashHmac = new (0, $f0fc6b161cb35602$exports.Sha256)(resultFromAWSCryptoPrk);
        awsCryptoHashHmac.update(infoBitsBuffer);
        var resultFromAWSCryptoHmac = awsCryptoHashHmac.digestSync();
        var hashHexFromAWSCrypto = resultFromAWSCryptoHmac;
        var currentHex = hashHexFromAWSCrypto.slice(0, 16);
        return currentHex;
    } /**
   * Calculates the final hkdf based on computed S value, and computed U value and the key
   * @param {String} username Username.
   * @param {String} password Password.
   * @param {BigInteger} serverBValue Server B value.
   * @param {BigInteger} salt Generated salt.
   * @param {nodeCallback<Buffer>} callback Called with (err, hkdfValue)
   * @returns {void}
   */ ;
    _proto.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
        var _this4 = this;
        if (serverBValue.mod(this.N).equals((0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039).ZERO)) throw new Error("B cannot be zero.");
        this.UValue = this.calculateU(this.largeAValue, serverBValue);
        if (this.UValue.equals((0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039).ZERO)) throw new Error("U cannot be zero.");
        var usernamePassword = "" + this.poolName + username + ":" + password;
        var usernamePasswordHash = this.hash(usernamePassword);
        var xValue = new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)(this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
        this.calculateS(xValue, serverBValue, function(err, sValue) {
            if (err) callback(err, null);
            var hkdf = _this4.computehkdf((0, $411d94524a9cdc1d$export$a143d493d941bafc).from(_this4.padHex(sValue), "hex"), (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(_this4.padHex(_this4.UValue), "hex"));
            callback(null, hkdf);
        });
    } /**
   * Calculates the S value used in getPasswordAuthenticationKey
   * @param {BigInteger} xValue Salted password hash value.
   * @param {BigInteger} serverBValue Server B value.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.calculateS = function calculateS(xValue, serverBValue, callback) {
        var _this5 = this;
        this.g.modPow(xValue, this.N, function(err, gModPowXN) {
            if (err) callback(err, null);
            var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
            intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function(err2, result) {
                if (err2) callback(err2, null);
                callback(null, result.mod(_this5.N));
            });
        });
    } /**
   * Return constant newPasswordRequiredChallengeUserAttributePrefix
   * @return {newPasswordRequiredChallengeUserAttributePrefix} constant prefix value
   */ ;
    _proto.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
        return $88865c6be67431f3$var$newPasswordRequiredChallengeUserAttributePrefix;
    } /**
   * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
   *
   * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
   * byte array containing the two's-complement representation of a BigInteger. The array contains
   * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
   *
   * Examples showing how ambiguity is avoided by left padding with:
   * 	"00" (for positive values where the most-significant-bit is set)
   *  "FF" (for negative values where the most-significant-bit is set)
   *
   * padHex(bigInteger.fromInt(-236))  === "FF14"
   * padHex(bigInteger.fromInt(20))    === "14"
   *
   * padHex(bigInteger.fromInt(-200))  === "FF38"
   * padHex(bigInteger.fromInt(56))    === "38"
   *
   * padHex(bigInteger.fromInt(-20))   === "EC"
   * padHex(bigInteger.fromInt(236))   === "00EC"
   *
   * padHex(bigInteger.fromInt(-56))   === "C8"
   * padHex(bigInteger.fromInt(200))   === "00C8"
   *
   * @param {BigInteger} bigInt Number to encode.
   * @returns {String} even-length hex string of the two's complement encoding.
   */ ;
    _proto.padHex = function padHex(bigInt) {
        if (!(bigInt instanceof (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039))) throw new Error("Not a BigInteger");
        var isNegative = bigInt.compareTo((0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039).ZERO) < 0;
        /* Get a hex string for abs(bigInt) */ var hexStr = bigInt.abs().toString(16);
        /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? "0" + hexStr : hexStr;
        /* Prepend "00" if the most significant bit is set */ hexStr = $88865c6be67431f3$var$HEX_MSB_REGEX.test(hexStr) ? "00" + hexStr : hexStr;
        if (isNegative) {
            /* Flip the bits of the representation */ var invertedNibbles = hexStr.split("").map(function(x) {
                var invertedNibble = ~parseInt(x, 16) & 0xf;
                return "0123456789ABCDEF".charAt(invertedNibble);
            }).join("");
            /* After flipping the bits, add one to get the 2's complement representation */ var flippedBitsBI = new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)(invertedNibbles, 16).add((0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039).ONE);
            hexStr = flippedBitsBI.toString(16);
            /*
      For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128
      		Any sequence of '1' bits on the left can always be substituted with a single '1' bit
      without changing the represented value.
      		This only happens in the case when the input is 80...00
      */ if (hexStr.toUpperCase().startsWith("FF8")) hexStr = hexStr.substring(2);
        }
        return hexStr;
    };
    return AuthenticationHelper;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
/** @class */ var $9cace9e0163889ff$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoJwtToken object
   * @param {string=} token The JWT token.
   */ function CognitoJwtToken(token) {
        // Assign object
        this.jwtToken = token || "";
        this.payload = this.decodePayload();
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoJwtToken.prototype;
    _proto.getJwtToken = function getJwtToken() {
        return this.jwtToken;
    } /**
   * @returns {int} the token's expiration (exp member).
   */ ;
    _proto.getExpiration = function getExpiration() {
        return this.payload.exp;
    } /**
   * @returns {int} the token's "issued at" (iat member).
   */ ;
    _proto.getIssuedAt = function getIssuedAt() {
        return this.payload.iat;
    } /**
   * @returns {object} the token's payload.
   */ ;
    _proto.decodePayload = function decodePayload() {
        var payload = this.jwtToken.split(".")[1];
        try {
            return JSON.parse((0, $411d94524a9cdc1d$export$a143d493d941bafc).from(payload, "base64").toString("utf8"));
        } catch (err) {
            return {};
        }
    };
    return CognitoJwtToken;
}();


function $41c9382bb6a72dfa$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $41c9382bb6a72dfa$var$_setPrototypeOf(subClass, superClass);
}
function $41c9382bb6a72dfa$var$_setPrototypeOf(o, p) {
    $41c9382bb6a72dfa$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $41c9382bb6a72dfa$var$_setPrototypeOf(o, p);
}
/** @class */ var $41c9382bb6a72dfa$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $41c9382bb6a72dfa$var$_inheritsLoose(CognitoAccessToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */ function CognitoAccessToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, AccessToken = _ref.AccessToken;
        return _CognitoJwtToken.call(this, AccessToken || "") || this;
    }
    return CognitoAccessToken;
}((0, $9cace9e0163889ff$export$2e2bcd8739ae039));



function $d9c1dd270429cf89$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $d9c1dd270429cf89$var$_setPrototypeOf(subClass, superClass);
}
function $d9c1dd270429cf89$var$_setPrototypeOf(o, p) {
    $d9c1dd270429cf89$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d9c1dd270429cf89$var$_setPrototypeOf(o, p);
}
/** @class */ var $d9c1dd270429cf89$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $d9c1dd270429cf89$var$_inheritsLoose(CognitoIdToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */ function CognitoIdToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken;
        return _CognitoJwtToken.call(this, IdToken || "") || this;
    }
    return CognitoIdToken;
}((0, $9cace9e0163889ff$export$2e2bcd8739ae039));


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $fdaf527344dd671b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */ function CognitoRefreshToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, RefreshToken = _ref.RefreshToken;
        // Assign object
        this.token = RefreshToken || "";
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoRefreshToken.prototype;
    _proto.getToken = function getToken() {
        return this.token;
    };
    return CognitoRefreshToken;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 

/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ // generated by genversion
var $4c68ad5a26d6b3ee$export$83d89fbfd8236492 = "5.0.4";


var $37924787154e0cec$var$BASE_USER_AGENT = "aws-amplify/" + (0, $4c68ad5a26d6b3ee$export$83d89fbfd8236492);
var $37924787154e0cec$export$2dffd0b5373a4389 = {
    userAgent: $37924787154e0cec$var$BASE_USER_AGENT,
    isReactNative: typeof navigator !== "undefined" && navigator.product === "ReactNative"
};
var $37924787154e0cec$export$7935961ef7719cb0 = function getUserAgent() {
    return $37924787154e0cec$export$2dffd0b5373a4389.userAgent;
};
var /**
 * @deprecated use named import
 */ $37924787154e0cec$export$2e2bcd8739ae039 = $37924787154e0cec$export$2dffd0b5373a4389;







/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $45e3ad811e5296cd$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserSession object
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
   */ function CognitoUserSession(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken, RefreshToken = _ref.RefreshToken, AccessToken = _ref.AccessToken, ClockDrift = _ref.ClockDrift;
        if (AccessToken == null || IdToken == null) throw new Error("Id token and Access Token must be present.");
        this.idToken = IdToken;
        this.refreshToken = RefreshToken;
        this.accessToken = AccessToken;
        this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
    }
    /**
   * @returns {CognitoIdToken} the session's Id token
   */ var _proto = CognitoUserSession.prototype;
    _proto.getIdToken = function getIdToken() {
        return this.idToken;
    } /**
   * @returns {CognitoRefreshToken} the session's refresh token
   */ ;
    _proto.getRefreshToken = function getRefreshToken() {
        return this.refreshToken;
    } /**
   * @returns {CognitoAccessToken} the session's access token
   */ ;
    _proto.getAccessToken = function getAccessToken() {
        return this.accessToken;
    } /**
   * @returns {int} the session's clock drift
   */ ;
    _proto.getClockDrift = function getClockDrift() {
        return this.clockDrift;
    } /**
   * @returns {int} the computer's clock drift
   */ ;
    _proto.calculateClockDrift = function calculateClockDrift() {
        var now = Math.floor(new Date() / 1000);
        var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
        return now - iat;
    } /**
   * Checks to see if the session is still valid based on session expiry information found
   * in tokens and the current time (adjusted with clock drift)
   * @returns {boolean} if the session is still valid
   */ ;
    _proto.isValid = function isValid() {
        var now = Math.floor(new Date() / 1000);
        var adjusted = now - this.clockDrift;
        return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
    };
    return CognitoUserSession;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $cd3600c8771307cd$var$monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $cd3600c8771307cd$var$weekNames = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
/** @class */ var $cd3600c8771307cd$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function DateHelper() {}
    var _proto = DateHelper.prototype;
    /**
   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
   */ _proto.getNowString = function getNowString() {
        var now = new Date();
        var weekDay = $cd3600c8771307cd$var$weekNames[now.getUTCDay()];
        var month = $cd3600c8771307cd$var$monthNames[now.getUTCMonth()];
        var day = now.getUTCDate();
        var hours = now.getUTCHours();
        if (hours < 10) hours = "0" + hours;
        var minutes = now.getUTCMinutes();
        if (minutes < 10) minutes = "0" + minutes;
        var seconds = now.getUTCSeconds();
        if (seconds < 10) seconds = "0" + seconds;
        var year = now.getUTCFullYear();
        // ddd MMM D HH:mm:ss UTC YYYY
        var dateNow = weekDay + " " + month + " " + day + " " + hours + ":" + minutes + ":" + seconds + " UTC " + year;
        return dateNow;
    };
    return DateHelper;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $559b6e1d514a188f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserAttribute object
   * @param {string=} Name The record's name
   * @param {string=} Value The record's value
   */ function CognitoUserAttribute(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, Name = _ref.Name, Value = _ref.Value;
        this.Name = Name || "";
        this.Value = Value || "";
    }
    /**
   * @returns {string} the record's value.
   */ var _proto = CognitoUserAttribute.prototype;
    _proto.getValue = function getValue() {
        return this.Value;
    } /**
   * Sets the record's value.
   * @param {string} value The new value.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setValue = function setValue(value) {
        this.Value = value;
        return this;
    } /**
   * @returns {string} the record's name.
   */ ;
    _proto.getName = function getName() {
        return this.Name;
    } /**
   * Sets the record's name
   * @param {string} name The new name.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setName = function setName(name) {
        this.Name = name;
        return this;
    } /**
   * @returns {string} a string representation of the record.
   */ ;
    _proto.toString = function toString() {
        return JSON.stringify(this);
    } /**
   * @returns {object} a flat object representing the record.
   */ ;
    _proto.toJSON = function toJSON() {
        return {
            Name: this.Name,
            Value: this.Value
        };
    };
    return CognitoUserAttribute;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $d3c0ec7e73282823$var$dataMemory = {};
var $d3c0ec7e73282823$export$d7392285c701ecf5 = /*#__PURE__*/ function() {
    function MemoryStorage() {}
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ MemoryStorage.setItem = function setItem(key, value) {
        $d3c0ec7e73282823$var$dataMemory[key] = value;
        return $d3c0ec7e73282823$var$dataMemory[key];
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    MemoryStorage.getItem = function getItem(key) {
        return Object.prototype.hasOwnProperty.call($d3c0ec7e73282823$var$dataMemory, key) ? $d3c0ec7e73282823$var$dataMemory[key] : undefined;
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {boolean} return true
   */ ;
    MemoryStorage.removeItem = function removeItem(key) {
        return delete $d3c0ec7e73282823$var$dataMemory[key];
    } /**
   * This is used to clear the storage
   * @returns {string} nothing
   */ ;
    MemoryStorage.clear = function clear() {
        $d3c0ec7e73282823$var$dataMemory = {};
        return $d3c0ec7e73282823$var$dataMemory;
    };
    return MemoryStorage;
}();
/** @class */ var $d3c0ec7e73282823$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * This is used to get a storage object
   * @returns {object} the storage
   */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem("aws.cognito.test-ls", 1);
            this.storageWindow.removeItem("aws.cognito.test-ls");
        } catch (exception) {
            this.storageWindow = $d3c0ec7e73282823$export$d7392285c701ecf5;
        }
    }
    /**
   * This is used to return the storage
   * @returns {object} the storage
   */ var _proto = StorageHelper.prototype;
    _proto.getStorage = function getStorage() {
        return this.storageWindow;
    };
    return StorageHelper;
}();


/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */ /**
 * @callback onFailure
 * @param {*} err Failure reason.
 */ /**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */ /**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */ /**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */ /**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */ /**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */ var $a44bf0d9fbe2b4df$var$isNavigatorAvailable = typeof navigator !== "undefined";
var $a44bf0d9fbe2b4df$var$userAgent = $a44bf0d9fbe2b4df$var$isNavigatorAvailable ? (0, $37924787154e0cec$export$2dffd0b5373a4389).isReactNative ? "react-native" : navigator.userAgent : "nodejs";
/** @class */ var $a44bf0d9fbe2b4df$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUser object
   * @param {object} data Creation options
   * @param {string} data.Username The user's username.
   * @param {CognitoUserPool} data.Pool Pool containing the user.
   * @param {object} data.Storage Optional storage object.
   */ function CognitoUser(data) {
        if (data == null || data.Username == null || data.Pool == null) throw new Error("Username and Pool information are required.");
        this.username = data.Username || "";
        this.pool = data.Pool;
        this.Session = null;
        this.client = data.Pool.client;
        this.signInUserSession = null;
        this.authenticationFlowType = "USER_SRP_AUTH";
        this.storage = data.Storage || new (0, $d3c0ec7e73282823$export$2e2bcd8739ae039)().getStorage();
        this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
    }
    /**
   * Sets the session for this user
   * @param {CognitoUserSession} signInUserSession the session
   * @returns {void}
   */ var _proto = CognitoUser.prototype;
    _proto.setSignInUserSession = function setSignInUserSession(signInUserSession) {
        this.clearCachedUserData();
        this.signInUserSession = signInUserSession;
        this.cacheTokens();
    } /**
   * @returns {CognitoUserSession} the current session for this user
   */ ;
    _proto.getSignInUserSession = function getSignInUserSession() {
        return this.signInUserSession;
    } /**
   * @returns {string} the user's username
   */ ;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {String} the authentication flow type
   */ ;
    _proto.getAuthenticationFlowType = function getAuthenticationFlowType() {
        return this.authenticationFlowType;
    } /**
   * sets authentication flow type
   * @param {string} authenticationFlowType New value.
   * @returns {void}
   */ ;
    _proto.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
        this.authenticationFlowType = authenticationFlowType;
    } /**
   * This is used for authenticating the user through the custom authentication flow.
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.initiateAuth = function initiateAuth(authDetails, callback) {
        var _this = this;
        var authParameters = authDetails.getAuthParameters();
        authParameters.USERNAME = this.username;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "CUSTOM_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            var challengeName = data.ChallengeName;
            var challengeParameters = data.ChallengeParameters;
            if (challengeName === "CUSTOM_CHALLENGE") {
                _this.Session = data.Session;
                return callback.customChallenge(challengeParameters);
            }
            _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
            _this.cacheTokens();
            return callback.onSuccess(_this.signInUserSession);
        });
    } /**
   * This is used for authenticating the user.
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUser = function authenticateUser(authDetails, callback) {
        if (this.authenticationFlowType === "USER_PASSWORD_AUTH") return this.authenticateUserPlainUsernamePassword(authDetails, callback);
        else if (this.authenticationFlowType === "USER_SRP_AUTH" || this.authenticationFlowType === "CUSTOM_AUTH") return this.authenticateUserDefaultAuth(authDetails, callback);
        return callback.onFailure(new Error("Authentication flow type is invalid."));
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * It calls the AuthenticationHelper for SRP related
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback) {
        var _this2 = this;
        var authenticationHelper = new (0, $88865c6be67431f3$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        var dateHelper = new (0, $cd3600c8771307cd$export$2e2bcd8739ae039)();
        var serverBValue;
        var salt;
        var authParameters = {};
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        authParameters.USERNAME = this.username;
        authenticationHelper.getLargeAValue(function(errOnAValue, aValue) {
            // getLargeAValue callback start
            if (errOnAValue) callback.onFailure(errOnAValue);
            authParameters.SRP_A = aValue.toString(16);
            if (_this2.authenticationFlowType === "CUSTOM_AUTH") authParameters.CHALLENGE_NAME = "SRP_A";
            var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
            var jsonReq = {
                AuthFlow: _this2.authenticationFlowType,
                ClientId: _this2.pool.getClientId(),
                AuthParameters: authParameters,
                ClientMetadata: clientMetaData
            };
            if (_this2.getUserContextData(_this2.username)) jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
            _this2.client.request("InitiateAuth", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                _this2.username = challengeParameters.USER_ID_FOR_SRP;
                _this2.userDataKey = _this2.keyPrefix + "." + _this2.username + ".userData";
                serverBValue = new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)(challengeParameters.SRP_B, 16);
                salt = new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)(challengeParameters.SALT, 16);
                _this2.getCachedDeviceKeyAndPassword();
                authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function(errOnHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errOnHkdf) callback.onFailure(errOnHkdf);
                    var dateNow = dateHelper.getNowString();
                    var concatBuffer = (0, $411d94524a9cdc1d$export$a143d493d941bafc).concat([
                        (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(_this2.pool.getUserPoolName(), "utf8"),
                        (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(_this2.username, "utf8"),
                        (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(dateNow, "utf8")
                    ]);
                    var awsCryptoHash = new (0, $f0fc6b161cb35602$exports.Sha256)(hkdf);
                    awsCryptoHash.update(concatBuffer);
                    var resultFromAWSCrypto = awsCryptoHash.digestSync();
                    var signatureString = (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(resultFromAWSCrypto).toString("base64");
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this2.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    if (_this2.deviceKey != null) challengeResponses.DEVICE_KEY = _this2.deviceKey;
                    var respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
                        return _this2.client.request("RespondToAuthChallenge", challenge, function(errChallenge, dataChallenge) {
                            if (errChallenge && errChallenge.code === "ResourceNotFoundException" && errChallenge.message.toLowerCase().indexOf("device") !== -1) {
                                challengeResponses.DEVICE_KEY = null;
                                _this2.deviceKey = null;
                                _this2.randomPassword = null;
                                _this2.deviceGroupKey = null;
                                _this2.clearCachedDeviceKeyAndPassword();
                                return respondToAuthChallenge(challenge, challengeCallback);
                            }
                            return challengeCallback(errChallenge, dataChallenge);
                        });
                    };
                    var jsonReqResp = {
                        ChallengeName: "PASSWORD_VERIFIER",
                        ClientId: _this2.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session,
                        ClientMetadata: clientMetaData
                    };
                    if (_this2.getUserContextData()) jsonReqResp.UserContextData = _this2.getUserContextData();
                    respondToAuthChallenge(jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {AuthenticationDetails} authDetails Contains the authentication data.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback) {
        var _this3 = this;
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.PASSWORD = authDetails.getPassword();
        if (!authParameters.PASSWORD) {
            callback.onFailure(new Error("PASSWORD parameter is required"));
            return;
        }
        var authenticationHelper = new (0, $88865c6be67431f3$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "USER_PASSWORD_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData(this.username)) jsonReq.UserContextData = this.getUserContextData(this.username);
        // USER_PASSWORD_AUTH happens in a single round-trip: client sends userName and password,
        // Cognito UserPools verifies password and returns tokens.
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) return callback.onFailure(err);
            return _this3.authenticateUserInternal(authResult, authenticationHelper, callback);
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {object} dataAuthenticate authentication data
   * @param {object} authenticationHelper helper created
   * @param {callback} callback passed on from caller
   * @returns {void}
   */ ;
    _proto.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
        var _this4 = this;
        var challengeName = dataAuthenticate.ChallengeName;
        var challengeParameters = dataAuthenticate.ChallengeParameters;
        if (challengeName === "SMS_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaRequired(challengeName, challengeParameters);
        }
        if (challengeName === "SELECT_MFA_TYPE") {
            this.Session = dataAuthenticate.Session;
            return callback.selectMFAType(challengeName, challengeParameters);
        }
        if (challengeName === "MFA_SETUP") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaSetup(challengeName, challengeParameters);
        }
        if (challengeName === "SOFTWARE_TOKEN_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.totpRequired(challengeName, challengeParameters);
        }
        if (challengeName === "CUSTOM_CHALLENGE") {
            this.Session = dataAuthenticate.Session;
            return callback.customChallenge(challengeParameters);
        }
        if (challengeName === "NEW_PASSWORD_REQUIRED") {
            this.Session = dataAuthenticate.Session;
            var userAttributes = null;
            var rawRequiredAttributes = null;
            var requiredAttributes = [];
            var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
            if (challengeParameters) {
                userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
                rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
            }
            if (rawRequiredAttributes) for(var i = 0; i < rawRequiredAttributes.length; i++)requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
            return callback.newPasswordRequired(userAttributes, requiredAttributes);
        }
        if (challengeName === "DEVICE_SRP_AUTH") {
            this.Session = dataAuthenticate.Session;
            this.getDeviceResponse(callback);
            return undefined;
        }
        this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
        this.challengeName = challengeName;
        this.cacheTokens();
        var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
        if (newDeviceMetadata == null) return callback.onSuccess(this.signInUserSession);
        authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
            if (errGenHash) return callback.onFailure(errGenHash);
            var deviceSecretVerifierConfig = {
                Salt: (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                PasswordVerifier: (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
            };
            _this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
            _this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
            _this4.randomPassword = authenticationHelper.getRandomPassword();
            _this4.client.request("ConfirmDevice", {
                DeviceKey: newDeviceMetadata.DeviceKey,
                AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
                DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                DeviceName: $a44bf0d9fbe2b4df$var$userAgent
            }, function(errConfirm, dataConfirm) {
                if (errConfirm) return callback.onFailure(errConfirm);
                _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                _this4.cacheDeviceKeyAndPassword();
                if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
                return callback.onSuccess(_this4.signInUserSession);
            });
            return undefined;
        });
        return undefined;
    } /**
   * This method is user to complete the NEW_PASSWORD_REQUIRED challenge.
   * Pass the new password with any new user attributes to be updated.
   * User attribute keys must be of format userAttributes.<attribute_name>.
   * @param {string} newPassword new password for this user
   * @param {object} requiredAttributeData map with values for all required attributes
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *         response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata) {
        var _this5 = this;
        if (!newPassword) return callback.onFailure(new Error("New password is required."));
        var authenticationHelper = new (0, $88865c6be67431f3$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
        var finalUserAttributes = {};
        if (requiredAttributeData) Object.keys(requiredAttributeData).forEach(function(key) {
            finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
        });
        finalUserAttributes.NEW_PASSWORD = newPassword;
        finalUserAttributes.USERNAME = this.username;
        var jsonReq = {
            ChallengeName: "NEW_PASSWORD_REQUIRED",
            ClientId: this.pool.getClientId(),
            ChallengeResponses: finalUserAttributes,
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) return callback.onFailure(errAuthenticate);
            return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
        });
        return undefined;
    } /**
   * This is used to get a session using device authentication. It is called at the end of user
   * authentication
   *
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   * @private
   */ ;
    _proto.getDeviceResponse = function getDeviceResponse(callback, clientMetadata) {
        var _this6 = this;
        var authenticationHelper = new (0, $88865c6be67431f3$export$2e2bcd8739ae039)(this.deviceGroupKey);
        var dateHelper = new (0, $cd3600c8771307cd$export$2e2bcd8739ae039)();
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.DEVICE_KEY = this.deviceKey;
        authenticationHelper.getLargeAValue(function(errAValue, aValue) {
            // getLargeAValue callback start
            if (errAValue) callback.onFailure(errAValue);
            authParameters.SRP_A = aValue.toString(16);
            var jsonReq = {
                ChallengeName: "DEVICE_SRP_AUTH",
                ClientId: _this6.pool.getClientId(),
                ChallengeResponses: authParameters,
                ClientMetadata: clientMetadata,
                Session: _this6.Session
            };
            if (_this6.getUserContextData()) jsonReq.UserContextData = _this6.getUserContextData();
            _this6.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                var serverBValue = new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)(challengeParameters.SRP_B, 16);
                var salt = new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)(challengeParameters.SALT, 16);
                authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function(errHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errHkdf) return callback.onFailure(errHkdf);
                    var dateNow = dateHelper.getNowString();
                    var concatBuffer = (0, $411d94524a9cdc1d$export$a143d493d941bafc).concat([
                        (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(_this6.deviceGroupKey, "utf8"),
                        (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(_this6.deviceKey, "utf8"),
                        (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(dateNow, "utf8")
                    ]);
                    var awsCryptoHash = new (0, $f0fc6b161cb35602$exports.Sha256)(hkdf);
                    awsCryptoHash.update(concatBuffer);
                    var resultFromAWSCrypto = awsCryptoHash.digestSync();
                    var signatureString = (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(resultFromAWSCrypto).toString("base64");
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this6.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    challengeResponses.DEVICE_KEY = _this6.deviceKey;
                    var jsonReqResp = {
                        ChallengeName: "DEVICE_PASSWORD_VERIFIER",
                        ClientId: _this6.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session
                    };
                    if (_this6.getUserContextData()) jsonReqResp.UserContextData = _this6.getUserContextData();
                    _this6.client.request("RespondToAuthChallenge", jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        _this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
                        _this6.cacheTokens();
                        return callback.onSuccess(_this6.signInUserSession);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * This is used for a certain user to confirm the registration by using a confirmation code
   * @param {string} confirmationCode Code entered by user.
   * @param {bool} forceAliasCreation Allow migrating from an existing email / phone number.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            ConfirmationCode: confirmationCode,
            Username: this.username,
            ForceAliasCreation: forceAliasCreation,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmSignUp", jsonReq, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
    } /**
   * This is used by the user once he has the responses to a custom challenge
   * @param {string} answerChallenge The custom challenge answer.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge
   *    Custom challenge response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata) {
        var _this7 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var authenticationHelper = new (0, $88865c6be67431f3$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: "CUSTOM_CHALLENGE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            return _this7.authenticateUserInternal(data, authenticationHelper, callback);
        });
    } /**
   * This is used by the user once he has an MFA code
   * @param {string} confirmationCode The MFA code entered by the user.
   * @param {object} callback Result callback map.
   * @param {string} mfaType The mfa we are replying to.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata) {
        var _this8 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.SMS_MFA_CODE = confirmationCode;
        var mfaTypeSelection = mfaType || "SMS_MFA";
        if (mfaTypeSelection === "SOFTWARE_TOKEN_MFA") challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: mfaTypeSelection,
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, dataAuthenticate) {
            if (err) return callback.onFailure(err);
            var challengeName = dataAuthenticate.ChallengeName;
            if (challengeName === "DEVICE_SRP_AUTH") {
                _this8.getDeviceResponse(callback);
                return undefined;
            }
            _this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
            _this8.cacheTokens();
            if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) return callback.onSuccess(_this8.signInUserSession);
            var authenticationHelper = new (0, $88865c6be67431f3$export$2e2bcd8739ae039)(_this8.pool.getUserPoolName());
            authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
                if (errGenHash) return callback.onFailure(errGenHash);
                var deviceSecretVerifierConfig = {
                    Salt: (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                    PasswordVerifier: (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
                };
                _this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
                _this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
                _this8.randomPassword = authenticationHelper.getRandomPassword();
                _this8.client.request("ConfirmDevice", {
                    DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
                    AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
                    DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                    DeviceName: $a44bf0d9fbe2b4df$var$userAgent
                }, function(errConfirm, dataConfirm) {
                    if (errConfirm) return callback.onFailure(errConfirm);
                    _this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                    _this8.cacheDeviceKeyAndPassword();
                    if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
                    return callback.onSuccess(_this8.signInUserSession);
                });
                return undefined;
            });
            return undefined;
        });
    } /**
   * This is used by an authenticated user to change the current password
   * @param {string} oldUserPassword The current password.
   * @param {string} newUserPassword The requested new password.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("ChangePassword", {
            PreviousPassword: oldUserPassword,
            ProposedPassword: newUserPassword,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.enableMFA = function enableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        var mfaEnabled = {
            DeliveryMedium: "SMS",
            AttributeName: "phone_number"
        };
        mfaOptions.push(mfaEnabled);
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @param {IMfaSettings} smsMfaSettings the sms mfa settings
   * @param {IMFASettings} softwareTokenMfaSettings the software token mfa settings
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("SetUserMFAPreference", {
            SMSMfaSettings: smsMfaSettings,
            SoftwareTokenMfaSettings: softwareTokenMfaSettings,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to disable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.disableMFA = function disableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to delete itself
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.deleteUser = function deleteUser(callback, clientMetadata) {
        var _this9 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            _this9.clearCachedUser();
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to change a list of attributes
   * @param {AttributeArg[]} attributes A list of the new user attributes.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.updateAttributes = function updateAttributes(attributes, callback, clientMetadata) {
        var _this10 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("UpdateUserAttributes", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserAttributes: attributes,
            ClientMetadata: clientMetadata
        }, function(err, result) {
            if (err) return callback(err, null);
            // update cached user
            return _this10.getUserData(function() {
                return callback(null, "SUCCESS", result);
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by an authenticated user to get a list of attributes
   * @param {nodeCallback<CognitoUserAttribute[]>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getUserAttributes = function getUserAttributes(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            var attributeList = [];
            for(var i = 0; i < userData.UserAttributes.length; i++){
                var attribute = {
                    Name: userData.UserAttributes[i].Name,
                    Value: userData.UserAttributes[i].Value
                };
                var userAttribute = new (0, $559b6e1d514a188f$export$2e2bcd8739ae039)(attribute);
                attributeList.push(userAttribute);
            }
            return callback(null, attributeList);
        });
        return undefined;
    } /**
   * This was previously used by an authenticated user to get MFAOptions,
   * but no longer returns a meaningful response. Refer to the documentation for
   * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
   * @deprecated
   * @param {nodeCallback<MFAOptions>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getMFAOptions = function getMFAOptions(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            return callback(null, userData.MFAOptions);
        });
        return undefined;
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.createGetUserRequest = function createGetUserRequest() {
        return this.client.promisifyRequest("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.refreshSessionIfPossible = function refreshSessionIfPossible(options) {
        var _this11 = this;
        if (options === void 0) options = {};
        // best effort, if not possible
        return new Promise(function(resolve) {
            var refresh = _this11.signInUserSession.getRefreshToken();
            if (refresh && refresh.getToken()) _this11.refreshSession(refresh, resolve, options.clientMetadata);
            else resolve();
        });
    } /**
   * This is used by an authenticated users to get the userData
   * @param {nodeCallback<UserData>} callback Called on success or error.
   * @param {GetUserDataOptions} params
   * @returns {void}
   */ ;
    _proto.getUserData = function getUserData(callback, params) {
        var _this12 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
            this.clearCachedUserData();
            return callback(new Error("User is not authenticated"), null);
        }
        var userData = this.getUserDataFromCache();
        if (!userData) {
            this.fetchUserData().then(function(data) {
                callback(null, data);
            })["catch"](callback);
            return;
        }
        if (this.isFetchUserDataAndTokenRequired(params)) {
            this.fetchUserData().then(function(data) {
                return _this12.refreshSessionIfPossible(params).then(function() {
                    return data;
                });
            }).then(function(data) {
                return callback(null, data);
            })["catch"](callback);
            return;
        }
        try {
            callback(null, JSON.parse(userData));
            return;
        } catch (err) {
            this.clearCachedUserData();
            callback(err, null);
            return;
        }
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.getUserDataFromCache = function getUserDataFromCache() {
        var userData = this.storage.getItem(this.userDataKey);
        return userData;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.isFetchUserDataAndTokenRequired = function isFetchUserDataAndTokenRequired(params) {
        var _ref = params || {}, _ref$bypassCache = _ref.bypassCache, bypassCache = _ref$bypassCache === void 0 ? false : _ref$bypassCache;
        return bypassCache;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.fetchUserData = function fetchUserData() {
        var _this13 = this;
        return this.createGetUserRequest().then(function(data) {
            _this13.cacheUserData(data);
            return data;
        });
    } /**
   * This is used by an authenticated user to delete a list of attributes
   * @param {string[]} attributeList Names of the attributes to delete.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.deleteAttributes = function deleteAttributes(attributeList, callback) {
        var _this14 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUserAttributes", {
            UserAttributeNames: attributeList,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            // update cached user
            return _this14.getUserData(function() {
                return callback(null, "SUCCESS");
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by a user to resend a confirmation code
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        this.client.request("ResendConfirmationCode", jsonReq, function(err, result) {
            if (err) return callback(err, null);
            return callback(null, result);
        });
    } /**
   * This is used to get a session, either from the session object
   * or from  the local storage, or by using a refresh token
   *
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {GetSessionOptions} options
   * @returns {void}
   */ ;
    _proto.getSession = function getSession(callback, options) {
        if (options === void 0) options = {};
        if (this.username == null) return callback(new Error("Username is null. Cannot retrieve a new session"), null);
        if (this.signInUserSession != null && this.signInUserSession.isValid()) return callback(null, this.signInUserSession);
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var idTokenKey = keyPrefix + ".idToken";
        var accessTokenKey = keyPrefix + ".accessToken";
        var refreshTokenKey = keyPrefix + ".refreshToken";
        var clockDriftKey = keyPrefix + ".clockDrift";
        if (this.storage.getItem(idTokenKey)) {
            var idToken = new (0, $d9c1dd270429cf89$export$2e2bcd8739ae039)({
                IdToken: this.storage.getItem(idTokenKey)
            });
            var accessToken = new (0, $41c9382bb6a72dfa$export$2e2bcd8739ae039)({
                AccessToken: this.storage.getItem(accessTokenKey)
            });
            var refreshToken = new (0, $fdaf527344dd671b$export$2e2bcd8739ae039)({
                RefreshToken: this.storage.getItem(refreshTokenKey)
            });
            var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;
            var sessionData = {
                IdToken: idToken,
                AccessToken: accessToken,
                RefreshToken: refreshToken,
                ClockDrift: clockDrift
            };
            var cachedSession = new (0, $45e3ad811e5296cd$export$2e2bcd8739ae039)(sessionData);
            if (cachedSession.isValid()) {
                this.signInUserSession = cachedSession;
                return callback(null, this.signInUserSession);
            }
            if (!refreshToken.getToken()) return callback(new Error("Cannot retrieve a new session. Please authenticate."), null);
            this.refreshSession(refreshToken, callback, options.clientMetadata);
        } else callback(new Error("Local storage is missing an ID Token, Please authenticate"), null);
        return undefined;
    } /**
   * This uses the refreshToken to retrieve a new session
   * @param {CognitoRefreshToken} refreshToken A previous session's refresh token.
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.refreshSession = function refreshSession(refreshToken, callback, clientMetadata) {
        var _this15 = this;
        var wrappedCallback = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(callback) : callback;
        var authParameters = {};
        authParameters.REFRESH_TOKEN = refreshToken.getToken();
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var lastUserKey = keyPrefix + ".LastAuthUser";
        if (this.storage.getItem(lastUserKey)) {
            this.username = this.storage.getItem(lastUserKey);
            var deviceKeyKey = keyPrefix + "." + this.username + ".deviceKey";
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            authParameters.DEVICE_KEY = this.deviceKey;
        }
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            AuthFlow: "REFRESH_TOKEN_AUTH",
            AuthParameters: authParameters,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) {
                if (err.code === "NotAuthorizedException") _this15.clearCachedUser();
                return wrappedCallback(err, null);
            }
            if (authResult) {
                var authenticationResult = authResult.AuthenticationResult;
                if (!Object.prototype.hasOwnProperty.call(authenticationResult, "RefreshToken")) authenticationResult.RefreshToken = refreshToken.getToken();
                _this15.signInUserSession = _this15.getCognitoUserSession(authenticationResult);
                _this15.cacheTokens();
                return wrappedCallback(null, _this15.signInUserSession);
            }
            return undefined;
        });
    } /**
   * This is used to save the session tokens to local storage
   * @returns {void}
   */ ;
    _proto.cacheTokens = function cacheTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
        this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
        this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
        this.storage.setItem(clockDriftKey, "" + this.signInUserSession.getClockDrift());
        this.storage.setItem(lastUserKey, this.username);
    } /**
   * This is to cache user data
   */ ;
    _proto.cacheUserData = function cacheUserData(userData) {
        this.storage.setItem(this.userDataKey, JSON.stringify(userData));
    } /**
   * This is to remove cached user data
   */ ;
    _proto.clearCachedUserData = function clearCachedUserData() {
        this.storage.removeItem(this.userDataKey);
    };
    _proto.clearCachedUser = function clearCachedUser() {
        this.clearCachedTokens();
        this.clearCachedUserData();
    } /**
   * This is used to cache the device key and device group and device password
   * @returns {void}
   */ ;
    _proto.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.setItem(deviceKeyKey, this.deviceKey);
        this.storage.setItem(randomPasswordKey, this.randomPassword);
        this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
    } /**
   * This is used to get current device key and device group and device password
   * @returns {void}
   */ ;
    _proto.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        if (this.storage.getItem(deviceKeyKey)) {
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            this.randomPassword = this.storage.getItem(randomPasswordKey);
            this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
        }
    } /**
   * This is used to clear the device key info from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.removeItem(deviceKeyKey);
        this.storage.removeItem(randomPasswordKey);
        this.storage.removeItem(deviceGroupKeyKey);
    } /**
   * This is used to clear the session tokens from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedTokens = function clearCachedTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        this.storage.removeItem(idTokenKey);
        this.storage.removeItem(accessTokenKey);
        this.storage.removeItem(refreshTokenKey);
        this.storage.removeItem(lastUserKey);
        this.storage.removeItem(clockDriftKey);
    } /**
   * This is used to build a user session from tokens retrieved in the authentication result
   * @param {object} authResult Successful auth response from server.
   * @returns {CognitoUserSession} The new user session.
   * @private
   */ ;
    _proto.getCognitoUserSession = function getCognitoUserSession(authResult) {
        var idToken = new (0, $d9c1dd270429cf89$export$2e2bcd8739ae039)(authResult);
        var accessToken = new (0, $41c9382bb6a72dfa$export$2e2bcd8739ae039)(authResult);
        var refreshToken = new (0, $fdaf527344dd671b$export$2e2bcd8739ae039)(authResult);
        var sessionData = {
            IdToken: idToken,
            AccessToken: accessToken,
            RefreshToken: refreshToken
        };
        return new (0, $45e3ad811e5296cd$export$2e2bcd8739ae039)(sessionData);
    } /**
   * This is used to initiate a forgot password request
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode?} callback.inputVerificationCode
   *    Optional callback raised instead of onSuccess with response data.
   * @param {onSuccess} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.forgotPassword = function forgotPassword(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ForgotPassword", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess(data);
        });
    } /**
   * This is used to confirm a new password using a confirmationCode
   * @param {string} confirmationCode Code entered by user.
   * @param {string} newPassword Confirm new password.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<void>} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ConfirmationCode: confirmationCode,
            Password: newPassword,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmForgotPassword", jsonReq, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
    } /**
   * This is used to initiate an attribute confirmation request
   * @param {string} attributeName User attribute that needs confirmation.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode} callback.inputVerificationCode Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetUserAttributeVerificationCode", {
            AttributeName: attributeName,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to confirm an attribute using a confirmation code
   * @param {string} attributeName Attribute being confirmed.
   * @param {string} confirmationCode Code entered by user.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("VerifyUserAttribute", {
            AttributeName: attributeName,
            Code: confirmationCode,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to get the device information using the current device key
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device data.
   * @returns {void}
   */ ;
    _proto.getDevice = function getDevice(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to forget a specific device
   * @param {string} deviceKey Device key.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("ForgetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: deviceKey
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to forget the current device
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetDevice = function forgetDevice(callback) {
        var _this16 = this;
        this.forgetSpecificDevice(this.deviceKey, {
            onFailure: callback.onFailure,
            onSuccess: function onSuccess(result) {
                _this16.deviceKey = null;
                _this16.deviceGroupKey = null;
                _this16.randomPassword = null;
                _this16.clearCachedDeviceKeyAndPassword();
                return callback.onSuccess(result);
            }
        });
    } /**
   * This is used to set the device status as remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to set the device status as not remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "not_remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to list all devices for a user
   *
   * @param {int} limit the number of devices returned in a call
   * @param {string | null} paginationToken the pagination token in case any was returned before
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device list.
   * @returns {void}
   */ ;
    _proto.listDevices = function listDevices(limit, paginationToken, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        var requestParams = {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            Limit: limit
        };
        if (paginationToken) requestParams.PaginationToken = paginationToken;
        this.client.request("ListDevices", requestParams, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to globally revoke all tokens issued to a user
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.globalSignOut = function globalSignOut(callback) {
        var _this17 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GlobalSignOut", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            _this17.clearCachedUser();
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used for the user to signOut of the application and clear the cached tokens.
   * @returns {void}
   */ ;
    _proto.signOut = function signOut(revokeTokenCallback) {
        var _this18 = this;
        // If tokens won't be revoked, we just clean the client data.
        if (!revokeTokenCallback || typeof revokeTokenCallback !== "function") {
            this.cleanClientData();
            return;
        }
        this.getSession(function(error, _session) {
            if (error) return revokeTokenCallback(error);
            _this18.revokeTokens(function(err) {
                _this18.cleanClientData();
                revokeTokenCallback(err);
            });
        });
    };
    _proto.revokeTokens = function revokeTokens(revokeTokenCallback) {
        if (revokeTokenCallback === void 0) revokeTokenCallback = function revokeTokenCallback() {};
        if (typeof revokeTokenCallback !== "function") throw new Error("Invalid revokeTokenCallback. It should be a function.");
        var tokensToBeRevoked = [];
        if (!this.signInUserSession) {
            var error = new Error("User is not authenticated");
            return revokeTokenCallback(error);
        }
        if (!this.signInUserSession.getAccessToken()) {
            var _error = new Error("No Access token available");
            return revokeTokenCallback(_error);
        }
        var refreshToken = this.signInUserSession.getRefreshToken().getToken();
        var accessToken = this.signInUserSession.getAccessToken();
        if (this.isSessionRevocable(accessToken)) {
            if (refreshToken) return this.revokeToken({
                token: refreshToken,
                callback: revokeTokenCallback
            });
        }
        revokeTokenCallback();
    };
    _proto.isSessionRevocable = function isSessionRevocable(token) {
        if (token && typeof token.decodePayload === "function") try {
            var _token$decodePayload = token.decodePayload(), origin_jti = _token$decodePayload.origin_jti;
            return !!origin_jti;
        } catch (err) {
        // Nothing to do, token doesnt have origin_jti claim
        }
        return false;
    };
    _proto.cleanClientData = function cleanClientData() {
        this.signInUserSession = null;
        this.clearCachedUser();
    };
    _proto.revokeToken = function revokeToken(_ref2) {
        var token = _ref2.token, callback = _ref2.callback;
        this.client.requestWithRetry("RevokeToken", {
            Token: token,
            ClientId: this.pool.getClientId()
        }, function(err) {
            if (err) return callback(err);
            callback();
        });
    } /**
   * This is used by a user trying to select a given MFA
   * @param {string} answerChallenge the mfa the user wants
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
        var _this19 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var jsonReq = {
            ChallengeName: "SELECT_MFA_TYPE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            _this19.Session = data.Session;
            if (answerChallenge === "SMS_MFA") return callback.mfaRequired(data.ChallengeName, data.ChallengeParameters);
            if (answerChallenge === "SOFTWARE_TOKEN_MFA") return callback.totpRequired(data.ChallengeName, data.ChallengeParameters);
            return undefined;
        });
    } /**
   * This returns the user context data for advanced security feature.
   * @returns {string} the user context data from CognitoUserPool
   */ ;
    _proto.getUserContextData = function getUserContextData() {
        var pool = this.pool;
        return pool.getUserContextData(this.username);
    } /**
   * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.associateSoftwareToken = function associateSoftwareToken(callback) {
        var _this20 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("AssociateSoftwareToken", {
            Session: this.Session
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this20.Session = data.Session;
            return callback.associateSecretCode(data.SecretCode);
        });
        else this.client.request("AssociateSoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.associateSecretCode(data.SecretCode);
        });
    } /**
   * This is used by an authenticated or a user trying to authenticate to verify a TOTP MFA
   * @param {string} totpCode The MFA code entered by the user.
   * @param {string} friendlyDeviceName The device name we are assigning to the device.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
        var _this21 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("VerifySoftwareToken", {
            Session: this.Session,
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this21.Session = data.Session;
            var challengeResponses = {};
            challengeResponses.USERNAME = _this21.username;
            var jsonReq = {
                ChallengeName: "MFA_SETUP",
                ClientId: _this21.pool.getClientId(),
                ChallengeResponses: challengeResponses,
                Session: _this21.Session
            };
            if (_this21.getUserContextData()) jsonReq.UserContextData = _this21.getUserContextData();
            _this21.client.request("RespondToAuthChallenge", jsonReq, function(errRespond, dataRespond) {
                if (errRespond) return callback.onFailure(errRespond);
                _this21.signInUserSession = _this21.getCognitoUserSession(dataRespond.AuthenticationResult);
                _this21.cacheTokens();
                return callback.onSuccess(_this21.signInUserSession);
            });
            return undefined;
        });
        else this.client.request("VerifySoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
    };
    return CognitoUser;
}();



/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 

var $217cbcb095508b55$export$c388c654f0be37f3 = {
    None: "0",
    ReactNative: "1"
};
var $217cbcb095508b55$export$2ef00488675027c = "auth";


// constructor
function $a3aa897b4733833f$var$UserAgent() {}
// public
$a3aa897b4733833f$var$UserAgent.prototype.userAgent = (0, $37924787154e0cec$export$7935961ef7719cb0)();
var $a3aa897b4733833f$export$ad34c5a3baecdb02 = function appendToCognitoUserAgent(content) {
    if (!content) return;
    if ($a3aa897b4733833f$var$UserAgent.prototype.userAgent && !$a3aa897b4733833f$var$UserAgent.prototype.userAgent.includes(content)) $a3aa897b4733833f$var$UserAgent.prototype.userAgent = $a3aa897b4733833f$var$UserAgent.prototype.userAgent.concat(" ", content);
    if (!$a3aa897b4733833f$var$UserAgent.prototype.userAgent || $a3aa897b4733833f$var$UserAgent.prototype.userAgent === "") $a3aa897b4733833f$var$UserAgent.prototype.userAgent = content;
};
var $a3aa897b4733833f$export$523857f9fc06cb0d = function addAuthCategoryToCognitoUserAgent() {
    $a3aa897b4733833f$var$UserAgent.category = (0, $217cbcb095508b55$export$2ef00488675027c);
};
var $a3aa897b4733833f$export$972f94ce7a888cac = function addFrameworkToCognitoUserAgent(framework) {
    $a3aa897b4733833f$var$UserAgent.framework = framework;
};
var $a3aa897b4733833f$export$ede38edb26c0bfdf = function getAmplifyUserAgent(action) {
    var uaCategoryAction = $a3aa897b4733833f$var$UserAgent.category ? " " + $a3aa897b4733833f$var$UserAgent.category : "";
    var uaFramework = $a3aa897b4733833f$var$UserAgent.framework ? " framework/" + $a3aa897b4733833f$var$UserAgent.framework : "";
    var userAgent = "" + $a3aa897b4733833f$var$UserAgent.prototype.userAgent + uaCategoryAction + uaFramework;
    return userAgent;
};
var // class for defining the amzn user-agent
$a3aa897b4733833f$export$2e2bcd8739ae039 = $a3aa897b4733833f$var$UserAgent;


function $aad7c33fb80d1a83$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $aad7c33fb80d1a83$var$_setPrototypeOf(subClass, superClass);
}
function $aad7c33fb80d1a83$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $aad7c33fb80d1a83$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$aad7c33fb80d1a83$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $aad7c33fb80d1a83$var$_construct(Class, arguments, $aad7c33fb80d1a83$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $aad7c33fb80d1a83$var$_setPrototypeOf(Wrapper, Class);
    };
    return $aad7c33fb80d1a83$var$_wrapNativeSuper(Class);
}
function $aad7c33fb80d1a83$var$_construct(Parent, args, Class) {
    if ($aad7c33fb80d1a83$var$_isNativeReflectConstruct()) $aad7c33fb80d1a83$var$_construct = Reflect.construct.bind();
    else $aad7c33fb80d1a83$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $aad7c33fb80d1a83$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $aad7c33fb80d1a83$var$_construct.apply(null, arguments);
}
function $aad7c33fb80d1a83$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $aad7c33fb80d1a83$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $aad7c33fb80d1a83$var$_setPrototypeOf(o, p) {
    $aad7c33fb80d1a83$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $aad7c33fb80d1a83$var$_setPrototypeOf(o, p);
}
function $aad7c33fb80d1a83$var$_getPrototypeOf(o) {
    $aad7c33fb80d1a83$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $aad7c33fb80d1a83$var$_getPrototypeOf(o);
}
var $aad7c33fb80d1a83$var$CognitoError = /*#__PURE__*/ function(_Error) {
    $aad7c33fb80d1a83$var$_inheritsLoose(CognitoError, _Error);
    function CognitoError(message, code, name, statusCode) {
        var _this;
        _this = _Error.call(this, message) || this;
        _this.code = code;
        _this.name = name;
        _this.statusCode = statusCode;
        return _this;
    }
    return CognitoError;
}(/*#__PURE__*/ $aad7c33fb80d1a83$var$_wrapNativeSuper(Error));
/** @class */ var $aad7c33fb80d1a83$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AWS Cognito Identity Provider client object
   * @param {string} region AWS region
   * @param {string} endpoint endpoint
   * @param {object} fetchOptions options for fetch API (only credentials is supported)
   */ function Client(region, endpoint, fetchOptions) {
        this.endpoint = endpoint || "https://cognito-idp." + region + ".amazonaws.com/";
        var _ref = fetchOptions || {}, credentials = _ref.credentials;
        this.fetchOptions = credentials ? {
            credentials: credentials
        } : {};
    }
    /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @returns Promise<object>
   */ var _proto = Client.prototype;
    _proto.promisifyRequest = function promisifyRequest(operation, params) {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.request(operation, params, function(err, data) {
                if (err) reject(new $aad7c33fb80d1a83$var$CognitoError(err.message, err.code, err.name, err.statusCode));
                else resolve(data);
            });
        });
    };
    _proto.requestWithRetry = function requestWithRetry(operation, params, callback) {
        var _this3 = this;
        var MAX_DELAY_IN_MILLIS = 5000;
        $aad7c33fb80d1a83$var$jitteredExponentialRetry(function(p) {
            return new Promise(function(res, rej) {
                _this3.request(operation, p, function(error, result) {
                    if (error) rej(error);
                    else res(result);
                });
            });
        }, [
            params
        ], MAX_DELAY_IN_MILLIS).then(function(result) {
            return callback(null, result);
        })["catch"](function(error) {
            return callback(error);
        });
    } /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @param {function} callback Callback called when a response is returned
   * @returns {void}
   */ ;
    _proto.request = function request(operation, params, callback) {
        var headers = {
            "Content-Type": "application/x-amz-json-1.1",
            "X-Amz-Target": "AWSCognitoIdentityProviderService." + operation,
            "X-Amz-User-Agent": (0, $a3aa897b4733833f$export$ede38edb26c0bfdf)(),
            "Cache-Control": "no-store"
        };
        var options = Object.assign({}, this.fetchOptions, {
            headers: headers,
            method: "POST",
            mode: "cors",
            body: JSON.stringify(params)
        });
        var response;
        var responseJsonData;
        fetch(this.endpoint, options).then(function(resp) {
            response = resp;
            return resp;
        }, function(err) {
            // If error happens here, the request failed
            // if it is TypeError throw network error
            if (err instanceof TypeError) throw new Error("Network error");
            throw err;
        }).then(function(resp) {
            return resp.json()["catch"](function() {
                return {};
            });
        }).then(function(data) {
            // return parsed body stream
            if (response.ok) return callback(null, data);
            responseJsonData = data;
            // Taken from aws-sdk-js/lib/protocol/json.js
            // eslint-disable-next-line no-underscore-dangle
            var code = (data.__type || data.code).split("#").pop();
            var error = new Error(data.message || data.Message || null);
            error.name = code;
            error.code = code;
            return callback(error);
        })["catch"](function(err) {
            // first check if we have a service error
            if (response && response.headers && response.headers.get("x-amzn-errortype")) try {
                var code = response.headers.get("x-amzn-errortype").split(":")[0];
                var error = new Error(response.status ? response.status.toString() : null);
                error.code = code;
                error.name = code;
                error.statusCode = response.status;
                return callback(error);
            } catch (ex) {
                return callback(err);
            }
            else if (err instanceof Error && err.message === "Network error") err.code = "NetworkError";
            return callback(err);
        });
    };
    return Client;
}();
var $aad7c33fb80d1a83$var$logger = {
    debug: function debug() {
    // Intentionally blank. This package doesn't have logging
    }
};
/**
 * For now, all errors are retryable.
 */ var $aad7c33fb80d1a83$var$NonRetryableError = /*#__PURE__*/ function(_Error2) {
    $aad7c33fb80d1a83$var$_inheritsLoose(NonRetryableError, _Error2);
    function NonRetryableError(message) {
        var _this4;
        _this4 = _Error2.call(this, message) || this;
        _this4.nonRetryable = true;
        return _this4;
    }
    return NonRetryableError;
}(/*#__PURE__*/ $aad7c33fb80d1a83$var$_wrapNativeSuper(Error));
var $aad7c33fb80d1a83$var$isNonRetryableError = function isNonRetryableError(obj) {
    var key = "nonRetryable";
    return obj && obj[key];
};
function $aad7c33fb80d1a83$var$retry(functionToRetry, args, delayFn, attempt) {
    if (attempt === void 0) attempt = 1;
    if (typeof functionToRetry !== "function") throw Error("functionToRetry must be a function");
    $aad7c33fb80d1a83$var$logger.debug(functionToRetry.name + " attempt #" + attempt + " with args: " + JSON.stringify(args));
    return functionToRetry.apply(void 0, args)["catch"](function(err) {
        $aad7c33fb80d1a83$var$logger.debug("error on " + functionToRetry.name, err);
        if ($aad7c33fb80d1a83$var$isNonRetryableError(err)) {
            $aad7c33fb80d1a83$var$logger.debug(functionToRetry.name + " non retryable error", err);
            throw err;
        }
        var retryIn = delayFn(attempt, args, err);
        $aad7c33fb80d1a83$var$logger.debug(functionToRetry.name + " retrying in " + retryIn + " ms");
        if (retryIn !== false) return new Promise(function(res) {
            return setTimeout(res, retryIn);
        }).then(function() {
            return $aad7c33fb80d1a83$var$retry(functionToRetry, args, delayFn, attempt + 1);
        });
        else throw err;
    });
}
function $aad7c33fb80d1a83$var$jitteredBackoff(maxDelayMs) {
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var $aad7c33fb80d1a83$var$MAX_DELAY_MS = 300000;
function $aad7c33fb80d1a83$var$jitteredExponentialRetry(functionToRetry, args, maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = $aad7c33fb80d1a83$var$MAX_DELAY_MS;
    return $aad7c33fb80d1a83$var$retry(functionToRetry, args, $aad7c33fb80d1a83$var$jitteredBackoff(maxDelayMs));
}




var $eb46ddfd02c1d36e$var$USER_POOL_ID_MAX_LENGTH = 55;
/** @class */ var $eb46ddfd02c1d36e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserPool object
   * @param {object} data Creation options.
   * @param {string} data.UserPoolId Cognito user pool id.
   * @param {string} data.ClientId User pool application client id.
   * @param {string} data.endpoint Optional custom service endpoint.
   * @param {object} data.fetchOptions Optional options for fetch API.
   *        (only credentials option is supported)
   * @param {object} data.Storage Optional storage object.
   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
   *        boolean flag indicating if the data collection is enabled
   *        to support cognito advanced security features. By default, this
   *        flag is set to true.
   */ function CognitoUserPool(data, wrapRefreshSessionCallback) {
        var _ref = data || {}, UserPoolId = _ref.UserPoolId, ClientId = _ref.ClientId, endpoint = _ref.endpoint, fetchOptions = _ref.fetchOptions, AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;
        if (!UserPoolId || !ClientId) throw new Error("Both UserPoolId and ClientId are required.");
        if (UserPoolId.length > $eb46ddfd02c1d36e$var$USER_POOL_ID_MAX_LENGTH || !/^[\w-]+_[0-9a-zA-Z]+$/.test(UserPoolId)) throw new Error("Invalid UserPoolId format.");
        var region = UserPoolId.split("_")[0];
        this.userPoolId = UserPoolId;
        this.clientId = ClientId;
        this.client = new (0, $aad7c33fb80d1a83$export$2e2bcd8739ae039)(region, endpoint, fetchOptions);
        /**
     * By default, AdvancedSecurityDataCollectionFlag is set to true,
     * if no input value is provided.
     */ this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;
        this.storage = data.Storage || new (0, $d3c0ec7e73282823$export$2e2bcd8739ae039)().getStorage();
        if (wrapRefreshSessionCallback) this.wrapRefreshSessionCallback = wrapRefreshSessionCallback;
    }
    /**
   * @returns {string} the user pool id
   */ var _proto = CognitoUserPool.prototype;
    _proto.getUserPoolId = function getUserPoolId() {
        return this.userPoolId;
    } /**
   * @returns {string} the user pool name
   */ ;
    _proto.getUserPoolName = function getUserPoolName() {
        return this.getUserPoolId().split("_")[1];
    } /**
   * @returns {string} the client id
   */ ;
    _proto.getClientId = function getClientId() {
        return this.clientId;
    } /**
   * method for signing up a user
   * @param {string} username User's username.
   * @param {string} password Plain-text initial password entered by user.
   * @param {(AttributeArg[])=} userAttributes New user attributes.
   * @param {(AttributeArg[])=} validationData Application metadata.
   * @param {(AttributeArg[])=} clientMetadata Client metadata.
   * @param {nodeCallback<SignUpResult>} callback Called on error or with the new user.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata) {
        var _this = this;
        var jsonReq = {
            ClientId: this.clientId,
            Username: username,
            Password: password,
            UserAttributes: userAttributes,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData(username)) jsonReq.UserContextData = this.getUserContextData(username);
        this.client.request("SignUp", jsonReq, function(err, data) {
            if (err) return callback(err, null);
            var cognitoUser = {
                Username: username,
                Pool: _this,
                Storage: _this.storage
            };
            var returnData = {
                user: new (0, $a44bf0d9fbe2b4df$export$2e2bcd8739ae039)(cognitoUser),
                userConfirmed: data.UserConfirmed,
                userSub: data.UserSub,
                codeDeliveryDetails: data.CodeDeliveryDetails
            };
            return callback(null, returnData);
        });
    } /**
   * method for getting the current user of the application from the local storage
   *
   * @returns {CognitoUser} the user retrieved from storage
   */ ;
    _proto.getCurrentUser = function getCurrentUser() {
        var lastUserKey = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser";
        var lastAuthUser = this.storage.getItem(lastUserKey);
        if (lastAuthUser) {
            var cognitoUser = {
                Username: lastAuthUser,
                Pool: this,
                Storage: this.storage
            };
            return new (0, $a44bf0d9fbe2b4df$export$2e2bcd8739ae039)(cognitoUser);
        }
        return null;
    } /**
   * This method returns the encoded data string used for cognito advanced security feature.
   * This would be generated only when developer has included the JS used for collecting the
   * data on their client. Please refer to documentation to know more about using AdvancedSecurity
   * features
   * @param {string} username the username for the context data
   * @returns {string} the user context data
   **/ ;
    _proto.getUserContextData = function getUserContextData(username) {
        if (typeof AmazonCognitoAdvancedSecurityData === "undefined") return undefined;
        /* eslint-disable */ var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
        /* eslint-enable */ if (this.advancedSecurityDataCollectionFlag) {
            var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
            if (advancedSecurityData) {
                var userContextData = {
                    EncodedData: advancedSecurityData
                };
                return userContextData;
            }
        }
        return {};
    };
    return CognitoUserPool;
}();



var $de309840e50e5fe9$exports = {};
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    $de309840e50e5fe9$exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});


/** @class */ var $7bb5d86070c49555$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CookieStorage object
   * @param {object} data Creation options.
   * @param {string} data.domain Cookies domain (default: domain of the page
   * 				where the cookie was created, excluding subdomains)
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   * @param {string} data.sameSite Cookie request behavior (default: null)
   */ function CookieStorage(data) {
        if (data === void 0) data = {};
        if (data.domain) this.domain = data.domain;
        if (data.path) this.path = data.path;
        else this.path = "/";
        if (Object.prototype.hasOwnProperty.call(data, "expires")) this.expires = data.expires;
        else this.expires = 365;
        if (Object.prototype.hasOwnProperty.call(data, "secure")) this.secure = data.secure;
        else this.secure = true;
        if (Object.prototype.hasOwnProperty.call(data, "sameSite")) {
            if (![
                "strict",
                "lax",
                "none"
            ].includes(data.sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (data.sameSite === "none" && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
            this.sameSite = data.sameSite;
        } else this.sameSite = null;
    }
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ var _proto = CookieStorage.prototype;
    _proto.setItem = function setItem(key, value) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        $de309840e50e5fe9$exports.set(key, value, options);
        return $de309840e50e5fe9$exports.get(key);
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    _proto.getItem = function getItem(key) {
        return $de309840e50e5fe9$exports.get(key);
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */ ;
    _proto.removeItem = function removeItem(key) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        return $de309840e50e5fe9$exports.remove(key, options);
    } /**
   * This is used to clear the storage of optional
   * items that were previously set
   * @returns {} an empty object
   */ ;
    _proto.clear = function clear() {
        var cookies = $de309840e50e5fe9$exports.get();
        var numKeys = Object.keys(cookies).length;
        for(var index = 0; index < numKeys; ++index)this.removeItem(Object.keys(cookies)[index]);
        return {};
    };
    return CookieStorage;
}();











var $eAyj5 = parcelRequire("eAyj5");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $eAyj5 = parcelRequire("eAyj5");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $3f5f5e56dab920f9$var$SELF = "_self";
var $3f5f5e56dab920f9$export$9b38228bd9928080 = function(url) {
    var windowProxy = window.open(url, $3f5f5e56dab920f9$var$SELF);
    if (windowProxy) return Promise.resolve(windowProxy);
    else return Promise.reject();
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $d0a58259f3672a68$export$42fffed799c298bb = function(state) {
    window.sessionStorage.setItem("oauth_state", state);
};
var $d0a58259f3672a68$export$50fdfeece43146fd = function() {
    var oauth_state = window.sessionStorage.getItem("oauth_state");
    window.sessionStorage.removeItem("oauth_state");
    return oauth_state;
};
var $d0a58259f3672a68$export$14934cb45d589fa1 = function(private_key) {
    window.sessionStorage.setItem("ouath_pkce_key", private_key);
};
var $d0a58259f3672a68$export$742ac7ded61fbfce = function() {
    var ouath_pkce_key = window.sessionStorage.getItem("ouath_pkce_key");
    window.sessionStorage.removeItem("ouath_pkce_key");
    return ouath_pkce_key;
};
var $d0a58259f3672a68$export$1042faa6df30c26 = function() {
    window.sessionStorage.removeItem("ouath_pkce_key");
    window.sessionStorage.removeItem("oauth_state");
};


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $b7db0505e9467abd$export$a143d493d941bafc;
var $b7db0505e9467abd$export$e4cf37d7f6fb9e0a;
var $b7db0505e9467abd$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $b7db0505e9467abd$export$599f31c3813fae4d;
"use strict";

var $3nocJ = parcelRequire("3nocJ");

var $gU9iR = parcelRequire("gU9iR");
var $75331489c54d4d5e$exports = {};
var $75331489c54d4d5e$var$toString = {}.toString;
$75331489c54d4d5e$exports = Array.isArray || function(arr) {
    return $75331489c54d4d5e$var$toString.call(arr) == "[object Array]";
};


$b7db0505e9467abd$export$a143d493d941bafc = $b7db0505e9467abd$var$Buffer;
$b7db0505e9467abd$export$e4cf37d7f6fb9e0a = $b7db0505e9467abd$var$SlowBuffer;
$b7db0505e9467abd$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $b7db0505e9467abd$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $b7db0505e9467abd$var$typedArraySupport();
$b7db0505e9467abd$export$599f31c3813fae4d = $b7db0505e9467abd$var$kMaxLength();
function $b7db0505e9467abd$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $b7db0505e9467abd$var$kMaxLength() {
    return $b7db0505e9467abd$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $b7db0505e9467abd$var$createBuffer(that, length) {
    if ($b7db0505e9467abd$var$kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if ($b7db0505e9467abd$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $b7db0505e9467abd$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $b7db0505e9467abd$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $b7db0505e9467abd$var$Buffer(arg, encodingOrOffset, length) {
    if (!$b7db0505e9467abd$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $b7db0505e9467abd$var$Buffer)) return new $b7db0505e9467abd$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return $b7db0505e9467abd$var$allocUnsafe(this, arg);
    }
    return $b7db0505e9467abd$var$from(this, arg, encodingOrOffset, length);
}
$b7db0505e9467abd$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$b7db0505e9467abd$var$Buffer._augment = function(arr) {
    arr.__proto__ = $b7db0505e9467abd$var$Buffer.prototype;
    return arr;
};
function $b7db0505e9467abd$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return $b7db0505e9467abd$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return $b7db0505e9467abd$var$fromString(that, value, encodingOrOffset);
    return $b7db0505e9467abd$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $b7db0505e9467abd$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $b7db0505e9467abd$var$from(null, value, encodingOrOffset, length);
};
if ($b7db0505e9467abd$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $b7db0505e9467abd$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $b7db0505e9467abd$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && $b7db0505e9467abd$var$Buffer[Symbol.species] === $b7db0505e9467abd$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($b7db0505e9467abd$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $b7db0505e9467abd$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $b7db0505e9467abd$var$alloc(that, size, fill, encoding) {
    $b7db0505e9467abd$var$assertSize(size);
    if (size <= 0) return $b7db0505e9467abd$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? $b7db0505e9467abd$var$createBuffer(that, size).fill(fill, encoding) : $b7db0505e9467abd$var$createBuffer(that, size).fill(fill);
    return $b7db0505e9467abd$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $b7db0505e9467abd$var$Buffer.alloc = function(size, fill, encoding) {
    return $b7db0505e9467abd$var$alloc(null, size, fill, encoding);
};
function $b7db0505e9467abd$var$allocUnsafe(that, size) {
    $b7db0505e9467abd$var$assertSize(size);
    that = $b7db0505e9467abd$var$createBuffer(that, size < 0 ? 0 : $b7db0505e9467abd$var$checked(size) | 0);
    if (!$b7db0505e9467abd$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $b7db0505e9467abd$var$Buffer.allocUnsafe = function(size) {
    return $b7db0505e9467abd$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $b7db0505e9467abd$var$Buffer.allocUnsafeSlow = function(size) {
    return $b7db0505e9467abd$var$allocUnsafe(null, size);
};
function $b7db0505e9467abd$var$fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$b7db0505e9467abd$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $b7db0505e9467abd$var$byteLength(string, encoding) | 0;
    that = $b7db0505e9467abd$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $b7db0505e9467abd$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $b7db0505e9467abd$var$checked(array.length) | 0;
    that = $b7db0505e9467abd$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $b7db0505e9467abd$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($b7db0505e9467abd$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $b7db0505e9467abd$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $b7db0505e9467abd$var$fromArrayLike(that, array);
    return that;
}
function $b7db0505e9467abd$var$fromObject(that, obj) {
    if ($b7db0505e9467abd$var$Buffer.isBuffer(obj)) {
        var len = $b7db0505e9467abd$var$checked(obj.length) | 0;
        that = $b7db0505e9467abd$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || $b7db0505e9467abd$var$isnan(obj.length)) return $b7db0505e9467abd$var$createBuffer(that, 0);
            return $b7db0505e9467abd$var$fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && $75331489c54d4d5e$exports(obj.data)) return $b7db0505e9467abd$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function $b7db0505e9467abd$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $b7db0505e9467abd$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $b7db0505e9467abd$var$kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function $b7db0505e9467abd$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $b7db0505e9467abd$var$Buffer.alloc(+length);
}
$b7db0505e9467abd$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$b7db0505e9467abd$var$Buffer.compare = function compare(a, b) {
    if (!$b7db0505e9467abd$var$Buffer.isBuffer(a) || !$b7db0505e9467abd$var$Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$b7db0505e9467abd$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$b7db0505e9467abd$var$Buffer.concat = function concat(list, length) {
    if (!$75331489c54d4d5e$exports(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $b7db0505e9467abd$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $b7db0505e9467abd$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$b7db0505e9467abd$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $b7db0505e9467abd$var$byteLength(string, encoding) {
    if ($b7db0505e9467abd$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return $b7db0505e9467abd$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $b7db0505e9467abd$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $b7db0505e9467abd$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$b7db0505e9467abd$var$Buffer.byteLength = $b7db0505e9467abd$var$byteLength;
function $b7db0505e9467abd$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $b7db0505e9467abd$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $b7db0505e9467abd$var$utf8Slice(this, start, end);
        case "ascii":
            return $b7db0505e9467abd$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $b7db0505e9467abd$var$latin1Slice(this, start, end);
        case "base64":
            return $b7db0505e9467abd$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $b7db0505e9467abd$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$b7db0505e9467abd$var$Buffer.prototype._isBuffer = true;
function $b7db0505e9467abd$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$b7db0505e9467abd$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$b7db0505e9467abd$var$swap(this, i, i + 1);
    return this;
};
$b7db0505e9467abd$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $b7db0505e9467abd$var$swap(this, i, i + 3);
        $b7db0505e9467abd$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$b7db0505e9467abd$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $b7db0505e9467abd$var$swap(this, i, i + 7);
        $b7db0505e9467abd$var$swap(this, i + 1, i + 6);
        $b7db0505e9467abd$var$swap(this, i + 2, i + 5);
        $b7db0505e9467abd$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$b7db0505e9467abd$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return $b7db0505e9467abd$var$utf8Slice(this, 0, length);
    return $b7db0505e9467abd$var$slowToString.apply(this, arguments);
};
$b7db0505e9467abd$var$Buffer.prototype.equals = function equals(b) {
    if (!$b7db0505e9467abd$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $b7db0505e9467abd$var$Buffer.compare(this, b) === 0;
};
$b7db0505e9467abd$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $b7db0505e9467abd$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
$b7db0505e9467abd$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$b7db0505e9467abd$var$Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $b7db0505e9467abd$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $b7db0505e9467abd$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($b7db0505e9467abd$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $b7db0505e9467abd$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($b7db0505e9467abd$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $b7db0505e9467abd$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $b7db0505e9467abd$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$b7db0505e9467abd$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$b7db0505e9467abd$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $b7db0505e9467abd$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$b7db0505e9467abd$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $b7db0505e9467abd$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $b7db0505e9467abd$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $b7db0505e9467abd$var$utf8Write(buf, string, offset, length) {
    return $b7db0505e9467abd$var$blitBuffer($b7db0505e9467abd$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $b7db0505e9467abd$var$asciiWrite(buf, string, offset, length) {
    return $b7db0505e9467abd$var$blitBuffer($b7db0505e9467abd$var$asciiToBytes(string), buf, offset, length);
}
function $b7db0505e9467abd$var$latin1Write(buf, string, offset, length) {
    return $b7db0505e9467abd$var$asciiWrite(buf, string, offset, length);
}
function $b7db0505e9467abd$var$base64Write(buf, string, offset, length) {
    return $b7db0505e9467abd$var$blitBuffer($b7db0505e9467abd$var$base64ToBytes(string), buf, offset, length);
}
function $b7db0505e9467abd$var$ucs2Write(buf, string, offset, length) {
    return $b7db0505e9467abd$var$blitBuffer($b7db0505e9467abd$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$b7db0505e9467abd$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $b7db0505e9467abd$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $b7db0505e9467abd$var$utf8Write(this, string, offset, length);
        case "ascii":
            return $b7db0505e9467abd$var$asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return $b7db0505e9467abd$var$latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $b7db0505e9467abd$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $b7db0505e9467abd$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$b7db0505e9467abd$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $b7db0505e9467abd$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3nocJ.fromByteArray(buf);
    else return $3nocJ.fromByteArray(buf.slice(start, end));
}
function $b7db0505e9467abd$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $b7db0505e9467abd$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $b7db0505e9467abd$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $b7db0505e9467abd$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $b7db0505e9467abd$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $b7db0505e9467abd$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $b7db0505e9467abd$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $b7db0505e9467abd$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $b7db0505e9467abd$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $b7db0505e9467abd$var$toHex(buf[i]);
    return out;
}
function $b7db0505e9467abd$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$b7db0505e9467abd$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($b7db0505e9467abd$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $b7db0505e9467abd$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $b7db0505e9467abd$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $b7db0505e9467abd$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$b7db0505e9467abd$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $b7db0505e9467abd$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$b7db0505e9467abd$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $b7db0505e9467abd$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$b7db0505e9467abd$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $b7db0505e9467abd$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$b7db0505e9467abd$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $b7db0505e9467abd$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$b7db0505e9467abd$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $b7db0505e9467abd$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$b7db0505e9467abd$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $b7db0505e9467abd$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$b7db0505e9467abd$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $b7db0505e9467abd$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$b7db0505e9467abd$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $b7db0505e9467abd$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$b7db0505e9467abd$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $b7db0505e9467abd$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$b7db0505e9467abd$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $b7db0505e9467abd$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$b7db0505e9467abd$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $b7db0505e9467abd$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$b7db0505e9467abd$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $b7db0505e9467abd$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$b7db0505e9467abd$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $b7db0505e9467abd$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$b7db0505e9467abd$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $b7db0505e9467abd$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$b7db0505e9467abd$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $b7db0505e9467abd$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, true, 23, 4);
};
$b7db0505e9467abd$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $b7db0505e9467abd$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, false, 23, 4);
};
$b7db0505e9467abd$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $b7db0505e9467abd$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, true, 52, 8);
};
$b7db0505e9467abd$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $b7db0505e9467abd$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, false, 52, 8);
};
function $b7db0505e9467abd$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$b7db0505e9467abd$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$b7db0505e9467abd$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $b7db0505e9467abd$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$b7db0505e9467abd$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $b7db0505e9467abd$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$b7db0505e9467abd$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $b7db0505e9467abd$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$b7db0505e9467abd$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $b7db0505e9467abd$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$b7db0505e9467abd$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $b7db0505e9467abd$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($b7db0505e9467abd$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $b7db0505e9467abd$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$b7db0505e9467abd$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $b7db0505e9467abd$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($b7db0505e9467abd$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $b7db0505e9467abd$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $b7db0505e9467abd$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$b7db0505e9467abd$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $b7db0505e9467abd$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($b7db0505e9467abd$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $b7db0505e9467abd$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$b7db0505e9467abd$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $b7db0505e9467abd$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($b7db0505e9467abd$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $b7db0505e9467abd$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$b7db0505e9467abd$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $b7db0505e9467abd$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$b7db0505e9467abd$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $b7db0505e9467abd$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$b7db0505e9467abd$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $b7db0505e9467abd$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$b7db0505e9467abd$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$b7db0505e9467abd$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $b7db0505e9467abd$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($b7db0505e9467abd$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $b7db0505e9467abd$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$b7db0505e9467abd$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $b7db0505e9467abd$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($b7db0505e9467abd$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $b7db0505e9467abd$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$b7db0505e9467abd$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $b7db0505e9467abd$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($b7db0505e9467abd$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $b7db0505e9467abd$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$b7db0505e9467abd$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $b7db0505e9467abd$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($b7db0505e9467abd$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $b7db0505e9467abd$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $b7db0505e9467abd$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $b7db0505e9467abd$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $b7db0505e9467abd$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$b7db0505e9467abd$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $b7db0505e9467abd$var$writeFloat(this, value, offset, true, noAssert);
};
$b7db0505e9467abd$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $b7db0505e9467abd$var$writeFloat(this, value, offset, false, noAssert);
};
function $b7db0505e9467abd$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $b7db0505e9467abd$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$b7db0505e9467abd$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $b7db0505e9467abd$var$writeDouble(this, value, offset, true, noAssert);
};
$b7db0505e9467abd$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $b7db0505e9467abd$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$b7db0505e9467abd$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$b7db0505e9467abd$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$b7db0505e9467abd$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$b7db0505e9467abd$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $b7db0505e9467abd$var$Buffer.isBuffer(val) ? val : $b7db0505e9467abd$var$utf8ToBytes(new $b7db0505e9467abd$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $b7db0505e9467abd$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $b7db0505e9467abd$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $b7db0505e9467abd$var$stringtrim(str).replace($b7db0505e9467abd$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $b7db0505e9467abd$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function $b7db0505e9467abd$var$toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function $b7db0505e9467abd$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $b7db0505e9467abd$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $b7db0505e9467abd$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $b7db0505e9467abd$var$base64ToBytes(str) {
    return $3nocJ.toByteArray($b7db0505e9467abd$var$base64clean(str));
}
function $b7db0505e9467abd$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $b7db0505e9467abd$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}





var $fa31c1180104e3fc$var$AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var $fa31c1180104e3fc$var$dispatchAuthEvent = function(event, data, message) {
    (0, $3b4d9bb645fe011c$export$8c41bb232f1008b1).dispatch("auth", {
        event: event,
        data: data,
        message: message
    }, "Auth", $fa31c1180104e3fc$var$AMPLIFY_SYMBOL);
};
var $fa31c1180104e3fc$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("OAuth");
var $fa31c1180104e3fc$var$OAuth = /** @class */ function() {
    function OAuth(_a) {
        var config = _a.config, cognitoClientId = _a.cognitoClientId, _b = _a.scopes, scopes = _b === void 0 ? [] : _b;
        this._urlOpener = config.urlOpener || (0, $3f5f5e56dab920f9$export$9b38228bd9928080);
        this._config = config;
        this._cognitoClientId = cognitoClientId;
        if (!this.isValidScopes(scopes)) throw Error("scopes must be a String Array");
        this._scopes = scopes;
    }
    OAuth.prototype.isValidScopes = function(scopes) {
        return Array.isArray(scopes) && scopes.every(function(scope) {
            return typeof scope === "string";
        });
    };
    OAuth.prototype.oauthSignIn = function(responseType, domain, redirectSignIn, clientId, provider, customState) {
        if (responseType === void 0) responseType = "code";
        if (provider === void 0) provider = (0, $f267bd63d0d39d9d$export$eeb013770cb92342).Cognito;
        var generatedState = this._generateState(32);
        /* encodeURIComponent is not URL safe, use urlSafeEncode instead. Cognito
        single-encodes/decodes url on first sign in and double-encodes/decodes url
        when user already signed in. Using encodeURIComponent, Base32, Base64 add
        characters % or = which on further encoding becomes unsafe. '=' create issue
        for parsing query params.
        Refer: https://github.com/aws-amplify/amplify-js/issues/5218 */ var state = customState ? generatedState + "-" + (0, $019354a06509f3ba$export$b855308a44508212)(customState) : generatedState;
        $d0a58259f3672a68$export$42fffed799c298bb(state);
        var pkce_key = this._generateRandom(128);
        $d0a58259f3672a68$export$14934cb45d589fa1(pkce_key);
        var code_challenge = this._generateChallenge(pkce_key);
        var code_challenge_method = "S256";
        var scopesString = this._scopes.join(" ");
        var queryString = Object.entries((0, $b054e3c0d18c20fe$export$18ce0697a983be9b)((0, $b054e3c0d18c20fe$export$18ce0697a983be9b)({
            redirect_uri: redirectSignIn,
            response_type: responseType,
            client_id: clientId,
            identity_provider: provider,
            scope: scopesString,
            state: state
        }, responseType === "code" ? {
            code_challenge: code_challenge
        } : {}), responseType === "code" ? {
            code_challenge_method: code_challenge_method
        } : {})).map(function(_a) {
            var _b = (0, $b054e3c0d18c20fe$export$8d051b38c9118094)(_a, 2), k = _b[0], v = _b[1];
            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
        }).join("&");
        var URL = "https://" + domain + "/oauth2/authorize?" + queryString;
        $fa31c1180104e3fc$var$logger.debug("Redirecting to " + URL);
        this._urlOpener(URL, redirectSignIn);
    };
    OAuth.prototype._handleCodeFlow = function(currentUrl) {
        return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var code, currentUrlPathname, redirectSignInPathname, oAuthTokenEndpoint, client_id, redirect_uri, code_verifier, oAuthTokenBody, body, customUserAgentDetails, _a, access_token, refresh_token, id_token, error;
            var _b;
            return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        code = ((0, $eAyj5.parse)(currentUrl).query || "").split("&").map(function(pairings) {
                            return pairings.split("=");
                        }).reduce(function(accum, _a) {
                            var _b;
                            var _c = (0, $b054e3c0d18c20fe$export$8d051b38c9118094)(_a, 2), k = _c[0], v = _c[1];
                            return (0, $b054e3c0d18c20fe$export$18ce0697a983be9b)((0, $b054e3c0d18c20fe$export$18ce0697a983be9b)({}, accum), (_b = {}, _b[k] = v, _b));
                        }, {
                            code: undefined
                        }).code;
                        currentUrlPathname = (0, $eAyj5.parse)(currentUrl).pathname || "/";
                        redirectSignInPathname = (0, $eAyj5.parse)(this._config.redirectSignIn).pathname || "/";
                        if (!code || currentUrlPathname !== redirectSignInPathname) return [
                            2 /*return*/ 
                        ];
                        oAuthTokenEndpoint = "https://" + this._config.domain + "/oauth2/token";
                        $fa31c1180104e3fc$var$dispatchAuthEvent("codeFlow", {}, "Retrieving tokens from " + oAuthTokenEndpoint);
                        client_id = (0, $f267bd63d0d39d9d$export$b380f8ec78ef17c8)(this._config) ? this._cognitoClientId : this._config.clientID;
                        redirect_uri = (0, $f267bd63d0d39d9d$export$b380f8ec78ef17c8)(this._config) ? this._config.redirectSignIn : this._config.redirectUri;
                        code_verifier = $d0a58259f3672a68$export$742ac7ded61fbfce();
                        oAuthTokenBody = (0, $b054e3c0d18c20fe$export$18ce0697a983be9b)({
                            grant_type: "authorization_code",
                            code: code,
                            client_id: client_id,
                            redirect_uri: redirect_uri
                        }, code_verifier ? {
                            code_verifier: code_verifier
                        } : {});
                        $fa31c1180104e3fc$var$logger.debug("Calling token endpoint: " + oAuthTokenEndpoint + " with", oAuthTokenBody);
                        body = Object.entries(oAuthTokenBody).map(function(_a) {
                            var _b = (0, $b054e3c0d18c20fe$export$8d051b38c9118094)(_a, 2), k = _b[0], v = _b[1];
                            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
                        }).join("&");
                        customUserAgentDetails = {
                            category: (0, $58c96d580693cdce$export$3a8840c5b2ecf003).Auth,
                            action: (0, $58c96d580693cdce$export$900b1436d7e65f4).FederatedSignIn
                        };
                        return [
                            4 /*yield*/ ,
                            fetch(oAuthTokenEndpoint, {
                                method: "POST",
                                headers: (_b = {
                                    "Content-Type": "application/x-www-form-urlencoded"
                                }, _b[0, $ed8a415515f52c9d$export$16032fc466434892] = (0, $0d25e50bf44b1a9b$export$ede38edb26c0bfdf)(customUserAgentDetails), _b),
                                body: body
                            })
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _c.sent().json()
                        ];
                    case 2:
                        _a = _c.sent(), access_token = _a.access_token, refresh_token = _a.refresh_token, id_token = _a.id_token, error = _a.error;
                        if (error) throw new Error(error);
                        return [
                            2 /*return*/ ,
                            {
                                accessToken: access_token,
                                refreshToken: refresh_token,
                                idToken: id_token
                            }
                        ];
                }
            });
        });
    };
    OAuth.prototype._handleImplicitFlow = function(currentUrl) {
        return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a, id_token, access_token;
            return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_b) {
                _a = ((0, $eAyj5.parse)(currentUrl).hash || "#").substr(1) // Remove # from returned code
                .split("&").map(function(pairings) {
                    return pairings.split("=");
                }).reduce(function(accum, _a) {
                    var _b;
                    var _c = (0, $b054e3c0d18c20fe$export$8d051b38c9118094)(_a, 2), k = _c[0], v = _c[1];
                    return (0, $b054e3c0d18c20fe$export$18ce0697a983be9b)((0, $b054e3c0d18c20fe$export$18ce0697a983be9b)({}, accum), (_b = {}, _b[k] = v, _b));
                }, {
                    id_token: undefined,
                    access_token: undefined
                }), id_token = _a.id_token, access_token = _a.access_token;
                $fa31c1180104e3fc$var$dispatchAuthEvent("implicitFlow", {}, "Got tokens from " + currentUrl);
                $fa31c1180104e3fc$var$logger.debug("Retrieving implicit tokens from " + currentUrl + " with");
                return [
                    2 /*return*/ ,
                    {
                        accessToken: access_token,
                        idToken: id_token,
                        refreshToken: null
                    }
                ];
            });
        });
    };
    OAuth.prototype.handleAuthResponse = function(currentUrl) {
        return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var urlParams, error, error_description, state, _a, _b, e_1;
            return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        urlParams = currentUrl ? (0, $b054e3c0d18c20fe$export$18ce0697a983be9b)((0, $b054e3c0d18c20fe$export$18ce0697a983be9b)({}, ((0, $eAyj5.parse)(currentUrl).hash || "#").substr(1).split("&").map(function(entry) {
                            return entry.split("=");
                        }).reduce(function(acc, _a) {
                            var _b = (0, $b054e3c0d18c20fe$export$8d051b38c9118094)(_a, 2), k = _b[0], v = _b[1];
                            return acc[k] = v, acc;
                        }, {})), ((0, $eAyj5.parse)(currentUrl).query || "").split("&").map(function(entry) {
                            return entry.split("=");
                        }).reduce(function(acc, _a) {
                            var _b = (0, $b054e3c0d18c20fe$export$8d051b38c9118094)(_a, 2), k = _b[0], v = _b[1];
                            return acc[k] = v, acc;
                        }, {})) : {};
                        error = urlParams.error, error_description = urlParams.error_description;
                        if (error) throw new Error(error_description);
                        state = this._validateState(urlParams);
                        $fa31c1180104e3fc$var$logger.debug("Starting " + this._config.responseType + " flow with " + currentUrl);
                        if (!(this._config.responseType === "code")) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleCodeFlow(currentUrl)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            (0, $b054e3c0d18c20fe$export$18ce0697a983be9b).apply(void 0, [
                                (0, $b054e3c0d18c20fe$export$18ce0697a983be9b).apply(void 0, _a.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 2:
                        _b = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleImplicitFlow(currentUrl)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            (0, $b054e3c0d18c20fe$export$18ce0697a983be9b).apply(void 0, [
                                (0, $b054e3c0d18c20fe$export$18ce0697a983be9b).apply(void 0, _b.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 4:
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        e_1 = _c.sent();
                        $fa31c1180104e3fc$var$logger.debug("Error handling auth response.", e_1);
                        throw e_1;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    OAuth.prototype._validateState = function(urlParams) {
        if (!urlParams) return;
        var savedState = $d0a58259f3672a68$export$50fdfeece43146fd();
        var returnedState = urlParams.state;
        // This is because savedState only exists if the flow was initiated by Amplify
        if (savedState && savedState !== returnedState) throw new Error("Invalid state in OAuth flow");
        return returnedState;
    };
    OAuth.prototype.signOut = function() {
        return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var oAuthLogoutEndpoint, client_id, signout_uri;
            return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                oAuthLogoutEndpoint = "https://" + this._config.domain + "/logout?";
                client_id = (0, $f267bd63d0d39d9d$export$b380f8ec78ef17c8)(this._config) ? this._cognitoClientId : this._config.oauth.clientID;
                signout_uri = (0, $f267bd63d0d39d9d$export$b380f8ec78ef17c8)(this._config) ? this._config.redirectSignOut : this._config.returnTo;
                oAuthLogoutEndpoint += Object.entries({
                    client_id: client_id,
                    logout_uri: encodeURIComponent(signout_uri)
                }).map(function(_a) {
                    var _b = (0, $b054e3c0d18c20fe$export$8d051b38c9118094)(_a, 2), k = _b[0], v = _b[1];
                    return k + "=" + v;
                }).join("&");
                $fa31c1180104e3fc$var$dispatchAuthEvent("oAuthSignOut", {
                    oAuth: "signOut"
                }, "Signing out from " + oAuthLogoutEndpoint);
                $fa31c1180104e3fc$var$logger.debug("Signing out from " + oAuthLogoutEndpoint);
                return [
                    2 /*return*/ ,
                    this._urlOpener(oAuthLogoutEndpoint, signout_uri)
                ];
            });
        });
    };
    OAuth.prototype._generateState = function(length) {
        var result = "";
        var i = length;
        var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
        for(; i > 0; --i)result += chars[Math.round(Math.random() * (chars.length - 1))];
        return result;
    };
    OAuth.prototype._generateChallenge = function(code) {
        var awsCryptoHash = new (0, $f0fc6b161cb35602$exports.Sha256)();
        awsCryptoHash.update(code);
        var resultFromAWSCrypto = awsCryptoHash.digestSync();
        var b64 = (0, $b7db0505e9467abd$export$a143d493d941bafc).from(resultFromAWSCrypto).toString("base64");
        var base64URLFromAWSCrypto = this._base64URL(b64);
        return base64URLFromAWSCrypto;
    };
    OAuth.prototype._base64URL = function(string) {
        return string.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    };
    OAuth.prototype._generateRandom = function(size) {
        var CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
        var buffer = new Uint8Array(size);
        if (typeof window !== "undefined" && !!window.crypto) window.crypto.getRandomValues(buffer);
        else for(var i = 0; i < size; i += 1)buffer[i] = Math.random() * CHARSET.length | 0;
        return this._bufferToString(buffer);
    };
    OAuth.prototype._bufferToString = function(buffer) {
        var CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var state = [];
        for(var i = 0; i < buffer.byteLength; i += 1){
            var index = buffer[i] % CHARSET.length;
            state.push(CHARSET[index]);
        }
        return state.join("");
    };
    return OAuth;
}();
var $fa31c1180104e3fc$export$2e2bcd8739ae039 = $fa31c1180104e3fc$var$OAuth;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $08be90f55b31d49e$export$2e2bcd8739ae039 = function(callback) {
    if ((0, $4fe24881fb69f2d5$export$a2708fdb45cd35f)().isBrowser && window.location) {
        var url = window.location.href;
        callback({
            url: url
        });
    } else if ((0, $4fe24881fb69f2d5$export$a2708fdb45cd35f)().isNode) ;
    else throw new Error("Not supported");
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $62a87a195585f064$export$c3070468b9d65120;
(function(AuthErrorStrings) {
    AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
    AuthErrorStrings["EMPTY_EMAIL"] = "Email cannot be empty";
    AuthErrorStrings["EMPTY_PHONE"] = "Phone number cannot be empty";
    AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
    AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
    AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
    AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
    AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
    AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
    AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
    AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
    AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
    AuthErrorStrings["NETWORK_ERROR"] = "Network Error";
    AuthErrorStrings["DEVICE_CONFIG"] = "Device tracking has not been configured in this User Pool";
    AuthErrorStrings["AUTOSIGNIN_ERROR"] = "Please use your credentials to sign in";
})($62a87a195585f064$export$c3070468b9d65120 || ($62a87a195585f064$export$c3070468b9d65120 = {}));


var $32e07c5f35861dc7$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("AuthError");
var $32e07c5f35861dc7$export$145273558d58e0ac = /** @class */ function(_super) {
    (0, $b054e3c0d18c20fe$export$a8ba968b8961cb8a)(AuthError, _super);
    function AuthError(type) {
        var _this = this;
        var _a = $32e07c5f35861dc7$export$d8113b8d790509a4[type], message = _a.message, log = _a.log;
        _this = _super.call(this, message) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = AuthError;
        Object.setPrototypeOf(_this, AuthError.prototype);
        _this.name = "AuthError";
        _this.log = log || message;
        $32e07c5f35861dc7$var$logger.error(_this.log);
        return _this;
    }
    return AuthError;
}(Error);
var $32e07c5f35861dc7$export$71192787e041818c = /** @class */ function(_super) {
    (0, $b054e3c0d18c20fe$export$a8ba968b8961cb8a)(NoUserPoolError, _super);
    function NoUserPoolError(type) {
        var _this = _super.call(this, type) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = NoUserPoolError;
        Object.setPrototypeOf(_this, NoUserPoolError.prototype);
        _this.name = "NoUserPoolError";
        return _this;
    }
    return NoUserPoolError;
}($32e07c5f35861dc7$export$145273558d58e0ac);
var $32e07c5f35861dc7$export$d8113b8d790509a4 = {
    noConfig: {
        message: (0, $62a87a195585f064$export$c3070468b9d65120).DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly.\n            This error is typically caused by one of the following scenarios:\n\n            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point\n                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information\n            \n            2. There might be multiple conflicting versions of amplify packages in your node_modules.\n				Refer to our docs site for help upgrading Amplify packages (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js)\n        "
    },
    missingAuthConfig: {
        message: (0, $62a87a195585f064$export$c3070468b9d65120).DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly. \n            The configuration object is missing required auth properties.\n            This error is typically caused by one of the following scenarios:\n\n            1. Did you run `amplify push` after adding auth via `amplify add auth`?\n                See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information\n\n            2. This could also be caused by multiple conflicting versions of amplify packages, see (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js) for help upgrading Amplify packages.\n        "
    },
    emptyUsername: {
        message: (0, $62a87a195585f064$export$c3070468b9d65120).EMPTY_USERNAME
    },
    // TODO: should include a list of valid sign-in types
    invalidUsername: {
        message: (0, $62a87a195585f064$export$c3070468b9d65120).INVALID_USERNAME
    },
    emptyPassword: {
        message: (0, $62a87a195585f064$export$c3070468b9d65120).EMPTY_PASSWORD
    },
    emptyCode: {
        message: (0, $62a87a195585f064$export$c3070468b9d65120).EMPTY_CODE
    },
    signUpError: {
        message: (0, $62a87a195585f064$export$c3070468b9d65120).SIGN_UP_ERROR,
        log: "The first parameter should either be non-null string or object"
    },
    noMFA: {
        message: (0, $62a87a195585f064$export$c3070468b9d65120).NO_MFA
    },
    invalidMFA: {
        message: (0, $62a87a195585f064$export$c3070468b9d65120).INVALID_MFA
    },
    emptyChallengeResponse: {
        message: (0, $62a87a195585f064$export$c3070468b9d65120).EMPTY_CHALLENGE
    },
    noUserSession: {
        message: (0, $62a87a195585f064$export$c3070468b9d65120).NO_USER_SESSION
    },
    deviceConfig: {
        message: (0, $62a87a195585f064$export$c3070468b9d65120).DEVICE_CONFIG
    },
    networkError: {
        message: (0, $62a87a195585f064$export$c3070468b9d65120).NETWORK_ERROR
    },
    autoSignInError: {
        message: (0, $62a87a195585f064$export$c3070468b9d65120).AUTOSIGNIN_ERROR
    },
    default: {
        message: (0, $62a87a195585f064$export$c3070468b9d65120).DEFAULT_MSG
    }
};



var $9e453b5784a8464e$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("AuthClass");
var $9e453b5784a8464e$var$USER_ADMIN_SCOPE = "aws.cognito.signin.user.admin";
// 10 sec, following this guide https://www.nngroup.com/articles/response-times-3-important-limits/
var $9e453b5784a8464e$var$OAUTH_FLOW_MS_TIMEOUT = 10000;
var $9e453b5784a8464e$var$AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var $9e453b5784a8464e$var$dispatchAuthEvent = function(event, data, message) {
    (0, $3b4d9bb645fe011c$export$8c41bb232f1008b1).dispatch("auth", {
        event: event,
        data: data,
        message: message
    }, "Auth", $9e453b5784a8464e$var$AMPLIFY_SYMBOL);
};
// Cognito Documentation for max device
// tslint:disable-next-line:max-line-length
// https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/API_ListDevices.html#API_ListDevices_RequestSyntax
var $9e453b5784a8464e$var$MAX_DEVICES = 60;
var $9e453b5784a8464e$var$MAX_AUTOSIGNIN_POLLING_MS = 180000;
/**
 * Provide authentication steps
 */ var $9e453b5784a8464e$export$eeff9d1a8b8c057b = /** @class */ function() {
    /**
     * Initialize Auth with AWS configurations
     * @param {Object} config - Configuration of the Auth
     */ function AuthClass(config) {
        var _this = this;
        this.userPool = null;
        this.user = null;
        this.oAuthFlowInProgress = false;
        this.autoSignInInitiated = false;
        this.inflightSessionPromise = null;
        this.inflightSessionPromiseCounter = 0;
        this.Credentials = (0, $44b8a981f31e24b5$export$a9627919734faa48);
        this.wrapRefreshSessionCallback = function(callback) {
            var wrapped = function(error, data) {
                if (data) $9e453b5784a8464e$var$dispatchAuthEvent("tokenRefresh", undefined, "New token retrieved");
                else $9e453b5784a8464e$var$dispatchAuthEvent("tokenRefresh_failure", error, "Failed to retrieve new token");
                return callback(error, data);
            };
            return wrapped;
        }; // prettier-ignore
        this.configure(config);
        this.currentCredentials = this.currentCredentials.bind(this);
        this.currentUserCredentials = this.currentUserCredentials.bind(this);
        (0, $3b4d9bb645fe011c$export$8c41bb232f1008b1).listen("auth", function(_a) {
            var payload = _a.payload;
            var event = payload.event;
            switch(event){
                case "verify":
                case "signIn":
                    _this._storage.setItem("amplify-signin-with-hostedUI", "false");
                    break;
                case "signOut":
                    _this._storage.removeItem("amplify-signin-with-hostedUI");
                    break;
                case "cognitoHostedUI":
                    _this._storage.setItem("amplify-signin-with-hostedUI", "true");
                    break;
            }
        });
        (0, $a3aa897b4733833f$export$523857f9fc06cb0d)();
        (0, $a3aa897b4733833f$export$972f94ce7a888cac)((0, $0d25e50bf44b1a9b$export$2dffd0b5373a4389).framework);
        (0, $0d25e50bf44b1a9b$export$2dffd0b5373a4389).observeFrameworkChanges(function() {
            (0, $a3aa897b4733833f$export$972f94ce7a888cac)((0, $0d25e50bf44b1a9b$export$2dffd0b5373a4389).framework);
        });
    }
    AuthClass.prototype.getModuleName = function() {
        return "Auth";
    };
    AuthClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config || {};
        $9e453b5784a8464e$var$logger.debug("configure Auth");
        var conf = Object.assign({}, this._config, (0, $d0434983171bcfb8$export$1ef2e9c2da492d)(config).Auth, config);
        this._config = conf;
        var _a = this._config, userPoolId = _a.userPoolId, userPoolWebClientId = _a.userPoolWebClientId, cookieStorage = _a.cookieStorage, oauth = _a.oauth, region = _a.region, identityPoolId = _a.identityPoolId, mandatorySignIn = _a.mandatorySignIn, refreshHandlers = _a.refreshHandlers, identityPoolRegion = _a.identityPoolRegion, clientMetadata = _a.clientMetadata, endpoint = _a.endpoint, storage = _a.storage;
        if (!storage) {
            // backward compatability
            if (cookieStorage) this._storage = new (0, $7bb5d86070c49555$export$2e2bcd8739ae039)(cookieStorage);
            else this._storage = config.ssr ? new (0, $ff4879a542aaba90$export$ded9c57084144144)() : new (0, $7a09b30b2e4e0fe6$export$a2bd19c49e4760e8)().getStorage();
        } else {
            if (!this._isValidAuthStorage(storage)) {
                $9e453b5784a8464e$var$logger.error("The storage in the Auth config is not valid!");
                throw new Error("Empty storage object");
            }
            this._storage = storage;
        }
        this._storageSync = Promise.resolve();
        if (typeof this._storage["sync"] === "function") this._storageSync = this._storage["sync"]();
        if (userPoolId) {
            var userPoolData = {
                UserPoolId: userPoolId,
                ClientId: userPoolWebClientId,
                endpoint: endpoint
            };
            userPoolData.Storage = this._storage;
            this.userPool = new (0, $eb46ddfd02c1d36e$export$2e2bcd8739ae039)(userPoolData, this.wrapRefreshSessionCallback);
        }
        this.Credentials.configure({
            mandatorySignIn: mandatorySignIn,
            region: region,
            userPoolId: userPoolId,
            identityPoolId: identityPoolId,
            refreshHandlers: refreshHandlers,
            storage: this._storage,
            identityPoolRegion: identityPoolRegion
        });
        // initialize cognitoauth client if hosted ui options provided
        // to keep backward compatibility:
        var cognitoHostedUIConfig = oauth ? (0, $f267bd63d0d39d9d$export$b380f8ec78ef17c8)(this._config.oauth) ? oauth : oauth.awsCognito : undefined;
        if (cognitoHostedUIConfig) {
            var cognitoAuthParams = Object.assign({
                cognitoClientId: userPoolWebClientId,
                UserPoolId: userPoolId,
                domain: cognitoHostedUIConfig["domain"],
                scopes: cognitoHostedUIConfig["scope"],
                redirectSignIn: cognitoHostedUIConfig["redirectSignIn"],
                redirectSignOut: cognitoHostedUIConfig["redirectSignOut"],
                responseType: cognitoHostedUIConfig["responseType"],
                Storage: this._storage,
                urlOpener: cognitoHostedUIConfig["urlOpener"],
                clientMetadata: clientMetadata
            }, cognitoHostedUIConfig["options"]);
            this._oAuthHandler = new (0, $fa31c1180104e3fc$export$2e2bcd8739ae039)({
                scopes: cognitoAuthParams.scopes,
                config: cognitoAuthParams,
                cognitoClientId: cognitoAuthParams.cognitoClientId
            });
            // **NOTE** - Remove this in a future major release as it is a breaking change
            // Prevents _handleAuthResponse from being called multiple times in Expo
            // See https://github.com/aws-amplify/amplify-js/issues/4388
            var usedResponseUrls_1 = {};
            (0, $08be90f55b31d49e$export$2e2bcd8739ae039)(function(_a) {
                var url = _a.url;
                if (usedResponseUrls_1[url]) return;
                usedResponseUrls_1[url] = true;
                _this._handleAuthResponse(url);
            });
        }
        $9e453b5784a8464e$var$dispatchAuthEvent("configured", null, "The Auth category has been configured successfully");
        if (!this.autoSignInInitiated && typeof this._storage["getItem"] === "function") {
            var pollingInitiated = this.isTrueStorageValue("amplify-polling-started");
            if (pollingInitiated) {
                $9e453b5784a8464e$var$dispatchAuthEvent("autoSignIn_failure", null, (0, $f267bd63d0d39d9d$export$edb367c0a140d3db).AutoSignInError);
                this._storage.removeItem("amplify-auto-sign-in");
            }
            this._storage.removeItem("amplify-polling-started");
        }
        return this._config;
    };
    /**
     * Sign up with username, password and other attributes like phone, email
     * @param {String | object} params - The user attributes used for signin
     * @param {String[]} restOfAttrs - for the backward compatability
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.signUp = function(params) {
        var _this = this;
        var restOfAttrs = [];
        for(var _i = 1; _i < arguments.length; _i++)restOfAttrs[_i - 1] = arguments[_i];
        var _a, _b, _c;
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var attributes = [];
        var validationData = null;
        var clientMetadata;
        var autoSignIn = {
            enabled: false
        };
        var autoSignInValidationData = {};
        var autoSignInClientMetaData = {};
        if (params && typeof params === "string") {
            username = params;
            password = restOfAttrs ? restOfAttrs[0] : null;
            var email = restOfAttrs ? restOfAttrs[1] : null;
            var phone_number = restOfAttrs ? restOfAttrs[2] : null;
            if (email) attributes.push(new (0, $559b6e1d514a188f$export$2e2bcd8739ae039)({
                Name: "email",
                Value: email
            }));
            if (phone_number) attributes.push(new (0, $559b6e1d514a188f$export$2e2bcd8739ae039)({
                Name: "phone_number",
                Value: phone_number
            }));
        } else if (params && typeof params === "object") {
            username = params["username"];
            password = params["password"];
            if (params && params.clientMetadata) clientMetadata = params.clientMetadata;
            else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
            var attrs_1 = params["attributes"];
            if (attrs_1) Object.keys(attrs_1).map(function(key) {
                attributes.push(new (0, $559b6e1d514a188f$export$2e2bcd8739ae039)({
                    Name: key,
                    Value: attrs_1[key]
                }));
            });
            var validationDataObject_1 = params["validationData"];
            if (validationDataObject_1) {
                validationData = [];
                Object.keys(validationDataObject_1).map(function(key) {
                    validationData.push(new (0, $559b6e1d514a188f$export$2e2bcd8739ae039)({
                        Name: key,
                        Value: validationDataObject_1[key]
                    }));
                });
            }
            autoSignIn = (_a = params.autoSignIn) !== null && _a !== void 0 ? _a : {
                enabled: false
            };
            if (autoSignIn.enabled) {
                this._storage.setItem("amplify-auto-sign-in", "true");
                autoSignInValidationData = (_b = autoSignIn.validationData) !== null && _b !== void 0 ? _b : {};
                autoSignInClientMetaData = (_c = autoSignIn.clientMetaData) !== null && _c !== void 0 ? _c : {};
            }
        } else return this.rejectAuthError((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).SignUpError);
        if (!username) return this.rejectAuthError((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).EmptyUsername);
        if (!password) return this.rejectAuthError((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).EmptyPassword);
        $9e453b5784a8464e$var$logger.debug("signUp attrs:", attributes);
        $9e453b5784a8464e$var$logger.debug("signUp validation data:", validationData);
        return new Promise(function(resolve, reject) {
            _this.userPool.signUp(username, password, attributes, validationData, function(err, data) {
                if (err) {
                    $9e453b5784a8464e$var$dispatchAuthEvent("signUp_failure", err, username + " failed to signup");
                    reject(err);
                } else {
                    $9e453b5784a8464e$var$dispatchAuthEvent("signUp", data, username + " has signed up successfully");
                    if (autoSignIn.enabled) _this.handleAutoSignIn(username, password, autoSignInValidationData, autoSignInClientMetaData, data);
                    resolve(data);
                }
            }, clientMetadata);
        });
    };
    AuthClass.prototype.handleAutoSignIn = function(username, password, validationData, clientMetadata, data) {
        this.autoSignInInitiated = true;
        var authDetails = new (0, $5578ec1dc18d671c$export$2e2bcd8739ae039)({
            Username: username,
            Password: password,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        });
        if (data.userConfirmed) this.signInAfterUserConfirmed(authDetails);
        else if (this._config.signUpVerificationMethod === "link") this.handleLinkAutoSignIn(authDetails);
        else this.handleCodeAutoSignIn(authDetails);
    };
    AuthClass.prototype.handleCodeAutoSignIn = function(authDetails) {
        var _this = this;
        var listenEvent = function(_a) {
            var payload = _a.payload;
            if (payload.event === "confirmSignUp") _this.signInAfterUserConfirmed(authDetails, listenEvent);
        };
        (0, $3b4d9bb645fe011c$export$8c41bb232f1008b1).listen("auth", listenEvent);
    };
    AuthClass.prototype.handleLinkAutoSignIn = function(authDetails) {
        var _this = this;
        this._storage.setItem("amplify-polling-started", "true");
        var start = Date.now();
        var autoSignInPollingIntervalId = setInterval(function() {
            if (Date.now() - start > $9e453b5784a8464e$var$MAX_AUTOSIGNIN_POLLING_MS) {
                clearInterval(autoSignInPollingIntervalId);
                $9e453b5784a8464e$var$dispatchAuthEvent("autoSignIn_failure", null, "Please confirm your account and use your credentials to sign in.");
                _this._storage.removeItem("amplify-auto-sign-in");
            } else _this.signInAfterUserConfirmed(authDetails, null, autoSignInPollingIntervalId);
        }, 5000);
    };
    AuthClass.prototype.signInAfterUserConfirmed = function(authDetails, listenEvent, autoSignInPollingIntervalId) {
        return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var user, error_1;
            var _this = this;
            return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        user = this.createCognitoUser(authDetails.getUsername());
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            user.authenticateUser(authDetails, this.authCallbacks(user, function(value) {
                                $9e453b5784a8464e$var$dispatchAuthEvent("autoSignIn", value, authDetails.getUsername() + " has signed in successfully");
                                if (listenEvent) (0, $3b4d9bb645fe011c$export$8c41bb232f1008b1).remove("auth", listenEvent);
                                if (autoSignInPollingIntervalId) {
                                    clearInterval(autoSignInPollingIntervalId);
                                    _this._storage.removeItem("amplify-polling-started");
                                }
                                _this._storage.removeItem("amplify-auto-sign-in");
                            }, function(error) {
                                $9e453b5784a8464e$var$logger.error(error);
                                _this._storage.removeItem("amplify-auto-sign-in");
                            }))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_1 = _a.sent();
                        $9e453b5784a8464e$var$logger.error(error_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Send the verification code to confirm sign up
     * @param {String} username - The username to be confirmed
     * @param {String} code - The verification code
     * @param {ConfirmSignUpOptions} options - other options for confirm signup
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.confirmSignUp = function(username, code, options) {
        var _this = this;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).EmptyUsername);
        if (!code) return this.rejectAuthError((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).EmptyCode);
        var user = this.createCognitoUser(username);
        var forceAliasCreation = options && typeof options.forceAliasCreation === "boolean" ? options.forceAliasCreation : true;
        var clientMetadata;
        if (options && options.clientMetadata) clientMetadata = options.clientMetadata;
        else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.confirmRegistration(code, forceAliasCreation, function(err, data) {
                if (err) reject(err);
                else {
                    $9e453b5784a8464e$var$dispatchAuthEvent("confirmSignUp", data, username + " has been confirmed successfully");
                    var autoSignIn = _this.isTrueStorageValue("amplify-auto-sign-in");
                    if (autoSignIn && !_this.autoSignInInitiated) {
                        $9e453b5784a8464e$var$dispatchAuthEvent("autoSignIn_failure", null, (0, $f267bd63d0d39d9d$export$edb367c0a140d3db).AutoSignInError);
                        _this._storage.removeItem("amplify-auto-sign-in");
                    }
                    resolve(data);
                }
            }, clientMetadata);
        });
    };
    AuthClass.prototype.isTrueStorageValue = function(value) {
        var item = this._storage.getItem(value);
        return item ? item === "true" : false;
    };
    /**
     * Resend the verification code
     * @param {String} username - The username to be confirmed
     * @param {ClientMetadata} clientMetadata - Metadata to be passed to Cognito Lambda triggers
     * @return - A promise resolves code delivery details if successful
     */ AuthClass.prototype.resendSignUp = function(username, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.resendConfirmationCode(function(err, data) {
                if (err) reject(err);
                else resolve(data);
            }, clientMetadata);
        });
    };
    /**
     * Sign in
     * @param {String | SignInOpts} usernameOrSignInOpts - The username to be signed in or the sign in options
     * @param {String} pw - The password of the username
     * @param {ClientMetaData} clientMetadata - Client metadata for custom workflows
     * @return - A promise resolves the CognitoUser
     */ AuthClass.prototype.signIn = function(usernameOrSignInOpts, pw, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var validationData = {};
        // for backward compatibility
        if (typeof usernameOrSignInOpts === "string") {
            username = usernameOrSignInOpts;
            password = pw;
        } else if ((0, $f267bd63d0d39d9d$export$ad34f09783c4cb16)(usernameOrSignInOpts)) {
            if (typeof pw !== "undefined") $9e453b5784a8464e$var$logger.warn("The password should be defined under the first parameter object!");
            username = usernameOrSignInOpts.username;
            password = usernameOrSignInOpts.password;
            validationData = usernameOrSignInOpts.validationData;
        } else return this.rejectAuthError((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).InvalidUsername);
        if (!username) return this.rejectAuthError((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).EmptyUsername);
        var authDetails = new (0, $5578ec1dc18d671c$export$2e2bcd8739ae039)({
            Username: username,
            Password: password,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        });
        if (password) return this.signInWithPassword(authDetails);
        else return this.signInWithoutPassword(authDetails);
    };
    /**
     * Return an object with the authentication callbacks
     * @param {CognitoUser} user - the cognito user object
     * @param {} resolve - function called when resolving the current step
     * @param {} reject - function called when rejecting the current step
     * @return - an object with the callback methods for user authentication
     */ AuthClass.prototype.authCallbacks = function(user, resolve, reject) {
        var _this = this;
        var that = this;
        return {
            onSuccess: function(session) {
                return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                    var cred, e_1, currentUser, e_2;
                    return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                $9e453b5784a8464e$var$logger.debug(session);
                                delete user["challengeName"];
                                delete user["challengeParam"];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    4,
                                    5,
                                    9
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.clear()
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.set(session, "session")
                                ];
                            case 3:
                                cred = _a.sent();
                                $9e453b5784a8464e$var$logger.debug("succeed to get cognito credentials", cred);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 4:
                                e_1 = _a.sent();
                                $9e453b5784a8464e$var$logger.debug("cannot get cognito credentials", e_1);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 5:
                                _a.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.currentUserPoolUser()
                                ];
                            case 6:
                                currentUser = _a.sent();
                                that.user = currentUser;
                                $9e453b5784a8464e$var$dispatchAuthEvent("signIn", currentUser, "A user " + user.getUsername() + " has been signed in");
                                resolve(currentUser);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 7:
                                e_2 = _a.sent();
                                $9e453b5784a8464e$var$logger.error("Failed to get the signed in user", e_2);
                                reject(e_2);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 8:
                                return [
                                    7 /*endfinally*/ 
                                ];
                            case 9:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            },
            onFailure: function(err) {
                $9e453b5784a8464e$var$logger.debug("signIn failure", err);
                $9e453b5784a8464e$var$dispatchAuthEvent("signIn_failure", err, user.getUsername() + " failed to signin");
                reject(err);
            },
            customChallenge: function(challengeParam) {
                $9e453b5784a8464e$var$logger.debug("signIn custom challenge answer required");
                user["challengeName"] = "CUSTOM_CHALLENGE";
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            mfaRequired: function(challengeName, challengeParam) {
                $9e453b5784a8464e$var$logger.debug("signIn MFA required");
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            mfaSetup: function(challengeName, challengeParam) {
                $9e453b5784a8464e$var$logger.debug("signIn mfa setup", challengeName);
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            newPasswordRequired: function(userAttributes, requiredAttributes) {
                $9e453b5784a8464e$var$logger.debug("signIn new password");
                user["challengeName"] = "NEW_PASSWORD_REQUIRED";
                user["challengeParam"] = {
                    userAttributes: userAttributes,
                    requiredAttributes: requiredAttributes
                };
                resolve(user);
            },
            totpRequired: function(challengeName, challengeParam) {
                $9e453b5784a8464e$var$logger.debug("signIn totpRequired");
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            selectMFAType: function(challengeName, challengeParam) {
                $9e453b5784a8464e$var$logger.debug("signIn selectMFAType", challengeName);
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            }
        };
    };
    /**
     * Sign in with a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ AuthClass.prototype.signInWithPassword = function(authDetails) {
        var _this = this;
        if (this.pendingSignIn) throw new Error("Pending sign-in attempt already in progress");
        var user = this.createCognitoUser(authDetails.getUsername());
        this.pendingSignIn = new Promise(function(resolve, reject) {
            user.authenticateUser(authDetails, _this.authCallbacks(user, function(value) {
                _this.pendingSignIn = null;
                resolve(value);
            }, function(error) {
                _this.pendingSignIn = null;
                reject(error);
            }));
        });
        return this.pendingSignIn;
    };
    /**
     * Sign in without a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ AuthClass.prototype.signInWithoutPassword = function(authDetails) {
        var _this = this;
        var user = this.createCognitoUser(authDetails.getUsername());
        user.setAuthenticationFlowType("CUSTOM_AUTH");
        return new Promise(function(resolve, reject) {
            user.initiateAuth(authDetails, _this.authCallbacks(user, resolve, reject));
        });
    };
    /**
     * This was previously used by an authenticated user to get MFAOptions,
     * but no longer returns a meaningful response. Refer to the documentation for
     * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves the current preferred mfa option if success
     */ AuthClass.prototype.getMFAOptions = function(user) {
        return new Promise(function(res, rej) {
            user.getMFAOptions(function(err, mfaOptions) {
                if (err) {
                    $9e453b5784a8464e$var$logger.debug("get MFA Options failed", err);
                    rej(err);
                    return;
                }
                $9e453b5784a8464e$var$logger.debug("get MFA options success", mfaOptions);
                res(mfaOptions);
                return;
            });
        });
    };
    /**
     * get preferred mfa method
     * @param {CognitoUser} user - the current cognito user
     * @param {GetPreferredMFAOpts} params - options for getting the current user preferred MFA
     */ AuthClass.prototype.getPreferredMFA = function(user, params) {
        var _this = this;
        var that = this;
        return new Promise(function(res, rej) {
            var clientMetadata = _this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
            var bypassCache = params ? params.bypassCache : false;
            user.getUserData(function(err, data) {
                return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                    var cleanUpError_1, mfaType;
                    return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!err) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                $9e453b5784a8464e$var$logger.debug("getting preferred mfa failed", err);
                                if (!this.isSessionInvalid(err)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.cleanUpInvalidSession(user)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                cleanUpError_1 = _a.sent();
                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_1.message));
                                return [
                                    2 /*return*/ 
                                ];
                            case 4:
                                rej(err);
                                return [
                                    2 /*return*/ 
                                ];
                            case 5:
                                mfaType = that._getMfaTypeFromUserData(data);
                                if (!mfaType) {
                                    rej("invalid MFA Type");
                                    return [
                                        2 /*return*/ 
                                    ];
                                } else {
                                    res(mfaType);
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, {
                bypassCache: bypassCache,
                clientMetadata: clientMetadata
            });
        });
    };
    AuthClass.prototype._getMfaTypeFromUserData = function(data) {
        var ret = null;
        var preferredMFA = data.PreferredMfaSetting;
        // if the user has used Auth.setPreferredMFA() to setup the mfa type
        // then the "PreferredMfaSetting" would exist in the response
        if (preferredMFA) ret = preferredMFA;
        else {
            // if mfaList exists but empty, then its noMFA
            var mfaList = data.UserMFASettingList;
            if (!mfaList) {
                // if SMS was enabled by using Auth.enableSMS(),
                // the response would contain MFAOptions
                // as for now Cognito only supports for SMS, so we will say it is 'SMS_MFA'
                // if it does not exist, then it should be NOMFA
                var MFAOptions = data.MFAOptions;
                if (MFAOptions) ret = "SMS_MFA";
                else ret = "NOMFA";
            } else if (mfaList.length === 0) ret = "NOMFA";
            else $9e453b5784a8464e$var$logger.debug("invalid case for getPreferredMFA", data);
        }
        return ret;
    };
    AuthClass.prototype._getUserData = function(user, params) {
        var _this = this;
        return new Promise(function(res, rej) {
            user.getUserData(function(err, data) {
                return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                    var cleanUpError_2;
                    return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!err) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                $9e453b5784a8464e$var$logger.debug("getting user data failed", err);
                                if (!this.isSessionInvalid(err)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.cleanUpInvalidSession(user)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                cleanUpError_2 = _a.sent();
                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_2.message));
                                return [
                                    2 /*return*/ 
                                ];
                            case 4:
                                rej(err);
                                return [
                                    2 /*return*/ 
                                ];
                            case 5:
                                res(data);
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, params);
        });
    };
    /**
     * set preferred MFA method
     * @param {CognitoUser} user - the current Cognito user
     * @param {string} mfaMethod - preferred mfa method
     * @return - A promise resolve if success
     */ AuthClass.prototype.setPreferredMFA = function(user, mfaMethod) {
        return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var clientMetadata, userData, smsMfaSettings, totpMfaSettings, _a, mfaList, currentMFAType, that;
            var _this = this;
            return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        clientMetadata = this._config.clientMetadata;
                        return [
                            4 /*yield*/ ,
                            this._getUserData(user, {
                                bypassCache: true,
                                clientMetadata: clientMetadata
                            })
                        ];
                    case 1:
                        userData = _b.sent();
                        smsMfaSettings = null;
                        totpMfaSettings = null;
                        _a = mfaMethod;
                        switch(_a){
                            case "TOTP":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case "SOFTWARE_TOKEN_MFA":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case "SMS":
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case "SMS_MFA":
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case "NOMFA":
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 2:
                        totpMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 3:
                        smsMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 4:
                        mfaList = userData["UserMFASettingList"];
                        return [
                            4 /*yield*/ ,
                            this._getMfaTypeFromUserData(userData)
                        ];
                    case 5:
                        currentMFAType = _b.sent();
                        if (currentMFAType === "NOMFA") return [
                            2 /*return*/ ,
                            Promise.resolve("No change for mfa type")
                        ];
                        else if (currentMFAType === "SMS_MFA") smsMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else if (currentMFAType === "SOFTWARE_TOKEN_MFA") totpMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).InvalidMFA)
                        ];
                        // if there is a UserMFASettingList in the response
                        // we need to disable every mfa type in that list
                        if (mfaList && mfaList.length !== 0) // to disable SMS or TOTP if exists in that list
                        mfaList.forEach(function(mfaType) {
                            if (mfaType === "SMS_MFA") smsMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                            else if (mfaType === "SOFTWARE_TOKEN_MFA") totpMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                        });
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        $9e453b5784a8464e$var$logger.debug("no validmfa method provided");
                        return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).NoMFA)
                        ];
                    case 7:
                        that = this;
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                user.setUserMfaPreference(smsMfaSettings, totpMfaSettings, function(err, result) {
                                    if (err) {
                                        $9e453b5784a8464e$var$logger.debug("Set user mfa preference error", err);
                                        return rej(err);
                                    }
                                    $9e453b5784a8464e$var$logger.debug("Set user mfa success", result);
                                    $9e453b5784a8464e$var$logger.debug("Caching the latest user data into local");
                                    // cache the latest result into user data
                                    user.getUserData(function(err, data) {
                                        return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                            var cleanUpError_3;
                                            return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                                                switch(_a.label){
                                                    case 0:
                                                        if (!err) return [
                                                            3 /*break*/ ,
                                                            5
                                                        ];
                                                        $9e453b5784a8464e$var$logger.debug("getting user data failed", err);
                                                        if (!this.isSessionInvalid(err)) return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                        _a.label = 1;
                                                    case 1:
                                                        _a.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.cleanUpInvalidSession(user)
                                                        ];
                                                    case 2:
                                                        _a.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                    case 3:
                                                        cleanUpError_3 = _a.sent();
                                                        rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_3.message));
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                    case 4:
                                                        return [
                                                            2 /*return*/ ,
                                                            rej(err)
                                                        ];
                                                    case 5:
                                                        return [
                                                            2 /*return*/ ,
                                                            res(result)
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        bypassCache: true,
                                        clientMetadata: clientMetadata
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * disable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.disableSMS = function(user) {
        return new Promise(function(res, rej) {
            user.disableMFA(function(err, data) {
                if (err) {
                    $9e453b5784a8464e$var$logger.debug("disable mfa failed", err);
                    rej(err);
                    return;
                }
                $9e453b5784a8464e$var$logger.debug("disable mfa succeed", data);
                res(data);
                return;
            });
        });
    };
    /**
     * enable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.enableSMS = function(user) {
        return new Promise(function(res, rej) {
            user.enableMFA(function(err, data) {
                if (err) {
                    $9e453b5784a8464e$var$logger.debug("enable mfa failed", err);
                    rej(err);
                    return;
                }
                $9e453b5784a8464e$var$logger.debug("enable mfa succeed", data);
                res(data);
                return;
            });
        });
    };
    /**
     * Setup TOTP
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves with the secret code if success
     */ AuthClass.prototype.setupTOTP = function(user) {
        return new Promise(function(res, rej) {
            user.associateSoftwareToken({
                onFailure: function(err) {
                    $9e453b5784a8464e$var$logger.debug("associateSoftwareToken failed", err);
                    rej(err);
                    return;
                },
                associateSecretCode: function(secretCode) {
                    $9e453b5784a8464e$var$logger.debug("associateSoftwareToken success", secretCode);
                    res(secretCode);
                    return;
                }
            });
        });
    };
    /**
     * verify TOTP setup
     * @param {CognitoUser} user - the current user
     * @param {string} challengeAnswer - challenge answer
     * @return - A promise resolves is success
     */ AuthClass.prototype.verifyTotpToken = function(user, challengeAnswer) {
        $9e453b5784a8464e$var$logger.debug("verification totp token", user, challengeAnswer);
        var signInUserSession;
        if (user && typeof user.getSignInUserSession === "function") signInUserSession = user.getSignInUserSession();
        var isLoggedIn = signInUserSession === null || signInUserSession === void 0 ? void 0 : signInUserSession.isValid();
        return new Promise(function(res, rej) {
            user.verifySoftwareToken(challengeAnswer, "My TOTP device", {
                onFailure: function(err) {
                    $9e453b5784a8464e$var$logger.debug("verifyTotpToken failed", err);
                    rej(err);
                    return;
                },
                onSuccess: function(data) {
                    if (!isLoggedIn) $9e453b5784a8464e$var$dispatchAuthEvent("signIn", user, "A user " + user.getUsername() + " has been signed in");
                    $9e453b5784a8464e$var$dispatchAuthEvent("verify", user, "A user " + user.getUsername() + " has been verified");
                    $9e453b5784a8464e$var$logger.debug("verifyTotpToken success", data);
                    res(data);
                    return;
                }
            });
        });
    };
    /**
     * Send MFA code to confirm sign in
     * @param {Object} user - The CognitoUser object
     * @param {String} code - The confirmation code
     */ AuthClass.prototype.confirmSignIn = function(user, code, mfaType, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!code) return this.rejectAuthError((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).EmptyCode);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendMFACode(code, {
                onSuccess: function(session) {
                    return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                        var cred, e_3, currentUser, e_4;
                        return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    $9e453b5784a8464e$var$logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        10
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.set(session, "session")
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    $9e453b5784a8464e$var$logger.debug("succeed to get cognito credentials", cred);
                                    return [
                                        3 /*break*/ ,
                                        10
                                    ];
                                case 4:
                                    e_3 = _a.sent();
                                    $9e453b5784a8464e$var$logger.debug("cannot get cognito credentials", e_3);
                                    return [
                                        3 /*break*/ ,
                                        10
                                    ];
                                case 5:
                                    that.user = user;
                                    _a.label = 6;
                                case 6:
                                    _a.trys.push([
                                        6,
                                        8,
                                        ,
                                        9
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.currentUserPoolUser()
                                    ];
                                case 7:
                                    currentUser = _a.sent();
                                    user.attributes = currentUser.attributes;
                                    return [
                                        3 /*break*/ ,
                                        9
                                    ];
                                case 8:
                                    e_4 = _a.sent();
                                    $9e453b5784a8464e$var$logger.debug("cannot get updated Cognito User", e_4);
                                    return [
                                        3 /*break*/ ,
                                        9
                                    ];
                                case 9:
                                    $9e453b5784a8464e$var$dispatchAuthEvent("signIn", user, "A user " + user.getUsername() + " has been signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 10:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function(err) {
                    $9e453b5784a8464e$var$logger.debug("confirm signIn failure", err);
                    reject(err);
                }
            }, mfaType, clientMetadata);
        });
    };
    AuthClass.prototype.completeNewPassword = function(user, password, requiredAttributes, clientMetadata) {
        var _this = this;
        if (requiredAttributes === void 0) requiredAttributes = {};
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!password) return this.rejectAuthError((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).EmptyPassword);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.completeNewPasswordChallenge(password, requiredAttributes, {
                onSuccess: function(session) {
                    return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                        var cred, e_5;
                        return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    $9e453b5784a8464e$var$logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        6
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.set(session, "session")
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    $9e453b5784a8464e$var$logger.debug("succeed to get cognito credentials", cred);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 4:
                                    e_5 = _a.sent();
                                    $9e453b5784a8464e$var$logger.debug("cannot get cognito credentials", e_5);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 5:
                                    that.user = user;
                                    $9e453b5784a8464e$var$dispatchAuthEvent("signIn", user, "A user " + user.getUsername() + " has been signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 6:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function(err) {
                    $9e453b5784a8464e$var$logger.debug("completeNewPassword failure", err);
                    $9e453b5784a8464e$var$dispatchAuthEvent("completeNewPassword_failure", err, _this.user + " failed to complete the new password flow");
                    reject(err);
                },
                mfaRequired: function(challengeName, challengeParam) {
                    $9e453b5784a8464e$var$logger.debug("signIn MFA required");
                    user["challengeName"] = challengeName;
                    user["challengeParam"] = challengeParam;
                    resolve(user);
                },
                mfaSetup: function(challengeName, challengeParam) {
                    $9e453b5784a8464e$var$logger.debug("signIn mfa setup", challengeName);
                    user["challengeName"] = challengeName;
                    user["challengeParam"] = challengeParam;
                    resolve(user);
                },
                totpRequired: function(challengeName, challengeParam) {
                    $9e453b5784a8464e$var$logger.debug("signIn mfa setup", challengeName);
                    user["challengeName"] = challengeName;
                    user["challengeParam"] = challengeParam;
                    resolve(user);
                }
            }, clientMetadata);
        });
    };
    /**
     * Send the answer to a custom challenge
     * @param {CognitoUser} user - The CognitoUser object
     * @param {String} challengeResponses - The confirmation code
     */ AuthClass.prototype.sendCustomChallengeAnswer = function(user, challengeResponses, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!challengeResponses) return this.rejectAuthError((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).EmptyChallengeResponse);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendCustomChallengeAnswer(challengeResponses, _this.authCallbacks(user, resolve, reject), clientMetadata);
        });
    };
    /**
     * Delete an authenticated users' attributes
     * @param {CognitoUser} - The currently logged in user object
     * @return {Promise}
     **/ AuthClass.prototype.deleteUserAttributes = function(user, attributeNames) {
        var that = this;
        return new Promise(function(resolve, reject) {
            that.userSession(user).then(function(session) {
                user.deleteAttributes(attributeNames, function(err, result) {
                    if (err) return reject(err);
                    else return resolve(result);
                });
            });
        });
    };
    /**
     * Delete the current authenticated user
     * @return {Promise}
     **/ // TODO: Check return type void
    AuthClass.prototype.deleteUser = function() {
        return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var e_6, isSignedInHostedUI;
            var _this = this;
            return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_6 = _a.sent();
                        $9e453b5784a8464e$var$logger.debug("Failed to sync cache info into memory", e_6);
                        throw new Error(e_6);
                    case 3:
                        isSignedInHostedUI = this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true";
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                    var user_1;
                                    var _this = this;
                                    return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                                        if (this.userPool) {
                                            user_1 = this.userPool.getCurrentUser();
                                            if (!user_1) {
                                                $9e453b5784a8464e$var$logger.debug("Failed to get user from user pool");
                                                return [
                                                    2 /*return*/ ,
                                                    rej(new Error("No current user."))
                                                ];
                                            } else user_1.getSession(function(err, session) {
                                                return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                                    var cleanUpError_4;
                                                    var _this = this;
                                                    return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                                                        switch(_a.label){
                                                            case 0:
                                                                if (!err) return [
                                                                    3 /*break*/ ,
                                                                    5
                                                                ];
                                                                $9e453b5784a8464e$var$logger.debug("Failed to get the user session", err);
                                                                if (!this.isSessionInvalid(err)) return [
                                                                    3 /*break*/ ,
                                                                    4
                                                                ];
                                                                _a.label = 1;
                                                            case 1:
                                                                _a.trys.push([
                                                                    1,
                                                                    3,
                                                                    ,
                                                                    4
                                                                ]);
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    this.cleanUpInvalidSession(user_1)
                                                                ];
                                                            case 2:
                                                                _a.sent();
                                                                return [
                                                                    3 /*break*/ ,
                                                                    4
                                                                ];
                                                            case 3:
                                                                cleanUpError_4 = _a.sent();
                                                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_4.message));
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                            case 4:
                                                                return [
                                                                    2 /*return*/ ,
                                                                    rej(err)
                                                                ];
                                                            case 5:
                                                                user_1.deleteUser(function(err, result) {
                                                                    if (err) rej(err);
                                                                    else {
                                                                        $9e453b5784a8464e$var$dispatchAuthEvent("userDeleted", result, "The authenticated user has been deleted.");
                                                                        user_1.signOut();
                                                                        _this.user = null;
                                                                        try {
                                                                            _this.cleanCachedItems(); // clean aws credentials
                                                                        } catch (e) {
                                                                            // TODO: change to rejects in refactor
                                                                            $9e453b5784a8464e$var$logger.debug("failed to clear cached items");
                                                                        }
                                                                        if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                                                        else {
                                                                            $9e453b5784a8464e$var$dispatchAuthEvent("signOut", _this.user, "A user has been signed out");
                                                                            res(result);
                                                                        }
                                                                    }
                                                                });
                                                                _a.label = 6;
                                                            case 6:
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                        }
                                                    });
                                                });
                                            });
                                        } else {
                                            $9e453b5784a8464e$var$logger.debug("no Congito User pool");
                                            rej(new Error("Cognito User pool does not exist"));
                                        }
                                        return [
                                            2 /*return*/ 
                                        ];
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * Update an authenticated users' attributes
     * @param {CognitoUser} - The currently logged in user object
     * @return {Promise}
     **/ AuthClass.prototype.updateUserAttributes = function(user, attributes, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        var attributeList = [];
        var that = this;
        return new Promise(function(resolve, reject) {
            that.userSession(user).then(function(session) {
                for(var key in attributes)if (key !== "sub" && key.indexOf("_verified") < 0) {
                    var attr = {
                        Name: key,
                        Value: attributes[key]
                    };
                    attributeList.push(attr);
                }
                user.updateAttributes(attributeList, function(err, result, details) {
                    if (err) {
                        $9e453b5784a8464e$var$dispatchAuthEvent("updateUserAttributes_failure", err, "Failed to update attributes");
                        return reject(err);
                    } else {
                        var attrs = _this.createUpdateAttributesResultList(attributes, details === null || details === void 0 ? void 0 : details.CodeDeliveryDetailsList);
                        $9e453b5784a8464e$var$dispatchAuthEvent("updateUserAttributes", attrs, "Attributes successfully updated");
                        return resolve(result);
                    }
                }, clientMetadata);
            });
        });
    };
    AuthClass.prototype.createUpdateAttributesResultList = function(attributes, codeDeliveryDetailsList) {
        var attrs = {};
        Object.keys(attributes).forEach(function(key) {
            attrs[key] = {
                isUpdated: true
            };
            var codeDeliveryDetails = codeDeliveryDetailsList === null || codeDeliveryDetailsList === void 0 ? void 0 : codeDeliveryDetailsList.find(function(value) {
                return value.AttributeName === key;
            });
            if (codeDeliveryDetails) {
                attrs[key].isUpdated = false;
                attrs[key].codeDeliveryDetails = codeDeliveryDetails;
            }
        });
        return attrs;
    };
    /**
     * Return user attributes
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to user attributes if success
     */ AuthClass.prototype.userAttributes = function(user) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.getUserAttributes(function(err, attributes) {
                    if (err) reject(err);
                    else resolve(attributes);
                });
            });
        });
    };
    AuthClass.prototype.verifiedContact = function(user) {
        var that = this;
        return this.userAttributes(user).then(function(attributes) {
            var attrs = that.attributesToObject(attributes);
            var unverified = {};
            var verified = {};
            if (attrs["email"]) {
                if (attrs["email_verified"]) verified["email"] = attrs["email"];
                else unverified["email"] = attrs["email"];
            }
            if (attrs["phone_number"]) {
                if (attrs["phone_number_verified"]) verified["phone_number"] = attrs["phone_number"];
                else unverified["phone_number"] = attrs["phone_number"];
            }
            return {
                verified: verified,
                unverified: unverified
            };
        });
    };
    AuthClass.prototype.isErrorWithMessage = function(err) {
        return typeof err === "object" && Object.prototype.hasOwnProperty.call(err, "message");
    };
    // Session revoked by another app
    AuthClass.prototype.isTokenRevokedError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "Access Token has been revoked";
    };
    AuthClass.prototype.isRefreshTokenRevokedError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "Refresh Token has been revoked";
    };
    AuthClass.prototype.isUserDisabledError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "User is disabled.";
    };
    AuthClass.prototype.isUserDoesNotExistError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "User does not exist.";
    };
    AuthClass.prototype.isRefreshTokenExpiredError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "Refresh Token has expired";
    };
    AuthClass.prototype.isPasswordResetRequiredError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "Password reset required for the user";
    };
    AuthClass.prototype.isSignedInHostedUI = function() {
        return this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true";
    };
    AuthClass.prototype.isSessionInvalid = function(err) {
        return this.isUserDisabledError(err) || this.isUserDoesNotExistError(err) || this.isTokenRevokedError(err) || this.isRefreshTokenRevokedError(err) || this.isRefreshTokenExpiredError(err) || this.isPasswordResetRequiredError(err);
    };
    AuthClass.prototype.cleanUpInvalidSession = function(user) {
        return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var e_7;
            var _this = this;
            return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        user.signOut();
                        this.user = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cleanCachedItems()
                        ];
                    case 2:
                        _a.sent(); // clean aws credentials
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_7 = _a.sent();
                        $9e453b5784a8464e$var$logger.debug("failed to clear cached items");
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        if (this.isSignedInHostedUI()) return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                _this.oAuthSignOutRedirect(res, rej);
                            })
                        ];
                        else $9e453b5784a8464e$var$dispatchAuthEvent("signOut", this.user, "A user has been signed out");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get current authenticated user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentUserPoolUser = function(params) {
        var _this = this;
        if (!this.userPool) return this.rejectNoUserPool();
        return new Promise(function(res, rej) {
            _this._storageSync.then(function() {
                return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                    var user, session, bypassCache, clientMetadata, _a, scope, err_1;
                    var _this = this;
                    return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                if (!this.isOAuthInProgress()) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                $9e453b5784a8464e$var$logger.debug("OAuth signIn in progress, waiting for resolution...");
                                return [
                                    4 /*yield*/ ,
                                    new Promise(function(res) {
                                        var timeoutId = setTimeout(function() {
                                            $9e453b5784a8464e$var$logger.debug("OAuth signIn in progress timeout");
                                            (0, $3b4d9bb645fe011c$export$8c41bb232f1008b1).remove("auth", hostedUISignCallback);
                                            res();
                                        }, $9e453b5784a8464e$var$OAUTH_FLOW_MS_TIMEOUT);
                                        (0, $3b4d9bb645fe011c$export$8c41bb232f1008b1).listen("auth", hostedUISignCallback);
                                        function hostedUISignCallback(_a) {
                                            var payload = _a.payload;
                                            var event = payload.event;
                                            if (event === "cognitoHostedUI" || event === "cognitoHostedUI_failure") {
                                                $9e453b5784a8464e$var$logger.debug("OAuth signIn resolved: " + event);
                                                clearTimeout(timeoutId);
                                                (0, $3b4d9bb645fe011c$export$8c41bb232f1008b1).remove("auth", hostedUISignCallback);
                                                res();
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _b.sent();
                                _b.label = 2;
                            case 2:
                                user = this.userPool.getCurrentUser();
                                if (!user) {
                                    $9e453b5784a8464e$var$logger.debug("Failed to get user from user pool");
                                    rej("No current user");
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                _b.label = 3;
                            case 3:
                                _b.trys.push([
                                    3,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this._userSession(user)
                                ];
                            case 4:
                                session = _b.sent();
                                bypassCache = params ? params.bypassCache : false;
                                if (!bypassCache) return [
                                    3 /*break*/ ,
                                    6
                                ];
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.clear()
                                ];
                            case 5:
                                _b.sent();
                                _b.label = 6;
                            case 6:
                                clientMetadata = this._config.clientMetadata;
                                _a = session.getAccessToken().decodePayload().scope, scope = _a === void 0 ? "" : _a;
                                if (scope.split(" ").includes($9e453b5784a8464e$var$USER_ADMIN_SCOPE)) user.getUserData(function(err, data) {
                                    return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                        var cleanUpError_5, preferredMFA, attributeList, i, attribute, userAttribute, attributes;
                                        return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                                            switch(_a.label){
                                                case 0:
                                                    if (!err) return [
                                                        3 /*break*/ ,
                                                        7
                                                    ];
                                                    $9e453b5784a8464e$var$logger.debug("getting user data failed", err);
                                                    if (!this.isSessionInvalid(err)) return [
                                                        3 /*break*/ ,
                                                        5
                                                    ];
                                                    _a.label = 1;
                                                case 1:
                                                    _a.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        4
                                                    ]);
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.cleanUpInvalidSession(user)
                                                    ];
                                                case 2:
                                                    _a.sent();
                                                    return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                case 3:
                                                    cleanUpError_5 = _a.sent();
                                                    rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_5.message));
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                                case 4:
                                                    rej(err);
                                                    return [
                                                        3 /*break*/ ,
                                                        6
                                                    ];
                                                case 5:
                                                    res(user);
                                                    _a.label = 6;
                                                case 6:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                                case 7:
                                                    preferredMFA = data.PreferredMfaSetting || "NOMFA";
                                                    attributeList = [];
                                                    for(i = 0; i < data.UserAttributes.length; i++){
                                                        attribute = {
                                                            Name: data.UserAttributes[i].Name,
                                                            Value: data.UserAttributes[i].Value
                                                        };
                                                        userAttribute = new (0, $559b6e1d514a188f$export$2e2bcd8739ae039)(attribute);
                                                        attributeList.push(userAttribute);
                                                    }
                                                    attributes = this.attributesToObject(attributeList);
                                                    Object.assign(user, {
                                                        attributes: attributes,
                                                        preferredMFA: preferredMFA
                                                    });
                                                    return [
                                                        2 /*return*/ ,
                                                        res(user)
                                                    ];
                                            }
                                        });
                                    });
                                }, {
                                    bypassCache: bypassCache,
                                    clientMetadata: clientMetadata
                                });
                                else {
                                    $9e453b5784a8464e$var$logger.debug("Unable to get the user data because the " + $9e453b5784a8464e$var$USER_ADMIN_SCOPE + " " + "is not in the scopes of the access token");
                                    return [
                                        2 /*return*/ ,
                                        res(user)
                                    ];
                                }
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 7:
                                err_1 = _b.sent();
                                rej(err_1);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 8:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }).catch(function(e) {
                $9e453b5784a8464e$var$logger.debug("Failed to sync cache info into memory", e);
                return rej(e);
            });
        });
    };
    AuthClass.prototype.isOAuthInProgress = function() {
        return this.oAuthFlowInProgress;
    };
    /**
     * Get current authenticated user
     * @param {CurrentUserOpts} - options for getting the current user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentAuthenticatedUser = function(params) {
        return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var federatedUser, e_8, federatedInfo, user, e_9;
            return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $9e453b5784a8464e$var$logger.debug("getting current authenticated user");
                        federatedUser = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_8 = _a.sent();
                        $9e453b5784a8464e$var$logger.debug("Failed to sync cache info into memory", e_8);
                        throw e_8;
                    case 4:
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem("aws-amplify-federatedInfo"));
                            if (federatedInfo) federatedUser = (0, $b054e3c0d18c20fe$export$18ce0697a983be9b)((0, $b054e3c0d18c20fe$export$18ce0697a983be9b)({}, federatedInfo.user), {
                                token: federatedInfo.token
                            });
                        } catch (e) {
                            $9e453b5784a8464e$var$logger.debug("cannot load federated user from auth storage");
                        }
                        if (!federatedUser) return [
                            3 /*break*/ ,
                            5
                        ];
                        this.user = federatedUser;
                        $9e453b5784a8464e$var$logger.debug("get current authenticated federated user", this.user);
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                    case 5:
                        $9e453b5784a8464e$var$logger.debug("get current authenticated userpool user");
                        user = null;
                        _a.label = 6;
                    case 6:
                        _a.trys.push([
                            6,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser(params)
                        ];
                    case 7:
                        user = _a.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        e_9 = _a.sent();
                        if (e_9 === "No userPool") $9e453b5784a8464e$var$logger.error("Cannot get the current user because the user pool is missing. Please make sure the Auth module is configured with a valid Cognito User Pool ID");
                        $9e453b5784a8464e$var$logger.debug("The user is not authenticated by the error", e_9);
                        return [
                            2 /*return*/ ,
                            Promise.reject("The user is not authenticated")
                        ];
                    case 9:
                        this.user = user;
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                }
            });
        });
    };
    /**
     * Get current user's session
     * @return - A promise resolves to session object if success
     */ AuthClass.prototype.currentSession = function() {
        var that = this;
        $9e453b5784a8464e$var$logger.debug("Getting current session");
        // Purposely not calling the reject method here because we don't need a console error
        if (!this.userPool) return Promise.reject(new Error("No User Pool in the configuration."));
        return new Promise(function(res, rej) {
            that.currentUserPoolUser().then(function(user) {
                that.userSession(user).then(function(session) {
                    res(session);
                    return;
                }).catch(function(e) {
                    $9e453b5784a8464e$var$logger.debug("Failed to get the current session", e);
                    rej(e);
                    return;
                });
            }).catch(function(e) {
                $9e453b5784a8464e$var$logger.debug("Failed to get the current user", e);
                rej(e);
                return;
            });
        });
    };
    AuthClass.prototype._userSession = function(user) {
        return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var clientMetadata, userSession;
            var _this = this;
            return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!user) {
                            $9e453b5784a8464e$var$logger.debug("the user is null");
                            return [
                                2 /*return*/ ,
                                this.rejectAuthError((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).NoUserSession)
                            ];
                        }
                        clientMetadata = this._config.clientMetadata;
                        // Debouncing the concurrent userSession calls by caching the promise.
                        // This solution assumes users will always call this function with the same CognitoUser instance.
                        if (this.inflightSessionPromiseCounter === 0) this.inflightSessionPromise = new Promise(function(res, rej) {
                            user.getSession(function(err, session) {
                                return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                    var cleanUpError_6;
                                    return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                if (!err) return [
                                                    3 /*break*/ ,
                                                    5
                                                ];
                                                $9e453b5784a8464e$var$logger.debug("Failed to get the session from user", user);
                                                if (!this.isSessionInvalid(err)) return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                                _a.label = 1;
                                            case 1:
                                                _a.trys.push([
                                                    1,
                                                    3,
                                                    ,
                                                    4
                                                ]);
                                                return [
                                                    4 /*yield*/ ,
                                                    this.cleanUpInvalidSession(user)
                                                ];
                                            case 2:
                                                _a.sent();
                                                return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                            case 3:
                                                cleanUpError_6 = _a.sent();
                                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_6.message));
                                                return [
                                                    2 /*return*/ 
                                                ];
                                            case 4:
                                                rej(err);
                                                return [
                                                    2 /*return*/ 
                                                ];
                                            case 5:
                                                $9e453b5784a8464e$var$logger.debug("Succeed to get the user session", session);
                                                res(session);
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }, {
                                clientMetadata: clientMetadata
                            });
                        });
                        this.inflightSessionPromiseCounter++;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.inflightSessionPromise
                        ];
                    case 2:
                        userSession = _a.sent();
                        // Set private member. Avoid user.setSignInUserSession() to prevent excessive localstorage refresh.
                        // @ts-ignore
                        user.signInUserSession = userSession;
                        return [
                            2 /*return*/ ,
                            userSession
                        ];
                    case 3:
                        this.inflightSessionPromiseCounter--;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get the corresponding user session
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to the session
     */ AuthClass.prototype.userSession = function(user) {
        return this._userSession(user);
    };
    /**
     * Get authenticated credentials of current user.
     * @return - A promise resolves to be current user's credentials
     */ AuthClass.prototype.currentUserCredentials = function() {
        return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var e_10, federatedInfo;
            var _this = this;
            return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $9e453b5784a8464e$var$logger.debug("Getting current user credentials");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_10 = _a.sent();
                        $9e453b5784a8464e$var$logger.debug("Failed to sync cache info into memory", e_10);
                        throw e_10;
                    case 4:
                        federatedInfo = null;
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem("aws-amplify-federatedInfo"));
                        } catch (e) {
                            $9e453b5784a8464e$var$logger.debug("failed to get or parse item aws-amplify-federatedInfo", e);
                        }
                        if (federatedInfo) // refresh the jwt token here if necessary
                        return [
                            2 /*return*/ ,
                            this.Credentials.refreshFederatedToken(federatedInfo)
                        ];
                        else return [
                            2 /*return*/ ,
                            this.currentSession().then(function(session) {
                                $9e453b5784a8464e$var$logger.debug("getting session success", session);
                                return _this.Credentials.set(session, "session");
                            }).catch(function() {
                                $9e453b5784a8464e$var$logger.debug("getting guest credentials");
                                return _this.Credentials.set(null, "guest");
                            })
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.currentCredentials = function() {
        $9e453b5784a8464e$var$logger.debug("getting current credentials");
        return this.Credentials.get();
    };
    /**
     * Initiate an attribute confirmation request
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attributes to be verified
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttribute = function(user, attr, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.getAttributeVerificationCode(attr, {
                onSuccess: function(success) {
                    return resolve(success);
                },
                onFailure: function(err) {
                    return reject(err);
                }
            }, clientMetadata);
        });
    };
    /**
     * Confirm an attribute using a confirmation code
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttributeSubmit = function(user, attr, code) {
        if (!code) return this.rejectAuthError((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).EmptyCode);
        return new Promise(function(resolve, reject) {
            user.verifyAttribute(attr, code, {
                onSuccess: function(data) {
                    resolve(data);
                    return;
                },
                onFailure: function(err) {
                    reject(err);
                    return;
                }
            });
        });
    };
    AuthClass.prototype.verifyCurrentUserAttribute = function(attr) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttribute(user, attr);
        });
    };
    /**
     * Confirm current user's attribute using a confirmation code
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyCurrentUserAttributeSubmit = function(attr, code) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttributeSubmit(user, attr, code);
        });
    };
    AuthClass.prototype.cognitoIdentitySignOut = function(opts, user) {
        return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var e_11, isSignedInHostedUI;
            var _this = this;
            return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_11 = _a.sent();
                        $9e453b5784a8464e$var$logger.debug("Failed to sync cache info into memory", e_11);
                        throw e_11;
                    case 3:
                        isSignedInHostedUI = this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true";
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                if (opts && opts.global) {
                                    $9e453b5784a8464e$var$logger.debug("user global sign out", user);
                                    // in order to use global signout
                                    // we must validate the user as an authenticated user by using getSession
                                    var clientMetadata = _this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
                                    user.getSession(function(err, result) {
                                        return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                            var cleanUpError_7;
                                            var _this = this;
                                            return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                                                switch(_a.label){
                                                    case 0:
                                                        if (!err) return [
                                                            3 /*break*/ ,
                                                            5
                                                        ];
                                                        $9e453b5784a8464e$var$logger.debug("failed to get the user session", err);
                                                        if (!this.isSessionInvalid(err)) return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                        _a.label = 1;
                                                    case 1:
                                                        _a.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.cleanUpInvalidSession(user)
                                                        ];
                                                    case 2:
                                                        _a.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                    case 3:
                                                        cleanUpError_7 = _a.sent();
                                                        rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_7.message));
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                    case 4:
                                                        return [
                                                            2 /*return*/ ,
                                                            rej(err)
                                                        ];
                                                    case 5:
                                                        user.globalSignOut({
                                                            onSuccess: function(data) {
                                                                $9e453b5784a8464e$var$logger.debug("global sign out success");
                                                                if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                                                else return res();
                                                            },
                                                            onFailure: function(err) {
                                                                $9e453b5784a8464e$var$logger.debug("global sign out failed", err);
                                                                return rej(err);
                                                            }
                                                        });
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        clientMetadata: clientMetadata
                                    });
                                } else {
                                    $9e453b5784a8464e$var$logger.debug("user sign out", user);
                                    user.signOut(function() {
                                        if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                        else return res();
                                    });
                                }
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.oAuthSignOutRedirect = function(resolve, reject) {
        var isBrowser = (0, $4fe24881fb69f2d5$export$a2708fdb45cd35f)().isBrowser;
        if (isBrowser) this.oAuthSignOutRedirectOrReject(reject);
        else this.oAuthSignOutAndResolve(resolve);
    };
    AuthClass.prototype.oAuthSignOutAndResolve = function(resolve) {
        this._oAuthHandler.signOut();
        resolve();
    };
    AuthClass.prototype.oAuthSignOutRedirectOrReject = function(reject) {
        this._oAuthHandler.signOut(); // this method redirects url
        // App should be redirected to another url otherwise it will reject
        setTimeout(function() {
            return reject(Error("Signout timeout fail"));
        }, 3000);
    };
    /**
     * Sign out method
     * @
     * @return - A promise resolved if success
     */ AuthClass.prototype.signOut = function(opts) {
        return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var e_12, user;
            return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cleanCachedItems()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_12 = _a.sent();
                        $9e453b5784a8464e$var$logger.debug("failed to clear cached items");
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        if (!this.userPool) return [
                            3 /*break*/ ,
                            7
                        ];
                        user = this.userPool.getCurrentUser();
                        if (!user) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.cognitoIdentitySignOut(opts, user)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        $9e453b5784a8464e$var$logger.debug("no current Cognito user");
                        _a.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        $9e453b5784a8464e$var$logger.debug("no Cognito User pool");
                        _a.label = 8;
                    case 8:
                        /**
                         * Note for future refactor - no reliable way to get username with
                         * Cognito User Pools vs Identity when federating with Social Providers
                         * This is why we need a well structured session object that can be inspected
                         * and information passed back in the message below for Hub dispatch
                         */ $9e453b5784a8464e$var$dispatchAuthEvent("signOut", this.user, "A user has been signed out");
                        this.user = null;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.cleanCachedItems = function() {
        return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // clear cognito cached item
                        return [
                            4 /*yield*/ ,
                            this.Credentials.clear()
                        ];
                    case 1:
                        // clear cognito cached item
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Change a password for an authenticated user
     * @param {Object} user - The CognitoUser object
     * @param {String} oldPassword - the current password
     * @param {String} newPassword - the requested new password
     * @return - A promise resolves if success
     */ AuthClass.prototype.changePassword = function(user, oldPassword, newPassword, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.changePassword(oldPassword, newPassword, function(err, data) {
                    if (err) {
                        $9e453b5784a8464e$var$logger.debug("change password failure", err);
                        return reject(err);
                    } else return resolve(data);
                }, clientMetadata);
            });
        });
    };
    /**
     * Initiate a forgot password request
     * @param {String} username - the username to change password
     * @return - A promise resolves if success
     */ AuthClass.prototype.forgotPassword = function(username, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.forgotPassword({
                onSuccess: function() {
                    resolve();
                    return;
                },
                onFailure: function(err) {
                    $9e453b5784a8464e$var$logger.debug("forgot password failure", err);
                    $9e453b5784a8464e$var$dispatchAuthEvent("forgotPassword_failure", err, username + " forgotPassword failed");
                    reject(err);
                    return;
                },
                inputVerificationCode: function(data) {
                    $9e453b5784a8464e$var$dispatchAuthEvent("forgotPassword", user, username + " has initiated forgot password flow");
                    resolve(data);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Confirm a new password using a confirmation Code
     * @param {String} username - The username
     * @param {String} code - The confirmation code
     * @param {String} password - The new password
     * @return - A promise that resolves if success
     */ AuthClass.prototype.forgotPasswordSubmit = function(username, code, password, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).EmptyUsername);
        if (!code) return this.rejectAuthError((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).EmptyCode);
        if (!password) return this.rejectAuthError((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).EmptyPassword);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.confirmPassword(code, password, {
                onSuccess: function(success) {
                    $9e453b5784a8464e$var$dispatchAuthEvent("forgotPasswordSubmit", user, username + " forgotPasswordSubmit successful");
                    resolve(success);
                    return;
                },
                onFailure: function(err) {
                    $9e453b5784a8464e$var$dispatchAuthEvent("forgotPasswordSubmit_failure", err, username + " forgotPasswordSubmit failed");
                    reject(err);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Get user information
     * @async
     * @return {Object }- current User's information
     */ AuthClass.prototype.currentUserInfo = function() {
        return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var source, user, attributes, userAttrs, credentials, e_13, info, err_2, user;
            return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        source = this.Credentials.getCredSource();
                        if (!(!source || source === "aws" || source === "userPool")) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser().catch(function(err) {
                                return $9e453b5784a8464e$var$logger.error(err);
                            })
                        ];
                    case 1:
                        user = _a.sent();
                        if (!user) return [
                            2 /*return*/ ,
                            null
                        ];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.userAttributes(user)
                        ];
                    case 3:
                        attributes = _a.sent();
                        userAttrs = this.attributesToObject(attributes);
                        credentials = null;
                        _a.label = 4;
                    case 4:
                        _a.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentCredentials()
                        ];
                    case 5:
                        credentials = _a.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        e_13 = _a.sent();
                        $9e453b5784a8464e$var$logger.debug("Failed to retrieve credentials while getting current user info", e_13);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        info = {
                            id: credentials ? credentials.identityId : undefined,
                            username: user.getUsername(),
                            attributes: userAttrs
                        };
                        return [
                            2 /*return*/ ,
                            info
                        ];
                    case 8:
                        err_2 = _a.sent();
                        $9e453b5784a8464e$var$logger.error("currentUserInfo error", err_2);
                        return [
                            2 /*return*/ ,
                            {}
                        ];
                    case 9:
                        if (source === "federated") {
                            user = this.user;
                            return [
                                2 /*return*/ ,
                                user ? user : {}
                            ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.federatedSignIn = function(providerOrOptions, response, user) {
        return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var options, provider, customState, client_id, redirect_uri, provider, loggedInUser, token, identity_id, expires_at, credentials, currentUser;
            return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation requires either a User Pool or Identity Pool in config");
                        // Ensure backwards compatability
                        if (typeof providerOrOptions === "undefined") {
                            if (this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation with Identity Pools requires tokens passed as arguments");
                        }
                        if (!((0, $f267bd63d0d39d9d$export$9b905d6895bdc426)(providerOrOptions) || (0, $f267bd63d0d39d9d$export$828f8efbdf71714b)(providerOrOptions) || (0, $f267bd63d0d39d9d$export$6bae5520ca265d22)(providerOrOptions) || typeof providerOrOptions === "undefined")) return [
                            3 /*break*/ ,
                            1
                        ];
                        options = providerOrOptions || {
                            provider: (0, $f267bd63d0d39d9d$export$eeb013770cb92342).Cognito
                        };
                        provider = (0, $f267bd63d0d39d9d$export$9b905d6895bdc426)(options) ? options.provider : options.customProvider;
                        customState = (0, $f267bd63d0d39d9d$export$9b905d6895bdc426)(options) ? options.customState : options.customState;
                        if (this._config.userPoolId) {
                            client_id = (0, $f267bd63d0d39d9d$export$b380f8ec78ef17c8)(this._config.oauth) ? this._config.userPoolWebClientId : this._config.oauth.clientID;
                            redirect_uri = (0, $f267bd63d0d39d9d$export$b380f8ec78ef17c8)(this._config.oauth) ? this._config.oauth.redirectSignIn : this._config.oauth.redirectUri;
                            this._oAuthHandler.oauthSignIn(this._config.oauth.responseType, this._config.oauth.domain, redirect_uri, client_id, provider, customState);
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 1:
                        provider = providerOrOptions;
                        // To check if the user is already logged in
                        try {
                            loggedInUser = JSON.stringify(JSON.parse(this._storage.getItem("aws-amplify-federatedInfo")).user);
                            if (loggedInUser) $9e453b5784a8464e$var$logger.warn("There is already a signed in user: " + loggedInUser + " in your app.\n																	You should not call Auth.federatedSignIn method again as it may cause unexpected behavior.");
                        } catch (e) {}
                        token = response.token, identity_id = response.identity_id, expires_at = response.expires_at;
                        return [
                            4 /*yield*/ ,
                            this.Credentials.set({
                                provider: provider,
                                token: token,
                                identity_id: identity_id,
                                user: user,
                                expires_at: expires_at
                            }, "federation")
                        ];
                    case 2:
                        credentials = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.currentAuthenticatedUser()
                        ];
                    case 3:
                        currentUser = _a.sent();
                        $9e453b5784a8464e$var$dispatchAuthEvent("signIn", currentUser, "A user " + currentUser.username + " has been signed in");
                        $9e453b5784a8464e$var$logger.debug("federated sign in credentials", credentials);
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Used to complete the OAuth flow with or without the Cognito Hosted UI
     * @param {String} URL - optional parameter for customers to pass in the response URL
     */ AuthClass.prototype._handleAuthResponse = function(URL) {
        return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var currentUrl, hasCodeOrError, hasTokenOrError, _a, accessToken, idToken, refreshToken, state, session, credentials, isCustomStateIncluded, currentUser, customState, err_3;
            return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (this.oAuthFlowInProgress) {
                            $9e453b5784a8464e$var$logger.debug("Skipping URL " + URL + " current flow in progress");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            8,
                            9
                        ]);
                        this.oAuthFlowInProgress = true;
                        if (!this._config.userPoolId) throw new Error("OAuth responses require a User Pool defined in config");
                        $9e453b5784a8464e$var$dispatchAuthEvent("parsingCallbackUrl", {
                            url: URL
                        }, "The callback url is being parsed");
                        currentUrl = URL || ((0, $4fe24881fb69f2d5$export$a2708fdb45cd35f)().isBrowser ? window.location.href : "");
                        hasCodeOrError = !!((0, $eAyj5.parse)(currentUrl).query || "").split("&").map(function(entry) {
                            return entry.split("=");
                        }).find(function(_a) {
                            var _b = (0, $b054e3c0d18c20fe$export$8d051b38c9118094)(_a, 1), k = _b[0];
                            return k === "code" || k === "error";
                        });
                        hasTokenOrError = !!((0, $eAyj5.parse)(currentUrl).hash || "#").substr(1).split("&").map(function(entry) {
                            return entry.split("=");
                        }).find(function(_a) {
                            var _b = (0, $b054e3c0d18c20fe$export$8d051b38c9118094)(_a, 1), k = _b[0];
                            return k === "access_token" || k === "error";
                        });
                        if (!(hasCodeOrError || hasTokenOrError)) return [
                            3 /*break*/ ,
                            7
                        ];
                        this._storage.setItem("amplify-redirected-from-hosted-ui", "true");
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._oAuthHandler.handleAuthResponse(currentUrl)
                        ];
                    case 3:
                        _a = _b.sent(), accessToken = _a.accessToken, idToken = _a.idToken, refreshToken = _a.refreshToken, state = _a.state;
                        session = new (0, $45e3ad811e5296cd$export$2e2bcd8739ae039)({
                            IdToken: new (0, $d9c1dd270429cf89$export$2e2bcd8739ae039)({
                                IdToken: idToken
                            }),
                            RefreshToken: new (0, $fdaf527344dd671b$export$2e2bcd8739ae039)({
                                RefreshToken: refreshToken
                            }),
                            AccessToken: new (0, $41c9382bb6a72dfa$export$2e2bcd8739ae039)({
                                AccessToken: accessToken
                            })
                        });
                        credentials = void 0;
                        if (!this._config.identityPoolId) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.Credentials.set(session, "session")
                        ];
                    case 4:
                        credentials = _b.sent();
                        $9e453b5784a8464e$var$logger.debug("AWS credentials", credentials);
                        _b.label = 5;
                    case 5:
                        isCustomStateIncluded = /-/.test(state);
                        currentUser = this.createCognitoUser(session.getIdToken().decodePayload()["cognito:username"]);
                        // This calls cacheTokens() in Cognito SDK
                        currentUser.setSignInUserSession(session);
                        if (window && typeof window.history !== "undefined") window.history.replaceState({}, null, this._config.oauth.redirectSignIn);
                        $9e453b5784a8464e$var$dispatchAuthEvent("signIn", currentUser, "A user " + currentUser.getUsername() + " has been signed in");
                        $9e453b5784a8464e$var$dispatchAuthEvent("cognitoHostedUI", currentUser, "A user " + currentUser.getUsername() + " has been signed in via Cognito Hosted UI");
                        if (isCustomStateIncluded) {
                            customState = state.split("-").splice(1).join("-");
                            $9e453b5784a8464e$var$dispatchAuthEvent("customOAuthState", (0, $019354a06509f3ba$export$a7ea17e93539f9a5)(customState), "State for user " + currentUser.getUsername());
                        }
                        //#endregion
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 6:
                        err_3 = _b.sent();
                        $9e453b5784a8464e$var$logger.debug("Error in cognito hosted auth response", err_3);
                        // Just like a successful handling of `?code`, replace the window history to "dispose" of the `code`.
                        // Otherwise, reloading the page will throw errors as the `code` has already been spent.
                        if (window && typeof window.history !== "undefined") window.history.replaceState({}, null, this._config.oauth.redirectSignIn);
                        $9e453b5784a8464e$var$dispatchAuthEvent("signIn_failure", err_3, "The OAuth response flow failed");
                        $9e453b5784a8464e$var$dispatchAuthEvent("cognitoHostedUI_failure", err_3, "A failure occurred when returning to the Cognito Hosted UI");
                        $9e453b5784a8464e$var$dispatchAuthEvent("customState_failure", err_3, "A failure occurred when returning state");
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        this.oAuthFlowInProgress = false;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ AuthClass.prototype.essentialCredentials = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    AuthClass.prototype.attributesToObject = function(attributes) {
        var _this = this;
        var obj = {};
        if (attributes) attributes.map(function(attribute) {
            if (attribute.Name === "email_verified" || attribute.Name === "phone_number_verified") obj[attribute.Name] = _this.isTruthyString(attribute.Value) || attribute.Value === true;
            else obj[attribute.Name] = attribute.Value;
        });
        return obj;
    };
    AuthClass.prototype.isTruthyString = function(value) {
        return typeof value.toLowerCase === "function" && value.toLowerCase() === "true";
    };
    AuthClass.prototype.createCognitoUser = function(username) {
        var userData = {
            Username: username,
            Pool: this.userPool
        };
        userData.Storage = this._storage;
        var authenticationFlowType = this._config.authenticationFlowType;
        var user = new (0, $a44bf0d9fbe2b4df$export$2e2bcd8739ae039)(userData);
        if (authenticationFlowType) user.setAuthenticationFlowType(authenticationFlowType);
        return user;
    };
    AuthClass.prototype._isValidAuthStorage = function(obj) {
        // We need to check if the obj has the functions of Storage
        return !!obj && typeof obj.getItem === "function" && typeof obj.setItem === "function" && typeof obj.removeItem === "function" && typeof obj.clear === "function";
    };
    AuthClass.prototype.noUserPoolErrorHandler = function(config) {
        if (config) {
            if (!config.userPoolId || !config.identityPoolId) return (0, $f267bd63d0d39d9d$export$edb367c0a140d3db).MissingAuthConfig;
        }
        return (0, $f267bd63d0d39d9d$export$edb367c0a140d3db).NoConfig;
    };
    AuthClass.prototype.rejectAuthError = function(type) {
        return Promise.reject(new (0, $32e07c5f35861dc7$export$145273558d58e0ac)(type));
    };
    AuthClass.prototype.rejectNoUserPool = function() {
        var type = this.noUserPoolErrorHandler(this._config);
        return Promise.reject(new (0, $32e07c5f35861dc7$export$71192787e041818c)(type));
    };
    AuthClass.prototype.rememberDevice = function() {
        return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var currUser, error_2;
            return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_2 = _a.sent();
                        $9e453b5784a8464e$var$logger.debug("The user is not authenticated by the error", error_2);
                        return [
                            2 /*return*/ ,
                            Promise.reject("The user is not authenticated")
                        ];
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                currUser.setDeviceStatusRemembered({
                                    onSuccess: function(data) {
                                        res(data);
                                    },
                                    onFailure: function(err) {
                                        if (err.code === "InvalidParameterException") rej(new (0, $32e07c5f35861dc7$export$145273558d58e0ac)((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).DeviceConfig));
                                        else if (err.code === "NetworkError") rej(new (0, $32e07c5f35861dc7$export$145273558d58e0ac)((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).NetworkError));
                                        else rej(err);
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.forgetDevice = function() {
        return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var currUser, error_3;
            return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_3 = _a.sent();
                        $9e453b5784a8464e$var$logger.debug("The user is not authenticated by the error", error_3);
                        return [
                            2 /*return*/ ,
                            Promise.reject("The user is not authenticated")
                        ];
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                currUser.forgetDevice({
                                    onSuccess: function(data) {
                                        res(data);
                                    },
                                    onFailure: function(err) {
                                        if (err.code === "InvalidParameterException") rej(new (0, $32e07c5f35861dc7$export$145273558d58e0ac)((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).DeviceConfig));
                                        else if (err.code === "NetworkError") rej(new (0, $32e07c5f35861dc7$export$145273558d58e0ac)((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).NetworkError));
                                        else rej(err);
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.fetchDevices = function() {
        return (0, $b054e3c0d18c20fe$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var currUser, error_4;
            return (0, $b054e3c0d18c20fe$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_4 = _a.sent();
                        $9e453b5784a8464e$var$logger.debug("The user is not authenticated by the error", error_4);
                        throw new Error("The user is not authenticated");
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                var cb = {
                                    onSuccess: function(data) {
                                        var deviceList = data.Devices.map(function(device) {
                                            var deviceName = device.DeviceAttributes.find(function(_a) {
                                                var Name = _a.Name;
                                                return Name === "device_name";
                                            }) || {};
                                            var deviceInfo = {
                                                id: device.DeviceKey,
                                                name: deviceName.Value
                                            };
                                            return deviceInfo;
                                        });
                                        res(deviceList);
                                    },
                                    onFailure: function(err) {
                                        if (err.code === "InvalidParameterException") rej(new (0, $32e07c5f35861dc7$export$145273558d58e0ac)((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).DeviceConfig));
                                        else if (err.code === "NetworkError") rej(new (0, $32e07c5f35861dc7$export$145273558d58e0ac)((0, $f267bd63d0d39d9d$export$edb367c0a140d3db).NetworkError));
                                        else rej(err);
                                    }
                                };
                                currUser.listDevices($9e453b5784a8464e$var$MAX_DEVICES, null, cb);
                            })
                        ];
                }
            });
        });
    };
    return AuthClass;
}();
var $9e453b5784a8464e$export$334c29725a78c21d = new $9e453b5784a8464e$export$eeff9d1a8b8c057b(null);
(0, $6ff5c7c169206e21$export$a3858a9a153cffc7).register($9e453b5784a8464e$export$334c29725a78c21d);





var /**
 * @deprecated use named import
 */ $a29751a163d4c549$export$2e2bcd8739ae039 = (0, $9e453b5784a8464e$export$334c29725a78c21d);


var $112df51fe8154441$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $112df51fe8154441$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $112df51fe8154441$var$StyledBox = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $77ec199cefd4182a$export$2e2bcd8739ae039))({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
var $112df51fe8154441$var$StyledTypography = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $caf112117fe1fc50$export$2e2bcd8739ae039))({
    marginRight: 8
});
var $112df51fe8154441$var$LoginPage = function(_a) {
    var navigatePage = _a.navigatePage;
    var _b = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false), Loading = _b[0], setLoading = _b[1];
    var formConfig = [
        {
            name: "email",
            label: "Email",
            fieldType: "input",
            icon: "email",
            isRequired: true,
            validations: {
                type: "email",
                required: true,
                customMessages: {
                    required: "Email can't be blank.",
                    email: "That doesn't look like a valid email address."
                }
            }
        },
        {
            name: "password",
            label: "Password",
            fieldType: "password",
            icon: "password",
            isRequired: true,
            validations: {
                type: "password",
                required: true,
                minLength: 8,
                customMessages: {
                    required: "Password can't be blank.",
                    minLength: "Passwords should be at least 8 characters."
                }
            }
        }
    ];
    var handleFormSubmit = function(data) {
        return $112df51fe8154441$var$__awaiter(void 0, void 0, void 0, function() {
            var user, userAttributes, error_1, ex_1;
            return $112df51fe8154441$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        setLoading(true);
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        (0, $de77e498e07914bf$export$b410431fab84fa58).loading("Processing...");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4,
                            (0, $9e453b5784a8464e$export$334c29725a78c21d).signIn(data.email, data.password)
                        ];
                    case 2:
                        user = _a.sent();
                        if (!(user.challengeName === "NEW_PASSWORD_REQUIRED")) return [
                            3,
                            6
                        ];
                        userAttributes = {
                            name: "Muhammad Jafer"
                        };
                        _a.label = 3;
                    case 3:
                        _a.trys.push([
                            3,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            (0, $9e453b5784a8464e$export$334c29725a78c21d).completeNewPassword(user, "Nopass@1947", userAttributes)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        error_1 = _a.sent();
                        console.error("Error completing new password challenge:", error_1);
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        setLoading(false);
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        ex_1 = _a.sent();
                        setLoading(false);
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        (0, $de77e498e07914bf$export$b410431fab84fa58).error("Incorrect username or password", {
                            autoClose: false
                        });
                        return [
                            2
                        ];
                    case 8:
                        (0, $de77e498e07914bf$export$b410431fab84fa58).success("Login Successful");
                        navigatePage("/");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cb41040a78bf22dc$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $583409c85622bda5$export$3b3351848a5e0231), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $583409c85622bda5$export$69b6e38dc7d8a757), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
        width: "300px",
        style: {
            backgroundColor: "blue"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a416711bf93b5db7$export$2e2bcd8739ae039), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $583409c85622bda5$export$5d77723460428c5b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $caf112117fe1fc50$export$2e2bcd8739ae039), {
        variant: "h5",
        align: "center",
        gutterBottom: true
    }, "Welcome to Startupmuster Admin Panel! \uD83D\uDC4B\uD83C\uDFFB"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $caf112117fe1fc50$export$2e2bcd8739ae039), {
        variant: "subtitle1",
        align: "center",
        gutterBottom: true
    }, "Exclusively for administrators. Manage and create surveys."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8f033a6d446e1ef1$export$2e2bcd8739ae039), {
        marginTop: "1rem"
    }), Loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $02d7d65f84f180ce$export$2e2bcd8739ae039), {
        number: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        style: {
            display: Loading ? "none" : "block",
            width: "100%"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d3accb062935cef9$export$2e2bcd8739ae039), {
        key: 0,
        fields: formConfig,
        onSubmit: handleFormSubmit,
        submitButtonText: "SIGN IN",
        extraBeforeButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8f033a6d446e1ef1$export$2e2bcd8739ae039), {
            marginTop: "0rem"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
            control: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4d99e6d55ec7d57a$export$2e2bcd8739ae039), {
                value: "remember",
                color: "primary"
            }),
            label: "Remember me"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $caf112117fe1fc50$export$2e2bcd8739ae039), {
            variant: "body2",
            align: "right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $0ffd2a40b14139b1$export$2e2bcd8739ae039), {
            href: "",
            onClick: function() {
                navigatePage("/password/request/reset");
            }
        }, "Forgot Password?"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8f033a6d446e1ef1$export$2e2bcd8739ae039), {
            marginTop: "1rem"
        }))
    })))));
};
var $112df51fe8154441$export$2e2bcd8739ae039 = $112df51fe8154441$var$LoginPage;



var $7fPBF = parcelRequire("7fPBF");





var $cd1840d04f05f9d4$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $cd1840d04f05f9d4$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $cd1840d04f05f9d4$var$ResetPasswordPage = function(_a) {
    var navigatePage = _a.navigatePage;
    var formConfig = [
        {
            name: "email",
            label: "Email",
            fieldType: "input",
            icon: "email",
            isRequired: true,
            validations: {
                type: "email",
                required: true,
                customMessages: {
                    required: "Email can't be blank.",
                    email: "That doesn't look like a valid email address."
                }
            }
        }
    ];
    var handleFormSubmit = function(data) {
        return $cd1840d04f05f9d4$var$__awaiter(void 0, void 0, void 0, function() {
            var ex_1;
            return $cd1840d04f05f9d4$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, $9e453b5784a8464e$export$334c29725a78c21d).forgotPassword(data.email)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        ex_1 = _a.sent();
                        console.log("Form.test.tsx data:", ex_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        (0, $de77e498e07914bf$export$b410431fab84fa58).info("Your request has been processed. If you are registered user, you should recieve an email", {
                            position: (0, $de77e498e07914bf$export$b410431fab84fa58).POSITION.TOP_RIGHT,
                            autoClose: false
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cb41040a78bf22dc$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a416711bf93b5db7$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $583409c85622bda5$export$3b3351848a5e0231), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $583409c85622bda5$export$69b6e38dc7d8a757), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $583409c85622bda5$export$5d77723460428c5b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $caf112117fe1fc50$export$2e2bcd8739ae039), {
        variant: "h5",
        align: "center",
        gutterBottom: true
    }, "Welcome to Startupmuster Admin Panel! \uD83D\uDC4B\uD83C\uDFFB"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $caf112117fe1fc50$export$2e2bcd8739ae039), {
        variant: "subtitle1",
        align: "center",
        gutterBottom: true
    }, "Exclusively for administrators. Manage and create surveys."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8f033a6d446e1ef1$export$2e2bcd8739ae039), {
        marginTop: "1rem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d3accb062935cef9$export$2e2bcd8739ae039), {
        fields: formConfig,
        onSubmit: handleFormSubmit,
        submitButtonText: "RESET PASSWORD",
        extraBeforeButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8f033a6d446e1ef1$export$2e2bcd8739ae039), {
            marginTop: "0rem"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
            control: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null),
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $caf112117fe1fc50$export$2e2bcd8739ae039), {
            variant: "body2",
            align: "right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $0ffd2a40b14139b1$export$2e2bcd8739ae039), {
            href: "",
            onClick: function() {
                navigatePage("/login");
            }
        }, "Login"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8f033a6d446e1ef1$export$2e2bcd8739ae039), {
            marginTop: "1rem"
        }))
    })))));
};
var $cd1840d04f05f9d4$export$2e2bcd8739ae039 = $cd1840d04f05f9d4$var$ResetPasswordPage;


var $0a4caa2c2698f967$var$ProtectedRoutes = {
    Login: {
        Component: (0, $112df51fe8154441$export$2e2bcd8739ae039),
        type: "protected",
        route: "/login",
        title: "Login"
    },
    ResetPassword: {
        Component: (0, $cd1840d04f05f9d4$export$2e2bcd8739ae039),
        type: "protected",
        route: "/password/request/reset",
        title: "Forgot Password"
    }
};
var $0a4caa2c2698f967$export$2e2bcd8739ae039 = $0a4caa2c2698f967$var$ProtectedRoutes;



var $7fPBF = parcelRequire("7fPBF");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $033c8ca1c8420c0b$var$extendStatics = function(d, b) {
    $033c8ca1c8420c0b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $033c8ca1c8420c0b$var$extendStatics(d, b);
};
function $033c8ca1c8420c0b$export$a8ba968b8961cb8a(d, b) {
    $033c8ca1c8420c0b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $033c8ca1c8420c0b$export$18ce0697a983be9b = function() {
    $033c8ca1c8420c0b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $033c8ca1c8420c0b$export$18ce0697a983be9b.apply(this, arguments);
};
function $033c8ca1c8420c0b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $033c8ca1c8420c0b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $033c8ca1c8420c0b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $033c8ca1c8420c0b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $033c8ca1c8420c0b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $033c8ca1c8420c0b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $033c8ca1c8420c0b$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $033c8ca1c8420c0b$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $033c8ca1c8420c0b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $033c8ca1c8420c0b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $033c8ca1c8420c0b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($033c8ca1c8420c0b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $033c8ca1c8420c0b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $033c8ca1c8420c0b$export$10c90e4f7922046c(v) {
    return this instanceof $033c8ca1c8420c0b$export$10c90e4f7922046c ? (this.v = v, this) : new $033c8ca1c8420c0b$export$10c90e4f7922046c(v);
}
function $033c8ca1c8420c0b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $033c8ca1c8420c0b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $033c8ca1c8420c0b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $033c8ca1c8420c0b$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $033c8ca1c8420c0b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $033c8ca1c8420c0b$export$19a8beecd37a4c45 === "function" ? $033c8ca1c8420c0b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $033c8ca1c8420c0b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $033c8ca1c8420c0b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $033c8ca1c8420c0b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $033c8ca1c8420c0b$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $033c8ca1c8420c0b$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}




/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $7d95c07d19eb445d$var$extendStatics = function(d, b) {
    $7d95c07d19eb445d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $7d95c07d19eb445d$var$extendStatics(d, b);
};
function $7d95c07d19eb445d$export$a8ba968b8961cb8a(d, b) {
    $7d95c07d19eb445d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $7d95c07d19eb445d$export$18ce0697a983be9b = function() {
    $7d95c07d19eb445d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7d95c07d19eb445d$export$18ce0697a983be9b.apply(this, arguments);
};
function $7d95c07d19eb445d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $7d95c07d19eb445d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $7d95c07d19eb445d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $7d95c07d19eb445d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $7d95c07d19eb445d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $7d95c07d19eb445d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $7d95c07d19eb445d$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $7d95c07d19eb445d$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $7d95c07d19eb445d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $7d95c07d19eb445d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $7d95c07d19eb445d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($7d95c07d19eb445d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $7d95c07d19eb445d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $7d95c07d19eb445d$export$10c90e4f7922046c(v) {
    return this instanceof $7d95c07d19eb445d$export$10c90e4f7922046c ? (this.v = v, this) : new $7d95c07d19eb445d$export$10c90e4f7922046c(v);
}
function $7d95c07d19eb445d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $7d95c07d19eb445d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $7d95c07d19eb445d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $7d95c07d19eb445d$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $7d95c07d19eb445d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $7d95c07d19eb445d$export$19a8beecd37a4c45 === "function" ? $7d95c07d19eb445d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $7d95c07d19eb445d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $7d95c07d19eb445d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $7d95c07d19eb445d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $7d95c07d19eb445d$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $7d95c07d19eb445d$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


function $5ac2620ded7ab85b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5ac2620ded7ab85b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $5ac2620ded7ab85b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5ac2620ded7ab85b$var$_typeof(obj);
}
function $5ac2620ded7ab85b$export$2e2bcd8739ae039(value) {
    return $5ac2620ded7ab85b$var$_typeof(value) == "object" && value !== null;
}


// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $c6abdc0167301e1d$export$f6cdee3c26d6da57 = typeof Symbol === "function" && Symbol.iterator != null ? Symbol.iterator : "@@iterator"; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $c6abdc0167301e1d$export$8d0083df0471478e = typeof Symbol === "function" && Symbol.asyncIterator != null ? Symbol.asyncIterator : "@@asyncIterator"; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $c6abdc0167301e1d$export$5deadc579ccc7c9c = typeof Symbol === "function" && Symbol.toStringTag != null ? Symbol.toStringTag : "@@toStringTag";


/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $7ea20c9d4098caaf$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}



function $280d710c8621a0ac$export$96a9681e539deed(location) {
    return $280d710c8621a0ac$export$867940333fd9f869(location.source, (0, $7ea20c9d4098caaf$export$e7fd20fad3cf4b5f)(location.source, location.start));
}
function $280d710c8621a0ac$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $280d710c8621a0ac$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $280d710c8621a0ac$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                "",
                subLine
            ];
        }), [
            [
                " ",
                $280d710c8621a0ac$var$whitespace(subLineColumnNum - 1) + "^"
            ],
            [
                "",
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $280d710c8621a0ac$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            "",
            $280d710c8621a0ac$var$whitespace(columnNum - 1) + "^"
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $280d710c8621a0ac$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $280d710c8621a0ac$var$leftPad(padLen, prefix) + (line ? " | " + line : " |");
    }).join("\n");
}
function $280d710c8621a0ac$var$whitespace(len) {
    return Array(len + 1).join(" ");
}
function $280d710c8621a0ac$var$leftPad(len, str) {
    return $280d710c8621a0ac$var$whitespace(len - str.length) + str;
}


function $b81b6b4578512de6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b81b6b4578512de6$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $b81b6b4578512de6$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b81b6b4578512de6$var$_typeof(obj);
}
function $b81b6b4578512de6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b81b6b4578512de6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $b81b6b4578512de6$var$ownKeys(Object(source), true).forEach(function(key) {
            $b81b6b4578512de6$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $b81b6b4578512de6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b81b6b4578512de6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b81b6b4578512de6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b81b6b4578512de6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b81b6b4578512de6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b81b6b4578512de6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b81b6b4578512de6$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $b81b6b4578512de6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $b81b6b4578512de6$var$_setPrototypeOf(subClass, superClass);
}
function $b81b6b4578512de6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b81b6b4578512de6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $b81b6b4578512de6$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $b81b6b4578512de6$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b81b6b4578512de6$var$_possibleConstructorReturn(this, result);
    };
}
function $b81b6b4578512de6$var$_possibleConstructorReturn(self, call) {
    if (call && ($b81b6b4578512de6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $b81b6b4578512de6$var$_assertThisInitialized(self);
}
function $b81b6b4578512de6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b81b6b4578512de6$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $b81b6b4578512de6$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$b81b6b4578512de6$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $b81b6b4578512de6$var$_construct(Class, arguments, $b81b6b4578512de6$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $b81b6b4578512de6$var$_setPrototypeOf(Wrapper, Class);
    };
    return $b81b6b4578512de6$var$_wrapNativeSuper(Class);
}
function $b81b6b4578512de6$var$_construct(Parent, args, Class) {
    if ($b81b6b4578512de6$var$_isNativeReflectConstruct()) $b81b6b4578512de6$var$_construct = Reflect.construct;
    else $b81b6b4578512de6$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $b81b6b4578512de6$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $b81b6b4578512de6$var$_construct.apply(null, arguments);
}
function $b81b6b4578512de6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b81b6b4578512de6$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $b81b6b4578512de6$var$_setPrototypeOf(o, p) {
    $b81b6b4578512de6$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b81b6b4578512de6$var$_setPrototypeOf(o, p);
}
function $b81b6b4578512de6$var$_getPrototypeOf(o) {
    $b81b6b4578512de6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b81b6b4578512de6$var$_getPrototypeOf(o);
}
var $b81b6b4578512de6$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $b81b6b4578512de6$var$_inherits(GraphQLError, _Error);
    var _super = $b81b6b4578512de6$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $b81b6b4578512de6$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = "GraphQLError";
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $b81b6b4578512de6$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $b81b6b4578512de6$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $7ea20c9d4098caaf$export$e7fd20fad3cf4b5f)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $7ea20c9d4098caaf$export$e7fd20fad3cf4b5f)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $5ac2620ded7ab85b$export$2e2bcd8739ae039)(originalExtensions)) _this.extensions = $b81b6b4578512de6$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($b81b6b4578512de6$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($b81b6b4578512de6$var$_assertThisInitialized(_this), "stack", {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $b81b6b4578512de6$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($b81b6b4578512de6$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($b81b6b4578512de6$var$_assertThisInitialized(_this), "stack", {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $b81b6b4578512de6$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $b81b6b4578512de6$export$55ee1551a3f962e6(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $c6abdc0167301e1d$export$5deadc579ccc7c9c),
            get: function get() {
                return "Object";
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $b81b6b4578512de6$var$_wrapNativeSuper(Error));
function $b81b6b4578512de6$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $b81b6b4578512de6$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += "\n\n" + (0, $280d710c8621a0ac$export$96a9681e539deed)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += "\n\n" + (0, $280d710c8621a0ac$export$867940333fd9f869)(error.source, location);
    }
    return output;
}


function $33ed40a0f4e07882$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $b81b6b4578512de6$export$92d6ed0888e7cb7f)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}


/**
 * The set of allowed kind values for AST nodes.
 */ var $ecef357b0eb1b7e8$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: "Name",
    // Document
    DOCUMENT: "Document",
    OPERATION_DEFINITION: "OperationDefinition",
    VARIABLE_DEFINITION: "VariableDefinition",
    SELECTION_SET: "SelectionSet",
    FIELD: "Field",
    ARGUMENT: "Argument",
    // Fragments
    FRAGMENT_SPREAD: "FragmentSpread",
    INLINE_FRAGMENT: "InlineFragment",
    FRAGMENT_DEFINITION: "FragmentDefinition",
    // Values
    VARIABLE: "Variable",
    INT: "IntValue",
    FLOAT: "FloatValue",
    STRING: "StringValue",
    BOOLEAN: "BooleanValue",
    NULL: "NullValue",
    ENUM: "EnumValue",
    LIST: "ListValue",
    OBJECT: "ObjectValue",
    OBJECT_FIELD: "ObjectField",
    // Directives
    DIRECTIVE: "Directive",
    // Types
    NAMED_TYPE: "NamedType",
    LIST_TYPE: "ListType",
    NON_NULL_TYPE: "NonNullType",
    // Type System Definitions
    SCHEMA_DEFINITION: "SchemaDefinition",
    OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
    // Type Definitions
    SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
    OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
    FIELD_DEFINITION: "FieldDefinition",
    INPUT_VALUE_DEFINITION: "InputValueDefinition",
    INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
    UNION_TYPE_DEFINITION: "UnionTypeDefinition",
    ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
    ENUM_VALUE_DEFINITION: "EnumValueDefinition",
    INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
    // Directive Definitions
    DIRECTIVE_DEFINITION: "DirectiveDefinition",
    // Type System Extensions
    SCHEMA_EXTENSION: "SchemaExtension",
    // Type Extensions
    SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
    OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
    INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
    UNION_TYPE_EXTENSION: "UnionTypeExtension",
    ENUM_TYPE_EXTENSION: "EnumTypeExtension",
    INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 


function $c2e91ea852c741d6$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : "Unexpected invariant triggered.");
}


// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $30d26f561d96a743$var$nodejsCustomInspectSymbol = typeof Symbol === "function" && typeof Symbol.for === "function" ? Symbol.for("nodejs.util.inspect.custom") : undefined;
var $30d26f561d96a743$export$2e2bcd8739ae039 = $30d26f561d96a743$var$nodejsCustomInspectSymbol;


function $5620172edf86d32a$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === "function" || (0, $c2e91ea852c741d6$export$2e2bcd8739ae039)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $30d26f561d96a743$export$2e2bcd8739ae039) classObject.prototype[0, $30d26f561d96a743$export$2e2bcd8739ae039] = fn;
}


var $e81858ad5f243549$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $5620172edf86d32a$export$2e2bcd8739ae039)($e81858ad5f243549$export$18a2be9195644f38);
var $e81858ad5f243549$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $5620172edf86d32a$export$2e2bcd8739ae039)($e81858ad5f243549$export$50792b0e93539fde);
function $e81858ad5f243549$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === "string";
} /**
 * The list of all possible AST node types.
 */ 


/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $cc9b3e5933bbe9a1$export$8b9d26ab11394711 = Object.freeze({
    SOF: "<SOF>",
    EOF: "<EOF>",
    BANG: "!",
    DOLLAR: "$",
    AMP: "&",
    PAREN_L: "(",
    PAREN_R: ")",
    SPREAD: "...",
    COLON: ":",
    EQUALS: "=",
    AT: "@",
    BRACKET_L: "[",
    BRACKET_R: "]",
    BRACE_L: "{",
    PIPE: "|",
    BRACE_R: "}",
    NAME: "Name",
    INT: "Int",
    FLOAT: "Float",
    STRING: "String",
    BLOCK_STRING: "BlockString",
    COMMENT: "Comment"
}); /**
 * The enum type representing the token kinds values.
 */ 




function $ecd8fa86c9b71070$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ecd8fa86c9b71070$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ecd8fa86c9b71070$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ecd8fa86c9b71070$var$_typeof(obj);
}
var $ecd8fa86c9b71070$var$MAX_ARRAY_LENGTH = 10;
var $ecd8fa86c9b71070$var$MAX_RECURSIVE_DEPTH = 2;
function $ecd8fa86c9b71070$export$2e2bcd8739ae039(value) {
    return $ecd8fa86c9b71070$var$formatValue(value, []);
}
function $ecd8fa86c9b71070$var$formatValue(value, seenValues) {
    switch($ecd8fa86c9b71070$var$_typeof(value)){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? "[function ".concat(value.name, "]") : "[function]";
        case "object":
            if (value === null) return "null";
            return $ecd8fa86c9b71070$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $ecd8fa86c9b71070$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return "[Circular]";
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $ecd8fa86c9b71070$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === "string" ? customValue : $ecd8fa86c9b71070$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $ecd8fa86c9b71070$var$formatArray(value, seenValues);
    return $ecd8fa86c9b71070$var$formatObject(value, seenValues);
}
function $ecd8fa86c9b71070$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return "{}";
    if (seenValues.length > $ecd8fa86c9b71070$var$MAX_RECURSIVE_DEPTH) return "[" + $ecd8fa86c9b71070$var$getObjectTag(object) + "]";
    var properties = keys.map(function(key) {
        var value = $ecd8fa86c9b71070$var$formatValue(object[key], seenValues);
        return key + ": " + value;
    });
    return "{ " + properties.join(", ") + " }";
}
function $ecd8fa86c9b71070$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $ecd8fa86c9b71070$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    var len = Math.min($ecd8fa86c9b71070$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($ecd8fa86c9b71070$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return "[" + items.join(", ") + "]";
}
function $ecd8fa86c9b71070$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $30d26f561d96a743$export$2e2bcd8739ae039))];
    if (typeof customInspectFn === "function") return customInspectFn;
    if (typeof object.inspect === "function") return object.inspect;
}
function $ecd8fa86c9b71070$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        var name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}


function $06a95c052eee85ee$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}



function $2875198b8b7d4c05$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2875198b8b7d4c05$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $2875198b8b7d4c05$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2875198b8b7d4c05$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$2875198b8b7d4c05$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};


function $ac4a1dd10439f667$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ac4a1dd10439f667$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ac4a1dd10439f667$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ac4a1dd10439f667$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $ac4a1dd10439f667$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "GraphQL request";
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === "string" || (0, $06a95c052eee85ee$export$2e2bcd8739ae039)(0, "Body must be a string. Received: ".concat((0, $ecd8fa86c9b71070$export$2e2bcd8739ae039)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $06a95c052eee85ee$export$2e2bcd8739ae039)(0, "line in locationOffset is 1-indexed and must be positive.");
        this.locationOffset.column > 0 || (0, $06a95c052eee85ee$export$2e2bcd8739ae039)(0, "column in locationOffset is 1-indexed and must be positive.");
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $ac4a1dd10439f667$var$_createClass(Source, [
        {
            key: (0, $c6abdc0167301e1d$export$5deadc579ccc7c9c),
            get: function get() {
                return "Source";
            }
        }
    ]);
    return Source;
}();
function $ac4a1dd10439f667$export$75135ee9ed6e435b(source) {
    return (0, $2875198b8b7d4c05$export$2e2bcd8739ae039)(source, $ac4a1dd10439f667$export$1d2df86270c81ecb);
}


/**
 * The set of allowed directive location values.
 */ var $9ec593e76e6b29f0$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: "QUERY",
    MUTATION: "MUTATION",
    SUBSCRIPTION: "SUBSCRIPTION",
    FIELD: "FIELD",
    FRAGMENT_DEFINITION: "FRAGMENT_DEFINITION",
    FRAGMENT_SPREAD: "FRAGMENT_SPREAD",
    INLINE_FRAGMENT: "INLINE_FRAGMENT",
    VARIABLE_DEFINITION: "VARIABLE_DEFINITION",
    // Type System Definitions
    SCHEMA: "SCHEMA",
    SCALAR: "SCALAR",
    OBJECT: "OBJECT",
    FIELD_DEFINITION: "FIELD_DEFINITION",
    ARGUMENT_DEFINITION: "ARGUMENT_DEFINITION",
    INTERFACE: "INTERFACE",
    UNION: "UNION",
    ENUM: "ENUM",
    ENUM_VALUE: "ENUM_VALUE",
    INPUT_OBJECT: "INPUT_OBJECT",
    INPUT_FIELD_DEFINITION: "INPUT_FIELD_DEFINITION"
}); /**
 * The enum type representing the directive location values.
 */ 





/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $8514581045a3511a$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $8514581045a3511a$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $8514581045a3511a$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $8514581045a3511a$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join("\n");
}
function $8514581045a3511a$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== " " && str[i] !== "	") return false;
    }
    return true;
}
function $8514581045a3511a$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $8514581045a3511a$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf("\n") === -1;
    var hasLeadingSpace = value[0] === " " || value[0] === "	";
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === "\\";
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ""; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += "\n" + indentation;
    result += indentation ? value.replace(/\n/g, "\n" + indentation) : value;
    if (printAsMultipleLines) result += "\n";
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}


var $52923c4cf9d72eb9$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $e81858ad5f243549$export$50792b0e93539fde)((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $52923c4cf9d72eb9$var$readToken(this, token);
        }while (token.kind === (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).COMMENT);
        return token;
    };
    return Lexer;
}();
function $52923c4cf9d72eb9$export$59ac0f4da287406a(kind) {
    return kind === (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BANG || kind === (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).DOLLAR || kind === (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).AMP || kind === (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).PAREN_L || kind === (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).PAREN_R || kind === (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).SPREAD || kind === (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).COLON || kind === (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).EQUALS || kind === (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).AT || kind === (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACKET_L || kind === (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACKET_R || kind === (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_L || kind === (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).PIPE || kind === (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_R;
}
function $52923c4cf9d72eb9$var$printCharCode(code) {
    return isNaN(code) ? (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : '"\\u'.concat(("00" + code.toString(16).toUpperCase()).slice(-4), '"');
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $52923c4cf9d72eb9$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $e81858ad5f243549$export$50792b0e93539fde)((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $52923c4cf9d72eb9$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $e81858ad5f243549$export$50792b0e93539fde)((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $e81858ad5f243549$export$50792b0e93539fde)((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $e81858ad5f243549$export$50792b0e93539fde)((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $e81858ad5f243549$export$50792b0e93539fde)((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $e81858ad5f243549$export$50792b0e93539fde)((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $e81858ad5f243549$export$50792b0e93539fde)((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $e81858ad5f243549$export$50792b0e93539fde)((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $e81858ad5f243549$export$50792b0e93539fde)((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $e81858ad5f243549$export$50792b0e93539fde)((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $e81858ad5f243549$export$50792b0e93539fde)((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $e81858ad5f243549$export$50792b0e93539fde)((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $e81858ad5f243549$export$50792b0e93539fde)((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $e81858ad5f243549$export$50792b0e93539fde)((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $52923c4cf9d72eb9$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $52923c4cf9d72eb9$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $52923c4cf9d72eb9$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $52923c4cf9d72eb9$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $33ed40a0f4e07882$export$bbee0c6176c019d4)(source, pos, $52923c4cf9d72eb9$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $e81858ad5f243549$export$50792b0e93539fde)((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $52923c4cf9d72eb9$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($52923c4cf9d72eb9$var$printCharCode(code), ".");
    if (code === 39) // '
    return "Unexpected single quote character ('), did you mean to use a double quote (\")?";
    return "Cannot parse the unexpected character ".concat($52923c4cf9d72eb9$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $52923c4cf9d72eb9$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $e81858ad5f243549$export$50792b0e93539fde)((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $52923c4cf9d72eb9$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $33ed40a0f4e07882$export$bbee0c6176c019d4)(source, position, "Invalid number, unexpected digit after 0: ".concat($52923c4cf9d72eb9$var$printCharCode(code), "."));
    } else {
        position = $52923c4cf9d72eb9$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $52923c4cf9d72eb9$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $52923c4cf9d72eb9$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $52923c4cf9d72eb9$var$isNameStart(code)) throw (0, $33ed40a0f4e07882$export$bbee0c6176c019d4)(source, position, "Invalid number, expected digit but got: ".concat($52923c4cf9d72eb9$var$printCharCode(code), "."));
    return new (0, $e81858ad5f243549$export$50792b0e93539fde)(isFloat ? (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).FLOAT : (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $52923c4cf9d72eb9$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $33ed40a0f4e07882$export$bbee0c6176c019d4)(source, position, "Invalid number, expected digit but got: ".concat($52923c4cf9d72eb9$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $52923c4cf9d72eb9$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = "";
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $e81858ad5f243549$export$50792b0e93539fde)((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $33ed40a0f4e07882$export$bbee0c6176c019d4)(source, position, "Invalid character within String: ".concat($52923c4cf9d72eb9$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += "/";
                    break;
                case 92:
                    value += "\\";
                    break;
                case 98:
                    value += "\b";
                    break;
                case 102:
                    value += "\f";
                    break;
                case 110:
                    value += "\n";
                    break;
                case 114:
                    value += "\r";
                    break;
                case 116:
                    value += "	";
                    break;
                case 117:
                    // uXXXX
                    var charCode = $52923c4cf9d72eb9$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $33ed40a0f4e07882$export$bbee0c6176c019d4)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $33ed40a0f4e07882$export$bbee0c6176c019d4)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $33ed40a0f4e07882$export$bbee0c6176c019d4)(source, position, "Unterminated string.");
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $52923c4cf9d72eb9$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = "";
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $e81858ad5f243549$export$50792b0e93539fde)((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BLOCK_STRING, start, position + 3, line, col, prev, (0, $8514581045a3511a$export$fd88c0b652c46ccc)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $33ed40a0f4e07882$export$bbee0c6176c019d4)(source, position, "Invalid character within String: ".concat($52923c4cf9d72eb9$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $33ed40a0f4e07882$export$bbee0c6176c019d4)(source, position, "Unterminated string.");
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $52923c4cf9d72eb9$var$uniCharCode(a, b, c, d) {
    return $52923c4cf9d72eb9$var$char2hex(a) << 12 | $52923c4cf9d72eb9$var$char2hex(b) << 8 | $52923c4cf9d72eb9$var$char2hex(c) << 4 | $52923c4cf9d72eb9$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $52923c4cf9d72eb9$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $52923c4cf9d72eb9$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $e81858ad5f243549$export$50792b0e93539fde)((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $52923c4cf9d72eb9$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}


function $9bdfafd0ada79eb4$export$98e6a39c04603d36(source, options) {
    var parser = new $9bdfafd0ada79eb4$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $9bdfafd0ada79eb4$export$5303528d1070ff6f(source, options) {
    var parser = new $9bdfafd0ada79eb4$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).EOF);
    return value;
}
function $9bdfafd0ada79eb4$export$28b8f402ccc88182(source, options) {
    var parser = new $9bdfafd0ada79eb4$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).EOF);
    return type;
}
var $9bdfafd0ada79eb4$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $ac4a1dd10439f667$export$75135ee9ed6e435b)(source) ? source : new (0, $ac4a1dd10439f667$export$1d2df86270c81ecb)(source);
        this._lexer = new (0, $52923c4cf9d72eb9$export$6168dc8908a6c652)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).NAME);
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).DOCUMENT,
            definitions: this.many((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).SOF, this.parseDefinition, (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).NAME)) switch(this._lexer.token.value){
            case "query":
            case "mutation":
            case "subscription":
                return this.parseOperationDefinition();
            case "fragment":
                return this.parseFragmentDefinition();
            case "schema":
            case "scalar":
            case "type":
            case "interface":
            case "union":
            case "enum":
            case "input":
            case "directive":
                return this.parseTypeSystemDefinition();
            case "extend":
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_L)) return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: "query",
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).NAME)) name = this.parseName();
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).NAME);
        switch(operationToken.value){
            case "query":
                return "query";
            case "mutation":
                return "mutation";
            case "subscription":
                return "subscription";
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).PAREN_L, this.parseVariableDefinition, (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).DOLLAR);
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).SELECTION_SET,
            selections: this.many((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_L, this.parseSelection, (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).PAREN_L, item, (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).COLON);
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword("on");
        if (!hasTypeCondition && this.peek((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).NAME)) return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword("fragment"); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === "on") throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACKET_L:
                return this.parseList(isConst);
            case (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_L:
                return this.parseObject(isConst);
            case (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).INT:
                this._lexer.advance();
                return {
                    kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).STRING:
            case (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).NAME:
                this._lexer.advance();
                switch(token.value){
                    case "true":
                        return {
                            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case "false":
                        return {
                            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case "null":
                        return {
                            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).STRING,
            value: token.value,
            block: token.kind === (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).LIST,
            values: this.any((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACKET_L, item, (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).OBJECT,
            fields: this.any((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_L, item, (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).COLON);
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).AT);
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACKET_R);
            type = {
                kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BANG)) return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaDefinition();
            case "scalar":
                return this.parseScalarTypeDefinition();
            case "type":
                return this.parseObjectTypeDefinition();
            case "interface":
                return this.parseInterfaceTypeDefinition();
            case "union":
                return this.parseUnionTypeDefinition();
            case "enum":
                return this.parseEnumTypeDefinition();
            case "input":
                return this.parseInputObjectTypeDefinition();
            case "directive":
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).STRING) || this.peek((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("schema");
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_R);
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("scalar");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("type");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword("implements")) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).AMP) || this.peek((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).NAME));
            return types;
        }
        return this.delimitedMany((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_L) && this._lexer.lookahead().kind === (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_L, this.parseFieldDefinition, (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).PAREN_L, this.parseInputValueDef, (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("interface");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("union");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).EQUALS) ? this.delimitedMany((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("enum");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_L, this.parseEnumValueDefinition, (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("input");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_L, this.parseInputValueDef, (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaExtension();
            case "scalar":
                return this.parseScalarTypeExtension();
            case "type":
                return this.parseObjectTypeExtension();
            case "interface":
                return this.parseInterfaceTypeExtension();
            case "union":
                return this.parseUnionTypeExtension();
            case "enum":
                return this.parseEnumTypeExtension();
            case "input":
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("schema");
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("scalar");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("type");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("interface");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("union");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("enum");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("input");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("directive");
        this.expectToken((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword("repeatable");
        this.expectKeyword("on");
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $ecef357b0eb1b7e8$export$a84bdc57c5122798).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $9ec593e76e6b29f0$export$b45ffd2948484c41)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $e81858ad5f243549$export$18a2be9195644f38)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $33ed40a0f4e07882$export$bbee0c6176c019d4)(this._lexer.source, token.start, "Expected ".concat($9bdfafd0ada79eb4$var$getTokenKindDesc(kind), ", found ").concat($9bdfafd0ada79eb4$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).NAME && token.value === value) this._lexer.advance();
        else throw (0, $33ed40a0f4e07882$export$bbee0c6176c019d4)(this._lexer.source, token.start, 'Expected "'.concat(value, '", found ').concat($9bdfafd0ada79eb4$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $cc9b3e5933bbe9a1$export$8b9d26ab11394711).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $33ed40a0f4e07882$export$bbee0c6176c019d4)(this._lexer.source, token.start, "Unexpected ".concat($9bdfafd0ada79eb4$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $9bdfafd0ada79eb4$var$getTokenDesc(token) {
    var value = token.value;
    return $9bdfafd0ada79eb4$var$getTokenKindDesc(token.kind) + (value != null ? ' "'.concat(value, '"') : "");
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $9bdfafd0ada79eb4$var$getTokenKindDesc(kind) {
    return (0, $52923c4cf9d72eb9$export$59ac0f4da287406a)(kind) ? '"'.concat(kind, '"') : kind;
}



var $2b160687940d5623$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        // or removed in the future.
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
var $2b160687940d5623$export$a89c95c098ac2a58 = Object.freeze({});
function $2b160687940d5623$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $2b160687940d5623$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $e81858ad5f243549$export$8ee0fc9ee280b4ee)(node)) throw new Error("Invalid AST Node: ".concat((0, $ecd8fa86c9b71070$export$2e2bcd8739ae039)(node), "."));
            var visitFn = $2b160687940d5623$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $2b160687940d5623$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $e81858ad5f243549$export$8ee0fc9ee280b4ee)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $2b160687940d5623$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $2b160687940d5623$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $2b160687940d5623$export$a89c95c098ac2a58) skipping[i] = $2b160687940d5623$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $2b160687940d5623$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $2b160687940d5623$export$a89c95c098ac2a58) skipping[i] = $2b160687940d5623$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $2b160687940d5623$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === "function") // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === "function") // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === "function") // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === "function") // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}



function $721fc34398b6420b$export$c2d084dc44961371(ast) {
    return (0, $2b160687940d5623$export$bf638b60ea8b89b7)(ast, {
        leave: $721fc34398b6420b$var$printDocASTReducer
    });
}
var $721fc34398b6420b$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $721fc34398b6420b$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return "$" + node.name;
    },
    // Document
    Document: function Document(node) {
        return $721fc34398b6420b$var$join(node.definitions, "\n\n") + "\n";
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $721fc34398b6420b$var$wrap("(", $721fc34398b6420b$var$join(node.variableDefinitions, ", "), ")");
        var directives = $721fc34398b6420b$var$join(node.directives, " ");
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === "query" ? selectionSet : $721fc34398b6420b$var$join([
            op,
            $721fc34398b6420b$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], " ");
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ": " + type + $721fc34398b6420b$var$wrap(" = ", defaultValue) + $721fc34398b6420b$var$wrap(" ", $721fc34398b6420b$var$join(directives, " "));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $721fc34398b6420b$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $721fc34398b6420b$var$wrap("", alias, ": ") + name;
        var argsLine = prefix + $721fc34398b6420b$var$wrap("(", $721fc34398b6420b$var$join(args, ", "), ")");
        if (argsLine.length > $721fc34398b6420b$var$MAX_LINE_LENGTH) argsLine = prefix + $721fc34398b6420b$var$wrap("(\n", $721fc34398b6420b$var$indent($721fc34398b6420b$var$join(args, "\n")), "\n)");
        return $721fc34398b6420b$var$join([
            argsLine,
            $721fc34398b6420b$var$join(directives, " "),
            selectionSet
        ], " ");
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ": " + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return "..." + name + $721fc34398b6420b$var$wrap(" ", $721fc34398b6420b$var$join(directives, " "));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $721fc34398b6420b$var$join([
            "...",
            $721fc34398b6420b$var$wrap("on ", typeCondition),
            $721fc34398b6420b$var$join(directives, " "),
            selectionSet
        ], " ");
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($721fc34398b6420b$var$wrap("(", $721fc34398b6420b$var$join(variableDefinitions, ", "), ")"), " ") + "on ".concat(typeCondition, " ").concat($721fc34398b6420b$var$wrap("", $721fc34398b6420b$var$join(directives, " "), " ")) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $8514581045a3511a$export$adb6ca997eeb1f45)(value, key === "description" ? "" : "  ") : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? "true" : "false";
    },
    NullValue: function NullValue() {
        return "null";
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return "[" + $721fc34398b6420b$var$join(values, ", ") + "]";
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return "{" + $721fc34398b6420b$var$join(fields, ", ") + "}";
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ": " + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return "@" + name + $721fc34398b6420b$var$wrap("(", $721fc34398b6420b$var$join(args, ", "), ")");
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return "[" + type + "]";
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + "!";
    },
    // Type System Definitions
    SchemaDefinition: $721fc34398b6420b$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $721fc34398b6420b$var$join([
            "schema",
            $721fc34398b6420b$var$join(directives, " "),
            $721fc34398b6420b$var$block(operationTypes)
        ], " ");
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ": " + type;
    },
    ScalarTypeDefinition: $721fc34398b6420b$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $721fc34398b6420b$var$join([
            "scalar",
            name,
            $721fc34398b6420b$var$join(directives, " ")
        ], " ");
    }),
    ObjectTypeDefinition: $721fc34398b6420b$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $721fc34398b6420b$var$join([
            "type",
            name,
            $721fc34398b6420b$var$wrap("implements ", $721fc34398b6420b$var$join(interfaces, " & ")),
            $721fc34398b6420b$var$join(directives, " "),
            $721fc34398b6420b$var$block(fields)
        ], " ");
    }),
    FieldDefinition: $721fc34398b6420b$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($721fc34398b6420b$var$hasMultilineItems(args) ? $721fc34398b6420b$var$wrap("(\n", $721fc34398b6420b$var$indent($721fc34398b6420b$var$join(args, "\n")), "\n)") : $721fc34398b6420b$var$wrap("(", $721fc34398b6420b$var$join(args, ", "), ")")) + ": " + type + $721fc34398b6420b$var$wrap(" ", $721fc34398b6420b$var$join(directives, " "));
    }),
    InputValueDefinition: $721fc34398b6420b$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $721fc34398b6420b$var$join([
            name + ": " + type,
            $721fc34398b6420b$var$wrap("= ", defaultValue),
            $721fc34398b6420b$var$join(directives, " ")
        ], " ");
    }),
    InterfaceTypeDefinition: $721fc34398b6420b$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $721fc34398b6420b$var$join([
            "interface",
            name,
            $721fc34398b6420b$var$wrap("implements ", $721fc34398b6420b$var$join(interfaces, " & ")),
            $721fc34398b6420b$var$join(directives, " "),
            $721fc34398b6420b$var$block(fields)
        ], " ");
    }),
    UnionTypeDefinition: $721fc34398b6420b$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $721fc34398b6420b$var$join([
            "union",
            name,
            $721fc34398b6420b$var$join(directives, " "),
            types && types.length !== 0 ? "= " + $721fc34398b6420b$var$join(types, " | ") : ""
        ], " ");
    }),
    EnumTypeDefinition: $721fc34398b6420b$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $721fc34398b6420b$var$join([
            "enum",
            name,
            $721fc34398b6420b$var$join(directives, " "),
            $721fc34398b6420b$var$block(values)
        ], " ");
    }),
    EnumValueDefinition: $721fc34398b6420b$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $721fc34398b6420b$var$join([
            name,
            $721fc34398b6420b$var$join(directives, " ")
        ], " ");
    }),
    InputObjectTypeDefinition: $721fc34398b6420b$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $721fc34398b6420b$var$join([
            "input",
            name,
            $721fc34398b6420b$var$join(directives, " "),
            $721fc34398b6420b$var$block(fields)
        ], " ");
    }),
    DirectiveDefinition: $721fc34398b6420b$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return "directive @" + name + ($721fc34398b6420b$var$hasMultilineItems(args) ? $721fc34398b6420b$var$wrap("(\n", $721fc34398b6420b$var$indent($721fc34398b6420b$var$join(args, "\n")), "\n)") : $721fc34398b6420b$var$wrap("(", $721fc34398b6420b$var$join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + $721fc34398b6420b$var$join(locations, " | ");
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $721fc34398b6420b$var$join([
            "extend schema",
            $721fc34398b6420b$var$join(directives, " "),
            $721fc34398b6420b$var$block(operationTypes)
        ], " ");
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $721fc34398b6420b$var$join([
            "extend scalar",
            name,
            $721fc34398b6420b$var$join(directives, " ")
        ], " ");
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $721fc34398b6420b$var$join([
            "extend type",
            name,
            $721fc34398b6420b$var$wrap("implements ", $721fc34398b6420b$var$join(interfaces, " & ")),
            $721fc34398b6420b$var$join(directives, " "),
            $721fc34398b6420b$var$block(fields)
        ], " ");
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $721fc34398b6420b$var$join([
            "extend interface",
            name,
            $721fc34398b6420b$var$wrap("implements ", $721fc34398b6420b$var$join(interfaces, " & ")),
            $721fc34398b6420b$var$join(directives, " "),
            $721fc34398b6420b$var$block(fields)
        ], " ");
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $721fc34398b6420b$var$join([
            "extend union",
            name,
            $721fc34398b6420b$var$join(directives, " "),
            types && types.length !== 0 ? "= " + $721fc34398b6420b$var$join(types, " | ") : ""
        ], " ");
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $721fc34398b6420b$var$join([
            "extend enum",
            name,
            $721fc34398b6420b$var$join(directives, " "),
            $721fc34398b6420b$var$block(values)
        ], " ");
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $721fc34398b6420b$var$join([
            "extend input",
            name,
            $721fc34398b6420b$var$join(directives, " "),
            $721fc34398b6420b$var$block(fields)
        ], " ");
    }
};
function $721fc34398b6420b$var$addDescription(cb) {
    return function(node) {
        return $721fc34398b6420b$var$join([
            node.description,
            cb(node)
        ], "\n");
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $721fc34398b6420b$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $721fc34398b6420b$var$block(array) {
    return $721fc34398b6420b$var$wrap("{\n", $721fc34398b6420b$var$indent($721fc34398b6420b$var$join(array, "\n")), "\n}");
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $721fc34398b6420b$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function $721fc34398b6420b$var$indent(str) {
    return $721fc34398b6420b$var$wrap("  ", str.replace(/\n/g, "\n  "));
}
function $721fc34398b6420b$var$isMultiline(str) {
    return str.indexOf("\n") !== -1;
}
function $721fc34398b6420b$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($721fc34398b6420b$var$isMultiline);
}



/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $ad5e523f9031e630$var$extendStatics = function(d, b) {
    $ad5e523f9031e630$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $ad5e523f9031e630$var$extendStatics(d, b);
};
function $ad5e523f9031e630$export$a8ba968b8961cb8a(d, b) {
    $ad5e523f9031e630$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ad5e523f9031e630$export$18ce0697a983be9b = function() {
    $ad5e523f9031e630$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ad5e523f9031e630$export$18ce0697a983be9b.apply(this, arguments);
};
function $ad5e523f9031e630$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ad5e523f9031e630$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ad5e523f9031e630$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ad5e523f9031e630$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ad5e523f9031e630$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ad5e523f9031e630$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $ad5e523f9031e630$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $ad5e523f9031e630$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $ad5e523f9031e630$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ad5e523f9031e630$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ad5e523f9031e630$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ad5e523f9031e630$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ad5e523f9031e630$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ad5e523f9031e630$export$10c90e4f7922046c(v) {
    return this instanceof $ad5e523f9031e630$export$10c90e4f7922046c ? (this.v = v, this) : new $ad5e523f9031e630$export$10c90e4f7922046c(v);
}
function $ad5e523f9031e630$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ad5e523f9031e630$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ad5e523f9031e630$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ad5e523f9031e630$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $ad5e523f9031e630$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ad5e523f9031e630$export$19a8beecd37a4c45 === "function" ? $ad5e523f9031e630$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ad5e523f9031e630$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $ad5e523f9031e630$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $ad5e523f9031e630$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ad5e523f9031e630$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $ad5e523f9031e630$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}







var $eAyj5 = parcelRequire("eAyj5");
var $e2addc82b6ae150b$exports = {};
var $ba283618bcd164a9$exports = {};
var $a69bac2f2b19b974$exports = {};
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $a69bac2f2b19b974$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($a69bac2f2b19b974$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $a69bac2f2b19b974$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    $a69bac2f2b19b974$exports = function whatwgRNG() {
        $a69bac2f2b19b974$var$getRandomValues($a69bac2f2b19b974$var$rnds8);
        return $a69bac2f2b19b974$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $a69bac2f2b19b974$var$rnds = new Array(16);
    $a69bac2f2b19b974$exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $a69bac2f2b19b974$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $a69bac2f2b19b974$var$rnds;
    };
}


var $ecf064d225c203f8$exports = {};
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $ecf064d225c203f8$var$byteToHex = [];
for(var $ecf064d225c203f8$var$i = 0; $ecf064d225c203f8$var$i < 256; ++$ecf064d225c203f8$var$i)$ecf064d225c203f8$var$byteToHex[$ecf064d225c203f8$var$i] = ($ecf064d225c203f8$var$i + 0x100).toString(16).substr(1);
function $ecf064d225c203f8$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $ecf064d225c203f8$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
$ecf064d225c203f8$exports = $ecf064d225c203f8$var$bytesToUuid;


// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $ba283618bcd164a9$var$_nodeId;
var $ba283618bcd164a9$var$_clockseq;
// Previous uuid creation time
var $ba283618bcd164a9$var$_lastMSecs = 0;
var $ba283618bcd164a9$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $ba283618bcd164a9$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $ba283618bcd164a9$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $ba283618bcd164a9$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $a69bac2f2b19b974$exports();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $ba283618bcd164a9$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $ba283618bcd164a9$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $ba283618bcd164a9$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $ba283618bcd164a9$var$_lastMSecs + (nsecs - $ba283618bcd164a9$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $ba283618bcd164a9$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $ba283618bcd164a9$var$_lastMSecs = msecs;
    $ba283618bcd164a9$var$_lastNSecs = nsecs;
    $ba283618bcd164a9$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $ecf064d225c203f8$exports(b);
}
$ba283618bcd164a9$exports = $ba283618bcd164a9$var$v1;


var $0f0d74359b5004a3$exports = {};


function $0f0d74359b5004a3$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $a69bac2f2b19b974$exports)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $ecf064d225c203f8$exports(rnds);
}
$0f0d74359b5004a3$exports = $0f0d74359b5004a3$var$v4;


var $e2addc82b6ae150b$var$uuid = $0f0d74359b5004a3$exports;
$e2addc82b6ae150b$var$uuid.v1 = $ba283618bcd164a9$exports;
$e2addc82b6ae150b$var$uuid.v4 = $0f0d74359b5004a3$exports;
$e2addc82b6ae150b$exports = $e2addc82b6ae150b$var$uuid;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $bff9a911785bcc42$export$a143d493d941bafc;
var $bff9a911785bcc42$export$e4cf37d7f6fb9e0a;
var $bff9a911785bcc42$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $bff9a911785bcc42$export$599f31c3813fae4d;
"use strict";

var $3nocJ = parcelRequire("3nocJ");

var $gU9iR = parcelRequire("gU9iR");
var $beb9d02497498da6$exports = {};
var $beb9d02497498da6$var$toString = {}.toString;
$beb9d02497498da6$exports = Array.isArray || function(arr) {
    return $beb9d02497498da6$var$toString.call(arr) == "[object Array]";
};


$bff9a911785bcc42$export$a143d493d941bafc = $bff9a911785bcc42$var$Buffer;
$bff9a911785bcc42$export$e4cf37d7f6fb9e0a = $bff9a911785bcc42$var$SlowBuffer;
$bff9a911785bcc42$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $bff9a911785bcc42$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $bff9a911785bcc42$var$typedArraySupport();
$bff9a911785bcc42$export$599f31c3813fae4d = $bff9a911785bcc42$var$kMaxLength();
function $bff9a911785bcc42$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $bff9a911785bcc42$var$kMaxLength() {
    return $bff9a911785bcc42$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $bff9a911785bcc42$var$createBuffer(that, length) {
    if ($bff9a911785bcc42$var$kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if ($bff9a911785bcc42$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $bff9a911785bcc42$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $bff9a911785bcc42$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $bff9a911785bcc42$var$Buffer(arg, encodingOrOffset, length) {
    if (!$bff9a911785bcc42$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $bff9a911785bcc42$var$Buffer)) return new $bff9a911785bcc42$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return $bff9a911785bcc42$var$allocUnsafe(this, arg);
    }
    return $bff9a911785bcc42$var$from(this, arg, encodingOrOffset, length);
}
$bff9a911785bcc42$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$bff9a911785bcc42$var$Buffer._augment = function(arr) {
    arr.__proto__ = $bff9a911785bcc42$var$Buffer.prototype;
    return arr;
};
function $bff9a911785bcc42$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return $bff9a911785bcc42$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return $bff9a911785bcc42$var$fromString(that, value, encodingOrOffset);
    return $bff9a911785bcc42$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $bff9a911785bcc42$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $bff9a911785bcc42$var$from(null, value, encodingOrOffset, length);
};
if ($bff9a911785bcc42$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $bff9a911785bcc42$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $bff9a911785bcc42$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && $bff9a911785bcc42$var$Buffer[Symbol.species] === $bff9a911785bcc42$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($bff9a911785bcc42$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $bff9a911785bcc42$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $bff9a911785bcc42$var$alloc(that, size, fill, encoding) {
    $bff9a911785bcc42$var$assertSize(size);
    if (size <= 0) return $bff9a911785bcc42$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? $bff9a911785bcc42$var$createBuffer(that, size).fill(fill, encoding) : $bff9a911785bcc42$var$createBuffer(that, size).fill(fill);
    return $bff9a911785bcc42$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $bff9a911785bcc42$var$Buffer.alloc = function(size, fill, encoding) {
    return $bff9a911785bcc42$var$alloc(null, size, fill, encoding);
};
function $bff9a911785bcc42$var$allocUnsafe(that, size) {
    $bff9a911785bcc42$var$assertSize(size);
    that = $bff9a911785bcc42$var$createBuffer(that, size < 0 ? 0 : $bff9a911785bcc42$var$checked(size) | 0);
    if (!$bff9a911785bcc42$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $bff9a911785bcc42$var$Buffer.allocUnsafe = function(size) {
    return $bff9a911785bcc42$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $bff9a911785bcc42$var$Buffer.allocUnsafeSlow = function(size) {
    return $bff9a911785bcc42$var$allocUnsafe(null, size);
};
function $bff9a911785bcc42$var$fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$bff9a911785bcc42$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $bff9a911785bcc42$var$byteLength(string, encoding) | 0;
    that = $bff9a911785bcc42$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $bff9a911785bcc42$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $bff9a911785bcc42$var$checked(array.length) | 0;
    that = $bff9a911785bcc42$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $bff9a911785bcc42$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($bff9a911785bcc42$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $bff9a911785bcc42$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $bff9a911785bcc42$var$fromArrayLike(that, array);
    return that;
}
function $bff9a911785bcc42$var$fromObject(that, obj) {
    if ($bff9a911785bcc42$var$Buffer.isBuffer(obj)) {
        var len = $bff9a911785bcc42$var$checked(obj.length) | 0;
        that = $bff9a911785bcc42$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || $bff9a911785bcc42$var$isnan(obj.length)) return $bff9a911785bcc42$var$createBuffer(that, 0);
            return $bff9a911785bcc42$var$fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && $beb9d02497498da6$exports(obj.data)) return $bff9a911785bcc42$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function $bff9a911785bcc42$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $bff9a911785bcc42$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $bff9a911785bcc42$var$kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function $bff9a911785bcc42$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $bff9a911785bcc42$var$Buffer.alloc(+length);
}
$bff9a911785bcc42$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$bff9a911785bcc42$var$Buffer.compare = function compare(a, b) {
    if (!$bff9a911785bcc42$var$Buffer.isBuffer(a) || !$bff9a911785bcc42$var$Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$bff9a911785bcc42$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$bff9a911785bcc42$var$Buffer.concat = function concat(list, length) {
    if (!$beb9d02497498da6$exports(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $bff9a911785bcc42$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $bff9a911785bcc42$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$bff9a911785bcc42$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $bff9a911785bcc42$var$byteLength(string, encoding) {
    if ($bff9a911785bcc42$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return $bff9a911785bcc42$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $bff9a911785bcc42$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $bff9a911785bcc42$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$bff9a911785bcc42$var$Buffer.byteLength = $bff9a911785bcc42$var$byteLength;
function $bff9a911785bcc42$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $bff9a911785bcc42$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $bff9a911785bcc42$var$utf8Slice(this, start, end);
        case "ascii":
            return $bff9a911785bcc42$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $bff9a911785bcc42$var$latin1Slice(this, start, end);
        case "base64":
            return $bff9a911785bcc42$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $bff9a911785bcc42$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$bff9a911785bcc42$var$Buffer.prototype._isBuffer = true;
function $bff9a911785bcc42$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$bff9a911785bcc42$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$bff9a911785bcc42$var$swap(this, i, i + 1);
    return this;
};
$bff9a911785bcc42$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $bff9a911785bcc42$var$swap(this, i, i + 3);
        $bff9a911785bcc42$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$bff9a911785bcc42$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $bff9a911785bcc42$var$swap(this, i, i + 7);
        $bff9a911785bcc42$var$swap(this, i + 1, i + 6);
        $bff9a911785bcc42$var$swap(this, i + 2, i + 5);
        $bff9a911785bcc42$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$bff9a911785bcc42$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return $bff9a911785bcc42$var$utf8Slice(this, 0, length);
    return $bff9a911785bcc42$var$slowToString.apply(this, arguments);
};
$bff9a911785bcc42$var$Buffer.prototype.equals = function equals(b) {
    if (!$bff9a911785bcc42$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $bff9a911785bcc42$var$Buffer.compare(this, b) === 0;
};
$bff9a911785bcc42$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $bff9a911785bcc42$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
$bff9a911785bcc42$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$bff9a911785bcc42$var$Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $bff9a911785bcc42$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $bff9a911785bcc42$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($bff9a911785bcc42$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $bff9a911785bcc42$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($bff9a911785bcc42$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $bff9a911785bcc42$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $bff9a911785bcc42$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$bff9a911785bcc42$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$bff9a911785bcc42$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $bff9a911785bcc42$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$bff9a911785bcc42$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $bff9a911785bcc42$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $bff9a911785bcc42$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $bff9a911785bcc42$var$utf8Write(buf, string, offset, length) {
    return $bff9a911785bcc42$var$blitBuffer($bff9a911785bcc42$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $bff9a911785bcc42$var$asciiWrite(buf, string, offset, length) {
    return $bff9a911785bcc42$var$blitBuffer($bff9a911785bcc42$var$asciiToBytes(string), buf, offset, length);
}
function $bff9a911785bcc42$var$latin1Write(buf, string, offset, length) {
    return $bff9a911785bcc42$var$asciiWrite(buf, string, offset, length);
}
function $bff9a911785bcc42$var$base64Write(buf, string, offset, length) {
    return $bff9a911785bcc42$var$blitBuffer($bff9a911785bcc42$var$base64ToBytes(string), buf, offset, length);
}
function $bff9a911785bcc42$var$ucs2Write(buf, string, offset, length) {
    return $bff9a911785bcc42$var$blitBuffer($bff9a911785bcc42$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$bff9a911785bcc42$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $bff9a911785bcc42$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $bff9a911785bcc42$var$utf8Write(this, string, offset, length);
        case "ascii":
            return $bff9a911785bcc42$var$asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return $bff9a911785bcc42$var$latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $bff9a911785bcc42$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $bff9a911785bcc42$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$bff9a911785bcc42$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $bff9a911785bcc42$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3nocJ.fromByteArray(buf);
    else return $3nocJ.fromByteArray(buf.slice(start, end));
}
function $bff9a911785bcc42$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $bff9a911785bcc42$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $bff9a911785bcc42$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $bff9a911785bcc42$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $bff9a911785bcc42$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $bff9a911785bcc42$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $bff9a911785bcc42$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $bff9a911785bcc42$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $bff9a911785bcc42$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $bff9a911785bcc42$var$toHex(buf[i]);
    return out;
}
function $bff9a911785bcc42$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$bff9a911785bcc42$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($bff9a911785bcc42$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $bff9a911785bcc42$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $bff9a911785bcc42$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $bff9a911785bcc42$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$bff9a911785bcc42$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $bff9a911785bcc42$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$bff9a911785bcc42$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $bff9a911785bcc42$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$bff9a911785bcc42$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $bff9a911785bcc42$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$bff9a911785bcc42$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $bff9a911785bcc42$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$bff9a911785bcc42$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $bff9a911785bcc42$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$bff9a911785bcc42$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $bff9a911785bcc42$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$bff9a911785bcc42$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $bff9a911785bcc42$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$bff9a911785bcc42$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $bff9a911785bcc42$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$bff9a911785bcc42$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $bff9a911785bcc42$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$bff9a911785bcc42$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $bff9a911785bcc42$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$bff9a911785bcc42$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $bff9a911785bcc42$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$bff9a911785bcc42$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $bff9a911785bcc42$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$bff9a911785bcc42$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $bff9a911785bcc42$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$bff9a911785bcc42$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $bff9a911785bcc42$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$bff9a911785bcc42$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $bff9a911785bcc42$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, true, 23, 4);
};
$bff9a911785bcc42$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $bff9a911785bcc42$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, false, 23, 4);
};
$bff9a911785bcc42$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $bff9a911785bcc42$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, true, 52, 8);
};
$bff9a911785bcc42$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $bff9a911785bcc42$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, false, 52, 8);
};
function $bff9a911785bcc42$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$bff9a911785bcc42$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$bff9a911785bcc42$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $bff9a911785bcc42$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$bff9a911785bcc42$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $bff9a911785bcc42$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$bff9a911785bcc42$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $bff9a911785bcc42$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$bff9a911785bcc42$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $bff9a911785bcc42$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$bff9a911785bcc42$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $bff9a911785bcc42$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($bff9a911785bcc42$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $bff9a911785bcc42$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$bff9a911785bcc42$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $bff9a911785bcc42$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($bff9a911785bcc42$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $bff9a911785bcc42$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $bff9a911785bcc42$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$bff9a911785bcc42$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $bff9a911785bcc42$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($bff9a911785bcc42$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $bff9a911785bcc42$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$bff9a911785bcc42$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $bff9a911785bcc42$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($bff9a911785bcc42$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $bff9a911785bcc42$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$bff9a911785bcc42$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $bff9a911785bcc42$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$bff9a911785bcc42$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $bff9a911785bcc42$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$bff9a911785bcc42$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $bff9a911785bcc42$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$bff9a911785bcc42$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$bff9a911785bcc42$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $bff9a911785bcc42$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($bff9a911785bcc42$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $bff9a911785bcc42$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$bff9a911785bcc42$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $bff9a911785bcc42$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($bff9a911785bcc42$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $bff9a911785bcc42$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$bff9a911785bcc42$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $bff9a911785bcc42$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($bff9a911785bcc42$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $bff9a911785bcc42$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$bff9a911785bcc42$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $bff9a911785bcc42$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($bff9a911785bcc42$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $bff9a911785bcc42$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $bff9a911785bcc42$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $bff9a911785bcc42$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $bff9a911785bcc42$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$bff9a911785bcc42$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $bff9a911785bcc42$var$writeFloat(this, value, offset, true, noAssert);
};
$bff9a911785bcc42$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $bff9a911785bcc42$var$writeFloat(this, value, offset, false, noAssert);
};
function $bff9a911785bcc42$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $bff9a911785bcc42$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$bff9a911785bcc42$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $bff9a911785bcc42$var$writeDouble(this, value, offset, true, noAssert);
};
$bff9a911785bcc42$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $bff9a911785bcc42$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$bff9a911785bcc42$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$bff9a911785bcc42$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$bff9a911785bcc42$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$bff9a911785bcc42$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $bff9a911785bcc42$var$Buffer.isBuffer(val) ? val : $bff9a911785bcc42$var$utf8ToBytes(new $bff9a911785bcc42$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $bff9a911785bcc42$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $bff9a911785bcc42$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $bff9a911785bcc42$var$stringtrim(str).replace($bff9a911785bcc42$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $bff9a911785bcc42$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function $bff9a911785bcc42$var$toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function $bff9a911785bcc42$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $bff9a911785bcc42$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $bff9a911785bcc42$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $bff9a911785bcc42$var$base64ToBytes(str) {
    return $3nocJ.toByteArray($bff9a911785bcc42$var$base64clean(str));
}
function $bff9a911785bcc42$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $bff9a911785bcc42$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $69020f10d3252c76$var$extendStatics = function(d, b) {
    $69020f10d3252c76$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $69020f10d3252c76$var$extendStatics(d, b);
};
function $69020f10d3252c76$export$a8ba968b8961cb8a(d, b) {
    $69020f10d3252c76$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $69020f10d3252c76$export$18ce0697a983be9b = function() {
    $69020f10d3252c76$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $69020f10d3252c76$export$18ce0697a983be9b.apply(this, arguments);
};
function $69020f10d3252c76$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $69020f10d3252c76$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $69020f10d3252c76$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $69020f10d3252c76$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $69020f10d3252c76$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $69020f10d3252c76$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $69020f10d3252c76$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $69020f10d3252c76$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $69020f10d3252c76$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $69020f10d3252c76$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $69020f10d3252c76$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($69020f10d3252c76$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $69020f10d3252c76$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $69020f10d3252c76$export$10c90e4f7922046c(v) {
    return this instanceof $69020f10d3252c76$export$10c90e4f7922046c ? (this.v = v, this) : new $69020f10d3252c76$export$10c90e4f7922046c(v);
}
function $69020f10d3252c76$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $69020f10d3252c76$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $69020f10d3252c76$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $69020f10d3252c76$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $69020f10d3252c76$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $69020f10d3252c76$export$19a8beecd37a4c45 === "function" ? $69020f10d3252c76$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $69020f10d3252c76$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $69020f10d3252c76$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $69020f10d3252c76$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $69020f10d3252c76$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $69020f10d3252c76$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $e82a6a8b6cd75a4a$export$f84bd70098573c5c = {
    keyPrefix: "aws-amplify-cache",
    capacityInBytes: 1048576,
    itemMaxSize: 210000,
    defaultTTL: 259200000,
    defaultPriority: 5,
    warningThreshold: 0.8,
    // the storage helper will check if localStorage exists,
    // if not, will use a in-memory object instead
    storage: new (0, $7a09b30b2e4e0fe6$export$a2bd19c49e4760e8)().getStorage()
};
function $e82a6a8b6cd75a4a$export$cc8c3b705bb8e6e2(str) {
    var ret = 0;
    ret = str.length;
    for(var i = str.length; i >= 0; i -= 1){
        var charCode = str.charCodeAt(i);
        if (charCode > 0x7f && charCode <= 0x7ff) ret += 1;
        else if (charCode > 0x7ff && charCode <= 0xffff) ret += 2;
        // trail surrogate
        if (charCode >= 0xdc00 && charCode <= 0xdfff) i -= 1;
    }
    return ret;
}
function $e82a6a8b6cd75a4a$export$dd144842d7b22d3a() {
    var currTime = new Date();
    return currTime.getTime();
}
function $e82a6a8b6cd75a4a$export$a287f47fed4544b8(value) {
    if (Number.isInteger) return Number.isInteger(value);
    return $e82a6a8b6cd75a4a$var$_isInteger(value);
}
function $e82a6a8b6cd75a4a$var$_isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
}
/**
 * provide an object as the in-memory cache
 */ var $e82a6a8b6cd75a4a$var$store = {};
var $e82a6a8b6cd75a4a$export$2dd5b9e5ba192a1a = /** @class */ function() {
    function CacheObject() {}
    CacheObject.clear = function() {
        $e82a6a8b6cd75a4a$var$store = {};
    };
    CacheObject.getItem = function(key) {
        return $e82a6a8b6cd75a4a$var$store[key] || null;
    };
    CacheObject.setItem = function(key, value) {
        $e82a6a8b6cd75a4a$var$store[key] = value;
    };
    CacheObject.removeItem = function(key) {
        delete $e82a6a8b6cd75a4a$var$store[key];
    };
    return CacheObject;
}();


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $a0d8cc6592a19fa5$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("StorageCache");
/**
 * Initialization of the cache
 *
 */ var $a0d8cc6592a19fa5$export$947ed1997bd112b4 = /** @class */ function() {
    /**
     * Initialize the cache
     * @param config - the configuration of the cache
     */ function StorageCache(config) {
        this.config = Object.assign({}, config);
        this.cacheCurSizeKey = this.config.keyPrefix + "CurSize";
        this.checkConfig();
    }
    StorageCache.prototype.getModuleName = function() {
        return "Cache";
    };
    StorageCache.prototype.checkConfig = function() {
        // check configuration
        if (!(0, $e82a6a8b6cd75a4a$export$a287f47fed4544b8)(this.config.capacityInBytes)) {
            $a0d8cc6592a19fa5$var$logger.error("Invalid parameter: capacityInBytes. It should be an Integer. Setting back to default.");
            this.config.capacityInBytes = (0, $e82a6a8b6cd75a4a$export$f84bd70098573c5c).capacityInBytes;
        }
        if (!(0, $e82a6a8b6cd75a4a$export$a287f47fed4544b8)(this.config.itemMaxSize)) {
            $a0d8cc6592a19fa5$var$logger.error("Invalid parameter: itemMaxSize. It should be an Integer. Setting back to default.");
            this.config.itemMaxSize = (0, $e82a6a8b6cd75a4a$export$f84bd70098573c5c).itemMaxSize;
        }
        if (!(0, $e82a6a8b6cd75a4a$export$a287f47fed4544b8)(this.config.defaultTTL)) {
            $a0d8cc6592a19fa5$var$logger.error("Invalid parameter: defaultTTL. It should be an Integer. Setting back to default.");
            this.config.defaultTTL = (0, $e82a6a8b6cd75a4a$export$f84bd70098573c5c).defaultTTL;
        }
        if (!(0, $e82a6a8b6cd75a4a$export$a287f47fed4544b8)(this.config.defaultPriority)) {
            $a0d8cc6592a19fa5$var$logger.error("Invalid parameter: defaultPriority. It should be an Integer. Setting back to default.");
            this.config.defaultPriority = (0, $e82a6a8b6cd75a4a$export$f84bd70098573c5c).defaultPriority;
        }
        if (this.config.itemMaxSize > this.config.capacityInBytes) {
            $a0d8cc6592a19fa5$var$logger.error("Invalid parameter: itemMaxSize. It should be smaller than capacityInBytes. Setting back to default.");
            this.config.itemMaxSize = (0, $e82a6a8b6cd75a4a$export$f84bd70098573c5c).itemMaxSize;
        }
        if (this.config.defaultPriority > 5 || this.config.defaultPriority < 1) {
            $a0d8cc6592a19fa5$var$logger.error("Invalid parameter: defaultPriority. It should be between 1 and 5. Setting back to default.");
            this.config.defaultPriority = (0, $e82a6a8b6cd75a4a$export$f84bd70098573c5c).defaultPriority;
        }
        if (Number(this.config.warningThreshold) > 1 || Number(this.config.warningThreshold) < 0) {
            $a0d8cc6592a19fa5$var$logger.error("Invalid parameter: warningThreshold. It should be between 0 and 1. Setting back to default.");
            this.config.warningThreshold = (0, $e82a6a8b6cd75a4a$export$f84bd70098573c5c).warningThreshold;
        }
        // set 5MB limit
        var cacheLimit = 5242880;
        if (this.config.capacityInBytes > cacheLimit) {
            $a0d8cc6592a19fa5$var$logger.error("Cache Capacity should be less than 5MB. Setting back to default. Setting back to default.");
            this.config.capacityInBytes = (0, $e82a6a8b6cd75a4a$export$f84bd70098573c5c).capacityInBytes;
        }
    };
    /**
     * produce a JSON object with meta-data and data value
     * @param value - the value of the item
     * @param options - optional, the specified meta-data
     *
     * @return - the item which has the meta-data and the value
     */ StorageCache.prototype.fillCacheItem = function(key, value, options) {
        var ret = {
            key: key,
            data: value,
            timestamp: (0, $e82a6a8b6cd75a4a$export$dd144842d7b22d3a)(),
            visitedTime: (0, $e82a6a8b6cd75a4a$export$dd144842d7b22d3a)(),
            priority: options.priority,
            expires: options.expires,
            type: typeof value,
            byteSize: 0
        };
        ret.byteSize = (0, $e82a6a8b6cd75a4a$export$cc8c3b705bb8e6e2)(JSON.stringify(ret));
        // for accurate size
        ret.byteSize = (0, $e82a6a8b6cd75a4a$export$cc8c3b705bb8e6e2)(JSON.stringify(ret));
        return ret;
    };
    /**
     * set cache with customized configuration
     * @param config - customized configuration
     *
     * @return - the current configuration
     */ StorageCache.prototype.configure = function(config) {
        if (!config) return this.config;
        if (config.keyPrefix) $a0d8cc6592a19fa5$var$logger.warn("Don't try to configure keyPrefix!");
        this.config = Object.assign({}, this.config, config, config.Cache);
        this.checkConfig();
        return this.config;
    };
    return StorageCache;
}();


var $476f1cc74cf261fb$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("Cache");
/**
 * Customized storage based on the SessionStorage or LocalStorage with LRU implemented
 */ var $476f1cc74cf261fb$export$e6fda0405fa98d6d = /** @class */ function(_super) {
    (0, $69020f10d3252c76$export$a8ba968b8961cb8a)(BrowserStorageCacheClass, _super);
    /**
     * initialize the cache
     * @param config - the configuration of the cache
     */ function BrowserStorageCacheClass(config) {
        var _this = this;
        var cacheConfig = config ? Object.assign({}, (0, $e82a6a8b6cd75a4a$export$f84bd70098573c5c), config) : (0, $e82a6a8b6cd75a4a$export$f84bd70098573c5c);
        _this = _super.call(this, cacheConfig) || this;
        _this.config.storage = cacheConfig.storage;
        _this.getItem = _this.getItem.bind(_this);
        _this.setItem = _this.setItem.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);
        return _this;
    }
    /**
     * decrease current size of the cache
     *
     * @private
     * @param amount - the amount of the cache size which needs to be decreased
     */ BrowserStorageCacheClass.prototype._decreaseCurSizeInBytes = function(amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize - amount).toString());
    };
    /**
     * increase current size of the cache
     *
     * @private
     * @param amount - the amount of the cache szie which need to be increased
     */ BrowserStorageCacheClass.prototype._increaseCurSizeInBytes = function(amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize + amount).toString());
    };
    /**
     * update the visited time if item has been visited
     *
     * @private
     * @param item - the item which need to be refreshed
     * @param prefixedKey - the key of the item
     *
     * @return the refreshed item
     */ BrowserStorageCacheClass.prototype._refreshItem = function(item, prefixedKey) {
        item.visitedTime = (0, $e82a6a8b6cd75a4a$export$dd144842d7b22d3a)();
        this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        return item;
    };
    /**
     * check wether item is expired
     *
     * @private
     * @param key - the key of the item
     *
     * @return true if the item is expired.
     */ BrowserStorageCacheClass.prototype._isExpired = function(key) {
        var text = this.config.storage.getItem(key);
        var item = JSON.parse(text);
        if ((0, $e82a6a8b6cd75a4a$export$dd144842d7b22d3a)() >= item.expires) return true;
        return false;
    };
    /**
     * delete item from cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param size - optional, the byte size of the item
     */ BrowserStorageCacheClass.prototype._removeItem = function(prefixedKey, size) {
        var itemSize = size ? size : JSON.parse(this.config.storage.getItem(prefixedKey)).byteSize;
        this._decreaseCurSizeInBytes(itemSize);
        // remove the cache item
        this.config.storage.removeItem(prefixedKey);
    };
    /**
     * put item into cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param itemData - the value of the item
     * @param itemSizeInBytes - the byte size of the item
     */ BrowserStorageCacheClass.prototype._setItem = function(prefixedKey, item) {
        // update the cache size
        this._increaseCurSizeInBytes(item.byteSize);
        try {
            this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        } catch (setItemErr) {
            // if failed, we need to rollback the cache size
            this._decreaseCurSizeInBytes(item.byteSize);
            $476f1cc74cf261fb$var$logger.error("Failed to set item " + setItemErr);
        }
    };
    /**
     * total space needed when poping out items
     *
     * @private
     * @param itemSize
     *
     * @return total space needed
     */ BrowserStorageCacheClass.prototype._sizeToPop = function(itemSize) {
        var spaceItemNeed = this.getCacheCurSize() + itemSize - this.config.capacityInBytes;
        var cacheThresholdSpace = (1 - this.config.warningThreshold) * this.config.capacityInBytes;
        return spaceItemNeed > cacheThresholdSpace ? spaceItemNeed : cacheThresholdSpace;
    };
    /**
     * see whether cache is full
     *
     * @private
     * @param itemSize
     *
     * @return true if cache is full
     */ BrowserStorageCacheClass.prototype._isCacheFull = function(itemSize) {
        return itemSize + this.getCacheCurSize() > this.config.capacityInBytes;
    };
    /**
     * scan the storage and find out all the keys owned by this cache
     * also clean the expired keys while scanning
     *
     * @private
     *
     * @return array of keys
     */ BrowserStorageCacheClass.prototype._findValidKeys = function() {
        var keys = [];
        var keyInCache = [];
        // get all keys in Storage
        for(var i = 0; i < this.config.storage.length; i += 1)keyInCache.push(this.config.storage.key(i));
        // find those items which belong to our cache and also clean those expired items
        for(var i = 0; i < keyInCache.length; i += 1){
            var key = keyInCache[i];
            if (key.indexOf(this.config.keyPrefix) === 0 && key !== this.cacheCurSizeKey) {
                if (this._isExpired(key)) this._removeItem(key);
                else keys.push(key);
            }
        }
        return keys;
    };
    /**
     * get all the items we have, sort them by their priority,
     * if priority is same, sort them by their last visited time
     * pop out items from the low priority (5 is the lowest)
     *
     * @private
     * @param keys - all the keys in this cache
     * @param sizeToPop - the total size of the items which needed to be poped out
     */ BrowserStorageCacheClass.prototype._popOutItems = function(keys, sizeToPop) {
        var items = [];
        var remainedSize = sizeToPop;
        // get the items from Storage
        for(var i = 0; i < keys.length; i += 1){
            var val = this.config.storage.getItem(keys[i]);
            if (val != null) {
                var item = JSON.parse(val);
                items.push(item);
            }
        }
        // first compare priority
        // then compare visited time
        items.sort(function(a, b) {
            if (a.priority > b.priority) return -1;
            else if (a.priority < b.priority) return 1;
            else {
                if (a.visitedTime < b.visitedTime) return -1;
                else return 1;
            }
        });
        for(var i = 0; i < items.length; i += 1){
            // pop out items until we have enough room for new item
            this._removeItem(items[i].key, items[i].byteSize);
            remainedSize -= items[i].byteSize;
            if (remainedSize <= 0) return;
        }
    };
    /**
     * Set item into cache. You can put number, string, boolean or object.
     * The cache will first check whether has the same key.
     * If it has, it will delete the old item and then put the new item in
     * The cache will pop out items if it is full
     * You can specify the cache item options. The cache will abort and output a warning:
     * If the key is invalid
     * If the size of the item exceeds itemMaxSize.
     * If the value is undefined
     * If incorrect cache item configuration
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param value - the value of the item
     * @param {Object} [options] - optional, the specified meta-data
     */ BrowserStorageCacheClass.prototype.setItem = function(key, value, options) {
        $476f1cc74cf261fb$var$logger.log("Set item: key is " + key + ", value is " + value + " with options: " + options);
        var prefixedKey = this.config.keyPrefix + key;
        // invalid keys
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
            $476f1cc74cf261fb$var$logger.warn("Invalid key: should not be empty or 'CurSize'");
            return;
        }
        if (typeof value === "undefined") {
            $476f1cc74cf261fb$var$logger.warn("The value of item should not be undefined!");
            return;
        }
        var cacheItemOptions = {
            priority: options && options.priority !== undefined ? options.priority : this.config.defaultPriority,
            expires: options && options.expires !== undefined ? options.expires : this.config.defaultTTL + (0, $e82a6a8b6cd75a4a$export$dd144842d7b22d3a)()
        };
        if (cacheItemOptions.priority < 1 || cacheItemOptions.priority > 5) {
            $476f1cc74cf261fb$var$logger.warn("Invalid parameter: priority due to out or range. It should be within 1 and 5.");
            return;
        }
        var item = this.fillCacheItem(prefixedKey, value, cacheItemOptions);
        // check wether this item is too big;
        if (item.byteSize > this.config.itemMaxSize) {
            $476f1cc74cf261fb$var$logger.warn("Item with key: " + key + " you are trying to put into is too big!");
            return;
        }
        try {
            // first look into the storage, if it exists, delete it.
            var val = this.config.storage.getItem(prefixedKey);
            if (val) this._removeItem(prefixedKey, JSON.parse(val).byteSize);
            // check whether the cache is full
            if (this._isCacheFull(item.byteSize)) {
                var validKeys = this._findValidKeys();
                // check again and then pop out items
                if (this._isCacheFull(item.byteSize)) {
                    var sizeToPop = this._sizeToPop(item.byteSize);
                    this._popOutItems(validKeys, sizeToPop);
                }
            }
            // put item in the cache
            // may failed due to storage full
            this._setItem(prefixedKey, item);
        } catch (e) {
            $476f1cc74cf261fb$var$logger.warn("setItem failed! " + e);
        }
    };
    /**
     * Get item from cache. It will return null if item doesn’t exist or it has been expired.
     * If you specified callback function in the options,
     * then the function will be executed if no such item in the cache
     * and finally put the return value into cache.
     * Please make sure the callback function will return the value you want to put into the cache.
     * The cache will abort output a warning:
     * If the key is invalid
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param {Object} [options] - the options of callback function
     *
     * @return - return the value of the item
     */ BrowserStorageCacheClass.prototype.getItem = function(key, options) {
        $476f1cc74cf261fb$var$logger.log("Get item: key is " + key + " with options " + options);
        var ret = null;
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
            $476f1cc74cf261fb$var$logger.warn("Invalid key: should not be empty or 'CurSize'");
            return null;
        }
        try {
            ret = this.config.storage.getItem(prefixedKey);
            if (ret != null) {
                if (this._isExpired(prefixedKey)) {
                    // if expired, remove that item and return null
                    this._removeItem(prefixedKey, JSON.parse(ret).byteSize);
                    ret = null;
                } else {
                    // if not expired, great, return the value and refresh it
                    var item = JSON.parse(ret);
                    item = this._refreshItem(item, prefixedKey);
                    return item.data;
                }
            }
            if (options && options.callback !== undefined) {
                var val = options.callback();
                if (val !== null) this.setItem(key, val, options);
                return val;
            }
            return null;
        } catch (e) {
            $476f1cc74cf261fb$var$logger.warn("getItem failed! " + e);
            return null;
        }
    };
    /**
     * remove item from the cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     * @param key - the key of the item
     */ BrowserStorageCacheClass.prototype.removeItem = function(key) {
        $476f1cc74cf261fb$var$logger.log("Remove item: key is " + key);
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) return;
        try {
            var val = this.config.storage.getItem(prefixedKey);
            if (val) this._removeItem(prefixedKey, JSON.parse(val).byteSize);
        } catch (e) {
            $476f1cc74cf261fb$var$logger.warn("removeItem failed! " + e);
        }
    };
    /**
     * clear the entire cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     */ BrowserStorageCacheClass.prototype.clear = function() {
        $476f1cc74cf261fb$var$logger.log("Clear Cache");
        var keysToRemove = [];
        for(var i = 0; i < this.config.storage.length; i += 1){
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0) keysToRemove.push(key);
        }
        try {
            for(var i = 0; i < keysToRemove.length; i += 1)this.config.storage.removeItem(keysToRemove[i]);
        } catch (e) {
            $476f1cc74cf261fb$var$logger.warn("clear failed! " + e);
        }
    };
    /**
     * Return all the keys in the cache.
     *
     * @return - all keys in the cache
     */ BrowserStorageCacheClass.prototype.getAllKeys = function() {
        var keys = [];
        for(var i = 0; i < this.config.storage.length; i += 1){
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0 && key !== this.cacheCurSizeKey) keys.push(key.substring(this.config.keyPrefix.length));
        }
        return keys;
    };
    /**
     * return the current size of the cache
     *
     * @return - current size of the cache
     */ BrowserStorageCacheClass.prototype.getCacheCurSize = function() {
        var ret = this.config.storage.getItem(this.cacheCurSizeKey);
        if (!ret) {
            this.config.storage.setItem(this.cacheCurSizeKey, "0");
            ret = "0";
        }
        return Number(ret);
    };
    /**
     * Return a new instance of cache with customized configuration.
     * @param config - the customized configuration
     *
     * @return - new instance of Cache
     */ BrowserStorageCacheClass.prototype.createInstance = function(config) {
        if (!config.keyPrefix || config.keyPrefix === (0, $e82a6a8b6cd75a4a$export$f84bd70098573c5c).keyPrefix) {
            $476f1cc74cf261fb$var$logger.error("invalid keyPrefix, setting keyPrefix with timeStamp");
            config.keyPrefix = (0, $e82a6a8b6cd75a4a$export$dd144842d7b22d3a).toString();
        }
        return new BrowserStorageCacheClass(config);
    };
    return BrowserStorageCacheClass;
}((0, $a0d8cc6592a19fa5$export$947ed1997bd112b4));
var $476f1cc74cf261fb$export$2a9787695d97e2c4 = new $476f1cc74cf261fb$export$e6fda0405fa98d6d();
(0, $6ff5c7c169206e21$export$a3858a9a153cffc7).register($476f1cc74cf261fb$export$2a9787695d97e2c4);





var $df7e75a1ec5157cc$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("AbstractPubSubProvider");
var $df7e75a1ec5157cc$export$38596aa9173af3e4 = /** @class */ function() {
    function AbstractPubSubProvider(options) {
        this._config = options;
    }
    AbstractPubSubProvider.prototype.configure = function(config) {
        this._config = (0, $ad5e523f9031e630$export$18ce0697a983be9b)((0, $ad5e523f9031e630$export$18ce0697a983be9b)({}, config), this._config);
        $df7e75a1ec5157cc$var$logger.debug("configure " + this.getProviderName(), this._config);
        return this.options;
    };
    AbstractPubSubProvider.prototype.getCategory = function() {
        return "PubSub";
    };
    Object.defineProperty(AbstractPubSubProvider.prototype, "options", {
        get: function() {
            return (0, $ad5e523f9031e630$export$18ce0697a983be9b)({}, this._config);
        },
        enumerable: true,
        configurable: true
    });
    return AbstractPubSubProvider;
}();


var $158e47b81d4a4e5d$export$f96baa4bc836aea4;
(function(CONTROL_MSG) {
    CONTROL_MSG["CONNECTION_CLOSED"] = "Connection closed";
    CONTROL_MSG["CONNECTION_FAILED"] = "Connection failed";
    CONTROL_MSG["REALTIME_SUBSCRIPTION_INIT_ERROR"] = "AppSync Realtime subscription init error";
    CONTROL_MSG["SUBSCRIPTION_ACK"] = "Subscription ack";
    CONTROL_MSG["TIMEOUT_DISCONNECT"] = "Timeout disconnect";
})($158e47b81d4a4e5d$export$f96baa4bc836aea4 || ($158e47b81d4a4e5d$export$f96baa4bc836aea4 = {}));
var $158e47b81d4a4e5d$export$cd9c3c6bf535afc9;
(function(ConnectionState) {
    /*
     * The connection is alive and healthy
     */ ConnectionState["Connected"] = "Connected";
    /*
     * The connection is alive, but the connection is offline
     */ ConnectionState["ConnectedPendingNetwork"] = "ConnectedPendingNetwork";
    /*
     * The connection has been disconnected while in use
     */ ConnectionState["ConnectionDisrupted"] = "ConnectionDisrupted";
    /*
     * The connection has been disconnected and the network is offline
     */ ConnectionState["ConnectionDisruptedPendingNetwork"] = "ConnectionDisruptedPendingNetwork";
    /*
     * The connection is in the process of connecting
     */ ConnectionState["Connecting"] = "Connecting";
    /*
     * The connection is not in use and is being disconnected
     */ ConnectionState["ConnectedPendingDisconnect"] = "ConnectedPendingDisconnect";
    /*
     * The connection is not in use and has been disconnected
     */ ConnectionState["Disconnected"] = "Disconnected";
    /*
     * The connection is alive, but a keep alive message has been missed
     */ ConnectionState["ConnectedPendingKeepAlive"] = "ConnectedPendingKeepAlive";
})($158e47b81d4a4e5d$export$cd9c3c6bf535afc9 || ($158e47b81d4a4e5d$export$cd9c3c6bf535afc9 = {}));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $a01acced3fd149b0$export$76041b1400befb8b = 5000;
var $a01acced3fd149b0$export$d0eacfe8369b1f8e = [
    400,
    401,
    403
];
var $a01acced3fd149b0$export$a222eb271a4ce46b = "ConnectionStateChange";
var $a01acced3fd149b0$export$e5fcfdba4a8ae715;
(function(MESSAGE_TYPES) {
    /**
     * Client -> Server message.
     * This message type is the first message after handshake and this will initialize AWS AppSync RealTime communication
     */ MESSAGE_TYPES["GQL_CONNECTION_INIT"] = "connection_init";
    /**
     * Server -> Client message
     * This message type is in case there is an issue with AWS AppSync RealTime when establishing connection
     */ MESSAGE_TYPES["GQL_CONNECTION_ERROR"] = "connection_error";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_CONNECTION_INIT message
     */ MESSAGE_TYPES["GQL_CONNECTION_ACK"] = "connection_ack";
    /**
     * Client -> Server message.
     * This message type is for register subscriptions with AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_START"] = "start";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_START message
     */ MESSAGE_TYPES["GQL_START_ACK"] = "start_ack";
    /**
     * Server -> Client message.
     * This message type is for subscription message from AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_DATA"] = "data";
    /**
     * Server -> Client message.
     * This message type helps the client to know is still receiving messages from AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_CONNECTION_KEEP_ALIVE"] = "ka";
    /**
     * Client -> Server message.
     * This message type is for unregister subscriptions with AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_STOP"] = "stop";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_STOP message
     */ MESSAGE_TYPES["GQL_COMPLETE"] = "complete";
    /**
     * Server -> Client message.
     * This message type is for sending error messages from AWS AppSync RealTime to the client
     */ MESSAGE_TYPES["GQL_ERROR"] = "error";
})($a01acced3fd149b0$export$e5fcfdba4a8ae715 || ($a01acced3fd149b0$export$e5fcfdba4a8ae715 = {}));
var $a01acced3fd149b0$export$50fc1b1dccfe0f97;
(function(SUBSCRIPTION_STATUS) {
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["PENDING"] = 0] = "PENDING";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["CONNECTED"] = 1] = "CONNECTED";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["FAILED"] = 2] = "FAILED";
})($a01acced3fd149b0$export$50fc1b1dccfe0f97 || ($a01acced3fd149b0$export$50fc1b1dccfe0f97 = {}));
var $a01acced3fd149b0$export$453843f36861c0a2;
(function(SOCKET_STATUS) {
    SOCKET_STATUS[SOCKET_STATUS["CLOSED"] = 0] = "CLOSED";
    SOCKET_STATUS[SOCKET_STATUS["READY"] = 1] = "READY";
    SOCKET_STATUS[SOCKET_STATUS["CONNECTING"] = 2] = "CONNECTING";
})($a01acced3fd149b0$export$453843f36861c0a2 || ($a01acced3fd149b0$export$453843f36861c0a2 = {}));
var $a01acced3fd149b0$export$aadf71dd9875dd20 = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var $a01acced3fd149b0$export$7a236fa930e45f72 = {
    accept: "application/json, text/javascript",
    "content-encoding": "amz-1.0",
    "content-type": "application/json; charset=UTF-8"
};
var $a01acced3fd149b0$export$c36bbd48cffe7fa4 = 15000;
var $a01acced3fd149b0$export$c6bc4b7cffb2ca8 = 15000;
var $a01acced3fd149b0$export$71a299b29e2098f0 = 300000;
var $a01acced3fd149b0$export$2cb64c85846dde7d = 65000;
var $a01acced3fd149b0$export$6040e6f953ecf619 = 5000;
var $a01acced3fd149b0$export$6229bdb3fed88d41 = 60000;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $b235212b4a8bb9d1$export$2636160e319be4f9 = function() {
    return new (0, $510cca51d2937e6d$export$2e2bcd8739ae039)().networkMonitor();
};


var $c9dcc04d7253336c$export$77ad93647ea34124 = {
    KEEP_ALIVE_MISSED: {
        keepAliveState: "unhealthy"
    },
    KEEP_ALIVE: {
        keepAliveState: "healthy"
    },
    CONNECTION_ESTABLISHED: {
        connectionState: "connected"
    },
    CONNECTION_FAILED: {
        intendedConnectionState: "disconnected",
        connectionState: "disconnected"
    },
    CLOSING_CONNECTION: {
        intendedConnectionState: "disconnected"
    },
    OPENING_CONNECTION: {
        intendedConnectionState: "connected",
        connectionState: "connecting"
    },
    CLOSED: {
        connectionState: "disconnected"
    },
    ONLINE: {
        networkState: "connected"
    },
    OFFLINE: {
        networkState: "disconnected"
    }
};
var $c9dcc04d7253336c$export$d8916ed266c478dd = /** @class */ function() {
    function ConnectionStateMonitor() {
        var _this = this;
        this._networkMonitoringSubscription = undefined;
        this._linkedConnectionState = {
            networkState: "connected",
            connectionState: "disconnected",
            intendedConnectionState: "disconnected",
            keepAliveState: "healthy"
        };
        // Attempt to update the state with the current actual network state
        this._initialNetworkStateSubscription = (0, $b235212b4a8bb9d1$export$2636160e319be4f9)().subscribe(function(_a) {
            var online = _a.online;
            var _b;
            _this.record(online ? $c9dcc04d7253336c$export$77ad93647ea34124.ONLINE : $c9dcc04d7253336c$export$77ad93647ea34124.OFFLINE);
            (_b = _this._initialNetworkStateSubscription) === null || _b === void 0 || _b.unsubscribe();
        });
        this._linkedConnectionStateObservable = new (0, $297ced72d65979d1$export$2e2bcd8739ae039)(function(connectionStateObserver) {
            connectionStateObserver.next(_this._linkedConnectionState);
            _this._linkedConnectionStateObserver = connectionStateObserver;
        });
    }
    /**
     * Turn network state monitoring on if it isn't on already
     */ ConnectionStateMonitor.prototype.enableNetworkMonitoring = function() {
        var _this = this;
        var _a;
        // If no initial network state was discovered, stop trying
        (_a = this._initialNetworkStateSubscription) === null || _a === void 0 || _a.unsubscribe();
        // Maintain the network state based on the reachability monitor
        if (this._networkMonitoringSubscription === undefined) this._networkMonitoringSubscription = (0, $b235212b4a8bb9d1$export$2636160e319be4f9)().subscribe(function(_a) {
            var online = _a.online;
            _this.record(online ? $c9dcc04d7253336c$export$77ad93647ea34124.ONLINE : $c9dcc04d7253336c$export$77ad93647ea34124.OFFLINE);
        });
    };
    /**
     * Turn network state monitoring off if it isn't off already
     */ ConnectionStateMonitor.prototype.disableNetworkMonitoring = function() {
        var _a;
        (_a = this._networkMonitoringSubscription) === null || _a === void 0 || _a.unsubscribe();
        this._networkMonitoringSubscription = undefined;
    };
    Object.defineProperty(ConnectionStateMonitor.prototype, "connectionStateObservable", {
        /**
         * Get the observable that allows us to monitor the connection state
         *
         * @returns {Observable<ConnectionState>} - The observable that emits ConnectionState updates
         */ get: function() {
            var _this = this;
            var previous;
            // The linked state aggregates state changes to any of the network, connection,
            // intendedConnection and keepAliveHealth. Some states will change these independent
            // states without changing the overall connection state.
            // After translating from linked states to ConnectionState, then remove any duplicates
            return this._linkedConnectionStateObservable.map(function(value) {
                return _this.connectionStatesTranslator(value);
            }).filter(function(current) {
                var toInclude = current !== previous;
                previous = current;
                return toInclude;
            });
        },
        enumerable: true,
        configurable: true
    });
    /*
     * Updates local connection state and emits the full state to the observer.
     */ ConnectionStateMonitor.prototype.record = function(statusUpdates) {
        // Maintain the network monitor
        if (statusUpdates.intendedConnectionState === "connected") this.enableNetworkMonitoring();
        else if (statusUpdates.intendedConnectionState === "disconnected") this.disableNetworkMonitoring();
        // Maintain the socket state
        var newSocketStatus = (0, $ad5e523f9031e630$export$18ce0697a983be9b)((0, $ad5e523f9031e630$export$18ce0697a983be9b)({}, this._linkedConnectionState), statusUpdates);
        this._linkedConnectionState = (0, $ad5e523f9031e630$export$18ce0697a983be9b)({}, newSocketStatus);
        this._linkedConnectionStateObserver.next(this._linkedConnectionState);
    };
    /*
     * Translate the ConnectionState structure into a specific ConnectionState string literal union
     */ ConnectionStateMonitor.prototype.connectionStatesTranslator = function(_a) {
        var connectionState = _a.connectionState, networkState = _a.networkState, intendedConnectionState = _a.intendedConnectionState, keepAliveState = _a.keepAliveState;
        if (connectionState === "connected" && networkState === "disconnected") return (0, $158e47b81d4a4e5d$export$cd9c3c6bf535afc9).ConnectedPendingNetwork;
        if (connectionState === "connected" && intendedConnectionState === "disconnected") return (0, $158e47b81d4a4e5d$export$cd9c3c6bf535afc9).ConnectedPendingDisconnect;
        if (connectionState === "disconnected" && intendedConnectionState === "connected" && networkState === "disconnected") return (0, $158e47b81d4a4e5d$export$cd9c3c6bf535afc9).ConnectionDisruptedPendingNetwork;
        if (connectionState === "disconnected" && intendedConnectionState === "connected") return (0, $158e47b81d4a4e5d$export$cd9c3c6bf535afc9).ConnectionDisrupted;
        if (connectionState === "connected" && keepAliveState === "unhealthy") return (0, $158e47b81d4a4e5d$export$cd9c3c6bf535afc9).ConnectedPendingKeepAlive;
        // All remaining states directly correspond to the connection state
        if (connectionState === "connecting") return (0, $158e47b81d4a4e5d$export$cd9c3c6bf535afc9).Connecting;
        if (connectionState === "disconnected") return (0, $158e47b81d4a4e5d$export$cd9c3c6bf535afc9).Disconnected;
        return (0, $158e47b81d4a4e5d$export$cd9c3c6bf535afc9).Connected;
    };
    return ConnectionStateMonitor;
}();



var $88c455e528b5e04a$export$ce528341f93f43f1;
(function(ReconnectEvent) {
    ReconnectEvent["START_RECONNECT"] = "START_RECONNECT";
    ReconnectEvent["HALT_RECONNECT"] = "HALT_RECONNECT";
})($88c455e528b5e04a$export$ce528341f93f43f1 || ($88c455e528b5e04a$export$ce528341f93f43f1 = {}));
/**
 * Captures the reconnect event logic used to determine when to reconnect to PubSub providers.
 *   Reconnnect attempts are delayed by 5 seconds to let the interface settle.
 *   Attempting to reconnect only once creates unrecoverable states when the network state isn't
 *   supported by the browser, so this keeps retrying every minute until halted.
 */ var $88c455e528b5e04a$export$6d01b279c51a2afb = /** @class */ function() {
    function ReconnectionMonitor() {
        this.reconnectObservers = [];
    }
    /**
     * Add reconnect observer to the list of observers to alert on reconnect
     */ ReconnectionMonitor.prototype.addObserver = function(reconnectObserver) {
        this.reconnectObservers.push(reconnectObserver);
    };
    /**
     * Given a reconnect event, start the appropriate behavior
     */ ReconnectionMonitor.prototype.record = function(event) {
        var _this = this;
        if (event === $88c455e528b5e04a$export$ce528341f93f43f1.START_RECONNECT) // If the reconnection hasn't been started
        {
            if (this.reconnectSetTimeoutId === undefined && this.reconnectIntervalId === undefined) this.reconnectSetTimeoutId = setTimeout(function() {
                // Reconnect now
                _this._triggerReconnect();
                // Retry reconnect every periodically until it works
                _this.reconnectIntervalId = setInterval(function() {
                    _this._triggerReconnect();
                }, (0, $a01acced3fd149b0$export$6229bdb3fed88d41));
            }, (0, $a01acced3fd149b0$export$6040e6f953ecf619));
        }
        if (event === $88c455e528b5e04a$export$ce528341f93f43f1.HALT_RECONNECT) {
            if (this.reconnectIntervalId) {
                clearInterval(this.reconnectIntervalId);
                this.reconnectIntervalId = undefined;
            }
            if (this.reconnectSetTimeoutId) {
                clearTimeout(this.reconnectSetTimeoutId);
                this.reconnectSetTimeoutId = undefined;
            }
        }
    };
    /**
     * Complete all reconnect observers
     */ ReconnectionMonitor.prototype.close = function() {
        this.reconnectObservers.forEach(function(reconnectObserver) {
            var _a;
            (_a = reconnectObserver.complete) === null || _a === void 0 || _a.call(reconnectObserver);
        });
    };
    ReconnectionMonitor.prototype._triggerReconnect = function() {
        this.reconnectObservers.forEach(function(reconnectObserver) {
            var _a;
            (_a = reconnectObserver.next) === null || _a === void 0 || _a.call(reconnectObserver);
        });
    };
    return ReconnectionMonitor;
}();


var $870aa9661b071147$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("AWSAppSyncRealTimeProvider");
var $870aa9661b071147$var$dispatchApiEvent = function(event, data, message) {
    (0, $3b4d9bb645fe011c$export$8c41bb232f1008b1).dispatch("api", {
        event: event,
        data: data,
        message: message
    }, "PubSub", (0, $a01acced3fd149b0$export$aadf71dd9875dd20));
};
var $870aa9661b071147$var$standardDomainPattern = /^https:\/\/\w{26}\.appsync\-api\.\w{2}(?:(?:\-\w{2,})+)\-\d\.amazonaws.com(?:\.cn)?\/graphql$/i;
var $870aa9661b071147$var$customDomainPath = "/realtime";
var $870aa9661b071147$export$b7b5e6371992068d = /** @class */ function(_super) {
    (0, $ad5e523f9031e630$export$a8ba968b8961cb8a)(AWSAppSyncRealTimeProvider, _super);
    function AWSAppSyncRealTimeProvider(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, options) || this;
        _this.socketStatus = (0, $a01acced3fd149b0$export$453843f36861c0a2).CLOSED;
        _this.keepAliveTimeout = (0, $a01acced3fd149b0$export$71a299b29e2098f0);
        _this.subscriptionObserverMap = new Map();
        _this.promiseArray = [];
        _this.connectionStateMonitor = new (0, $c9dcc04d7253336c$export$d8916ed266c478dd)();
        _this.reconnectionMonitor = new (0, $88c455e528b5e04a$export$6d01b279c51a2afb)();
        // Monitor the connection state and pass changes along to Hub
        _this.connectionStateMonitorSubscription = _this.connectionStateMonitor.connectionStateObservable.subscribe(function(connectionState) {
            $870aa9661b071147$var$dispatchApiEvent((0, $a01acced3fd149b0$export$a222eb271a4ce46b), {
                provider: _this,
                connectionState: connectionState
            }, "Connection state is " + connectionState);
            _this.connectionState = connectionState;
            // Trigger START_RECONNECT when the connection is disrupted
            if (connectionState === (0, $158e47b81d4a4e5d$export$cd9c3c6bf535afc9).ConnectionDisrupted) _this.reconnectionMonitor.record((0, $88c455e528b5e04a$export$ce528341f93f43f1).START_RECONNECT);
            // Trigger HALT_RECONNECT to halt reconnection attempts when the state is anything other than
            //   ConnectionDisrupted or Connecting
            if ([
                (0, $158e47b81d4a4e5d$export$cd9c3c6bf535afc9).Connected,
                (0, $158e47b81d4a4e5d$export$cd9c3c6bf535afc9).ConnectedPendingDisconnect,
                (0, $158e47b81d4a4e5d$export$cd9c3c6bf535afc9).ConnectedPendingKeepAlive,
                (0, $158e47b81d4a4e5d$export$cd9c3c6bf535afc9).ConnectedPendingNetwork,
                (0, $158e47b81d4a4e5d$export$cd9c3c6bf535afc9).ConnectionDisruptedPendingNetwork,
                (0, $158e47b81d4a4e5d$export$cd9c3c6bf535afc9).Disconnected
            ].includes(connectionState)) _this.reconnectionMonitor.record((0, $88c455e528b5e04a$export$ce528341f93f43f1).HALT_RECONNECT);
        });
        return _this;
    }
    /**
     * Mark the socket closed and release all active listeners
     */ AWSAppSyncRealTimeProvider.prototype.close = function() {
        // Mark the socket closed both in status and the connection monitor
        this.socketStatus = (0, $a01acced3fd149b0$export$453843f36861c0a2).CLOSED;
        this.connectionStateMonitor.record((0, $c9dcc04d7253336c$export$77ad93647ea34124).CONNECTION_FAILED);
        // Turn off the subscription monitor Hub publishing
        this.connectionStateMonitorSubscription.unsubscribe();
        // Complete all reconnect observers
        this.reconnectionMonitor.close();
    };
    AWSAppSyncRealTimeProvider.prototype.getNewWebSocket = function(url, protocol) {
        return new WebSocket(url, protocol);
    };
    AWSAppSyncRealTimeProvider.prototype.getProviderName = function() {
        return "AWSAppSyncRealTimeProvider";
    };
    AWSAppSyncRealTimeProvider.prototype.newClient = function() {
        throw new Error("Not used here");
    };
    AWSAppSyncRealTimeProvider.prototype.publish = function(_topics, _msg, _options) {
        return (0, $ad5e523f9031e630$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ad5e523f9031e630$export$67ebef60e6f28a6)(this, function(_a) {
                throw new Error("Operation not supported");
            });
        });
    };
    // Check if url matches standard domain pattern
    AWSAppSyncRealTimeProvider.prototype.isCustomDomain = function(url) {
        return url.match($870aa9661b071147$var$standardDomainPattern) === null;
    };
    AWSAppSyncRealTimeProvider.prototype.subscribe = function(_topics, options, customUserAgentDetails) {
        var _this = this;
        var appSyncGraphqlEndpoint = options === null || options === void 0 ? void 0 : options.appSyncGraphqlEndpoint;
        return new (0, $297ced72d65979d1$export$2e2bcd8739ae039)(function(observer) {
            if (!options || !appSyncGraphqlEndpoint) {
                observer.error({
                    errors: [
                        (0, $ad5e523f9031e630$export$18ce0697a983be9b)({}, new (0, $b81b6b4578512de6$export$92d6ed0888e7cb7f)("Subscribe only available for AWS AppSync endpoint"))
                    ]
                });
                observer.complete();
            } else {
                var subscriptionStartActive_1 = false;
                var subscriptionId_1 = (0, $e2addc82b6ae150b$exports.v4)();
                var startSubscription_1 = function() {
                    if (!subscriptionStartActive_1) {
                        subscriptionStartActive_1 = true;
                        var startSubscriptionPromise = _this._startSubscriptionWithAWSAppSyncRealTime({
                            options: options,
                            observer: observer,
                            subscriptionId: subscriptionId_1,
                            customUserAgentDetails: customUserAgentDetails
                        }).catch(function(err) {
                            $870aa9661b071147$var$logger.debug((0, $158e47b81d4a4e5d$export$f96baa4bc836aea4).REALTIME_SUBSCRIPTION_INIT_ERROR + ": " + err);
                            _this.connectionStateMonitor.record((0, $c9dcc04d7253336c$export$77ad93647ea34124).CLOSED);
                        });
                        startSubscriptionPromise.finally(function() {
                            subscriptionStartActive_1 = false;
                        });
                    }
                };
                var reconnectSubscription_1;
                // Add an observable to the reconnection list to manage reconnection for this subscription
                reconnectSubscription_1 = new (0, $297ced72d65979d1$export$2e2bcd8739ae039)(function(observer) {
                    _this.reconnectionMonitor.addObserver(observer);
                }).subscribe(function() {
                    startSubscription_1();
                });
                startSubscription_1();
                return function() {
                    return (0, $ad5e523f9031e630$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                        var subscriptionState, err_1;
                        return (0, $ad5e523f9031e630$export$67ebef60e6f28a6)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    // Cleanup reconnection subscription
                                    reconnectSubscription_1 === null || reconnectSubscription_1 === void 0 || reconnectSubscription_1.unsubscribe();
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        3,
                                        4,
                                        5
                                    ]);
                                    // Waiting that subscription has been connected before trying to unsubscribe
                                    return [
                                        4 /*yield*/ ,
                                        this._waitForSubscriptionToBeConnected(subscriptionId_1)
                                    ];
                                case 2:
                                    // Waiting that subscription has been connected before trying to unsubscribe
                                    _a.sent();
                                    subscriptionState = (this.subscriptionObserverMap.get(subscriptionId_1) || {}).subscriptionState;
                                    if (!subscriptionState) // subscription already unsubscribed
                                    return [
                                        2 /*return*/ 
                                    ];
                                    if (subscriptionState === (0, $a01acced3fd149b0$export$50fc1b1dccfe0f97).CONNECTED) this._sendUnsubscriptionMessage(subscriptionId_1);
                                    else throw new Error("Subscription never connected");
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 3:
                                    err_1 = _a.sent();
                                    $870aa9661b071147$var$logger.debug("Error while unsubscribing " + err_1);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    this._removeSubscriptionObserver(subscriptionId_1);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 5:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
            }
        });
    };
    Object.defineProperty(AWSAppSyncRealTimeProvider.prototype, "isSSLEnabled", {
        get: function() {
            return !this.options["aws_appsync_dangerously_connect_to_http_endpoint_for_testing"];
        },
        enumerable: true,
        configurable: true
    });
    AWSAppSyncRealTimeProvider.prototype._startSubscriptionWithAWSAppSyncRealTime = function(_a) {
        var options = _a.options, observer = _a.observer, subscriptionId = _a.subscriptionId, customUserAgentDetails = _a.customUserAgentDetails;
        var _b;
        return (0, $ad5e523f9031e630$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var appSyncGraphqlEndpoint, authenticationType, query, variables, apiKey, region, _c, graphql_headers, _d, additionalHeaders, subscriptionState, data, dataString, headerObj, _e, _f, subscriptionMessage, stringToAWSRealTime, err_2, _g, subscriptionFailedCallback, subscriptionReadyCallback;
            var _h;
            var _this = this;
            return (0, $ad5e523f9031e630$export$67ebef60e6f28a6)(this, function(_j) {
                switch(_j.label){
                    case 0:
                        appSyncGraphqlEndpoint = options.appSyncGraphqlEndpoint, authenticationType = options.authenticationType, query = options.query, variables = options.variables, apiKey = options.apiKey, region = options.region, _c = options.graphql_headers, graphql_headers = _c === void 0 ? function() {
                            return {};
                        } : _c, _d = options.additionalHeaders, additionalHeaders = _d === void 0 ? {} : _d;
                        subscriptionState = (0, $a01acced3fd149b0$export$50fc1b1dccfe0f97).PENDING;
                        data = {
                            query: query,
                            variables: variables
                        };
                        // Having a subscription id map will make it simple to forward messages received
                        this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            query: query !== null && query !== void 0 ? query : "",
                            variables: variables !== null && variables !== void 0 ? variables : {},
                            subscriptionState: subscriptionState,
                            startAckTimeoutId: undefined
                        });
                        dataString = JSON.stringify(data);
                        _e = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._awsRealTimeHeaderBasedAuth({
                                apiKey: apiKey,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                authenticationType: authenticationType,
                                payload: dataString,
                                canonicalUri: "",
                                region: region,
                                additionalHeaders: additionalHeaders
                            })
                        ];
                    case 1:
                        _f = [
                            (0, $ad5e523f9031e630$export$18ce0697a983be9b).apply(void 0, _e.concat([
                                _j.sent()
                            ]))
                        ];
                        return [
                            4 /*yield*/ ,
                            graphql_headers()
                        ];
                    case 2:
                        headerObj = (0, $ad5e523f9031e630$export$18ce0697a983be9b).apply(void 0, [
                            (0, $ad5e523f9031e630$export$18ce0697a983be9b).apply(void 0, [
                                (0, $ad5e523f9031e630$export$18ce0697a983be9b).apply(void 0, _f.concat([
                                    _j.sent()
                                ])),
                                additionalHeaders
                            ]),
                            (_h = {}, _h[0, $ed8a415515f52c9d$export$16032fc466434892] = (0, $0d25e50bf44b1a9b$export$ede38edb26c0bfdf)(customUserAgentDetails), _h)
                        ]);
                        subscriptionMessage = {
                            id: subscriptionId,
                            payload: {
                                data: dataString,
                                extensions: {
                                    authorization: (0, $ad5e523f9031e630$export$18ce0697a983be9b)({}, headerObj)
                                }
                            },
                            type: (0, $a01acced3fd149b0$export$e5fcfdba4a8ae715).GQL_START
                        };
                        stringToAWSRealTime = JSON.stringify(subscriptionMessage);
                        _j.label = 3;
                    case 3:
                        _j.trys.push([
                            3,
                            5,
                            ,
                            6
                        ]);
                        this.connectionStateMonitor.record((0, $c9dcc04d7253336c$export$77ad93647ea34124).OPENING_CONNECTION);
                        return [
                            4 /*yield*/ ,
                            this._initializeWebSocketConnection({
                                apiKey: apiKey,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                authenticationType: authenticationType,
                                region: region,
                                additionalHeaders: additionalHeaders
                            })
                        ];
                    case 4:
                        _j.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        err_2 = _j.sent();
                        this._logStartSubscriptionError(subscriptionId, observer, err_2);
                        return [
                            2 /*return*/ 
                        ];
                    case 6:
                        _g = (_b = this.subscriptionObserverMap.get(subscriptionId)) !== null && _b !== void 0 ? _b : {}, subscriptionFailedCallback = _g.subscriptionFailedCallback, subscriptionReadyCallback = _g.subscriptionReadyCallback;
                        // This must be done before sending the message in order to be listening immediately
                        this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            subscriptionState: subscriptionState,
                            query: query !== null && query !== void 0 ? query : "",
                            variables: variables !== null && variables !== void 0 ? variables : {},
                            subscriptionReadyCallback: subscriptionReadyCallback,
                            subscriptionFailedCallback: subscriptionFailedCallback,
                            startAckTimeoutId: setTimeout(function() {
                                _this._timeoutStartSubscriptionAck.call(_this, subscriptionId);
                            }, (0, $a01acced3fd149b0$export$c6bc4b7cffb2ca8))
                        });
                        if (this.awsRealTimeSocket) this.awsRealTimeSocket.send(stringToAWSRealTime);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Log logic for start subscription failures
    AWSAppSyncRealTimeProvider.prototype._logStartSubscriptionError = function(subscriptionId, observer, err) {
        var _a;
        $870aa9661b071147$var$logger.debug({
            err: err
        });
        var message = String((_a = err.message) !== null && _a !== void 0 ? _a : "");
        // Resolving to give the state observer time to propogate the update
        Promise.resolve(this.connectionStateMonitor.record((0, $c9dcc04d7253336c$export$77ad93647ea34124).CLOSED));
        // Capture the error only when the network didn't cause disruption
        if (this.connectionState !== (0, $158e47b81d4a4e5d$export$cd9c3c6bf535afc9).ConnectionDisruptedPendingNetwork) {
            // When the error is non-retriable, error out the observable
            if ((0, $e630ff0a3924a99b$export$490cab1f6f83794d)(err)) observer.error({
                errors: [
                    (0, $ad5e523f9031e630$export$18ce0697a983be9b)({}, new (0, $b81b6b4578512de6$export$92d6ed0888e7cb7f)((0, $158e47b81d4a4e5d$export$f96baa4bc836aea4).CONNECTION_FAILED + ": " + message))
                ]
            });
            else $870aa9661b071147$var$logger.debug((0, $158e47b81d4a4e5d$export$f96baa4bc836aea4).CONNECTION_FAILED + ": " + message);
            var subscriptionFailedCallback = (this.subscriptionObserverMap.get(subscriptionId) || {}).subscriptionFailedCallback;
            // Notify concurrent unsubscription
            if (typeof subscriptionFailedCallback === "function") subscriptionFailedCallback();
        }
    };
    // Waiting that subscription has been connected before trying to unsubscribe
    AWSAppSyncRealTimeProvider.prototype._waitForSubscriptionToBeConnected = function(subscriptionId) {
        return (0, $ad5e523f9031e630$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var subscriptionObserver, subscriptionState;
            var _this = this;
            return (0, $ad5e523f9031e630$export$67ebef60e6f28a6)(this, function(_a) {
                subscriptionObserver = this.subscriptionObserverMap.get(subscriptionId);
                if (subscriptionObserver) {
                    subscriptionState = subscriptionObserver.subscriptionState;
                    // This in case unsubscribe is invoked before sending start subscription message
                    if (subscriptionState === (0, $a01acced3fd149b0$export$50fc1b1dccfe0f97).PENDING) return [
                        2 /*return*/ ,
                        new Promise(function(res, rej) {
                            var observer = subscriptionObserver.observer, subscriptionState = subscriptionObserver.subscriptionState, variables = subscriptionObserver.variables, query = subscriptionObserver.query;
                            _this.subscriptionObserverMap.set(subscriptionId, {
                                observer: observer,
                                subscriptionState: subscriptionState,
                                variables: variables,
                                query: query,
                                subscriptionReadyCallback: res,
                                subscriptionFailedCallback: rej
                            });
                        })
                    ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._sendUnsubscriptionMessage = function(subscriptionId) {
        try {
            if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN && this.socketStatus === (0, $a01acced3fd149b0$export$453843f36861c0a2).READY) {
                // Preparing unsubscribe message to stop receiving messages for that subscription
                var unsubscribeMessage = {
                    id: subscriptionId,
                    type: (0, $a01acced3fd149b0$export$e5fcfdba4a8ae715).GQL_STOP
                };
                var stringToAWSRealTime = JSON.stringify(unsubscribeMessage);
                this.awsRealTimeSocket.send(stringToAWSRealTime);
            }
        } catch (err) {
            // If GQL_STOP is not sent because of disconnection issue, then there is nothing the client can do
            $870aa9661b071147$var$logger.debug({
                err: err
            });
        }
    };
    AWSAppSyncRealTimeProvider.prototype._removeSubscriptionObserver = function(subscriptionId) {
        this.subscriptionObserverMap.delete(subscriptionId);
        // Verifying 1000ms after removing subscription in case there are new subscription unmount/mount
        setTimeout(this._closeSocketIfRequired.bind(this), 1000);
    };
    AWSAppSyncRealTimeProvider.prototype._closeSocketIfRequired = function() {
        if (this.subscriptionObserverMap.size > 0) // Active subscriptions on the WebSocket
        return;
        if (!this.awsRealTimeSocket) {
            this.socketStatus = (0, $a01acced3fd149b0$export$453843f36861c0a2).CLOSED;
            return;
        }
        this.connectionStateMonitor.record((0, $c9dcc04d7253336c$export$77ad93647ea34124).CLOSING_CONNECTION);
        if (this.awsRealTimeSocket.bufferedAmount > 0) // Still data on the WebSocket
        setTimeout(this._closeSocketIfRequired.bind(this), 1000);
        else {
            $870aa9661b071147$var$logger.debug("closing WebSocket...");
            if (this.keepAliveTimeoutId) clearTimeout(this.keepAliveTimeoutId);
            if (this.keepAliveAlertTimeoutId) clearTimeout(this.keepAliveAlertTimeoutId);
            var tempSocket = this.awsRealTimeSocket;
            // Cleaning callbacks to avoid race condition, socket still exists
            tempSocket.onclose = null;
            tempSocket.onerror = null;
            tempSocket.close(1000);
            this.awsRealTimeSocket = undefined;
            this.socketStatus = (0, $a01acced3fd149b0$export$453843f36861c0a2).CLOSED;
            this.connectionStateMonitor.record((0, $c9dcc04d7253336c$export$77ad93647ea34124).CLOSED);
        }
    };
    AWSAppSyncRealTimeProvider.prototype._handleIncomingSubscriptionMessage = function(message) {
        var _this = this;
        if (typeof message.data !== "string") return;
        $870aa9661b071147$var$logger.debug("subscription message from AWS AppSync RealTime: " + message.data);
        var _a = JSON.parse(String(message.data)), _b = _a.id, id = _b === void 0 ? "" : _b, payload = _a.payload, type = _a.type;
        var _c = this.subscriptionObserverMap.get(id) || {}, _d = _c.observer, observer = _d === void 0 ? null : _d, _e = _c.query, query = _e === void 0 ? "" : _e, _f = _c.variables, variables = _f === void 0 ? {} : _f, startAckTimeoutId = _c.startAckTimeoutId, subscriptionReadyCallback = _c.subscriptionReadyCallback, subscriptionFailedCallback = _c.subscriptionFailedCallback;
        $870aa9661b071147$var$logger.debug({
            id: id,
            observer: observer,
            query: query,
            variables: variables
        });
        if (type === (0, $a01acced3fd149b0$export$e5fcfdba4a8ae715).GQL_DATA && payload && payload.data) {
            if (observer) observer.next(payload);
            else $870aa9661b071147$var$logger.debug("observer not found for id: " + id);
            return;
        }
        if (type === (0, $a01acced3fd149b0$export$e5fcfdba4a8ae715).GQL_START_ACK) {
            $870aa9661b071147$var$logger.debug("subscription ready for " + JSON.stringify({
                query: query,
                variables: variables
            }));
            if (typeof subscriptionReadyCallback === "function") subscriptionReadyCallback();
            if (startAckTimeoutId) clearTimeout(startAckTimeoutId);
            $870aa9661b071147$var$dispatchApiEvent((0, $158e47b81d4a4e5d$export$f96baa4bc836aea4).SUBSCRIPTION_ACK, {
                query: query,
                variables: variables
            }, "Connection established for subscription");
            var subscriptionState = (0, $a01acced3fd149b0$export$50fc1b1dccfe0f97).CONNECTED;
            if (observer) this.subscriptionObserverMap.set(id, {
                observer: observer,
                query: query,
                variables: variables,
                startAckTimeoutId: undefined,
                subscriptionState: subscriptionState,
                subscriptionReadyCallback: subscriptionReadyCallback,
                subscriptionFailedCallback: subscriptionFailedCallback
            });
            this.connectionStateMonitor.record((0, $c9dcc04d7253336c$export$77ad93647ea34124).CONNECTION_ESTABLISHED);
            return;
        }
        if (type === (0, $a01acced3fd149b0$export$e5fcfdba4a8ae715).GQL_CONNECTION_KEEP_ALIVE) {
            if (this.keepAliveTimeoutId) clearTimeout(this.keepAliveTimeoutId);
            if (this.keepAliveAlertTimeoutId) clearTimeout(this.keepAliveAlertTimeoutId);
            this.keepAliveTimeoutId = setTimeout(function() {
                return _this._errorDisconnect((0, $158e47b81d4a4e5d$export$f96baa4bc836aea4).TIMEOUT_DISCONNECT);
            }, this.keepAliveTimeout);
            this.keepAliveAlertTimeoutId = setTimeout(function() {
                _this.connectionStateMonitor.record((0, $c9dcc04d7253336c$export$77ad93647ea34124).KEEP_ALIVE_MISSED);
            }, (0, $a01acced3fd149b0$export$2cb64c85846dde7d));
            this.connectionStateMonitor.record((0, $c9dcc04d7253336c$export$77ad93647ea34124).KEEP_ALIVE);
            return;
        }
        if (type === (0, $a01acced3fd149b0$export$e5fcfdba4a8ae715).GQL_ERROR) {
            var subscriptionState = (0, $a01acced3fd149b0$export$50fc1b1dccfe0f97).FAILED;
            if (observer) {
                this.subscriptionObserverMap.set(id, {
                    observer: observer,
                    query: query,
                    variables: variables,
                    startAckTimeoutId: startAckTimeoutId,
                    subscriptionReadyCallback: subscriptionReadyCallback,
                    subscriptionFailedCallback: subscriptionFailedCallback,
                    subscriptionState: subscriptionState
                });
                $870aa9661b071147$var$logger.debug((0, $158e47b81d4a4e5d$export$f96baa4bc836aea4).CONNECTION_FAILED + ": " + JSON.stringify(payload));
                observer.error({
                    errors: [
                        (0, $ad5e523f9031e630$export$18ce0697a983be9b)({}, new (0, $b81b6b4578512de6$export$92d6ed0888e7cb7f)((0, $158e47b81d4a4e5d$export$f96baa4bc836aea4).CONNECTION_FAILED + ": " + JSON.stringify(payload)))
                    ]
                });
                if (startAckTimeoutId) clearTimeout(startAckTimeoutId);
                if (typeof subscriptionFailedCallback === "function") subscriptionFailedCallback();
            }
        }
    };
    AWSAppSyncRealTimeProvider.prototype._errorDisconnect = function(msg) {
        $870aa9661b071147$var$logger.debug("Disconnect error: " + msg);
        if (this.awsRealTimeSocket) {
            this.connectionStateMonitor.record((0, $c9dcc04d7253336c$export$77ad93647ea34124).CLOSED);
            this.awsRealTimeSocket.close();
        }
        this.socketStatus = (0, $a01acced3fd149b0$export$453843f36861c0a2).CLOSED;
    };
    AWSAppSyncRealTimeProvider.prototype._timeoutStartSubscriptionAck = function(subscriptionId) {
        var subscriptionObserver = this.subscriptionObserverMap.get(subscriptionId);
        if (subscriptionObserver) {
            var observer = subscriptionObserver.observer, query = subscriptionObserver.query, variables = subscriptionObserver.variables;
            if (!observer) return;
            this.subscriptionObserverMap.set(subscriptionId, {
                observer: observer,
                query: query,
                variables: variables,
                subscriptionState: (0, $a01acced3fd149b0$export$50fc1b1dccfe0f97).FAILED
            });
            this.connectionStateMonitor.record((0, $c9dcc04d7253336c$export$77ad93647ea34124).CLOSED);
            $870aa9661b071147$var$logger.debug("timeoutStartSubscription", JSON.stringify({
                query: query,
                variables: variables
            }));
        }
    };
    AWSAppSyncRealTimeProvider.prototype._initializeWebSocketConnection = function(_a) {
        var _this = this;
        var appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, authenticationType = _a.authenticationType, apiKey = _a.apiKey, region = _a.region, additionalHeaders = _a.additionalHeaders;
        if (this.socketStatus === (0, $a01acced3fd149b0$export$453843f36861c0a2).READY) return;
        return new Promise(function(res, rej) {
            return (0, $ad5e523f9031e630$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                var payloadString, authHeader, headerString, headerQs, payloadQs, discoverableEndpoint, protocol, awsRealTimeUrl, err_3;
                return (0, $ad5e523f9031e630$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.promiseArray.push({
                                res: res,
                                rej: rej
                            });
                            if (!(this.socketStatus === (0, $a01acced3fd149b0$export$453843f36861c0a2).CLOSED)) return [
                                3 /*break*/ ,
                                5
                            ];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            this.socketStatus = (0, $a01acced3fd149b0$export$453843f36861c0a2).CONNECTING;
                            payloadString = "{}";
                            return [
                                4 /*yield*/ ,
                                this._awsRealTimeHeaderBasedAuth({
                                    authenticationType: authenticationType,
                                    payload: payloadString,
                                    canonicalUri: "/connect",
                                    apiKey: apiKey,
                                    appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                    region: region,
                                    additionalHeaders: additionalHeaders
                                })
                            ];
                        case 2:
                            authHeader = _a.sent();
                            headerString = authHeader ? JSON.stringify(authHeader) : "";
                            headerQs = (0, $bff9a911785bcc42$export$a143d493d941bafc).from(headerString).toString("base64");
                            payloadQs = (0, $bff9a911785bcc42$export$a143d493d941bafc).from(payloadString).toString("base64");
                            discoverableEndpoint = appSyncGraphqlEndpoint !== null && appSyncGraphqlEndpoint !== void 0 ? appSyncGraphqlEndpoint : "";
                            if (this.isCustomDomain(discoverableEndpoint)) discoverableEndpoint = discoverableEndpoint.concat($870aa9661b071147$var$customDomainPath);
                            else discoverableEndpoint = discoverableEndpoint.replace("appsync-api", "appsync-realtime-api").replace("gogi-beta", "grt-beta");
                            protocol = this.isSSLEnabled ? "wss://" : "ws://";
                            discoverableEndpoint = discoverableEndpoint.replace("https://", protocol).replace("http://", protocol);
                            awsRealTimeUrl = discoverableEndpoint + "?header=" + headerQs + "&payload=" + payloadQs;
                            return [
                                4 /*yield*/ ,
                                this._initializeRetryableHandshake(awsRealTimeUrl)
                            ];
                        case 3:
                            _a.sent();
                            this.promiseArray.forEach(function(_a) {
                                var res = _a.res;
                                $870aa9661b071147$var$logger.debug("Notifying connection successful");
                                res();
                            });
                            this.socketStatus = (0, $a01acced3fd149b0$export$453843f36861c0a2).READY;
                            this.promiseArray = [];
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_3 = _a.sent();
                            $870aa9661b071147$var$logger.debug("Connection exited with", err_3);
                            this.promiseArray.forEach(function(_a) {
                                var rej = _a.rej;
                                return rej(err_3);
                            });
                            this.promiseArray = [];
                            if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN) this.awsRealTimeSocket.close(3001);
                            this.awsRealTimeSocket = undefined;
                            this.socketStatus = (0, $a01acced3fd149b0$export$453843f36861c0a2).CLOSED;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._initializeRetryableHandshake = function(awsRealTimeUrl) {
        return (0, $ad5e523f9031e630$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ad5e523f9031e630$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $870aa9661b071147$var$logger.debug("Initializaling retryable Handshake");
                        return [
                            4 /*yield*/ ,
                            (0, $e630ff0a3924a99b$export$a24aa7705df9cf44)(this._initializeHandshake.bind(this), [
                                awsRealTimeUrl
                            ], (0, $a01acced3fd149b0$export$76041b1400befb8b))
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._initializeHandshake = function(awsRealTimeUrl) {
        return (0, $ad5e523f9031e630$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var err_4, _a, errorType, errorCode;
            var _this = this;
            return (0, $ad5e523f9031e630$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $870aa9661b071147$var$logger.debug("Initializing handshake " + awsRealTimeUrl);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            function() {
                                return new Promise(function(res, rej) {
                                    var newSocket = _this.getNewWebSocket(awsRealTimeUrl, "graphql-ws");
                                    newSocket.onerror = function() {
                                        $870aa9661b071147$var$logger.debug("WebSocket connection error");
                                    };
                                    newSocket.onclose = function() {
                                        rej(new Error("Connection handshake error"));
                                    };
                                    newSocket.onopen = function() {
                                        _this.awsRealTimeSocket = newSocket;
                                        return res();
                                    };
                                });
                            }()
                        ];
                    case 2:
                        _b.sent();
                        // Step 2: wait for ack from AWS AppSyncReaTime after sending init
                        return [
                            4 /*yield*/ ,
                            function() {
                                return new Promise(function(res, rej) {
                                    if (_this.awsRealTimeSocket) {
                                        var ackOk_1 = false;
                                        _this.awsRealTimeSocket.onerror = function(error) {
                                            $870aa9661b071147$var$logger.debug("WebSocket error " + JSON.stringify(error));
                                        };
                                        _this.awsRealTimeSocket.onclose = function(event) {
                                            $870aa9661b071147$var$logger.debug("WebSocket closed " + event.reason);
                                            rej(new Error(JSON.stringify(event)));
                                        };
                                        _this.awsRealTimeSocket.onmessage = function(message) {
                                            if (typeof message.data !== "string") return;
                                            $870aa9661b071147$var$logger.debug("subscription message from AWS AppSyncRealTime: " + message.data + " ");
                                            var data = JSON.parse(message.data);
                                            var type = data.type, _a = data.payload, _b = (_a === void 0 ? {} : _a).connectionTimeoutMs, connectionTimeoutMs = _b === void 0 ? (0, $a01acced3fd149b0$export$71a299b29e2098f0) : _b;
                                            if (type === (0, $a01acced3fd149b0$export$e5fcfdba4a8ae715).GQL_CONNECTION_ACK) {
                                                ackOk_1 = true;
                                                if (_this.awsRealTimeSocket) {
                                                    _this.keepAliveTimeout = connectionTimeoutMs;
                                                    _this.awsRealTimeSocket.onmessage = _this._handleIncomingSubscriptionMessage.bind(_this);
                                                    _this.awsRealTimeSocket.onerror = function(err) {
                                                        $870aa9661b071147$var$logger.debug(err);
                                                        _this._errorDisconnect((0, $158e47b81d4a4e5d$export$f96baa4bc836aea4).CONNECTION_CLOSED);
                                                    };
                                                    _this.awsRealTimeSocket.onclose = function(event) {
                                                        $870aa9661b071147$var$logger.debug("WebSocket closed " + event.reason);
                                                        _this._errorDisconnect((0, $158e47b81d4a4e5d$export$f96baa4bc836aea4).CONNECTION_CLOSED);
                                                    };
                                                }
                                                res("Cool, connected to AWS AppSyncRealTime");
                                                return;
                                            }
                                            if (type === (0, $a01acced3fd149b0$export$e5fcfdba4a8ae715).GQL_CONNECTION_ERROR) {
                                                var _c = data.payload, _d = (_c === void 0 ? {} : _c).errors, _e = (0, $ad5e523f9031e630$export$8d051b38c9118094)(_d === void 0 ? [] : _d, 1), _f = _e[0], _g = _f === void 0 ? {} : _f, _h = _g.errorType, errorType = _h === void 0 ? "" : _h, _j = _g.errorCode, errorCode = _j === void 0 ? 0 : _j;
                                                rej({
                                                    errorType: errorType,
                                                    errorCode: errorCode
                                                });
                                            }
                                        };
                                        var gqlInit = {
                                            type: (0, $a01acced3fd149b0$export$e5fcfdba4a8ae715).GQL_CONNECTION_INIT
                                        };
                                        _this.awsRealTimeSocket.send(JSON.stringify(gqlInit));
                                        var checkAckOk_1 = function(ackOk) {
                                            if (!ackOk) {
                                                _this.connectionStateMonitor.record((0, $c9dcc04d7253336c$export$77ad93647ea34124).CONNECTION_FAILED);
                                                rej(new Error("Connection timeout: ack from AWSAppSyncRealTime was not received after " + (0, $a01acced3fd149b0$export$c36bbd48cffe7fa4) + " ms"));
                                            }
                                        };
                                        setTimeout(function() {
                                            return checkAckOk_1(ackOk_1);
                                        }, (0, $a01acced3fd149b0$export$c36bbd48cffe7fa4));
                                    }
                                });
                            }()
                        ];
                    case 3:
                        // Step 2: wait for ack from AWS AppSyncReaTime after sending init
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        err_4 = _b.sent();
                        _a = err_4, errorType = _a.errorType, errorCode = _a.errorCode;
                        if ((0, $a01acced3fd149b0$export$d0eacfe8369b1f8e).includes(errorCode)) throw new (0, $e630ff0a3924a99b$export$1e38badc838ad384)(errorType);
                        else if (errorType) throw new Error(errorType);
                        else throw err_4;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeHeaderBasedAuth = function(_a) {
        var authenticationType = _a.authenticationType, payload = _a.payload, canonicalUri = _a.canonicalUri, appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, apiKey = _a.apiKey, region = _a.region, additionalHeaders = _a.additionalHeaders;
        return (0, $ad5e523f9031e630$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var headerHandler, handler, host, result;
            return (0, $ad5e523f9031e630$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        headerHandler = {
                            API_KEY: this._awsRealTimeApiKeyHeader.bind(this),
                            AWS_IAM: this._awsRealTimeIAMHeader.bind(this),
                            OPENID_CONNECT: this._awsRealTimeOPENIDHeader.bind(this),
                            AMAZON_COGNITO_USER_POOLS: this._awsRealTimeCUPHeader.bind(this),
                            AWS_LAMBDA: this._customAuthHeader
                        };
                        if (!(!authenticationType || !headerHandler[authenticationType])) return [
                            3 /*break*/ ,
                            1
                        ];
                        $870aa9661b071147$var$logger.debug("Authentication type " + authenticationType + " not supported");
                        return [
                            2 /*return*/ ,
                            undefined
                        ];
                    case 1:
                        handler = headerHandler[authenticationType];
                        host = $eAyj5.parse(appSyncGraphqlEndpoint !== null && appSyncGraphqlEndpoint !== void 0 ? appSyncGraphqlEndpoint : "").host;
                        $870aa9661b071147$var$logger.debug("Authenticating with " + authenticationType);
                        return [
                            4 /*yield*/ ,
                            handler({
                                payload: payload,
                                canonicalUri: canonicalUri,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                apiKey: apiKey,
                                region: region,
                                host: host,
                                additionalHeaders: additionalHeaders
                            })
                        ];
                    case 2:
                        result = _b.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeCUPHeader = function(_a) {
        var host = _a.host;
        return (0, $ad5e523f9031e630$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var session;
            return (0, $ad5e523f9031e630$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $9e453b5784a8464e$export$334c29725a78c21d).currentSession()
                        ];
                    case 1:
                        session = _b.sent();
                        return [
                            2 /*return*/ ,
                            {
                                Authorization: session.getAccessToken().getJwtToken(),
                                host: host
                            }
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeOPENIDHeader = function(_a) {
        var host = _a.host;
        return (0, $ad5e523f9031e630$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var token, federatedInfo, currentUser;
            return (0, $ad5e523f9031e630$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $476f1cc74cf261fb$export$2a9787695d97e2c4).getItem("federatedInfo")
                        ];
                    case 1:
                        federatedInfo = _b.sent();
                        if (!federatedInfo) return [
                            3 /*break*/ ,
                            2
                        ];
                        token = federatedInfo.token;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            (0, $9e453b5784a8464e$export$334c29725a78c21d).currentAuthenticatedUser()
                        ];
                    case 3:
                        currentUser = _b.sent();
                        if (currentUser) token = currentUser.token;
                        _b.label = 4;
                    case 4:
                        if (!token) throw new Error("No federated jwt");
                        return [
                            2 /*return*/ ,
                            {
                                Authorization: token,
                                host: host
                            }
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeApiKeyHeader = function(_a) {
        var apiKey = _a.apiKey, host = _a.host;
        return (0, $ad5e523f9031e630$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var dt, dtStr;
            return (0, $ad5e523f9031e630$export$67ebef60e6f28a6)(this, function(_b) {
                dt = new Date();
                dtStr = dt.toISOString().replace(/[:\-]|\.\d{3}/g, "");
                return [
                    2 /*return*/ ,
                    {
                        host: host,
                        "x-amz-date": dtStr,
                        "x-api-key": apiKey
                    }
                ];
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeIAMHeader = function(_a) {
        var payload = _a.payload, canonicalUri = _a.canonicalUri, appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, region = _a.region;
        return (0, $ad5e523f9031e630$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var endpointInfo, credentialsOK, creds, request, signed_params;
            return (0, $ad5e523f9031e630$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        endpointInfo = {
                            region: region,
                            service: "appsync"
                        };
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _b.sent();
                        if (!credentialsOK) throw new Error("No credentials");
                        return [
                            4 /*yield*/ ,
                            (0, $44b8a981f31e24b5$export$a9627919734faa48).get().then(function(credentials) {
                                var _a = credentials, secretAccessKey = _a.secretAccessKey, accessKeyId = _a.accessKeyId, sessionToken = _a.sessionToken;
                                return {
                                    secret_key: secretAccessKey,
                                    access_key: accessKeyId,
                                    session_token: sessionToken
                                };
                            })
                        ];
                    case 2:
                        creds = _b.sent();
                        request = {
                            url: "" + appSyncGraphqlEndpoint + canonicalUri,
                            data: payload,
                            method: "POST",
                            headers: (0, $ad5e523f9031e630$export$18ce0697a983be9b)({}, (0, $a01acced3fd149b0$export$7a236fa930e45f72))
                        };
                        signed_params = (0, $14d9a0650c98b5f6$export$fdf54fdde81cc9f0).sign(request, creds, endpointInfo);
                        return [
                            2 /*return*/ ,
                            signed_params.headers
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._customAuthHeader = function(_a) {
        var host = _a.host, additionalHeaders = _a.additionalHeaders;
        if (!additionalHeaders || !additionalHeaders["Authorization"]) throw new Error("No auth token specified");
        return {
            Authorization: additionalHeaders.Authorization,
            host: host
        };
    };
    /**
     * @private
     */ AWSAppSyncRealTimeProvider.prototype._ensureCredentials = function() {
        return (0, $44b8a981f31e24b5$export$a9627919734faa48).get().then(function(credentials) {
            if (!credentials) return false;
            var cred = (0, $44b8a981f31e24b5$export$a9627919734faa48).shear(credentials);
            $870aa9661b071147$var$logger.debug("set credentials for AWSAppSyncRealTimeProvider", cred);
            return true;
        }).catch(function(err) {
            $870aa9661b071147$var$logger.warn("ensure credentials error", err);
            return false;
        });
    };
    return AWSAppSyncRealTimeProvider;
}((0, $df7e75a1ec5157cc$export$38596aa9173af3e4));



var $cefaf5d68a5e6242$var$isNode = (0, $4fe24881fb69f2d5$export$a2708fdb45cd35f)().isNode;
var $cefaf5d68a5e6242$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("PubSub");
var $cefaf5d68a5e6242$export$1a2a683fc95bb86b = /** @class */ function() {
    /**
     * Initialize PubSub with AWS configurations
     *
     * @param {PubSubOptions} options - Configuration object for PubSub
     */ function InternalPubSubClass(options) {
        this._options = options !== null && options !== void 0 ? options : {};
        $cefaf5d68a5e6242$var$logger.debug("PubSub Options", this._options);
        this._pluggables = [];
        this.subscribe = this.subscribe.bind(this);
    }
    Object.defineProperty(InternalPubSubClass.prototype, "awsAppSyncRealTimeProvider", {
        /**
         * Lazy instantiate AWSAppSyncRealTimeProvider when it is required by the API category
         */ get: function() {
            if (!this._awsAppSyncRealTimeProvider) this._awsAppSyncRealTimeProvider = new (0, $870aa9661b071147$export$b7b5e6371992068d)(this._options);
            return this._awsAppSyncRealTimeProvider;
        },
        enumerable: true,
        configurable: true
    });
    InternalPubSubClass.prototype.getModuleName = function() {
        return "InternalPubSub";
    };
    /**
     * Configure PubSub part with configurations
     *
     * @param {PubSubOptions} config - Configuration for PubSub
     * @return {Object} - The current configuration
     */ InternalPubSubClass.prototype.configure = function(options) {
        var _this = this;
        var opt = options ? options.PubSub || options : {};
        $cefaf5d68a5e6242$var$logger.debug("configure PubSub", {
            opt: opt
        });
        this._options = Object.assign({}, this._options, opt);
        this._pluggables.map(function(pluggable) {
            return pluggable.configure(_this._options);
        });
        return this._options;
    };
    /**
     * add plugin into Analytics category
     * @param {Object} pluggable - an instance of the plugin
     */ InternalPubSubClass.prototype.addPluggable = function(pluggable) {
        return (0, $ad5e523f9031e630$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var config;
            return (0, $ad5e523f9031e630$export$67ebef60e6f28a6)(this, function(_a) {
                if (pluggable && pluggable.getCategory() === "PubSub") {
                    this._pluggables.push(pluggable);
                    config = pluggable.configure(this._options);
                    return [
                        2 /*return*/ ,
                        config
                    ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * remove plugin from PubSub category
     * @param providerName - the name of the plugin
     */ InternalPubSubClass.prototype.removePluggable = function(providerName) {
        this._pluggables = this._pluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
    };
    InternalPubSubClass.prototype.getProviderByName = function(providerName) {
        if (providerName === (0, $ed8a415515f52c9d$export$ea26e09ecef8d08d)) return this.awsAppSyncRealTimeProvider;
        return this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
    };
    InternalPubSubClass.prototype.getProviders = function(options) {
        if (options === void 0) options = {};
        var providerName = options.provider;
        if (!providerName) return this._pluggables;
        var provider = this.getProviderByName(providerName);
        if (!provider) throw new Error("Could not find provider named " + String(providerName));
        return [
            provider
        ];
    };
    InternalPubSubClass.prototype.publish = function(topics, msg, options) {
        return (0, $ad5e523f9031e630$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ad5e523f9031e630$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    Promise.all(this.getProviders(options).map(function(provider) {
                        return provider.publish(topics, msg, options);
                    }))
                ];
            });
        });
    };
    InternalPubSubClass.prototype.subscribe = function(topics, options, customUserAgentDetails) {
        if ($cefaf5d68a5e6242$var$isNode && this._options && this._options.ssr) throw new Error("Subscriptions are not supported for Server-Side Rendering (SSR)");
        $cefaf5d68a5e6242$var$logger.debug("subscribe options", options);
        var providers = this.getProviders(options);
        var pubSubUserAgentDetails = (0, $ad5e523f9031e630$export$18ce0697a983be9b)({
            category: (0, $58c96d580693cdce$export$3a8840c5b2ecf003).PubSub,
            action: (0, $58c96d580693cdce$export$ade48b30f1e78672).Subscribe
        }, customUserAgentDetails);
        return new (0, $297ced72d65979d1$export$2e2bcd8739ae039)(function(observer) {
            var observables = providers.map(function(provider) {
                return {
                    provider: provider,
                    observable: provider.subscribe(topics, options, pubSubUserAgentDetails)
                };
            });
            var subscriptions = observables.map(function(_a) {
                var provider = _a.provider, observable = _a.observable;
                return observable.subscribe({
                    start: console.error,
                    next: function(value) {
                        return observer.next({
                            provider: provider,
                            value: value
                        });
                    },
                    error: function(error) {
                        return observer.error({
                            provider: provider,
                            error: error
                        });
                    }
                });
            });
            return function() {
                return subscriptions.forEach(function(subscription) {
                    return subscription.unsubscribe();
                });
            };
        });
    };
    return InternalPubSubClass;
}();
var $cefaf5d68a5e6242$export$4467dc9a3d612d9f = new $cefaf5d68a5e6242$export$1a2a683fc95bb86b();
(0, $6ff5c7c169206e21$export$a3858a9a153cffc7).register($cefaf5d68a5e6242$export$4467dc9a3d612d9f);





var $a72cd86896772ccb$export$b77ee9d1a91b5bd;
(function(GraphQLAuthError) {
    GraphQLAuthError["NO_API_KEY"] = "No api-key configured";
    GraphQLAuthError["NO_CURRENT_USER"] = "No current user";
    GraphQLAuthError["NO_CREDENTIALS"] = "No credentials";
    GraphQLAuthError["NO_FEDERATED_JWT"] = "No federated jwt";
    GraphQLAuthError["NO_AUTH_TOKEN"] = "No auth token specified";
})($a72cd86896772ccb$export$b77ee9d1a91b5bd || ($a72cd86896772ccb$export$b77ee9d1a91b5bd = {}));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $d5b85112adf1a6f7$var$extendStatics = function(d, b) {
    $d5b85112adf1a6f7$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $d5b85112adf1a6f7$var$extendStatics(d, b);
};
function $d5b85112adf1a6f7$export$a8ba968b8961cb8a(d, b) {
    $d5b85112adf1a6f7$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $d5b85112adf1a6f7$export$18ce0697a983be9b = function() {
    $d5b85112adf1a6f7$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d5b85112adf1a6f7$export$18ce0697a983be9b.apply(this, arguments);
};
function $d5b85112adf1a6f7$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d5b85112adf1a6f7$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $d5b85112adf1a6f7$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $d5b85112adf1a6f7$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $d5b85112adf1a6f7$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $d5b85112adf1a6f7$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $d5b85112adf1a6f7$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $d5b85112adf1a6f7$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $d5b85112adf1a6f7$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $d5b85112adf1a6f7$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $d5b85112adf1a6f7$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($d5b85112adf1a6f7$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $d5b85112adf1a6f7$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $d5b85112adf1a6f7$export$10c90e4f7922046c(v) {
    return this instanceof $d5b85112adf1a6f7$export$10c90e4f7922046c ? (this.v = v, this) : new $d5b85112adf1a6f7$export$10c90e4f7922046c(v);
}
function $d5b85112adf1a6f7$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d5b85112adf1a6f7$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $d5b85112adf1a6f7$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d5b85112adf1a6f7$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $d5b85112adf1a6f7$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $d5b85112adf1a6f7$export$19a8beecd37a4c45 === "function" ? $d5b85112adf1a6f7$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $d5b85112adf1a6f7$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $d5b85112adf1a6f7$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $d5b85112adf1a6f7$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $d5b85112adf1a6f7$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $d5b85112adf1a6f7$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



var $316e59de5abf4175$exports = {};

$316e59de5abf4175$exports = (parcelRequire("a2ZiP"));



var $eAyj5 = parcelRequire("eAyj5");
var $9108a3f0753d555f$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("RestClient");
/**
* HTTP Client for REST requests. Send and receive JSON data.
* Sign request with AWS credentials if available
* Usage:
<pre>
const restClient = new RestClient();
restClient.get('...')
    .then(function(data) {
        console.log(data);
    })
    .catch(err => console.log(err));
</pre>
*/ var $9108a3f0753d555f$export$ea8b5b3aea9558ce = /** @class */ function() {
    /**
     * @param {RestClientOptions} [options] - Instance options
     */ function RestClient(options) {
        this._region = "us-east-1"; // this will be updated by endpoint function
        this._service = "execute-api"; // this can be updated by endpoint function
        this._custom_header = undefined; // this can be updated by endpoint function
        /**
         * This weak map provides functionality to let clients cancel
         * in-flight axios requests. https://github.com/axios/axios#cancellation
         *
         * 1. For every axios request, a unique cancel token is generated and added in the request.
         * 2. Promise for fulfilling the request is then mapped to that unique cancel token.
         * 3. The promise is returned to the client.
         * 4. Clients can either wait for the promise to fulfill or call `API.cancel(promise)` to cancel the request.
         * 5. If `API.cancel(promise)` is called, then the corresponding cancel token is retrieved from the map below.
         * 6. Promise returned to the client will be in rejected state with the error provided during cancel.
         * 7. Clients can check if the error is because of cancelling by calling `API.isCancel(error)`.
         *
         * For more details, see https://github.com/aws-amplify/amplify-js/pull/3769#issuecomment-552660025
         */ this._cancelTokenMap = null;
        this.Credentials = (0, $44b8a981f31e24b5$export$a9627919734faa48);
        this._options = options;
        $9108a3f0753d555f$var$logger.debug("API Options", this._options);
        if (this._cancelTokenMap == null) this._cancelTokenMap = new WeakMap();
    }
    /**
    * Update AWS credentials
    * @param {AWSCredentials} credentials - AWS credentials
    *
    updateCredentials(credentials: AWSCredentials) {
        this.options.credentials = credentials;
    }
*/ /**
     * Basic HTTP request. Customizable
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {string} method - Request HTTP method
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.ajax = function(urlOrApiInfo, method, init) {
        return (0, $d5b85112adf1a6f7$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var parsed_url, url, region, service, custom_header, params, libraryHeaders, initParams, isAllResponse, custom_header_obj, _a, _b, search, parsedUrl, credentials, error_1, signedParams, response, error_2, headers, dateHeader, responseDate, requestDate;
            return (0, $d5b85112adf1a6f7$export$67ebef60e6f28a6)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $9108a3f0753d555f$var$logger.debug(method, urlOrApiInfo);
                        region = "us-east-1";
                        service = "execute-api";
                        custom_header = undefined;
                        if (typeof urlOrApiInfo === "string") {
                            parsed_url = this._parseUrl(urlOrApiInfo);
                            url = urlOrApiInfo;
                        } else {
                            url = urlOrApiInfo.endpoint, custom_header = urlOrApiInfo.custom_header, region = urlOrApiInfo.region, service = urlOrApiInfo.service;
                            parsed_url = this._parseUrl(urlOrApiInfo.endpoint);
                        }
                        params = {
                            method: method,
                            url: url,
                            host: parsed_url.host,
                            path: parsed_url.path,
                            headers: {},
                            data: null,
                            responseType: "json",
                            timeout: 0,
                            cancelToken: null
                        };
                        libraryHeaders = {};
                        initParams = Object.assign({}, init);
                        isAllResponse = initParams.response;
                        if (initParams.body) {
                            if (typeof FormData === "function" && initParams.body instanceof FormData) {
                                libraryHeaders["Content-Type"] = "multipart/form-data";
                                params.data = initParams.body;
                            } else {
                                libraryHeaders["Content-Type"] = "application/json; charset=UTF-8";
                                params.data = JSON.stringify(initParams.body);
                            }
                        }
                        if (initParams.responseType) params.responseType = initParams.responseType;
                        if (initParams.withCredentials) params["withCredentials"] = initParams.withCredentials;
                        if (initParams.timeout) params.timeout = initParams.timeout;
                        if (initParams.cancellableToken) params.cancelToken = initParams.cancellableToken.token;
                        params["signerServiceInfo"] = initParams.signerServiceInfo;
                        if (!(typeof custom_header === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            custom_header()
                        ];
                    case 1:
                        _a = _c.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = undefined;
                        _c.label = 3;
                    case 3:
                        custom_header_obj = _a;
                        params.headers = (0, $d5b85112adf1a6f7$export$18ce0697a983be9b)((0, $d5b85112adf1a6f7$export$18ce0697a983be9b)((0, $d5b85112adf1a6f7$export$18ce0697a983be9b)({}, libraryHeaders), custom_header_obj), initParams.headers);
                        _b = (0, $eAyj5.parse)(url, true, true), search = _b.search, parsedUrl = (0, $d5b85112adf1a6f7$export$3c9a16f847548506)(_b, [
                            "search"
                        ]);
                        params.url = (0, $eAyj5.format)((0, $d5b85112adf1a6f7$export$18ce0697a983be9b)((0, $d5b85112adf1a6f7$export$18ce0697a983be9b)({}, parsedUrl), {
                            query: (0, $d5b85112adf1a6f7$export$18ce0697a983be9b)((0, $d5b85112adf1a6f7$export$18ce0697a983be9b)({}, parsedUrl.query), initParams.queryStringParameters || {})
                        }));
                        // Do not sign the request if client has added 'Authorization' header,
                        // which means custom authorizer.
                        if (typeof params.headers["Authorization"] !== "undefined") {
                            params.headers = Object.keys(params.headers).reduce(function(acc, k) {
                                if (params.headers[k]) acc[k] = params.headers[k];
                                return acc;
                            // tslint:disable-next-line:align
                            }, {});
                            return [
                                2 /*return*/ ,
                                this._request(params, isAllResponse)
                            ];
                        }
                        _c.label = 4;
                    case 4:
                        _c.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.Credentials.get()
                        ];
                    case 5:
                        credentials = _c.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        error_1 = _c.sent();
                        $9108a3f0753d555f$var$logger.debug("No credentials available, the request will be unsigned");
                        return [
                            2 /*return*/ ,
                            this._request(params, isAllResponse)
                        ];
                    case 7:
                        _c.trys.push([
                            7,
                            9,
                            ,
                            10
                        ]);
                        signedParams = this._sign((0, $d5b85112adf1a6f7$export$18ce0697a983be9b)({}, params), credentials, {
                            region: region,
                            service: service
                        });
                        return [
                            4 /*yield*/ ,
                            (0, (/*@__PURE__*/$parcel$interopDefault($316e59de5abf4175$exports)))(signedParams)
                        ];
                    case 8:
                        response = _c.sent();
                        return [
                            2 /*return*/ ,
                            isAllResponse ? response : response.data
                        ];
                    case 9:
                        error_2 = _c.sent();
                        $9108a3f0753d555f$var$logger.debug(error_2);
                        if ((0, $51eccc75455b5d7a$export$3e048df13f4eb60b).isClockSkewError(error_2)) {
                            headers = error_2.response.headers;
                            dateHeader = headers && (headers.date || headers.Date);
                            responseDate = new Date(dateHeader);
                            requestDate = (0, $51eccc75455b5d7a$export$3e048df13f4eb60b).getDateFromHeaderString(signedParams.headers["x-amz-date"]);
                            // Compare local clock to the server clock
                            if ((0, $51eccc75455b5d7a$export$3e048df13f4eb60b).isClockSkewed(responseDate)) {
                                (0, $51eccc75455b5d7a$export$3e048df13f4eb60b).setClockOffset(responseDate.getTime() - requestDate.getTime());
                                return [
                                    2 /*return*/ ,
                                    this.ajax(urlOrApiInfo, method, init)
                                ];
                            }
                        }
                        throw error_2;
                    case 10:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * GET HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {JSON} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.get = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, "GET", init);
    };
    /**
     * PUT HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.put = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, "PUT", init);
    };
    /**
     * PATCH HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.patch = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, "PATCH", init);
    };
    /**
     * POST HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.post = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, "POST", init);
    };
    /**
     * DELETE HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.del = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, "DELETE", init);
    };
    /**
     * HEAD HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.head = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, "HEAD", init);
    };
    /**
     * Cancel an inflight API request
     * @param {Promise<any>} request - The request promise to cancel
     * @param {string} [message] - A message to include in the cancelation exception
     */ RestClient.prototype.cancel = function(request, message) {
        var source = this._cancelTokenMap.get(request);
        if (source) {
            source.cancel(message);
            return true;
        }
        return false;
    };
    /**
     * Check if the request has a corresponding cancel token in the WeakMap.
     * @params request - The request promise
     * @return if the request has a corresponding cancel token.
     */ RestClient.prototype.hasCancelToken = function(request) {
        return this._cancelTokenMap.has(request);
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param {any} error - Any error
     * @return {boolean} - A boolean indicating if the error was from an api request cancellation
     */ RestClient.prototype.isCancel = function(error) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($316e59de5abf4175$exports))).isCancel(error);
    };
    /**
     * Retrieves a new and unique cancel token which can be
     * provided in an axios request to be cancelled later.
     */ RestClient.prototype.getCancellableToken = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($316e59de5abf4175$exports))).CancelToken.source();
    };
    /**
     * Updates the weakmap with a response promise and its
     * cancel token such that the cancel token can be easily
     * retrieved (and used for cancelling the request)
     */ RestClient.prototype.updateRequestToBeCancellable = function(promise, cancelTokenSource) {
        this._cancelTokenMap.set(promise, cancelTokenSource);
    };
    /**
     * Getting endpoint for API
     * @param {string} apiName - The name of the api
     * @return {string} - The endpoint of the api
     */ RestClient.prototype.endpoint = function(apiName) {
        var _this = this;
        var cloud_logic_array = this._options.endpoints;
        var response = "";
        if (!Array.isArray(cloud_logic_array)) return response;
        cloud_logic_array.forEach(function(v) {
            if (v.name === apiName) {
                response = v.endpoint;
                if (typeof v.region === "string") _this._region = v.region;
                else if (typeof _this._options.region === "string") _this._region = _this._options.region;
                if (typeof v.service === "string") _this._service = v.service || "execute-api";
                else _this._service = "execute-api";
                if (typeof v.custom_header === "function") _this._custom_header = v.custom_header;
                else _this._custom_header = undefined;
            }
        });
        return response;
    };
    /** private methods **/ RestClient.prototype._sign = function(params, credentials, _a) {
        var service = _a.service, region = _a.region;
        var signerServiceInfoParams = params.signerServiceInfo, otherParams = (0, $d5b85112adf1a6f7$export$3c9a16f847548506)(params, [
            "signerServiceInfo"
        ]);
        var endpoint_region = region || this._region || this._options.region;
        var endpoint_service = service || this._service || this._options.service;
        var creds = {
            secret_key: credentials.secretAccessKey,
            access_key: credentials.accessKeyId,
            session_token: credentials.sessionToken
        };
        var endpointInfo = {
            region: endpoint_region,
            service: endpoint_service
        };
        var signerServiceInfo = Object.assign(endpointInfo, signerServiceInfoParams);
        var signed_params = (0, $14d9a0650c98b5f6$export$fdf54fdde81cc9f0).sign(otherParams, creds, signerServiceInfo);
        if (signed_params.data) signed_params.body = signed_params.data;
        $9108a3f0753d555f$var$logger.debug("Signed Request: ", signed_params);
        delete signed_params.headers["host"];
        return signed_params;
    };
    RestClient.prototype._request = function(params, isAllResponse) {
        if (isAllResponse === void 0) isAllResponse = false;
        return (0, (/*@__PURE__*/$parcel$interopDefault($316e59de5abf4175$exports)))(params).then(function(response) {
            return isAllResponse ? response : response.data;
        }).catch(function(error) {
            $9108a3f0753d555f$var$logger.debug(error);
            throw error;
        });
    };
    RestClient.prototype._parseUrl = function(url) {
        var parts = url.split("/");
        return {
            host: parts[2],
            path: "/" + parts.slice(3).join("/")
        };
    };
    return RestClient;
}();


var $cc07bc70b7cb104a$var$USER_AGENT_HEADER = "x-amz-user-agent";
var $cc07bc70b7cb104a$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("GraphQLAPI");
var $cc07bc70b7cb104a$export$78930a3b816845f9 = function(query, variables, authToken) {
    if (variables === void 0) variables = {};
    return {
        query: query,
        variables: variables,
        authToken: authToken
    };
};
/**
 * Export Cloud Logic APIs
 */ var $cc07bc70b7cb104a$export$c3e852ee609522ad = /** @class */ function() {
    /**
     * Initialize GraphQL API with AWS configuration
     * @param {Object} options - Configuration object for API
     */ function InternalGraphQLAPIClass(options) {
        this._api = null;
        this.Auth = (0, $9e453b5784a8464e$export$334c29725a78c21d);
        this.Cache = (0, $476f1cc74cf261fb$export$2a9787695d97e2c4);
        this.Credentials = (0, $44b8a981f31e24b5$export$a9627919734faa48);
        this._options = options;
        $cc07bc70b7cb104a$var$logger.debug("API Options", this._options);
    }
    InternalGraphQLAPIClass.prototype.getModuleName = function() {
        return "InternalGraphQLAPI";
    };
    /**
     * Configure API
     * @param {Object} config - Configuration of the API
     * @return {Object} - The current configuration
     */ InternalGraphQLAPIClass.prototype.configure = function(options) {
        var _a = options || {}, _b = _a.API, API = _b === void 0 ? {} : _b, otherOptions = (0, $7d95c07d19eb445d$export$3c9a16f847548506)(_a, [
            "API"
        ]);
        var opt = (0, $7d95c07d19eb445d$export$18ce0697a983be9b)((0, $7d95c07d19eb445d$export$18ce0697a983be9b)({}, otherOptions), API);
        $cc07bc70b7cb104a$var$logger.debug("configure GraphQL API", {
            opt: opt
        });
        if (opt["aws_project_region"]) opt = Object.assign({}, opt, {
            region: opt["aws_project_region"],
            header: {}
        });
        if (typeof opt.graphql_headers !== "undefined" && typeof opt.graphql_headers !== "function") {
            $cc07bc70b7cb104a$var$logger.warn("graphql_headers should be a function");
            opt.graphql_headers = undefined;
        }
        this._options = Object.assign({}, this._options, opt);
        this.createInstance();
        return this._options;
    };
    /**
     * Create an instance of API for the library
     * @return - A promise of true if Success
     */ InternalGraphQLAPIClass.prototype.createInstance = function() {
        $cc07bc70b7cb104a$var$logger.debug("create Rest instance");
        if (this._options) {
            this._api = new (0, $9108a3f0753d555f$export$ea8b5b3aea9558ce)(this._options);
            // Share instance Credentials with client for SSR
            this._api.Credentials = this.Credentials;
            return true;
        } else return Promise.reject("API not configured");
    };
    InternalGraphQLAPIClass.prototype._headerBasedAuth = function(defaultAuthenticationType, additionalHeaders) {
        if (additionalHeaders === void 0) additionalHeaders = {};
        return (0, $7d95c07d19eb445d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a, aws_appsync_authenticationType, apiKey, authenticationType, headers, _b, credentialsOK, token, federatedInfo, currentUser, e_1, session, e_2;
            return (0, $7d95c07d19eb445d$export$67ebef60e6f28a6)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = this._options, aws_appsync_authenticationType = _a.aws_appsync_authenticationType, apiKey = _a.aws_appsync_apiKey;
                        authenticationType = defaultAuthenticationType || aws_appsync_authenticationType || "AWS_IAM";
                        headers = {};
                        _b = authenticationType;
                        switch(_b){
                            case "API_KEY":
                                return [
                                    3 /*break*/ ,
                                    1
                                ];
                            case "AWS_IAM":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case "OPENID_CONNECT":
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case "AMAZON_COGNITO_USER_POOLS":
                                return [
                                    3 /*break*/ ,
                                    11
                                ];
                            case "AWS_LAMBDA":
                                return [
                                    3 /*break*/ ,
                                    15
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 1:
                        if (!apiKey) throw new Error((0, $a72cd86896772ccb$export$b77ee9d1a91b5bd).NO_API_KEY);
                        headers = {
                            Authorization: null,
                            "X-Api-Key": apiKey
                        };
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 3:
                        credentialsOK = _c.sent();
                        if (!credentialsOK) throw new Error((0, $a72cd86896772ccb$export$b77ee9d1a91b5bd).NO_CREDENTIALS);
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 4:
                        _c.trys.push([
                            4,
                            9,
                            ,
                            10
                        ]);
                        token = void 0;
                        return [
                            4 /*yield*/ ,
                            (0, $476f1cc74cf261fb$export$2a9787695d97e2c4).getItem("federatedInfo")
                        ];
                    case 5:
                        federatedInfo = _c.sent();
                        if (!federatedInfo) return [
                            3 /*break*/ ,
                            6
                        ];
                        token = federatedInfo.token;
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            (0, $9e453b5784a8464e$export$334c29725a78c21d).currentAuthenticatedUser()
                        ];
                    case 7:
                        currentUser = _c.sent();
                        if (currentUser) token = currentUser.token;
                        _c.label = 8;
                    case 8:
                        if (!token) throw new Error((0, $a72cd86896772ccb$export$b77ee9d1a91b5bd).NO_FEDERATED_JWT);
                        headers = {
                            Authorization: token
                        };
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        e_1 = _c.sent();
                        throw new Error((0, $a72cd86896772ccb$export$b77ee9d1a91b5bd).NO_CURRENT_USER);
                    case 10:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 11:
                        _c.trys.push([
                            11,
                            13,
                            ,
                            14
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.Auth.currentSession()
                        ];
                    case 12:
                        session = _c.sent();
                        headers = {
                            Authorization: session.getAccessToken().getJwtToken()
                        };
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 13:
                        e_2 = _c.sent();
                        throw new Error((0, $a72cd86896772ccb$export$b77ee9d1a91b5bd).NO_CURRENT_USER);
                    case 14:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 15:
                        if (!additionalHeaders.Authorization) throw new Error((0, $a72cd86896772ccb$export$b77ee9d1a91b5bd).NO_AUTH_TOKEN);
                        headers = {
                            Authorization: additionalHeaders.Authorization
                        };
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 16:
                        headers = {
                            Authorization: null
                        };
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 17:
                        return [
                            2 /*return*/ ,
                            headers
                        ];
                }
            });
        });
    };
    /**
     * to get the operation type
     * @param operation
     */ InternalGraphQLAPIClass.prototype.getGraphqlOperationType = function(operation) {
        var doc = (0, $9bdfafd0ada79eb4$export$98e6a39c04603d36)(operation);
        var definitions = doc.definitions;
        var _a = (0, $7d95c07d19eb445d$export$8d051b38c9118094)(definitions, 1), operationType = _a[0].operation;
        return operationType;
    };
    /**
     * Executes a GraphQL operation
     *
     * @param options - GraphQL Options
     * @param [additionalHeaders] - headers to merge in after any `graphql_headers` set in the config
     * @returns An Observable if the query is a subscription query, else a promise of the graphql result.
     */ InternalGraphQLAPIClass.prototype.graphql = function(_a, additionalHeaders, customUserAgentDetails) {
        var paramQuery = _a.query, _b = _a.variables, variables = _b === void 0 ? {} : _b, authMode = _a.authMode, authToken = _a.authToken;
        var query = typeof paramQuery === "string" ? (0, $9bdfafd0ada79eb4$export$98e6a39c04603d36)(paramQuery) : (0, $9bdfafd0ada79eb4$export$98e6a39c04603d36)((0, $721fc34398b6420b$export$c2d084dc44961371)(paramQuery));
        var _c = (0, $7d95c07d19eb445d$export$8d051b38c9118094)(query.definitions.filter(function(def) {
            return def.kind === "OperationDefinition";
        }), 1), _d = _c[0], operationDef = _d === void 0 ? {} : _d;
        var operationType = operationDef.operation;
        var headers = additionalHeaders || {};
        // if an authorization header is set, have the explicit authToken take precedence
        if (authToken) headers.Authorization = authToken;
        switch(operationType){
            case "query":
            case "mutation":
                this.createInstanceIfNotCreated();
                var cancellableToken = this._api.getCancellableToken();
                var initParams = {
                    cancellableToken: cancellableToken,
                    withCredentials: this._options.withCredentials
                };
                var responsePromise = this._graphql({
                    query: query,
                    variables: variables,
                    authMode: authMode
                }, headers, initParams, customUserAgentDetails);
                this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
                return responsePromise;
            case "subscription":
                return this._graphqlSubscribe({
                    query: query,
                    variables: variables,
                    authMode: authMode
                }, headers, customUserAgentDetails);
            default:
                throw new Error("invalid operation type: " + operationType);
        }
    };
    InternalGraphQLAPIClass.prototype._graphql = function(_a, additionalHeaders, initParams, customUserAgentDetails) {
        var query = _a.query, variables = _a.variables, authMode = _a.authMode;
        if (additionalHeaders === void 0) additionalHeaders = {};
        if (initParams === void 0) initParams = {};
        return (0, $7d95c07d19eb445d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _b, region, appSyncGraphqlEndpoint, _c, graphql_headers, customGraphqlEndpoint, customEndpointRegion, headers, _d, _e, _f, _g, _h, _j, body, init, endpoint, error, response, err_1, errors;
            var _k;
            return (0, $7d95c07d19eb445d$export$67ebef60e6f28a6)(this, function(_l) {
                switch(_l.label){
                    case 0:
                        this.createInstanceIfNotCreated();
                        _b = this._options, region = _b.aws_appsync_region, appSyncGraphqlEndpoint = _b.aws_appsync_graphqlEndpoint, _c = _b.graphql_headers, graphql_headers = _c === void 0 ? function() {
                            return {};
                        } : _c, customGraphqlEndpoint = _b.graphql_endpoint, customEndpointRegion = _b.graphql_endpoint_iam_region;
                        _d = [
                            {}
                        ];
                        _e = !customGraphqlEndpoint;
                        if (!_e) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._headerBasedAuth(authMode, additionalHeaders)
                        ];
                    case 1:
                        _e = _l.sent();
                        _l.label = 2;
                    case 2:
                        _f = [
                            (0, $7d95c07d19eb445d$export$18ce0697a983be9b).apply(void 0, _d.concat([
                                _e
                            ]))
                        ];
                        _g = customGraphqlEndpoint;
                        if (!_g) return [
                            3 /*break*/ ,
                            6
                        ];
                        if (!customEndpointRegion) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this._headerBasedAuth(authMode, additionalHeaders)
                        ];
                    case 3:
                        _h = _l.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        _h = {
                            Authorization: null
                        };
                        _l.label = 5;
                    case 5:
                        _g = _h;
                        _l.label = 6;
                    case 6:
                        _j = [
                            (0, $7d95c07d19eb445d$export$18ce0697a983be9b).apply(void 0, _f.concat([
                                _g
                            ]))
                        ];
                        return [
                            4 /*yield*/ ,
                            graphql_headers({
                                query: query,
                                variables: variables
                            })
                        ];
                    case 7:
                        headers = (0, $7d95c07d19eb445d$export$18ce0697a983be9b).apply(void 0, [
                            (0, $7d95c07d19eb445d$export$18ce0697a983be9b).apply(void 0, [
                                (0, $7d95c07d19eb445d$export$18ce0697a983be9b).apply(void 0, _j.concat([
                                    _l.sent()
                                ])),
                                additionalHeaders
                            ]),
                            !customGraphqlEndpoint && (_k = {}, _k[$cc07bc70b7cb104a$var$USER_AGENT_HEADER] = (0, $0d25e50bf44b1a9b$export$ede38edb26c0bfdf)(customUserAgentDetails), _k)
                        ]);
                        body = {
                            query: (0, $721fc34398b6420b$export$c2d084dc44961371)(query),
                            variables: variables
                        };
                        init = Object.assign({
                            headers: headers,
                            body: body,
                            signerServiceInfo: {
                                service: !customGraphqlEndpoint ? "appsync" : "execute-api",
                                region: !customGraphqlEndpoint ? region : customEndpointRegion
                            }
                        }, initParams);
                        endpoint = customGraphqlEndpoint || appSyncGraphqlEndpoint;
                        if (!endpoint) {
                            error = new (0, $b81b6b4578512de6$export$92d6ed0888e7cb7f)("No graphql endpoint provided.");
                            throw {
                                data: {},
                                errors: [
                                    error
                                ]
                            };
                        }
                        _l.label = 8;
                    case 8:
                        _l.trys.push([
                            8,
                            10,
                            ,
                            11
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._api.post(endpoint, init)
                        ];
                    case 9:
                        response = _l.sent();
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        err_1 = _l.sent();
                        // If the exception is because user intentionally
                        // cancelled the request, do not modify the exception
                        // so that clients can identify the exception correctly.
                        if (this._api.isCancel(err_1)) throw err_1;
                        response = {
                            data: {},
                            errors: [
                                new (0, $b81b6b4578512de6$export$92d6ed0888e7cb7f)(err_1.message, null, null, null, null, err_1)
                            ]
                        };
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 11:
                        errors = response.errors;
                        if (errors && errors.length) throw response;
                        return [
                            2 /*return*/ ,
                            response
                        ];
                }
            });
        });
    };
    InternalGraphQLAPIClass.prototype.createInstanceIfNotCreated = function() {
        return (0, $7d95c07d19eb445d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $7d95c07d19eb445d$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this._api) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.createInstance()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param {any} error - Any error
     * @return {boolean} - A boolean indicating if the error was from an api request cancellation
     */ InternalGraphQLAPIClass.prototype.isCancel = function(error) {
        return this._api.isCancel(error);
    };
    /**
     * Cancels an inflight request. Only applicable for graphql queries and mutations
     * @param {any} request - request to cancel
     * @return {boolean} - A boolean indicating if the request was cancelled
     */ InternalGraphQLAPIClass.prototype.cancel = function(request, message) {
        return this._api.cancel(request, message);
    };
    /**
     * Check if the request has a corresponding cancel token in the WeakMap.
     * @params request - The request promise
     * @return if the request has a corresponding cancel token.
     */ InternalGraphQLAPIClass.prototype.hasCancelToken = function(request) {
        return this._api.hasCancelToken(request);
    };
    InternalGraphQLAPIClass.prototype._graphqlSubscribe = function(_a, additionalHeaders, customUserAgentDetails) {
        var query = _a.query, variables = _a.variables, defaultAuthenticationType = _a.authMode, authToken = _a.authToken;
        if (additionalHeaders === void 0) additionalHeaders = {};
        var _b = this._options, region = _b.aws_appsync_region, appSyncGraphqlEndpoint = _b.aws_appsync_graphqlEndpoint, aws_appsync_authenticationType = _b.aws_appsync_authenticationType, apiKey = _b.aws_appsync_apiKey, _c = _b.graphql_headers, graphql_headers = _c === void 0 ? function() {
            return {};
        } : _c;
        var authenticationType = defaultAuthenticationType || aws_appsync_authenticationType || "AWS_IAM";
        if ((0, $cefaf5d68a5e6242$export$4467dc9a3d612d9f) && typeof (0, $cefaf5d68a5e6242$export$4467dc9a3d612d9f).subscribe === "function") return (0, $cefaf5d68a5e6242$export$4467dc9a3d612d9f).subscribe("", {
            provider: (0, $ed8a415515f52c9d$export$ea26e09ecef8d08d),
            appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
            authenticationType: authenticationType,
            apiKey: apiKey,
            query: (0, $721fc34398b6420b$export$c2d084dc44961371)(query),
            region: region,
            variables: variables,
            graphql_headers: graphql_headers,
            additionalHeaders: additionalHeaders,
            authToken: authToken
        }, customUserAgentDetails);
        else {
            $cc07bc70b7cb104a$var$logger.debug("No pubsub module applied for subscription");
            throw new Error("No pubsub module applied for subscription");
        }
    };
    /**
     * @private
     */ InternalGraphQLAPIClass.prototype._ensureCredentials = function() {
        var _this = this;
        return this.Credentials.get().then(function(credentials) {
            if (!credentials) return false;
            var cred = _this.Credentials.shear(credentials);
            $cc07bc70b7cb104a$var$logger.debug("set credentials for api", cred);
            return true;
        }).catch(function(err) {
            $cc07bc70b7cb104a$var$logger.warn("ensure credentials error", err);
            return false;
        });
    };
    return InternalGraphQLAPIClass;
}();
var $cc07bc70b7cb104a$export$ed344e8d198d4142 = new $cc07bc70b7cb104a$export$c3e852ee609522ad(null);
(0, $6ff5c7c169206e21$export$a3858a9a153cffc7).register($cc07bc70b7cb104a$export$ed344e8d198d4142);





var $58ed9dc8932b2d5c$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("RestAPI");
/**
 * Export Cloud Logic APIs
 */ var $58ed9dc8932b2d5c$export$dcf8f1a1141f2be6 = /** @class */ function() {
    /**
     * Initialize Rest API with AWS configuration
     * @param {Object} options - Configuration object for API
     */ function RestAPIClass(options) {
        this._api = null;
        this.Credentials = (0, $44b8a981f31e24b5$export$a9627919734faa48);
        this._options = options;
        $58ed9dc8932b2d5c$var$logger.debug("API Options", this._options);
    }
    RestAPIClass.prototype.getModuleName = function() {
        return "RestAPI";
    };
    /**
     * Configure API part with aws configurations
     * @param {Object} config - Configuration of the API
     * @return {Object} - The current configuration
     */ RestAPIClass.prototype.configure = function(options) {
        var _a = options || {}, _b = _a.API, API = _b === void 0 ? {} : _b, otherOptions = (0, $d5b85112adf1a6f7$export$3c9a16f847548506)(_a, [
            "API"
        ]);
        var opt = (0, $d5b85112adf1a6f7$export$18ce0697a983be9b)((0, $d5b85112adf1a6f7$export$18ce0697a983be9b)({}, otherOptions), API);
        $58ed9dc8932b2d5c$var$logger.debug("configure Rest API", {
            opt: opt
        });
        if (opt["aws_project_region"]) {
            if (opt["aws_cloud_logic_custom"]) {
                var custom = opt["aws_cloud_logic_custom"];
                opt.endpoints = typeof custom === "string" ? JSON.parse(custom) : custom;
            }
            opt = Object.assign({}, opt, {
                region: opt["aws_project_region"],
                header: {}
            });
        }
        if (Array.isArray(opt.endpoints)) // Check if endpoints has custom_headers and validate if is a function
        opt.endpoints.forEach(function(endpoint) {
            if (typeof endpoint.custom_header !== "undefined" && typeof endpoint.custom_header !== "function") {
                $58ed9dc8932b2d5c$var$logger.warn("Rest API " + endpoint.name + ", custom_header should be a function");
                endpoint.custom_header = undefined;
            }
        });
        else if (this._options && Array.isArray(this._options.endpoints)) opt.endpoints = this._options.endpoints;
        else opt.endpoints = [];
        this._options = Object.assign({}, this._options, opt);
        this.createInstance();
        return this._options;
    };
    /**
     * Create an instance of API for the library
     * @return - A promise of true if Success
     */ RestAPIClass.prototype.createInstance = function() {
        $58ed9dc8932b2d5c$var$logger.debug("create Rest API instance");
        this._api = new (0, $9108a3f0753d555f$export$ea8b5b3aea9558ce)(this._options);
        // Share Amplify instance with client for SSR
        this._api.Credentials = this.Credentials;
        return true;
    };
    /**
     * Make a GET request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.get = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.get(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a POST request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.post = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.post(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a PUT request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.put = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.put(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a PATCH request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.patch = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.patch(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a DEL request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.del = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.del(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a HEAD request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.head = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.head(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param {any} error - Any error
     * @return {boolean} - A boolean indicating if the error was from an api request cancellation
     */ RestAPIClass.prototype.isCancel = function(error) {
        return this._api.isCancel(error);
    };
    /**
     * Cancels an inflight request
     * @param {any} request - request to cancel
     * @return {boolean} - A boolean indicating if the request was cancelled
     */ RestAPIClass.prototype.cancel = function(request, message) {
        return this._api.cancel(request, message);
    };
    /**
     * Check if the request has a corresponding cancel token in the WeakMap.
     * @params request - The request promise
     * @return if the request has a corresponding cancel token.
     */ RestAPIClass.prototype.hasCancelToken = function(request) {
        return this._api.hasCancelToken(request);
    };
    /**
     * Getting endpoint for API
     * @param {string} apiName - The name of the api
     * @return {string} - The endpoint of the api
     */ RestAPIClass.prototype.endpoint = function(apiName) {
        return (0, $d5b85112adf1a6f7$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $d5b85112adf1a6f7$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._api.endpoint(apiName)
                ];
            });
        });
    };
    /**
     * Getting endpoint info for API
     * @param {string} apiName - The name of the api
     * @param {string} path - The path of the api that is going to accessed
     * @return {ApiInfo} - The endpoint information for that api-name
     */ RestAPIClass.prototype.getEndpointInfo = function(apiName, path) {
        var cloud_logic_array = this._options.endpoints;
        if (!Array.isArray(cloud_logic_array)) throw new Error("API category not configured");
        var apiConfig = cloud_logic_array.find(function(api) {
            return api.name === apiName;
        });
        if (!apiConfig) throw new Error("API " + apiName + " does not exist");
        var response = {
            endpoint: apiConfig.endpoint + path
        };
        if (typeof apiConfig.region === "string") response.region = apiConfig.region;
        else if (typeof this._options.region === "string") response.region = this._options.region;
        if (typeof apiConfig.service === "string") response.service = apiConfig.service || "execute-api";
        else response.service = "execute-api";
        if (typeof apiConfig.custom_header === "function") response.custom_header = apiConfig.custom_header;
        else response.custom_header = undefined;
        return response;
    };
    return RestAPIClass;
}();
var $58ed9dc8932b2d5c$export$45f9ca334065d2ff = new $58ed9dc8932b2d5c$export$dcf8f1a1141f2be6(null);
(0, $6ff5c7c169206e21$export$a3858a9a153cffc7).register($58ed9dc8932b2d5c$export$45f9ca334065d2ff);





var $4f84b192b2273b2c$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("API");
/**
 * @deprecated
 * Use RestApi or GraphQLAPI to reduce your application bundle size
 * Export Cloud Logic APIs
 */ var $4f84b192b2273b2c$export$5158c6990c07fc65 = /** @class */ function() {
    /**
     * Initialize API with AWS configuration
     * @param {Object} options - Configuration object for API
     */ function InternalAPIClass(options) {
        this.Auth = (0, $9e453b5784a8464e$export$334c29725a78c21d);
        this.Cache = (0, $476f1cc74cf261fb$export$2a9787695d97e2c4);
        this.Credentials = (0, $44b8a981f31e24b5$export$a9627919734faa48);
        this._options = options;
        this._restApi = new (0, $58ed9dc8932b2d5c$export$dcf8f1a1141f2be6)(options);
        this._graphqlApi = new (0, $cc07bc70b7cb104a$export$c3e852ee609522ad)(options);
        $4f84b192b2273b2c$var$logger.debug("API Options", this._options);
    }
    InternalAPIClass.prototype.getModuleName = function() {
        return "InternalAPI";
    };
    /**
     * Configure API part with aws configurations
     * @param {Object} config - Configuration of the API
     * @return {Object} - The current configuration
     */ InternalAPIClass.prototype.configure = function(options) {
        this._options = Object.assign({}, this._options, options);
        // Share Amplify instance with client for SSR
        this._restApi.Credentials = this.Credentials;
        this._graphqlApi.Auth = this.Auth;
        this._graphqlApi.Cache = this.Cache;
        this._graphqlApi.Credentials = this.Credentials;
        var restAPIConfig = this._restApi.configure(this._options);
        var graphQLAPIConfig = this._graphqlApi.configure(this._options);
        return (0, $033c8ca1c8420c0b$export$18ce0697a983be9b)((0, $033c8ca1c8420c0b$export$18ce0697a983be9b)({}, restAPIConfig), graphQLAPIConfig);
    };
    /**
     * Make a GET request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.get = function(apiName, path, init) {
        return this._restApi.get(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, $58c96d580693cdce$export$126e20fdc0f0d34b).Get));
    };
    /**
     * Make a POST request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.post = function(apiName, path, init) {
        return this._restApi.post(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, $58c96d580693cdce$export$126e20fdc0f0d34b).Post));
    };
    /**
     * Make a PUT request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.put = function(apiName, path, init) {
        return this._restApi.put(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, $58c96d580693cdce$export$126e20fdc0f0d34b).Put));
    };
    /**
     * Make a PATCH request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.patch = function(apiName, path, init) {
        return this._restApi.patch(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, $58c96d580693cdce$export$126e20fdc0f0d34b).Patch));
    };
    /**
     * Make a DEL request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.del = function(apiName, path, init) {
        return this._restApi.del(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, $58c96d580693cdce$export$126e20fdc0f0d34b).Del));
    };
    /**
     * Make a HEAD request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.head = function(apiName, path, init) {
        return this._restApi.head(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, $58c96d580693cdce$export$126e20fdc0f0d34b).Head));
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param error - Any error
     * @return If the error was from an api request cancellation
     */ InternalAPIClass.prototype.isCancel = function(error) {
        return this._restApi.isCancel(error);
    };
    /**
     * Cancels an inflight request for either a GraphQL request or a Rest API request.
     * @param request - request to cancel
     * @param [message] - custom error message
     * @return If the request was cancelled
     */ InternalAPIClass.prototype.cancel = function(request, message) {
        if (this._restApi.hasCancelToken(request)) return this._restApi.cancel(request, message);
        else if (this._graphqlApi.hasCancelToken(request)) return this._graphqlApi.cancel(request, message);
        return false;
    };
    InternalAPIClass.prototype.getInitWithCustomUserAgentDetails = function(init, action) {
        var customUserAgentDetails = {
            category: (0, $58c96d580693cdce$export$3a8840c5b2ecf003).API,
            action: action
        };
        var initParams = (0, $033c8ca1c8420c0b$export$18ce0697a983be9b)((0, $033c8ca1c8420c0b$export$18ce0697a983be9b)({}, init), {
            customUserAgentDetails: customUserAgentDetails
        });
        return initParams;
    };
    /**
     * Getting endpoint for API
     * @param apiName - The name of the api
     * @return The endpoint of the api
     */ InternalAPIClass.prototype.endpoint = function(apiName) {
        return (0, $033c8ca1c8420c0b$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $033c8ca1c8420c0b$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._restApi.endpoint(apiName)
                ];
            });
        });
    };
    /**
     * to get the operation type
     * @param operation
     */ InternalAPIClass.prototype.getGraphqlOperationType = function(operation) {
        return this._graphqlApi.getGraphqlOperationType(operation);
    };
    InternalAPIClass.prototype.graphql = function(options, additionalHeaders, customUserAgentDetails) {
        var apiUserAgentDetails = (0, $033c8ca1c8420c0b$export$18ce0697a983be9b)({
            category: (0, $58c96d580693cdce$export$3a8840c5b2ecf003).API,
            action: (0, $58c96d580693cdce$export$126e20fdc0f0d34b).GraphQl
        }, customUserAgentDetails);
        return this._graphqlApi.graphql(options, additionalHeaders, apiUserAgentDetails);
    };
    return InternalAPIClass;
}();
var $4f84b192b2273b2c$export$76bce36b77a871ea = new $4f84b192b2273b2c$export$5158c6990c07fc65(null);
(0, $6ff5c7c169206e21$export$a3858a9a153cffc7).register($4f84b192b2273b2c$export$76bce36b77a871ea);


var $cd347cc85afbaa02$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("API");
/**
 * @deprecated
 * Use RestApi or GraphQLAPI to reduce your application bundle size
 * Export Cloud Logic APIs
 */ var $cd347cc85afbaa02$export$8361325628175dce = /** @class */ function(_super) {
    (0, $033c8ca1c8420c0b$export$a8ba968b8961cb8a)(APIClass, _super);
    function APIClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    APIClass.prototype.getModuleName = function() {
        return "API";
    };
    APIClass.prototype.graphql = function(options, additionalHeaders) {
        return _super.prototype.graphql.call(this, options, additionalHeaders);
    };
    return APIClass;
}((0, $4f84b192b2273b2c$export$5158c6990c07fc65));
var $cd347cc85afbaa02$export$2c4e825dc9120f87 = new $cd347cc85afbaa02$export$8361325628175dce(null);
(0, $6ff5c7c169206e21$export$a3858a9a153cffc7).register($cd347cc85afbaa02$export$2c4e825dc9120f87);


var $bb8ae67dbafc7dbb$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $bb8ae67dbafc7dbb$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function $bb8ae67dbafc7dbb$var$GoogleEmailCaptchaDownload() {
    return $bb8ae67dbafc7dbb$var$__awaiter(this, void 0, void 0, function() {
        var response, error_1;
        return $bb8ae67dbafc7dbb$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $cd347cc85afbaa02$export$2c4e825dc9120f87).post("EmailDownloadPublicWithGoogleCaptcha", "/", {
                            body: {}
                        })
                    ];
                case 1:
                    response = _a.sent();
                    console.log(response);
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 2:
                    error_1 = _a.sent();
                    console.error("Error calling Lambda function:", error_1);
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
var $bb8ae67dbafc7dbb$export$2e2bcd8739ae039 = $bb8ae67dbafc7dbb$var$GoogleEmailCaptchaDownload;


var $96e9d5022f95f8a8$var$DashbaordPage = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        (0, $bb8ae67dbafc7dbb$export$2e2bcd8739ae039)();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null, "dd");
};
var $96e9d5022f95f8a8$export$2e2bcd8739ae039 = $96e9d5022f95f8a8$var$DashbaordPage;



var $7fPBF = parcelRequire("7fPBF");

/* tslint:disable */ /* eslint-disable */ // this is an auto generated file. This will be overwritten
var $d819d0cbe64233c2$export$95829e54368ddd6b = /* GraphQL */ "query GetTableCount($key: String!) {\n  getTableCount(key: $key)\n}\n";
var $d819d0cbe64233c2$export$a23c3b558b9d6621 = /* GraphQL */ "query GetSystemGlobalSecrets($id: ID!) {\n  getSystemGlobalSecrets(id: $id) {\n    id\n    config\n    record\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$197e07aa664d3d5f = /* GraphQL */ "query ListSystemGlobalSecrets(\n  $id: ID\n  $filter: ModelSystemGlobalSecretsFilterInput\n  $limit: Int\n  $nextToken: String\n  $sortDirection: ModelSortDirection\n) {\n  listSystemGlobalSecrets(\n    id: $id\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n    sortDirection: $sortDirection\n  ) {\n    items {\n      id\n      config\n      record\n      updatedAt\n      createdAt\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$14df56e7b5db2c4 = /* GraphQL */ "query GetSurveyNotifyReportEmail($id: ID!) {\n  getSurveyNotifyReportEmail(id: $id) {\n    id\n    email\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$52a9fc74204dc76b = /* GraphQL */ "query ListSurveyNotifyReportEmails(\n  $id: ID\n  $filter: ModelSurveyNotifyReportEmailFilterInput\n  $limit: Int\n  $nextToken: String\n  $sortDirection: ModelSortDirection\n) {\n  listSurveyNotifyReportEmails(\n    id: $id\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n    sortDirection: $sortDirection\n  ) {\n    items {\n      id\n      email\n      updatedAt\n      createdAt\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$27e90d76e87bd6b8 = /* GraphQL */ "query GetSurveyDownloadReportEmail($id: ID!) {\n  getSurveyDownloadReportEmail(id: $id) {\n    id\n    reportID\n    reportYear\n    email\n    updatedAt\n    createdAt\n    allowedContact\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$471672b8dcf898fa = /* GraphQL */ "query ListSurveyDownloadReportEmails(\n  $id: ID\n  $filter: ModelSurveyDownloadReportEmailFilterInput\n  $limit: Int\n  $nextToken: String\n  $sortDirection: ModelSortDirection\n) {\n  listSurveyDownloadReportEmails(\n    id: $id\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n    sortDirection: $sortDirection\n  ) {\n    items {\n      id\n      reportID\n      reportYear\n      email\n      updatedAt\n      createdAt\n      allowedContact\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$7043984ae48e363 = /* GraphQL */ "query GetSystemInternalConfigurationVariablesReadonly($id: ID!) {\n  getSystemInternalConfigurationVariablesReadonly(id: $id) {\n    id\n    variable_name\n    variable_value\n    updatedAt\n    createdAt\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$c9a0e79705565a5e = /* GraphQL */ "query ListSystemInternalConfigurationVariablesReadonlies(\n  $id: ID\n  $filter: ModelSystemInternalConfigurationVariablesReadonlyFilterInput\n  $limit: Int\n  $nextToken: String\n  $sortDirection: ModelSortDirection\n) {\n  listSystemInternalConfigurationVariablesReadonlies(\n    id: $id\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n    sortDirection: $sortDirection\n  ) {\n    items {\n      id\n      variable_name\n      variable_value\n      updatedAt\n      createdAt\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$c4045551791ad9e8 = /* GraphQL */ "query GetSystemProcesses($id: ID!) {\n  getSystemProcesses(id: $id) {\n    id\n    process_name\n    process_status\n    percentage_complete\n    started_by\n    exceptions\n    updatedAt\n    createdAt\n    key\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$429cbfee7ac0c4e5 = /* GraphQL */ "query ListSystemProcesses(\n  $id: ID\n  $filter: ModelSystemProcessesFilterInput\n  $limit: Int\n  $nextToken: String\n  $sortDirection: ModelSortDirection\n) {\n  listSystemProcesses(\n    id: $id\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n    sortDirection: $sortDirection\n  ) {\n    items {\n      id\n      process_name\n      process_status\n      percentage_complete\n      started_by\n      exceptions\n      updatedAt\n      createdAt\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$670eef42c038f642 = /* GraphQL */ "query GetTableCSVs($id: ID!) {\n  getTableCSVs(id: $id) {\n    id\n    table_name\n    s3Key\n    s3Name\n    s3Type\n    requested_by\n    updatedAt\n    createdAt\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$2f5e7950720f2db4 = /* GraphQL */ "query ListTableCSVs(\n  $id: ID\n  $filter: ModelTableCSVsFilterInput\n  $limit: Int\n  $nextToken: String\n  $sortDirection: ModelSortDirection\n) {\n  listTableCSVs(\n    id: $id\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n    sortDirection: $sortDirection\n  ) {\n    items {\n      id\n      table_name\n      s3Key\n      s3Name\n      s3Type\n      requested_by\n      updatedAt\n      createdAt\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$4f5da003f4245282 = /* GraphQL */ "query GetSortedSystemGlobalSecrets(\n  $key: String!\n  $updatedAt: ModelStringKeyConditionInput\n  $sortDirection: ModelSortDirection\n  $filter: ModelSystemGlobalSecretsFilterInput\n  $limit: Int\n  $nextToken: String\n) {\n  getSortedSystemGlobalSecrets(\n    key: $key\n    updatedAt: $updatedAt\n    sortDirection: $sortDirection\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n  ) {\n    items {\n      id\n      config\n      record\n      updatedAt\n      createdAt\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$86199c0eb9b8146f = /* GraphQL */ "query GetSortedSurveyNotifyReportEmail(\n  $key: String!\n  $updatedAt: ModelStringKeyConditionInput\n  $sortDirection: ModelSortDirection\n  $filter: ModelSurveyNotifyReportEmailFilterInput\n  $limit: Int\n  $nextToken: String\n) {\n  getSortedSurveyNotifyReportEmail(\n    key: $key\n    updatedAt: $updatedAt\n    sortDirection: $sortDirection\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n  ) {\n    items {\n      id\n      email\n      updatedAt\n      createdAt\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$b0cad8549cbe63d9 = /* GraphQL */ "query SurveyDownloadReportEmailsByEmail(\n  $email: String!\n  $sortDirection: ModelSortDirection\n  $filter: ModelSurveyDownloadReportEmailFilterInput\n  $limit: Int\n  $nextToken: String\n) {\n  surveyDownloadReportEmailsByEmail(\n    email: $email\n    sortDirection: $sortDirection\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n  ) {\n    items {\n      id\n      reportID\n      reportYear\n      email\n      updatedAt\n      createdAt\n      allowedContact\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$5d0f58c92b9f8981 = /* GraphQL */ "query GetSortedSurveyDownloadReportEmail(\n  $key: String!\n  $updatedAt: ModelStringKeyConditionInput\n  $sortDirection: ModelSortDirection\n  $filter: ModelSurveyDownloadReportEmailFilterInput\n  $limit: Int\n  $nextToken: String\n) {\n  getSortedSurveyDownloadReportEmail(\n    key: $key\n    updatedAt: $updatedAt\n    sortDirection: $sortDirection\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n  ) {\n    items {\n      id\n      reportID\n      reportYear\n      email\n      updatedAt\n      createdAt\n      allowedContact\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$e31b6fdd64a5a385 = /* GraphQL */ "query GetSystemInternalConfigurationVariablesReadonlyByVariableName(\n  $variable_name: String!\n  $sortDirection: ModelSortDirection\n  $filter: ModelSystemInternalConfigurationVariablesReadonlyFilterInput\n  $limit: Int\n  $nextToken: String\n) {\n  getSystemInternalConfigurationVariablesReadonlyByVariableName(\n    variable_name: $variable_name\n    sortDirection: $sortDirection\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n  ) {\n    items {\n      id\n      variable_name\n      variable_value\n      updatedAt\n      createdAt\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$e228d72a738cc37a = /* GraphQL */ "query GetSortedSystemProcesses(\n  $key: String!\n  $updatedAt: ModelStringKeyConditionInput\n  $sortDirection: ModelSortDirection\n  $filter: ModelSystemProcessesFilterInput\n  $limit: Int\n  $nextToken: String\n) {\n  getSortedSystemProcesses(\n    key: $key\n    updatedAt: $updatedAt\n    sortDirection: $sortDirection\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n  ) {\n    items {\n      id\n      process_name\n      process_status\n      percentage_complete\n      started_by\n      exceptions\n      updatedAt\n      createdAt\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$bf1a0786a2c67c29 = /* GraphQL */ "query GetByTableName(\n  $table_name: String!\n  $updatedAt: ModelStringKeyConditionInput\n  $sortDirection: ModelSortDirection\n  $filter: ModelTableCSVsFilterInput\n  $limit: Int\n  $nextToken: String\n) {\n  getByTableName(\n    table_name: $table_name\n    updatedAt: $updatedAt\n    sortDirection: $sortDirection\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n  ) {\n    items {\n      id\n      table_name\n      s3Key\n      s3Name\n      s3Type\n      requested_by\n      updatedAt\n      createdAt\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$954d60866bec39e2 = /* GraphQL */ "query GetCMSPages($id: ID!) {\n  getCMSPages(id: $id) {\n    id\n    pageTitle\n    metaDescription\n    pageURL\n    content\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$719fb4cf2242cc14 = /* GraphQL */ "query ListCMSPages(\n  $id: ID\n  $filter: ModelCMSPagesFilterInput\n  $limit: Int\n  $nextToken: String\n  $sortDirection: ModelSortDirection\n) {\n  listCMSPages(\n    id: $id\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n    sortDirection: $sortDirection\n  ) {\n    items {\n      id\n      pageTitle\n      metaDescription\n      pageURL\n      content\n      updatedAt\n      createdAt\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$8f37cc661d36d6a2 = /* GraphQL */ "query GetByTitleCMSPages(\n  $pageTitle: String!\n  $sortDirection: ModelSortDirection\n  $filter: ModelCMSPagesFilterInput\n  $limit: Int\n  $nextToken: String\n) {\n  getByTitleCMSPages(\n    pageTitle: $pageTitle\n    sortDirection: $sortDirection\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n  ) {\n    items {\n      id\n      pageTitle\n      metaDescription\n      pageURL\n      content\n      updatedAt\n      createdAt\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$f824506d03b7212d = /* GraphQL */ "query GetByURLCMSPages(\n  $pageURL: String!\n  $sortDirection: ModelSortDirection\n  $filter: ModelCMSPagesFilterInput\n  $limit: Int\n  $nextToken: String\n) {\n  getByURLCMSPages(\n    pageURL: $pageURL\n    sortDirection: $sortDirection\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n  ) {\n    items {\n      id\n      pageTitle\n      metaDescription\n      pageURL\n      content\n      updatedAt\n      createdAt\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$81c75b72726fd81b = /* GraphQL */ "query GetSortedCMSPages(\n  $key: String!\n  $updatedAt: ModelStringKeyConditionInput\n  $sortDirection: ModelSortDirection\n  $filter: ModelCMSPagesFilterInput\n  $limit: Int\n  $nextToken: String\n) {\n  getSortedCMSPages(\n    key: $key\n    updatedAt: $updatedAt\n    sortDirection: $sortDirection\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n  ) {\n    items {\n      id\n      pageTitle\n      metaDescription\n      pageURL\n      content\n      updatedAt\n      createdAt\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$ea8112eca8241c4a = /* GraphQL */ "query GetCMSMenus($id: ID!) {\n  getCMSMenus(id: $id) {\n    id\n    menu\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$9715557d39aff273 = /* GraphQL */ "query ListCMSMenus(\n  $id: ID\n  $filter: ModelCMSMenusFilterInput\n  $limit: Int\n  $nextToken: String\n  $sortDirection: ModelSortDirection\n) {\n  listCMSMenus(\n    id: $id\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n    sortDirection: $sortDirection\n  ) {\n    items {\n      id\n      menu\n      updatedAt\n      createdAt\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$c8b0f44301faa222 = /* GraphQL */ "query GetByMenuCMSPages(\n  $menu: String!\n  $sortDirection: ModelSortDirection\n  $filter: ModelCMSMenusFilterInput\n  $limit: Int\n  $nextToken: String\n) {\n  getByMenuCMSPages(\n    menu: $menu\n    sortDirection: $sortDirection\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n  ) {\n    items {\n      id\n      menu\n      updatedAt\n      createdAt\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$63f076abd9302a21 = /* GraphQL */ "query GetSortedCMSMenus(\n  $key: String!\n  $updatedAt: ModelStringKeyConditionInput\n  $sortDirection: ModelSortDirection\n  $filter: ModelCMSMenusFilterInput\n  $limit: Int\n  $nextToken: String\n) {\n  getSortedCMSMenus(\n    key: $key\n    updatedAt: $updatedAt\n    sortDirection: $sortDirection\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n  ) {\n    items {\n      id\n      menu\n      updatedAt\n      createdAt\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$6aeb38e260f8803a = /* GraphQL */ "query GetCMSMenuItems($id: ID!) {\n  getCMSMenuItems(id: $id) {\n    id\n    menuID\n    menuItem\n    type\n    link\n    componentID\n    sortNumber\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$c0c1f89746adf454 = /* GraphQL */ "query ListCMSMenuItems(\n  $id: ID\n  $filter: ModelCMSMenuItemsFilterInput\n  $limit: Int\n  $nextToken: String\n  $sortDirection: ModelSortDirection\n) {\n  listCMSMenuItems(\n    id: $id\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n    sortDirection: $sortDirection\n  ) {\n    items {\n      id\n      menuID\n      menuItem\n      type\n      link\n      componentID\n      sortNumber\n      updatedAt\n      createdAt\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$d35d755fa91e9a0e = /* GraphQL */ "query GetByMenuIDForCMSMenuItem(\n  $menuID: ID!\n  $sortNumber: ModelIntKeyConditionInput\n  $sortDirection: ModelSortDirection\n  $filter: ModelCMSMenuItemsFilterInput\n  $limit: Int\n  $nextToken: String\n) {\n  getByMenuIDForCMSMenuItem(\n    menuID: $menuID\n    sortNumber: $sortNumber\n    sortDirection: $sortDirection\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n  ) {\n    items {\n      id\n      menuID\n      menuItem\n      type\n      link\n      componentID\n      sortNumber\n      updatedAt\n      createdAt\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$74ace0dc0af4194d = /* GraphQL */ "query GetCMSMetas($id: ID!) {\n  getCMSMetas(id: $id) {\n    id\n    name\n    contents\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$be98de4b489dc31d = /* GraphQL */ "query ListCMSMetas(\n  $id: ID\n  $filter: ModelCMSMetasFilterInput\n  $limit: Int\n  $nextToken: String\n  $sortDirection: ModelSortDirection\n) {\n  listCMSMetas(\n    id: $id\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n    sortDirection: $sortDirection\n  ) {\n    items {\n      id\n      name\n      contents\n      updatedAt\n      createdAt\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$1fbc446f47f31fca = /* GraphQL */ "query GetSortedCMSMetas(\n  $key: String!\n  $updatedAt: ModelStringKeyConditionInput\n  $sortDirection: ModelSortDirection\n  $filter: ModelCMSMetasFilterInput\n  $limit: Int\n  $nextToken: String\n) {\n  getSortedCMSMetas(\n    key: $key\n    updatedAt: $updatedAt\n    sortDirection: $sortDirection\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n  ) {\n    items {\n      id\n      name\n      contents\n      updatedAt\n      createdAt\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$7ce0b34cfff31064 = /* GraphQL */ "query GetCMSHeadScripts($id: ID!) {\n  getCMSHeadScripts(id: $id) {\n    id\n    name\n    script\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$111493ee87d3e00d = /* GraphQL */ "query ListCMSHeadScripts(\n  $id: ID\n  $filter: ModelCMSHeadScriptsFilterInput\n  $limit: Int\n  $nextToken: String\n  $sortDirection: ModelSortDirection\n) {\n  listCMSHeadScripts(\n    id: $id\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n    sortDirection: $sortDirection\n  ) {\n    items {\n      id\n      name\n      script\n      updatedAt\n      createdAt\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$9f1f3c1214add4f7 = /* GraphQL */ "query GetSortedCMSHeadScripts(\n  $key: String!\n  $updatedAt: ModelStringKeyConditionInput\n  $sortDirection: ModelSortDirection\n  $filter: ModelCMSHeadScriptsFilterInput\n  $limit: Int\n  $nextToken: String\n) {\n  getSortedCMSHeadScripts(\n    key: $key\n    updatedAt: $updatedAt\n    sortDirection: $sortDirection\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n  ) {\n    items {\n      id\n      name\n      script\n      updatedAt\n      createdAt\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$4ff209a90825df6e = /* GraphQL */ "query GetCMSConfigurations($id: ID!) {\n  getCMSConfigurations(id: $id) {\n    id\n    config\n    record\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$1a240ec58c4d770c = /* GraphQL */ "query ListCMSConfigurations(\n  $id: ID\n  $filter: ModelCMSConfigurationsFilterInput\n  $limit: Int\n  $nextToken: String\n  $sortDirection: ModelSortDirection\n) {\n  listCMSConfigurations(\n    id: $id\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n    sortDirection: $sortDirection\n  ) {\n    items {\n      id\n      config\n      record\n      updatedAt\n      createdAt\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$95867aa59dafe5c7 = /* GraphQL */ "query GetSortedCMSConfigurations(\n  $key: String!\n  $updatedAt: ModelStringKeyConditionInput\n  $sortDirection: ModelSortDirection\n  $filter: ModelCMSConfigurationsFilterInput\n  $limit: Int\n  $nextToken: String\n) {\n  getSortedCMSConfigurations(\n    key: $key\n    updatedAt: $updatedAt\n    sortDirection: $sortDirection\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n  ) {\n    items {\n      id\n      config\n      record\n      updatedAt\n      createdAt\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$2f014546a152053c = /* GraphQL */ "query GetSurveySettings($id: ID!) {\n  getSurveySettings(id: $id) {\n    id\n    name\n    setting\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$535c74dbcb4c46ee = /* GraphQL */ "query ListSurveySettings(\n  $id: ID\n  $filter: ModelSurveySettingsFilterInput\n  $limit: Int\n  $nextToken: String\n  $sortDirection: ModelSortDirection\n) {\n  listSurveySettings(\n    id: $id\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n    sortDirection: $sortDirection\n  ) {\n    items {\n      id\n      name\n      setting\n      updatedAt\n      createdAt\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$9baa9a341f16e4a5 = /* GraphQL */ "query GetSortedSurveySettings(\n  $key: String!\n  $updatedAt: ModelStringKeyConditionInput\n  $sortDirection: ModelSortDirection\n  $filter: ModelSurveySettingsFilterInput\n  $limit: Int\n  $nextToken: String\n) {\n  getSortedSurveySettings(\n    key: $key\n    updatedAt: $updatedAt\n    sortDirection: $sortDirection\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n  ) {\n    items {\n      id\n      name\n      setting\n      updatedAt\n      createdAt\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$87b4d4eebd6cb3e7 = /* GraphQL */ "query GetSurveyReports($id: ID!) {\n  getSurveyReports(id: $id) {\n    id\n    reportStatus\n    year\n    description\n    reportImage\n    s3Key\n    s3Name\n    s3Type\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$9f1eb3a8a6c90115 = /* GraphQL */ "query ListSurveyReports(\n  $id: ID\n  $filter: ModelSurveyReportsFilterInput\n  $limit: Int\n  $nextToken: String\n  $sortDirection: ModelSortDirection\n) {\n  listSurveyReports(\n    id: $id\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n    sortDirection: $sortDirection\n  ) {\n    items {\n      id\n      reportStatus\n      year\n      description\n      reportImage\n      s3Key\n      s3Name\n      s3Type\n      updatedAt\n      createdAt\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";
var $d819d0cbe64233c2$export$cf57b28d21aff9c5 = /* GraphQL */ "query GetSortedSurveyReports(\n  $key: String!\n  $updatedAt: ModelStringKeyConditionInput\n  $sortDirection: ModelSortDirection\n  $filter: ModelSurveyReportsFilterInput\n  $limit: Int\n  $nextToken: String\n) {\n  getSortedSurveyReports(\n    key: $key\n    updatedAt: $updatedAt\n    sortDirection: $sortDirection\n    filter: $filter\n    limit: $limit\n    nextToken: $nextToken\n  ) {\n    items {\n      id\n      reportStatus\n      year\n      description\n      reportImage\n      s3Key\n      s3Name\n      s3Type\n      updatedAt\n      createdAt\n      updatedBy\n      createdBy\n      key\n      __typename\n    }\n    nextToken\n    __typename\n  }\n}\n";


/* tslint:disable */ /* eslint-disable */ // this is an auto generated file. This will be overwritten
var $7a1d5ab68f58f51c$export$c9e39ad5d462defd = /* GraphQL */ "mutation CreateCMSPages(\n  $input: CreateCMSPagesInput!\n  $condition: ModelCMSPagesConditionInput\n) {\n  createCMSPages(input: $input, condition: $condition) {\n    id\n    pageTitle\n    metaDescription\n    pageURL\n    content\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$a6f89f8360a074d3 = /* GraphQL */ "mutation UpdateCMSPages(\n  $input: UpdateCMSPagesInput!\n  $condition: ModelCMSPagesConditionInput\n) {\n  updateCMSPages(input: $input, condition: $condition) {\n    id\n    pageTitle\n    metaDescription\n    pageURL\n    content\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$e7bb58a3ece4334c = /* GraphQL */ "mutation DeleteCMSPages(\n  $input: DeleteCMSPagesInput!\n  $condition: ModelCMSPagesConditionInput\n) {\n  deleteCMSPages(input: $input, condition: $condition) {\n    id\n    pageTitle\n    metaDescription\n    pageURL\n    content\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$297e33b795426edf = /* GraphQL */ "mutation CreateCMSMenus(\n  $input: CreateCMSMenusInput!\n  $condition: ModelCMSMenusConditionInput\n) {\n  createCMSMenus(input: $input, condition: $condition) {\n    id\n    menu\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$f9f56aa8f6d1864 = /* GraphQL */ "mutation UpdateCMSMenus(\n  $input: UpdateCMSMenusInput!\n  $condition: ModelCMSMenusConditionInput\n) {\n  updateCMSMenus(input: $input, condition: $condition) {\n    id\n    menu\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$7fd69839f318f0ed = /* GraphQL */ "mutation DeleteCMSMenus(\n  $input: DeleteCMSMenusInput!\n  $condition: ModelCMSMenusConditionInput\n) {\n  deleteCMSMenus(input: $input, condition: $condition) {\n    id\n    menu\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$e2bb2cc7e681444a = /* GraphQL */ "mutation CreateCMSMenuItems(\n  $input: CreateCMSMenuItemsInput!\n  $condition: ModelCMSMenuItemsConditionInput\n) {\n  createCMSMenuItems(input: $input, condition: $condition) {\n    id\n    menuID\n    menuItem\n    type\n    link\n    componentID\n    sortNumber\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$9618e57ca8d89830 = /* GraphQL */ "mutation UpdateCMSMenuItems(\n  $input: UpdateCMSMenuItemsInput!\n  $condition: ModelCMSMenuItemsConditionInput\n) {\n  updateCMSMenuItems(input: $input, condition: $condition) {\n    id\n    menuID\n    menuItem\n    type\n    link\n    componentID\n    sortNumber\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$a6b4f67d228ab4c9 = /* GraphQL */ "mutation DeleteCMSMenuItems(\n  $input: DeleteCMSMenuItemsInput!\n  $condition: ModelCMSMenuItemsConditionInput\n) {\n  deleteCMSMenuItems(input: $input, condition: $condition) {\n    id\n    menuID\n    menuItem\n    type\n    link\n    componentID\n    sortNumber\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$a22aafb65bc115d9 = /* GraphQL */ "mutation CreateCMSMetas(\n  $input: CreateCMSMetasInput!\n  $condition: ModelCMSMetasConditionInput\n) {\n  createCMSMetas(input: $input, condition: $condition) {\n    id\n    name\n    contents\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$930ca4b7b675092e = /* GraphQL */ "mutation UpdateCMSMetas(\n  $input: UpdateCMSMetasInput!\n  $condition: ModelCMSMetasConditionInput\n) {\n  updateCMSMetas(input: $input, condition: $condition) {\n    id\n    name\n    contents\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$35823a5221398c4b = /* GraphQL */ "mutation DeleteCMSMetas(\n  $input: DeleteCMSMetasInput!\n  $condition: ModelCMSMetasConditionInput\n) {\n  deleteCMSMetas(input: $input, condition: $condition) {\n    id\n    name\n    contents\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$99846709f0a1c450 = /* GraphQL */ "mutation CreateCMSHeadScripts(\n  $input: CreateCMSHeadScriptsInput!\n  $condition: ModelCMSHeadScriptsConditionInput\n) {\n  createCMSHeadScripts(input: $input, condition: $condition) {\n    id\n    name\n    script\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$d69c6e3875fd7cf3 = /* GraphQL */ "mutation UpdateCMSHeadScripts(\n  $input: UpdateCMSHeadScriptsInput!\n  $condition: ModelCMSHeadScriptsConditionInput\n) {\n  updateCMSHeadScripts(input: $input, condition: $condition) {\n    id\n    name\n    script\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$e97fcad5ca2a29e9 = /* GraphQL */ "mutation DeleteCMSHeadScripts(\n  $input: DeleteCMSHeadScriptsInput!\n  $condition: ModelCMSHeadScriptsConditionInput\n) {\n  deleteCMSHeadScripts(input: $input, condition: $condition) {\n    id\n    name\n    script\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$3cc2f3bbfd4dcc86 = /* GraphQL */ "mutation CreateCMSConfigurations(\n  $input: CreateCMSConfigurationsInput!\n  $condition: ModelCMSConfigurationsConditionInput\n) {\n  createCMSConfigurations(input: $input, condition: $condition) {\n    id\n    config\n    record\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$86ffb00491f8eb6b = /* GraphQL */ "mutation UpdateCMSConfigurations(\n  $input: UpdateCMSConfigurationsInput!\n  $condition: ModelCMSConfigurationsConditionInput\n) {\n  updateCMSConfigurations(input: $input, condition: $condition) {\n    id\n    config\n    record\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$ec8df78d8cbf61ea = /* GraphQL */ "mutation DeleteCMSConfigurations(\n  $input: DeleteCMSConfigurationsInput!\n  $condition: ModelCMSConfigurationsConditionInput\n) {\n  deleteCMSConfigurations(input: $input, condition: $condition) {\n    id\n    config\n    record\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$460903208bc6934d = /* GraphQL */ "mutation CreateSystemGlobalSecrets(\n  $input: CreateSystemGlobalSecretsInput!\n  $condition: ModelSystemGlobalSecretsConditionInput\n) {\n  createSystemGlobalSecrets(input: $input, condition: $condition) {\n    id\n    config\n    record\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$fe2848aa9648df5f = /* GraphQL */ "mutation UpdateSystemGlobalSecrets(\n  $input: UpdateSystemGlobalSecretsInput!\n  $condition: ModelSystemGlobalSecretsConditionInput\n) {\n  updateSystemGlobalSecrets(input: $input, condition: $condition) {\n    id\n    config\n    record\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$6e1cc715f2833d3b = /* GraphQL */ "mutation DeleteSystemGlobalSecrets(\n  $input: DeleteSystemGlobalSecretsInput!\n  $condition: ModelSystemGlobalSecretsConditionInput\n) {\n  deleteSystemGlobalSecrets(input: $input, condition: $condition) {\n    id\n    config\n    record\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$7f3767f6ceb72db2 = /* GraphQL */ "mutation CreateSurveySettings(\n  $input: CreateSurveySettingsInput!\n  $condition: ModelSurveySettingsConditionInput\n) {\n  createSurveySettings(input: $input, condition: $condition) {\n    id\n    name\n    setting\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$5472a1c840d124fc = /* GraphQL */ "mutation UpdateSurveySettings(\n  $input: UpdateSurveySettingsInput!\n  $condition: ModelSurveySettingsConditionInput\n) {\n  updateSurveySettings(input: $input, condition: $condition) {\n    id\n    name\n    setting\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$af4efcec16e1a80f = /* GraphQL */ "mutation DeleteSurveySettings(\n  $input: DeleteSurveySettingsInput!\n  $condition: ModelSurveySettingsConditionInput\n) {\n  deleteSurveySettings(input: $input, condition: $condition) {\n    id\n    name\n    setting\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$837ad18711977e9c = /* GraphQL */ "mutation CreateSurveyReports(\n  $input: CreateSurveyReportsInput!\n  $condition: ModelSurveyReportsConditionInput\n) {\n  createSurveyReports(input: $input, condition: $condition) {\n    id\n    reportStatus\n    year\n    description\n    reportImage\n    s3Key\n    s3Name\n    s3Type\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$60b7413f09d475b = /* GraphQL */ "mutation UpdateSurveyReports(\n  $input: UpdateSurveyReportsInput!\n  $condition: ModelSurveyReportsConditionInput\n) {\n  updateSurveyReports(input: $input, condition: $condition) {\n    id\n    reportStatus\n    year\n    description\n    reportImage\n    s3Key\n    s3Name\n    s3Type\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$769971d68cb45d1a = /* GraphQL */ "mutation DeleteSurveyReports(\n  $input: DeleteSurveyReportsInput!\n  $condition: ModelSurveyReportsConditionInput\n) {\n  deleteSurveyReports(input: $input, condition: $condition) {\n    id\n    reportStatus\n    year\n    description\n    reportImage\n    s3Key\n    s3Name\n    s3Type\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$d132f2ec94189d1c = /* GraphQL */ "mutation CreateSurveyNotifyReportEmail(\n  $input: CreateSurveyNotifyReportEmailInput!\n  $condition: ModelSurveyNotifyReportEmailConditionInput\n) {\n  createSurveyNotifyReportEmail(input: $input, condition: $condition) {\n    id\n    email\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$8fadaf7e7e30fd9e = /* GraphQL */ "mutation UpdateSurveyNotifyReportEmail(\n  $input: UpdateSurveyNotifyReportEmailInput!\n  $condition: ModelSurveyNotifyReportEmailConditionInput\n) {\n  updateSurveyNotifyReportEmail(input: $input, condition: $condition) {\n    id\n    email\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$81a40b35df0b650a = /* GraphQL */ "mutation DeleteSurveyNotifyReportEmail(\n  $input: DeleteSurveyNotifyReportEmailInput!\n  $condition: ModelSurveyNotifyReportEmailConditionInput\n) {\n  deleteSurveyNotifyReportEmail(input: $input, condition: $condition) {\n    id\n    email\n    updatedAt\n    createdAt\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$724c753285e1b60b = /* GraphQL */ "mutation CreateSurveyDownloadReportEmail(\n  $input: CreateSurveyDownloadReportEmailInput!\n  $condition: ModelSurveyDownloadReportEmailConditionInput\n) {\n  createSurveyDownloadReportEmail(input: $input, condition: $condition) {\n    id\n    reportID\n    reportYear\n    email\n    updatedAt\n    createdAt\n    allowedContact\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$dabe6b9f54960e0b = /* GraphQL */ "mutation UpdateSurveyDownloadReportEmail(\n  $input: UpdateSurveyDownloadReportEmailInput!\n  $condition: ModelSurveyDownloadReportEmailConditionInput\n) {\n  updateSurveyDownloadReportEmail(input: $input, condition: $condition) {\n    id\n    reportID\n    reportYear\n    email\n    updatedAt\n    createdAt\n    allowedContact\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$bdf1f7f82dfd20a7 = /* GraphQL */ "mutation DeleteSurveyDownloadReportEmail(\n  $input: DeleteSurveyDownloadReportEmailInput!\n  $condition: ModelSurveyDownloadReportEmailConditionInput\n) {\n  deleteSurveyDownloadReportEmail(input: $input, condition: $condition) {\n    id\n    reportID\n    reportYear\n    email\n    updatedAt\n    createdAt\n    allowedContact\n    updatedBy\n    createdBy\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$fda9d4299aa12bb8 = /* GraphQL */ "mutation CreateSystemInternalConfigurationVariablesReadonly(\n  $input: CreateSystemInternalConfigurationVariablesReadonlyInput!\n  $condition: ModelSystemInternalConfigurationVariablesReadonlyConditionInput\n) {\n  createSystemInternalConfigurationVariablesReadonly(\n    input: $input\n    condition: $condition\n  ) {\n    id\n    variable_name\n    variable_value\n    updatedAt\n    createdAt\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$3d8c2f61368b6db0 = /* GraphQL */ "mutation UpdateSystemInternalConfigurationVariablesReadonly(\n  $input: UpdateSystemInternalConfigurationVariablesReadonlyInput!\n  $condition: ModelSystemInternalConfigurationVariablesReadonlyConditionInput\n) {\n  updateSystemInternalConfigurationVariablesReadonly(\n    input: $input\n    condition: $condition\n  ) {\n    id\n    variable_name\n    variable_value\n    updatedAt\n    createdAt\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$30d5cbba0260b1e4 = /* GraphQL */ "mutation DeleteSystemInternalConfigurationVariablesReadonly(\n  $input: DeleteSystemInternalConfigurationVariablesReadonlyInput!\n  $condition: ModelSystemInternalConfigurationVariablesReadonlyConditionInput\n) {\n  deleteSystemInternalConfigurationVariablesReadonly(\n    input: $input\n    condition: $condition\n  ) {\n    id\n    variable_name\n    variable_value\n    updatedAt\n    createdAt\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$2477e340b55c8785 = /* GraphQL */ "mutation CreateSystemProcesses(\n  $input: CreateSystemProcessesInput!\n  $condition: ModelSystemProcessesConditionInput\n) {\n  createSystemProcesses(input: $input, condition: $condition) {\n    id\n    process_name\n    process_status\n    percentage_complete\n    started_by\n    exceptions\n    updatedAt\n    createdAt\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$550552020d6abc2a = /* GraphQL */ "mutation UpdateSystemProcesses(\n  $input: UpdateSystemProcessesInput!\n  $condition: ModelSystemProcessesConditionInput\n) {\n  updateSystemProcesses(input: $input, condition: $condition) {\n    id\n    process_name\n    process_status\n    percentage_complete\n    started_by\n    exceptions\n    updatedAt\n    createdAt\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$7d8c2c15246adf1b = /* GraphQL */ "mutation DeleteSystemProcesses(\n  $input: DeleteSystemProcessesInput!\n  $condition: ModelSystemProcessesConditionInput\n) {\n  deleteSystemProcesses(input: $input, condition: $condition) {\n    id\n    process_name\n    process_status\n    percentage_complete\n    started_by\n    exceptions\n    updatedAt\n    createdAt\n    key\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$62125c4be1aaf039 = /* GraphQL */ "mutation CreateTableCSVs(\n  $input: CreateTableCSVsInput!\n  $condition: ModelTableCSVsConditionInput\n) {\n  createTableCSVs(input: $input, condition: $condition) {\n    id\n    table_name\n    s3Key\n    s3Name\n    s3Type\n    requested_by\n    updatedAt\n    createdAt\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$335cba6241dd6ed3 = /* GraphQL */ "mutation UpdateTableCSVs(\n  $input: UpdateTableCSVsInput!\n  $condition: ModelTableCSVsConditionInput\n) {\n  updateTableCSVs(input: $input, condition: $condition) {\n    id\n    table_name\n    s3Key\n    s3Name\n    s3Type\n    requested_by\n    updatedAt\n    createdAt\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$6ed186f61e93267e = /* GraphQL */ "mutation DeleteTableCSVs(\n  $input: DeleteTableCSVsInput!\n  $condition: ModelTableCSVsConditionInput\n) {\n  deleteTableCSVs(input: $input, condition: $condition) {\n    id\n    table_name\n    s3Key\n    s3Name\n    s3Type\n    requested_by\n    updatedAt\n    createdAt\n    __typename\n  }\n}\n";
var $7a1d5ab68f58f51c$export$706b10a2fae99b26 = /* GraphQL */ "mutation CreatePublicSurveyDownloadReportEmail(\n  $args: InputPublicSurveyDownloadReportEmail!\n) {\n  createPublicSurveyDownloadReportEmail(args: $args)\n}\n";
var $7a1d5ab68f58f51c$export$b5206f28caf876be = /* GraphQL */ "mutation CreatePublicSurveyNotifyReportEmail(\n  $args: InputPublicSurveyNotifyReportEmail!\n) {\n  createPublicSurveyNotifyReportEmail(args: $args)\n}\n";


var $3ad4f174f34ffe7d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3ad4f174f34ffe7d$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $3ad4f174f34ffe7d$var$AsyncStorage = {
    setItem: function(key, value) {
        return $3ad4f174f34ffe7d$var$__awaiter(void 0, void 0, Promise, function() {
            return $3ad4f174f34ffe7d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            new Promise(function(resolve, reject) {
                                try {
                                    localStorage.setItem(key, value);
                                    resolve(value);
                                } catch (error) {
                                    reject(error);
                                }
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    },
    getItem: function(key) {
        return $3ad4f174f34ffe7d$var$__awaiter(void 0, void 0, Promise, function() {
            return $3ad4f174f34ffe7d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            new Promise(function(resolve, reject) {
                                try {
                                    var value = localStorage.getItem(key);
                                    resolve(value);
                                } catch (error) {
                                    reject(error);
                                }
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    },
    removeItem: function(key) {
        return $3ad4f174f34ffe7d$var$__awaiter(void 0, void 0, Promise, function() {
            return $3ad4f174f34ffe7d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            new Promise(function(resolve, reject) {
                                try {
                                    localStorage.removeItem(key);
                                    resolve(true);
                                } catch (error) {
                                    reject(error);
                                }
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    },
    clear: function() {
        return $3ad4f174f34ffe7d$var$__awaiter(void 0, void 0, Promise, function() {
            return $3ad4f174f34ffe7d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            new Promise(function(resolve, reject) {
                                try {
                                    localStorage.clear();
                                    resolve(true);
                                } catch (error) {
                                    reject(error);
                                }
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    }
};
var $3ad4f174f34ffe7d$export$2e2bcd8739ae039 = $3ad4f174f34ffe7d$var$AsyncStorage;


var $9d45be0f6beae26c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9d45be0f6beae26c$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $9d45be0f6beae26c$var$CacheKey = "CMMenusPagesCache";
var $9d45be0f6beae26c$var$CMSMenusCache = {
    setItem: function(value) {
        return $9d45be0f6beae26c$var$__awaiter(void 0, void 0, Promise, function() {
            return $9d45be0f6beae26c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).setItem($9d45be0f6beae26c$var$CacheKey, JSON.stringify(value))
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    },
    getItem: function() {
        return $9d45be0f6beae26c$var$__awaiter(void 0, void 0, Promise, function() {
            var items;
            return $9d45be0f6beae26c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).getItem($9d45be0f6beae26c$var$CacheKey)
                        ];
                    case 1:
                        items = _a.sent();
                        return [
                            2,
                            items ? JSON.parse(items) : null
                        ];
                }
            });
        });
    },
    removeItem: function() {
        return $9d45be0f6beae26c$var$__awaiter(void 0, void 0, Promise, function() {
            return $9d45be0f6beae26c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).removeItem($9d45be0f6beae26c$var$CacheKey)
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    }
};
var $9d45be0f6beae26c$export$2e2bcd8739ae039 = $9d45be0f6beae26c$var$CMSMenusCache;





var $02b369573055e688$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $02b369573055e688$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $02b369573055e688$var$UserSession = function(navigate) {
    return $02b369573055e688$var$__awaiter(void 0, void 0, void 0, function() {
        var e_1;
        return $02b369573055e688$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        2,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $9e453b5784a8464e$export$334c29725a78c21d).currentAuthenticatedUser()
                    ];
                case 1:
                    return [
                        2,
                        _a.sent()
                    ];
                case 2:
                    e_1 = _a.sent();
                    (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                    return [
                        4,
                        (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).clear()
                    ];
                case 3:
                    _a.sent();
                    navigate("/login");
                    (0, $de77e498e07914bf$export$b410431fab84fa58).warn("User expired. Therefore, logged out", {
                        autoClose: false
                    });
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $02b369573055e688$export$2e2bcd8739ae039 = $02b369573055e688$var$UserSession;






var $6135f73f4616c1d5$export$78930a3b816845f9 = function(query, variables, authToken) {
    if (variables === void 0) variables = {};
    return {
        query: query,
        variables: variables,
        authToken: authToken
    };
};
/**
 * Export Cloud Logic APIs
 */ var $6135f73f4616c1d5$export$e32503f9802a56ee = /** @class */ function(_super) {
    (0, $7d95c07d19eb445d$export$a8ba968b8961cb8a)(GraphQLAPIClass, _super);
    function GraphQLAPIClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GraphQLAPIClass.prototype.getModuleName = function() {
        return "GraphQLAPI";
    };
    /**
     * Executes a GraphQL operation
     *
     * @param options - GraphQL Options
     * @param [additionalHeaders] - headers to merge in after any `graphql_headers` set in the config
     * @returns An Observable if the query is a subscription query, else a promise of the graphql result.
     */ GraphQLAPIClass.prototype.graphql = function(options, additionalHeaders) {
        return _super.prototype.graphql.call(this, options, additionalHeaders);
    };
    return GraphQLAPIClass;
}((0, $cc07bc70b7cb104a$export$c3e852ee609522ad));
var $6135f73f4616c1d5$export$6572ab1b3fe6697f = new $6135f73f4616c1d5$export$e32503f9802a56ee(null);
(0, $6ff5c7c169206e21$export$a3858a9a153cffc7).register($6135f73f4616c1d5$export$6572ab1b3fe6697f);


var $e202af6739f6b19f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e202af6739f6b19f$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $e202af6739f6b19f$var$blobToString = function(blob) {
    return $e202af6739f6b19f$var$__awaiter(void 0, void 0, void 0, function() {
        return $e202af6739f6b19f$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4,
                        new Promise(function(resolve, reject) {
                            var reader = new FileReader();
                            reader.onloadend = function() {
                                resolve(reader.result);
                            };
                            reader.onerror = reject;
                            reader.readAsText(blob);
                        })
                    ];
                case 1:
                    return [
                        2,
                        _a.sent()
                    ];
            }
        });
    });
};
var $e202af6739f6b19f$var$FileSQLAPI = {
    update: function(newItem) {
        return $e202af6739f6b19f$var$__awaiter(void 0, void 0, Promise, function() {
            return $e202af6739f6b19f$var$__generator(this, function(_a) {
                /*
        try {
          const date = new Date();
          const fileName = `${date.getFullYear()}-${
            date.getMonth() + 1
          }-${date.getDate()}.json`;
                   let fileContent = [];
                   // Try to retrieve the existing file
          try {
            const existingFile = await Storage.get(`CMSPage/${fileName}`, {
              download: true,
            });
            if (existingFile.Body) {
              const Body: any = await blobToString(existingFile.Body);
                       fileContent = JSON.parse(Body);
            }
          } catch (error) {
            console.log('File does not exist or other error:', error);
          }
          fileContent.push(newItem);
          const result = await Storage.put(
            `CMSPage/${fileName}`,
            JSON.stringify(fileContent),
            {
              contentType: 'application/json',
            },
          );
                   console.log('File uploaded successfully:', result);
        } catch (error) {
          console.error('Error processing the file:', error);
        } */ console.log("backup disabled sql");
                return [
                    2 /*return*/ 
                ];
            });
        });
    }
};
var $e202af6739f6b19f$export$2e2bcd8739ae039 = $e202af6739f6b19f$var$FileSQLAPI;



var $85c3021a0318976c$var$__assign = undefined && undefined.__assign || function() {
    $85c3021a0318976c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $85c3021a0318976c$var$__assign.apply(this, arguments);
};
var $85c3021a0318976c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $85c3021a0318976c$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $85c3021a0318976c$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $85c3021a0318976c$var$UtilFuncAPIs = /** @class */ function() {
    function UtilFuncAPIs(_a) {
        var ref = _a.ref, cacheFunc = _a.cacheFunc, filter = _a.filter, getFunc = _a.getFunc, route = _a.route, deleteFunc = _a.deleteFunc, insertFunc = _a.insertFunc, updateFunc = _a.updateFunc, backupTable = _a.backupTable, deleteMSG = _a.deleteMSG, insertMSG = _a.insertMSG, updateMSG = _a.updateMSG, key = _a.key, listFunc = _a.listFunc, getName = _a.getName;
        this.ref = ref;
        this.filter = filter;
        this.getFunc = getFunc;
        this.route = route;
        this.deleteFunc = deleteFunc;
        this.insertFunc = insertFunc;
        this.updateFunc = updateFunc;
        this.backupTable = backupTable;
        this.deleteMSG = deleteMSG;
        this.insertMSG = insertMSG;
        this.updateMSG = updateMSG;
        this.listFunc = listFunc;
        this.getName = getName;
        if (key) this.key = key;
        if (cacheFunc) this.cacheFunc = cacheFunc;
    }
    UtilFuncAPIs.prototype.handleError = function(error, data) {
        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
        if ((error + "").includes("Network error")) (0, $de77e498e07914bf$export$b410431fab84fa58).error("Unable to connect to internet", {
            autoClose: false
        });
        else (0, $de77e498e07914bf$export$b410431fab84fa58).error("Unable to contact server");
        console.log("error " + this.ref + ": ", error);
    };
    UtilFuncAPIs.prototype.findItems = function(obj) {
        if (obj && typeof obj === "object") {
            if (Object.prototype.hasOwnProperty.call(obj, "items")) return obj.items;
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var result = this.findItems(obj[key]);
                if (result) return result;
            }
        }
        return null;
    };
    UtilFuncAPIs.prototype.findNextToken = function(data) {
        // Get the first property name in the object
        var firstPropertyName = Object.keys(data)[0];
        // Get the nextToken from the first property
        var nextToken = data[firstPropertyName].nextToken;
        return nextToken;
    };
    UtilFuncAPIs.prototype.hasNexToken = function() {
        return $85c3021a0318976c$var$__awaiter(this, void 0, Promise, function() {
            var cacheData;
            return $85c3021a0318976c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.cacheFunc) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.cacheFunc.getItem()
                        ];
                    case 1:
                        cacheData = _a.sent() || {
                            items: [],
                            nextToken: null
                        };
                        return [
                            2,
                            !cacheData.nextToken
                        ];
                    case 2:
                        return [
                            2,
                            false
                        ];
                }
            });
        });
    };
    UtilFuncAPIs.prototype.getPageNumbers = function() {
        return $85c3021a0318976c$var$__awaiter(this, void 0, Promise, function() {
            var cacheData;
            return $85c3021a0318976c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // console.group('UtilFunc - getPageNumbers');
                        console.log(this.cacheFunc);
                        if (!this.cacheFunc) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.cacheFunc.getItem()
                        ];
                    case 1:
                        cacheData = _a.sent() || {
                            items: [],
                            count: 0,
                            nextToken: null
                        };
                        console.log("cacheData count", cacheData.count);
                        return [
                            2,
                            cacheData.count + 1
                        ];
                    case 2:
                        return [
                            2,
                            1
                        ];
                }
            });
        });
    };
    UtilFuncAPIs.prototype.getList = function(navigation, refreshCache, page, limit) {
        if (page === void 0) page = 1;
        if (limit === void 0) limit = 25;
        return $85c3021a0318976c$var$__awaiter(this, void 0, Promise, function() {
            var cacheData, total, startIndex, endIndex, authMode, response, itemCount, countResponse, jsonCount, items, nextToken, total, error_1;
            return $85c3021a0318976c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            12,
                            ,
                            13
                        ]);
                        if (!navigation) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0, $02b369573055e688$export$2e2bcd8739ae039)(navigation)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        cacheData = {
                            items: [],
                            count: 0,
                            nextToken: null
                        };
                        if (!(this.cacheFunc && !refreshCache)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            this.cacheFunc.getItem()
                        ];
                    case 3:
                        // console.log('inside refresh');
                        cacheData = _a.sent() || {
                            items: [],
                            count: 0,
                            nextToken: null
                        };
                        console.log(cacheData);
                        total = Math.floor(cacheData.items.length / limit);
                        console.log("total:", total);
                        console.log("page:", page);
                        console.log((!(page > total) || !cacheData.nextToken) && cacheData.items.length > 0);
                        if ((!(page > total) || !cacheData.nextToken) && cacheData.items.length > 0) {
                            startIndex = (page - 1) * limit;
                            endIndex = startIndex + limit;
                            return [
                                2,
                                $85c3021a0318976c$var$__spreadArray([], cacheData.items, true).slice(startIndex, endIndex)
                            ];
                        }
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        cacheData = {
                            items: [],
                            count: 0,
                            nextToken: null
                        };
                        _a.label = 5;
                    case 5:
                        authMode = navigation ? "AMAZON_COGNITO_USER_POOLS" : "API_KEY";
                        return [
                            4,
                            (0, $cd347cc85afbaa02$export$2c4e825dc9120f87).graphql({
                                query: this.listFunc,
                                variables: $85c3021a0318976c$var$__assign($85c3021a0318976c$var$__assign({}, this.filter), {
                                    limit: limit,
                                    nextToken: cacheData.nextToken
                                }),
                                authMode: authMode
                            })
                        ];
                    case 6:
                        response = _a.sent();
                        itemCount = 0;
                        if (!navigation) return [
                            3,
                            8
                        ];
                        return [
                            4,
                            (0, $cd347cc85afbaa02$export$2c4e825dc9120f87).graphql({
                                query: (0, $d819d0cbe64233c2$export$95829e54368ddd6b),
                                variables: $85c3021a0318976c$var$__assign({}, this.filter),
                                authMode: "AMAZON_COGNITO_USER_POOLS"
                            })
                        ];
                    case 7:
                        countResponse = _a.sent();
                        jsonCount = JSON.parse(countResponse.data.getTableCount);
                        itemCount = jsonCount.response;
                        _a.label = 8;
                    case 8:
                        items = this.findItems(response.data);
                        nextToken = this.findNextToken(response.data);
                        if (!this.cacheFunc) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            this.cacheFunc.setItem({
                                items: $85c3021a0318976c$var$__spreadArray($85c3021a0318976c$var$__spreadArray([], cacheData.items, true), items, true),
                                count: itemCount,
                                nextToken: nextToken
                            })
                        ];
                    case 9:
                        _a.sent();
                        total = Math.floor(cacheData.items.length / limit) + 1;
                        console.log("total:", total);
                        if (!(page > total && nextToken)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            this.getList(navigation, refreshCache, page, limit)
                        ];
                    case 10:
                        return [
                            2,
                            _a.sent()
                        ];
                    case 11:
                        return [
                            2,
                            $85c3021a0318976c$var$__spreadArray([], items, true)
                        ];
                    case 12:
                        error_1 = _a.sent();
                        this.handleError(error_1);
                        return [
                            2,
                            []
                        ];
                    case 13:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    UtilFuncAPIs.prototype.get = function(navigation, id) {
        return $85c3021a0318976c$var$__awaiter(this, void 0, Promise, function() {
            var apiData, error_2;
            return $85c3021a0318976c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        (0, $de77e498e07914bf$export$b410431fab84fa58).loading("Processing...");
                        if (!navigation) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0, $02b369573055e688$export$2e2bcd8739ae039)(navigation)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $cd347cc85afbaa02$export$2c4e825dc9120f87).graphql((0, $6135f73f4616c1d5$export$78930a3b816845f9)(this.getFunc, {
                                id: id
                            }))
                        ];
                    case 3:
                        apiData = _a.sent();
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        return [
                            2,
                            apiData.data[this.getName]
                        ];
                    case 4:
                        error_2 = _a.sent();
                        this.handleError(error_2);
                        if (navigation) navigation(this.route);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
    };
    UtilFuncAPIs.prototype.custom_call = function(navigation, func, filter, funcName) {
        return $85c3021a0318976c$var$__awaiter(this, void 0, Promise, function() {
            var apiData, error_3;
            return $85c3021a0318976c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        (0, $de77e498e07914bf$export$b410431fab84fa58).loading("Processing...");
                        if (!navigation) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0, $02b369573055e688$export$2e2bcd8739ae039)(navigation)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $cd347cc85afbaa02$export$2c4e825dc9120f87).graphql({
                                query: func,
                                variables: filter,
                                authMode: "API_KEY"
                            })
                        ];
                    case 3:
                        apiData = _a.sent();
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        return [
                            2,
                            apiData.data[funcName]
                        ];
                    case 4:
                        error_3 = _a.sent();
                        this.handleError(error_3);
                        if (navigation) navigation(this.route);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
    };
    UtilFuncAPIs.prototype.delete = function(navigation, id) {
        return $85c3021a0318976c$var$__awaiter(this, void 0, Promise, function() {
            var input, authMode, error_4;
            return $85c3021a0318976c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            6,
                            ,
                            7
                        ]);
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        (0, $de77e498e07914bf$export$b410431fab84fa58).loading("Processing...");
                        if (!navigation) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0, $02b369573055e688$export$2e2bcd8739ae039)(navigation)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        input = {
                            id: id
                        };
                        authMode = {
                            authMode: "AMAZON_COGNITO_USER_POOLS"
                        };
                        if (!navigation) authMode = {};
                        return [
                            4,
                            (0, $cd347cc85afbaa02$export$2c4e825dc9120f87).graphql($85c3021a0318976c$var$__assign({
                                query: this.deleteFunc,
                                variables: {
                                    input: input
                                }
                            }, authMode))
                        ];
                    case 3:
                        _a.sent();
                        return [
                            4,
                            this.cacheFunc.removeItem()
                        ];
                    case 4:
                        _a.sent();
                        return [
                            4,
                            (0, $e202af6739f6b19f$export$2e2bcd8739ae039).update({
                                type: "delete",
                                table: this.backupTable,
                                data: {
                                    id: id
                                }
                            })
                        ];
                    case 5:
                        _a.sent();
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        (0, $de77e498e07914bf$export$b410431fab84fa58).success(this.deleteMSG);
                        return [
                            2,
                            true
                        ];
                    case 6:
                        error_4 = _a.sent();
                        this.handleError(error_4);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        return [
                            2,
                            false
                        ];
                }
            });
        });
    };
    UtilFuncAPIs.prototype.save = function(navigation, input, doNotShowMessage) {
        return $85c3021a0318976c$var$__awaiter(this, void 0, Promise, function() {
            var user, authMode, response, error_5;
            return $85c3021a0318976c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            7,
                            ,
                            8
                        ]);
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        (0, $de77e498e07914bf$export$b410431fab84fa58).loading("Processing...");
                        if (!navigation) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0, $02b369573055e688$export$2e2bcd8739ae039)(navigation)
                        ];
                    case 1:
                        user = _a.sent();
                        input.createdBy = user.username;
                        input.updatedBy = user.username;
                        _a.label = 2;
                    case 2:
                        if (this.key) input.key = this.key;
                        input.createdAt = new Date().toISOString();
                        input.updatedAt = new Date().toISOString();
                        authMode = {
                            authMode: "AMAZON_COGNITO_USER_POOLS"
                        };
                        if (!navigation) authMode = {};
                        return [
                            4,
                            (0, $cd347cc85afbaa02$export$2c4e825dc9120f87).graphql($85c3021a0318976c$var$__assign({
                                query: this.insertFunc,
                                variables: {
                                    input: input
                                }
                            }, authMode))
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            4,
                            (0, $e202af6739f6b19f$export$2e2bcd8739ae039).update({
                                type: "insert",
                                table: this.backupTable,
                                id: response.data[this.insertFunc]
                            })
                        ];
                    case 4:
                        _a.sent();
                        if (!this.cacheFunc) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            this.cacheFunc.removeItem()
                        ];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        if (!doNotShowMessage) (0, $de77e498e07914bf$export$b410431fab84fa58).success(this.insertMSG);
                        if (navigation) navigation(this.route);
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        error_5 = _a.sent();
                        this.handleError(error_5, input);
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    UtilFuncAPIs.prototype.update = function(navigation, data, updateInput) {
        return $85c3021a0318976c$var$__awaiter(this, void 0, Promise, function() {
            var user, input, authMode, error_6;
            return $85c3021a0318976c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            7,
                            ,
                            8
                        ]);
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        (0, $de77e498e07914bf$export$b410431fab84fa58).loading("Processing...");
                        if (!navigation) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0, $02b369573055e688$export$2e2bcd8739ae039)(navigation)
                        ];
                    case 1:
                        user = _a.sent();
                        data.updatedBy = user.username;
                        _a.label = 2;
                    case 2:
                        Object.keys(data).forEach(function(key) {
                            if (updateInput[key]) data[key] = updateInput[key];
                        });
                        delete data.__typename;
                        if (this.key) data.key = this.key;
                        data.updatedAt = new Date().toISOString();
                        input = data;
                        authMode = {
                            authMode: "AMAZON_COGNITO_USER_POOLS"
                        };
                        if (!navigation) authMode = {};
                        return [
                            4,
                            (0, $cd347cc85afbaa02$export$2c4e825dc9120f87).graphql($85c3021a0318976c$var$__assign({
                                query: this.updateFunc,
                                variables: {
                                    input: input
                                }
                            }, authMode))
                        ];
                    case 3:
                        _a.sent();
                        return [
                            4,
                            (0, $e202af6739f6b19f$export$2e2bcd8739ae039).update({
                                type: "update",
                                table: this.backupTable,
                                data: {
                                    updateInput: updateInput
                                }
                            })
                        ];
                    case 4:
                        _a.sent();
                        if (!this.cacheFunc) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            this.cacheFunc.removeItem()
                        ];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        if (navigation) navigation(this.route);
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        (0, $de77e498e07914bf$export$b410431fab84fa58).success(this.updateMSG);
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        error_6 = _a.sent();
                        this.handleError(error_6, updateInput);
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return UtilFuncAPIs;
}();
var $85c3021a0318976c$export$2e2bcd8739ae039 = $85c3021a0318976c$var$UtilFuncAPIs;


var $febd7c6e52a5fe25$var$CMSMenusAPI = new (0, $85c3021a0318976c$export$2e2bcd8739ae039)({
    ref: "CMSMenusAPI",
    cacheFunc: (0, $9d45be0f6beae26c$export$2e2bcd8739ae039),
    filter: {
        key: "CMS_Menus",
        sortDirection: "ASC"
    },
    listFunc: (0, $d819d0cbe64233c2$export$63f076abd9302a21),
    getFunc: (0, $d819d0cbe64233c2$export$ea8112eca8241c4a),
    route: "/members/cms/menus",
    insertFunc: (0, $7a1d5ab68f58f51c$export$297e33b795426edf),
    updateFunc: (0, $7a1d5ab68f58f51c$export$f9f56aa8f6d1864),
    deleteFunc: (0, $7a1d5ab68f58f51c$export$7fd69839f318f0ed),
    backupTable: "cms_head_scripts",
    deleteMSG: "Menu deleted",
    insertMSG: "Menu saved",
    updateMSG: "Menu updated",
    key: "CMS_Menus",
    getName: "getCMSMenus"
});
var $febd7c6e52a5fe25$export$2e2bcd8739ae039 = $febd7c6e52a5fe25$var$CMSMenusAPI;


var $e74eb2e0679e897b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e74eb2e0679e897b$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $e74eb2e0679e897b$var$FormMenu = function(_a) {
    var _b;
    var navigatePage = _a.navigatePage, urlParams = _a.urlParams;
    var _c = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false), loading = _c[0], setLoading = _c[1];
    var _d = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(Date.now()), key = _d[0], setKey = _d[1];
    var formConfig = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef([
        {
            name: "menu",
            label: "Menu",
            fieldType: "input",
            isRequired: true,
            validations: {
                type: "input",
                required: true,
                customMessages: {
                    required: "Menu can't be blank."
                }
            }
        }
    ]);
    var record = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        if (urlParams.id) reloadFunc().then();
    }, []);
    var reloadFunc = function() {
        return $e74eb2e0679e897b$var$__awaiter(void 0, void 0, Promise, function() {
            var _a, i;
            var _b;
            return $e74eb2e0679e897b$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        setLoading(true);
                        _a = record;
                        return [
                            4,
                            (0, $febd7c6e52a5fe25$export$2e2bcd8739ae039).get(navigatePage, (_b = urlParams.id) !== null && _b !== void 0 ? _b : "")
                        ];
                    case 1:
                        _a.current = _c.sent();
                        for(i = 0; i < formConfig.current.length; i++)formConfig.current[i].value = record.current[formConfig.current[i].name];
                        setLoading(false);
                        setKey(Date.now());
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var handleFormSubmit = function(data) {
        return $e74eb2e0679e897b$var$__awaiter(void 0, void 0, void 0, function() {
            return $e74eb2e0679e897b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        setLoading(true);
                        if (!urlParams.id) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0, $febd7c6e52a5fe25$export$2e2bcd8739ae039).update(navigatePage, record.current, data)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            (0, $febd7c6e52a5fe25$export$2e2bcd8739ae039).save(navigatePage, data)
                        ];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        setLoading(false);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, {
        key: key
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $391db0dc72f5c1c4$export$2e2bcd8739ae039), {
        fields: (_b = formConfig.current) !== null && _b !== void 0 ? _b : [],
        onSubmit: handleFormSubmit,
        submitButtonText: urlParams.id ? "Update" : "Save",
        doShowCardHeader: true,
        reloadFunc: urlParams.id ? reloadFunc : undefined,
        title: urlParams.id ? "Update Menu" : "New Manu",
        loading: loading
    }));
};
var $e74eb2e0679e897b$export$2e2bcd8739ae039 = $e74eb2e0679e897b$var$FormMenu;



var $7fPBF = parcelRequire("7fPBF");

var $03d8b6da908e0eb9$exports = {};
"use strict";
"use client";

Object.defineProperty($03d8b6da908e0eb9$exports, "__esModule", {
    value: true
});
$03d8b6da908e0eb9$exports.default = void 0;

var $03d8b6da908e0eb9$var$_createSvgIcon = $4657741705a128f0$exports((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $03d8b6da908e0eb9$var$_default = (0, $03d8b6da908e0eb9$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), "Edit");
$03d8b6da908e0eb9$exports.default = $03d8b6da908e0eb9$var$_default;


var $59f8877c56368b42$exports = {};
"use strict";
"use client";

Object.defineProperty($59f8877c56368b42$exports, "__esModule", {
    value: true
});
$59f8877c56368b42$exports.default = void 0;

var $59f8877c56368b42$var$_createSvgIcon = $4657741705a128f0$exports((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $59f8877c56368b42$var$_default = (0, $59f8877c56368b42$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), "Delete");
$59f8877c56368b42$exports.default = $59f8877c56368b42$var$_default;



var $75e4617f17b5a476$exports = {};
"use strict";
"use client";

Object.defineProperty($75e4617f17b5a476$exports, "__esModule", {
    value: true
});
$75e4617f17b5a476$exports.default = void 0;

var $75e4617f17b5a476$var$_createSvgIcon = $4657741705a128f0$exports((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $75e4617f17b5a476$var$_default = (0, $75e4617f17b5a476$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M8 5v14l11-7z"
}), "PlayArrow");
$75e4617f17b5a476$exports.default = $75e4617f17b5a476$var$_default;


var $46c12d7a126b51c1$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $46c12d7a126b51c1$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $46c12d7a126b51c1$var$Menus = function(_a) {
    var navigatePage = _a.navigatePage;
    var _b = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState([]), record = _b[0], setRecord = _b[1];
    var loadRecords = function(refreshCache, page) {
        return $46c12d7a126b51c1$var$__awaiter(void 0, void 0, Promise, function() {
            var _a;
            return $46c12d7a126b51c1$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = setRecord;
                        return [
                            4,
                            (0, $febd7c6e52a5fe25$export$2e2bcd8739ae039).getList(navigatePage, refreshCache, 1)
                        ];
                    case 1:
                        _a.apply(void 0, [
                            _b.sent()
                        ]);
                        return [
                            4,
                            (0, $febd7c6e52a5fe25$export$2e2bcd8739ae039).getPageNumbers()
                        ];
                    case 2:
                        return [
                            2,
                            _b.sent()
                        ];
                }
            });
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $97914e663a317172$export$2e2bcd8739ae039), {
        sm: 6,
        itemProps: [
            {
                type: "data",
                key: "menu",
                text: "menu"
            }
        ],
        items: record,
        itemActions: [
            {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($03d8b6da908e0eb9$exports))), {
                    color: "primary"
                }),
                handler: function(id) {
                    return $46c12d7a126b51c1$var$__awaiter(void 0, void 0, void 0, function() {
                        return $46c12d7a126b51c1$var$__generator(this, function(_a) {
                            navigatePage("/members/cms/menus/update/" + id);
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                }
            },
            {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($59f8877c56368b42$exports))), {
                    color: "primary"
                }),
                handler: function(id) {
                    return $46c12d7a126b51c1$var$__awaiter(void 0, void 0, void 0, function() {
                        return $46c12d7a126b51c1$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    return [
                                        4,
                                        (0, $febd7c6e52a5fe25$export$2e2bcd8739ae039).delete(navigatePage, id)
                                    ];
                                case 1:
                                    if (!_a.sent()) return [
                                        3,
                                        3
                                    ];
                                    return [
                                        4,
                                        loadRecords(false, 1)
                                    ];
                                case 2:
                                    _a.sent();
                                    _a.label = 3;
                                case 3:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                }
            },
            {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($75e4617f17b5a476$exports))), {
                    color: "primary"
                }),
                handler: function(id) {
                    return $46c12d7a126b51c1$var$__awaiter(void 0, void 0, void 0, function() {
                        return $46c12d7a126b51c1$var$__generator(this, function(_a) {
                            navigatePage("/members/cms/menus/play/" + id);
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                }
            }
        ],
        addInfo: {
            text: "Menu",
            handler: function() {
                navigatePage("add");
            }
        },
        actionID: "id",
        loadRecords: loadRecords,
        doShowCardHeader: true,
        doShowTableHeader: true
    });
};
var $46c12d7a126b51c1$export$2e2bcd8739ae039 = $46c12d7a126b51c1$var$Menus;



var $7fPBF = parcelRequire("7fPBF");


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");



var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $hngXp = parcelRequire("hngXp");




var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $kjiCM = parcelRequire("kjiCM");




var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $f1998ac7e19a4022$export$5162da8f798e0959(slot) {
    return (0, $k6RDS.default)("MuiCollapse", slot);
}
const $f1998ac7e19a4022$var$collapseClasses = (0, $4jzsB.default)("MuiCollapse", [
    "root",
    "horizontal",
    "vertical",
    "entered",
    "hidden",
    "wrapper",
    "wrapperInner"
]);
var $f1998ac7e19a4022$export$2e2bcd8739ae039 = $f1998ac7e19a4022$var$collapseClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $6207032cc256a7e6$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $6207032cc256a7e6$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `${orientation}`
        ],
        entered: [
            "entered"
        ],
        hidden: [
            "hidden"
        ],
        wrapper: [
            "wrapper",
            `${orientation}`
        ],
        wrapperInner: [
            "wrapperInner",
            `${orientation}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $f1998ac7e19a4022$export$5162da8f798e0959), classes);
};
const $6207032cc256a7e6$var$CollapseRoot = (0, $kDBhE.default)("div", {
    name: "MuiCollapse",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === "entered" && styles.entered,
            ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        height: 0,
        overflow: "hidden",
        transition: theme.transitions.create("height")
    }, ownerState.orientation === "horizontal" && {
        height: "auto",
        width: 0,
        transition: theme.transitions.create("width")
    }, ownerState.state === "entered" && (0, $kY3Ke.default)({
        height: "auto",
        overflow: "visible"
    }, ownerState.orientation === "horizontal" && {
        width: "auto"
    }), ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && {
        visibility: "hidden"
    }));
const $6207032cc256a7e6$var$CollapseWrapper = (0, $kDBhE.default)("div", {
    name: "MuiCollapse",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: "flex",
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
const $6207032cc256a7e6$var$CollapseWrapperInner = (0, $kDBhE.default)("div", {
    name: "MuiCollapse",
    slot: "WrapperInner",
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $6207032cc256a7e6$var$Collapse = /*#__PURE__*/ $7fPBF.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiCollapse"
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = "0px", component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = "vertical", style: style, timeout: timeout = (0, $kjiCM.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $623678cbb6daf054$export$2e2bcd8739ae039) } = props, other = (0, $cFLic.default)(props, $6207032cc256a7e6$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $6207032cc256a7e6$var$useUtilityClasses(ownerState);
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const timer = $7fPBF.useRef();
    const wrapperRef = $7fPBF.useRef(null);
    const autoTransitionDuration = $7fPBF.useRef();
    const collapsedSize = typeof collapsedSizeProp === "number" ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === "horizontal";
    const size = isHorizontal ? "width" : "height";
    $7fPBF.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    const nodeRef = $7fPBF.useRef(null);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? "clientWidth" : "clientHeight"] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = "absolute";
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = "";
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        if (timeout === "auto") {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = "auto";
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        if (timeout === "auto") {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.current = setTimeout(next, autoTransitionDuration.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $bbzbN.jsx)($6207032cc256a7e6$var$CollapseRoot, (0, $kY3Ke.default)({
                as: component,
                className: (0, $hngXp.default)(classes.root, className, {
                    "entered": classes.entered,
                    "exited": !inProp && collapsedSize === "0px" && classes.hidden
                }[state]),
                style: (0, $kY3Ke.default)({
                    [isHorizontal ? "minWidth" : "minHeight"]: collapsedSize
                }, style),
                ownerState: (0, $kY3Ke.default)({}, ownerState, {
                    state: state
                }),
                ref: handleRef
            }, childProps, {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)($6207032cc256a7e6$var$CollapseWrapper, {
                    ownerState: (0, $kY3Ke.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)($6207032cc256a7e6$var$CollapseWrapperInner, {
                        ownerState: (0, $kY3Ke.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$6207032cc256a7e6$var$Collapse.muiSupportAuto = true;
var $6207032cc256a7e6$export$2e2bcd8739ae039 = $6207032cc256a7e6$var$Collapse;




var $7fPBF = parcelRequire("7fPBF");
"use client";
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $5a1af90f4ba984a4$var$AccordionContext = /*#__PURE__*/ $7fPBF.createContext({});
var $5a1af90f4ba984a4$export$2e2bcd8739ae039 = $5a1af90f4ba984a4$var$AccordionContext;




var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $163963791cd5489f$export$80fb6a2cb3f13b8b(slot) {
    return (0, $k6RDS.default)("MuiAccordion", slot);
}
const $163963791cd5489f$var$accordionClasses = (0, $4jzsB.default)("MuiAccordion", [
    "root",
    "rounded",
    "expanded",
    "disabled",
    "gutters",
    "region"
]);
var $163963791cd5489f$export$2e2bcd8739ae039 = $163963791cd5489f$var$accordionClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $e9f205f7f0ba8e26$var$_excluded = [
    "children",
    "className",
    "defaultExpanded",
    "disabled",
    "disableGutters",
    "expanded",
    "onChange",
    "square",
    "TransitionComponent",
    "TransitionProps"
];
const $e9f205f7f0ba8e26$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, square: square, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            "root",
            !square && "rounded",
            expanded && "expanded",
            disabled && "disabled",
            !disableGutters && "gutters"
        ],
        region: [
            "region"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $163963791cd5489f$export$80fb6a2cb3f13b8b), classes);
};
const $e9f205f7f0ba8e26$var$AccordionRoot = (0, $kDBhE.default)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: "MuiAccordion",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $163963791cd5489f$export$2e2bcd8739ae039).region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: "relative",
        transition: theme.transitions.create([
            "margin"
        ], transition),
        overflowAnchor: "none",
        // Keep the same scrolling position
        "&:before": {
            position: "absolute",
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: (theme.vars || theme).palette.divider,
            transition: theme.transitions.create([
                "opacity",
                "background-color"
            ], transition)
        },
        "&:first-of-type": {
            "&:before": {
                display: "none"
            }
        },
        [`&.${(0, $163963791cd5489f$export$2e2bcd8739ae039).expanded}`]: {
            "&:before": {
                opacity: 0
            },
            "&:first-of-type": {
                marginTop: 0
            },
            "&:last-of-type": {
                marginBottom: 0
            },
            "& + &": {
                "&:before": {
                    display: "none"
                }
            }
        },
        [`&.${(0, $163963791cd5489f$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    };
}, ({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, !ownerState.square && {
        borderRadius: 0,
        "&:first-of-type": {
            borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
            borderTopRightRadius: (theme.vars || theme).shape.borderRadius
        },
        "&:last-of-type": {
            borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
            borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
            // Fix a rendering issue on Edge
            "@supports (-ms-ime-align: auto)": {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0
            }
        }
    }, !ownerState.disableGutters && {
        [`&.${(0, $163963791cd5489f$export$2e2bcd8739ae039).expanded}`]: {
            margin: "16px 0"
        }
    }));
const $e9f205f7f0ba8e26$var$Accordion = /*#__PURE__*/ $7fPBF.forwardRef(function Accordion(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiAccordion"
    });
    const { children: childrenProp, className: className, defaultExpanded: defaultExpanded = false, disabled: disabled = false, disableGutters: disableGutters = false, expanded: expandedProp, onChange: onChange, square: square = false, TransitionComponent: TransitionComponent = (0, $6207032cc256a7e6$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $cFLic.default)(props, $e9f205f7f0ba8e26$var$_excluded);
    const [expanded, setExpandedState] = (0, $3b64539a8a5729fa$export$2e2bcd8739ae039)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: "Accordion",
        state: "expanded"
    });
    const handleChange = $7fPBF.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = $7fPBF.Children.toArray(childrenProp);
    const contextValue = $7fPBF.useMemo(()=>({
            expanded: expanded,
            disabled: disabled,
            disableGutters: disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        square: square,
        disabled: disabled,
        disableGutters: disableGutters,
        expanded: expanded
    });
    const classes = $e9f205f7f0ba8e26$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($e9f205f7f0ba8e26$var$AccordionRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        square: square
    }, other, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5a1af90f4ba984a4$export$2e2bcd8739ae039).Provider, {
                value: contextValue,
                children: summary
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
                in: expanded,
                timeout: "auto"
            }, TransitionProps, {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    "aria-labelledby": summary.props.id,
                    id: summary.props["aria-controls"],
                    role: "region",
                    className: classes.region,
                    children: children
                })
            }))
        ]
    }));
});
var $e9f205f7f0ba8e26$export$2e2bcd8739ae039 = $e9f205f7f0ba8e26$var$Accordion;


var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $23907523cf37a860$export$a6afb527becfac26(slot) {
    return (0, $k6RDS.default)("MuiAccordionDetails", slot);
}
const $23907523cf37a860$var$accordionDetailsClasses = (0, $4jzsB.default)("MuiAccordionDetails", [
    "root"
]);
var $23907523cf37a860$export$2e2bcd8739ae039 = $23907523cf37a860$var$accordionDetailsClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $a33ac73601ffa184$var$_excluded = [
    "className"
];
const $a33ac73601ffa184$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $23907523cf37a860$export$a6afb527becfac26), classes);
};
const $a33ac73601ffa184$var$AccordionDetailsRoot = (0, $kDBhE.default)("div", {
    name: "MuiAccordionDetails",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        padding: theme.spacing(1, 2, 2)
    }));
const $a33ac73601ffa184$var$AccordionDetails = /*#__PURE__*/ $7fPBF.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiAccordionDetails"
    });
    const { className: className } = props, other = (0, $cFLic.default)(props, $a33ac73601ffa184$var$_excluded);
    const ownerState = props;
    const classes = $a33ac73601ffa184$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($a33ac73601ffa184$var$AccordionDetailsRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $a33ac73601ffa184$export$2e2bcd8739ae039 = $a33ac73601ffa184$var$AccordionDetails;


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");



var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $e30a7f2c0637be93$export$282216ad123d6580(slot) {
    return (0, $k6RDS.default)("MuiAccordionSummary", slot);
}
const $e30a7f2c0637be93$var$accordionSummaryClasses = (0, $4jzsB.default)("MuiAccordionSummary", [
    "root",
    "expanded",
    "focusVisible",
    "disabled",
    "gutters",
    "contentGutters",
    "content",
    "expandIconWrapper"
]);
var $e30a7f2c0637be93$export$2e2bcd8739ae039 = $e30a7f2c0637be93$var$accordionSummaryClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $4dadc25f7bb7b60a$var$_excluded = [
    "children",
    "className",
    "expandIcon",
    "focusVisibleClassName",
    "onClick"
];
const $4dadc25f7bb7b60a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            "root",
            expanded && "expanded",
            disabled && "disabled",
            !disableGutters && "gutters"
        ],
        focusVisible: [
            "focusVisible"
        ],
        content: [
            "content",
            expanded && "expanded",
            !disableGutters && "contentGutters"
        ],
        expandIconWrapper: [
            "expandIconWrapper",
            expanded && "expanded"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $e30a7f2c0637be93$export$282216ad123d6580), classes);
};
const $4dadc25f7bb7b60a$var$AccordionSummaryRoot = (0, $kDBhE.default)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    name: "MuiAccordionSummary",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return (0, $kY3Ke.default)({
        display: "flex",
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            "min-height",
            "background-color"
        ], transition),
        [`&.${(0, $e30a7f2c0637be93$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $e30a7f2c0637be93$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`&:hover:not(.${(0, $e30a7f2c0637be93$export$2e2bcd8739ae039).disabled})`]: {
            cursor: "pointer"
        }
    }, !ownerState.disableGutters && {
        [`&.${(0, $e30a7f2c0637be93$export$2e2bcd8739ae039).expanded}`]: {
            minHeight: 64
        }
    });
});
const $4dadc25f7bb7b60a$var$AccordionSummaryContent = (0, $kDBhE.default)("div", {
    name: "MuiAccordionSummary",
    slot: "Content",
    overridesResolver: (props, styles)=>styles.content
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "flex",
        flexGrow: 1,
        margin: "12px 0"
    }, !ownerState.disableGutters && {
        transition: theme.transitions.create([
            "margin"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $e30a7f2c0637be93$export$2e2bcd8739ae039).expanded}`]: {
            margin: "20px 0"
        }
    }));
const $4dadc25f7bb7b60a$var$AccordionSummaryExpandIconWrapper = (0, $kDBhE.default)("div", {
    name: "MuiAccordionSummary",
    slot: "ExpandIconWrapper",
    overridesResolver: (props, styles)=>styles.expandIconWrapper
})(({ theme: theme })=>({
        display: "flex",
        color: (theme.vars || theme).palette.action.active,
        transform: "rotate(0deg)",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $e30a7f2c0637be93$export$2e2bcd8739ae039).expanded}`]: {
            transform: "rotate(180deg)"
        }
    }));
const $4dadc25f7bb7b60a$var$AccordionSummary = /*#__PURE__*/ $7fPBF.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiAccordionSummary"
    });
    const { children: children, className: className, expandIcon: expandIcon, focusVisibleClassName: focusVisibleClassName, onClick: onClick } = props, other = (0, $cFLic.default)(props, $4dadc25f7bb7b60a$var$_excluded);
    const { disabled: disabled = false, disableGutters: disableGutters, expanded: expanded, toggle: toggle } = $7fPBF.useContext((0, $5a1af90f4ba984a4$export$2e2bcd8739ae039));
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = (0, $kY3Ke.default)({}, props, {
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters
    });
    const classes = $4dadc25f7bb7b60a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($4dadc25f7bb7b60a$var$AccordionSummaryRoot, (0, $kY3Ke.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, $hngXp.default)(classes.root, className),
        focusVisibleClassName: (0, $hngXp.default)(classes.focusVisible, focusVisibleClassName),
        onClick: handleChange,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($4dadc25f7bb7b60a$var$AccordionSummaryContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, $bbzbN.jsx)($4dadc25f7bb7b60a$var$AccordionSummaryExpandIconWrapper, {
                className: classes.expandIconWrapper,
                ownerState: ownerState,
                children: expandIcon
            })
        ]
    }));
});
var $4dadc25f7bb7b60a$export$2e2bcd8739ae039 = $4dadc25f7bb7b60a$var$AccordionSummary;



var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $8825e02edbe1c553$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), "Delete");


var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $46c29ed3341f7225$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");




var $bbzbN = parcelRequire("bbzbN");
function $505ebcb184373782$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $505ebcb184373782$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $505ebcb184373782$export$2e2bcd8739ae039(o);
}



function $27f18dd8fc16da3b$export$2e2bcd8739ae039(input, hint) {
    if ((0, $505ebcb184373782$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $505ebcb184373782$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $7fddabb4b045308c$export$2e2bcd8739ae039(arg) {
    var key = (0, $27f18dd8fc16da3b$export$2e2bcd8739ae039)(arg, "string");
    return (0, $505ebcb184373782$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $a155b5e75cfe9a4d$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $7fddabb4b045308c$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $8273a87573256c54$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8273a87573256c54$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8273a87573256c54$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8273a87573256c54$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $71488736b7fc99c4$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $71488736b7fc99c4$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $71488736b7fc99c4$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $71488736b7fc99c4$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $71488736b7fc99c4$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $71488736b7fc99c4$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $71488736b7fc99c4$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $71488736b7fc99c4$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $71488736b7fc99c4$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($71488736b7fc99c4$var$isDate(val)) return "date";
    if ($71488736b7fc99c4$var$isError(val)) return "error";
    var constructorName = $71488736b7fc99c4$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $71488736b7fc99c4$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $71488736b7fc99c4$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $71488736b7fc99c4$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $71488736b7fc99c4$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $71488736b7fc99c4$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(1));
        return enhancer($71488736b7fc99c4$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$71488736b7fc99c4$var$isPlainObject(action)) throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $71488736b7fc99c4$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$71488736b7fc99c4$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $71488736b7fc99c4$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$71488736b7fc99c4$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $71488736b7fc99c4$export$8928921ea2d3b126 = $71488736b7fc99c4$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $71488736b7fc99c4$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $71488736b7fc99c4$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $71488736b7fc99c4$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$71488736b7fc99c4$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $71488736b7fc99c4$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $71488736b7fc99c4$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $71488736b7fc99c4$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $71488736b7fc99c4$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $71488736b7fc99c4$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $71488736b7fc99c4$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $71488736b7fc99c4$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $71488736b7fc99c4$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $71488736b7fc99c4$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $71488736b7fc99c4$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $71488736b7fc99c4$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $71488736b7fc99c4$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $71488736b7fc99c4$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $71488736b7fc99c4$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ 
var $4ZL0H = parcelRequire("4ZL0H");
function $6b6d471b1ffae726$export$f5708dca728d7177(condition, format, ...args) {
    if ($6b6d471b1ffae726$var$isProduction()) {
        if (format === undefined) throw new Error("invariant requires an error message argument");
    }
    if (!condition) {
        let error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            let argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1 // we don't care about invariant's own frame
        ;
        throw error;
    }
}
function $6b6d471b1ffae726$var$isProduction() {
    return typeof $4ZL0H !== "undefined" && true;
}


// cheap lodash replacements
/**
 * drop-in replacement for _.get
 * @param obj
 * @param path
 * @param defaultValue
 */ function $f4e1caca2f23e260$export$3988ae62b71be9a3(obj, path, defaultValue) {
    return path.split(".").reduce((a, c)=>a && a[c] ? a[c] : defaultValue || null, obj);
}
function $f4e1caca2f23e260$export$5d14bf425b37f49e(items, item) {
    return items.filter((i)=>i !== item);
}
function $f4e1caca2f23e260$export$844ec244b1367d54(input) {
    return typeof input === "string";
}
function $f4e1caca2f23e260$export$a6cdc56e425d0d0a(input) {
    return typeof input === "object";
}
function $f4e1caca2f23e260$export$6444ef5cd411280c(itemsA, itemsB) {
    const map = new Map();
    const insertItem = (item)=>{
        map.set(item, map.has(item) ? map.get(item) + 1 : 1);
    };
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    map.forEach((count, key)=>{
        if (count === 1) result.push(key);
    });
    return result;
}
function $f4e1caca2f23e260$export$bc86dfbf7795668c(itemsA, itemsB) {
    return itemsA.filter((t)=>itemsB.indexOf(t) > -1);
}


const $d4c965cb1b450ebf$export$3fc3a33e48b33945 = "dnd-core/INIT_COORDS";
const $d4c965cb1b450ebf$export$98f9b4193e6b55e6 = "dnd-core/BEGIN_DRAG";
const $d4c965cb1b450ebf$export$22d1d88e2de0d0e0 = "dnd-core/PUBLISH_DRAG_SOURCE";
const $d4c965cb1b450ebf$export$9d358706ccac3727 = "dnd-core/HOVER";
const $d4c965cb1b450ebf$export$b4af72c40fd57063 = "dnd-core/DROP";
const $d4c965cb1b450ebf$export$d300627d16aeb9cc = "dnd-core/END_DRAG";


function $6260e5d71855dc33$export$844048139dfc906d(clientOffset, sourceClientOffset) {
    return {
        type: (0, $d4c965cb1b450ebf$export$3fc3a33e48b33945),
        payload: {
            sourceClientOffset: sourceClientOffset || null,
            clientOffset: clientOffset || null
        }
    };
}



const $5e0013d7d92f5565$var$ResetCoordinatesAction = {
    type: (0, $d4c965cb1b450ebf$export$3fc3a33e48b33945),
    payload: {
        clientOffset: null,
        sourceClientOffset: null
    }
};
function $5e0013d7d92f5565$export$d6542eb0d76867d6(manager) {
    return function beginDrag(sourceIds = [], options = {
        publishSource: true
    }) {
        const { publishSource: publishSource = true, clientOffset: clientOffset, getSourceClientOffset: getSourceClientOffset } = options;
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        // Initialize the coordinates using the client offset
        manager.dispatch((0, $6260e5d71855dc33$export$844048139dfc906d)(clientOffset));
        $5e0013d7d92f5565$var$verifyInvariants(sourceIds, monitor, registry);
        // Get the draggable source
        const sourceId = $5e0013d7d92f5565$var$getDraggableSource(sourceIds, monitor);
        if (sourceId == null) {
            manager.dispatch($5e0013d7d92f5565$var$ResetCoordinatesAction);
            return;
        }
        // Get the source client offset
        let sourceClientOffset = null;
        if (clientOffset) {
            if (!getSourceClientOffset) throw new Error("getSourceClientOffset must be defined");
            $5e0013d7d92f5565$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
            sourceClientOffset = getSourceClientOffset(sourceId);
        }
        // Initialize the full coordinates
        manager.dispatch((0, $6260e5d71855dc33$export$844048139dfc906d)(clientOffset, sourceClientOffset));
        const source = registry.getSource(sourceId);
        const item = source.beginDrag(monitor, sourceId);
        // If source.beginDrag returns null, this is an indicator to cancel the drag
        if (item == null) return undefined;
        $5e0013d7d92f5565$var$verifyItemIsObject(item);
        registry.pinSource(sourceId);
        const itemType = registry.getSourceType(sourceId);
        return {
            type: (0, $d4c965cb1b450ebf$export$98f9b4193e6b55e6),
            payload: {
                itemType: itemType,
                item: item,
                sourceId: sourceId,
                clientOffset: clientOffset || null,
                sourceClientOffset: sourceClientOffset || null,
                isSourcePublic: !!publishSource
            }
        };
    };
}
function $5e0013d7d92f5565$var$verifyInvariants(sourceIds, monitor, registry) {
    (0, $6b6d471b1ffae726$export$f5708dca728d7177)(!monitor.isDragging(), "Cannot call beginDrag while dragging.");
    sourceIds.forEach(function(sourceId) {
        (0, $6b6d471b1ffae726$export$f5708dca728d7177)(registry.getSource(sourceId), "Expected sourceIds to be registered.");
    });
}
function $5e0013d7d92f5565$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
    (0, $6b6d471b1ffae726$export$f5708dca728d7177)(typeof getSourceClientOffset === "function", "When clientOffset is provided, getSourceClientOffset must be a function.");
}
function $5e0013d7d92f5565$var$verifyItemIsObject(item) {
    (0, $6b6d471b1ffae726$export$f5708dca728d7177)((0, $f4e1caca2f23e260$export$a6cdc56e425d0d0a)(item), "Item must be an object.");
}
function $5e0013d7d92f5565$var$getDraggableSource(sourceIds, monitor) {
    let sourceId = null;
    for(let i = sourceIds.length - 1; i >= 0; i--)if (monitor.canDragSource(sourceIds[i])) {
        sourceId = sourceIds[i];
        break;
    }
    return sourceId;
}





function $687be4cb0aa22b77$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $687be4cb0aa22b77$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $687be4cb0aa22b77$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $687be4cb0aa22b77$export$9f5cbae8d079dda0(manager) {
    return function drop(options = {}) {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        $687be4cb0aa22b77$var$verifyInvariants(monitor);
        const targetIds = $687be4cb0aa22b77$var$getDroppableTargets(monitor);
        // Multiple actions are dispatched here, which is why this doesn't return an action
        targetIds.forEach((targetId, index)=>{
            const dropResult = $687be4cb0aa22b77$var$determineDropResult(targetId, index, registry, monitor);
            const action = {
                type: (0, $d4c965cb1b450ebf$export$b4af72c40fd57063),
                payload: {
                    dropResult: $687be4cb0aa22b77$var$_objectSpread({}, options, dropResult)
                }
            };
            manager.dispatch(action);
        });
    };
}
function $687be4cb0aa22b77$var$verifyInvariants(monitor) {
    (0, $6b6d471b1ffae726$export$f5708dca728d7177)(monitor.isDragging(), "Cannot call drop while not dragging.");
    (0, $6b6d471b1ffae726$export$f5708dca728d7177)(!monitor.didDrop(), "Cannot call drop twice during one drag operation.");
}
function $687be4cb0aa22b77$var$determineDropResult(targetId, index, registry, monitor) {
    const target = registry.getTarget(targetId);
    let dropResult = target ? target.drop(monitor, targetId) : undefined;
    $687be4cb0aa22b77$var$verifyDropResultType(dropResult);
    if (typeof dropResult === "undefined") dropResult = index === 0 ? {} : monitor.getDropResult();
    return dropResult;
}
function $687be4cb0aa22b77$var$verifyDropResultType(dropResult) {
    (0, $6b6d471b1ffae726$export$f5708dca728d7177)(typeof dropResult === "undefined" || (0, $f4e1caca2f23e260$export$a6cdc56e425d0d0a)(dropResult), "Drop result must either be an object or undefined.");
}
function $687be4cb0aa22b77$var$getDroppableTargets(monitor) {
    const targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
    targetIds.reverse();
    return targetIds;
}




function $a43e1f81e6415f70$export$2f5c7d4805260fdf(manager) {
    return function endDrag() {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        $a43e1f81e6415f70$var$verifyIsDragging(monitor);
        const sourceId = monitor.getSourceId();
        if (sourceId != null) {
            const source = registry.getSource(sourceId, true);
            source.endDrag(monitor, sourceId);
            registry.unpinSource();
        }
        return {
            type: (0, $d4c965cb1b450ebf$export$d300627d16aeb9cc)
        };
    };
}
function $a43e1f81e6415f70$var$verifyIsDragging(monitor) {
    (0, $6b6d471b1ffae726$export$f5708dca728d7177)(monitor.isDragging(), "Cannot call endDrag while not dragging.");
}



function $0700d0193831c36b$export$2d6239ff106f142f(targetType, draggedItemType) {
    if (draggedItemType === null) return targetType === null;
    return Array.isArray(targetType) ? targetType.some((t)=>t === draggedItemType) : targetType === draggedItemType;
}



function $98e4440ce76e8fee$export$2f85b44a1d72ad03(manager) {
    return function hover(targetIdsArg, { clientOffset: clientOffset } = {}) {
        $98e4440ce76e8fee$var$verifyTargetIdsIsArray(targetIdsArg);
        const targetIds = targetIdsArg.slice(0);
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        const draggedItemType = monitor.getItemType();
        $98e4440ce76e8fee$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
        $98e4440ce76e8fee$var$checkInvariants(targetIds, monitor, registry);
        $98e4440ce76e8fee$var$hoverAllTargets(targetIds, monitor, registry);
        return {
            type: (0, $d4c965cb1b450ebf$export$9d358706ccac3727),
            payload: {
                targetIds: targetIds,
                clientOffset: clientOffset || null
            }
        };
    };
}
function $98e4440ce76e8fee$var$verifyTargetIdsIsArray(targetIdsArg) {
    (0, $6b6d471b1ffae726$export$f5708dca728d7177)(Array.isArray(targetIdsArg), "Expected targetIds to be an array.");
}
function $98e4440ce76e8fee$var$checkInvariants(targetIds, monitor, registry) {
    (0, $6b6d471b1ffae726$export$f5708dca728d7177)(monitor.isDragging(), "Cannot call hover while not dragging.");
    (0, $6b6d471b1ffae726$export$f5708dca728d7177)(!monitor.didDrop(), "Cannot call hover after drop.");
    for(let i = 0; i < targetIds.length; i++){
        const targetId = targetIds[i];
        (0, $6b6d471b1ffae726$export$f5708dca728d7177)(targetIds.lastIndexOf(targetId) === i, "Expected targetIds to be unique in the passed array.");
        const target = registry.getTarget(targetId);
        (0, $6b6d471b1ffae726$export$f5708dca728d7177)(target, "Expected targetIds to be registered.");
    }
}
function $98e4440ce76e8fee$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
    // Remove those targetIds that don't match the targetType.  This
    // fixes shallow isOver which would only be non-shallow because of
    // non-matching targets.
    for(let i = targetIds.length - 1; i >= 0; i--){
        const targetId = targetIds[i];
        const targetType = registry.getTargetType(targetId);
        if (!(0, $0700d0193831c36b$export$2d6239ff106f142f)(targetType, draggedItemType)) targetIds.splice(i, 1);
    }
}
function $98e4440ce76e8fee$var$hoverAllTargets(targetIds, monitor, registry) {
    // Finally call hover on all matching targets.
    targetIds.forEach(function(targetId) {
        const target = registry.getTarget(targetId);
        target.hover(monitor, targetId);
    });
}



function $65dfb70211c089a5$export$1675a481db21e714(manager) {
    return function publishDragSource() {
        const monitor = manager.getMonitor();
        if (monitor.isDragging()) return {
            type: (0, $d4c965cb1b450ebf$export$22d1d88e2de0d0e0)
        };
        return;
    };
}



function $92a3609f408e635a$export$ac1b80e79f04247f(manager) {
    return {
        beginDrag: (0, $5e0013d7d92f5565$export$d6542eb0d76867d6)(manager),
        publishDragSource: (0, $65dfb70211c089a5$export$1675a481db21e714)(manager),
        hover: (0, $98e4440ce76e8fee$export$2f85b44a1d72ad03)(manager),
        drop: (0, $687be4cb0aa22b77$export$9f5cbae8d079dda0)(manager),
        endDrag: (0, $a43e1f81e6415f70$export$2f5c7d4805260fdf)(manager)
    };
}


class $d8925ead7c0258e5$export$1141bbf61324c55f {
    receiveBackend(backend) {
        this.backend = backend;
    }
    getMonitor() {
        return this.monitor;
    }
    getBackend() {
        return this.backend;
    }
    getRegistry() {
        return this.monitor.registry;
    }
    getActions() {
        /* eslint-disable-next-line @typescript-eslint/no-this-alias */ const manager = this;
        const { dispatch: dispatch } = this.store;
        function bindActionCreator(actionCreator) {
            return (...args)=>{
                const action = actionCreator.apply(manager, args);
                if (typeof action !== "undefined") dispatch(action);
            };
        }
        const actions = (0, $92a3609f408e635a$export$ac1b80e79f04247f)(this);
        return Object.keys(actions).reduce((boundActions, key)=>{
            const action = actions[key];
            boundActions[key] = bindActionCreator(action);
            return boundActions;
        }, {});
    }
    dispatch(action) {
        this.store.dispatch(action);
    }
    constructor(store, monitor){
        this.isSetUp = false;
        this.handleRefCountChange = ()=>{
            const shouldSetUp = this.store.getState().refCount > 0;
            if (this.backend) {
                if (shouldSetUp && !this.isSetUp) {
                    this.backend.setup();
                    this.isSetUp = true;
                } else if (!shouldSetUp && this.isSetUp) {
                    this.backend.teardown();
                    this.isSetUp = false;
                }
            }
        };
        this.store = store;
        this.monitor = monitor;
        store.subscribe(this.handleRefCountChange);
    }
}



/**
 * Coordinate addition
 * @param a The first coordinate
 * @param b The second coordinate
 */ function $87dacff5db1ed59e$export$e16d8520af44a096(a, b) {
    return {
        x: a.x + b.x,
        y: a.y + b.y
    };
}
function $87dacff5db1ed59e$export$4e2d2ead65e5f7e3(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $87dacff5db1ed59e$export$b6a5970fca17c71e(state) {
    const { clientOffset: clientOffset, initialClientOffset: initialClientOffset, initialSourceClientOffset: initialSourceClientOffset } = state;
    if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) return null;
    return $87dacff5db1ed59e$export$4e2d2ead65e5f7e3($87dacff5db1ed59e$export$e16d8520af44a096(clientOffset, initialSourceClientOffset), initialClientOffset);
}
function $87dacff5db1ed59e$export$b57ee1a41eb1620b(state) {
    const { clientOffset: clientOffset, initialClientOffset: initialClientOffset } = state;
    if (!clientOffset || !initialClientOffset) return null;
    return $87dacff5db1ed59e$export$4e2d2ead65e5f7e3(clientOffset, initialClientOffset);
}



const $0322567264f58fc5$export$c53d0f541b41b88e = [];
const $0322567264f58fc5$export$61b49a5ae59d663 = [];
$0322567264f58fc5$export$c53d0f541b41b88e.__IS_NONE__ = true;
$0322567264f58fc5$export$61b49a5ae59d663.__IS_ALL__ = true;
function $0322567264f58fc5$export$3347776eeed47180(dirtyIds, handlerIds) {
    if (dirtyIds === $0322567264f58fc5$export$c53d0f541b41b88e) return false;
    if (dirtyIds === $0322567264f58fc5$export$61b49a5ae59d663 || typeof handlerIds === "undefined") return true;
    const commonIds = (0, $f4e1caca2f23e260$export$bc86dfbf7795668c)(handlerIds, dirtyIds);
    return commonIds.length > 0;
}



class $33fc4eee71f48d1e$export$e220263e518daaed {
    subscribeToStateChange(listener, options = {}) {
        const { handlerIds: handlerIds } = options;
        (0, $6b6d471b1ffae726$export$f5708dca728d7177)(typeof listener === "function", "listener must be a function.");
        (0, $6b6d471b1ffae726$export$f5708dca728d7177)(typeof handlerIds === "undefined" || Array.isArray(handlerIds), "handlerIds, when specified, must be an array of strings.");
        let prevStateId = this.store.getState().stateId;
        const handleChange = ()=>{
            const state = this.store.getState();
            const currentStateId = state.stateId;
            try {
                const canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, $0322567264f58fc5$export$3347776eeed47180)(state.dirtyHandlerIds, handlerIds);
                if (!canSkipListener) listener();
            } finally{
                prevStateId = currentStateId;
            }
        };
        return this.store.subscribe(handleChange);
    }
    subscribeToOffsetChange(listener) {
        (0, $6b6d471b1ffae726$export$f5708dca728d7177)(typeof listener === "function", "listener must be a function.");
        let previousState = this.store.getState().dragOffset;
        const handleChange = ()=>{
            const nextState = this.store.getState().dragOffset;
            if (nextState === previousState) return;
            previousState = nextState;
            listener();
        };
        return this.store.subscribe(handleChange);
    }
    canDragSource(sourceId) {
        if (!sourceId) return false;
        const source = this.registry.getSource(sourceId);
        (0, $6b6d471b1ffae726$export$f5708dca728d7177)(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (this.isDragging()) return false;
        return source.canDrag(this, sourceId);
    }
    canDropOnTarget(targetId) {
        // undefined on initial render
        if (!targetId) return false;
        const target = this.registry.getTarget(targetId);
        (0, $6b6d471b1ffae726$export$f5708dca728d7177)(target, `Expected to find a valid target. targetId=${targetId}`);
        if (!this.isDragging() || this.didDrop()) return false;
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        return (0, $0700d0193831c36b$export$2d6239ff106f142f)(targetType, draggedItemType) && target.canDrop(this, targetId);
    }
    isDragging() {
        return Boolean(this.getItemType());
    }
    isDraggingSource(sourceId) {
        // undefined on initial render
        if (!sourceId) return false;
        const source = this.registry.getSource(sourceId, true);
        (0, $6b6d471b1ffae726$export$f5708dca728d7177)(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (!this.isDragging() || !this.isSourcePublic()) return false;
        const sourceType = this.registry.getSourceType(sourceId);
        const draggedItemType = this.getItemType();
        if (sourceType !== draggedItemType) return false;
        return source.isDragging(this, sourceId);
    }
    isOverTarget(targetId, options = {
        shallow: false
    }) {
        // undefined on initial render
        if (!targetId) return false;
        const { shallow: shallow } = options;
        if (!this.isDragging()) return false;
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        if (draggedItemType && !(0, $0700d0193831c36b$export$2d6239ff106f142f)(targetType, draggedItemType)) return false;
        const targetIds = this.getTargetIds();
        if (!targetIds.length) return false;
        const index = targetIds.indexOf(targetId);
        if (shallow) return index === targetIds.length - 1;
        else return index > -1;
    }
    getItemType() {
        return this.store.getState().dragOperation.itemType;
    }
    getItem() {
        return this.store.getState().dragOperation.item;
    }
    getSourceId() {
        return this.store.getState().dragOperation.sourceId;
    }
    getTargetIds() {
        return this.store.getState().dragOperation.targetIds;
    }
    getDropResult() {
        return this.store.getState().dragOperation.dropResult;
    }
    didDrop() {
        return this.store.getState().dragOperation.didDrop;
    }
    isSourcePublic() {
        return Boolean(this.store.getState().dragOperation.isSourcePublic);
    }
    getInitialClientOffset() {
        return this.store.getState().dragOffset.initialClientOffset;
    }
    getInitialSourceClientOffset() {
        return this.store.getState().dragOffset.initialSourceClientOffset;
    }
    getClientOffset() {
        return this.store.getState().dragOffset.clientOffset;
    }
    getSourceClientOffset() {
        return (0, $87dacff5db1ed59e$export$b6a5970fca17c71e)(this.store.getState().dragOffset);
    }
    getDifferenceFromInitialOffset() {
        return (0, $87dacff5db1ed59e$export$b57ee1a41eb1620b)(this.store.getState().dragOffset);
    }
    constructor(store, registry){
        this.store = store;
        this.registry = registry;
    }
}


/* eslint-disable no-restricted-globals, @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-non-null-assertion */ // Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
/* globals self */ const $f4b3de445e9425ac$var$scope = typeof $parcel$global !== "undefined" ? $parcel$global : self;
const $f4b3de445e9425ac$var$BrowserMutationObserver = $f4b3de445e9425ac$var$scope.MutationObserver || $f4b3de445e9425ac$var$scope.WebKitMutationObserver;
function $f4b3de445e9425ac$export$27a7cafb047f3c77(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        const timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        const intervalHandle = setInterval(handleTimer, 50);
        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}
function $f4b3de445e9425ac$export$2785f4493cc9ca62(callback) {
    let toggle = 1;
    const observer = new $f4b3de445e9425ac$var$BrowserMutationObserver(callback);
    const node = document.createTextNode("");
    observer.observe(node, {
        characterData: true
    });
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}
const $f4b3de445e9425ac$export$29545a1340296ce3 = typeof $f4b3de445e9425ac$var$BrowserMutationObserver === "function" ? // They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
$f4b3de445e9425ac$export$2785f4493cc9ca62 : // 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.
// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396
// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
$f4b3de445e9425ac$export$27a7cafb047f3c77;


class $394b79d2b1fc493d$export$d3f0708de0e313ed {
    // Use the fastest means possible to execute a task in its own turn, with
    // priority over other events including IO, animation, reflow, and redraw
    // events in browsers.
    //
    // An exception thrown by a task will permanently interrupt the processing of
    // subsequent tasks. The higher level `asap` function ensures that if an
    // exception is thrown by a task, that the task queue will continue flushing as
    // soon as possible, but if you use `rawAsap` directly, you are responsible to
    // either ensure that no exceptions are thrown from your task, or to manually
    // call `rawAsap.requestFlush` if an exception is thrown.
    enqueueTask(task) {
        const { queue: q, requestFlush: requestFlush } = this;
        if (!q.length) {
            requestFlush();
            this.flushing = true;
        }
        // Equivalent to push, but avoids a function call.
        q[q.length] = task;
    }
    constructor(){
        this.queue = [];
        // We queue errors to ensure they are thrown in right order (FIFO).
        // Array-as-queue is good enough here, since we are just dealing with exceptions.
        this.pendingErrors = [];
        // Once a flush has been requested, no further calls to `requestFlush` are
        // necessary until the next `flush` completes.
        // @ts-ignore
        this.flushing = false;
        // The position of the next task to execute in the task queue. This is
        // preserved between calls to `flush` so that it can be resumed if
        // a task throws an exception.
        this.index = 0;
        // If a task schedules additional tasks recursively, the task queue can grow
        // unbounded. To prevent memory exhaustion, the task queue will periodically
        // truncate already-completed tasks.
        this.capacity = 1024;
        // The flush function processes all tasks that have been scheduled with
        // `rawAsap` unless and until one of those tasks throws an exception.
        // If a task throws an exception, `flush` ensures that its state will remain
        // consistent and will resume where it left off when called again.
        // However, `flush` does not make any arrangements to be called again if an
        // exception is thrown.
        this.flush = ()=>{
            const { queue: q } = this;
            while(this.index < q.length){
                const currentIndex = this.index;
                // Advance the index before calling the task. This ensures that we will
                // begin flushing on the next task the task throws an error.
                this.index++;
                q[currentIndex].call();
                // Prevent leaking memory for long chains of recursive calls to `asap`.
                // If we call `asap` within tasks scheduled by `asap`, the queue will
                // grow, but to avoid an O(n) walk for every task we execute, we don't
                // shift tasks off the queue after they have been executed.
                // Instead, we periodically shift 1024 tasks off the queue.
                if (this.index > this.capacity) {
                    // Manually shift all values starting at the index back to the
                    // beginning of the queue.
                    for(let scan = 0, newLength = q.length - this.index; scan < newLength; scan++)q[scan] = q[scan + this.index];
                    q.length -= this.index;
                    this.index = 0;
                }
            }
            q.length = 0;
            this.index = 0;
            this.flushing = false;
        };
        // In a web browser, exceptions are not fatal. However, to avoid
        // slowing down the queue of pending tasks, we rethrow the error in a
        // lower priority turn.
        this.registerPendingError = (err)=>{
            this.pendingErrors.push(err);
            this.requestErrorThrow();
        };
        // `requestFlush` requests that the high priority event queue be flushed as
        // soon as possible.
        // This is useful to prevent an error thrown in a task from stalling the event
        // queue if the exception handled by Node.js’s
        // `process.on("uncaughtException")` or by a domain.
        // `requestFlush` is implemented using a strategy based on data collected from
        // every available SauceLabs Selenium web driver worker at time of writing.
        // https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
        this.requestFlush = (0, $f4b3de445e9425ac$export$29545a1340296ce3)(this.flush);
        this.requestErrorThrow = (0, $f4b3de445e9425ac$export$27a7cafb047f3c77)(()=>{
            // Throw first error
            if (this.pendingErrors.length) throw this.pendingErrors.shift();
        });
    }
} // The message channel technique was discovered by Malte Ubl and was the
 // original foundation for this library.
 // http://www.nonblocking.io/2011/06/windownexttick.html
 // Safari 6.0.5 (at least) intermittently fails to create message ports on a
 // page's first load. Thankfully, this version of Safari supports
 // MutationObservers, so we don't need to fall back in that case.
 // function makeRequestCallFromMessageChannel(callback) {
 //     var channel = new MessageChannel();
 //     channel.port1.onmessage = callback;
 //     return function requestCall() {
 //         channel.port2.postMessage(0);
 //     };
 // }
 // For reasons explained above, we are also unable to use `setImmediate`
 // under any circumstances.
 // Even if we were, there is another bug in Internet Explorer 10.
 // It is not sufficient to assign `setImmediate` to `requestFlush` because
 // `setImmediate` must be called *by name* and therefore must be wrapped in a
 // closure.
 // Never forget.
 // function makeRequestCallFromSetImmediate(callback) {
 //     return function requestCall() {
 //         setImmediate(callback);
 //     };
 // }
 // Safari 6.0 has a problem where timers will get lost while the user is
 // scrolling. This problem does not impact ASAP because Safari 6.0 supports
 // mutation observers, so that implementation is used instead.
 // However, if we ever elect to use timers in Safari, the prevalent work-around
 // is to add a scroll event listener that calls for a flush.
 // `setTimeout` does not call the passed callback if the delay is less than
 // approximately 7 in web workers in Firefox 8 through 18, and sometimes not
 // even then.
 // This is for `asap.js` only.
 // Its name will be periodically randomized to break any code that depends on
 // // its existence.
 // rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer
 // ASAP was originally a nextTick shim included in Q. This was factored out
 // into this ASAP package. It was later adapted to RSVP which made further
 // amendments. These decisions, particularly to marginalize MessageChannel and
 // to capture the MutationObserver implementation in a closure, were integrated
 // back into ASAP proper.
 // https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js


// `call`, just like a function.
class $5a2c27f676dd5542$export$c84b69da61b33d93 {
    call() {
        try {
            this.task && this.task();
        } catch (error) {
            this.onError(error);
        } finally{
            this.task = null;
            this.release(this);
        }
    }
    constructor(onError, release){
        this.onError = onError;
        this.release = release;
        this.task = null;
    }
}


class $9b062a9b2be174a5$export$4577931b6c22c63b {
    create(task) {
        const tasks = this.freeTasks;
        const t1 = tasks.length ? tasks.pop() : new (0, $5a2c27f676dd5542$export$c84b69da61b33d93)(this.onError, (t)=>tasks[tasks.length] = t);
        t1.task = task;
        return t1;
    }
    constructor(onError){
        this.onError = onError;
        this.freeTasks = [];
    }
}


const $1733db71af4b3d43$var$asapQueue = new (0, $394b79d2b1fc493d$export$d3f0708de0e313ed)();
const $1733db71af4b3d43$var$taskFactory = new (0, $9b062a9b2be174a5$export$4577931b6c22c63b)($1733db71af4b3d43$var$asapQueue.registerPendingError);
function $1733db71af4b3d43$export$dc4d482300a341e1(task) {
    $1733db71af4b3d43$var$asapQueue.enqueueTask($1733db71af4b3d43$var$taskFactory.create(task));
}









const $5f599b975b5a64c8$export$b36933c81fb1c092 = "dnd-core/ADD_SOURCE";
const $5f599b975b5a64c8$export$2c313542981556ae = "dnd-core/ADD_TARGET";
const $5f599b975b5a64c8$export$13332566b98b8783 = "dnd-core/REMOVE_SOURCE";
const $5f599b975b5a64c8$export$82ace346d17d8869 = "dnd-core/REMOVE_TARGET";
function $5f599b975b5a64c8$export$bc333c64f07a75c4(sourceId) {
    return {
        type: $5f599b975b5a64c8$export$b36933c81fb1c092,
        payload: {
            sourceId: sourceId
        }
    };
}
function $5f599b975b5a64c8$export$9dd68fe78f37278b(targetId) {
    return {
        type: $5f599b975b5a64c8$export$2c313542981556ae,
        payload: {
            targetId: targetId
        }
    };
}
function $5f599b975b5a64c8$export$c724aacd61334138(sourceId) {
    return {
        type: $5f599b975b5a64c8$export$13332566b98b8783,
        payload: {
            sourceId: sourceId
        }
    };
}
function $5f599b975b5a64c8$export$20ae7ec87f7f8696(targetId) {
    return {
        type: $5f599b975b5a64c8$export$82ace346d17d8869,
        payload: {
            targetId: targetId
        }
    };
}



function $5088683e86a98a64$export$a7a13c013ce18993(source) {
    (0, $6b6d471b1ffae726$export$f5708dca728d7177)(typeof source.canDrag === "function", "Expected canDrag to be a function.");
    (0, $6b6d471b1ffae726$export$f5708dca728d7177)(typeof source.beginDrag === "function", "Expected beginDrag to be a function.");
    (0, $6b6d471b1ffae726$export$f5708dca728d7177)(typeof source.endDrag === "function", "Expected endDrag to be a function.");
}
function $5088683e86a98a64$export$77d3cd1340fdeb5a(target) {
    (0, $6b6d471b1ffae726$export$f5708dca728d7177)(typeof target.canDrop === "function", "Expected canDrop to be a function.");
    (0, $6b6d471b1ffae726$export$f5708dca728d7177)(typeof target.hover === "function", "Expected hover to be a function.");
    (0, $6b6d471b1ffae726$export$f5708dca728d7177)(typeof target.drop === "function", "Expected beginDrag to be a function.");
}
function $5088683e86a98a64$export$831a593efd22380d(type, allowArray) {
    if (allowArray && Array.isArray(type)) {
        type.forEach((t)=>$5088683e86a98a64$export$831a593efd22380d(t, false));
        return;
    }
    (0, $6b6d471b1ffae726$export$f5708dca728d7177)(typeof type === "string" || typeof type === "symbol", allowArray ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
}


var $2fd41c3ce7d46e8f$export$bb8f0843d7d66cb0;
(function(HandlerRole) {
    HandlerRole["SOURCE"] = "SOURCE";
    HandlerRole["TARGET"] = "TARGET";
})($2fd41c3ce7d46e8f$export$bb8f0843d7d66cb0 || ($2fd41c3ce7d46e8f$export$bb8f0843d7d66cb0 = {}));


let $752baf483b385ff7$var$nextUniqueId = 0;
function $752baf483b385ff7$export$dbfb29c8f2c7bb44() {
    return $752baf483b385ff7$var$nextUniqueId++;
}


function $cc736372020fc43a$var$getNextHandlerId(role) {
    const id = (0, $752baf483b385ff7$export$dbfb29c8f2c7bb44)().toString();
    switch(role){
        case (0, $2fd41c3ce7d46e8f$export$bb8f0843d7d66cb0).SOURCE:
            return `S${id}`;
        case (0, $2fd41c3ce7d46e8f$export$bb8f0843d7d66cb0).TARGET:
            return `T${id}`;
        default:
            throw new Error(`Unknown Handler Role: ${role}`);
    }
}
function $cc736372020fc43a$var$parseRoleFromHandlerId(handlerId) {
    switch(handlerId[0]){
        case "S":
            return (0, $2fd41c3ce7d46e8f$export$bb8f0843d7d66cb0).SOURCE;
        case "T":
            return (0, $2fd41c3ce7d46e8f$export$bb8f0843d7d66cb0).TARGET;
        default:
            throw new Error(`Cannot parse handler ID: ${handlerId}`);
    }
}
function $cc736372020fc43a$var$mapContainsValue(map, searchValue) {
    const entries = map.entries();
    let isDone = false;
    do {
        const { done: done, value: [, value] } = entries.next();
        if (value === searchValue) return true;
        isDone = !!done;
    }while (!isDone);
    return false;
}
class $cc736372020fc43a$export$60ceab237232d5db {
    addSource(type, source) {
        (0, $5088683e86a98a64$export$831a593efd22380d)(type);
        (0, $5088683e86a98a64$export$a7a13c013ce18993)(source);
        const sourceId = this.addHandler((0, $2fd41c3ce7d46e8f$export$bb8f0843d7d66cb0).SOURCE, type, source);
        this.store.dispatch((0, $5f599b975b5a64c8$export$bc333c64f07a75c4)(sourceId));
        return sourceId;
    }
    addTarget(type, target) {
        (0, $5088683e86a98a64$export$831a593efd22380d)(type, true);
        (0, $5088683e86a98a64$export$77d3cd1340fdeb5a)(target);
        const targetId = this.addHandler((0, $2fd41c3ce7d46e8f$export$bb8f0843d7d66cb0).TARGET, type, target);
        this.store.dispatch((0, $5f599b975b5a64c8$export$9dd68fe78f37278b)(targetId));
        return targetId;
    }
    containsHandler(handler) {
        return $cc736372020fc43a$var$mapContainsValue(this.dragSources, handler) || $cc736372020fc43a$var$mapContainsValue(this.dropTargets, handler);
    }
    getSource(sourceId, includePinned = false) {
        (0, $6b6d471b1ffae726$export$f5708dca728d7177)(this.isSourceId(sourceId), "Expected a valid source ID.");
        const isPinned = includePinned && sourceId === this.pinnedSourceId;
        const source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
        return source;
    }
    getTarget(targetId) {
        (0, $6b6d471b1ffae726$export$f5708dca728d7177)(this.isTargetId(targetId), "Expected a valid target ID.");
        return this.dropTargets.get(targetId);
    }
    getSourceType(sourceId) {
        (0, $6b6d471b1ffae726$export$f5708dca728d7177)(this.isSourceId(sourceId), "Expected a valid source ID.");
        return this.types.get(sourceId);
    }
    getTargetType(targetId) {
        (0, $6b6d471b1ffae726$export$f5708dca728d7177)(this.isTargetId(targetId), "Expected a valid target ID.");
        return this.types.get(targetId);
    }
    isSourceId(handlerId) {
        const role = $cc736372020fc43a$var$parseRoleFromHandlerId(handlerId);
        return role === (0, $2fd41c3ce7d46e8f$export$bb8f0843d7d66cb0).SOURCE;
    }
    isTargetId(handlerId) {
        const role = $cc736372020fc43a$var$parseRoleFromHandlerId(handlerId);
        return role === (0, $2fd41c3ce7d46e8f$export$bb8f0843d7d66cb0).TARGET;
    }
    removeSource(sourceId) {
        (0, $6b6d471b1ffae726$export$f5708dca728d7177)(this.getSource(sourceId), "Expected an existing source.");
        this.store.dispatch((0, $5f599b975b5a64c8$export$c724aacd61334138)(sourceId));
        (0, $1733db71af4b3d43$export$dc4d482300a341e1)(()=>{
            this.dragSources.delete(sourceId);
            this.types.delete(sourceId);
        });
    }
    removeTarget(targetId) {
        (0, $6b6d471b1ffae726$export$f5708dca728d7177)(this.getTarget(targetId), "Expected an existing target.");
        this.store.dispatch((0, $5f599b975b5a64c8$export$20ae7ec87f7f8696)(targetId));
        this.dropTargets.delete(targetId);
        this.types.delete(targetId);
    }
    pinSource(sourceId) {
        const source = this.getSource(sourceId);
        (0, $6b6d471b1ffae726$export$f5708dca728d7177)(source, "Expected an existing source.");
        this.pinnedSourceId = sourceId;
        this.pinnedSource = source;
    }
    unpinSource() {
        (0, $6b6d471b1ffae726$export$f5708dca728d7177)(this.pinnedSource, "No source is pinned at the time.");
        this.pinnedSourceId = null;
        this.pinnedSource = null;
    }
    addHandler(role, type, handler) {
        const id = $cc736372020fc43a$var$getNextHandlerId(role);
        this.types.set(id, type);
        if (role === (0, $2fd41c3ce7d46e8f$export$bb8f0843d7d66cb0).SOURCE) this.dragSources.set(id, handler);
        else if (role === (0, $2fd41c3ce7d46e8f$export$bb8f0843d7d66cb0).TARGET) this.dropTargets.set(id, handler);
        return id;
    }
    constructor(store){
        this.types = new Map();
        this.dragSources = new Map();
        this.dropTargets = new Map();
        this.pinnedSourceId = null;
        this.pinnedSource = null;
        this.store = store;
    }
}






const $b11e5b2c9f54d90c$export$2116cbe61f6a442a = (a, b)=>a === b;
function $b11e5b2c9f54d90c$export$102b20725d4d2263(offsetA, offsetB) {
    if (!offsetA && !offsetB) return true;
    else if (!offsetA || !offsetB) return false;
    else return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
}
function $b11e5b2c9f54d90c$export$94fd53d40f0652a(a, b, isEqual = $b11e5b2c9f54d90c$export$2116cbe61f6a442a) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; ++i){
        if (!isEqual(a[i], b[i])) return false;
    }
    return true;
}



function $b60cd36d91d00d9a$export$533b26079ad0b4b(_state = (0, $0322567264f58fc5$export$c53d0f541b41b88e), action) {
    switch(action.type){
        case 0, $d4c965cb1b450ebf$export$9d358706ccac3727:
            break;
        case 0, $5f599b975b5a64c8$export$b36933c81fb1c092:
        case 0, $5f599b975b5a64c8$export$2c313542981556ae:
        case 0, $5f599b975b5a64c8$export$82ace346d17d8869:
        case 0, $5f599b975b5a64c8$export$13332566b98b8783:
            return 0, $0322567264f58fc5$export$c53d0f541b41b88e;
        case 0, $d4c965cb1b450ebf$export$98f9b4193e6b55e6:
        case 0, $d4c965cb1b450ebf$export$22d1d88e2de0d0e0:
        case 0, $d4c965cb1b450ebf$export$d300627d16aeb9cc:
        case 0, $d4c965cb1b450ebf$export$b4af72c40fd57063:
        default:
            return 0, $0322567264f58fc5$export$61b49a5ae59d663;
    }
    const { targetIds: targetIds = [], prevTargetIds: prevTargetIds = [] } = action.payload;
    const result = (0, $f4e1caca2f23e260$export$6444ef5cd411280c)(targetIds, prevTargetIds);
    const didChange = result.length > 0 || !(0, $b11e5b2c9f54d90c$export$94fd53d40f0652a)(targetIds, prevTargetIds);
    if (!didChange) return 0, $0322567264f58fc5$export$c53d0f541b41b88e;
    // Check the target ids at the innermost position. If they are valid, add them
    // to the result
    const prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
    const innermostTargetId = targetIds[targetIds.length - 1];
    if (prevInnermostTargetId !== innermostTargetId) {
        if (prevInnermostTargetId) result.push(prevInnermostTargetId);
        if (innermostTargetId) result.push(innermostTargetId);
    }
    return result;
}




function $c2dcaf2ceed7434e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c2dcaf2ceed7434e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $c2dcaf2ceed7434e$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
const $c2dcaf2ceed7434e$var$initialState = {
    initialSourceClientOffset: null,
    initialClientOffset: null,
    clientOffset: null
};
function $c2dcaf2ceed7434e$export$533b26079ad0b4b(state = $c2dcaf2ceed7434e$var$initialState, action) {
    const { payload: payload } = action;
    switch(action.type){
        case 0, $d4c965cb1b450ebf$export$3fc3a33e48b33945:
        case 0, $d4c965cb1b450ebf$export$98f9b4193e6b55e6:
            return {
                initialSourceClientOffset: payload.sourceClientOffset,
                initialClientOffset: payload.clientOffset,
                clientOffset: payload.clientOffset
            };
        case 0, $d4c965cb1b450ebf$export$9d358706ccac3727:
            if ((0, $b11e5b2c9f54d90c$export$102b20725d4d2263)(state.clientOffset, payload.clientOffset)) return state;
            return $c2dcaf2ceed7434e$var$_objectSpread({}, state, {
                clientOffset: payload.clientOffset
            });
        case 0, $d4c965cb1b450ebf$export$d300627d16aeb9cc:
        case 0, $d4c965cb1b450ebf$export$b4af72c40fd57063:
            return $c2dcaf2ceed7434e$var$initialState;
        default:
            return state;
    }
}





function $4e37cee3d6723ad0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4e37cee3d6723ad0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $4e37cee3d6723ad0$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
const $4e37cee3d6723ad0$var$initialState = {
    itemType: null,
    item: null,
    sourceId: null,
    targetIds: [],
    dropResult: null,
    didDrop: false,
    isSourcePublic: null
};
function $4e37cee3d6723ad0$export$533b26079ad0b4b(state = $4e37cee3d6723ad0$var$initialState, action) {
    const { payload: payload } = action;
    switch(action.type){
        case 0, $d4c965cb1b450ebf$export$98f9b4193e6b55e6:
            return $4e37cee3d6723ad0$var$_objectSpread({}, state, {
                itemType: payload.itemType,
                item: payload.item,
                sourceId: payload.sourceId,
                isSourcePublic: payload.isSourcePublic,
                dropResult: null,
                didDrop: false
            });
        case 0, $d4c965cb1b450ebf$export$22d1d88e2de0d0e0:
            return $4e37cee3d6723ad0$var$_objectSpread({}, state, {
                isSourcePublic: true
            });
        case 0, $d4c965cb1b450ebf$export$9d358706ccac3727:
            return $4e37cee3d6723ad0$var$_objectSpread({}, state, {
                targetIds: payload.targetIds
            });
        case 0, $5f599b975b5a64c8$export$82ace346d17d8869:
            if (state.targetIds.indexOf(payload.targetId) === -1) return state;
            return $4e37cee3d6723ad0$var$_objectSpread({}, state, {
                targetIds: (0, $f4e1caca2f23e260$export$5d14bf425b37f49e)(state.targetIds, payload.targetId)
            });
        case 0, $d4c965cb1b450ebf$export$b4af72c40fd57063:
            return $4e37cee3d6723ad0$var$_objectSpread({}, state, {
                dropResult: payload.dropResult,
                didDrop: true,
                targetIds: []
            });
        case 0, $d4c965cb1b450ebf$export$d300627d16aeb9cc:
            return $4e37cee3d6723ad0$var$_objectSpread({}, state, {
                itemType: null,
                item: null,
                sourceId: null,
                dropResult: null,
                didDrop: false,
                isSourcePublic: null,
                targetIds: []
            });
        default:
            return state;
    }
}



function $0fca6636f5fcfcd7$export$533b26079ad0b4b(state = 0, action) {
    switch(action.type){
        case 0, $5f599b975b5a64c8$export$b36933c81fb1c092:
        case 0, $5f599b975b5a64c8$export$2c313542981556ae:
            return state + 1;
        case 0, $5f599b975b5a64c8$export$13332566b98b8783:
        case 0, $5f599b975b5a64c8$export$82ace346d17d8869:
            return state - 1;
        default:
            return state;
    }
}


function $b74c50968a053e6c$export$533b26079ad0b4b(state = 0) {
    return state + 1;
}


function $ad8c5ed2e7a42dc0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ad8c5ed2e7a42dc0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $ad8c5ed2e7a42dc0$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $ad8c5ed2e7a42dc0$export$533b26079ad0b4b(state = {}, action) {
    return {
        dirtyHandlerIds: (0, $b60cd36d91d00d9a$export$533b26079ad0b4b)(state.dirtyHandlerIds, {
            type: action.type,
            payload: $ad8c5ed2e7a42dc0$var$_objectSpread({}, action.payload, {
                prevTargetIds: (0, $f4e1caca2f23e260$export$3988ae62b71be9a3)(state, "dragOperation.targetIds", [])
            })
        }),
        dragOffset: (0, $c2dcaf2ceed7434e$export$533b26079ad0b4b)(state.dragOffset, action),
        refCount: (0, $0fca6636f5fcfcd7$export$533b26079ad0b4b)(state.refCount, action),
        dragOperation: (0, $4e37cee3d6723ad0$export$533b26079ad0b4b)(state.dragOperation, action),
        stateId: (0, $b74c50968a053e6c$export$533b26079ad0b4b)(state.stateId)
    };
}


function $a7413988fc070a72$export$ff47aa43d5fd3e5d(backendFactory, globalContext, backendOptions = {}, debugMode = false) {
    const store = $a7413988fc070a72$var$makeStoreInstance(debugMode);
    const monitor = new (0, $33fc4eee71f48d1e$export$e220263e518daaed)(store, new (0, $cc736372020fc43a$export$60ceab237232d5db)(store));
    const manager = new (0, $d8925ead7c0258e5$export$1141bbf61324c55f)(store, monitor);
    const backend = backendFactory(manager, globalContext, backendOptions);
    manager.receiveBackend(backend);
    return manager;
}
function $a7413988fc070a72$var$makeStoreInstance(debugMode) {
    // TODO: if we ever make a react-native version of this,
    // we'll need to consider how to pull off dev-tooling
    const reduxDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__;
    return (0, $71488736b7fc99c4$export$f51a9068ac82ea43)((0, $ad8c5ed2e7a42dc0$export$533b26079ad0b4b), debugMode && reduxDevTools && reduxDevTools({
        name: "dnd-core",
        instanceId: "dnd-core"
    }));
}



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
const $f4aff835dca10427$export$2d5c5ceac203fc1e = (0, $7fPBF.createContext)({
    dragDropManager: undefined
});


function $b84d99e06e9d3dec$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b84d99e06e9d3dec$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b84d99e06e9d3dec$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
let $b84d99e06e9d3dec$var$refCount = 0;
const $b84d99e06e9d3dec$var$INSTANCE_SYM = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
var $b84d99e06e9d3dec$export$9861489d68213f9c = /*#__PURE__*/ (0, $7fPBF.memo)(function DndProvider(_param) {
    var { children: children } = _param, props = $b84d99e06e9d3dec$var$_objectWithoutProperties(_param, [
        "children"
    ]);
    const [manager, isGlobalInstance] = $b84d99e06e9d3dec$var$getDndContextValue(props) // memoized from props
    ;
    /**
		 * If the global context was used to store the DND context
		 * then where theres no more references to it we should
		 * clean it up to avoid memory leaks
		 */ (0, $7fPBF.useEffect)(()=>{
        if (isGlobalInstance) {
            const context = $b84d99e06e9d3dec$var$getGlobalContext();
            ++$b84d99e06e9d3dec$var$refCount;
            return ()=>{
                if (--$b84d99e06e9d3dec$var$refCount === 0) context[$b84d99e06e9d3dec$var$INSTANCE_SYM] = null;
            };
        }
        return;
    }, []);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f4aff835dca10427$export$2d5c5ceac203fc1e).Provider, {
        value: manager,
        children: children
    });
});
function $b84d99e06e9d3dec$var$getDndContextValue(props) {
    if ("manager" in props) {
        const manager = {
            dragDropManager: props.manager
        };
        return [
            manager,
            false
        ];
    }
    const manager = $b84d99e06e9d3dec$var$createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
    const isGlobalInstance = !props.context;
    return [
        manager,
        isGlobalInstance
    ];
}
function $b84d99e06e9d3dec$var$createSingletonDndContext(backend, context = $b84d99e06e9d3dec$var$getGlobalContext(), options, debugMode) {
    const ctx = context;
    if (!ctx[$b84d99e06e9d3dec$var$INSTANCE_SYM]) ctx[$b84d99e06e9d3dec$var$INSTANCE_SYM] = {
        dragDropManager: (0, $a7413988fc070a72$export$ff47aa43d5fd3e5d)(backend, context, options, debugMode)
    };
    return ctx[$b84d99e06e9d3dec$var$INSTANCE_SYM];
}
function $b84d99e06e9d3dec$var$getGlobalContext() {
    return typeof $parcel$global !== "undefined" ? $parcel$global : window;
}


var $99170e1e1690344b$exports = {};
"use strict";
// do not edit .js files directly - edit src/index.jst
$99170e1e1690344b$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
const $6aeb1f89c47c90dd$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);


function $aa5a1b0e286cefc7$export$e32e64a4387f290a(monitor, collect, onUpdate) {
    const [collected, setCollected] = (0, $7fPBF.useState)(()=>collect(monitor));
    const updateCollected = (0, $7fPBF.useCallback)(()=>{
        const nextValue = collect(monitor);
        // This needs to be a deep-equality check because some monitor-collected values
        // include XYCoord objects that may be equivalent, but do not have instance equality.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($99170e1e1690344b$exports)))(collected, nextValue)) {
            setCollected(nextValue);
            if (onUpdate) onUpdate();
        }
    }, [
        collected,
        monitor,
        onUpdate
    ]);
    // update the collected properties after react renders.
    // Note that the "Dustbin Stress Test" fails if this is not
    // done when the component updates
    (0, $6aeb1f89c47c90dd$export$700979bc83e7db82)(updateCollected);
    return [
        collected,
        updateCollected
    ];
}



function $43449fcf65d24ede$export$f34439a5e43bd79c(monitor, collect, onCollect) {
    const [collected, updateCollected] = (0, $aa5a1b0e286cefc7$export$e32e64a4387f290a)(monitor, collect, onCollect);
    (0, $6aeb1f89c47c90dd$export$700979bc83e7db82)(function subscribeToMonitorStateChange() {
        const handlerId = monitor.getHandlerId();
        if (handlerId == null) return;
        return monitor.subscribeToStateChange(updateCollected, {
            handlerIds: [
                handlerId
            ]
        });
    }, [
        monitor,
        updateCollected
    ]);
    return collected;
}


function $ec9b480e023f385c$export$a55a4e3c0acb6f15(collector, monitor, connector) {
    return (0, $43449fcf65d24ede$export$f34439a5e43bd79c)(monitor, collector || (()=>({})), ()=>connector.reconnect());
}



var $7fPBF = parcelRequire("7fPBF");
function $3554d3840fc025af$export$f16a07909151e918(arg, deps) {
    const memoDeps = [
        ...deps || []
    ];
    if (deps == null && typeof arg !== "function") memoDeps.push(arg);
    return (0, $7fPBF.useMemo)(()=>{
        return typeof arg === "function" ? arg() : arg;
    }, memoDeps);
}



var $7fPBF = parcelRequire("7fPBF");
function $5ac93c1df0fa5f2b$export$90c397533e0cc6(connector) {
    return (0, $7fPBF.useMemo)(()=>connector.hooks.dragSource(), [
        connector
    ]);
}
function $5ac93c1df0fa5f2b$export$a66b3011bc8970d6(connector) {
    return (0, $7fPBF.useMemo)(()=>connector.hooks.dragPreview(), [
        connector
    ]);
}



var $7fPBF = parcelRequire("7fPBF");
function $5c0d7d230cf505e0$export$d36bdfa510afb180(objA, objB, compare, compareContext) {
    let compareResult = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (compareResult !== void 0) return !!compareResult;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(let idx = 0; idx < keysA.length; idx++){
        const key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        const valueA = objA[key];
        const valueB = objB[key];
        compareResult = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (compareResult === false || compareResult === void 0 && valueA !== valueB) return false;
    }
    return true;
}


function $6ff893967de5eab5$export$4f9f5282de18fc69(obj) {
    return obj !== null && typeof obj === "object" && Object.prototype.hasOwnProperty.call(obj, "current");
}




var $7fPBF = parcelRequire("7fPBF");
function $9e4bfc7637dd9b3c$var$throwIfCompositeComponentElement(element) {
    // Custom components can no longer be wrapped directly in React DnD 2.0
    // so that we don't need to depend on findDOMNode() from react-dom.
    if (typeof element.type === "string") return;
    const displayName = element.type.displayName || element.type.name || "the component";
    throw new Error("Only native element nodes can now be passed to React DnD connectors." + `You can either wrap ${displayName} into a <div>, or turn it into a ` + "drag source or a drop target itself.");
}
function $9e4bfc7637dd9b3c$var$wrapHookToRecognizeElement(hook) {
    return (elementOrNode = null, options = null)=>{
        // When passed a node, call the hook straight away.
        if (!(0, $7fPBF.isValidElement)(elementOrNode)) {
            const node = elementOrNode;
            hook(node, options);
            // return the node so it can be chained (e.g. when within callback refs
            // <div ref={node => connectDragSource(connectDropTarget(node))}/>
            return node;
        }
        // If passed a ReactElement, clone it and attach this function as a ref.
        // This helps us achieve a neat API where user doesn't even know that refs
        // are being used under the hood.
        const element = elementOrNode;
        $9e4bfc7637dd9b3c$var$throwIfCompositeComponentElement(element);
        // When no options are passed, use the hook directly
        const ref = options ? (node)=>hook(node, options) : hook;
        return $9e4bfc7637dd9b3c$var$cloneWithRef(element, ref);
    };
}
function $9e4bfc7637dd9b3c$export$d8dcaf80ab4f6cb7(hooks) {
    const wrappedHooks = {};
    Object.keys(hooks).forEach((key)=>{
        const hook = hooks[key];
        // ref objects should be passed straight through without wrapping
        if (key.endsWith("Ref")) wrappedHooks[key] = hooks[key];
        else {
            const wrappedHook = $9e4bfc7637dd9b3c$var$wrapHookToRecognizeElement(hook);
            wrappedHooks[key] = ()=>wrappedHook;
        }
    });
    return wrappedHooks;
}
function $9e4bfc7637dd9b3c$var$setRef(ref, node) {
    if (typeof ref === "function") ref(node);
    else ref.current = node;
}
function $9e4bfc7637dd9b3c$var$cloneWithRef(element, newRef) {
    const previousRef = element.ref;
    (0, $6b6d471b1ffae726$export$f5708dca728d7177)(typeof previousRef !== "string", "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs");
    if (!previousRef) // When there is no ref on the element, use the new ref directly
    return (0, $7fPBF.cloneElement)(element, {
        ref: newRef
    });
    else return (0, $7fPBF.cloneElement)(element, {
        ref: (node)=>{
            $9e4bfc7637dd9b3c$var$setRef(previousRef, node);
            $9e4bfc7637dd9b3c$var$setRef(newRef, node);
        }
    });
}


class $c584b96630975b99$export$9a7176fb37ab5028 {
    receiveHandlerId(newHandlerId) {
        if (this.handlerId === newHandlerId) return;
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get connectTarget() {
        return this.dragSource;
    }
    get dragSourceOptions() {
        return this.dragSourceOptionsInternal;
    }
    set dragSourceOptions(options) {
        this.dragSourceOptionsInternal = options;
    }
    get dragPreviewOptions() {
        return this.dragPreviewOptionsInternal;
    }
    set dragPreviewOptions(options) {
        this.dragPreviewOptionsInternal = options;
    }
    reconnect() {
        const didChange = this.reconnectDragSource();
        this.reconnectDragPreview(didChange);
    }
    reconnectDragSource() {
        const dragSource = this.dragSource;
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
        if (didChange) this.disconnectDragSource();
        if (!this.handlerId) return didChange;
        if (!dragSource) {
            this.lastConnectedDragSource = dragSource;
            return didChange;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragSource = dragSource;
            this.lastConnectedDragSourceOptions = this.dragSourceOptions;
            this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
        }
        return didChange;
    }
    reconnectDragPreview(forceDidChange = false) {
        const dragPreview = this.dragPreview;
        // if nothing has changed then don't resubscribe
        const didChange = forceDidChange || this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
        if (didChange) this.disconnectDragPreview();
        if (!this.handlerId) return;
        if (!dragPreview) {
            this.lastConnectedDragPreview = dragPreview;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragPreview = dragPreview;
            this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
            this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
        }
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didConnectedDragSourceChange() {
        return this.lastConnectedDragSource !== this.dragSource;
    }
    didConnectedDragPreviewChange() {
        return this.lastConnectedDragPreview !== this.dragPreview;
    }
    didDragSourceOptionsChange() {
        return !(0, $5c0d7d230cf505e0$export$d36bdfa510afb180)(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
    }
    didDragPreviewOptionsChange() {
        return !(0, $5c0d7d230cf505e0$export$d36bdfa510afb180)(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
    }
    disconnectDragSource() {
        if (this.dragSourceUnsubscribe) {
            this.dragSourceUnsubscribe();
            this.dragSourceUnsubscribe = undefined;
        }
    }
    disconnectDragPreview() {
        if (this.dragPreviewUnsubscribe) {
            this.dragPreviewUnsubscribe();
            this.dragPreviewUnsubscribe = undefined;
            this.dragPreviewNode = null;
            this.dragPreviewRef = null;
        }
    }
    get dragSource() {
        return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
    }
    get dragPreview() {
        return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
    }
    clearDragSource() {
        this.dragSourceNode = null;
        this.dragSourceRef = null;
    }
    clearDragPreview() {
        this.dragPreviewNode = null;
        this.dragPreviewRef = null;
    }
    constructor(backend){
        this.hooks = (0, $9e4bfc7637dd9b3c$export$d8dcaf80ab4f6cb7)({
            dragSource: (node, options)=>{
                this.clearDragSource();
                this.dragSourceOptions = options || null;
                if ((0, $6ff893967de5eab5$export$4f9f5282de18fc69)(node)) this.dragSourceRef = node;
                else this.dragSourceNode = node;
                this.reconnectDragSource();
            },
            dragPreview: (node, options)=>{
                this.clearDragPreview();
                this.dragPreviewOptions = options || null;
                if ((0, $6ff893967de5eab5$export$4f9f5282de18fc69)(node)) this.dragPreviewRef = node;
                else this.dragPreviewNode = node;
                this.reconnectDragPreview();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dragSourceRef = null;
        this.dragSourceOptionsInternal = null;
        // The drag preview may either be attached via ref or connect function
        this.dragPreviewRef = null;
        this.dragPreviewOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDragSource = null;
        this.lastConnectedDragSourceOptions = null;
        this.lastConnectedDragPreview = null;
        this.lastConnectedDragPreviewOptions = null;
        this.backend = backend;
    }
}




var $7fPBF = parcelRequire("7fPBF");

function $c93a7c1795c555f9$export$49db7e1a057ab0fa() {
    const { dragDropManager: dragDropManager } = (0, $7fPBF.useContext)((0, $f4aff835dca10427$export$2d5c5ceac203fc1e));
    (0, $6b6d471b1ffae726$export$f5708dca728d7177)(dragDropManager != null, "Expected drag drop context");
    return dragDropManager;
}



function $0545c0a481748cac$export$a5dfa024c6f78e86(dragSourceOptions, dragPreviewOptions) {
    const manager = (0, $c93a7c1795c555f9$export$49db7e1a057ab0fa)();
    const connector = (0, $7fPBF.useMemo)(()=>new (0, $c584b96630975b99$export$9a7176fb37ab5028)(manager.getBackend()), [
        manager
    ]);
    (0, $6aeb1f89c47c90dd$export$700979bc83e7db82)(()=>{
        connector.dragSourceOptions = dragSourceOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragSource();
    }, [
        connector,
        dragSourceOptions
    ]);
    (0, $6aeb1f89c47c90dd$export$700979bc83e7db82)(()=>{
        connector.dragPreviewOptions = dragPreviewOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragPreview();
    }, [
        connector,
        dragPreviewOptions
    ]);
    return connector;
}



var $7fPBF = parcelRequire("7fPBF");

let $6ac9d86aa4ec3419$var$isCallingCanDrag = false;
let $6ac9d86aa4ec3419$var$isCallingIsDragging = false;
class $6ac9d86aa4ec3419$export$af934094fb48ddf {
    receiveHandlerId(sourceId) {
        this.sourceId = sourceId;
    }
    getHandlerId() {
        return this.sourceId;
    }
    canDrag() {
        (0, $6b6d471b1ffae726$export$f5708dca728d7177)(!$6ac9d86aa4ec3419$var$isCallingCanDrag, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
        try {
            $6ac9d86aa4ec3419$var$isCallingCanDrag = true;
            return this.internalMonitor.canDragSource(this.sourceId);
        } finally{
            $6ac9d86aa4ec3419$var$isCallingCanDrag = false;
        }
    }
    isDragging() {
        if (!this.sourceId) return false;
        (0, $6b6d471b1ffae726$export$f5708dca728d7177)(!$6ac9d86aa4ec3419$var$isCallingIsDragging, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
        try {
            $6ac9d86aa4ec3419$var$isCallingIsDragging = true;
            return this.internalMonitor.isDraggingSource(this.sourceId);
        } finally{
            $6ac9d86aa4ec3419$var$isCallingIsDragging = false;
        }
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    isDraggingSource(sourceId) {
        return this.internalMonitor.isDraggingSource(sourceId);
    }
    isOverTarget(targetId, options) {
        return this.internalMonitor.isOverTarget(targetId, options);
    }
    getTargetIds() {
        return this.internalMonitor.getTargetIds();
    }
    isSourcePublic() {
        return this.internalMonitor.isSourcePublic();
    }
    getSourceId() {
        return this.internalMonitor.getSourceId();
    }
    subscribeToOffsetChange(listener) {
        return this.internalMonitor.subscribeToOffsetChange(listener);
    }
    canDragSource(sourceId) {
        return this.internalMonitor.canDragSource(sourceId);
    }
    canDropOnTarget(targetId) {
        return this.internalMonitor.canDropOnTarget(targetId);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.sourceId = null;
        this.internalMonitor = manager.getMonitor();
    }
}



function $997440a115756e1a$export$82f95eab323fcd7a() {
    const manager = (0, $c93a7c1795c555f9$export$49db7e1a057ab0fa)();
    return (0, $7fPBF.useMemo)(()=>new (0, $6ac9d86aa4ec3419$export$af934094fb48ddf)(manager), [
        manager
    ]);
}


function $e8a1200e80d753aa$export$38b18180ae58b09b(type, target, manager) {
    const registry = manager.getRegistry();
    const targetId = registry.addTarget(type, target);
    return [
        targetId,
        ()=>registry.removeTarget(targetId)
    ];
}
function $e8a1200e80d753aa$export$51c814b9e17958c(type, source, manager) {
    const registry = manager.getRegistry();
    const sourceId = registry.addSource(type, source);
    return [
        sourceId,
        ()=>registry.removeSource(sourceId)
    ];
}





var $7fPBF = parcelRequire("7fPBF");
class $8fd3a382b118a3ca$export$680f0a3c92f9d645 {
    beginDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        let result = null;
        if (typeof spec.item === "object") result = spec.item;
        else if (typeof spec.item === "function") result = spec.item(monitor);
        else result = {};
        return result !== null && result !== void 0 ? result : null;
    }
    canDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (typeof spec.canDrag === "boolean") return spec.canDrag;
        else if (typeof spec.canDrag === "function") return spec.canDrag(monitor);
        else return true;
    }
    isDragging(globalMonitor, target) {
        const spec = this.spec;
        const monitor = this.monitor;
        const { isDragging: isDragging } = spec;
        return isDragging ? isDragging(monitor) : target === globalMonitor.getSourceId();
    }
    endDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        const connector = this.connector;
        const { end: end } = spec;
        if (end) end(monitor.getItem(), monitor);
        connector.reconnect();
    }
    constructor(spec, monitor, connector){
        this.spec = spec;
        this.monitor = monitor;
        this.connector = connector;
    }
}


function $a29649a562f18998$export$cdddb20adb7aad5c(spec, monitor, connector) {
    const handler = (0, $7fPBF.useMemo)(()=>new (0, $8fd3a382b118a3ca$export$680f0a3c92f9d645)(spec, monitor, connector), [
        monitor,
        connector
    ]);
    (0, $7fPBF.useEffect)(()=>{
        handler.spec = spec;
    }, [
        spec
    ]);
    return handler;
}




var $7fPBF = parcelRequire("7fPBF");
function $eae81d0c21a73282$export$dec3a5d742510a3f(spec) {
    return (0, $7fPBF.useMemo)(()=>{
        const result = spec.type;
        (0, $6b6d471b1ffae726$export$f5708dca728d7177)(result != null, "spec.type must be defined");
        return result;
    }, [
        spec
    ]);
}


function $f416b6d8f313a576$export$1bdd19ff5ac2e03c(spec, monitor, connector) {
    const manager = (0, $c93a7c1795c555f9$export$49db7e1a057ab0fa)();
    const handler = (0, $a29649a562f18998$export$cdddb20adb7aad5c)(spec, monitor, connector);
    const itemType = (0, $eae81d0c21a73282$export$dec3a5d742510a3f)(spec);
    (0, $6aeb1f89c47c90dd$export$700979bc83e7db82)(function registerDragSource() {
        if (itemType != null) {
            const [handlerId, unregister] = (0, $e8a1200e80d753aa$export$51c814b9e17958c)(itemType, handler, manager);
            monitor.receiveHandlerId(handlerId);
            connector.receiveHandlerId(handlerId);
            return unregister;
        }
        return;
    }, [
        manager,
        monitor,
        connector,
        handler,
        itemType
    ]);
}


function $33ac2d56891a4573$export$7941f8aafa4b6021(specArg, deps) {
    const spec = (0, $3554d3840fc025af$export$f16a07909151e918)(specArg, deps);
    (0, $6b6d471b1ffae726$export$f5708dca728d7177)(!spec.begin, `useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)`);
    const monitor = (0, $997440a115756e1a$export$82f95eab323fcd7a)();
    const connector = (0, $0545c0a481748cac$export$a5dfa024c6f78e86)(spec.options, spec.previewOptions);
    (0, $f416b6d8f313a576$export$1bdd19ff5ac2e03c)(spec, monitor, connector);
    return [
        (0, $ec9b480e023f385c$export$a55a4e3c0acb6f15)(spec.collect, monitor, connector),
        (0, $5ac93c1df0fa5f2b$export$90c397533e0cc6)(connector),
        (0, $5ac93c1df0fa5f2b$export$a66b3011bc8970d6)(connector)
    ];
}




var $7fPBF = parcelRequire("7fPBF");
function $6a1422733eb8171e$export$c914595a34b9504a(connector) {
    return (0, $7fPBF.useMemo)(()=>connector.hooks.dropTarget(), [
        connector
    ]);
}



var $7fPBF = parcelRequire("7fPBF");



class $fe55ecd5365d63a5$export$ed6d7b7bc55193cf {
    get connectTarget() {
        return this.dropTarget;
    }
    reconnect() {
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
        if (didChange) this.disconnectDropTarget();
        const dropTarget = this.dropTarget;
        if (!this.handlerId) return;
        if (!dropTarget) {
            this.lastConnectedDropTarget = dropTarget;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDropTarget = dropTarget;
            this.lastConnectedDropTargetOptions = this.dropTargetOptions;
            this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
        }
    }
    receiveHandlerId(newHandlerId) {
        if (newHandlerId === this.handlerId) return;
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get dropTargetOptions() {
        return this.dropTargetOptionsInternal;
    }
    set dropTargetOptions(options) {
        this.dropTargetOptionsInternal = options;
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didDropTargetChange() {
        return this.lastConnectedDropTarget !== this.dropTarget;
    }
    didOptionsChange() {
        return !(0, $5c0d7d230cf505e0$export$d36bdfa510afb180)(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
    }
    disconnectDropTarget() {
        if (this.unsubscribeDropTarget) {
            this.unsubscribeDropTarget();
            this.unsubscribeDropTarget = undefined;
        }
    }
    get dropTarget() {
        return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
    }
    clearDropTarget() {
        this.dropTargetRef = null;
        this.dropTargetNode = null;
    }
    constructor(backend){
        this.hooks = (0, $9e4bfc7637dd9b3c$export$d8dcaf80ab4f6cb7)({
            dropTarget: (node, options)=>{
                this.clearDropTarget();
                this.dropTargetOptions = options;
                if ((0, $6ff893967de5eab5$export$4f9f5282de18fc69)(node)) this.dropTargetRef = node;
                else this.dropTargetNode = node;
                this.reconnect();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dropTargetRef = null;
        this.dropTargetOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDropTarget = null;
        this.lastConnectedDropTargetOptions = null;
        this.backend = backend;
    }
}




function $1531f605f91e5c35$export$29242ded1aad6df7(options) {
    const manager = (0, $c93a7c1795c555f9$export$49db7e1a057ab0fa)();
    const connector = (0, $7fPBF.useMemo)(()=>new (0, $fe55ecd5365d63a5$export$ed6d7b7bc55193cf)(manager.getBackend()), [
        manager
    ]);
    (0, $6aeb1f89c47c90dd$export$700979bc83e7db82)(()=>{
        connector.dropTargetOptions = options || null;
        connector.reconnect();
        return ()=>connector.disconnectDropTarget();
    }, [
        options
    ]);
    return connector;
}



var $7fPBF = parcelRequire("7fPBF");

let $07d840b3fa652734$var$isCallingCanDrop = false;
class $07d840b3fa652734$export$9fe8834769ae8ddf {
    receiveHandlerId(targetId) {
        this.targetId = targetId;
    }
    getHandlerId() {
        return this.targetId;
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    canDrop() {
        // Cut out early if the target id has not been set. This should prevent errors
        // where the user has an older version of dnd-core like in
        // https://github.com/react-dnd/react-dnd/issues/1310
        if (!this.targetId) return false;
        (0, $6b6d471b1ffae726$export$f5708dca728d7177)(!$07d840b3fa652734$var$isCallingCanDrop, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
        try {
            $07d840b3fa652734$var$isCallingCanDrop = true;
            return this.internalMonitor.canDropOnTarget(this.targetId);
        } finally{
            $07d840b3fa652734$var$isCallingCanDrop = false;
        }
    }
    isOver(options) {
        if (!this.targetId) return false;
        return this.internalMonitor.isOverTarget(this.targetId, options);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.targetId = null;
        this.internalMonitor = manager.getMonitor();
    }
}



function $ef6eb21ec58426d0$export$f0c0ad05844dec3b() {
    const manager = (0, $c93a7c1795c555f9$export$49db7e1a057ab0fa)();
    return (0, $7fPBF.useMemo)(()=>new (0, $07d840b3fa652734$export$9fe8834769ae8ddf)(manager), [
        manager
    ]);
}







var $7fPBF = parcelRequire("7fPBF");
function $4e6c041b8d4f8a92$export$2a5cc7f0ac8651d0(spec) {
    const { accept: accept } = spec;
    return (0, $7fPBF.useMemo)(()=>{
        (0, $6b6d471b1ffae726$export$f5708dca728d7177)(spec.accept != null, "accept must be defined");
        return Array.isArray(accept) ? accept : [
            accept
        ];
    }, [
        accept
    ]);
}



var $7fPBF = parcelRequire("7fPBF");
class $951534accc8194ba$export$f26a17703f5cb233 {
    canDrop() {
        const spec = this.spec;
        const monitor = this.monitor;
        return spec.canDrop ? spec.canDrop(monitor.getItem(), monitor) : true;
    }
    hover() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.hover) spec.hover(monitor.getItem(), monitor);
    }
    drop() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.drop) return spec.drop(monitor.getItem(), monitor);
        return;
    }
    constructor(spec, monitor){
        this.spec = spec;
        this.monitor = monitor;
    }
}


function $149e71e718b359e1$export$5967d4bb72ce3c0(spec, monitor) {
    const dropTarget = (0, $7fPBF.useMemo)(()=>new (0, $951534accc8194ba$export$f26a17703f5cb233)(spec, monitor), [
        monitor
    ]);
    (0, $7fPBF.useEffect)(()=>{
        dropTarget.spec = spec;
    }, [
        spec
    ]);
    return dropTarget;
}


function $8758a33025627632$export$b31a008bfacf9de1(spec, monitor, connector) {
    const manager = (0, $c93a7c1795c555f9$export$49db7e1a057ab0fa)();
    const dropTarget = (0, $149e71e718b359e1$export$5967d4bb72ce3c0)(spec, monitor);
    const accept = (0, $4e6c041b8d4f8a92$export$2a5cc7f0ac8651d0)(spec);
    (0, $6aeb1f89c47c90dd$export$700979bc83e7db82)(function registerDropTarget() {
        const [handlerId, unregister] = (0, $e8a1200e80d753aa$export$38b18180ae58b09b)(accept, dropTarget, manager);
        monitor.receiveHandlerId(handlerId);
        connector.receiveHandlerId(handlerId);
        return unregister;
    }, [
        manager,
        monitor,
        dropTarget,
        connector,
        accept.map((a)=>a.toString()).join("|")
    ]);
}


function $6af5593d0127d7e1$export$ccdee5eaf73cf661(specArg, deps) {
    const spec = (0, $3554d3840fc025af$export$f16a07909151e918)(specArg, deps);
    const monitor = (0, $ef6eb21ec58426d0$export$f0c0ad05844dec3b)();
    const connector = (0, $1531f605f91e5c35$export$29242ded1aad6df7)(spec.options);
    (0, $8758a33025627632$export$b31a008bfacf9de1)(spec, monitor, connector);
    return [
        (0, $ec9b480e023f385c$export$a55a4e3c0acb6f15)(spec.collect, monitor, connector),
        (0, $6a1422733eb8171e$export$c914595a34b9504a)(connector)
    ];
}


// cheap lodash replacements
function $127d4851c768185a$export$fc10aeed3a532e2a(fn) {
    let result = null;
    const memoized = ()=>{
        if (result == null) result = fn();
        return result;
    };
    return memoized;
}
function $127d4851c768185a$export$5d14bf425b37f49e(items, item) {
    return items.filter((i)=>i !== item);
}
function $127d4851c768185a$export$971dd5b0dfd021b6(itemsA, itemsB) {
    const set = new Set();
    const insertItem = (item)=>set.add(item);
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    set.forEach((key)=>result.push(key));
    return result;
}


class $d18cade12d0c12bd$export$9ff3e6eb5c734d0d {
    enter(enteringNode) {
        const previousLength = this.entered.length;
        const isNodeEntered = (node)=>this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode));
        this.entered = (0, $127d4851c768185a$export$971dd5b0dfd021b6)(this.entered.filter(isNodeEntered), [
            enteringNode
        ]);
        return previousLength === 0 && this.entered.length > 0;
    }
    leave(leavingNode) {
        const previousLength = this.entered.length;
        this.entered = (0, $127d4851c768185a$export$5d14bf425b37f49e)(this.entered.filter(this.isNodeInDocument), leavingNode);
        return previousLength > 0 && this.entered.length === 0;
    }
    reset() {
        this.entered = [];
    }
    constructor(isNodeInDocument){
        this.entered = [];
        this.isNodeInDocument = isNodeInDocument;
    }
}


class $26df699a90d9399b$export$f22384f077cf51c4 {
    initializeExposedProperties() {
        Object.keys(this.config.exposeProperties).forEach((property)=>{
            Object.defineProperty(this.item, property, {
                configurable: true,
                enumerable: true,
                get () {
                    // eslint-disable-next-line no-console
                    console.warn(`Browser doesn't allow reading "${property}" until the drop event.`);
                    return null;
                }
            });
        });
    }
    loadDataTransfer(dataTransfer) {
        if (dataTransfer) {
            const newProperties = {};
            Object.keys(this.config.exposeProperties).forEach((property)=>{
                const propertyFn = this.config.exposeProperties[property];
                if (propertyFn != null) newProperties[property] = {
                    value: propertyFn(dataTransfer, this.config.matchesTypes),
                    configurable: true,
                    enumerable: true
                };
            });
            Object.defineProperties(this.item, newProperties);
        }
    }
    canDrag() {
        return true;
    }
    beginDrag() {
        return this.item;
    }
    isDragging(monitor, handle) {
        return handle === monitor.getSourceId();
    }
    endDrag() {
    // empty
    }
    constructor(config){
        this.config = config;
        this.item = {};
        this.initializeExposedProperties();
    }
}


var $c029df516b6fb7e6$exports = {};

$parcel$export($c029df516b6fb7e6$exports, "FILE", function () { return $c029df516b6fb7e6$export$1802dbfd31b58482; });
$parcel$export($c029df516b6fb7e6$exports, "URL", function () { return $c029df516b6fb7e6$export$61abde59b50deb8e; });
$parcel$export($c029df516b6fb7e6$exports, "TEXT", function () { return $c029df516b6fb7e6$export$d597759d33be802e; });
$parcel$export($c029df516b6fb7e6$exports, "HTML", function () { return $c029df516b6fb7e6$export$9dcd2b1ca4768128; });
const $c029df516b6fb7e6$export$1802dbfd31b58482 = "__NATIVE_FILE__";
const $c029df516b6fb7e6$export$61abde59b50deb8e = "__NATIVE_URL__";
const $c029df516b6fb7e6$export$d597759d33be802e = "__NATIVE_TEXT__";
const $c029df516b6fb7e6$export$9dcd2b1ca4768128 = "__NATIVE_HTML__";


function $27314a62ecf0d76b$export$dc02f6a7b68f305f(dataTransfer, typesToTry, defaultValue) {
    const result = typesToTry.reduce((resultSoFar, typeToTry)=>resultSoFar || dataTransfer.getData(typeToTry), "");
    return result != null ? result : defaultValue;
}


const $3caa02a0f6c9477e$export$8cc89d9b8cb1bd88 = {
    [$c029df516b6fb7e6$export$1802dbfd31b58482]: {
        exposeProperties: {
            files: (dataTransfer)=>Array.prototype.slice.call(dataTransfer.files),
            items: (dataTransfer)=>dataTransfer.items,
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Files"
        ]
    },
    [$c029df516b6fb7e6$export$9dcd2b1ca4768128]: {
        exposeProperties: {
            html: (dataTransfer, matchesTypes)=>(0, $27314a62ecf0d76b$export$dc02f6a7b68f305f)(dataTransfer, matchesTypes, ""),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Html",
            "text/html"
        ]
    },
    [$c029df516b6fb7e6$export$61abde59b50deb8e]: {
        exposeProperties: {
            urls: (dataTransfer, matchesTypes)=>(0, $27314a62ecf0d76b$export$dc02f6a7b68f305f)(dataTransfer, matchesTypes, "").split("\n"),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Url",
            "text/uri-list"
        ]
    },
    [$c029df516b6fb7e6$export$d597759d33be802e]: {
        exposeProperties: {
            text: (dataTransfer, matchesTypes)=>(0, $27314a62ecf0d76b$export$dc02f6a7b68f305f)(dataTransfer, matchesTypes, ""),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Text",
            "text/plain"
        ]
    }
};


function $b64dd8ea9239c8e4$export$ada362c01636774d(type, dataTransfer) {
    const config = (0, $3caa02a0f6c9477e$export$8cc89d9b8cb1bd88)[type];
    if (!config) throw new Error(`native type ${type} has no configuration`);
    const result = new (0, $26df699a90d9399b$export$f22384f077cf51c4)(config);
    result.loadDataTransfer(dataTransfer);
    return result;
}
function $b64dd8ea9239c8e4$export$11b547ed8c182c11(dataTransfer) {
    if (!dataTransfer) return null;
    const dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
    return Object.keys((0, $3caa02a0f6c9477e$export$8cc89d9b8cb1bd88)).filter((nativeItemType)=>{
        const typeConfig = (0, $3caa02a0f6c9477e$export$8cc89d9b8cb1bd88)[nativeItemType];
        if (!(typeConfig === null || typeConfig === void 0 ? void 0 : typeConfig.matchesTypes)) return false;
        return typeConfig.matchesTypes.some((t)=>dataTransferTypes.indexOf(t) > -1);
    })[0] || null;
}




const $88d90ac2cac9c616$export$b7d78993b74f766d = (0, $127d4851c768185a$export$fc10aeed3a532e2a)(()=>/firefox/i.test(navigator.userAgent));
const $88d90ac2cac9c616$export$95df08bae54cb4df = (0, $127d4851c768185a$export$fc10aeed3a532e2a)(()=>Boolean(window.safari));


class $2da27da0504b2a13$export$6d87c156c5199b02 {
    interpolate(x) {
        const { xs: xs, ys: ys, c1s: c1s, c2s: c2s, c3s: c3s } = this;
        // The rightmost point in the dataset should give an exact result
        let i = xs.length - 1;
        if (x === xs[i]) return ys[i];
        // Search for the interval x is in, returning the corresponding y if x is one of the original xs
        let low = 0;
        let high = c3s.length - 1;
        let mid;
        while(low <= high){
            mid = Math.floor(0.5 * (low + high));
            const xHere = xs[mid];
            if (xHere < x) low = mid + 1;
            else if (xHere > x) high = mid - 1;
            else return ys[mid];
        }
        i = Math.max(0, high);
        // Interpolate
        const diff = x - xs[i];
        const diffSq = diff * diff;
        return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
    }
    constructor(xs, ys){
        const { length: length } = xs;
        // Rearrange xs and ys so that xs is sorted
        const indexes = [];
        for(let i = 0; i < length; i++)indexes.push(i);
        indexes.sort((a, b)=>xs[a] < xs[b] ? -1 : 1);
        // Get consecutive differences and slopes
        const dys = [];
        const dxs = [];
        const ms = [];
        let dx;
        let dy;
        for(let i1 = 0; i1 < length - 1; i1++){
            dx = xs[i1 + 1] - xs[i1];
            dy = ys[i1 + 1] - ys[i1];
            dxs.push(dx);
            dys.push(dy);
            ms.push(dy / dx);
        }
        // Get degree-1 coefficients
        const c1s = [
            ms[0]
        ];
        for(let i2 = 0; i2 < dxs.length - 1; i2++){
            const m2 = ms[i2];
            const mNext = ms[i2 + 1];
            if (m2 * mNext <= 0) c1s.push(0);
            else {
                dx = dxs[i2];
                const dxNext = dxs[i2 + 1];
                const common = dx + dxNext;
                c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
            }
        }
        c1s.push(ms[ms.length - 1]);
        // Get degree-2 and degree-3 coefficients
        const c2s = [];
        const c3s = [];
        let m;
        for(let i3 = 0; i3 < c1s.length - 1; i3++){
            m = ms[i3];
            const c1 = c1s[i3];
            const invDx = 1 / dxs[i3];
            const common = c1 + c1s[i3 + 1] - m - m;
            c2s.push((m - c1 - common) * invDx);
            c3s.push(common * invDx * invDx);
        }
        this.xs = xs;
        this.ys = ys;
        this.c1s = c1s;
        this.c2s = c2s;
        this.c3s = c3s;
    }
}


const $dc24dd845be1db4a$var$ELEMENT_NODE = 1;
function $dc24dd845be1db4a$export$8419e8612027b1d8(node) {
    const el = node.nodeType === $dc24dd845be1db4a$var$ELEMENT_NODE ? node : node.parentElement;
    if (!el) return null;
    const { top: top, left: left } = el.getBoundingClientRect();
    return {
        x: left,
        y: top
    };
}
function $dc24dd845be1db4a$export$710c829989c68339(e) {
    return {
        x: e.clientX,
        y: e.clientY
    };
}
function $dc24dd845be1db4a$var$isImageNode(node) {
    var ref;
    return node.nodeName === "IMG" && ((0, $88d90ac2cac9c616$export$b7d78993b74f766d)() || !((ref = document.documentElement) === null || ref === void 0 ? void 0 : ref.contains(node)));
}
function $dc24dd845be1db4a$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
    let dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
    let dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
    // Work around @2x coordinate discrepancies in browsers
    if ((0, $88d90ac2cac9c616$export$95df08bae54cb4df)() && isImage) {
        dragPreviewHeight /= window.devicePixelRatio;
        dragPreviewWidth /= window.devicePixelRatio;
    }
    return {
        dragPreviewWidth: dragPreviewWidth,
        dragPreviewHeight: dragPreviewHeight
    };
}
function $dc24dd845be1db4a$export$e99fdbb90efc75c5(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
    // The browsers will use the image intrinsic size under different conditions.
    // Firefox only cares if it's an image, but WebKit also wants it to be detached.
    const isImage = $dc24dd845be1db4a$var$isImageNode(dragPreview);
    const dragPreviewNode = isImage ? sourceNode : dragPreview;
    const dragPreviewNodeOffsetFromClient = $dc24dd845be1db4a$export$8419e8612027b1d8(dragPreviewNode);
    const offsetFromDragPreview = {
        x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
        y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
    };
    const { offsetWidth: sourceWidth, offsetHeight: sourceHeight } = sourceNode;
    const { anchorX: anchorX, anchorY: anchorY } = anchorPoint;
    const { dragPreviewWidth: dragPreviewWidth, dragPreviewHeight: dragPreviewHeight } = $dc24dd845be1db4a$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight);
    const calculateYOffset = ()=>{
        const interpolantY = new (0, $2da27da0504b2a13$export$6d87c156c5199b02)([
            0,
            0.5,
            1
        ], [
            // Dock to the top
            offsetFromDragPreview.y,
            // Align at the center
            offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
            // Dock to the bottom
            offsetFromDragPreview.y + dragPreviewHeight - sourceHeight
        ]);
        let y = interpolantY.interpolate(anchorY);
        // Work around Safari 8 positioning bug
        if ((0, $88d90ac2cac9c616$export$95df08bae54cb4df)() && isImage) // We'll have to wait for @3x to see if this is entirely correct
        y += (window.devicePixelRatio - 1) * dragPreviewHeight;
        return y;
    };
    const calculateXOffset = ()=>{
        // Interpolate coordinates depending on anchor point
        // If you know a simpler way to do this, let me know
        const interpolantX = new (0, $2da27da0504b2a13$export$6d87c156c5199b02)([
            0,
            0.5,
            1
        ], [
            // Dock to the left
            offsetFromDragPreview.x,
            // Align at the center
            offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
            // Dock to the right
            offsetFromDragPreview.x + dragPreviewWidth - sourceWidth
        ]);
        return interpolantX.interpolate(anchorX);
    };
    // Force offsets if specified in the options.
    const { offsetX: offsetX, offsetY: offsetY } = offsetPoint;
    const isManualOffsetX = offsetX === 0 || offsetX;
    const isManualOffsetY = offsetY === 0 || offsetY;
    return {
        x: isManualOffsetX ? offsetX : calculateXOffset(),
        y: isManualOffsetY ? offsetY : calculateYOffset()
    };
}


class $94ee75401d7c1d13$export$2b3a268803e49e64 {
    get window() {
        if (this.globalContext) return this.globalContext;
        else if (typeof window !== "undefined") return window;
        return undefined;
    }
    get document() {
        var ref;
        if ((ref = this.globalContext) === null || ref === void 0 ? void 0 : ref.document) return this.globalContext.document;
        else if (this.window) return this.window.document;
        else return undefined;
    }
    get rootElement() {
        var ref;
        return ((ref = this.optionsArgs) === null || ref === void 0 ? void 0 : ref.rootElement) || this.window;
    }
    constructor(globalContext, options){
        this.ownerDocument = null;
        this.globalContext = globalContext;
        this.optionsArgs = options;
    }
}


function $c8f87edb486f2a0e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c8f87edb486f2a0e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $c8f87edb486f2a0e$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
class $c8f87edb486f2a0e$export$3a01990c235a9281 {
    /**
	 * Generate profiling statistics for the HTML5Backend.
	 */ profile() {
        var ref, ref1;
        return {
            sourcePreviewNodes: this.sourcePreviewNodes.size,
            sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
            sourceNodeOptions: this.sourceNodeOptions.size,
            sourceNodes: this.sourceNodes.size,
            dragStartSourceIds: ((ref = this.dragStartSourceIds) === null || ref === void 0 ? void 0 : ref.length) || 0,
            dropTargetIds: this.dropTargetIds.length,
            dragEnterTargetIds: this.dragEnterTargetIds.length,
            dragOverTargetIds: ((ref1 = this.dragOverTargetIds) === null || ref1 === void 0 ? void 0 : ref1.length) || 0
        };
    }
    // public for test
    get window() {
        return this.options.window;
    }
    get document() {
        return this.options.document;
    }
    /**
	 * Get the root element to use for event subscriptions
	 */ get rootElement() {
        return this.options.rootElement;
    }
    setup() {
        const root = this.rootElement;
        if (root === undefined) return;
        if (root.__isReactDndBackendSetUp) throw new Error("Cannot have two HTML5 backends at the same time.");
        root.__isReactDndBackendSetUp = true;
        this.addEventListeners(root);
    }
    teardown() {
        const root = this.rootElement;
        if (root === undefined) return;
        root.__isReactDndBackendSetUp = false;
        this.removeEventListeners(this.rootElement);
        this.clearCurrentDragSourceNode();
        if (this.asyncEndDragFrameId) {
            var ref;
            (ref = this.window) === null || ref === void 0 || ref.cancelAnimationFrame(this.asyncEndDragFrameId);
        }
    }
    connectDragPreview(sourceId, node, options) {
        this.sourcePreviewNodeOptions.set(sourceId, options);
        this.sourcePreviewNodes.set(sourceId, node);
        return ()=>{
            this.sourcePreviewNodes.delete(sourceId);
            this.sourcePreviewNodeOptions.delete(sourceId);
        };
    }
    connectDragSource(sourceId, node, options) {
        this.sourceNodes.set(sourceId, node);
        this.sourceNodeOptions.set(sourceId, options);
        const handleDragStart = (e)=>this.handleDragStart(e, sourceId);
        const handleSelectStart = (e)=>this.handleSelectStart(e);
        node.setAttribute("draggable", "true");
        node.addEventListener("dragstart", handleDragStart);
        node.addEventListener("selectstart", handleSelectStart);
        return ()=>{
            this.sourceNodes.delete(sourceId);
            this.sourceNodeOptions.delete(sourceId);
            node.removeEventListener("dragstart", handleDragStart);
            node.removeEventListener("selectstart", handleSelectStart);
            node.setAttribute("draggable", "false");
        };
    }
    connectDropTarget(targetId, node) {
        const handleDragEnter = (e)=>this.handleDragEnter(e, targetId);
        const handleDragOver = (e)=>this.handleDragOver(e, targetId);
        const handleDrop = (e)=>this.handleDrop(e, targetId);
        node.addEventListener("dragenter", handleDragEnter);
        node.addEventListener("dragover", handleDragOver);
        node.addEventListener("drop", handleDrop);
        return ()=>{
            node.removeEventListener("dragenter", handleDragEnter);
            node.removeEventListener("dragover", handleDragOver);
            node.removeEventListener("drop", handleDrop);
        };
    }
    addEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.addEventListener) return;
        target.addEventListener("dragstart", this.handleTopDragStart);
        target.addEventListener("dragstart", this.handleTopDragStartCapture, true);
        target.addEventListener("dragend", this.handleTopDragEndCapture, true);
        target.addEventListener("dragenter", this.handleTopDragEnter);
        target.addEventListener("dragenter", this.handleTopDragEnterCapture, true);
        target.addEventListener("dragleave", this.handleTopDragLeaveCapture, true);
        target.addEventListener("dragover", this.handleTopDragOver);
        target.addEventListener("dragover", this.handleTopDragOverCapture, true);
        target.addEventListener("drop", this.handleTopDrop);
        target.addEventListener("drop", this.handleTopDropCapture, true);
    }
    removeEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.removeEventListener) return;
        target.removeEventListener("dragstart", this.handleTopDragStart);
        target.removeEventListener("dragstart", this.handleTopDragStartCapture, true);
        target.removeEventListener("dragend", this.handleTopDragEndCapture, true);
        target.removeEventListener("dragenter", this.handleTopDragEnter);
        target.removeEventListener("dragenter", this.handleTopDragEnterCapture, true);
        target.removeEventListener("dragleave", this.handleTopDragLeaveCapture, true);
        target.removeEventListener("dragover", this.handleTopDragOver);
        target.removeEventListener("dragover", this.handleTopDragOverCapture, true);
        target.removeEventListener("drop", this.handleTopDrop);
        target.removeEventListener("drop", this.handleTopDropCapture, true);
    }
    getCurrentSourceNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
        return $c8f87edb486f2a0e$var$_objectSpread({
            dropEffect: this.altKeyPressed ? "copy" : "move"
        }, sourceNodeOptions || {});
    }
    getCurrentDropEffect() {
        if (this.isDraggingNativeItem()) // It makes more sense to default to 'copy' for native resources
        return "copy";
        return this.getCurrentSourceNodeOptions().dropEffect;
    }
    getCurrentSourcePreviewNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
        return $c8f87edb486f2a0e$var$_objectSpread({
            anchorX: 0.5,
            anchorY: 0.5,
            captureDraggingState: false
        }, sourcePreviewNodeOptions || {});
    }
    isDraggingNativeItem() {
        const itemType = this.monitor.getItemType();
        return Object.keys($c029df516b6fb7e6$exports).some((key)=>$c029df516b6fb7e6$exports[key] === itemType);
    }
    beginDragNativeItem(type, dataTransfer) {
        this.clearCurrentDragSourceNode();
        this.currentNativeSource = (0, $b64dd8ea9239c8e4$export$ada362c01636774d)(type, dataTransfer);
        this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
        this.actions.beginDrag([
            this.currentNativeHandle
        ]);
    }
    setCurrentDragSourceNode(node) {
        this.clearCurrentDragSourceNode();
        this.currentDragSourceNode = node;
        // A timeout of > 0 is necessary to resolve Firefox issue referenced
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        const MOUSE_MOVE_TIMEOUT = 1000;
        // Receiving a mouse event in the middle of a dragging operation
        // means it has ended and the drag source node disappeared from DOM,
        // so the browser didn't dispatch the dragend event.
        //
        // We need to wait before we start listening for mousemove events.
        // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
        // immediately in some browsers.
        //
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        //
        this.mouseMoveTimeoutTimer = setTimeout(()=>{
            var ref;
            return (ref = this.rootElement) === null || ref === void 0 ? void 0 : ref.addEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, true);
        }, MOUSE_MOVE_TIMEOUT);
    }
    clearCurrentDragSourceNode() {
        if (this.currentDragSourceNode) {
            this.currentDragSourceNode = null;
            if (this.rootElement) {
                var ref;
                (ref = this.window) === null || ref === void 0 || ref.clearTimeout(this.mouseMoveTimeoutTimer || undefined);
                this.rootElement.removeEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, true);
            }
            this.mouseMoveTimeoutTimer = null;
            return true;
        }
        return false;
    }
    handleDragStart(e, sourceId) {
        if (e.defaultPrevented) return;
        if (!this.dragStartSourceIds) this.dragStartSourceIds = [];
        this.dragStartSourceIds.unshift(sourceId);
    }
    handleDragEnter(_e, targetId) {
        this.dragEnterTargetIds.unshift(targetId);
    }
    handleDragOver(_e, targetId) {
        if (this.dragOverTargetIds === null) this.dragOverTargetIds = [];
        this.dragOverTargetIds.unshift(targetId);
    }
    handleDrop(_e, targetId) {
        this.dropTargetIds.unshift(targetId);
    }
    constructor(manager, globalContext, options){
        this.sourcePreviewNodes = new Map();
        this.sourcePreviewNodeOptions = new Map();
        this.sourceNodes = new Map();
        this.sourceNodeOptions = new Map();
        this.dragStartSourceIds = null;
        this.dropTargetIds = [];
        this.dragEnterTargetIds = [];
        this.currentNativeSource = null;
        this.currentNativeHandle = null;
        this.currentDragSourceNode = null;
        this.altKeyPressed = false;
        this.mouseMoveTimeoutTimer = null;
        this.asyncEndDragFrameId = null;
        this.dragOverTargetIds = null;
        this.lastClientOffset = null;
        this.hoverRafId = null;
        this.getSourceClientOffset = (sourceId)=>{
            const source = this.sourceNodes.get(sourceId);
            return source && (0, $dc24dd845be1db4a$export$8419e8612027b1d8)(source) || null;
        };
        this.endDragNativeItem = ()=>{
            if (!this.isDraggingNativeItem()) return;
            this.actions.endDrag();
            if (this.currentNativeHandle) this.registry.removeSource(this.currentNativeHandle);
            this.currentNativeHandle = null;
            this.currentNativeSource = null;
        };
        this.isNodeInDocument = (node)=>{
            // Check the node either in the main document or in the current context
            return Boolean(node && this.document && this.document.body && this.document.body.contains(node));
        };
        this.endDragIfSourceWasRemovedFromDOM = ()=>{
            const node = this.currentDragSourceNode;
            if (node == null || this.isNodeInDocument(node)) return;
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) this.actions.endDrag();
            this.cancelHover();
        };
        this.scheduleHover = (dragOverTargetIds)=>{
            if (this.hoverRafId === null && typeof requestAnimationFrame !== "undefined") this.hoverRafId = requestAnimationFrame(()=>{
                if (this.monitor.isDragging()) this.actions.hover(dragOverTargetIds || [], {
                    clientOffset: this.lastClientOffset
                });
                this.hoverRafId = null;
            });
        };
        this.cancelHover = ()=>{
            if (this.hoverRafId !== null && typeof cancelAnimationFrame !== "undefined") {
                cancelAnimationFrame(this.hoverRafId);
                this.hoverRafId = null;
            }
        };
        this.handleTopDragStartCapture = ()=>{
            this.clearCurrentDragSourceNode();
            this.dragStartSourceIds = [];
        };
        this.handleTopDragStart = (e)=>{
            if (e.defaultPrevented) return;
            const { dragStartSourceIds: dragStartSourceIds } = this;
            this.dragStartSourceIds = null;
            const clientOffset = (0, $dc24dd845be1db4a$export$710c829989c68339)(e);
            // Avoid crashing if we missed a drop event or our previous drag died
            if (this.monitor.isDragging()) {
                this.actions.endDrag();
                this.cancelHover();
            }
            // Don't publish the source just yet (see why below)
            this.actions.beginDrag(dragStartSourceIds || [], {
                publishSource: false,
                getSourceClientOffset: this.getSourceClientOffset,
                clientOffset: clientOffset
            });
            const { dataTransfer: dataTransfer } = e;
            const nativeType = (0, $b64dd8ea9239c8e4$export$11b547ed8c182c11)(dataTransfer);
            if (this.monitor.isDragging()) {
                if (dataTransfer && typeof dataTransfer.setDragImage === "function") {
                    // Use custom drag image if user specifies it.
                    // If child drag source refuses drag but parent agrees,
                    // use parent's node as drag image. Neither works in IE though.
                    const sourceId = this.monitor.getSourceId();
                    const sourceNode = this.sourceNodes.get(sourceId);
                    const dragPreview = this.sourcePreviewNodes.get(sourceId) || sourceNode;
                    if (dragPreview) {
                        const { anchorX: anchorX, anchorY: anchorY, offsetX: offsetX, offsetY: offsetY } = this.getCurrentSourcePreviewNodeOptions();
                        const anchorPoint = {
                            anchorX: anchorX,
                            anchorY: anchorY
                        };
                        const offsetPoint = {
                            offsetX: offsetX,
                            offsetY: offsetY
                        };
                        const dragPreviewOffset = (0, $dc24dd845be1db4a$export$e99fdbb90efc75c5)(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
                        dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
                    }
                }
                try {
                    // Firefox won't drag without setting data
                    dataTransfer === null || dataTransfer === void 0 || dataTransfer.setData("application/json", {});
                } catch (err) {
                // IE doesn't support MIME types in setData
                }
                // Store drag source node so we can check whether
                // it is removed from DOM and trigger endDrag manually.
                this.setCurrentDragSourceNode(e.target);
                // Now we are ready to publish the drag source.. or are we not?
                const { captureDraggingState: captureDraggingState } = this.getCurrentSourcePreviewNodeOptions();
                if (!captureDraggingState) // Usually we want to publish it in the next tick so that browser
                // is able to screenshot the current (not yet dragging) state.
                //
                // It also neatly avoids a situation where render() returns null
                // in the same tick for the source element, and browser freaks out.
                setTimeout(()=>this.actions.publishDragSource(), 0);
                else // In some cases the user may want to override this behavior, e.g.
                // to work around IE not supporting custom drag previews.
                //
                // When using a custom drag layer, the only way to prevent
                // the default drag preview from drawing in IE is to screenshot
                // the dragging state in which the node itself has zero opacity
                // and height. In this case, though, returning null from render()
                // will abruptly end the dragging, which is not obvious.
                //
                // This is the reason such behavior is strictly opt-in.
                this.actions.publishDragSource();
            } else if (nativeType) // A native item (such as URL) dragged from inside the document
            this.beginDragNativeItem(nativeType);
            else if (dataTransfer && !dataTransfer.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute("draggable"))) // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
            // Just let it drag. It's a native type (URL or text) and will be picked up in
            // dragenter handler.
            return;
            else // If by this time no drag source reacted, tell browser not to drag.
            e.preventDefault();
        };
        this.handleTopDragEndCapture = ()=>{
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) // Firefox can dispatch this event in an infinite loop
            // if dragend handler does something like showing an alert.
            // Only proceed if we have not handled it already.
            this.actions.endDrag();
            this.cancelHover();
        };
        this.handleTopDragEnterCapture = (e)=>{
            this.dragEnterTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            }
            const isFirstEnter = this.enterLeaveCounter.enter(e.target);
            if (!isFirstEnter || this.monitor.isDragging()) return;
            const { dataTransfer: dataTransfer } = e;
            const nativeType = (0, $b64dd8ea9239c8e4$export$11b547ed8c182c11)(dataTransfer);
            if (nativeType) // A native item (such as file or URL) dragged from outside the document
            this.beginDragNativeItem(nativeType, dataTransfer);
        };
        this.handleTopDragEnter = (e)=>{
            const { dragEnterTargetIds: dragEnterTargetIds } = this;
            this.dragEnterTargetIds = [];
            if (!this.monitor.isDragging()) // This is probably a native item type we don't understand.
            return;
            this.altKeyPressed = e.altKey;
            // If the target changes position as the result of `dragenter`, `dragover` might still
            // get dispatched despite target being no longer there. The easy solution is to check
            // whether there actually is a target before firing `hover`.
            if (dragEnterTargetIds.length > 0) this.actions.hover(dragEnterTargetIds, {
                clientOffset: (0, $dc24dd845be1db4a$export$710c829989c68339)(e)
            });
            const canDrop = dragEnterTargetIds.some((targetId)=>this.monitor.canDropOnTarget(targetId));
            if (canDrop) {
                // IE requires this to fire dragover events
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = this.getCurrentDropEffect();
            }
        };
        this.handleTopDragOverCapture = (e)=>{
            this.dragOverTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            }
        };
        this.handleTopDragOver = (e)=>{
            const { dragOverTargetIds: dragOverTargetIds } = this;
            this.dragOverTargetIds = [];
            if (!this.monitor.isDragging()) {
                // This is probably a native item type we don't understand.
                // Prevent default "drop and blow away the whole document" action.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = "none";
                return;
            }
            this.altKeyPressed = e.altKey;
            this.lastClientOffset = (0, $dc24dd845be1db4a$export$710c829989c68339)(e);
            this.scheduleHover(dragOverTargetIds);
            const canDrop = (dragOverTargetIds || []).some((targetId)=>this.monitor.canDropOnTarget(targetId));
            if (canDrop) {
                // Show user-specified drop effect.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = this.getCurrentDropEffect();
            } else if (this.isDraggingNativeItem()) // Don't show a nice cursor but still prevent default
            // "drop and blow away the whole document" action.
            e.preventDefault();
            else {
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = "none";
            }
        };
        this.handleTopDragLeaveCapture = (e)=>{
            if (this.isDraggingNativeItem()) e.preventDefault();
            const isLastLeave = this.enterLeaveCounter.leave(e.target);
            if (!isLastLeave) return;
            if (this.isDraggingNativeItem()) setTimeout(()=>this.endDragNativeItem(), 0);
            this.cancelHover();
        };
        this.handleTopDropCapture = (e)=>{
            this.dropTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                e.preventDefault();
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            } else if ((0, $b64dd8ea9239c8e4$export$11b547ed8c182c11)(e.dataTransfer)) // Dragging some elements, like <a> and <img> may still behave like a native drag event,
            // even if the current drag event matches a user-defined type.
            // Stop the default behavior when we're not expecting a native item to be dropped.
            e.preventDefault();
            this.enterLeaveCounter.reset();
        };
        this.handleTopDrop = (e)=>{
            const { dropTargetIds: dropTargetIds } = this;
            this.dropTargetIds = [];
            this.actions.hover(dropTargetIds, {
                clientOffset: (0, $dc24dd845be1db4a$export$710c829989c68339)(e)
            });
            this.actions.drop({
                dropEffect: this.getCurrentDropEffect()
            });
            if (this.isDraggingNativeItem()) this.endDragNativeItem();
            else if (this.monitor.isDragging()) this.actions.endDrag();
            this.cancelHover();
        };
        this.handleSelectStart = (e)=>{
            const target = e.target;
            // Only IE requires us to explicitly say
            // we want drag drop operation to start
            if (typeof target.dragDrop !== "function") return;
            // Inputs and textareas should be selectable
            if (target.tagName === "INPUT" || target.tagName === "SELECT" || target.tagName === "TEXTAREA" || target.isContentEditable) return;
            // For other targets, ask IE
            // to enable drag and drop
            e.preventDefault();
            target.dragDrop();
        };
        this.options = new (0, $94ee75401d7c1d13$export$2b3a268803e49e64)(globalContext, options);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.registry = manager.getRegistry();
        this.enterLeaveCounter = new (0, $d18cade12d0c12bd$export$9ff3e6eb5c734d0d)(this.isNodeInDocument);
    }
}




const $adc78aa6dde5fba1$export$f4f61d779bb20744 = function createBackend(manager, context, options) {
    return new (0, $c8f87edb486f2a0e$export$3a01990c235a9281)(manager, context, options);
};


const $fadcf04f5e0ec6ac$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $fadcf04f5e0ec6ac$export$2e2bcd8739ae039 = {
    randomUUID: $fadcf04f5e0ec6ac$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $2bcaa466815aa8a5$var$getRandomValues;
const $2bcaa466815aa8a5$var$rnds8 = new Uint8Array(16);
function $2bcaa466815aa8a5$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$2bcaa466815aa8a5$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $2bcaa466815aa8a5$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$2bcaa466815aa8a5$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $2bcaa466815aa8a5$var$getRandomValues($2bcaa466815aa8a5$var$rnds8);
}


var $7709510a2fca9f72$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $8df89a4d60889f85$var$validate(uuid) {
    return typeof uuid === "string" && (0, $7709510a2fca9f72$export$2e2bcd8739ae039).test(uuid);
}
var $8df89a4d60889f85$export$2e2bcd8739ae039 = $8df89a4d60889f85$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $ee13ceee8d9f46c4$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$ee13ceee8d9f46c4$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $ee13ceee8d9f46c4$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 0]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 1]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 2]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 3]] + "-" + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 4]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 5]] + "-" + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 6]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 7]] + "-" + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 8]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 9]] + "-" + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 10]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 11]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 12]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 13]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 14]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 15]];
}
function $ee13ceee8d9f46c4$var$stringify(arr, offset = 0) {
    const uuid = $ee13ceee8d9f46c4$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $8df89a4d60889f85$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $ee13ceee8d9f46c4$export$2e2bcd8739ae039 = $ee13ceee8d9f46c4$var$stringify;


function $6810e10b84975c3e$var$v4(options, buf, offset) {
    if ((0, $fadcf04f5e0ec6ac$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $fadcf04f5e0ec6ac$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $2bcaa466815aa8a5$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $ee13ceee8d9f46c4$export$8fb373d660548968)(rnds);
}
var $6810e10b84975c3e$export$2e2bcd8739ae039 = $6810e10b84975c3e$var$v4;










var $c5096964d50e626a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c5096964d50e626a$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $c5096964d50e626a$var$CMSMenusRoute = "/members/cms/menus";
var $c5096964d50e626a$var$table = "CMSMenuItems";
var $c5096964d50e626a$var$CMSMenuItemsAPI = {
    getByMenuID: function(navigation, menuID) {
        return $c5096964d50e626a$var$__awaiter(void 0, void 0, Promise, function() {
            var result1, ex_1;
            return $c5096964d50e626a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        if (!navigation) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0, $02b369573055e688$export$2e2bcd8739ae039)(navigation)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            4,
                            (0, $cd347cc85afbaa02$export$2c4e825dc9120f87).graphql({
                                query: (0, $d819d0cbe64233c2$export$d35d755fa91e9a0e),
                                variables: {
                                    menuID: menuID
                                },
                                authMode: "API_KEY"
                            })
                        ];
                    case 3:
                        result1 = _a.sent();
                        return [
                            2,
                            result1.data.getByMenuIDForCMSMenuItem.items
                        ];
                    case 4:
                        ex_1 = _a.sent();
                        console.log(ex_1);
                        (0, $de77e498e07914bf$export$b410431fab84fa58).error("Unable to contact server");
                        if (navigation) navigation($c5096964d50e626a$var$CMSMenusRoute);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
    },
    delete: function(navigation, id) {
        return $c5096964d50e626a$var$__awaiter(void 0, void 0, Promise, function() {
            var input, error_1;
            return $c5096964d50e626a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        (0, $de77e498e07914bf$export$b410431fab84fa58).loading("Processing...");
                        return [
                            4,
                            (0, $02b369573055e688$export$2e2bcd8739ae039)(navigation)
                        ];
                    case 1:
                        _a.sent();
                        input = {
                            id: id
                        };
                        return [
                            4,
                            (0, $cd347cc85afbaa02$export$2c4e825dc9120f87).graphql({
                                query: (0, $7a1d5ab68f58f51c$export$a6b4f67d228ab4c9),
                                variables: {
                                    input: input
                                },
                                authMode: "AMAZON_COGNITO_USER_POOLS"
                            })
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4,
                            (0, $e202af6739f6b19f$export$2e2bcd8739ae039).update({
                                type: "delete",
                                table: $c5096964d50e626a$var$table,
                                data: {
                                    id: id
                                }
                            })
                        ];
                    case 3:
                        _a.sent();
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        return [
                            2,
                            true
                        ];
                    case 4:
                        error_1 = _a.sent();
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        if ((error_1 + "").includes("Network error")) (0, $de77e498e07914bf$export$b410431fab84fa58).error("Unable to connect to internet", {
                            autoClose: false
                        });
                        else {
                            console.log(error_1);
                            (0, $de77e498e07914bf$export$b410431fab84fa58).error("Unable to contact server");
                        }
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2,
                            false
                        ];
                }
            });
        });
    },
    save: function(navigation, input) {
        return $c5096964d50e626a$var$__awaiter(void 0, void 0, Promise, function() {
            var user, response, error_2;
            return $c5096964d50e626a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        (0, $de77e498e07914bf$export$b410431fab84fa58).loading("Processing...");
                        return [
                            4,
                            (0, $02b369573055e688$export$2e2bcd8739ae039)(navigation)
                        ];
                    case 1:
                        user = _a.sent();
                        input.key = "CMS_Menu_Items";
                        input.createdBy = user.username;
                        input.updatedBy = user.username;
                        input.createdAt = new Date().toISOString();
                        input.updatedAt = new Date().toISOString();
                        return [
                            4,
                            (0, $cd347cc85afbaa02$export$2c4e825dc9120f87).graphql({
                                query: (0, $7a1d5ab68f58f51c$export$e2bb2cc7e681444a),
                                variables: {
                                    input: input
                                },
                                authMode: "AMAZON_COGNITO_USER_POOLS"
                            })
                        ];
                    case 2:
                        response = _a.sent();
                        return [
                            4,
                            (0, $e202af6739f6b19f$export$2e2bcd8739ae039).update({
                                type: "insert",
                                table: $c5096964d50e626a$var$table,
                                id: response.data.createCMSPages
                            })
                        ];
                    case 3:
                        _a.sent();
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        error_2 = _a.sent();
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        if ((error_2 + "").includes("Network error")) (0, $de77e498e07914bf$export$b410431fab84fa58).error("Unable to connect to internet", {
                            autoClose: false
                        });
                        else {
                            console.log(error_2);
                            (0, $de77e498e07914bf$export$b410431fab84fa58).error("Unable to contact server");
                        }
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    },
    update: function(navigation, updateInput) {
        return $c5096964d50e626a$var$__awaiter(void 0, void 0, Promise, function() {
            var user, input, error_3;
            return $c5096964d50e626a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        (0, $de77e498e07914bf$export$b410431fab84fa58).loading("Processing...");
                        return [
                            4,
                            (0, $02b369573055e688$export$2e2bcd8739ae039)(navigation)
                        ];
                    case 1:
                        user = _a.sent();
                        delete updateInput.__typename;
                        updateInput.updatedBy = user.username;
                        updateInput.updatedAt = new Date().toISOString();
                        input = updateInput;
                        return [
                            4,
                            (0, $cd347cc85afbaa02$export$2c4e825dc9120f87).graphql({
                                query: (0, $7a1d5ab68f58f51c$export$9618e57ca8d89830),
                                variables: {
                                    input: input
                                },
                                authMode: "AMAZON_COGNITO_USER_POOLS"
                            })
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4,
                            (0, $e202af6739f6b19f$export$2e2bcd8739ae039).update({
                                type: "update",
                                table: $c5096964d50e626a$var$table,
                                data: {
                                    updateInput: updateInput
                                }
                            })
                        ];
                    case 3:
                        _a.sent();
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        error_3 = _a.sent();
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        if ((error_3 + "").includes("Network error")) (0, $de77e498e07914bf$export$b410431fab84fa58).error("Unable to connect to internet", {
                            autoClose: false
                        });
                        else {
                            console.log(error_3);
                            (0, $de77e498e07914bf$export$b410431fab84fa58).error("Unable to contact server");
                        }
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }
};
var $c5096964d50e626a$export$2e2bcd8739ae039 = $c5096964d50e626a$var$CMSMenuItemsAPI;





var $5278985b6921bbda$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5278985b6921bbda$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $5278985b6921bbda$var$CacheKey = "CMSPagesCache";
var $5278985b6921bbda$var$CMSPagesCache = {
    setItem: function(value) {
        return $5278985b6921bbda$var$__awaiter(void 0, void 0, Promise, function() {
            return $5278985b6921bbda$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).setItem($5278985b6921bbda$var$CacheKey, JSON.stringify(value))
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    },
    getItem: function() {
        return $5278985b6921bbda$var$__awaiter(void 0, void 0, Promise, function() {
            var items;
            return $5278985b6921bbda$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).getItem($5278985b6921bbda$var$CacheKey)
                        ];
                    case 1:
                        items = _a.sent();
                        return [
                            2,
                            items ? JSON.parse(items) : null
                        ];
                }
            });
        });
    },
    removeItem: function() {
        return $5278985b6921bbda$var$__awaiter(void 0, void 0, Promise, function() {
            return $5278985b6921bbda$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).removeItem($5278985b6921bbda$var$CacheKey)
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    }
};
var $5278985b6921bbda$export$2e2bcd8739ae039 = $5278985b6921bbda$var$CMSPagesCache;



var $eaa073c6f549d2c5$var$CMSPagesAPI = new (0, $85c3021a0318976c$export$2e2bcd8739ae039)({
    ref: "CMSPagesAPI",
    cacheFunc: (0, $5278985b6921bbda$export$2e2bcd8739ae039),
    filter: {
        key: "CMS_Pages",
        sortDirection: "ASC"
    },
    listFunc: (0, $d819d0cbe64233c2$export$81c75b72726fd81b),
    getFunc: (0, $d819d0cbe64233c2$export$954d60866bec39e2),
    route: "/members/cms/pages",
    insertFunc: (0, $7a1d5ab68f58f51c$export$c9e39ad5d462defd),
    updateFunc: (0, $7a1d5ab68f58f51c$export$a6f89f8360a074d3),
    deleteFunc: (0, $7a1d5ab68f58f51c$export$e7bb58a3ece4334c),
    backupTable: "cms_pages",
    deleteMSG: "Page deleted",
    insertMSG: "Page saved",
    updateMSG: "Page updated",
    key: "CMS_PAGE",
    getName: "getCMSPages"
});
var $eaa073c6f549d2c5$export$2e2bcd8739ae039 = $eaa073c6f549d2c5$var$CMSPagesAPI;


var $a1696951e98b6264$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $a1696951e98b6264$var$__assign = undefined && undefined.__assign || function() {
    $a1696951e98b6264$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a1696951e98b6264$var$__assign.apply(this, arguments);
};
var $a1696951e98b6264$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a1696951e98b6264$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $a1696951e98b6264$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $a1696951e98b6264$var$gridPattern = (0, $4920bb85ed07bfd6$export$dbf350e5966cf602)($a1696951e98b6264$var$templateObject_1 || ($a1696951e98b6264$var$templateObject_1 = $a1696951e98b6264$var$__makeTemplateObject([
    "\n  background-image: repeating-linear-gradient(\n      0deg,\n      transparent,\n      transparent 31px,\n      rgba(255, 255, 255, 0.1) 31px,\n      rgba(255, 255, 255, 0.1) 32px\n    ),\n    repeating-linear-gradient(\n      90deg,\n      transparent,\n      transparent 31px,\n      rgba(255, 255, 255, 0.1) 31px,\n      rgba(255, 255, 255, 0.1) 32px\n    );\n  background-size: 32px 32px;\n"
], [
    "\n  background-image: repeating-linear-gradient(\n      0deg,\n      transparent,\n      transparent 31px,\n      rgba(255, 255, 255, 0.1) 31px,\n      rgba(255, 255, 255, 0.1) 32px\n    ),\n    repeating-linear-gradient(\n      90deg,\n      transparent,\n      transparent 31px,\n      rgba(255, 255, 255, 0.1) 31px,\n      rgba(255, 255, 255, 0.1) 32px\n    );\n  background-size: 32px 32px;\n"
])));
var $a1696951e98b6264$var$InnerCard = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $bfb223886c302418$export$2e2bcd8739ae039))($a1696951e98b6264$var$templateObject_2 || ($a1696951e98b6264$var$templateObject_2 = $a1696951e98b6264$var$__makeTemplateObject([
    "\n  padding: 20px;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\n"
], [
    "\n  padding: 20px;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\n"
])));
var $a1696951e98b6264$var$DesignBox = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $77ec199cefd4182a$export$2e2bcd8739ae039))($a1696951e98b6264$var$templateObject_3 || ($a1696951e98b6264$var$templateObject_3 = $a1696951e98b6264$var$__makeTemplateObject([
    "\n  width: 100%;\n  min-height: 80vh;\n  border: 3px solid rgba(255, 255, 255, 0.1);\n  position: relative;\n  background-color: #2b2b2b; // Dark Background\n  ",
    "\n  transition: all 0.3s ease-in-out;\n  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.2);\n  border-radius: 8px;\n\n  &:hover {\n    box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.3);\n    border-color: rgba(255, 255, 255, 0.2);\n  }\n"
], [
    "\n  width: 100%;\n  min-height: 80vh;\n  border: 3px solid rgba(255, 255, 255, 0.1);\n  position: relative;\n  background-color: #2b2b2b; // Dark Background\n  ",
    "\n  transition: all 0.3s ease-in-out;\n  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.2);\n  border-radius: 8px;\n\n  &:hover {\n    box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.3);\n    border-color: rgba(255, 255, 255, 0.2);\n  }\n"
])), $a1696951e98b6264$var$gridPattern);
var $a1696951e98b6264$var$StyledAccordion = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $e9f205f7f0ba8e26$export$2e2bcd8739ae039))($a1696951e98b6264$var$templateObject_4 || ($a1696951e98b6264$var$templateObject_4 = $a1696951e98b6264$var$__makeTemplateObject([
    "\n  &.MuiAccordion-root {\n    border: 1px solid blue;\n    margin-bottom: 8px; // This will create space between accordions when closed.\n\n    &.Mui-expanded {\n      margin-bottom: 8px; // Ensures spacing is maintained when expanded.\n    }\n\n    &:before {\n      background-color: transparent; // Removes the default line that appears between the header and details.\n    }\n  }\n"
], [
    "\n  &.MuiAccordion-root {\n    border: 1px solid blue;\n    margin-bottom: 8px; // This will create space between accordions when closed.\n\n    &.Mui-expanded {\n      margin-bottom: 8px; // Ensures spacing is maintained when expanded.\n    }\n\n    &:before {\n      background-color: transparent; // Removes the default line that appears between the header and details.\n    }\n  }\n"
])));
var $a1696951e98b6264$var$ItemType = {
    ITEM: "ITEM"
};
var $a1696951e98b6264$var$DraggableItem = function(_a) {
    var item = _a.item, pages = _a.pages, onAdd = _a.onAdd;
    var _b = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(""), menuItem = _b[0], setMenuItem = _b[1];
    var _c = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(""), link = _c[0], setLink = _c[1];
    var _d = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(""), script = _d[0], setScript = _d[1];
    var _e = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(""), componentID = _e[0], setComponentID = _e[1];
    var _f = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false), isFirstSubmit = _f[0], setIsFirstSubmit = _f[1];
    var _g = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false), linkError = _g[0], setLinkError = _g[1];
    var _h = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false), scriptError = _h[0], setScriptError = _h[1];
    var _j = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false), componentIDError = _j[0], setComponentIDError = _j[1];
    var _k = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false), menuItemError = _k[0], setMenuItemError = _k[1];
    var isValidLink = function(url) {
        var pattern = /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/;
        return pattern.test(url);
    };
    var isValid = function() {
        var hasError = false;
        if (menuItem === "") {
            setMenuItemError(true);
            hasError = true;
        } else setMenuItemError(false);
        if (item.text === "Link" && (link === "" || !isValidLink(link))) {
            setLinkError(true);
            hasError = true;
        } else setLinkError(false);
        if (item.text === "Javascript" && script === "") {
            setScriptError(true);
            hasError = true;
        } else setScriptError(false);
        if (item.text === "Page" && componentID === "") {
            setComponentIDError(true);
            hasError = true;
        } else setComponentIDError(false);
        return !hasError;
    };
    var handleAddClick = function() {
        if (!isValid()) {
            setIsFirstSubmit(true);
            return;
        }
        onAdd({
            type: item.text.toLowerCase(),
            menuItem: menuItem,
            link: item.text === "Javascript" ? script : link,
            componentID: componentID
        });
        setMenuItem("");
        setLink("");
        setScript("");
        setComponentID("");
        setIsFirstSubmit(false);
        (0, $de77e498e07914bf$export$b410431fab84fa58).success(menuItem + " added");
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        if (isFirstSubmit) isValid();
    }, [
        menuItem,
        script,
        link,
        componentID
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($a1696951e98b6264$var$StyledAccordion, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4dadc25f7bb7b60a$export$2e2bcd8739ae039), {
        expandIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $46c29ed3341f7225$export$2e2bcd8739ae039), null),
        style: {
            borderBottom: "1px solid blue"
        }
    }, item.text), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a33ac73601ffa184$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
        item: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
        error: menuItemError,
        label: menuItemError ? "Name (required)" : "Name",
        placeholder: "Enter the name here" // Placeholder for added guidance
        ,
        value: menuItem,
        fullWidth: true,
        required: true,
        onChange: function(e) {
            setMenuItem(e.target.value);
        }
    })), item.text === "Link" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
        item: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
        error: linkError,
        label: linkError ? link === "" ? "HTTP Link(required)" : "HTTP Link(invalid link)" : "HTTP Link",
        placeholder: "https://example.com" // Placeholder for context
        ,
        value: link,
        fullWidth: true,
        required: true,
        onChange: function(e) {
            setLink(e.target.value);
        }
    })), item.text === "Javascript" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
        item: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
        error: scriptError,
        label: scriptError ? "Script(required)" : "Script",
        placeholder: "no script tags",
        value: script,
        fullWidth: true,
        required: true,
        onChange: function(e) {
            setScript(e.target.value);
        }
    })), item.text === "Page" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
        item: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
        fullWidth: true,
        required: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $fcd80672e9993aad$export$2e2bcd8739ae039), null, componentIDError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        style: {
            color: "#D32F2F"
        }
    }, " Page (required)") : "Pages"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
        error: componentIDError,
        label: componentIDError ? "Page(required)" : "Page",
        value: componentID,
        onChange: function(e) {
            setComponentID(e.target.value);
        }
    }, pages === null || pages === void 0 ? void 0 : pages.map(function(page, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
            key: index,
            value: page.id
        }, page.pageTitle);
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
        item: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
        variant: "contained",
        color: "primary",
        fullWidth: true,
        onClick: handleAddClick
    }, "Add")))));
};
var $a1696951e98b6264$var$DroppableItemAccordion = function(_a) {
    var item = _a.item, index = _a.index, moveItem = _a.moveItem, onDelete = _a.onDelete, page = _a.page;
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    var _b = (0, $33ac2d56891a4573$export$7941f8aafa4b6021)({
        type: $a1696951e98b6264$var$ItemType.ITEM,
        item: {
            index: index
        }
    }), drag = _b[1];
    var _c = (0, $6af5593d0127d7e1$export$ccdee5eaf73cf661)({
        accept: $a1696951e98b6264$var$ItemType.ITEM,
        hover: function(draggedItem) {
            if (draggedItem.index !== index) {
                moveItem(draggedItem.index, index);
                draggedItem.index = index;
            }
        }
    }), drop = _c[1];
    drag(drop(ref));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($a1696951e98b6264$var$StyledAccordion, {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4dadc25f7bb7b60a$export$2e2bcd8739ae039), {
        expandIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $46c29ed3341f7225$export$2e2bcd8739ae039), null),
        style: {
            alignItems: "center",
            borderBottom: "1px solid blue"
        }
    }, item.menuItem, " (", item.type, ")", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        style: {
            display: "flex",
            alignItems: "center",
            width: "100%"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
        size: "small",
        onClick: function(e) {
            e.stopPropagation();
            onDelete(index);
        },
        edge: "end",
        style: {
            marginLeft: "auto"
        }
    }, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8825e02edbe1c553$export$2e2bcd8739ae039), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a33ac73601ffa184$export$2e2bcd8739ae039), null, item.type === "link" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null, "Link: ", item.link), item.type === "javascript" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null, "Script: ", "<script>" + item.link + "</script>"), item.type === "page" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null, "Page: ", page.pageTitle)));
};
var $a1696951e98b6264$var$DroppableArea = function(_a) {
    var incomingItems = _a.incomingItems, saveItems = _a.saveItems, pages = _a.pages;
    var _b = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState([]), items = _b[0], setItems = _b[1];
    var moveItem = function(fromIndex, toIndex) {
        setItems(function(prev) {
            var updatedItems = $a1696951e98b6264$var$__spreadArray([], prev, true);
            var movedItem = updatedItems.splice(fromIndex, 1)[0];
            updatedItems.splice(toIndex, 0, movedItem);
            return updatedItems;
        });
    };
    var handleDelete = function(indexToDelete) {
        setItems(function(prevItems) {
            return prevItems.filter(function(_, index) {
                return index !== indexToDelete;
            });
        });
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        if (incomingItems && incomingItems.length > items.length) {
            if (items.length === 0) {
                setItems(incomingItems);
                return;
            }
            setItems($a1696951e98b6264$var$__spreadArray($a1696951e98b6264$var$__spreadArray([], items, true), incomingItems.slice(incomingItems.length - 1), true));
        }
    }, [
        incomingItems
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        saveItems(items);
    }, [
        items
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        style: {
            minHeight: "200px",
            width: "100%",
            border: "1px dashed gray",
            padding: "8px",
            overflow: "auto"
        }
    }, items.map(function(item, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($a1696951e98b6264$var$DroppableItemAccordion, {
            key: index,
            index: index,
            item: item,
            moveItem: moveItem,
            onDelete: handleDelete,
            page: pages.find(function(page) {
                return page.id === item.componentID;
            })
        });
    }));
};
var $a1696951e98b6264$var$PlayMenu = function(_a) {
    var navigatePage = _a.navigatePage, urlParams = _a.urlParams;
    var _b = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState([]), droppableItems = _b[0], setDroppableItems = _b[1];
    var _c = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false), loading = _c[0], setLoading = _c[1];
    var items = [
        {
            text: "Link",
            key: (0, $6810e10b84975c3e$export$2e2bcd8739ae039)()
        },
        {
            text: "Javascript",
            key: (0, $6810e10b84975c3e$export$2e2bcd8739ae039)()
        },
        {
            text: "Page",
            key: (0, $6810e10b84975c3e$export$2e2bcd8739ae039)()
        }
    ];
    var savedRecords = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef({
        name: "",
        menuID: "",
        items: [],
        pages: []
    });
    var menuItems = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
    var loadData = function() {
        return $a1696951e98b6264$var$__awaiter(void 0, void 0, Promise, function() {
            var menuData, _a, _b, i;
            var _c;
            return $a1696951e98b6264$var$__generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        setLoading(true);
                        (0, $de77e498e07914bf$export$b410431fab84fa58).loading("Processing...");
                        return [
                            4 /*yield*/ ,
                            (0, $febd7c6e52a5fe25$export$2e2bcd8739ae039).get(navigatePage, (_c = urlParams.id) !== null && _c !== void 0 ? _c : "")
                        ];
                    case 1:
                        menuData = _d.sent();
                        if (menuData) {
                            savedRecords.current.name = menuData === null || menuData === void 0 ? void 0 : menuData.menu;
                            savedRecords.current.menuID = menuData === null || menuData === void 0 ? void 0 : menuData.id;
                        }
                        _a = savedRecords.current;
                        return [
                            4 /*yield*/ ,
                            (0, $c5096964d50e626a$export$2e2bcd8739ae039).getByMenuID(navigatePage, savedRecords.current.menuID)
                        ];
                    case 2:
                        _a.items = _d.sent();
                        _b = savedRecords.current;
                        return [
                            4 /*yield*/ ,
                            (0, $eaa073c6f549d2c5$export$2e2bcd8739ae039).getList(navigatePage, false)
                        ];
                    case 3:
                        _b.pages = _d.sent();
                        savedRecords.current.pages.push({
                            id: "survey",
                            pageTitle: "Survey"
                        });
                        savedRecords.current.pages.push({
                            id: "reports",
                            pageTitle: "Reports"
                        });
                        if (savedRecords.current.items && savedRecords.current.items.length > 0) {
                            menuItems.current = [];
                            for(i = 0; i < savedRecords.current.items.length; i++){
                                menuItems.current.push(savedRecords.current.items[i]);
                                menuItems.current[i].text = menuItems.current[i].menuItem;
                            }
                            setDroppableItems(menuItems.current);
                        }
                        setLoading(false);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var handleAddToDroppableArea = function(itemDetails) {
        setDroppableItems(function(prev) {
            return $a1696951e98b6264$var$__spreadArray($a1696951e98b6264$var$__spreadArray([], prev, true), [
                itemDetails
            ], false);
        });
    };
    var saveMenuItems = function(items) {
        menuItems.current = items;
        setDroppableItems(items);
    };
    var saveAllData = function() {
        return $a1696951e98b6264$var$__awaiter(void 0, void 0, void 0, function() {
            var itemsNotInMenuItems, sortedMenuItems, i, i, items_1;
            return $a1696951e98b6264$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        setLoading(true);
                        (0, $de77e498e07914bf$export$b410431fab84fa58).loading("Processing...");
                        itemsNotInMenuItems = savedRecords.current.items.filter(function(item) {
                            return !menuItems.current.some(function(menuItem) {
                                return menuItem.id === item.id;
                            });
                        });
                        sortedMenuItems = menuItems.current.map(function(item, index) {
                            return $a1696951e98b6264$var$__assign($a1696951e98b6264$var$__assign({}, item), {
                                sortNumber: index
                            });
                        });
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < itemsNotInMenuItems.length)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $c5096964d50e626a$export$2e2bcd8739ae039).delete(navigatePage, itemsNotInMenuItems[i].id)
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        i++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        i = 0;
                        _a.label = 5;
                    case 5:
                        if (!(i < sortedMenuItems.length)) return [
                            3 /*break*/ ,
                            10
                        ];
                        items_1 = sortedMenuItems[i];
                        items_1.menuID = savedRecords.current.menuID;
                        delete items_1.text;
                        if (!items_1.id) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $c5096964d50e626a$export$2e2bcd8739ae039).update(navigatePage, items_1)
                        ];
                    case 6:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 7:
                        return [
                            4 /*yield*/ ,
                            (0, $c5096964d50e626a$export$2e2bcd8739ae039).save(navigatePage, items_1)
                        ];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9:
                        i++;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 10:
                        (0, $de77e498e07914bf$export$b410431fab84fa58).dismiss();
                        (0, $de77e498e07914bf$export$b410431fab84fa58).success("Menu Items Updated");
                        setLoading(false);
                        navigatePage("/members/cms/menus");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        loadData().then();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        elevation: 3
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        p: 2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
        variant: "h6"
    }, savedRecords.current.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
        variant: "contained",
        color: "primary",
        onClick: saveAllData
    }, "Save"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $075f1be02379b00f$export$2e2bcd8739ae039), {
        variant: "outlined"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8bffaacbbee0c705$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($a1696951e98b6264$var$DesignBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $b84d99e06e9d3dec$export$9861489d68213f9c), {
        backend: (0, $adc78aa6dde5fba1$export$f4f61d779bb20744)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
        container: true,
        spacing: 3,
        style: {
            height: "100%",
            padding: "16px"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
        item: true,
        xs: 6
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($a1696951e98b6264$var$InnerCard, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2bfceb6bd3ad6f45$export$2e2bcd8739ae039), {
        title: "Menu Item Types"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8bffaacbbee0c705$export$2e2bcd8739ae039), null, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
        variant: "rectangular",
        width: "100%",
        height: 180
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($a1696951e98b6264$var$DraggableItem, {
        item: items[0],
        onAdd: handleAddToDroppableArea,
        pages: savedRecords.current.pages
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($a1696951e98b6264$var$DraggableItem, {
        item: items[1],
        onAdd: handleAddToDroppableArea,
        pages: savedRecords.current.pages
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($a1696951e98b6264$var$DraggableItem, {
        item: items[2],
        onAdd: handleAddToDroppableArea,
        pages: savedRecords.current.pages
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
        item: true,
        xs: 6
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($a1696951e98b6264$var$InnerCard, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2bfceb6bd3ad6f45$export$2e2bcd8739ae039), {
        title: "Menu Items"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8bffaacbbee0c705$export$2e2bcd8739ae039), null, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $76ada7aef489324c$export$2e2bcd8739ae039), {
        variant: "rectangular",
        width: "100%",
        height: 250
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($a1696951e98b6264$var$DroppableArea, {
        incomingItems: droppableItems,
        saveItems: saveMenuItems,
        pages: savedRecords.current.pages
    }))))))))));
};
var $a1696951e98b6264$export$2e2bcd8739ae039 = $a1696951e98b6264$var$PlayMenu;
var $a1696951e98b6264$var$templateObject_1, $a1696951e98b6264$var$templateObject_2, $a1696951e98b6264$var$templateObject_3, $a1696951e98b6264$var$templateObject_4;


var $a7e932e58cbfcc53$var$CMSMenusRoutes = {
    cmsMenus: {
        Component: (0, $46c12d7a126b51c1$export$2e2bcd8739ae039),
        type: "private",
        route: "/members/cms/menus",
        title: "Menus",
        breadcrumb: [
            {
                title: "Home",
                route: "/"
            },
            {
                title: "CMS"
            }
        ]
    },
    cmsNewMenu: {
        Component: (0, $e74eb2e0679e897b$export$2e2bcd8739ae039),
        type: "private",
        route: "/members/cms/menus/add",
        title: "New Menu",
        breadcrumb: [
            {
                title: "Home",
                route: "/"
            },
            {
                title: "CMS"
            },
            {
                title: "Menus",
                route: "/members/cms/menus"
            }
        ]
    },
    cmsUpdateMenu: {
        Component: (0, $e74eb2e0679e897b$export$2e2bcd8739ae039),
        type: "private",
        route: "/members/cms/menus/update/:id",
        title: "Update Menu",
        breadcrumb: [
            {
                title: "Home",
                route: "/"
            },
            {
                title: "CMS"
            },
            {
                title: "Menus",
                route: "/members/cms/menus"
            }
        ]
    },
    cmsPlayMenu: {
        Component: (0, $a1696951e98b6264$export$2e2bcd8739ae039),
        type: "private",
        route: "/members/cms/menus/play/:id",
        title: "Manage Menu Items",
        breadcrumb: [
            {
                title: "Home",
                route: "/"
            },
            {
                title: "CMS"
            },
            {
                title: "Menus",
                route: "/members/cms/menus"
            }
        ]
    }
};
var $a7e932e58cbfcc53$export$2e2bcd8739ae039 = $a7e932e58cbfcc53$var$CMSMenusRoutes;



var $7fPBF = parcelRequire("7fPBF");





var $bc806532b229f3da$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $bc806532b229f3da$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $bc806532b229f3da$var$CacheKey = "CMSConfigurationCache";
var $bc806532b229f3da$var$CMSConfigurationsCache = {
    setItem: function(value) {
        return $bc806532b229f3da$var$__awaiter(void 0, void 0, Promise, function() {
            return $bc806532b229f3da$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).setItem($bc806532b229f3da$var$CacheKey, JSON.stringify(value))
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    },
    getItem: function() {
        return $bc806532b229f3da$var$__awaiter(void 0, void 0, Promise, function() {
            var items;
            return $bc806532b229f3da$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).getItem($bc806532b229f3da$var$CacheKey)
                        ];
                    case 1:
                        items = _a.sent();
                        return [
                            2,
                            items ? JSON.parse(items) : null
                        ];
                }
            });
        });
    },
    removeItem: function() {
        return $bc806532b229f3da$var$__awaiter(void 0, void 0, Promise, function() {
            return $bc806532b229f3da$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).removeItem($bc806532b229f3da$var$CacheKey)
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    }
};
var $bc806532b229f3da$export$2e2bcd8739ae039 = $bc806532b229f3da$var$CMSConfigurationsCache;



var $4f62bf5d6a658643$var$CMSConfigurationsAPI = new (0, $85c3021a0318976c$export$2e2bcd8739ae039)({
    ref: "CMSConfigurationsAPI",
    cacheFunc: (0, $bc806532b229f3da$export$2e2bcd8739ae039),
    filter: {
        key: "CMS_Configurations"
    },
    listFunc: (0, $d819d0cbe64233c2$export$1a240ec58c4d770c),
    getFunc: (0, $d819d0cbe64233c2$export$4ff209a90825df6e),
    route: "/members/cms/configurations",
    insertFunc: (0, $7a1d5ab68f58f51c$export$3cc2f3bbfd4dcc86),
    updateFunc: (0, $7a1d5ab68f58f51c$export$86ffb00491f8eb6b),
    deleteFunc: (0, $7a1d5ab68f58f51c$export$ec8df78d8cbf61ea),
    backupTable: "cms_configurations",
    deleteMSG: "Configuration deleted",
    insertMSG: "Configuration saved",
    updateMSG: "Configuration updated",
    key: "CMS_Configurations",
    getName: "getCMSConfigurations"
});
var $4f62bf5d6a658643$export$2e2bcd8739ae039 = $4f62bf5d6a658643$var$CMSConfigurationsAPI;


var $8ad980af92fec109$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8ad980af92fec109$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $8ad980af92fec109$var$FormConfiguration = function(_a) {
    var _b;
    var navigatePage = _a.navigatePage, urlParams = _a.urlParams;
    var _c = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(true), loading = _c[0], setLoading = _c[1];
    var configurationData = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef({});
    var configurationBase = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef([]);
    var formConfig = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef([
        {
            name: "maintenance",
            label: "Maintenance Enabled",
            fieldType: "select",
            isRequired: true,
            options: {
                data: [
                    {
                        id: "2",
                        value: "No"
                    },
                    {
                        id: "1",
                        value: "Yes"
                    }
                ],
                dictionary: {
                    id: "id",
                    value: "value"
                }
            },
            value: "1",
            validations: {
                required: true,
                customMessages: {
                    required: "Maintenance can't be blank."
                }
            }
        },
        {
            name: "topMenu",
            label: "Top Menu",
            fieldType: "select",
            isRequired: true,
            options: {
                data: [],
                dictionary: {
                    id: "id",
                    value: "menu"
                }
            },
            validations: {
                required: true,
                customMessages: {
                    required: "Top Menu is required."
                }
            }
        },
        {
            name: "bottomMenu",
            label: "Bottom Menu",
            fieldType: "select",
            isRequired: true,
            options: {
                data: [],
                dictionary: {
                    id: "id",
                    value: "menu"
                }
            },
            validations: {
                required: true,
                customMessages: {
                    required: "Bottom Menu is required."
                }
            }
        },
        {
            name: "favicon",
            label: "Fav Icon",
            fieldType: "file",
            isRequired: true,
            fileType: ".ico",
            validations: {
                required: true,
                customMessages: {
                    required: "Fav Icon is required."
                }
            }
        },
        {
            name: "logo",
            label: "Logo",
            fieldType: "file",
            isRequired: true,
            fileType: ".svg,.png",
            validations: {
                required: true,
                customMessages: {
                    required: "Fav Icon is required."
                }
            }
        },
        {
            name: "googleRecaptchaKey",
            label: "Google Recaptcha Key",
            fieldType: "input",
            isRequired: true,
            value: "",
            validations: {
                type: "input",
                required: true,
                customMessages: {
                    required: "Google Recaptcha Key can't be blank."
                }
            }
        },
        {
            name: "copyRights",
            label: "Copy Rights",
            fieldType: "input",
            isRequired: true,
            value: "Startup Muster",
            validations: {
                type: "input",
                required: true,
                customMessages: {
                    required: "URL can't be blank."
                }
            }
        },
        {
            name: "websiteTitle",
            label: "Website Title",
            fieldType: "input",
            isRequired: true,
            value: "Startup Muster 2023",
            validations: {
                type: "input",
                required: true,
                customMessages: {
                    required: "Title can't be blank."
                }
            }
        },
        {
            name: "metaDescription",
            label: "Meta Description",
            fieldType: "textarea",
            isRequired: true,
            value: "Startup Muster is the largest survey of the Australian startup ecosystem and enables meaningful and timely connections between startups and the businesses.",
            validations: {
                type: "input",
                required: true,
                customMessages: {
                    required: "Meta Description can't be blank."
                }
            }
        }
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        reloadFunc().then();
    }, []);
    var reloadFunc = function() {
        return $8ad980af92fec109$var$__awaiter(void 0, void 0, Promise, function() {
            var menus, _a;
            return $8ad980af92fec109$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        setLoading(true);
                        return [
                            4,
                            (0, $febd7c6e52a5fe25$export$2e2bcd8739ae039).getList(navigatePage, false)
                        ];
                    case 1:
                        menus = _b.sent();
                        formConfig.current[1].options.data = menus;
                        formConfig.current[2].options.data = menus;
                        _a = configurationBase;
                        return [
                            4,
                            (0, $4f62bf5d6a658643$export$2e2bcd8739ae039).getList(false, true)
                        ];
                    case 2:
                        _a.current = _b.sent();
                        configurationBase.current.map(function(configuration) {
                            configurationData.current[configuration.config] = configuration.record;
                            return configuration;
                        });
                        formConfig.current.map(function(field) {
                            var _a;
                            field.value = (_a = configurationData.current[field.name]) !== null && _a !== void 0 ? _a : field.value;
                            return field;
                        });
                        setLoading(false);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var submitData = function(data) {
        var dataValues = Object.entries(data);
        dataValues.forEach(function(_a, index) {
            var key = _a[0], value = _a[1];
            return $8ad980af92fec109$var$__awaiter(void 0, void 0, void 0, function() {
                var input;
                var _b;
                return $8ad980af92fec109$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            input = {
                                config: key,
                                record: value
                            };
                            if (!((_b = configurationData.current) === null || _b === void 0 ? void 0 : _b[key])) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0, $4f62bf5d6a658643$export$2e2bcd8739ae039).update(navigatePage, configurationBase.current.find(function(configuration) {
                                    return configuration.config === key;
                                }), input)
                            ];
                        case 1:
                            _c.sent();
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                (0, $4f62bf5d6a658643$export$2e2bcd8739ae039).save(navigatePage, input)
                            ];
                        case 3:
                            _c.sent();
                            _c.label = 4;
                        case 4:
                            if (index + 1 === dataValues.length) setLoading(false);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    var loadFavIcon = function(data, logo, isLoad) {
        if (!isLoad) data.logo = JSON.stringify(data.logo);
        else data.logo = JSON.stringify({
            name: data.logo.name,
            file: logo.result
        });
        if (data.favicon.file) {
            data.favicon = JSON.stringify(data.favicon);
            submitData(data);
            return;
        }
        var favicon = new FileReader();
        favicon.readAsDataURL(data.favicon);
        favicon.onload = function() {
            return $8ad980af92fec109$var$__awaiter(void 0, void 0, void 0, function() {
                return $8ad980af92fec109$var$__generator(this, function(_a) {
                    data.favicon = JSON.stringify({
                        name: data.favicon.name,
                        file: favicon.result
                    });
                    submitData(data);
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
    };
    var handleFormSubmit = function(data) {
        return $8ad980af92fec109$var$__awaiter(void 0, void 0, void 0, function() {
            var logo;
            return $8ad980af92fec109$var$__generator(this, function(_a) {
                setLoading(true);
                if (data.logo.file) {
                    loadFavIcon(data, null, false);
                    return [
                        2
                    ];
                }
                logo = new FileReader();
                logo.readAsDataURL(data.logo);
                logo.onload = function() {
                    loadFavIcon(data, logo, true);
                };
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $391db0dc72f5c1c4$export$2e2bcd8739ae039), {
        fields: (_b = formConfig.current) !== null && _b !== void 0 ? _b : [],
        onSubmit: handleFormSubmit,
        submitButtonText: "Save",
        doShowCardHeader: true,
        reloadFunc: reloadFunc,
        title: "Configuration",
        loading: loading
    }));
};
var $8ad980af92fec109$export$2e2bcd8739ae039 = $8ad980af92fec109$var$FormConfiguration;


var $bc7fb32e4ee55355$var$CMSConfigurationsRoutes = {
    cmsConfigurations: {
        Component: (0, $8ad980af92fec109$export$2e2bcd8739ae039),
        type: "private",
        route: "/members/cms/configurations",
        title: "CMS Configuration",
        breadcrumb: [
            {
                title: "Home",
                route: "/"
            },
            {
                title: "CMS"
            }
        ]
    }
};
var $bc7fb32e4ee55355$export$2e2bcd8739ae039 = $bc7fb32e4ee55355$var$CMSConfigurationsRoutes;



var $7fPBF = parcelRequire("7fPBF");







var $2700863955b86b32$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2700863955b86b32$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $2700863955b86b32$var$CacheKey = "CMSHeadScriptsTypesCache";
var $2700863955b86b32$var$CMSHeadScriptsCache = {
    setItem: function(value) {
        return $2700863955b86b32$var$__awaiter(void 0, void 0, Promise, function() {
            return $2700863955b86b32$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).setItem($2700863955b86b32$var$CacheKey, JSON.stringify(value))
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    },
    getItem: function() {
        return $2700863955b86b32$var$__awaiter(void 0, void 0, Promise, function() {
            var items;
            return $2700863955b86b32$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).getItem($2700863955b86b32$var$CacheKey)
                        ];
                    case 1:
                        items = _a.sent();
                        return [
                            2,
                            items ? JSON.parse(items) : null
                        ];
                }
            });
        });
    },
    removeItem: function() {
        return $2700863955b86b32$var$__awaiter(void 0, void 0, Promise, function() {
            return $2700863955b86b32$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).removeItem($2700863955b86b32$var$CacheKey)
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    }
};
var $2700863955b86b32$export$2e2bcd8739ae039 = $2700863955b86b32$var$CMSHeadScriptsCache;


var $3435990efe49f3cd$var$CMSHeadScriptsAPI = new (0, $85c3021a0318976c$export$2e2bcd8739ae039)({
    ref: "CMSHeadScriptsAPI",
    cacheFunc: (0, $2700863955b86b32$export$2e2bcd8739ae039),
    filter: {
        key: "CMS_Head_Scripts",
        sortDirection: "ASC"
    },
    listFunc: (0, $d819d0cbe64233c2$export$9f1f3c1214add4f7),
    getFunc: (0, $d819d0cbe64233c2$export$7ce0b34cfff31064),
    route: "/members/cms/scripts",
    insertFunc: (0, $7a1d5ab68f58f51c$export$99846709f0a1c450),
    updateFunc: (0, $7a1d5ab68f58f51c$export$d69c6e3875fd7cf3),
    deleteFunc: (0, $7a1d5ab68f58f51c$export$e97fcad5ca2a29e9),
    backupTable: "cms_head_scripts",
    deleteMSG: "Script deleted",
    insertMSG: "Script saved",
    updateMSG: "Script updated",
    key: "CMS_Head_Scripts",
    getName: "getCMSHeadScripts"
});
var $3435990efe49f3cd$export$2e2bcd8739ae039 = $3435990efe49f3cd$var$CMSHeadScriptsAPI;


var $5b7e0df008841c03$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5b7e0df008841c03$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $5b7e0df008841c03$var$Scripts = function(_a) {
    var navigatePage = _a.navigatePage;
    var _b = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState([]), record = _b[0], setRecord = _b[1];
    var loadRecords = function(refreshCache, page) {
        return $5b7e0df008841c03$var$__awaiter(void 0, void 0, Promise, function() {
            var _a;
            return $5b7e0df008841c03$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = setRecord;
                        return [
                            4,
                            (0, $3435990efe49f3cd$export$2e2bcd8739ae039).getList(navigatePage, refreshCache, page)
                        ];
                    case 1:
                        _a.apply(void 0, [
                            _b.sent()
                        ]);
                        return [
                            4,
                            (0, $3435990efe49f3cd$export$2e2bcd8739ae039).getPageNumbers()
                        ];
                    case 2:
                        return [
                            2,
                            _b.sent()
                        ];
                }
            });
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $97914e663a317172$export$2e2bcd8739ae039), {
        sm: 4,
        itemProps: [
            {
                type: "data",
                key: "name",
                text: "Script Name"
            },
            {
                type: "data",
                key: "script",
                text: "Script"
            }
        ],
        items: record,
        itemActions: [
            {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($03d8b6da908e0eb9$exports))), {
                    color: "primary"
                }),
                handler: function(id) {
                    return $5b7e0df008841c03$var$__awaiter(void 0, void 0, void 0, function() {
                        return $5b7e0df008841c03$var$__generator(this, function(_a) {
                            navigatePage("/members/cms/scripts/update/" + id);
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                }
            },
            {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($59f8877c56368b42$exports))), {
                    color: "primary"
                }),
                handler: function(id) {
                    return $5b7e0df008841c03$var$__awaiter(void 0, void 0, void 0, function() {
                        return $5b7e0df008841c03$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    return [
                                        4,
                                        (0, $3435990efe49f3cd$export$2e2bcd8739ae039).delete(navigatePage, id)
                                    ];
                                case 1:
                                    if (!_a.sent()) return [
                                        3,
                                        3
                                    ];
                                    return [
                                        4,
                                        loadRecords(false, 1)
                                    ];
                                case 2:
                                    _a.sent();
                                    _a.label = 3;
                                case 3:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                }
            }
        ],
        addInfo: {
            text: "Script",
            handler: function() {
                navigatePage("add");
            }
        },
        actionID: "id",
        loadRecords: loadRecords,
        doShowCardHeader: true,
        doShowTableHeader: true
    });
};
var $5b7e0df008841c03$export$2e2bcd8739ae039 = $5b7e0df008841c03$var$Scripts;



var $7fPBF = parcelRequire("7fPBF");


var $1145da97b952c76c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1145da97b952c76c$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $1145da97b952c76c$var$FormScript = function(_a) {
    var _b;
    var navigatePage = _a.navigatePage, urlParams = _a.urlParams;
    var _c = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false), loading = _c[0], setLoading = _c[1];
    var _d = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(Date.now()), key = _d[0], setKey = _d[1];
    var formConfig = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef([
        {
            name: "name",
            label: "Script Name",
            fieldType: "input",
            isRequired: true,
            validations: {
                type: "input",
                required: true,
                customMessages: {
                    required: "name can't be blank."
                }
            }
        },
        {
            name: "script",
            label: "Script with on or multiple <script> tags",
            fieldType: "textarea",
            isRequired: true,
            validations: {
                type: "input",
                required: true,
                customMessages: {
                    required: "script can't be blank."
                }
            }
        }
    ]);
    var record = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        if (urlParams.id) reloadFunc().then();
    }, []);
    var reloadFunc = function() {
        return $1145da97b952c76c$var$__awaiter(void 0, void 0, Promise, function() {
            var _a, i;
            var _b;
            return $1145da97b952c76c$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        setLoading(true);
                        _a = record;
                        return [
                            4,
                            (0, $3435990efe49f3cd$export$2e2bcd8739ae039).get(navigatePage, (_b = urlParams.id) !== null && _b !== void 0 ? _b : "")
                        ];
                    case 1:
                        _a.current = _c.sent();
                        for(i = 0; i < formConfig.current.length; i++)formConfig.current[i].value = record.current[formConfig.current[i].name];
                        setLoading(false);
                        setKey(Date.now());
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var handleFormSubmit = function(data) {
        return $1145da97b952c76c$var$__awaiter(void 0, void 0, void 0, function() {
            return $1145da97b952c76c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        setLoading(true);
                        if (!urlParams.id) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0, $3435990efe49f3cd$export$2e2bcd8739ae039).update(navigatePage, record.current, data)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            (0, $3435990efe49f3cd$export$2e2bcd8739ae039).save(navigatePage, data)
                        ];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        setLoading(false);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, {
        key: key
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $391db0dc72f5c1c4$export$2e2bcd8739ae039), {
        fields: (_b = formConfig.current) !== null && _b !== void 0 ? _b : [],
        onSubmit: handleFormSubmit,
        submitButtonText: urlParams.id ? "Update" : "Save",
        doShowCardHeader: true,
        reloadFunc: urlParams.id ? reloadFunc : undefined,
        title: urlParams.id ? "Update Page" : "New Page",
        loading: loading
    }));
};
var $1145da97b952c76c$export$2e2bcd8739ae039 = $1145da97b952c76c$var$FormScript;


var $0440f3166c652360$var$CMSScriptsRoutes = {
    cmsScripts: {
        Component: (0, $5b7e0df008841c03$export$2e2bcd8739ae039),
        type: "private",
        route: "/members/cms/scripts",
        title: "Scripts",
        breadcrumb: [
            {
                title: "Home",
                route: "/"
            },
            {
                title: "CMS"
            }
        ]
    },
    cmsNewScripts: {
        Component: (0, $1145da97b952c76c$export$2e2bcd8739ae039),
        type: "private",
        route: "/members/cms/scripts/add",
        title: "New Script",
        breadcrumb: [
            {
                title: "Home",
                route: "/"
            },
            {
                title: "CMS"
            },
            {
                title: "Scripts",
                route: "/members/cms/scripts"
            }
        ]
    },
    cmsUpdateScripts: {
        Component: (0, $1145da97b952c76c$export$2e2bcd8739ae039),
        type: "private",
        route: "/members/cms/scripts/update/:id",
        title: "Update Script",
        breadcrumb: [
            {
                title: "Home",
                route: "/"
            },
            {
                title: "CMS"
            },
            {
                title: "Scripts",
                route: "/members/cms/scripts"
            }
        ]
    }
};
var $0440f3166c652360$export$2e2bcd8739ae039 = $0440f3166c652360$var$CMSScriptsRoutes;



var $7fPBF = parcelRequire("7fPBF");






var $1d5912f12df631e8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1d5912f12df631e8$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $1d5912f12df631e8$var$CacheKey = "CMSMetaTypesCache";
var $1d5912f12df631e8$var$CMSMetasCache = {
    setItem: function(value) {
        return $1d5912f12df631e8$var$__awaiter(void 0, void 0, Promise, function() {
            return $1d5912f12df631e8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).setItem($1d5912f12df631e8$var$CacheKey, JSON.stringify(value))
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    },
    getItem: function() {
        return $1d5912f12df631e8$var$__awaiter(void 0, void 0, Promise, function() {
            var items;
            return $1d5912f12df631e8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).getItem($1d5912f12df631e8$var$CacheKey)
                        ];
                    case 1:
                        items = _a.sent();
                        return [
                            2,
                            items ? JSON.parse(items) : null
                        ];
                }
            });
        });
    },
    removeItem: function() {
        return $1d5912f12df631e8$var$__awaiter(void 0, void 0, Promise, function() {
            return $1d5912f12df631e8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).removeItem($1d5912f12df631e8$var$CacheKey)
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    }
};
var $1d5912f12df631e8$export$2e2bcd8739ae039 = $1d5912f12df631e8$var$CMSMetasCache;



var $03ec468c504f4409$var$CMSMetasAPI = new (0, $85c3021a0318976c$export$2e2bcd8739ae039)({
    ref: "CMSMetasAPI",
    cacheFunc: (0, $1d5912f12df631e8$export$2e2bcd8739ae039),
    filter: {
        key: "CMS_Metas",
        sortDirection: "ASC"
    },
    listFunc: (0, $d819d0cbe64233c2$export$1fbc446f47f31fca),
    getFunc: (0, $d819d0cbe64233c2$export$74ace0dc0af4194d),
    route: "/members/cms/metas",
    insertFunc: (0, $7a1d5ab68f58f51c$export$a22aafb65bc115d9),
    updateFunc: (0, $7a1d5ab68f58f51c$export$930ca4b7b675092e),
    deleteFunc: (0, $7a1d5ab68f58f51c$export$35823a5221398c4b),
    backupTable: "cms_metas",
    deleteMSG: "Meta deleted",
    insertMSG: "Meta saved",
    updateMSG: "Meta updated",
    key: "CMS_Metas",
    getName: "getCMSMetas"
});
var $03ec468c504f4409$export$2e2bcd8739ae039 = $03ec468c504f4409$var$CMSMetasAPI;


var $f257fc7e1682e821$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f257fc7e1682e821$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $f257fc7e1682e821$var$Metas = function(_a) {
    var navigatePage = _a.navigatePage;
    var _b = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState([]), record = _b[0], setRecord = _b[1];
    var loadRecords = function(refreshCache, page) {
        return $f257fc7e1682e821$var$__awaiter(void 0, void 0, Promise, function() {
            var _a;
            return $f257fc7e1682e821$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = setRecord;
                        return [
                            4,
                            (0, $03ec468c504f4409$export$2e2bcd8739ae039).getList(navigatePage, refreshCache, page)
                        ];
                    case 1:
                        _a.apply(void 0, [
                            _b.sent()
                        ]);
                        return [
                            4,
                            (0, $03ec468c504f4409$export$2e2bcd8739ae039).getPageNumbers()
                        ];
                    case 2:
                        return [
                            2,
                            _b.sent()
                        ];
                }
            });
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $97914e663a317172$export$2e2bcd8739ae039), {
        sm: 4,
        itemProps: [
            {
                type: "data",
                key: "name",
                text: "Meta Name"
            },
            {
                type: "data",
                key: "contents",
                text: "Meta Contents"
            }
        ],
        items: record,
        itemActions: [
            {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($03d8b6da908e0eb9$exports))), {
                    color: "primary"
                }),
                handler: function(id) {
                    return $f257fc7e1682e821$var$__awaiter(void 0, void 0, void 0, function() {
                        return $f257fc7e1682e821$var$__generator(this, function(_a) {
                            navigatePage("/members/cms/metas/update/" + id);
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                }
            },
            {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($59f8877c56368b42$exports))), {
                    color: "primary"
                }),
                handler: function(id) {
                    return $f257fc7e1682e821$var$__awaiter(void 0, void 0, void 0, function() {
                        return $f257fc7e1682e821$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    return [
                                        4,
                                        (0, $03ec468c504f4409$export$2e2bcd8739ae039).delete(navigatePage, id)
                                    ];
                                case 1:
                                    if (!_a.sent()) return [
                                        3,
                                        3
                                    ];
                                    return [
                                        4,
                                        loadRecords(false, 1)
                                    ];
                                case 2:
                                    _a.sent();
                                    _a.label = 3;
                                case 3:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                }
            }
        ],
        addInfo: {
            text: "Meta",
            handler: function() {
                navigatePage("add");
            }
        },
        actionID: "id",
        loadRecords: loadRecords,
        doShowCardHeader: true,
        doShowTableHeader: true
    });
};
var $f257fc7e1682e821$export$2e2bcd8739ae039 = $f257fc7e1682e821$var$Metas;



var $7fPBF = parcelRequire("7fPBF");


var $466cad9a70c6ac5a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $466cad9a70c6ac5a$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $466cad9a70c6ac5a$var$FormMeta = function(_a) {
    var _b;
    var navigatePage = _a.navigatePage, urlParams = _a.urlParams;
    var _c = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false), loading = _c[0], setLoading = _c[1];
    var _d = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(Date.now()), key = _d[0], setKey = _d[1];
    var formConfig = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef([
        {
            name: "name",
            label: "Meta Name",
            fieldType: "input",
            isRequired: true,
            validations: {
                type: "input",
                required: true,
                customMessages: {
                    required: "name can't be blank."
                }
            }
        },
        {
            name: "contents",
            label: "Contents",
            fieldType: "input",
            isRequired: true,
            validations: {
                type: "input",
                required: true,
                customMessages: {
                    required: "Content can't be blank."
                }
            }
        }
    ]);
    var record = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        if (urlParams.id) reloadFunc().then();
    }, []);
    var reloadFunc = function() {
        return $466cad9a70c6ac5a$var$__awaiter(void 0, void 0, Promise, function() {
            var _a, i;
            var _b;
            return $466cad9a70c6ac5a$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        setLoading(true);
                        _a = record;
                        return [
                            4,
                            (0, $03ec468c504f4409$export$2e2bcd8739ae039).get(navigatePage, (_b = urlParams.id) !== null && _b !== void 0 ? _b : "")
                        ];
                    case 1:
                        _a.current = _c.sent();
                        for(i = 0; i < formConfig.current.length; i++)formConfig.current[i].value = record.current[formConfig.current[i].name];
                        setLoading(false);
                        setKey(Date.now());
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var handleFormSubmit = function(data) {
        return $466cad9a70c6ac5a$var$__awaiter(void 0, void 0, void 0, function() {
            return $466cad9a70c6ac5a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        setLoading(true);
                        if (!urlParams.id) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0, $03ec468c504f4409$export$2e2bcd8739ae039).update(navigatePage, record.current, data)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            (0, $03ec468c504f4409$export$2e2bcd8739ae039).save(navigatePage, data)
                        ];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        setLoading(false);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, {
        key: key
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $391db0dc72f5c1c4$export$2e2bcd8739ae039), {
        fields: (_b = formConfig.current) !== null && _b !== void 0 ? _b : [],
        onSubmit: handleFormSubmit,
        submitButtonText: urlParams.id ? "Update" : "Save",
        doShowCardHeader: true,
        reloadFunc: urlParams.id ? reloadFunc : undefined,
        title: urlParams.id ? "Update Page" : "New Page",
        loading: loading
    }));
};
var $466cad9a70c6ac5a$export$2e2bcd8739ae039 = $466cad9a70c6ac5a$var$FormMeta;


var $9cc05afe7adcb6f1$var$CMSMetasRoutes = {
    cmsMetas: {
        Component: (0, $f257fc7e1682e821$export$2e2bcd8739ae039),
        type: "private",
        route: "/members/cms/metas",
        title: "Metas",
        breadcrumb: [
            {
                title: "Home",
                route: "/"
            },
            {
                title: "CMS"
            }
        ]
    },
    cmsNewMetas: {
        Component: (0, $466cad9a70c6ac5a$export$2e2bcd8739ae039),
        type: "private",
        route: "/members/cms/metas/add",
        title: "New Meta",
        breadcrumb: [
            {
                title: "Home",
                route: "/"
            },
            {
                title: "CMS"
            },
            {
                title: "Metas",
                route: "/members/cms/metas"
            }
        ]
    },
    cmsUpdateMetas: {
        Component: (0, $466cad9a70c6ac5a$export$2e2bcd8739ae039),
        type: "private",
        route: "/members/cms/metas/update/:id",
        title: "Update Meta",
        breadcrumb: [
            {
                title: "Home",
                route: "/"
            },
            {
                title: "CMS"
            },
            {
                title: "Metas",
                route: "/members/cms/metas"
            }
        ]
    }
};
var $9cc05afe7adcb6f1$export$2e2bcd8739ae039 = $9cc05afe7adcb6f1$var$CMSMetasRoutes;



var $7fPBF = parcelRequire("7fPBF");




var $716deef5d942b2d6$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $716deef5d942b2d6$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $716deef5d942b2d6$var$Pages = function(_a) {
    var navigatePage = _a.navigatePage;
    var _b = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState([]), record = _b[0], setRecord = _b[1];
    var loadRecords = function(refreshCache, page) {
        return $716deef5d942b2d6$var$__awaiter(void 0, void 0, Promise, function() {
            var _a;
            return $716deef5d942b2d6$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = setRecord;
                        return [
                            4,
                            (0, $eaa073c6f549d2c5$export$2e2bcd8739ae039).getList(navigatePage, refreshCache, page)
                        ];
                    case 1:
                        _a.apply(void 0, [
                            _b.sent()
                        ]);
                        return [
                            4,
                            (0, $eaa073c6f549d2c5$export$2e2bcd8739ae039).getPageNumbers()
                        ];
                    case 2:
                        return [
                            2,
                            _b.sent()
                        ];
                }
            });
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $97914e663a317172$export$2e2bcd8739ae039), {
        sm: 4,
        itemProps: [
            {
                type: "data",
                key: "pageTitle",
                text: "Page"
            },
            {
                type: "data",
                key: "pageURL",
                text: "url"
            }
        ],
        items: record,
        itemActions: [
            {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($03d8b6da908e0eb9$exports))), {
                    color: "primary"
                }),
                handler: function(id) {
                    return $716deef5d942b2d6$var$__awaiter(void 0, void 0, void 0, function() {
                        return $716deef5d942b2d6$var$__generator(this, function(_a) {
                            navigatePage("/members/cms/pages/update/" + id);
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                }
            },
            {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($59f8877c56368b42$exports))), {
                    color: "primary"
                }),
                handler: function(id) {
                    return $716deef5d942b2d6$var$__awaiter(void 0, void 0, void 0, function() {
                        return $716deef5d942b2d6$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    return [
                                        4,
                                        (0, $eaa073c6f549d2c5$export$2e2bcd8739ae039).delete(navigatePage, id)
                                    ];
                                case 1:
                                    if (!_a.sent()) return [
                                        3,
                                        3
                                    ];
                                    return [
                                        4,
                                        loadRecords(false, 1)
                                    ];
                                case 2:
                                    _a.sent();
                                    _a.label = 3;
                                case 3:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                }
            }
        ],
        addInfo: {
            text: "Page",
            handler: function() {
                navigatePage("add");
            }
        },
        actionID: "id",
        loadRecords: loadRecords,
        doShowCardHeader: true,
        doShowTableHeader: true
    });
};
var $716deef5d942b2d6$export$2e2bcd8739ae039 = $716deef5d942b2d6$var$Pages;



var $7fPBF = parcelRequire("7fPBF");




var $3ed4c33f35224b8a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3ed4c33f35224b8a$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $3ed4c33f35224b8a$var$FormPage = function(_a) {
    var _b;
    var navigatePage = _a.navigatePage, urlParams = _a.urlParams;
    var _c = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false), loading = _c[0], setLoading = _c[1];
    var _d = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(Date.now()), key = _d[0], setKey = _d[1];
    var formConfig = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef([
        {
            name: "pageTitle",
            label: "Title",
            fieldType: "input",
            isRequired: true,
            validations: {
                type: "input",
                required: true,
                customMessages: {
                    required: "Title can't be blank."
                }
            }
        },
        {
            name: "pageURL",
            label: "URL",
            fieldType: "input",
            isRequired: true,
            validations: {
                type: "input",
                required: true,
                customMessages: {
                    required: "URL can't be blank."
                }
            }
        },
        {
            name: "metaDescription",
            label: "Meta Description",
            fieldType: "input",
            isRequired: false
        },
        {
            name: "content",
            label: "Page Content",
            fieldType: "editor",
            isRequired: true,
            validations: {
                type: "input",
                required: true,
                customMessages: {
                    required: "Page content can't be blank."
                }
            }
        }
    ]);
    var record = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        if (urlParams.id) reloadFunc().then();
    }, []);
    var reloadFunc = function() {
        return $3ed4c33f35224b8a$var$__awaiter(void 0, void 0, Promise, function() {
            var _a, i;
            var _b;
            return $3ed4c33f35224b8a$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        setLoading(true);
                        _a = record;
                        return [
                            4,
                            (0, $eaa073c6f549d2c5$export$2e2bcd8739ae039).get(navigatePage, (_b = urlParams.id) !== null && _b !== void 0 ? _b : "")
                        ];
                    case 1:
                        _a.current = _c.sent();
                        for(i = 0; i < formConfig.current.length; i++)formConfig.current[i].value = record.current[formConfig.current[i].name];
                        setLoading(false);
                        setKey(Date.now());
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var handleFormSubmit = function(data) {
        return $3ed4c33f35224b8a$var$__awaiter(void 0, void 0, void 0, function() {
            var titleInfo, urlInfo;
            return $3ed4c33f35224b8a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        setLoading(true);
                        return [
                            4,
                            (0, $eaa073c6f549d2c5$export$2e2bcd8739ae039).custom_call(navigatePage, (0, $d819d0cbe64233c2$export$8f37cc661d36d6a2), {
                                pageTitle: data.pageTitle
                            }, "getByTitleCMSPages")
                        ];
                    case 1:
                        titleInfo = _a.sent();
                        return [
                            4,
                            (0, $eaa073c6f549d2c5$export$2e2bcd8739ae039).custom_call(navigatePage, (0, $d819d0cbe64233c2$export$f824506d03b7212d), {
                                pageURL: data.pageURL
                            }, "getByURLCMSPages")
                        ];
                    case 2:
                        urlInfo = _a.sent();
                        if (!urlParams.id) return [
                            3,
                            4
                        ];
                        if (titleInfo.items.length > 0 && titleInfo.items[0].id !== record.current.id) {
                            (0, $de77e498e07914bf$export$b410431fab84fa58).warning("Title already exists");
                            setLoading(false);
                            return [
                                2
                            ];
                        } else if (urlInfo.items.length > 0 && urlInfo.items[0].id !== record.current.id) {
                            (0, $de77e498e07914bf$export$b410431fab84fa58).warning("Url already exists");
                            setLoading(false);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            (0, $eaa073c6f549d2c5$export$2e2bcd8739ae039).update(navigatePage, record.current, data)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        if (titleInfo.items.length > 0) {
                            (0, $de77e498e07914bf$export$b410431fab84fa58).warning("Title already exists");
                            setLoading(false);
                            return [
                                2
                            ];
                        } else if (urlInfo.items.length > 0) {
                            (0, $de77e498e07914bf$export$b410431fab84fa58).warning("Url already exists");
                            setLoading(false);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            (0, $eaa073c6f549d2c5$export$2e2bcd8739ae039).save(navigatePage, data)
                        ];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        setLoading(false);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, {
        key: key
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $391db0dc72f5c1c4$export$2e2bcd8739ae039), {
        fields: (_b = formConfig.current) !== null && _b !== void 0 ? _b : [],
        onSubmit: handleFormSubmit,
        submitButtonText: urlParams.id ? "Update" : "Save",
        doShowCardHeader: true,
        reloadFunc: urlParams.id ? reloadFunc : undefined,
        title: urlParams.id ? "Update Page" : "New Page",
        loading: loading
    }));
};
var $3ed4c33f35224b8a$export$2e2bcd8739ae039 = $3ed4c33f35224b8a$var$FormPage;


var $89471c185f56fb52$var$CMSPagesRoutes = {
    cmsPages: {
        Component: (0, $716deef5d942b2d6$export$2e2bcd8739ae039),
        type: "private",
        route: "/members/cms/pages",
        title: "Pages",
        breadcrumb: [
            {
                title: "Home",
                route: "/"
            },
            {
                title: "CMS"
            }
        ]
    },
    cmsNewPage: {
        Component: (0, $3ed4c33f35224b8a$export$2e2bcd8739ae039),
        type: "private",
        route: "/members/cms/pages/add",
        title: "New Page",
        breadcrumb: [
            {
                title: "Home",
                route: "/"
            },
            {
                title: "CMS"
            },
            {
                title: "Pages",
                route: "/members/cms/pages"
            }
        ]
    },
    cmsUpdatePage: {
        Component: (0, $3ed4c33f35224b8a$export$2e2bcd8739ae039),
        type: "private",
        route: "/members/cms/pages/update/:id",
        title: "Update Page",
        breadcrumb: [
            {
                title: "Home",
                route: "/"
            },
            {
                title: "CMS"
            },
            {
                title: "Pages",
                route: "/members/cms/pages"
            }
        ]
    }
};
var $89471c185f56fb52$export$2e2bcd8739ae039 = $89471c185f56fb52$var$CMSPagesRoutes;


var $d94fcb777a6e8507$var$__assign = undefined && undefined.__assign || function() {
    $d94fcb777a6e8507$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d94fcb777a6e8507$var$__assign.apply(this, arguments);
};
var $d94fcb777a6e8507$var$CMSRoutes = $d94fcb777a6e8507$var$__assign($d94fcb777a6e8507$var$__assign($d94fcb777a6e8507$var$__assign($d94fcb777a6e8507$var$__assign($d94fcb777a6e8507$var$__assign({}, (0, $89471c185f56fb52$export$2e2bcd8739ae039)), (0, $a7e932e58cbfcc53$export$2e2bcd8739ae039)), (0, $9cc05afe7adcb6f1$export$2e2bcd8739ae039)), (0, $0440f3166c652360$export$2e2bcd8739ae039)), (0, $bc7fb32e4ee55355$export$2e2bcd8739ae039));
var $d94fcb777a6e8507$export$2e2bcd8739ae039 = $d94fcb777a6e8507$var$CMSRoutes;



var $7fPBF = parcelRequire("7fPBF");




var $2cebb30272adc837$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2cebb30272adc837$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $2cebb30272adc837$var$CacheKey = "SurveySettingsCache";
var $2cebb30272adc837$var$SurveySettingsCache = {
    setItem: function(value) {
        return $2cebb30272adc837$var$__awaiter(void 0, void 0, Promise, function() {
            return $2cebb30272adc837$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).setItem($2cebb30272adc837$var$CacheKey, JSON.stringify(value))
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    },
    getItem: function() {
        return $2cebb30272adc837$var$__awaiter(void 0, void 0, Promise, function() {
            var items;
            return $2cebb30272adc837$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).getItem($2cebb30272adc837$var$CacheKey)
                        ];
                    case 1:
                        items = _a.sent();
                        return [
                            2,
                            items ? JSON.parse(items) : null
                        ];
                }
            });
        });
    },
    removeItem: function() {
        return $2cebb30272adc837$var$__awaiter(void 0, void 0, Promise, function() {
            return $2cebb30272adc837$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).removeItem($2cebb30272adc837$var$CacheKey)
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    }
};
var $2cebb30272adc837$export$2e2bcd8739ae039 = $2cebb30272adc837$var$SurveySettingsCache;



var $53037fa6745050b5$var$SurveySettingsAPI = new (0, $85c3021a0318976c$export$2e2bcd8739ae039)({
    ref: "SurveySettingsAPI",
    cacheFunc: (0, $2cebb30272adc837$export$2e2bcd8739ae039),
    filter: {
        key: "Survey_Settings"
    },
    listFunc: (0, $d819d0cbe64233c2$export$535c74dbcb4c46ee),
    getFunc: (0, $d819d0cbe64233c2$export$2f014546a152053c),
    route: "/members/survey/settings",
    insertFunc: (0, $7a1d5ab68f58f51c$export$7f3767f6ceb72db2),
    updateFunc: (0, $7a1d5ab68f58f51c$export$5472a1c840d124fc),
    deleteFunc: (0, $7a1d5ab68f58f51c$export$af4efcec16e1a80f),
    backupTable: "survey_settings",
    deleteMSG: "Settings deleted",
    insertMSG: "Settings saved",
    updateMSG: "Settings updated",
    key: "Survey_Settings",
    getName: "getSurveySettings"
});
var $53037fa6745050b5$export$2e2bcd8739ae039 = $53037fa6745050b5$var$SurveySettingsAPI;





var $b721c56e89ed452a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b721c56e89ed452a$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $b721c56e89ed452a$var$CacheKey = "SurveyReportsCache";
var $b721c56e89ed452a$var$SurveyReportsCache = {
    setItem: function(value) {
        return $b721c56e89ed452a$var$__awaiter(void 0, void 0, Promise, function() {
            return $b721c56e89ed452a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).setItem($b721c56e89ed452a$var$CacheKey, JSON.stringify(value))
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    },
    getItem: function() {
        return $b721c56e89ed452a$var$__awaiter(void 0, void 0, Promise, function() {
            var items;
            return $b721c56e89ed452a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).getItem($b721c56e89ed452a$var$CacheKey)
                        ];
                    case 1:
                        items = _a.sent();
                        return [
                            2,
                            items ? JSON.parse(items) : null
                        ];
                }
            });
        });
    },
    removeItem: function() {
        return $b721c56e89ed452a$var$__awaiter(void 0, void 0, Promise, function() {
            return $b721c56e89ed452a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).removeItem($b721c56e89ed452a$var$CacheKey)
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    }
};
var $b721c56e89ed452a$export$2e2bcd8739ae039 = $b721c56e89ed452a$var$SurveyReportsCache;



var $010273dbafa4ccc3$var$SurveyReportsAPI = new (0, $85c3021a0318976c$export$2e2bcd8739ae039)({
    ref: "SurveyReportsAPI",
    cacheFunc: (0, $b721c56e89ed452a$export$2e2bcd8739ae039),
    filter: {
        key: "Survey_Reports",
        sortDirection: "ASC"
    },
    listFunc: (0, $d819d0cbe64233c2$export$cf57b28d21aff9c5),
    getFunc: (0, $d819d0cbe64233c2$export$87b4d4eebd6cb3e7),
    route: "/members/survey/reports",
    insertFunc: (0, $7a1d5ab68f58f51c$export$837ad18711977e9c),
    updateFunc: (0, $7a1d5ab68f58f51c$export$60b7413f09d475b),
    deleteFunc: (0, $7a1d5ab68f58f51c$export$769971d68cb45d1a),
    backupTable: "survey_reports",
    deleteMSG: "Reports deleted",
    insertMSG: "Report saved",
    updateMSG: "Report updated",
    key: "Survey_Reports",
    getName: "getSurveyReports"
});
var $010273dbafa4ccc3$export$2e2bcd8739ae039 = $010273dbafa4ccc3$var$SurveyReportsAPI;


var $9b738a3f3ea258d6$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9b738a3f3ea258d6$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $9b738a3f3ea258d6$var$FormConfiguration = function(_a) {
    var _b;
    var navigatePage = _a.navigatePage, urlParams = _a.urlParams;
    var _c = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(true), loading = _c[0], setLoading = _c[1];
    var settingsData = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef({});
    var settingsBase = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef([]);
    var formConfig = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef([
        {
            name: "isSurveyCompleted",
            label: "Survey Completed",
            fieldType: "select",
            isRequired: true,
            options: {
                data: [
                    {
                        id: "2",
                        value: "No"
                    },
                    {
                        id: "1",
                        value: "Yes"
                    }
                ],
                dictionary: {
                    id: "id",
                    value: "value"
                }
            },
            value: "1",
            validations: {
                required: true
            }
        },
        {
            name: "defaultReport",
            label: "Survey Report",
            fieldType: "select",
            isRequired: false,
            options: {
                data: [],
                dictionary: {
                    id: "id",
                    value: "year"
                }
            }
        },
        {
            name: "pageTitle",
            label: "Survey Page Title",
            fieldType: "input",
            isRequired: true,
            value: "Welcome back!",
            validations: {
                type: "input",
                required: true,
                customMessages: {
                    required: "Title can't be blank."
                }
            }
        },
        {
            name: "surveyReportURL",
            label: "Survey Report URL",
            fieldType: "input",
            isRequired: true,
            value: "/reports",
            validations: {
                type: "input",
                required: true,
                customMessages: {
                    required: "URL can't be blank."
                }
            }
        },
        {
            name: "surveyPageURL",
            label: "Survey Page URL",
            fieldType: "input",
            isRequired: true,
            value: "/",
            validations: {
                type: "input",
                required: true,
                customMessages: {
                    required: "URL can't be blank."
                }
            }
        },
        {
            name: "surveyIntro",
            label: "Survey Introduction Paragraph",
            fieldType: "editor",
            isRequired: true,
            value: "This is Survey",
            validations: {
                type: "input",
                required: true,
                customMessages: {
                    required: "Survey Introduction Paragraph can't be blank."
                }
            }
        },
        {
            name: "surveyMaintenance",
            label: "Maintenance Text",
            fieldType: "editor",
            isRequired: true,
            value: '<p class="ql-align-justify">The Startup Muster 2023 survey has now closed. Our report will be released on October 30th 2023, and we can\u2019t wait to share how Australia\u2019s startup ecosystem has changed since our 2018 report.</p><p><br></p><p class="ql-align-justify">Thank you to <strong>Atlassian</strong>, <strong>NSW Government</strong>, <strong>Microsoft</strong>,<strong>Antler</strong>,<strong>Parramatta City Council</strong> and <strong>The Gild Group</strong> for making the 2023 survey possible.</p><p><br></p><p class="ql-align-justify">To be notified when the report is published, please enter your email address below:</p>',
            validations: {
                type: "input",
                required: true,
                customMessages: {
                    required: "Maintenance Text can't be blank."
                }
            }
        },
        {
            name: "enableEmailReportSubscriber",
            label: "Email Report Subscriber",
            fieldType: "select",
            isRequired: true,
            options: {
                data: [
                    {
                        id: "2",
                        value: "No"
                    },
                    {
                        id: "1",
                        value: "Yes"
                    }
                ],
                dictionary: {
                    id: "id",
                    value: "value"
                }
            },
            value: "1",
            validations: {
                required: true
            }
        },
        {
            name: "mailReportSubscriberThankYourMessage",
            label: "Maintenance Subscriber Thank You Message",
            fieldType: "editor",
            isRequired: true,
            value: "Thankyou Survey",
            validations: {
                type: "input",
                required: true,
                customMessages: {
                    required: "Thankyou Text can't be blank."
                }
            }
        }
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        reloadFunc().then();
    }, []);
    var reloadFunc = function() {
        return $9b738a3f3ea258d6$var$__awaiter(void 0, void 0, Promise, function() {
            var _a, data;
            return $9b738a3f3ea258d6$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        setLoading(true);
                        _a = settingsBase;
                        return [
                            4,
                            (0, $53037fa6745050b5$export$2e2bcd8739ae039).getList(navigatePage, false)
                        ];
                    case 1:
                        _a.current = _b.sent();
                        settingsBase.current.map(function(setting) {
                            settingsData.current[setting.name] = setting.setting;
                            return setting;
                        });
                        return [
                            4,
                            (0, $010273dbafa4ccc3$export$2e2bcd8739ae039).getList(navigatePage, false)
                        ];
                    case 2:
                        data = _b.sent();
                        if (data && data.length > 0) {
                            formConfig.current[1].isRequired = true;
                            formConfig.current[1].options.data = data;
                            formConfig.current[1].validations = {
                                required: true,
                                customMessages: {
                                    required: "Default Report is required."
                                }
                            };
                        }
                        formConfig.current.map(function(field) {
                            var _a;
                            field.value = (_a = settingsData.current[field.name]) !== null && _a !== void 0 ? _a : field.value;
                            return field;
                        });
                        setLoading(false);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var handleFormSubmit = function(data) {
        return $9b738a3f3ea258d6$var$__awaiter(void 0, void 0, void 0, function() {
            var dataValues;
            return $9b738a3f3ea258d6$var$__generator(this, function(_a) {
                setLoading(true);
                dataValues = Object.entries(data);
                dataValues.forEach(function(_a, index) {
                    var key = _a[0], value = _a[1];
                    return $9b738a3f3ea258d6$var$__awaiter(void 0, void 0, void 0, function() {
                        var input;
                        var _b;
                        return $9b738a3f3ea258d6$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    input = {
                                        name: key,
                                        setting: value
                                    };
                                    if (!((_b = settingsData.current) === null || _b === void 0 ? void 0 : _b[key])) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        (0, $53037fa6745050b5$export$2e2bcd8739ae039).update(navigatePage, settingsBase.current.find(function(configuration) {
                                            return configuration.name === key;
                                        }), input)
                                    ];
                                case 1:
                                    _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                case 2:
                                    return [
                                        4,
                                        (0, $53037fa6745050b5$export$2e2bcd8739ae039).save(navigatePage, input)
                                    ];
                                case 3:
                                    _c.sent();
                                    _c.label = 4;
                                case 4:
                                    if (index + 1 === dataValues.length) setLoading(false);
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                });
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $391db0dc72f5c1c4$export$2e2bcd8739ae039), {
        fields: (_b = formConfig.current) !== null && _b !== void 0 ? _b : [],
        onSubmit: handleFormSubmit,
        submitButtonText: "Save",
        doShowCardHeader: true,
        reloadFunc: reloadFunc,
        title: "Survey Settings",
        loading: loading
    }));
};
var $9b738a3f3ea258d6$export$2e2bcd8739ae039 = $9b738a3f3ea258d6$var$FormConfiguration;


var $c7a280a74cea845a$var$SurveySettingsRoutes = {
    surveySettings: {
        Component: (0, $9b738a3f3ea258d6$export$2e2bcd8739ae039),
        type: "private",
        route: "/members/survey/settings",
        title: "Survey Settings",
        breadcrumb: [
            {
                title: "Home",
                route: "/"
            },
            {
                title: "Survey"
            }
        ]
    }
};
var $c7a280a74cea845a$export$2e2bcd8739ae039 = $c7a280a74cea845a$var$SurveySettingsRoutes;



var $7fPBF = parcelRequire("7fPBF");




var $bf8c8db7535cd819$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $bf8c8db7535cd819$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $bf8c8db7535cd819$var$Reports = function(_a) {
    var navigatePage = _a.navigatePage;
    var _b = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState([]), record = _b[0], setRecord = _b[1];
    var loadRecords = function(refreshCache, page) {
        return $bf8c8db7535cd819$var$__awaiter(void 0, void 0, Promise, function() {
            var _a;
            return $bf8c8db7535cd819$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = setRecord;
                        return [
                            4,
                            (0, $010273dbafa4ccc3$export$2e2bcd8739ae039).getList(navigatePage, refreshCache, page)
                        ];
                    case 1:
                        _a.apply(void 0, [
                            _b.sent()
                        ]);
                        return [
                            4,
                            (0, $010273dbafa4ccc3$export$2e2bcd8739ae039).getPageNumbers()
                        ];
                    case 2:
                        return [
                            2,
                            _b.sent()
                        ];
                }
            });
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $97914e663a317172$export$2e2bcd8739ae039), {
        sm: 3,
        itemProps: [
            {
                type: "data",
                key: "year",
                text: "Year"
            },
            {
                type: "data",
                key: "reportStatus",
                text: "Status"
            },
            {
                type: "data",
                key: "description",
                text: "Description"
            }
        ],
        items: record,
        itemActions: [
            {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($03d8b6da908e0eb9$exports))), {
                    color: "primary"
                }),
                handler: function(id) {
                    return $bf8c8db7535cd819$var$__awaiter(void 0, void 0, void 0, function() {
                        return $bf8c8db7535cd819$var$__generator(this, function(_a) {
                            navigatePage("/members/survey/reports/update/" + id);
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                }
            },
            {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($59f8877c56368b42$exports))), {
                    color: "primary"
                }),
                handler: function(id) {
                    return $bf8c8db7535cd819$var$__awaiter(void 0, void 0, void 0, function() {
                        return $bf8c8db7535cd819$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    return [
                                        4,
                                        (0, $010273dbafa4ccc3$export$2e2bcd8739ae039).delete(navigatePage, id)
                                    ];
                                case 1:
                                    if (!_a.sent()) return [
                                        3,
                                        3
                                    ];
                                    return [
                                        4,
                                        loadRecords(false, 1)
                                    ];
                                case 2:
                                    _a.sent();
                                    _a.label = 3;
                                case 3:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                }
            }
        ],
        addInfo: {
            text: "Report",
            handler: function() {
                navigatePage("add");
            }
        },
        actionID: "id",
        loadRecords: loadRecords,
        doShowCardHeader: true,
        doShowTableHeader: true
    });
};
var $bf8c8db7535cd819$export$2e2bcd8739ae039 = $bf8c8db7535cd819$var$Reports;



var $7fPBF = parcelRequire("7fPBF");




//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
let $117e03bdefca38ae$var$_nodeId;
let $117e03bdefca38ae$var$_clockseq; // Previous uuid creation time
let $117e03bdefca38ae$var$_lastMSecs = 0;
let $117e03bdefca38ae$var$_lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details
function $117e03bdefca38ae$var$v1(options, buf, offset) {
    let i = buf && offset || 0;
    const b = buf || new Array(16);
    options = options || {};
    let node = options.node || $117e03bdefca38ae$var$_nodeId;
    let clockseq = options.clockseq !== undefined ? options.clockseq : $117e03bdefca38ae$var$_clockseq; // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        const seedBytes = options.random || (options.rng || (0, $2bcaa466815aa8a5$export$2e2bcd8739ae039))();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $117e03bdefca38ae$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $117e03bdefca38ae$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    let msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    let nsecs = options.nsecs !== undefined ? options.nsecs : $117e03bdefca38ae$var$_lastNSecs + 1; // Time since last uuid creation (in msecs)
    const dt = msecs - $117e03bdefca38ae$var$_lastMSecs + (nsecs - $117e03bdefca38ae$var$_lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
     // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $117e03bdefca38ae$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
     // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $117e03bdefca38ae$var$_lastMSecs = msecs;
    $117e03bdefca38ae$var$_lastNSecs = nsecs;
    $117e03bdefca38ae$var$_clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000; // `time_low`
    const tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff; // `time_mid`
    const tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff; // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`
    b[i++] = clockseq & 0xff; // `node`
    for(let n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf || (0, $ee13ceee8d9f46c4$export$8fb373d660548968)(b);
}
var $117e03bdefca38ae$export$2e2bcd8739ae039 = $117e03bdefca38ae$var$v1;



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Drop-in replacement for fast-xml-parser's XmlParser class used in the AWS SDK S3 client XML deserializer. This
 * implementation is not tested against the full xml conformance test suite. It is only tested against the XML responses
 * from S3. This implementation requires the `DOMParser` class in the runtime.
 */ var $92a10fe3d952914b$export$8f49e4af10703ce3 = {
    parse: function(xmlStr) {
        var domParser = new DOMParser();
        var xml = domParser.parseFromString(xmlStr, "text/xml");
        var parsedObj = $92a10fe3d952914b$var$parseXmlNode(xml);
        var rootKey = Object.keys(parsedObj)[0];
        return parsedObj[rootKey];
    }
};
var $92a10fe3d952914b$var$parseXmlNode = function(node) {
    var _a;
    var _b, _c;
    if ($92a10fe3d952914b$var$isDocumentNode(node)) return _a = {}, _a[node.documentElement.nodeName] = $92a10fe3d952914b$var$parseXmlNode(node.documentElement), _a;
    if (node.nodeType === Node.TEXT_NODE) return (_b = node.nodeValue) === null || _b === void 0 ? void 0 : _b.trim();
    if ($92a10fe3d952914b$var$isElementNode(node)) {
        // Node like <Location>foo</Location> will be converted to { Location: 'foo' }
        // instead of { Location: { '#text': 'foo' } }.
        if ($92a10fe3d952914b$var$isTextOnlyElementNode(node)) return (_c = node.childNodes[0]) === null || _c === void 0 ? void 0 : _c.nodeValue;
        var nodeValue = {};
        // convert attributes
        for(var i = 0; i < node.attributes.length; i++){
            var attr = node.attributes[i];
            if (!$92a10fe3d952914b$var$isNamespaceAttributeName(attr.nodeName)) nodeValue[attr.nodeName] = attr.nodeValue;
        }
        // convert child nodes
        if (node.children.length > 0) for(var i = 0; i < node.children.length; i++){
            var child = node.children[i];
            var childValue = $92a10fe3d952914b$var$parseXmlNode(child);
            if (childValue === undefined) continue;
            var childName = child.nodeName;
            if (nodeValue[childName] === undefined) nodeValue[childName] = childValue;
            else if (Array.isArray(nodeValue[childName])) nodeValue[childName].push(childValue);
            else nodeValue[childName] = [
                nodeValue[childName],
                childValue
            ];
        }
        // Return empty element node as empty string instead of `{}`, which is the default behavior of fast-xml-parser.
        return Object.keys(nodeValue).length === 0 ? "" : nodeValue;
    }
};
var $92a10fe3d952914b$var$isElementNode = function(node) {
    return node.nodeType === Node.ELEMENT_NODE;
};
var $92a10fe3d952914b$var$isDocumentNode = function(node) {
    return node.nodeType === Node.DOCUMENT_NODE;
};
var $92a10fe3d952914b$var$isTextOnlyElementNode = function(node) {
    var _a;
    return $92a10fe3d952914b$var$hasOnlyNamespaceAttributes(node) && node.children.length === 0 && ((_a = node.firstChild) === null || _a === void 0 ? void 0 : _a.nodeType) === Node.TEXT_NODE;
};
var $92a10fe3d952914b$var$hasOnlyNamespaceAttributes = function(node) {
    for(var i = 0; i < node.attributes.length; i++){
        var attr = node.attributes[i];
        if (!$92a10fe3d952914b$var$isNamespaceAttributeName(attr.nodeName)) return false;
    }
    return true;
};
var $92a10fe3d952914b$var$isNamespaceAttributeName = function(name) {
    return name === "xmlns" || name.startsWith("xmlns:");
};


var $9229af72cd043253$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9229af72cd043253$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $9229af72cd043253$export$a02c37c2d0ab7154 = function(response) {
    return $9229af72cd043253$var$__awaiter(void 0, void 0, void 0, function() {
        var statusCode, body, code, message, error;
        var _a, _b;
        return $9229af72cd043253$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (!response || response.statusCode < 300) return [
                        2 /*return*/ 
                    ];
                    statusCode = response.statusCode;
                    return [
                        4 /*yield*/ ,
                        $9229af72cd043253$export$9f31af2cd814b6c7(response)
                    ];
                case 1:
                    body = _c.sent();
                    code = (body === null || body === void 0 ? void 0 : body["Code"]) ? body.Code : statusCode === 404 ? "NotFound" : statusCode.toString();
                    message = (_b = (_a = body === null || body === void 0 ? void 0 : body["message"]) !== null && _a !== void 0 ? _a : body === null || body === void 0 ? void 0 : body["Message"]) !== null && _b !== void 0 ? _b : code;
                    error = new Error(message);
                    return [
                        2 /*return*/ ,
                        Object.assign(error, {
                            name: code,
                            $metadata: (0, $fe0ec52dee712a0c$export$978f9418fe0cb26c)(response)
                        })
                    ];
            }
        });
    });
};
var $9229af72cd043253$export$9f31af2cd814b6c7 = function(response) {
    return $9229af72cd043253$var$__awaiter(void 0, void 0, void 0, function() {
        var data;
        return $9229af72cd043253$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!response.body) // S3 can return 200 without a body indicating failure.
                    throw new Error("S3 aborted request.");
                    return [
                        4 /*yield*/ ,
                        response.body.text()
                    ];
                case 1:
                    data = _a.sent();
                    if ((data === null || data === void 0 ? void 0 : data.length) > 0) try {
                        return [
                            2 /*return*/ ,
                            (0, $92a10fe3d952914b$export$8f49e4af10703ce3).parse(data)
                        ];
                    } catch (error) {
                        throw new Error("Failed to parse XML response.");
                    }
                    return [
                        2 /*return*/ ,
                        {}
                    ];
            }
        });
    });
};


var $04efb6a586095162$var$DOMAIN_PATTERN = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/;
var $04efb6a586095162$var$IP_ADDRESS_PATTERN = /(\d+\.){3}\d+/;
var $04efb6a586095162$var$DOTS_PATTERN = /\.\./;
var $04efb6a586095162$export$818eb7ab11414506 = "s3";
/**
 * The endpoint resolver function that returns the endpoint URL for a given region, and input parameters.
 */ var $04efb6a586095162$var$endpointResolver = function(options, apiInput) {
    var region = options.region, useAccelerateEndpoint = options.useAccelerateEndpoint, customEndpoint = options.customEndpoint, forcePathStyle = options.forcePathStyle;
    var endpoint;
    // 1. get base endpoint
    if (customEndpoint) endpoint = new URL(customEndpoint);
    else if (useAccelerateEndpoint) {
        if (forcePathStyle) throw new Error("Path style URLs are not supported with S3 Transfer Acceleration.");
        endpoint = new URL("https://s3-accelerate.".concat((0, $045984a6263bd645$export$1c28e37cdcc37f6d)(region)));
    } else endpoint = new URL("https://s3.".concat(region, ".").concat((0, $045984a6263bd645$export$1c28e37cdcc37f6d)(region)));
    // 2. inject bucket name
    if (apiInput === null || apiInput === void 0 ? void 0 : apiInput.Bucket) {
        if (!$04efb6a586095162$export$360a1e07839d0d27(apiInput.Bucket)) throw new Error('Invalid bucket name: "'.concat(apiInput.Bucket, '".'));
        if (forcePathStyle || apiInput.Bucket.includes(".")) endpoint.pathname = "/".concat(apiInput.Bucket);
        else endpoint.host = "".concat(apiInput.Bucket, ".").concat(endpoint.host);
    }
    return {
        url: endpoint
    };
};
var $04efb6a586095162$export$360a1e07839d0d27 = function(bucketName) {
    return $04efb6a586095162$var$DOMAIN_PATTERN.test(bucketName) && !$04efb6a586095162$var$IP_ADDRESS_PATTERN.test(bucketName) && !$04efb6a586095162$var$DOTS_PATTERN.test(bucketName);
};
var $04efb6a586095162$export$f84bd70098573c5c = {
    service: $04efb6a586095162$export$818eb7ab11414506,
    endpointResolver: $04efb6a586095162$var$endpointResolver,
    retryDecider: (0, $87853ac980d212ed$export$b919d98317a7685f)((0, $9229af72cd043253$export$a02c37c2d0ab7154)),
    computeDelay: (0, $6e5ff8686fd7c540$export$caea50bde345f648),
    userAgentValue: (0, $0d25e50bf44b1a9b$export$ede38edb26c0bfdf)(),
    useAccelerateEndpoint: false,
    uriEscapePath: false
};


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $a2c22136b41df437$var$extendStatics = function(d, b) {
    $a2c22136b41df437$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $a2c22136b41df437$var$extendStatics(d, b);
};
function $a2c22136b41df437$export$a8ba968b8961cb8a(d, b) {
    $a2c22136b41df437$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a2c22136b41df437$export$18ce0697a983be9b = function() {
    $a2c22136b41df437$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a2c22136b41df437$export$18ce0697a983be9b.apply(this, arguments);
};
function $a2c22136b41df437$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a2c22136b41df437$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a2c22136b41df437$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a2c22136b41df437$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a2c22136b41df437$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a2c22136b41df437$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $a2c22136b41df437$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $a2c22136b41df437$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $a2c22136b41df437$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a2c22136b41df437$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a2c22136b41df437$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a2c22136b41df437$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a2c22136b41df437$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a2c22136b41df437$export$10c90e4f7922046c(v) {
    return this instanceof $a2c22136b41df437$export$10c90e4f7922046c ? (this.v = v, this) : new $a2c22136b41df437$export$10c90e4f7922046c(v);
}
function $a2c22136b41df437$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a2c22136b41df437$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a2c22136b41df437$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a2c22136b41df437$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $a2c22136b41df437$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a2c22136b41df437$export$19a8beecd37a4c45 === "function" ? $a2c22136b41df437$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a2c22136b41df437$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $a2c22136b41df437$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $a2c22136b41df437$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a2c22136b41df437$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $a2c22136b41df437$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var $ad36e6a06ac20042$export$c7c5cef950a4d2fc = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var $ad36e6a06ac20042$export$b4b216764bb846eb = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};


function $ce5e236f17b919d1$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $ce5e236f17b919d1$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}


var $b6db281eaac95c69$export$c7c5cef950a4d2fc = function(input) {
    return typeof TextEncoder === "function" ? (0, $ce5e236f17b919d1$export$c7c5cef950a4d2fc)(input) : (0, $ad36e6a06ac20042$export$c7c5cef950a4d2fc)(input);
};
var $b6db281eaac95c69$export$b4b216764bb846eb = function(input) {
    return typeof TextDecoder === "function" ? (0, $ce5e236f17b919d1$export$b4b216764bb846eb)(input) : (0, $ad36e6a06ac20042$export$b4b216764bb846eb)(input);
};


/**
 * @internal
 */ var $9015be62e6f7c3f1$export$b2e3d6d444266a5c = 64;
var $9015be62e6f7c3f1$export$d7bd469488748c5f = 16;
var $9015be62e6f7c3f1$export$d788bc089976c004 = [
    0x67452301,
    0xefcdab89,
    0x98badcfe,
    0x10325476
];


var $13f69c882036e129$export$9f5a3dfc7a9f5dd = /** @class */ function() {
    function Md5() {
        this.state = Uint32Array.from((0, $9015be62e6f7c3f1$export$d788bc089976c004));
        this.buffer = new DataView(new ArrayBuffer((0, $9015be62e6f7c3f1$export$b2e3d6d444266a5c)));
        this.bufferLength = 0;
        this.bytesHashed = 0;
        this.finished = false;
    }
    Md5.prototype.update = function(sourceData) {
        if ($13f69c882036e129$var$isEmptyData(sourceData)) return;
        else if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var data = $13f69c882036e129$var$convertToBuffer(sourceData);
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        while(byteLength > 0){
            this.buffer.setUint8(this.bufferLength++, data[position++]);
            byteLength--;
            if (this.bufferLength === (0, $9015be62e6f7c3f1$export$b2e3d6d444266a5c)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    Md5.prototype.digest = function() {
        return (0, $a2c22136b41df437$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a, buffer, undecoratedLength, bytesHashed, bitsHashed, i, i, out, i;
            return (0, $a2c22136b41df437$export$67ebef60e6f28a6)(this, function(_b) {
                if (!this.finished) {
                    _a = this, buffer = _a.buffer, undecoratedLength = _a.bufferLength, bytesHashed = _a.bytesHashed;
                    bitsHashed = bytesHashed * 8;
                    buffer.setUint8(this.bufferLength++, 128);
                    // Ensure the final block has enough room for the hashed length
                    if (undecoratedLength % (0, $9015be62e6f7c3f1$export$b2e3d6d444266a5c) >= (0, $9015be62e6f7c3f1$export$b2e3d6d444266a5c) - 8) {
                        for(i = this.bufferLength; i < (0, $9015be62e6f7c3f1$export$b2e3d6d444266a5c); i++)buffer.setUint8(i, 0);
                        this.hashBuffer();
                        this.bufferLength = 0;
                    }
                    for(i = this.bufferLength; i < (0, $9015be62e6f7c3f1$export$b2e3d6d444266a5c) - 8; i++)buffer.setUint8(i, 0);
                    buffer.setUint32((0, $9015be62e6f7c3f1$export$b2e3d6d444266a5c) - 8, bitsHashed >>> 0, true);
                    buffer.setUint32((0, $9015be62e6f7c3f1$export$b2e3d6d444266a5c) - 4, Math.floor(bitsHashed / 0x100000000), true);
                    this.hashBuffer();
                    this.finished = true;
                }
                out = new DataView(new ArrayBuffer((0, $9015be62e6f7c3f1$export$d7bd469488748c5f)));
                for(i = 0; i < 4; i++)out.setUint32(i * 4, this.state[i], true);
                return [
                    2 /*return*/ ,
                    new Uint8Array(out.buffer, out.byteOffset, out.byteLength)
                ];
            });
        });
    };
    Md5.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var a = state[0], b = state[1], c = state[2], d = state[3];
        a = $13f69c882036e129$var$ff(a, b, c, d, buffer.getUint32(0, true), 7, 0xd76aa478);
        d = $13f69c882036e129$var$ff(d, a, b, c, buffer.getUint32(4, true), 12, 0xe8c7b756);
        c = $13f69c882036e129$var$ff(c, d, a, b, buffer.getUint32(8, true), 17, 0x242070db);
        b = $13f69c882036e129$var$ff(b, c, d, a, buffer.getUint32(12, true), 22, 0xc1bdceee);
        a = $13f69c882036e129$var$ff(a, b, c, d, buffer.getUint32(16, true), 7, 0xf57c0faf);
        d = $13f69c882036e129$var$ff(d, a, b, c, buffer.getUint32(20, true), 12, 0x4787c62a);
        c = $13f69c882036e129$var$ff(c, d, a, b, buffer.getUint32(24, true), 17, 0xa8304613);
        b = $13f69c882036e129$var$ff(b, c, d, a, buffer.getUint32(28, true), 22, 0xfd469501);
        a = $13f69c882036e129$var$ff(a, b, c, d, buffer.getUint32(32, true), 7, 0x698098d8);
        d = $13f69c882036e129$var$ff(d, a, b, c, buffer.getUint32(36, true), 12, 0x8b44f7af);
        c = $13f69c882036e129$var$ff(c, d, a, b, buffer.getUint32(40, true), 17, 0xffff5bb1);
        b = $13f69c882036e129$var$ff(b, c, d, a, buffer.getUint32(44, true), 22, 0x895cd7be);
        a = $13f69c882036e129$var$ff(a, b, c, d, buffer.getUint32(48, true), 7, 0x6b901122);
        d = $13f69c882036e129$var$ff(d, a, b, c, buffer.getUint32(52, true), 12, 0xfd987193);
        c = $13f69c882036e129$var$ff(c, d, a, b, buffer.getUint32(56, true), 17, 0xa679438e);
        b = $13f69c882036e129$var$ff(b, c, d, a, buffer.getUint32(60, true), 22, 0x49b40821);
        a = $13f69c882036e129$var$gg(a, b, c, d, buffer.getUint32(4, true), 5, 0xf61e2562);
        d = $13f69c882036e129$var$gg(d, a, b, c, buffer.getUint32(24, true), 9, 0xc040b340);
        c = $13f69c882036e129$var$gg(c, d, a, b, buffer.getUint32(44, true), 14, 0x265e5a51);
        b = $13f69c882036e129$var$gg(b, c, d, a, buffer.getUint32(0, true), 20, 0xe9b6c7aa);
        a = $13f69c882036e129$var$gg(a, b, c, d, buffer.getUint32(20, true), 5, 0xd62f105d);
        d = $13f69c882036e129$var$gg(d, a, b, c, buffer.getUint32(40, true), 9, 0x02441453);
        c = $13f69c882036e129$var$gg(c, d, a, b, buffer.getUint32(60, true), 14, 0xd8a1e681);
        b = $13f69c882036e129$var$gg(b, c, d, a, buffer.getUint32(16, true), 20, 0xe7d3fbc8);
        a = $13f69c882036e129$var$gg(a, b, c, d, buffer.getUint32(36, true), 5, 0x21e1cde6);
        d = $13f69c882036e129$var$gg(d, a, b, c, buffer.getUint32(56, true), 9, 0xc33707d6);
        c = $13f69c882036e129$var$gg(c, d, a, b, buffer.getUint32(12, true), 14, 0xf4d50d87);
        b = $13f69c882036e129$var$gg(b, c, d, a, buffer.getUint32(32, true), 20, 0x455a14ed);
        a = $13f69c882036e129$var$gg(a, b, c, d, buffer.getUint32(52, true), 5, 0xa9e3e905);
        d = $13f69c882036e129$var$gg(d, a, b, c, buffer.getUint32(8, true), 9, 0xfcefa3f8);
        c = $13f69c882036e129$var$gg(c, d, a, b, buffer.getUint32(28, true), 14, 0x676f02d9);
        b = $13f69c882036e129$var$gg(b, c, d, a, buffer.getUint32(48, true), 20, 0x8d2a4c8a);
        a = $13f69c882036e129$var$hh(a, b, c, d, buffer.getUint32(20, true), 4, 0xfffa3942);
        d = $13f69c882036e129$var$hh(d, a, b, c, buffer.getUint32(32, true), 11, 0x8771f681);
        c = $13f69c882036e129$var$hh(c, d, a, b, buffer.getUint32(44, true), 16, 0x6d9d6122);
        b = $13f69c882036e129$var$hh(b, c, d, a, buffer.getUint32(56, true), 23, 0xfde5380c);
        a = $13f69c882036e129$var$hh(a, b, c, d, buffer.getUint32(4, true), 4, 0xa4beea44);
        d = $13f69c882036e129$var$hh(d, a, b, c, buffer.getUint32(16, true), 11, 0x4bdecfa9);
        c = $13f69c882036e129$var$hh(c, d, a, b, buffer.getUint32(28, true), 16, 0xf6bb4b60);
        b = $13f69c882036e129$var$hh(b, c, d, a, buffer.getUint32(40, true), 23, 0xbebfbc70);
        a = $13f69c882036e129$var$hh(a, b, c, d, buffer.getUint32(52, true), 4, 0x289b7ec6);
        d = $13f69c882036e129$var$hh(d, a, b, c, buffer.getUint32(0, true), 11, 0xeaa127fa);
        c = $13f69c882036e129$var$hh(c, d, a, b, buffer.getUint32(12, true), 16, 0xd4ef3085);
        b = $13f69c882036e129$var$hh(b, c, d, a, buffer.getUint32(24, true), 23, 0x04881d05);
        a = $13f69c882036e129$var$hh(a, b, c, d, buffer.getUint32(36, true), 4, 0xd9d4d039);
        d = $13f69c882036e129$var$hh(d, a, b, c, buffer.getUint32(48, true), 11, 0xe6db99e5);
        c = $13f69c882036e129$var$hh(c, d, a, b, buffer.getUint32(60, true), 16, 0x1fa27cf8);
        b = $13f69c882036e129$var$hh(b, c, d, a, buffer.getUint32(8, true), 23, 0xc4ac5665);
        a = $13f69c882036e129$var$ii(a, b, c, d, buffer.getUint32(0, true), 6, 0xf4292244);
        d = $13f69c882036e129$var$ii(d, a, b, c, buffer.getUint32(28, true), 10, 0x432aff97);
        c = $13f69c882036e129$var$ii(c, d, a, b, buffer.getUint32(56, true), 15, 0xab9423a7);
        b = $13f69c882036e129$var$ii(b, c, d, a, buffer.getUint32(20, true), 21, 0xfc93a039);
        a = $13f69c882036e129$var$ii(a, b, c, d, buffer.getUint32(48, true), 6, 0x655b59c3);
        d = $13f69c882036e129$var$ii(d, a, b, c, buffer.getUint32(12, true), 10, 0x8f0ccc92);
        c = $13f69c882036e129$var$ii(c, d, a, b, buffer.getUint32(40, true), 15, 0xffeff47d);
        b = $13f69c882036e129$var$ii(b, c, d, a, buffer.getUint32(4, true), 21, 0x85845dd1);
        a = $13f69c882036e129$var$ii(a, b, c, d, buffer.getUint32(32, true), 6, 0x6fa87e4f);
        d = $13f69c882036e129$var$ii(d, a, b, c, buffer.getUint32(60, true), 10, 0xfe2ce6e0);
        c = $13f69c882036e129$var$ii(c, d, a, b, buffer.getUint32(24, true), 15, 0xa3014314);
        b = $13f69c882036e129$var$ii(b, c, d, a, buffer.getUint32(52, true), 21, 0x4e0811a1);
        a = $13f69c882036e129$var$ii(a, b, c, d, buffer.getUint32(16, true), 6, 0xf7537e82);
        d = $13f69c882036e129$var$ii(d, a, b, c, buffer.getUint32(44, true), 10, 0xbd3af235);
        c = $13f69c882036e129$var$ii(c, d, a, b, buffer.getUint32(8, true), 15, 0x2ad7d2bb);
        b = $13f69c882036e129$var$ii(b, c, d, a, buffer.getUint32(36, true), 21, 0xeb86d391);
        state[0] = a + state[0] & 0xffffffff;
        state[1] = b + state[1] & 0xffffffff;
        state[2] = c + state[2] & 0xffffffff;
        state[3] = d + state[3] & 0xffffffff;
    };
    return Md5;
}();
function $13f69c882036e129$var$cmn(q, a, b, x, s, t) {
    a = (a + q & 0xffffffff) + (x + t & 0xffffffff) & 0xffffffff;
    return (a << s | a >>> 32 - s) + b & 0xffffffff;
}
function $13f69c882036e129$var$ff(a, b, c, d, x, s, t) {
    return $13f69c882036e129$var$cmn(b & c | ~b & d, a, b, x, s, t);
}
function $13f69c882036e129$var$gg(a, b, c, d, x, s, t) {
    return $13f69c882036e129$var$cmn(b & d | c & ~d, a, b, x, s, t);
}
function $13f69c882036e129$var$hh(a, b, c, d, x, s, t) {
    return $13f69c882036e129$var$cmn(b ^ c ^ d, a, b, x, s, t);
}
function $13f69c882036e129$var$ii(a, b, c, d, x, s, t) {
    return $13f69c882036e129$var$cmn(c ^ (b | ~d), a, b, x, s, t);
}
function $13f69c882036e129$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
function $13f69c882036e129$var$convertToBuffer(data) {
    if (typeof data === "string") return (0, $b6db281eaac95c69$export$c7c5cef950a4d2fc)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Wraps encodeURIComponent to encode additional characters to fully adhere to RFC 3986.
 * @see https://github.com/aws/aws-sdk-js-v3/blob/86b432c464150069678b25ff88d57c2ca26e75a2/packages/smithy-client/src/extended-encode-uri-component.ts#L7
 *
 * @param uri URI string to encode
 * @returns RFC 3986 encoded string
 *
 * @internal
 */ var $185f4f58e2d1a698$export$7640f3c16fe7f54b = function(uri) {
    // Match characters normally not encoded by `encodeURIComponent`
    var extendedCharacters = /[!'()*]/g;
    return encodeURIComponent(uri).replace(extendedCharacters, $185f4f58e2d1a698$var$hexEncode);
};
var $185f4f58e2d1a698$var$hexEncode = function(c) {
    return "%".concat(c.charCodeAt(0).toString(16).toUpperCase());
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $41fb895557f65b2f$var$bytesToBase64(bytes) {
    var base64Str = Array.from(bytes, function(x) {
        return String.fromCodePoint(x);
    }).join("");
    return btoa(base64Str);
}
function $41fb895557f65b2f$export$e1b32e613f230dc6(input) {
    return new TextEncoder().encode(input);
}
function $41fb895557f65b2f$export$37cc283d8fbd3462(input) {
    if (typeof input === "string") return $41fb895557f65b2f$var$bytesToBase64($41fb895557f65b2f$export$e1b32e613f230dc6(input));
    return $41fb895557f65b2f$var$bytesToBase64(new Uint8Array(input.buffer, input.byteOffset, input.byteLength));
}


var $854326972c2cbcdb$var$__assign = undefined && undefined.__assign || function() {
    $854326972c2cbcdb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $854326972c2cbcdb$var$__assign.apply(this, arguments);
};
var $854326972c2cbcdb$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $854326972c2cbcdb$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $854326972c2cbcdb$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $854326972c2cbcdb$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $854326972c2cbcdb$export$e17cc407388b3e89 = function(values) {
    var e_1, _a;
    var queryParams = {};
    try {
        for(var _b = $854326972c2cbcdb$var$__values(Object.entries(values)), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = $854326972c2cbcdb$var$__read(_c.value, 2), key = _d[0], value = _d[1];
            if (value != null) queryParams[key] = value.toString();
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return queryParams;
};
var $854326972c2cbcdb$export$63c8eae6d43cbe48 = function(input) {
    return $854326972c2cbcdb$var$__awaiter(void 0, void 0, void 0, function() {
        var getMd5Digest, _a, _b, _c, _d;
        var _e;
        return $854326972c2cbcdb$var$__generator(this, function(_f) {
            switch(_f.label){
                case 0:
                    getMd5Digest = function(content) {
                        return $854326972c2cbcdb$var$__awaiter(void 0, void 0, void 0, function() {
                            var md5Hasher;
                            return $854326972c2cbcdb$var$__generator(this, function(_a) {
                                md5Hasher = new (0, $13f69c882036e129$export$9f5a3dfc7a9f5dd)();
                                md5Hasher.update((0, $41fb895557f65b2f$export$e1b32e613f230dc6)(content));
                                return [
                                    2 /*return*/ ,
                                    md5Hasher.digest()
                                ];
                            });
                        });
                    };
                    _a = $854326972c2cbcdb$export$e17cc407388b3e89;
                    _e = {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm,
                        // base64 encoded is need
                        // see: https://docs.aws.amazon.com/AmazonS3/latest/userguide/ServerSideEncryptionCustomerKeys.html#specifying-s3-c-encryption
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey && (0, $41fb895557f65b2f$export$37cc283d8fbd3462)(input.SSECustomerKey)
                    };
                    // Calculate the md5 digest of the the SSE-C key, for compatibility with AWS SDK
                    // see: https://github.com/aws/aws-sdk-js-v3/blob/91fc83307c38cc9cbe0b3acd919557d5b5b831d6/packages/middleware-ssec/src/index.ts#L36
                    _b = "x-amz-server-side-encryption-customer-key-md5";
                    _c = input.SSECustomerKey;
                    if (!_c) return [
                        3 /*break*/ ,
                        2
                    ];
                    _d = (0, $41fb895557f65b2f$export$37cc283d8fbd3462);
                    return [
                        4 /*yield*/ ,
                        getMd5Digest(input.SSECustomerKey)
                    ];
                case 1:
                    _c = _d.apply(void 0, [
                        _f.sent()
                    ]);
                    _f.label = 2;
                case 2:
                    return [
                        2 /*return*/ ,
                        _a.apply(void 0, [
                            // Calculate the md5 digest of the the SSE-C key, for compatibility with AWS SDK
                            // see: https://github.com/aws/aws-sdk-js-v3/blob/91fc83307c38cc9cbe0b3acd919557d5b5b831d6/packages/middleware-ssec/src/index.ts#L36
                            (_e[_b] = _c, _e)
                        ])
                    ];
            }
        });
    });
};
var $854326972c2cbcdb$export$2707645b554c9055 = function(input) {
    return $854326972c2cbcdb$var$__awaiter(void 0, void 0, void 0, function() {
        var _a;
        var _b;
        return $854326972c2cbcdb$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $854326972c2cbcdb$export$63c8eae6d43cbe48(input)
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        $854326972c2cbcdb$var$__assign.apply(void 0, [
                            $854326972c2cbcdb$var$__assign.apply(void 0, _a.concat([
                                _c.sent()
                            ])),
                            $854326972c2cbcdb$export$e17cc407388b3e89($854326972c2cbcdb$var$__assign({
                                "x-amz-server-side-encryption": input.ServerSideEncryption,
                                "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId,
                                "x-amz-acl": input.ACL,
                                "cache-control": input.CacheControl,
                                "content-disposition": input.ContentDisposition,
                                "content-language": input.ContentLanguage,
                                "content-encoding": input.ContentEncoding,
                                "content-type": input.ContentType,
                                expires: (_b = input.Expires) === null || _b === void 0 ? void 0 : _b.toUTCString(),
                                "x-amz-tagging": input.Tagging
                            }, $854326972c2cbcdb$var$serializeMetadata(input.Metadata)))
                        ])
                    ];
            }
        });
    });
};
var $854326972c2cbcdb$var$serializeMetadata = function(metadata) {
    if (metadata === void 0) metadata = {};
    return Object.keys(metadata).reduce(function(acc, suffix) {
        acc["x-amz-meta-".concat(suffix.toLowerCase())] = metadata[suffix];
        return acc;
    }, {});
};
var $854326972c2cbcdb$export$5af35979a44e17e4 = function(url, key) {
    return url.pathname.replace(/\/$/, "") + "/".concat(key.split("/").map((0, $185f4f58e2d1a698$export$7640f3c16fe7f54b)).join("/"));
};

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a `Date` that is corrected for clock skew.
 *
 * @param systemClockOffset The offset of the system clock in milliseconds.
 *
 * @returns `Date` representing the current time adjusted by the system clock offset.
 *
 * @internal
 */ var $94095279f06a2b1c$export$86d5c90340985ada = function(systemClockOffset) {
    return new Date(Date.now() + systemClockOffset);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// 5 mins in milliseconds. Ref: https://github.com/aws/aws-sdk-js-v3/blob/6c0f44fab30a1bb2134af47362a31332abc3666b/packages/middleware-signing/src/utils/isClockSkewed.ts#L10
var $39c2125f00d0fa57$var$SKEW_WINDOW = 300000;
var $39c2125f00d0fa57$export$c162a01d4a03ea6f = function(clockTimeInMilliseconds, clockOffsetInMilliseconds) {
    return Math.abs((0, $94095279f06a2b1c$export$86d5c90340985ada)(clockOffsetInMilliseconds).getTime() - clockTimeInMilliseconds) >= $39c2125f00d0fa57$var$SKEW_WINDOW;
};


var $9f3f0a7bab2d120a$export$1ed4d48b860b1348 = function(clockTimeInMilliseconds, currentSystemClockOffset) {
    if ((0, $39c2125f00d0fa57$export$c162a01d4a03ea6f)(clockTimeInMilliseconds, currentSystemClockOffset)) return clockTimeInMilliseconds - Date.now();
    return currentSystemClockOffset;
};


var $1c2023cb8fc3ba07$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1c2023cb8fc3ba07$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $1c2023cb8fc3ba07$export$31cfc6b101983bdf = function(_a) {
    var credentials = _a.credentials, region = _a.region, service = _a.service, _b = _a.uriEscapePath, uriEscapePath = _b === void 0 ? true : _b;
    var currentSystemClockOffset;
    return function(next) {
        return function signingMiddleware(request) {
            return $1c2023cb8fc3ba07$var$__awaiter(this, void 0, void 0, function() {
                var signRequestOptions, _a, signedRequest, response, dateString;
                var _b;
                return $1c2023cb8fc3ba07$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            currentSystemClockOffset = currentSystemClockOffset !== null && currentSystemClockOffset !== void 0 ? currentSystemClockOffset : 0;
                            _b = {};
                            if (!(typeof credentials === "function")) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                credentials()
                            ];
                        case 1:
                            _a = _c.sent();
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 2:
                            _a = credentials;
                            _c.label = 3;
                        case 3:
                            signRequestOptions = (_b.credentials = _a, _b.signingDate = (0, $94095279f06a2b1c$export$86d5c90340985ada)(currentSystemClockOffset), _b.signingRegion = region, _b.signingService = service, _b.uriEscapePath = uriEscapePath, _b);
                            return [
                                4 /*yield*/ ,
                                (0, $59bef32240e822f5$export$aa7d25cddbad24ed)(request, signRequestOptions)
                            ];
                        case 4:
                            signedRequest = _c.sent();
                            return [
                                4 /*yield*/ ,
                                next(signedRequest)
                            ];
                        case 5:
                            response = _c.sent();
                            dateString = $1c2023cb8fc3ba07$var$getDateHeader(response);
                            if (dateString) currentSystemClockOffset = (0, $9f3f0a7bab2d120a$export$1ed4d48b860b1348)(Date.parse(dateString), currentSystemClockOffset);
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var $1c2023cb8fc3ba07$var$getDateHeader = function(_a) {
    var _b, _c;
    var _d = _a === void 0 ? {} : _a, headers = _d.headers;
    return (_c = (_b = headers === null || headers === void 0 ? void 0 : headers.date) !== null && _b !== void 0 ? _b : headers === null || headers === void 0 ? void 0 : headers.Date) !== null && _c !== void 0 ? _c : headers === null || headers === void 0 ? void 0 : headers["x-amz-date"];
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $3b18d274fcc1679a$export$c5e6923933be22a0 = "sendUploadProgress";
var $3b18d274fcc1679a$export$660a92f3322ba11a = "sendDownloadProgress";
var $3b18d274fcc1679a$export$65e55894e6e38a89 = "Network Error";
var $3b18d274fcc1679a$export$c7f012c6e67c4217 = "ECONNABORTED";
var $3b18d274fcc1679a$export$a8cd6fdacde36e8c = "Request aborted";
var $3b18d274fcc1679a$export$e544524598451432 = "ERR_ABORTED";
var $3b18d274fcc1679a$export$ff549c429fdaf151 = "canceled";
var $3b18d274fcc1679a$export$e355c3dce72254a9 = "ERR_CANCELED";
var $3b18d274fcc1679a$export$6087ef482ecf1ee7 = "x-amz-content-sha256";


var $adfdf155f7714db3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $adfdf155f7714db3$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $adfdf155f7714db3$export$cec386909c93f08a = function(options) {
    return function(next) {
        return function contentSha256Middleware(request) {
            return $adfdf155f7714db3$var$__awaiter(this, void 0, void 0, function() {
                var hash;
                return $adfdf155f7714db3$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!request.headers[0, $3b18d274fcc1679a$export$6087ef482ecf1ee7]) return [
                                3 /*break*/ ,
                                1
                            ];
                            return [
                                2 /*return*/ ,
                                next(request)
                            ];
                        case 1:
                            return [
                                4 /*yield*/ ,
                                (0, $566f2e9642a13796$export$b671a27d01dfc160)(request.body)
                            ];
                        case 2:
                            hash = _a.sent();
                            request.headers[0, $3b18d274fcc1679a$export$6087ef482ecf1ee7] = hash;
                            return [
                                2 /*return*/ ,
                                next(request)
                            ];
                    }
                });
            });
        };
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



var $0df55fff21bdf78c$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $0df55fff21bdf78c$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("xhr-http-handler");
var $0df55fff21bdf78c$export$a2e3be1e7ed3a1a = function(request, options) {
    var url = request.url, method = request.method, headers = request.headers, body = request.body;
    var emitter = options.emitter, responseType = options.responseType, abortSignal = options.abortSignal;
    return new Promise(function(resolve, reject) {
        var _a;
        var xhr = new XMLHttpRequest();
        xhr.open(method.toUpperCase(), url.toString());
        Object.entries(headers).filter(function(_a) {
            var _b = $0df55fff21bdf78c$var$__read(_a, 1), header = _b[0];
            return !$0df55fff21bdf78c$var$FORBIDDEN_HEADERS.includes(header);
        }).forEach(function(_a) {
            var _b = $0df55fff21bdf78c$var$__read(_a, 2), header = _b[0], value = _b[1];
            xhr.setRequestHeader(header, value);
        });
        xhr.responseType = responseType;
        if (emitter) {
            xhr.upload.addEventListener("progress", function(event) {
                emitter.emit((0, $3b18d274fcc1679a$export$c5e6923933be22a0), event);
                $0df55fff21bdf78c$var$logger.debug(event);
            });
            xhr.addEventListener("progress", function(event) {
                emitter.emit((0, $3b18d274fcc1679a$export$660a92f3322ba11a), event);
                $0df55fff21bdf78c$var$logger.debug(event);
            });
        }
        xhr.addEventListener("error", function() {
            var error = $0df55fff21bdf78c$var$simulateAxiosError((0, $3b18d274fcc1679a$export$65e55894e6e38a89), (0, $3b18d274fcc1679a$export$c7f012c6e67c4217), xhr, options);
            $0df55fff21bdf78c$var$logger.error((0, $3b18d274fcc1679a$export$65e55894e6e38a89));
            reject(error);
            xhr = null; // clean up request
        });
        // Handle browser request cancellation (as opposed to a manual cancellation)
        xhr.addEventListener("abort", function() {
            // The abort event can be triggered after the error or load event. So we need to check if the xhr is null.
            if (!xhr || (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted)) return;
            var error = $0df55fff21bdf78c$var$simulateAxiosError((0, $3b18d274fcc1679a$export$a8cd6fdacde36e8c), (0, $3b18d274fcc1679a$export$e544524598451432), xhr, options);
            $0df55fff21bdf78c$var$logger.error((0, $3b18d274fcc1679a$export$a8cd6fdacde36e8c));
            reject(error);
            xhr = null; // clean up request
        });
        // Skip handling timeout error since we don't have a timeout
        xhr.addEventListener("readystatechange", function() {
            if (!xhr || xhr.readyState !== xhr.DONE) return;
            var onloadend = function() {
                // The load event is triggered after the error/abort/load event. So we need to check if the xhr is null.
                if (!xhr) return;
                var responseHeaders = $0df55fff21bdf78c$var$convertResponseHeaders(xhr.getAllResponseHeaders());
                var responseType = xhr.responseType;
                var responseBlob = xhr.response;
                var responseText = responseType === "text" ? xhr.responseText : "";
                var bodyMixIn = {
                    blob: function() {
                        return Promise.resolve(responseBlob);
                    },
                    text: (0, $6b29aa0d39f75dc5$export$580ad1ce15092b15)(function() {
                        return responseType === "blob" ? $0df55fff21bdf78c$var$readBlobAsText(responseBlob) : Promise.resolve(responseText);
                    }),
                    json: function() {
                        return Promise.reject(// S3 does not support JSON response. So fail-fast here with nicer error message.
                        new Error("Parsing response to JSON is not implemented. Please use response.text() instead."));
                    }
                };
                var response = {
                    statusCode: xhr.status,
                    headers: responseHeaders,
                    // The xhr.responseType is only set to 'blob' for streaming binary S3 object data. The streaming data is
                    // exposed via public interface of Storage.get(). So we need to return the response as a Blob object for
                    // backward compatibility. In other cases, the response payload is only used internally, we return it is
                    // {@link ResponseBodyMixin}
                    body: xhr.responseType === "blob" ? Object.assign(responseBlob, bodyMixIn) : bodyMixIn
                };
                resolve(response);
                xhr = null; // clean up request
            };
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            // @see https://github.com/axios/axios/blob/9588fcdec8aca45c3ba2f7968988a5d03f23168c/lib/adapters/xhr.js#L98-L99
            setTimeout(onloadend);
        });
        if (abortSignal) {
            var onCancelled = function() {
                // The abort event is triggered after the error or load event. So we need to check if the xhr is null.
                if (!xhr) return;
                var canceledError = $0df55fff21bdf78c$var$simulateAxiosCanceledError((0, $3b18d274fcc1679a$export$ff549c429fdaf151) !== null && (0, $3b18d274fcc1679a$export$ff549c429fdaf151) !== void 0 ? (0, $3b18d274fcc1679a$export$ff549c429fdaf151) : abortSignal.reason, (0, $3b18d274fcc1679a$export$e355c3dce72254a9), xhr, options);
                xhr.abort();
                reject(canceledError);
                xhr = null;
            };
            abortSignal.aborted ? onCancelled() : abortSignal.addEventListener("abort", onCancelled);
        }
        if (typeof ReadableStream === "function" && body instanceof ReadableStream) // This does not matter as previous implementation uses Axios which does not support ReadableStream anyway.
        throw new Error("ReadableStream request payload is not supported.");
        xhr.send((_a = body) !== null && _a !== void 0 ? _a : null);
    });
};
// TODO: V6 remove this
var $0df55fff21bdf78c$var$simulateAxiosError = function(message, code, request, config) {
    return Object.assign(new Error(message), {
        code: code,
        config: config,
        request: request
    });
};
var $0df55fff21bdf78c$var$simulateAxiosCanceledError = function(message, code, request, config) {
    var error = $0df55fff21bdf78c$var$simulateAxiosError(message, code, request, config);
    error.name = "CanceledError";
    error["__CANCEL__"] = true;
    return error;
};
var $0df55fff21bdf78c$export$a88a1555052550c7 = function(error) {
    return !!(error === null || error === void 0 ? void 0 : error["__CANCEL__"]);
};
/**
 * Convert xhr.getAllResponseHeaders() string to a Record<string, string>. Note that modern browser already returns
 * header names in lowercase.
 * @param xhrHeaders - string of headers returned from xhr.getAllResponseHeaders()
 */ var $0df55fff21bdf78c$var$convertResponseHeaders = function(xhrHeaders) {
    if (!xhrHeaders) return {};
    return xhrHeaders.split("\r\n").reduce(function(headerMap, line) {
        var parts = line.split(": ");
        var header = parts.shift();
        var value = parts.join(": ");
        headerMap[header.toLowerCase()] = value;
        return headerMap;
    }, {});
};
var $0df55fff21bdf78c$var$readBlobAsText = function(blob) {
    var reader = new FileReader();
    return new Promise(function(resolve, reject) {
        reader.onloadend = function() {
            if (reader.readyState !== FileReader.DONE) return;
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
        reader.readAsText(blob);
    });
};
// To add more forbidden headers as found set by S3. Intentionally NOT list all of them here to save bundle size.
// https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name
var $0df55fff21bdf78c$var$FORBIDDEN_HEADERS = [
    "host"
];


var $a4b89fe9cb1a5395$export$387dd765fee16c05 = (0, $7c6efce776c036f5$export$f074d76e52925468)((0, $0df55fff21bdf78c$export$a2e3be1e7ed3a1a), [
    (0, $adfdf155f7714db3$export$cec386909c93f08a),
    (0, $e0f2f8f6c8baf5f5$export$62c460923941c0b0),
    (0, $ac90ade79318ec57$export$a3922aa5f87bae85),
    (0, $1c2023cb8fc3ba07$export$31cfc6b101983bdf)
]);


var $3fbff6c6f8a6f81e$var$__assign = undefined && undefined.__assign || function() {
    $3fbff6c6f8a6f81e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3fbff6c6f8a6f81e$var$__assign.apply(this, arguments);
};
var $3fbff6c6f8a6f81e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3fbff6c6f8a6f81e$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $3fbff6c6f8a6f81e$var$copyObjectSerializer = function(input, endpoint) {
    return $3fbff6c6f8a6f81e$var$__awaiter(void 0, void 0, void 0, function() {
        var headers, _a, url;
        return $3fbff6c6f8a6f81e$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $854326972c2cbcdb$export$2707645b554c9055)(input)
                    ];
                case 1:
                    headers = $3fbff6c6f8a6f81e$var$__assign.apply(void 0, [
                        $3fbff6c6f8a6f81e$var$__assign.apply(void 0, _a.concat([
                            _b.sent()
                        ])),
                        (0, $854326972c2cbcdb$export$e17cc407388b3e89)({
                            "x-amz-copy-source": input.CopySource,
                            "x-amz-metadata-directive": input.MetadataDirective
                        })
                    ]);
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, $854326972c2cbcdb$export$5af35979a44e17e4)(url, input.Key);
                    return [
                        2 /*return*/ ,
                        {
                            method: "PUT",
                            headers: headers,
                            url: url
                        }
                    ];
            }
        });
    });
};
var $3fbff6c6f8a6f81e$var$copyObjectDeserializer = function(response) {
    return $3fbff6c6f8a6f81e$var$__awaiter(void 0, void 0, void 0, function() {
        var error;
        return $3fbff6c6f8a6f81e$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $9229af72cd043253$export$a02c37c2d0ab7154)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, $9229af72cd043253$export$9f31af2cd814b6c7)(response)
                    ];
                case 3:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        {
                            $metadata: (0, $fe0ec52dee712a0c$export$978f9418fe0cb26c)(response)
                        }
                    ];
            }
        });
    });
};
var $3fbff6c6f8a6f81e$export$84f041eb9803ea1f = (0, $ed795cf51f5bd210$export$880429a8ae983d4d)((0, $a4b89fe9cb1a5395$export$387dd765fee16c05), $3fbff6c6f8a6f81e$var$copyObjectSerializer, $3fbff6c6f8a6f81e$var$copyObjectDeserializer, $3fbff6c6f8a6f81e$var$__assign($3fbff6c6f8a6f81e$var$__assign({}, (0, $04efb6a586095162$export$f84bd70098573c5c)), {
    responseType: "text"
}));

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $85992c38f9265346$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $85992c38f9265346$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $85992c38f9265346$export$871de8747c9eaa88 = function(obj, instructions) {
    var e_1, _a;
    var result = {};
    try {
        for(var _b = $85992c38f9265346$var$__values(Object.entries(instructions)), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = $85992c38f9265346$var$__read(_c.value, 2), key = _d[0], instruction = _d[1];
            var _e = $85992c38f9265346$var$__read(Array.isArray(instruction) ? instruction : [
                instruction
            ], 2), accessor = _e[0], deserializer = _e[1];
            if (obj.hasOwnProperty(accessor)) result[key] = deserializer ? deserializer(obj[accessor]) : String(obj[accessor]);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return result;
};
var $85992c38f9265346$export$c1eb6da0da8d0d20 = function(value) {
    return value ? Number(value) : undefined;
};
var $85992c38f9265346$export$c9f54d9c5173b67d = function(value) {
    return value ? value === "true" : undefined;
};
var $85992c38f9265346$export$8aadb6f9e991e309 = function(value) {
    return value ? new Date(value) : undefined;
};
var $85992c38f9265346$export$e9d411a739f8e6c1 = function(value, deserializer) {
    if (value === "") return [];
    var valueArray = (Array.isArray(value) ? value : [
        value
    ]).filter(function(e) {
        return e != null;
    });
    return deserializer(valueArray);
};
var $85992c38f9265346$export$233584d1796d8290 = function(headers) {
    var objectMetadataHeaderPrefix = "x-amz-meta-";
    var deserialized = Object.keys(headers).filter(function(header) {
        return header.startsWith(objectMetadataHeaderPrefix);
    }).reduce(function(acc, header) {
        acc[header.replace(objectMetadataHeaderPrefix, "")] = headers[header];
        return acc;
    }, {});
    return Object.keys(deserialized).length > 0 ? deserialized : undefined;
};


var $50dbca44dc0e52ae$var$__assign = undefined && undefined.__assign || function() {
    $50dbca44dc0e52ae$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $50dbca44dc0e52ae$var$__assign.apply(this, arguments);
};
var $50dbca44dc0e52ae$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $50dbca44dc0e52ae$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $50dbca44dc0e52ae$var$deleteObjectSerializer = function(input, endpoint) {
    var url = new URL(endpoint.url.toString());
    url.pathname = (0, $854326972c2cbcdb$export$5af35979a44e17e4)(url, input.Key);
    return {
        method: "DELETE",
        headers: {},
        url: url
    };
};
var $50dbca44dc0e52ae$var$deleteObjectDeserializer = function(response) {
    return $50dbca44dc0e52ae$var$__awaiter(void 0, void 0, void 0, function() {
        var error, content;
        return $50dbca44dc0e52ae$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $9229af72cd043253$export$a02c37c2d0ab7154)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    content = (0, $85992c38f9265346$export$871de8747c9eaa88)(response.headers, {
                        DeleteMarker: [
                            "x-amz-delete-marker",
                            (0, $85992c38f9265346$export$c9f54d9c5173b67d)
                        ],
                        VersionId: "x-amz-version-id",
                        RequestCharged: "x-amz-request-charged"
                    });
                    return [
                        2 /*return*/ ,
                        $50dbca44dc0e52ae$var$__assign($50dbca44dc0e52ae$var$__assign({}, content), {
                            $metadata: (0, $fe0ec52dee712a0c$export$978f9418fe0cb26c)(response)
                        })
                    ];
            }
        });
    });
};
var $50dbca44dc0e52ae$export$39c5ed4ec960eade = (0, $ed795cf51f5bd210$export$880429a8ae983d4d)((0, $a4b89fe9cb1a5395$export$387dd765fee16c05), $50dbca44dc0e52ae$var$deleteObjectSerializer, $50dbca44dc0e52ae$var$deleteObjectDeserializer, $50dbca44dc0e52ae$var$__assign($50dbca44dc0e52ae$var$__assign({}, (0, $04efb6a586095162$export$f84bd70098573c5c)), {
    responseType: "text"
}));

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0





var $149965fe409d78b9$var$__assign = undefined && undefined.__assign || function() {
    $149965fe409d78b9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $149965fe409d78b9$var$__assign.apply(this, arguments);
};
var $149965fe409d78b9$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $149965fe409d78b9$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $149965fe409d78b9$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $149965fe409d78b9$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $149965fe409d78b9$var$getObjectSerializer = function(input, endpoint) {
    return $149965fe409d78b9$var$__awaiter(void 0, void 0, void 0, function() {
        var headers, query, url;
        return $149965fe409d78b9$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, $854326972c2cbcdb$export$63c8eae6d43cbe48)(input)
                    ];
                case 1:
                    headers = _a.sent();
                    query = (0, $85992c38f9265346$export$871de8747c9eaa88)(input, {
                        "response-cache-control": "ResponseCacheControl",
                        "response-content-disposition": "ResponseContentDisposition",
                        "response-content-encoding": "ResponseContentEncoding",
                        "response-content-language": "ResponseContentLanguage",
                        "response-content-type": "ResponseContentType"
                    });
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, $854326972c2cbcdb$export$5af35979a44e17e4)(url, input.Key);
                    url.search = new URLSearchParams(query).toString();
                    return [
                        2 /*return*/ ,
                        {
                            method: "GET",
                            headers: headers,
                            url: url
                        }
                    ];
            }
        });
    });
};
var $149965fe409d78b9$var$getObjectDeserializer = function(response) {
    return $149965fe409d78b9$var$__awaiter(void 0, void 0, void 0, function() {
        var error;
        return $149965fe409d78b9$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $9229af72cd043253$export$a02c37c2d0ab7154)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    if (!response.body) throw new Error("Got empty response body.");
                    else return [
                        2 /*return*/ ,
                        $149965fe409d78b9$var$__assign($149965fe409d78b9$var$__assign({}, (0, $85992c38f9265346$export$871de8747c9eaa88)(response.headers, {
                            DeleteMarker: [
                                "x-amz-delete-marker",
                                (0, $85992c38f9265346$export$c9f54d9c5173b67d)
                            ],
                            AcceptRanges: "accept-ranges",
                            Expiration: "x-amz-expiration",
                            Restore: "x-amz-restore",
                            LastModified: [
                                "last-modified",
                                (0, $85992c38f9265346$export$8aadb6f9e991e309)
                            ],
                            ContentLength: [
                                "content-length",
                                (0, $85992c38f9265346$export$c1eb6da0da8d0d20)
                            ],
                            ETag: "etag",
                            ChecksumCRC32: "x-amz-checksum-crc32",
                            ChecksumCRC32C: "x-amz-checksum-crc32c",
                            ChecksumSHA1: "x-amz-checksum-sha1",
                            ChecksumSHA256: "x-amz-checksum-sha256",
                            MissingMeta: [
                                "x-amz-missing-meta",
                                (0, $85992c38f9265346$export$c1eb6da0da8d0d20)
                            ],
                            VersionId: "x-amz-version-id",
                            CacheControl: "cache-control",
                            ContentDisposition: "content-disposition",
                            ContentEncoding: "content-encoding",
                            ContentLanguage: "content-language",
                            ContentRange: "content-range",
                            ContentType: "content-type",
                            Expires: [
                                "expires",
                                (0, $85992c38f9265346$export$8aadb6f9e991e309)
                            ],
                            WebsiteRedirectLocation: "x-amz-website-redirect-location",
                            ServerSideEncryption: "x-amz-server-side-encryption",
                            SSECustomerAlgorithm: "x-amz-server-side-encryption-customer-algorithm",
                            SSECustomerKeyMD5: "x-amz-server-side-encryption-customer-key-md5",
                            SSEKMSKeyId: "x-amz-server-side-encryption-aws-kms-key-id",
                            BucketKeyEnabled: [
                                "x-amz-server-side-encryption-bucket-key-enabled",
                                (0, $85992c38f9265346$export$c9f54d9c5173b67d)
                            ],
                            StorageClass: "x-amz-storage-class",
                            RequestCharged: "x-amz-request-charged",
                            ReplicationStatus: "x-amz-replication-status",
                            PartsCount: [
                                "x-amz-mp-parts-count",
                                (0, $85992c38f9265346$export$c1eb6da0da8d0d20)
                            ],
                            TagCount: [
                                "x-amz-tagging-count",
                                (0, $85992c38f9265346$export$c1eb6da0da8d0d20)
                            ],
                            ObjectLockMode: "x-amz-object-lock-mode",
                            ObjectLockRetainUntilDate: [
                                "x-amz-object-lock-retain-until-date",
                                (0, $85992c38f9265346$export$8aadb6f9e991e309)
                            ],
                            ObjectLockLegalHoldStatus: "x-amz-object-lock-legal-hold"
                        })), {
                            Metadata: (0, $85992c38f9265346$export$233584d1796d8290)(response.headers),
                            $metadata: (0, $fe0ec52dee712a0c$export$978f9418fe0cb26c)(response),
                            Body: response.body
                        })
                    ];
                    _a.label = 3;
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $149965fe409d78b9$export$93534728ecb2e7b9 = (0, $ed795cf51f5bd210$export$880429a8ae983d4d)((0, $a4b89fe9cb1a5395$export$387dd765fee16c05), $149965fe409d78b9$var$getObjectSerializer, $149965fe409d78b9$var$getObjectDeserializer, $149965fe409d78b9$var$__assign($149965fe409d78b9$var$__assign({}, (0, $04efb6a586095162$export$f84bd70098573c5c)), {
    responseType: "blob"
}));
var $149965fe409d78b9$export$8a3cb53edae699d1 = function(config, input) {
    return $149965fe409d78b9$var$__awaiter(void 0, void 0, void 0, function() {
        var endpoint, _a, url, headers, method, _b, _c, _d, headerName, value;
        var e_1, _e;
        var _f;
        return $149965fe409d78b9$var$__generator(this, function(_g) {
            switch(_g.label){
                case 0:
                    endpoint = (0, $04efb6a586095162$export$f84bd70098573c5c).endpointResolver(config, input);
                    return [
                        4 /*yield*/ ,
                        $149965fe409d78b9$var$getObjectSerializer(input, endpoint)
                    ];
                case 1:
                    _a = _g.sent(), url = _a.url, headers = _a.headers, method = _a.method;
                    // TODO: set content sha256 query parameter with value of UNSIGNED-PAYLOAD.
                    // It requires changes in presignUrl. Without this change, the generated url still works,
                    // but not the same as other tools like AWS SDK and CLI.
                    url.searchParams.append((0, $3b18d274fcc1679a$export$6087ef482ecf1ee7), (0, $247c6c6e885234db$export$b445dbfd1d7f2d42));
                    url.searchParams.append((_f = config.userAgentHeader) !== null && _f !== void 0 ? _f : (0, $ed8a415515f52c9d$export$16032fc466434892), config.userAgentValue);
                    try {
                        for(_b = $149965fe409d78b9$var$__values(Object.entries(headers).sort(function(_a, _b) {
                            var _c = $149965fe409d78b9$var$__read(_a, 1), key1 = _c[0];
                            var _d = $149965fe409d78b9$var$__read(_b, 1), key2 = _d[0];
                            return key1.localeCompare(key2);
                        })), _c = _b.next(); !_c.done; _c = _b.next()){
                            _d = $149965fe409d78b9$var$__read(_c.value, 2), headerName = _d[0], value = _d[1];
                            url.searchParams.append(headerName, value);
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    return [
                        2 /*return*/ ,
                        (0, $b4fbe6c7907f8450$export$b30eabd005f8b990)({
                            method: method,
                            url: url,
                            body: null
                        }, $149965fe409d78b9$var$__assign($149965fe409d78b9$var$__assign({}, (0, $04efb6a586095162$export$f84bd70098573c5c)), config)).toString()
                    ];
            }
        });
    });
};

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




var $63554d7c2a89fb77$var$__assign = undefined && undefined.__assign || function() {
    $63554d7c2a89fb77$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $63554d7c2a89fb77$var$__assign.apply(this, arguments);
};
var $63554d7c2a89fb77$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $63554d7c2a89fb77$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $63554d7c2a89fb77$var$headObjectSerializer = function(input, endpoint) {
    return $63554d7c2a89fb77$var$__awaiter(void 0, void 0, void 0, function() {
        var headers, url;
        return $63554d7c2a89fb77$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, $854326972c2cbcdb$export$63c8eae6d43cbe48)(input)
                    ];
                case 1:
                    headers = _a.sent();
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, $854326972c2cbcdb$export$5af35979a44e17e4)(url, input.Key);
                    return [
                        2 /*return*/ ,
                        {
                            method: "HEAD",
                            headers: headers,
                            url: url
                        }
                    ];
            }
        });
    });
};
var $63554d7c2a89fb77$var$headObjectDeserializer = function(response) {
    return $63554d7c2a89fb77$var$__awaiter(void 0, void 0, void 0, function() {
        var error, contents;
        return $63554d7c2a89fb77$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $9229af72cd043253$export$a02c37c2d0ab7154)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    contents = $63554d7c2a89fb77$var$__assign($63554d7c2a89fb77$var$__assign({}, (0, $85992c38f9265346$export$871de8747c9eaa88)(response.headers, {
                        ContentLength: [
                            "content-length",
                            (0, $85992c38f9265346$export$c1eb6da0da8d0d20)
                        ],
                        ContentType: "content-type",
                        ETag: "etag",
                        LastModified: [
                            "last-modified",
                            (0, $85992c38f9265346$export$8aadb6f9e991e309)
                        ],
                        VersionId: "x-amz-version-id"
                    })), {
                        Metadata: (0, $85992c38f9265346$export$233584d1796d8290)(response.headers)
                    });
                    return [
                        2 /*return*/ ,
                        $63554d7c2a89fb77$var$__assign({
                            $metadata: (0, $fe0ec52dee712a0c$export$978f9418fe0cb26c)(response)
                        }, contents)
                    ];
            }
        });
    });
};
var $63554d7c2a89fb77$export$fde2a1002e11c41c = (0, $ed795cf51f5bd210$export$880429a8ae983d4d)((0, $a4b89fe9cb1a5395$export$387dd765fee16c05), $63554d7c2a89fb77$var$headObjectSerializer, $63554d7c2a89fb77$var$headObjectDeserializer, $63554d7c2a89fb77$var$__assign($63554d7c2a89fb77$var$__assign({}, (0, $04efb6a586095162$export$f84bd70098573c5c)), {
    responseType: "text"
}));

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




var $6060c9199bed7416$var$__assign = undefined && undefined.__assign || function() {
    $6060c9199bed7416$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6060c9199bed7416$var$__assign.apply(this, arguments);
};
var $6060c9199bed7416$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6060c9199bed7416$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $6060c9199bed7416$var$listObjectsV2Serializer = function(input, endpoint) {
    var headers = (0, $854326972c2cbcdb$export$e17cc407388b3e89)({
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    var query = (0, $854326972c2cbcdb$export$e17cc407388b3e89)({
        "list-type": "2",
        "continuation-token": input.ContinuationToken,
        delimiter: input.Delimiter,
        "encoding-type": input.EncodingType,
        "fetch-owner": input.FetchOwner,
        "max-keys": input.MaxKeys,
        prefix: input.Prefix,
        "start-after": input.StartAfter
    });
    var url = new URL(endpoint.url.toString());
    url.search = new URLSearchParams(query).toString();
    return {
        method: "GET",
        headers: headers,
        url: url
    };
};
var $6060c9199bed7416$var$listObjectsV2Deserializer = function(response) {
    return $6060c9199bed7416$var$__awaiter(void 0, void 0, void 0, function() {
        var error, parsed, contents;
        return $6060c9199bed7416$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $9229af72cd043253$export$a02c37c2d0ab7154)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, $9229af72cd043253$export$9f31af2cd814b6c7)(response)
                    ];
                case 3:
                    parsed = _a.sent();
                    contents = (0, $85992c38f9265346$export$871de8747c9eaa88)(parsed, {
                        CommonPrefixes: [
                            "CommonPrefixes",
                            function(value) {
                                return (0, $85992c38f9265346$export$e9d411a739f8e6c1)(value, $6060c9199bed7416$var$deserializeCommonPrefixList);
                            }
                        ],
                        Contents: [
                            "Contents",
                            function(value) {
                                return (0, $85992c38f9265346$export$e9d411a739f8e6c1)(value, $6060c9199bed7416$var$deserializeObjectList);
                            }
                        ],
                        ContinuationToken: "ContinuationToken",
                        Delimiter: "Delimiter",
                        EncodingType: "EncodingType",
                        IsTruncated: [
                            "IsTruncated",
                            (0, $85992c38f9265346$export$c9f54d9c5173b67d)
                        ],
                        KeyCount: [
                            "KeyCount",
                            (0, $85992c38f9265346$export$c1eb6da0da8d0d20)
                        ],
                        MaxKeys: [
                            "MaxKeys",
                            (0, $85992c38f9265346$export$c1eb6da0da8d0d20)
                        ],
                        Name: "Name",
                        NextContinuationToken: "NextContinuationToken",
                        Prefix: "Prefix",
                        StartAfter: "StartAfter"
                    });
                    return [
                        2 /*return*/ ,
                        $6060c9199bed7416$var$__assign({
                            $metadata: (0, $fe0ec52dee712a0c$export$978f9418fe0cb26c)(response)
                        }, contents)
                    ];
            }
        });
    });
};
var $6060c9199bed7416$var$deserializeCommonPrefixList = function(output) {
    return output.map($6060c9199bed7416$var$deserializeCommonPrefix);
};
var $6060c9199bed7416$var$deserializeCommonPrefix = function(output) {
    return (0, $85992c38f9265346$export$871de8747c9eaa88)(output, {
        Prefix: "Prefix"
    });
};
var $6060c9199bed7416$var$deserializeObjectList = function(output) {
    return output.map($6060c9199bed7416$var$deserializeObject);
};
var $6060c9199bed7416$var$deserializeObject = function(output) {
    return (0, $85992c38f9265346$export$871de8747c9eaa88)(output, {
        Key: "Key",
        LastModified: [
            "LastModified",
            (0, $85992c38f9265346$export$8aadb6f9e991e309)
        ],
        ETag: "ETag",
        ChecksumAlgorithm: [
            "ChecksumAlgorithm",
            function(value) {
                return (0, $85992c38f9265346$export$e9d411a739f8e6c1)(value, $6060c9199bed7416$var$deserializeChecksumAlgorithmList);
            }
        ],
        Size: [
            "Size",
            (0, $85992c38f9265346$export$c1eb6da0da8d0d20)
        ],
        StorageClass: "StorageClass",
        Owner: [
            "Owner",
            $6060c9199bed7416$var$deserializeOwner
        ]
    });
};
var $6060c9199bed7416$var$deserializeChecksumAlgorithmList = function(output) {
    return output.map(function(entry) {
        return String(entry);
    });
};
var $6060c9199bed7416$var$deserializeOwner = function(output) {
    return (0, $85992c38f9265346$export$871de8747c9eaa88)(output, {
        DisplayName: "DisplayName",
        ID: "ID"
    });
};
var $6060c9199bed7416$export$d00eea31b34c3abb = (0, $ed795cf51f5bd210$export$880429a8ae983d4d)((0, $a4b89fe9cb1a5395$export$387dd765fee16c05), $6060c9199bed7416$var$listObjectsV2Serializer, $6060c9199bed7416$var$listObjectsV2Deserializer, $6060c9199bed7416$var$__assign($6060c9199bed7416$var$__assign({}, (0, $04efb6a586095162$export$f84bd70098573c5c)), {
    responseType: "text"
}));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $ca7620d9022731b0$export$148a3867c72aff96;
(function(StorageErrorStrings) {
    StorageErrorStrings["NO_CREDENTIALS"] = "No credentials";
    StorageErrorStrings["NO_SRC_KEY"] = 'source param should be an object with the property "key" with value of type string';
    StorageErrorStrings["NO_DEST_KEY"] = 'destination param should be an object with the property "key" with value of type string';
    StorageErrorStrings["INVALID_BLOB"] = "Object must be an instance of Blob";
})($ca7620d9022731b0$export$148a3867c72aff96 || ($ca7620d9022731b0$export$148a3867c72aff96 = {}));
var $ca7620d9022731b0$export$85f5425ead1c79c0;
(function(AWSS3ProviderMultipartCopierErrors) {
    AWSS3ProviderMultipartCopierErrors["CLEANUP_FAILED"] = "Multipart copy clean up failed";
    AWSS3ProviderMultipartCopierErrors["NO_OBJECT_FOUND"] = "Object does not exist";
    AWSS3ProviderMultipartCopierErrors["INVALID_QUEUESIZE"] = "Queue size must be a positive number";
    AWSS3ProviderMultipartCopierErrors["NO_COPYSOURCE"] = "You must specify a copy source";
    AWSS3ProviderMultipartCopierErrors["MAX_NUM_PARTS_EXCEEDED"] = "Only a maximum of 10000 parts are allowed";
})($ca7620d9022731b0$export$85f5425ead1c79c0 || ($ca7620d9022731b0$export$85f5425ead1c79c0 = {}));
var $ca7620d9022731b0$export$179814ca32efa022;
(function(AWSS3ProviderUploadErrorStrings) {
    AWSS3ProviderUploadErrorStrings["UPLOAD_PAUSED_MESSAGE"] = "paused";
})($ca7620d9022731b0$export$179814ca32efa022 || ($ca7620d9022731b0$export$179814ca32efa022 = {}));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $9c583fdc61a644a5$export$aadf71dd9875dd20 = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var $9c583fdc61a644a5$export$b7bd51f6ce311d83 = "http://localhost:20005";
var $9c583fdc61a644a5$export$b9acc545d1bd0170 = "__uploadInProgress";


var $79809e69590d40e0$export$a48f0734ac7c2329 = function(x) {
    if (typeof x === "string") return x.length;
    else if ($79809e69590d40e0$var$isArrayBuffer(x)) return x.byteLength;
    else if ($79809e69590d40e0$export$5bcd6e94ed871c88(x)) return x.size;
    else throw new Error("Cannot determine byte length of " + x);
};
var $79809e69590d40e0$export$f4575af7aa417855 = function(track, event, attrs, metrics, message) {
    if (track) {
        var data = {
            attrs: attrs
        };
        if (metrics) data["metrics"] = metrics;
        (0, $3b4d9bb645fe011c$export$8c41bb232f1008b1).dispatch("storage", {
            event: event,
            data: data,
            message: message
        }, "Storage", (0, $9c583fdc61a644a5$export$aadf71dd9875dd20));
    }
};
var $79809e69590d40e0$export$be78b3111c50efdd = function(x) {
    return typeof x !== "undefined" && x instanceof File;
};
var $79809e69590d40e0$export$5bcd6e94ed871c88 = function(x) {
    return typeof x !== "undefined" && x instanceof Blob;
};
var $79809e69590d40e0$var$isArrayBuffer = function(x) {
    return typeof x !== "undefined" && x instanceof ArrayBuffer;
};




var $7a70ad0ea906f888$var$__assign = undefined && undefined.__assign || function() {
    $7a70ad0ea906f888$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7a70ad0ea906f888$var$__assign.apply(this, arguments);
};
var $7a70ad0ea906f888$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7a70ad0ea906f888$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $7a70ad0ea906f888$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("S3ClientUtils");
// placeholder credentials in order to satisfy type requirement, always results in 403 when used
var $7a70ad0ea906f888$var$INVALID_CRED = {
    accessKeyId: "",
    secretAccessKey: ""
};
var $7a70ad0ea906f888$export$36e24695f02d4503 = function(config) {
    var credentials = config.credentials, level = config.level, customPrefix = config.customPrefix, identityId = config.identityId;
    var resolvedCustomPrefix = customPrefix || {};
    var resolvedIdentityId = identityId || credentials.identityId;
    var privatePath = (resolvedCustomPrefix.private !== undefined ? resolvedCustomPrefix.private : "private/") + resolvedIdentityId + "/";
    var protectedPath = (resolvedCustomPrefix.protected !== undefined ? resolvedCustomPrefix.protected : "protected/") + resolvedIdentityId + "/";
    var publicPath = resolvedCustomPrefix.public !== undefined ? resolvedCustomPrefix.public : "public/";
    switch(level){
        case "private":
            return privatePath;
        case "protected":
            return protectedPath;
        default:
            return publicPath;
    }
};
var $7a70ad0ea906f888$export$ae4c744fb23e6d32 = function() {
    return $7a70ad0ea906f888$var$__awaiter(void 0, void 0, void 0, function() {
        var credentials, cred, error_1;
        return $7a70ad0ea906f888$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4 /*yield*/ ,
                        (0, $44b8a981f31e24b5$export$a9627919734faa48).get()
                    ];
                case 1:
                    credentials = _a.sent();
                    if (!credentials) return [
                        2 /*return*/ ,
                        $7a70ad0ea906f888$var$INVALID_CRED
                    ];
                    cred = (0, $44b8a981f31e24b5$export$a9627919734faa48).shear(credentials);
                    $7a70ad0ea906f888$var$logger.debug("credentials provider get credentials", cred);
                    return [
                        2 /*return*/ ,
                        cred
                    ];
                case 2:
                    error_1 = _a.sent();
                    $7a70ad0ea906f888$var$logger.warn("credentials provider error", error_1);
                    return [
                        2 /*return*/ ,
                        $7a70ad0ea906f888$var$INVALID_CRED
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $7a70ad0ea906f888$export$fa2cd26183e80a49 = function(config) {
    if (!config.region) // Same error thrown by aws-sdk
    throw new Error("Region is missing.");
    return $7a70ad0ea906f888$var$__assign($7a70ad0ea906f888$var$__assign($7a70ad0ea906f888$var$__assign({}, config), {
        region: config.region,
        credentials: config.credentials ? function() {
            return Promise.resolve(config.credentials);
        } : $7a70ad0ea906f888$export$ae4c744fb23e6d32,
        userAgentValue: (0, $0d25e50bf44b1a9b$export$ede38edb26c0bfdf)({
            category: (0, $58c96d580693cdce$export$3a8840c5b2ecf003).Storage,
            action: config.storageAction
        })
    }), config.dangerouslyConnectToHttpEndpointForTesting ? {
        customEndpoint: (0, $9c583fdc61a644a5$export$b7bd51f6ce311d83),
        forcePathStyle: true
    } : {});
};
var $7a70ad0ea906f888$var$MiB = 1048576;
var $7a70ad0ea906f888$var$GiB = 1024 * $7a70ad0ea906f888$var$MiB;
var $7a70ad0ea906f888$var$TiB = 1024 * $7a70ad0ea906f888$var$GiB;
var $7a70ad0ea906f888$export$a2977590b9739b8b = 5 * $7a70ad0ea906f888$var$MiB;
var $7a70ad0ea906f888$export$644fd66ce6bffe3 = 5 * $7a70ad0ea906f888$var$TiB;
var $7a70ad0ea906f888$export$63a260eede92f11a = 10000;
var $7a70ad0ea906f888$export$8cef33516f471d13 = 4;
var $7a70ad0ea906f888$export$8eb1333248593ec2 = function(totalSize) {
    var partSize = $7a70ad0ea906f888$export$a2977590b9739b8b;
    var partsCount = Math.ceil(totalSize / partSize);
    while(partsCount > $7a70ad0ea906f888$export$63a260eede92f11a){
        partSize *= 2;
        partsCount = Math.ceil(totalSize / partSize);
    }
    return partSize;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




var $ee31fa3eb3f6493c$var$__assign = undefined && undefined.__assign || function() {
    $ee31fa3eb3f6493c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ee31fa3eb3f6493c$var$__assign.apply(this, arguments);
};
var $ee31fa3eb3f6493c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ee31fa3eb3f6493c$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $ee31fa3eb3f6493c$var$abortMultipartUploadSerializer = function(input, endpoint) {
    var url = new URL(endpoint.url.toString());
    url.pathname = (0, $854326972c2cbcdb$export$5af35979a44e17e4)(url, input.Key);
    url.search = new URLSearchParams({
        uploadId: input.UploadId
    }).toString();
    return {
        method: "DELETE",
        headers: {},
        url: url
    };
};
var $ee31fa3eb3f6493c$var$abortMultipartUploadDeserializer = function(response) {
    return $ee31fa3eb3f6493c$var$__awaiter(void 0, void 0, void 0, function() {
        var error;
        return $ee31fa3eb3f6493c$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $9229af72cd043253$export$a02c37c2d0ab7154)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        2 /*return*/ ,
                        {
                            $metadata: (0, $fe0ec52dee712a0c$export$978f9418fe0cb26c)(response)
                        }
                    ];
            }
        });
    });
};
var $ee31fa3eb3f6493c$export$45ae37477c36d1d3 = (0, $ed795cf51f5bd210$export$880429a8ae983d4d)((0, $a4b89fe9cb1a5395$export$387dd765fee16c05), $ee31fa3eb3f6493c$var$abortMultipartUploadSerializer, $ee31fa3eb3f6493c$var$abortMultipartUploadDeserializer, $ee31fa3eb3f6493c$var$__assign($ee31fa3eb3f6493c$var$__assign({}, (0, $04efb6a586095162$export$f84bd70098573c5c)), {
    responseType: "text"
}));

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




var $96de8c6b18bb5569$var$__assign = undefined && undefined.__assign || function() {
    $96de8c6b18bb5569$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $96de8c6b18bb5569$var$__assign.apply(this, arguments);
};
var $96de8c6b18bb5569$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $96de8c6b18bb5569$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $96de8c6b18bb5569$var$INVALID_PARAMETER_ERROR_MSG = "Invalid parameter for ComplteMultipartUpload API";
var $96de8c6b18bb5569$var$completeMultipartUploadSerializer = function(input, endpoint) {
    return $96de8c6b18bb5569$var$__awaiter(void 0, void 0, void 0, function() {
        var headers, url;
        return $96de8c6b18bb5569$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, $854326972c2cbcdb$export$63c8eae6d43cbe48)(input)
                    ];
                case 1:
                    headers = _a.sent();
                    headers["content-type"] = "application/xml";
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, $854326972c2cbcdb$export$5af35979a44e17e4)(url, input.Key);
                    url.search = new URLSearchParams({
                        uploadId: input.UploadId
                    }).toString();
                    return [
                        2 /*return*/ ,
                        {
                            method: "POST",
                            headers: headers,
                            url: url,
                            body: '<?xml version="1.0" encoding="UTF-8"?>' + $96de8c6b18bb5569$var$serializeCompletedMultipartUpload(input.MultipartUpload)
                        }
                    ];
            }
        });
    });
};
var $96de8c6b18bb5569$var$serializeCompletedMultipartUpload = function(input) {
    var _a;
    if (!((_a = input.Parts) === null || _a === void 0 ? void 0 : _a.length)) throw new Error("".concat($96de8c6b18bb5569$var$INVALID_PARAMETER_ERROR_MSG, ": ").concat(input));
    return '<CompleteMultipartUpload xmlns="http://s3.amazonaws.com/doc/2006-03-01/">'.concat(input.Parts.map($96de8c6b18bb5569$var$serializeCompletedPartList).join(""), "</CompleteMultipartUpload>");
};
var $96de8c6b18bb5569$var$serializeCompletedPartList = function(input) {
    if (!input.ETag || input.PartNumber == null) throw new Error("".concat($96de8c6b18bb5569$var$INVALID_PARAMETER_ERROR_MSG, ": ").concat(input));
    return "<Part><ETag>".concat(input.ETag, "</ETag><PartNumber>").concat(input.PartNumber, "</PartNumber></Part>");
};
/**
 * Parse CompleteMultipartUpload API response payload, which may be empty or error indicating internal
 * server error, even when the status code is 200.
 *
 * Ref: https://docs.aws.amazon.com/AmazonS3/latest/API/API_CompleteMultipartUpload.html#API_CompleteMultipartUpload_Example_4
 */ var $96de8c6b18bb5569$var$parseXmlBodyOrThrow = function(response) {
    return $96de8c6b18bb5569$var$__awaiter(void 0, void 0, void 0, function() {
        var parsed, error;
        return $96de8c6b18bb5569$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, $9229af72cd043253$export$9f31af2cd814b6c7)(response)
                    ];
                case 1:
                    parsed = _a.sent();
                    if (!(parsed.Code !== undefined && parsed.Message !== undefined)) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $9229af72cd043253$export$a02c37c2d0ab7154)($96de8c6b18bb5569$var$__assign($96de8c6b18bb5569$var$__assign({}, response), {
                            statusCode: 500
                        }))
                    ];
                case 2:
                    error = _a.sent();
                    error.$metadata.httpStatusCode = response.statusCode;
                    throw error;
                case 3:
                    return [
                        2 /*return*/ ,
                        parsed
                    ];
            }
        });
    });
};
var $96de8c6b18bb5569$var$completeMultipartUploadDeserializer = function(response) {
    return $96de8c6b18bb5569$var$__awaiter(void 0, void 0, void 0, function() {
        var error, parsed, contents;
        return $96de8c6b18bb5569$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $9229af72cd043253$export$a02c37c2d0ab7154)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        $96de8c6b18bb5569$var$parseXmlBodyOrThrow(response)
                    ];
                case 3:
                    parsed = _a.sent();
                    contents = (0, $85992c38f9265346$export$871de8747c9eaa88)(parsed, {
                        ETag: "ETag",
                        Key: "Key",
                        Location: "Location"
                    });
                    return [
                        2 /*return*/ ,
                        $96de8c6b18bb5569$var$__assign({
                            $metadata: (0, $fe0ec52dee712a0c$export$978f9418fe0cb26c)(response)
                        }, contents)
                    ];
            }
        });
    });
};
// CompleteMultiPartUpload API returns 200 status code with empty body or error message.
// This indicates internal server error after the response has been sent to the client.
// Ref: https://docs.aws.amazon.com/AmazonS3/latest/API/API_CompleteMultipartUpload.html#API_CompleteMultipartUpload_Example_4
var $96de8c6b18bb5569$var$retryWhenErrorWith200StatusCode = function(response, error) {
    return $96de8c6b18bb5569$var$__awaiter(void 0, void 0, void 0, function() {
        var parsed, defaultRetryDecider;
        return $96de8c6b18bb5569$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode === 200)) return [
                        3 /*break*/ ,
                        2
                    ];
                    if (!response.body) return [
                        2 /*return*/ ,
                        true
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $9229af72cd043253$export$9f31af2cd814b6c7)(response)
                    ];
                case 1:
                    parsed = _a.sent();
                    if (parsed.Code !== undefined && parsed.Message !== undefined) return [
                        2 /*return*/ ,
                        true
                    ];
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 2:
                    defaultRetryDecider = (0, $04efb6a586095162$export$f84bd70098573c5c).retryDecider;
                    return [
                        2 /*return*/ ,
                        defaultRetryDecider(response, error)
                    ];
            }
        });
    });
};
var $96de8c6b18bb5569$export$43db64f5934888f1 = (0, $ed795cf51f5bd210$export$880429a8ae983d4d)((0, $a4b89fe9cb1a5395$export$387dd765fee16c05), $96de8c6b18bb5569$var$completeMultipartUploadSerializer, $96de8c6b18bb5569$var$completeMultipartUploadDeserializer, $96de8c6b18bb5569$var$__assign($96de8c6b18bb5569$var$__assign({}, (0, $04efb6a586095162$export$f84bd70098573c5c)), {
    responseType: "text",
    retryDecider: $96de8c6b18bb5569$var$retryWhenErrorWith200StatusCode
}));

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




var $d50063015f6c15c8$var$__assign = undefined && undefined.__assign || function() {
    $d50063015f6c15c8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d50063015f6c15c8$var$__assign.apply(this, arguments);
};
var $d50063015f6c15c8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d50063015f6c15c8$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $d50063015f6c15c8$var$createMultipartUploadSerializer = function(input, endpoint) {
    return $d50063015f6c15c8$var$__awaiter(void 0, void 0, void 0, function() {
        var headers, url;
        return $d50063015f6c15c8$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, $854326972c2cbcdb$export$2707645b554c9055)(input)
                    ];
                case 1:
                    headers = _a.sent();
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, $854326972c2cbcdb$export$5af35979a44e17e4)(url, input.Key);
                    url.search = "uploads";
                    return [
                        2 /*return*/ ,
                        {
                            method: "POST",
                            headers: headers,
                            url: url
                        }
                    ];
            }
        });
    });
};
var $d50063015f6c15c8$var$createMultipartUploadDeserializer = function(response) {
    return $d50063015f6c15c8$var$__awaiter(void 0, void 0, void 0, function() {
        var error, parsed, contents;
        return $d50063015f6c15c8$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $9229af72cd043253$export$a02c37c2d0ab7154)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, $9229af72cd043253$export$9f31af2cd814b6c7)(response)
                    ];
                case 3:
                    parsed = _a.sent();
                    contents = (0, $85992c38f9265346$export$871de8747c9eaa88)(parsed, {
                        UploadId: "UploadId"
                    });
                    return [
                        2 /*return*/ ,
                        $d50063015f6c15c8$var$__assign({
                            $metadata: (0, $fe0ec52dee712a0c$export$978f9418fe0cb26c)(response)
                        }, contents)
                    ];
            }
        });
    });
};
var $d50063015f6c15c8$export$42c43843cc7f452b = (0, $ed795cf51f5bd210$export$880429a8ae983d4d)((0, $a4b89fe9cb1a5395$export$387dd765fee16c05), $d50063015f6c15c8$var$createMultipartUploadSerializer, $d50063015f6c15c8$var$createMultipartUploadDeserializer, $d50063015f6c15c8$var$__assign($d50063015f6c15c8$var$__assign({}, (0, $04efb6a586095162$export$f84bd70098573c5c)), {
    responseType: "text"
}));

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




var $5f7d1e82f6657e9c$var$__assign = undefined && undefined.__assign || function() {
    $5f7d1e82f6657e9c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5f7d1e82f6657e9c$var$__assign.apply(this, arguments);
};
var $5f7d1e82f6657e9c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5f7d1e82f6657e9c$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $5f7d1e82f6657e9c$var$listPartsSerializer = function(input, endpoint) {
    return $5f7d1e82f6657e9c$var$__awaiter(void 0, void 0, void 0, function() {
        var headers, url;
        return $5f7d1e82f6657e9c$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, $854326972c2cbcdb$export$63c8eae6d43cbe48)(input)
                    ];
                case 1:
                    headers = _a.sent();
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, $854326972c2cbcdb$export$5af35979a44e17e4)(url, input.Key);
                    url.search = new URLSearchParams({
                        uploadId: input.UploadId
                    }).toString();
                    return [
                        2 /*return*/ ,
                        {
                            method: "GET",
                            headers: headers,
                            url: url
                        }
                    ];
            }
        });
    });
};
var $5f7d1e82f6657e9c$var$listPartsDeserializer = function(response) {
    return $5f7d1e82f6657e9c$var$__awaiter(void 0, void 0, void 0, function() {
        var error, parsed, contents;
        return $5f7d1e82f6657e9c$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $9229af72cd043253$export$a02c37c2d0ab7154)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, $9229af72cd043253$export$9f31af2cd814b6c7)(response)
                    ];
                case 3:
                    parsed = _a.sent();
                    contents = (0, $85992c38f9265346$export$871de8747c9eaa88)(parsed, {
                        UploadId: "UploadId",
                        Parts: [
                            "Part",
                            function(value) {
                                return (0, $85992c38f9265346$export$e9d411a739f8e6c1)(value, $5f7d1e82f6657e9c$var$deserializeCompletedPartList);
                            }
                        ]
                    });
                    return [
                        2 /*return*/ ,
                        $5f7d1e82f6657e9c$var$__assign({
                            $metadata: (0, $fe0ec52dee712a0c$export$978f9418fe0cb26c)(response)
                        }, contents)
                    ];
            }
        });
    });
};
var $5f7d1e82f6657e9c$var$deserializeCompletedPartList = function(input) {
    return input.map(function(item) {
        return (0, $85992c38f9265346$export$871de8747c9eaa88)(item, {
            PartNumber: [
                "PartNumber",
                (0, $85992c38f9265346$export$c1eb6da0da8d0d20)
            ],
            ETag: "ETag",
            Size: [
                "Size",
                (0, $85992c38f9265346$export$c1eb6da0da8d0d20)
            ]
        });
    });
};
var $5f7d1e82f6657e9c$export$3d31e3cd776cc9fe = (0, $ed795cf51f5bd210$export$880429a8ae983d4d)((0, $a4b89fe9cb1a5395$export$387dd765fee16c05), $5f7d1e82f6657e9c$var$listPartsSerializer, $5f7d1e82f6657e9c$var$listPartsDeserializer, $5f7d1e82f6657e9c$var$__assign($5f7d1e82f6657e9c$var$__assign({}, (0, $04efb6a586095162$export$f84bd70098573c5c)), {
    responseType: "text"
}));

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




var $9c02752db03d8d75$var$__assign = undefined && undefined.__assign || function() {
    $9c02752db03d8d75$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9c02752db03d8d75$var$__assign.apply(this, arguments);
};
var $9c02752db03d8d75$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9c02752db03d8d75$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $9c02752db03d8d75$var$putObjectSerializer = function(input, endpoint) {
    return $9c02752db03d8d75$var$__awaiter(void 0, void 0, void 0, function() {
        var headers, _a, url;
        var _b;
        return $9c02752db03d8d75$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $854326972c2cbcdb$export$2707645b554c9055)($9c02752db03d8d75$var$__assign($9c02752db03d8d75$var$__assign({}, input), {
                            ContentType: (_b = input.ContentType) !== null && _b !== void 0 ? _b : "application/octet-stream"
                        }))
                    ];
                case 1:
                    headers = $9c02752db03d8d75$var$__assign.apply(void 0, [
                        $9c02752db03d8d75$var$__assign.apply(void 0, _a.concat([
                            _c.sent()
                        ])),
                        (0, $854326972c2cbcdb$export$e17cc407388b3e89)({
                            "content-md5": input.ContentMD5
                        })
                    ]);
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, $854326972c2cbcdb$export$5af35979a44e17e4)(url, input.Key);
                    return [
                        2 /*return*/ ,
                        {
                            method: "PUT",
                            headers: headers,
                            url: url,
                            body: input.Body
                        }
                    ];
            }
        });
    });
};
var $9c02752db03d8d75$var$putObjectDeserializer = function(response) {
    return $9c02752db03d8d75$var$__awaiter(void 0, void 0, void 0, function() {
        var error;
        return $9c02752db03d8d75$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $9229af72cd043253$export$a02c37c2d0ab7154)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        2 /*return*/ ,
                        $9c02752db03d8d75$var$__assign($9c02752db03d8d75$var$__assign({}, (0, $85992c38f9265346$export$871de8747c9eaa88)(response.headers, {
                            ETag: "etag",
                            VersionId: "x-amz-version-id"
                        })), {
                            $metadata: (0, $fe0ec52dee712a0c$export$978f9418fe0cb26c)(response)
                        })
                    ];
            }
        });
    });
};
var $9c02752db03d8d75$export$f075753308a3c31a = (0, $ed795cf51f5bd210$export$880429a8ae983d4d)((0, $a4b89fe9cb1a5395$export$387dd765fee16c05), $9c02752db03d8d75$var$putObjectSerializer, $9c02752db03d8d75$var$putObjectDeserializer, $9c02752db03d8d75$var$__assign($9c02752db03d8d75$var$__assign({}, (0, $04efb6a586095162$export$f84bd70098573c5c)), {
    responseType: "text"
}));

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




var $4bc08a478a76f23c$var$__assign = undefined && undefined.__assign || function() {
    $4bc08a478a76f23c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4bc08a478a76f23c$var$__assign.apply(this, arguments);
};
var $4bc08a478a76f23c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4bc08a478a76f23c$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $4bc08a478a76f23c$var$uploadPartSerializer = function(input, endpoint) {
    return $4bc08a478a76f23c$var$__awaiter(void 0, void 0, void 0, function() {
        var headers, _a, url;
        return $4bc08a478a76f23c$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $854326972c2cbcdb$export$63c8eae6d43cbe48)(input)
                    ];
                case 1:
                    headers = $4bc08a478a76f23c$var$__assign.apply(void 0, [
                        $4bc08a478a76f23c$var$__assign.apply(void 0, _a.concat([
                            _b.sent()
                        ])),
                        (0, $854326972c2cbcdb$export$e17cc407388b3e89)({
                            "content-md5": input.ContentMD5
                        })
                    ]);
                    headers["content-type"] = "application/octet-stream";
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, $854326972c2cbcdb$export$5af35979a44e17e4)(url, input.Key);
                    url.search = new URLSearchParams({
                        partNumber: input.PartNumber + "",
                        uploadId: input.UploadId
                    }).toString();
                    return [
                        2 /*return*/ ,
                        {
                            method: "PUT",
                            headers: headers,
                            url: url,
                            body: input.Body
                        }
                    ];
            }
        });
    });
};
var $4bc08a478a76f23c$var$uploadPartDeserializer = function(response) {
    return $4bc08a478a76f23c$var$__awaiter(void 0, void 0, void 0, function() {
        var error;
        return $4bc08a478a76f23c$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $9229af72cd043253$export$a02c37c2d0ab7154)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        2 /*return*/ ,
                        $4bc08a478a76f23c$var$__assign($4bc08a478a76f23c$var$__assign({}, (0, $85992c38f9265346$export$871de8747c9eaa88)(response.headers, {
                            ETag: "etag"
                        })), {
                            $metadata: (0, $fe0ec52dee712a0c$export$978f9418fe0cb26c)(response)
                        })
                    ];
            }
        });
    });
};
var $4bc08a478a76f23c$export$a841ecc3dcaeabc6 = (0, $ed795cf51f5bd210$export$880429a8ae983d4d)((0, $a4b89fe9cb1a5395$export$387dd765fee16c05), $4bc08a478a76f23c$var$uploadPartSerializer, $4bc08a478a76f23c$var$uploadPartDeserializer, $4bc08a478a76f23c$var$__assign($4bc08a478a76f23c$var$__assign({}, (0, $04efb6a586095162$export$f84bd70098573c5c)), {
    responseType: "text"
}));



var $b5680518dd48c196$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $b5680518dd48c196$var$R = typeof Reflect === "object" ? Reflect : null;
var $b5680518dd48c196$var$ReflectApply = $b5680518dd48c196$var$R && typeof $b5680518dd48c196$var$R.apply === "function" ? $b5680518dd48c196$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $b5680518dd48c196$var$ReflectOwnKeys;
if ($b5680518dd48c196$var$R && typeof $b5680518dd48c196$var$R.ownKeys === "function") $b5680518dd48c196$var$ReflectOwnKeys = $b5680518dd48c196$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $b5680518dd48c196$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $b5680518dd48c196$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $b5680518dd48c196$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $b5680518dd48c196$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $b5680518dd48c196$var$EventEmitter() {
    $b5680518dd48c196$var$EventEmitter.init.call(this);
}
$b5680518dd48c196$exports = $b5680518dd48c196$var$EventEmitter;
$b5680518dd48c196$exports.once = $b5680518dd48c196$var$once;
// Backwards-compat with node 0.10.x
$b5680518dd48c196$var$EventEmitter.EventEmitter = $b5680518dd48c196$var$EventEmitter;
$b5680518dd48c196$var$EventEmitter.prototype._events = undefined;
$b5680518dd48c196$var$EventEmitter.prototype._eventsCount = 0;
$b5680518dd48c196$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $b5680518dd48c196$var$defaultMaxListeners = 10;
function $b5680518dd48c196$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($b5680518dd48c196$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $b5680518dd48c196$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $b5680518dd48c196$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $b5680518dd48c196$var$defaultMaxListeners = arg;
    }
});
$b5680518dd48c196$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$b5680518dd48c196$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $b5680518dd48c196$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $b5680518dd48c196$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $b5680518dd48c196$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$b5680518dd48c196$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $b5680518dd48c196$var$_getMaxListeners(this);
};
$b5680518dd48c196$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $b5680518dd48c196$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $b5680518dd48c196$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$b5680518dd48c196$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $b5680518dd48c196$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $b5680518dd48c196$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $b5680518dd48c196$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $b5680518dd48c196$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$b5680518dd48c196$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $b5680518dd48c196$var$_addListener(this, type, listener, false);
};
$b5680518dd48c196$var$EventEmitter.prototype.on = $b5680518dd48c196$var$EventEmitter.prototype.addListener;
$b5680518dd48c196$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $b5680518dd48c196$var$_addListener(this, type, listener, true);
};
function $b5680518dd48c196$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $b5680518dd48c196$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $b5680518dd48c196$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$b5680518dd48c196$var$EventEmitter.prototype.once = function once(type, listener) {
    $b5680518dd48c196$var$checkListener(listener);
    this.on(type, $b5680518dd48c196$var$_onceWrap(this, type, listener));
    return this;
};
$b5680518dd48c196$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $b5680518dd48c196$var$checkListener(listener);
    this.prependListener(type, $b5680518dd48c196$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$b5680518dd48c196$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $b5680518dd48c196$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $b5680518dd48c196$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$b5680518dd48c196$var$EventEmitter.prototype.off = $b5680518dd48c196$var$EventEmitter.prototype.removeListener;
$b5680518dd48c196$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $b5680518dd48c196$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $b5680518dd48c196$var$unwrapListeners(evlistener) : $b5680518dd48c196$var$arrayClone(evlistener, evlistener.length);
}
$b5680518dd48c196$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $b5680518dd48c196$var$_listeners(this, type, true);
};
$b5680518dd48c196$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $b5680518dd48c196$var$_listeners(this, type, false);
};
$b5680518dd48c196$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $b5680518dd48c196$var$listenerCount.call(emitter, type);
};
$b5680518dd48c196$var$EventEmitter.prototype.listenerCount = $b5680518dd48c196$var$listenerCount;
function $b5680518dd48c196$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$b5680518dd48c196$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $b5680518dd48c196$var$ReflectOwnKeys(this._events) : [];
};
function $b5680518dd48c196$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $b5680518dd48c196$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $b5680518dd48c196$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $b5680518dd48c196$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $b5680518dd48c196$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $b5680518dd48c196$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $b5680518dd48c196$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $b5680518dd48c196$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $b5680518dd48c196$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $f71a5760370423e5$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f71a5760370423e5$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $f71a5760370423e5$export$afc2e8fa4a4981d4 = function(content) {
    return $f71a5760370423e5$var$__awaiter(void 0, void 0, void 0, function() {
        var hasher, buffer, digest;
        return $f71a5760370423e5$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    hasher = new (0, $13f69c882036e129$export$9f5a3dfc7a9f5dd)();
                    if (!(typeof content === "string")) return [
                        3 /*break*/ ,
                        1
                    ];
                    hasher.update(content);
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 1:
                    return [
                        4 /*yield*/ ,
                        $f71a5760370423e5$var$readFile(content)
                    ];
                case 2:
                    buffer = _a.sent();
                    hasher.update(buffer);
                    _a.label = 3;
                case 3:
                    return [
                        4 /*yield*/ ,
                        hasher.digest()
                    ];
                case 4:
                    digest = _a.sent();
                    return [
                        2 /*return*/ ,
                        (0, $41fb895557f65b2f$export$37cc283d8fbd3462)(digest)
                    ];
            }
        });
    });
};
var $f71a5760370423e5$var$readFile = function(file) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function() {
            if (reader.result) resolve(reader.result);
            reader.onabort = function() {
                return reject(new Error("Read aborted"));
            };
            reader.onerror = function() {
                return reject(reader.error);
            };
        };
        if (file !== undefined) reader.readAsArrayBuffer(file);
    });
};



var $85e4f82c1067e7e2$var$__assign = undefined && undefined.__assign || function() {
    $85e4f82c1067e7e2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $85e4f82c1067e7e2$var$__assign.apply(this, arguments);
};
var $85e4f82c1067e7e2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $85e4f82c1067e7e2$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $85e4f82c1067e7e2$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("AWSS3ProviderManagedUpload");
var $85e4f82c1067e7e2$export$da75ae8ad0285104 = /** @class */ function() {
    function AWSS3ProviderManagedUpload(params, opts, emitter) {
        this.opts = null;
        this.completedParts = [];
        this.partSize = (0, $7a70ad0ea906f888$export$a2977590b9739b8b);
        // Progress reporting
        this.bytesUploaded = 0;
        this.totalBytesToUpload = 0;
        this.emitter = null;
        this.params = params;
        this.opts = $85e4f82c1067e7e2$var$__assign({
            isObjectLockEnabled: false
        }, opts);
        this.emitter = emitter;
        this.s3Config = (0, $7a70ad0ea906f888$export$fa2cd26183e80a49)($85e4f82c1067e7e2$var$__assign($85e4f82c1067e7e2$var$__assign({}, opts), {
            emitter: emitter,
            storageAction: (0, $58c96d580693cdce$export$d4f3c54b808b00ce).Put
        }));
    }
    AWSS3ProviderManagedUpload.prototype.upload = function() {
        return $85e4f82c1067e7e2$var$__awaiter(this, void 0, void 0, function() {
            var isObjectLockEnabled, _a, _b, _c, _d, _e, numberOfPartsToUpload, parts, start, error_1;
            var _f;
            var _this = this;
            return $85e4f82c1067e7e2$var$__generator(this, function(_g) {
                switch(_g.label){
                    case 0:
                        _g.trys.push([
                            0,
                            12,
                            ,
                            14
                        ]);
                        isObjectLockEnabled = this.opts.isObjectLockEnabled;
                        if (!(isObjectLockEnabled === true)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = this.params;
                        return [
                            4 /*yield*/ ,
                            (0, $f71a5760370423e5$export$afc2e8fa4a4981d4)(// @ts-expect-error currently ReadableStream<any> is not being supported in put api
                            this.params.Body)
                        ];
                    case 1:
                        _a.ContentMD5 = _g.sent();
                        _g.label = 2;
                    case 2:
                        this.body = this.validateAndSanitizeBody(this.params.Body);
                        this.totalBytesToUpload = this.byteLength(this.body);
                        if (!(this.totalBytesToUpload <= (0, $7a70ad0ea906f888$export$a2977590b9739b8b))) return [
                            3 /*break*/ ,
                            4
                        ];
                        // Multipart upload is not required. Upload the sanitized body as is
                        this.params.Body = this.body;
                        _b = (0, $9c02752db03d8d75$export$f075753308a3c31a);
                        _c = [
                            this.s3Config
                        ];
                        _d = [
                            $85e4f82c1067e7e2$var$__assign({}, this.params)
                        ];
                        _f = {};
                        return [
                            4 /*yield*/ ,
                            this.getObjectKeyWithPrefix(this.params.Key)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _b.apply(void 0, _c.concat([
                                $85e4f82c1067e7e2$var$__assign.apply(void 0, _d.concat([
                                    (_f.Key = _g.sent(), _f)
                                ]))
                            ]))
                        ];
                    case 4:
                        // Step 1: Determine appropriate part size.
                        this.partSize = (0, $7a70ad0ea906f888$export$8eb1333248593ec2)(this.totalBytesToUpload);
                        // Step 2: Initiate the multi part upload
                        _e = this;
                        return [
                            4 /*yield*/ ,
                            this.createMultiPartUpload()
                        ];
                    case 5:
                        // Step 2: Initiate the multi part upload
                        _e.uploadId = _g.sent();
                        numberOfPartsToUpload = Math.ceil(this.totalBytesToUpload / this.partSize);
                        parts = this.createParts();
                        start = 0;
                        _g.label = 6;
                    case 6:
                        if (!(start < numberOfPartsToUpload)) return [
                            3 /*break*/ ,
                            9
                        ];
                        // Upload as many as `queueSize` parts simultaneously
                        return [
                            4 /*yield*/ ,
                            this.uploadParts(this.uploadId, parts.slice(start, start + (0, $7a70ad0ea906f888$export$8cef33516f471d13)))
                        ];
                    case 7:
                        // Upload as many as `queueSize` parts simultaneously
                        _g.sent();
                        _g.label = 8;
                    case 8:
                        start += (0, $7a70ad0ea906f888$export$8cef33516f471d13);
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 9:
                        parts.map(function(part) {
                            _this.removeEventListener(part);
                        });
                        return [
                            4 /*yield*/ ,
                            this.finishMultiPartUpload(this.uploadId)
                        ];
                    case 10:
                        // Step 3: Finalize the upload such that S3 can recreate the file
                        return [
                            2 /*return*/ ,
                            _g.sent()
                        ];
                    case 11:
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 12:
                        error_1 = _g.sent();
                        // if any error is thrown, call cleanup
                        return [
                            4 /*yield*/ ,
                            this.cleanup(this.uploadId)
                        ];
                    case 13:
                        // if any error is thrown, call cleanup
                        _g.sent();
                        $85e4f82c1067e7e2$var$logger.error("Error. Cancelling the multipart upload.");
                        throw error_1;
                    case 14:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.createParts = function() {
        try {
            var parts = [];
            for(var bodyStart = 0; bodyStart < this.totalBytesToUpload;){
                var bodyEnd = Math.min(bodyStart + this.partSize, this.totalBytesToUpload);
                parts.push({
                    bodyPart: this.body.slice(bodyStart, bodyEnd),
                    partNumber: parts.length + 1,
                    emitter: new (0, $b5680518dd48c196$exports.EventEmitter)(),
                    _lastUploadedBytes: 0
                });
                bodyStart += this.partSize;
            }
            return parts;
        } catch (error) {
            $85e4f82c1067e7e2$var$logger.error(error);
            throw error;
        }
    };
    AWSS3ProviderManagedUpload.prototype.createMultiPartUpload = function() {
        return $85e4f82c1067e7e2$var$__awaiter(this, void 0, void 0, function() {
            var response, _a, _b, _c, error_2;
            var _d;
            return $85e4f82c1067e7e2$var$__generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _e.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        _a = (0, $d50063015f6c15c8$export$42c43843cc7f452b);
                        _b = [
                            this.s3Config
                        ];
                        _c = [
                            $85e4f82c1067e7e2$var$__assign({}, this.params)
                        ];
                        _d = {};
                        return [
                            4 /*yield*/ ,
                            this.getObjectKeyWithPrefix(this.params.Key)
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, _b.concat([
                                $85e4f82c1067e7e2$var$__assign.apply(void 0, _c.concat([
                                    (_d.Key = _e.sent(), _d)
                                ]))
                            ]))
                        ];
                    case 2:
                        response = _e.sent();
                        $85e4f82c1067e7e2$var$logger.debug(response.UploadId);
                        return [
                            2 /*return*/ ,
                            response.UploadId
                        ];
                    case 3:
                        error_2 = _e.sent();
                        $85e4f82c1067e7e2$var$logger.error(error_2);
                        throw error_2;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * @private Not to be extended outside of tests
     * @VisibleFotTesting
     */ AWSS3ProviderManagedUpload.prototype.uploadParts = function(uploadId, parts) {
        return $85e4f82c1067e7e2$var$__awaiter(this, void 0, void 0, function() {
            var allResults, i, error_3;
            var _this = this;
            return $85e4f82c1067e7e2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            Promise.all(parts.map(function(part) {
                                return $85e4f82c1067e7e2$var$__awaiter(_this, void 0, void 0, function() {
                                    var isObjectLockEnabled, _a, _b, Key, Bucket, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, ContentMD5, res, _c, _d;
                                    var _e;
                                    return $85e4f82c1067e7e2$var$__generator(this, function(_f) {
                                        switch(_f.label){
                                            case 0:
                                                this.setupEventListener(part);
                                                isObjectLockEnabled = this.opts.isObjectLockEnabled;
                                                if (!isObjectLockEnabled) return [
                                                    3 /*break*/ ,
                                                    2
                                                ];
                                                _a = this.params;
                                                return [
                                                    4 /*yield*/ ,
                                                    (0, $f71a5760370423e5$export$afc2e8fa4a4981d4)(part.bodyPart)
                                                ];
                                            case 1:
                                                _a.ContentMD5 = _f.sent();
                                                _f.label = 2;
                                            case 2:
                                                _b = this.params, Key = _b.Key, Bucket = _b.Bucket, SSECustomerAlgorithm = _b.SSECustomerAlgorithm, SSECustomerKey = _b.SSECustomerKey, SSECustomerKeyMD5 = _b.SSECustomerKeyMD5, ContentMD5 = _b.ContentMD5;
                                                _c = (0, $4bc08a478a76f23c$export$a841ecc3dcaeabc6);
                                                _d = [
                                                    $85e4f82c1067e7e2$var$__assign($85e4f82c1067e7e2$var$__assign({}, this.s3Config), {
                                                        emitter: part.emitter
                                                    })
                                                ];
                                                _e = {
                                                    PartNumber: part.partNumber,
                                                    Body: part.bodyPart,
                                                    UploadId: uploadId
                                                };
                                                return [
                                                    4 /*yield*/ ,
                                                    this.getObjectKeyWithPrefix(this.params.Key)
                                                ];
                                            case 3:
                                                return [
                                                    4 /*yield*/ ,
                                                    _c.apply(void 0, _d.concat([
                                                        (_e.Key = _f.sent(), _e.Bucket = Bucket, _e.SSECustomerAlgorithm = SSECustomerAlgorithm, _e.SSECustomerKey = SSECustomerKey, _e.SSECustomerKeyMD5 = SSECustomerKeyMD5, _e.ContentMD5 = ContentMD5, _e)
                                                    ]))
                                                ];
                                            case 4:
                                                res = _f.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    res
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 1:
                        allResults = _a.sent();
                        // The order of resolved promises is the same as input promise order.
                        for(i = 0; i < allResults.length; i++)this.completedParts.push({
                            PartNumber: parts[i].partNumber,
                            ETag: allResults[i].ETag
                        });
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_3 = _a.sent();
                        $85e4f82c1067e7e2$var$logger.error("Error happened while uploading a part. Cancelling the multipart upload");
                        throw error_3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.finishMultiPartUpload = function(uploadId) {
        return $85e4f82c1067e7e2$var$__awaiter(this, void 0, void 0, function() {
            var input, Key, error_4;
            var _a;
            return $85e4f82c1067e7e2$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = {
                            Bucket: this.params.Bucket
                        };
                        return [
                            4 /*yield*/ ,
                            this.getObjectKeyWithPrefix(this.params.Key)
                        ];
                    case 1:
                        input = (_a.Key = _b.sent(), _a.UploadId = uploadId, _a.MultipartUpload = {
                            Parts: this.completedParts
                        }, _a);
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, $96de8c6b18bb5569$export$43db64f5934888f1)(this.s3Config, input)
                        ];
                    case 3:
                        Key = _b.sent().Key;
                        return [
                            2 /*return*/ ,
                            Key
                        ];
                    case 4:
                        error_4 = _b.sent();
                        $85e4f82c1067e7e2$var$logger.error("Error happened while finishing the upload.");
                        throw error_4;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.cleanup = function(uploadId) {
        return $85e4f82c1067e7e2$var$__awaiter(this, void 0, void 0, function() {
            var input, data;
            var _a;
            return $85e4f82c1067e7e2$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        // Reset this's state
                        this.body = null;
                        this.completedParts = [];
                        this.bytesUploaded = 0;
                        this.totalBytesToUpload = 0;
                        if (!uploadId) // This is a single part upload;
                        return [
                            2 /*return*/ 
                        ];
                        _a = {
                            Bucket: this.params.Bucket
                        };
                        return [
                            4 /*yield*/ ,
                            this.getObjectKeyWithPrefix(this.params.Key)
                        ];
                    case 1:
                        input = (_a.Key = _b.sent(), _a.UploadId = uploadId, _a);
                        return [
                            4 /*yield*/ ,
                            (0, $ee31fa3eb3f6493c$export$45ae37477c36d1d3)(this.s3Config, input)
                        ];
                    case 2:
                        _b.sent();
                        return [
                            4 /*yield*/ ,
                            (0, $5f7d1e82f6657e9c$export$3d31e3cd776cc9fe)(this.s3Config, input)
                        ];
                    case 3:
                        data = _b.sent();
                        if (data && data.Parts && data.Parts.length > 0) throw new Error("Multipart upload clean up failed.");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.removeEventListener = function(part) {
        part.emitter.removeAllListeners((0, $3b18d274fcc1679a$export$c5e6923933be22a0));
        part.emitter.removeAllListeners((0, $3b18d274fcc1679a$export$660a92f3322ba11a));
    };
    AWSS3ProviderManagedUpload.prototype.setupEventListener = function(part) {
        var _this = this;
        part.emitter.on((0, $3b18d274fcc1679a$export$c5e6923933be22a0), function(progress) {
            _this.progressChanged(part.partNumber, progress.loaded - part._lastUploadedBytes);
            part._lastUploadedBytes = progress.loaded;
        });
    };
    AWSS3ProviderManagedUpload.prototype.progressChanged = function(partNumber, incrementalUpdate) {
        this.bytesUploaded += incrementalUpdate;
        this.emitter.emit((0, $3b18d274fcc1679a$export$c5e6923933be22a0), {
            loaded: this.bytesUploaded,
            total: this.totalBytesToUpload,
            part: partNumber,
            key: this.params.Key
        });
    };
    AWSS3ProviderManagedUpload.prototype.byteLength = function(input) {
        if (input === null || input === undefined) return 0;
        if (typeof input.byteLength === "number") return input.byteLength;
        else if (typeof input.length === "number") return input.length;
        else if (typeof input.size === "number") return input.size;
        else if (typeof input.path === "string") ;
        else throw new Error("Cannot determine length of " + input);
    };
    AWSS3ProviderManagedUpload.prototype.validateAndSanitizeBody = function(body) {
        var sanitizedBody = this.isGenericObject(body) ? JSON.stringify(body) : body;
        /* TODO: streams and files for nodejs
        if (
            typeof body.path === 'string' &&
            require('fs').lstatSync(body.path).size > 0
        ) {
            sanitizedBody = body;
        } */ if (this.byteLength(sanitizedBody) > (0, $7a70ad0ea906f888$export$644fd66ce6bffe3)) throw new Error("File size bigger than S3 Object limit of 5TB, got ".concat(this.totalBytesToUpload, " Bytes"));
        return sanitizedBody;
    };
    AWSS3ProviderManagedUpload.prototype.isGenericObject = function(body) {
        if (body !== null && typeof body === "object") try {
            return !(this.byteLength(body) >= 0);
        } catch (error) {
            // If we cannot determine the length of the body, consider it
            // as a generic object and upload a stringified version of it
            return true;
        }
        return false;
    };
    AWSS3ProviderManagedUpload.prototype.getObjectKeyWithPrefix = function(keyWithoutPrefix) {
        return $85e4f82c1067e7e2$var$__awaiter(this, void 0, void 0, function() {
            var _a, _b;
            var _c;
            return $85e4f82c1067e7e2$var$__generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _a = (0, $7a70ad0ea906f888$export$36e24695f02d4503);
                        _b = [
                            $85e4f82c1067e7e2$var$__assign({}, this.opts)
                        ];
                        _c = {};
                        return [
                            4 /*yield*/ ,
                            (0, $7a70ad0ea906f888$export$ae4c744fb23e6d32)()
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, [
                                $85e4f82c1067e7e2$var$__assign.apply(void 0, _b.concat([
                                    (_c.credentials = _d.sent(), _c)
                                ]))
                            ])
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _d.sent() + keyWithoutPrefix
                        ];
                }
            });
        });
    };
    return AWSS3ProviderManagedUpload;
}();








var $709f745b4b985ee8$var$__assign = undefined && undefined.__assign || function() {
    $709f745b4b985ee8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $709f745b4b985ee8$var$__assign.apply(this, arguments);
};
var $709f745b4b985ee8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $709f745b4b985ee8$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $709f745b4b985ee8$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $709f745b4b985ee8$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $709f745b4b985ee8$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("AWSS3UploadTask");
var $709f745b4b985ee8$export$badc82e7c9337824;
(function(AWSS3UploadTaskState) {
    AWSS3UploadTaskState[AWSS3UploadTaskState["INIT"] = 0] = "INIT";
    AWSS3UploadTaskState[AWSS3UploadTaskState["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    AWSS3UploadTaskState[AWSS3UploadTaskState["PAUSED"] = 2] = "PAUSED";
    AWSS3UploadTaskState[AWSS3UploadTaskState["CANCELLED"] = 3] = "CANCELLED";
    AWSS3UploadTaskState[AWSS3UploadTaskState["COMPLETED"] = 4] = "COMPLETED";
})($709f745b4b985ee8$export$badc82e7c9337824 || ($709f745b4b985ee8$export$badc82e7c9337824 = {}));
var $709f745b4b985ee8$export$1c9379601995aced;
(function(TaskEvents) {
    TaskEvents["CANCEL"] = "cancel";
    TaskEvents["UPLOAD_COMPLETE"] = "uploadComplete";
    TaskEvents["UPLOAD_PROGRESS"] = "uploadPartProgress";
    TaskEvents["ERROR"] = "error";
})($709f745b4b985ee8$export$1c9379601995aced || ($709f745b4b985ee8$export$1c9379601995aced = {}));
function $709f745b4b985ee8$var$comparePartNumber(a, b) {
    return a.PartNumber - b.PartNumber;
}
var $709f745b4b985ee8$export$ca4ab80441206528 = /** @class */ function() {
    function AWSS3UploadTask(_a) {
        var s3Config = _a.s3Config, file = _a.file, emitter = _a.emitter, storage = _a.storage, params = _a.params, level = _a.level, prefixPromise = _a.prefixPromise;
        this.queueSize = (0, $7a70ad0ea906f888$export$8cef33516f471d13);
        this.partSize = (0, $7a70ad0ea906f888$export$a2977590b9739b8b);
        this.inProgress = [];
        this.completedParts = [];
        this.queued = [];
        this.bytesUploaded = 0;
        this.totalBytes = 0;
        this.state = $709f745b4b985ee8$export$badc82e7c9337824.INIT;
        this.prefixPromise = prefixPromise;
        this.s3Config = s3Config;
        this.storage = storage;
        this.storageSync = Promise.resolve();
        if (typeof this.storage["sync"] === "function") this.storageSync = this.storage["sync"]();
        this.params = params;
        this.file = file;
        this.totalBytes = this.file.size;
        this.bytesUploaded = 0;
        this.emitter = emitter;
        this.queued = [];
        this.fileId = this._getFileId(level);
        this._validateParams();
        // event emitter will re-throw an error if an event emits an error unless there's a listener, attaching a no-op
        // function to it unless user adds their own onError callback
        this.emitter.on($709f745b4b985ee8$export$1c9379601995aced.ERROR, function() {});
    }
    Object.defineProperty(AWSS3UploadTask.prototype, "percent", {
        get: function() {
            return this.bytesUploaded / this.totalBytes * 100;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AWSS3UploadTask.prototype, "isInProgress", {
        get: function() {
            return this.state === $709f745b4b985ee8$export$badc82e7c9337824.IN_PROGRESS;
        },
        enumerable: false,
        configurable: true
    });
    AWSS3UploadTask.prototype._listSingleFile = function(_a) {
        var key = _a.key, bucket = _a.bucket;
        return $709f745b4b985ee8$var$__awaiter(this, void 0, void 0, function() {
            var objectKeyPrefix, _b, Contents, obj;
            return $709f745b4b985ee8$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 1:
                        objectKeyPrefix = _c.sent();
                        return [
                            4 /*yield*/ ,
                            (0, $6060c9199bed7416$export$d00eea31b34c3abb)(this.s3Config, {
                                Bucket: bucket,
                                Prefix: objectKeyPrefix + key
                            })
                        ];
                    case 2:
                        _b = _c.sent().Contents, Contents = _b === void 0 ? [] : _b;
                        obj = Contents.find(function(o) {
                            return o.Key === "".concat(objectKeyPrefix).concat(key);
                        });
                        return [
                            2 /*return*/ ,
                            obj
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._getFileId = function(level) {
        // We should check if it's a File first because File is also instance of a Blob
        if ((0, $79809e69590d40e0$export$be78b3111c50efdd)(this.file)) return [
            this.file.name,
            this.file.lastModified,
            this.file.size,
            this.file.type,
            this.params.Bucket,
            level,
            this.params.Key
        ].join("-");
        else return [
            this.file.size,
            this.file.type,
            this.params.Bucket,
            level,
            this.params.Key
        ].join("-");
    };
    AWSS3UploadTask.prototype._findCachedUploadParts = function() {
        return $709f745b4b985ee8$var$__awaiter(this, void 0, void 0, function() {
            var uploadRequests, cachedUploadFileData, _a, Parts, _b, _c;
            var _d;
            return $709f745b4b985ee8$var$__generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        uploadRequests = _e.sent();
                        if (Object.keys(uploadRequests).length === 0 || !Object.prototype.hasOwnProperty.call(uploadRequests, this.fileId)) return [
                            2 /*return*/ ,
                            {
                                parts: [],
                                uploadId: null
                            }
                        ];
                        cachedUploadFileData = uploadRequests[this.fileId];
                        cachedUploadFileData.lastTouched = Date.now();
                        this.storage.setItem((0, $9c583fdc61a644a5$export$b9acc545d1bd0170), JSON.stringify(uploadRequests));
                        _b = (0, $5f7d1e82f6657e9c$export$3d31e3cd776cc9fe);
                        _c = [
                            this.s3Config
                        ];
                        _d = {
                            Bucket: this.params.Bucket
                        };
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            _b.apply(void 0, _c.concat([
                                (_d.Key = _e.sent() + this.params.Key, _d.UploadId = cachedUploadFileData.uploadId, _d)
                            ]))
                        ];
                    case 3:
                        _a = _e.sent().Parts, Parts = _a === void 0 ? [] : _a;
                        return [
                            2 /*return*/ ,
                            {
                                parts: Parts,
                                uploadId: cachedUploadFileData.uploadId
                            }
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._emitEvent = function(event, payload) {
        this.emitter.emit(event, payload);
    };
    AWSS3UploadTask.prototype._validateParams = function() {
        if (this.totalBytes > (0, $7a70ad0ea906f888$export$644fd66ce6bffe3)) throw new Error("File size bigger than S3 Object limit of 5TB, got ".concat(this.totalBytes, " Bytes"));
    };
    AWSS3UploadTask.prototype._listCachedUploadTasks = function() {
        return $709f745b4b985ee8$var$__awaiter(this, void 0, void 0, function() {
            var tasks;
            return $709f745b4b985ee8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.storageSync
                        ];
                    case 1:
                        _a.sent();
                        tasks = this.storage.getItem((0, $9c583fdc61a644a5$export$b9acc545d1bd0170)) || "{}";
                        return [
                            2 /*return*/ ,
                            JSON.parse(tasks)
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._cache = function(fileMetadata) {
        return $709f745b4b985ee8$var$__awaiter(this, void 0, void 0, function() {
            var uploadRequests;
            return $709f745b4b985ee8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        uploadRequests = _a.sent();
                        uploadRequests[this.fileId] = fileMetadata;
                        this.storage.setItem((0, $9c583fdc61a644a5$export$b9acc545d1bd0170), JSON.stringify(uploadRequests));
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._isCached = function() {
        return $709f745b4b985ee8$var$__awaiter(this, void 0, void 0, function() {
            var _a, _b;
            return $709f745b4b985ee8$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _b = (_a = Object.prototype.hasOwnProperty).call;
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _b.apply(_a, [
                                _c.sent(),
                                this.fileId
                            ])
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._removeFromCache = function() {
        return $709f745b4b985ee8$var$__awaiter(this, void 0, void 0, function() {
            var uploadRequests;
            return $709f745b4b985ee8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        uploadRequests = _a.sent();
                        delete uploadRequests[this.fileId];
                        this.storage.setItem((0, $9c583fdc61a644a5$export$b9acc545d1bd0170), JSON.stringify(uploadRequests));
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._onPartUploadCompletion = function(_a) {
        var eTag = _a.eTag, partNumber = _a.partNumber, chunk = _a.chunk;
        return $709f745b4b985ee8$var$__awaiter(this, void 0, void 0, function() {
            return $709f745b4b985ee8$var$__generator(this, function(_b) {
                this.completedParts.push({
                    ETag: eTag,
                    PartNumber: partNumber
                });
                this.bytesUploaded += (0, $79809e69590d40e0$export$a48f0734ac7c2329)(chunk);
                this._emitEvent($709f745b4b985ee8$export$1c9379601995aced.UPLOAD_PROGRESS, {
                    loaded: this.bytesUploaded,
                    total: this.totalBytes
                });
                // Remove the completed item from the inProgress array
                this.inProgress = this.inProgress.filter(function(job) {
                    return job.uploadPartInput.PartNumber !== partNumber;
                });
                if (this.queued.length && this.state !== $709f745b4b985ee8$export$badc82e7c9337824.PAUSED) this._startNextPart();
                if (this._isDone()) this._completeUpload();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSS3UploadTask.prototype._completeUpload = function() {
        return $709f745b4b985ee8$var$__awaiter(this, void 0, void 0, function() {
            var _a, _b, err_1;
            var _c;
            return $709f745b4b985ee8$var$__generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _d.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        _a = (0, $96de8c6b18bb5569$export$43db64f5934888f1);
                        _b = [
                            this.s3Config
                        ];
                        _c = {
                            Bucket: this.params.Bucket
                        };
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, _b.concat([
                                (_c.Key = _d.sent() + this.params.Key, _c.UploadId = this.uploadId, _c.MultipartUpload = {
                                    // Parts are not always completed in order, we need to manually sort them
                                    Parts: $709f745b4b985ee8$var$__spreadArray([], $709f745b4b985ee8$var$__read(this.completedParts), false).sort($709f745b4b985ee8$var$comparePartNumber)
                                }, _c)
                            ]))
                        ];
                    case 2:
                        _d.sent();
                        return [
                            4 /*yield*/ ,
                            this._verifyFileSize()
                        ];
                    case 3:
                        _d.sent();
                        this._emitEvent($709f745b4b985ee8$export$1c9379601995aced.UPLOAD_COMPLETE, {
                            key: this.params.Key
                        });
                        this._removeFromCache();
                        this.state = $709f745b4b985ee8$export$badc82e7c9337824.COMPLETED;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        err_1 = _d.sent();
                        $709f745b4b985ee8$var$logger.error("error completing upload", err_1);
                        this._emitEvent($709f745b4b985ee8$export$1c9379601995aced.ERROR, err_1);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._makeUploadPartRequest = function(input, abortSignal) {
        return $709f745b4b985ee8$var$__awaiter(this, void 0, void 0, function() {
            var res, _a, _b, _c, err_2;
            var _d;
            return $709f745b4b985ee8$var$__generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _e.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        _a = (0, $4bc08a478a76f23c$export$a841ecc3dcaeabc6);
                        _b = [
                            $709f745b4b985ee8$var$__assign($709f745b4b985ee8$var$__assign({}, this.s3Config), {
                                abortSignal: abortSignal
                            })
                        ];
                        _c = [
                            $709f745b4b985ee8$var$__assign({}, input)
                        ];
                        _d = {};
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, _b.concat([
                                $709f745b4b985ee8$var$__assign.apply(void 0, _c.concat([
                                    (_d.Key = _e.sent() + this.params.Key, _d)
                                ]))
                            ]))
                        ];
                    case 2:
                        res = _e.sent();
                        return [
                            4 /*yield*/ ,
                            this._onPartUploadCompletion({
                                eTag: res.ETag,
                                partNumber: input.PartNumber,
                                chunk: input.Body
                            })
                        ];
                    case 3:
                        _e.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        err_2 = _e.sent();
                        if (this.state === $709f745b4b985ee8$export$badc82e7c9337824.PAUSED) $709f745b4b985ee8$var$logger.log("upload paused");
                        else if (this.state === $709f745b4b985ee8$export$badc82e7c9337824.CANCELLED) $709f745b4b985ee8$var$logger.log("upload aborted");
                        else $709f745b4b985ee8$var$logger.error("error starting next part of upload: ", err_2);
                        // xhr transfer handlers' cancel will also throw an error, however we don't need to emit an event in that case as it's an
                        // expected behavior
                        if (!(0, $0df55fff21bdf78c$export$a88a1555052550c7)(err_2) && err_2.message !== (0, $3b18d274fcc1679a$export$ff549c429fdaf151)) {
                            this._emitEvent($709f745b4b985ee8$export$1c9379601995aced.ERROR, err_2);
                            this.pause();
                        }
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._startNextPart = function() {
        if (this.queued.length > 0 && this.state !== $709f745b4b985ee8$export$badc82e7c9337824.PAUSED) {
            var abortController = new AbortController();
            var nextPart = this.queued.shift();
            this.inProgress.push({
                uploadPartInput: nextPart,
                s3Request: this._makeUploadPartRequest(nextPart, abortController.signal),
                abortController: abortController
            });
        }
    };
    /**
     * Verify on S3 side that the file size matches the one on the client side.
     *
     * @async
     * @throws throws an error if the file size does not match between local copy of the file and the file on s3.
     */ AWSS3UploadTask.prototype._verifyFileSize = function() {
        return $709f745b4b985ee8$var$__awaiter(this, void 0, void 0, function() {
            var valid, obj, e_1;
            return $709f745b4b985ee8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._listSingleFile({
                                key: this.params.Key,
                                bucket: this.params.Bucket
                            })
                        ];
                    case 1:
                        obj = _a.sent();
                        valid = Boolean(obj && obj.Size === this.file.size);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_1 = _a.sent();
                        $709f745b4b985ee8$var$logger.log("Could not get file on s3 for size matching: ", e_1);
                        // Don't gate verification on auth or other errors
                        // unrelated to file size verification
                        return [
                            2 /*return*/ 
                        ];
                    case 3:
                        if (!valid) throw new Error("File size does not match between local file and file on s3");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._isDone = function() {
        return !this.queued.length && !this.inProgress.length && this.bytesUploaded === this.totalBytes;
    };
    AWSS3UploadTask.prototype._createParts = function() {
        var size = this.file.size;
        var parts = [];
        for(var bodyStart = 0; bodyStart < size;){
            var bodyEnd = Math.min(bodyStart + this.partSize, size);
            parts.push({
                Body: this.file.slice(bodyStart, bodyEnd),
                Key: this.params.Key,
                Bucket: this.params.Bucket,
                PartNumber: parts.length + 1,
                UploadId: this.uploadId
            });
            bodyStart += this.partSize;
        }
        return parts;
    };
    AWSS3UploadTask.prototype._initCachedUploadParts = function(cachedParts) {
        this.bytesUploaded += cachedParts.reduce(function(acc, part) {
            return acc + part.Size;
        }, 0);
        // Find the set of part numbers that have already been uploaded
        var uploadedPartNumSet = new Set(cachedParts.map(function(part) {
            return part.PartNumber;
        }));
        this.queued = this.queued.filter(function(part) {
            return !uploadedPartNumSet.has(part.PartNumber);
        });
        this.completedParts = cachedParts.map(function(part) {
            return {
                PartNumber: part.PartNumber,
                ETag: part.ETag
            };
        });
        this._emitEvent($709f745b4b985ee8$export$1c9379601995aced.UPLOAD_PROGRESS, {
            loaded: this.bytesUploaded,
            total: this.totalBytes
        });
    };
    AWSS3UploadTask.prototype._initMultipartUpload = function() {
        return $709f745b4b985ee8$var$__awaiter(this, void 0, void 0, function() {
            var res, _a, _b, _c;
            var _d;
            return $709f745b4b985ee8$var$__generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = (0, $d50063015f6c15c8$export$42c43843cc7f452b);
                        _b = [
                            this.s3Config
                        ];
                        _c = [
                            $709f745b4b985ee8$var$__assign({}, this.params)
                        ];
                        _d = {};
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, _b.concat([
                                $709f745b4b985ee8$var$__assign.apply(void 0, _c.concat([
                                    (_d.Key = _e.sent() + this.params.Key, _d)
                                ]))
                            ]))
                        ];
                    case 2:
                        res = _e.sent();
                        this._cache({
                            uploadId: res.UploadId,
                            lastTouched: Date.now(),
                            bucket: this.params.Bucket,
                            key: this.params.Key,
                            fileName: this.file instanceof File ? this.file.name : ""
                        });
                        return [
                            2 /*return*/ ,
                            res.UploadId
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._initializeUploadTask = function() {
        return $709f745b4b985ee8$var$__awaiter(this, void 0, void 0, function() {
            var _a, parts, uploadId, uploadId, err_3;
            return $709f745b4b985ee8$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.state = $709f745b4b985ee8$export$badc82e7c9337824.IN_PROGRESS;
                        this.partSize = (0, $7a70ad0ea906f888$export$8eb1333248593ec2)(this.totalBytes);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._isCached()
                        ];
                    case 2:
                        if (!_b.sent()) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this._findCachedUploadParts()
                        ];
                    case 3:
                        _a = _b.sent(), parts = _a.parts, uploadId = _a.uploadId;
                        this.uploadId = uploadId;
                        this.queued = this._createParts();
                        this._initCachedUploadParts(parts);
                        if (this._isDone()) this._completeUpload();
                        else this._startUpload();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        if (!!this.uploadId) return [
                            3 /*break*/ ,
                            6
                        ];
                        return [
                            4 /*yield*/ ,
                            this._initMultipartUpload()
                        ];
                    case 5:
                        uploadId = _b.sent();
                        this.uploadId = uploadId;
                        this.queued = this._createParts();
                        this._startUpload();
                        _b.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        err_3 = _b.sent();
                        if (!(0, $0df55fff21bdf78c$export$a88a1555052550c7)(err_3)) {
                            $709f745b4b985ee8$var$logger.error("Error initializing the upload task", err_3);
                            this._emitEvent($709f745b4b985ee8$export$1c9379601995aced.ERROR, err_3);
                        }
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype.resume = function() {
        if (this.state === $709f745b4b985ee8$export$badc82e7c9337824.CANCELLED) $709f745b4b985ee8$var$logger.warn("This task has already been cancelled");
        else if (this.state === $709f745b4b985ee8$export$badc82e7c9337824.COMPLETED) $709f745b4b985ee8$var$logger.warn("This task has already been completed");
        else if (this.state === $709f745b4b985ee8$export$badc82e7c9337824.IN_PROGRESS) $709f745b4b985ee8$var$logger.warn("Upload task already in progress");
        else if (!this.uploadId) this._initializeUploadTask();
        else this._startUpload();
    };
    AWSS3UploadTask.prototype._startUpload = function() {
        this.state = $709f745b4b985ee8$export$badc82e7c9337824.IN_PROGRESS;
        for(var i = 0; i < this.queueSize; i++)this._startNextPart();
    };
    AWSS3UploadTask.prototype._cancel = function() {
        return $709f745b4b985ee8$var$__awaiter(this, void 0, void 0, function() {
            var _a, _b, err_4;
            var _c;
            return $709f745b4b985ee8$var$__generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        if (!(this.state === $709f745b4b985ee8$export$badc82e7c9337824.CANCELLED)) return [
                            3 /*break*/ ,
                            1
                        ];
                        $709f745b4b985ee8$var$logger.warn("This task has already been cancelled");
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 1:
                        if (!(this.state === $709f745b4b985ee8$export$badc82e7c9337824.COMPLETED)) return [
                            3 /*break*/ ,
                            2
                        ];
                        $709f745b4b985ee8$var$logger.warn("This task has already been completed");
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 2:
                        this.pause();
                        this.queued = [];
                        this.completedParts = [];
                        this.bytesUploaded = 0;
                        this.state = $709f745b4b985ee8$export$badc82e7c9337824.CANCELLED;
                        _d.label = 3;
                    case 3:
                        _d.trys.push([
                            3,
                            7,
                            ,
                            8
                        ]);
                        _a = (0, $ee31fa3eb3f6493c$export$45ae37477c36d1d3);
                        _b = [
                            this.s3Config
                        ];
                        _c = {
                            Bucket: this.params.Bucket
                        };
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, _b.concat([
                                (_c.Key = _d.sent() + this.params.Key, _c.UploadId = this.uploadId, _c)
                            ]))
                        ];
                    case 5:
                        _d.sent();
                        return [
                            4 /*yield*/ ,
                            this._removeFromCache()
                        ];
                    case 6:
                        _d.sent();
                        return [
                            2 /*return*/ ,
                            true
                        ];
                    case 7:
                        err_4 = _d.sent();
                        $709f745b4b985ee8$var$logger.error("Error cancelling upload task", err_4);
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * pause this particular upload task
     **/ AWSS3UploadTask.prototype.pause = function() {
        var _a;
        if (this.state === $709f745b4b985ee8$export$badc82e7c9337824.CANCELLED) $709f745b4b985ee8$var$logger.warn("This task has already been cancelled");
        else if (this.state === $709f745b4b985ee8$export$badc82e7c9337824.COMPLETED) $709f745b4b985ee8$var$logger.warn("This task has already been completed");
        else if (this.state === $709f745b4b985ee8$export$badc82e7c9337824.PAUSED) $709f745b4b985ee8$var$logger.warn("This task is already paused");
        this.state = $709f745b4b985ee8$export$badc82e7c9337824.PAUSED;
        // Abort the part request immediately
        // Add the inProgress parts back to pending
        var removedInProgressReq = this.inProgress.splice(0, this.inProgress.length);
        removedInProgressReq.forEach(function(req) {
            req.abortController.abort();
        });
        // Put all removed in progress parts back into the queue
        (_a = this.queued).unshift.apply(_a, $709f745b4b985ee8$var$__spreadArray([], $709f745b4b985ee8$var$__read(removedInProgressReq.map(function(req) {
            return req.uploadPartInput;
        })), false));
    };
    return AWSS3UploadTask;
}();




var $9d80bfb70ed4c338$var$__assign = undefined && undefined.__assign || function() {
    $9d80bfb70ed4c338$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9d80bfb70ed4c338$var$__assign.apply(this, arguments);
};
var $9d80bfb70ed4c338$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9d80bfb70ed4c338$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $9d80bfb70ed4c338$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $9d80bfb70ed4c338$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $9d80bfb70ed4c338$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("AWSS3Provider");
var $9d80bfb70ed4c338$var$DEFAULT_STORAGE_LEVEL = "public";
var $9d80bfb70ed4c338$var$DEFAULT_PRESIGN_EXPIRATION = 900;
var $9d80bfb70ed4c338$export$a8628d9eb315b139 = /** @class */ function() {
    /**
     * Initialize Storage with AWS configurations
     * @param {Object} config - Configuration object for storage
     */ function AWSS3Provider(config) {
        var _this = this;
        this._config = config ? config : {};
        this._storage = new (0, $7a09b30b2e4e0fe6$export$a2bd19c49e4760e8)().getStorage();
        (0, $3b4d9bb645fe011c$export$8c41bb232f1008b1).listen("auth", function(data) {
            var payload = data.payload;
            if (payload.event === "signOut" || payload.event === "signIn") _this._storage.removeItem((0, $9c583fdc61a644a5$export$b9acc545d1bd0170));
        });
        $9d80bfb70ed4c338$var$logger.debug("Storage Options", this._config);
    }
    /**
     * get the category of the plugin
     */ AWSS3Provider.prototype.getCategory = function() {
        return AWSS3Provider.CATEGORY;
    };
    /**
     * get provider name of the plugin
     */ AWSS3Provider.prototype.getProviderName = function() {
        return AWSS3Provider.PROVIDER_NAME;
    };
    /**
     * Configure Storage part with aws configuration
     * @param {Object} config - Configuration of the Storage
     * @return {Object} - Current configuration
     */ AWSS3Provider.prototype.configure = function(config) {
        $9d80bfb70ed4c338$var$logger.debug("configure Storage", config);
        if (!config) return this._config;
        var amplifyConfig = (0, $d0434983171bcfb8$export$1ef2e9c2da492d)(config);
        this._config = Object.assign({}, this._config, amplifyConfig.Storage);
        if (!this._config.bucket) $9d80bfb70ed4c338$var$logger.debug("Do not have bucket yet");
        return this._config;
    };
    AWSS3Provider.prototype.startResumableUpload = function(addTaskInput, config) {
        var _a;
        var s3Config = addTaskInput.s3Config, emitter = addTaskInput.emitter, key = addTaskInput.key, file = addTaskInput.file, params = addTaskInput.params;
        var progressCallback = config.progressCallback, completeCallback = config.completeCallback, errorCallback = config.errorCallback, track = (_a = config.track, _a === void 0 ? false : _a);
        if (!(file instanceof Blob)) throw new Error((0, $ca7620d9022731b0$export$148a3867c72aff96).INVALID_BLOB);
        emitter.on((0, $709f745b4b985ee8$export$1c9379601995aced).UPLOAD_PROGRESS, function(event) {
            if (progressCallback) {
                if (typeof progressCallback === "function") progressCallback(event);
                else $9d80bfb70ed4c338$var$logger.warn("progressCallback should be a function, not a " + typeof progressCallback);
            }
        });
        emitter.on((0, $709f745b4b985ee8$export$1c9379601995aced).UPLOAD_COMPLETE, function(event) {
            if (completeCallback) {
                if (typeof completeCallback === "function") completeCallback(event);
                else $9d80bfb70ed4c338$var$logger.warn("completeCallback should be a function, not a " + typeof completeCallback);
            }
        });
        emitter.on((0, $709f745b4b985ee8$export$1c9379601995aced).ERROR, function(err) {
            if (errorCallback) {
                if (typeof errorCallback === "function") errorCallback(err);
                else $9d80bfb70ed4c338$var$logger.warn("errorCallback should be a function, not a " + typeof errorCallback);
            }
        });
        // we want to keep this function sync so we defer this promise to AWSS3UploadTask to resolve when it's needed
        // when its doing a final check with _listSingleFile function
        var prefixPromise = (0, $44b8a981f31e24b5$export$a9627919734faa48).get().then(function(credentials) {
            var cred = (0, $44b8a981f31e24b5$export$a9627919734faa48).shear(credentials);
            return (0, $7a70ad0ea906f888$export$36e24695f02d4503)($9d80bfb70ed4c338$var$__assign($9d80bfb70ed4c338$var$__assign({}, config), {
                level: addTaskInput.accessLevel,
                credentials: cred
            }));
        });
        var task = new (0, $709f745b4b985ee8$export$ca4ab80441206528)({
            s3Config: s3Config,
            file: file,
            emitter: emitter,
            level: addTaskInput.accessLevel,
            storage: this._storage,
            params: params,
            prefixPromise: prefixPromise
        });
        (0, $79809e69590d40e0$export$f4575af7aa417855)(track, "upload", {
            method: "put",
            result: "success"
        }, null, "Upload Task created successfully for ".concat(key));
        // automatically start the upload task
        task.resume();
        return task;
    };
    /**
     * Copy an object from a source object to a new object within the same bucket. Can optionally copy files across
     * different level or identityId (if source object's level is 'protected').
     *
     * @async
     * @param {S3CopySource} src - Key and optionally access level and identityId of the source object.
     * @param {S3CopyDestination} dest - Key and optionally access level of the destination object.
     * @param {S3ProviderCopyConfig} [config] - Optional configuration for s3 commands.
     * @return {Promise<S3ProviderCopyOutput>} The key of the copied object.
     */ AWSS3Provider.prototype.copy = function(src, dest, config) {
        return $9d80bfb70ed4c338$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, acl, bucket, cacheControl, expires, track, serverSideEncryption, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, SSEKMSKeyId, srcLevel, srcIdentityId, srcKey, destLevel, destKey, srcPrefix, destPrefix, finalSrcKey, finalDestKey, params, error_1;
            var _a, _b;
            return $9d80bfb70ed4c338$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _c.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, $ca7620d9022731b0$export$148a3867c72aff96).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        acl = opt.acl, bucket = opt.bucket, cacheControl = opt.cacheControl, expires = opt.expires, track = opt.track, serverSideEncryption = opt.serverSideEncryption, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, SSEKMSKeyId = opt.SSEKMSKeyId;
                        srcLevel = (_a = src.level, _a === void 0 ? $9d80bfb70ed4c338$var$DEFAULT_STORAGE_LEVEL : _a), srcIdentityId = src.identityId, srcKey = src.key;
                        destLevel = (_b = dest.level, _b === void 0 ? $9d80bfb70ed4c338$var$DEFAULT_STORAGE_LEVEL : _b), destKey = dest.key;
                        if (!srcKey || typeof srcKey !== "string") throw new Error((0, $ca7620d9022731b0$export$148a3867c72aff96).NO_SRC_KEY);
                        if (!destKey || typeof destKey !== "string") throw new Error((0, $ca7620d9022731b0$export$148a3867c72aff96).NO_DEST_KEY);
                        if (srcLevel !== "protected" && srcIdentityId) $9d80bfb70ed4c338$var$logger.warn('You may copy files from another user if the source level is "protected", currently it\'s '.concat(srcLevel));
                        srcPrefix = this._prefix($9d80bfb70ed4c338$var$__assign($9d80bfb70ed4c338$var$__assign($9d80bfb70ed4c338$var$__assign({}, opt), {
                            level: srcLevel
                        }), srcIdentityId && {
                            identityId: srcIdentityId
                        }));
                        destPrefix = this._prefix($9d80bfb70ed4c338$var$__assign($9d80bfb70ed4c338$var$__assign({}, opt), {
                            level: destLevel
                        }));
                        finalSrcKey = "".concat(bucket, "/").concat(srcPrefix).concat(srcKey);
                        finalDestKey = "".concat(destPrefix).concat(destKey);
                        $9d80bfb70ed4c338$var$logger.debug("copying ".concat(finalSrcKey, " to ").concat(finalDestKey));
                        params = {
                            Bucket: bucket,
                            CopySource: finalSrcKey,
                            Key: finalDestKey,
                            // Copies over metadata like contentType as well
                            MetadataDirective: "COPY"
                        };
                        if (cacheControl) params.CacheControl = cacheControl;
                        if (expires) params.Expires = expires;
                        if (serverSideEncryption) params.ServerSideEncryption = serverSideEncryption;
                        if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
                        if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
                        if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
                        if (SSEKMSKeyId) params.SSEKMSKeyId = SSEKMSKeyId;
                        if (acl) params.ACL = acl;
                        _c.label = 2;
                    case 2:
                        _c.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, $3fbff6c6f8a6f81e$export$84f041eb9803ea1f)((0, $7a70ad0ea906f888$export$fa2cd26183e80a49)($9d80bfb70ed4c338$var$__assign($9d80bfb70ed4c338$var$__assign({}, opt), {
                                storageAction: (0, $58c96d580693cdce$export$d4f3c54b808b00ce).Copy
                            })), params)
                        ];
                    case 3:
                        _c.sent();
                        (0, $79809e69590d40e0$export$f4575af7aa417855)(track, "copy", {
                            method: "copy",
                            result: "success"
                        }, null, "Copy success from ".concat(srcKey, " to ").concat(destKey));
                        return [
                            2 /*return*/ ,
                            {
                                key: destKey
                            }
                        ];
                    case 4:
                        error_1 = _c.sent();
                        (0, $79809e69590d40e0$export$f4575af7aa417855)(track, "copy", {
                            method: "copy",
                            result: "failed"
                        }, null, "Copy failed from ".concat(srcKey, " to ").concat(destKey));
                        throw error_1;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype.get = function(key, config) {
        var _a;
        return $9d80bfb70ed4c338$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, download, cacheControl, contentDisposition, contentEncoding, contentLanguage, contentType, expires, track, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, progressCallback, validateObjectExistence, prefix, final_key, emitter, s3Config, params, response, error_2, error_3, url, _b, _c, error_4;
            var _d, _e;
            return $9d80bfb70ed4c338$var$__generator(this, function(_f) {
                switch(_f.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _f.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, $ca7620d9022731b0$export$148a3867c72aff96).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, download = opt.download, cacheControl = opt.cacheControl, contentDisposition = opt.contentDisposition, contentEncoding = opt.contentEncoding, contentLanguage = opt.contentLanguage, contentType = opt.contentType, expires = opt.expires, track = opt.track, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, progressCallback = opt.progressCallback, validateObjectExistence = (_d = opt.validateObjectExistence, _d === void 0 ? false : _d);
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        emitter = new $b5680518dd48c196$exports.EventEmitter();
                        s3Config = (0, $7a70ad0ea906f888$export$fa2cd26183e80a49)($9d80bfb70ed4c338$var$__assign($9d80bfb70ed4c338$var$__assign({}, opt), {
                            emitter: emitter,
                            storageAction: (0, $58c96d580693cdce$export$d4f3c54b808b00ce).Get
                        }));
                        $9d80bfb70ed4c338$var$logger.debug("get " + key + " from " + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        // See: https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/S3.html#getObject-property
                        if (cacheControl) params.ResponseCacheControl = cacheControl;
                        if (contentDisposition) params.ResponseContentDisposition = contentDisposition;
                        if (contentEncoding) params.ResponseContentEncoding = contentEncoding;
                        if (contentLanguage) params.ResponseContentLanguage = contentLanguage;
                        if (contentType) params.ResponseContentType = contentType;
                        if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
                        if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
                        if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
                        if (!(download === true)) return [
                            3 /*break*/ ,
                            5
                        ];
                        _f.label = 2;
                    case 2:
                        _f.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        if (progressCallback) {
                            if (typeof progressCallback === "function") emitter.on((0, $3b18d274fcc1679a$export$660a92f3322ba11a), function(progress) {
                                progressCallback(progress);
                            });
                            else $9d80bfb70ed4c338$var$logger.warn("progressCallback should be a function, not a " + typeof progressCallback);
                        }
                        return [
                            4 /*yield*/ ,
                            (0, $149965fe409d78b9$export$93534728ecb2e7b9)(s3Config, params)
                        ];
                    case 3:
                        response = _f.sent();
                        emitter.removeAllListeners((0, $3b18d274fcc1679a$export$660a92f3322ba11a));
                        (0, $79809e69590d40e0$export$f4575af7aa417855)(track, "download", {
                            method: "get",
                            result: "success"
                        }, {
                            fileSize: Number(response.Body["size"] || response.Body["length"])
                        }, "Download success for ".concat(key));
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 4:
                        error_2 = _f.sent();
                        (0, $79809e69590d40e0$export$f4575af7aa417855)(track, "download", {
                            method: "get",
                            result: "failed"
                        }, null, "Download failed with ".concat(error_2.message));
                        throw error_2;
                    case 5:
                        if (!validateObjectExistence) return [
                            3 /*break*/ ,
                            9
                        ];
                        _f.label = 6;
                    case 6:
                        _f.trys.push([
                            6,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, $63554d7c2a89fb77$export$fde2a1002e11c41c)(s3Config, params)
                        ];
                    case 7:
                        _f.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        error_3 = _f.sent();
                        if (((_a = error_3.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 404) (0, $79809e69590d40e0$export$f4575af7aa417855)(track, "getSignedUrl", {
                            method: "get",
                            result: "failed"
                        }, null, "".concat(key, " not found"));
                        throw error_3;
                    case 9:
                        _f.trys.push([
                            9,
                            12,
                            ,
                            13
                        ]);
                        _b = (0, $149965fe409d78b9$export$8a3cb53edae699d1);
                        _c = [
                            $9d80bfb70ed4c338$var$__assign({}, s3Config)
                        ];
                        _e = {
                            expiration: expires || $9d80bfb70ed4c338$var$DEFAULT_PRESIGN_EXPIRATION
                        };
                        return [
                            4 /*yield*/ ,
                            s3Config.credentials()
                        ];
                    case 10:
                        return [
                            4 /*yield*/ ,
                            _b.apply(void 0, [
                                $9d80bfb70ed4c338$var$__assign.apply(void 0, _c.concat([
                                    (_e.credentials = _f.sent(), _e.signingRegion = s3Config.region, _e.signingService = (0, $04efb6a586095162$export$818eb7ab11414506), _e)
                                ])),
                                params
                            ])
                        ];
                    case 11:
                        url = _f.sent();
                        (0, $79809e69590d40e0$export$f4575af7aa417855)(track, "getSignedUrl", {
                            method: "get",
                            result: "success"
                        }, null, "Signed URL: ".concat(url));
                        return [
                            2 /*return*/ ,
                            url
                        ];
                    case 12:
                        error_4 = _f.sent();
                        $9d80bfb70ed4c338$var$logger.warn("get signed url error", error_4);
                        (0, $79809e69590d40e0$export$f4575af7aa417855)(track, "getSignedUrl", {
                            method: "get",
                            result: "failed"
                        }, null, "Could not get a signed URL for ".concat(key));
                        throw error_4;
                    case 13:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get Properties of the object
     *
     * @param {string} key - key of the object
     * @param {S3ProviderGetPropertiesConfig} [config] - Optional configuration for the underlying S3 command
     * @return {Promise<S3ProviderGetPropertiesOutput>} - A promise resolves to contentType,
     * contentLength, eTag, lastModified, metadata
     */ AWSS3Provider.prototype.getProperties = function(key, config) {
        var _a;
        return $9d80bfb70ed4c338$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, prefix, final_key, s3Config, params, response, getPropertiesResponse, error_5;
            var _b;
            return $9d80bfb70ed4c338$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _c.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, $ca7620d9022731b0$export$148a3867c72aff96).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = (_b = opt.track, _b === void 0 ? false : _b), SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5;
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        $9d80bfb70ed4c338$var$logger.debug("getProperties ".concat(key, " from ").concat(final_key));
                        s3Config = (0, $7a70ad0ea906f888$export$fa2cd26183e80a49)($9d80bfb70ed4c338$var$__assign($9d80bfb70ed4c338$var$__assign({}, opt), {
                            storageAction: (0, $58c96d580693cdce$export$d4f3c54b808b00ce).GetProperties
                        }));
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
                        if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
                        if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
                        _c.label = 2;
                    case 2:
                        _c.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, $63554d7c2a89fb77$export$fde2a1002e11c41c)(s3Config, params)
                        ];
                    case 3:
                        response = _c.sent();
                        getPropertiesResponse = {
                            contentLength: response.ContentLength,
                            contentType: response.ContentType,
                            eTag: response.ETag,
                            lastModified: response.LastModified,
                            metadata: response.Metadata
                        };
                        (0, $79809e69590d40e0$export$f4575af7aa417855)(track, "getProperties", {
                            method: "getProperties",
                            result: "success"
                        }, null, "getProperties successful for ".concat(key));
                        return [
                            2 /*return*/ ,
                            getPropertiesResponse
                        ];
                    case 4:
                        error_5 = _c.sent();
                        if (((_a = error_5.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 404) (0, $79809e69590d40e0$export$f4575af7aa417855)(track, "getProperties", {
                            method: "getProperties",
                            result: "failed"
                        }, null, "".concat(key, " not found"));
                        throw error_5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Put a file in S3 bucket specified to configure method
     * @param key - key of the object
     * @param object - File to be put in Amazon S3 bucket
     * @param [config] - Optional configuration for the underlying S3 command
     * @return an instance of AWSS3UploadTask or a promise that resolves to an object with the new object's key on
     * success.
     */ AWSS3Provider.prototype.put = function(key, object, config) {
        var opt = Object.assign({}, this._config, config);
        var bucket = opt.bucket, track = opt.track, progressCallback = opt.progressCallback, level = opt.level, resumable = opt.resumable;
        var contentType = opt.contentType, contentDisposition = opt.contentDisposition, contentEncoding = opt.contentEncoding, cacheControl = opt.cacheControl, expires = opt.expires, metadata = opt.metadata, tagging = opt.tagging, acl = opt.acl;
        var serverSideEncryption = opt.serverSideEncryption, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, SSEKMSKeyId = opt.SSEKMSKeyId;
        var type = contentType ? contentType : "binary/octet-stream";
        var params = {
            Bucket: bucket,
            Key: key,
            Body: object,
            ContentType: type
        };
        if (cacheControl) params.CacheControl = cacheControl;
        if (contentDisposition) params.ContentDisposition = contentDisposition;
        if (contentEncoding) params.ContentEncoding = contentEncoding;
        if (expires) params.Expires = expires;
        if (metadata) params.Metadata = metadata;
        if (tagging) params.Tagging = tagging;
        if (serverSideEncryption) params.ServerSideEncryption = serverSideEncryption;
        if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
        if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
        if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
        if (SSEKMSKeyId) params.SSEKMSKeyId = SSEKMSKeyId;
        var emitter = new $b5680518dd48c196$exports.EventEmitter();
        var uploader = new (0, $85e4f82c1067e7e2$export$da75ae8ad0285104)(params, opt, emitter);
        if (acl) params.ACL = acl;
        if (resumable === true) {
            var s3Config = (0, $7a70ad0ea906f888$export$fa2cd26183e80a49)($9d80bfb70ed4c338$var$__assign($9d80bfb70ed4c338$var$__assign({}, opt), {
                storageAction: (0, $58c96d580693cdce$export$d4f3c54b808b00ce).Put
            }));
            var addTaskInput = {
                bucket: bucket,
                key: key,
                s3Config: s3Config,
                file: object,
                emitter: emitter,
                accessLevel: level,
                params: params
            };
            // explicitly asserting the type here as Typescript could not infer that resumable is of type true
            return this.startResumableUpload(addTaskInput, config);
        }
        try {
            if (progressCallback) {
                if (typeof progressCallback === "function") emitter.on((0, $3b18d274fcc1679a$export$c5e6923933be22a0), function(progress) {
                    progressCallback(progress);
                });
                else $9d80bfb70ed4c338$var$logger.warn("progressCallback should be a function, not a " + typeof progressCallback);
            }
            return uploader.upload().then(function(response) {
                $9d80bfb70ed4c338$var$logger.debug("upload result", response);
                (0, $79809e69590d40e0$export$f4575af7aa417855)(track, "upload", {
                    method: "put",
                    result: "success"
                }, null, "Upload success for ".concat(key));
                return {
                    key: key
                };
            });
        } catch (error) {
            $9d80bfb70ed4c338$var$logger.warn("error uploading", error);
            (0, $79809e69590d40e0$export$f4575af7aa417855)(track, "upload", {
                method: "put",
                result: "failed"
            }, null, "Error uploading ".concat(key));
            throw error;
        }
    };
    /**
     * Remove the object for specified key
     * @param {string} key - key of the object
     * @param {S3ProviderRemoveConfig} [config] - Optional configuration for the underlying S3 command
     * @return {Promise<S3ProviderRemoveOutput>} - Promise resolves upon successful removal of the object
     */ AWSS3Provider.prototype.remove = function(key, config) {
        return $9d80bfb70ed4c338$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, prefix, final_key, params, s3Config, response, error_6;
            return $9d80bfb70ed4c338$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, $ca7620d9022731b0$export$148a3867c72aff96).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track;
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        $9d80bfb70ed4c338$var$logger.debug("remove " + key + " from " + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        s3Config = (0, $7a70ad0ea906f888$export$fa2cd26183e80a49)($9d80bfb70ed4c338$var$__assign($9d80bfb70ed4c338$var$__assign({}, opt), {
                            storageAction: (0, $58c96d580693cdce$export$d4f3c54b808b00ce).Remove
                        }));
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, $50dbca44dc0e52ae$export$39c5ed4ec960eade)(s3Config, params)
                        ];
                    case 3:
                        response = _a.sent();
                        (0, $79809e69590d40e0$export$f4575af7aa417855)(track, "delete", {
                            method: "remove",
                            result: "success"
                        }, null, "Deleted ".concat(key, " successfully"));
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 4:
                        error_6 = _a.sent();
                        (0, $79809e69590d40e0$export$f4575af7aa417855)(track, "delete", {
                            method: "remove",
                            result: "failed"
                        }, null, "Deletion of ".concat(key, " failed with ").concat(error_6));
                        throw error_6;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype._list = function(params, opt, prefix) {
        return $9d80bfb70ed4c338$var$__awaiter(this, void 0, void 0, function() {
            var list, response;
            return $9d80bfb70ed4c338$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        list = {
                            results: [],
                            hasNextToken: false
                        };
                        return [
                            4 /*yield*/ ,
                            (0, $6060c9199bed7416$export$d00eea31b34c3abb)((0, $7a70ad0ea906f888$export$fa2cd26183e80a49)($9d80bfb70ed4c338$var$__assign($9d80bfb70ed4c338$var$__assign({}, opt), {
                                storageAction: (0, $58c96d580693cdce$export$d4f3c54b808b00ce).List
                            })), $9d80bfb70ed4c338$var$__assign({}, params))
                        ];
                    case 1:
                        response = _a.sent();
                        if (response && response.Contents) {
                            list.results = response.Contents.map(function(item) {
                                return {
                                    key: item.Key.substr(prefix.length),
                                    eTag: item.ETag,
                                    lastModified: item.LastModified,
                                    size: item.Size
                                };
                            });
                            list.nextToken = response.NextContinuationToken;
                            list.hasNextToken = response.IsTruncated;
                        }
                        return [
                            2 /*return*/ ,
                            list
                        ];
                }
            });
        });
    };
    /**
     * List bucket objects relative to the level and prefix specified
     * @param {string} path - the path that contains objects
     * @param {S3ProviderListConfig} [config] - Optional configuration for the underlying S3 command
     * @return {Promise<S3ProviderListOutput>} - Promise resolves to list of keys, eTags, lastModified
     * and file size for all objects in path
     */ AWSS3Provider.prototype.list = function(path, config) {
        return $9d80bfb70ed4c338$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, pageSize, nextToken, prefix, final_path, list, MAX_PAGE_SIZE, listResult, params, error_7;
            var _a, _b;
            return $9d80bfb70ed4c338$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _c.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, $ca7620d9022731b0$export$148a3867c72aff96).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track, pageSize = opt.pageSize, nextToken = opt.nextToken;
                        prefix = this._prefix(opt);
                        final_path = prefix + path;
                        $9d80bfb70ed4c338$var$logger.debug("list " + path + " from " + final_path);
                        _c.label = 2;
                    case 2:
                        _c.trys.push([
                            2,
                            10,
                            ,
                            11
                        ]);
                        list = {
                            results: [],
                            hasNextToken: false
                        };
                        MAX_PAGE_SIZE = 1000;
                        listResult = void 0;
                        params = {
                            Bucket: bucket,
                            Prefix: final_path,
                            MaxKeys: MAX_PAGE_SIZE,
                            ContinuationToken: nextToken
                        };
                        params.ContinuationToken = nextToken;
                        if (!(pageSize === "ALL")) return [
                            3 /*break*/ ,
                            7
                        ];
                        _c.label = 3;
                    case 3:
                        return [
                            4 /*yield*/ ,
                            this._list(params, opt, prefix)
                        ];
                    case 4:
                        listResult = _c.sent();
                        (_a = list.results).push.apply(_a, $9d80bfb70ed4c338$var$__spreadArray([], $9d80bfb70ed4c338$var$__read(listResult.results), false));
                        if (listResult.nextToken) params.ContinuationToken = listResult.nextToken;
                        _c.label = 5;
                    case 5:
                        if (listResult.nextToken) return [
                            3 /*break*/ ,
                            3
                        ];
                        _c.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 7:
                        if (pageSize && pageSize <= MAX_PAGE_SIZE && typeof pageSize === "number") params.MaxKeys = pageSize;
                        else $9d80bfb70ed4c338$var$logger.warn("pageSize should be from 0 - ".concat(MAX_PAGE_SIZE, "."));
                        return [
                            4 /*yield*/ ,
                            this._list(params, opt, prefix)
                        ];
                    case 8:
                        listResult = _c.sent();
                        (_b = list.results).push.apply(_b, $9d80bfb70ed4c338$var$__spreadArray([], $9d80bfb70ed4c338$var$__read(listResult.results), false));
                        list.hasNextToken = listResult.hasNextToken;
                        list.nextToken = (0, listResult.nextToken);
                        _c.label = 9;
                    case 9:
                        (0, $79809e69590d40e0$export$f4575af7aa417855)(track, "list", {
                            method: "list",
                            result: "success"
                        }, null, "".concat(list.results.length, " items returned from list operation"));
                        $9d80bfb70ed4c338$var$logger.debug("list", list);
                        return [
                            2 /*return*/ ,
                            list
                        ];
                    case 10:
                        error_7 = _c.sent();
                        $9d80bfb70ed4c338$var$logger.error("list InvalidArgument", error_7);
                        (0, $79809e69590d40e0$export$f4575af7aa417855)(track, "list", {
                            method: "list",
                            result: "failed"
                        }, null, "Listing items failed: ".concat(error_7.message));
                        throw error_7;
                    case 11:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype._ensureCredentials = function() {
        return $9d80bfb70ed4c338$var$__awaiter(this, void 0, void 0, function() {
            var credentials, cred, error_8;
            return $9d80bfb70ed4c338$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, $44b8a981f31e24b5$export$a9627919734faa48).get()
                        ];
                    case 1:
                        credentials = _a.sent();
                        if (!credentials) return [
                            2 /*return*/ ,
                            false
                        ];
                        cred = (0, $44b8a981f31e24b5$export$a9627919734faa48).shear(credentials);
                        $9d80bfb70ed4c338$var$logger.debug("set credentials for storage", cred);
                        this._config.credentials = cred;
                        return [
                            2 /*return*/ ,
                            true
                        ];
                    case 2:
                        error_8 = _a.sent();
                        $9d80bfb70ed4c338$var$logger.warn("ensure credentials error", error_8);
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype._isWithCredentials = function(config) {
        return typeof config === "object" && config.hasOwnProperty("credentials");
    };
    AWSS3Provider.prototype._prefix = function(config) {
        var credentials = config.credentials, level = config.level;
        var customPrefix = config.customPrefix || {};
        var identityId = config.identityId || credentials.identityId;
        var privatePath = (customPrefix.private !== undefined ? customPrefix.private : "private/") + identityId + "/";
        var protectedPath = (customPrefix.protected !== undefined ? customPrefix.protected : "protected/") + identityId + "/";
        var publicPath = customPrefix.public !== undefined ? customPrefix.public : "public/";
        switch(level){
            case "private":
                return privatePath;
            case "protected":
                return protectedPath;
            default:
                return publicPath;
        }
    };
    AWSS3Provider.CATEGORY = "Storage";
    AWSS3Provider.PROVIDER_NAME = "AWSS3";
    return AWSS3Provider;
}();




var $82b5c847df02364b$var$__assign = undefined && undefined.__assign || function() {
    $82b5c847df02364b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $82b5c847df02364b$var$__assign.apply(this, arguments);
};
var $82b5c847df02364b$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $82b5c847df02364b$var$logger = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("StorageClass");
var $82b5c847df02364b$var$loggerStorageInstance = new (0, $67f97941d33988c4$export$ba6a9c7ac8291f7f)("Storage"); // Logging relating to Storage instance management
var $82b5c847df02364b$var$DEFAULT_PROVIDER = "AWSS3";
/**
 * Provide storage methods to use AWS S3
 */ var $82b5c847df02364b$export$bf2a15d34f3c441c = /** @class */ function() {
    /**
     * Initialize Storage
     * @param {Object} config - Configuration object for storage
     */ function Storage() {
        this._config = {};
        this._pluggables = [];
        this._abortControllerMap = new WeakMap();
        $82b5c847df02364b$var$logger.debug("Storage Options", this._config);
        this.get = this.get.bind(this);
        this.put = this.put.bind(this);
        this.remove = this.remove.bind(this);
        this.list = this.list.bind(this);
    }
    Storage.prototype.getModuleName = function() {
        return "Storage";
    };
    /**
     * add plugin into Storage category
     * @param {Object} pluggable - an instance of the plugin
     */ Storage.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategory() === "Storage") {
            this._pluggables.push(pluggable);
            var config = {};
            config = pluggable.configure(this._config[pluggable.getProviderName()]);
            return config;
        }
    };
    /**
     * Get the plugin object
     * @param providerName - the name of the plugin
     */ Storage.prototype.getPluggable = function(providerName) {
        var pluggable = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
        if (pluggable === undefined) {
            $82b5c847df02364b$var$logger.debug("No plugin found with providerName", providerName);
            return null;
        } else return pluggable;
    };
    /**
     * Remove the plugin object
     * @param providerName - the name of the plugin
     */ Storage.prototype.removePluggable = function(providerName) {
        this._pluggables = this._pluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        return;
    };
    /**
     * Configure Storage
     * @param {Object} config - Configuration object for storage
     * @return {Object} - Current configuration
     */ Storage.prototype.configure = function(config) {
        var _this = this;
        var _a;
        $82b5c847df02364b$var$logger.debug("configure Storage");
        if (!config) return this._config;
        var amplifyConfig = (0, $d0434983171bcfb8$export$1ef2e9c2da492d)(config);
        var storageConfig = (_a = amplifyConfig.Storage) !== null && _a !== void 0 ? _a : {};
        var defaultProviderConfigKeys = [
            "bucket",
            "region",
            "level",
            "track",
            "customPrefix",
            "ContentMD5",
            "serverSideEncryption",
            "SSECustomerAlgorithm",
            "SSECustomerKey",
            // TODO(AllanZhengYP): remove in V6.
            "SSECustomerKeyMD5",
            "SSEKMSKeyId"
        ];
        var hasDefaultProviderConfigKeys = function(config) {
            return Object.keys(config).find(function(key) {
                return defaultProviderConfigKeys.includes(key);
            });
        };
        if (hasDefaultProviderConfigKeys(storageConfig) && !storageConfig[$82b5c847df02364b$var$DEFAULT_PROVIDER]) storageConfig[$82b5c847df02364b$var$DEFAULT_PROVIDER] = {};
        Object.entries(storageConfig).forEach(function(_a) {
            var _b = $82b5c847df02364b$var$__read(_a, 2), key = _b[0], value = _b[1];
            if (key && defaultProviderConfigKeys.includes(key) && value !== undefined) {
                storageConfig[$82b5c847df02364b$var$DEFAULT_PROVIDER][key] = value;
                delete storageConfig[key];
            }
        });
        // only update new values for each provider
        Object.keys(storageConfig).forEach(function(providerName) {
            if (typeof storageConfig[providerName] !== "string") _this._config[providerName] = $82b5c847df02364b$var$__assign($82b5c847df02364b$var$__assign({}, _this._config[providerName]), storageConfig[providerName]);
        });
        this._pluggables.forEach(function(pluggable) {
            pluggable.configure(_this._config[pluggable.getProviderName()]);
        });
        if (this._pluggables.length === 0) this.addPluggable(new (0, $9d80bfb70ed4c338$export$a8628d9eb315b139)());
        return this._config;
    };
    Storage.prototype.getAbortController = function() {
        return new AbortController();
    };
    Storage.prototype.updateRequestToBeCancellable = function(request, abortController) {
        this._abortControllerMap.set(request, abortController);
    };
    Storage.prototype.isUploadTask = function(x) {
        return typeof x !== "undefined" && typeof x["pause"] === "function" && typeof x["resume"] === "function";
    };
    Storage.prototype.cancel = function(request, message) {
        if (request instanceof (0, $709f745b4b985ee8$export$ca4ab80441206528)) return request._cancel();
        var abortController = this._abortControllerMap.get(request);
        if (abortController) // TODO: [v6] clean up the aborted promise in the weak map.
        // Not doing it yet to avoid breaking changes when users may abort a request twice.
        abortController.abort(message);
        else $82b5c847df02364b$var$logger.debug("The request does not map to any cancel token");
    };
    Storage.prototype.copy = function(src, dest, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || $82b5c847df02364b$var$DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            $82b5c847df02364b$var$logger.debug("No plugin found with providerName", provider);
            return Promise.reject("No plugin found in Storage for the provider");
        }
        var abortController = this.getAbortController();
        if (typeof plugin.copy !== "function") return Promise.reject(".copy is not implemented on provider ".concat(plugin.getProviderName()));
        var responsePromise = plugin.copy(src, dest, $82b5c847df02364b$var$__assign($82b5c847df02364b$var$__assign({}, config), {
            abortSignal: abortController.signal
        }));
        this.updateRequestToBeCancellable(responsePromise, abortController);
        return responsePromise;
    };
    Storage.prototype.get = function(key, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || $82b5c847df02364b$var$DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            $82b5c847df02364b$var$logger.debug("No plugin found with providerName", provider);
            return Promise.reject("No plugin found in Storage for the provider");
        }
        var abortController = this.getAbortController();
        var responsePromise = plugin.get(key, $82b5c847df02364b$var$__assign($82b5c847df02364b$var$__assign({}, config), {
            abortSignal: abortController.signal
        }));
        this.updateRequestToBeCancellable(responsePromise, abortController);
        return responsePromise;
    };
    Storage.prototype.isCancelError = function(error) {
        return (0, $0df55fff21bdf78c$export$a88a1555052550c7)(error);
    };
    Storage.prototype.getProperties = function(key, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || $82b5c847df02364b$var$DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            $82b5c847df02364b$var$logger.debug("No plugin found with providerName", provider);
            throw new Error("No plugin found with providerName");
        }
        var abortController = this.getAbortController();
        if (typeof plugin.getProperties !== "function") return Promise.reject(".getProperties is not implemented on provider ".concat(plugin.getProviderName()));
        var responsePromise = plugin === null || plugin === void 0 ? void 0 : plugin.getProperties(key, $82b5c847df02364b$var$__assign({}, config));
        this.updateRequestToBeCancellable(responsePromise, abortController);
        return responsePromise;
    };
    Storage.prototype.put = function(key, object, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || $82b5c847df02364b$var$DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            $82b5c847df02364b$var$logger.debug("No plugin found with providerName", provider);
            return Promise.reject("No plugin found in Storage for the provider");
        }
        var abortController = this.getAbortController();
        var response = plugin.put(key, object, $82b5c847df02364b$var$__assign($82b5c847df02364b$var$__assign({}, config), {
            abortSignal: abortController.signal
        }));
        if (!this.isUploadTask(response)) this.updateRequestToBeCancellable(response, abortController);
        return response;
    };
    Storage.prototype.remove = function(key, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || $82b5c847df02364b$var$DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            $82b5c847df02364b$var$logger.debug("No plugin found with providerName", provider);
            return Promise.reject("No plugin found in Storage for the provider");
        }
        return plugin.remove(key, config);
    };
    Storage.prototype.list = function(path, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || $82b5c847df02364b$var$DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            $82b5c847df02364b$var$logger.debug("No plugin found with providerName", provider);
            return Promise.reject("No plugin found in Storage for the provider");
        }
        return plugin.list(path, config);
    };
    return Storage;
}();
/**
 * Configure & register Storage singleton instance.
 */ var $82b5c847df02364b$var$_instance = null;
var $82b5c847df02364b$var$getInstance = function() {
    if ($82b5c847df02364b$var$_instance) return $82b5c847df02364b$var$_instance;
    $82b5c847df02364b$var$loggerStorageInstance.debug("Create Storage Instance, debug");
    $82b5c847df02364b$var$_instance = new $82b5c847df02364b$export$bf2a15d34f3c441c();
    $82b5c847df02364b$var$_instance.vault = new $82b5c847df02364b$export$bf2a15d34f3c441c();
    var old_configure = $82b5c847df02364b$var$_instance.configure;
    $82b5c847df02364b$var$_instance.configure = function(options) {
        $82b5c847df02364b$var$loggerStorageInstance.debug("storage configure called");
        var vaultConfig = $82b5c847df02364b$var$__assign({}, old_configure.call($82b5c847df02364b$var$_instance, options));
        // set level private for each provider for the vault
        Object.keys(vaultConfig).forEach(function(providerName) {
            if (typeof vaultConfig[providerName] !== "string") vaultConfig[providerName] = $82b5c847df02364b$var$__assign($82b5c847df02364b$var$__assign({}, vaultConfig[providerName]), {
                level: "private"
            });
        });
        $82b5c847df02364b$var$loggerStorageInstance.debug("storage vault configure called");
        $82b5c847df02364b$var$_instance.vault.configure(vaultConfig);
    };
    return $82b5c847df02364b$var$_instance;
};
var $82b5c847df02364b$export$f43fbdef6dd3768c = $82b5c847df02364b$var$getInstance();
(0, $6ff5c7c169206e21$export$a3858a9a153cffc7).register($82b5c847df02364b$export$f43fbdef6dd3768c);


var $8633ffc42a989fa8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8633ffc42a989fa8$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $8633ffc42a989fa8$var$FormReport = function(_a) {
    var _b;
    var navigatePage = _a.navigatePage, urlParams = _a.urlParams;
    var _c = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false), loading = _c[0], setLoading = _c[1];
    var _d = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(Date.now()), key = _d[0], setKey = _d[1];
    var formConfig = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef([
        {
            name: "year",
            label: "Report Year",
            fieldType: "input",
            isRequired: true,
            validations: {
                type: "input",
                required: true,
                customMessages: {
                    required: "year can't be blank."
                }
            }
        },
        {
            name: "reportStatus",
            label: "Status",
            fieldType: "select",
            isRequired: true,
            options: {
                data: [
                    {
                        id: "Draft",
                        value: "Draft"
                    },
                    {
                        id: "Coming Soon",
                        value: "Coming Soon"
                    },
                    {
                        id: "Active",
                        value: "Active"
                    }
                ],
                dictionary: {
                    id: "id",
                    value: "value"
                }
            },
            value: "1",
            validations: {
                required: true
            }
        },
        {
            name: "description",
            label: "Report information",
            fieldType: "editor",
            isRequired: true,
            validations: {
                type: "input",
                required: true,
                customMessages: {
                    required: "information can't be blank."
                }
            }
        },
        {
            name: "reportImage",
            label: "Report Image",
            fieldType: "file",
            isRequired: true,
            fileType: ".jpg,.png,.svg",
            validations: {
                required: true,
                customMessages: {
                    required: "Image is required."
                }
            }
        },
        {
            name: "report",
            label: "Report",
            fieldType: "file",
            isRequired: true,
            fileType: ".pdf",
            validations: {
                required: true,
                customMessages: {
                    required: "Report is required."
                }
            }
        }
    ]);
    var record = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        if (urlParams.id) reloadFunc().then();
    }, []);
    var reloadFunc = function() {
        return $8633ffc42a989fa8$var$__awaiter(void 0, void 0, Promise, function() {
            var _a, i;
            var _b;
            return $8633ffc42a989fa8$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        setLoading(true);
                        _a = record;
                        return [
                            4,
                            (0, $010273dbafa4ccc3$export$2e2bcd8739ae039).get(navigatePage, (_b = urlParams.id) !== null && _b !== void 0 ? _b : "")
                        ];
                    case 1:
                        _a.current = _c.sent();
                        for(i = 0; i < formConfig.current.length; i++)formConfig.current[i].value = record.current[formConfig.current[i].name];
                        formConfig.current[formConfig.current.length - 1].value = JSON.stringify({
                            name: record.current.s3Name,
                            file: "file"
                        });
                        setLoading(false);
                        setKey(Date.now());
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var uploadToS3 = function(data, report) {
        report.onload = function() {
            return $8633ffc42a989fa8$var$__awaiter(void 0, void 0, void 0, function() {
                var nameList, uniqueFileName, filePath, results, error_1;
                return $8633ffc42a989fa8$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            data.s3Name = data.report.name;
                            data.s3Type = "pdf";
                            nameList = data.report.name.split(".");
                            uniqueFileName = "".concat($117e03bdefca38ae$export$2e2bcd8739ae039(), ".").concat(nameList[nameList.length - 1]);
                            filePath = "uploads/".concat(uniqueFileName);
                            return [
                                4,
                                (0, $82b5c847df02364b$export$f43fbdef6dd3768c).put(filePath, report.result, {
                                    contentType: "application/pdf"
                                })
                            ];
                        case 1:
                            results = _a.sent();
                            if (!results) return [
                                2
                            ];
                            data.s3Key = results.key;
                            delete data.report;
                            loadImage(data);
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 2:
                            error_1 = _a.sent();
                            console.error("Error uploading to S3:", error_1);
                            (0, $de77e498e07914bf$export$b410431fab84fa58).error("There was an error uploading the file. Please try again.");
                            return [
                                2,
                                undefined
                            ];
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
    };
    var loadImage = function(data) {
        var reportImage = new FileReader();
        reportImage.readAsDataURL(data.reportImage);
        reportImage.onload = function() {
            return $8633ffc42a989fa8$var$__awaiter(void 0, void 0, void 0, function() {
                return $8633ffc42a989fa8$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            data.reportImage = JSON.stringify({
                                name: data.reportImage.name,
                                file: reportImage.result
                            });
                            return [
                                4,
                                saveAllData(data)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
    };
    var saveAllData = function(data) {
        return $8633ffc42a989fa8$var$__awaiter(void 0, void 0, void 0, function() {
            return $8633ffc42a989fa8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!urlParams.id) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0, $010273dbafa4ccc3$export$2e2bcd8739ae039).update(navigatePage, record.current, data)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            (0, $010273dbafa4ccc3$export$2e2bcd8739ae039).save(navigatePage, data)
                        ];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        setLoading(false);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var handleFormSubmit = function(data) {
        return $8633ffc42a989fa8$var$__awaiter(void 0, void 0, void 0, function() {
            var report;
            return $8633ffc42a989fa8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        setLoading(true);
                        if (!data.report.file) return [
                            3,
                            3
                        ];
                        if (!data.reportImage.file) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            saveAllData(data)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2
                        ];
                    case 2:
                        loadImage(data);
                        return [
                            2
                        ];
                    case 3:
                        report = new FileReader();
                        report.readAsDataURL(data.report);
                        uploadToS3(data, report);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, {
        key: key
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $391db0dc72f5c1c4$export$2e2bcd8739ae039), {
        fields: (_b = formConfig.current) !== null && _b !== void 0 ? _b : [],
        onSubmit: handleFormSubmit,
        submitButtonText: urlParams.id ? "Update" : "Save",
        doShowCardHeader: true,
        reloadFunc: urlParams.id ? reloadFunc : undefined,
        title: urlParams.id ? "Update Survey" : "New Survey",
        loading: loading
    }));
};
var $8633ffc42a989fa8$export$2e2bcd8739ae039 = $8633ffc42a989fa8$var$FormReport;


var $7c9a8b48c9e0e766$var$SurveyReportsRoutes = {
    surveyReports: {
        Component: (0, $bf8c8db7535cd819$export$2e2bcd8739ae039),
        type: "private",
        route: "/members/survey/reports",
        title: "Reports",
        breadcrumb: [
            {
                title: "Home",
                route: "/"
            },
            {
                title: "Survey"
            }
        ]
    },
    surveyNewReport: {
        Component: (0, $8633ffc42a989fa8$export$2e2bcd8739ae039),
        type: "private",
        route: "/members/survey/reports/add",
        title: "New Report",
        breadcrumb: [
            {
                title: "Home",
                route: "/"
            },
            {
                title: "Survey"
            },
            {
                title: "Reports",
                route: "/members/survey/reports"
            }
        ]
    },
    surveyUpdateReport: {
        Component: (0, $8633ffc42a989fa8$export$2e2bcd8739ae039),
        type: "private",
        route: "/members/survey/reports/update/:id",
        title: "Update Report",
        breadcrumb: [
            {
                title: "Home",
                route: "/"
            },
            {
                title: "Survey"
            },
            {
                title: "Reports",
                route: "/members/survey/reports"
            }
        ]
    }
};
var $7c9a8b48c9e0e766$export$2e2bcd8739ae039 = $7c9a8b48c9e0e766$var$SurveyReportsRoutes;


var $ce51c19f5e6b6167$var$__assign = undefined && undefined.__assign || function() {
    $ce51c19f5e6b6167$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ce51c19f5e6b6167$var$__assign.apply(this, arguments);
};
var $ce51c19f5e6b6167$var$SurveyRoutes = $ce51c19f5e6b6167$var$__assign($ce51c19f5e6b6167$var$__assign({}, (0, $c7a280a74cea845a$export$2e2bcd8739ae039)), (0, $7c9a8b48c9e0e766$export$2e2bcd8739ae039));
var $ce51c19f5e6b6167$export$2e2bcd8739ae039 = $ce51c19f5e6b6167$var$SurveyRoutes;



var $7fPBF = parcelRequire("7fPBF");




var $cae0824f9cd993f0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $cae0824f9cd993f0$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $cae0824f9cd993f0$var$CacheKey = "SystemGlobalSecrets";
var $cae0824f9cd993f0$var$SystemGlobalSecretsCache = {
    setItem: function(value) {
        return $cae0824f9cd993f0$var$__awaiter(void 0, void 0, Promise, function() {
            return $cae0824f9cd993f0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).setItem($cae0824f9cd993f0$var$CacheKey, JSON.stringify(value))
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    },
    getItem: function() {
        return $cae0824f9cd993f0$var$__awaiter(void 0, void 0, Promise, function() {
            var items;
            return $cae0824f9cd993f0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).getItem($cae0824f9cd993f0$var$CacheKey)
                        ];
                    case 1:
                        items = _a.sent();
                        return [
                            2,
                            items ? JSON.parse(items) : null
                        ];
                }
            });
        });
    },
    removeItem: function() {
        return $cae0824f9cd993f0$var$__awaiter(void 0, void 0, Promise, function() {
            return $cae0824f9cd993f0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).removeItem($cae0824f9cd993f0$var$CacheKey)
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    }
};
var $cae0824f9cd993f0$export$2e2bcd8739ae039 = $cae0824f9cd993f0$var$SystemGlobalSecretsCache;



var $f21a530b943c8c47$var$SystemGlobalSecretsAPI = new (0, $85c3021a0318976c$export$2e2bcd8739ae039)({
    ref: "CMSConfigurationsAPI",
    cacheFunc: (0, $cae0824f9cd993f0$export$2e2bcd8739ae039),
    filter: {
        key: "System_Global_Secrets"
    },
    listFunc: (0, $d819d0cbe64233c2$export$197e07aa664d3d5f),
    getFunc: (0, $d819d0cbe64233c2$export$4f5da003f4245282),
    route: "/members/system/secrets",
    insertFunc: (0, $7a1d5ab68f58f51c$export$460903208bc6934d),
    updateFunc: (0, $7a1d5ab68f58f51c$export$fe2848aa9648df5f),
    deleteFunc: (0, $7a1d5ab68f58f51c$export$6e1cc715f2833d3b),
    backupTable: "system_global_secrets",
    deleteMSG: "Secret deleted",
    insertMSG: "Secret saved",
    updateMSG: "Secret updated",
    key: "System_Global_Secrets",
    getName: "getSortedSystemGlobalSecrets"
});
var $f21a530b943c8c47$export$2e2bcd8739ae039 = $f21a530b943c8c47$var$SystemGlobalSecretsAPI;


var $61c98463000f308f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $61c98463000f308f$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $61c98463000f308f$var$FormConfiguration = function(_a) {
    var _b;
    var navigatePage = _a.navigatePage, urlParams = _a.urlParams;
    var _c = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(true), loading = _c[0], setLoading = _c[1];
    var dataSecret = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef({});
    var baseSecret = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef([]);
    var formConfig = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef([
        {
            name: "googleSecretKey",
            label: "Google Secret Key",
            fieldType: "input",
            isRequired: false,
            value: "",
            validations: {
                type: "input",
                required: true,
                customMessages: {
                    required: "Google Secret Key can't be blank."
                }
            }
        }
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        reloadFunc().then();
    }, []);
    var reloadFunc = function() {
        return $61c98463000f308f$var$__awaiter(void 0, void 0, Promise, function() {
            var _a;
            return $61c98463000f308f$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        setLoading(true);
                        _a = baseSecret;
                        return [
                            4,
                            (0, $f21a530b943c8c47$export$2e2bcd8739ae039).getList(navigatePage, true)
                        ];
                    case 1:
                        _a.current = _b.sent();
                        baseSecret.current.map(function(configuration) {
                            dataSecret.current[configuration.config] = configuration.record;
                            return configuration;
                        });
                        formConfig.current.map(function(field) {
                            var _a;
                            field.value = (_a = dataSecret.current[field.name]) !== null && _a !== void 0 ? _a : field.value;
                            return field;
                        });
                        setLoading(false);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var submitData = function(data) {
        var dataValues = Object.entries(data);
        dataValues.forEach(function(_a, index) {
            var key = _a[0], value = _a[1];
            return $61c98463000f308f$var$__awaiter(void 0, void 0, void 0, function() {
                var input;
                var _b;
                return $61c98463000f308f$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            input = {
                                config: key,
                                record: value
                            };
                            if (!((_b = dataSecret.current) === null || _b === void 0 ? void 0 : _b[key])) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0, $f21a530b943c8c47$export$2e2bcd8739ae039).update(navigatePage, baseSecret.current.find(function(configuration) {
                                    return configuration.config === key;
                                }), input)
                            ];
                        case 1:
                            _c.sent();
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                (0, $f21a530b943c8c47$export$2e2bcd8739ae039).save(navigatePage, input)
                            ];
                        case 3:
                            _c.sent();
                            _c.label = 4;
                        case 4:
                            if (index + 1 === dataValues.length) setLoading(false);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    var handleFormSubmit = function(data) {
        return $61c98463000f308f$var$__awaiter(void 0, void 0, void 0, function() {
            return $61c98463000f308f$var$__generator(this, function(_a) {
                setLoading(true);
                submitData(data);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $391db0dc72f5c1c4$export$2e2bcd8739ae039), {
        fields: (_b = formConfig.current) !== null && _b !== void 0 ? _b : [],
        onSubmit: handleFormSubmit,
        submitButtonText: "Save",
        doShowCardHeader: true,
        reloadFunc: reloadFunc,
        title: "System Secrets",
        loading: loading
    }));
};
var $61c98463000f308f$export$2e2bcd8739ae039 = $61c98463000f308f$var$FormConfiguration;


var $def5ca501f85d556$var$SystemSecretsRoutes = {
    systemSecrets: {
        Component: (0, $61c98463000f308f$export$2e2bcd8739ae039),
        type: "private",
        route: "/members/system/secrets",
        title: "System Secrets",
        breadcrumb: [
            {
                title: "Home",
                route: "/"
            },
            {
                title: "System"
            }
        ]
    }
};
var $def5ca501f85d556$export$2e2bcd8739ae039 = $def5ca501f85d556$var$SystemSecretsRoutes;



var $7fPBF = parcelRequire("7fPBF");




var $e64ccba43de5ed00$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e64ccba43de5ed00$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $e64ccba43de5ed00$var$CacheKey = "SystemInternalConfigurationVariablesReadonlyCache";
var $e64ccba43de5ed00$var$SystemInternalConfigurationVariablesReadonlyCache = {
    setItem: function(value) {
        return $e64ccba43de5ed00$var$__awaiter(void 0, void 0, Promise, function() {
            return $e64ccba43de5ed00$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).setItem($e64ccba43de5ed00$var$CacheKey, JSON.stringify(value))
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    },
    getItem: function() {
        return $e64ccba43de5ed00$var$__awaiter(void 0, void 0, Promise, function() {
            var items;
            return $e64ccba43de5ed00$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).getItem($e64ccba43de5ed00$var$CacheKey)
                        ];
                    case 1:
                        items = _a.sent();
                        return [
                            2,
                            items ? JSON.parse(items) : null
                        ];
                }
            });
        });
    },
    removeItem: function() {
        return $e64ccba43de5ed00$var$__awaiter(void 0, void 0, Promise, function() {
            return $e64ccba43de5ed00$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).removeItem($e64ccba43de5ed00$var$CacheKey)
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    }
};
var $e64ccba43de5ed00$export$2e2bcd8739ae039 = $e64ccba43de5ed00$var$SystemInternalConfigurationVariablesReadonlyCache;



var $009fad4350176f13$var$SystemInternalConfigurationVariablesReadonlyAPI = new (0, $85c3021a0318976c$export$2e2bcd8739ae039)({
    ref: "SystemInternalConfigurationVariablesReadonlyAPI",
    cacheFunc: (0, $e64ccba43de5ed00$export$2e2bcd8739ae039),
    filter: {
        key: ""
    },
    listFunc: (0, $d819d0cbe64233c2$export$c9a0e79705565a5e),
    getFunc: (0, $d819d0cbe64233c2$export$7043984ae48e363),
    route: "/members/system/internal-versions",
    insertFunc: (0, $7a1d5ab68f58f51c$export$fda9d4299aa12bb8),
    updateFunc: (0, $7a1d5ab68f58f51c$export$3d8c2f61368b6db0),
    deleteFunc: (0, $7a1d5ab68f58f51c$export$30d5cbba0260b1e4),
    backupTable: "",
    deleteMSG: " deleted",
    insertMSG: " saved",
    updateMSG: " updated",
    key: "",
    getName: "getSystemInternalConfigurationVariablesReadonly"
});
var $009fad4350176f13$export$2e2bcd8739ae039 = $009fad4350176f13$var$SystemInternalConfigurationVariablesReadonlyAPI;


var $cb6daa1b72819117$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $cb6daa1b72819117$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $cb6daa1b72819117$var$InternalVersions = function(_a) {
    var navigatePage = _a.navigatePage;
    var _b = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState([]), record = _b[0], setRecord = _b[1];
    var loadRecords = function(refreshCache) {
        return $cb6daa1b72819117$var$__awaiter(void 0, void 0, void 0, function() {
            var _a;
            return $cb6daa1b72819117$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = setRecord;
                        return [
                            4,
                            (0, $009fad4350176f13$export$2e2bcd8739ae039).getList(navigatePage, refreshCache)
                        ];
                    case 1:
                        _a.apply(void 0, [
                            _b.sent()
                        ]);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $97914e663a317172$export$2e2bcd8739ae039), {
        sm: 6,
        itemProps: [
            {
                type: "data",
                key: "variable_name",
                text: "Variable"
            },
            {
                type: "data",
                key: "variable_value",
                text: "Value"
            }
        ],
        items: record,
        itemActions: [],
        addInfo: {
            text: "Readonly Internal Variables",
            handler: function() {
                return;
            }
        },
        actionID: "id",
        loadRecords: loadRecords,
        doShowCardHeader: true,
        doShowTableHeader: true
    });
};
var $cb6daa1b72819117$export$2e2bcd8739ae039 = $cb6daa1b72819117$var$InternalVersions;


var $bea0ef8b25eae4a0$var$SystemInternalReadonlyVariablesRoutes = {
    systemInternalVerions: {
        Component: (0, $cb6daa1b72819117$export$2e2bcd8739ae039),
        type: "private",
        route: "/members/system/internal-versions",
        title: "System Readonly Variables",
        breadcrumb: [
            {
                title: "Home",
                route: "/"
            },
            {
                title: "System"
            }
        ]
    }
};
var $bea0ef8b25eae4a0$export$2e2bcd8739ae039 = $bea0ef8b25eae4a0$var$SystemInternalReadonlyVariablesRoutes;


var $581919de262e859f$var$__assign = undefined && undefined.__assign || function() {
    $581919de262e859f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $581919de262e859f$var$__assign.apply(this, arguments);
};
var $581919de262e859f$var$SystemRoutes = $581919de262e859f$var$__assign($581919de262e859f$var$__assign({}, (0, $def5ca501f85d556$export$2e2bcd8739ae039)), (0, $bea0ef8b25eae4a0$export$2e2bcd8739ae039));
var $581919de262e859f$export$2e2bcd8739ae039 = $581919de262e859f$var$SystemRoutes;



var $7fPBF = parcelRequire("7fPBF");




var $7fb32072f4b42c23$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7fb32072f4b42c23$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $7fb32072f4b42c23$var$CacheKey = "SurveyDownloadReportEmailCache";
var $7fb32072f4b42c23$var$SurveyDownloadReportEmailCache = {
    setItem: function(value) {
        return $7fb32072f4b42c23$var$__awaiter(void 0, void 0, Promise, function() {
            return $7fb32072f4b42c23$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).setItem($7fb32072f4b42c23$var$CacheKey, JSON.stringify(value))
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    },
    getItem: function() {
        return $7fb32072f4b42c23$var$__awaiter(void 0, void 0, Promise, function() {
            var items;
            return $7fb32072f4b42c23$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).getItem($7fb32072f4b42c23$var$CacheKey)
                        ];
                    case 1:
                        items = _a.sent();
                        return [
                            2,
                            items ? JSON.parse(items) : null
                        ];
                }
            });
        });
    },
    removeItem: function() {
        return $7fb32072f4b42c23$var$__awaiter(void 0, void 0, Promise, function() {
            return $7fb32072f4b42c23$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).removeItem($7fb32072f4b42c23$var$CacheKey)
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    }
};
var $7fb32072f4b42c23$export$2e2bcd8739ae039 = $7fb32072f4b42c23$var$SurveyDownloadReportEmailCache;



var $03ff035b4ab3e762$var$SurveyDownloadReportEmailAPI = new (0, $85c3021a0318976c$export$2e2bcd8739ae039)({
    ref: "SurveyDownloadReportEmailAPI",
    cacheFunc: (0, $7fb32072f4b42c23$export$2e2bcd8739ae039),
    filter: {
        key: "Survey_Download_Report_Email",
        sortDirection: "DESC"
    },
    listFunc: (0, $d819d0cbe64233c2$export$5d0f58c92b9f8981),
    getFunc: (0, $d819d0cbe64233c2$export$27e90d76e87bd6b8),
    route: "/members/records/reports-downloaders",
    insertFunc: (0, $7a1d5ab68f58f51c$export$724c753285e1b60b),
    updateFunc: (0, $7a1d5ab68f58f51c$export$dabe6b9f54960e0b),
    deleteFunc: (0, $7a1d5ab68f58f51c$export$bdf1f7f82dfd20a7),
    backupTable: "",
    deleteMSG: "Downloader deleted",
    insertMSG: "Downloader saved",
    updateMSG: "Downloader updated",
    key: "Survey_Download_Report_Email",
    getName: "getSurveyDownloadReportEmail"
});
var $03ff035b4ab3e762$export$2e2bcd8739ae039 = $03ff035b4ab3e762$var$SurveyDownloadReportEmailAPI;


var $b77fc0fe1b78031c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b77fc0fe1b78031c$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $b77fc0fe1b78031c$var$ReportsDownloaders = function(_a) {
    var navigatePage = _a.navigatePage;
    var _b = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState([]), record = _b[0], setRecord = _b[1];
    var loadRecords = function(refreshCache, page) {
        return $b77fc0fe1b78031c$var$__awaiter(void 0, void 0, Promise, function() {
            var _a;
            return $b77fc0fe1b78031c$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = setRecord;
                        return [
                            4,
                            (0, $03ff035b4ab3e762$export$2e2bcd8739ae039).getList(navigatePage, refreshCache, page)
                        ];
                    case 1:
                        _a.apply(void 0, [
                            _b.sent()
                        ]);
                        return [
                            4,
                            (0, $03ff035b4ab3e762$export$2e2bcd8739ae039).getPageNumbers()
                        ];
                    case 2:
                        return [
                            2,
                            _b.sent()
                        ];
                }
            });
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $97914e663a317172$export$2e2bcd8739ae039), {
        sm: 6,
        itemProps: [
            {
                type: "data",
                key: "reportYear",
                text: "Year"
            },
            {
                type: "data",
                key: "email",
                text: "Downloader"
            }
        ],
        items: record,
        addInfo: {
            text: "Reports Downloaders",
            handler: function() {}
        },
        actionID: "id",
        loadRecords: loadRecords,
        doShowCardHeader: true,
        doShowTableHeader: true
    });
};
var $b77fc0fe1b78031c$export$2e2bcd8739ae039 = $b77fc0fe1b78031c$var$ReportsDownloaders;


var $ccace026e372098f$var$RecordReportsDownloadersRoutes = {
    recordListReportsDownloaders: {
        Component: (0, $b77fc0fe1b78031c$export$2e2bcd8739ae039),
        type: "private",
        route: "/members/records/reports-downloaders",
        title: "Reports Downloaders",
        breadcrumb: [
            {
                title: "Home",
                route: "/"
            }
        ]
    }
};
var $ccace026e372098f$export$2e2bcd8739ae039 = $ccace026e372098f$var$RecordReportsDownloadersRoutes;


var $48a01249ed79482a$var$__assign = undefined && undefined.__assign || function() {
    $48a01249ed79482a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $48a01249ed79482a$var$__assign.apply(this, arguments);
};
var $48a01249ed79482a$var$RecordsRoutes = $48a01249ed79482a$var$__assign({}, (0, $ccace026e372098f$export$2e2bcd8739ae039));
var $48a01249ed79482a$export$2e2bcd8739ae039 = $48a01249ed79482a$var$RecordsRoutes;


var $8d99a7d5dbb5bf9a$var$__assign = undefined && undefined.__assign || function() {
    $8d99a7d5dbb5bf9a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8d99a7d5dbb5bf9a$var$__assign.apply(this, arguments);
};
var $8d99a7d5dbb5bf9a$var$MemberRoutes = $8d99a7d5dbb5bf9a$var$__assign($8d99a7d5dbb5bf9a$var$__assign($8d99a7d5dbb5bf9a$var$__assign($8d99a7d5dbb5bf9a$var$__assign({
    dashboard: {
        Component: (0, $96e9d5022f95f8a8$export$2e2bcd8739ae039),
        type: "private",
        route: "/",
        title: "Dashboard",
        breadcrumb: [
            {
                title: "Home",
                route: "/"
            }
        ]
    }
}, (0, $d94fcb777a6e8507$export$2e2bcd8739ae039)), (0, $ce51c19f5e6b6167$export$2e2bcd8739ae039)), (0, $581919de262e859f$export$2e2bcd8739ae039)), (0, $48a01249ed79482a$export$2e2bcd8739ae039));
var $8d99a7d5dbb5bf9a$export$2e2bcd8739ae039 = $8d99a7d5dbb5bf9a$var$MemberRoutes;



var $7fPBF = parcelRequire("7fPBF");
var $dcc8248ae17d0157$var$NotFoundPage = function() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("h1", null, "404"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("p", null, "Page not found."));
};
var $dcc8248ae17d0157$export$2e2bcd8739ae039 = $dcc8248ae17d0157$var$NotFoundPage;


var $68c9b59f43b34021$var$PublicRoutes = {
    NotFound: {
        Component: (0, $dcc8248ae17d0157$export$2e2bcd8739ae039),
        type: "public",
        route: "*"
    }
};
var $68c9b59f43b34021$export$2e2bcd8739ae039 = $68c9b59f43b34021$var$PublicRoutes;


var $f5cd700b607f5c94$var$__assign = undefined && undefined.__assign || function() {
    $f5cd700b607f5c94$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f5cd700b607f5c94$var$__assign.apply(this, arguments);
};
var $f5cd700b607f5c94$var$PageRoutes = $f5cd700b607f5c94$var$__assign($f5cd700b607f5c94$var$__assign($f5cd700b607f5c94$var$__assign({}, (0, $0a4caa2c2698f967$export$2e2bcd8739ae039)), (0, $8d99a7d5dbb5bf9a$export$2e2bcd8739ae039)), (0, $68c9b59f43b34021$export$2e2bcd8739ae039));
var $f5cd700b607f5c94$export$2e2bcd8739ae039 = $f5cd700b607f5c94$var$PageRoutes;



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $4b22ed45c8105c74$exports = {};
$4b22ed45c8105c74$exports = JSON.parse('{"name":"startupmuster-admin-fe-v2","version":"1.4.2","private":true,"dependencies":{"@aws-amplify/auth":"^5.6.4","@aws-amplify/ui-react":"^5.3.1","@emotion/react":"^11.11.1","@emotion/styled":"^11.11.0","@mui/icons-material":"^5.14.8","@mui/material":"^5.14.8","@parcel/transformer-css":"^2.9.3","@parcel/transformer-sass":"^2.9.3","@types/node":"^16.7.13","@types/react":"^18.2.21","@types/react-dom":"^18.2.7","@types/react-window":"^1.8.8","aws-amplify":"^5.3.10","caniuse-lite":"^1.0.30001538","cross-env":"^7.0.3","dompurify":"^3.0.6","quill":"^1.3.7","react":"^18.2.0","react-dnd":"^16.0.1","react-dnd-html5-backend":"^16.0.1","react-dom":"^18.2.0","react-gesture-responder":"^2.1.0","react-google-recaptcha-v3":"^1.10.1","react-grid-dnd":"^2.1.2","react-helmet":"^6.1.0","react-quill":"^2.0.0","react-router-dom":"^6.15.0","react-scripts":"5.0.1","react-toastify":"^9.1.3","react-virtualized-auto-sizer":"^1.0.20","react-window":"^1.8.9","sass":"^1.67.0","styled-components":"^6.0.7","typescript":"^5.2.2","uuid":"^9.0.1","web-vitals":"^2.1.0"},"scripts":{"start-fe":"cross-env REACT_APP_System=ui rm -rf ./.parcel-cache && cross-env REACT_APP_System=ui yarn parcel serve public/index.html --port 1234  --dist-dir ./dist/fe & cross-env REACT_APP_System=ui browser-sync start --host 192.168.1.2 --proxy \\"localhost:1234\\" --files \\"dist/fe/**/*.*\\"","start-admin":"cross-env REACT_APP_System=admin rm -rf ./.parcel-cache && cross-env REACT_APP_System=admin yarn parcel serve public/index.html  --port 1235 --dist-dir ./dist/admin & cross-env REACT_APP_System=admin browser-sync start --proxy \\"localhost:1235\\" --files \\"dist/admin/**/*.*\\"","build-fe-reports":"cross-env REACT_APP_System=ui rm -rf ./.parcel-cache && cross-env REACT_APP_System=ui parcel build public/index.html --dist-dir ./build/fe/reports --public-url /reports/","build-fe-about":"cross-env REACT_APP_System=ui rm -rf ./.parcel-cache && cross-env REACT_APP_System=ui parcel build public/index.html --dist-dir ./build/fe/about","build-fe":"cross-env REACT_APP_System=ui rm -rf ./.parcel-cache && cross-env REACT_APP_System=ui yarn parcel build public/index.html  --dist-dir ./build/fe --public-url /","build-admin":"cross-env REACT_APP_System=admin rm -rf ./.parcel-cache && cross-env REACT_APP_System=admin yarn parcel build public/index.html --dist-dir ./build/admin ","server-fe":"browser-sync start --server build/fe --files \\"build/fe/**/*.*\\" --no-notify --port 3000","server-admin":"browser-sync start --server build/admin --files \\"build/admin/**/*.*\\" --no-notify --port 3001","build":"yarn parcel build public/index.html --dist-dir ./build","test":"jest --colors","eject":"react-scripts eject","test-coverage":"yarn jest --clearCache;yarn test -- --coverage","storybook":"storybook dev -p 6006","build-storybook":"storybook build"},"eslintConfig":{"extends":["react-app","react-app/jest"]},"browserslist":{"production":[">0.2%","not dead","not op_mini all"],"development":["last 1 chrome version","last 1 firefox version","last 1 safari version"]},"devDependencies":{"@babel/core":"^7.22.17","@babel/preset-react":"^7.22.15","@babel/preset-typescript":"^7.22.15","@hot-loader/react-dom":"^17.0.2","@parcel/packager-raw-url":"^2.9.3","@parcel/transformer-typescript-tsc":"^2.9.3","@parcel/transformer-webmanifest":"^2.9.3","@storybook/addon-actions":"^7.4.1","@storybook/addon-essentials":"^7.4.1","@storybook/addon-interactions":"^7.4.1","@storybook/addon-links":"^7.4.1","@storybook/addon-onboarding":"^1.0.8","@storybook/blocks":"^7.4.1","@storybook/preset-create-react-app":"^7.4.1","@storybook/react":"^7.4.1","@storybook/react-webpack5":"^7.4.1","@storybook/testing-library":"^0.2.0","@testing-library/jest-dom":"^6.1.3","@testing-library/react":"^14.0.0","@testing-library/react-hooks":"^8.0.1","@testing-library/user-event":"^14.4.3","@types/jest":"^29.5.4","@types/styled-components":"^5.1.27","@typescript-eslint/eslint-plugin":"^6.6.0","@typescript-eslint/parser":"^6.6.0","babel-jest":"^29.6.4","babel-loader":"^9.1.3","babel-plugin-module-resolver":"^5.0.0","babel-plugin-named-exports-order":"^0.0.2","browser-sync":"^2.29.3","buffer":"^5.5.0||^6.0.0","customize-cra":"^1.0.0","eslint":"^8.48.0","eslint-config-prettier":"^9.0.0","eslint-config-standard-with-typescript":"^39.0.0","eslint-plugin-n":"^16.1.0","eslint-plugin-prettier":"^5.0.0","eslint-plugin-promise":"^6.1.1","eslint-plugin-react":"^7.33.2","eslint-plugin-security":"^1.7.1","eslint-plugin-storybook":"^0.6.13","history":"^5.3.0","http-server":"^14.1.1","jest":"^29.7.0","jest-environment-jsdom-sixteen":"^2.0.0","parcel":"^2.9.3","prettier":"^3.0.3","process":"^0.11.10","prop-types":"^15.8.1","punycode":"^1.4.1","querystring-es3":"^0.2.1","react-app-rewired":"^2.2.1","react-hot-loader":"^4.13.1","storybook":"^7.4.1","ts-jest":"^29.1.1","ts-loader":"^9.4.4","webpack":"^5.88.2"}}');



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $7fPBF = parcelRequire("7fPBF");
"use client";
const $8058a65d531805f3$var$usePreviousProps = (value)=>{
    const ref = $7fPBF.useRef({});
    $7fPBF.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $8058a65d531805f3$export$2e2bcd8739ae039 = $8058a65d531805f3$var$usePreviousProps;



var $cFCqu = parcelRequire("cFCqu");

"use client";
function $d84a6b6441baa24e$export$6105a25a68f1d9ae(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero: showZero = false } = parameters;
    const prevProps = (0, $8058a65d531805f3$export$2e2bcd8739ae039)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent: badgeContent, max: max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue
    };
}




var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $b6UUh = parcelRequire("b6UUh");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $02ea6fcaa7760459$export$aaccef17e6dab084(slot) {
    return (0, $k6RDS.default)("MuiBadge", slot);
}
const $02ea6fcaa7760459$var$badgeClasses = (0, $4jzsB.default)("MuiBadge", [
    "root",
    "badge",
    "dot",
    "standard",
    "anchorOriginTopRight",
    "anchorOriginBottomRight",
    "anchorOriginTopLeft",
    "anchorOriginBottomLeft",
    "invisible",
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "overlapRectangular",
    "overlapCircular",
    // TODO: v6 remove the overlap value from these class keys
    "anchorOriginTopLeftCircular",
    "anchorOriginTopLeftRectangular",
    "anchorOriginTopRightCircular",
    "anchorOriginTopRightRectangular",
    "anchorOriginBottomLeftCircular",
    "anchorOriginBottomLeftRectangular",
    "anchorOriginBottomRightCircular",
    "anchorOriginBottomRightRectangular"
]);
var $02ea6fcaa7760459$export$2e2bcd8739ae039 = $02ea6fcaa7760459$var$badgeClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $a5e88fe2e369b9f6$var$_excluded = [
    "anchorOrigin",
    "className",
    "classes",
    "component",
    "components",
    "componentsProps",
    "children",
    "overlap",
    "color",
    "invisible",
    "max",
    "badgeContent",
    "slots",
    "slotProps",
    "showZero",
    "variant"
];
const $a5e88fe2e369b9f6$var$RADIUS_STANDARD = 10;
const $a5e88fe2e369b9f6$var$RADIUS_DOT = 4;
const $a5e88fe2e369b9f6$var$useUtilityClasses = (ownerState)=>{
    const { color: color, anchorOrigin: anchorOrigin, invisible: invisible, overlap: overlap, variant: variant, classes: classes = {} } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        badge: [
            "badge",
            variant,
            invisible && "invisible",
            `anchorOrigin${(0, $b6UUh.default)(anchorOrigin.vertical)}${(0, $b6UUh.default)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, $b6UUh.default)(anchorOrigin.vertical)}${(0, $b6UUh.default)(anchorOrigin.horizontal)}${(0, $b6UUh.default)(overlap)}`,
            `overlap${(0, $b6UUh.default)(overlap)}`,
            color !== "default" && `color${(0, $b6UUh.default)(color)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $02ea6fcaa7760459$export$aaccef17e6dab084), classes);
};
const $a5e88fe2e369b9f6$var$BadgeRoot = (0, $kDBhE.default)("span", {
    name: "MuiBadge",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    position: "relative",
    display: "inline-flex",
    // For correct alignment with the text.
    verticalAlign: "middle",
    flexShrink: 0
});
const $a5e88fe2e369b9f6$var$BadgeBadge = (0, $kDBhE.default)("span", {
    name: "MuiBadge",
    slot: "Badge",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, $b6UUh.default)(ownerState.anchorOrigin.vertical)}${(0, $b6UUh.default)(ownerState.anchorOrigin.horizontal)}${(0, $b6UUh.default)(ownerState.overlap)}`],
            ownerState.color !== "default" && styles[`color${(0, $b6UUh.default)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        position: "absolute",
        boxSizing: "border-box",
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: $a5e88fe2e369b9f6$var$RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: "0 6px",
        height: $a5e88fe2e369b9f6$var$RADIUS_STANDARD * 2,
        borderRadius: $a5e88fe2e369b9f6$var$RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        })
    }, ownerState.color !== "default" && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.variant === "dot" && {
        borderRadius: $a5e88fe2e369b9f6$var$RADIUS_DOT,
        height: $a5e88fe2e369b9f6$var$RADIUS_DOT * 2,
        minWidth: $a5e88fe2e369b9f6$var$RADIUS_DOT * 2,
        padding: 0
    }, ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "rectangular" && {
        top: 0,
        right: 0,
        transform: "scale(1) translate(50%, -50%)",
        transformOrigin: "100% 0%",
        [`&.${(0, $02ea6fcaa7760459$export$2e2bcd8739ae039).invisible}`]: {
            transform: "scale(0) translate(50%, -50%)"
        }
    }, ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "rectangular" && {
        bottom: 0,
        right: 0,
        transform: "scale(1) translate(50%, 50%)",
        transformOrigin: "100% 100%",
        [`&.${(0, $02ea6fcaa7760459$export$2e2bcd8739ae039).invisible}`]: {
            transform: "scale(0) translate(50%, 50%)"
        }
    }, ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "rectangular" && {
        top: 0,
        left: 0,
        transform: "scale(1) translate(-50%, -50%)",
        transformOrigin: "0% 0%",
        [`&.${(0, $02ea6fcaa7760459$export$2e2bcd8739ae039).invisible}`]: {
            transform: "scale(0) translate(-50%, -50%)"
        }
    }, ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "rectangular" && {
        bottom: 0,
        left: 0,
        transform: "scale(1) translate(-50%, 50%)",
        transformOrigin: "0% 100%",
        [`&.${(0, $02ea6fcaa7760459$export$2e2bcd8739ae039).invisible}`]: {
            transform: "scale(0) translate(-50%, 50%)"
        }
    }, ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "circular" && {
        top: "14%",
        right: "14%",
        transform: "scale(1) translate(50%, -50%)",
        transformOrigin: "100% 0%",
        [`&.${(0, $02ea6fcaa7760459$export$2e2bcd8739ae039).invisible}`]: {
            transform: "scale(0) translate(50%, -50%)"
        }
    }, ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "circular" && {
        bottom: "14%",
        right: "14%",
        transform: "scale(1) translate(50%, 50%)",
        transformOrigin: "100% 100%",
        [`&.${(0, $02ea6fcaa7760459$export$2e2bcd8739ae039).invisible}`]: {
            transform: "scale(0) translate(50%, 50%)"
        }
    }, ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "circular" && {
        top: "14%",
        left: "14%",
        transform: "scale(1) translate(-50%, -50%)",
        transformOrigin: "0% 0%",
        [`&.${(0, $02ea6fcaa7760459$export$2e2bcd8739ae039).invisible}`]: {
            transform: "scale(0) translate(-50%, -50%)"
        }
    }, ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "circular" && {
        bottom: "14%",
        left: "14%",
        transform: "scale(1) translate(-50%, 50%)",
        transformOrigin: "0% 100%",
        [`&.${(0, $02ea6fcaa7760459$export$2e2bcd8739ae039).invisible}`]: {
            transform: "scale(0) translate(-50%, 50%)"
        }
    }, ownerState.invisible && {
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.leavingScreen
        })
    }));
const $a5e88fe2e369b9f6$var$Badge = /*#__PURE__*/ $7fPBF.forwardRef(function Badge(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$badge, _slotProps$root, _slotProps$badge;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiBadge"
    });
    const { anchorOrigin: anchorOriginProp = {
        vertical: "top",
        horizontal: "right"
    }, className: className, component: component, components: components = {}, componentsProps: componentsProps = {}, children: children, overlap: overlapProp = "rectangular", color: colorProp = "default", invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots: slots, slotProps: slotProps, showZero: showZero = false, variant: variantProp = "standard" } = props, other = (0, $cFLic.default)(props, $a5e88fe2e369b9f6$var$_excluded);
    const { badgeContent: badgeContent, invisible: invisibleFromHook, max: max, displayValue: displayValueFromHook } = (0, $d84a6b6441baa24e$export$6105a25a68f1d9ae)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero
    });
    const prevProps = (0, $8058a65d531805f3$export$2e2bcd8739ae039)({
        anchorOrigin: anchorOriginProp,
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== "dot";
    const { color: color = colorProp, overlap: overlap = overlapProp, anchorOrigin: anchorOrigin = anchorOriginProp, variant: variant = variantProp } = invisible ? prevProps : props;
    const displayValue = variant !== "dot" ? displayValueFromHook : undefined;
    const ownerState = (0, $kY3Ke.default)({}, props, {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue,
        showZero: showZero,
        anchorOrigin: anchorOrigin,
        color: color,
        overlap: overlap,
        variant: variant
    });
    const classes = $a5e88fe2e369b9f6$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $a5e88fe2e369b9f6$var$BadgeRoot;
    const BadgeSlot = (_ref2 = (_slots$badge = slots == null ? void 0 : slots.badge) != null ? _slots$badge : components.Badge) != null ? _ref2 : $a5e88fe2e369b9f6$var$BadgeBadge;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const badgeSlotProps = (_slotProps$badge = slotProps == null ? void 0 : slotProps.badge) != null ? _slotProps$badge : componentsProps.badge;
    const rootProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $hngXp.default)(rootSlotProps == null ? void 0 : rootSlotProps.className, classes.root, className)
    });
    const badgeProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: BadgeSlot,
        externalSlotProps: badgeSlotProps,
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.badge, badgeSlotProps == null ? void 0 : badgeSlotProps.className)
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)(RootSlot, (0, $kY3Ke.default)({}, rootProps, {
        children: [
            children,
            /*#__PURE__*/ (0, $bbzbN.jsx)(BadgeSlot, (0, $kY3Ke.default)({}, badgeProps, {
                children: displayValue
            }))
        ]
    }));
});
var $a5e88fe2e369b9f6$export$2e2bcd8739ae039 = $a5e88fe2e369b9f6$var$Badge;



var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $5cc76d37cd9568d2$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20z"
}), "AccountCircle");


var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $372ae2b649be1ab3$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), "Menu");


var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $2f60b410f5011765$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
}), "Notifications");







var $7fPBF = parcelRequire("7fPBF");

var $38WAi = parcelRequire("38WAi");
var $84PRT = parcelRequire("84PRT");

"use client";
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $ee4a86a3270f4470$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $7fPBF.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $ee4a86a3270f4470$var$maybeReactUseSyncExternalStore = $7fPBF.useSyncExternalStore;
function $ee4a86a3270f4470$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $7fPBF.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $7fPBF.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $7fPBF.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $ee4a86a3270f4470$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $ee4a86a3270f4470$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $84PRT.default)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $38WAi.default)({
        name: "MuiUseMediaQuery",
        props: options,
        theme: theme
    });
    let query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, "");
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $ee4a86a3270f4470$var$maybeReactUseSyncExternalStore !== undefined ? $ee4a86a3270f4470$var$useMediaQueryNew : $ee4a86a3270f4470$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}



var $52c628f697c03739$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $52c628f697c03739$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $52c628f697c03739$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $52c628f697c03739$var$AdminPanelLabel = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039))($52c628f697c03739$var$templateObject_1 || ($52c628f697c03739$var$templateObject_1 = $52c628f697c03739$var$__makeTemplateObject([
    "\n  flex-grow: 1; // Allows the label to take up the remaining space\n  color: white;\n  margin-right: 16px; // To give some spacing before the icons\n"
], [
    "\n  flex-grow: 1; // Allows the label to take up the remaining space\n  color: white;\n  margin-right: 16px; // To give some spacing before the icons\n"
])));
var $52c628f697c03739$var$PrivateNavbar = function(_a) {
    var navigate = _a.navigate, onThemeToggle = _a.onThemeToggle, toggleSideBar = _a.toggleSideBar;
    var isTabletOrSmaller = (0, $ee4a86a3270f4470$export$2e2bcd8739ae039)("(max-width:1023px)");
    // screens less than 1024px
    var _b = (0, $7fPBF.useState)(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var handleProfileMenuOpen = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleMenuClose = function(url) {
        setAnchorEl(null);
    };
    var handleMenuLogout = function() {
        return $52c628f697c03739$var$__awaiter(void 0, void 0, void 0, function() {
            return $52c628f697c03739$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $9e453b5784a8464e$export$334c29725a78c21d).signOut()
                        ];
                    case 1:
                        _a.sent();
                        (0, $de77e498e07914bf$export$b410431fab84fa58).info("Logout successful");
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).clear()
                        ];
                    case 2:
                        _a.sent();
                        navigate("/login");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e049be44ef4f8ddc$export$e1f54711bfda4290), {
        position: "static"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e049be44ef4f8ddc$export$f3f426abf36f8c0), null, isTabletOrSmaller && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
        color: "inherit",
        onClick: toggleSideBar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $372ae2b649be1ab3$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($52c628f697c03739$var$AdminPanelLabel, {
        variant: "h6"
    }, "Admin Panel (V ", (0, (/*@__PURE__*/$parcel$interopDefault($4b22ed45c8105c74$exports))).version, ")"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
        color: "inherit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a5e88fe2e369b9f6$export$2e2bcd8739ae039), {
        badgeContent: 4,
        color: "secondary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2f60b410f5011765$export$2e2bcd8739ae039), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
        edge: "end",
        "aria-label": "account of current user",
        "aria-controls": "primary-search-account-menu",
        "aria-haspopup": "true",
        onClick: handleProfileMenuOpen,
        color: "inherit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $5cc76d37cd9568d2$export$2e2bcd8739ae039), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
        anchorEl: anchorEl,
        anchorOrigin: {
            vertical: "top",
            horizontal: "right"
        },
        id: "primary-search-account-menu",
        keepMounted: true,
        transformOrigin: {
            vertical: "top",
            horizontal: "right"
        },
        open: Boolean(anchorEl),
        onClose: handleMenuClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
        onClick: function() {
            handleMenuClose("/members/user/profile");
        }
    }, "Profile"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
        onClick: function() {
            handleMenuClose("/members/settings");
        }
    }, "Account Settings"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
        onClick: handleMenuLogout
    }, "Logout")));
};
var $52c628f697c03739$export$2e2bcd8739ae039 = $52c628f697c03739$var$PrivateNavbar;
var $52c628f697c03739$var$templateObject_1;





var $7fPBF = parcelRequire("7fPBF");




var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $3b977dfc67db1ec5$var$_excluded = [
    "className"
];
const $3b977dfc67db1ec5$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            alignItems === "flex-start" && "alignItemsFlexStart"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $7a8a9052410fb062$export$81478e24460c57f2), classes);
};
const $3b977dfc67db1ec5$var$ListItemIconRoot = (0, $kDBhE.default)("div", {
    name: "MuiListItemIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: "inline-flex"
    }, ownerState.alignItems === "flex-start" && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $3b977dfc67db1ec5$var$ListItemIcon = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiListItemIcon"
    });
    const { className: className } = props, other = (0, $cFLic.default)(props, $3b977dfc67db1ec5$var$_excluded);
    const context = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    const ownerState = (0, $kY3Ke.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $3b977dfc67db1ec5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($3b977dfc67db1ec5$var$ListItemIconRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $3b977dfc67db1ec5$export$2e2bcd8739ae039 = $3b977dfc67db1ec5$var$ListItemIcon;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");



var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");


var $bbzbN = parcelRequire("bbzbN");
"use client";
const $9dc4208e00f56723$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $9dc4208e00f56723$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            "root",
            inset && "inset",
            dense && "dense",
            primary && secondary && "multiline"
        ],
        primary: [
            "primary"
        ],
        secondary: [
            "secondary"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $2a8a1c268392e331$export$1061006a0db3aeb5), classes);
};
const $9dc4208e00f56723$var$ListItemTextRoot = (0, $kDBhE.default)("div", {
    name: "MuiListItemText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $2a8a1c268392e331$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $2a8a1c268392e331$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        flex: "1 1 auto",
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $9dc4208e00f56723$var$ListItemText = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiListItemText"
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $cFLic.default)(props, $9dc4208e00f56723$var$_excluded);
    const { dense: dense } = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $9dc4208e00f56723$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $26f68e516ee75fc4$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
        variant: dense ? "body2" : "body1",
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : "span",
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $26f68e516ee75fc4$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($9dc4208e00f56723$var$ListItemTextRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
var $9dc4208e00f56723$export$2e2bcd8739ae039 = $9dc4208e00f56723$var$ListItemText;





var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");


var $cxeT8 = parcelRequire("cxeT8");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");






var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $0ca5a1e6788dced6$export$5682c366c0c669d9(slot) {
    return (0, $k6RDS.default)("MuiListItem", slot);
}
const $0ca5a1e6788dced6$var$listItemClasses = (0, $4jzsB.default)("MuiListItem", [
    "root",
    "container",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "padding",
    "button",
    "secondaryAction",
    "selected"
]);
var $0ca5a1e6788dced6$export$2e2bcd8739ae039 = $0ca5a1e6788dced6$var$listItemClasses;



var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $5af8cd7874d684d8$export$c09531d8563c67a5(slot) {
    return (0, $k6RDS.default)("MuiListItemButton", slot);
}
const $5af8cd7874d684d8$var$listItemButtonClasses = (0, $4jzsB.default)("MuiListItemButton", [
    "root",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $5af8cd7874d684d8$export$2e2bcd8739ae039 = $5af8cd7874d684d8$var$listItemButtonClasses;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");


var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $90836af743b99227$export$ccdb26aeba48a86e(slot) {
    return (0, $k6RDS.default)("MuiListItemSecondaryAction", slot);
}
const $90836af743b99227$var$listItemSecondaryActionClasses = (0, $4jzsB.default)("MuiListItemSecondaryAction", [
    "root",
    "disableGutters"
]);
var $90836af743b99227$export$2e2bcd8739ae039 = $90836af743b99227$var$listItemSecondaryActionClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $a4e848490d2ab66f$var$_excluded = [
    "className"
];
const $a4e848490d2ab66f$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disableGutters && "disableGutters"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $90836af743b99227$export$ccdb26aeba48a86e), classes);
};
const $a4e848490d2ab66f$var$ListItemSecondaryActionRoot = (0, $kDBhE.default)("div", {
    name: "MuiListItemSecondaryAction",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        position: "absolute",
        right: 16,
        top: "50%",
        transform: "translateY(-50%)"
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $a4e848490d2ab66f$var$ListItemSecondaryAction = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiListItemSecondaryAction"
    });
    const { className: className } = props, other = (0, $cFLic.default)(props, $a4e848490d2ab66f$var$_excluded);
    const context = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $a4e848490d2ab66f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($a4e848490d2ab66f$var$ListItemSecondaryActionRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$a4e848490d2ab66f$var$ListItemSecondaryAction.muiName = "ListItemSecondaryAction";
var $a4e848490d2ab66f$export$2e2bcd8739ae039 = $a4e848490d2ab66f$var$ListItemSecondaryAction;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $2c1b031ce0fa2278$var$_excluded = [
    "className"
], $2c1b031ce0fa2278$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const $2c1b031ce0fa2278$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $2c1b031ce0fa2278$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, button: button, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            !disableGutters && "gutters",
            !disablePadding && "padding",
            divider && "divider",
            disabled && "disabled",
            button && "button",
            alignItems === "flex-start" && "alignItemsFlexStart",
            hasSecondaryAction && "secondaryAction",
            selected && "selected"
        ],
        container: [
            "container"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $0ca5a1e6788dced6$export$5682c366c0c669d9), classes);
};
const $2c1b031ce0fa2278$export$aed538f7519abe89 = (0, $kDBhE.default)("div", {
    name: "MuiListItem",
    slot: "Root",
    overridesResolver: $2c1b031ce0fa2278$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        width: "100%",
        boxSizing: "border-box",
        textAlign: "left"
    }, !ownerState.disablePadding && (0, $kY3Ke.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $5af8cd7874d684d8$export$2e2bcd8739ae039).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $0ca5a1e6788dced6$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $0ca5a1e6788dced6$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $0ca5a1e6788dced6$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $0ca5a1e6788dced6$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === "flex-start" && {
        alignItems: "flex-start"
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, ownerState.button && {
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $0ca5a1e6788dced6$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $2c1b031ce0fa2278$var$ListItemContainer = (0, $kDBhE.default)("li", {
    name: "MuiListItem",
    slot: "Container",
    overridesResolver: (props, styles)=>styles.container
})({
    position: "relative"
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $2c1b031ce0fa2278$var$ListItem = /*#__PURE__*/ $7fPBF.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiListItem"
    });
    const { alignItems: alignItems = "center", autoFocus: autoFocus = false, button: button = false, children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = "li", ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disabled: disabled = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, secondaryAction: secondaryAction, selected: selected = false, slotProps: slotProps = {}, slots: slots = {} } = props, ContainerProps = (0, $cFLic.default)(props.ContainerProps, $2c1b031ce0fa2278$var$_excluded), other = (0, $cFLic.default)(props, $2c1b031ce0fa2278$var$_excluded2);
    const context = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    const childContext = $7fPBF.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $7fPBF.useRef(null);
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = $7fPBF.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $6926d37cb7ff7774$export$2e2bcd8739ae039)(children[children.length - 1], [
        "ListItemSecondaryAction"
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $2c1b031ce0fa2278$var$useUtilityClasses(ownerState);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(listItemRef, ref);
    const Root = slots.root || components.Root || $2c1b031ce0fa2278$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || "li";
    if (button) {
        componentProps.component = componentProp || "div";
        componentProps.focusVisibleClassName = (0, $hngXp.default)((0, $0ca5a1e6788dced6$export$2e2bcd8739ae039).focusVisible, focusVisibleClassName);
        Component = (0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? "div" : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === "li") {
            if (Component === "li") Component = "div";
            else if (componentProps.component === "li") componentProps.component = "div";
        }
        return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $94e271e17fd22222$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $bbzbN.jsxs)($2c1b031ce0fa2278$var$ListItemContainer, (0, $kY3Ke.default)({
                as: ContainerComponent,
                className: (0, $hngXp.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)(Root, (0, $kY3Ke.default)({}, rootProps, !(0, $59c589404b20ab2d$export$e28348cc2430497)(Root) && {
                        as: Component,
                        ownerState: (0, $kY3Ke.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $94e271e17fd22222$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)(Root, (0, $kY3Ke.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, $59c589404b20ab2d$export$e28348cc2430497)(Root) && {
            ownerState: (0, $kY3Ke.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a4e848490d2ab66f$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
var $2c1b031ce0fa2278$export$2e2bcd8739ae039 = $2c1b031ce0fa2278$var$ListItem;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");






var $bbzbN = parcelRequire("bbzbN");
"use client";
const $37a9e765f5011e1f$var$_excluded = [
    "alignItems",
    "autoFocus",
    "component",
    "children",
    "dense",
    "disableGutters",
    "divider",
    "focusVisibleClassName",
    "selected",
    "className"
];
const $37a9e765f5011e1f$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $37a9e765f5011e1f$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, divider: divider, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            !disableGutters && "gutters",
            divider && "divider",
            disabled && "disabled",
            alignItems === "flex-start" && "alignItemsFlexStart",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $5af8cd7874d684d8$export$c09531d8563c67a5), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $37a9e765f5011e1f$var$ListItemButtonRoot = (0, $kDBhE.default)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $kDBhE.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiListItemButton",
    slot: "Root",
    overridesResolver: $37a9e765f5011e1f$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "flex",
        flexGrow: 1,
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minWidth: 0,
        boxSizing: "border-box",
        textAlign: "left",
        paddingTop: 8,
        paddingBottom: 8,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $5af8cd7874d684d8$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $5af8cd7874d684d8$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $5af8cd7874d684d8$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $5af8cd7874d684d8$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $5af8cd7874d684d8$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, ownerState.alignItems === "flex-start" && {
        alignItems: "flex-start"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }));
const $37a9e765f5011e1f$var$ListItemButton = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemButton(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiListItemButton"
    });
    const { alignItems: alignItems = "center", autoFocus: autoFocus = false, component: component = "div", children: children, dense: dense = false, disableGutters: disableGutters = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, selected: selected = false, className: className } = props, other = (0, $cFLic.default)(props, $37a9e765f5011e1f$var$_excluded);
    const context = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    const childContext = $7fPBF.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $7fPBF.useRef(null);
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        divider: divider,
        selected: selected
    });
    const classes = $37a9e765f5011e1f$var$useUtilityClasses(ownerState);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(listItemRef, ref);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $94e271e17fd22222$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($37a9e765f5011e1f$var$ListItemButtonRoot, (0, $kY3Ke.default)({
            ref: handleRef,
            href: other.href || other.to,
            component: (other.href || other.to) && component === "div" ? "button" : component,
            focusVisibleClassName: (0, $hngXp.default)(classes.focusVisible, focusVisibleClassName),
            ownerState: ownerState,
            className: (0, $hngXp.default)(classes.root, className)
        }, other, {
            classes: classes,
            children: children
        }))
    });
});
var $37a9e765f5011e1f$export$2e2bcd8739ae039 = $37a9e765f5011e1f$var$ListItemButton;



var $4812ef34f63b7d58$var$__makeTemplateObject = undefined && undefined.__makeTemplateObject || function(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
};
var $4812ef34f63b7d58$export$4a2034c9f860b7cd = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $77ec199cefd4182a$export$2e2bcd8739ae039))($4812ef34f63b7d58$var$templateObject_1 || ($4812ef34f63b7d58$var$templateObject_1 = $4812ef34f63b7d58$var$__makeTemplateObject([
    "\n  background-color: #367fbb;\n  margin: 5px !important;\n"
], [
    "\n  background-color: #367fbb;\n  margin: 5px !important;\n"
])));
var $4812ef34f63b7d58$export$ecbb77022efc44cf = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $2c1b031ce0fa2278$export$2e2bcd8739ae039))($4812ef34f63b7d58$var$templateObject_2 || ($4812ef34f63b7d58$var$templateObject_2 = $4812ef34f63b7d58$var$__makeTemplateObject([
    "\n  margin: 0 !important;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n"
], [
    "\n  margin: 0 !important;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n"
])));
var $4812ef34f63b7d58$export$502d4b3db84df618 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039))($4812ef34f63b7d58$var$templateObject_3 || ($4812ef34f63b7d58$var$templateObject_3 = $4812ef34f63b7d58$var$__makeTemplateObject([
    "\n  border-radius: 6px;\n  margin-top: 5px !important;\n"
], [
    "\n  border-radius: 6px;\n  margin-top: 5px !important;\n"
])));
var $4812ef34f63b7d58$export$f5d6dce4f2f10f7d = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $37a9e765f5011e1f$export$2e2bcd8739ae039))($4812ef34f63b7d58$var$templateObject_4 || ($4812ef34f63b7d58$var$templateObject_4 = $4812ef34f63b7d58$var$__makeTemplateObject([
    "\n  border-radius: 6px;\n  margin-top: 0 !important;\n  padding-top: 0 !important;\n  margin-bottom: 0 !important;\n  padding-bottom: 0 !important;\n"
], [
    "\n  border-radius: 6px;\n  margin-top: 0 !important;\n  padding-top: 0 !important;\n  margin-bottom: 0 !important;\n  padding-bottom: 0 !important;\n"
])));
var $4812ef34f63b7d58$export$6fbb8dcf01447d41 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $2c1b031ce0fa2278$export$2e2bcd8739ae039))($4812ef34f63b7d58$var$templateObject_5 || ($4812ef34f63b7d58$var$templateObject_5 = $4812ef34f63b7d58$var$__makeTemplateObject([
    "\n  margin-top: 10px !important;\n  padding-top: 0 !important;\n  margin-bottom: 0 !important;\n  padding-bottom: 0 !important;\n"
], [
    "\n  margin-top: 10px !important;\n  padding-top: 0 !important;\n  margin-bottom: 0 !important;\n  padding-bottom: 0 !important;\n"
])));
var $4812ef34f63b7d58$export$a1ec7fd90f147fa8 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)((0, $9dc4208e00f56723$export$2e2bcd8739ae039))($4812ef34f63b7d58$var$templateObject_6 || ($4812ef34f63b7d58$var$templateObject_6 = $4812ef34f63b7d58$var$__makeTemplateObject([
    "\n  font-size: 14px !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  && .MuiListItemText-primary {\n    font-size: 14px; // adjust as needed\n  }\n"
], [
    "\n  font-size: 14px !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  && .MuiListItemText-primary {\n    font-size: 14px; // adjust as needed\n  }\n"
])));
var $4812ef34f63b7d58$var$templateObject_1, $4812ef34f63b7d58$var$templateObject_2, $4812ef34f63b7d58$var$templateObject_3, $4812ef34f63b7d58$var$templateObject_4, $4812ef34f63b7d58$var$templateObject_5, $4812ef34f63b7d58$var$templateObject_6;




var $5cbd76ecbd407bed$var$useOutsideClick = function(ref, callback) {
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        function handleClickOutside(event) {
            callback();
        } // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref,
        callback
    ]);
};
var $5cbd76ecbd407bed$var$Drawer = function(_a) {
    var toggleParentSideBar = _a.toggleParentSideBar, navigate = _a.navigate, openSideBar = _a.openSideBar;
    var isTabletOrSmaller = (0, $ee4a86a3270f4470$export$2e2bcd8739ae039)("(max-width:1023px)"); // screens less than 1024px
    var drawerRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    var _b = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false), drawerOpen = _b[0], setDrawerOpen = _b[1];
    $5cbd76ecbd407bed$var$useOutsideClick(drawerRef, function() {
        if (!openSideBar) return;
        setDrawerOpen(false);
        toggleParentSideBar();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        setDrawerOpen(openSideBar);
    }, [
        openSideBar
    ]);
    var open = isTabletOrSmaller ? drawerOpen : true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e049be44ef4f8ddc$export$7a49bdedb3cef1c4), {
        ref: drawerRef,
        variant: isTabletOrSmaller ? "temporary" : "permanent",
        open: open
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4812ef34f63b7d58$export$4a2034c9f860b7cd), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2a1f02c275eba654$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("nav", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $fb70212a09473954$export$2e2bcd8739ae039), null, Object.values((0, $0f1536060938b5c4$export$2e2bcd8739ae039)).map(function(drawer, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
            key: index
        }, drawer.type === "text" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4812ef34f63b7d58$export$6fbb8dcf01447d41), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4812ef34f63b7d58$export$f5d6dce4f2f10f7d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4812ef34f63b7d58$export$a1ec7fd90f147fa8), {
            primary: drawer.text
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4812ef34f63b7d58$export$ecbb77022efc44cf), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4812ef34f63b7d58$export$502d4b3db84df618), {
            onClick: function() {
                navigate(drawer.route);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $3b977dfc67db1ec5$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(drawer.icon, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $9dc4208e00f56723$export$2e2bcd8739ae039), {
            primary: drawer.text
        }))));
    }))));
};
var $5cbd76ecbd407bed$export$2e2bcd8739ae039 = $5cbd76ecbd407bed$var$Drawer;




var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");



var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");


var $cxeT8 = parcelRequire("cxeT8");

var $kDBhE = parcelRequire("kDBhE");
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $bf5ccaae290cc05e$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreHoriz");




var $bbzbN = parcelRequire("bbzbN");
"use client";
const $b9b83b4d3c9e8b74$var$_excluded = [
    "slots",
    "slotProps"
];
const $b9b83b4d3c9e8b74$var$BreadcrumbCollapsedButton = (0, $kDBhE.default)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039))(({ theme: theme })=>(0, $kY3Ke.default)({
        display: "flex",
        marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
        marginRight: `calc(${theme.spacing(1)} * 0.5)`
    }, theme.palette.mode === "light" ? {
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.grey[700]
    } : {
        backgroundColor: theme.palette.grey[700],
        color: theme.palette.grey[100]
    }, {
        borderRadius: 2,
        "&:hover, &:focus": (0, $kY3Ke.default)({}, theme.palette.mode === "light" ? {
            backgroundColor: theme.palette.grey[200]
        } : {
            backgroundColor: theme.palette.grey[600]
        }),
        "&:active": (0, $kY3Ke.default)({
            boxShadow: theme.shadows[0]
        }, theme.palette.mode === "light" ? {
            backgroundColor: (0, $cxeT8.emphasize)(theme.palette.grey[200], 0.12)
        } : {
            backgroundColor: (0, $cxeT8.emphasize)(theme.palette.grey[600], 0.12)
        })
    }));
const $b9b83b4d3c9e8b74$var$BreadcrumbCollapsedIcon = (0, $kDBhE.default)((0, $bf5ccaae290cc05e$export$2e2bcd8739ae039))({
    width: 24,
    height: 16
});
/**
 * @ignore - internal component.
 */ function $b9b83b4d3c9e8b74$var$BreadcrumbCollapsed(props) {
    const { slots: slots = {}, slotProps: slotProps = {} } = props, otherProps = (0, $cFLic.default)(props, $b9b83b4d3c9e8b74$var$_excluded);
    const ownerState = props;
    return /*#__PURE__*/ (0, $bbzbN.jsx)("li", {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($b9b83b4d3c9e8b74$var$BreadcrumbCollapsedButton, (0, $kY3Ke.default)({
            focusRipple: true
        }, otherProps, {
            ownerState: ownerState,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)($b9b83b4d3c9e8b74$var$BreadcrumbCollapsedIcon, (0, $kY3Ke.default)({
                as: slots.CollapsedIcon,
                ownerState: ownerState
            }, slotProps.collapsedIcon))
        }))
    });
}
var $b9b83b4d3c9e8b74$export$2e2bcd8739ae039 = $b9b83b4d3c9e8b74$var$BreadcrumbCollapsed;



var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $e85bea44bd9c3da4$export$17261110b18c8084(slot) {
    return (0, $k6RDS.default)("MuiBreadcrumbs", slot);
}
const $e85bea44bd9c3da4$var$breadcrumbsClasses = (0, $4jzsB.default)("MuiBreadcrumbs", [
    "root",
    "ol",
    "li",
    "separator"
]);
var $e85bea44bd9c3da4$export$2e2bcd8739ae039 = $e85bea44bd9c3da4$var$breadcrumbsClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $9d7afcdf99dc1f56$var$_excluded = [
    "children",
    "className",
    "component",
    "slots",
    "slotProps",
    "expandText",
    "itemsAfterCollapse",
    "itemsBeforeCollapse",
    "maxItems",
    "separator"
];
const $9d7afcdf99dc1f56$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        li: [
            "li"
        ],
        ol: [
            "ol"
        ],
        separator: [
            "separator"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $e85bea44bd9c3da4$export$17261110b18c8084), classes);
};
const $9d7afcdf99dc1f56$var$BreadcrumbsRoot = (0, $kDBhE.default)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
    name: "MuiBreadcrumbs",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${(0, $e85bea44bd9c3da4$export$2e2bcd8739ae039).li}`]: styles.li
            },
            styles.root
        ];
    }
})({});
const $9d7afcdf99dc1f56$var$BreadcrumbsOl = (0, $kDBhE.default)("ol", {
    name: "MuiBreadcrumbs",
    slot: "Ol",
    overridesResolver: (props, styles)=>styles.ol
})({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: 0,
    margin: 0,
    listStyle: "none"
});
const $9d7afcdf99dc1f56$var$BreadcrumbsSeparator = (0, $kDBhE.default)("li", {
    name: "MuiBreadcrumbs",
    slot: "Separator",
    overridesResolver: (props, styles)=>styles.separator
})({
    display: "flex",
    userSelect: "none",
    marginLeft: 8,
    marginRight: 8
});
function $9d7afcdf99dc1f56$var$insertSeparators(items, className, separator, ownerState) {
    return items.reduce((acc, current, index)=>{
        if (index < items.length - 1) acc = acc.concat(current, /*#__PURE__*/ (0, $bbzbN.jsx)($9d7afcdf99dc1f56$var$BreadcrumbsSeparator, {
            "aria-hidden": true,
            className: className,
            ownerState: ownerState,
            children: separator
        }, `separator-${index}`));
        else acc.push(current);
        return acc;
    }, []);
}
const $9d7afcdf99dc1f56$var$Breadcrumbs = /*#__PURE__*/ $7fPBF.forwardRef(function Breadcrumbs(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiBreadcrumbs"
    });
    const { children: children, className: className, component: component = "nav", slots: slots = {}, slotProps: slotProps = {}, expandText: expandText = "Show path", itemsAfterCollapse: itemsAfterCollapse = 1, itemsBeforeCollapse: itemsBeforeCollapse = 1, maxItems: maxItems = 8, separator: separator = "/" } = props, other = (0, $cFLic.default)(props, $9d7afcdf99dc1f56$var$_excluded);
    const [expanded, setExpanded] = $7fPBF.useState(false);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        expanded: expanded,
        expandText: expandText,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        maxItems: maxItems,
        separator: separator
    });
    const classes = $9d7afcdf99dc1f56$var$useUtilityClasses(ownerState);
    const collapsedIconSlotProps = (0, $699e2a22f1708389$export$1e5c9e6e4e15efe3)({
        elementType: slots.CollapsedIcon,
        externalSlotProps: slotProps.collapsedIcon,
        ownerState: ownerState
    });
    const listRef = $7fPBF.useRef(null);
    const renderItemsBeforeAndAfter = (allItems)=>{
        const handleClickExpand = ()=>{
            setExpanded(true);
            // The clicked element received the focus but gets removed from the DOM.
            // Let's keep the focus in the component after expanding.
            // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
            // By moving it to some link/button at least we have some announcement.
            const focusable = listRef.current.querySelector("a[href],button,[tabindex]");
            if (focusable) focusable.focus();
        };
        // This defends against someone passing weird input, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        return [
            ...allItems.slice(0, itemsBeforeCollapse),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b9b83b4d3c9e8b74$export$2e2bcd8739ae039), {
                "aria-label": expandText,
                slots: {
                    CollapsedIcon: slots.CollapsedIcon
                },
                slotProps: {
                    collapsedIcon: collapsedIconSlotProps
                },
                onClick: handleClickExpand
            }, "ellipsis"),
            ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)
        ];
    };
    const allItems = $7fPBF.Children.toArray(children).filter((child)=>{
        return /*#__PURE__*/ $7fPBF.isValidElement(child);
    }).map((child, index)=>/*#__PURE__*/ (0, $bbzbN.jsx)("li", {
            className: classes.li,
            children: child
        }, `child-${index}`));
    return /*#__PURE__*/ (0, $bbzbN.jsx)($9d7afcdf99dc1f56$var$BreadcrumbsRoot, (0, $kY3Ke.default)({
        ref: ref,
        component: component,
        color: "text.secondary",
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($9d7afcdf99dc1f56$var$BreadcrumbsOl, {
            className: classes.ol,
            ref: listRef,
            ownerState: ownerState,
            children: $9d7afcdf99dc1f56$var$insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
        })
    }));
});
var $9d7afcdf99dc1f56$export$2e2bcd8739ae039 = $9d7afcdf99dc1f56$var$Breadcrumbs;



var $99436c1341408044$var$PrivateRoute = function(_a) {
    var navigate = _a.navigate, Component = _a.Component, type = _a.type, path = _a.path, title = _a.title, breadcrumb = _a.breadcrumb, urlParams = _a.urlParams;
    var _b = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false), openSideBar = _b[0], setOpenSideBar = _b[1];
    var toggleSideBar = function() {
        setOpenSideBar(!openSideBar);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $6a8f348853d6c3c2$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $5cbd76ecbd407bed$export$2e2bcd8739ae039), {
        navigate: navigate,
        toggleParentSideBar: toggleSideBar,
        openSideBar: openSideBar
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4703c608b586990e$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $52c628f697c03739$export$2e2bcd8739ae039), {
        navigate: navigate,
        toggleSideBar: toggleSideBar
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
        style: {
            marginTop: "70px"
        }
    }, breadcrumb && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
        marginBottom: "1.5rem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $bfb223886c302418$export$2e2bcd8739ae039), {
        elevation: 3
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8bffaacbbee0c705$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $9d7afcdf99dc1f56$export$2e2bcd8739ae039), {
        "aria-label": "breadcrumb"
    }, breadcrumb.map(function(item, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
            key: index
        }, item.route ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $0d11cdf3888dcbb4$export$2e2bcd8739ae039), {
            variant: "text",
            color: "primary",
            onClick: function() {
                navigate(item.route);
            }
        }, item.title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
            color: "textPrimary"
        }, item.title));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
        color: "textPrimary"
    }, title))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, {
        type: type,
        navigatePage: navigate,
        path: path,
        urlParams: urlParams
    }))));
};
var $99436c1341408044$export$2e2bcd8739ae039 = $99436c1341408044$var$PrivateRoute;



/**
 * React Router DOM v6.18.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");


function $a0cf24fd73ae067c$var$_extends() {
    $a0cf24fd73ae067c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a0cf24fd73ae067c$var$_extends.apply(this, arguments);
}
function $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $a0cf24fd73ae067c$var$defaultMethod = "get";
const $a0cf24fd73ae067c$var$defaultEncType = "application/x-www-form-urlencoded";
function $a0cf24fd73ae067c$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $a0cf24fd73ae067c$var$isButtonElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $a0cf24fd73ae067c$var$isFormElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $a0cf24fd73ae067c$var$isInputElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $a0cf24fd73ae067c$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $a0cf24fd73ae067c$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$a0cf24fd73ae067c$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $a0cf24fd73ae067c$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = null;
function $a0cf24fd73ae067c$var$isFormDataSubmitterSupported() {
    if ($a0cf24fd73ae067c$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = true;
    }
    return $a0cf24fd73ae067c$var$_formDataSupportsSubmitter;
}
const $a0cf24fd73ae067c$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $a0cf24fd73ae067c$var$getFormEncType(encType) {
    if (encType != null && !$a0cf24fd73ae067c$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $a0cf24fd73ae067c$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($a0cf24fd73ae067c$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $55100129ab36ed65$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $a0cf24fd73ae067c$var$defaultMethod;
        encType = $a0cf24fd73ae067c$var$getFormEncType(target.getAttribute("enctype")) || $a0cf24fd73ae067c$var$defaultEncType;
        formData = new FormData(target);
    } else if ($a0cf24fd73ae067c$var$isButtonElement(target) || $a0cf24fd73ae067c$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $55100129ab36ed65$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $a0cf24fd73ae067c$var$defaultMethod;
        encType = $a0cf24fd73ae067c$var$getFormEncType(target.getAttribute("formenctype")) || $a0cf24fd73ae067c$var$getFormEncType(form.getAttribute("enctype")) || $a0cf24fd73ae067c$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$a0cf24fd73ae067c$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($a0cf24fd73ae067c$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $a0cf24fd73ae067c$var$defaultMethod;
        action = null;
        encType = $a0cf24fd73ae067c$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $a0cf24fd73ae067c$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $a0cf24fd73ae067c$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $a0cf24fd73ae067c$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
function $a0cf24fd73ae067c$export$1f3f55432a00e06d(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a0cf24fd73ae067c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a0cf24fd73ae067c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $d9fd026bfea79ab9$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a0cf24fd73ae067c$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a0cf24fd73ae067c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a0cf24fd73ae067c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $d9fd026bfea79ab9$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a0cf24fd73ae067c$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $a0cf24fd73ae067c$var$_extends({}, state, {
        errors: $a0cf24fd73ae067c$var$deserializeErrors(state.errors)
    });
    return state;
}
function $a0cf24fd73ae067c$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $55100129ab36ed65$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $a0cf24fd73ae067c$export$7ad602f0e94e62d1 = /*#__PURE__*/ $7fPBF.createContext({
    isTransitioning: false
});
const $a0cf24fd73ae067c$export$148fd98d095596d4 = /*#__PURE__*/ $7fPBF.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $a0cf24fd73ae067c$var$START_TRANSITION = "startTransition";
const $a0cf24fd73ae067c$var$startTransitionImpl = $7fPBF[$a0cf24fd73ae067c$var$START_TRANSITION];
function $a0cf24fd73ae067c$var$startTransitionSafe(cb) {
    if ($a0cf24fd73ae067c$var$startTransitionImpl) $a0cf24fd73ae067c$var$startTransitionImpl(cb);
    else cb();
}
class $a0cf24fd73ae067c$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $a0cf24fd73ae067c$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7fPBF.useState(router.state);
    let [pendingState, setPendingState] = $7fPBF.useState();
    let [vtContext, setVtContext] = $7fPBF.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $7fPBF.useState();
    let [transition, setTransition] = $7fPBF.useState();
    let [interruption, setInterruption] = $7fPBF.useState();
    let fetcherData = $7fPBF.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $7fPBF.useCallback((cb)=>{
        if (v7_startTransition) $a0cf24fd73ae067c$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $7fPBF.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        if (!viewTransitionOpts || router.window == null || typeof router.window.document.startViewTransition !== "function") // Mid-navigation state update, or startViewTransition isn't available
        optInStartTransition(()=>setStateImpl(newState));
        else if (transition && renderDfd) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $7fPBF.useEffect(()=>{
        if (vtContext.isTransitioning) setRenderDfd(new $a0cf24fd73ae067c$var$Deferred());
    }, [
        vtContext.isTransitioning
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $7fPBF.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))))), null);
}
function $a0cf24fd73ae067c$var$DataRoutes(_ref3) {
    let { routes: routes, state: state } = _ref3;
    return (0, $d9fd026bfea79ab9$export$5fcee62552a12fbf)(routes, undefined, state);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $a0cf24fd73ae067c$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $a0cf24fd73ae067c$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $a0cf24fd73ae067c$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $a0cf24fd73ae067c$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $a0cf24fd73ae067c$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $a0cf24fd73ae067c$export$a6c7ac8248d6e38a = /*#__PURE__*/ $7fPBF.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref7, $a0cf24fd73ae067c$var$_excluded);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $a0cf24fd73ae067c$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($a0cf24fd73ae067c$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $d9fd026bfea79ab9$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $a0cf24fd73ae067c$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $7fPBF.createElement("a", $a0cf24fd73ae067c$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $a0cf24fd73ae067c$export$b0d92dbee9b5b60d = /*#__PURE__*/ $7fPBF.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref8, $a0cf24fd73ae067c$var$_excluded2);
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let routerState = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$145dfa71566a64dc));
    let { navigator: navigator } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $a0cf24fd73ae067c$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$a6c7ac8248d6e38a, $a0cf24fd73ae067c$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $a0cf24fd73ae067c$export$a7fed597f4b8afd8 = /*#__PURE__*/ $7fPBF.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $a0cf24fd73ae067c$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref9, $a0cf24fd73ae067c$var$_excluded3);
    let submit = $a0cf24fd73ae067c$export$47c85c6e3a081d3();
    let formAction = $a0cf24fd73ae067c$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $7fPBF.createElement("form", $a0cf24fd73ae067c$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $a0cf24fd73ae067c$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $a0cf24fd73ae067c$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $a0cf24fd73ae067c$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($a0cf24fd73ae067c$var$DataRouterHook || ($a0cf24fd73ae067c$var$DataRouterHook = {}));
var $a0cf24fd73ae067c$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($a0cf24fd73ae067c$var$DataRouterStateHook || ($a0cf24fd73ae067c$var$DataRouterStateHook = {}));
// Internal hooks
function $a0cf24fd73ae067c$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $a0cf24fd73ae067c$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$3add0d5dce533e2e));
    !ctx && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return ctx;
}
function $a0cf24fd73ae067c$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$145dfa71566a64dc));
    !state && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $a0cf24fd73ae067c$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $7fPBF.useCallback((event)=>{
        if ($a0cf24fd73ae067c$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $55100129ab36ed65$export$fe53371bee54353d)(location) === (0, $55100129ab36ed65$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $a0cf24fd73ae067c$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $7fPBF.useRef($a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $7fPBF.useRef(false);
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let searchParams = $7fPBF.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $a0cf24fd73ae067c$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    let setSearchParams = $7fPBF.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $a0cf24fd73ae067c$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $a0cf24fd73ae067c$var$fetcherId = 0;
let $a0cf24fd73ae067c$var$getUniqueFetcherId = ()=>"__" + String(++$a0cf24fd73ae067c$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $a0cf24fd73ae067c$export$47c85c6e3a081d3() {
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let currentRouteId = (0, $d9fd026bfea79ab9$export$5fc8298006ad9e58)();
    return $7fPBF.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $a0cf24fd73ae067c$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $a0cf24fd73ae067c$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $a0cf24fd73ae067c$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $a0cf24fd73ae067c$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let routeContext = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$9072aa6dd1f93057));
    !routeContext && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $a0cf24fd73ae067c$var$_extends({}, (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $55100129ab36ed65$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $a0cf24fd73ae067c$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseFetcher);
    let state = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $7fPBF.useContext($a0cf24fd73ae067c$export$148fd98d095596d4);
    let route = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    !route && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    let [fetcherKey, setFetcherKey] = $7fPBF.useState(key || "");
    if (!fetcherKey) setFetcherKey($a0cf24fd73ae067c$var$getUniqueFetcherId());
    // Registration/cleanup
    $7fPBF.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $7fPBF.useCallback((href)=>{
        !routeId && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $a0cf24fd73ae067c$export$47c85c6e3a081d3();
    let submit = $7fPBF.useCallback((target, opts)=>{
        submitImpl(target, $a0cf24fd73ae067c$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $7fPBF.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $7fPBF.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$a7fed597f4b8afd8, $a0cf24fd73ae067c$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $55100129ab36ed65$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $7fPBF.useMemo(()=>$a0cf24fd73ae067c$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $a0cf24fd73ae067c$export$fa996778a3a31087() {
    let state = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $a0cf24fd73ae067c$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $a0cf24fd73ae067c$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $a0cf24fd73ae067c$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let matches = (0, $d9fd026bfea79ab9$export$2378eb7f5ff86053)();
    let navigation = (0, $d9fd026bfea79ab9$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $7fPBF.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $a0cf24fd73ae067c$var$usePageHide($7fPBF.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $a0cf24fd73ae067c$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($a0cf24fd73ae067c$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $a0cf24fd73ae067c$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($a0cf24fd73ae067c$var$_extends({}, location, {
                    pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($a0cf24fd73ae067c$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a0cf24fd73ae067c$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a0cf24fd73ae067c$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $a0cf24fd73ae067c$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $d9fd026bfea79ab9$export$2af03a1de5c0910)(when);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $a0cf24fd73ae067c$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $7fPBF.useContext($a0cf24fd73ae067c$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { basename: basename } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.useViewTransitionState);
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $55100129ab36ed65$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $55100129ab36ed65$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $4dc1c9997df7c010$exports = {};
$4dc1c9997df7c010$exports = new URL("skyline.a461e4d8.png", import.meta.url).toString();


var $49a727e13f3caa8a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $49a727e13f3caa8a$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $49a727e13f3caa8a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $49a727e13f3caa8a$var$Routes = function(_a) {
    var title = _a.title, breadcrumb = _a.breadcrumb, Component = _a.Component, type = _a.type, path = _a.path, system = _a.system, props = $49a727e13f3caa8a$var$__rest(_a, [
        "title",
        "breadcrumb",
        "Component",
        "type",
        "path",
        "system"
    ]);
    var navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    var _b = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false), pageLoad = _b[0], setPageLoad = _b[1];
    var CheckUserBasedType = function() {
        return $49a727e13f3caa8a$var$__awaiter(void 0, void 0, void 0, function() {
            var ex_1;
            return $49a727e13f3caa8a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0, $9e453b5784a8464e$export$334c29725a78c21d).currentAuthenticatedUser()
                        ];
                    case 1:
                        _a.sent();
                        if (type === "protected") navigate("/");
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        ex_1 = _a.sent();
                        if (type === "private") navigate("/login");
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        setPageLoad(true);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var TypedComponent = function() {
        if (type === "private") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $99436c1341408044$export$2e2bcd8739ae039), {
            Component: Component,
            type: type,
            navigate: navigate,
            path: path,
            title: title,
            breadcrumb: breadcrumb,
            urlParams: (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)()
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, {
            type: type,
            navigatePage: navigate,
            path: path,
            urlParams: (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)(),
            otherProps: props
        });
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        setPageLoad(false);
        if (type === "public") {
            setPageLoad(true);
            return;
        }
        CheckUserBasedType().then(function(r) {});
    }, []);
    var params = props;
    console.log(params);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, system === "admin" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $533baf7da870110d$export$547f7e6e23e64097), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $533baf7da870110d$export$d73fb1e26fe3246a), null), !pageLoad ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $429e1b9333d17135$export$a3333cf4ee0f7f9c), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $429e1b9333d17135$export$d0ec8c45e742fc5f), {
        variant: "rectangular"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $429e1b9333d17135$export$7ab73119e7428f59), {
        color: "success"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, system === "admin" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(TypedComponent, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $69c87d542bb99a74$export$2e2bcd8739ae039), {
        bgimage: (0, (/*@__PURE__*/$parcel$interopDefault($4dc1c9997df7c010$exports)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $38b5ec1caf9c5093$export$2e2bcd8739ae039), {
        variant: "h1"
    }, params.params.pageTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $65cb075c7aae556e$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(TypedComponent, null)))));
};
var $49a727e13f3caa8a$export$2e2bcd8739ae039 = $49a727e13f3caa8a$var$Routes;





var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");
var $eff9fc39e94a657e$var$Page = function(_a) {
    var navigatePage = _a.navigatePage, otherProps = _a.otherProps;
    var params = otherProps === null || otherProps === void 0 ? void 0 : otherProps.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, (params === null || params === void 0 ? void 0 : params.content) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: params === null || params === void 0 ? void 0 : params.content
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null, "No Content"));
};
var $eff9fc39e94a657e$export$2e2bcd8739ae039 = $eff9fc39e94a657e$var$Page;



var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");


var $b6UUh = parcelRequire("b6UUh");




var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $8523c8ab2139cf2c$export$2177af0aa15c34c2(slot) {
    return (0, $k6RDS.default)("MuiDialog", slot);
}
const $8523c8ab2139cf2c$var$dialogClasses = (0, $4jzsB.default)("MuiDialog", [
    "root",
    "scrollPaper",
    "scrollBody",
    "container",
    "paper",
    "paperScrollPaper",
    "paperScrollBody",
    "paperWidthFalse",
    "paperWidthXs",
    "paperWidthSm",
    "paperWidthMd",
    "paperWidthLg",
    "paperWidthXl",
    "paperFullWidth",
    "paperFullScreen"
]);
var $8523c8ab2139cf2c$export$2e2bcd8739ae039 = $8523c8ab2139cf2c$var$dialogClasses;



var $7fPBF = parcelRequire("7fPBF");
const $40596d25b0f9c334$var$DialogContext = /*#__PURE__*/ $7fPBF.createContext({});
var $40596d25b0f9c334$export$2e2bcd8739ae039 = $40596d25b0f9c334$var$DialogContext;





var $bbzbN = parcelRequire("bbzbN");
"use client";
const $7f096abd658f7c85$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $7f096abd658f7c85$var$DialogBackdrop = (0, $kDBhE.default)((0, $e70e583d684cb5f4$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Backdrop",
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $7f096abd658f7c85$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container",
            `scroll${(0, $b6UUh.default)(scroll)}`
        ],
        paper: [
            "paper",
            `paperScroll${(0, $b6UUh.default)(scroll)}`,
            `paperWidth${(0, $b6UUh.default)(String(maxWidth))}`,
            fullWidth && "paperFullWidth",
            fullScreen && "paperFullScreen"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $8523c8ab2139cf2c$export$2177af0aa15c34c2), classes);
};
const $7f096abd658f7c85$var$DialogRoot = (0, $kDBhE.default)((0, $a65b89a1133e1fe4$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
    }
});
const $7f096abd658f7c85$var$DialogContainer = (0, $kDBhE.default)("div", {
    name: "MuiDialog",
    slot: "Container",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $b6UUh.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        height: "100%",
        "@media print": {
            height: "auto"
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === "paper" && {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.scroll === "body" && {
        overflowY: "auto",
        overflowX: "hidden",
        textAlign: "center",
        "&:after": {
            content: '""',
            display: "inline-block",
            verticalAlign: "middle",
            height: "100%",
            width: "0"
        }
    }));
const $7f096abd658f7c85$var$DialogPaper = (0, $kDBhE.default)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $b6UUh.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $b6UUh.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        margin: 32,
        position: "relative",
        overflowY: "auto",
        // Fix IE11 issue, to remove at some point.
        "@media print": {
            overflowY: "visible",
            boxShadow: "none"
        }
    }, ownerState.scroll === "paper" && {
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100% - 64px)"
    }, ownerState.scroll === "body" && {
        display: "inline-block",
        verticalAlign: "middle",
        textAlign: "left" // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: "calc(100% - 64px)"
    }, ownerState.maxWidth === "xs" && {
        maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $8523c8ab2139cf2c$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== "xs" && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $8523c8ab2139cf2c$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.fullWidth && {
        width: "calc(100% - 64px)"
    }, ownerState.fullScreen && {
        margin: 0,
        width: "100%",
        maxWidth: "100%",
        height: "100%",
        maxHeight: "none",
        borderRadius: 0,
        [`&.${(0, $8523c8ab2139cf2c$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: "100%"
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $7f096abd658f7c85$var$Dialog = /*#__PURE__*/ $7fPBF.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiDialog"
    });
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { "aria-describedby": ariaDescribedby, "aria-labelledby": ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = "sm", onBackdropClick: onBackdropClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $74e245c78e363f11$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = "paper", TransitionComponent: TransitionComponent = (0, $68214be7242cbfc8$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $cFLic.default)(props, $7f096abd658f7c85$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $7f096abd658f7c85$var$useUtilityClasses(ownerState);
    const backdropClick = $7fPBF.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const ariaLabelledby = (0, $46f5b561912058f9$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $7fPBF.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($7f096abd658f7c85$var$DialogRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $7f096abd658f7c85$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $kY3Ke.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $bbzbN.jsx)($7f096abd658f7c85$var$DialogContainer, {
                className: (0, $hngXp.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)($7f096abd658f7c85$var$DialogPaper, (0, $kY3Ke.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $hngXp.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $40596d25b0f9c334$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $7f096abd658f7c85$export$2e2bcd8739ae039 = $7f096abd658f7c85$var$Dialog;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $64f614045184fa19$export$61b0ee1f05fb344e(slot) {
    return (0, $k6RDS.default)("MuiDialogContent", slot);
}
const $64f614045184fa19$var$dialogContentClasses = (0, $4jzsB.default)("MuiDialogContent", [
    "root",
    "dividers"
]);
var $64f614045184fa19$export$2e2bcd8739ae039 = $64f614045184fa19$var$dialogContentClasses;



var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $18611d95980659c6$export$f5d2ec7e4c47e088(slot) {
    return (0, $k6RDS.default)("MuiDialogTitle", slot);
}
const $18611d95980659c6$var$dialogTitleClasses = (0, $4jzsB.default)("MuiDialogTitle", [
    "root"
]);
var $18611d95980659c6$export$2e2bcd8739ae039 = $18611d95980659c6$var$dialogTitleClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $634ad3fd5060cf75$var$_excluded = [
    "className",
    "dividers"
];
const $634ad3fd5060cf75$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            "root",
            dividers && "dividers"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $64f614045184fa19$export$61b0ee1f05fb344e), classes);
};
const $634ad3fd5060cf75$var$DialogContentRoot = (0, $kDBhE.default)("div", {
    name: "MuiDialogContent",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        flex: "1 1 auto",
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        overflowY: "auto",
        padding: "20px 24px"
    }, ownerState.dividers ? {
        padding: "16px 24px",
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $18611d95980659c6$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $634ad3fd5060cf75$var$DialogContent = /*#__PURE__*/ $7fPBF.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiDialogContent"
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $cFLic.default)(props, $634ad3fd5060cf75$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        dividers: dividers
    });
    const classes = $634ad3fd5060cf75$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($634ad3fd5060cf75$var$DialogContentRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $634ad3fd5060cf75$export$2e2bcd8739ae039 = $634ad3fd5060cf75$var$DialogContent;



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");


var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $ac75506ecdb312f1$var$_excluded = [
    "className",
    "id"
];
const $ac75506ecdb312f1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $18611d95980659c6$export$f5d2ec7e4c47e088), classes);
};
const $ac75506ecdb312f1$var$DialogTitleRoot = (0, $kDBhE.default)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
    name: "MuiDialogTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    padding: "16px 24px",
    flex: "0 0 auto"
});
const $ac75506ecdb312f1$var$DialogTitle = /*#__PURE__*/ $7fPBF.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiDialogTitle"
    });
    const { className: className, id: idProp } = props, other = (0, $cFLic.default)(props, $ac75506ecdb312f1$var$_excluded);
    const ownerState = props;
    const classes = $ac75506ecdb312f1$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $7fPBF.useContext((0, $40596d25b0f9c334$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $bbzbN.jsx)($ac75506ecdb312f1$var$DialogTitleRoot, (0, $kY3Ke.default)({
        component: "h2",
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $ac75506ecdb312f1$export$2e2bcd8739ae039 = $ac75506ecdb312f1$var$DialogTitle;




var $ced2811cec92894a$exports = {};
"use strict";
"use client";

Object.defineProperty($ced2811cec92894a$exports, "__esModule", {
    value: true
});
$ced2811cec92894a$exports.default = void 0;

var $ced2811cec92894a$var$_createSvgIcon = $4657741705a128f0$exports((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $ced2811cec92894a$var$_default = (0, $ced2811cec92894a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
$ced2811cec92894a$exports.default = $ced2811cec92894a$var$_default;






var $7fPBF = parcelRequire("7fPBF");

var $4ZL0H = parcelRequire("4ZL0H");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $af2bb3e49e41c9b6$var$s = function() {
    return $af2bb3e49e41c9b6$var$s = Object.assign || function(e) {
        for(var t, r = 1, o = arguments.length; r < o; r++)for(var n in t = arguments[r])Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        return e;
    }, $af2bb3e49e41c9b6$var$s.apply(this, arguments);
};
function $af2bb3e49e41c9b6$var$u(e, t, r, o) {
    return new (r || (r = Promise))(function(n, a) {
        function c(e) {
            try {
                s(o.next(e));
            } catch (e) {
                a(e);
            }
        }
        function i(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                a(e);
            }
        }
        function s(e) {
            var t;
            e.done ? n(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                e(t);
            })).then(c, i);
        }
        s((o = o.apply(e, t || [])).next());
    });
}
function $af2bb3e49e41c9b6$var$l(e, t) {
    var r, o, n, a, c = {
        label: 0,
        sent: function() {
            if (1 & n[0]) throw n[1];
            return n[1];
        },
        trys: [],
        ops: []
    };
    return a = {
        next: i(0),
        throw: i(1),
        return: i(2)
    }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function i(a) {
        return function(i) {
            return function(a) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; c;)try {
                    if (r = 1, o && (n = 2 & a[0] ? o.return : a[0] ? o.throw || ((n = o.return) && n.call(o), 0) : o.next) && !(n = n.call(o, a[1])).done) return n;
                    switch(o = 0, n && (a = [
                        2 & a[0],
                        n.value
                    ]), a[0]){
                        case 0:
                        case 1:
                            n = a;
                            break;
                        case 4:
                            return c.label++, {
                                value: a[1],
                                done: !1
                            };
                        case 5:
                            c.label++, o = a[1], a = [
                                0
                            ];
                            continue;
                        case 7:
                            a = c.ops.pop(), c.trys.pop();
                            continue;
                        default:
                            if (!(n = c.trys, (n = n.length > 0 && n[n.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                c = 0;
                                continue;
                            }
                            if (3 === a[0] && (!n || a[1] > n[0] && a[1] < n[3])) {
                                c.label = a[1];
                                break;
                            }
                            if (6 === a[0] && c.label < n[1]) {
                                c.label = n[1], n = a;
                                break;
                            }
                            if (n && c.label < n[2]) {
                                c.label = n[2], c.ops.push(a);
                                break;
                            }
                            n[2] && c.ops.pop(), c.trys.pop();
                            continue;
                    }
                    a = t.call(e, c);
                } catch (e) {
                    a = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    r = n = 0;
                }
                if (5 & a[0]) throw a[1];
                return {
                    value: a[0] ? a[1] : void 0,
                    done: !0
                };
            }([
                a,
                i
            ]);
        };
    }
}
var $af2bb3e49e41c9b6$var$f, $af2bb3e49e41c9b6$var$p = function(e) {
    var t;
    e ? function(e) {
        if (e) for(; e.lastChild;)e.lastChild.remove();
    }("string" == typeof e ? document.getElementById(e) : e) : (t = document.querySelector(".grecaptcha-badge")) && t.parentNode && document.body.removeChild(t.parentNode);
}, $af2bb3e49e41c9b6$var$d = function(e, t) {
    $af2bb3e49e41c9b6$var$p(t), window.___grecaptcha_cfg = void 0;
    var r = document.querySelector("#" + e);
    r && r.remove(), function() {
        var e = document.querySelector('script[src^="https://www.gstatic.com/recaptcha/releases"]');
        e && e.remove();
    }();
}, $af2bb3e49e41c9b6$var$y = function(e) {
    var t = e.render, r = e.onLoadCallbackName, o = e.language, n = e.onLoad, a = e.useRecaptchaNet, c = e.useEnterprise, i = e.scriptProps, s = void 0 === i ? {} : i, u = s.nonce, l = void 0 === u ? "" : u, f = s.defer, p = void 0 !== f && f, d = s.async, y = void 0 !== d && d, m = s.id, v = void 0 === m ? "" : m, b = s.appendTo, h = v || "google-recaptcha-v3";
    if (function(e) {
        return !!document.querySelector("#" + e);
    }(h)) n();
    else {
        var g = function(e) {
            return "https://www." + (e.useRecaptchaNet ? "recaptcha.net" : "google.com") + "/recaptcha/" + (e.useEnterprise ? "enterprise.js" : "api.js");
        }({
            useEnterprise: c,
            useRecaptchaNet: a
        }), S = document.createElement("script");
        S.id = h, S.src = g + "?render=" + t + ("explicit" === t ? "&onload=" + r : "") + (o ? "&hl=" + o : ""), l && (S.nonce = l), S.defer = !!p, S.async = !!y, S.onload = n, ("body" === b ? document.body : document.getElementsByTagName("head")[0]).appendChild(S);
    }
}, $af2bb3e49e41c9b6$var$m = function(e) {
    "undefined" != typeof $4ZL0H && $4ZL0H.env, console.warn(e);
};
!function(e) {
    e.SCRIPT_NOT_AVAILABLE = "Recaptcha script is not available";
}($af2bb3e49e41c9b6$var$f || ($af2bb3e49e41c9b6$var$f = {}));
var $af2bb3e49e41c9b6$export$dd93270ab0cf623c = (0, $7fPBF.createContext)({
    executeRecaptcha: function() {
        throw Error("GoogleReCaptcha Context has not yet been implemented, if you are using useGoogleReCaptcha hook, make sure the hook is called inside component wrapped by GoogleRecaptchaProvider");
    }
}), $af2bb3e49e41c9b6$export$14d6311c3d83742b = $af2bb3e49e41c9b6$export$dd93270ab0cf623c.Consumer;
function $af2bb3e49e41c9b6$export$3d3872bfc53fd642(t) {
    var i = t.reCaptchaKey, u = t.useEnterprise, l = void 0 !== u && u, p = t.useRecaptchaNet, b = void 0 !== p && p, h = t.scriptProps, g = t.language, S = t.container, w = t.children, $ = (0, $7fPBF.useState)(null), C = $[0], P = $[1], x = (0, $7fPBF.useRef)(i), E = JSON.stringify(h), R = JSON.stringify(null == S ? void 0 : S.parameters);
    (0, $7fPBF.useEffect)(function() {
        if (i) {
            var e = (null == h ? void 0 : h.id) || "google-recaptcha-v3", t = (null == h ? void 0 : h.onLoadCallbackName) || "onRecaptchaLoadCallback";
            window[t] = function() {
                var e = l ? window.grecaptcha.enterprise : window.grecaptcha, t = $af2bb3e49e41c9b6$var$s({
                    badge: "inline",
                    size: "invisible",
                    sitekey: i
                }, (null == S ? void 0 : S.parameters) || {});
                x.current = e.render(null == S ? void 0 : S.element, t);
            };
            return $af2bb3e49e41c9b6$var$y({
                render: (null == S ? void 0 : S.element) ? "explicit" : i,
                onLoadCallbackName: t,
                useEnterprise: l,
                useRecaptchaNet: b,
                scriptProps: h,
                language: g,
                onLoad: function() {
                    if (window && window.grecaptcha) {
                        var e = l ? window.grecaptcha.enterprise : window.grecaptcha;
                        e.ready(function() {
                            P(e);
                        });
                    } else $af2bb3e49e41c9b6$var$m("<GoogleRecaptchaProvider /> " + $af2bb3e49e41c9b6$var$f.SCRIPT_NOT_AVAILABLE);
                },
                onError: function() {
                    $af2bb3e49e41c9b6$var$m("Error loading google recaptcha script");
                }
            }), function() {
                $af2bb3e49e41c9b6$var$d(e, null == S ? void 0 : S.element);
            };
        }
        $af2bb3e49e41c9b6$var$m("<GoogleReCaptchaProvider /> recaptcha key not provided");
    }, [
        l,
        b,
        E,
        R,
        g,
        i,
        null == S ? void 0 : S.element
    ]);
    var M = (0, $7fPBF.useCallback)(function(e) {
        if (!C || !C.execute) throw new Error("<GoogleReCaptchaProvider /> Google Recaptcha has not been loaded");
        return C.execute(x.current, {
            action: e
        });
    }, [
        C,
        x
    ]), N = (0, $7fPBF.useMemo)(function() {
        return {
            executeRecaptcha: C ? M : void 0,
            container: null == S ? void 0 : S.element
        };
    }, [
        M,
        C,
        null == S ? void 0 : S.element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($af2bb3e49e41c9b6$export$dd93270ab0cf623c.Provider, {
        value: N
    }, w);
}
var $af2bb3e49e41c9b6$export$7f8feffd50fb5144 = function() {
    return (0, $7fPBF.useContext)($af2bb3e49e41c9b6$export$dd93270ab0cf623c);
};
function $af2bb3e49e41c9b6$export$d5aa16f6da947fbf(t) {
    var r = this, o = t.action, a = t.onVerify, c = t.refreshReCaptcha, i = $af2bb3e49e41c9b6$export$7f8feffd50fb5144();
    (0, $7fPBF.useEffect)(function() {
        var e = i.executeRecaptcha;
        if (e) $af2bb3e49e41c9b6$var$u(r, void 0, void 0, function() {
            var t;
            return $af2bb3e49e41c9b6$var$l(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            e(o)
                        ];
                    case 1:
                        return t = r.sent(), a ? (a(t), [
                            2
                        ]) : ($af2bb3e49e41c9b6$var$m("Please define an onVerify function"), [
                            2
                        ]);
                }
            });
        });
    }, [
        o,
        a,
        c,
        i
    ]);
    var s = i.container;
    return "string" == typeof s ? (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        id: s
    }) : null;
}
function $af2bb3e49e41c9b6$var$w(e, t) {
    return e(t = {
        exports: {}
    }, t.exports), t.exports;
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ }
var $af2bb3e49e41c9b6$var$$ = "function" == typeof Symbol && Symbol.for, $af2bb3e49e41c9b6$var$C = $af2bb3e49e41c9b6$var$$ ? Symbol.for("react.element") : 60103, $af2bb3e49e41c9b6$var$P = $af2bb3e49e41c9b6$var$$ ? Symbol.for("react.portal") : 60106, $af2bb3e49e41c9b6$var$x = $af2bb3e49e41c9b6$var$$ ? Symbol.for("react.fragment") : 60107, $af2bb3e49e41c9b6$var$E = $af2bb3e49e41c9b6$var$$ ? Symbol.for("react.strict_mode") : 60108, $af2bb3e49e41c9b6$var$R = $af2bb3e49e41c9b6$var$$ ? Symbol.for("react.profiler") : 60114, $af2bb3e49e41c9b6$var$M = $af2bb3e49e41c9b6$var$$ ? Symbol.for("react.provider") : 60109, $af2bb3e49e41c9b6$var$N = $af2bb3e49e41c9b6$var$$ ? Symbol.for("react.context") : 60110, $af2bb3e49e41c9b6$var$O = $af2bb3e49e41c9b6$var$$ ? Symbol.for("react.async_mode") : 60111, $af2bb3e49e41c9b6$var$_ = $af2bb3e49e41c9b6$var$$ ? Symbol.for("react.concurrent_mode") : 60111, $af2bb3e49e41c9b6$var$T = $af2bb3e49e41c9b6$var$$ ? Symbol.for("react.forward_ref") : 60112, $af2bb3e49e41c9b6$var$j = $af2bb3e49e41c9b6$var$$ ? Symbol.for("react.suspense") : 60113, $af2bb3e49e41c9b6$var$L = $af2bb3e49e41c9b6$var$$ ? Symbol.for("react.suspense_list") : 60120, $af2bb3e49e41c9b6$var$k = $af2bb3e49e41c9b6$var$$ ? Symbol.for("react.memo") : 60115, $af2bb3e49e41c9b6$var$F = $af2bb3e49e41c9b6$var$$ ? Symbol.for("react.lazy") : 60116, $af2bb3e49e41c9b6$var$A = $af2bb3e49e41c9b6$var$$ ? Symbol.for("react.block") : 60121, $af2bb3e49e41c9b6$var$V = $af2bb3e49e41c9b6$var$$ ? Symbol.for("react.fundamental") : 60117, $af2bb3e49e41c9b6$var$z = $af2bb3e49e41c9b6$var$$ ? Symbol.for("react.responder") : 60118, $af2bb3e49e41c9b6$var$G = $af2bb3e49e41c9b6$var$$ ? Symbol.for("react.scope") : 60119;
function $af2bb3e49e41c9b6$var$I(e) {
    if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;
        switch(t){
            case $af2bb3e49e41c9b6$var$C:
                switch(e = e.type){
                    case $af2bb3e49e41c9b6$var$O:
                    case $af2bb3e49e41c9b6$var$_:
                    case $af2bb3e49e41c9b6$var$x:
                    case $af2bb3e49e41c9b6$var$R:
                    case $af2bb3e49e41c9b6$var$E:
                    case $af2bb3e49e41c9b6$var$j:
                        return e;
                    default:
                        switch(e = e && e.$$typeof){
                            case $af2bb3e49e41c9b6$var$N:
                            case $af2bb3e49e41c9b6$var$T:
                            case $af2bb3e49e41c9b6$var$F:
                            case $af2bb3e49e41c9b6$var$k:
                            case $af2bb3e49e41c9b6$var$M:
                                return e;
                            default:
                                return t;
                        }
                }
            case $af2bb3e49e41c9b6$var$P:
                return t;
        }
    }
}
function $af2bb3e49e41c9b6$var$D(e) {
    return $af2bb3e49e41c9b6$var$I(e) === $af2bb3e49e41c9b6$var$_;
}
var $af2bb3e49e41c9b6$var$q = {
    AsyncMode: $af2bb3e49e41c9b6$var$O,
    ConcurrentMode: $af2bb3e49e41c9b6$var$_,
    ContextConsumer: $af2bb3e49e41c9b6$var$N,
    ContextProvider: $af2bb3e49e41c9b6$var$M,
    Element: $af2bb3e49e41c9b6$var$C,
    ForwardRef: $af2bb3e49e41c9b6$var$T,
    Fragment: $af2bb3e49e41c9b6$var$x,
    Lazy: $af2bb3e49e41c9b6$var$F,
    Memo: $af2bb3e49e41c9b6$var$k,
    Portal: $af2bb3e49e41c9b6$var$P,
    Profiler: $af2bb3e49e41c9b6$var$R,
    StrictMode: $af2bb3e49e41c9b6$var$E,
    Suspense: $af2bb3e49e41c9b6$var$j,
    isAsyncMode: function(e) {
        return $af2bb3e49e41c9b6$var$D(e) || $af2bb3e49e41c9b6$var$I(e) === $af2bb3e49e41c9b6$var$O;
    },
    isConcurrentMode: $af2bb3e49e41c9b6$var$D,
    isContextConsumer: function(e) {
        return $af2bb3e49e41c9b6$var$I(e) === $af2bb3e49e41c9b6$var$N;
    },
    isContextProvider: function(e) {
        return $af2bb3e49e41c9b6$var$I(e) === $af2bb3e49e41c9b6$var$M;
    },
    isElement: function(e) {
        return "object" == typeof e && null !== e && e.$$typeof === $af2bb3e49e41c9b6$var$C;
    },
    isForwardRef: function(e) {
        return $af2bb3e49e41c9b6$var$I(e) === $af2bb3e49e41c9b6$var$T;
    },
    isFragment: function(e) {
        return $af2bb3e49e41c9b6$var$I(e) === $af2bb3e49e41c9b6$var$x;
    },
    isLazy: function(e) {
        return $af2bb3e49e41c9b6$var$I(e) === $af2bb3e49e41c9b6$var$F;
    },
    isMemo: function(e) {
        return $af2bb3e49e41c9b6$var$I(e) === $af2bb3e49e41c9b6$var$k;
    },
    isPortal: function(e) {
        return $af2bb3e49e41c9b6$var$I(e) === $af2bb3e49e41c9b6$var$P;
    },
    isProfiler: function(e) {
        return $af2bb3e49e41c9b6$var$I(e) === $af2bb3e49e41c9b6$var$R;
    },
    isStrictMode: function(e) {
        return $af2bb3e49e41c9b6$var$I(e) === $af2bb3e49e41c9b6$var$E;
    },
    isSuspense: function(e) {
        return $af2bb3e49e41c9b6$var$I(e) === $af2bb3e49e41c9b6$var$j;
    },
    isValidElementType: function(e) {
        return "string" == typeof e || "function" == typeof e || e === $af2bb3e49e41c9b6$var$x || e === $af2bb3e49e41c9b6$var$_ || e === $af2bb3e49e41c9b6$var$R || e === $af2bb3e49e41c9b6$var$E || e === $af2bb3e49e41c9b6$var$j || e === $af2bb3e49e41c9b6$var$L || "object" == typeof e && null !== e && (e.$$typeof === $af2bb3e49e41c9b6$var$F || e.$$typeof === $af2bb3e49e41c9b6$var$k || e.$$typeof === $af2bb3e49e41c9b6$var$M || e.$$typeof === $af2bb3e49e41c9b6$var$N || e.$$typeof === $af2bb3e49e41c9b6$var$T || e.$$typeof === $af2bb3e49e41c9b6$var$V || e.$$typeof === $af2bb3e49e41c9b6$var$z || e.$$typeof === $af2bb3e49e41c9b6$var$G || e.$$typeof === $af2bb3e49e41c9b6$var$A);
    },
    typeOf: $af2bb3e49e41c9b6$var$I
}, $af2bb3e49e41c9b6$var$B = $af2bb3e49e41c9b6$var$w(function(e, t) {}), $af2bb3e49e41c9b6$var$J = ($af2bb3e49e41c9b6$var$B.AsyncMode, $af2bb3e49e41c9b6$var$B.ConcurrentMode, $af2bb3e49e41c9b6$var$B.ContextConsumer, $af2bb3e49e41c9b6$var$B.ContextProvider, $af2bb3e49e41c9b6$var$B.Element, $af2bb3e49e41c9b6$var$B.ForwardRef, $af2bb3e49e41c9b6$var$B.Fragment, $af2bb3e49e41c9b6$var$B.Lazy, $af2bb3e49e41c9b6$var$B.Memo, $af2bb3e49e41c9b6$var$B.Portal, $af2bb3e49e41c9b6$var$B.Profiler, $af2bb3e49e41c9b6$var$B.StrictMode, $af2bb3e49e41c9b6$var$B.Suspense, $af2bb3e49e41c9b6$var$B.isAsyncMode, $af2bb3e49e41c9b6$var$B.isConcurrentMode, $af2bb3e49e41c9b6$var$B.isContextConsumer, $af2bb3e49e41c9b6$var$B.isContextProvider, $af2bb3e49e41c9b6$var$B.isElement, $af2bb3e49e41c9b6$var$B.isForwardRef, $af2bb3e49e41c9b6$var$B.isFragment, $af2bb3e49e41c9b6$var$B.isLazy, $af2bb3e49e41c9b6$var$B.isMemo, $af2bb3e49e41c9b6$var$B.isPortal, $af2bb3e49e41c9b6$var$B.isProfiler, $af2bb3e49e41c9b6$var$B.isStrictMode, $af2bb3e49e41c9b6$var$B.isSuspense, $af2bb3e49e41c9b6$var$B.isValidElementType, $af2bb3e49e41c9b6$var$B.typeOf, $af2bb3e49e41c9b6$var$w(function(e) {
    e.exports = $af2bb3e49e41c9b6$var$q;
})), $af2bb3e49e41c9b6$var$K = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $af2bb3e49e41c9b6$var$U = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $af2bb3e49e41c9b6$var$H = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $af2bb3e49e41c9b6$var$Q = {};
function $af2bb3e49e41c9b6$var$W(e) {
    return $af2bb3e49e41c9b6$var$J.isMemo(e) ? $af2bb3e49e41c9b6$var$H : $af2bb3e49e41c9b6$var$Q[e.$$typeof] || $af2bb3e49e41c9b6$var$K;
}
$af2bb3e49e41c9b6$var$Q[$af2bb3e49e41c9b6$var$J.ForwardRef] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $af2bb3e49e41c9b6$var$Q[$af2bb3e49e41c9b6$var$J.Memo] = $af2bb3e49e41c9b6$var$H;
var $af2bb3e49e41c9b6$var$X = Object.defineProperty, $af2bb3e49e41c9b6$var$Y = Object.getOwnPropertyNames, $af2bb3e49e41c9b6$var$Z = Object.getOwnPropertySymbols, $af2bb3e49e41c9b6$var$ee = Object.getOwnPropertyDescriptor, $af2bb3e49e41c9b6$var$te = Object.getPrototypeOf, $af2bb3e49e41c9b6$var$re = Object.prototype;
var $af2bb3e49e41c9b6$var$oe = function e(t, r, o) {
    if ("string" != typeof r) {
        if ($af2bb3e49e41c9b6$var$re) {
            var n = $af2bb3e49e41c9b6$var$te(r);
            n && n !== $af2bb3e49e41c9b6$var$re && e(t, n, o);
        }
        var a = $af2bb3e49e41c9b6$var$Y(r);
        $af2bb3e49e41c9b6$var$Z && (a = a.concat($af2bb3e49e41c9b6$var$Z(r)));
        for(var c = $af2bb3e49e41c9b6$var$W(t), i = $af2bb3e49e41c9b6$var$W(r), s = 0; s < a.length; ++s){
            var u = a[s];
            if (!($af2bb3e49e41c9b6$var$U[u] || o && o[u] || i && i[u] || c && c[u])) {
                var l = $af2bb3e49e41c9b6$var$ee(r, u);
                try {
                    $af2bb3e49e41c9b6$var$X(t, u, l);
                } catch (e) {}
            }
        }
    }
    return t;
}, $af2bb3e49e41c9b6$export$b641f6dbb7005cb7 = function(t) {
    var r = function(r) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($af2bb3e49e41c9b6$export$14d6311c3d83742b, null, function(o) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(t, $af2bb3e49e41c9b6$var$s({}, r, {
                googleReCaptchaProps: o
            }));
        });
    };
    return r.displayName = "withGoogleReCaptcha(" + (t.displayName || t.name || "Component") + ")", $af2bb3e49e41c9b6$var$oe(r, t), r;
};


var $5c23e3bc85bb6be0$var$GAEvents = {
    setSurveyResumption: function(email) {
        var gtag = window.gtag;
        if (gtag) {
            gtag("config", "G-NCDYXM0456", {
                page_title: "/login"
            });
            gtag("event", "survey_resumption", {
                email: email
            });
        }
    },
    setPage: function(page) {
        var gtag = window.gtag;
        if (gtag) {
            gtag("config", "G-NCDYXM0456", {
                page_title: page
            });
            var urlParams = new URLSearchParams(window.location.search);
            var fromParam = urlParams.get("from");
            if (fromParam) gtag("event", "partnerID", {
                partnerID: fromParam
            });
        }
    },
    pageview: function() {
        var gtag = window.gtag;
        if (gtag) gtag("config", "G-NCDYXM0456", {
            send_page_view: true
        });
    },
    logNewCriteriaSet: function() {
        $5c23e3bc85bb6be0$var$GAEvents.send({
            hitType: "event",
            eventCategory: "criteriaSet",
            eventAction: "new"
        });
    },
    logReportDownload: function(reportId) {
        $5c23e3bc85bb6be0$var$GAEvents.send({
            hitType: "event",
            eventCategory: "reportDownload",
            eventAction: reportId
        });
    },
    send: function(payload) {
        var gtag = window.gtag;
        if (gtag) gtag(payload.hitType, payload.eventAction, {
            event_category: payload.eventCategory
        });
    }
};
var $5c23e3bc85bb6be0$export$2e2bcd8739ae039 = $5c23e3bc85bb6be0$var$GAEvents;




var $b3a22c3b6c4b7b49$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b3a22c3b6c4b7b49$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $b3a22c3b6c4b7b49$var$DownloadEmailDialog = function(_a) {
    var open = _a.open, logo = _a.logo, report = _a.report, close = _a.close, googleKey = _a.googleKey;
    var _b = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false), loading = _b[0], setLoading = _b[1];
    var linkRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    var dataForm = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
    var _c = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(true), refreshReCaptcha = _c[0], setRefreshReCaptcha = _c[1];
    var _d = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState("yes"), allowedContact = _d[0], setAllowedContact = _d[1];
    var formConfig = [
        {
            name: "email",
            label: "Email",
            fieldType: "input",
            isRequired: true,
            validations: {
                type: "input",
                required: true,
                customMessages: {
                    required: "Email can't be blank."
                }
            }
        }
    ];
    var _e = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(null), objectURL = _e[0], setObjectURL = _e[1];
    var anchorRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    var submitForm = function(data) {
        return $b3a22c3b6c4b7b49$var$__awaiter(void 0, void 0, void 0, function() {
            return $b3a22c3b6c4b7b49$var$__generator(this, function(_a) {
                setRefreshReCaptcha(true);
                setLoading(true);
                dataForm.current = data;
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    var processForm = function(token) {
        return $b3a22c3b6c4b7b49$var$__awaiter(void 0, void 0, void 0, function() {
            var data, response;
            return $b3a22c3b6c4b7b49$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        data = dataForm.current;
                        data.reportID = report.id;
                        data.reportYear = report.year;
                        data.token = token;
                        data.key = "Survey_Download_Report_Email";
                        data.createdAt = new Date().toISOString();
                        data.updatedAt = new Date().toISOString();
                        data.allowedContact = allowedContact;
                        // Set the value of allowedContact
                        return [
                            4,
                            (0, $03ff035b4ab3e762$export$2e2bcd8739ae039).custom_call(null, (0, $7a1d5ab68f58f51c$export$706b10a2fae99b26), {
                                args: data
                            }, "createPublicSurveyDownloadReportEmail")
                        ];
                    case 1:
                        response = _a.sent();
                        (0, $5c23e3bc85bb6be0$export$2e2bcd8739ae039).logReportDownload(report.year);
                        if (!(response === "Ok" && report.reportStatus === "Active")) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            fetchPDF()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        setLoading(false);
                        setRefreshReCaptcha(false);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var fetchPDF = function() {
        return $b3a22c3b6c4b7b49$var$__awaiter(void 0, void 0, void 0, function() {
            var signedUrl, response, base64data, mimeType, byteCharacters, byteNumbers, i, byteArray, blob, objectURL_1, error_1;
            var _a;
            return $b3a22c3b6c4b7b49$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _b.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            (0, $82b5c847df02364b$export$f43fbdef6dd3768c).get((_a = report.s3Key) !== null && _a !== void 0 ? _a : "", {
                                level: "public"
                            })
                        ];
                    case 1:
                        signedUrl = _b.sent();
                        return [
                            4,
                            fetch(signedUrl)
                        ];
                    case 2:
                        response = _b.sent();
                        return [
                            4,
                            response.text()
                        ];
                    case 3:
                        base64data = _b.sent();
                        mimeType = "data:application/pdf;base64,";
                        if (base64data.startsWith(mimeType)) base64data = base64data.substring(mimeType.length);
                        byteCharacters = atob(base64data);
                        byteNumbers = new Array(byteCharacters.length);
                        for(i = 0; i < byteCharacters.length; i++)byteNumbers[i] = byteCharacters.charCodeAt(i);
                        byteArray = new Uint8Array(byteNumbers);
                        blob = new Blob([
                            byteArray
                        ], {
                            type: "application/pdf"
                        });
                        objectURL_1 = URL.createObjectURL(blob);
                        window.location.href = objectURL_1;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        error_1 = _b.sent();
                        console.error("Error fetching the s3 PDF", error_1);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        if (objectURL) {
            anchorRef.current.click();
            close();
        }
    }, [
        objectURL
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7f096abd658f7c85$export$2e2bcd8739ae039), {
        open: open,
        onClose: close,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        maxWidth: "sm",
        fullWidth: true,
        style: {
            overflow: "hidden"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("a", {
        href: objectURL !== null && objectURL !== void 0 ? objectURL : "#",
        ref: anchorRef,
        style: {
            display: "none"
        },
        target: "_blank",
        rel: "noopener noreferrer"
    }, "Hidden Link"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $ac75506ecdb312f1$export$2e2bcd8739ae039), {
        id: "alert-dialog-title",
        style: {
            backgroundColor: "#367fbb",
            padding: "1.25rem",
            textAlign: "center"
        }
    }, logo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("img", {
        src: logo,
        alt: "",
        width: "220",
        style: {
            textAlign: "center"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
        edge: "end",
        color: "inherit",
        onClick: function() {
            close();
        },
        "aria-label": "close",
        style: {
            position: "absolute",
            right: "16px",
            top: "8px"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ced2811cec92894a$exports))), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $af2bb3e49e41c9b6$export$3d3872bfc53fd642), {
        reCaptchaKey: googleKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        style: {
            padding: "2.5rem"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("p", {
        style: {
            color: "#44546a",
            lineHeight: "1.56",
            fontStyle: "italic",
            margin: "0 0 1.25rem"
        }
    }, "We will contact you with future Startup Muster reports and surveys"), loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $af2bb3e49e41c9b6$export$d5aa16f6da947fbf), {
        onVerify: function(token) {
            return $b3a22c3b6c4b7b49$var$__awaiter(void 0, void 0, void 0, function() {
                return $b3a22c3b6c4b7b49$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                processForm(token)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        },
        refreshReCaptcha: refreshReCaptcha
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("p", {
        style: {
            margin: "0 0 1.25rem",
            color: "#44546a",
            lineHeight: "1.56",
            fontSize: "20px",
            fontWeight: "bold"
        }
    }, "Thank you! Your download should start shortly.")) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("p", {
        style: {
            margin: "0 0 1.25rem",
            color: "#44546a",
            lineHeight: "1.56",
            fontSize: "20px",
            fontWeight: "600"
        }
    }, "Enter your email address to download the free report"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $206020d7e70b2617$export$2e2bcd8739ae039), {
        control: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $4d99e6d55ec7d57a$export$2e2bcd8739ae039), {
            checked: allowedContact === "yes",
            onChange: function(e) {
                return setAllowedContact(e.target.checked ? "yes" : "no");
            }
        }),
        label: "Allow contact from the organisations that support Startup Muster\u2019s work"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d3accb062935cef9$export$2e2bcd8739ae039), {
        fields: formConfig,
        onSubmit: submitForm,
        submitButtonText: "Download Report"
    }))))));
};
var $b3a22c3b6c4b7b49$export$2e2bcd8739ae039 = $b3a22c3b6c4b7b49$var$DownloadEmailDialog;





var $4b2ec354b2a17eaa$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4b2ec354b2a17eaa$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $4b2ec354b2a17eaa$var$ReportsPage = function(_a) {
    var navigatePage = _a.navigatePage, urlParams = _a.urlParams, otherProps = _a.otherProps;
    var _b = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(true), loading = _b[0], setLoading = _b[1];
    var reports = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef([]);
    var defaultReport = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
    var _c = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(), selectedReport = _c[0], setSelectedReport = _c[1];
    var loadReport = function() {
        return $4b2ec354b2a17eaa$var$__awaiter(void 0, void 0, void 0, function() {
            var _a, index;
            return $4b2ec354b2a17eaa$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = reports;
                        return [
                            4,
                            (0, $010273dbafa4ccc3$export$2e2bcd8739ae039).getList(null, false)
                        ];
                    case 1:
                        _a.current = _b.sent();
                        reports.current = reports.current.filter(function(report) {
                            return report.reportStatus !== "Draft";
                        });
                        reports.current.sort(function(a, b) {
                            return Number(b.year) - Number(a.year);
                        });
                        reports.current.map(function(data) {
                            try {
                                data.reportImage = JSON.parse(data.reportImage);
                            } catch (e) {}
                            return data;
                        });
                        index = JSON.parse(JSON.stringify(reports.current)).findIndex(function(data) {
                            return data.id === (otherProps === null || otherProps === void 0 ? void 0 : otherProps.params.settings.defaultReport);
                        });
                        defaultReport.current = reports.current.splice(index, 1);
                        setLoading(false);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var handleOpenFile = function(report) {
        setSelectedReport(report);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        loadReport().then();
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        (0, $5c23e3bc85bb6be0$export$2e2bcd8739ae039).setPage("Reports");
    }, []);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $b3a22c3b6c4b7b49$export$2e2bcd8739ae039), {
        open: !!selectedReport,
        logo: otherProps === null || otherProps === void 0 ? void 0 : otherProps.params.configurations.logo,
        report: selectedReport,
        googleKey: otherProps === null || otherProps === void 0 ? void 0 : otherProps.params.configurations.googleRecaptchaKey,
        close: function() {
            handleOpenFile(undefined);
        }
    }), defaultReport.current && defaultReport.current.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        style: {
            padding: "16px"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
        item: true,
        xs: 12,
        md: 4
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $330e0167222bbfb2$export$76930ccd091205a8), {
        onClick: function() {
            handleOpenFile(defaultReport.current[0]);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $330e0167222bbfb2$export$d048b6aa73a37379), {
        src: defaultReport.current[0].reportImage.file,
        width: "400",
        alt: defaultReport.current[0].year
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
        item: true,
        xs: 12,
        md: 8
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $330e0167222bbfb2$export$38acf89cb4e932a0), {
        dangerouslySetInnerHTML: {
            __html: defaultReport.current[0].description
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
        variant: "contained",
        onClick: function() {
            handleOpenFile(defaultReport.current[0]);
        }
    }, "Read the report")))), reports.current.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e9512dd5d5a180fa$export$2e2bcd8739ae039), {
        variant: "h3"
    }, "Previous Reports"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        style: {
            padding: 20
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
        container: true,
        spacing: 3
    }, reports.current.map(function(data, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fa4a4d669bc53fb$export$2e2bcd8739ae039), {
            item: true,
            xs: 12,
            md: 4,
            lg: 4,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $330e0167222bbfb2$export$7cbae8a56cf36d2a), {
            onClick: function() {
                handleOpenFile(data);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $330e0167222bbfb2$export$ae8703768ec16e8a), {
            src: data.reportImage.file,
            width: "256",
            alt: data.year
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $330e0167222bbfb2$export$643523328257f345), null, data.year)));
    })))));
};
var $4b2ec354b2a17eaa$export$2e2bcd8739ae039 = $4b2ec354b2a17eaa$var$ReportsPage;



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");





var $5144ab925a5cd5d3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5144ab925a5cd5d3$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $5144ab925a5cd5d3$var$CacheKey = "SurveyDownloadReportEmail";
var $5144ab925a5cd5d3$var$SurveyDownloadReportEmailTypesCahce = {
    setItem: function(value) {
        return $5144ab925a5cd5d3$var$__awaiter(void 0, void 0, Promise, function() {
            return $5144ab925a5cd5d3$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).setItem($5144ab925a5cd5d3$var$CacheKey, JSON.stringify(value))
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    },
    getItem: function() {
        return $5144ab925a5cd5d3$var$__awaiter(void 0, void 0, Promise, function() {
            var items;
            return $5144ab925a5cd5d3$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).getItem($5144ab925a5cd5d3$var$CacheKey)
                        ];
                    case 1:
                        items = _a.sent();
                        return [
                            2,
                            items ? JSON.parse(items) : null
                        ];
                }
            });
        });
    },
    removeItem: function() {
        return $5144ab925a5cd5d3$var$__awaiter(void 0, void 0, Promise, function() {
            return $5144ab925a5cd5d3$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).removeItem($5144ab925a5cd5d3$var$CacheKey)
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent()
                        ];
                }
            });
        });
    }
};
var $5144ab925a5cd5d3$export$2e2bcd8739ae039 = $5144ab925a5cd5d3$var$SurveyDownloadReportEmailTypesCahce;


var $062454becd5ef76d$var$SurveyNotifyReportEmailAPI = new (0, $85c3021a0318976c$export$2e2bcd8739ae039)({
    ref: "SurveyNotifyReportEmail",
    cacheFunc: (0, $5144ab925a5cd5d3$export$2e2bcd8739ae039),
    filter: {
        key: "Survey_Notify_Report_Email",
        sortDirection: "ASC"
    },
    listFunc: (0, $d819d0cbe64233c2$export$cf57b28d21aff9c5),
    getFunc: (0, $d819d0cbe64233c2$export$14df56e7b5db2c4),
    route: "/members/survey/reports/downloaders",
    insertFunc: (0, $7a1d5ab68f58f51c$export$d132f2ec94189d1c),
    updateFunc: (0, $7a1d5ab68f58f51c$export$8fadaf7e7e30fd9e),
    deleteFunc: (0, $7a1d5ab68f58f51c$export$81a40b35df0b650a),
    backupTable: "cms_survey_settings",
    deleteMSG: "Subscriber deleted",
    insertMSG: "Subscriber saved",
    updateMSG: "Subscriber updated",
    key: "Survey_Notify_Report_Email",
    getName: "getSurveyNotifyReportEmail"
});
var $062454becd5ef76d$export$2e2bcd8739ae039 = $062454becd5ef76d$var$SurveyNotifyReportEmailAPI;





var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $bpHMA = parcelRequire("bpHMA");

var $b6UUh = parcelRequire("b6UUh");

var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $978389e4a0c045ec$export$29cad1383b3f235d(slot) {
    return (0, $k6RDS.default)("MuiCircularProgress", slot);
}
const $978389e4a0c045ec$var$circularProgressClasses = (0, $4jzsB.default)("MuiCircularProgress", [
    "root",
    "determinate",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "svg",
    "circle",
    "circleDeterminate",
    "circleIndeterminate",
    "circleDisableShrink"
]);
var $978389e4a0c045ec$export$2e2bcd8739ae039 = $978389e4a0c045ec$var$circularProgressClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
let $d513166e63c42433$var$_ = (t)=>t, $d513166e63c42433$var$t, $d513166e63c42433$var$t1, $d513166e63c42433$var$t2, $d513166e63c42433$var$t3;
const $d513166e63c42433$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $d513166e63c42433$var$_1 = (t)=>t, $d513166e63c42433$var$_t, $d513166e63c42433$var$_t2, $d513166e63c42433$var$_t3, $d513166e63c42433$var$_t4;
const $d513166e63c42433$var$SIZE = 44;
const $d513166e63c42433$var$circularRotateKeyframe = (0, $bpHMA.keyframes)($d513166e63c42433$var$_t || ($d513166e63c42433$var$_t = $d513166e63c42433$var$_1($d513166e63c42433$var$t || ($d513166e63c42433$var$t = $d513166e63c42433$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`))));
const $d513166e63c42433$var$circularDashKeyframe = (0, $bpHMA.keyframes)($d513166e63c42433$var$_t2 || ($d513166e63c42433$var$_t2 = $d513166e63c42433$var$_1($d513166e63c42433$var$t1 || ($d513166e63c42433$var$t1 = $d513166e63c42433$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`))));
const $d513166e63c42433$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `color${(0, $b6UUh.default)(color)}`
        ],
        svg: [
            "svg"
        ],
        circle: [
            "circle",
            `circle${(0, $b6UUh.default)(variant)}`,
            disableShrink && "circleDisableShrink"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $978389e4a0c045ec$export$29cad1383b3f235d), classes);
};
const $d513166e63c42433$var$CircularProgressRoot = (0, $kDBhE.default)("span", {
    name: "MuiCircularProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $b6UUh.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        display: "inline-block"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("transform")
    }, ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && (0, $bpHMA.css)($d513166e63c42433$var$_t3 || ($d513166e63c42433$var$_t3 = $d513166e63c42433$var$_1($d513166e63c42433$var$t2 || ($d513166e63c42433$var$t2 = $d513166e63c42433$var$_`
      animation: ${0} 1.4s linear infinite;
    `), 0)), $d513166e63c42433$var$circularRotateKeyframe));
const $d513166e63c42433$var$CircularProgressSVG = (0, $kDBhE.default)("svg", {
    name: "MuiCircularProgress",
    slot: "Svg",
    overridesResolver: (props, styles)=>styles.svg
})({
    display: "block" // Keeps the progress centered
});
const $d513166e63c42433$var$CircularProgressCircle = (0, $kDBhE.default)("circle", {
    name: "MuiCircularProgress",
    slot: "Circle",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $b6UUh.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        stroke: "currentColor"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("stroke-dashoffset")
    }, ownerState.variant === "indeterminate" && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: "80px, 200px",
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && !ownerState.disableShrink && (0, $bpHMA.css)($d513166e63c42433$var$_t4 || ($d513166e63c42433$var$_t4 = $d513166e63c42433$var$_1($d513166e63c42433$var$t3 || ($d513166e63c42433$var$t3 = $d513166e63c42433$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), 0)), $d513166e63c42433$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $d513166e63c42433$var$CircularProgress = /*#__PURE__*/ $7fPBF.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiCircularProgress"
    });
    const { className: className, color: color = "primary", disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = "indeterminate" } = props, other = (0, $cFLic.default)(props, $d513166e63c42433$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $d513166e63c42433$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === "determinate") {
        const circumference = 2 * Math.PI * (($d513166e63c42433$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)($d513166e63c42433$var$CircularProgressRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        style: (0, $kY3Ke.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($d513166e63c42433$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$d513166e63c42433$var$SIZE / 2} ${$d513166e63c42433$var$SIZE / 2} ${$d513166e63c42433$var$SIZE} ${$d513166e63c42433$var$SIZE}`,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)($d513166e63c42433$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $d513166e63c42433$var$SIZE,
                cy: $d513166e63c42433$var$SIZE,
                r: ($d513166e63c42433$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $d513166e63c42433$export$2e2bcd8739ae039 = $d513166e63c42433$var$CircularProgress;


var $620d04c04da7a015$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $620d04c04da7a015$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $620d04c04da7a015$var$SurveySubscriberReports = function(_a) {
    var enableForm = _a.enableForm, successMsg = _a.successMsg, googleKey = _a.googleKey;
    var _b = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false), loading = _b[0], setLoading = _b[1];
    var doShowSuccessMsg = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(false);
    var dataForm = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
    var _c = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(true), refreshReCaptcha = _c[0], setRefreshReCaptcha = _c[1];
    var formConfig = [
        {
            name: "email",
            label: "Email",
            fieldType: "input",
            isRequired: true,
            validations: {
                type: "input",
                required: true,
                customMessages: {
                    required: "Email can't be blank."
                }
            }
        }
    ];
    var submitForm = function(data) {
        return $620d04c04da7a015$var$__awaiter(void 0, void 0, void 0, function() {
            return $620d04c04da7a015$var$__generator(this, function(_a) {
                setRefreshReCaptcha(true);
                dataForm.current = data;
                setLoading(true);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    var processFormWithToken = function(token) {
        return $620d04c04da7a015$var$__awaiter(void 0, void 0, void 0, function() {
            var data, response;
            return $620d04c04da7a015$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        setRefreshReCaptcha(false);
                        data = dataForm.current;
                        data.token = token;
                        data.key = "Survey_Notify_Report_Email";
                        data.createdAt = new Date().toISOString();
                        data.updatedAt = new Date().toISOString();
                        console.log(data);
                        return [
                            4,
                            (0, $062454becd5ef76d$export$2e2bcd8739ae039).custom_call(null, (0, $7a1d5ab68f58f51c$export$b5206f28caf876be), {
                                args: data
                            }, "createPublicSurveyNotifyReportEmail")
                        ];
                    case 1:
                        response = _a.sent();
                        if (response === "Ok") doShowSuccessMsg.current = true;
                        setLoading(false);
                        setRefreshReCaptcha(false);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    if (!enableForm) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, doShowSuccessMsg.current ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: successMsg
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        style: {
            maxWidth: "500px"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $af2bb3e49e41c9b6$export$3d3872bfc53fd642), {
        reCaptchaKey: googleKey
    }, !loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d3accb062935cef9$export$2e2bcd8739ae039), {
        fields: formConfig,
        onSubmit: submitForm,
        submitButtonText: "Subscribe"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "5px"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d513166e63c42433$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $af2bb3e49e41c9b6$export$d5aa16f6da947fbf), {
        onVerify: function(token) {
            return $620d04c04da7a015$var$__awaiter(void 0, void 0, void 0, function() {
                return $620d04c04da7a015$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                processFormWithToken(token)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        },
        refreshReCaptcha: refreshReCaptcha
    }))))));
};
var $620d04c04da7a015$export$2e2bcd8739ae039 = $620d04c04da7a015$var$SurveySubscriberReports;




var $0fb484e1ea177fb3$var$__assign = undefined && undefined.__assign || function() {
    $0fb484e1ea177fb3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0fb484e1ea177fb3$var$__assign.apply(this, arguments);
};
var $0fb484e1ea177fb3$var$SurveyPage = function(_a) {
    var otherProps = _a.otherProps;
    var _b = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState({
        isLoaded: true,
        isSurveyCompleted: "1",
        enableEmailReportSubscriber: "1",
        mailReportSubscriberThankYourMessage: "",
        surveyIntro: "",
        surveyMaintenance: ""
    }), data = _b[0], setData = _b[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        if (otherProps === null || otherProps === void 0 ? void 0 : otherProps.params) setData($0fb484e1ea177fb3$var$__assign({
            isLoaded: false
        }, otherProps.params));
    }, []);
    if (data.isLoaded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null, "Loading");
    if (data.isSurveyCompleted === "1") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        style: {
            maxWidth: "800px"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: data.surveyMaintenance
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $620d04c04da7a015$export$2e2bcd8739ae039), {
        enableForm: data.enableEmailReportSubscriber === "1",
        successMsg: data.mailReportSubscriberThankYourMessage,
        googleKey: otherProps === null || otherProps === void 0 ? void 0 : otherProps.params.configurations.googleRecaptchaKey
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null);
};
var $0fb484e1ea177fb3$export$2e2bcd8739ae039 = $0fb484e1ea177fb3$var$SurveyPage;







var $2oXYc = parcelRequire("2oXYc");
var $bcfc8fd789313436$exports = {};
"use strict";
function $bcfc8fd789313436$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $7fPBF = parcelRequire("7fPBF");
var $bcfc8fd789313436$var$React__default = $bcfc8fd789313436$var$_interopDefault($7fPBF);
function $bcfc8fd789313436$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bcfc8fd789313436$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $bcfc8fd789313436$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $bcfc8fd789313436$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== "function") throw new Error("Expected reducePropsToState to be a function.");
    if (typeof handleStateChangeOnClient !== "function") throw new Error("Expected handleStateChangeOnClient to be a function.");
    if (typeof mapStateOnServer !== "undefined" && typeof mapStateOnServer !== "function") throw new Error("Expected mapStateOnServer to either be undefined or a function.");
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== "function") throw new Error("Expected WrappedComponent to be a React component.");
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $bcfc8fd789313436$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $bcfc8fd789313436$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($7fPBF.PureComponent);
        $bcfc8fd789313436$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $bcfc8fd789313436$var$_defineProperty(SideEffect, "canUseDOM", $bcfc8fd789313436$var$canUseDOM);
        return SideEffect;
    };
}
$bcfc8fd789313436$exports = $bcfc8fd789313436$var$withSideEffect;


var $d8cf8ca5172c2b64$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $d8cf8ca5172c2b64$var$hasElementType = typeof Element !== "undefined";
var $d8cf8ca5172c2b64$var$hasMap = typeof Map === "function";
var $d8cf8ca5172c2b64$var$hasSet = typeof Set === "function";
var $d8cf8ca5172c2b64$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $d8cf8ca5172c2b64$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$d8cf8ca5172c2b64$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($d8cf8ca5172c2b64$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$d8cf8ca5172c2b64$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($d8cf8ca5172c2b64$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($d8cf8ca5172c2b64$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($d8cf8ca5172c2b64$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$d8cf8ca5172c2b64$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$d8cf8ca5172c2b64$exports = function isEqual(a, b) {
    try {
        return $d8cf8ca5172c2b64$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $7fPBF = parcelRequire("7fPBF");
var $00332d224329ec89$exports = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $00332d224329ec89$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $00332d224329ec89$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $00332d224329ec89$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $00332d224329ec89$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $00332d224329ec89$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
$00332d224329ec89$exports = $00332d224329ec89$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $00332d224329ec89$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($00332d224329ec89$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($00332d224329ec89$var$getOwnPropertySymbols) {
            symbols = $00332d224329ec89$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($00332d224329ec89$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};


var $6c1f4330886a1125$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $6c1f4330886a1125$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $6c1f4330886a1125$var$VALID_TAG_NAMES = Object.keys($6c1f4330886a1125$var$TAG_NAMES).map(function(name) {
    return $6c1f4330886a1125$var$TAG_NAMES[name];
});
var $6c1f4330886a1125$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $6c1f4330886a1125$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $6c1f4330886a1125$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $6c1f4330886a1125$var$HTML_TAG_MAP = Object.keys($6c1f4330886a1125$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$6c1f4330886a1125$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $6c1f4330886a1125$var$SELF_CLOSING_TAGS = [
    $6c1f4330886a1125$var$TAG_NAMES.NOSCRIPT,
    $6c1f4330886a1125$var$TAG_NAMES.SCRIPT,
    $6c1f4330886a1125$var$TAG_NAMES.STYLE
];
var $6c1f4330886a1125$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $6c1f4330886a1125$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $6c1f4330886a1125$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $6c1f4330886a1125$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $6c1f4330886a1125$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $6c1f4330886a1125$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $6c1f4330886a1125$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $6c1f4330886a1125$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $6c1f4330886a1125$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $6c1f4330886a1125$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $6c1f4330886a1125$var$getInnermostProperty(propsList, $6c1f4330886a1125$var$TAG_NAMES.TITLE);
    var innermostTemplate = $6c1f4330886a1125$var$getInnermostProperty(propsList, $6c1f4330886a1125$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $6c1f4330886a1125$var$getInnermostProperty(propsList, $6c1f4330886a1125$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $6c1f4330886a1125$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $6c1f4330886a1125$var$getInnermostProperty(propsList, $6c1f4330886a1125$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $6c1f4330886a1125$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $6c1f4330886a1125$var$_extends({}, tagAttrs, current);
    }, {});
};
var $6c1f4330886a1125$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$6c1f4330886a1125$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$6c1f4330886a1125$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $6c1f4330886a1125$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $6c1f4330886a1125$var$warn("Helmet: " + tagName + ' should be of type "Array". Instead found type "' + $6c1f4330886a1125$var$_typeof(props[tagName]) + '"');
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $6c1f4330886a1125$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $6c1f4330886a1125$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $6c1f4330886a1125$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $6c1f4330886a1125$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $6c1f4330886a1125$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($00332d224329ec89$exports)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $6c1f4330886a1125$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $6c1f4330886a1125$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $6c1f4330886a1125$var$getBaseTagFromPropsList([
            $6c1f4330886a1125$var$TAG_PROPERTIES.HREF,
            $6c1f4330886a1125$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $6c1f4330886a1125$var$getAttributesFromPropsList($6c1f4330886a1125$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $6c1f4330886a1125$var$getInnermostProperty(propsList, $6c1f4330886a1125$var$HELMET_PROPS.DEFER),
        encode: $6c1f4330886a1125$var$getInnermostProperty(propsList, $6c1f4330886a1125$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $6c1f4330886a1125$var$getAttributesFromPropsList($6c1f4330886a1125$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $6c1f4330886a1125$var$getTagsFromPropsList($6c1f4330886a1125$var$TAG_NAMES.LINK, [
            $6c1f4330886a1125$var$TAG_PROPERTIES.REL,
            $6c1f4330886a1125$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $6c1f4330886a1125$var$getTagsFromPropsList($6c1f4330886a1125$var$TAG_NAMES.META, [
            $6c1f4330886a1125$var$TAG_PROPERTIES.NAME,
            $6c1f4330886a1125$var$TAG_PROPERTIES.CHARSET,
            $6c1f4330886a1125$var$TAG_PROPERTIES.HTTPEQUIV,
            $6c1f4330886a1125$var$TAG_PROPERTIES.PROPERTY,
            $6c1f4330886a1125$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $6c1f4330886a1125$var$getTagsFromPropsList($6c1f4330886a1125$var$TAG_NAMES.NOSCRIPT, [
            $6c1f4330886a1125$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $6c1f4330886a1125$var$getOnChangeClientState(propsList),
        scriptTags: $6c1f4330886a1125$var$getTagsFromPropsList($6c1f4330886a1125$var$TAG_NAMES.SCRIPT, [
            $6c1f4330886a1125$var$TAG_PROPERTIES.SRC,
            $6c1f4330886a1125$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $6c1f4330886a1125$var$getTagsFromPropsList($6c1f4330886a1125$var$TAG_NAMES.STYLE, [
            $6c1f4330886a1125$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $6c1f4330886a1125$var$getTitleFromPropsList(propsList),
        titleAttributes: $6c1f4330886a1125$var$getAttributesFromPropsList($6c1f4330886a1125$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $6c1f4330886a1125$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $6c1f4330886a1125$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $6c1f4330886a1125$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $6c1f4330886a1125$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $6c1f4330886a1125$var$rafPolyfill : $parcel$global.requestAnimationFrame || $6c1f4330886a1125$var$rafPolyfill;
var $6c1f4330886a1125$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $6c1f4330886a1125$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $6c1f4330886a1125$var$cafPolyfill;
var $6c1f4330886a1125$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $6c1f4330886a1125$var$_helmetCallback = null;
var $6c1f4330886a1125$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($6c1f4330886a1125$var$_helmetCallback) $6c1f4330886a1125$var$cancelAnimationFrame($6c1f4330886a1125$var$_helmetCallback);
    if (newState.defer) $6c1f4330886a1125$var$_helmetCallback = $6c1f4330886a1125$var$requestAnimationFrame(function() {
        $6c1f4330886a1125$var$commitTagChanges(newState, function() {
            $6c1f4330886a1125$var$_helmetCallback = null;
        });
    });
    else {
        $6c1f4330886a1125$var$commitTagChanges(newState);
        $6c1f4330886a1125$var$_helmetCallback = null;
    }
};
var $6c1f4330886a1125$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $6c1f4330886a1125$var$updateAttributes($6c1f4330886a1125$var$TAG_NAMES.BODY, bodyAttributes);
    $6c1f4330886a1125$var$updateAttributes($6c1f4330886a1125$var$TAG_NAMES.HTML, htmlAttributes);
    $6c1f4330886a1125$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $6c1f4330886a1125$var$updateTags($6c1f4330886a1125$var$TAG_NAMES.BASE, baseTag),
        linkTags: $6c1f4330886a1125$var$updateTags($6c1f4330886a1125$var$TAG_NAMES.LINK, linkTags),
        metaTags: $6c1f4330886a1125$var$updateTags($6c1f4330886a1125$var$TAG_NAMES.META, metaTags),
        noscriptTags: $6c1f4330886a1125$var$updateTags($6c1f4330886a1125$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $6c1f4330886a1125$var$updateTags($6c1f4330886a1125$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $6c1f4330886a1125$var$updateTags($6c1f4330886a1125$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $6c1f4330886a1125$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $6c1f4330886a1125$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $6c1f4330886a1125$var$flattenArray(title);
    $6c1f4330886a1125$var$updateAttributes($6c1f4330886a1125$var$TAG_NAMES.TITLE, attributes);
};
var $6c1f4330886a1125$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($6c1f4330886a1125$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($6c1f4330886a1125$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($6c1f4330886a1125$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($6c1f4330886a1125$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $6c1f4330886a1125$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($6c1f4330886a1125$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $6c1f4330886a1125$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $6c1f4330886a1125$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $6c1f4330886a1125$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($6c1f4330886a1125$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $6c1f4330886a1125$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + '="' + attributes[key] + '"' : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $6c1f4330886a1125$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $6c1f4330886a1125$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $6c1f4330886a1125$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $6c1f4330886a1125$var$HELMET_ATTRIBUTE + '="true" ' + attributeString + ">" + $6c1f4330886a1125$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $6c1f4330886a1125$var$HELMET_ATTRIBUTE + '="true">' + $6c1f4330886a1125$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $6c1f4330886a1125$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $6c1f4330886a1125$var$TAG_PROPERTIES.INNER_HTML || attribute === $6c1f4330886a1125$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + '="' + $6c1f4330886a1125$var$encodeSpecialCharacters(tag[attribute], encode) + '"';
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $6c1f4330886a1125$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $6c1f4330886a1125$var$HELMET_ATTRIBUTE + '="true" ' + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $6c1f4330886a1125$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$6c1f4330886a1125$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $6c1f4330886a1125$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$6c1f4330886a1125$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $6c1f4330886a1125$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$6c1f4330886a1125$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $6c1f4330886a1125$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($6c1f4330886a1125$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $6c1f4330886a1125$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$6c1f4330886a1125$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $6c1f4330886a1125$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $6c1f4330886a1125$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $6c1f4330886a1125$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(type, mappedTag);
    });
};
var $6c1f4330886a1125$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $6c1f4330886a1125$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $6c1f4330886a1125$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $6c1f4330886a1125$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $6c1f4330886a1125$var$ATTRIBUTE_NAMES.BODY:
        case $6c1f4330886a1125$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $6c1f4330886a1125$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $6c1f4330886a1125$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $6c1f4330886a1125$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $6c1f4330886a1125$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $6c1f4330886a1125$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $6c1f4330886a1125$var$getMethodsForTag($6c1f4330886a1125$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $6c1f4330886a1125$var$getMethodsForTag($6c1f4330886a1125$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $6c1f4330886a1125$var$getMethodsForTag($6c1f4330886a1125$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $6c1f4330886a1125$var$getMethodsForTag($6c1f4330886a1125$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $6c1f4330886a1125$var$getMethodsForTag($6c1f4330886a1125$var$TAG_NAMES.META, metaTags, encode),
        noscript: $6c1f4330886a1125$var$getMethodsForTag($6c1f4330886a1125$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $6c1f4330886a1125$var$getMethodsForTag($6c1f4330886a1125$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $6c1f4330886a1125$var$getMethodsForTag($6c1f4330886a1125$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $6c1f4330886a1125$var$getMethodsForTag($6c1f4330886a1125$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $6c1f4330886a1125$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $6c1f4330886a1125$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $6c1f4330886a1125$var$classCallCheck(this, HelmetWrapper);
            return $6c1f4330886a1125$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($d8cf8ca5172c2b64$exports)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $6c1f4330886a1125$var$TAG_NAMES.SCRIPT:
                case $6c1f4330886a1125$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $6c1f4330886a1125$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $6c1f4330886a1125$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $6c1f4330886a1125$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $6c1f4330886a1125$var$TAG_NAMES.TITLE:
                    return $6c1f4330886a1125$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $6c1f4330886a1125$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $6c1f4330886a1125$var$TAG_NAMES.BODY:
                    return $6c1f4330886a1125$var$_extends({}, newProps, {
                        bodyAttributes: $6c1f4330886a1125$var$_extends({}, newChildProps)
                    });
                case $6c1f4330886a1125$var$TAG_NAMES.HTML:
                    return $6c1f4330886a1125$var$_extends({}, newProps, {
                        htmlAttributes: $6c1f4330886a1125$var$_extends({}, newChildProps)
                    });
            }
            return $6c1f4330886a1125$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $6c1f4330886a1125$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $6c1f4330886a1125$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $6c1f4330886a1125$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $6c1f4330886a1125$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $6c1f4330886a1125$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $6c1f4330886a1125$var$TAG_NAMES.LINK:
                    case $6c1f4330886a1125$var$TAG_NAMES.META:
                    case $6c1f4330886a1125$var$TAG_NAMES.NOSCRIPT:
                    case $6c1f4330886a1125$var$TAG_NAMES.SCRIPT:
                    case $6c1f4330886a1125$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $6c1f4330886a1125$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $6c1f4330886a1125$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, newProps);
        };
        $6c1f4330886a1125$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $6c1f4330886a1125$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $6c1f4330886a1125$var$NullComponent = function NullComponent() {
    return null;
};
var $6c1f4330886a1125$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($bcfc8fd789313436$exports)))($6c1f4330886a1125$var$reducePropsToState, $6c1f4330886a1125$var$handleClientStateChange, $6c1f4330886a1125$var$mapStateOnServer)($6c1f4330886a1125$var$NullComponent);
var $6c1f4330886a1125$export$dcef8f9bb9a41431 = $6c1f4330886a1125$var$Helmet($6c1f4330886a1125$var$HelmetSideEffects);
$6c1f4330886a1125$export$dcef8f9bb9a41431.renderStatic = $6c1f4330886a1125$export$dcef8f9bb9a41431.rewind;
var $6c1f4330886a1125$export$2e2bcd8739ae039 = $6c1f4330886a1125$export$dcef8f9bb9a41431;





var $7fPBF = parcelRequire("7fPBF");

var $584d1d79bcf8f59f$exports = {};
"use strict";
"use client";

Object.defineProperty($584d1d79bcf8f59f$exports, "__esModule", {
    value: true
});
$584d1d79bcf8f59f$exports.default = void 0;

var $584d1d79bcf8f59f$var$_createSvgIcon = $4657741705a128f0$exports((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $584d1d79bcf8f59f$var$_default = (0, $584d1d79bcf8f59f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), "Menu");
$584d1d79bcf8f59f$exports.default = $584d1d79bcf8f59f$var$_default;




var $b58744c46e804185$var$UIGlobalAppBar = function(_a) {
    var logo = _a.logo, menuItems = _a.menuItems, navigate = _a.navigate;
    var _b = (0, $7fPBF.useState)(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var isMobile = (0, $ee4a86a3270f4470$export$2e2bcd8739ae039)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, isMobile && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $767547096e8203cd$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $67a243c492197f3b$export$2e2bcd8739ae039), {
        edge: "start",
        color: "inherit",
        "aria-label": "menu",
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($584d1d79bcf8f59f$exports))), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), {
        anchorEl: anchorEl,
        keepMounted: true,
        open: Boolean(anchorEl),
        onClose: handleClose
    }, menuItems.map(function(items, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
            key: index,
            onClick: function() {
                if (items.func) items.func(items.link);
                else location.href = items.link;
            }
        }, items.text);
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
        variant: "h6",
        style: {
            flexGrow: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fd1c1b5e264e679$export$2e2bcd8739ae039), {
        href: "https://startupmuster.com"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $eb03033f13ccf7ae$export$2e2bcd8739ae039), {
        src: logo
    })))), !isMobile && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $71f798123fa792a7$export$2e2bcd8739ae039), {
        position: "static",
        color: "default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $f9b036cf55e12ab7$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
        variant: "h6",
        style: {
            flexGrow: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fd1c1b5e264e679$export$2e2bcd8739ae039), {
        href: "https://startupmuster.com"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $eb03033f13ccf7ae$export$2e2bcd8739ae039), {
        src: logo
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null, menuItems.map(function(items, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2ffdcffbab0cb7f8$export$2e2bcd8739ae039), {
            variant: "body1",
            component: "span",
            style: {
                marginRight: 20
            },
            key: index,
            onClick: function() {
                if (items.func) items.func(items.link);
                else location.href = items.link;
            }
        }, items.text);
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2ffdcffbab0cb7f8$export$2e2bcd8739ae039), {
        variant: "body1",
        component: "span",
        style: {
            marginRight: 20
        },
        onClick: function() {
            var ic = window.Intercom;
            if (ic) ic("show");
        }
    }, "Contact us")))));
};
var $b58744c46e804185$export$2e2bcd8739ae039 = $b58744c46e804185$var$UIGlobalAppBar;



var $hmhHQ = parcelRequire("hmhHQ");
var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");
parcelRequire("7fPBF");


var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");
const $c21ce0253dc11cd3$var$ThemeContext = /*#__PURE__*/ $7fPBF.createContext(null);
var $c21ce0253dc11cd3$export$2e2bcd8739ae039 = $c21ce0253dc11cd3$var$ThemeContext;



var $7fPBF = parcelRequire("7fPBF");

function $b5dba0f0f3e50f8f$export$2e2bcd8739ae039() {
    const theme = $7fPBF.useContext((0, $c21ce0253dc11cd3$export$2e2bcd8739ae039));
    return theme;
}


const $24ebfb3bf89f6ffe$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $24ebfb3bf89f6ffe$export$2e2bcd8739ae039 = $24ebfb3bf89f6ffe$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";



var $bbzbN = parcelRequire("bbzbN");
function $f311b16c4b43b6fd$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $kY3Ke.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $f311b16c4b43b6fd$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $b5dba0f0f3e50f8f$export$2e2bcd8739ae039)();
    const theme = $7fPBF.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $f311b16c4b43b6fd$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $24ebfb3bf89f6ffe$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c21ce0253dc11cd3$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $f311b16c4b43b6fd$export$2e2bcd8739ae039 = $f311b16c4b43b6fd$var$ThemeProvider;



parcelRequire("bpHMA");
var $6H441 = parcelRequire("6H441");

var $84PRT = parcelRequire("84PRT");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $cac97cfcc46fa531$var$EMPTY_THEME = {};
function $cac97cfcc46fa531$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $7fPBF.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $kY3Ke.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $kY3Ke.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $kY3Ke.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $cac97cfcc46fa531$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $84PRT.default)($cac97cfcc46fa531$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $b5dba0f0f3e50f8f$export$2e2bcd8739ae039)() || $cac97cfcc46fa531$var$EMPTY_THEME;
    const engineTheme = $cac97cfcc46fa531$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $cac97cfcc46fa531$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f311b16c4b43b6fd$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6H441.T).Provider, {
            value: engineTheme,
            children: children
        })
    });
}
var $cac97cfcc46fa531$export$2e2bcd8739ae039 = $cac97cfcc46fa531$var$ThemeProvider;



var $jwhZE = parcelRequire("jwhZE");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $b8226d5132dedede$var$_excluded = [
    "theme"
];
function $b8226d5132dedede$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $cFLic.default)(_ref, $b8226d5132dedede$var$_excluded);
    const scopedTheme = themeInput[0, $jwhZE.default];
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cac97cfcc46fa531$export$2e2bcd8739ae039), (0, $kY3Ke.default)({}, props, {
        themeId: scopedTheme ? (0, $jwhZE.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}





var $78ee64ad18830082$exports = {};
$78ee64ad18830082$exports = new URL("SM001_CREATIVE_ASSETS_2.2bea465e.png", import.meta.url).toString();




var $504f230e6f606554$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $504f230e6f606554$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
(0, $b77a6c022ec92b76$export$2e2bcd8739ae039).configure((0, $e49d2414ba339a79$export$2e2bcd8739ae039));
var $504f230e6f606554$var$UIRoutes = function(_a) {
    var _b;
    var system = _a.system;
    var navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    var _c = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(true), loading = _c[0], setLoading = _c[1];
    var loadingData = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef({
        pageRoutes: {},
        metas: [],
        scripts: [],
        configurations: {},
        settings: {},
        topMenuItems: [],
        bottomMenuItems: []
    });
    var scriptRender = function(script) {
        var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var result = "";
        for(var i = 0; i < 10; i++)result += chars.charAt(Math.floor(Math.random() * chars.length));
        var scriptElement = document.createElement("script");
        var func = "scriptRender_" + result;
        scriptElement.innerHTML = "function " + func + "(){" + script + "}";
        document.head.appendChild(scriptElement);
        window[func]();
        document.head.removeChild(scriptElement);
    };
    var loadMenuItems = function(rawMenuItems) {
        if (!rawMenuItems) return [];
        var menuItems = [];
        var _loop_1 = function(i) {
            if (rawMenuItems[i].type === "page") {
                var link = Object.values(loadingData.current.pageRoutes).find(function(route) {
                    return route.menuItemID === rawMenuItems[i].componentID;
                });
                menuItems.push({
                    text: rawMenuItems[i].menuItem,
                    func: navigate,
                    link: link.route
                });
            } else if (rawMenuItems[i].type === "link") menuItems.push({
                text: rawMenuItems[i].menuItem,
                link: rawMenuItems[i].link
            });
            else if (rawMenuItems[i].type === "javascript") menuItems.push({
                text: rawMenuItems[i].menuItem,
                func: scriptRender,
                link: rawMenuItems[i].link
            });
        };
        for(var i = 0; i < rawMenuItems.length; i++)_loop_1(i);
        return menuItems;
    };
    var loadData = function() {
        return $504f230e6f606554$var$__awaiter(void 0, void 0, void 0, function() {
            var data, i, reportSetting, i, _a, _b, configurations, i, record, fileParse, _c, _d, _e, _f, script;
            return $504f230e6f606554$var$__generator(this, function(_g) {
                switch(_g.label){
                    case 0:
                        return [
                            4,
                            (0, $3ad4f174f34ffe7d$export$2e2bcd8739ae039).clear()
                        ];
                    case 1:
                        _g.sent();
                        return [
                            4,
                            (0, $eaa073c6f549d2c5$export$2e2bcd8739ae039).getList(null, true)
                        ];
                    case 2:
                        data = _g.sent();
                        loadingData.current.pageRoutes = {};
                        for(i = 0; i < data.length; i++)loadingData.current.pageRoutes[data[i].pageTitle] = {
                            Component: (0, $eff9fc39e94a657e$export$2e2bcd8739ae039),
                            menuItemID: data[i].id,
                            type: "public",
                            route: data[i].pageURL,
                            title: data[i].pageTitle,
                            params: data[i]
                        };
                        return [
                            4,
                            (0, $53037fa6745050b5$export$2e2bcd8739ae039).getList(null, true)
                        ];
                    case 3:
                        reportSetting = _g.sent();
                        loadingData.current.pageRoutes.reports = {
                            Component: (0, $4b2ec354b2a17eaa$export$2e2bcd8739ae039),
                            menuItemID: "reports",
                            type: "public",
                            route: "",
                            title: "Reports",
                            params: {
                                reportSetting: reportSetting
                            }
                        };
                        loadingData.current.pageRoutes.survey = {
                            Component: (0, $0fb484e1ea177fb3$export$2e2bcd8739ae039),
                            menuItemID: "survey",
                            type: "public",
                            route: "",
                            title: "",
                            params: reportSetting
                        };
                        for(i = 0; i < reportSetting.length; i++){
                            if (reportSetting[i].name === "pageTitle") loadingData.current.pageRoutes.survey.title = reportSetting[i].setting;
                            if (reportSetting[i].name === "surveyPageURL") loadingData.current.pageRoutes.survey.route = reportSetting[i].setting;
                            if (reportSetting[i].name === "surveyReportURL") loadingData.current.pageRoutes.reports.route = reportSetting[i].setting;
                            loadingData.current.settings[reportSetting[i].name] = reportSetting[i].setting;
                        }
                        loadingData.current.pageRoutes.survey.params = loadingData.current.settings;
                        _a = loadingData.current;
                        return [
                            4,
                            (0, $03ec468c504f4409$export$2e2bcd8739ae039).getList(null, true)
                        ];
                    case 4:
                        _a.metas = _g.sent();
                        _b = loadingData.current;
                        return [
                            4,
                            (0, $3435990efe49f3cd$export$2e2bcd8739ae039).getList(null, true)
                        ];
                    case 5:
                        _b.scripts = _g.sent();
                        return [
                            4,
                            (0, $4f62bf5d6a658643$export$2e2bcd8739ae039).getList(null, true)
                        ];
                    case 6:
                        configurations = _g.sent();
                        for(i = 0; i < configurations.length; i++){
                            record = configurations[i].record;
                            if (record.includes("image/")) {
                                fileParse = JSON.parse(record);
                                record = fileParse.file;
                            }
                            loadingData.current.configurations[configurations[i].config] = record;
                        }
                        loadingData.current.pageRoutes.reports.params = {
                            settings: loadingData.current.settings,
                            configurations: loadingData.current.configurations,
                            pageTitle: "Reports"
                        };
                        loadingData.current.pageRoutes.survey.params.configurations = loadingData.current.configurations;
                        _c = loadingData.current;
                        _d = loadMenuItems;
                        return [
                            4,
                            (0, $c5096964d50e626a$export$2e2bcd8739ae039).getByMenuID(null, loadingData.current.configurations.topMenu)
                        ];
                    case 7:
                        _c.topMenuItems = _d.apply(void 0, [
                            _g.sent()
                        ]);
                        _e = loadingData.current;
                        _f = loadMenuItems;
                        return [
                            4,
                            (0, $c5096964d50e626a$export$2e2bcd8739ae039).getByMenuID(null, loadingData.current.configurations.bottomMenu)
                        ];
                    case 8:
                        _e.bottomMenuItems = _f.apply(void 0, [
                            _g.sent()
                        ]);
                        script = document.createElement("script");
                        script.type = "text/javascript";
                        script.async = false;
                        script.src = "https://www.google.com/recaptcha/enterprise.js?render=" + loadingData.current.configurations.googleRecaptchaKey;
                        document.head.appendChild(script);
                        setLoading(false);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var theme = (0, $hmhHQ.default)();
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        loadData().then();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $6c1f4330886a1125$export$dcef8f9bb9a41431), null, loadingData.current.metas.map(function(record, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("meta", {
            key: index,
            name: record.name,
            content: record.contents
        });
    }), loadingData.current.scripts.map(function(record, index) {
        var contentString = record.script;
        if (contentString.includes("<script") && contentString.includes("src=")) {
            var srcMatch = contentString.match(/src="([^"]+)"/);
            var asyncMatch = contentString.includes("async");
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.async = asyncMatch;
            script.src = srcMatch[1];
            document.head.appendChild(script);
        } else if (contentString.includes("<script")) {
            var innerContent = contentString.match(/<script[^>]*>([\s\S]*?)<\/script>/)[1];
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.async = true;
            script.innerHTML = innerContent;
            document.head.appendChild(script);
        } else if (contentString.includes("<noscript")) {
            var innerContent = contentString.match(/<noscript>([\s\S]*?)<\/noscript>/)[1];
            var noscript = document.createElement("noscript");
            noscript.innerHTML = innerContent;
            document.head.appendChild(noscript);
        }
        return null;
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, (_b = loadingData.current.configurations.websiteTitle) !== null && _b !== void 0 ? _b : "SurveyPage Muster"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("link", {
        rel: "icon",
        type: "image/x-icon",
        href: loadingData.current.configurations.favicon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("meta", {
        name: "description",
        content: loadingData.current.configurations.metaDescription
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $533baf7da870110d$export$d73fb1e26fe3246a), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $b8226d5132dedede$export$2e2bcd8739ae039), {
        theme: theme
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $69c87d542bb99a74$export$2e2bcd8739ae039), {
        bgimage: (0, (/*@__PURE__*/$parcel$interopDefault($4dc1c9997df7c010$exports)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $38b5ec1caf9c5093$export$2e2bcd8739ae039), {
        variant: "h1"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $65cb075c7aae556e$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            height: "40vh",
            alignItems: "center",
            justifyContent: "center"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $d513166e63c42433$export$2e2bcd8739ae039), null)))) : Object.keys(loadingData.current.configurations).length !== 0 && loadingData.current.configurations.maintenance !== "1" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $c858e0b31b487591$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $b58744c46e804185$export$2e2bcd8739ae039), {
        menuItems: loadingData.current.topMenuItems,
        logo: loadingData.current.configurations.logo,
        navigate: navigate
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $aed4709c841a33e1$export$2e2bcd8739ae039), {
        pageRoutes: loadingData.current.pageRoutes,
        InternalRoutes: (0, $49a727e13f3caa8a$export$2e2bcd8739ae039),
        system: system
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $0dd52264ef4ab763$export$a06f1c675e846f6f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $0dd52264ef4ab763$export$b77809c590a7b2a1), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("a", {
        href: "javascript:void(0)",
        onClick: function() {
            navigate("/");
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $eb03033f13ccf7ae$export$2e2bcd8739ae039), {
        src: loadingData.current.configurations.logo
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $0dd52264ef4ab763$export$29661101d42f8ad7), null, "\xa0")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $0dd52264ef4ab763$export$b77809c590a7b2a1), null, loadingData.current.bottomMenuItems.map(function(items, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $0dd52264ef4ab763$export$fca61eb8d64108cc), {
            key: index,
            onClick: function() {
                if (items.func) items.func(items.link);
                else location.href = items.link;
            }
        }, items.text);
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $0dd52264ef4ab763$export$65c64c42ce748db0), null, "Copyright ", new Date().getFullYear(), " \xa9", " ", loadingData.current.configurations.copyRights, ". All rights reserved."))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, "The site is under maintenance")));
};
var $504f230e6f606554$export$2e2bcd8739ae039 = $504f230e6f606554$var$UIRoutes;


var $39d7946aaa2a73b0$var$_a;
var $39d7946aaa2a73b0$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($f11ec298ebcca059$exports))).createRoot(document.getElementById("root"));
var $39d7946aaa2a73b0$var$system = ($39d7946aaa2a73b0$var$_a = "ui", $39d7946aaa2a73b0$var$_a !== void 0) ? $39d7946aaa2a73b0$var$_a : "ui";
console.log = console.error = console.warn = console.info = console.debug = function() {};
$39d7946aaa2a73b0$var$root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).StrictMode, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a0cf24fd73ae067c$export$9ba4e89fdfa1fc54), null, $39d7946aaa2a73b0$var$system === "admin" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $aed4709c841a33e1$export$2e2bcd8739ae039), {
    system: $39d7946aaa2a73b0$var$system,
    pageRoutes: (0, $f5cd700b607f5c94$export$2e2bcd8739ae039),
    InternalRoutes: (0, $49a727e13f3caa8a$export$2e2bcd8739ae039)
}) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $504f230e6f606554$export$2e2bcd8739ae039), {
    system: $39d7946aaa2a73b0$var$system
})), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $de77e498e07914bf$export$f2815235e76a62b9), null)));


//# sourceMappingURL=index.2f03a399.js.map
